import { gql } from '@nerdwallet/apollo';
import * as React from 'react';
import * as ApolloReactCommon from '@nerdwallet/apollo';
import * as ApolloReactComponents from '@nerdwallet/apollo';
import * as ApolloReactHoc from '@nerdwallet/apollo';
import * as ApolloReactHooks from '@nerdwallet/apollo';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
  openfed__Scope: { input: any; output: any; }
  /**
   * The \`JSON\` scalar type represents JSON values as specified by ' +
   * '[ECMA-404](http://www.ecma-international.org/' + 'publications/files/ECMA-ST/ECMA-404.pdf).
   */
  JSON: { input: any; output: any; }
  _FieldSet: { input: any; output: any; }
  /** A date-time string at UTC, such as 2007-12-03T10:15:30Z, compliant with the `date-time` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  DateTime: { input: any; output: any; }
  /** A field whose value conforms to the standard internet email address format as specified in HTML Spec: https://html.spec.whatwg.org/multipage/input.html#valid-e-mail-address. */
  EmailAddress: { input: any; output: any; }
  link__Import: { input: any; output: any; }
  federation__FieldSet: { input: any; output: any; }
  JSONObject: { input: any; output: any; }
  /** A date string, such as 2007-12-03, compliant with the `full-date` format outlined in section 5.6 of the RFC 3339 profile of the ISO 8601 standard for representation of dates and times using the Gregorian calendar. */
  Date: { input: any; output: any; }
  /** A field whose value conforms to the standard URL format as specified in RFC3986: https://www.ietf.org/rfc/rfc3986.txt. */
  URL: { input: any; output: any; }
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  StructuredContentDocument: { input: any; output: any; }
  /** For bigger integers */
  BigInt: { input: any; output: any; }
  /** ISO Date String in YYYY-MM-DDThh:mm:ssTZD */
  DateTimeWithTimeOffset: { input: any; output: any; }
  /** 3-letter currency code. */
  FinancialCurrency: { input: any; output: any; }
};

/** A valid US State Code */
export enum StateCodeEnum {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  As = 'AS',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vi = 'VI',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type AutoInsuranceCitySummary = {
  __typename?: 'AutoInsuranceCitySummary';
  /** US city name */
  cityName: Scalars['String']['output'];
  /** US state name */
  stateName: Scalars['String']['output'];
  /** US two-letter state abbreviation */
  stateCode: StateCodeEnum;
  /** Average insurance annual premium across a city */
  avgForCity?: Maybe<Scalars['Float']['output']>;
  /** Average insurance annual premium across a state */
  avgForState: Scalars['Float']['output'];
  /** Average insurance annual with minimum coverage across a state */
  minimumCoverageAvgForState: Scalars['Float']['output'];
  /** Array of average annual premium by zipCode within a city */
  avgByZipCode?: Maybe<Array<AnnualPremiumByZipCode>>;
  /** Array of cheapest companies and annual premiums within a city */
  avgByCarrier?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for drivers with poor credit score within a city */
  cheapestForPoorCredit?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for drivers with good credit score within a city */
  cheapestForGoodCredit?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for drivers with excellent credit score within a city */
  cheapestForExcellentCredit?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a driver at age 20 within a city */
  cheapestFor20YearOlds?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a driver at age 35 within a city */
  cheapestFor35YearOlds?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a driver at age 60 within a city */
  cheapestFor60YearOlds?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a clean driving record within a city */
  cheapestWithCleanRecord?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for a Dui record within a city */
  cheapestWithDui?: Maybe<Array<AutoInsuranceCarrier>>;
  /** Array of cheapest companies and annual premiums for an At Fault record within a city */
  cheapestWithAtFaultAccident?: Maybe<Array<AutoInsuranceCarrier>>;
};

export type AnnualPremiumByZipCode = {
  __typename?: 'AnnualPremiumByZipCode';
  /** US zipCode */
  zipcode: Scalars['String']['output'];
  /** Carrier's annual premium */
  annualPremium: Scalars['Float']['output'];
};

export type AutoInsuranceCarrier = {
  __typename?: 'AutoInsuranceCarrier';
  /** Name of a carrier */
  carrierName?: Maybe<Scalars['String']['output']>;
  /** An Insurance offer */
  marketplaceOffer?: Maybe<InsuranceOfferV2>;
  /** Carrier's annual premium */
  annualPremium?: Maybe<Scalars['Float']['output']>;
};

export type AutoInsuranceVehicleSummary = {
  __typename?: 'AutoInsuranceVehicleSummary';
  /** The make of a vehicle */
  make?: Maybe<Scalars['String']['output']>;
  /** The model of a vehicle */
  model?: Maybe<Scalars['String']['output']>;
  /** The timestamp of the most recent update for the vehicle */
  mostRecentUpdate?: Maybe<Scalars['String']['output']>;
  /** Array of years with average for each year */
  avgForModelYear?: Maybe<Array<VehiclePremiumByYear>>;
  /** Array of years for the vehicle, each with cheapest premiums */
  cheapestRatesByModelYear?: Maybe<Array<VehicleYearCheapestPremiums>>;
  /** Other models for this make */
  otherModels?: Maybe<Array<Scalars['String']['output']>>;
};

export type VehiclePremiumByYear = {
  __typename?: 'VehiclePremiumByYear';
  /** The model year of the vehicle */
  modelYear?: Maybe<Scalars['String']['output']>;
  /** The average annual premium */
  averagePremium: Scalars['Float']['output'];
};

export type VehicleYearCheapestPremiums = {
  __typename?: 'VehicleYearCheapestPremiums';
  /** The model year of the vehicle */
  modelYear?: Maybe<Scalars['String']['output']>;
  /** Array of cheapest companies and annual premiums for this model year */
  offers?: Maybe<Array<AutoInsuranceCarrier>>;
};

export type StateCityList = {
  __typename?: 'StateCityList';
  stateCode: StateCodeEnum;
  stateName: Scalars['String']['output'];
  cities?: Maybe<Array<Scalars['String']['output']>>;
};

/** Empty field. Not to be used. */
export type Query = {
  __typename?: 'Query';
  /** Return drcCitySummary json */
  drcCitySummary?: Maybe<AutoInsuranceCitySummary>;
  /** Returns a list of states and cities */
  drcCityLocations?: Maybe<Array<StateCityList>>;
  /** Return drcVehicleSummary json */
  drcVehicleSummary?: Maybe<AutoInsuranceVehicleSummary>;
  abExperiments?: Maybe<Array<Maybe<Experiment>>>;
  CAPEgreeting?: Maybe<Scalars['String']['output']>;
  CBLgreeting?: Maybe<Scalars['String']['output']>;
  /** Performs a site search for a given search query */
  siteSearch?: Maybe<SearchResults>;
  smbThing?: Maybe<SmbThing>;
  cardFinderUserData: CardFinderUserData;
  cardFinderGlobalMarkup: CardFinderGlobalMarkup;
  /**
   * Returns a list of notifications, along with newest/oldest IDs to assist with pagination,
   *   and the unread notifications count.
   */
  notifications: GetNotificationsResponse;
  investingRoundup?: Maybe<InvestingRoundup>;
  columnTaxUserInformation?: Maybe<ColumnTaxUserInformation>;
  isWpAuthenticated?: Maybe<Scalars['Boolean']['output']>;
  /** Send a message to ChatBot and get a reply */
  sendMessage?: Maybe<ChatBotReply>;
  /** Returns a list of available models to use */
  listModels?: Maybe<Array<Maybe<ChatBotModel>>>;
  /** Returns a list of feedback reasons */
  feedbackReasons?: Maybe<Array<Maybe<FeedbackReason>>>;
  /** Returns the plain text for an article */
  articlePlainText?: Maybe<ArticlePlainText>;
  /** Get one, many, or all Scripted Questions */
  scriptedQuestions?: Maybe<Array<Maybe<ScriptedQuestion>>>;
  /** Get one, many, or all Scripted Answers */
  scriptedAnswers?: Maybe<Array<Maybe<ScriptedAnswer>>>;
  costOfLivingCities?: Maybe<Array<Maybe<CostOfLivingCity>>>;
  costOfLivingSuggestedCities?: Maybe<Array<Maybe<CostOfLivingCity>>>;
  cityLifeCities?: Maybe<Array<Maybe<CostOfLivingCityWithCityLife>>>;
  cityLifeFieldDetails?: Maybe<Array<Maybe<CityLifeFieldDetails>>>;
  udpHealthCheck?: Maybe<UdpHealthCheck>;
  /** Returns data to be pre-filled in forms */
  preFill?: Maybe<PreFillFields>;
  stateOfResidence?: Maybe<Scalars['String']['output']>;
  getCurrentRates: CurrentMortgageRates;
  getHistoricalRates: HistoricalMortgageRates;
  housingCharacteristicsByState: StateHousingCharacteristics;
  personalizedOffers: PersonalizedOffers;
  myCardsConsent?: Maybe<CardsConsent>;
  experimentDecisions?: Maybe<Array<ExperimentDecision>>;
  abSmartlyFeatureFlags?: Maybe<Array<Maybe<AbSmartlyFeatureFlag>>>;
  abSmartlyFeatureFlagsByApp?: Maybe<Array<Maybe<AbSmartlyFeatureFlag>>>;
  /**
   * The appName argument is not being used. The "X-Caller-Client-ID" request header is being used
   *   to fetch the feature flags for the appropriate platform.
   *   Update: I made the 'appName' input arg not required so that we can safely deprecate it's usage
   *   in the native app startup queries
   */
  featureFlags?: Maybe<Array<FeatureFlag>>;
  featureFlag?: Maybe<FeatureFlag>;
  qsInsuranceOffers?: Maybe<InsuranceOffersResponse>;
  getInsuranceAirFieldV2?: Maybe<InsuranceAirField>;
  getInsuranceAirList?: Maybe<InsuranceAirList>;
  getInsuranceAirTable?: Maybe<InsuranceAirTable>;
  getAvailableAirFieldIdentifiers: Array<Scalars['String']['output']>;
  getVehicleMakesByYear: MakesByYearResponse;
  getVehicleModelsByMakeYear: ModelByMakeYearResponse;
  qwInsuranceLeads?: Maybe<QwTransformedResponse>;
  qsInsuranceLeads: QsInsuranceLeadsResponse;
  getSmBenefitsDetails: SmBenefitsDetailsResponse;
  getSmProductQuote: SmTravelInsuranceQuoteResponse;
  getSmCountries: Array<SmCountry>;
  getDriverStatus: DriverStatusResponse;
  deleteTrip: DeleteTripResponse;
  getDriverTrips: DriverTripsResponse;
  getAdUnitV2: AdUnitV2Response;
  getListOfAdvertisers: ListOfAdvertisersResponse;
  getSupportedState: SupportedStateResponse;
  setDriverInfo?: Maybe<DriverInfoResponse>;
  updatePasswordlessUser: UpdatePasswordlessUserResponse;
  validatePhone: ValidatePhoneResponse;
  evertreeInsuranceLeads?: Maybe<EvertreeResponse>;
  getFenrisProfileData?: Maybe<FenrisProfileDataResponse>;
  getCovrQuotes?: Maybe<CovrGetQuotesResponse>;
  getCovrAppointments?: Maybe<Array<Maybe<AppointmentResponse>>>;
  postCovrAppointment: CovrPostAppointmentResponse;
  postCovrLGAHandoff?: Maybe<CovrLgaHandoffResponse>;
  postCovrAmericoHandoff?: Maybe<CovrAmericoHandoffResponse>;
  maHomeInsuranceOffers?: Maybe<InsuranceOffersResponse>;
  postHomeInsuranceQuoteRequestToCovered?: Maybe<CoveredQuoteResponse>;
  carImages: Array<ImageGroupedByAssociation>;
  carData: CarData;
  carDataByTrim: CarData;
  makes: Array<Make>;
  models: Array<Model>;
  years: Array<Year>;
  carTrimData: Array<Maybe<CarTrim>>;
  carReviewLinks: Array<ReviewLink>;
  carModelData: ModelData;
  carIngestionLogs: Array<CarIngestionLog>;
  carIngestionLogEvents: Array<CarIngestionLogEvent>;
  carDataExport: CarDataExport;
  carSegments: Array<CarSegment>;
  carSubsegments: Array<CarSubsegment>;
  carBestLists: Array<CarBestList>;
  carModelBestList?: Maybe<Array<CarModelBestList>>;
  /** Testing InvestingOfferV2 for field migration */
  marketplaceEntityTest?: Maybe<InvestingOfferV2>;
  marketplaceEntitiesTest?: Maybe<Array<Maybe<InvestingOfferV2>>>;
  marketplaceEntityV2Test?: Maybe<MarketplaceEntityInterface>;
  marketplaceEntitiesV2Test?: Maybe<Array<Maybe<MarketplaceEntityInterface>>>;
  /** Returns a list of Content Configurations. */
  contentConfigs: ContentConfigsResponse;
  /**
   * Returns a list of feature discovery modules that the user is eligible to see, in priority
   *   order
   *   Datasource endpoint: app-configs
   */
  nativeFeatureDiscovery: NativeFeatureDiscoveryResponse;
  financialAccounts?: Maybe<GetFinancialAccountsResponse>;
  financialAccountsByPortal?: Maybe<GetFinancialAccountsResponse>;
  financialAccountsIAVDetails?: Maybe<FinancialAccountsIavDetailsResponse>;
  financialAccountTypeSums?: Maybe<FinancialAccountTypeSumsResponse>;
  /** Fetches a user's financial account by financial account ID. */
  financialAccountById?: Maybe<FinancialAccount>;
  /**
   * Retrieve a list of credit cards a user has applied for and the associated rewards earned
   *   for NerdWallet+ users
   * @deprecated use the general query financialNwPlusRewards for all products
   */
  financialCreditCardRewards: FinancialCreditCardRewardResponse;
  /**
   * Retrieve a list of product offers a user has applied for and the associated
   *   rewards earned for NerdWallet+ users
   */
  financialNwPlusRewards: FinancialNwPlusRewardResponse;
  /**
   * Retrieve a list of NW+ eligible product offers with statuses indicating
   *   if a NW+ user can earn rewards for them or not.
   *   For non-NW+ users, the response will contain empty lists.
   */
  nwPlusUserEligibleOffers: NwPlusUserEligibleOffersResponse;
  /** Retrieve shopping events for an anonymous user */
  anonymousShoppingEvents?: Maybe<AnonymousShoppingEventsResponse>;
  financialPortals?: Maybe<GetPortalsResponse>;
  /**
   * Fetches all portals that are not in the INIT state. This is useful for clients because
   *   portals in the INIT state have not been fully linked by the user and should not be shown in the UI
   */
  linkedFinancialPortals?: Maybe<GetPortalsResponse>;
  /**
   * Create a portal if one does not exist for a particular institution
   * @deprecated Moved to a mutation
   */
  initializeFinancialPortal?: Maybe<FinancialPortal>;
  /** Retrieves a financial portal by the provided marketplace institution ID */
  financialPortalByInstitutionId?: Maybe<FinancialPortal>;
  /** Fetches a user's financial portal by financial portal ID. */
  financialPortalById?: Maybe<FinancialPortal>;
  /** Retrieves institution status health data for the financial portal ID and identity id specified. */
  institutionHealthDetailsByPortalId?: Maybe<GetInstitutionHealthDetailsResponse>;
  /**
   * Initializes a short lived, one-time use token that should be unique for each Plaid Link session
   *   on the client.
   */
  initializeLinkToken?: Maybe<InitializeLinkTokenResponse>;
  /** Retrieves all bill streams */
  billStreams: BillStreamsResponse;
  /** Retrieves an individual bill by ID */
  getBillStreamById?: Maybe<BillStreamResponse>;
  /** User's list of added bills */
  userBillStreams: BillStreamsResponse;
  /** Get suggested bills */
  suggestedBillStreams: BillStreamsResponse;
  /** Retrieve user's set of upcoming bill instances with status and due dates */
  userUpcomingBillStreams?: Maybe<UpcomingBillStreamsResponse>;
  /** A generic query to fetch the transactions pre-filtered for what we expect */
  financialTransactions?: Maybe<GetTransactionsResponse>;
  /** Returns a transaction for a user by transaction ID. */
  financialTransactionById?: Maybe<FinancialTransaction>;
  financialTransactionCategories?: Maybe<FinancialTransactionCategoriesResponse>;
  /** Sync API for returning all of a user's transactions changes including additions, updates and deletions. */
  financialTransactionsSync?: Maybe<FinancialTransactionSyncResponse>;
  /** Fetches FDP user meta data for UserOps Dashboard */
  financialUsersForIdentityId?: Maybe<GetFinancialUserMetaResponse>;
  /** Retrieves FDP related information about the user. */
  financialDataUser: FinancialUserResponse;
  /** Retrieves the annual income the user set in their financial profile in UDP. */
  financialUserAnnualIncome: FinancialUserAnnualIncomeResponse;
  /** Retrieves the monthly net income the user set in their financial profile in UDP. */
  financialUserMonthlyNetIncome: FinancialUserMonthlyNetIncomeResponse;
  /** Represents if the user has acknowledged Covered's Terms of Service. */
  hasAcknowledgedCoveredTermsOfService: HasAcknowledgedCoveredTermsOfServiceResponse;
  /** Returns the URL which links the user to Covered's generated auto quotes. */
  coveredQuoteStatus: CoveredQuoteStatusResponse;
  /** Returns an encrypted Identity ID to pass to the Canopy Connect widget */
  canopyIdentityId: Scalars['String']['output'];
  /**
   * Returns the list of Terms of Service agreements for Canopy.
   *   (Usually, there will only be zero or one result, but possibly more if we
   *   implement multiple versions.)
   */
  canopyTermsOfServiceAgreements: CanopyTermsOfServiceAgreementsResponse;
  /** Returns the list of the user's insurance policies. */
  insurancePolicies: InsurancePoliciesResponse;
  /** Returns the policy for the given policy ID. */
  insurancePolicy: InsurancePolicyResponse;
  /** Returns rates for the policy specified */
  insurancePolicyRateReport: InsurancePolicyRateReportResponse;
  /** Returns rates for all policies */
  insurancePoliciesRateReports: InsurancePoliciesRateReportsResponse;
  /** Returns insurance pull information including associated policies */
  insurancePull: InsurancePullResponse;
  /** Returns the policy document URL by ID. */
  insuranceDocumentUrl: InsuranceDocumentUrlResponse;
  /** Returns the list of the user's insurance accounts. */
  insuranceAccounts: InsuranceAccountsResponse;
  /**
   * Returns the "global" and auto overrides for the given policy ID.
   *   These overrides influence the Quadrant Rates response.
   */
  insurancePolicyOverrides?: Maybe<InsurancePolicyOverridesResponse>;
  /**
   * Returns a list of Canopy insurance carriers. This is used to determine
   *   which insurance carriers we can link policies for.
   */
  supportedCarriers: Array<CanopyCarriers>;
  /** Returns the account reconnect token */
  accountReconnectToken?: Maybe<InsuranceAccountReconnectTokenResponse>;
  membershipAppActivity?: Maybe<MembershipAppActivityResponse>;
  /**
   * Returns the URL for the WLL (White Label Loyalty) microsite
   *
   *   The WLl microsite allows users to interact with the Rewards dashboard, and redeem rewards
   */
  wllMicrositeUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the URL for Recurly's hosted payment page */
  recurlyHostedPageUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the URL for Recurly's account management page */
  recurlyAccountManagementPageUrl?: Maybe<Scalars['String']['output']>;
  /** Returns the user's Recurly account info */
  recurlyAccountInfo?: Maybe<RecurlyAccountInfoResponse>;
  /** Returns the user's Recurly billing history */
  recurlyBillingHistory: RecurlyBillingHistoryResponse;
  /** Returns a list of points for the requested event types */
  rewardEventPoints: RewardEventPointsResponse;
  /**
   * Returns a list of NW plus rewards available.
   *   This should be the single-source of truth to list rewards on different clients.
   *   This list includes one-time, recurring and exclusive rewards.
   */
  nwPlusAvailableRewards?: Maybe<NwPlusAvailableRewardsResponse>;
  /** Returns the FAQs for the NW+ Landing Page on Native and Web */
  nwPlusLandingPageFaqs?: Maybe<NwPlusLandingPageFaqsResponse>;
  /** Returns the user's current points from WLL */
  nwPlusWallet?: Maybe<NwPlusWalletResponse>;
  /** Returns the user's earned points, the points cap and the correlation between them from WLL */
  nwPlusPredictions?: Maybe<NwPlusPredictionsResponse>;
  /** Returns a summary of all points related information for a NW+ user */
  nwPlusPointsSummary?: Maybe<NwPlusPointsSummaryResponse>;
  /** Returns an estimate of points a non-NW+ user */
  nwPlusPointsEstimate?: Maybe<NwPlusPointsEstimateResponse>;
  /** Returns data for NW+ users to refer NW+ to others */
  nwPlusReferralCode?: Maybe<NwPlusReferralCodeResponse>;
  /** Returns the stats for the user's referral code */
  nwPlusReferralCodeStats?: Maybe<NwPlusReferralCodeStatsResponse>;
  /** Returns info for a user's outstanding events */
  nwPlusOutstandingEvents?: Maybe<NwPlusOutstandingEventsResponse>;
  /** Returns all rewards that a NW+ user can still earn points on */
  nwPlusUserQualifiedRewards?: Maybe<NwPlusUserQualifiedRewardsResponse>;
  /** Returns all rewards that a user can redeem their points for */
  nwPlusRedeemableRewards?: Maybe<NwPlusUserRedeemableRewardsResponse>;
  /** Returns all redemeed rewards */
  nwPlusRedeemedRewardsHistory?: Maybe<NwPlusUserRedeemedRewardsHistoryResponse>;
  /** Returns the user's NerdWallet Plus membership status */
  nwPlusMembershipStatus?: Maybe<NwPlusMembershipStatus>;
  /** Returns the user's completed events */
  nwPlusCompletedEvents?: Maybe<Array<NwPlusCompletedEvent>>;
  /** Returns the user's history of completed events that resulted in points earned */
  nwPlusRewardedCompletedEvents: Array<NwPlusRewardedCompletedEvent>;
  /** Returns a list of pre-defined user reviews on N+ */
  nwPlusUserReviews?: Maybe<NwPlusUserReviewsResponse>;
  /** Returns the status of user registration and other details that would help initiate a payout */
  nwPlusPayoutsRegistrationInfo?: Maybe<NwPlusPayoutsRegistrationInfoResponse>;
  /** Returns a list of N+ exclusive feature cards for the carousel */
  nwPlusExclusiveFeatureCards?: Maybe<NwPlusExclusiveFeatureCardsResponse>;
  /** Returns the copy for N+ features on native */
  nwPlusNativeCopy?: Maybe<NwPlusNativeCopyResponse>;
  nwPlusMonthlyCreditCardPaymentInfo?: Maybe<NwPlusMonthlyCreditCardPaymentInfoResponse>;
  offerRecommendations?: Maybe<Array<Maybe<OfferRecommendation>>>;
  scribeUpTermsOfService: ScribeUpTermsOfServiceResponse;
  scribeUpBillsData?: Maybe<ScribeUpBillsDataResponse>;
  scribeUpBillsUrl?: Maybe<ScribeUpBillsUrlResponse>;
  scribeUpBillsActivated: ScribeUpBillsActivatedResponse;
  treasuryAccountMarketing?: Maybe<TreasuryAccountMarketing>;
  treasuryAccountStatus?: Maybe<TreasuryAccountStatus>;
  /** Fetches the insurance account details for all user accounts by identity. */
  adminAccountDetails: AdminInsuranceAccounts;
  investmentAccountsEmbedModule?: Maybe<InvestmentAccountsEmbedModule>;
  investmentAccountsStatus?: Maybe<InvestmentAccountsStatus>;
  investmentAccountsSummary?: Maybe<InvestmentAccountsSummary>;
  /**
   * Retrieve list of investment account related rewards an NW+ user is eligible
   *   to earn points for
   */
  investmentAccountsNwPlusRewards: InvestmentAccountNwPlusRewardResponse;
  _empty?: Maybe<Scalars['String']['output']>;
  /** Gets the current user's security questions */
  securityQuestions?: Maybe<Array<Scalars['String']['output']>>;
  /** Return compareAutoInsuranceCarriers json */
  compareAutoInsuranceCarriers?: Maybe<CompareAutoInsuranceCarriers>;
  /** User's list of bills */
  myBills: BillsResponse;
  /** Get suggested bills based on transactions meeting relevant criteria */
  suggestedBills: BillsResponse;
  capeOffers?: Maybe<Array<CapeOffer>>;
  /**
   * The breakdown of cash flow this month from the first day to the current day in dollars.
   *   Optionally, currentDate variable can be passed to the query to override the user current date
   *   used to calculate total amount, if not present it will default to the server current date.
   */
  cashFlowBreakdown?: Maybe<CashFlowBreakdown>;
  cashFlowHistoryBreakdown: CashFlowHistoryBreakdown;
  /** A user's top takeaways with regards to their cash flow based on the current date */
  cashFlowTopTakeaways?: Maybe<Array<CashFlowTakeaway>>;
  getChapter?: Maybe<ChapterData>;
  /** Returns a list of content packs containing relevant content */
  memberHomeContentPacks?: Maybe<ContentPackResponse>;
  /** Retrieves a list of all the WP recommended posts from the ML recommendation pipeline. */
  contentRecommendationPosts?: Maybe<ContentRecommendations>;
  /** Current status of the user's Credit Builder Loan */
  fetchLoanStatus: CreditBuilderLoanResponse;
  /**
   * Returns the user's persisted set of quiz flow answers for the Credit Card Match quiz.
   *   Datasource endpoint: recommendation-service/api/quiz-recommendations/user-answers/v1
   */
  creditCardMatchQuizAnswers?: Maybe<CreditCardMatchQuizAnswersResponse>;
  creditCardMatchQuizOffers?: Maybe<CreditCardMatchQuizOffersResponse>;
  creditFactors?: Maybe<CreditFactors>;
  creditFactorTips?: Maybe<CreditFactorTips>;
  /** The user's credit history represented by their credit scores for a time range */
  creditScoreHistory?: Maybe<CreditScoreHistoryResponse>;
  /** The user's TU credit report. */
  tuCreditReport?: Maybe<TuCreditReport>;
  /** Returns a simulated credit score given a value amount of a credit simulation type */
  simulateCreditScore?: Maybe<SimulateCreditScoreResponse>;
  /** Returns a single simulated credit score given a list of score modifiers */
  simulateVantageScore?: Maybe<SimulateVantageScoreResponse>;
  tuAuthenticationStatusProfile?: Maybe<CreditProfileAuthStatusProfile>;
  tuCreditReportIdentityProfile?: Maybe<TuCreditReportIdentityProfile>;
  accountLinkingOpportunities?: Maybe<AccountLinkingOpportunitiesResponse>;
  debtSummary?: Maybe<DebtSummary>;
  /** Returns the user's DLAN profile */
  getDLANProfile?: Maybe<DlanProfileResponse>;
  /** Financial Health Score entrypoint */
  financialHealthScore: FinancialHealthScore;
  /**
   * Returns a user's spending and earning for a given month range.
   *   Datasource endpoint: /api/v1/financial_accounts/transactions/cash_flow
   */
  financialTransactionsSpendingAndEarningForMonthRange?: Maybe<FinancialTransactionsSpendingAndEarningForMonthRangeResponse>;
  /**
   * Returns a user's spending totals by category for a target month.
   *   Datasource endpoint: /financial_accounts/transactions/cash_flow/by_categories
   */
  financialTransactionsSpendingByCategoryForMonth?: Maybe<FinancialTransactionsSpendingByCategoryForMonth>;
  /**
   * Returns a user's spending totals by date for a target month and the month prior to that month.
   *   Datasource endpoint: /financial_accounts/transactions/cash_flow/daily
   */
  financialTransactionsSpendingByDateForMonth?: Maybe<FinancialTransactionsSpendingByDayOfTheMonthForMonth>;
  /**
   * Returns a user's spending in the current selected time period compared to the previous.
   *   Ex. spending up to the current date of the month, vs the same date for last month
   *   Ex. spending up to the current week of the quarter, vs the same week for last quarter
   *   Datasource endpoint: /financial_accounts_transactions/cash_flow/daily
   */
  financialTransactionsSpendingPeriodComparison?: Maybe<FinancialTransactionsSpendingPeriodComparisonResponse>;
  /**
   * Returns a user's mean average spending by day of the month for the target month range.
   *   Datasource endpoint: /financial_accounts/transactions/cash_flow/daily/average
   */
  financialTransactionsAverageSpendingByDayOfTheMonth?: Maybe<FinancialTransactionsAverageSpendingByDayOfTheMonth>;
  /**
   * Returns a user's spending by month in a target month range.
   *   Datasource endpoint: financial_accounts/transactions/spending/monthly
   */
  financialTransactionsSpendingByMonth?: Maybe<FinancialTransactionsSpendingByMonth>;
  /** Returns a user's spending and earning by month for a given date range. */
  financialTransactionsSpendingAndEarningByMonth?: Maybe<FinancialTransactionsSpendingAndEarningByMonth>;
  /**
   * Returns a user's projected earning for the target month.
   *   Datasource endpoint: financial_accounts/transactions/cash_flow/projection
   */
  financialTransactionsProjectionForMonth?: Maybe<FinancialTransactionsProjectionForMonth>;
  /**
   * Returns a user's top merchants by spending for the target month range.
   *   Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsTopMerchantsBySpending?: Maybe<FinancialTransactionsTopMerchantsBySpending>;
  /**
   * Returns a user's top categories by spending for the target month range.
   *   Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsTopCategoriesBySpending?: Maybe<FinancialTransactionsTopCategoriesBySpending>;
  /**
   * Returns a user's budget breakdown for the last month range.
   *   Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   * @deprecated should be using financialTransactionsBudgetBreakdownByMonth
   */
  financialTransactionsBudgetBreakdown?: Maybe<FinancialTransactionsBudgetBreakdown>;
  /**
   * Returns a user's budget breakdown separated by month for a specified range.
   *   Datasource endpoint: /financial_accounts/transactions/cash_flow/top
   */
  financialTransactionsBudgetBreakdownByMonth?: Maybe<FinancialTransactionsBudgetBreakdownByMonthResponse>;
  /** Returns a user's cash in and cash out monthly summary for the current month and previous months */
  financialTransactionsCashInCashOutSummary?: Maybe<FinancialTransactionsCashInCashOutSummary>;
  /** Returns a user's cash in and cash out summary for the current date period and previous date period */
  financialTransactionsCashInCashOutSummaryForDatePeriod?: Maybe<FinancialTransactionsCashInCashOutSummaryForDatePeriodsResponse>;
  /** Returns the activation status of the CashFlow feature */
  cashFlowActivationStatus?: Maybe<CashFlowActivationStatusResponse>;
  /** Returns the activation status of the CreditScore feature */
  creditScoreActivationStatus?: Maybe<CreditScoreActivationStatusResponse>;
  /**
   * Returns the activation status of an EORU (Email-only Registered User).
   *   "Activated" means their visitor_profile is associated with an email address.
   */
  emailOnlyRegisteredUserStatus?: Maybe<EmailOnlyRegisteredUserActivationStatusResponse>;
  /** Returns the activation status of the NetWorth feature */
  netWorthActivationStatus?: Maybe<NetWorthActivationStatusResponse>;
  /** Query to get the feature discovery for web membership experience */
  webFeatureDiscovery?: Maybe<FeatureDiscoveryResponse>;
  /**
   * Returns a list of cards that should be displayed in the AWAL (Also Worth A Look) section of Member Home.
   *   (The term "feed" is a legacy PFM feature that predates the modern Member Home experience).
   */
  nonInsightFeedCards?: Maybe<Array<FeedCard>>;
  /**
   * Returns a list of authors followed by the user
   *   Includes WP information about the authors
   */
  followedAuthors: Array<FollowedAuthorResponse>;
  gamificationChecklist?: Maybe<GamificationChecklistResponse>;
  greenhouseDepartments?: Maybe<Array<GreenhouseDepartment>>;
  /**
   * Accepts an id, name, or kebabName field to filter for a GreenhouseDepartment.
   *   If multiple fields are present, the priority is id -> name -> kebabName.
   */
  greenhouseDepartment?: Maybe<GreenhouseDepartment>;
  greenhouseJob?: Maybe<GreenhouseJob>;
  /** Fetch the state from zipCode */
  getStateFromZipCode?: Maybe<GetStateFromZipCodeResponse>;
  getHealthNetwork?: Maybe<HealthNetworkData>;
  /**
   * The `authCookies` query returns the cookies returned when querying auth info. This could include cookies
   *   such as csrf_token, access_token, jwt_access_token, refresh_token
   */
  authCookies: Array<Cookie>;
  rawIdentity?: Maybe<RawIdentity>;
  rawIdentityProfile?: Maybe<RawIdentityProfile>;
  /**
   * The `subscriptionIdentityProfile` query returns subscription_profile_v3, the query/type is not versioned
   *   because of recommended GraphQL best practices
   */
  subscriptionIdentityProfile?: Maybe<SubscriptionIdentityProfile>;
  globalIdentityProfile?: Maybe<GlobalIdentityProfile>;
  identity?: Maybe<IdentityResponse>;
  mobileAppIdentityProfile?: Maybe<MobileAppIdentityProfile>;
  financialIdentityProfile?: Maybe<FinancialIdentityProfile>;
  termsOfServiceIdentityProfile?: Maybe<TermsOfServiceIdentityProfile>;
  hasLinkedFinancialAccounts: Scalars['Boolean']['output'];
  accountAggCtaDismissedFlags?: Maybe<AccountAggCtaDismissedResponse>;
  /** Return a list of UserInsights to be surfaced in a particular UX context (as expressed via the filter param) */
  userInsights: UserInsightsResponse;
  /**
   * Mutation-esque query
   *   Returns the user's current streak. If the current date is not in the same week or the consecutive week of the most recent completion date of weekly insights, then mutates the user's weekly_insights_completed_at array to be empty
   */
  getWeeklyInsightsCurrentStreak: WeeklyInsightsCurrentStreakResponse;
  /** Query to get the info banner details from the feature flag service */
  sitewideInfoBanner: SitewideInfoBannerResponse;
  /**
   * Search for account aggregation institutions by keyword, with the use case of an autocomplete input for users
   *   linking accounts in mind
   */
  institutionsForAccountLinkingByKeyword?: Maybe<AccountAggregationInstitutionsResponse>;
  /** Get a list of the top institutions used for account linking */
  topInstitutionsForAccountLinking?: Maybe<TopInstitutionsForLinkingResponse>;
  accountAggregationInstitutionById?: Maybe<AccountAggregationInstitutionByIdResponse>;
  /** Search for canonical institution by keyword, with the use case of an autocomplete input in mind */
  canonicalInstitutionsByKeyword?: Maybe<CanonicalInstitutionsResponse>;
  /**
   * Get a single credit card offer by its legacy ID
   *   Returns null if it cannot be found
   */
  creditCardOfferByLegacyId?: Maybe<CreditCardOffer>;
  /**
   * Returns credit card offers associated with the account aggregation institution first by
   *   checking for offers with a credit card institution matching the canonical institution ID of the account aggregation institution
   *   and falling back to a search by offer name using the account aggregation institution name.
   */
  creditCardOffersForAccountAggregationInstitution?: Maybe<CreditCardOffersV2Response>;
  creditCardOffersByLegacyIds?: Maybe<CreditCardOffersResponse>;
  /**
   * Search for credit card offers by keyword,
   *   with the use case of an autocomplete input in mind
   */
  creditCardOffersByKeyword?: Maybe<CreditCardOffersResponse>;
  creditCardOffersByNamedQuery?: Maybe<CreditCardOffersResponse>;
  /** Search for all active Personal Loan Offers. */
  personalLoanOffers?: Maybe<PersonalLoanOffersResponse>;
  /** Request a single personal loan offer by providing the offer's id. */
  personalLoanOffer?: Maybe<PersonalLoanOffer>;
  /** Returns recommended credit card offer bundles for the user. */
  recommendedCreditCardOfferBundles: CreditCardOfferBundlesResponse;
  savingsAccountOfferBySlug?: Maybe<SavingsAccountOffer>;
  savingsAccountOffersByNamedQuery: SavingsAccountOffersByNamedQueryResponse;
  marketplaceEntityV2?: Maybe<MarketplaceEntityInterface>;
  marketplaceEntitiesV2: Array<Maybe<MarketplaceEntityInterface>>;
  /** Get a specific marketplace field value based on entity id and field's raw path */
  marketplaceField?: Maybe<MarketplaceFieldResponse>;
  /**
   * Search for Marketplace entities by keyword
   *   using Marketplace's Autocomplete endpoint.
   *   https://docs.nerdwallet.io/marketplace/branches/master/api.full_text.html
   */
  marketplaceAutocompleteSearch?: Maybe<Array<MarketplaceEntityInterface>>;
  /**
   * Search for Marketplace entities
   *   using Marketplace's product search endpoint.
   */
  marketplaceSearch: MarketplaceSearchResponse;
  /**
   * Query to return unstructured marketplace entities given a list of ids.
   * @deprecated This query was created to support a migration away from Structured Content Data Dependencies and should not be used for new development.
   */
  marketplacePassthrough: Array<MarketplacePassthroughEntity>;
  /**
   * Query to return unstructured response for a marketplace named query.
   * @deprecated This query was created to support a migration away from Structured Content Data Dependencies and should not be used for new development.
   */
  marketplaceNamedQueryPassthrough: MarketplaceNamedQueryPassthroughResponse;
  /**
   * Returns the money management eligibility for a financial portal's accounts. AS part of
   *   determining the eligibility, the money management service goes through the process of attempting
   *   to IAV verify the accounts.
   */
  moneyTransferAccountEligibility?: Maybe<MoneyTransferAccountEligibilityResponse>;
  /** Return the transfer limits for the user */
  moneyTransferTransferLimits?: Maybe<MoneyTransferTransferLimitsResponse>;
  /**
   * Returns the KBA questions used by an onboarding money transfer user
   *   to identify themselves if we weren't able to from SSN alone:
   *   // https://nerdwallet.atlassian.net/wiki/spaces/PRODUCT/pages/620134583/KBA+in+Money+Management
   */
  moneyTransferKbaQuestions?: Maybe<MoneyTransferKbaQuestionsResponse>;
  /** Retrieve Home Lead Match offer based on offerId or legacy productId */
  mortgageSavedLeadMatch?: Maybe<MortgagesOfferV2>;
  /** Retrieve Home Lead Match offers given offer ids */
  mortgageSavedLeadMatches?: Maybe<MortgageSavedLendersResponse>;
  /** Retrieve Home Lead Match recommended lenders offers based on offerIds or legacy productIds */
  mortgageSavedRecommendedLenders?: Maybe<MortgageSavedRecommendedLendersResponse>;
  /** Find matching offers based on Mortgage OSX inputs */
  mortgageLenderMatch: Array<MortgagesOfferV2>;
  homeLeadMatch: Array<MortgagesOfferWithRates>;
  /** Checks if the user is in a state where NerdWallet is a licensed mortgage broker */
  isNerdWalletMortgageLicensed: MortgageLicensed;
  /** Retrieve Mortgage Best of Award marketplace entity and category details based on award category */
  mortgageBestOfAwardWinnerDetails?: Maybe<MortgageBestOfAwardWinnerDetails>;
  /** Information on the user's NerdUp Credit Card, if applicable */
  nerdUpCreditCard: NerdUpCreditCardData;
  /** Information on the user's accounts */
  nerdUpUserAccounts: UserAccountInformation;
  /** Information on the users's overall status */
  nerdUpUserOverallStatus: UserOverallStatus;
  /**
   * Net worth breakdown balances, with account grouping logic based upon "nw_type"
   * @deprecated the new UI should use netWorthBalancesByFinancialAccountCategorization
   */
  netWorthBalances?: Maybe<NetWorthBalances>;
  /** Net worth breakdown balances, with account grouping logic based upon FDP account type/subtype */
  netWorthBalancesByFinancialDataCategorization?: Maybe<NetWorthBalances>;
  /**
   * Returns the user's net worth contributions summary.
   *   Datasource endpoint: wealth-recommender/contributions/v1/identities/me/summary
   * @deprecated Deprecated in favor of using FDP and FIS instead of wealth-recommender.
   */
  netWorthContributionSummaries?: Maybe<NetWorthContributionSummaries>;
  /**
   * NOTE: The underlying endpoint has been deprecated. Please do not make any new requests.
   *   This query will be removed after traffic has ceased.
   *
   *   Returns the user's net worth recommendations.
   *   Datasource endpoint: wealth-recommender/recommendations/v1/identities/me/recommendations
   */
  netWorthRecommendations?: Maybe<NetWorthRecommendations>;
  /**
   * Returns the wealth recommender user. Creates it if it doesn't already exist.
   *   Datasource endpoint: wealth-recommender/users/v1/identities/me/users
   */
  wealthRecommenderUser?: Maybe<WealthRecommenderUser>;
  /**
   * Returns the user's net worth accounts. The fields provided by Wealth Recommender are
   *   annotations on the accounts supplied by Identity/FDP.
   *   Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts
   */
  netWorthAccounts?: Maybe<NetWorthAccountsResponse>;
  /**
   * Returns the user's net worth account pertaining to the provided financial account ID.
   *   Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts
   */
  netWorthAccountByFinancialAccountId?: Maybe<NetWorthAccountResponse>;
  /**
   * Returns the user's net worth account pertaining to the provided net worth account ID.
   *   Datasource endpoint: wealth-recommender/accounts/v1/identities/me/accounts/<net_worth_account_id>
   */
  netWorthAccountById?: Maybe<NetWorthAccountResponse>;
  /**
   * Returns the user's net worth real assets, which depicts their non-monetary assets
   *   Datasource endpoint: wealth-recommender/assets/v1/identities/me/assets
   */
  netWorthRealAssets?: Maybe<NetWorthRealAssetsResponse>;
  /**
   * Returns the user's net worth real asset, which depicts their non-monetary assets
   *   Datasource endpoint: wealth-recommender/assets/v1/identities/me/assets/<net_worth_real_asset_id>
   */
  netWorthRealAsset?: Maybe<NetWorthRealAssetResponse>;
  /**
   * Returns the provider home value pertaining to the specified address. Currently only
   *   returns the Redfin home value, but could potentially be extended to include Zillow.
   *   Datasource endpoint: wealth-recommender/home/v1/home_value
   * @deprecated the new UI should be using netWorthHomeValueResultWithPossibilitiesByAddress
   */
  netWorthHomeValueResultByAddress?: Maybe<NetWorthHomeValueResultResponse>;
  /**
   * Returns the provider home value pertaining to the specified property_id. Currently only
   *   returns the Redfin home value, but could potentially be extended to include Zillow.
   *   Datasource endpoint: wealth-recommender/home/v2/home_value
   */
  netWorthHomeValueResultByPropertyId?: Maybe<NetWorthHomeValueResultByPropertyIdResponse>;
  /**
   * Returns the provider home value result pertaining to the specified address, or a list of
   *   possible home value results. Currently only returns Redfin home values, but could potentially
   *   be extended to include Zillow. This query effectively replaces
   *   netWorthHomeValueResultByAddress.
   *   Datasource endpoint: wealth-recommender/home/v2/home_value
   */
  netWorthHomeValueResultWithPossibilitiesByAddress?: Maybe<NetWorthHomeValueResultWithPossibilitiesResponse>;
  /**
   * Returns the user's net worth contributions summary.
   *   Datasource endpoint: wealth-recommender/contributions/v1/identities/me/summary
   */
  netWorthHistory?: Maybe<NetWorthHistoryResponse>;
  /**
   * Returns boolean that denotes whether or not to show the snapshot notification.
   *   Show the notification to users who linked accounts or assets before the respective cutoff dates.
   */
  netWorthHistorySnapshotNotification?: Maybe<NetWorthHistorySnapshotNotificationResponse>;
  /** Retrieve Personal Loans Best of Award marketplace entity and category details based on award category */
  personalLoansBestOfAwardWinnerDetails?: Maybe<PersonalLoansBestOfAwardWinnerDetails>;
  financialPriorities?: Maybe<FinancialPrioritiesResponse>;
  financialPrioritiesFeatureDiscovery?: Maybe<FinancialPrioritiesFeatureDiscoveryResponse>;
  /** Get status of prequal jobs by specifiying a job ID, the prequal serivce, and the path */
  prequalJobStatus: PrequalJobStatusResponse;
  /** Get auto insurance prequal offers */
  autoInsurancePrequalOffers?: Maybe<AutoInsurancePrequalOffersResponse>;
  /** Get auto insurance prequal offers without cache (v2) */
  autoInsurancePrequalOffersJobIds?: Maybe<AutoInsurancePrequalOffersJobResponse>;
  /** Get offers response from a list of Prequal Jobs */
  autoInsurancePrequalOffersV2?: Maybe<AutoInsurancePrequalOffersResponseV2>;
  creditCardPrequalOffers: CreditCardPrequalOffersResponse;
  /** Search for decline loan offers that match the relevant expanded marketplace category */
  declinePersonalLoanOffersSearch?: Maybe<DeclinePersonalLoanOffers>;
  /** Get insurance prequal offers (v1) */
  insurancePrequalOffers?: Maybe<InsurancePrequalOffersResponse>;
  /** Get offers response from a list of Prequal Jobs (v2) */
  insurancePrequalOffersByJobId?: Maybe<InsurancePrequalOffersByJobIdResponse>;
  /** Get insurance prequal offers without cache (v2) */
  insurancePrequalOffersJobIds?: Maybe<InsurancePrequalOffersJobResponse>;
  /** Return saved personal loans prequal offer data for the given user */
  savedPersonalLoansPrequalOffers?: Maybe<SavedPersonalLoansPrequalOffers>;
  /** Return a list of Recently Viewed posts */
  recentlyViewed?: Maybe<Array<RecentlyViewed>>;
  recommendedGuidance: Array<RecommendationGuidance>;
  rewardAccounts?: Maybe<Array<RewardAccount>>;
  userReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /** Retrieve content related to the given keywords from WP via the search service */
  rewardsContent: SearchServiceContentSearchResults;
  /** Return a list of saved content for a specific entity type */
  savedContentByEntityType: Array<SavedContentResponse>;
  /** Return information for a specific piece of saved content */
  savedContentById: SavedContentResponse;
  getContent: SearchServiceContentSearchResults;
  /**
   * The total amount of money spent this month from the first day to the current day in dollars.
   *   Optionally, currentDate variable can be pass to the query to override the user current date
   *   used to calculate total amount, if not present it will default to the server current date.
   *   Example: Return value is `6000.56`
   */
  totalAmountSpentCurrentMonth?: Maybe<Scalars['Float']['output']>;
  /**
   * The total amount of money spent last month from the first day to the same current day last month in dollars.
   *   Optionally, currentDate variable can be pass to the query to override the user current date
   *   used to calculate total amount, if not present it will default to the server current date.
   *   Example: Return value is `6000.56`
   */
  totalAmountSpentPreviousMonthToDate?: Maybe<Scalars['Float']['output']>;
  /**
   * Total sum of a user checking, investing, savings, retirement account balances on the passed-in date.
   *   Example: Return value is `86000.56`
   */
  csirBalanceOnDate?: Maybe<Scalars['Float']['output']>;
  /** Query for the data to render a page with structured content client */
  structuredContentPage: StructuredContentPageInterface;
  /** Retrieve Personal Loans Best of Award marketplace entity and category details based on award category */
  studentLoansBestOfAwardWinnerDetails?: Maybe<StudentLoansBestOfAwardWinnerDetails>;
  trueCarData: TrueCarData;
  getUserOpsFDPLinkingErrorEvents: Array<UserOpsPaoEventDetails>;
  getUserOpsCommsSubscriptionPreferencesWrapperList: Array<UserOpsCommsSubscriptionPreferencesWrapper>;
  getUserOpsFinancialPriorities: UserOpsFinancialPriorities;
  getFinancialPrioritiesForUser: Array<UdpFinancialPriorities>;
  getUserOpsMessagingActivityEventsList: Array<Maybe<UserOpsMessagingActivityEvent>>;
  /** Retrieves all the of the user's wallet cards associated with their identity from the my cards service. */
  userWalletCards?: Maybe<UserWalletCardsResponse>;
  /** Query to fetch a single Article object. */
  article?: Maybe<Article>;
  /** Query to fetch a single Article object. */
  articleFork?: Maybe<Article>;
  /** Query to fetch multiple Article objects. */
  articles?: Maybe<ArticleConnectionResponse>;
  /** Query to fetch a single AUFlexPage object. */
  aUFlexPage?: Maybe<AuFlexPage>;
  /** Query to fetch a single AUFlexPage object. */
  aUFlexPageFork?: Maybe<AuFlexPage>;
  /** Query to fetch multiple AUFlexPage objects. */
  aUFlexPages?: Maybe<AuFlexPageConnectionResponse>;
  /** Query to fetch a single AUFlexTemplate object. */
  aUFlexTemplate?: Maybe<AuFlexTemplate>;
  /** Query to fetch a single AUFlexTemplate object. */
  aUFlexTemplateFork?: Maybe<AuFlexTemplate>;
  /** Query to fetch multiple AUFlexTemplate objects. */
  aUFlexTemplates?: Maybe<AuFlexTemplateConnectionResponse>;
  /** Query to fetch a single Author object. */
  author?: Maybe<Author>;
  /** Query to fetch a single BccPage object. */
  bccPage?: Maybe<BccPage>;
  /** Query to fetch a single BccPageCard object. */
  bccPageCard?: Maybe<BccPageCard>;
  /** Query to fetch multiple BccPageCard objects. */
  bccPageCards?: Maybe<BccPageCardConnectionResponse>;
  /** Query to fetch multiple BccPage objects. */
  bccPages?: Maybe<BccPageConnectionResponse>;
  /** Query to fetch a single Block object. */
  block?: Maybe<Block>;
  /** Query to fetch a single BlockGroup object. */
  blockGroup?: Maybe<BlockGroup>;
  /** Query to fetch multiple BlockGroup objects. */
  blockGroups?: Maybe<BlockGroupConnectionResponse>;
  /** Query to fetch multiple Block objects. */
  blocks?: Maybe<BlockConnectionResponse>;
  /** Query to fetch a single CAFlexPage object. */
  cAFlexPage?: Maybe<CaFlexPage>;
  /** Query to fetch a single CAFlexPage object. */
  cAFlexPageFork?: Maybe<CaFlexPage>;
  /** Query to fetch multiple CAFlexPage objects. */
  cAFlexPages?: Maybe<CaFlexPageConnectionResponse>;
  /** Query to fetch a single CAFlexTemplate object. */
  cAFlexTemplate?: Maybe<CaFlexTemplate>;
  /** Query to fetch a single CAFlexTemplate object. */
  cAFlexTemplateFork?: Maybe<CaFlexTemplate>;
  /** Query to fetch multiple CAFlexTemplate objects. */
  cAFlexTemplates?: Maybe<CaFlexTemplateConnectionResponse>;
  /** Query to fetch a single CalculatorPage object. */
  calculatorPage?: Maybe<CalculatorPage>;
  /** Query to fetch a single CalculatorPage object. */
  calculatorPageFork?: Maybe<CalculatorPage>;
  /** Query to fetch multiple CalculatorPage objects. */
  calculatorPages?: Maybe<CalculatorPageConnectionResponse>;
  /** Query to fetch a single Category object. */
  category?: Maybe<Category>;
  /** Query to fetch a single ContentHub object. */
  contentHub?: Maybe<ContentHub>;
  /** Query to fetch a single ContentHub object. */
  contentHubFork?: Maybe<ContentHub>;
  /** Query to fetch multiple ContentHub objects. */
  contentHubs?: Maybe<ContentHubConnectionResponse>;
  /** Query to fetch a single ContentPack object. */
  contentPack?: Maybe<ContentPack>;
  /** Query to fetch multiple ContentPack objects. */
  contentPacks?: Maybe<ContentPackConnectionResponse>;
  /** Query to fetch a single ContentReviewer object. */
  contentReviewer?: Maybe<ContentReviewer>;
  /** Query to fetch multiple ContentReviewer objects. */
  contentReviewers?: Maybe<ContentReviewerConnectionResponse>;
  /** Query to fetch a collection of content search results. */
  contentSearch?: Maybe<ContentSearchResultConnectionResponse>;
  /** Query to fetch a single ContentUserPage object. */
  contentUserPage?: Maybe<ContentUserPage>;
  /** Query to fetch a single ContentUserPage object. */
  contentUserPageFork?: Maybe<ContentUserPage>;
  /** Query to fetch multiple ContentUserPage objects. */
  contentUserPages?: Maybe<ContentUserPageConnectionResponse>;
  /** Query to fetch a single DynamicPlacement object. */
  dynamicPlacement?: Maybe<DynamicPlacement>;
  /** Query to fetch multiple DynamicPlacement objects. */
  dynamicPlacements?: Maybe<DynamicPlacementConnectionResponse>;
  /** Query to fetch a single EngineeringPost object. */
  engineeringPost?: Maybe<EngineeringPost>;
  /** Query to fetch multiple EngineeringPost objects. */
  engineeringPosts?: Maybe<EngineeringPostConnectionResponse>;
  /** Query to fetch a single FlexPage object. */
  flexPage?: Maybe<FlexPage>;
  /** Query to fetch a single FlexPage object. */
  flexPageFork?: Maybe<FlexPage>;
  /** Query to fetch multiple FlexPage objects. */
  flexPages?: Maybe<FlexPageConnectionResponse>;
  /** Query to fetch a single FlexTemplate object. */
  flexTemplate?: Maybe<FlexTemplate>;
  /** Query to fetch a single FlexTemplate object. */
  flexTemplateFork?: Maybe<FlexTemplate>;
  /** Query to fetch multiple FlexTemplate objects. */
  flexTemplates?: Maybe<FlexTemplateConnectionResponse>;
  /** Query to fetch a single GlobalNavItem object. */
  globalNavItem?: Maybe<GlobalNavItem>;
  /** Query to fetch a single GlobalNavItem object. */
  globalNavItemFork?: Maybe<GlobalNavItem>;
  /** Query to fetch multiple GlobalNavItem objects. */
  globalNavItems?: Maybe<GlobalNavItemConnectionResponse>;
  /** Query to fetch a single HouseAd object. */
  houseAd?: Maybe<HouseAd>;
  /** Query to fetch multiple HouseAd objects. */
  houseAds?: Maybe<HouseAdConnectionResponse>;
  /** Query to fetch a single Hub object. */
  hub?: Maybe<Hub>;
  /** Query to fetch a single Hub object. */
  hubFork?: Maybe<Hub>;
  /** Query to fetch multiple Hub objects. */
  hubs?: Maybe<HubConnectionResponse>;
  /** Query to fetch a single InsuranceFlexPage object. */
  insuranceFlexPage?: Maybe<InsuranceFlexPage>;
  /** Query to fetch a single InsuranceFlexPage object. */
  insuranceFlexPageFork?: Maybe<InsuranceFlexPage>;
  /** Query to fetch multiple InsuranceFlexPage objects. */
  insuranceFlexPages?: Maybe<InsuranceFlexPageConnectionResponse>;
  /** Query to fetch a single InsurancePage object. */
  insurancePage?: Maybe<InsurancePage>;
  /** Query to fetch multiple InsurancePage objects. */
  insurancePages?: Maybe<InsurancePageConnectionResponse>;
  /** Query to fetch a single InsuranceTemplate object. */
  insuranceTemplate?: Maybe<InsuranceTemplate>;
  /** Query to fetch a single InsuranceTemplate object. */
  insuranceTemplateFork?: Maybe<InsuranceTemplate>;
  /** Query to fetch multiple InsuranceTemplate objects. */
  insuranceTemplates?: Maybe<InsuranceTemplateConnectionResponse>;
  /** Query to fetch a single LandingPage object. */
  landingPage?: Maybe<LandingPage>;
  /** Query to fetch a single LandingPage object. */
  landingPageFork?: Maybe<LandingPage>;
  /** Query to fetch multiple LandingPage objects. */
  landingPages?: Maybe<LandingPageConnectionResponse>;
  /** Query to fetch a single LegacyLender object. */
  legacyLender?: Maybe<LegacyLender>;
  /** Query to fetch multiple LegacyLender objects. */
  legacyLenders?: Maybe<LegacyLenderConnectionResponse>;
  /** Query to fetch a single MarketplaceEntryPoint object. */
  marketplaceEntryPoint?: Maybe<MarketplaceEntryPoint>;
  /** Query to fetch multiple MarketplaceEntryPoint objects. */
  marketplaceEntryPoints?: Maybe<MarketplaceEntryPointConnectionResponse>;
  /** Query to fetch a single MediaItem object. */
  mediaItem?: Maybe<MediaItem>;
  /** Query to fetch multiple MediaItem objects. */
  mediaItems?: Maybe<MediaItemConnectionResponse>;
  /** Query to fetch a single MediaSite object. */
  mediaSite?: Maybe<MediaSite>;
  /** Query to fetch a single Page object. */
  page?: Maybe<Page>;
  /** Query to fetch a single Post object. */
  post?: Maybe<Post>;
  /** Query for a single post-like object from WP given its ID. */
  postById?: Maybe<PostInterface>;
  /** Query for a collection of post-like objects from WP given their IDs. */
  postsById?: Maybe<Array<PostInterface>>;
  /** Query to fetch a single PressRelease object. */
  pressRelease?: Maybe<PressRelease>;
  /** Query to fetch multiple PressRelease objects. */
  pressReleases?: Maybe<PressReleaseConnectionResponse>;
  /** Query to fetch a single Review object. */
  review?: Maybe<Review>;
  /** Query to fetch a single Review object. */
  reviewFork?: Maybe<Review>;
  /** Query to fetch multiple Review objects. */
  reviews?: Maybe<ReviewConnectionResponse>;
  /** Query to fetch a single Roundup object. */
  roundup?: Maybe<Roundup>;
  /** Query to fetch a single Roundup object. */
  roundupFork?: Maybe<Roundup>;
  /** Query to fetch multiple Roundup objects. */
  roundups?: Maybe<RoundupConnectionResponse>;
  /** Query to fetch a single StructuredContentCalculator object. */
  structuredContentCalculator?: Maybe<StructuredContentCalculator>;
  /** Query to fetch multiple StructuredContentCalculator objects. */
  structuredContentCalculators?: Maybe<StructuredContentCalculatorConnectionResponse>;
  /** Query to fetch a single Table object. */
  table?: Maybe<Table>;
  /** Query to fetch multiple Table objects. */
  tables?: Maybe<TableConnectionResponse>;
  /** Query to fetch a single UrlRecord object. */
  urlRecord?: Maybe<UrlRecord>;
  /** Query to fetch multiple UrlRecord objects. */
  urlRecords?: Maybe<UrlRecordConnectionResponse>;
  /**
   * Query to fetch a collection of related articles.
   *   This query is meant to be a temporary implementation to support a use-case
   *   in article-client. The intention is to replace it with a more robust solution
   *   and remove it entirely soon after.
   */
  relatedArticles?: Maybe<Array<Article>>;
  userBestCreditCardRecommendations?: Maybe<UserBestCreditCardRecommendations>;
  /** The (Filtered) BCC Page Sections for a given post. */
  bccPageSections: Array<BccPageSection>;
  /** Whether or not the current user is logged in to WordPress. */
  isUserLoggedInToWP: Scalars['Boolean']['output'];
  /** Query to return a URL Record by current URL. */
  urlRecordByUrl?: Maybe<UrlRecord>;
  youtubeVideo?: Maybe<YoutubeVideo>;
  /**
   * Retrieves a list of all credit cards that the ML API supports calculating approval
   *   odds predictions for.
   */
  creditCardApprovalOddsPrediction?: Maybe<CreditCardApprovalOddsPredictionResponse>;
  /** Retrieves a list of all of the credit card IDs that support approval odds. */
  creditCardOfferIdsWithApprovalOddsPrediction?: Maybe<CreditCardOfferIdsWithApprovalOddsPredictionResponse>;
  /** Returns the service test state profile for the current user */
  serviceTestStateProfile?: Maybe<ServiceTestStateProfile>;
  /** Returns the query0 current version */
  query0Version?: Maybe<Scalars['String']['output']>;
  /** Retrieve array of HealthabilityReports from the trunk branch of all repos */
  healthability?: Maybe<Array<Maybe<HealthabilityReport>>>;
};


/** Empty field. Not to be used. */
export type QueryDrcCitySummaryArgs = {
  stateCode: StateCodeEnum;
  cityName: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryDrcVehicleSummaryArgs = {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryAbExperimentsArgs = {
  uuid?: InputMaybe<Scalars['String']['input']>;
  testNames: Array<InputMaybe<Scalars['String']['input']>>;
};


/** Empty field. Not to be used. */
export type QuerySiteSearchArgs = {
  searchQuery?: InputMaybe<SearchQueryInput>;
};


/** Empty field. Not to be used. */
export type QuerySmbThingArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryNotificationsArgs = {
  options?: InputMaybe<NotificationsInput>;
};


/** Empty field. Not to be used. */
export type QuerySendMessageArgs = {
  conversation?: InputMaybe<ChatBotConversation>;
};


/** Empty field. Not to be used. */
export type QueryArticlePlainTextArgs = {
  contentId?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryScriptedQuestionsArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Empty field. Not to be used. */
export type QueryScriptedAnswersArgs = {
  ids?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Empty field. Not to be used. */
export type QueryCostOfLivingCitiesArgs = {
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Empty field. Not to be used. */
export type QueryCityLifeCitiesArgs = {
  slugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};


/** Empty field. Not to be used. */
export type QueryPreFillArgs = {
  input: PreFillInput;
};


/** Empty field. Not to be used. */
export type QueryGetHistoricalRatesArgs = {
  state?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryHousingCharacteristicsByStateArgs = {
  state: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryExperimentDecisionsArgs = {
  testNames: Array<Scalars['String']['input']>;
  userAttributes: Scalars['JSON']['input'];
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  uidType?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryAbSmartlyFeatureFlagsArgs = {
  featureFlagNames: Array<Scalars['String']['input']>;
  userAttributes?: InputMaybe<Scalars['JSON']['input']>;
  anonymousId?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryAbSmartlyFeatureFlagsByAppArgs = {
  userAttributes?: InputMaybe<Scalars['JSON']['input']>;
  anonymousId?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFeatureFlagsArgs = {
  appName?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFeatureFlagArgs = {
  featureFlagName: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryQsInsuranceOffersArgs = {
  userInput?: InputMaybe<HomeInsuranceOfferInput>;
  userInfo?: InputMaybe<OfferUserInfoInput>;
  homeInfo?: InputMaybe<HomeInsuranceOfferInput>;
  driverInfo?: InputMaybe<OfferDriverInfoInput>;
  lifeInfo?: InputMaybe<LifeInsuranceOfferInput>;
  vertical: InsuranceVerticalEnum;
};


/** Empty field. Not to be used. */
export type QueryGetInsuranceAirFieldV2Args = {
  identifier: Scalars['String']['input'];
  airData?: InputMaybe<Scalars['JSON']['input']>;
};


/** Empty field. Not to be used. */
export type QueryGetInsuranceAirListArgs = {
  identifier: Scalars['String']['input'];
  airData?: InputMaybe<AirData>;
};


/** Empty field. Not to be used. */
export type QueryGetInsuranceAirTableArgs = {
  identifier: Scalars['String']['input'];
  airData?: InputMaybe<Scalars['JSON']['input']>;
};


/** Empty field. Not to be used. */
export type QueryGetVehicleMakesByYearArgs = {
  year: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetVehicleModelsByMakeYearArgs = {
  year: Scalars['Int']['input'];
  make: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryQwInsuranceLeadsArgs = {
  contactInput: HomeInsuranceQwContactInput;
  residenceInput: HomeInsuranceQwResidenceInput;
  vendorData: VendorData;
  analyticsProps: AnalyticsProps;
};


/** Empty field. Not to be used. */
export type QueryQsInsuranceLeadsArgs = {
  vendorData: VendorData;
  userInfo: OfferUserInfoInput;
  driverInfo: OfferDriverInfoInput;
  analyticsProps?: InputMaybe<AnalyticsProps>;
};


/** Empty field. Not to be used. */
export type QueryGetSmProductQuoteArgs = {
  quoteNumber: Scalars['String']['input'];
  productVersions?: InputMaybe<Array<ProductVersionInput>>;
};


/** Empty field. Not to be used. */
export type QueryGetDriverStatusArgs = {
  driverId: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryDeleteTripArgs = {
  driverId: Scalars['String']['input'];
  tripId: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetDriverTripsArgs = {
  driverId: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  orderType?: InputMaybe<OrderTypeEnum>;
  cursor?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryGetAdUnitV2Args = {
  driverId: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetSupportedStateArgs = {
  countryCode: Scalars['String']['input'];
  stateCode: Scalars['String']['input'];
  currentInsurer: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QuerySetDriverInfoArgs = {
  driverId: Scalars['String']['input'];
  country: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
  insurer?: InputMaybe<Scalars['String']['input']>;
  acqSource?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryUpdatePasswordlessUserArgs = {
  token: Scalars['String']['input'];
  newEmail: Scalars['EmailAddress']['input'];
  newPassword: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryValidatePhoneArgs = {
  phoneNumber: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryEvertreeInsuranceLeadsArgs = {
  linesOfBusiness?: InputMaybe<LinesOfBusiness>;
  propertyAddress?: InputMaybe<IntakeAddressModel>;
  primaryApplicant?: InputMaybe<IntakePrimaryApplicantModel>;
  primaryApplicantWithPhone?: InputMaybe<EvertreePrimaryApplicantInput>;
  analyticsProps?: InputMaybe<AnalyticsProps>;
};


/** Empty field. Not to be used. */
export type QueryGetFenrisProfileDataArgs = {
  person: FenrisPerson;
  address: FenrisAddress;
  responseType?: InputMaybe<FenrisResponseTypeEnum>;
};


/** Empty field. Not to be used. */
export type QueryGetCovrQuotesArgs = {
  gender: CovrGenderEnum;
  dob: Scalars['String']['input'];
  tobacco: Scalars['Boolean']['input'];
  heightFeet: Scalars['Int']['input'];
  heightInches: Scalars['Int']['input'];
  weightPounds: Scalars['Int']['input'];
  faceAmount: Scalars['Int']['input'];
  termLengthYears: Scalars['Int']['input'];
  stateCode: Us51State;
  healthClass?: InputMaybe<CovrHealthClassEnum>;
  customerID?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryGetCovrAppointmentsArgs = {
  date: Scalars['String']['input'];
  timeZone: CovrTimeZoneEnum;
};


/** Empty field. Not to be used. */
export type QueryPostCovrAppointmentArgs = {
  shoppingFinishId?: InputMaybe<Scalars['String']['input']>;
  partnerTrackingId?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<CovrGenderEnum>;
  dob?: InputMaybe<Scalars['String']['input']>;
  tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  heightFeet?: InputMaybe<Scalars['Int']['input']>;
  heightInches?: InputMaybe<Scalars['Int']['input']>;
  weightPounds?: InputMaybe<Scalars['Int']['input']>;
  faceAmount?: InputMaybe<Scalars['Int']['input']>;
  termLengthYears?: InputMaybe<Scalars['Int']['input']>;
  stateCode?: InputMaybe<Us51State>;
  healthClass?: InputMaybe<CovrHealthClassEnum>;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  phone: Scalars['String']['input'];
  specificAppointmentTime?: InputMaybe<Scalars['DateTime']['input']>;
  specificAppointmentTimeZone?: InputMaybe<CovrTimeZoneEnum>;
  quoteResult: QuoteResultInput;
  customerID?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryPostCovrLgaHandoffArgs = {
  shoppingFinishId?: InputMaybe<Scalars['String']['input']>;
  partnerTrackingId?: InputMaybe<Scalars['String']['input']>;
  dob: Scalars['String']['input'];
  gender: CovrGenderEnum;
  stateCode: Us51State;
  tobacco: Scalars['Boolean']['input'];
  heightFeet: Scalars['Int']['input'];
  heightInches: Scalars['Int']['input'];
  weightPounds: Scalars['Int']['input'];
  termLengthYears: Scalars['Int']['input'];
  faceAmount: Scalars['Int']['input'];
  phone: Scalars['String']['input'];
  quoteResult: QuoteResultInput;
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  healthClass?: InputMaybe<CovrHealthClassEnum>;
  customerID?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryPostCovrAmericoHandoffArgs = {
  shoppingFinishId?: InputMaybe<Scalars['String']['input']>;
  dob: Scalars['String']['input'];
  gender?: InputMaybe<CovrGenderEnum>;
  stateCode?: InputMaybe<Us51State>;
  tobacco?: InputMaybe<Scalars['Boolean']['input']>;
  heightFeet?: InputMaybe<Scalars['Int']['input']>;
  heightInches?: InputMaybe<Scalars['Int']['input']>;
  weightPounds?: InputMaybe<Scalars['Int']['input']>;
  termLengthYears?: InputMaybe<Scalars['Int']['input']>;
  faceAmount?: InputMaybe<Scalars['Int']['input']>;
  quoteResult: QuoteResultInput;
  partnerTrackingId?: InputMaybe<Scalars['String']['input']>;
  customerID?: InputMaybe<Scalars['String']['input']>;
  customerId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  healthClass?: InputMaybe<CovrHealthClassEnum>;
};


/** Empty field. Not to be used. */
export type QueryMaHomeInsuranceOffersArgs = {
  data: MediaAlphaHomeInsuranceUserData;
  ua: Scalars['String']['input'];
  ua_language?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  sub_1?: InputMaybe<Scalars['String']['input']>;
  sub_2?: InputMaybe<Scalars['String']['input']>;
  sub_3?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryPostHomeInsuranceQuoteRequestToCoveredArgs = {
  propertyAddress: IntakeAddressModel;
  primaryInsured: IntakePrimaryApplicantModelWithPhone;
  analyticsProps?: InputMaybe<AnalyticsProps>;
};


/** Empty field. Not to be used. */
export type QueryCarImagesArgs = {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
  year: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryCarDataArgs = {
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
  year?: InputMaybe<Scalars['String']['input']>;
  trimId?: InputMaybe<Scalars['String']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  withNoMatchedSegments?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty field. Not to be used. */
export type QueryCarDataByTrimArgs = {
  trimIds?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Empty field. Not to be used. */
export type QueryModelsArgs = {
  make: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryYearsArgs = {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryCarTrimDataArgs = {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
  year: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryCarReviewLinksArgs = {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryCarModelDataArgs = {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
  year: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryCarIngestionLogsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryCarIngestionLogEventsArgs = {
  ingestionLogId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryCarDataExportArgs = {
  year: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type QueryCarBestListsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryCarModelBestListArgs = {
  styleIds: Array<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntityTestArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntitiesTestArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntityV2TestArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntitiesV2TestArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Empty field. Not to be used. */
export type QueryNativeFeatureDiscoveryArgs = {
  effectiveDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  identityId?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountsByPortalArgs = {
  financialPortalId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountsIavDetailsArgs = {
  financialAccountIds: Array<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountTypeSumsArgs = {
  identityId?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialAccountByIdArgs = {
  financialAccountId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialCreditCardRewardsArgs = {
  filter?: InputMaybe<FinancialCreditCardRewardFilterInput>;
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialNwPlusRewardsArgs = {
  filter?: InputMaybe<FinancialNwPlusRewardFilterInput>;
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
  identityId?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryAnonymousShoppingEventsArgs = {
  anonymousId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialPortalsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  filters?: InputMaybe<FinancialPortalFilterInput>;
  identityId?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryLinkedFinancialPortalsArgs = {
  pagination?: InputMaybe<OffsetPaginationInput>;
  filters?: InputMaybe<FinancialPortalFilterInput>;
  identityId?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryInitializeFinancialPortalArgs = {
  marketplaceInstitutionId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialPortalByInstitutionIdArgs = {
  marketplaceInstitutionId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialPortalByIdArgs = {
  financialPortalId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryInstitutionHealthDetailsByPortalIdArgs = {
  financialPortalId: Scalars['ID']['input'];
  identityId?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryInitializeLinkTokenArgs = {
  iavEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  androidPackageName?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryBillStreamsArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QueryGetBillStreamByIdArgs = {
  id: Scalars['ID']['input'];
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QueryUserBillStreamsArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QuerySuggestedBillStreamsArgs = {
  filter?: InputMaybe<BillStreamFilterInput>;
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QueryUserUpcomingBillStreamsArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsArgs = {
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
  sort?: InputMaybe<FinancialTransactionsSortInput>;
  identityId?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionByIdArgs = {
  transactionId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSyncArgs = {
  pagination: SyncPaginationInput;
  identityId?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialUsersForIdentityIdArgs = {
  identityId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryCoveredQuoteStatusArgs = {
  policyId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryInsurancePolicyArgs = {
  policyId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryInsurancePolicyRateReportArgs = {
  policyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryInsurancePoliciesRateReportsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryInsurancePullArgs = {
  pullId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryInsuranceDocumentUrlArgs = {
  documentId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryInsurancePolicyOverridesArgs = {
  policyId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryAccountReconnectTokenArgs = {
  accountId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryRewardEventPointsArgs = {
  eventTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty field. Not to be used. */
export type QueryNwPlusOutstandingEventsArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QueryNwPlusUserQualifiedRewardsArgs = {
  includeCompleted?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty field. Not to be used. */
export type QueryNwPlusRedeemedRewardsHistoryArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<NwPlusCompletedEventOrder>;
  sort?: InputMaybe<NwPlusCompletedEventSort>;
};


/** Empty field. Not to be used. */
export type QueryNwPlusCompletedEventsArgs = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<NwPlusCompletedEventOrder>;
  sort?: InputMaybe<NwPlusCompletedEventSort>;
};


/** Empty field. Not to be used. */
export type QueryNwPlusRewardedCompletedEventsArgs = {
  filter?: InputMaybe<NwPlusRewardedCompletedEventFilter>;
};


/** Empty field. Not to be used. */
export type QueryNwPlusNativeCopyArgs = {
  featureFlagNames?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Empty field. Not to be used. */
export type QueryScribeUpBillsUrlArgs = {
  initParams?: InputMaybe<ScribeUpBillsUrlInput>;
};


/** Empty field. Not to be used. */
export type QueryAdminAccountDetailsArgs = {
  identityId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryInvestmentAccountsEmbedModuleArgs = {
  atomicProductType?: InputMaybe<AtomicProductType>;
};


/** Empty field. Not to be used. */
export type QueryInvestmentAccountsNwPlusRewardsArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QueryCompareAutoInsuranceCarriersArgs = {
  carrierA: Scalars['String']['input'];
  carrierB: Scalars['String']['input'];
  state: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QuerySuggestedBillsArgs = {
  userCurrentDate?: InputMaybe<Scalars['Date']['input']>;
};


/** Empty field. Not to be used. */
export type QueryCashFlowBreakdownArgs = {
  currentDate: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryCashFlowHistoryBreakdownArgs = {
  currentDate: Scalars['Date']['input'];
  numPreviousMonthsToInclude: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type QueryCashFlowTopTakeawaysArgs = {
  currentDate: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetChapterArgs = {
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  id?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  medicarePlanType: Scalars['String']['input'];
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  utmCampaign: Scalars['String']['input'];
  zip?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryMemberHomeContentPacksArgs = {
  options?: InputMaybe<ContentPacksOptionsInput>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardMatchQuizAnswersArgs = {
  quizVersion: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type QueryCreditCardMatchQuizOffersArgs = {
  quizVersion: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type QueryCreditScoreHistoryArgs = {
  input: CreditScoreHistoryInput;
};


/** Empty field. Not to be used. */
export type QuerySimulateCreditScoreArgs = {
  input: CreditSimulationInput;
};


/** Empty field. Not to be used. */
export type QuerySimulateVantageScoreArgs = {
  input: CreditSimulationInput;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingAndEarningForMonthRangeArgs = {
  dateInStartMonth: Scalars['Date']['input'];
  dateInEndMonth: Scalars['Date']['input'];
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByCategoryForMonthArgs = {
  dateInTargetMonth: Scalars['Date']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByDateForMonthArgs = {
  dateInTargetMonth: Scalars['Date']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingPeriodComparisonArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
  datePeriod?: InputMaybe<FinancialTransactionsSpendingComparisonDatePeriodEnum>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsAverageSpendingByDayOfTheMonthArgs = {
  dateInTargetStartMonth: Scalars['Date']['input'];
  dateInTargetEndMonth: Scalars['Date']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingByMonthArgs = {
  dateInTargetStartMonth: Scalars['Date']['input'];
  dateInTargetEndMonth: Scalars['Date']['input'];
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsSpendingAndEarningByMonthArgs = {
  dateInTargetStartMonth: Scalars['Date']['input'];
  dateInTargetEndMonth: Scalars['Date']['input'];
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsProjectionForMonthArgs = {
  dateInTargetMonth: Scalars['Date']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsTopMerchantsBySpendingArgs = {
  dateInTargetStartMonth: Scalars['Date']['input'];
  dateInTargetEndMonth: Scalars['Date']['input'];
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsTopCategoriesBySpendingArgs = {
  dateInTargetStartMonth: Scalars['Date']['input'];
  dateInTargetEndMonth: Scalars['Date']['input'];
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsBudgetBreakdownArgs = {
  today?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsBudgetBreakdownByMonthArgs = {
  today?: InputMaybe<Scalars['DateTime']['input']>;
  numMonths?: InputMaybe<Scalars['Int']['input']>;
  includeCurrentMonth?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsCashInCashOutSummaryArgs = {
  currentDate?: InputMaybe<Scalars['Date']['input']>;
  numPreviousMonthsToInclude?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryFinancialTransactionsCashInCashOutSummaryForDatePeriodArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
  datePeriod?: InputMaybe<FinancialTransactionsSpendingComparisonDatePeriodEnum>;
  numPreviousDatePeriodsToInclude?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryNonInsightFeedCardsArgs = {
  onlyTemplates: Array<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryGreenhouseDepartmentArgs = {
  kebabName?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryGreenhouseJobArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetStateFromZipCodeArgs = {
  zipCode: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetHealthNetworkArgs = {
  campaign: Scalars['String']['input'];
  email?: InputMaybe<Scalars['String']['input']>;
  firstName: Scalars['String']['input'];
  ipAddress: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  leadId?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  referringUrl: Scalars['String']['input'];
  source: Scalars['String']['input'];
  userAgent: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryRawIdentityProfileArgs = {
  profileType: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryUserInsightsArgs = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
  filter?: InputMaybe<UserInsightsFilterInput>;
  shouldRegenerate?: InputMaybe<Scalars['Boolean']['input']>;
  rankingModelName?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryGetWeeklyInsightsCurrentStreakArgs = {
  weeklyInsightsCurrentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type QueryInstitutionsForAccountLinkingByKeywordArgs = {
  keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  namedQuery?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryTopInstitutionsForAccountLinkingArgs = {
  productType?: InputMaybe<AccountAggregationProductType>;
  yodleeOnly?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty field. Not to be used. */
export type QueryAccountAggregationInstitutionByIdArgs = {
  accountAggregationInstitutionId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryCanonicalInstitutionsByKeywordArgs = {
  isFuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  namedQuery?: InputMaybe<Scalars['String']['input']>;
  queryFields?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOfferByLegacyIdArgs = {
  input?: InputMaybe<CreditCardOffersParameters>;
  id: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersForAccountAggregationInstitutionArgs = {
  accountAggregationInstitutionId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersByLegacyIdsArgs = {
  input?: InputMaybe<CreditCardOffersParameters>;
  ids: Array<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersByKeywordArgs = {
  namedQuery?: InputMaybe<Scalars['String']['input']>;
  keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardOffersByNamedQueryArgs = {
  input?: InputMaybe<CreditCardOffersParameters>;
  namedQuery: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryPersonalLoanOffersArgs = {
  namedQuery?: InputMaybe<Scalars['String']['input']>;
  input?: InputMaybe<PersonalLoanOffersParameters>;
};


/** Empty field. Not to be used. */
export type QueryPersonalLoanOfferArgs = {
  input?: InputMaybe<PersonalLoanOffersParameters>;
  namedQuery?: InputMaybe<Scalars['String']['input']>;
  id: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QuerySavingsAccountOfferBySlugArgs = {
  slug: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QuerySavingsAccountOffersByNamedQueryArgs = {
  namedQuery: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntityV2Args = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntitiesV2Args = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceFieldArgs = {
  id: Scalars['ID']['input'];
  field: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryMarketplaceAutocompleteSearchArgs = {
  isFuzzy?: InputMaybe<Scalars['Boolean']['input']>;
  keyword: Scalars['String']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  namedQuery?: InputMaybe<Scalars['String']['input']>;
  productType: Scalars['String']['input'];
  queryFields?: InputMaybe<Array<Scalars['String']['input']>>;
  sort?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceSearchArgs = {
  entityType?: InputMaybe<Scalars['String']['input']>;
  productType: Scalars['String']['input'];
  namedQuery?: InputMaybe<Scalars['String']['input']>;
  query?: InputMaybe<Array<MarketplaceQueryInput>>;
  sort?: InputMaybe<Array<MarketplaceSortInput>>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  parameters?: InputMaybe<Scalars['JSON']['input']>;
};


/** Empty field. Not to be used. */
export type QueryMarketplacePassthroughArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceNamedQueryPassthroughArgs = {
  input: MarketplaceNamedQueryPassthroughInput;
};


/** Empty field. Not to be used. */
export type QueryMoneyTransferAccountEligibilityArgs = {
  financialPortalId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryMortgageSavedLeadMatchArgs = {
  input: MortgageSavedLeadMatchInput;
};


/** Empty field. Not to be used. */
export type QueryMortgageSavedLeadMatchesArgs = {
  ids: Array<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryMortgageSavedRecommendedLendersArgs = {
  ids?: InputMaybe<Array<Scalars['ID']['input']>>;
};


/** Empty field. Not to be used. */
export type QueryMortgageLenderMatchArgs = {
  input: MortgageLenderMatchInput;
  namedQuery?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type QueryHomeLeadMatchArgs = {
  input: HomeLeadMatchInput;
  usePep: Scalars['Boolean']['input'];
};


/** Empty field. Not to be used. */
export type QueryIsNerdWalletMortgageLicensedArgs = {
  address: MortgageUserAddressInput;
};


/** Empty field. Not to be used. */
export type QueryMortgageBestOfAwardWinnerDetailsArgs = {
  awardCategory: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryNetWorthRecommendationsArgs = {
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
  filter?: InputMaybe<NetWorthRecommendationsFilterInput>;
};


/** Empty field. Not to be used. */
export type QueryNetWorthAccountByFinancialAccountIdArgs = {
  financialAccountId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryNetWorthAccountByIdArgs = {
  netWorthAccountId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryNetWorthRealAssetArgs = {
  netWorthRealAssetId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultByAddressArgs = {
  address: NetWorthHomeValueResultAddressInput;
  source?: InputMaybe<NetWorthHomeValueResultSourceEnum>;
};


/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultByPropertyIdArgs = {
  propertyId: Scalars['ID']['input'];
  source: NetWorthHomeValueResultSourceEnum;
};


/** Empty field. Not to be used. */
export type QueryNetWorthHomeValueResultWithPossibilitiesByAddressArgs = {
  address: NetWorthHomeValueResultAddressInput;
  source?: InputMaybe<NetWorthHomeValueResultSourceEnum>;
};


/** Empty field. Not to be used. */
export type QueryNetWorthHistoryArgs = {
  netWorthFilter: NetWorthHistoryFiltersEnum;
  effectiveDate: Scalars['DateTimeWithTimeOffset']['input'];
};


/** Empty field. Not to be used. */
export type QueryPersonalLoansBestOfAwardWinnerDetailsArgs = {
  awardCategory: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryPrequalJobStatusArgs = {
  prequalJobs: Array<PrequalJobInput>;
};


/** Empty field. Not to be used. */
export type QueryAutoInsurancePrequalOffersArgs = {
  providerIds: Array<AutoInsuranceProviderId>;
  userInput?: InputMaybe<AutoInsurancePrequalOfferInput>;
};


/** Empty field. Not to be used. */
export type QueryAutoInsurancePrequalOffersJobIdsArgs = {
  providerIds: Array<AutoInsuranceProviderId>;
  userInput?: InputMaybe<AutoInsurancePrequalOfferInput>;
};


/** Empty field. Not to be used. */
export type QueryAutoInsurancePrequalOffersV2Args = {
  prequalJobs: Array<PrequalJobInput>;
};


/** Empty field. Not to be used. */
export type QueryCreditCardPrequalOffersArgs = {
  userInput: CreditCardPrequalInput;
};


/** Empty field. Not to be used. */
export type QueryDeclinePersonalLoanOffersSearchArgs = {
  params: DeclineResultsQueryInputs;
};


/** Empty field. Not to be used. */
export type QueryInsurancePrequalOffersArgs = {
  providerIds: Array<InsuranceProviderEnum>;
  userInput?: InputMaybe<HomeInsurancePrequalOfferInput>;
  userInfo?: InputMaybe<PrequalOfferUserInfoInput>;
  homeInfo?: InputMaybe<HomeInsurancePrequalOfferInput>;
  driverInfo?: InputMaybe<PrequalOfferDriverInfoInput>;
  lifeInfo?: InputMaybe<LifeInsurancePrequalOfferInput>;
  vertical: InsuranceVerticalEnum;
};


/** Empty field. Not to be used. */
export type QueryInsurancePrequalOffersByJobIdArgs = {
  prequalJobs: Array<PrequalJobInput>;
};


/** Empty field. Not to be used. */
export type QueryInsurancePrequalOffersJobIdsArgs = {
  providerIds: Array<InsuranceProviderEnum>;
  userInput?: InputMaybe<HomeInsurancePrequalOfferInput>;
};


/** Empty field. Not to be used. */
export type QueryRecentlyViewedArgs = {
  maxPagesCount?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryRewardsContentArgs = {
  cardNames: Array<Scalars['String']['input']>;
  cardPrograms: Array<Scalars['String']['input']>;
  allowPosts?: InputMaybe<Scalars['Boolean']['input']>;
  sortDir?: InputMaybe<ContentSortDirection>;
  numResults?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QuerySavedContentByEntityTypeArgs = {
  entityType: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QuerySavedContentByIdArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetContentArgs = {
  contentSearchFilter?: InputMaybe<ContentSearchInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryTotalAmountSpentCurrentMonthArgs = {
  currentDate?: InputMaybe<Scalars['Date']['input']>;
};


/** Empty field. Not to be used. */
export type QueryTotalAmountSpentPreviousMonthToDateArgs = {
  currentDate?: InputMaybe<Scalars['Date']['input']>;
};


/** Empty field. Not to be used. */
export type QueryCsirBalanceOnDateArgs = {
  date: Scalars['Date']['input'];
};


/** Empty field. Not to be used. */
export type QueryStructuredContentPageArgs = {
  uri: Scalars['String']['input'];
  urlParams?: InputMaybe<Array<UrlParamsInput>>;
};


/** Empty field. Not to be used. */
export type QueryStudentLoansBestOfAwardWinnerDetailsArgs = {
  awardCategory: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetUserOpsFdpLinkingErrorEventsArgs = {
  identityId: Scalars['ID']['input'];
  portalId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetUserOpsCommsSubscriptionPreferencesWrapperListArgs = {
  identityId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetUserOpsFinancialPrioritiesArgs = {
  identityId: Scalars['ID']['input'];
  lastDaysLimit?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryGetFinancialPrioritiesForUserArgs = {
  identityId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type QueryGetUserOpsMessagingActivityEventsListArgs = {
  identityId: Scalars['ID']['input'];
  pagination: OffsetPaginationInput;
  lastDaysLimit?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type QueryArticleArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryArticleForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryArticlesArgs = {
  filter?: InputMaybe<ArticleFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryAuFlexPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryAuFlexPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryAuFlexPagesArgs = {
  filter?: InputMaybe<AuFlexPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryAuFlexTemplateArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryAuFlexTemplateForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryAuFlexTemplatesArgs = {
  filter?: InputMaybe<AuFlexTemplateFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryAuthorArgs = {
  input?: InputMaybe<AuthorItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBccPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBccPageCardArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBccPageCardsArgs = {
  filter?: InputMaybe<BccPageCardFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryBccPagesArgs = {
  filter?: InputMaybe<BccPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryBlockArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBlockGroupArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryBlockGroupsArgs = {
  filter?: InputMaybe<BlockGroupFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryBlocksArgs = {
  filter?: InputMaybe<BlockFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryCaFlexPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryCaFlexPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryCaFlexPagesArgs = {
  filter?: InputMaybe<CaFlexPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryCaFlexTemplateArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryCaFlexTemplateForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryCaFlexTemplatesArgs = {
  filter?: InputMaybe<CaFlexTemplateFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryCalculatorPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryCalculatorPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryCalculatorPagesArgs = {
  filter?: InputMaybe<CalculatorPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryCategoryArgs = {
  input?: InputMaybe<TermItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentHubArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentHubForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentHubsArgs = {
  filter?: InputMaybe<ContentHubFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryContentPackArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentPacksArgs = {
  filter?: InputMaybe<ContentPackFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryContentReviewerArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentReviewersArgs = {
  filter?: InputMaybe<ContentReviewerFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryContentSearchArgs = {
  filter?: InputMaybe<ContentSearchFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
  wpNonce?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type QueryContentUserPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentUserPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryContentUserPagesArgs = {
  filter?: InputMaybe<ContentUserPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryDynamicPlacementArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryDynamicPlacementsArgs = {
  filter?: InputMaybe<DynamicPlacementFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryEngineeringPostArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryEngineeringPostsArgs = {
  filter?: InputMaybe<EngineeringPostFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryFlexPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryFlexPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryFlexPagesArgs = {
  filter?: InputMaybe<FlexPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryFlexTemplateArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryFlexTemplateForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryFlexTemplatesArgs = {
  filter?: InputMaybe<FlexTemplateFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryGlobalNavItemArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryGlobalNavItemForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryGlobalNavItemsArgs = {
  filter?: InputMaybe<GlobalNavItemFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryHouseAdArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryHouseAdsArgs = {
  filter?: InputMaybe<HouseAdFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryHubArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryHubForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryHubsArgs = {
  filter?: InputMaybe<HubFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryInsuranceFlexPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryInsuranceFlexPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryInsuranceFlexPagesArgs = {
  filter?: InputMaybe<InsuranceFlexPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryInsurancePageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryInsurancePagesArgs = {
  filter?: InputMaybe<InsurancePageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryInsuranceTemplateArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryInsuranceTemplateForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryInsuranceTemplatesArgs = {
  filter?: InputMaybe<InsuranceTemplateFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryLandingPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryLandingPageForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryLandingPagesArgs = {
  filter?: InputMaybe<LandingPageFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryLegacyLenderArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryLegacyLendersArgs = {
  filter?: InputMaybe<LegacyLenderFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntryPointArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryMarketplaceEntryPointsArgs = {
  filter?: InputMaybe<MarketplaceEntryPointFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryMediaItemArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryMediaItemsArgs = {
  filter?: InputMaybe<MediaItemFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryMediaSiteArgs = {
  input?: InputMaybe<TermItemInput>;
};


/** Empty field. Not to be used. */
export type QueryPageArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryPostArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryPostByIdArgs = {
  id: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type QueryPostsByIdArgs = {
  ids?: InputMaybe<Array<Scalars['Int']['input']>>;
};


/** Empty field. Not to be used. */
export type QueryPressReleaseArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryPressReleasesArgs = {
  filter?: InputMaybe<PressReleaseFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryReviewArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryReviewForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryReviewsArgs = {
  filter?: InputMaybe<ReviewFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryRoundupArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryRoundupForkArgs = {
  input?: InputMaybe<PostForkItemInput>;
};


/** Empty field. Not to be used. */
export type QueryRoundupsArgs = {
  filter?: InputMaybe<RoundupFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryStructuredContentCalculatorArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryStructuredContentCalculatorsArgs = {
  filter?: InputMaybe<StructuredContentCalculatorFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryTableArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryTablesArgs = {
  filter?: InputMaybe<TableFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryUrlRecordArgs = {
  input?: InputMaybe<PostItemInput>;
};


/** Empty field. Not to be used. */
export type QueryUrlRecordsArgs = {
  filter?: InputMaybe<UrlRecordFilterInput>;
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** Empty field. Not to be used. */
export type QueryRelatedArticlesArgs = {
  input?: InputMaybe<RelatedArticlesInput>;
};


/** Empty field. Not to be used. */
export type QueryUserBestCreditCardRecommendationsArgs = {
  input?: InputMaybe<UserBestCreditCardRecommendationsInput>;
};


/** Empty field. Not to be used. */
export type QueryBccPageSectionsArgs = {
  input?: InputMaybe<PostItemInput>;
  filteredSectionIdentifiers?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** Empty field. Not to be used. */
export type QueryUrlRecordByUrlArgs = {
  url: Scalars['URL']['input'];
};


/** Empty field. Not to be used. */
export type QueryYoutubeVideoArgs = {
  id: Scalars['ID']['input'];
};

export type Variant = {
  __typename?: 'Variant';
  variantId: Scalars['String']['output'];
  variantName: Scalars['String']['output'];
  customData?: Maybe<Scalars['JSON']['output']>;
};

export type Experiment = {
  __typename?: 'Experiment';
  /** The name of the experiment */
  experimentName: Scalars['String']['output'];
  /** The ID of the experiment */
  experimentId: Scalars['String']['output'];
  /**
   * The ID of the variant the requesting user is bucketed into.
   *   This accounts for variants forced using a request header or query param on the originating URL of the form \`test_[testname]=[variantname]\`
   */
  assignedVariant: Scalars['String']['output'];
  /**
   * The name of the variant the requesting user is bucketed into.
   *   This accounts for variants forced using a request header or query param on the originating URL of the form \`test_[testname]=[variantname]\`
   */
  assignedVariantName: Scalars['String']['output'];
  /** Is the variant forced via query param. Variants can be forced using a request header or query param on the originating URL of the form \`test_[testname]=[variantname]\` */
  isForcedVariant: Scalars['Boolean']['output'];
  rampNum: Scalars['Int']['output'];
  usesEEE: Scalars['Boolean']['output'];
  variants: Array<Maybe<Variant>>;
};

/** The options needed for a search query */
export type SearchQueryInput = {
  /** The search text from the user */
  searchText: Scalars['String']['input'];
  /** The number of results to get back per page */
  itemsPerPage: Scalars['Int']['input'];
  /** The page number you want returned */
  page: Scalars['Int']['input'];
};

/** Represents a specific search result */
export type SearchResult = {
  __typename?: 'SearchResult';
  /** The id of a wordpress post */
  postId?: Maybe<Scalars['Int']['output']>;
  /** The title for a wordpress post */
  title?: Maybe<Scalars['String']['output']>;
  /** The content to display for the post */
  content?: Maybe<Scalars['String']['output']>;
  /** The URL of the post */
  url?: Maybe<Scalars['String']['output']>;
  /** The last modified timestamp in GMT for the post */
  lastModifiedDate?: Maybe<Scalars['Float']['output']>;
  /** The create timestamp in GMT for the post */
  createDate?: Maybe<Scalars['Float']['output']>;
  /** The date timestamp to show in the UI */
  displayDate?: Maybe<Scalars['Float']['output']>;
  /** The match score this post received */
  score?: Maybe<Scalars['Float']['output']>;
};

/** The response from a search query */
export type SearchResults = {
  __typename?: 'SearchResults';
  /** The total number of pages for the query */
  totalPages?: Maybe<Scalars['Int']['output']>;
  /** The search result set */
  results?: Maybe<Array<Maybe<SearchResult>>>;
};

/** The source of the content action request */
export enum SearchDataSource {
  /** When the source is Wordpress */
  Wordpress = 'WORDPRESS'
}

/** The action we should take on the content */
export enum SearchDataAction {
  /** All data for a piece of content will be updated */
  Update = 'UPDATE',
  /** All data for a piece of content will be removed */
  Delete = 'DELETE'
}

/** The response for a content action request */
export type UpdateSearchDataResponse = {
  __typename?: 'UpdateSearchDataResponse';
  /** The identifier for the content */
  id?: Maybe<Scalars['String']['output']>;
  /** The source of the content update request */
  source?: Maybe<SearchDataSource>;
  /** The action we took on the content */
  action?: Maybe<SearchDataAction>;
  /** Whether or not the action was successful */
  success?: Maybe<Scalars['Boolean']['output']>;
  /** And error message for when the action was not successful */
  error?: Maybe<Scalars['String']['output']>;
};

/** Empty field. Not to be used. */
export type Mutation = {
  __typename?: 'Mutation';
  /** request an action on a piece of content */
  updateSearchData?: Maybe<UpdateSearchDataResponse>;
  smbCreateThing?: Maybe<SmbThing>;
  cardFinderInitSession?: Maybe<Scalars['String']['output']>;
  cardFinderUserData?: Maybe<Scalars['Boolean']['output']>;
  cardFinderRegister?: Maybe<RegisterResponse>;
  /**
   * Marks a notification as read.
   *   Input is the ID of the notification to mark as read.
   *   Output is the updated notification and the updated unread count.
   */
  markNotificationAsRead: MarkNotificationAsReadResponse;
  /**
   * Marks a notification as unread.
   *   Input is the ID of the notification to mark as unread.
   *   Output is the updated notification and the updated unread count.
   */
  markNotificationAsUnread: MarkNotificationAsUnreadResponse;
  /**
   * Marks a notification as pinned.
   *   Input is the ID of the notification to mark as pinned.
   *   Output is the updated notification.
   */
  markNotificationAsPinned: MarkNotificationAsPinnedResponse;
  /**
   * Marks a notification as unpinned.
   *   Input is the ID of the notification to mark as unpinned.
   *   Output is the updated notification.
   */
  markNotificationAsUnpinned: MarkNotificationAsUnpinnedResponse;
  /**
   * Marks a notification as dismissed.
   *   Input is the ID of the notification to mark as dismissed.
   *   Output is the updated notification and the updated unread count.
   */
  markNotificationAsDismissed: MarkNotificationAsDismissedResponse;
  /**
   * Marks a notification as undismissed.
   *   Input is the ID of the notification to mark as undismissed.
   *   Output is the updated notification and the updated unread count.
   */
  markNotificationAsUndismissed: MarkNotificationAsUndismissedResponse;
  /**
   * Marks all of notifications as read.
   *   Inputs are the IDs of the notifications known to the frontend, and the ID before which to perform the action (inclusive).
   *   Output is the updated notifications and the updated unread count.
   */
  markAllNotificationsAsRead: BulkActionResponse;
  /**
   * Marks all of notifications as dismissed.
   *   Inputs are the IDs of the notifications known to the frontend, and the ID before which to perform the action (inclusive).
   *   Output is the updated notifications, the updated unread count and the associated operation ID.
   */
  markAllNotificationsAsDismissed: BulkDismissResponse;
  /**
   * Undoes the last bulk action performed by the user.
   *   Inputs are the IDs of the notifications known to the frontend, and the operation ID of the bulk action to undo.
   *   Output is the updated notifications and the updated unread count.
   */
  undoMarkAllNotificationsAsDismissed: BulkActionResponse;
  /**
   * Attempts to register the user's browser token for Web push notifications via Iterable
   *   Note - Maximum of 500 browser tokens per user profile.
   *   https://api.iterable.com/api/docs#users_registerBrowserToken
   */
  saveBrowserToken: SaveBrowserTokenResponse;
  /** Tracks when a user clicks on a Web Push notification via Iterable */
  trackWebPushClick: TrackWebPushClickResponse;
  initializeColumnTaxFiling?: Maybe<ColumnTaxUserInformation>;
  sendFeedback?: Maybe<SendFeedbackResponse>;
  updateAIData?: Maybe<UpdateAiDataResponse>;
  writeScriptedQuestion?: Maybe<ScriptedQuestion>;
  writeScriptedAnswer?: Maybe<ScriptedAnswer>;
  deleteScriptedPrompt?: Maybe<Scalars['Boolean']['output']>;
  updateUserCardsConsentStatus: CardsConsent;
  experimentTrackEvents?: Maybe<Scalars['Boolean']['output']>;
  smTravelInsuranceQuotes?: Maybe<SmTravelInsuranceQuotesResponse>;
  passwordlessUserRegister?: Maybe<UserRegistrationResponse>;
  addCarReviewLink: Scalars['Boolean']['output'];
  addTrimRating: Scalars['Boolean']['output'];
  updateTrimSegment: Scalars['Boolean']['output'];
  addCarBestList: CarBestList;
  updateCarBestList: CarBestList;
  deleteCarBestList: CarBestList;
  updateCarBestListRanks: Scalars['Boolean']['output'];
  /** Update whether a financial account is hidden. */
  updateFinancialAccountVisibility?: Maybe<FinancialAccount>;
  /** Create a "user" financial account that will be associated with manual transactions. */
  createManualTransactionAccount?: Maybe<CreateManualTransactionAccountResponse>;
  /** Create a "user" financial account. */
  createUserFinancialAccount?: Maybe<CreateUserFinancialAccountResponse>;
  /** Update a "user" financial account. */
  updateUserFinancialAccount?: Maybe<UpdateFinancialAccountResponse>;
  /** Delete a "user" financial account. */
  deleteUserFinancialAccount?: Maybe<DeleteUserFinancialAccountResponse>;
  /**
   * Update the viewed state of a credit card reward
   * @deprecated use the general mutation updateFinancialNwPlusRewardViewed for all products
   */
  updateFinancialCreditCardRewardViewed?: Maybe<UpdateFinancialCreditCardRewardViewedResponse>;
  /** Update the viewed state of a NW+ reward */
  updateFinancialNwPlusRewardViewed?: Maybe<UpdateFinancialRewardViewedResponse>;
  /** Update tracker's status to be dismissed. This will also dismiss every instance of trackers with same marketplaceOfferId */
  updateFinancialNwPlusRewardDismissed?: Maybe<UpdateFinancialNwPlusRewardDismissedResponse>;
  /** Create a portal for a particular institution */
  initializeFinancialPortal?: Maybe<FinancialPortal>;
  /** Reinitialize a portal for fixing a broken link */
  reinitializeFinancialPortal?: Maybe<ReinitializeFinancialPortalResponse>;
  /** Initializes the migration of a portal to a new primary source */
  migrateFinancialPortal?: Maybe<MigrateFinancialPortalResponse>;
  /** Finishes the migration of a portal to a new primary source despite data loss */
  finishPortalMigration?: Maybe<FinishPortalMigrationResponse>;
  /** Delete a financial portal (for unlinking) */
  deleteFinancialPortal?: Maybe<DeleteFinancialPortalResponse>;
  /** Attempt to trigger a refresh of the data associated with a financial portal */
  refreshFinancialPortal?: Maybe<FinancialPortal>;
  /**
   * Sends information to the appropriate plugin for the financial portal. Typically used for
   *   facilitating and sending progress on the linking flow.
   *   https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-proxy/#operation/event
   */
  publishFinancialDataLinkEvent?: Maybe<FinancialPortalMessageResponse>;
  /**
   * Initializes the FDP User and does the initial pull for all the User's Plaid streams
   *   Datasource endpoint: /streams/init
   */
  initializeBillStreamUser?: Maybe<InitializeUserResponse>;
  /** Manually create a bill */
  createBillStream?: Maybe<BillStreamResponse>;
  /** Edit the details of an existing bill */
  updateBillStream?: Maybe<BillStreamResponse>;
  /** Promote a suggested bill to a user's saved bill */
  promoteSuggestedBillStream?: Maybe<BillStreamResponse>;
  /** Mark the bill as paid */
  markBillStreamPaid?: Maybe<BillStreamResponse>;
  /** Hide or unhide the suggested bill */
  updateSuggestedBillStreamHiddenState?: Maybe<BillStreamResponse>;
  /** Will delete a manually created bill, otherwise will hide the Plaid generated suggested bill */
  deleteBillStream?: Maybe<DeleteBillStreamResponse>;
  /** Will associate any specified Plaid transactions from the same account of the Plaid-detected bill, with the bill */
  updateBillStreamTransactions?: Maybe<UpdateBillStreamTransactionsResponse>;
  /** Creates a FinancialTransaction and links it to the account given by accountId. */
  createFinancialTransaction?: Maybe<FinancialTransaction>;
  /** Attempts to delete a FinancialTransaction by id. */
  deleteFinancialTransaction?: Maybe<DeleteFinancialTransactionResponse>;
  /**
   * Updates the visibility of a transaction.
   *   Transactions that are hidden are excluded from transaction calculations and aggregations.
   */
  updateFinancialTransactionVisibility?: Maybe<FinancialTransaction>;
  /** Updates the category of a transaction. */
  updateFinancialTransactionCategory?: Maybe<FinancialTransaction>;
  /**
   * Updates the category of a merchant.
   *   All transactions for that merchant will be given the category of the merchant, unless they have their
   *   own respective transaction category override specified.
   * @deprecated replaced in the product with the Edit feature that uses updateFinancialTransaction. Can be removed once all clients are on the latest release
   */
  updateFinancialMerchantTransactionCategory?: Maybe<UpdateFinancialMerchantTransactionCategoryResponse>;
  /** Updates the amount, category, and date fields of the transaction given by transactionId. */
  updateFinancialTransaction?: Maybe<FinancialTransaction>;
  /** Creates or updates the annual income field in the user's financial profile in UDP. */
  updateUserAnnualIncome: FinancialUserAnnualIncomeResponse;
  /** Creates or updates the monthly net income field in the user's financial profile in UDP. */
  updateUserMonthlyNetIncome: FinancialUserMonthlyNetIncomeResponse;
  /**
   * Represents the user acknowledging Covered's Terms of Service.
   *
   *   Returns the status of the acknowledgement.
   */
  acknowledgeCoveredTermsOfService: AcknowledgeCoveredTermsOfServiceResponse;
  /**
   * Represents the user acknowledging Covered's TCPA agreement.
   *
   *   Returns the status of the acknowledgement.
   */
  acknowledgeCoveredTCPAConsent: AcknowledgeCoveredTcpaConsentResponse;
  acknowledgeCanopyTermsOfServiceAgreement?: Maybe<AcknowledgeCanopyTermsOfServiceAgreementResponse>;
  hidePolicy: InsurancePoliciesResponse;
  updateInsurancePolicyOverrides: InsurancePolicyOverridesResponse;
  deleteInsuranceByAccountId?: Maybe<DeleteInsuranceByAccountIdResponse>;
  /** Update my_nerdwallet_profile fields for the user. */
  updateMembershipAppActivity?: Maybe<MembershipAppActivityResponse>;
  /** Indicate at what time a user viewed a Feature Discovery message */
  markFeatureDiscoveryViewed: MembershipAppActivityFeatureDiscoveryResponse;
  /** Mutate to earn a reward */
  earnReward: EarnRewardResponse;
  /** Redeem points for a specific gift card reward */
  nwPlusPurchaseReward: NwPlusPurchaseRewardResponse;
  /** Processes a user's new NW+ subscription */
  registerNwPlusSubscriptionSuccess?: Maybe<IdentityResponse>;
  /** Create a purchase using Recurly */
  createRecurlyPurchase: RecurlyPurchaseResponse;
  /** Update Recurly Address */
  updateRecurlyAccountAddressInfo: RecurlyAccountInfoMutationResponse;
  /** Update Recurly Billing Info */
  updateRecurlyBillingInfo: RecurlyBillingInfoMutationResponse;
  /** Cancel a NerdWallet Plus subscription */
  cancelNwPlusSubscription: SubscriptionCancelReactivateResponse;
  /** Reactivate a NerdWallet Plus subscription */
  reactivateNwPlusSubscription: SubscriptionCancelReactivateResponse;
  acknowledgeScribeUpTermsOfService: AcknowledgeScribeUpTermsOfServiceResponse;
  activateScribeUpBills: ActivateScribeUpBillsResponse;
  deactivateScribeUpBills: DeactivateScribeUpBillsResponse;
  _empty?: Maybe<Scalars['String']['output']>;
  /** Registers a new user via first party credentials */
  registerUser?: Maybe<RegisterUserResponse>;
  /** Logs out the current user */
  logOutUser?: Maybe<LogOutUserResponse>;
  /** Log in an existing user via first party credentials */
  logInUser?: Maybe<LogInUserResponse>;
  /** Log in/register a user via Google credentials */
  logInUserViaGoogle?: Maybe<LogInUserResponse>;
  /** Log in/register a user via Apple credentials */
  logInUserViaApple?: Maybe<LogInUserResponse>;
  /** Log in an existing user via a refresh token */
  logInUserViaRefreshToken?: Maybe<LogInUserResponse>;
  /** Updates the current user's password */
  updatePassword?: Maybe<Scalars['Boolean']['output']>;
  /** Sets the user's security question and answer */
  setSecurityQuestion?: Maybe<Scalars['Boolean']['output']>;
  /** Deactivates the current user's account */
  deactivateUser?: Maybe<Scalars['Boolean']['output']>;
  /** Generate a one-time login token for the current user */
  generateOneTimeLoginToken?: Maybe<Scalars['Boolean']['output']>;
  /** Generate a one-time transfer token for a cookie id */
  generateOneTimeCookieIdTransferToken?: Maybe<Scalars['Boolean']['output']>;
  /** Initializes a CSRF session for the current user */
  initializeCsrfSession?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Accepts the new set of Credit Card Match quiz flow answers and attempts to persist it,
   *   either replacing a previous set of answers or writing it new.
   *   If this is successful, the response will return with the set of answers.
   */
  updateCreditCardMatchQuizAnswers: CreditCardMatchQuizAnswersResponse;
  /**
   * Retrieves a unique "trust session ID" for the user from Transunion, which is stamped onto future requests and
   *   helps protect against fraudulent use of NerdWallet's TU integration.
   */
  createTrustSessionId: TrustSessionIdResponse;
  /**
   * Accepts the users details and attempts to initialize their TU profile.
   *   If this is successful, TU will return security questions to present to
   *   the user and put the user in status = PENDING.
   * @deprecated Errors returned from Transunion may be incorrectly redacted. Use initializeCreditProfileWithFallback instead.
   */
  initializeCreditProfile: CreditProfileAuthStatusProfile;
  /**
   * Accepts the users details and attempts to initialize their TU profile.
   *   If this is successful, TU will return security questions to present to
   *   the user and put the user in status = PENDING.
   */
  initializeCreditProfileWithFallback: CreditProfileAuthResponseUnion;
  /**
   * Accepts a list of question / answer pairs and posts question to TU.
   *   If this is successful, the user will be put in status = AUTHENTICATED.
   *   Next it will attempt to enroll the user. If this is successful, then
   *   the user will be put in status = ACTIVE and the credit report will
   *   be returned.
   * @deprecated This mutation does not correctly reflect the response type from Identity, which can return two different response objects.  Use authenticateCreditProfileQuestions instead.
   */
  authenticateCreditProfile: TuCreditReportIdentityProfile;
  /**
   * Accepts a list of question / answer pairs and posts question to TU.
   *   If this is successful, the user will be put in status = AUTHENTICATED.
   *   Next it will attempt to enroll the user. If this is successful, then
   *   the user will be put in status = ACTIVE and the credit report (TuCreditReportIdentityProfile) will
   *   be returned.  If there are additional verification questions a user must continue to answer,
   *   then a CreditProfileAuthStatusProfile will be returned.
   */
  authenticateCreditProfileQuestions: AuthenticateCreditProfileResponseUnion;
  /**
   * This is only needed if authenticateCreditProfile left the user in
   *   status = AUTHENTICATED (instead of ACTIVE).
   */
  enrollCreditProfile: TuCreditReportIdentityProfile;
  /** Refreshes the user's TU credit profile. If successful, then the refreshed credit report will be returned. */
  refreshCreditProfile: TuCreditReportIdentityProfile;
  /** Deactivates the user's TU credit profile. If successful, then the user will be put in status = DEACTIVATED. */
  deactivateCreditProfile: CreditProfileAuthStatusProfile;
  /**
   * Publish a simple CRM event (CRM events that just have identity_id in its payload)
   *   publishSimpleCRMEvent will be deprecated and replaced by publishCRMEvent, which can handle payloads with just identity_id, and payloads with identity_id and other custom fields.
   *
   *   Publish messages to a private Yak exchange.
   *   If message fails to publish due to an error, the mutation will result in an error located at
   *   `errors[0].message` indicating why the message failed.
   */
  publishSimpleCRMEvent: PublishYakMessageResult;
  /**
   * Publish a CRM Event
   *
   *   Publish messages to a private Yak exchange.
   *   If message fails to publish due to an error, the mutation will result in an error located at
   *   `errors[0].message` indicating why the message failed.
   */
  publishCRMEvent: PublishYakMessageResult;
  /** Create or update the user's DLAN profile */
  updateDLANProfile?: Maybe<DlanProfileResponse>;
  financialHealthScore: FinancialHealthScoreMutations;
  followAuthor?: Maybe<FollowedAuthorResponse>;
  unfollowAuthor?: Maybe<Scalars['Boolean']['output']>;
  followArticleAuthors?: Maybe<FollowedArticleAuthorsResponse>;
  unfollowArticleAuthors?: Maybe<Scalars['Boolean']['output']>;
  updateGamificationChecklist?: Maybe<GamificationChecklistResponse>;
  /** Update subscription_profile_v3 of the user. Only changed fields are required. */
  updateSubscriptionProfile?: Maybe<SubscriptionIdentityProfile>;
  /** Update subscription settings for a user via a one time use token path. */
  updateSubscriptionWithoutIdentity?: Maybe<SubscriptionIdentityProfile>;
  /** Unsubscribes from a specific notification type */
  unsubscribeFromNotification?: Maybe<SubscriptionIdentityProfile>;
  addMobileAppDevice?: Maybe<MobileAppIdentityProfile>;
  /** Update my_nerdwallet_profile fields for the user. */
  updateDismissAccountAggCta?: Maybe<AccountAggCtaDismissedResponse>;
  /** Update the user's income information. */
  updateIncome: UpdateIncomeResponse;
  /** Update the user's name. */
  updateName: UpdateNameResponse;
  /** Acknowledges the specified terms of service */
  acknowledgeTermsOfService?: Maybe<AcknowledgeTermsOfServiceResponse>;
  /** Returns the user's weekly_insights_completed_at array. If the weeklyInsightsCompletedDate is not in the same week of the most recent completion date of weekly insights, then mutates and appends the user's weekly_insights_completed_at array with weeklyInsightsCompletedDate */
  updateWeeklyInsightsCurrentStreak: UpdateWeeklyInsightsCurrentStreakResponse;
  /** Creates a money transfer account to be used in a money transfer */
  moneyTransferCreateAccount?: Maybe<CreateMoneyTransferAccountResponse>;
  /** Cancels a transfer */
  moneyTransferCancelTransfer?: Maybe<MoneyTransferCancelTransferResponse>;
  /** Creates a transfer */
  moneyTransferCreateTransfer?: Maybe<CreateMoneyTransferResponse>;
  moneyTransferCreateUser?: Maybe<MoneyTransferCreateUserResponse>;
  /** Generate authentication tokens to log into client-side embedded application */
  generateNerdUpAuthenticationTokens: NerdUpAuthenticationResponse;
  /**
   * Accepts the account hidden value and attempts to patch the account in Wealth Recommender.
   *   If this is successful, the response will return with the updated account object.
   */
  updateNetWorthAccountVisibility?: Maybe<UpdateNetWorthAccountVisibilityResponse>;
  /**
   * Accepts the data object representing a linked Real Asset of type Home in Wealth Recommender and attempts to add it.
   *   If this is successful, the response will return with the newly-persisted asset object.
   */
  addNetWorthHomeIntegrated?: Maybe<AddNetWorthHomeIntegratedResponse>;
  /**
   * Accepts an asset type, nickname, and amount and attempts to add it.
   *   If this is successful, the response will return with the newly-persisted asset object.
   */
  addNetWorthRealAssetSelfReported?: Maybe<AddNetWorthRealAssetSelfReportedResponse>;
  /**
   * Accepts the new real asset isHiddenFromNetWorth value and attempts to update it.
   *   If this is successful, the response will return with the updated asset object.
   */
  updateNetWorthRealAssetIsHiddenFromNetWorth?: Maybe<UpdateNetWorthRealAssetResponse>;
  /**
   * Accepts a new nickname and/or amount and attempts to update the asset with
   *   id netWorthRealAssetId.
   *   If this is successful, the response will return with the updated asset object.
   */
  editNetWorthRealAssetSelfReported?: Maybe<EditNetWorthRealAssetSelfReportedResponse>;
  /**
   * Accepts the id of the real asset in Wealth Recommender and attempts to delete it.
   *   If this is successful, the response will be an object containing a boolean "success"
   *   property.
   */
  deleteNetWorthRealAsset?: Maybe<DeleteNetWorthRealAssetResponse>;
  updateFinancialPriorities?: Maybe<FinancialPrioritiesResponse>;
  updateFinancialPrioritiesFeatureDiscovery?: Maybe<FinancialPrioritiesFeatureDiscoveryResponse>;
  /**
   * Initiate prequal jobs, which can be polled by ID, from user input to personal
   *   loans prequal service. The underlying service adds any personal loan offers
   *   to the user profile.
   */
  initiatePersonalLoansPrequalRequest: Array<PrequalJob>;
  /**
   * Accepts the a set of Project ted flow answers and attempts to persist it,
   *   writes a new record in Airtable.
   *   If this is successful, the response will return with the set of answers and a success status
   */
  addProjectTedForm: ProjectTedFormResponse;
  /** Delete all of the user's Recently Viewed history */
  clearRecentlyViewedHistory?: Maybe<Scalars['Boolean']['output']>;
  /** Add new credit cards to a list of self-reported cards a user owns. */
  addUserReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /**
   * Update in full, the list of self-reported cards a user owns.
   *   This will replace the current list of cards a user has reported owning.
   */
  setUserReportedCreditCards?: Maybe<UserReportedCreditCardsResult>;
  /** Remove an individual card from the list of self-reported credit cards a user owns. */
  removeUserReportedCreditCard?: Maybe<RemoveUserReportedCreditCardResult>;
  /** Remove all self-reported credit cards from the user profile */
  removeAllUserReportedCreditCards: RewardsMutationSuccessResponse;
  publishViewedPYCRExperience: Scalars['String']['output'];
  /** Save a specific piece of saved content */
  saveContent?: Maybe<SavedContentResponse>;
  /** Unsave a specific piece of saved content */
  unsaveContent?: Maybe<Scalars['Boolean']['output']>;
  /** Adds a new wallet card to the user's cards in the my cards service */
  addUserWalletCard?: Maybe<AddUserWalletCardResponse>;
  /** Updates an existing wallet card from the user's cards in the my cards service */
  updateUserWalletCard?: Maybe<UpdateUserWalletCardResponse>;
  /** Removes a wallet card from the user's cards in the my cards service */
  removeUserWalletCard?: Maybe<RemoveUserWalletCardResponse>;
  /**
   * DEPRECATED: Query0 no longer supports publishing to Yak. This mutation will be kept for
   *   clients who have yet to clean up their Yak usage for backwards-compatibility sake.
   *
   *   Publish messages to a Yak exchange.
   *
   *   If any message fails to publish due to an error, the mutation will result in an error with an
   *   array of results (of equal length as the messages input) located at
   *   `errors[0].extensions.exception.results` indicating which message(s) failed and why.
   * @deprecated Yak is deprecated.
   */
  publishYakMessages: Array<PublishYakMessageResult>;
  /** Creates or replaces the service test state profile for the current user */
  updateServiceTestStateProfile?: Maybe<ServiceTestStateProfile>;
};


/** Empty field. Not to be used. */
export type MutationUpdateSearchDataArgs = {
  id: Scalars['String']['input'];
  source: SearchDataSource;
  action: SearchDataAction;
};


/** Empty field. Not to be used. */
export type MutationSmbCreateThingArgs = {
  SMBThing: CreateThing;
};


/** Empty field. Not to be used. */
export type MutationCardFinderUserDataArgs = {
  inputs: QuizAnswers;
};


/** Empty field. Not to be used. */
export type MutationCardFinderRegisterArgs = {
  email: Scalars['String']['input'];
  password: Scalars['String']['input'];
  trackingProfile: RegistrationTrackingProfile;
};


/** Empty field. Not to be used. */
export type MutationMarkNotificationAsReadArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationMarkNotificationAsUnreadArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationMarkNotificationAsPinnedArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationMarkNotificationAsUnpinnedArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationMarkNotificationAsDismissedArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationMarkNotificationAsUndismissedArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationMarkAllNotificationsAsReadArgs = {
  track: Array<Scalars['ID']['input']>;
  beforeInclusive?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type MutationMarkAllNotificationsAsDismissedArgs = {
  track: Array<Scalars['ID']['input']>;
  beforeInclusive?: InputMaybe<Scalars['ID']['input']>;
};


/** Empty field. Not to be used. */
export type MutationUndoMarkAllNotificationsAsDismissedArgs = {
  track: Array<Scalars['ID']['input']>;
  operationId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationSaveBrowserTokenArgs = {
  browserToken: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type MutationTrackWebPushClickArgs = {
  campaignId?: InputMaybe<Scalars['Int']['input']>;
  messageId: Scalars['String']['input'];
  templateId?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type MutationInitializeColumnTaxFilingArgs = {
  taxYear?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type MutationSendFeedbackArgs = {
  feedback: Feedback;
};


/** Empty field. Not to be used. */
export type MutationUpdateAiDataArgs = {
  id: Scalars['String']['input'];
  source: AiDataSource;
  action: AiDataAction;
};


/** Empty field. Not to be used. */
export type MutationWriteScriptedQuestionArgs = {
  question: ScriptedQuestionInput;
};


/** Empty field. Not to be used. */
export type MutationWriteScriptedAnswerArgs = {
  answer: ScriptedAnswerInput;
};


/** Empty field. Not to be used. */
export type MutationDeleteScriptedPromptArgs = {
  id: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateUserCardsConsentStatusArgs = {
  newStatus: UserCardsConsentStatus;
};


/** Empty field. Not to be used. */
export type MutationExperimentTrackEventsArgs = {
  trackEvents: Array<TrackEventInput>;
};


/** Empty field. Not to be used. */
export type MutationSmTravelInsuranceQuotesArgs = {
  quote: CreateSingleTripQuoteInput;
};


/** Empty field. Not to be used. */
export type MutationPasswordlessUserRegisterArgs = {
  app: Scalars['String']['input'];
  email: Scalars['String']['input'];
  trafficSource?: InputMaybe<Scalars['String']['input']>;
  profiles?: InputMaybe<RegisterProfiles>;
  identifyPageProps: SegmentIdentifyPageProps;
};


/** Empty field. Not to be used. */
export type MutationAddCarReviewLinkArgs = {
  make: Scalars['String']['input'];
  model: Scalars['String']['input'];
  year: Scalars['String']['input'];
  url: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Float']['input']>;
};


/** Empty field. Not to be used. */
export type MutationAddTrimRatingArgs = {
  trim: Scalars['String']['input'];
  rating?: InputMaybe<Scalars['Float']['input']>;
};


/** Empty field. Not to be used. */
export type MutationUpdateTrimSegmentArgs = {
  trimId: Scalars['String']['input'];
  segmentId?: InputMaybe<Scalars['Int']['input']>;
  subsegmentId?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type MutationAddCarBestListArgs = {
  bestList: CarBestListInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateCarBestListArgs = {
  id: Scalars['ID']['input'];
  bestList: CarBestListInput;
};


/** Empty field. Not to be used. */
export type MutationDeleteCarBestListArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateCarBestListRanksArgs = {
  bestListId: Scalars['ID']['input'];
  ranks: Array<CarBestListRankInput>;
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialAccountVisibilityArgs = {
  financialAccountId: Scalars['ID']['input'];
  isHidden: Scalars['Boolean']['input'];
};


/** Empty field. Not to be used. */
export type MutationCreateUserFinancialAccountArgs = {
  balance: Scalars['BigInt']['input'];
  name: Scalars['String']['input'];
  subtype: FinancialAccountSubtype;
  subtypeDetails: Scalars['String']['input'];
  type: FinancialAccountType;
};


/** Empty field. Not to be used. */
export type MutationUpdateUserFinancialAccountArgs = {
  balance?: InputMaybe<Scalars['BigInt']['input']>;
  financialAccountId: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
  subtype?: InputMaybe<FinancialAccountSubtype>;
  subtypeDetails?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FinancialAccountType>;
};


/** Empty field. Not to be used. */
export type MutationDeleteUserFinancialAccountArgs = {
  financialAccountId: Scalars['ID']['input'];
  source?: InputMaybe<FinancialDataSource>;
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialCreditCardRewardViewedArgs = {
  id: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialNwPlusRewardViewedArgs = {
  id: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialNwPlusRewardDismissedArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationInitializeFinancialPortalArgs = {
  marketplaceInstitutionId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationReinitializeFinancialPortalArgs = {
  financialPortalId: Scalars['ID']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  androidPackageName?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type MutationMigrateFinancialPortalArgs = {
  financialPortalId: Scalars['ID']['input'];
  marketplaceInstitutionId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationFinishPortalMigrationArgs = {
  financialPortalId: Scalars['ID']['input'];
  shouldMigrate?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty field. Not to be used. */
export type MutationDeleteFinancialPortalArgs = {
  financialPortalId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationRefreshFinancialPortalArgs = {
  financialPortalId: Scalars['ID']['input'];
  isAutoRefresh?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty field. Not to be used. */
export type MutationPublishFinancialDataLinkEventArgs = {
  event: ProxyEventType;
  eventBody?: InputMaybe<Scalars['JSON']['input']>;
  financialPortalId?: InputMaybe<Scalars['ID']['input']>;
  linkToken?: InputMaybe<Scalars['String']['input']>;
  sourceEntityId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<FinancialDataSource>;
  sourceInstitutionId?: InputMaybe<Scalars['ID']['input']>;
  migrationMarketplaceInstitutionId?: InputMaybe<Scalars['ID']['input']>;
  isMigrate?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty field. Not to be used. */
export type MutationCreateBillStreamArgs = {
  billName: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  frequency: BillStreamFrequency;
  dueDate: Scalars['DateTime']['input'];
  newTransactionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type MutationUpdateBillStreamArgs = {
  id: Scalars['ID']['input'];
  billName?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  frequency?: InputMaybe<BillStreamFrequency>;
  dueDate?: InputMaybe<Scalars['DateTime']['input']>;
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type MutationPromoteSuggestedBillStreamArgs = {
  id: Scalars['ID']['input'];
  billName?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Float']['input']>;
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type MutationMarkBillStreamPaidArgs = {
  id: Scalars['ID']['input'];
  paidDate?: InputMaybe<Scalars['DateTime']['input']>;
  newTransactionIds?: InputMaybe<Array<Scalars['ID']['input']>>;
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type MutationUpdateSuggestedBillStreamHiddenStateArgs = {
  id: Scalars['ID']['input'];
  hideSuggestedBill: Scalars['Boolean']['input'];
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type MutationDeleteBillStreamArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateBillStreamTransactionsArgs = {
  id: Scalars['ID']['input'];
  newTransactionIds: Array<Scalars['ID']['input']>;
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type MutationCreateFinancialTransactionArgs = {
  accountId: Scalars['ID']['input'];
  amount: Scalars['Int']['input'];
  category?: InputMaybe<FinancialTransactionCategory>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  date: Scalars['DateTime']['input'];
  description?: InputMaybe<Scalars['String']['input']>;
  merchantName: Scalars['String']['input'];
  type: FinancialTransactionType;
};


/** Empty field. Not to be used. */
export type MutationDeleteFinancialTransactionArgs = {
  transactionId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionVisibilityArgs = {
  transactionId: Scalars['ID']['input'];
  isHidden: Scalars['Boolean']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionCategoryArgs = {
  transactionId: Scalars['ID']['input'];
  category?: InputMaybe<FinancialTransactionCategory>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialMerchantTransactionCategoryArgs = {
  transactionId: Scalars['ID']['input'];
  category?: InputMaybe<FinancialTransactionCategory>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  merchantName: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialTransactionArgs = {
  transactionId: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Int']['input']>;
  category?: InputMaybe<FinancialTransactionCategory>;
  categoryId?: InputMaybe<Scalars['Int']['input']>;
  date?: InputMaybe<Scalars['DateTime']['input']>;
  merchantName?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<FinancialTransactionType>;
};


/** Empty field. Not to be used. */
export type MutationUpdateUserAnnualIncomeArgs = {
  annualIncome: Scalars['Float']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateUserMonthlyNetIncomeArgs = {
  monthlyNetIncome: Scalars['Float']['input'];
};


/** Empty field. Not to be used. */
export type MutationAcknowledgeCoveredTcpaConsentArgs = {
  policyId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationAcknowledgeCanopyTermsOfServiceAgreementArgs = {
  source: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type MutationHidePolicyArgs = {
  policyId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateInsurancePolicyOverridesArgs = {
  policyId: Scalars['ID']['input'];
  localOverrides: LocalInsurancePolicyOverridesInput;
  globalOverrides: GlobalInsurancePolicyOverridesInput;
};


/** Empty field. Not to be used. */
export type MutationDeleteInsuranceByAccountIdArgs = {
  accountId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateMembershipAppActivityArgs = {
  membershipAppActivity: MembershipAppActivityInput;
};


/** Empty field. Not to be used. */
export type MutationMarkFeatureDiscoveryViewedArgs = {
  featureId: Scalars['String']['input'];
  viewedOnDate: Scalars['DateTime']['input'];
};


/** Empty field. Not to be used. */
export type MutationEarnRewardArgs = {
  type: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSON']['input']>;
};


/** Empty field. Not to be used. */
export type MutationNwPlusPurchaseRewardArgs = {
  rewardId: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type MutationRegisterNwPlusSubscriptionSuccessArgs = {
  anonymousId?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type MutationCreateRecurlyPurchaseArgs = {
  tokenId: Scalars['String']['input'];
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  couponCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  mailingAddress?: InputMaybe<RecurlyAddressInput>;
};


/** Empty field. Not to be used. */
export type MutationUpdateRecurlyAccountAddressInfoArgs = {
  address?: InputMaybe<RecurlyAddressInput>;
};


/** Empty field. Not to be used. */
export type MutationUpdateRecurlyBillingInfoArgs = {
  token_id?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type MutationAcknowledgeScribeUpTermsOfServiceArgs = {
  source: Scalars['String']['input'];
  version: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type MutationRegisterUserArgs = {
  registerInfo: NwRegisterInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserArgs = {
  loginInfo: NwLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserViaGoogleArgs = {
  loginInfo: GoogleLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserViaAppleArgs = {
  loginInfo: AppleLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationLogInUserViaRefreshTokenArgs = {
  loginInfo: RefreshTokenLoginInfoInput;
};


/** Empty field. Not to be used. */
export type MutationUpdatePasswordArgs = {
  passwordInfo: UpdatePasswordInfoInput;
};


/** Empty field. Not to be used. */
export type MutationSetSecurityQuestionArgs = {
  securityInfo: SecurityQuestionInfoInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateCreditCardMatchQuizAnswersArgs = {
  answers?: InputMaybe<Scalars['JSON']['input']>;
  quizVersion: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type MutationCreateTrustSessionIdArgs = {
  input: TrustSessionIdInput;
};


/** Empty field. Not to be used. */
export type MutationInitializeCreditProfileArgs = {
  customer: CreditProfileAuthCustomerInput;
  trustSessionId?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type MutationInitializeCreditProfileWithFallbackArgs = {
  customer: CreditProfileAuthCustomerInput;
};


/** Empty field. Not to be used. */
export type MutationAuthenticateCreditProfileArgs = {
  answers: Array<CreditProfileAuthAnswerInput>;
};


/** Empty field. Not to be used. */
export type MutationAuthenticateCreditProfileQuestionsArgs = {
  answers: Array<CreditProfileAuthAnswerInput>;
  resetPasscode?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Empty field. Not to be used. */
export type MutationPublishSimpleCrmEventArgs = {
  eventName: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type MutationPublishCrmEventArgs = {
  eventName: Scalars['String']['input'];
  customPayload?: InputMaybe<Scalars['JSON']['input']>;
};


/** Empty field. Not to be used. */
export type MutationUpdateDlanProfileArgs = {
  input: DlanProfileInput;
};


/** Empty field. Not to be used. */
export type MutationFollowAuthorArgs = {
  entityId: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type MutationUnfollowAuthorArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationFollowArticleAuthorsArgs = {
  articleId: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type MutationUnfollowArticleAuthorsArgs = {
  articleId: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateGamificationChecklistArgs = {
  gamificationChecklist: GamificationChecklistInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateSubscriptionProfileArgs = {
  subscriptionProfile: UpdateSubscriptionProfileInput;
  identityId: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateSubscriptionWithoutIdentityArgs = {
  subscriptionSettings: UpdateSubscriptionProfileInput;
  updateSubscriptionToken?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type MutationUnsubscribeFromNotificationArgs = {
  subscriptionField: SubscriptionTypeEnum;
  unsubscribeToken: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type MutationAddMobileAppDeviceArgs = {
  device: MobileAppProfileDeviceInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateDismissAccountAggCtaArgs = {
  dismissAccountAggCta: AccountAggCtaDismissedInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateIncomeArgs = {
  input: UpdateIncomeInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateNameArgs = {
  input: UpdateNameInput;
};


/** Empty field. Not to be used. */
export type MutationAcknowledgeTermsOfServiceArgs = {
  input: AcknowledgeTermsOfServiceInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateWeeklyInsightsCurrentStreakArgs = {
  weeklyInsightsCompletedDate?: InputMaybe<Scalars['DateTime']['input']>;
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateAccountArgs = {
  financialAccountId: Scalars['ID']['input'];
  moneyTransferAccountType: MoneyTransferFinancialAccountTypeEnum;
  financialAccountSource: FinancialDataSource;
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCancelTransferArgs = {
  transferId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateTransferArgs = {
  amount: Scalars['Int']['input'];
  sourceMoneyTransferAccountId: Scalars['ID']['input'];
  destinationMoneyTransferAccountId: Scalars['ID']['input'];
  idempotencyKey: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationMoneyTransferCreateUserArgs = {
  userInput: MoneyTransferCreateUserInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateNetWorthAccountVisibilityArgs = {
  netWorthAccountId: Scalars['ID']['input'];
  isHiddenFromNetWorth: Scalars['Boolean']['input'];
};


/** Empty field. Not to be used. */
export type MutationAddNetWorthHomeIntegratedArgs = {
  address: NetWorthHomeIntegratedAddressInput;
  externalInfo: NetWorthHomeIntegratedExternalInfoInput;
};


/** Empty field. Not to be used. */
export type MutationAddNetWorthRealAssetSelfReportedArgs = {
  type: NetWorthRealAssetTypeEnum;
  nickname: Scalars['String']['input'];
  amount: Scalars['Float']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateNetWorthRealAssetIsHiddenFromNetWorthArgs = {
  netWorthRealAssetId: Scalars['ID']['input'];
  isHiddenFromNetWorth: Scalars['Boolean']['input'];
};


/** Empty field. Not to be used. */
export type MutationEditNetWorthRealAssetSelfReportedArgs = {
  amount?: InputMaybe<Scalars['Float']['input']>;
  netWorthRealAssetId: Scalars['ID']['input'];
  nickname?: InputMaybe<Scalars['String']['input']>;
};


/** Empty field. Not to be used. */
export type MutationDeleteNetWorthRealAssetArgs = {
  netWorthRealAssetId: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialPrioritiesArgs = {
  financialPriorities: FinancialPrioritiesInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateFinancialPrioritiesFeatureDiscoveryArgs = {
  isDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  impressionCount?: InputMaybe<Scalars['Int']['input']>;
};


/** Empty field. Not to be used. */
export type MutationInitiatePersonalLoansPrequalRequestArgs = {
  userInput: PersonalLoansPrequalOfferInput;
  providerIds: Array<InputMaybe<PersonalLoansPrequalProviderIdEnum>>;
};


/** Empty field. Not to be used. */
export type MutationAddProjectTedFormArgs = {
  form?: InputMaybe<Scalars['JSON']['input']>;
};


/** Empty field. Not to be used. */
export type MutationAddUserReportedCreditCardsArgs = {
  cards: Array<UserReportedCreditCardInput>;
};


/** Empty field. Not to be used. */
export type MutationSetUserReportedCreditCardsArgs = {
  cards?: InputMaybe<Array<UserReportedCreditCardInput>>;
};


/** Empty field. Not to be used. */
export type MutationRemoveUserReportedCreditCardArgs = {
  cardId: Scalars['Int']['input'];
};


/** Empty field. Not to be used. */
export type MutationSaveContentArgs = {
  entityId: Scalars['Int']['input'];
  entityType: Scalars['String']['input'];
};


/** Empty field. Not to be used. */
export type MutationUnsaveContentArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationAddUserWalletCardArgs = {
  input: AddUserWalletCardInput;
};


/** Empty field. Not to be used. */
export type MutationUpdateUserWalletCardArgs = {
  input: UpdateUserWalletCardInput;
};


/** Empty field. Not to be used. */
export type MutationRemoveUserWalletCardArgs = {
  id: Scalars['ID']['input'];
};


/** Empty field. Not to be used. */
export type MutationPublishYakMessagesArgs = {
  messages: Array<YakMessageInput>;
};


/** Empty field. Not to be used. */
export type MutationUpdateServiceTestStateProfileArgs = {
  testState: ServiceTestStateInput;
};

/** Common interface Type for all explicit structured content page Types to implement */
export type StructuredContentPageInterface = {
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type SmbThing = {
  __typename?: 'SMBThing';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CreateThing = {
  id: Scalars['ID']['input'];
  name?: InputMaybe<Scalars['String']['input']>;
};

export type RegistrationTrackingProfile = {
  trackingCode: Scalars['String']['input'];
  location: Scalars['String']['input'];
  vertical: Scalars['String']['input'];
  pageName?: InputMaybe<Scalars['String']['input']>;
  impressionID?: InputMaybe<Scalars['String']['input']>;
  anonymousId?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterResponse = {
  __typename?: 'RegisterResponse';
  success: Scalars['Boolean']['output'];
  memberIdentityAssertionToken?: Maybe<Scalars['String']['output']>;
};

export type QuizResponse = {
  __typename?: 'QuizResponse';
  offers?: Maybe<Array<Maybe<QuizOffer>>>;
};

export type CardFinderUserData = {
  __typename?: 'CardFinderUserData';
  inputs?: Maybe<SavedQuizAnswers>;
  isSignedIn: Scalars['Boolean']['output'];
  isReturnUser: Scalars['Boolean']['output'];
  tuCreditScore?: Maybe<Scalars['Int']['output']>;
  tuCreditScoreBand?: Maybe<CreditScore>;
};

export type CardFinderGlobalMarkup = {
  __typename?: 'CardFinderGlobalMarkup';
  head: Scalars['String']['output'];
  header: Scalars['String']['output'];
  footer: Scalars['String']['output'];
};

export type ItemizedScore = {
  __typename?: 'ItemizedScore';
  awardedPoints?: Maybe<Scalars['Float']['output']>;
  availablePoints?: Maybe<Scalars['Int']['output']>;
  name: Scalars['String']['output'];
};

export type QuizOffer = {
  __typename?: 'QuizOffer';
  offer: CardsMarketplaceOffer;
  matchScore: Scalars['Float']['output'];
  itemizedScore?: Maybe<Array<Maybe<ItemizedScore>>>;
  itemizedMethodology?: Maybe<Array<Maybe<ItemizedScore>>>;
};

export type FullDebtInput = {
  debtType?: InputMaybe<DebtTypeEnum>;
  institution?: InputMaybe<CurrentBalanceCompany>;
  amount?: InputMaybe<Scalars['Int']['input']>;
};

export type QuizAnswers = {
  airlineChoice?: InputMaybe<Array<InputMaybe<AirlineChoice>>>;
  annualFees?: InputMaybe<Scalars['Boolean']['input']>;
  annualFeesTravel?: InputMaybe<AnnualFeesTravel>;
  bonusCategories?: InputMaybe<Array<InputMaybe<BonusCategories>>>;
  bonusCategoriesStaySame?: InputMaybe<Scalars['Boolean']['input']>;
  cardDeposit?: InputMaybe<Scalars['Boolean']['input']>;
  cashBackBigPurchase?: InputMaybe<Scalars['String']['input']>;
  cashBackMinimum?: InputMaybe<Scalars['Boolean']['input']>;
  cashBackPreference?: InputMaybe<Scalars['String']['input']>;
  collegeStudent?: InputMaybe<Scalars['Boolean']['input']>;
  createAccount?: InputMaybe<Scalars['Boolean']['input']>;
  creditScore?: InputMaybe<CreditScore>;
  currentBalanceCompany?: InputMaybe<CurrentBalanceCompany>;
  fullDebt?: InputMaybe<Array<InputMaybe<FullDebtInput>>>;
  hotelChoice?: InputMaybe<Array<InputMaybe<HotelChoice>>>;
  howCashBack?: InputMaybe<HowCashBack>;
  howLongToPayOffDebt?: InputMaybe<HowLongToPayOffDebt>;
  howMuchTransferFee?: InputMaybe<HowMuchTransferFee>;
  howOftenTravel?: InputMaybe<HowOftenTravel>;
  internationalTravel?: InputMaybe<Scalars['Boolean']['input']>;
  introAPROrRewards?: InputMaybe<IntroAprOrRewards>;
  isBuildingCredit?: InputMaybe<Scalars['Boolean']['input']>;
  isDebtCreditCard?: InputMaybe<Scalars['Boolean']['input']>;
  luxuryPerks?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  managingCategories?: InputMaybe<Scalars['String']['input']>;
  monthlySpend?: InputMaybe<Scalars['Int']['input']>;
  primaryGoal: PrimaryGoal;
  purchaseSpend?: InputMaybe<Scalars['Int']['input']>;
  purchaseSpendingCategories?: InputMaybe<Array<InputMaybe<PurchaseSpendingCategories>>>;
  rewardsAndPerks?: InputMaybe<RewardsAndPerks>;
  securityDeposit?: InputMaybe<Scalars['Int']['input']>;
  specificAirline?: InputMaybe<Scalars['Boolean']['input']>;
  specificAirlineOrHotel?: InputMaybe<SpecificAirlineOrHotel>;
  specificHotel?: InputMaybe<Scalars['Boolean']['input']>;
  spendingCategories?: InputMaybe<Array<InputMaybe<SpendingCategories>>>;
  studentSpendingCategories?: InputMaybe<Array<InputMaybe<StudentSpendingCategories>>>;
  typeOfDebt?: InputMaybe<TypeOfDebt>;
};

export enum RewardsAndPerks {
  HasEarningRewardsRedeemedForTravelExpenses = 'HAS_EARNING_REWARDS_REDEEMED_FOR_TRAVEL_EXPENSES',
  HasLuxuryPerksTravelMorePleasant = 'HAS_LUXURY_PERKS_TRAVEL_MORE_PLEASANT',
  HasMixedRewardsAndTravelPerks = 'HAS_MIXED_REWARDS_AND_TRAVEL_PERKS'
}

export enum IntroAprOrRewards {
  IntroApr = 'INTRO_APR',
  Rewards = 'REWARDS'
}

export enum SpecificAirlineOrHotel {
  YesHotel = 'YES_HOTEL',
  YesAirline = 'YES_AIRLINE',
  YesBoth = 'YES_BOTH',
  Neither = 'NEITHER'
}

export enum SpendingCategories {
  DrugStores = 'DRUG_STORES',
  Entertainment = 'ENTERTAINMENT',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  HomeImprovement = 'HOME_IMPROVEMENT',
  OnlineShopping = 'ONLINE_SHOPPING',
  Restaurants = 'RESTAURANTS',
  Streaming = 'STREAMING',
  Travel = 'TRAVEL'
}

export enum PurchaseSpendingCategories {
  Entertainment = 'ENTERTAINMENT',
  HomeImprovement = 'HOME_IMPROVEMENT',
  OnlineShopping = 'ONLINE_SHOPPING',
  Travel = 'TRAVEL',
  Other = 'OTHER'
}

export type FullDebt = {
  __typename?: 'FullDebt';
  debtType?: Maybe<DebtTypeEnum>;
  institution?: Maybe<CurrentBalanceCompany>;
  amount?: Maybe<Scalars['Int']['output']>;
};

export type SavedQuizAnswers = {
  __typename?: 'SavedQuizAnswers';
  airlineChoice?: Maybe<Array<Maybe<AirlineChoice>>>;
  annualFees?: Maybe<Scalars['Boolean']['output']>;
  annualFeesTravel?: Maybe<AnnualFeesTravel>;
  bonusCategories?: Maybe<Array<Maybe<BonusCategories>>>;
  bonusCategoriesStaySame?: Maybe<Scalars['Boolean']['output']>;
  cardDeposit?: Maybe<Scalars['Boolean']['output']>;
  cashBackBigPurchase?: Maybe<Scalars['String']['output']>;
  cashBackMinimum?: Maybe<Scalars['Boolean']['output']>;
  cashBackPreference?: Maybe<Scalars['String']['output']>;
  collegeStudent?: Maybe<Scalars['Boolean']['output']>;
  createAccount?: Maybe<Scalars['Boolean']['output']>;
  creditScore?: Maybe<CreditScore>;
  currentBalanceCompany?: Maybe<CurrentBalanceCompany>;
  fullDebt?: Maybe<Array<Maybe<FullDebt>>>;
  hotelChoice?: Maybe<Array<Maybe<HotelChoice>>>;
  howCashBack?: Maybe<HowCashBack>;
  howLongToPayOffDebt?: Maybe<HowLongToPayOffDebt>;
  howMuchTransferFee?: Maybe<HowMuchTransferFee>;
  howOftenTravel?: Maybe<HowOftenTravel>;
  internationalTravel?: Maybe<Scalars['Boolean']['output']>;
  introAPROrRewards?: Maybe<IntroAprOrRewards>;
  isBuildingCredit?: Maybe<Scalars['Boolean']['output']>;
  isDebtCreditCard?: Maybe<Scalars['Boolean']['output']>;
  luxuryPerks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  managingCategories?: Maybe<Scalars['String']['output']>;
  monthlySpend?: Maybe<Scalars['Int']['output']>;
  primaryGoal?: Maybe<PrimaryGoal>;
  purchaseSpend?: Maybe<Scalars['Int']['output']>;
  purchaseSpendingCategories?: Maybe<Array<Maybe<PurchaseSpendingCategories>>>;
  rewardsAndPerks?: Maybe<RewardsAndPerks>;
  securityDeposit?: Maybe<Scalars['Int']['output']>;
  specificAirline?: Maybe<Scalars['Boolean']['output']>;
  specificAirlineOrHotel?: Maybe<SpecificAirlineOrHotel>;
  specificHotel?: Maybe<Scalars['Boolean']['output']>;
  spendingCategories?: Maybe<Array<Maybe<SpendingCategories>>>;
  studentSpendingCategories?: Maybe<Array<Maybe<StudentSpendingCategories>>>;
  typeOfDebt?: Maybe<TypeOfDebt>;
};

export enum TypeOfDebt {
  PersonalLoan = 'PERSONAL_LOAN',
  AutoLoan = 'AUTO_LOAN',
  StudentLoan = 'STUDENT_LOAN',
  HomeEquityLoan = 'HOME_EQUITY_LOAN'
}

export enum DebtTypeEnum {
  CreditCard = 'CREDIT_CARD',
  PersonalLoan = 'PERSONAL_LOAN',
  AutoLoan = 'AUTO_LOAN',
  StudentLoan = 'STUDENT_LOAN',
  HomeEquityLoan = 'HOME_EQUITY_LOAN'
}

export enum PrimaryGoal {
  Travel = 'TRAVEL',
  CashBack = 'CASH_BACK',
  Debt = 'DEBT',
  BigPurchase = 'BIG_PURCHASE',
  BuildCredit = 'BUILD_CREDIT'
}

export enum CreditScore {
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Average = 'AVERAGE',
  Poor = 'POOR',
  LimitedCreditHistory = 'LIMITED_CREDIT_HISTORY'
}

export enum HowLongToPayOffDebt {
  LessThan_18Months = 'LESS_THAN_18_MONTHS',
  MoreThan_18Months = 'MORE_THAN_18_MONTHS'
}

export enum CurrentBalanceCompany {
  AmericanExpress = 'AMERICAN_EXPRESS',
  BankOfAmerica = 'BANK_OF_AMERICA',
  CapitalOne = 'CAPITAL_ONE',
  Chase = 'CHASE',
  Citibank = 'CITIBANK',
  Discover = 'DISCOVER',
  WellsFargo = 'WELLS_FARGO',
  UsBank = 'US_BANK',
  Other = 'OTHER'
}

export enum HowMuchTransferFee {
  LessThan_3 = 'LESS_THAN_3',
  Between_3And_5 = 'BETWEEN_3_AND_5'
}

export enum HowCashBack {
  SameRate = 'SAME_RATE',
  Categories = 'CATEGORIES'
}

export enum BonusCategories {
  DrugStores = 'DRUG_STORES',
  Entertainment = 'ENTERTAINMENT',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  HomeImprovement = 'HOME_IMPROVEMENT',
  OnlineShopping = 'ONLINE_SHOPPING',
  Restaurants = 'RESTAURANTS',
  Streaming = 'STREAMING',
  Travel = 'TRAVEL'
}

export enum HowOftenTravel {
  OneToThree = 'ONE_TO_THREE',
  FourToNine = 'FOUR_TO_NINE',
  MoreThan_10 = 'MORE_THAN_10'
}

export enum AirlineChoice {
  AmericanAirlines = 'AMERICAN_AIRLINES',
  AlaskaAirlines = 'ALASKA_AIRLINES',
  Delta = 'DELTA',
  Jetblue = 'JETBLUE',
  SouthwestAirlines = 'SOUTHWEST_AIRLINES',
  UnitedAirlines = 'UNITED_AIRLINES',
  Other = 'OTHER'
}

export enum HotelChoice {
  Choice = 'CHOICE',
  Hilton = 'HILTON',
  Hyatt = 'HYATT',
  Ihg = 'IHG',
  Marriott = 'MARRIOTT',
  Radisson = 'RADISSON',
  Wyndham = 'WYNDHAM',
  Other = 'OTHER'
}

export enum AnnualFeesTravel {
  LessThan_100 = 'LESS_THAN_100',
  Between_100And_300 = 'BETWEEN_100_AND_300',
  MoreThan_300 = 'MORE_THAN_300'
}

export enum CardsMarketplaceStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum StudentSpendingCategories {
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  Restaurants = 'RESTAURANTS',
  Streaming = 'STREAMING',
  Travel = 'TRAVEL'
}

export type CardsMarketplaceOffer = {
  __typename?: 'CardsMarketplaceOffer';
  name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  details: CardsMarketplaceOfferDetails;
  derived_details: CardsMarketplaceOfferDerivedDetails;
  product: CardsMarketplaceProduct;
  status: CardsMarketplaceStatus;
};

export type CardsMarketplaceProduct = {
  __typename?: 'CardsMarketplaceProduct';
  name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  institution: CardsMarketplaceInstitution;
  details?: Maybe<CardsMarketplaceProductDetails>;
};

export type CardsMarketplaceInstitution = {
  __typename?: 'CardsMarketplaceInstitution';
  name: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  details?: Maybe<CardsMarketplaceInstitutionDetails>;
};

export type CardsMarketplaceProductDetails = {
  __typename?: 'CardsMarketplaceProductDetails';
  manual_entry?: Maybe<Scalars['Boolean']['output']>;
};

export type CardsMarketplaceInstitutionDetails = {
  __typename?: 'CardsMarketplaceInstitutionDetails';
  manual_entry?: Maybe<Scalars['Boolean']['output']>;
  enable_match_score_display?: Maybe<Scalars['Boolean']['output']>;
};

export type CardsMarketplaceOfferDetails = {
  __typename?: 'CardsMarketplaceOfferDetails';
  annual_fee: Scalars['Float']['output'];
  annual_fee_details?: Maybe<Scalars['String']['output']>;
  best_of_badge_winner_2020?: Maybe<Array<Maybe<CardsMarketplaceOfferBestOfBadgeWinner2020>>>;
  best_of_badge_winner_2021?: Maybe<Array<Maybe<CardsMarketplaceOfferBestOfBadgeWinner2021>>>;
  reward_program_name?: Maybe<Scalars['String']['output']>;
  annual_fee_first_year: Scalars['Float']['output'];
  apply_pay_per_call?: Maybe<Scalars['String']['output']>;
  apr_average?: Maybe<Scalars['Float']['output']>;
  apr_display_list: Array<Maybe<Scalars['String']['output']>>;
  apr_excellent?: Maybe<Scalars['Float']['output']>;
  apr_good?: Maybe<Scalars['Float']['output']>;
  apr_intro_message?: Maybe<Scalars['String']['output']>;
  apr_intro_message_list: Array<Maybe<Scalars['String']['output']>>;
  apr_max?: Maybe<Scalars['Float']['output']>;
  apr_min?: Maybe<Scalars['Float']['output']>;
  apr_poor?: Maybe<Scalars['Float']['output']>;
  balance_transfer_fee?: Maybe<Scalars['Float']['output']>;
  balance_transfer_intro_apr?: Maybe<Scalars['Float']['output']>;
  balance_transfer_fee_description?: Maybe<Scalars['String']['output']>;
  balance_transfer_intro_fee_description?: Maybe<Scalars['String']['output']>;
  balance_transfer_intro_time?: Maybe<Scalars['Int']['output']>;
  banned_pages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  billing_cycle_units: Scalars['String']['output'];
  canonical_url?: Maybe<Scalars['String']['output']>;
  card_categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  card_user?: Maybe<CardsMarketplaceOfferCardUser>;
  cash_advance_apr?: Maybe<Scalars['Float']['output']>;
  cash_advance_fee?: Maybe<Scalars['Float']['output']>;
  cobrand_airline?: Maybe<CardsMarketplaceOfferCobrandAirline>;
  cobrand_hotel?: Maybe<CardsMarketplaceOfferCobrandHotel>;
  compare_categories?: Maybe<Array<Maybe<CardsMarketplaceOfferCompareCategories>>>;
  cons_bullets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  content_tips?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  custom_details_list?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  disclaimer_text?: Maybe<Scalars['String']['output']>;
  editorial_value_prop?: Maybe<Scalars['String']['output']>;
  feed_id?: Maybe<Scalars['Int']['output']>;
  feed_product_id?: Maybe<Scalars['String']['output']>;
  foreign_transaction_fee: Scalars['Float']['output'];
  foreign_transaction_fee_description?: Maybe<Scalars['String']['output']>;
  image_alt_text: Scalars['String']['output'];
  image_is_portrait: Scalars['Boolean']['output'];
  image_source: Scalars['String']['output'];
  image_source_large: Scalars['String']['output'];
  image_source_medium: Scalars['String']['output'];
  included_pages?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  is_editorial_apply_link_disabled?: Maybe<Scalars['Boolean']['output']>;
  is_fixed_rate: Scalars['Boolean']['output'];
  is_monetizing?: Maybe<Scalars['Boolean']['output']>;
  is_shown_on_tool: Scalars['Boolean']['output'];
  issuer_info_page_url?: Maybe<Scalars['String']['output']>;
  last_ingested_at?: Maybe<Scalars['Int']['output']>;
  late_payment_fee?: Maybe<Scalars['Int']['output']>;
  late_payment_fee_description?: Maybe<Scalars['String']['output']>;
  legacy_id: Scalars['Int']['output'];
  manual_entry?: Maybe<Scalars['Boolean']['output']>;
  marketing_bullets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  marketing_bullets_without_terms_and_fees_link?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  max_fico: Scalars['Int']['output'];
  meta_description?: Maybe<Scalars['String']['output']>;
  meta_keywords?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  meta_title?: Maybe<Scalars['String']['output']>;
  min_fico: Scalars['Int']['output'];
  minimum_deposit?: Maybe<Scalars['Float']['output']>;
  minimum_deposit_description?: Maybe<Scalars['String']['output']>;
  obsolete_referrals?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  offer_url?: Maybe<Scalars['String']['output']>;
  ongoing_apr: Scalars['String']['output'];
  ongoing_apr_annotated?: Maybe<Scalars['String']['output']>;
  ongoing_apr_unannotated: Scalars['String']['output'];
  penalty_apr?: Maybe<Scalars['Float']['output']>;
  perks?: Maybe<Array<Maybe<CardsMarketplaceOfferPerks>>>;
  prequal_link?: Maybe<Scalars['String']['output']>;
  prequal_link_text?: Maybe<Scalars['String']['output']>;
  processing_network?: Maybe<CardsMarketplaceOfferProcessingNetwork>;
  pros_bullets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  purchase_apr?: Maybe<Scalars['String']['output']>;
  purchase_apr_annotated?: Maybe<Scalars['String']['output']>;
  purchase_intro_apr?: Maybe<Scalars['Float']['output']>;
  purchase_intro_time?: Maybe<Scalars['Int']['output']>;
  rating_stars?: Maybe<Scalars['Float']['output']>;
  related_card_ids?: Maybe<Array<Maybe<Scalars['Int']['output']>>>;
  related_content?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  reward_categories_best_rates?: Maybe<Array<Maybe<CardsMarketplaceOfferRewardCategoriesBestRates>>>;
  reward_type?: Maybe<Scalars['String']['output']>;
  reward_rate: Scalars['Float']['output'];
  reward_rate_details: Scalars['String']['output'];
  reward_rate_notes?: Maybe<Scalars['String']['output']>;
  rewards_rates?: Maybe<Array<Maybe<CardsMarketplaceOfferRewardsRates>>>;
  redemption_complexity?: Maybe<Scalars['Int']['output']>;
  seo_name?: Maybe<Scalars['String']['output']>;
  redemptions?: Maybe<Array<Maybe<CardsMarketplaceOfferRedemptions>>>;
  review_link?: Maybe<Scalars['String']['output']>;
  sign_up_bonus: Scalars['Int']['output'];
  sign_up_bonus_details: Scalars['String']['output'];
  sign_up_bonus_details_annotation?: Maybe<Scalars['String']['output']>;
  sign_up_bonus_type?: Maybe<CardsMarketplaceOfferSignUpBonusType>;
  slug?: Maybe<Scalars['String']['output']>;
  terms_and_fees_link?: Maybe<Scalars['String']['output']>;
  promos?: Maybe<Array<Maybe<CardsMarketplaceOfferPromos>>>;
  rewards?: Maybe<Array<Maybe<CardsMarketplaceOfferRewards>>>;
  best_of_awards?: Maybe<Array<Maybe<CardsMarketplaceOfferBestOfAwards>>>;
  limited_credit_history?: Maybe<Scalars['Boolean']['output']>;
  eligible_for_nerdwallet_plus_bonus?: Maybe<Scalars['Boolean']['output']>;
};

export type CardsMarketplaceOfferDerivedDetails = {
  __typename?: 'CardsMarketplaceOfferDerivedDetails';
  apply_link?: Maybe<Scalars['String']['output']>;
  approval_likelihood?: Maybe<Scalars['Float']['output']>;
  balance_transfer_cfa?: Maybe<Scalars['Float']['output']>;
  balance_transfer_interest_savings?: Maybe<Scalars['Float']['output']>;
  category_dining?: Maybe<Scalars['Float']['output']>;
  category_gas?: Maybe<Scalars['Float']['output']>;
  category_grocery_drug?: Maybe<Scalars['Float']['output']>;
  category_office?: Maybe<Scalars['Float']['output']>;
  category_other?: Maybe<Scalars['Float']['output']>;
  category_travel?: Maybe<Scalars['Float']['output']>;
  debt_free_monthly_payment?: Maybe<Scalars['Float']['output']>;
  estimated_ongoing_apr?: Maybe<Scalars['Float']['output']>;
  fees?: Maybe<Scalars['Float']['output']>;
  is_approval_likely?: Maybe<Scalars['Boolean']['output']>;
  is_sponsored?: Maybe<Scalars['Boolean']['output']>;
  match_score?: Maybe<Scalars['Int']['output']>;
  monetizable?: Maybe<CardsMarketplaceOfferMonetizable>;
  net_rewards?: Maybe<Scalars['Float']['output']>;
  reward_cents_per_unit?: Maybe<Scalars['Float']['output']>;
  reward_cents_per_unit_string?: Maybe<Scalars['String']['output']>;
  purchase_cfa?: Maybe<Scalars['Float']['output']>;
  purchase_interest_savings?: Maybe<Scalars['Float']['output']>;
  sign_up_bonus?: Maybe<Scalars['Float']['output']>;
  spending_rewards?: Maybe<Scalars['Float']['output']>;
  terms_and_fees_redirect_link?: Maybe<Scalars['String']['output']>;
  total_balance_transfer_cost?: Maybe<Scalars['Float']['output']>;
  total_balance_transfer_savings_ongoing_interest?: Maybe<Scalars['Float']['output']>;
  total_balance_transfer_savings_time?: Maybe<Scalars['Int']['output']>;
  total_purchase_savings_amount?: Maybe<Scalars['Float']['output']>;
  total_purchase_savings_ongoing_interest?: Maybe<Scalars['Float']['output']>;
  total_purchase_savings_time?: Maybe<Scalars['Int']['output']>;
  total_savings_amount?: Maybe<Scalars['Float']['output']>;
  true_balance_transfer_cost?: Maybe<Scalars['Float']['output']>;
  true_interest_cost?: Maybe<Scalars['Float']['output']>;
  visitor_approval_likelihood?: Maybe<Scalars['Float']['output']>;
};

export type CardsMarketplaceOfferRewardCategoriesBestRates = {
  __typename?: 'CardsMarketplaceOfferRewardCategoriesBestRates';
  rate: Scalars['Float']['output'];
  category: CardsMarketplaceOfferRewardCategoriesBestRatesCategory;
};

export type CardsMarketplaceOfferRewardsRates = {
  __typename?: 'CardsMarketplaceOfferRewardsRates';
  rate?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type CardsMarketplaceOfferPromos = {
  __typename?: 'CardsMarketplaceOfferPromos';
  id?: Maybe<Scalars['String']['output']>;
  type?: Maybe<CardsMarketplaceOfferPromosType>;
  version_id?: Maybe<Scalars['Int']['output']>;
  spend_amount?: Maybe<Scalars['Int']['output']>;
  spend_months?: Maybe<Scalars['Float']['output']>;
  reward_amount?: Maybe<Scalars['Int']['output']>;
  display_suffix?: Maybe<Scalars['String']['output']>;
};

export type CardsMarketplaceOfferRewards = {
  __typename?: 'CardsMarketplaceOfferRewards';
  id?: Maybe<Scalars['String']['output']>;
  cap?: Maybe<Scalars['Int']['output']>;
  rate: Scalars['Float']['output'];
  period: CardsMarketplaceOfferRewardsPeriod;
  category: CardsMarketplaceOfferRewardsCategory;
  duration: Scalars['Int']['output'];
  is_custom?: Maybe<Scalars['Boolean']['output']>;
  is_rotating?: Maybe<Scalars['Boolean']['output']>;
  is_tiered: Scalars['Boolean']['output'];
  recommendation_category?: Maybe<CardsMarketplaceOfferRewardsRecommendationCategory>;
  version_id: Scalars['Int']['output'];
};

export type CardsMarketplaceOfferBestOfAwards = {
  __typename?: 'CardsMarketplaceOfferBestOfAwards';
  year?: Maybe<Scalars['String']['output']>;
  category?: Maybe<CardsMarketplaceOfferBestOfAwardsCategory>;
};

export enum CardsMarketplaceOfferMonetizable {
  YesAssumed = 'YES_ASSUMED',
  No = 'NO',
  NoBecauseOfLimit = 'NO_BECAUSE_OF_LIMIT'
}

export enum CardsMarketplaceOfferBestOfBadgeWinner2020 {
  Best_0IntroAprCreditCard = 'BEST_0_INTRO_APR_CREDIT_CARD',
  BestAirlineCreditCard = 'BEST_AIRLINE_CREDIT_CARD',
  BestBalanceTransferCreditCard = 'BEST_BALANCE_TRANSFER_CREDIT_CARD',
  BestBonusRewardsCashBackCreditCard = 'BEST_BONUS_REWARDS_CASH_BACK_CREDIT_CARD',
  BestBonusRewardsTravelCreditCard = 'BEST_BONUS_REWARDS_TRAVEL_CREDIT_CARD',
  BestCreditCardForBuildingCredit = 'BEST_CREDIT_CARD_FOR_BUILDING_CREDIT',
  BestCreditCardForCollegeStudents = 'BEST_CREDIT_CARD_FOR_COLLEGE_STUDENTS',
  BestCreditCardForDiningAndEntertainment = 'BEST_CREDIT_CARD_FOR_DINING_AND_ENTERTAINMENT',
  BestCreditCardForFairCredit = 'BEST_CREDIT_CARD_FOR_FAIR_CREDIT',
  BestCreditCardForFamilies = 'BEST_CREDIT_CARD_FOR_FAMILIES',
  BestCreditCardForInternationalStudents = 'BEST_CREDIT_CARD_FOR_INTERNATIONAL_STUDENTS',
  BestFlatRateCashBackCreditCard = 'BEST_FLAT_RATE_CASH_BACK_CREDIT_CARD',
  BestFlatRateTravelCreditCard = 'BEST_FLAT_RATE_TRAVEL_CREDIT_CARD',
  BestGasCreditCard = 'BEST_GAS_CREDIT_CARD',
  BestHotelCreditCard = 'BEST_HOTEL_CREDIT_CARD',
  BestNoAnnualFeeTravelCreditCard = 'BEST_NO_ANNUAL_FEE_TRAVEL_CREDIT_CARD',
  BestPremiumCreditCard = 'BEST_PREMIUM_CREDIT_CARD',
  BestSmallBusinessCashBackCreditCard = 'BEST_SMALL_BUSINESS_CASH_BACK_CREDIT_CARD',
  BestSmallBusinessTravelCreditCard = 'BEST_SMALL_BUSINESS_TRAVEL_CREDIT_CARD',
  BestStoreCreditCard = 'BEST_STORE_CREDIT_CARD'
}

export enum CardsMarketplaceOfferBestOfBadgeWinner2021 {
  Best_0IntroAprAndBalanceTransferCreditCard = 'BEST_0_INTRO_APR_AND_BALANCE_TRANSFER_CREDIT_CARD',
  BestAirlineCreditCard = 'BEST_AIRLINE_CREDIT_CARD',
  BestBonusRewardsCashBackCreditCard = 'BEST_BONUS_REWARDS_CASH_BACK_CREDIT_CARD',
  BestBonusRewardsTravelCreditCard = 'BEST_BONUS_REWARDS_TRAVEL_CREDIT_CARD',
  BestCreditCardForBuildingCredit = 'BEST_CREDIT_CARD_FOR_BUILDING_CREDIT',
  BestCreditCardForCollegeStudents = 'BEST_CREDIT_CARD_FOR_COLLEGE_STUDENTS',
  BestCreditCardForDiningOutOrOrderingIn = 'BEST_CREDIT_CARD_FOR_DINING_OUT_OR_ORDERING_IN',
  BestCreditCardForGroceries = 'BEST_CREDIT_CARD_FOR_GROCERIES',
  BestCreditCardForStayingAtHome = 'BEST_CREDIT_CARD_FOR_STAYING_AT_HOME',
  BestFlatRateCashBackCreditCard = 'BEST_FLAT_RATE_CASH_BACK_CREDIT_CARD',
  BestFlatRateTravelCreditCard = 'BEST_FLAT_RATE_TRAVEL_CREDIT_CARD',
  BestHotelCreditCard = 'BEST_HOTEL_CREDIT_CARD',
  BestNoAnnualFeeTravelCreditCard = 'BEST_NO_ANNUAL_FEE_TRAVEL_CREDIT_CARD',
  BestSmallBusinessCashBackCreditCard = 'BEST_SMALL_BUSINESS_CASH_BACK_CREDIT_CARD'
}

export enum CardsMarketplaceOfferCardUser {
  Business = 'BUSINESS',
  Personal = 'PERSONAL',
  Student = 'STUDENT'
}

export enum CardsMarketplaceOfferCobrandAirline {
  Aeroplan = 'AEROPLAN',
  AirLingus = 'AIR_LINGUS',
  AlaskaAirlines = 'ALASKA_AIRLINES',
  AmericanAirlines = 'AMERICAN_AIRLINES',
  BritishAirways = 'BRITISH_AIRWAYS',
  Delta = 'DELTA',
  Iberia = 'IBERIA',
  Jetblue = 'JETBLUE',
  Other = 'OTHER',
  SouthwestAirlines = 'SOUTHWEST_AIRLINES',
  UnitedAirlines = 'UNITED_AIRLINES'
}

export enum CardsMarketplaceOfferCobrandHotel {
  Choice = 'CHOICE',
  Hilton = 'HILTON',
  Hyatt = 'HYATT',
  Ihg = 'IHG',
  Marriott = 'MARRIOTT',
  Other = 'OTHER',
  Radisson = 'RADISSON',
  Wyndham = 'WYNDHAM'
}

export enum CardsMarketplaceOfferCompareCategories {
  AirlineCreditCards = 'AIRLINE_CREDIT_CARDS',
  BadCreditCards = 'BAD_CREDIT_CARDS',
  BalanceTransferCreditCards = 'BALANCE_TRANSFER_CREDIT_CARDS',
  BusinessCreditCards = 'BUSINESS_CREDIT_CARDS',
  CashRewardsCreditCards = 'CASH_REWARDS_CREDIT_CARDS',
  CreditCardBonusOffers = 'CREDIT_CARD_BONUS_OFFERS',
  GasCreditCards = 'GAS_CREDIT_CARDS',
  HotelCreditCards = 'HOTEL_CREDIT_CARDS',
  LowInterestCreditCards = 'LOW_INTEREST_CREDIT_CARDS',
  NwSearch = 'NW_SEARCH',
  PersRecResults = 'PERS_REC_RESULTS',
  RecommendedPlacement = 'RECOMMENDED_PLACEMENT',
  RewardsCreditCards = 'REWARDS_CREDIT_CARDS',
  SecuredCreditCards = 'SECURED_CREDIT_CARDS',
  ShadowCard = 'SHADOW_CARD',
  StudentCreditCards = 'STUDENT_CREDIT_CARDS',
  TheBestCreditCards = 'THE_BEST_CREDIT_CARDS',
  TravelMilesCreditCards = 'TRAVEL_MILES_CREDIT_CARDS',
  ZeroPercentCreditCards = 'ZERO_PERCENT_CREDIT_CARDS'
}

export enum CardsMarketplaceOfferPerks {
  HasCompanionFareAnnualFlight = 'HAS_COMPANION_FARE_ANNUAL_FLIGHT',
  HasFreeAnnualHotelNight = 'HAS_FREE_ANNUAL_HOTEL_NIGHT',
  HasFreeCheckedBags = 'HAS_FREE_CHECKED_BAGS',
  HasAirportLoungeAccess = 'HAS_AIRPORT_LOUNGE_ACCESS',
  HasGlobalentryTsaCredit = 'HAS_GLOBALENTRY_TSA_CREDIT',
  HasPrimaryRentalCarInsurance = 'HAS_PRIMARY_RENTAL_CAR_INSURANCE',
  HasTravelCredits = 'HAS_TRAVEL_CREDITS',
  HasAutomaticEliteStatus = 'HAS_AUTOMATIC_ELITE_STATUS'
}

export enum CardsMarketplaceOfferProcessingNetwork {
  AmericanExpress = 'AMERICAN_EXPRESS',
  Discover = 'DISCOVER',
  Mastercard = 'MASTERCARD',
  Visa = 'VISA'
}

export enum CardsMarketplaceOfferRedemptions {
  RedeemForAmericanAirlines = 'REDEEM_FOR_AMERICAN_AIRLINES',
  RedeemForUnitedAirlines = 'REDEEM_FOR_UNITED_AIRLINES',
  RedeemForDeltaAirlines = 'REDEEM_FOR_DELTA_AIRLINES',
  RedeemForSouthwestAirlines = 'REDEEM_FOR_SOUTHWEST_AIRLINES',
  RedeemForAlaskaAirlines = 'REDEEM_FOR_ALASKA_AIRLINES',
  RedeemForMarriottStarwoodHotel = 'REDEEM_FOR_MARRIOTT_STARWOOD_HOTEL',
  RedeemForHiltonHotel = 'REDEEM_FOR_HILTON_HOTEL',
  RedeemForHyattHotel = 'REDEEM_FOR_HYATT_HOTEL',
  RedeemForMutlipleAirlinesHotels = 'REDEEM_FOR_MUTLIPLE_AIRLINES_HOTELS',
  RedeemForMultipleAirlinesHotels = 'REDEEM_FOR_MULTIPLE_AIRLINES_HOTELS',
  RedeemForStatementCredit = 'REDEEM_FOR_STATEMENT_CREDIT'
}

export enum CardsMarketplaceOfferSignUpBonusType {
  Cash = 'CASH',
  Points = 'POINTS',
  Miles = 'MILES',
  NoRewards = 'NO_REWARDS'
}

export enum CardsMarketplaceOfferRewardCategoriesBestRatesCategory {
  Airfare = 'AIRFARE',
  All = 'ALL',
  Bookstores = 'BOOKSTORES',
  Business = 'BUSINESS',
  CarRental = 'CAR_RENTAL',
  Charity = 'CHARITY',
  Dining = 'DINING',
  Discount = 'DISCOUNT',
  Drugstores = 'DRUGSTORES',
  Entertainment = 'ENTERTAINMENT',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  HomeImprove = 'HOME_IMPROVE',
  Hotel = 'HOTEL',
  Lodging = 'LODGING',
  Movies = 'MOVIES',
  Office = 'OFFICE',
  Other = 'OTHER',
  Parking = 'PARKING',
  Playstation = 'PLAYSTATION',
  Telecom = 'TELECOM',
  Travel = 'TRAVEL',
  Utilities = 'UTILITIES',
  Wireless = 'WIRELESS'
}

export enum CardsMarketplaceOfferPromosType {
  Cash = 'CASH',
  Points = 'POINTS',
  Miles = 'MILES',
  NoRewards = 'NO_REWARDS'
}

export enum CardsMarketplaceOfferRewardsPeriod {
  FirstYear = 'FIRST_YEAR',
  Monthly = 'MONTHLY',
  Quarterly = 'QUARTERLY',
  Yearly = 'YEARLY'
}

export enum CardsMarketplaceOfferRewardsCategory {
  Airfare = 'AIRFARE',
  All = 'ALL',
  Bookstores = 'BOOKSTORES',
  Business = 'BUSINESS',
  CarRental = 'CAR_RENTAL',
  Charity = 'CHARITY',
  Dining = 'DINING',
  Discount = 'DISCOUNT',
  Drugstores = 'DRUGSTORES',
  Entertainment = 'ENTERTAINMENT',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  HomeImprove = 'HOME_IMPROVE',
  Hotel = 'HOTEL',
  Lodging = 'LODGING',
  Movies = 'MOVIES',
  Office = 'OFFICE',
  Other = 'OTHER',
  Parking = 'PARKING',
  Playstation = 'PLAYSTATION',
  Telecom = 'TELECOM',
  Travel = 'TRAVEL',
  Utilities = 'UTILITIES',
  Wireless = 'WIRELESS'
}

export enum CardsMarketplaceOfferRewardsRecommendationCategory {
  All = 'ALL',
  DrugStores = 'DRUG_STORES',
  Entertainment = 'ENTERTAINMENT',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  HomeImprovement = 'HOME_IMPROVEMENT',
  OnlineShopping = 'ONLINE_SHOPPING',
  Restaurants = 'RESTAURANTS',
  Streaming = 'STREAMING',
  Travel = 'TRAVEL'
}

export enum CardsMarketplaceOfferBestOfAwardsCategory {
  Best_0AprCreditCardForPurchases = 'BEST_0_APR_CREDIT_CARD_FOR_PURCHASES',
  Best_0IntroAprAndBalanceTransferCreditCard = 'BEST_0_INTRO_APR_AND_BALANCE_TRANSFER_CREDIT_CARD',
  BestAirlineCreditCard = 'BEST_AIRLINE_CREDIT_CARD',
  BestAllPurposeTravelRewardsCreditCard = 'BEST_ALL_PURPOSE_TRAVEL_REWARDS_CREDIT_CARD',
  BestBalanceTransferCreditCard = 'BEST_BALANCE_TRANSFER_CREDIT_CARD',
  BestBasicTravelRewardsCreditCard = 'BEST_BASIC_TRAVEL_REWARDS_CREDIT_CARD',
  BestCreditCardForBonusCashBack = 'BEST_CREDIT_CARD_FOR_BONUS_CASH_BACK',
  BestCreditCardForBuildingCredit = 'BEST_CREDIT_CARD_FOR_BUILDING_CREDIT',
  BestCreditCardForCollegeStudents = 'BEST_CREDIT_CARD_FOR_COLLEGE_STUDENTS',
  BestCreditCardForDining = 'BEST_CREDIT_CARD_FOR_DINING',
  BestCreditCardForEntertainment = 'BEST_CREDIT_CARD_FOR_ENTERTAINMENT',
  BestCreditCardForGas = 'BEST_CREDIT_CARD_FOR_GAS',
  BestCreditCardForGroceries = 'BEST_CREDIT_CARD_FOR_GROCERIES',
  BestCreditCardForSimpleCashBack = 'BEST_CREDIT_CARD_FOR_SIMPLE_CASH_BACK',
  BestCreditCardForTravelPerks = 'BEST_CREDIT_CARD_FOR_TRAVEL_PERKS',
  BestHotelCreditCard = 'BEST_HOTEL_CREDIT_CARD',
  BestPremiumTravelCreditCard = 'BEST_PREMIUM_TRAVEL_CREDIT_CARD',
  BestSmallBusinessCreditCard = 'BEST_SMALL_BUSINESS_CREDIT_CARD'
}

export type CursorPaginationInput = {
  /** The ID of the item from which pagination should start reading backwards. */
  before?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the item from which pagination should start reading forwards. */
  after?: InputMaybe<Scalars['ID']['input']>;
  /** The number of items to return in the pagination */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * The medium by which notifications are sent to users.
 *
 * Currently only includes NotificationCenter, but may be expanded to include email and/or push, as needed.
 */
export enum NotificationChannelEnum {
  NotificationCenter = 'NOTIFICATION_CENTER'
}

export type NotificationUpdate = {
  __typename?: 'NotificationUpdate';
  /** The type of update (e.g. dismiss, undismiss, mark_as_read, mark_as_unread, pin, unpin) */
  update: Scalars['String']['output'];
  /** The time when this update occurred. */
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationPinDetails = {
  __typename?: 'NotificationPinDetails';
  /**
   * The isPinned flag denotes if a notification has been "pinned" by the user.
   *
   *   A notification can be marked as "pinned" by clicking the pin option in the notification menu.
   */
  isPinned: Scalars['Boolean']['output'];
  /** The time when this update occurred. */
  updatedAt: Scalars['DateTime']['output'];
};

export type NotificationImageDetails = {
  __typename?: 'NotificationImageDetails';
  /** The alternative text to describe the image. */
  altText?: Maybe<Scalars['String']['output']>;
  /** The image source URL from the CDN domain. */
  sourceUrl: Scalars['String']['output'];
};

export enum AppActionTargetType {
  WebLink = 'WEB_LINK',
  Navigation = 'NAVIGATION',
  Billshark = 'BILLSHARK',
  MyBillsSuggested = 'MY_BILLS_SUGGESTED',
  LinkAccount = 'LINK_ACCOUNT',
  LinkHome = 'LINK_HOME',
  SelfReportedIncome = 'SELF_REPORTED_INCOME',
  TuActivation = 'TU_ACTIVATION'
}

/**
 * The type used by Native and Web that describes how to handle a defined action.
 * On Mobile, it allows for a link that could deeplink or fall back to a webview if that deeplink
 * is not supported in the client version of the mobile app.
 * On Web, the action is determined using both targetType and the target.
 */
export type AppAction = {
  __typename?: 'AppAction';
  /** A string that describes the type of action (used for analytics). */
  name?: Maybe<Scalars['String']['output']>;
  /** The user-facing copy on the action button/link */
  text: Scalars['String']['output'];
  /** A NerdWallet mobile app deep link */
  mobileTarget?: Maybe<Scalars['String']['output']>;
  /** Typically a web URL. If mobileTarget is not specified or invalid, this will open in a webview. */
  target?: Maybe<Scalars['String']['output']>;
  /** A string that tells the client how to handle this action. Only used on Web. */
  targetType?: Maybe<AppActionTargetType>;
  /** Indicates whether the provided target is a place where the user can fulfill the described action */
  leadsToUserActionFulfillment?: Maybe<Scalars['Boolean']['output']>;
};

/** Notifications contain actionable information relevent to the user that NerdWallet sends via a notification channel. */
export type Notification = {
  __typename?: 'Notification';
  /** The action to be performed in the app when the user engages with the notification (CTA that navigates to L1, L2). */
  action?: Maybe<AppAction>;
  /**
   * The user-facing copy that describes the notification.
   *
   *   This is *not* the CTA text -- that should be supplied in action.text
   */
  body?: Maybe<Scalars['String']['output']>;
  /** The name of the CRM campaign ID this notification belongs to. */
  campaignId?: Maybe<Scalars['String']['output']>;
  /** The name of the CRM campaign this notification belongs to. */
  campaignName?: Maybe<Scalars['String']['output']>;
  /** The creation time in UTC of the notification. */
  createdAt: Scalars['DateTime']['output'];
  /**
   * The primary identifier for the notification.
   *
   *   Primarily used for interacting with the API - id will now match the "newest" and "oldest" fields.
   */
  id: Scalars['ID']['output'];
  /** The isDismissed flag denotes if a notification has been "dismissed" by the user. */
  isDismissed: Scalars['Boolean']['output'];
  /**
   * The isRead flag denotes if a notification has been "read" by the user.
   *
   *   A notification can be marked as "read" by interacting with the CTA, or manually by the user.
   */
  isRead: Scalars['Boolean']['output'];
  /** The pin status and time when this update occurred. */
  pinDetails?: Maybe<NotificationPinDetails>;
  /**
   * A human-readable identifier for a particular notification.
   *
   *   Note that the slug field is the same across all instances of a particular notification (whereas the id field is unique).
   */
  slug?: Maybe<Scalars['String']['output']>;
  /** The ID of the CRM template used for this notification. */
  templateId?: Maybe<Scalars['String']['output']>;
  /** The name of the CRM template used for this notification. */
  templateName?: Maybe<Scalars['String']['output']>;
  /** The update history of a notification. */
  updates?: Maybe<Array<NotificationUpdate>>;
  /** The image details for the notification. */
  imageDetails?: Maybe<NotificationImageDetails>;
};

export type NotificationsInput = {
  /** Specifies the channel of notifications to retrieve from */
  channel: NotificationChannelEnum;
  /**
   * The Identity ID to fetch notifications for (for admin use).
   *   If the ID isn't the same as the requesting user's ID, some fields will not be available.
   */
  identityId?: InputMaybe<Scalars['ID']['input']>;
  /** Whether to include notifications that have been dismissed by the user. */
  includeDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Contains parameters that assist with pagination, such as: after, before, limit. */
  pagination?: InputMaybe<CursorPaginationInput>;
};

export type GetNotificationsResponse = {
  __typename?: 'GetNotificationsResponse';
  /** List of notifications in reverse chronological order. */
  items?: Maybe<Array<Notification>>;
  /** The newest notification ID is used as the "after" value in subsequent queries. */
  newest?: Maybe<Scalars['ID']['output']>;
  /** The oldest notification ID is used as the "before" value in subsequent queries. */
  oldest?: Maybe<Scalars['ID']['output']>;
  /** The number of unread notifications for the user. */
  unreadCount?: Maybe<Scalars['Int']['output']>;
};

export type MarkNotificationAsReadResponse = {
  __typename?: 'MarkNotificationAsReadResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int']['output'];
  /** The updated notification that has been marked as read. */
  item: Notification;
};

export type MarkNotificationAsUnreadResponse = {
  __typename?: 'MarkNotificationAsUnreadResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int']['output'];
  /** The updated notification that has been marked as unread. */
  item: Notification;
};

export type MarkNotificationAsPinnedResponse = {
  __typename?: 'MarkNotificationAsPinnedResponse';
  /** The updated notification that has been marked as pinned. */
  item: Notification;
};

export type MarkNotificationAsUnpinnedResponse = {
  __typename?: 'MarkNotificationAsUnpinnedResponse';
  /** The updated notification that has been marked as unpinned. */
  item: Notification;
};

export type MarkNotificationAsDismissedResponse = {
  __typename?: 'MarkNotificationAsDismissedResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int']['output'];
  /** The updated notification that has been marked as dismissed. */
  item: Notification;
};

export type MarkNotificationAsUndismissedResponse = {
  __typename?: 'MarkNotificationAsUndismissedResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int']['output'];
  /** The updated notification that has been marked as undismissed. */
  item: Notification;
};

export type BulkActionResponse = {
  __typename?: 'BulkActionResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int']['output'];
  /** The updated state of notifications visible to the user. */
  items: Array<Notification>;
};

export type BulkDismissResponse = {
  __typename?: 'BulkDismissResponse';
  /** The updated number of unread notifications for the user. */
  unreadCount: Scalars['Int']['output'];
  /** The operation id associated with the request. */
  operationId: Scalars['String']['output'];
  /** The updated state of notifications visible to the user. */
  items: Array<Notification>;
};

export type BulkActionInput = {
  /** The IDs visible to the user. */
  track: Array<Scalars['ID']['input']>;
  /** The ID before which to perform the action (inclusive). */
  beforeInclusive?: InputMaybe<Scalars['ID']['input']>;
};

export type UndoBulkActionInput = {
  /** The IDs visible to the user. */
  track: Array<Scalars['ID']['input']>;
  /** The operation ID of the bulk action to undo. */
  operationId: Scalars['ID']['input'];
};

export type SaveBrowserTokenResponse = {
  __typename?: 'SaveBrowserTokenResponse';
  /** Identity email for the user */
  id: Scalars['EmailAddress']['output'];
  /** Denotes whether or not the user's browser token was successfully registered for Web push notifications */
  success: Scalars['Boolean']['output'];
};

export type TrackWebPushClickResponse = {
  __typename?: 'TrackWebPushClickResponse';
  /** Denotes whether or not the user's Web Push notification click was successfully tracked */
  success: Scalars['Boolean']['output'];
};

export enum Link__Purpose {
  /** `SECURITY` features provide metadata necessary to securely resolve fields. */
  Security = 'SECURITY',
  /** `EXECUTION` features provide metadata necessary for operation execution. */
  Execution = 'EXECUTION'
}

export type InvestingRoundup = {
  __typename?: 'InvestingRoundup';
  /** The title of the roundup */
  title?: Maybe<Scalars['String']['output']>;
};

export enum ColumnTaxInformationDisclosureConsentStatusEnum {
  Consented = 'CONSENTED',
  NotConsented = 'NOT_CONSENTED'
}

export enum ColumnTaxFilingStatusEnum {
  NotStarted = 'NOT_STARTED',
  Started = 'STARTED',
  Submitted = 'SUBMITTED'
}

export type ColumnTaxTaxReturn = {
  __typename?: 'ColumnTaxTaxReturn';
  /** The status of the tax return */
  status: ColumnTaxFilingStatusEnum;
  /** The status of the user's information disclosure consent */
  informationDisclosureConsentStatus: ColumnTaxInformationDisclosureConsentStatusEnum;
  /** The filing year of the tax return */
  taxYear: Scalars['Int']['output'];
};

export type ColumnTaxUserInformation = {
  __typename?: 'ColumnTaxUserInformation';
  /** The Column Tax user's tax returns information */
  taxReturns?: Maybe<Array<ColumnTaxTaxReturn>>;
  /** The Column Tax user */
  userId: Scalars['ID']['output'];
  /** The current, unexpired URL for the user to access the Column Tax module */
  userUrl: Scalars['String']['output'];
};


export type ColumnTaxUserInformationTaxReturnsArgs = {
  taxYear?: InputMaybe<Scalars['String']['input']>;
};

export enum ChatMessageSenderRole {
  User = 'USER',
  Assistant = 'ASSISTANT',
  System = 'SYSTEM'
}

export enum ChatSendFailureReason {
  ServerError = 'SERVER_ERROR',
  NoContent = 'NO_CONTENT',
  OpenaiRateLimit = 'OPENAI_RATE_LIMIT',
  OpenaiTimeout = 'OPENAI_TIMEOUT',
  InappropriateContentFlagged = 'INAPPROPRIATE_CONTENT_FLAGGED',
  KeywordFlagged = 'KEYWORD_FLAGGED',
  TokenLimitExceeded = 'TOKEN_LIMIT_EXCEEDED',
  NotFinanceRelated = 'NOT_FINANCE_RELATED',
  AnswerKeywordFlagged = 'ANSWER_KEYWORD_FLAGGED',
  MfiServiceError = 'MFI_SERVICE_ERROR'
}

export enum AnswerSource {
  Gpt = 'GPT',
  Faq = 'FAQ',
  Scr = 'SCR',
  Agq = 'AGQ',
  Mfi = 'MFI'
}

export enum ContentFormat {
  String = 'String',
  StructuredContent = 'StructuredContent',
  Json = 'JSON'
}

export type ChatBotConversation = {
  /** A uuid which identifies this session. If left any one will be generated for you and returned with the response. Make sure to pass that in with consecutive requests. */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /**
   * The model used for the completion request
   *   https://platform.openai.com/docs/models/model-endpoint-compatibility
   */
  model?: InputMaybe<Scalars['String']['input']>;
  /** The message history, limit to aroud 12 */
  messages?: InputMaybe<Array<InputMaybe<ChatBotMessage>>>;
  /** What sampling temperature to use, between 0 and 2. Higher values like 0.8 will make the output more random, while lower values like 0.2 will make it more focused and deterministic. */
  temperature?: InputMaybe<Scalars['Float']['input']>;
  /**
   * The maximum number of tokens to generate in the chat completion. The total length of input tokens and generated tokens is limited by the model's context length.
   *   https://platform.openai.com/tokenizer
   */
  maxTokens?: InputMaybe<Scalars['Int']['input']>;
  /**
   * Number between -2.0 and 2.0. Positive values penalize new tokens based on whether they appear in the text so far, increasing the model's likelihood to talk about new topics.
   *   https://platform.openai.com/docs/api-reference/parameter-details
   */
  presencePenalty?: InputMaybe<Scalars['Float']['input']>;
  /**
   * Number between -2.0 and 2.0. Positive values penalize new tokens based on their existing frequency in the text so far, decreasing the model's likelihood to repeat the same line verbatim.
   *   https://platform.openai.com/docs/api-reference/parameter-details
   */
  frequencyPenalty?: InputMaybe<Scalars['Float']['input']>;
  /** A unique identifier representing your end-user, which can help OpenAI to monitor and detect abuse. */
  user?: InputMaybe<Scalars['String']['input']>;
  /** Min match score to for results from the vector db, default is no minimum */
  minMatchScore?: InputMaybe<Scalars['Float']['input']>;
  /** The max number of FAQs to include, default is 7 */
  numFAQsToInclude?: InputMaybe<Scalars['Int']['input']>;
  /** The max number of related links to include, default is 3 */
  relatedLinkCount?: InputMaybe<Scalars['Int']['input']>;
  /** Optional content specifically for handling summarization of articles or other larger blobs of text */
  contentForSummarization?: InputMaybe<Scalars['String']['input']>;
  /** The content id of an article */
  contentId?: InputMaybe<Scalars['Int']['input']>;
  /** The url of the page */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Number of successfull interactions the user has had with the bot, we need this because the messages is always trimmed to a limit */
  interactions?: InputMaybe<Scalars['Int']['input']>;
  /** When set true this request will be routed to the MFI service so the user can ask questions about their financial data */
  useMyFinancialInsights?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ChatBotMessage = {
  /** The role of the sender */
  role?: InputMaybe<ChatMessageSenderRole>;
  /** The content of the message */
  content?: InputMaybe<Scalars['String']['input']>;
  /** Timestamp of the message in UTC */
  timestamp?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContentZone {
  PrimaryResponse = 'PrimaryResponse',
  SecondaryResponse = 'SecondaryResponse',
  SuggestedPrompts = 'SuggestedPrompts',
  RelatedLinks = 'RelatedLinks'
}

export type ReplyContent = {
  __typename?: 'ReplyContent';
  /** The zone this part of the response is for */
  zone?: Maybe<ContentZone>;
  /** The type of content this zone */
  contentFormat?: Maybe<ContentFormat>;
  /** The content response */
  content?: Maybe<Scalars['JSON']['output']>;
  /** The plain text version of the content (optional) */
  plainTextContent?: Maybe<Scalars['String']['output']>;
  /** Where the answer came from */
  answerSource?: Maybe<AnswerSource>;
};

export type ChatBotReply = {
  __typename?: 'ChatBotReply';
  /** A uuid which identifies this session. If one was passed into the request, it's returned here. If no sessionId was passed into the request this one was generated for you. Make sure to pass that in with consecutive requests. */
  sessionId?: Maybe<Scalars['String']['output']>;
  /** The id of the request */
  id?: Maybe<Scalars['String']['output']>;
  /** The role of who's replying */
  role?: Maybe<Scalars['String']['output']>;
  /** The replies we're returning */
  replies?: Maybe<Array<Maybe<ReplyContent>>>;
  /** The OpenAI model used */
  model?: Maybe<Scalars['String']['output']>;
  /** How many tokens were used for the prompt */
  promptTokens?: Maybe<Scalars['Int']['output']>;
  /** How many tokens were used for the response */
  completionTokens?: Maybe<Scalars['Int']['output']>;
  /** How many tokens were used in total */
  totalTokens?: Maybe<Scalars['Int']['output']>;
  /** Specifies the reason for a failure if any, empty if there were no problems */
  failureReason?: Maybe<ChatSendFailureReason>;
  /** Where the answer came from */
  answerSource?: Maybe<AnswerSource>;
};

export type ChatBotModel = {
  __typename?: 'ChatBotModel';
  id?: Maybe<Scalars['String']['output']>;
  object?: Maybe<Scalars['String']['output']>;
  ownedBy?: Maybe<Scalars['String']['output']>;
  created?: Maybe<Scalars['Int']['output']>;
  root?: Maybe<Scalars['String']['output']>;
};

export type RelatedLink = {
  __typename?: 'RelatedLink';
  /** The title of the link */
  title?: Maybe<Scalars['String']['output']>;
  /** The url of th link */
  url?: Maybe<Scalars['String']['output']>;
  /** The match score from pinecone */
  score?: Maybe<Scalars['Float']['output']>;
  /** The wordpress page id of the link */
  pageId?: Maybe<Scalars['Int']['output']>;
};

export type FeedbackReason = {
  __typename?: 'FeedbackReason';
  /** The 3 character code for the feedback reason */
  id?: Maybe<Scalars['String']['output']>;
  /** The client facing text for the feedback reason */
  description?: Maybe<Scalars['String']['output']>;
  /** The type of feedback this reason belongs to */
  type?: Maybe<FeedbackType>;
};

export type FaqPlainText = {
  __typename?: 'FAQPlainText';
  question?: Maybe<Scalars['String']['output']>;
  answer?: Maybe<Scalars['String']['output']>;
};

export type ArticlePlainText = {
  __typename?: 'ArticlePlainText';
  /** The full article in plaintext */
  fullArticle?: Maybe<Scalars['String']['output']>;
  /** The split up chunks for an article */
  chunks?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** FAQs for an article */
  faqs?: Maybe<Array<Maybe<FaqPlainText>>>;
  /** Suggested prompts for the user to choose from */
  suggestedPrompts?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type ScriptedQuestionInput = {
  /** The question */
  content: Scalars['String']['input'];
  /** The ID of the question */
  id?: InputMaybe<Scalars['String']['input']>;
  /** A number 0 to 1 (1 being an exact match) that will match the user's question to this one. */
  similarity: Scalars['Float']['input'];
  /** This should be the ID of the Redis object. If no answer is found, fallback to an normal AI response flow. */
  answerId?: InputMaybe<Scalars['String']['input']>;
  /** Name of the owning team */
  ownedBy?: InputMaybe<Scalars['String']['input']>;
  /** should use the same categories we track elsewhere in the subgraph */
  categories?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

export type ScriptedQuestion = {
  __typename?: 'ScriptedQuestion';
  /** The question */
  content?: Maybe<Scalars['String']['output']>;
  /** The ID of the question */
  id?: Maybe<Scalars['String']['output']>;
  /** A number 0 to 1 (1 being an exact match) that will match the user's question to this one. */
  similarity?: Maybe<Scalars['Float']['output']>;
  /** This should be the ID of the Redis object. If no answer is found, fallback to an normal AI response flow. */
  answerId?: Maybe<Scalars['String']['output']>;
  /** Name of the owning team */
  ownedBy?: Maybe<Scalars['String']['output']>;
  /** should use the same categories we track elsewhere in the subgraph */
  categories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The source type */
  sourceType?: Maybe<Scalars['String']['output']>;
  /** The vector for the question */
  vector?: Maybe<Array<Maybe<Scalars['Float']['output']>>>;
};

export type ScriptedAnswerInput = {
  /** The ID of the answer */
  id?: InputMaybe<Scalars['String']['input']>;
  /** The content of the answer, either a string or a StructuredContentDocument */
  content: Scalars['JSON']['input'];
  /** The type of content in the content */
  contentFormat: ContentFormat;
  /** True includes an AI response before the answer */
  aiResponse: Scalars['Boolean']['input'];
  /** Questions to show as suggestions. Used to build a chain of questions and answers. */
  followupQuestionIds?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** If true, show followup suggestion prompts */
  showSuggestionPrompts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Name of the owning team */
  ownedBy?: InputMaybe<Scalars['String']['input']>;
  /** A textual description of the answer to help OpenAI with context */
  structuredContentContext?: InputMaybe<Scalars['String']['input']>;
};

export type ScriptedAnswer = {
  __typename?: 'ScriptedAnswer';
  /** The ID of the answer */
  id?: Maybe<Scalars['String']['output']>;
  /** The content of the answer, either a string or a StructuredContentDocument */
  content?: Maybe<Scalars['JSON']['output']>;
  /** True includes an AI response before the answer */
  aiResponse?: Maybe<Scalars['Boolean']['output']>;
  /** Questions to show as suggestions. Used to build a chain of questions and answers. */
  followupQuestionIds?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** If true, show followup suggestion prompts */
  showSuggestionPrompts?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the owning team */
  ownedBy?: Maybe<Scalars['String']['output']>;
  /** The source type */
  sourceType?: Maybe<Scalars['String']['output']>;
  /** The type of content in the content */
  contentFormat?: Maybe<ContentFormat>;
  /** A textual description of the answer to help OpenAI with context */
  structuredContentContext?: Maybe<Scalars['String']['output']>;
};

export enum FeedbackType {
  Positive = 'Positive',
  Negative = 'Negative'
}

export type Feedback = {
  /** The session id for the current chat session */
  sessionId?: InputMaybe<Scalars['String']['input']>;
  /** The question text the user is providing feedback about */
  question?: InputMaybe<Scalars['String']['input']>;
  /** The answer text the user is providing feedback about */
  answer?: InputMaybe<Scalars['String']['input']>;
  /** The type of feedback, positive or negative */
  type?: InputMaybe<FeedbackType>;
  /** The list of reasons they're providing feedback */
  reasons?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Optional comments about their experience */
  comments?: InputMaybe<Scalars['String']['input']>;
};

export type SendFeedbackResponse = {
  __typename?: 'SendFeedbackResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
};

export type UpdateAiDataResponse = {
  __typename?: 'UpdateAIDataResponse';
  id?: Maybe<Scalars['String']['output']>;
  source?: Maybe<AiDataSource>;
  action?: Maybe<AiDataAction>;
  success?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export enum AiDataSource {
  Wordpress = 'WORDPRESS'
}

export enum AiDataAction {
  Update = 'UPDATE',
  Delete = 'DELETE',
  UpdateAgqs = 'UPDATE_AGQS'
}

export type CostOfLivingCityFields = {
  slug: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  state_abbr: Scalars['String']['output'];
  has_city_life_data: Scalars['Boolean']['output'];
  photo?: Maybe<Scalars['String']['output']>;
  suggested_ranking?: Maybe<Scalars['Int']['output']>;
  milk_cost?: Maybe<Scalars['Float']['output']>;
  eggs_cost?: Maybe<Scalars['Float']['output']>;
  bread_cost?: Maybe<Scalars['Float']['output']>;
  apt_rent_cost?: Maybe<Scalars['Float']['output']>;
  home_cost?: Maybe<Scalars['Float']['output']>;
  mortgage_plus_interest_cost?: Maybe<Scalars['Float']['output']>;
  gas_cost?: Maybe<Scalars['Float']['output']>;
  optometrist_cost?: Maybe<Scalars['Float']['output']>;
  doctor_cost?: Maybe<Scalars['Float']['output']>;
  dentist_cost?: Maybe<Scalars['Float']['output']>;
  lipitor_cost?: Maybe<Scalars['Float']['output']>;
  quarter_pounder_cost?: Maybe<Scalars['Float']['output']>;
  pizza_cost?: Maybe<Scalars['Float']['output']>;
  movie_cost?: Maybe<Scalars['Float']['output']>;
  yoga_cost?: Maybe<Scalars['Float']['output']>;
  heineken_cost?: Maybe<Scalars['Float']['output']>;
  composite_index?: Maybe<Scalars['Float']['output']>;
  grocery_index?: Maybe<Scalars['Float']['output']>;
  housing_index?: Maybe<Scalars['Float']['output']>;
  utilities_index?: Maybe<Scalars['Float']['output']>;
  transportation_index?: Maybe<Scalars['Float']['output']>;
  healthcare_index?: Maybe<Scalars['Float']['output']>;
  misc_index?: Maybe<Scalars['Float']['output']>;
  ranking?: Maybe<Scalars['Float']['output']>;
  greatschools_rating?: Maybe<Scalars['Float']['output']>;
};

export type CityLifeFieldDetails = {
  __typename?: 'CityLifeFieldDetails';
  id?: Maybe<Scalars['String']['output']>;
  field?: Maybe<Scalars['String']['output']>;
  national_average?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type CityLifePage = {
  __typename?: 'CityLifePage';
  id: Scalars['ID']['output'];
};

export type UdpHealthCheck = {
  __typename?: 'UDPHealthCheck';
  status: Scalars['String']['output'];
};

/** Pre Fill Input options */
export type PreFillInput = {
  /** The anonymous_id of the user to prefill the form for */
  anonymousId: Scalars['String']['input'];
  /** Input used for tracking and instrumentation */
  trackingInput: TrackingInput;
};

/**
 * Pre Fill Tracking Input,
 * see https://nerdwallet.atlassian.net/wiki/spaces/PEDD/pages/2977431926/Pre-Fill+Instrumentation+Thought for more information
 */
export type TrackingInput = {
  /** The name of the service calling this query */
  callerDeployableName: Scalars['String']['input'];
  /** The version of the service calling this query */
  callerDeployableVersion: Scalars['String']['input'];
  /** The name of the form or flow that is being pre-filled, Example `ai_prefill_application` */
  formName: Scalars['String']['input'];
  /** The vertical of the form or flow that is being pre-filled, Example `auto_insurance` */
  vertical: Scalars['String']['input'];
  /** Optional field, for a multi part flow (such as our Auto Insurance flow), the name of the screen that is being pre-filled, Example `ai_prefill_applicant_birthdate */
  screenName?: InputMaybe<Scalars['String']['input']>;
  /** Optional field, for the specific structured-content component name */
  scComponentName?: InputMaybe<Scalars['String']['input']>;
  /** Optional field, A dictionary of additional non standard attributes such as `parent_event_id` or `pageview_id` */
  additionalAttributes?: InputMaybe<Scalars['JSON']['input']>;
  /** Optional field, A string containing the business use case for prefilling */
  businessUseCase?: InputMaybe<Scalars['JSON']['input']>;
};

/** Available Pre Fill fields */
export type PreFillFields = {
  __typename?: 'PreFillFields';
  /** Annual Income for the specified user */
  annualIncome?: Maybe<AnnualIncome>;
  /** Age of the specified user */
  age?: Maybe<Age>;
  /** Zip code of the specified user's residence for US users only */
  zipCode?: Maybe<ZipCode>;
};

export type BaseField = {
  /** Value of the field */
  value?: Maybe<Scalars['String']['output']>;
};

export type CurrentMortgageRates = {
  __typename?: 'CurrentMortgageRates';
  date?: Maybe<Scalars['String']['output']>;
  arm_5_1?: Maybe<Scalars['Float']['output']>;
  fixed_15?: Maybe<Scalars['Float']['output']>;
  fixed_30?: Maybe<Scalars['Float']['output']>;
  excerpt?: Maybe<Scalars['String']['output']>;
};

export type HistoricalRate = {
  __typename?: 'HistoricalRate';
  date?: Maybe<Scalars['String']['output']>;
  fixed_10?: Maybe<Scalars['Float']['output']>;
  fixed_15?: Maybe<Scalars['Float']['output']>;
  fixed_15_jumbo?: Maybe<Scalars['Float']['output']>;
  fixed_20?: Maybe<Scalars['Float']['output']>;
  fixed_30?: Maybe<Scalars['Float']['output']>;
  fixed_30_fha?: Maybe<Scalars['Float']['output']>;
  fixed_30_jumbo?: Maybe<Scalars['Float']['output']>;
  fixed_30_va?: Maybe<Scalars['Float']['output']>;
  arm_10_1?: Maybe<Scalars['Float']['output']>;
  arm_3_1?: Maybe<Scalars['Float']['output']>;
  arm_5_1?: Maybe<Scalars['Float']['output']>;
  arm_5_1_jumbo?: Maybe<Scalars['Float']['output']>;
  arm_7_1?: Maybe<Scalars['Float']['output']>;
};

export type HistoricalMortgageRates = {
  __typename?: 'HistoricalMortgageRates';
  yearly?: Maybe<HistoricalRate>;
  today?: Maybe<HistoricalRate>;
  yesterday?: Maybe<HistoricalRate>;
  weekly?: Maybe<HistoricalRate>;
  aprs?: Maybe<HistoricalRate>;
  interestRates?: Maybe<HistoricalRate>;
  rates?: Maybe<Array<Maybe<HistoricalRate>>>;
};

export type CountyHousingCharacteristics = {
  __typename?: 'CountyHousingCharacteristics';
  name?: Maybe<Scalars['String']['output']>;
  medianHomeValue?: Maybe<Scalars['Float']['output']>;
  propertyTaxRate?: Maybe<Scalars['Float']['output']>;
};

export type StateHousingCharacteristics = {
  __typename?: 'StateHousingCharacteristics';
  counties?: Maybe<Array<Maybe<CountyHousingCharacteristics>>>;
  source?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export enum PersonalizedOfferCategory {
  Travel = 'TRAVEL',
  Rewards = 'REWARDS',
  DebtPayoff = 'DEBT_PAYOFF',
  MajorPurchase = 'MAJOR_PURCHASE',
  BuildCredit = 'BUILD_CREDIT',
  CashBack = 'CASH_BACK',
  Student = 'STUDENT',
  FairCredit = 'FAIR_CREDIT',
  Business = 'BUSINESS',
  BestOffers = 'BEST_OFFERS',
  Airline = 'AIRLINE',
  NoForeignTransactionFee = 'NO_FOREIGN_TRANSACTION_FEE',
  ZeroPercent = 'ZERO_PERCENT'
}

export enum ApprovalLikelihood {
  PreQualified = 'PRE_QUALIFIED',
  PreApproved = 'PRE_APPROVED',
  PreSelected = 'PRE_SELECTED',
  OutstandingAo = 'OUTSTANDING_AO',
  ExcellentAo = 'EXCELLENT_AO',
  GoodAo = 'GOOD_AO',
  FairAo = 'FAIR_AO',
  PoorAo = 'POOR_AO'
}

export enum UserCardsConsentStatus {
  Consented = 'CONSENTED',
  Rejected = 'REJECTED',
  Revoked = 'REVOKED'
}

export type CardsConsent = {
  __typename?: 'CardsConsent';
  status: UserCardsConsentStatus;
  dateCreated: Scalars['String']['output'];
  dateUpdated: Scalars['String']['output'];
};

export type PersonalizedOffers = {
  __typename?: 'PersonalizedOffers';
  crinkoRequestID: Scalars['ID']['output'];
  categories?: Maybe<Array<Maybe<CategorizedOffers>>>;
};


export type PersonalizedOffersCategoriesArgs = {
  in?: InputMaybe<Array<InputMaybe<PersonalizedOfferCategory>>>;
};

export type CategorizedOffers = {
  __typename?: 'CategorizedOffers';
  category?: Maybe<PersonalizedOfferCategory>;
  offers: Array<Maybe<CreditCardsOfferV2>>;
};

export type CrinkoDetails = {
  __typename?: 'CrinkoDetails';
  crinkoID: Scalars['String']['output'];
  destinationUrl: Scalars['String']['output'];
  /** @deprecated Use chosenApprovalLikelihood instead */
  approvalLikelihood?: Maybe<ApprovalLikelihood>;
  chosenApprovalLikelihood?: Maybe<ApprovalLikelihood>;
};

/** Information on the user's Accounts */
export type UserAccountInformation = {
  __typename?: 'UserAccountInformation';
  /** The user's identity ID */
  userId: Scalars['ID']['output'];
  /** The date the user's application was approved */
  dateApproved?: Maybe<Scalars['String']['output']>;
  graduationOffers?: Maybe<PersonalizedOffers>;
  /** Information on the user's credit account */
  creditAccount?: Maybe<CreditAccountData>;
  /** Information on the user's security deposit account */
  securityDepositAccount?: Maybe<SecurityDepositAccountData>;
};

export type ExperimentDecision = {
  __typename?: 'ExperimentDecision';
  /** The name of the experiment. */
  experimentName: Scalars['String']['output'];
  /**
   * The name of the variant the requesting user is bucketed into. If the given experimentName is not found,
   *   this value is empty. This is different from a valid default variant, which is usually called 'control'.
   */
  assignedVariantName: Scalars['String']['output'];
  /**
   * The UUIDs of the MODEL_EXECUTED events associated with this decision.
   *   These should be used in downstream event headers; for more details
   *   see: https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/model_executed.yaml
   */
  modelExecutionIds: Array<Scalars['ID']['output']>;
  /**
   * Optional field that contains information about the bucketing decision. For example, if the user was force bucketed,
   *   or didn't meet the audience condition
   */
  message?: Maybe<Scalars['String']['output']>;
};

export type AbSmartlyFeatureFlag = {
  __typename?: 'ABSmartlyFeatureFlag';
  /** The name of the feature flag. */
  flagName: Scalars['String']['output'];
  /** If the Feature Flag is enabled or not. */
  enabled: Scalars['Boolean']['output'];
  /**
   * Optional field that contains information about the bucketing decision. For example, if the user was force bucketed,
   *   or didn't meet the audience condition
   */
  message?: Maybe<Scalars['String']['output']>;
  /** Optional field that contains Extra JSON Data */
  extraData?: Maybe<Scalars['JSON']['output']>;
  /** If the decision was forced or not */
  isForced: Scalars['Boolean']['output'];
  /** If the extra data was forced or not */
  isForcedExtraData: Scalars['Boolean']['output'];
};

export type FeatureFlag = {
  __typename?: 'FeatureFlag';
  /** The name of the feature flag */
  name: Scalars['String']['output'];
  /**
   * The value of the feature flag.
   *   This accounts for values forced using a request header or query param on the originating URL of the form \`feat_[featurename]=[true|false]\`
   */
  value: Scalars['Boolean']['output'];
  /**
   * Extra feature data
   *   This accounts for values forced using a request header or query param on the originating URL of the form \`feat_[featurename]_data=<stringified_json>\`
   */
  extraData?: Maybe<Scalars['JSON']['output']>;
  /**
   * Is the value or extraData forced.
   *   values can be forced using a request header or query param on the originating URL of the form \`feat_[featurename]=[true|false]\`
   *   extraData can be forced using a request header or query param on the originating URL of the form \`feat_[featurename]_data=<stringified_json>\`
   */
  isForced: Scalars['Boolean']['output'];
};

export type TrackEventInput = {
  eventKey: Scalars['String']['input'];
  userAttributes?: InputMaybe<Scalars['JSON']['input']>;
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  uidType?: InputMaybe<Scalars['String']['input']>;
  vendor?: InputMaybe<Scalars['String']['input']>;
};

export type MediaAlphaHomeInsuranceUserData = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
  birth_date?: InputMaybe<Scalars['Date']['input']>;
  contact?: InputMaybe<Scalars['String']['input']>;
  continuous_coverage?: InputMaybe<Scalars['Int']['input']>;
  credit_rating?: InputMaybe<Scalars['String']['input']>;
  current_company?: InputMaybe<Scalars['String']['input']>;
  current_policy_expires?: InputMaybe<Scalars['Int']['input']>;
  currently_insured?: InputMaybe<Scalars['Int']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  gender?: InputMaybe<Scalars['String']['input']>;
  leadid_id?: InputMaybe<Scalars['String']['input']>;
  married?: InputMaybe<Scalars['Int']['input']>;
  mediaalpha_certificate_id?: InputMaybe<Scalars['String']['input']>;
  phone?: InputMaybe<Scalars['String']['input']>;
  claims?: InputMaybe<Scalars['Int']['input']>;
  properties?: InputMaybe<Array<MediaAlphaProperty>>;
};

export type MediaAlphaProperty = {
  address?: InputMaybe<Scalars['String']['input']>;
  address_2?: InputMaybe<Scalars['String']['input']>;
  central_air_conditioning?: InputMaybe<Scalars['Int']['input']>;
  construction?: InputMaybe<Scalars['String']['input']>;
  copper_water_pipes?: InputMaybe<Scalars['Int']['input']>;
  coverage_amount?: InputMaybe<Scalars['String']['input']>;
  covered_deck?: InputMaybe<Scalars['Int']['input']>;
  deadbolt_locks?: InputMaybe<Scalars['Int']['input']>;
  deductible?: InputMaybe<Scalars['String']['input']>;
  earthquake?: InputMaybe<Scalars['Int']['input']>;
  electrical?: InputMaybe<Scalars['String']['input']>;
  fire_extinguisher?: InputMaybe<Scalars['Int']['input']>;
  fire_hydrant_within_1000_ft?: InputMaybe<Scalars['Int']['input']>;
  fireplace?: InputMaybe<Scalars['Int']['input']>;
  flood?: InputMaybe<Scalars['Int']['input']>;
  foundation?: InputMaybe<Scalars['String']['input']>;
  garage?: InputMaybe<Scalars['String']['input']>;
  in_ground_swimming_pool?: InputMaybe<Scalars['Int']['input']>;
  indoor_sprinklers?: InputMaybe<Scalars['Int']['input']>;
  liability_coverage_amount?: InputMaybe<Scalars['String']['input']>;
  manned_fire_station_within_5_mi?: InputMaybe<Scalars['Int']['input']>;
  new_purchase?: InputMaybe<Scalars['Int']['input']>;
  num_bathrooms?: InputMaybe<Scalars['Float']['input']>;
  num_bedrooms?: InputMaybe<Scalars['Int']['input']>;
  num_stories?: InputMaybe<Scalars['String']['input']>;
  occupancy?: InputMaybe<Scalars['String']['input']>;
  property_type?: InputMaybe<Scalars['String']['input']>;
  roof?: InputMaybe<Scalars['String']['input']>;
  roof_age?: InputMaybe<Scalars['Int']['input']>;
  security?: InputMaybe<Scalars['String']['input']>;
  smoke_alarm?: InputMaybe<Scalars['Int']['input']>;
  smoker_in_household?: InputMaybe<Scalars['Int']['input']>;
  square_footage?: InputMaybe<Scalars['Int']['input']>;
  swimming_pool_is_fenced?: InputMaybe<Scalars['Int']['input']>;
  uncovered_deck?: InputMaybe<Scalars['Int']['input']>;
  woodburning_stove?: InputMaybe<Scalars['Int']['input']>;
  year_built?: InputMaybe<Scalars['Int']['input']>;
  zip?: InputMaybe<Scalars['String']['input']>;
};

export type IntakeAddressModel = {
  lineOne: Scalars['String']['input'];
  lineTwo?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  stateAbbreviation: UsState;
  zipCode: Scalars['String']['input'];
};

export type IntakePrimaryApplicantModel = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
};

export type IntakePrimaryApplicantModelWithPhone = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  phone: Scalars['String']['input'];
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
};

export type EvertreePrimaryApplicantInput = {
  firstName: Scalars['String']['input'];
  lastName: Scalars['String']['input'];
  email: Scalars['String']['input'];
  mobilePhoneNumber?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
};

export enum LinesOfBusiness {
  Auto = 'Auto',
  Home = 'Home'
}

export type EvertreeResponse = EvertreeSuccessResponse | EvertreeErrorResponse;

export type EvertreeSuccessResponse = {
  __typename?: 'EvertreeSuccessResponse';
  id?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  shoppingFinishId?: Maybe<Scalars['String']['output']>;
};

export type EvertreeErrorResponse = {
  __typename?: 'EvertreeErrorResponse';
  type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  instance?: Maybe<Scalars['String']['output']>;
};

export type AirData = {
  alignedCreditScore?: InputMaybe<AlignedCreditScore>;
  ageOfDriver?: InputMaybe<Scalars['Int']['input']>;
  usState: UsState;
  coverageType?: InputMaybe<CoverageType>;
  drivingRecord?: InputMaybe<DrivingRecord>;
  cityName?: InputMaybe<Scalars['String']['input']>;
};

export type SegmentIdentifyPageProps = {
  pageViewId?: InputMaybe<Scalars['String']['input']>;
  entityName?: InputMaybe<Scalars['String']['input']>;
  screenName?: InputMaybe<Scalars['String']['input']>;
  flowName?: InputMaybe<Scalars['String']['input']>;
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  pageUrl?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterProfiles = {
  global_profile: RegisterGlobalProfile;
  registration_tracking_profile: RegisterTrackParams;
};

export type RegisterGlobalProfile = {
  first_name?: InputMaybe<Scalars['String']['input']>;
  last_name?: InputMaybe<Scalars['String']['input']>;
};

export type RegisterTrackParams = {
  page_impression_id?: InputMaybe<Scalars['String']['input']>;
  trk_mode?: InputMaybe<Scalars['String']['input']>;
  trk_channel?: InputMaybe<Scalars['String']['input']>;
  trk_vertical?: InputMaybe<Scalars['String']['input']>;
  trk_topic?: InputMaybe<Scalars['String']['input']>;
  trk_nldt?: InputMaybe<Scalars['String']['input']>;
  trk_pagetype?: InputMaybe<Scalars['String']['input']>;
  trk_element?: InputMaybe<Scalars['String']['input']>;
  trk_location?: InputMaybe<Scalars['String']['input']>;
  trk_copy?: InputMaybe<Scalars['String']['input']>;
};

export type UserRegistrationResponse = {
  __typename?: 'UserRegistrationResponse';
  id: Scalars['String']['output'];
  sheaId: Scalars['String']['output'];
  roles: Array<Scalars['String']['output']>;
};

export type ProductVersionInput = {
  code: Scalars['String']['input'];
  optionPackages?: InputMaybe<Array<OptionPackageInput>>;
};

export type OptionPackageInput = {
  id: Scalars['String']['input'];
};

export type CreateSingleTripQuoteInput = {
  affiliateReferralCode?: InputMaybe<Scalars['String']['input']>;
  citizenCountryCode: Scalars['String']['input'];
  departureDate: Scalars['Date']['input'];
  depositDate: Scalars['Date']['input'];
  destinationCountryCode: Scalars['String']['input'];
  filters?: InputMaybe<Array<FilterInput>>;
  hasPaymentsLeft: Scalars['Boolean']['input'];
  residentCountryCode: Scalars['String']['input'];
  residentRegionCode: Scalars['String']['input'];
  returnDate: Scalars['Date']['input'];
  sortBy?: InputMaybe<SortQuotesByTypeEnum>;
  travelers: Array<TravelerInput>;
  tripCost?: InputMaybe<Scalars['Int']['input']>;
  tripCostType?: InputMaybe<TripCostTypeEnum>;
};

export enum OrderTypeEnum {
  Asc = 'asc',
  Desc = 'desc'
}

export enum TripCostTypeEnum {
  TotalTripCost = 'TOTAL_TRIP_COST',
  CostPerTraveler = 'COST_PER_TRAVELER'
}

export enum SortQuotesByTypeEnum {
  PriceAsc = 'PRICE_ASC',
  SalesDesc = 'SALES_DESC',
  RatingDesc = 'RATING_DESC',
  LastPurchasedDesc = 'LAST_PURCHASED_DESC',
  PriceDesc = 'PRICE_DESC',
  Carrier = 'CARRIER'
}

export type TravelerInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  dob?: InputMaybe<Scalars['Date']['input']>;
};

export type FilterInput = {
  code?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<Scalars['String']['input']>;
  amount?: InputMaybe<Scalars['Int']['input']>;
};

export type UpdatePasswordlessUserResponse = {
  __typename?: 'UpdatePasswordlessUserResponse';
  success: Scalars['Boolean']['output'];
};

export type QsInsuranceLeadsResponse = {
  __typename?: 'QsInsuranceLeadsResponse';
  status: Scalars['String']['output'];
  responseMessage: Scalars['String']['output'];
  pingId: Scalars['String']['output'];
};

export type Traveler = {
  __typename?: 'Traveler';
  age?: Maybe<Scalars['Int']['output']>;
};

export type Coverage = {
  __typename?: 'Coverage';
  benefitName: Scalars['String']['output'];
  benefitGroupName: Scalars['String']['output'];
  coverageSummary?: Maybe<Scalars['String']['output']>;
  coverageText: Scalars['String']['output'];
  isCovered: Scalars['Boolean']['output'];
};

export type OptionPackageGroup = {
  __typename?: 'OptionPackageGroup';
  optionPackages: Array<OptionPackage>;
  isSingleBenefitOption: Scalars['Boolean']['output'];
};

export type OptionPackage = {
  __typename?: 'OptionPackage';
  id: Scalars['String']['output'];
  coverages: Array<Coverage>;
};

export type SmUnderwriter = {
  __typename?: 'SMUnderwriter';
  code: Scalars['String']['output'];
  description?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  address?: Maybe<Scalars['String']['output']>;
  ambestRating?: Maybe<Scalars['String']['output']>;
  ambestEffectiveDate?: Maybe<Scalars['Date']['output']>;
  ambestLink?: Maybe<Scalars['String']['output']>;
};

export type SmProvider = {
  __typename?: 'SMProvider';
  name: Scalars['String']['output'];
  largeLogoUrl?: Maybe<Scalars['String']['output']>;
};

export type ReportCard = {
  __typename?: 'ReportCard';
  averageBeforeTripRating?: Maybe<Scalars['Float']['output']>;
  averageDuringTripRating?: Maybe<Scalars['Float']['output']>;
  averageClaimRating?: Maybe<Scalars['Float']['output']>;
  averageOverallRating?: Maybe<Scalars['Float']['output']>;
  reviewsCount?: Maybe<Scalars['Int']['output']>;
  negativeReviewsCount?: Maybe<Scalars['Int']['output']>;
  starRatings?: Maybe<StarRating>;
};

export type StarRating = {
  __typename?: 'StarRating';
  oneStarRating?: Maybe<Scalars['Int']['output']>;
  twoStarRating?: Maybe<Scalars['Int']['output']>;
  threeStarRating?: Maybe<Scalars['Int']['output']>;
  fourStarRating?: Maybe<Scalars['Int']['output']>;
  fiveStarRating?: Maybe<Scalars['Int']['output']>;
};

export type TripDetails = {
  __typename?: 'TripDetails';
  residentCountryCode: Scalars['String']['output'];
  residentRegionCode: Scalars['String']['output'];
  citizenCountryCode: Scalars['String']['output'];
  travelers: Array<Traveler>;
  tripCost?: Maybe<Scalars['Int']['output']>;
  tripCostType?: Maybe<TripCostTypeEnum>;
  hasPaymentsLeft: Scalars['Boolean']['output'];
  depositDate: Scalars['Date']['output'];
  departureDate: Scalars['Date']['output'];
  returnDate: Scalars['Date']['output'];
  destinationCountryCode: Scalars['String']['output'];
};

export type ProductQuote = {
  __typename?: 'ProductQuote';
  coverages: Array<Coverage>;
  productName: Scalars['String']['output'];
  provider: SmProvider;
  productCode: Scalars['String']['output'];
  premium: Scalars['Float']['output'];
  purchaseUrl: Scalars['String']['output'];
};

export type SmTravelInsuranceQuoteCoverageResponse = {
  __typename?: 'SmTravelInsuranceQuoteCoverageResponse';
  benefitName: Scalars['String']['output'];
  benefitGroupName: Scalars['String']['output'];
  coverageLongText: Scalars['String']['output'];
  coverageSummary?: Maybe<Scalars['String']['output']>;
  coverageText: Scalars['String']['output'];
  isCovered: Scalars['Boolean']['output'];
};

export type SmTravelInsuranceQuoteProductQuoteResponse = {
  __typename?: 'SmTravelInsuranceQuoteProductQuoteResponse';
  certificateUrl: Scalars['String']['output'];
  coverages: Array<SmTravelInsuranceQuoteCoverageResponse>;
  productName: Scalars['String']['output'];
  productCode: Scalars['String']['output'];
  provider: SmProvider;
  premium: Scalars['Float']['output'];
  purchaseUrl: Scalars['String']['output'];
};

export type SmTravelInsuranceQuoteResponse = {
  __typename?: 'SmTravelInsuranceQuoteResponse';
  quoteNumber: Scalars['String']['output'];
  productQuotes: Array<SmTravelInsuranceQuoteProductQuoteResponse>;
  quoteWarning?: Maybe<Scalars['String']['output']>;
};

export type SmTravelInsuranceQuotesResponse = {
  __typename?: 'SmTravelInsuranceQuotesResponse';
  quoteNumber: Scalars['String']['output'];
  productQuotes: Array<ProductQuote>;
  tripDetails: TripDetails;
  quoteWarning?: Maybe<Scalars['String']['output']>;
};

export type SmCountry = {
  __typename?: 'SmCountry';
  name: Scalars['String']['output'];
  iso3166: Scalars['String']['output'];
};

export type RegisterUserWithPasswordResponse = {
  __typename?: 'RegisterUserWithPasswordResponse';
  id?: Maybe<Scalars['String']['output']>;
  roles?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  email?: Maybe<Scalars['String']['output']>;
};

export type Benefit = {
  __typename?: 'Benefit';
  name?: Maybe<Scalars['String']['output']>;
  code?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export type BenefitGroup = {
  __typename?: 'BenefitGroup';
  name?: Maybe<Scalars['String']['output']>;
  benefits?: Maybe<Array<Maybe<Benefit>>>;
};

export type SmBenefitsDetailsResponse = {
  __typename?: 'SmBenefitsDetailsResponse';
  benefitGroups?: Maybe<Array<Maybe<BenefitGroup>>>;
};

export enum UsState {
  Al = 'AL',
  Ak = 'AK',
  Az = 'AZ',
  Ar = 'AR',
  As = 'AS',
  Ca = 'CA',
  Cz = 'CZ',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Dc = 'DC',
  Fl = 'FL',
  Ga = 'GA',
  Gu = 'GU',
  Hi = 'HI',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ia = 'IA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mo = 'MO',
  Mt = 'MT',
  Mp = 'MP',
  Ne = 'NE',
  Nv = 'NV',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Ny = 'NY',
  Nc = 'NC',
  Nd = 'ND',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Pr = 'PR',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Tt = 'TT',
  Ut = 'UT',
  Vt = 'VT',
  Vi = 'VI',
  Va = 'VA',
  Wa = 'WA',
  Wv = 'WV',
  Wi = 'WI',
  Wy = 'WY'
}

export enum AlignedCreditScore {
  Good = 'Good',
  Poor = 'Poor'
}

export enum DrivingRecord {
  Gooddriver = 'gooddriver',
  Dui = 'dui',
  Accident = 'accident',
  Speeding = 'speeding'
}

export enum CoverageType {
  Minimum = 'Minimum',
  Full = 'Full'
}

export type SnowflakeQueryResponse = {
  __typename?: 'SnowflakeQueryResponse';
  data: Scalars['JSON']['output'];
  statementID: Scalars['String']['output'];
  requestID: Scalars['String']['output'];
};

export type QwTransformedResponse = {
  __typename?: 'QwTransformedResponse';
  dateTime: Scalars['String']['output'];
  status: Scalars['String']['output'];
  contractID: Scalars['String']['output'];
  quoteID: Scalars['String']['output'];
  reason?: Maybe<Scalars['String']['output']>;
  payout?: Maybe<Scalars['String']['output']>;
};

export type MakesByYearResponse = {
  __typename?: 'MakesByYearResponse';
  status: Scalars['String']['output'];
  year: Scalars['Int']['output'];
  makes: Array<VehicleMake>;
};

export type ModelByMakeYearResponse = {
  __typename?: 'ModelByMakeYearResponse';
  status: Scalars['String']['output'];
  year: Scalars['Int']['output'];
  make: Scalars['String']['output'];
  models: Array<VehicleModel>;
};

export type VehicleMake = {
  __typename?: 'VehicleMake';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
  iconUrl: Scalars['String']['output'];
};

export type VehicleModel = {
  __typename?: 'VehicleModel';
  label: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

export type InsuranceAirField = {
  __typename?: 'InsuranceAirField';
  value: Scalars['String']['output'];
  format?: Maybe<Scalars['String']['output']>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type InsuranceAirList = {
  __typename?: 'InsuranceAirList';
  listName?: Maybe<Scalars['String']['output']>;
  data: Array<InsuranceAirListItem>;
  updated_at?: Maybe<Scalars['String']['output']>;
};

export type InsuranceAirTable = {
  __typename?: 'InsuranceAirTable';
  data?: Maybe<Scalars['JSON']['output']>;
};

export type InsuranceAirListItem = {
  __typename?: 'InsuranceAirListItem';
  company: Scalars['String']['output'];
  annualPremium: Scalars['Int']['output'];
  monthlyPremium: Scalars['Int']['output'];
};

/** Enum to differentiate between different verticals for the v1 insurance endpoint */
export enum InsuranceVerticalEnum {
  HomeInsurance = 'HOME_INSURANCE',
  AutoInsurance = 'AUTO_INSURANCE',
  LifeInsurance = 'LIFE_INSURANCE'
}

/** Insurance user input that is shared among verticals */
export type OfferUserInfoInput = {
  contactName?: InputMaybe<UserNameInput>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  inventoryType?: InputMaybe<Scalars['String']['input']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isMarried?: InputMaybe<Scalars['Boolean']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']['input']>;
  pricingCodeExpiration?: InputMaybe<Scalars['Date']['input']>;
  pricingCodeExpirationDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  qsClickKey?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  affiliateId?: InputMaybe<Scalars['String']['input']>;
  var1?: InputMaybe<Scalars['String']['input']>;
  var2?: InputMaybe<Scalars['String']['input']>;
};

export type OfferDriverInfoInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  contactAddress?: InputMaybe<UserAddressInput>;
  continuousCoverageMonths?: InputMaybe<Scalars['Int']['input']>;
  creditScoreRange?: InputMaybe<QuinStreetCreditScoreRangeEnum>;
  driversCount?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  hasHadDui?: InputMaybe<Scalars['Boolean']['input']>;
  isVeteran?: InputMaybe<Scalars['Boolean']['input']>;
  isGoodDriver?: InputMaybe<Scalars['Boolean']['input']>;
  licenseStatus?: InputMaybe<LicenseStatusEnum>;
  numRecentIncidents?: InputMaybe<Scalars['Int']['input']>;
  requiresSr22?: InputMaybe<Scalars['Boolean']['input']>;
  bundleAutoHome?: InputMaybe<Scalars['Boolean']['input']>;
  vehicles?: InputMaybe<Array<AutoInsuranceVehicleInput>>;
  vehiclesCount?: InputMaybe<Scalars['Int']['input']>;
};

export type HomeInsuranceQwContactInput = {
  isMarried?: InputMaybe<Scalars['Boolean']['input']>;
  gender?: InputMaybe<GenderEnum>;
  contactName?: InputMaybe<UserNameInput>;
  contactAddress?: InputMaybe<UserAddressInput>;
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']['input']>;
};

export type VendorData = {
  jornayaLeadID?: InputMaybe<Scalars['String']['input']>;
  tcpaLanguage?: InputMaybe<Scalars['String']['input']>;
};

export type UtmParams = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  utmSource?: InputMaybe<Scalars['String']['input']>;
  utmMedium?: InputMaybe<Scalars['String']['input']>;
  utmTerm?: InputMaybe<Scalars['String']['input']>;
  utmContent?: InputMaybe<Scalars['String']['input']>;
};

export type AnalyticsProps = {
  productImpressionId?: InputMaybe<Scalars['String']['input']>;
  skuImpressionId?: InputMaybe<Scalars['String']['input']>;
  pageviewId?: InputMaybe<Scalars['String']['input']>;
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  userId?: InputMaybe<Scalars['String']['input']>;
  sourcePageViewId?: InputMaybe<Scalars['String']['input']>;
  sourcePageUrl?: InputMaybe<Scalars['String']['input']>;
  sourcePageName?: InputMaybe<Scalars['String']['input']>;
  impressionPageName?: InputMaybe<Scalars['String']['input']>;
  impressionSection?: InputMaybe<Scalars['String']['input']>;
  impressionPosition?: InputMaybe<Scalars['Int']['input']>;
  subAliasId?: InputMaybe<Scalars['String']['input']>;
  finishType?: InputMaybe<Scalars['String']['input']>;
  revenueType?: InputMaybe<Scalars['String']['input']>;
  destinationUrl?: InputMaybe<Scalars['String']['input']>;
  utmParams?: InputMaybe<UtmParams>;
};

export type HomeInsuranceQwResidenceInput = {
  dwellingType?: InputMaybe<Scalars['String']['input']>;
  ownershipStatus?: InputMaybe<Scalars['String']['input']>;
  yearBuilt?: InputMaybe<Scalars['String']['input']>;
  residenceSquareFootage?: InputMaybe<Scalars['String']['input']>;
};

export type HomeInsuranceOfferInput = {
  contactName?: InputMaybe<UserNameInput>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  inventoryType?: InputMaybe<Scalars['String']['input']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isMarried?: InputMaybe<Scalars['Boolean']['input']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  qsClickKey?: InputMaybe<Scalars['String']['input']>;
};

/** Query variables for qsInsuranceOffers */
export type LifeInsuranceOfferInput = {
  tobaccoUse?: InputMaybe<Scalars['Boolean']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
};

/** Input for Vehicle Information: Year, Make, Model */
export type AutoInsuranceVehicleInput = {
  year?: InputMaybe<Scalars['String']['input']>;
  make?: InputMaybe<Scalars['String']['input']>;
  model?: InputMaybe<Scalars['String']['input']>;
};

export enum LicenseStatusEnum {
  Valid = 'VALID',
  Temporary = 'TEMPORARY',
  Suspended = 'SUSPENDED',
  NoLicense = 'NO_LICENSE',
  Permit = 'PERMIT'
}

export enum GenderEnum {
  Male = 'MALE',
  Female = 'FEMALE',
  NonBinary = 'NON_BINARY'
}

/** Named credit score ranges accepted for creditScoreRange in AutoInsurancePrequalOfferInput */
export enum QuinStreetCreditScoreRangeEnum {
  Excellent = 'EXCELLENT',
  Good = 'GOOD',
  Fair = 'FAIR',
  Poor = 'POOR'
}

export type UserAddressInput = {
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export type UserNameInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

/** Format of response to qsInsuranceOffers query (v1) */
export type InsuranceOffersResponse = {
  __typename?: 'InsuranceOffersResponse';
  offers?: Maybe<Array<InsuranceOfferV2>>;
};

/** Interface for all Marketplace entity types (Institution, Product, and Offer) */
export type MarketplaceEntityInterface = {
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

export enum MarketplaceEntityStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

/** Common interface for marketplace entities that can win a Best Of Awards Badge for 2021 */
export type MarketplaceEntityWithBestOfAwards2021Interface = {
  /**
   * The list of NW Best-Of Awards this offer has won for 2021
   * @deprecated This year specific best of badge field is now succeeded by a generic best of awards field. Use the bestOfAwards field on the MarketplaceEntityWithBestOfAwardsInterface interface instead.
   */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
};

export type BestOfAward = {
  __typename?: 'BestOfAward';
  /** The year in which the offer won */
  year: Scalars['Int']['output'];
  /** The category in which the offer won */
  category: Scalars['String']['output'];
};

/** Common interface for marketplace entities that can win a Best Of Awards Badge */
export type MarketplaceEntityWithBestOfAwardsInterface = {
  /** The list of NW Best Of Awards this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
};

/** Common interface for marketplace entities that can be used in a placement */
export type MarketplaceEntityWithPlacementInterface = {
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
  monetizable: Scalars['String']['output'];
  /** The drivers associated with the entity */
  placementDrivers: Array<Maybe<EntityPlacementDriver>>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};

export enum EntityPlacementCtaTypeEnum {
  ApplyNow = 'APPLY_NOW',
  Prequal = 'PREQUAL',
  ReadReview = 'READ_REVIEW'
}

export type EntityPlacementCta = {
  __typename?: 'EntityPlacementCTA';
  /** The destination url of the CTA */
  link: Scalars['URL']['output'];
  /** Whether or not to show the icon in the CTA */
  showIcon: Scalars['Boolean']['output'];
  /** The text to show underneath the CTA button */
  subtext?: Maybe<Scalars['String']['output']>;
  /** The button/link text to show for the CTA */
  text: Scalars['String']['output'];
  /** The ultimate destination type of the CTA */
  type: EntityPlacementCtaTypeEnum;
};

export type EntityPlacementDriver = {
  __typename?: 'EntityPlacementDriver';
  /** The driver description */
  description?: Maybe<Scalars['String']['output']>;
  /** The driver id */
  id: Scalars['String']['output'];
  /** The driver label */
  label: Scalars['String']['output'];
  /** The tooltip associated with the driver label */
  labelTooltip?: Maybe<Scalars['String']['output']>;
  /** The driver value */
  value?: Maybe<Scalars['String']['output']>;
  /** The driver tooltip */
  tooltip?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The driver tooltip (no SC) */
  valueTooltip?: Maybe<Scalars['String']['output']>;
  /** Whether or not the value tooltip has HTML in it */
  valueTooltipHasHtml: Scalars['Boolean']['output'];
};

export type EntityPlacementImage = {
  __typename?: 'EntityPlacementImage';
  /** The alt text that will accompany the logo */
  alt?: Maybe<Scalars['String']['output']>;
  /** The height of the image, in px */
  height?: Maybe<Scalars['Int']['output']>;
  /**
   * The relative image path for CloudFlare's image optimization service.
   *   Can be used to build an image URL with custom height/width/quality.
   */
  resizableImagePath?: Maybe<Scalars['String']['output']>;
  /** The URL for the logo */
  source?: Maybe<Scalars['URL']['output']>;
  /** The URL for the large-size logo */
  sourceLarge?: Maybe<Scalars['URL']['output']>;
  /** The URL for the medium-size logo */
  sourceMedium?: Maybe<Scalars['URL']['output']>;
  /** The width of the image, in px */
  width?: Maybe<Scalars['Int']['output']>;
};

export type EntityPlacementAnalyticsProps = {
  __typename?: 'EntityPlacementAnalyticsProps';
  /** The marketplace UUID for the associated institution. */
  institutionId: Scalars['ID']['output'];
  /** The marketplace UUID for the associated offer. Null for institutions and products. */
  offerId?: Maybe<Scalars['ID']['output']>;
  /** The marketplace UUID for the associated product. Null for institutions. */
  productId?: Maybe<Scalars['ID']['output']>;
  /**
   * Boolean indicating if the entity can log a legacy impression. This is only used for legacy
   *   analytics and can be removed after the Bedrock cutover.
   */
  hasLegacyImpression: Scalars['Boolean']['output'];
  /**
   * Additional data to be sent to legacy impression events. This is only used for legacy
   *   analytics and can be removed after the Bedrock cutover.
   */
  legacyAdditionalEventData?: Maybe<Scalars['JSON']['output']>;
  /**
   * The entity's issuer name. This is only used for legacy analytics and can be removed after
   *   the Bedrock cutover.
   */
  legacyIssuer: Scalars['String']['output'];
  /**
   * The entity slug. This is only used for legacy analytics and can be removed after
   *   the Bedrock cutover.
   */
  legacySlug?: Maybe<Scalars['String']['output']>;
  /**
   * The vertical name to use to map to the legacy impression. This is only used for legacy
   *   analytics and can be removed after the Bedrock cutover.
   */
  legacyVertical?: Maybe<Scalars['String']['output']>;
};

/** Common interface for marketplace entities with review links */
export type MarketplaceEntityWithReviewInterface = {
  reviewLink?: Maybe<Scalars['URL']['output']>;
};

/** Common interface for marketplace entities with a star rating */
export type MarketplaceEntityWithStarRatingInterface = {
  /** NerdWallet review rating stars */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
};

/** Interface for all Marketplace Offer types */
export type MarketplaceOfferInterface = {
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** The parent Product of this Offer */
  product: MarketplaceProductInterface;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
};

/** Interface for all Marketplace Product types */
export type MarketplaceProductInterface = {
  /** The parent Institution of this Product */
  institution: MarketplaceEntityInterface;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
};

/** Interface for all Marketplace institution types */
export type MarketplaceInstitutionInterface = {
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
};

export enum MarketplaceStatusEnum {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Archived = 'ARCHIVED'
}

export type EventRatingForStatus = {
  __typename?: 'EventRatingForStatus';
  rapid_acceleration?: Maybe<Scalars['Float']['output']>;
  phone_use?: Maybe<Scalars['Float']['output']>;
  hard_brake?: Maybe<Scalars['Float']['output']>;
  hard_turn?: Maybe<Scalars['Float']['output']>;
  overspeeding?: Maybe<Scalars['Float']['output']>;
};

export type EventRatingForTrips = {
  __typename?: 'EventRatingForTrips';
  rapid_acceleration?: Maybe<Scalars['Float']['output']>;
  phone_use?: Maybe<Scalars['Float']['output']>;
  hard_brake?: Maybe<Scalars['Float']['output']>;
  hard_turn?: Maybe<Scalars['Float']['output']>;
  over_speeding?: Maybe<Scalars['Float']['output']>;
};

export type DriverMetrics = {
  __typename?: 'DriverMetrics';
  date_first_drive?: Maybe<Scalars['String']['output']>;
  unique_driving_days?: Maybe<Scalars['Float']['output']>;
  event_rating?: Maybe<EventRatingForStatus>;
  trips_count?: Maybe<Scalars['Float']['output']>;
  distance_miles?: Maybe<Scalars['Float']['output']>;
  distance_kms?: Maybe<Scalars['Float']['output']>;
  progress_percentage?: Maybe<Scalars['Float']['output']>;
  zendrive_score?: Maybe<Scalars['Float']['output']>;
  offer_available?: Maybe<Scalars['Boolean']['output']>;
  offer_clicked?: Maybe<Scalars['Boolean']['output']>;
  is_disqualified?: Maybe<Scalars['Boolean']['output']>;
};

export type DriverStatusResponse = {
  __typename?: 'DriverStatusResponse';
  driver_id?: Maybe<Scalars['String']['output']>;
  start_date?: Maybe<Scalars['String']['output']>;
  end_date?: Maybe<Scalars['String']['output']>;
  metrics?: Maybe<DriverMetrics>;
};

export type LocationLatLong = {
  __typename?: 'LocationLatLong';
  latitude?: Maybe<Scalars['Float']['output']>;
  longitude?: Maybe<Scalars['Float']['output']>;
};

export type ZendriveScore = {
  __typename?: 'ZendriveScore';
  zendrive_score: Scalars['Float']['output'];
};

export type DrivingBehavior = {
  __typename?: 'DrivingBehavior';
  score: ZendriveScore;
  event_rating?: Maybe<EventRatingForTrips>;
};

export type Trip = {
  __typename?: 'Trip';
  trip_id: Scalars['String']['output'];
  start_time: Scalars['String']['output'];
  end_time: Scalars['String']['output'];
  start_location: LocationLatLong;
  end_location: LocationLatLong;
  distance: Scalars['Float']['output'];
  highway_distance: Scalars['Float']['output'];
  driving_behavior: DrivingBehavior;
};

export type ResponseMetaData = {
  __typename?: 'ResponseMetaData';
  next_cursor?: Maybe<Scalars['String']['output']>;
  limit?: Maybe<Scalars['Int']['output']>;
  total_trips?: Maybe<Scalars['Int']['output']>;
};

export type DriverTripsResponse = {
  __typename?: 'DriverTripsResponse';
  trips?: Maybe<Array<Maybe<Trip>>>;
  response_metadata?: Maybe<ResponseMetaData>;
};

export type DeleteTripResponse = {
  __typename?: 'DeleteTripResponse';
  status?: Maybe<Scalars['Float']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export type DriverInfo = {
  __typename?: 'DriverInfo';
  publisher_app_name: Scalars['String']['output'];
  driver_id: Scalars['String']['output'];
};

export type AdUnitBody = {
  __typename?: 'AdUnitBody';
  text?: Maybe<Scalars['String']['output']>;
  bullets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type AdUnit = {
  __typename?: 'AdUnit';
  offer_id: Scalars['String']['output'];
  insurer_name: Scalars['String']['output'];
  logo_url: Scalars['String']['output'];
  title?: Maybe<Scalars['String']['output']>;
  body?: Maybe<AdUnitBody>;
  button_text?: Maybe<Scalars['String']['output']>;
  button_click_url?: Maybe<Scalars['String']['output']>;
  legal?: Maybe<AdUnitLegalInfo>;
};

export type AdUnitDisclaimers = {
  __typename?: 'AdUnitDisclaimers';
  generic?: Maybe<Scalars['String']['output']>;
  current_customer?: Maybe<Scalars['String']['output']>;
};

export type AdUnitLegalInfo = {
  __typename?: 'AdUnitLegalInfo';
  disclaimers?: Maybe<AdUnitDisclaimers>;
  privacy_policy_url?: Maybe<Scalars['String']['output']>;
  terms_and_conditions_url?: Maybe<Scalars['String']['output']>;
};

export type AdUnitV2Response = {
  __typename?: 'AdUnitV2Response';
  driver_info?: Maybe<DriverInfo>;
  ad_unit?: Maybe<AdUnit>;
};

export type SupportedStateResponse = {
  __typename?: 'SupportedStateResponse';
  is_supported_state?: Maybe<Scalars['Boolean']['output']>;
  can_receive_offer?: Maybe<Scalars['Boolean']['output']>;
};

export type ListOfAdvertisersResponse = {
  __typename?: 'ListOfAdvertisersResponse';
  advertisers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
};

export type DriverInfoSegment = {
  __typename?: 'DriverInfoSegment';
  source?: Maybe<Scalars['String']['output']>;
};

export type DriverInfoRequest = {
  __typename?: 'DriverInfoRequest';
  country?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipcode?: Maybe<Scalars['String']['output']>;
  insurer?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<DriverInfoSegment>;
};

export type DriverInfoResponse = {
  __typename?: 'DriverInfoResponse';
  status?: Maybe<Scalars['Float']['output']>;
};

export type ValidatePhoneResponse = {
  __typename?: 'ValidatePhoneResponse';
  isValid?: Maybe<Scalars['Boolean']['output']>;
};

export type FenrisPerson = {
  firstName: Scalars['String']['input'];
  middleName?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  dateOfBirth?: InputMaybe<Scalars['String']['input']>;
};

export type FenrisAddress = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state: Scalars['String']['input'];
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

export enum FenrisResponseTypeEnum {
  M = 'M',
  C = 'C'
}

export type FenrisProfileDataSuccessResponse = {
  __typename?: 'FenrisProfileDataSuccessResponse';
  requestId?: Maybe<Scalars['String']['output']>;
  submissionId?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  statusDescription?: Maybe<Scalars['String']['output']>;
  matchDescription?: Maybe<Scalars['String']['output']>;
  addressDescription?: Maybe<Scalars['String']['output']>;
  primary?: Maybe<FenrisPrimaryResponse>;
  drivers?: Maybe<Array<Maybe<FenrisDriverResponse>>>;
  vehicles?: Maybe<Array<Maybe<FenrisVehicleResponse>>>;
  vehiclesEnhanced?: Maybe<Array<Maybe<FenrisEnhancedVehicleResponse>>>;
};

export type FenrisProfileDataErrorResponse = {
  __typename?: 'FenrisProfileDataErrorResponse';
  requestId?: Maybe<Scalars['String']['output']>;
  submissionId?: Maybe<Scalars['String']['output']>;
  status: Scalars['Int']['output'];
  timestamp?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  message?: Maybe<Scalars['String']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  fieldErrors?: Maybe<Array<Maybe<Array<Maybe<Scalars['String']['output']>>>>>;
  error?: Maybe<Scalars['String']['output']>;
};

export type FenrisPrimaryResponse = {
  __typename?: 'FenrisPrimaryResponse';
  gender?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  memberCode?: Maybe<Scalars['String']['output']>;
  parsedAddress?: Maybe<FenrisParsedAddress>;
  homeOwnerStatus?: Maybe<Scalars['String']['output']>;
  lengthOfResidence?: Maybe<Scalars['String']['output']>;
  numberOfGenerations?: Maybe<Scalars['Int']['output']>;
  presenceOf16Or17YearOlds?: Maybe<Scalars['Boolean']['output']>;
  babyBoomer?: Maybe<Scalars['Boolean']['output']>;
  dualIncomeNoKids?: Maybe<Scalars['Boolean']['output']>;
  millennial?: Maybe<Scalars['Boolean']['output']>;
  vehicleHouseholdNum?: Maybe<Scalars['Int']['output']>;
};

export type FenrisParsedAddress = {
  __typename?: 'FenrisParsedAddress';
  addressLine1: Scalars['String']['output'];
  city?: Maybe<Scalars['String']['output']>;
  state: Scalars['String']['output'];
  zipCode?: Maybe<Scalars['String']['output']>;
  addressType?: Maybe<Scalars['String']['output']>;
};

export type FenrisDriverResponse = {
  __typename?: 'FenrisDriverResponse';
  firstName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<Scalars['String']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  memberCode?: Maybe<Scalars['String']['output']>;
  verificationDate?: Maybe<Scalars['String']['output']>;
};

export type FenrisVehicleResponse = {
  __typename?: 'FenrisVehicleResponse';
  confidence?: Maybe<Scalars['Int']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  mileage?: Maybe<Scalars['String']['output']>;
  marketValue?: Maybe<Scalars['Int']['output']>;
};

export type FenrisEnhancedVehicleResponse = {
  __typename?: 'FenrisEnhancedVehicleResponse';
  vin?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['Int']['output']>;
  color?: Maybe<Scalars['String']['output']>;
  trim?: Maybe<Scalars['String']['output']>;
  registeredState?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  plateType?: Maybe<Scalars['String']['output']>;
  leaseIndicator?: Maybe<Scalars['Boolean']['output']>;
  brandedTitleIndicator?: Maybe<Scalars['Boolean']['output']>;
  price?: Maybe<Scalars['Int']['output']>;
  manufacturerBasePrice?: Maybe<Scalars['Int']['output']>;
  driveSystem?: Maybe<Scalars['String']['output']>;
  registeredOwners?: Maybe<Array<Maybe<FenrisRegisteredOwner>>>;
  vinChangeIndicator?: Maybe<Scalars['String']['output']>;
  bodyStyle?: Maybe<Scalars['String']['output']>;
  transactionDate?: Maybe<Scalars['String']['output']>;
  brandedTitleCode?: Maybe<Scalars['String']['output']>;
  addressType?: Maybe<Scalars['String']['output']>;
  addressLine1?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
  weight?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  confidence?: Maybe<Scalars['Int']['output']>;
};

export type FenrisRegisteredOwner = {
  __typename?: 'FenrisRegisteredOwner';
  surname?: Maybe<Scalars['String']['output']>;
  givenName?: Maybe<Scalars['String']['output']>;
  suffix?: Maybe<Scalars['String']['output']>;
  businessName?: Maybe<Scalars['String']['output']>;
  entityType?: Maybe<Scalars['String']['output']>;
  ownerType?: Maybe<Scalars['String']['output']>;
};

export type FenrisProfileDataResponse = FenrisProfileDataSuccessResponse | FenrisProfileDataErrorResponse;

export enum CovrGenderEnum {
  M = 'M',
  F = 'F'
}

export enum CovrHealthClassEnum {
  Pp = 'PP',
  P = 'P',
  R = 'R',
  Rp = 'RP'
}

export enum Us51State {
  Al = 'AL',
  Ak = 'AK',
  Az = 'AZ',
  Ar = 'AR',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  De = 'DE',
  Dc = 'DC',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ia = 'IA',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Me = 'ME',
  Md = 'MD',
  Ma = 'MA',
  Mi = 'MI',
  Mn = 'MN',
  Ms = 'MS',
  Mo = 'MO',
  Mt = 'MT',
  Ne = 'NE',
  Nv = 'NV',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Ny = 'NY',
  Nc = 'NC',
  Nd = 'ND',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Vt = 'VT',
  Va = 'VA',
  Wa = 'WA',
  Wv = 'WV',
  Wi = 'WI',
  Wy = 'WY'
}

export enum CovrTimeZoneEnum {
  Hawaii = 'Hawaii',
  Pacific = 'Pacific',
  Central = 'Central',
  Eastern = 'Eastern',
  Mountain = 'Mountain'
}

export type AppointmentResponse = {
  __typename?: 'AppointmentResponse';
  appointment?: Maybe<Scalars['String']['output']>;
  available?: Maybe<Scalars['Boolean']['output']>;
};

export type ProductHighlight = {
  __typename?: 'ProductHighlight';
  productHighlight: Scalars['String']['output'];
  productHighlightDescription: Scalars['String']['output'];
};

export type QuoteResult = {
  __typename?: 'QuoteResult';
  product: Scalars['String']['output'];
  productID: Scalars['Int']['output'];
  carrierName: Scalars['String']['output'];
  annualRate?: Maybe<Scalars['Float']['output']>;
  monthlyRate: Scalars['Float']['output'];
  logoUrl: Scalars['String']['output'];
  rating: Scalars['String']['output'];
  minIssueAge?: Maybe<Scalars['Int']['output']>;
  minFace?: Maybe<Scalars['String']['output']>;
  maxFace?: Maybe<Scalars['String']['output']>;
  yearsLevel?: Maybe<Scalars['String']['output']>;
  yearsGuaranteedLevel?: Maybe<Scalars['String']['output']>;
  allowReentry?: Maybe<Scalars['String']['output']>;
  ageDetermination?: Maybe<Scalars['String']['output']>;
  policyMaturityAge?: Maybe<Scalars['Int']['output']>;
  conversionOption?: Maybe<Scalars['String']['output']>;
  minimumPremium?: Maybe<Scalars['Int']['output']>;
  carrierID?: Maybe<Scalars['Int']['output']>;
  productName: Scalars['String']['output'];
  riderCost?: Maybe<Scalars['Int']['output']>;
  riderCostMonthly?: Maybe<Scalars['Int']['output']>;
  hasChildRider?: Maybe<Scalars['Boolean']['output']>;
  minChildRider?: Maybe<Scalars['Int']['output']>;
  maxChildRider?: Maybe<Scalars['Int']['output']>;
  coverageAmount?: Maybe<Scalars['Float']['output']>;
  quoteID?: Maybe<Scalars['String']['output']>;
  premiumWaiverAmount?: Maybe<Scalars['Float']['output']>;
  jwtToken?: Maybe<Scalars['String']['output']>;
  policyFee?: Maybe<Scalars['Int']['output']>;
  productInformation: Scalars['String']['output'];
  convertibility?: Maybe<Scalars['String']['output']>;
  annualsavings?: Maybe<Scalars['Float']['output']>;
  termLength?: Maybe<Scalars['String']['output']>;
  productDescription: Scalars['String']['output'];
  applicationInformation?: Maybe<Scalars['String']['output']>;
  hasPermConversionOption?: Maybe<Scalars['Boolean']['output']>;
  productRanges?: Maybe<Array<Maybe<CovrQuoteProductRange>>>;
  convertibilityScore?: Maybe<Scalars['Float']['output']>;
  ridersScore?: Maybe<Scalars['Float']['output']>;
  companyRatingsScore?: Maybe<Scalars['Float']['output']>;
  noExamScore?: Maybe<Scalars['Float']['output']>;
  digitalScore?: Maybe<Scalars['Float']['output']>;
  speedScore?: Maybe<Scalars['Float']['output']>;
  optionsScore?: Maybe<Scalars['Float']['output']>;
  totalUnweightedScore?: Maybe<Scalars['Float']['output']>;
  underwritingTimeTypical: Scalars['String']['output'];
  requiresMedicalExam: Scalars['String']['output'];
  ratingAMBest?: Maybe<Scalars['String']['output']>;
  ratingSP?: Maybe<Scalars['String']['output']>;
  ratingMoodys?: Maybe<Scalars['String']['output']>;
  ratingFitch?: Maybe<Scalars['String']['output']>;
  ratingComdex?: Maybe<Scalars['String']['output']>;
  availableRiders?: Maybe<Array<Maybe<CovrQuoteRider>>>;
  disclosureDetail?: Maybe<Scalars['String']['output']>;
  hasConvertibility?: Maybe<Scalars['Boolean']['output']>;
  subProductID?: Maybe<Scalars['String']['output']>;
  underwritingType?: Maybe<Scalars['Int']['output']>;
  productAppointments?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  cashValue?: Maybe<Scalars['Int']['output']>;
  quoteLogId?: Maybe<Scalars['Int']['output']>;
  isDecreasingTerm?: Maybe<Scalars['Boolean']['output']>;
  requiresPhoneInterview?: Maybe<Scalars['Boolean']['output']>;
  isDigitalProduct?: Maybe<Scalars['Boolean']['output']>;
  productValueProposition?: Maybe<Scalars['String']['output']>;
  productHighlightInfo: Array<Maybe<ProductHighlight>>;
};

export type CovrQuoteRider = {
  __typename?: 'CovrQuoteRider';
  rider: Scalars['String']['output'];
  description: Scalars['String']['output'];
  additionalCost: Scalars['Boolean']['output'];
};

export type CovrQuoteRiderInput = {
  rider?: InputMaybe<Scalars['String']['input']>;
  description?: InputMaybe<Scalars['String']['input']>;
  additionalCost?: InputMaybe<Scalars['Boolean']['input']>;
};

export type CovrQuoteProductRange = {
  __typename?: 'CovrQuoteProductRange';
  maxFace: Scalars['Int']['output'];
  minFace: Scalars['Int']['output'];
  terms: Array<Scalars['Int']['output']>;
  maxAge: Scalars['Int']['output'];
  minAge: Scalars['Int']['output'];
};

export type CovrQuoteProductRangeInput = {
  maxFace: Scalars['Int']['input'];
  minFace: Scalars['Int']['input'];
  terms: Array<Scalars['Int']['input']>;
  maxAge: Scalars['Int']['input'];
  minAge: Scalars['Int']['input'];
};

export type CovrGetQuotesResponse = {
  __typename?: 'CovrGetQuotesResponse';
  partnerQuoteId?: Maybe<Scalars['String']['output']>;
  lowestMonthlyRate?: Maybe<Scalars['Float']['output']>;
  success?: Maybe<Scalars['Boolean']['output']>;
  quoteResults?: Maybe<Array<Maybe<QuoteResult>>>;
  quoteNumber?: Maybe<Scalars['String']['output']>;
};

export type CovrAmericoHandoffResponse = {
  __typename?: 'CovrAmericoHandoffResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type CovrLgaHandoffResponse = {
  __typename?: 'CovrLGAHandoffResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  redirectUrl?: Maybe<Scalars['String']['output']>;
};

export type CovrPostAppointmentResponse = {
  __typename?: 'CovrPostAppointmentResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  consumerApplicationId?: Maybe<Scalars['String']['output']>;
};

export type ProductHighlightInput = {
  productHighlight?: InputMaybe<Scalars['String']['input']>;
  productHighlightDescription?: InputMaybe<Scalars['String']['input']>;
};

export type QuoteResultInput = {
  product: Scalars['String']['input'];
  productID: Scalars['Int']['input'];
  carrierName: Scalars['String']['input'];
  annualRate?: InputMaybe<Scalars['Float']['input']>;
  monthlyRate: Scalars['Float']['input'];
  logoUrl: Scalars['String']['input'];
  rating: Scalars['String']['input'];
  minIssueAge?: InputMaybe<Scalars['Int']['input']>;
  minFace?: InputMaybe<Scalars['String']['input']>;
  maxFace?: InputMaybe<Scalars['String']['input']>;
  yearsLevel?: InputMaybe<Scalars['String']['input']>;
  yearsGuaranteedLevel?: InputMaybe<Scalars['String']['input']>;
  allowReentry?: InputMaybe<Scalars['String']['input']>;
  ageDetermination?: InputMaybe<Scalars['String']['input']>;
  policyMaturityAge?: InputMaybe<Scalars['Int']['input']>;
  conversionOption?: InputMaybe<Scalars['String']['input']>;
  minimumPremium?: InputMaybe<Scalars['Int']['input']>;
  carrierID?: InputMaybe<Scalars['Int']['input']>;
  productName: Scalars['String']['input'];
  riderCost?: InputMaybe<Scalars['Int']['input']>;
  riderCostMonthly?: InputMaybe<Scalars['Int']['input']>;
  hasChildRider?: InputMaybe<Scalars['Boolean']['input']>;
  minChildRider?: InputMaybe<Scalars['Int']['input']>;
  maxChildRider?: InputMaybe<Scalars['Int']['input']>;
  coverageAmount?: InputMaybe<Scalars['Float']['input']>;
  quoteID?: InputMaybe<Scalars['String']['input']>;
  premiumWaiverAmount?: InputMaybe<Scalars['Float']['input']>;
  jwtToken?: InputMaybe<Scalars['String']['input']>;
  policyFee?: InputMaybe<Scalars['Int']['input']>;
  productInformation: Scalars['String']['input'];
  convertibility?: InputMaybe<Scalars['String']['input']>;
  annualsavings?: InputMaybe<Scalars['Float']['input']>;
  termLength?: InputMaybe<Scalars['String']['input']>;
  productDescription: Scalars['String']['input'];
  applicationInformation?: InputMaybe<Scalars['String']['input']>;
  hasPermConversionOption?: InputMaybe<Scalars['Boolean']['input']>;
  productRanges?: InputMaybe<Array<InputMaybe<CovrQuoteProductRangeInput>>>;
  convertibilityScore?: InputMaybe<Scalars['Float']['input']>;
  ridersScore?: InputMaybe<Scalars['Float']['input']>;
  companyRatingsScore?: InputMaybe<Scalars['Float']['input']>;
  noExamScore?: InputMaybe<Scalars['Float']['input']>;
  digitalScore?: InputMaybe<Scalars['Float']['input']>;
  speedScore?: InputMaybe<Scalars['Float']['input']>;
  optionsScore?: InputMaybe<Scalars['Float']['input']>;
  totalUnweightedScore?: InputMaybe<Scalars['Float']['input']>;
  underwritingTimeTypical: Scalars['String']['input'];
  requiresMedicalExam: Scalars['String']['input'];
  ratingAMBest?: InputMaybe<Scalars['String']['input']>;
  ratingSP?: InputMaybe<Scalars['String']['input']>;
  ratingMoodys?: InputMaybe<Scalars['String']['input']>;
  ratingFitch?: InputMaybe<Scalars['String']['input']>;
  ratingComdex?: InputMaybe<Scalars['String']['input']>;
  availableRiders?: InputMaybe<Array<InputMaybe<CovrQuoteRiderInput>>>;
  disclosureDetail?: InputMaybe<Scalars['String']['input']>;
  hasConvertibility?: InputMaybe<Scalars['Boolean']['input']>;
  subProductID?: InputMaybe<Scalars['String']['input']>;
  underwritingType?: InputMaybe<Scalars['Int']['input']>;
  productAppointments?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  cashValue?: InputMaybe<Scalars['Int']['input']>;
  quoteLogId?: InputMaybe<Scalars['Int']['input']>;
  isDecreasingTerm?: InputMaybe<Scalars['Boolean']['input']>;
  requiresPhoneInterview?: InputMaybe<Scalars['Boolean']['input']>;
  isDigitalProduct?: InputMaybe<Scalars['Boolean']['input']>;
  productValueProposition?: InputMaybe<Scalars['String']['input']>;
  productHighlightInfo: Array<InputMaybe<ProductHighlightInput>>;
};

export type CoveredQuoteSuccessResponse = {
  __typename?: 'CoveredQuoteSuccessResponse';
  id?: Maybe<Scalars['String']['output']>;
  href?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  shoppingFinishedId?: Maybe<Scalars['ID']['output']>;
};

export type CoveredQuoteErrorResponse = {
  __typename?: 'CoveredQuoteErrorResponse';
  type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['Int']['output']>;
  detail?: Maybe<Scalars['String']['output']>;
  instance?: Maybe<Scalars['String']['output']>;
};

export type CoveredQuoteResponse = CoveredQuoteSuccessResponse | CoveredQuoteErrorResponse;

export type CarSegment = {
  __typename?: 'CarSegment';
  segmentId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type CarSubsegment = {
  __typename?: 'CarSubsegment';
  subsegmentId: Scalars['Int']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type Image = {
  __typename?: 'Image';
  styleId?: Maybe<Scalars['String']['output']>;
  imageId?: Maybe<Scalars['String']['output']>;
  fileName?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  background?: Maybe<Scalars['String']['output']>;
  size?: Maybe<Scalars['String']['output']>;
  carryover?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
  divisionName?: Maybe<Scalars['String']['output']>;
  modelName?: Maybe<Scalars['String']['output']>;
  bodyType?: Maybe<Scalars['String']['output']>;
  exactMatch?: Maybe<Scalars['String']['output']>;
  oemTemp?: Maybe<Scalars['String']['output']>;
  angelCode?: Maybe<Scalars['Int']['output']>;
  link?: Maybe<Scalars['String']['output']>;
  fullDescription?: Maybe<Scalars['String']['output']>;
  association?: Maybe<Scalars['String']['output']>;
};

export type ImageGroupedByAssociation = {
  __typename?: 'ImageGroupedByAssociation';
  association: Scalars['String']['output'];
  images: Array<Image>;
};

export type TrimData = {
  __typename?: 'TrimData';
  engine?: Maybe<Scalars['String']['output']>;
  horsepower?: Maybe<Scalars['String']['output']>;
  drivetrain?: Maybe<Scalars['String']['output']>;
  seatingCapacity?: Maybe<Scalars['String']['output']>;
  estimatedBatteryRange?: Maybe<Scalars['String']['output']>;
  cargoCapacity?: Maybe<Scalars['String']['output']>;
  frontTireSize?: Maybe<Scalars['String']['output']>;
  rearTireSize?: Maybe<Scalars['String']['output']>;
  grossVehicleWeightRatingCap?: Maybe<Scalars['String']['output']>;
  vehicleBodyLength?: Maybe<Scalars['String']['output']>;
  wheelbase?: Maybe<Scalars['String']['output']>;
  groundClearance?: Maybe<Scalars['String']['output']>;
  curbWeight?: Maybe<Scalars['String']['output']>;
  cityElectricFuelEconomy?: Maybe<Scalars['String']['output']>;
  highwayElectricFuelEconomy?: Maybe<Scalars['String']['output']>;
  combinedElectricFuelEconomy?: Maybe<Scalars['String']['output']>;
  combinedFuelEconomy?: Maybe<Scalars['String']['output']>;
  highwayFuelEconomy?: Maybe<Scalars['String']['output']>;
  cityFuelEconomy?: Maybe<Scalars['String']['output']>;
  torque?: Maybe<Scalars['String']['output']>;
  transmissionType?: Maybe<Scalars['String']['output']>;
  transmissionSpeeds?: Maybe<Scalars['String']['output']>;
  legRoomFirstRow?: Maybe<Scalars['String']['output']>;
  legRoomSecondRow?: Maybe<Scalars['String']['output']>;
  legRoomThirdRow?: Maybe<Scalars['String']['output']>;
  frontHeadRoom?: Maybe<Scalars['String']['output']>;
  secondHeadRoom?: Maybe<Scalars['String']['output']>;
  thirdHeadRoom?: Maybe<Scalars['String']['output']>;
  frontHipRoom?: Maybe<Scalars['String']['output']>;
  secondHipRoom?: Maybe<Scalars['String']['output']>;
  thirdHipRoom?: Maybe<Scalars['String']['output']>;
  frontShoulderRoom?: Maybe<Scalars['String']['output']>;
  secondShoulderRoom?: Maybe<Scalars['String']['output']>;
  thirdShoulderRoom?: Maybe<Scalars['String']['output']>;
  cargoCapacityMaximum?: Maybe<Scalars['String']['output']>;
  basicWarranty?: Maybe<Scalars['String']['output']>;
  powertrainWarranty?: Maybe<Scalars['String']['output']>;
  assistanceWarranty?: Maybe<Scalars['String']['output']>;
  hybirdBatteryWarranty?: Maybe<Scalars['String']['output']>;
  chargePower?: Maybe<Scalars['String']['output']>;
  chargeTime110_120V?: Maybe<Scalars['String']['output']>;
  chargeTime220_240V?: Maybe<Scalars['String']['output']>;
  chargeTime440V?: Maybe<Scalars['String']['output']>;
  batteryCapacity?: Maybe<Scalars['String']['output']>;
  powerWindows?: Maybe<Scalars['String']['output']>;
  engineType?: Maybe<Scalars['String']['output']>;
  plugInElectricFastCharge?: Maybe<Scalars['String']['output']>;
  fuelType?: Maybe<Scalars['String']['output']>;
  aluminumWheels?: Maybe<Scalars['String']['output']>;
  chromeWheels?: Maybe<Scalars['String']['output']>;
  steelWheels?: Maybe<Scalars['String']['output']>;
  powerSteering?: Maybe<Scalars['String']['output']>;
  climateControl?: Maybe<Scalars['String']['output']>;
  multiZoneAC?: Maybe<Scalars['String']['output']>;
  frontAC?: Maybe<Scalars['String']['output']>;
  rearAC?: Maybe<Scalars['String']['output']>;
  tiltAndTelescopingSteeringWheel?: Maybe<Scalars['String']['output']>;
  cruiseControl?: Maybe<Scalars['String']['output']>;
  adaptiveCruiseControl?: Maybe<Scalars['String']['output']>;
  cruiseControlSteeringAssist?: Maybe<Scalars['String']['output']>;
  bluetoothConnection?: Maybe<Scalars['String']['output']>;
  keylessStart?: Maybe<Scalars['String']['output']>;
  remoteEngineStart?: Maybe<Scalars['String']['output']>;
  tripComputer?: Maybe<Scalars['String']['output']>;
  backUpCamera?: Maybe<Scalars['String']['output']>;
  rearParkingAid?: Maybe<Scalars['String']['output']>;
  automaticParking?: Maybe<Scalars['String']['output']>;
  remoteParkingSystem?: Maybe<Scalars['String']['output']>;
  securitySystem?: Maybe<Scalars['String']['output']>;
  engineImmobilizer?: Maybe<Scalars['String']['output']>;
  keylessEntry?: Maybe<Scalars['String']['output']>;
  heatedMirrors?: Maybe<Scalars['String']['output']>;
  driverIlluminatedVanityMirror?: Maybe<Scalars['String']['output']>;
  passengerIlluminatedVisorMirror?: Maybe<Scalars['String']['output']>;
  seatTrim?: Maybe<Scalars['String']['output']>;
  frontSeatType?: Maybe<Scalars['String']['output']>;
  heatedFrontSeats?: Maybe<Scalars['String']['output']>;
  heatedRearSeats?: Maybe<Scalars['String']['output']>;
  powerDriverSeatControls?: Maybe<Scalars['String']['output']>;
  powerPassengerSeatControls?: Maybe<Scalars['String']['output']>;
  rearBenchSeats?: Maybe<Scalars['String']['output']>;
  rearBucketSeats?: Maybe<Scalars['String']['output']>;
  secondRowChildSeat?: Maybe<Scalars['String']['output']>;
  integratedNavigation?: Maybe<Scalars['String']['output']>;
  turnByTurnNavigation?: Maybe<Scalars['String']['output']>;
  driverAirBag?: Maybe<Scalars['String']['output']>;
  passengerAirBag?: Maybe<Scalars['String']['output']>;
  passengerAirBagSensor?: Maybe<Scalars['String']['output']>;
  frontSideAirBag?: Maybe<Scalars['String']['output']>;
  rearSideAirBag?: Maybe<Scalars['String']['output']>;
  absBrakes?: Maybe<Scalars['String']['output']>;
  fourWheelDiscBrakes?: Maybe<Scalars['String']['output']>;
  fourWheelDrumBrakes?: Maybe<Scalars['String']['output']>;
  frontDiscRearDrumBrakes?: Maybe<Scalars['String']['output']>;
  tractionControl?: Maybe<Scalars['String']['output']>;
  blindSpotMonitor?: Maybe<Scalars['String']['output']>;
  laneDepartureWarning?: Maybe<Scalars['String']['output']>;
  crossTrafficAlert?: Maybe<Scalars['String']['output']>;
  laneKeepingAssist?: Maybe<Scalars['String']['output']>;
  driverAttentionMonitor?: Maybe<Scalars['String']['output']>;
  frontCollisionMitigation?: Maybe<Scalars['String']['output']>;
  rearCollisionMitigation?: Maybe<Scalars['String']['output']>;
  brakeAssist?: Maybe<Scalars['String']['output']>;
  automaticHeadlights?: Maybe<Scalars['String']['output']>;
  daytimeRunningLights?: Maybe<Scalars['String']['output']>;
  turnSignalInDoorMirrors?: Maybe<Scalars['String']['output']>;
  childDoorLocks?: Maybe<Scalars['String']['output']>;
  electronicStabilityControl?: Maybe<Scalars['String']['output']>;
  lowTirePressureWarning?: Maybe<Scalars['String']['output']>;
  entertainmentSystem?: Maybe<Scalars['String']['output']>;
  rearSeatAudioControls?: Maybe<Scalars['String']['output']>;
  amFmStereo?: Maybe<Scalars['String']['output']>;
  satelliteRadio?: Maybe<Scalars['String']['output']>;
  grossVehicleWeightRating?: Maybe<Scalars['String']['output']>;
  maximumTowingCapacity?: Maybe<Scalars['String']['output']>;
  engineSize?: Maybe<Scalars['String']['output']>;
  cylinders?: Maybe<Scalars['String']['output']>;
  fuelSystem?: Maybe<Scalars['String']['output']>;
  fuelTankCapacity?: Maybe<Scalars['String']['output']>;
  thirdRowSeat?: Maybe<Scalars['String']['output']>;
  maximumPayloadCapacity?: Maybe<Scalars['String']['output']>;
  cargoBoxLength?: Maybe<Scalars['String']['output']>;
  cargoBoxWidth?: Maybe<Scalars['String']['output']>;
  cargoBoxHeight?: Maybe<Scalars['String']['output']>;
  frontSuspensionType?: Maybe<Scalars['String']['output']>;
  rearSuspensionType?: Maybe<Scalars['String']['output']>;
};

export type Trim = {
  __typename?: 'Trim';
  styleId?: Maybe<Scalars['String']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  segment?: Maybe<CarSegment>;
  subsegment?: Maybe<CarSubsegment>;
  data?: Maybe<TrimData>;
  images: Array<Image>;
  startingMSRP?: Maybe<Scalars['String']['output']>;
  minMSRP?: Maybe<Scalars['Float']['output']>;
  maxMSRP?: Maybe<Scalars['Float']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewLink?: Maybe<Scalars['String']['output']>;
  bestLinkRanks?: Maybe<Array<Maybe<CarBestListRank>>>;
};

export type ModelDataItem = {
  __typename?: 'ModelDataItem';
  type: Scalars['String']['output'];
  values?: Maybe<Array<Scalars['String']['output']>>;
};

export type ModelData = {
  __typename?: 'ModelData';
  segment?: Maybe<CarSegment>;
  subsegment?: Maybe<CarSubsegment>;
  images: Array<Image>;
  startingMSRP?: Maybe<ModelDataItem>;
  engine: ModelDataItem;
  horsepower?: Maybe<ModelDataItem>;
  drivetrain: ModelDataItem;
  seatingCapacity: ModelDataItem;
  cargoCapacity?: Maybe<ModelDataItem>;
  basicYears?: Maybe<ModelDataItem>;
  basicMiles?: Maybe<ModelDataItem>;
  chargeTime?: Maybe<ModelDataItem>;
  estimatedBatteryRange?: Maybe<ModelDataItem>;
  combinedFuelEconomy?: Maybe<ModelDataItem>;
};

export type CarData = {
  __typename?: 'CarData';
  trims: Array<Trim>;
};

export type Make = {
  __typename?: 'Make';
  name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Model = {
  __typename?: 'Model';
  name?: Maybe<Scalars['String']['output']>;
  id?: Maybe<Scalars['String']['output']>;
};

export type Year = {
  __typename?: 'Year';
  year?: Maybe<Scalars['String']['output']>;
};

export type ReviewLink = {
  __typename?: 'ReviewLink';
  url?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
};

export type CarTrim = {
  __typename?: 'CarTrim';
  id?: Maybe<Scalars['String']['output']>;
  name?: Maybe<Scalars['String']['output']>;
};

export type CarIngestionLog = {
  __typename?: 'CarIngestionLog';
  id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
};

export type CarIngestionLogEvent = {
  __typename?: 'CarIngestionLogEvent';
  ingestionLog?: Maybe<CarIngestionLog>;
  id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  eventType?: Maybe<Scalars['String']['output']>;
  payload?: Maybe<Scalars['JSON']['output']>;
};

export type CarDataExportItem = {
  __typename?: 'CarDataExportItem';
  make: Scalars['String']['output'];
  model: Scalars['String']['output'];
  year: Scalars['String']['output'];
  trim: Scalars['String']['output'];
  style: Scalars['String']['output'];
  styleId: Scalars['String']['output'];
  msrp?: Maybe<Scalars['Float']['output']>;
  sequence?: Maybe<Scalars['String']['output']>;
  specs?: Maybe<Scalars['JSON']['output']>;
  categories?: Maybe<Scalars['JSON']['output']>;
  norms?: Maybe<Scalars['JSON']['output']>;
  standards?: Maybe<Scalars['JSON']['output']>;
};

export type CarDataExport = {
  __typename?: 'CarDataExport';
  data: Array<CarDataExportItem>;
};

export type CarBestList = {
  __typename?: 'CarBestList';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  link?: Maybe<Scalars['String']['output']>;
  ranks?: Maybe<Array<Maybe<CarBestListRank>>>;
};

export type BestListRankDetail = {
  __typename?: 'BestListRankDetail';
  id: Scalars['ID']['output'];
  category: Scalars['String']['output'];
  rating: Scalars['Float']['output'];
  order: Scalars['Int']['output'];
};

export type BestListRankMake = {
  __typename?: 'BestListRankMake';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
};

export type BestListRankModel = {
  __typename?: 'BestListRankModel';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  year?: Maybe<Scalars['String']['output']>;
  make?: Maybe<BestListRankMake>;
};

export type BestListRankStyle = {
  __typename?: 'BestListRankStyle';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  model?: Maybe<BestListRankModel>;
};

export type CarBestListRank = {
  __typename?: 'CarBestListRank';
  id: Scalars['ID']['output'];
  styleId: Scalars['String']['output'];
  style?: Maybe<BestListRankStyle>;
  rank: Scalars['Int']['output'];
  rating: Scalars['Float']['output'];
  bestList?: Maybe<CarBestList>;
  rankDetails: Array<Maybe<BestListRankDetail>>;
};

export type CarBestListRankDetailInput = {
  category: Scalars['String']['input'];
  rating: Scalars['Float']['input'];
  order: Scalars['Int']['input'];
};

export type CarBestListRankInput = {
  styleId: Scalars['String']['input'];
  rank: Scalars['Int']['input'];
  rating: Scalars['Float']['input'];
  rankDetails: Array<CarBestListRankDetailInput>;
};

export type CarBestListInput = {
  name: Scalars['String']['input'];
  link?: InputMaybe<Scalars['String']['input']>;
};

export type CarModelBestListTrim = {
  __typename?: 'CarModelBestListTrim';
  styleId: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  sequence: Scalars['Int']['output'];
  segment?: Maybe<CarSegment>;
  subsegment?: Maybe<CarSubsegment>;
  ranks?: Maybe<Array<CarBestListRank>>;
  images?: Maybe<Array<Image>>;
};

export type CarModelBestList = {
  __typename?: 'CarModelBestList';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  reviewLink?: Maybe<Scalars['String']['output']>;
  year: Scalars['String']['output'];
  make: Scalars['String']['output'];
  trims?: Maybe<Array<CarModelBestListTrim>>;
  minMSRP?: Maybe<Scalars['Float']['output']>;
  maxMSRP?: Maybe<Scalars['Float']['output']>;
};

export type RewardRateBreakdown = {
  __typename?: 'RewardRateBreakdown';
  rate?: Maybe<Scalars['Float']['output']>;
  description?: Maybe<Scalars['String']['output']>;
};

export enum ContentConfigPodcastSource {
  Spotify = 'SPOTIFY'
}

export enum ContentConfigItemType {
  Post = 'POST',
  Button = 'BUTTON',
  Link = 'LINK',
  Video = 'VIDEO',
  Podcast = 'PODCAST',
  Text = 'TEXT'
}

export enum ContentConfigPostItemType {
  Article = 'ARTICLE',
  Review = 'REVIEW',
  FlexPage = 'FLEX_PAGE',
  Roundup = 'ROUNDUP'
}

export type ContentConfigItem = {
  type: ContentConfigItemType;
};

export type ContentConfigPostOverrideItem = {
  __typename?: 'ContentConfigPostOverrideItem';
  title?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  url?: Maybe<Scalars['URL']['output']>;
  imageUrl?: Maybe<Scalars['URL']['output']>;
};

export type ContentConfigGroup = {
  __typename?: 'ContentConfigGroup';
  title?: Maybe<Scalars['String']['output']>;
  type: ContentConfigItemType;
  isNew: Scalars['Boolean']['output'];
  imageUrl?: Maybe<Scalars['URL']['output']>;
  items: Array<ContentConfigItem>;
};

export type ContentConfig = {
  __typename?: 'ContentConfig';
  id: Scalars['ID']['output'];
  groups: Array<ContentConfigGroup>;
};

export type ContentConfigsResponse = {
  __typename?: 'ContentConfigsResponse';
  configs: Array<ContentConfig>;
};

/** Controls whether the response is cacheable by clients and shared (proxy) caches. PRIVATE by default. */
export enum CacheControlScope {
  Public = 'PUBLIC',
  Private = 'PRIVATE'
}

export type OffsetPaginationInput = {
  /** The maximum number of results to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The start index of the results to return. Useful for pagination. */
  offset?: InputMaybe<Scalars['Int']['input']>;
};

export enum ApplicationActionTargetType {
  WebLink = 'WEB_LINK',
  Navigation = 'NAVIGATION',
  Billshark = 'BILLSHARK',
  MyBillsSuggested = 'MY_BILLS_SUGGESTED',
  LinkAccount = 'LINK_ACCOUNT',
  LinkHome = 'LINK_HOME',
  SelfReportedIncome = 'SELF_REPORTED_INCOME',
  TuActivation = 'TU_ACTIVATION'
}

export type ApplicationAction = {
  __typename?: 'ApplicationAction';
  /** A string that describes the type of action (used for analytics). */
  name?: Maybe<Scalars['String']['output']>;
  /** The user-facing copy on the action button/link. */
  text: Scalars['String']['output'];
  /** A NerdWallet mobile app deep link. */
  mobileTarget?: Maybe<Scalars['String']['output']>;
  /** Typically a web URL. If mobileTarget is not specified or invalid, this will open in a webview. */
  target?: Maybe<Scalars['String']['output']>;
  /** A string that tells the client how to handle this action. Only used on Web. */
  targetType?: Maybe<ApplicationActionTargetType>;
  /** Indicates whether the provided target is a place where the user can fulfill the described action. */
  leadsToUserActionFulfillment?: Maybe<Scalars['Boolean']['output']>;
};

export enum FeatureDiscoveryTypeEnum {
  FullScreen = 'FULL_SCREEN',
  ContextualSectionListPopup = 'CONTEXTUAL_SECTION_LIST_POPUP'
}

export enum FeatureDiscoveryFullScreenImageTypeEnum {
  Hero = 'HERO',
  Square = 'SQUARE'
}

export enum FeatureDiscoveryFullScreenModuleTriggerEnum {
  Startup = 'STARTUP'
}

export enum FeatureDiscoveryContextualSectionListPopupPositionEnum {
  Above = 'ABOVE',
  Below = 'BELOW'
}

/** Base interface for all feature discovery modules */
export type FeatureDiscoveryModuleInterface = {
  /**
   * Intended to be a unique identifier. Could technically use featureName as a unique identifier
   *   but technically the same feature could be featured multiple times
   */
  id: Scalars['ID']['output'];
  /** The type of module for feature highlighting */
  type: FeatureDiscoveryTypeEnum;
  /**
   * The priority value of the module. Currently based on the array order of the FEATURE_DISCOVERY
   *   app-config. This is a new value from the legacy Feature Discovery which allows multiple
   *   modules of the same type. E.g. we may want mulitple full screen modules to be highlighted
   *   at startup, so the lower priority modules will appear in subsequent startups.
   */
  priority: Scalars['Int']['output'];
};

/** The properties pertaining to the content and destination of the primary CTA in the UI */
export type FeatureDiscoveryFullScreenModulePrimaryAction = {
  __typename?: 'FeatureDiscoveryFullScreenModulePrimaryAction';
  /** The CTA text */
  text: Scalars['String']['output'];
  /** The mobile URL for deeplinking */
  mobileTarget: Scalars['String']['output'];
  /** The analytics name for the delphi impression event */
  delphiEntityName: Scalars['String']['output'];
};

/** The properties pertaining to the pill in the UI */
export type FeatureDiscoveryFullScreenPill = {
  __typename?: 'FeatureDiscoveryFullScreenPill';
  /** The pill text */
  text: Scalars['String']['output'];
  /** The color string of the pill container. Defaults to Green100 on the client. */
  backgroundColorName: Scalars['String']['output'];
  /** The color string of the pill text. Defaults to Green600 on the client. */
  textColorName: Scalars['String']['output'];
};

/** The properties pertaining to the highlight text in the UI */
export type FeatureDiscoveryContextualPopupHighlight = {
  __typename?: 'FeatureDiscoveryContextualPopupHighlight';
  /** The highlight text */
  text: Scalars['String']['output'];
  /** The color string of the highlight text. Defaults to white in the client. */
  textColorName: Scalars['String']['output'];
};

export type NativeFeatureDiscoveryResponse = {
  __typename?: 'NativeFeatureDiscoveryResponse';
  modules?: Maybe<Array<Maybe<FeatureDiscoveryModuleInterface>>>;
};

export enum FinancialAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export enum FinancialAccountType {
  Bank = 'BANK',
  Bill = 'BILL',
  CreditCard = 'CREDIT_CARD',
  Insurance = 'INSURANCE',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE',
  Reward = 'REWARD',
  Stuff = 'STUFF',
  Vehicle = 'VEHICLE'
}

export enum FinancialAccountSubtype {
  Bill = 'BILL',
  Checking = 'CHECKING',
  CreditCard = 'CREDIT_CARD',
  Invalid = 'INVALID',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER',
  RealEstate = 'REAL_ESTATE',
  Retirement = 'RETIREMENT',
  Reward = 'REWARD',
  Savings = 'SAVINGS',
  Stuff = 'STUFF',
  Vehicle = 'VEHICLE'
}

export enum FinancialAccountAccountNames {
  NwManualTransactionAccount = 'NW_MANUAL_TRANSACTION_ACCOUNT'
}

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/accounts
 */
export type FinancialAccount = {
  __typename?: 'FinancialAccount';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int']['output'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  autoRefreshRequired?: Maybe<Scalars['Boolean']['output']>;
  /** The "cent-normalized" account balance as an integer. e.g. 100 equals $1.00 */
  balance?: Maybe<Scalars['BigInt']['output']>;
  /** The currency code that transactions on the account are in */
  currency?: Maybe<Scalars['FinancialCurrency']['output']>;
  /** JSON Formatted fields related to specific account types: APR, CreditLimit, etc */
  extra?: Maybe<Scalars['JSON']['output']>;
  /** The financial portal under which the account resides */
  financialPortal?: Maybe<FinancialPortal>;
  /** IAV verification status flag */
  iavVerified?: Maybe<Scalars['Boolean']['output']>;
  /** The date at which the account was last synced */
  lastSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** Account mask */
  mask?: Maybe<Scalars['String']['output']>;
  /** Account name */
  name?: Maybe<Scalars['String']['output']>;
  /** Account status */
  status?: Maybe<FinancialAccountStatus>;
  /** Account sub-type */
  subtype?: Maybe<FinancialAccountSubtype>;
  /** Account sub-type details, e.g. "CHECKING_ACCOUNT", "PREPAID_CARD", "FSA" */
  subtypeDetails?: Maybe<Scalars['String']['output']>;
  /** Timestamp of the last transactions sync for the account */
  transactionsSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The type of account, e.g. "bank" or "investment" */
  type?: Maybe<FinancialAccountType>;
  /** Verification state of the account */
  verificationState?: Maybe<Scalars['String']['output']>;
  /** Whether the account is included in calculations and visible to the user */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the account is hidden from net worth calculations */
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the financial account is pending deletion. */
  deleteQueuedAt?: Maybe<Scalars['String']['output']>;
  /** Whether the financial account has been flagged as closed or inactive. */
  flaggedForClosureAt?: Maybe<Scalars['String']['output']>;
};

export type FinancialAccountSnapshot = {
  __typename?: 'FinancialAccountSnapshot';
  account_id: Scalars['ID']['output'];
  amount: Scalars['Int']['output'];
  created_at: Scalars['DateTime']['output'];
  date: Scalars['DateTime']['output'];
  identity_id: Scalars['ID']['output'];
  updated_at: Scalars['DateTime']['output'];
};

export type GetFinancialAccountsResponse = {
  __typename?: 'GetFinancialAccountsResponse';
  accounts?: Maybe<Array<FinancialAccount>>;
};

export type IavDetailsResponse = {
  __typename?: 'IAVDetailsResponse';
  accountNumber: Scalars['String']['output'];
  holderNames: Array<Scalars['String']['output']>;
  routingNumber: Scalars['String']['output'];
};

export type FinancialAccountsIavDetailsResponse = {
  __typename?: 'FinancialAccountsIAVDetailsResponse';
  details: Array<IavDetailsResponse>;
};

export type FinancialAccountTypeSumsResponse = {
  __typename?: 'FinancialAccountTypeSumsResponse';
  /** Sum of ALL assets, i.e. bank balances + investments in cents */
  assets: Scalars['BigInt']['output'];
  /** Sum of bank balances in cents */
  banks: Scalars['BigInt']['output'];
  /** Sum of bill balances in cents */
  bills: Scalars['BigInt']['output'];
  /** Sum of credit card balances (unsigned) in cents */
  creditCards: Scalars['BigInt']['output'];
  /** Sum of ALL debts (unsigned), i.e. credit card balances + loan balances in cents */
  debts: Scalars['BigInt']['output'];
  /** Sum of investments in cents */
  investments: Scalars['BigInt']['output'];
  /** Sum of loans (unsigned) in cents */
  loans: Scalars['BigInt']['output'];
  /** Sum of other account balances in cents */
  other: Scalars['BigInt']['output'];
};

export type CreateManualTransactionAccountResponse = {
  __typename?: 'CreateManualTransactionAccountResponse';
  financialAccount: FinancialAccount;
};

export type CreateUserFinancialAccountResponse = {
  __typename?: 'CreateUserFinancialAccountResponse';
  financialAccount: FinancialAccount;
};

export type DeleteUserFinancialAccountResponse = {
  __typename?: 'DeleteUserFinancialAccountResponse';
  success: Scalars['Boolean']['output'];
  financialAccount?: Maybe<FinancialAccount>;
};

export type UpdateFinancialAccountResponse = {
  __typename?: 'UpdateFinancialAccountResponse';
  financialAccount: FinancialAccount;
};

export enum FinancialCreditCardRewardEnum {
  AcquiredEligibleCreditCard = 'ACQUIRED_ELIGIBLE_CREDIT_CARD',
  ActivatedEligibleCreditCard = 'ACTIVATED_ELIGIBLE_CREDIT_CARD',
  PaidEligibleCreditCardOnTime = 'PAID_ELIGIBLE_CREDIT_CARD_ON_TIME'
}

export enum FinancialBankingRewardEnum {
  AcquiredEligibleBankAccount = 'ACQUIRED_ELIGIBLE_BANK_ACCOUNT',
  MadeDirectDepositForEligibleBankAccount = 'MADE_DIRECT_DEPOSIT_FOR_ELIGIBLE_BANK_ACCOUNT',
  SavingsAccountFunded = 'SAVINGS_ACCOUNT_FUNDED'
}

export enum FinancialNwPlusRewardProductEnum {
  Other = 'OTHER',
  CreditCards = 'CREDIT_CARDS',
  Banking = 'BANKING'
}

export enum FinancialAccountLinkStatusEnum {
  NotLinked = 'NOT_LINKED',
  Pending = 'PENDING',
  Successful = 'SUCCESSFUL',
  Failed = 'FAILED'
}

export enum NwPlusShoppingRewardEligibilityStatusEnum {
  Eligible = 'ELIGIBLE',
  Restricted = 'RESTRICTED'
}

export enum NwPlusShoppingRewardPathEnum {
  UnknownRewardPathType = 'UNKNOWN_REWARD_PATH_TYPE',
  CreditCardOnTimePayment = 'CREDIT_CARD_ON_TIME_PAYMENT',
  BankingDirectDeposit = 'BANKING_DIRECT_DEPOSIT',
  BankingFundedAccount = 'BANKING_FUNDED_ACCOUNT'
}

export enum NerdWalletPlusCreditCardActivationStatusEnum {
  /** User is not yet a NW+ member when they applied for a NW+ eligible card */
  Pending = 'PENDING',
  /** User was already a NW+ member when they applied for a NW+ eligible card */
  AlreadyActive = 'ALREADY_ACTIVE',
  /**
   * User became a NW+ member after they applied for a NW+ eligible card, but the time
   *   window for receiving rewards for the card has passed
   */
  ActivatedLate = 'ACTIVATED_LATE'
}

export enum NwPlusUserEligibleOfferStatusEnum {
  /** User is eligible to earn rewards for the offer */
  Eligible = 'ELIGIBLE',
  /** User has already earned rewards for the offer */
  IneligibleAlreadyAcquired = 'INELIGIBLE_ALREADY_ACQUIRED',
  /** User has already earned a reward with an offer from the same institution */
  IneligibleProductInstitutionLimit = 'INELIGIBLE_PRODUCT_INSTITUTION_LIMIT',
  /** User has already earned the maximum points allowed in a year */
  IneligibleYearlyMaxPointsEarned = 'INELIGIBLE_YEARLY_MAX_POINTS_EARNED'
}

export enum NwPlusRewardStepStatus {
  NoStatus = 'NO_STATUS',
  Pending = 'PENDING',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type NwPlusRichText = {
  __typename?: 'NwPlusRichText';
  text: Scalars['String']['output'];
  links?: Maybe<Array<NwPlusFaqLink>>;
};

export type FinancialNwPlusRewardStep = {
  __typename?: 'FinancialNwPlusRewardStep';
  title: NwPlusRichText;
  tagline?: Maybe<NwPlusRichText>;
  alertMessage?: Maybe<NwPlusRichText>;
  extraTagline?: Maybe<NwPlusRichText>;
  failedTagline?: Maybe<NwPlusRichText>;
  status: NwPlusRewardStepStatus;
  analyticsStatus: Scalars['String']['output'];
  ctaText?: Maybe<NwPlusRichText>;
  infoMessage?: Maybe<NwPlusRichText>;
};

/** Represents a common set of fields for all NW+ eligible product types */
export type FinancialNwPlusRewardInterface = {
  /** Unique ID for NW+ product reward tracking */
  id: Scalars['ID']['output'];
  /**
   * ID of the shopping finished event
   * @deprecated Same as id
   */
  shoppingFinishedId: Scalars['ID']['output'];
  /** When the Shopping Finished event has occurred */
  shoppingFinishedAt: Scalars['DateTime']['output'];
  /** Represents the type of product */
  productType?: Maybe<FinancialNwPlusRewardProductEnum>;
  /**
   * When we've received a Transaction Completed event, confirming that a user has successfully
   *   acquired the product through NW
   * @deprecated Use shoppingFinishedAt
   */
  transactionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Marketplace Institution ID associated with the Shopping Finished event */
  marketplaceInstitutionId: Scalars['ID']['output'];
  /** The Marketplace Product ID associated with the Shopping Finished event */
  marketplaceProductId: Scalars['ID']['output'];
  /** The Marketplace Offer ID associated with the Shopping Finished event */
  marketplaceOfferId: Scalars['ID']['output'];
  /**
   * NerdWallet+ reward eligibility status based on when a user became a NW+ member,
   *   relative to the shopping event
   */
  nwPlusActivationStatus: NerdWalletPlusCreditCardActivationStatusEnum;
  /** NerdWallet+ reward eligibility status based on the offer, relative to similar products */
  rewardEligibilityStatus?: Maybe<NwPlusShoppingRewardEligibilityStatusEnum>;
  /** The type of reward this shopping event can earn points for */
  rewardPathType?: Maybe<NwPlusShoppingRewardPathEnum>;
  /** The ID of the FDP Account associated with the marketplace product */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** When a user has associated an FDP account */
  accountLinkedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of account linking */
  accountLinkStatus?: Maybe<FinancialAccountLinkStatusEnum>;
  /** The FDP Account associated with the marketplace product */
  fdpAccount?: Maybe<FinancialAccount>;
  /** The steps for completing this reward. */
  steps: Array<FinancialNwPlusRewardStep>;
};


/** Represents a common set of fields for all NW+ eligible product types */
export type FinancialNwPlusRewardInterfaceStepsArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** Represents a common set of fields for all rewardable events for NW+ eligible product types */
export type FinancialNwPlusRewardEventInterface = {
  /** Unique ID for credit card reward event */
  id: Scalars['ID']['output'];
  /** The date when the event that was emitted */
  emittedAt: Scalars['DateTime']['output'];
  /** When the rewarded event has been viewed by a user */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The points earned for the reward */
  pointsRewarded?: Maybe<Scalars['Int']['output']>;
};

export type FinancialCreditCardRewardFilterInput = {
  /** Only return credit cards with a Shopping Finished event that occurred after the provided date */
  shoppingFinishedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return credit cards with a Shopping Finished event that occurred before the provided date */
  shoppingFinishedBefore?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialNwPlusRewardFilterInput = {
  /** Only return entries with a Shopping Finished event that occurred after the provided date */
  shoppingFinishedAfter?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return entries with a Shopping Finished event that occurred before the provided date */
  shoppingFinishedBefore?: InputMaybe<Scalars['DateTime']['input']>;
  /** Filter based on specified product types */
  productTypes?: InputMaybe<Array<FinancialNwPlusRewardProductEnum>>;
  /** Filter based on dismiss status */
  isUserDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Filter out shopping events that can't earn points */
  excludeIneligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Apply filtering logic specifically for reward trackers */
  forRewardTrackers?: InputMaybe<Scalars['Boolean']['input']>;
};

export type FinancialCreditCardRewardProgress = {
  __typename?: 'FinancialCreditCardRewardProgress';
  /** True if a user has applied for a NW+ eligible Credit Card */
  hasAppliedForCard: Scalars['Boolean']['output'];
  /** True if NW has confirmed via PDI that a user has been approved for the Card */
  hasConfirmedCardApproval: Scalars['Boolean']['output'];
  /** True if a user has linked the credit card account with Plaid */
  hasLinkedAccount: Scalars['Boolean']['output'];
  /** True if a user has made a transaction with the card */
  hasActivatedCard: Scalars['Boolean']['output'];
  /** True if a user has made the minimum payment on their first statement */
  hasMadeOnTimePayment: Scalars['Boolean']['output'];
  /** We weren't able to confirm via PDI that the user has been approved for the card */
  hasCardApprovalConfirmationExpired: Scalars['Boolean']['output'];
  /** No longer eligible for the activation reward */
  hasActivationRewardExpired: Scalars['Boolean']['output'];
  /** No longer eligible for the on-time payment reward */
  hasOnTimePaymentRewardExpired: Scalars['Boolean']['output'];
  /** Indicates if there is an expired error to show */
  hasExpiredErrorsToReport: Scalars['Boolean']['output'];
  /** Indicates if user did not link account in time */
  hasLinkedAccountExpired: Scalars['Boolean']['output'];
};

export type FinancialBankingRewardProgress = {
  __typename?: 'FinancialBankingRewardProgress';
  /** True if a user has applied for a NW+ eligible banking account */
  hasAppliedForBankingAccount: Scalars['Boolean']['output'];
  /**
   * True if NW has confirmed via PDI that a user has actually opened an account (for direct deposit reward)
   *   or an associated account has been linked with Plaid (for funded account)
   */
  hasConfirmedBankingAccount: Scalars['Boolean']['output'];
  /** True if a user has linked the banking account with Plaid */
  hasLinkedAccount: Scalars['Boolean']['output'];
  /** True if a user has made a direct deposit */
  hasMadeDirectDeposit: Scalars['Boolean']['output'];
  /** True if the account has been funded */
  hasFundedAccount: Scalars['Boolean']['output'];
  /** We weren't able to confirm via PDI that the user has opened a bank account */
  hasBankAccountConfirmationExpired: Scalars['Boolean']['output'];
  /** No longer eligible for the direct deposit reward */
  hasDirectDepositRewardExpired: Scalars['Boolean']['output'];
  /** No longer eligible for the funded account reward */
  hasFundedAccountRewardExpired: Scalars['Boolean']['output'];
  /** Indicates if there is an expired error to show */
  hasExpiredErrorsToReport: Scalars['Boolean']['output'];
  /** Indicates if user did not link account in time */
  hasLinkedAccountExpired: Scalars['Boolean']['output'];
};

export type FinancialCreditCardRewardResponse = {
  __typename?: 'FinancialCreditCardRewardResponse';
  creditCards: Array<FinancialCreditCardReward>;
};

export type FinancialNwPlusRewardResponse = {
  __typename?: 'FinancialNwPlusRewardResponse';
  creditCards: Array<FinancialCreditCardReward>;
  bankingAccounts: Array<FinancialBankingReward>;
};

export type UpdateFinancialCreditCardRewardViewedResponse = {
  __typename?: 'UpdateFinancialCreditCardRewardViewedResponse';
  creditCard?: Maybe<FinancialCreditCardReward>;
};

export type UpdateFinancialRewardViewedResponse = {
  __typename?: 'UpdateFinancialRewardViewedResponse';
  creditCard?: Maybe<FinancialCreditCardReward>;
  bankingAccount?: Maybe<FinancialBankingReward>;
};

export type UpdateFinancialNwPlusRewardDismissedResponse = {
  __typename?: 'UpdateFinancialNwPlusRewardDismissedResponse';
  creditCard?: Maybe<FinancialCreditCardReward>;
  bankingAccount?: Maybe<FinancialBankingReward>;
};

export type NwPlusUserEligibleCreditCardOffer = {
  __typename?: 'NwPlusUserEligibleCreditCardOffer';
  /** The Marketplace Offer ID */
  marketplaceOfferId: Scalars['ID']['output'];
  /** The Marketplace Credit Card Offer */
  marketplaceCreditCardOffer: CreditCardsOfferV2;
  /** Status indicating if a user can earn rewards with this offer */
  rewardEligibilityStatus: NwPlusUserEligibleOfferStatusEnum;
  /** If currently ineligible, the date when the offer will be eligible for NW+ rewards */
  eligibleAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NwPlusUserEligibleBankingOffer = {
  __typename?: 'NwPlusUserEligibleBankingOffer';
  /** The Marketplace Offer ID */
  marketplaceOfferId: Scalars['ID']['output'];
  /** The Marketplace Credit Card Offer */
  marketplaceBankingOffer: BankingOfferV2;
  /** Status indicating if a user can earn rewards with this offer */
  rewardEligibilityStatus: NwPlusUserEligibleOfferStatusEnum;
  /** If currently ineligible, the date when the offer will be eligible for NW+ rewards */
  eligibleAt?: Maybe<Scalars['DateTime']['output']>;
};

export type NwPlusUserEligibleOffersResponse = {
  __typename?: 'NwPlusUserEligibleOffersResponse';
  creditCards: Array<NwPlusUserEligibleCreditCardOffer>;
  bankingAccounts: Array<NwPlusUserEligibleBankingOffer>;
};

export type AnonymousShoppingEventsResponse = {
  __typename?: 'AnonymousShoppingEventsResponse';
  items?: Maybe<Array<Maybe<ShoppingEventItem>>>;
};

export type ShoppingEventItem = {
  __typename?: 'ShoppingEventItem';
  shoppingFinishedId?: Maybe<Scalars['String']['output']>;
  shoppingFinishedAt?: Maybe<Scalars['String']['output']>;
  marketplaceInstitutionId?: Maybe<Scalars['String']['output']>;
  marketplaceProductId?: Maybe<Scalars['String']['output']>;
  marketplaceOfferId?: Maybe<Scalars['String']['output']>;
  productType?: Maybe<Scalars['String']['output']>;
  nwPlusActivationStatus?: Maybe<Scalars['String']['output']>;
  anonymousId?: Maybe<Scalars['String']['output']>;
};

export enum FinancialPortalProductState {
  DataRetrieved = 'DATA_RETRIEVED',
  Null = 'NULL',
  PartialDataRetrieved = 'PARTIAL_DATA_RETRIEVED',
  RetrievalFailed = 'RETRIEVAL_FAILED',
  RetrievalInProgress = 'RETRIEVAL_IN_PROGRESS'
}

export enum FinancialPortalAuthState {
  Authenticated = 'AUTHENTICATED',
  Error = 'ERROR',
  Init = 'INIT',
  Null = 'NULL',
  UserActionRequired = 'USER_ACTION_REQUIRED'
}

export enum FinancialPortalPrimaryClientAction {
  Fix = 'FIX',
  GoToSite = 'GO_TO_SITE',
  Migrate = 'MIGRATE',
  Refresh = 'REFRESH',
  SearchToMigrate = 'SEARCH_TO_MIGRATE',
  TryOtherInstitution = 'TRY_OTHER_INSTITUTION',
  Unlink = 'UNLINK',
  UserConfirmation = 'USER_CONFIRMATION',
  LegacyFix = 'LEGACY_FIX'
}

export enum FinancialPortalErrorMessage {
  DataNotReady = 'DATA_NOT_READY',
  DataRetrievalFailed = 'DATA_RETRIEVAL_FAILED',
  InstitutionDown = 'INSTITUTION_DOWN',
  InstitutionNotSupported = 'INSTITUTION_NOT_SUPPORTED',
  InstitutionRequiresUserAction = 'INSTITUTION_REQUIRES_USER_ACTION',
  InternalError = 'INTERNAL_ERROR',
  InvalidCredentials = 'INVALID_CREDENTIALS',
  InvalidMfa = 'INVALID_MFA',
  InvalidMicrodepositAmount = 'INVALID_MICRODEPOSIT_AMOUNT',
  LoginRequired = 'LOGIN_REQUIRED',
  MfaNotSupported = 'MFA_NOT_SUPPORTED',
  MfaRequired = 'MFA_REQUIRED',
  NoDataOrAccount = 'NO_DATA_OR_ACCOUNT',
  NoEligibleAccounts = 'NO_ELIGIBLE_ACCOUNTS',
  NoInvestmentAccounts = 'NO_INVESTMENT_ACCOUNTS',
  NoLiabilityAccounts = 'NO_LIABILITY_ACCOUNTS',
  NoPropertyValue = 'NO_PROPERTY_VALUE',
  OtherError = 'OTHER_ERROR',
  PortalBlocked = 'PORTAL_BLOCKED',
  PortalLocked = 'PORTAL_LOCKED',
  ProductNotSupported = 'PRODUCT_NOT_SUPPORTED',
  TooManyVerificationAttempts = 'TOO_MANY_VERIFICATION_ATTEMPTS'
}

export enum FinancialPortalAlertMessage {
  NewAccount = 'NEW_ACCOUNT'
}

export type PlaidInstitutionInput = {
  /** The plaid id of an institution, e.g. `ins_4` */
  institutionId: Scalars['String']['input'];
  name: Scalars['String']['input'];
};

export type PlaidBalanceInput = {
  available?: InputMaybe<Scalars['Int']['input']>;
  current?: InputMaybe<Scalars['Int']['input']>;
};

/** See https://plaid.com/docs/#account-types */
export enum PlaidAccountType {
  Credit = 'CREDIT',
  Depository = 'DEPOSITORY',
  Investment = 'INVESTMENT',
  Loan = 'LOAN',
  Other = 'OTHER'
}

/** See https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-proxy/#operation/event */
export enum ProxyEventType {
  AuthenticationSuccess = 'AUTHENTICATION_SUCCESS',
  SourceEvent = 'SOURCE_EVENT',
  ResetLogin = 'RESET_LOGIN',
  FlowOpened = 'FLOW_OPENED',
  FlowClosed = 'FLOW_CLOSED',
  InstitutionSearched = 'INSTITUTION_SEARCHED',
  Exit = 'EXIT'
}

export enum PlaidInstitutionHealthStatus {
  Degraded = 'DEGRADED',
  Down = 'DOWN',
  Healthy = 'HEALTHY'
}

/** Documentation taken from Plaid docs: https://plaid.com/docs/#onsuccess-callback */
export enum PlaidVerificationStatus {
  /** an Item was successfully manually verified */
  ManuallyVerified = 'MANUALLY_VERIFIED',
  /** an Item is pending automated microdeposit verfication */
  PendingAutomaticVerification = 'PENDING_AUTOMATIC_VERIFICATION',
  /** an Item is pending manual microdeposit verification */
  PendingManualVerification = 'PENDING_MANUAL_VERIFICATION'
}

export type PlaidAccountInput = {
  balances?: InputMaybe<Array<PlaidBalanceInput>>;
  id: Scalars['String']['input'];
  mask?: InputMaybe<Scalars['String']['input']>;
  name?: InputMaybe<Scalars['String']['input']>;
  /**
   * There are a huge number of possible subtypes, and it depends on which type it is so for simplicity we're just accepting any string
   *   See https://plaid.com/docs/#account-subtypes
   */
  subtype?: InputMaybe<Scalars['String']['input']>;
  type?: InputMaybe<PlaidAccountType>;
  verificationStatus?: InputMaybe<PlaidVerificationStatus>;
};

export type FinancialPortalSourceMeta = {
  __typename?: 'FinancialPortalSourceMeta';
  /** Failed login attempts in the past 30 days */
  failedLoginAttemptsPast30Days?: Maybe<Scalars['Int']['output']>;
  /** Failed login attempts in the past hour */
  failedLoginAttemptsPastHour?: Maybe<Scalars['Int']['output']>;
  /** Date of last failed login */
  lastFailedLogin?: Maybe<Scalars['DateTime']['output']>;
  /** Date of last successful login */
  lastSuccessfulLogin?: Maybe<Scalars['DateTime']['output']>;
  /** The previous auth state */
  portalPreviousAuthState?: Maybe<FinancialPortalAuthState>;
  /** The Yodlee status code */
  portalStatusCode?: Maybe<Scalars['String']['output']>;
  /** The Yodlee status message */
  portalStatusMessage?: Maybe<Scalars['String']['output']>;
  /** The source access token */
  sourceAccessToken?: Maybe<Scalars['String']['output']>;
  /** The source entity id */
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  /** The Yodlee username (corresponds to the owner of this portal) */
  username?: Maybe<Scalars['String']['output']>;
};

export type FinancialPortalMigrationDetails = {
  __typename?: 'FinancialPortalMigrationDetails';
  /** A map of previous account id to new account id */
  accountsMapping?: Maybe<Scalars['JSON']['output']>;
  /** Whether the user has confirmed the migration is acceptable or not */
  hasUserConfirmed: Scalars['Boolean']['output'];
  /** Whether data for the new portal is currently being ported over */
  isDataPortInProgress: Scalars['Boolean']['output'];
  /** Whether data for the new portal has been retrieved */
  isDataRetrieved: Scalars['Boolean']['output'];
  /** The id of the portal being migrated from */
  migratedFromFinancialPortalId?: Maybe<Scalars['ID']['output']>;
  /** The id of the portal being migrated to */
  migratedToFinancialPortalId?: Maybe<Scalars['ID']['output']>;
  /** List of new account ids */
  newAccountIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** List of old account ids */
  oldAccountIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** The id of the marketplace account aggregation institution to migrate to, if a canonical id mapping exists */
  recommendedMarketplaceInstitutionId?: Maybe<Scalars['ID']['output']>;
  /** The source (e.g. Plaid) id of the institution to migrate to */
  recommendedSourceInstitutionId?: Maybe<Scalars['ID']['output']>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/financial_portals
 */
export type FinancialPortal = {
  __typename?: 'FinancialPortal';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int']['output'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** Accounts synchronization state for the portal */
  accountsState?: Maybe<FinancialPortalProductState>;
  /** A portal's migration state */
  activeMigration?: Maybe<Scalars['Boolean']['output']>;
  /** The alert message returned by the souce. */
  alertMessage?: Maybe<FinancialPortalAlertMessage>;
  /** The type of alert returned */
  alertName?: Maybe<Scalars['String']['output']>;
  /** The priority of the alert */
  alertPriority?: Maybe<Scalars['String']['output']>;
  /** Authentication state of the portal */
  authState?: Maybe<FinancialPortalAuthState>;
  /** The time at which the authentication state was set (ms precision) */
  authStateSetAt?: Maybe<Scalars['DateTime']['output']>;
  /** The id of the canonical institution this portal is associated with */
  canonicalInstitutionId?: Maybe<Scalars['ID']['output']>;
  /** The error message returned by the source if auth state went into "ERROR" */
  errorMessage?: Maybe<FinancialPortalErrorMessage>;
  /** The type of error returned if the auth state went into "ERROR" */
  errorName?: Maybe<Scalars['String']['output']>;
  /** The priority of the error */
  errorPriority?: Maybe<Scalars['String']['output']>;
  /** Whether the portal's data is being fetched for the first time */
  isActiveSync?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the financial portal is being automatically refreshed */
  isAutoRefreshing?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the financial portal's balance is being refreshed */
  isBalanceRefreshing?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the financial portal is being manually refreshed */
  isManualRefreshing?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the portal is refreshable */
  isRefreshable?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the portal is current refreshing (an OR of all types of refreshing) */
  isRefreshing?: Maybe<Scalars['Boolean']['output']>;
  /** The time at which the portal was last refreshed */
  lastRefreshedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The account aggregation institution this portal is associated with */
  marketplaceInstitution?: Maybe<AccountAggregationInstitution>;
  /**
   * The id of the acct agg institution this portal is associated with. This can be used instead of
   *   marketplaceInstitution.id to avoid an extra network request to marketplace
   */
  marketplaceInstitutionId?: Maybe<Scalars['ID']['output']>;
  /** Information on the state of a portal being migrated from vendor to vendor, if relevant */
  migrationDetails?: Maybe<FinancialPortalMigrationDetails>;
  /** The primary action for a client to take for an institution in a sub-optimal state */
  primaryClientAction?: Maybe<FinancialPortalPrimaryClientAction>;
  /** The secondary action for a client to take for an institution in a sub-optimal state */
  secondaryClientAction?: Maybe<Scalars['String']['output']>;
  /** The source institution id for the portal */
  sourceInstitutionId: Scalars['String']['output'];
  /** Contains metadata about the portal. Requires elevated permissions to query. */
  sourceMeta?: Maybe<FinancialPortalSourceMeta>;
  /** The transactions synchronization state for the portal */
  transactionsState?: Maybe<FinancialPortalProductState>;
  /** The financial accounts associated with this portal */
  accounts?: Maybe<Array<FinancialAccount>>;
  /** The time at which the portal was marked for offline deletion. */
  deleteQueuedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type GetPortalsResponse = {
  __typename?: 'GetPortalsResponse';
  portals?: Maybe<Array<FinancialPortal>>;
};

export type ReinitializeFinancialPortalResponseDetails = {
  __typename?: 'ReinitializeFinancialPortalResponseDetails';
  /** The link token used to open the Plaid fix flow with */
  linkToken?: Maybe<Scalars['ID']['output']>;
  /**
   * If there is an existing Plaid Item, use this token when opening Plaid Link to enter the fix flow
   * @deprecated For backwards compatibility, the values are the same but we should now be using the linkToken field
   */
  publicToken?: Maybe<Scalars['ID']['output']>;
  /** For a portal that should be migrated, the suggested marketplace account aggregation institution id */
  recommendedInstitutionId?: Maybe<Scalars['ID']['output']>;
  /** For a portal that should be migrated, the external (e.g. Plaid) id for the institution to link */
  recommendedSourceInstitutionId?: Maybe<Scalars['ID']['output']>;
};

export type ReinitializeFinancialPortalResponse = {
  __typename?: 'ReinitializeFinancialPortalResponse';
  financialPortal?: Maybe<FinancialPortal>;
  details?: Maybe<ReinitializeFinancialPortalResponseDetails>;
};

export type MigrateFinancialPortalResponse = {
  __typename?: 'MigrateFinancialPortalResponse';
  portal?: Maybe<FinancialPortal>;
};

export type FinishPortalMigrationResponse = {
  __typename?: 'FinishPortalMigrationResponse';
  portal?: Maybe<FinancialPortal>;
};

export type DeleteFinancialPortalResponse = {
  __typename?: 'DeleteFinancialPortalResponse';
  success: Scalars['Boolean']['output'];
};

export type FinancialPortalMessageResponse = {
  __typename?: 'FinancialPortalMessageResponse';
  portal?: Maybe<FinancialPortal>;
  success: Scalars['Boolean']['output'];
};

export type FinancialInstitutionStatusByProductDetails = {
  __typename?: 'FinancialInstitutionStatusByProductDetails';
  lastStatusChange?: Maybe<Scalars['DateTime']['output']>;
  status?: Maybe<PlaidInstitutionHealthStatus>;
};

/** Correlates to each of the "products" Plaid offers. Plaid breaks down the status of an institution on a per product basis. */
export type FinancialInstitutionStatusByProduct = {
  __typename?: 'FinancialInstitutionStatusByProduct';
  auth?: Maybe<FinancialInstitutionStatusByProductDetails>;
  balance?: Maybe<FinancialInstitutionStatusByProductDetails>;
  identity?: Maybe<FinancialInstitutionStatusByProductDetails>;
  itemLogins?: Maybe<FinancialInstitutionStatusByProductDetails>;
  transactionsUpdates?: Maybe<FinancialInstitutionStatusByProductDetails>;
};

export type FinancialInstitutionStatusResponse = {
  __typename?: 'FinancialInstitutionStatusResponse';
  status?: Maybe<FinancialInstitutionStatusByProduct>;
};

export type GetInstitutionHealthDetailsResponse = {
  __typename?: 'GetInstitutionHealthDetailsResponse';
  institution?: Maybe<FinancialInstitutionStatusResponse>;
};

export type InitializeLinkTokenResponse = {
  __typename?: 'InitializeLinkTokenResponse';
  token: Scalars['String']['output'];
};

/**
 * Used to filter a financial portal by fields such as its institution ID. The fields listed here are a subset of the complete list found here:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#operation/listFinancialPortals
 */
export type FinancialPortalFilterInput = {
  mpInstitutionId?: InputMaybe<Scalars['ID']['input']>;
};

export enum BillStreamFrequency {
  Annually = 'ANNUALLY',
  EveryOtherMonth = 'EVERY_OTHER_MONTH',
  Monthly = 'MONTHLY',
  SemiAnnually = 'SEMI_ANNUALLY',
  SemiMonthly = 'SEMI_MONTHLY',
  Biweekly = 'BIWEEKLY',
  Quarterly = 'QUARTERLY',
  Weekly = 'WEEKLY',
  Unknown = 'UNKNOWN'
}

export enum BillStreamStatus {
  Mature = 'MATURE',
  EarlyDetection = 'EARLY_DETECTION',
  Tombstoned = 'TOMBSTONED',
  Unknown = 'UNKNOWN'
}

export enum BillStreamType {
  /** Depository transaction bills */
  Inflow = 'INFLOW',
  /** Expense transaction bills */
  Outflow = 'OUTFLOW'
}

export enum BillStreamUserAction {
  None = 'NONE',
  Hidden = 'HIDDEN',
  Saved = 'SAVED'
}

export enum UpcomingBillStreamStatusEnum {
  /** Upcoming bill with a due date in the future */
  Future = 'FUTURE',
  /** Upcoming bill with a due date within the next 2 days */
  Upcoming = 'UPCOMING',
  /** Upcoming bill with a due date set over a day in the past and has not been paid */
  Overdue = 'OVERDUE',
  /** Upcoming bill that has been noted as paid for a specific due date */
  Paid = 'PAID'
}

export type BillStreamTransactionsInput = {
  /** The maximum number of results to return. Default is 10. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export type BillStreamFilterInput = {
  streamStatus?: InputMaybe<BillStreamStatus>;
};

export type BillStream = {
  __typename?: 'BillStream';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int']['output'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** ID of the FDP account associated with this bill */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** Base amount (in dollars and cents) of the bill */
  amount: Scalars['Float']['output'];
  /** Which financial V2 NW category ID the bill falls under. */
  categoryId?: Maybe<Scalars['ID']['output']>;
  /** A description of the bill */
  description: Scalars['String']['output'];
  /** The posted date of the earliest transaction in the bill */
  firstDate: Scalars['DateTime']['output'];
  /** Describes the frequency of the bill */
  frequency: BillStreamFrequency;
  /** The most recent associated bill's amount (in dollars and cents) */
  lastAmount?: Maybe<Scalars['Float']['output']>;
  /** The posted date of the latest transaction in the bill */
  lastDate: Scalars['DateTime']['output'];
  /** Indicates whether the bill is still live */
  isActive?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates the current state of the bill for the user */
  userAction: BillStreamUserAction;
  /** Merchant associated with the bill */
  merchantName?: Maybe<Scalars['String']['output']>;
  /** The next date this bill is due */
  nextDueDate?: Maybe<Scalars['DateTime']['output']>;
  /** Next several unpaid due dates */
  nextUnpaidDueDates?: Maybe<Array<Scalars['DateTime']['output']>>;
  /** When the bill was paid */
  paidDate?: Maybe<Scalars['DateTime']['output']>;
  /** Current status of the bill */
  status?: Maybe<BillStreamStatus>;
  /** Financial transaction IDs associated with the bill */
  transactionIds?: Maybe<Array<Scalars['ID']['output']>>;
  /** Financial transactions associated with the bill */
  transactions?: Maybe<Array<FinancialTransaction>>;
  /** Either INFLOW or OUTFLOW bill */
  flowType?: Maybe<BillStreamType>;
};


export type BillStreamTransactionsArgs = {
  input?: InputMaybe<BillStreamTransactionsInput>;
};

export type UpcomingBillStream = {
  __typename?: 'UpcomingBillStream';
  id: Scalars['ID']['output'];
  streamId: Scalars['ID']['output'];
  dueDate: Scalars['DateTime']['output'];
  status?: Maybe<UpcomingBillStreamStatusEnum>;
};

export type RemovedBillStream = {
  __typename?: 'RemovedBillStream';
  id: Scalars['ID']['output'];
  transactionIds?: Maybe<Array<Scalars['ID']['output']>>;
  transactions?: Maybe<Array<FinancialTransaction>>;
};

export type BillStreamsResponse = {
  __typename?: 'BillStreamsResponse';
  bills: Array<BillStream>;
};

export type DeleteBillStreamResponse = {
  __typename?: 'DeleteBillStreamResponse';
  success: Scalars['Boolean']['output'];
  /** Return the updated BillStream value for Plaid bills since they are dismissed instead of deleted */
  billStream?: Maybe<BillStream>;
};

/** The return type of the initializeUser mutation */
export type InitializeUserResponse = {
  __typename?: 'InitializeUserResponse';
  success: Scalars['Boolean']['output'];
  financialUser?: Maybe<FinancialDataUser>;
};

export type BillStreamResponse = {
  __typename?: 'BillStreamResponse';
  billStream?: Maybe<BillStream>;
};

export type UpcomingBillStreamsResponse = {
  __typename?: 'UpcomingBillStreamsResponse';
  currentMonthBills?: Maybe<Array<UpcomingBillStream>>;
  nextMonthBills?: Maybe<Array<UpcomingBillStream>>;
  horizonBills?: Maybe<Array<UpcomingBillStream>>;
  billStreams?: Maybe<Array<BillStream>>;
  currentMonthPaidAmount?: Maybe<Scalars['Float']['output']>;
  currentMonthUnPaidAmount?: Maybe<Scalars['Float']['output']>;
};

export type UpdateBillStreamTransactionsResponse = {
  __typename?: 'UpdateBillStreamTransactionsResponse';
  modifiedStreams?: Maybe<Array<BillStream>>;
  removedStreams?: Maybe<Array<RemovedBillStream>>;
};

export enum FinancialDataSource {
  Nerdwallet = 'NERDWALLET',
  Plaid = 'PLAID',
  Qa = 'QA',
  Redfin = 'REDFIN',
  User = 'USER',
  Yodlee = 'YODLEE'
}

/**
 * Deprecated in favor of the string category_ids
 * https://stage.nerdwallet.biz/api/financial-data-platform/categories
 */
export enum FinancialTransactionCategory {
  Childcare = 'CHILDCARE',
  Donations = 'DONATIONS',
  Entertainment = 'ENTERTAINMENT',
  Fees = 'FEES',
  Groceries = 'GROCERIES',
  Health = 'HEALTH',
  Housing = 'HOUSING',
  Income = 'INCOME',
  Insurance = 'INSURANCE',
  Other = 'OTHER',
  Pets = 'PETS',
  Restaurants = 'RESTAURANTS',
  Shopping = 'SHOPPING',
  Subscriptions = 'SUBSCRIPTIONS',
  Transfers = 'TRANSFERS',
  Transport = 'TRANSPORT',
  Travel = 'TRAVEL',
  Uncategorized = 'UNCATEGORIZED',
  Utilities = 'UTILITIES'
}

export enum FinancialTransactionTag {
  AccountFee = 'ACCOUNT_FEE',
  AccountFeeAnnual = 'ACCOUNT_FEE_ANNUAL',
  BankFeeAtm = 'BANK_FEE_ATM',
  BankFeeOverdraft = 'BANK_FEE_OVERDRAFT',
  CashWithdrawal = 'CASH_WITHDRAWAL',
  CheckPayment = 'CHECK_PAYMENT',
  Deposit = 'DEPOSIT',
  Education = 'EDUCATION',
  InvestmentIncome = 'INVESTMENT_INCOME',
  PayrollDeposit = 'PAYROLL_DEPOSIT',
  RebalanceTransfer = 'REBALANCE_TRANSFER',
  Refund = 'REFUND',
  RentPayment = 'RENT_PAYMENT',
  TaxRefund = 'TAX_REFUND'
}

export enum FinancialTransactionType {
  Credit = 'CREDIT',
  Debit = 'DEBIT'
}

export enum UserFinancialTransactionRuleType {
  Category = 'CATEGORY',
  Hide = 'HIDE',
  Tag = 'TAG'
}

export enum FinancialTransactionSortField {
  Date = 'DATE',
  Amount = 'AMOUNT'
}

export enum FinancialTransactionSortOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export type AdvancedOffsetPaginationInput = {
  /** The maximum number of results to return. Default is 500. */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The start index of the results to return. */
  offset?: InputMaybe<Scalars['Int']['input']>;
  /** The token associated with the result set, used to validate whether underlying data may have changed */
  resultSetToken?: InputMaybe<Scalars['String']['input']>;
};

export type SyncPaginationInput = {
  /** The ID of the item from which pagination should start reading forwards. */
  cursor?: InputMaybe<Scalars['ID']['input']>;
  /** The date that the pagination should start at. Returns data in descending order from the start date or cursor if provided. */
  startAt?: InputMaybe<Scalars['DateTime']['input']>;
  /** The date that the pagination should end at. Returns data in descending order from the start date or cursor if provided. */
  endAt?: InputMaybe<Scalars['DateTime']['input']>;
};

export type AdvancedOffsetPaginationInfo = {
  __typename?: 'AdvancedOffsetPaginationInfo';
  /** The adjusted maximum number of results to return based on the request limit and result set token. */
  limit?: Maybe<Scalars['Int']['output']>;
  /**
   * The adjusted start index of the results to return based on the request limit and result set token.
   *   If underlying data has changed, this will be reset to 0 and results will start from the "beginning" of the list.
   */
  offset?: Maybe<Scalars['Int']['output']>;
  /** The token associated with the result set, which may be different if the underlying data changed */
  resultSetToken?: Maybe<Scalars['String']['output']>;
};

/**
 * Field documentation:
 * https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#tag/transactions
 */
export type FinancialTransaction = {
  __typename?: 'FinancialTransaction';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  primarySource?: Maybe<FinancialDataSource>;
  sequenceNumber: Scalars['Int']['output'];
  source?: Maybe<FinancialDataSource>;
  sourceEntityId?: Maybe<Scalars['String']['output']>;
  updatedAt: Scalars['DateTime']['output'];
  /** The financial account under which the transaction resides */
  account?: Maybe<FinancialAccount>;
  /** The ID of the account associated with this transaction. Useful if you need the id but don't want to invoke an extra network request to fetch accounts */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** The "cent-normalized" amount of the transaction as an integer. e.g. 100 equals $1.00 */
  amount: Scalars['Int']['output'];
  /**
   * The NW category of the transaction. Nullable if reading an enrichment, otherwise guaranteed
   * @deprecated Deprecated in favor of the categoryId field which returns a V2 category ID.
   */
  category?: Maybe<FinancialTransactionCategory>;
  /** The NW V2 category ID of the transaction. Nullable if reading an enrichment, otherwise guaranteed */
  categoryId?: Maybe<Scalars['Int']['output']>;
  /** The currency of the account to which the transaction belongs */
  currency?: Maybe<Scalars['FinancialCurrency']['output']>;
  /** The date that the transaction took place */
  date: Scalars['DateTime']['output'];
  /** The type of account, e.g. "bank" or "investment" */
  accountType?: Maybe<FinancialAccountType>;
  /** A short description of the transaction */
  description?: Maybe<Scalars['String']['output']>;
  /** Whether or not the transaction is in a pending status, or if it has posted. */
  isPending?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the transaction is hidden. */
  isHidden?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the merchant associated to the transaction */
  merchantName?: Maybe<Scalars['String']['output']>;
  /** The Bill the transaction is associated with, if available */
  billStream?: Maybe<BillStream>;
  /** The Bill stream ID associated, if available */
  streamId?: Maybe<Scalars['ID']['output']>;
  /** Source category ID of the transaction */
  sourceCategoryId?: Maybe<Scalars['String']['output']>;
  /** Generally, whether this is a credit or a debt */
  type?: Maybe<FinancialTransactionType>;
  /** Used to label additional information about a transaction. e.g. REFUND */
  tags?: Maybe<Array<FinancialTransactionTag>>;
};

export type UpdateFinancialMerchantTransactionCategoryResponse = {
  __typename?: 'UpdateFinancialMerchantTransactionCategoryResponse';
  success: Scalars['Boolean']['output'];
};

export type RemovedFinancialTransaction = {
  __typename?: 'RemovedFinancialTransaction';
  id: Scalars['ID']['output'];
};

export type FinancialTransactionSyncResponse = {
  __typename?: 'FinancialTransactionSyncResponse';
  modified: Array<FinancialTransaction>;
  deleted: Array<RemovedFinancialTransaction>;
  hasMore: Scalars['Boolean']['output'];
  cursor: Scalars['ID']['output'];
};

export type GetTransactionsResponse = {
  __typename?: 'GetTransactionsResponse';
  /**
   * The pagination metadata associated with the request. If underlying data has changed, this will not match the
   *   requested pagination (offset will be set to 0 and a new result set token will be generated)
   */
  pagination: AdvancedOffsetPaginationInfo;
  /** The list of transactions associated with this result set */
  transactions: Array<FinancialTransaction>;
};

export type DeleteFinancialTransactionResponse = {
  __typename?: 'DeleteFinancialTransactionResponse';
  success: Scalars['Boolean']['output'];
};

/**
 * Note: this is not a complete set of available filters of the underlying API
 *
 * See docs for full support: https://docs.nerdwallet.io/financial-data-platform/branches/master/swagger-crud/#operation/listTransactions
 */
export type FinancialTransactionsFilterInput = {
  /** The account ID by which to filter the transactions. */
  accountId?: InputMaybe<Scalars['ID']['input']>;
  /**
   * To be deprecated. Please use "accountTypes".
   *   Only return transactions from an account with one of these types.
   */
  accountType?: InputMaybe<Array<FinancialAccountType>>;
  /** Only return transactions from an account with one of these types. */
  accountTypes?: InputMaybe<Array<FinancialAccountType>>;
  /**
   * To be deprecated. Please use "excludeAccountTypes".
   *   Exclude transactions from any accounts with one of these types.
   */
  excludeAccountType?: InputMaybe<Array<FinancialAccountType>>;
  /** Exclude transactions from any accounts with one of these types. */
  excludeAccountTypes?: InputMaybe<Array<FinancialAccountType>>;
  /** The exact merchant by which to filter the transactions. */
  merchantName?: InputMaybe<Scalars['String']['input']>;
  /** The merchant names by which to filter the transactions. */
  merchantNames?: InputMaybe<Array<Scalars['String']['input']>>;
  /** The search field to filter transaction by using a partial merchant name match. */
  merchantNameQuery?: InputMaybe<Scalars['String']['input']>;
  /** Deprecated. Use the categoryIds field. */
  category?: InputMaybe<Array<FinancialTransactionCategory>>;
  /** Deprecated. Use the categoryIds field. */
  categories?: InputMaybe<Array<FinancialTransactionCategory>>;
  /** The V2 category IDs to filter transactions by. */
  categoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Deprecated. Use the excludeCategoryIds field. */
  excludeCategory?: InputMaybe<Array<FinancialTransactionCategory>>;
  /** Deprecated. Use the excludeCategoryIds categoriesV2 field. */
  excludeCategories?: InputMaybe<Array<FinancialTransactionCategory>>;
  /** The V2 category IDs to exclude when filtering transactions. */
  excludeCategoryIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** The type by which to filter the transactions. */
  type?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include transactions for hidden accounts. */
  includeHiddenAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not to include transactions marked as hidden. Defaults to false. */
  excludeHiddenTransactions?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not to include pending transactions. Defaults to false. */
  includePending?: InputMaybe<Scalars['Boolean']['input']>;
  /** The beginning bound of the transaction date (ISO 8601) */
  startDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** The end bound of the transaction date (ISO 8601) */
  endDate?: InputMaybe<Scalars['DateTime']['input']>;
  /** Only return transactions with one of these tags. */
  includeTags?: InputMaybe<Array<FinancialTransactionTag>>;
  /** Exclude transactions with any one of these tags. */
  excludeTags?: InputMaybe<Array<FinancialTransactionTag>>;
  /** Transactions that have been modified since this date (ISO 8601). */
  updatedSince?: InputMaybe<Scalars['DateTime']['input']>;
  /** Whether or not to include accounts marked as disabled. Defaults to false. */
  includeDisabledAccounts?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether or not to include transactions with stream associations */
  excludeStreamAssociations?: InputMaybe<Scalars['Boolean']['input']>;
  /** Only fetch transactions belonging to the specified stream */
  streamId?: InputMaybe<Scalars['ID']['input']>;
  /** Do not fetch any transactions that belong to the specified stream */
  excludeStreamId?: InputMaybe<Scalars['ID']['input']>;
};

export type FinancialTransactionsSortInput = {
  /** The field to sort the transactions by. */
  field?: InputMaybe<FinancialTransactionSortField>;
  /** The order to sort the transactions by (default DESC). */
  order?: InputMaybe<FinancialTransactionSortOrder>;
};

export type FinancialTransactionCategoryConfig = {
  __typename?: 'FinancialTransactionCategoryConfig';
  id: Scalars['Int']['output'];
  iconUri: Scalars['String']['output'];
  displayName: Scalars['String']['output'];
};

export type FinancialTransactionCategoriesResponse = {
  __typename?: 'FinancialTransactionCategoriesResponse';
  categories: Array<FinancialTransactionCategoryConfig>;
};

export enum FinancialTransactionsSpendingComparisonDatePeriodEnum {
  Week = 'WEEK',
  Month = 'MONTH',
  Quarter = 'QUARTER',
  Year = 'YEAR'
}

export enum FinancialTransactionsSpendingComparisonDateIntervalEnum {
  Day = 'DAY',
  Week = 'WEEK'
}

export type FinancialUserMeta = {
  __typename?: 'FinancialUserMeta';
  /** The Source (YODLEE, PLAID, etc) */
  source?: Maybe<FinancialDataSource>;
  /** The Source username */
  username?: Maybe<Scalars['String']['output']>;
};

export type GetFinancialUserMetaResponse = {
  __typename?: 'GetFinancialUserMetaResponse';
  users?: Maybe<Array<FinancialUserMeta>>;
};

export type FinancialDataUser = {
  __typename?: 'FinancialDataUser';
  /** Unique identifier for the user */
  id: Scalars['ID']['output'];
  /** Indicates if the user is enrolled in receiving recurrent transactions */
  isEnrolledInStreams: Scalars['Boolean']['output'];
};

export type FinancialUserResponse = {
  __typename?: 'FinancialUserResponse';
  financialUser?: Maybe<FinancialDataUser>;
};

export type FinancialUserAnnualIncomeResponse = {
  __typename?: 'FinancialUserAnnualIncomeResponse';
  /** The user's estimated estimated gross income */
  annualIncome?: Maybe<Scalars['Float']['output']>;
};

export type FinancialUserMonthlyNetIncomeResponse = {
  __typename?: 'FinancialUserMonthlyNetIncomeResponse';
  monthlyNetIncome?: Maybe<Scalars['Float']['output']>;
};

/** The `IdentityResponse` type represents the generic identity profile */
export type IdentityResponse = {
  __typename?: 'IdentityResponse';
  authProviders?: Maybe<Array<Scalars['String']['output']>>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  email: Scalars['String']['output'];
  emailHash?: Maybe<Scalars['String']['output']>;
  hasPassword: Scalars['Boolean']['output'];
  id: Scalars['ID']['output'];
  identityId?: Maybe<Scalars['ID']['output']>;
  identityType?: Maybe<Scalars['String']['output']>;
  internalType?: Maybe<Scalars['String']['output']>;
  isNerdWalletPlusMember: Scalars['Boolean']['output'];
  roles: Array<Scalars['String']['output']>;
  scopes: Array<Scalars['String']['output']>;
  sheaId?: Maybe<Scalars['String']['output']>;
  verifiedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * Represents the status of Covered auto quote generation.
 * READY: Maps to QUOTES_VALID backend status.
 * QUOTES_INVALID: Maps to QUOTES_INVALID backend status.
 * TCPA_REQUIRED_QUOTES_VALID: Maps to TCPA_REQUIRED_QUOTES_VALID backend status (won't have the Quote URL).
 * TCPA_REQUIRED_QUOTES_INVALID: Maps to TCPA_REQUIRED_QUOTES_INVALID backend status (won't have the Quote URL).
 * QUOTES_NOT_YET_FOUND: Maps to QUOTES_NOT_YET_FOUND backend status (won't have the Quote URL).
 * SYNCING: Maps to all other backend status (won't have the Quote URL).
 */
export enum QuoteStatus {
  Ready = 'READY',
  QuotesInvalid = 'QUOTES_INVALID',
  TcpaRequiredQuotesValid = 'TCPA_REQUIRED_QUOTES_VALID',
  TcpaRequiredQuotesInvalid = 'TCPA_REQUIRED_QUOTES_INVALID',
  QuotesNotYetFound = 'QUOTES_NOT_YET_FOUND',
  Syncing = 'SYNCING'
}

export type HasAcknowledgedCoveredTermsOfServiceResponse = {
  __typename?: 'HasAcknowledgedCoveredTermsOfServiceResponse';
  acknowledged: Scalars['Boolean']['output'];
};

export type CoveredQuoteStatusResponse = {
  __typename?: 'CoveredQuoteStatusResponse';
  status: QuoteStatus;
  shoppingFinishId: Scalars['ID']['output'];
  quoteUrl?: Maybe<Scalars['String']['output']>;
};

export type AcknowledgeCoveredTermsOfServiceResponse = {
  __typename?: 'AcknowledgeCoveredTermsOfServiceResponse';
  success: Scalars['Boolean']['output'];
};

export type AcknowledgeCoveredTcpaConsentResponse = {
  __typename?: 'AcknowledgeCoveredTCPAConsentResponse';
  success: Scalars['Boolean']['output'];
  shoppingFinishId: Scalars['ID']['output'];
  quoteUrl: Scalars['String']['output'];
};

export enum CanopyGender {
  Male = 'MALE',
  Female = 'FEMALE',
  Nonbinary = 'NONBINARY'
}

/** https://docs.usecanopy.com/reference/schemas-address */
export type InsuredAddress = {
  __typename?: 'InsuredAddress';
  id: Scalars['ID']['output'];
  fullAddress?: Maybe<Scalars['String']['output']>;
  addressNature?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  number?: Maybe<Scalars['String']['output']>;
  street?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  secUnitType?: Maybe<Scalars['String']['output']>;
  secUnitNum?: Maybe<Scalars['String']['output']>;
  zip?: Maybe<Scalars['String']['output']>;
};

/** https://docs.usecanopy.com/reference/schemas-vehiclecoverage */
export type VehicleCoverages = {
  __typename?: 'VehicleCoverages';
  id: Scalars['ID']['output'];
  name?: Maybe<Scalars['String']['output']>;
  friendlyName?: Maybe<Scalars['String']['output']>;
  premiumCents?: Maybe<Scalars['Int']['output']>;
  perPersonLimitCents?: Maybe<Scalars['Int']['output']>;
  isPerPersonUnlimited?: Maybe<Scalars['Boolean']['output']>;
  perIncidentLimitCents?: Maybe<Scalars['Int']['output']>;
  isPerIncidentUnlimited?: Maybe<Scalars['Boolean']['output']>;
  perDayLimitCents?: Maybe<Scalars['Int']['output']>;
  maxDays?: Maybe<Scalars['Int']['output']>;
  deductibleCents?: Maybe<Scalars['Int']['output']>;
  isActualCashValue?: Maybe<Scalars['Boolean']['output']>;
  isDeclined?: Maybe<Scalars['Boolean']['output']>;
  perMilePremiumTenthOfCents?: Maybe<Scalars['Int']['output']>;
};

/** https://docs.usecanopy.com/reference/schemas-vehicledriver */
export type VehicleDrivers = {
  __typename?: 'VehicleDrivers';
  id: Scalars['ID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  driversLicense?: Maybe<Scalars['String']['output']>;
  driversLicenseState?: Maybe<Scalars['String']['output']>;
  birthdate?: Maybe<Scalars['String']['output']>;
  gender?: Maybe<CanopyGender>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  relationshipToInsured?: Maybe<Scalars['String']['output']>;
  age?: Maybe<Scalars['Int']['output']>;
  education?: Maybe<Scalars['String']['output']>;
  occupation?: Maybe<Scalars['String']['output']>;
  ageLicensed?: Maybe<Scalars['Int']['output']>;
  isExcluded?: Maybe<Scalars['Boolean']['output']>;
};

/** https://docs.usecanopy.com/reference/schemas-vehicle */
export type InsuredVehicles = {
  __typename?: 'InsuredVehicles';
  id: Scalars['ID']['output'];
  year?: Maybe<Scalars['Int']['output']>;
  make?: Maybe<Scalars['String']['output']>;
  model?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  vin?: Maybe<Scalars['String']['output']>;
  serialNumber?: Maybe<Scalars['String']['output']>;
  uses?: Maybe<Array<Scalars['String']['output']>>;
  purchaseDate?: Maybe<Scalars['DateTime']['output']>;
  ownershipType?: Maybe<Scalars['String']['output']>;
  garagingAddress?: Maybe<InsuredAddress>;
  coverages: Array<VehicleCoverages>;
  drivers: Array<VehicleDrivers>;
};

export type InsuredDwellings = {
  __typename?: 'InsuredDwellings';
  id: Scalars['ID']['output'];
  address?: Maybe<InsuredAddress>;
  yearBuilt?: Maybe<Scalars['Int']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * https://docs.usecanopy.com/reference/schemas-document
 *
 * See note above ^^
 */
export type InsuranceDocuments = {
  __typename?: 'InsuranceDocuments';
  id: Scalars['ID']['output'];
  title: Scalars['String']['output'];
  dateAdded?: Maybe<Scalars['DateTime']['output']>;
  documentType?: Maybe<Scalars['String']['output']>;
  policyId?: Maybe<Scalars['ID']['output']>;
};

export type InsuranceNamedInsureds = {
  __typename?: 'InsuranceNamedInsureds';
  id: Scalars['ID']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  middleName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** https://docs.usecanopy.com/reference/schemas-policy */
export type InsurancePolicy = {
  __typename?: 'InsurancePolicy';
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  accountId: Scalars['String']['output'];
  hidden: Scalars['Boolean']['output'];
  isExpired?: Maybe<Scalars['Boolean']['output']>;
  name?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  policyNumber?: Maybe<Scalars['String']['output']>;
  policyType: Scalars['String']['output'];
  policyDurationMonths?: Maybe<Scalars['Int']['output']>;
  effectiveDate?: Maybe<Scalars['DateTime']['output']>;
  expiryDate?: Maybe<Scalars['DateTime']['output']>;
  renewalDate?: Maybe<Scalars['DateTime']['output']>;
  canceledDate?: Maybe<Scalars['DateTime']['output']>;
  totalPremiumCents?: Maybe<Scalars['Int']['output']>;
  /** Monthly premium in cents based on the duration of insurance policy */
  monthlyPremiumCents?: Maybe<Scalars['Int']['output']>;
  carrierName?: Maybe<Scalars['String']['output']>;
  friendlyCarrierName: Scalars['String']['output'];
  vehicles: Array<InsuredVehicles>;
  dwellings: Array<InsuredDwellings>;
  documents: Array<InsuranceDocuments>;
  namedInsureds: Array<InsuranceNamedInsureds>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  insuranceProviderName: Scalars['String']['output'];
  insuranceProviderLogo: Scalars['String']['output'];
  friendlyInsuranceProviderName: Scalars['String']['output'];
  requiresReconnect: Scalars['Boolean']['output'];
};

/** https://docs.usecanopy.com/reference/schemas-pull */
export type InsurancePull = {
  __typename?: 'InsurancePull';
  id: Scalars['ID']['output'];
  carrierName?: Maybe<Scalars['String']['output']>;
  policies?: Maybe<Array<InsurancePolicy>>;
  friendlyCarrierName?: Maybe<Scalars['String']['output']>;
  unsupportedPolicies: Array<UnsupportedPolicyTypes>;
};

export type UnsupportedPolicyTypes = {
  __typename?: 'UnsupportedPolicyTypes';
  rawValue: Scalars['String']['output'];
  friendlyValue: Scalars['String']['output'];
};

export type InsuranceAccounts = {
  __typename?: 'InsuranceAccounts';
  id: Scalars['String']['output'];
  insuranceProviderName: Scalars['String']['output'];
  friendlyInsuranceProviderName: Scalars['String']['output'];
  requiresReconnect: Scalars['Boolean']['output'];
};

export type MarketplaceInstitution = {
  __typename?: 'MarketplaceInstitution';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  logo: Scalars['String']['output'];
};

export type MarketplaceEntity = {
  __typename?: 'MarketplaceEntity';
  starRating?: Maybe<Scalars['Float']['output']>;
  reviewLink?: Maybe<Scalars['String']['output']>;
  institution?: Maybe<MarketplaceInstitution>;
  productBottomLine?: Maybe<Scalars['String']['output']>;
};

export type InsurancePolicyRate = {
  __typename?: 'InsurancePolicyRate';
  id: Scalars['ID']['output'];
  marketplaceProductName?: Maybe<Scalars['String']['output']>;
  marketplaceProductId?: Maybe<Scalars['ID']['output']>;
  marketplaceEntity?: Maybe<MarketplaceEntity>;
  annualPremium: Scalars['Float']['output'];
  hasError: Scalars['Boolean']['output'];
};

export type InsurancePolicyRateReport = {
  __typename?: 'InsurancePolicyRateReport';
  policyId: Scalars['ID']['output'];
  rates: Array<InsurancePolicyRate>;
  updatedAt: Scalars['DateTime']['output'];
};

/** Response Types */
export type AcknowledgeCanopyTermsOfServiceAgreementResponse = {
  __typename?: 'AcknowledgeCanopyTermsOfServiceAgreementResponse';
  success: Scalars['Boolean']['output'];
};

export type CanopyTermsOfServiceAgreementsResponse = {
  __typename?: 'CanopyTermsOfServiceAgreementsResponse';
  success: Scalars['Boolean']['output'];
  acknowledgements?: Maybe<Array<CanopyTermsOfServiceAcknowledgement>>;
};

export type CanopyTermsOfServiceAcknowledgement = {
  __typename?: 'CanopyTermsOfServiceAcknowledgement';
  type: Scalars['String']['output'];
  source: Scalars['String']['output'];
  version: Scalars['String']['output'];
};

export type InsurancePolicyResponse = {
  __typename?: 'InsurancePolicyResponse';
  success: Scalars['Boolean']['output'];
  policy?: Maybe<InsurancePolicy>;
};

export type InsurancePoliciesResponse = {
  __typename?: 'InsurancePoliciesResponse';
  success: Scalars['Boolean']['output'];
  policies?: Maybe<Array<InsurancePolicy>>;
};

export type InsurancePolicyRateReportResponse = {
  __typename?: 'InsurancePolicyRateReportResponse';
  success: Scalars['Boolean']['output'];
  rateReport?: Maybe<InsurancePolicyRateReport>;
};

export type InsurancePoliciesRateReportsResponse = {
  __typename?: 'InsurancePoliciesRateReportsResponse';
  success: Scalars['Boolean']['output'];
  rateReports: Array<InsurancePolicyRateReport>;
};

export type InsurancePullResponse = {
  __typename?: 'InsurancePullResponse';
  success: Scalars['Boolean']['output'];
  pull?: Maybe<InsurancePull>;
};

export type DeleteInsuranceByAccountIdResponse = {
  __typename?: 'DeleteInsuranceByAccountIdResponse';
  success: Scalars['Boolean']['output'];
  policies?: Maybe<Array<Maybe<InsurancePolicy>>>;
};

export type InsuranceDocumentUrlResponse = {
  __typename?: 'InsuranceDocumentUrlResponse';
  success: Scalars['Boolean']['output'];
  documentUrl?: Maybe<Scalars['String']['output']>;
};

export type InsuranceAccountsResponse = {
  __typename?: 'InsuranceAccountsResponse';
  success: Scalars['Boolean']['output'];
  insuranceAccounts?: Maybe<Array<InsuranceAccounts>>;
};

export type InsuranceAccountReconnectTokenResponse = {
  __typename?: 'InsuranceAccountReconnectTokenResponse';
  success: Scalars['Boolean']['output'];
  reconnectToken?: Maybe<Scalars['String']['output']>;
};

export type InsurancePolicyOverridesResponse = {
  __typename?: 'InsurancePolicyOverridesResponse';
  /** The policy ID */
  id: Scalars['ID']['output'];
  /** Fields to help identify which policy these overrides belong to. */
  policy?: Maybe<InsurancePolicyOverridePolicy>;
  /** The overrides for this policy. */
  overrides?: Maybe<InsurancePolicyOverrides>;
};

export type CanopyCarriers = {
  __typename?: 'CanopyCarriers';
  /** Carrier unique ID */
  id: Scalars['String']['output'];
  /** Friendly carrier name */
  name: Scalars['String']['output'];
};

/** The local policy overrides that apply to a specific policy of type home, renters or auto. */
export type LocalInsurancePolicyOverrides = {
  __typename?: 'LocalInsurancePolicyOverrides';
  /** Shared policy overrides */
  zipCode?: Maybe<Scalars['String']['output']>;
  /** Auto policy overrides */
  carYear?: Maybe<Scalars['Int']['output']>;
  carMake?: Maybe<Scalars['String']['output']>;
  carModel?: Maybe<Scalars['String']['output']>;
  /** Home policy overrides */
  yearBuilt?: Maybe<Scalars['Int']['output']>;
};

export type InsurancePolicyOverrides = {
  __typename?: 'InsurancePolicyOverrides';
  /** Global overrides that apply to *all* of the user's policies */
  global?: Maybe<GlobalInsurancePolicyOverrides>;
  /** "Local" overrides that apply to an individual policy */
  policy?: Maybe<LocalInsurancePolicyOverrides>;
};

export type InsurancePolicyOverridePolicy = {
  __typename?: 'InsurancePolicyOverridePolicy';
  id: Scalars['ID']['output'];
  type: Scalars['String']['output'];
};

export type GlobalInsurancePolicyOverrides = {
  __typename?: 'GlobalInsurancePolicyOverrides';
  birthdate?: Maybe<Scalars['String']['output']>;
  creditScore?: Maybe<Scalars['Int']['output']>;
  gender?: Maybe<CanopyGender>;
};

export type GlobalInsurancePolicyOverridesInput = {
  /** Gender of the policy holder. */
  gender?: InputMaybe<CanopyGender>;
  /**
   * Birth date of the policy holder.
   *   Format: YYYY-MM-DD
   */
  birthdate?: InputMaybe<Scalars['String']['input']>;
  /** Credit score of the policy holder. */
  creditScore?: InputMaybe<Scalars['Int']['input']>;
};

export type LocalInsurancePolicyOverridesInput = {
  zipCode?: InputMaybe<Scalars['String']['input']>;
  carYear?: InputMaybe<Scalars['Int']['input']>;
  carMake?: InputMaybe<Scalars['String']['input']>;
  carModel?: InputMaybe<Scalars['String']['input']>;
  yearBuilt?: InputMaybe<Scalars['Int']['input']>;
};

/**
 * TODO: the `canonicalInstitutionId` field should map to a canonical institution
 * Note: @shareable was added so that membership-subgraph can have access to this schema
 */
export type AccountAggregationInstitution = {
  __typename?: 'AccountAggregationInstitution';
  id: Scalars['ID']['output'];
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
  /** Manual override by NW employee for the popularity of this institution */
  adminPopularity?: Maybe<Scalars['Int']['output']>;
  /**
   * Indicator of which account aggregator we are surfacing this institution from
   *
   *   Example: `yodlee`
   */
  aggregatorType?: Maybe<MarketplaceAggregatorType>;
  /** The countries with which the institution is affiliated. */
  countryCodes?: Maybe<Array<InstitutionCountryCode>>;
  /**
   * The timestamp at which the institution was last deleted from marketplace, if applicable
   *
   *   Example: `1563480626`
   */
  deletedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The status of the institution, typically used to determine whether to surface the institution or not
   *
   *   Example: `ACTIVE`
   */
  displayStatus: AccountAggregationInstitutionDisplayStatus;
  /** Whether the institution is manually deactivated by an NW employee or not ??? */
  iavAdminDeactivated?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the institution supports IAV or not */
  iavEnabled: Scalars['Boolean']['output'];
  /**
   * The timestamp at which the institution was last updated in marketplace
   *
   *   Example: `1563480626`
   */
  lastSyncedAt: Scalars['DateTime']['output'];
  /**
   * The logo for the institution as provided by the relevant third-party account aggregator. This may either be
   *   a full url, or a data-image representation of an image.
   *
   *   Example: `https://yodlee-1.hs.llnwd.net/v1/LOGO/LOGO_643_1_2.SVG`
   */
  logoUrl?: Maybe<Scalars['String']['output']>;
  /**
   * An alternate logo for the institution provided by NerdWallet that more clearly indicates which institution it is
   *   (i.e. via text in the logo)
   */
  topInstitutionLogo?: Maybe<Scalars['String']['output']>;
  /**
   * The URL at which the user will be logged in, as provided by the relevant third-party account aggregator
   *
   *   Example: `https://secure01c.chase.com/web/auth/dashboard`
   */
  loginUrl?: Maybe<Scalars['String']['output']>;
  /**
   * How popular this institution is for linking to in relation to others, equal to the number of successful
   *   links with this institution in the past
   */
  popularity: Scalars['Int']['output'];
};

export type MembershipAppActivityFeatureDiscovery = {
  __typename?: 'MembershipAppActivityFeatureDiscovery';
  featureId: Scalars['String']['output'];
  viewedOnDates?: Maybe<Array<Scalars['DateTime']['output']>>;
};

/**
 * The MembershipAppActivityResponse type records "activity" within the app,
 * such as feature dismissal, or flow progress.
 */
export type MembershipAppActivityResponse = {
  __typename?: 'MembershipAppActivityResponse';
  activationChecklistLastSessionAt?: Maybe<Scalars['DateTime']['output']>;
  activationChecklistSessionCount?: Maybe<Scalars['Int']['output']>;
  creditCardMatchBannerDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  creditFactorChangesSeenAt?: Maybe<Scalars['DateTime']['output']>;
  creditScoreBandSeen?: Maybe<Scalars['JSON']['output']>;
  downloadAppQrTakeoverDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  hideTransactionTipSeenAt?: Maybe<Scalars['DateTime']['output']>;
  isTransactionsFilterTooltipSeen?: Maybe<Scalars['Boolean']['output']>;
  netWorthGhostCtasDismissed?: Maybe<Scalars['JSON']['output']>;
  netWorthHideAccountTipDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  netWorthOtherAccountCategorizationModuleDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  netWorthSnapshotNotificationDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  studentLoanHubBannerDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  valuePropTakeoverDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  budget503020BannerDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  budget503020ActivatedAt?: Maybe<Scalars['DateTime']['output']>;
  budget503020CurrentMonthSeenAt?: Maybe<Scalars['DateTime']['output']>;
  featuresDiscovered?: Maybe<Array<MembershipAppActivityFeatureDiscovery>>;
  nwPlusMaxEarnedPointsModalDismissedAt?: Maybe<Scalars['DateTime']['output']>;
  nwPlusRewards?: Maybe<Scalars['JSON']['output']>;
  quickStartGuideStatus?: Maybe<Scalars['JSON']['output']>;
};

export type MembershipAppActivityFeatureDiscoveryResponse = {
  __typename?: 'MembershipAppActivityFeatureDiscoveryResponse';
  featuresDiscovered?: Maybe<Array<MembershipAppActivityFeatureDiscovery>>;
};

/** The expected payload for the `updateMembershipAppActivity` mutation. */
export type MembershipAppActivityInput = {
  activationChecklistLastSessionAt?: InputMaybe<Scalars['DateTime']['input']>;
  activationChecklistSessionCount?: InputMaybe<Scalars['Int']['input']>;
  creditCardMatchBannerDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditFactorChangesSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
  creditScoreBandSeen?: InputMaybe<Scalars['JSON']['input']>;
  downloadAppQrTakeoverDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  hideTransactionTipSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
  isTransactionsFilterTooltipSeen?: InputMaybe<Scalars['Boolean']['input']>;
  netWorthGhostCtasDismissed?: InputMaybe<Scalars['JSON']['input']>;
  netWorthHideAccountTipDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  netWorthOtherAccountCategorizationModuleDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  netWorthSnapshotNotificationDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  studentLoanHubBannerDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  valuePropTakeoverDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  budget503020BannerDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  budget503020ActivatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  budget503020CurrentMonthSeenAt?: InputMaybe<Scalars['DateTime']['input']>;
  nwPlusMaxEarnedPointsModalDismissedAt?: InputMaybe<Scalars['DateTime']['input']>;
  nwPlusRewards?: InputMaybe<Scalars['JSON']['input']>;
  quickStartGuideStatus?: InputMaybe<Scalars['JSON']['input']>;
};

/** Possible statuses for a WLL /events response */
export enum EarnRewardSuccessStatus {
  /** Everything went well */
  Success = 'SUCCESS',
  /** Event was created but the reactions failed to fetch */
  SuccessReactionsFailedToFetch = 'SUCCESS_REACTIONS_FAILED_TO_FETCH',
  /** Reward generated but no reactions found */
  SuccessNoReactions = 'SUCCESS_NO_REACTIONS',
  /** Reward generated but no reactions with SUM operation */
  SuccessNoSumReactions = 'SUCCESS_NO_SUM_REACTIONS',
  /** Reward generated but no reactions of type POINTS */
  SuccessNoPointsReactions = 'SUCCESS_NO_POINTS_REACTIONS',
  /** Reward generated but no reactions with NUMBER type arguments */
  SuccessNoNumberArgumentsInReactions = 'SUCCESS_NO_NUMBER_ARGUMENTS_IN_REACTIONS'
}

/** Possible types of an FAQ link */
export enum NwPlusFaqLinkType {
  /** Link is for an email */
  Email = 'EMAIL',
  /** Link is for a website. (Use webview on Native) */
  Web = 'WEB',
  /** Link is for a deeplink. */
  Deeplink = 'DEEPLINK',
  /** Not a link, but an identifier for the disclaimer */
  Disclaimer = 'DISCLAIMER'
}

export enum NwPlusRewardAppAction {
  /** Initiate Plaid linkage flow */
  LinkPlaid = 'LINK_PLAID',
  /** Initiate insurance linkage flow */
  LinkInsurance = 'LINK_INSURANCE',
  /** Initiate Financial Health Score flow */
  GetFinancialHealthScore = 'GET_FINANCIAL_HEALTH_SCORE',
  /** When data source reports a new unaccounted for action */
  Unknown = 'UNKNOWN'
}

export enum NwPlusPointType {
  /** Points are awarded in one lump sum */
  Default = 'DEFAULT',
  /** Points are awarded up to a certain amount */
  Max = 'MAX'
}

export enum NwPlusRewardType {
  /** One time rewards */
  OneTime = 'ONE_TIME',
  /** Recurring rewards */
  Recurring = 'RECURRING',
  /** Premium rewards */
  Premium = 'PREMIUM'
}

/** Names of the events to emit that have been configured in the WLL console */
export enum RewardableEventType {
  AchievedTwentyPercentSavings = 'ACHIEVED_TWENTY_PERCENT_SAVINGS',
  AcquiredIdentityTheftPlan = 'ACQUIRED_IDENTITY_THEFT_PLAN',
  ActivatedFinancialHealthScore = 'ACTIVATED_FINANCIAL_HEALTH_SCORE',
  ActivatedTu = 'ACTIVATED_TU',
  BoostedCsAverageGood = 'BOOSTED_CS_AVERAGE_GOOD',
  BoostedCsGoodExcellent = 'BOOSTED_CS_GOOD_EXCELLENT',
  BoostedCsPoorAverage = 'BOOSTED_CS_POOR_AVERAGE',
  CategorizedLastMonthTransactions = 'CATEGORIZED_LAST_MONTH_TRANSACTIONS',
  CheckedAutoInsurancePolicy = 'CHECKED_AUTO_INSURANCE_POLICY',
  CheckedPropertyInsurancePolicy = 'CHECKED_PROPERTY_INSURANCE_POLICY',
  CompletedWeeklyInsightsStack = 'COMPLETED_WEEKLY_INSIGHTS_STACK',
  EnabledPushNotifications = 'ENABLED_PUSH_NOTIFICATIONS',
  EnabledEmailMarketingNotifications = 'ENABLED_EMAIL_MARKETING_NOTIFICATIONS',
  FoundRetirementAccountWithCapitalize = 'FOUND_RETIREMENT_ACCOUNT_WITH_CAPITALIZE',
  ImprovedCreditUtilizationBelowOne = 'IMPROVED_CREDIT_UTILIZATION_BELOW_ONE',
  ImprovedCreditUtilizationBelowTen = 'IMPROVED_CREDIT_UTILIZATION_BELOW_TEN',
  ImprovedCreditUtilizationBelowThirty = 'IMPROVED_CREDIT_UTILIZATION_BELOW_THIRTY',
  LinkedAllAccountTypes = 'LINKED_ALL_ACCOUNT_TYPES',
  LinkedAtomicAccount = 'LINKED_ATOMIC_ACCOUNT',
  LinkedAutoInsurancePolicy = 'LINKED_AUTO_INSURANCE_POLICY',
  LinkedCreditCardAccount = 'LINKED_CREDIT_CARD_ACCOUNT',
  LinkedHomeOrRentersInsurancePolicy = 'LINKED_HOME_OR_RENTERS_INSURANCE_POLICY',
  LinkedInvestmentAccount = 'LINKED_INVESTMENT_ACCOUNT',
  LinkedLoanAccount = 'LINKED_LOAN_ACCOUNT',
  LinkedRedfinHomeValue = 'LINKED_REDFIN_HOME_VALUE',
  LinkedSavingsAccount = 'LINKED_SAVINGS_ACCOUNT',
  LoggedIntoNerdwalletWeb = 'LOGGED_INTO_NERDWALLET_WEB',
  LoggedIntoNerdwalletApp = 'LOGGED_INTO_NERDWALLET_APP',
  MadeDirectDepositForEligibleBankAccount = 'MADE_DIRECT_DEPOSIT_FOR_ELIGIBLE_BANK_ACCOUNT',
  NwNewAccountRegistration = 'NW_NEW_ACCOUNT_REGISTRATION',
  PaidCreditCardOnTimeMonthly = 'PAID_CREDIT_CARD_ON_TIME_MONTHLY',
  PaidEligibleCreditCardOnTime = 'PAID_ELIGIBLE_CREDIT_CARD_ON_TIME',
  PaidMonthlyMortgageOnTime = 'PAID_MONTHLY_MORTGAGE_ON_TIME',
  PurchasedCheaperInsurance = 'PURCHASED_CHEAPER_INSURANCE',
  ReferredAUser = 'REFERRED_A_USER',
  RolledOverRetirementAccountWithCapitalize = 'ROLLED_OVER_RETIREMENT_ACCOUNT_WITH_CAPITALIZE',
  SavedMonthlyAny = 'SAVED_MONTHLY_ANY',
  SavedMonthlyBronze = 'SAVED_MONTHLY_BRONZE',
  SavedMonthlyGold = 'SAVED_MONTHLY_GOLD',
  SavedMonthlySilver = 'SAVED_MONTHLY_SILVER',
  SavingsAccountFunded = 'SAVINGS_ACCOUNT_FUNDED',
  TreasuryAccountFunded = 'TREASURY_ACCOUNT_FUNDED',
  TreasuryAccountFundsHeld = 'TREASURY_ACCOUNT_FUNDS_HELD',
  TreasuryBillMatured = 'TREASURY_BILL_MATURED',
  UsedCreditCardFinder = 'USED_CREDIT_CARD_FINDER',
  UsedCreditSimulator = 'USED_CREDIT_SIMULATOR',
  ViewedCreditScore = 'VIEWED_CREDIT_SCORE',
  ViewedFiftyThirtyTwentyBudget = 'VIEWED_FIFTY_THIRTY_TWENTY_BUDGET',
  ViewedWeeklyReads = 'VIEWED_WEEKLY_READS'
}

export enum NwPlusRewardRecurringPattern {
  /** Reward by level */
  Level = 'LEVEL',
  /** Monthly reward */
  Month = 'MONTH',
  /** Weekly reward */
  Week = 'WEEK',
  /** Yearly reward */
  Year = 'YEAR'
}

export enum NwPlusRewardPlacementType {
  /** For you section */
  ForYou = 'FOR_YOU',
  /** Ways to earn section */
  WaysToEarn = 'WAYS_TO_EARN'
}

export enum NwPlusRewardPrerequisiteType {
  /** Activated with TransUnion */
  ActivatedTu = 'ACTIVATED_TU',
  /** Reward is only actionable in app */
  InAppOnly = 'IN_APP_ONLY',
  /** Auto insurance policy must be linked */
  LinkedAutoInsurancePolicy = 'LINKED_AUTO_INSURANCE_POLICY',
  /** Home or renters insurance policy must be linked */
  LinkedHomeOrRentersInsurancePolicy = 'LINKED_HOME_OR_RENTERS_INSURANCE_POLICY',
  /** Must have an active Atomic Investment account */
  OpenedAtomicInvestmentAccount = 'OPENED_ATOMIC_INVESTMENT_ACCOUNT',
  /** Must have an active Atomic Treasury account */
  OpenedAtomicTreasuryAccount = 'OPENED_ATOMIC_TREASURY_ACCOUNT'
}

/** Status types for redeeming a reward */
export enum NwPlusRedeemRewardStatus {
  /** Was able to both successfully purchase a reward and redeem it */
  Success = 'SUCCESS',
  /** Was able to purchase, but errored on redeeming the benefit */
  PurchaseSuccessRedeemError = 'PURCHASE_SUCCESS_REDEEM_ERROR'
}

export type WllReaction = {
  __typename?: 'WLLReaction';
  /** points */
  points?: Maybe<Scalars['Int']['output']>;
  /** Reactor name */
  reactorName: Scalars['String']['output'];
};

export type RewardAvailableElement = {
  __typename?: 'RewardAvailableElement';
  /** Codes tied to rewards */
  codes?: Maybe<Array<RewardableEventType>>;
  /** Copy to explain reward */
  copy: Scalars['String']['output'];
  /** Dollar value (depends on points) */
  dollarValue: Scalars['String']['output'];
  /**
   * Points this particular reward will grant.
   *   If points are not available the reward should not be present in the response.
   */
  points: Scalars['Int']['output'];
  /** Optional recurring value for rewards */
  recurringPattern?: Maybe<NwPlusRewardRecurringPattern>;
  /** Tooltip text associated */
  tooltipContent?: Maybe<Scalars['String']['output']>;
  /** Reward type */
  type?: Maybe<NwPlusRewardType>;
};

export type RewardEventPoints = {
  __typename?: 'RewardEventPoints';
  /** Points earned by the reward event.  If there are multiple reactors associated with the event, points will represent the maximum points that can be earned from a reactor. */
  points?: Maybe<Scalars['Int']['output']>;
  /** Event type is the identifier for the reward event */
  eventType: Scalars['String']['output'];
  /** If an event is related to multiple reactors, this will provide a list of the different point values per reactor */
  reactors?: Maybe<Array<WllReaction>>;
};

export type NwPlusFaqLink = {
  __typename?: 'NwPlusFaqLink';
  /** The displayed text of the link */
  text: Scalars['String']['output'];
  /** The destination of the link */
  url: Scalars['String']['output'];
  /** Identifier for the link in the NwPlusFaqAnswer text */
  tag: Scalars['String']['output'];
  /** The type of the link. Determines how to render the link on Native. */
  type: NwPlusFaqLinkType;
};

export type NwPlusFaqAnswer = {
  __typename?: 'NwPlusFaqAnswer';
  text: Scalars['String']['output'];
  links?: Maybe<Array<NwPlusFaqLink>>;
  orderedSubAnswers?: Maybe<Array<NwPlusFaqAnswer>>;
  unorderedSubAnswers?: Maybe<Array<NwPlusFaqAnswer>>;
};

export type NwPlusFaq = {
  __typename?: 'NwPlusFaq';
  question: Scalars['String']['output'];
  answer: NwPlusFaqAnswer;
};

export type NwPlusFaqDisclaimer = {
  __typename?: 'NwPlusFaqDisclaimer';
  id: Scalars['String']['output'];
  text: Scalars['String']['output'];
};

export type NwPlusPointBreakdown = {
  __typename?: 'NwPlusPointBreakdown';
  /** The NW+ event type */
  id: Scalars['String']['output'];
  /** Points associated with the event */
  points: Scalars['Int']['output'];
  /** The displayed text for the event */
  text: Scalars['String']['output'];
};

export type NwPlusOutstandingEvent = {
  __typename?: 'NwPlusOutstandingEvent';
  /** The unique identifier of the NwPlusOutstandingEvent */
  id: Scalars['ID']['output'];
  /** The event type of the NwPlusOutstandingEvent */
  eventType: Scalars['String']['output'];
  /** Possible points awarded by completing this event */
  points: Scalars['Int']['output'];
  /** Slug of the NwPlusOutstandingEvent */
  slug?: Maybe<Scalars['String']['output']>;
  /** Start date of relevancy for the NwPlusOutstandingEvent */
  startDate?: Maybe<Scalars['Date']['output']>;
  /** End date of relevancy for the NwPlusOutstandingEvent */
  endDate?: Maybe<Scalars['Date']['output']>;
  /** Title of the NwPlusOutstandingEvent */
  title?: Maybe<Scalars['String']['output']>;
  /** Subtitle of the NwPlusOutstandingEvent */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** Location users go to on CTA press */
  ctaLink?: Maybe<Scalars['URL']['output']>;
  /** Text to display to get users to the ctaLink location */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** URL of the icon */
  iconUrl?: Maybe<Scalars['URL']['output']>;
};

export type NwPlusRewardPrerequisite = {
  __typename?: 'NwPlusRewardPrerequisite';
  /** Prerequisite that must be fulfilled before you can earn the associated reward */
  type: NwPlusRewardPrerequisiteType;
  /** Display text for the CTA */
  ctaText: Scalars['String']['output'];
  /** Explanation of the action required */
  description: Scalars['String']['output'];
};

export type NwPlusQualifiedReward = {
  __typename?: 'NwPlusQualifiedReward';
  /** The unique identifier of the reward a user can earn points on */
  id: Scalars['ID']['output'];
  /** The WLL event types associated with triggering this reward */
  eventTypes?: Maybe<Array<Scalars['String']['output']>>;
  /** Possible points a user can earn for the reward */
  points: Scalars['Int']['output'];
  /** CTA text for the card version */
  cardCtaText: Scalars['String']['output'];
  /** Image to use in the card version */
  cardImageUrl: Scalars['URL']['output'];
  /** Title for the card version */
  cardTitle: Scalars['String']['output'];
  /** Category associated with the reward */
  category: Scalars['String']['output'];
  /** Image to display in the details display */
  detailImageUrl: Scalars['URL']['output'];
  /** If true, the details of the reward requires custom treatment on the client */
  detailIsCustom?: Maybe<Scalars['Boolean']['output']>;
  /** Title for the details display */
  detailTitle: Scalars['String']['output'];
  /** Subtitle for the details display */
  detailSubtitle: Scalars['String']['output'];
  /** Additional details */
  detailSecondaryDescription?: Maybe<Scalars['String']['output']>;
  /** Disclaimer for the details */
  detailDisclaimer?: Maybe<Scalars['String']['output']>;
  /** Marketplace Offer ID */
  detailMarketplaceOfferId?: Maybe<Scalars['String']['output']>;
  /** Primary CTA text for the details display, if available */
  detailCtaWebText?: Maybe<Scalars['String']['output']>;
  /** Primary CTA URL for the details display, if available */
  detailCtaWebLink?: Maybe<Scalars['URL']['output']>;
  /** Primary specific CTA action to be handled by the client */
  detailCtaAction?: Maybe<NwPlusRewardAppAction>;
  /** Primary CTA text for the details display on native, if available */
  detailCtaMobileText?: Maybe<Scalars['String']['output']>;
  /** Primary CTA URL for the details display on native, if available */
  detailCtaMobileLink?: Maybe<Scalars['String']['output']>;
  /** Primary CTA Type for the details display on native, if available */
  detailCtaMobileType?: Maybe<NwPlusFaqLinkType>;
  /** Secondary CTA text for the details display, if available */
  detailSecondaryCtaWebText?: Maybe<Scalars['String']['output']>;
  /** Secondary CTA URL for the details display, if available */
  detailSecondaryCtaWebLink?: Maybe<Scalars['URL']['output']>;
  /** Secondary specific CTA action to be handled by the client */
  detailSecondaryCtaAction?: Maybe<NwPlusRewardAppAction>;
  /** Secondary CTA text for the details display on native, if available */
  detailSecondaryCtaMobileText?: Maybe<Scalars['String']['output']>;
  /** Secondary CTA URL for the details display on native, if available */
  detailSecondaryCtaMobileLink?: Maybe<Scalars['String']['output']>;
  /** Secondary CTA Type for the details display on native, if available */
  detailSecondaryCtaMobileType?: Maybe<NwPlusFaqLinkType>;
  /** If the reward has a FOR_YOU placement, then this field indicates the order it should appear in */
  forYouOrder?: Maybe<Scalars['Int']['output']>;
  /** Priority order of displaying the reward */
  order: Scalars['Int']['output'];
  /** Text to display before the points (i.e. "Up to") */
  pointsPrefix?: Maybe<Scalars['String']['output']>;
  /** Set a placement for this reward to show it in the corresponding section */
  placement?: Maybe<NwPlusRewardPlacementType>;
  /** List of prerequisites or restrictions in order for the reward to be available */
  prerequisites?: Maybe<Array<NwPlusRewardPrerequisite>>;
  /** Prerequisite link for the reward in case is available */
  prerequisiteLink?: Maybe<Scalars['String']['output']>;
  /** Indicates if only NW+ members can interact with the reward */
  subscriberExclusive: Scalars['Boolean']['output'];
};

export type NwPlusRedeemableReward = {
  __typename?: 'NwPlusRedeemableReward';
  /** The unique identifier of the reward a user redeem */
  id: Scalars['ID']['output'];
  /** Name of the reward */
  name: Scalars['String']['output'];
  /** How many points it takes to redeem the reward */
  price: Scalars['Int']['output'];
  /** Priority order of displaying the reward */
  priority: Scalars['Int']['output'];
  /** Image to display */
  pictureUrl: Scalars['String']['output'];
  /** Reward type */
  type?: Maybe<Scalars['String']['output']>;
  /** Image to display in the reward's details */
  detailPictureUrl?: Maybe<Scalars['String']['output']>;
  /** Description of the reward */
  description?: Maybe<Scalars['String']['output']>;
  /** Conditions to show in the details modal */
  terms?: Maybe<Scalars['String']['output']>;
};

export type NwPlusRedeemedRewardEvent = {
  __typename?: 'NwPlusRedeemedRewardEvent';
  /** The WLL Event Id */
  id: Scalars['ID']['output'];
  /** The WLL Event type / category */
  eventType: Scalars['String']['output'];
  /** Points used to redeem the reward */
  redeemedPoints: Scalars['Int']['output'];
  /** When the event was reported */
  reportedAt: Scalars['String']['output'];
  /** Reward categories related */
  rewardCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Specific WLL Reward that was purchased. Can be nullable because cash payouts won't have a reward id. */
  rewardId?: Maybe<Scalars['ID']['output']>;
  /** Reward Name */
  rewardName: Scalars['String']['output'];
};

export type RecurlyAddress = {
  __typename?: 'RecurlyAddress';
  phone?: Maybe<Scalars['String']['output']>;
  street1?: Maybe<Scalars['String']['output']>;
  street2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  region?: Maybe<Scalars['String']['output']>;
  postalCode?: Maybe<Scalars['String']['output']>;
  country?: Maybe<Scalars['String']['output']>;
  geoCode?: Maybe<Scalars['String']['output']>;
};

export type RecurlyBillingInvoice = {
  __typename?: 'RecurlyBillingInvoice';
  /** The invoice ID */
  invoiceNumber: Scalars['String']['output'];
  /** Link to the recurly generated invoice */
  invoiceHref: Scalars['String']['output'];
  /** Link to the recurly generated invoice as a PDF */
  downloadHref: Scalars['String']['output'];
  /** The date payment is due */
  dueDate: Scalars['DateTime']['output'];
  /** The date the invoice was issued */
  issuedDate: Scalars['DateTime']['output'];
  /** Payment status */
  status: Scalars['String']['output'];
  /** Payment total */
  total: Scalars['String']['output'];
};

/** Response to RecurlyBillingHistory query */
export type RecurlyBillingHistoryResponse = {
  __typename?: 'RecurlyBillingHistoryResponse';
  billingHistory?: Maybe<Array<Maybe<RecurlyBillingInvoice>>>;
};

export type RecurlyPaymentMethod = {
  __typename?: 'RecurlyPaymentMethod';
  cardType?: Maybe<Scalars['String']['output']>;
  lastFour?: Maybe<Scalars['String']['output']>;
  expMonth?: Maybe<Scalars['Int']['output']>;
  expYear?: Maybe<Scalars['Int']['output']>;
  gatewayToken?: Maybe<Scalars['String']['output']>;
  gatewayCode?: Maybe<Scalars['String']['output']>;
  method?: Maybe<Scalars['String']['output']>;
};

export type RecurlyBillingInfo = {
  __typename?: 'RecurlyBillingInfo';
  address?: Maybe<RecurlyAddress>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  paymentMethod?: Maybe<RecurlyPaymentMethod>;
};

export type RecurlyAddressInput = {
  phone?: InputMaybe<Scalars['String']['input']>;
  street1: Scalars['String']['input'];
  street2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  region?: InputMaybe<Scalars['String']['input']>;
  postalCode: Scalars['String']['input'];
  country: Scalars['String']['input'];
  geoCode?: InputMaybe<Scalars['String']['input']>;
};

export type NwPlusMembershipStatus = {
  __typename?: 'NwPlusMembershipStatus';
  autoRenew?: Maybe<Scalars['Boolean']['output']>;
  currentPeriodEndsAt?: Maybe<Scalars['DateTime']['output']>;
  unitAmount?: Maybe<Scalars['Float']['output']>;
  state?: Maybe<Scalars['String']['output']>;
};

export type SubscriptionCancelReactivateResponse = {
  __typename?: 'SubscriptionCancelReactivateResponse';
  success?: Maybe<Scalars['Boolean']['output']>;
  error?: Maybe<Scalars['String']['output']>;
};

export type NwPlusEarnRewardDisplayDetails = {
  __typename?: 'NwPlusEarnRewardDisplayDetails';
  /** Copy to show in the alert */
  alertText: Scalars['String']['output'];
  /** Analytic type */
  alertAnalyticType: Scalars['String']['output'];
  /** Show a larger alert treatment, usually for higher earning rewards */
  isLargeAlert: Scalars['Boolean']['output'];
};

/** Response to EarnReward mutation */
export type EarnRewardResponse = {
  __typename?: 'EarnRewardResponse';
  /** Event ID submitted to WLL */
  eventId: Scalars['String']['output'];
  /** Success status */
  status: EarnRewardSuccessStatus;
  /** Number of points earned */
  points?: Maybe<Scalars['Int']['output']>;
  /** List of reactions */
  reactions: Array<WllReaction>;
  /** Display info associated with the response */
  displayDetails?: Maybe<NwPlusEarnRewardDisplayDetails>;
};

/** Response to RewardEventPoints query */
export type RewardEventPointsResponse = {
  __typename?: 'RewardEventPointsResponse';
  rewards: Array<RewardEventPoints>;
  aggregateRewards?: Maybe<Array<RewardEventPoints>>;
};

/** Response to RecurlyPurchase mutation */
export type RecurlyPurchaseResponse = {
  __typename?: 'RecurlyPurchaseResponse';
  /** Duplicate of tokenId, used for cache purposes */
  id: Scalars['String']['output'];
  /** success status */
  success: Scalars['Boolean']['output'];
  /** Error message if the purchase failed */
  error?: Maybe<Scalars['String']['output']>;
  /**
   * In the case a user signed up with a referral code, will return true
   *   if the code was applied successfully, false otherwise.
   */
  referralSucceeded?: Maybe<Scalars['Boolean']['output']>;
};

/** Response to RecurlyInfoUpdate mutation */
export type RecurlyAccountInfoMutationResponse = {
  __typename?: 'RecurlyAccountInfoMutationResponse';
  address?: Maybe<RecurlyAddress>;
  /** success status */
  success: Scalars['Boolean']['output'];
  /** Error message if the update failed */
  error?: Maybe<Scalars['String']['output']>;
};

/** Response to RecurlyBillingInfo mutation */
export type RecurlyBillingInfoMutationResponse = {
  __typename?: 'RecurlyBillingInfoMutationResponse';
  billingInfo?: Maybe<RecurlyBillingInfo>;
  /** success status */
  success: Scalars['Boolean']['output'];
  /** Error message if the update failed */
  error?: Maybe<Scalars['String']['output']>;
};

/** Response to LandingPageFAQs query */
export type NwPlusLandingPageFaqsResponse = {
  __typename?: 'NwPlusLandingPageFaqsResponse';
  faqs?: Maybe<Array<NwPlusFaq>>;
  disclaimers?: Maybe<Array<NwPlusFaqDisclaimer>>;
};

/** Response to Recurly account query */
export type RecurlyAccountInfoResponse = {
  __typename?: 'RecurlyAccountInfoResponse';
  address?: Maybe<RecurlyAddress>;
  billingInfo?: Maybe<RecurlyBillingInfo>;
};

/** Response to Wallet query */
export type NwPlusWalletResponse = {
  __typename?: 'NwPlusWalletResponse';
  points: Scalars['Int']['output'];
};

export type NwPlusPointsSummary = {
  __typename?: 'NwPlusPointsSummary';
  pointsCap: Scalars['Int']['output'];
  remainingPoints: Scalars['Int']['output'];
  percentageUsed: Scalars['Float']['output'];
};

export type NwPlusPointsPredictionOverallSummary = {
  __typename?: 'NwPlusPointsPredictionOverallSummary';
  type: Scalars['String']['output'];
  summary: NwPlusPointsSummary;
};

export type NwPlusPointsPrediction = {
  __typename?: 'NwPlusPointsPrediction';
  overallSummary?: Maybe<NwPlusPointsPredictionOverallSummary>;
};

/** Response to Wallet Predictions query */
export type NwPlusPredictionsResponse = {
  __typename?: 'NwPlusPredictionsResponse';
  pointsEarnPrediction?: Maybe<NwPlusPointsPrediction>;
};

/** Response to the Points Summary query */
export type NwPlusPointsSummaryResponse = {
  __typename?: 'NwPlusPointsSummaryResponse';
  /** The number of points a user can currently redeem */
  points: Scalars['Int']['output'];
  /** Points earned for the calendar year.  Value is calculated once a day by WLL. */
  earnedYearlyPoints?: Maybe<Scalars['Int']['output']>;
};

/** Response to the Points Estimate query */
export type NwPlusPointsEstimateResponse = {
  __typename?: 'NwPlusPointsEstimateResponse';
  /** The estimated number of points a user would receive when converting today */
  points: Scalars['Int']['output'];
  breakdown?: Maybe<Array<NwPlusPointBreakdown>>;
};

/** Response to the nwPlusReferralCode query */
export type NwPlusReferralCodeResponse = {
  __typename?: 'NwPlusReferralCodeResponse';
  referralCode: Scalars['String']['output'];
};

/** Response to the nwPlusReferralCode query */
export type NwPlusReferralCodeStatsResponse = {
  __typename?: 'NwPlusReferralCodeStatsResponse';
  referralCode: Scalars['String']['output'];
  numberOfReferredUsers: Scalars['Int']['output'];
};

/** Response to the nwPlusOutstandingEvents query */
export type NwPlusOutstandingEventsResponse = {
  __typename?: 'NwPlusOutstandingEventsResponse';
  events?: Maybe<Array<NwPlusOutstandingEvent>>;
};

/** Response to the nwPlusAvailableRewards query */
export type NwPlusAvailableRewardsResponse = {
  __typename?: 'NwPlusAvailableRewardsResponse';
  oneTimeRewards?: Maybe<Array<RewardAvailableElement>>;
  recurringRewards?: Maybe<Array<RewardAvailableElement>>;
  premiumRewards?: Maybe<Array<RewardAvailableElement>>;
};

export type NwPlusCompletedEventType = {
  __typename?: 'NwPlusCompletedEventType';
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
};

export type NwPlusCompletedEvent = {
  __typename?: 'NwPlusCompletedEvent';
  eventId: Scalars['Int']['output'];
  eventType: NwPlusCompletedEventType;
  reportedAt?: Maybe<Scalars['String']['output']>;
  registeredAt?: Maybe<Scalars['String']['output']>;
  reactedAt?: Maybe<Scalars['String']['output']>;
};

export type NwPlusRewardedCompletedEvent = {
  __typename?: 'NwPlusRewardedCompletedEvent';
  eventId: Scalars['ID']['output'];
  eventType: Scalars['String']['output'];
  points: Scalars['Int']['output'];
  reportedAt: Scalars['DateTime']['output'];
  category: Scalars['String']['output'];
  title: Scalars['String']['output'];
};

export enum NwPlusCompletedEventOrder {
  Asc = 'ASC',
  Desc = 'DESC'
}

export enum NwPlusCompletedEventSort {
  Id = 'id',
  ReportedAt = 'reportedAt',
  RegisteredAt = 'registeredAt',
  ReactedAt = 'reactedAt'
}

/** Response to the nwPlusUserQualifiedRewards query */
export type NwPlusUserQualifiedRewardsResponse = {
  __typename?: 'NwPlusUserQualifiedRewardsResponse';
  /** Subset of rewards to showcase */
  featuredRewards?: Maybe<Array<NwPlusQualifiedReward>>;
  /** All possible rewards a user can still earn points for */
  allRewards?: Maybe<Array<NwPlusQualifiedReward>>;
  /** Rewards a user has already earned points for */
  completedRewards?: Maybe<Array<NwPlusQualifiedReward>>;
};

/** Response to the nwPlusRedeemableRewards query */
export type NwPlusUserRedeemableRewardsResponse = {
  __typename?: 'NwPlusUserRedeemableRewardsResponse';
  rewards?: Maybe<Array<NwPlusRedeemableReward>>;
};

/** Response to the NwPlusUserRedeemedRewardsHistory query */
export type NwPlusUserRedeemedRewardsHistoryResponse = {
  __typename?: 'NwPlusUserRedeemedRewardsHistoryResponse';
  rewards?: Maybe<Array<NwPlusRedeemedRewardEvent>>;
};

/** The review from a user */
export type NwPlusUserReview = {
  __typename?: 'NwPlusUserReview';
  /** Name of the user who gave the review */
  userName: Scalars['String']['output'];
  /** The user's review */
  userReview: Scalars['String']['output'];
};

/** Response to the nwPlusUserReviews query */
export type NwPlusUserReviewsResponse = {
  __typename?: 'NwPlusUserReviewsResponse';
  /** List of individual user reviews */
  reviews?: Maybe<Array<NwPlusUserReview>>;
};

/** Possible values for the registration status */
export enum NwPlusPayoutRegistrationStatusEnum {
  Inprogress = 'INPROGRESS',
  Registered = 'REGISTERED',
  Unregistered = 'UNREGISTERED',
  Failed = 'FAILED'
}

/** Response to the nwPlusPayoutsRegistrationInfo query */
export type NwPlusPayoutsRegistrationInfoResponse = {
  __typename?: 'NwPlusPayoutsRegistrationInfoResponse';
  points: Scalars['Float']['output'];
  conversionRate: Scalars['Float']['output'];
  currencyCode: Scalars['String']['output'];
  minimumPayoutAmount: Scalars['Float']['output'];
  registrationStatus: NwPlusPayoutRegistrationStatusEnum;
};

export type NwPlusPoints = {
  __typename?: 'NwPlusPoints';
  value: Scalars['Int']['output'];
  type: NwPlusPointType;
};

/** The details for the N+ Exclusive Feature Card */
export type NwPlusExclusiveFeatureCard = {
  __typename?: 'NwPlusExclusiveFeatureCard';
  id: Scalars['String']['output'];
  title: Scalars['String']['output'];
  body: Scalars['String']['output'];
  points?: Maybe<NwPlusPoints>;
  ctaText: Scalars['String']['output'];
  ctaUrl: Scalars['String']['output'];
  imageUrl: Scalars['String']['output'];
  isNew?: Maybe<Scalars['Boolean']['output']>;
};

/** Response to the nwPlusExclusiveFeatureCards query */
export type NwPlusExclusiveFeatureCardsResponse = {
  __typename?: 'NwPlusExclusiveFeatureCardsResponse';
  cards?: Maybe<Array<NwPlusExclusiveFeatureCard>>;
};

export type NwPlusCopyUnorderedSubbody = {
  __typename?: 'NwPlusCopyUnorderedSubbody';
  iconUrl?: Maybe<Scalars['String']['output']>;
  text: Array<Scalars['String']['output']>;
};

export type NwPlusCopyBody = {
  __typename?: 'NwPlusCopyBody';
  text?: Maybe<Scalars['String']['output']>;
  orderedSubbody?: Maybe<Array<Scalars['String']['output']>>;
  unorderedSubbody?: Maybe<NwPlusCopyUnorderedSubbody>;
  cta?: Maybe<NwPlusFaqLink>;
};

export type NwPlusCopy = {
  __typename?: 'NwPlusCopy';
  id: Scalars['String']['output'];
  imageUrl?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  body?: Maybe<NwPlusCopyBody>;
  destinationUrl?: Maybe<NwPlusFaqLink>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  buttonCta?: Maybe<NwPlusFaqLink>;
};

export type NwPlusNativeCopyResponse = {
  __typename?: 'NwPlusNativeCopyResponse';
  copies?: Maybe<Array<NwPlusCopy>>;
};

export type NwPlusRewardBenefit = {
  __typename?: 'NwPlusRewardBenefit';
  id: Scalars['String']['output'];
  type: Scalars['String']['output'];
  createdAt: Scalars['String']['output'];
  redeemedAt?: Maybe<Scalars['String']['output']>;
};

/** Response to the nwPlusPurchaseReward mutation */
export type NwPlusPurchaseRewardResponse = {
  __typename?: 'NwPlusPurchaseRewardResponse';
  /** Status for purchasing and redeeming a benefit */
  status: NwPlusRedeemRewardStatus;
  /** Details on the benefit (instance of a purchasable reward) */
  benefit?: Maybe<NwPlusRewardBenefit>;
};

export type NwPlusRewardedCompletedEventFilter = {
  /** The maximum number of events to return */
  limit?: InputMaybe<Scalars['Int']['input']>;
  /** The WLL Event type field to sort the events by (defaults to reportedAt; other options are id, occurredAt, registeredAt, and reactedAt) */
  sort?: InputMaybe<Scalars['String']['input']>;
  /** The order to sort the events by 'DESC' (default) or 'ASC' */
  order?: InputMaybe<NwPlusCompletedEventOrder>;
  /** The WLL Event ID of the last event returned in the previous page */
  startAfterId?: InputMaybe<Scalars['String']['input']>;
  /** The most recent desired date of emission for events (inclusive, RFC3339 format) */
  emittedBefore?: InputMaybe<Scalars['String']['input']>;
  /** The oldest desired date of emission for events (exclusive, RFC3339 format) */
  emittedAfter?: InputMaybe<Scalars['String']['input']>;
  /** Include events indicating points manually granted by UserOps */
  includeManuallyGranted?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Response to NwPlusMonthlyCreditCardPaymentInfo Query */
export type NwPlusMonthlyCreditCardPaymentInfoResponse = {
  __typename?: 'NwPlusMonthlyCreditCardPaymentInfoResponse';
  creditCardAccounts: Array<FinancialAccount>;
  creditCardSelectedAccountId?: Maybe<Scalars['String']['output']>;
};

/** Represents the type of offer recommendation. */
export enum OfferRecommendationType {
  Savings = 'SAVINGS'
}

export enum OfferRecommendationConfidence {
  High = 'HIGH',
  Low = 'LOW'
}

export type OfferRecommendation = {
  type: OfferRecommendationType;
  confidence: OfferRecommendationConfidence;
  appAction: ApplicationAction;
  body?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<BankingOfferV2>;
};

export type ScribeUpTermsOfServiceResponse = {
  __typename?: 'ScribeUpTermsOfServiceResponse';
  hasAcknowledged: Scalars['Boolean']['output'];
};

export type ScribeUpBillsDataStatusChangelog = {
  __typename?: 'ScribeUpBillsDataStatusChangelog';
  action: Scalars['String']['output'];
  note: Scalars['String']['output'];
  created: Scalars['String']['output'];
};

export type ScribeUpBillsDataUpcoming = {
  __typename?: 'ScribeUpBillsDataUpcoming';
  merchantName: Scalars['String']['output'];
  amount: Scalars['String']['output'];
  date: Scalars['String']['output'];
  frequency: Scalars['String']['output'];
};

export type ScribeUpBillsUrlInput = {
  autoActivate?: InputMaybe<Scalars['Boolean']['input']>;
  deeplinkParams?: InputMaybe<Scalars['String']['input']>;
  includeNerdWalletPlusMembership?: InputMaybe<Scalars['Boolean']['input']>;
};

export type ScribeUpBillsUrlResponse = {
  __typename?: 'ScribeUpBillsUrlResponse';
  url: Scalars['URL']['output'];
};

export type ScribeUpBillsDataResponse = {
  __typename?: 'ScribeUpBillsDataResponse';
  /** @deprecated Clients should use scribeUpBillsUrl for the url */
  url: Scalars['URL']['output'];
  id: Scalars['String']['output'];
  externalId: Scalars['String']['output'];
  created: Scalars['String']['output'];
  status: Scalars['String']['output'];
  statusChangelog: Array<ScribeUpBillsDataStatusChangelog>;
  lastUpdated?: Maybe<Scalars['String']['output']>;
  count: Scalars['Int']['output'];
  averageMonthlySpend: Scalars['String']['output'];
  upcoming: Array<ScribeUpBillsDataUpcoming>;
};

export type ScribeUpBillsActivatedResponse = {
  __typename?: 'ScribeUpBillsActivatedResponse';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
};

export type AcknowledgeScribeUpTermsOfServiceResponse = {
  __typename?: 'AcknowledgeScribeUpTermsOfServiceResponse';
  success: Scalars['Boolean']['output'];
};

export type ActivateScribeUpBillsResponse = {
  __typename?: 'ActivateScribeUpBillsResponse';
  url: Scalars['URL']['output'];
  activatedAt: Scalars['DateTime']['output'];
};

export type DeactivateScribeUpBillsResponse = {
  __typename?: 'DeactivateScribeUpBillsResponse';
  success: Scalars['Boolean']['output'];
};

/** Represents the information about opening a treasury account. */
export type TreasuryAccountMarketing = {
  __typename?: 'TreasuryAccountMarketing';
  /** @deprecated Use annualPercentageYield for APY or yieldToMaturity for YTM values */
  yieldToMaturityPercentage: Scalars['Float']['output'];
  /** @deprecated Use 'lastFetchedAt' for a more general representation of the last fetch time for all values */
  yieldToMaturityPercentageLastFetchedAt: Scalars['DateTime']['output'];
  yieldToMaturityNetFeesFreemium: Scalars['Float']['output'];
  yieldToMaturityNetFeesNWplus: Scalars['Float']['output'];
  annualPercentageYield: Scalars['Float']['output'];
  yieldToMaturity: Scalars['Float']['output'];
  lastFetchedAt: Scalars['DateTime']['output'];
};

/** Represents the status of a treasury account. */
export type TreasuryAccountStatus = {
  __typename?: 'TreasuryAccountStatus';
  status?: Maybe<Scalars['String']['output']>;
};

/** Represents the details of a user's insurance accounts and policies for UserOps. */
export type AdminInsuranceAccounts = {
  __typename?: 'AdminInsuranceAccounts';
  accounts?: Maybe<Array<AdminInsuranceAccount>>;
};

export type AdminInsuranceAccount = {
  __typename?: 'AdminInsuranceAccount';
  id: Scalars['ID']['output'];
  originalAccountId: Scalars['String']['output'];
  firstName: Scalars['String']['output'];
  middleName?: Maybe<Scalars['String']['output']>;
  lastName: Scalars['String']['output'];
  providerName: Scalars['String']['output'];
  requiresReconnect: Scalars['Boolean']['output'];
  createdAt: Scalars['String']['output'];
  updatedAt: Scalars['String']['output'];
  unsupportedPolicyTypes: Array<Scalars['String']['output']>;
  policies: Array<AdminInsurancePolicy>;
};

export type AdminInsurancePolicy = {
  __typename?: 'AdminInsurancePolicy';
  id: Scalars['ID']['output'];
  providerName?: Maybe<Scalars['String']['output']>;
  insuranceType?: Maybe<Scalars['String']['output']>;
  status: Scalars['String']['output'];
  requiresReconnect?: Maybe<Scalars['Boolean']['output']>;
  hidden: Scalars['Boolean']['output'];
  rates: Array<Rates>;
  missingValues?: Maybe<Array<Scalars['String']['output']>>;
};

export type Rates = {
  __typename?: 'Rates';
  id: Scalars['String']['output'];
  substitutions: Array<Scalars['String']['output']>;
};

/** Represents the status of an Atomic investment account, and the products associated. */
export type InvestmentAccountsStatus = {
  __typename?: 'InvestmentAccountsStatus';
  accountStatus?: Maybe<Scalars['String']['output']>;
  automatedInvestingStatus?: Maybe<AtomicSleeveState>;
  hasAutomatedInvesting?: Maybe<Scalars['Boolean']['output']>;
  hasTreasury?: Maybe<Scalars['Boolean']['output']>;
  treasuryStatus?: Maybe<AtomicSleeveState>;
};

export enum AtomicSleeveState {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  Abandoned = 'ABANDONED'
}

/** Represents the module that can be used to embed/iframe the investment accounts from Atomic. */
export type InvestmentAccountsEmbedModule = {
  __typename?: 'InvestmentAccountsEmbedModule';
  nativeAppAtomicUri?: Maybe<Scalars['String']['output']>;
};

/** Represents the account summary of an Atomic investment account, and the products associated. */
export type InvestmentAccountsSummary = {
  __typename?: 'InvestmentAccountsSummary';
  automatedInvesting?: Maybe<AutomatedInvestingSummary>;
  treasury?: Maybe<TreasurySummary>;
};

export type TreasurySummary = {
  __typename?: 'TreasurySummary';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  earnings?: Maybe<TreasuryEarnings>;
  totalValue?: Maybe<Earnings>;
  yieldToMaturity?: Maybe<Earnings>;
};

export type AutomatedInvestingSummary = {
  __typename?: 'AutomatedInvestingSummary';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  pnl?: Maybe<AutomatedInvestingEarnings>;
  timeWeightedReturn?: Maybe<Earnings>;
  totalValue?: Maybe<Earnings>;
};

export type TreasuryEarnings = {
  __typename?: 'TreasuryEarnings';
  allTime?: Maybe<Earnings>;
  byMonth?: Maybe<Array<Maybe<EarningsByMonth>>>;
};

export type AutomatedInvestingEarnings = {
  __typename?: 'AutomatedInvestingEarnings';
  allTime?: Maybe<EarningsByPercentage>;
  daily?: Maybe<EarningsByPercentage>;
};

export type Earnings = {
  __typename?: 'Earnings';
  value?: Maybe<Scalars['String']['output']>;
};

export type EarningsByPercentage = {
  __typename?: 'EarningsByPercentage';
  value?: Maybe<Scalars['String']['output']>;
  percentage?: Maybe<Scalars['String']['output']>;
};

export type EarningsByMonth = {
  __typename?: 'EarningsByMonth';
  value?: Maybe<Scalars['String']['output']>;
  month?: Maybe<Scalars['String']['output']>;
};

export enum AtomicProductType {
  AutomatedInvesting = 'AUTOMATED_INVESTING',
  Combined = 'COMBINED',
  None = 'NONE',
  Treasury = 'TREASURY'
}

export type InvestmentAccountNwPlusRewardStatus = {
  __typename?: 'InvestmentAccountNwPlusRewardStatus';
  /** Rewards that can be earned from completing the steps */
  rewardTypes: Array<RewardEventPoints>;
  /** The steps for completing this reward. */
  steps: Array<FinancialNwPlusRewardStep>;
};

/** Response to investmentAccountsNwPlusRewards query */
export type InvestmentAccountNwPlusRewardResponse = {
  __typename?: 'InvestmentAccountNwPlusRewardResponse';
  /** List of investment account type rewards a user is eligible to earn points for */
  rewards: Array<InvestmentAccountNwPlusRewardStatus>;
};

/** Enum used to determine the app type of a third party log in */
export enum AppTypeEnum {
  NerdwalletMobile = 'NERDWALLET_MOBILE',
  NerdwalletWeb = 'NERDWALLET_WEB',
  Nwadmin = 'NWADMIN'
}

/** Interface that must be implemented by log in/register user responses */
export type AuthenticationResponseInterface = {
  /** Determines whether user registration was successful */
  success: Scalars['Boolean']['output'];
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
};

export type LogOutUserResponse = {
  __typename?: 'LogOutUserResponse';
  /** Determines whether user log out was successful */
  success: Scalars['Boolean']['output'];
};

export type RegistrationTrackingMetadata = {
  /** The tracking channel for the current user (e.g. 'mobile') */
  trackingChannel?: InputMaybe<Scalars['String']['input']>;
  /** The tracking version for the current user */
  trackingVersion?: InputMaybe<Scalars['String']['input']>;
  /** The tracking vertical for the current user (e.g. 'nw_native_app') */
  trackingVertical?: InputMaybe<Scalars['String']['input']>;
  /** The page impression ID associated with the user registration event */
  pageImpressionId: Scalars['String']['input'];
  /** The navigation source impression ID associated with the user registration event */
  navigationSourceImpressionId: Scalars['String']['input'];
  /** The navigation source tracking code associated with the user registration event */
  navigationSourceTrackingCode?: InputMaybe<Scalars['String']['input']>;
};

export type NwRegisterInfoInput = {
  /** The email used to register an account */
  email: Scalars['EmailAddress']['input'];
  /** The password used to register an account */
  password: Scalars['String']['input'];
  /** The tracking metadata to include with registration */
  trackingMetadata?: InputMaybe<RegistrationTrackingMetadata>;
};

export type NwLoginInfoInput = {
  /** The email used to register an account */
  email: Scalars['EmailAddress']['input'];
  /** The password used to register an account */
  password: Scalars['String']['input'];
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean']['input'];
};

export type GoogleLoginInfoInput = {
  /** The app used to log in with Google */
  appType: AppTypeEnum;
  /** The google OAuth token required for log in/registration */
  googleOAuthToken: Scalars['String']['input'];
  /** The password used to log in with third party credentials (required for the first log in to existing passworded identities) */
  password?: InputMaybe<Scalars['String']['input']>;
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean']['input'];
};

export type AppleLoginInfoInput = {
  /** The app used to log in with Apple */
  appType: AppTypeEnum;
  /** The authorization code associated with the Apple log in/registration */
  authorizationCode: Scalars['String']['input'];
  /** The client ID associated with the Apple log in/registration */
  clientId: Scalars['String']['input'];
  /** The current user's email associated with the Apple log in/registration */
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  /** The current user's first name associated with the Apple log in/registration */
  firstName?: InputMaybe<Scalars['String']['input']>;
  /** The current user's last name associated with the Apple log in/registration */
  lastName?: InputMaybe<Scalars['String']['input']>;
  /** The "number only used once" associated with the Apple log in/registration */
  nonce?: InputMaybe<Scalars['String']['input']>;
  /** The password used to log in with third party credentials (required for the first log in to existing passworded identities) */
  password?: InputMaybe<Scalars['String']['input']>;
  /** The redirect URI ssociated with the Apple log in/registration */
  redirectUri?: InputMaybe<Scalars['String']['input']>;
  /** Determines if the current user should stay logged in */
  rememberMe: Scalars['Boolean']['input'];
};

export type RefreshTokenLoginInfoInput = {
  /** The refresh token used to login */
  refreshToken: Scalars['String']['input'];
  /** Determines if user should stay logged in */
  rememberMe: Scalars['Boolean']['input'];
};

export type SecurityQuestionInfoInput = {
  /** The user's security question */
  question: Scalars['String']['input'];
  /** The user's answer to their security question */
  answer: Scalars['String']['input'];
};

export type UpdatePasswordInfoInput = {
  /** The user's old password before the update */
  oldPassword: Scalars['String']['input'];
  /** The user's new password after the update */
  newPassword: Scalars['String']['input'];
};

export type CompareAutoInsuranceCarriers = {
  __typename?: 'CompareAutoInsuranceCarriers';
  /** Name of State */
  usState: Scalars['String']['output'];
  /** Array of carriers */
  carriers: Array<Carrier>;
};

export type Carrier = {
  __typename?: 'Carrier';
  /** Unique ID of a Carrier */
  id: Scalars['ID']['output'];
  /** Name of a Carrier */
  carrierName: Scalars['String']['output'];
  /** average insurance price */
  avgCost: Scalars['Float']['output'];
  /** average insurance cost for a driver with a DUI history */
  withDUI: Scalars['Float']['output'];
  /** average insurance cost for a driver with a ACCIDENT history */
  withAccident: Scalars['Float']['output'];
  /** average insurance cost for a good driver (no ACCIDENT or DUI history) */
  withGoodDriver: Scalars['Float']['output'];
  /** average insurance cost for a good and poor credit score */
  byCreditRange: CreditRangeMap;
  /** average insurance cost based on driver's age */
  byAgeRange: AgeRangeMap;
  /** Carrier selected by Nerdwallet to feature as best car insurance companies for 2021 */
  best2021: Scalars['Boolean']['output'];
};

export type AgeRangeMap = {
  __typename?: 'AgeRangeMap';
  /** average insurance cost for a driver at age 20 */
  age20: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 25 */
  age25: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 30 */
  age30: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 35 */
  age35: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 40 */
  age40: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 45 */
  age45: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 50 */
  age50: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 55 */
  age55: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 60 */
  age60: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 65 */
  age65: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 70 */
  age70: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 75 */
  age75: Scalars['Float']['output'];
  /** average insurance cost for a driver at age 80 */
  age80: Scalars['Float']['output'];
};

export type CreditRangeMap = {
  __typename?: 'CreditRangeMap';
  /** average insurance cost for a good credit score */
  withGoodCredit: Scalars['Float']['output'];
  /** average insurance cost for a poor credit score */
  withPoorCredit: Scalars['Float']['output'];
};

export enum BillFrequency {
  Annually = 'ANNUALLY',
  TwiceAYear = 'TWICE_A_YEAR',
  Quarterly = 'QUARTERLY',
  EveryOtherMonth = 'EVERY_OTHER_MONTH',
  Monthly = 'MONTHLY',
  EveryOtherWeek = 'EVERY_OTHER_WEEK',
  Weekly = 'WEEKLY',
  OneTime = 'ONE_TIME'
}

export enum BillSubcategory {
  Insurance = 'INSURANCE',
  Loan = 'LOAN'
}

export type Bill = {
  __typename?: 'Bill';
  /** Unique identifier for the bill */
  id: Scalars['ID']['output'];
  /** User's ID */
  identityId?: Maybe<Scalars['ID']['output']>;
  /** Name of the bill */
  name: Scalars['String']['output'];
  /** Who the bill is from (transaction merchant name) */
  biller?: Maybe<Scalars['String']['output']>;
  /** Amount due */
  amount?: Maybe<Scalars['Int']['output']>;
  /** How frequent this bill appears */
  frequency: BillFrequency;
  /** Initial due date that was provided */
  baseDueDate?: Maybe<Scalars['Date']['output']>;
  /** When the bill was paid */
  paidDate?: Maybe<Scalars['Date']['output']>;
  /** Due dates in the past that were assumed to be paid */
  paidDueDates?: Maybe<Array<Scalars['Date']['output']>>;
  /** Next upcoming unpaid due date */
  nextUnpaidDueDate?: Maybe<Scalars['Date']['output']>;
  /** Next several unpaid due dates */
  nextUnpaidDueDates?: Maybe<Array<Scalars['Date']['output']>>;
  /** Next due date, may have been marked as paid or not */
  nextDueDate?: Maybe<Scalars['Date']['output']>;
  /**
   * Which financial category bill falls under
   * @deprecated Deprecated in favor of the categoryId field which returns a V2 category ID.
   */
  category: FinancialTransactionCategory;
  /** Which financial V2 NW category ID the category bill falls under. */
  categoryId?: Maybe<Scalars['ID']['output']>;
  /** Additional subcategory */
  subcategory?: Maybe<BillSubcategory>;
};

export type BillsResponse = {
  __typename?: 'BillsResponse';
  bills: Array<Bill>;
};

export type CapeOffer = {
  __typename?: 'CapeOffer';
  id?: Maybe<Scalars['String']['output']>;
  originatingTransactionId?: Maybe<Scalars['String']['output']>;
  identityId?: Maybe<Scalars['String']['output']>;
  marketplaceId?: Maybe<Scalars['String']['output']>;
  partnerName?: Maybe<Scalars['String']['output']>;
  partnerOfferId?: Maybe<Scalars['Int']['output']>;
  url?: Maybe<Scalars['String']['output']>;
  term?: Maybe<Scalars['Int']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  interestRate?: Maybe<Scalars['Float']['output']>;
  apr?: Maybe<Scalars['Float']['output']>;
  monthlyPayment?: Maybe<Scalars['Float']['output']>;
  originationFee?: Maybe<Scalars['Float']['output']>;
  offerDate?: Maybe<Scalars['String']['output']>;
  expirationDate?: Maybe<Scalars['String']['output']>;
  legalDisclaimer?: Maybe<Scalars['String']['output']>;
  isSecuredLoan?: Maybe<Scalars['Boolean']['output']>;
};

export type CashFlowHistoryMonthlyBreakdownDatum = {
  __typename?: 'CashFlowHistoryMonthlyBreakdownDatum';
  /** A date in the month that this datum represents */
  date: Scalars['Date']['output'];
  /** The amount spent in dollars and cents. */
  spending: Scalars['Float']['output'];
  /**
   * The user's actual earning for the month, in dollars. Earning is credits minus
   *   debits in the income category. Estimated income is based on user self-reported values
   *   or if that is not provided, then based on transactions in the income category.
   */
  earning: Scalars['Float']['output'];
  /**
   * The user's estimated income for the month, in dollars. It is only present for
   *   the current month. Estimated income is based on user self-reported values or
   *   if that is not provided, then based on transactions in the income category.
   */
  estimatedIncome?: Maybe<Scalars['Float']['output']>;
  /**
   * The total sum amount of payments needed to cover bills due over the rest of the month, in dollars and cents.
   *   Note: this value is only present for the currentMonth (otherwise there are no upcoming bills)
   */
  upcomingBills?: Maybe<Scalars['Float']['output']>;
  /**
   * Computed as ((earnings or estimatedIncome) - spending - upcomingBills (if any)).
   *   Note: this value can be negative
   */
  remaining: Scalars['Float']['output'];
};

export type CashFlowHistoryBreakdown = {
  __typename?: 'CashFlowHistoryBreakdown';
  /** Month by month breakdown of historical cash flow, current month included */
  cashFlowHistoryBreakdown: Array<CashFlowHistoryMonthlyBreakdownDatum>;
  /**
   * The average of the 'remaining' fields in the breakdown, current month NOT included
   *   A positive number means, on average, the user has saved more than they have spent.
   */
  averageSavingsRemaining?: Maybe<Scalars['Float']['output']>;
};

export type CashFlowBreakdown = {
  __typename?: 'CashFlowBreakdown';
  /** The amount spent in dollars and cents. */
  spending: Scalars['Float']['output'];
  /**
   * The user's estimated income for the month in dollars. Income is estimated
   *   based on user self-reported values or if that is not provided, then based
   *   on transactions in the income category.
   */
  estimatedIncome: Scalars['Float']['output'];
  /** The total sum amount of payments needed to cover bills due over the rest of the month, in dollars and cents. */
  upcomingBillsTotalDue: Scalars['Float']['output'];
  /**
   * Computed as (estimated income - spending - upcomingBillsTotalDue).
   *   Note: this value can be negative
   */
  remaining: Scalars['Float']['output'];
};

export type CashFlowTakeaway = {
  __typename?: 'CashFlowTakeaway';
  /** A label describing the takeaway (user facing). */
  label?: Maybe<Scalars['String']['output']>;
  /** The body of the takeaway - describes the takeaway for the user in more detail (user facing). */
  body: Scalars['String']['output'];
  /** A string that describes the type of takeaway (e.g. ONBOARDING) (used for analytics). */
  theme?: Maybe<Scalars['String']['output']>;
  /** A string that can further describe the type within the larger theme of the takeaway (used for analytics). */
  subtheme?: Maybe<Scalars['String']['output']>;
  /** A string representing the takeaway name (used for analytics) */
  takeaway?: Maybe<Scalars['String']['output']>;
  /**
   * Describes the sentiment of the takeaway and further helps distinguish when theme/subtheme are the same
   *   (e.g. POSITIVE) (used for analytics).
   */
  condition?: Maybe<Scalars['String']['output']>;
  /**
   * A list of actions that the user can take related to this takeaway. These usually represent
   *   links to another page or screen so the user can dig into the details of the takeaway. There's usually
   *   1 action per takeaway (but this is not a requirement).
   */
  actions: Array<AppAction>;
};

export type ChapterData = {
  __typename?: 'ChapterData';
  /** Url to the health network page */
  redirectUrl: Scalars['String']['output'];
  /** Unique identifier for the health network */
  id: Scalars['ID']['output'];
};

export type ContentPacksOptionsInput = {
  /** If specified, returns either personalized content pack or interest-based content pack */
  includePersonalizedContentPack?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Contains a content pack and its meta data */
export type ContentPackPlacement = {
  __typename?: 'ContentPackPlacement';
  /** A single content pack and its associated data */
  contentPack: ContentPack;
  /** The list of model execution IDs used in personalized/fallback content packs */
  modelExecutionIds?: Maybe<Array<Scalars['String']['output']>>;
};

export type ContentPackResponse = {
  __typename?: 'ContentPackResponse';
  /** The list of content packs returned by the query */
  contentPackPlacements?: Maybe<Array<ContentPackPlacement>>;
};

export type ContentRecommendations = {
  __typename?: 'ContentRecommendations';
  personalised?: Maybe<Array<PostInterface>>;
  popular?: Maybe<Array<PostInterface>>;
  trending?: Maybe<Array<PostInterface>>;
};

/** A type that represents an empty object. */
export type EmptyObject = {
  __typename?: 'EmptyObject';
  _empty?: Maybe<Scalars['String']['output']>;
};

/**
 * The `Cookie` type represents a cookie, with all the standard cookie properties.
 * See https://tools.ietf.org/html/rfc6265
 */
export type Cookie = {
  __typename?: 'Cookie';
  name: Scalars['String']['output'];
  value: Scalars['String']['output'];
  expires?: Maybe<Scalars['String']['output']>;
  maxAge?: Maybe<Scalars['String']['output']>;
  domain?: Maybe<Scalars['String']['output']>;
  path?: Maybe<Scalars['String']['output']>;
  secure?: Maybe<Scalars['Boolean']['output']>;
  httpOnly?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A Set-Cookie header literal representing the Cookie
   *
   *   Example: 'AWSALB=n2EKrJVwfmU1FJ0KMGnRY01LfTmkFJmLAF0dNjkuMoW/V7QPwdDatoDKrmzTjDP7j1fO7VTyl/MXjp8Tljq3yM8nmTs9HsSUcZi0f2ik77H9chfNR86RX2ud7zMl; Expires=Fri, 29 Mar 2019 18:47:06 GMT; Path=/'
   */
  headerString: Scalars['String']['output'];
};

export enum CreditBuilderLoanStatus {
  /** The applicant supplied their payment information and has accepted the loan */
  Accepted = 'Accepted',
  /** A borrower has applied for credit builder loan */
  Applied = 'Applied',
  /** The applicant's loan has been approved */
  Approved = 'Approved',
  /** The loan has been closed due to bankruptcy */
  Bankruptcy = 'Bankruptcy',
  /** The loan has been fully paid off and closed */
  Closed = 'Closed',
  /** The first payment cleared and the loan has been funded */
  Funded = 'Funded',
  /** The borrower's identity couldn't be verified. A manual identification process may be employed at this point. */
  KycReject = 'KYCReject',
  Late30 = 'Late30',
  Late60 = 'Late60',
  Late90 = 'Late90',
  ManualReview = 'ManualReview',
  MilitaryException = 'MilitaryException',
  MilitaryReject = 'MilitaryReject',
  PaidInFull = 'PaidInFull',
  Pending = 'Pending',
  PendingSurrendered = 'PendingSurrendered',
  /** The borrower's identity couldn't be verified */
  Reject = 'Reject',
  /** The borrower has surrendered the loan, whether voluntarily or involuntarily */
  Surrendered = 'Surrendered',
  Repossessed = 'Repossessed',
  /** No loan record was found */
  LoanNotFound = 'LoanNotFound'
}

export type CreditBuilderLoanResponse = {
  __typename?: 'CreditBuilderLoanResponse';
  /** Error message so client can act on, if any */
  error?: Maybe<Scalars['String']['output']>;
  /** Current status of the user's Credit Builder Loan if available */
  loanStatus?: Maybe<CreditBuilderLoanStatus>;
};

/** The persisted set of answers that the user submitted in the Credit Card Match quiz flow. */
export type CreditCardMatchQuizAnswersResponse = {
  __typename?: 'CreditCardMatchQuizAnswersResponse';
  answers?: Maybe<Scalars['JSON']['output']>;
  quizVersion: Scalars['Int']['output'];
};

export type CreditCardMatchQuizOffersResponse = {
  __typename?: 'CreditCardMatchQuizOffersResponse';
  offers: Array<Maybe<CreditCardsOfferV2>>;
  fallbackOffers: Array<Maybe<CreditCardsOfferV2>>;
  userCardOffers: Array<Maybe<CreditCardsOfferV2>>;
};

export enum CreditFactorImpactLevel {
  Highest = 'HIGHEST',
  High = 'HIGH',
  Medium = 'MEDIUM',
  Low = 'LOW'
}

export enum CreditFactorSentiment {
  Negative = 'NEGATIVE',
  Positive = 'POSITIVE'
}

export enum CreditHistoryPayStatusCode {
  Current = 'CURRENT',
  Unknown = 'UNKNOWN',
  Late_30Days = 'LATE_30_DAYS',
  Late_60Days = 'LATE_60_DAYS',
  Late_90Days = 'LATE_90_DAYS',
  Late_120Days = 'LATE_120_DAYS',
  Late_150Days = 'LATE_150_DAYS',
  PaymentPlan = 'PAYMENT_PLAN',
  Repossession = 'REPOSSESSION',
  CollectionChargeoff = 'COLLECTION_CHARGEOFF'
}

export enum CreditFactorTradelineOpenClosedSymbol {
  Closed = 'CLOSED',
  Open = 'OPEN'
}

export type CreditFactorTradelinePayHistoryDatum = {
  __typename?: 'CreditFactorTradelinePayHistoryDatum';
  /** The date that the corresponding status was submitted */
  date?: Maybe<Scalars['String']['output']>;
  /** The pay status for the tradeline */
  status?: Maybe<CreditHistoryPayStatusCode>;
};

export type CreditFactorTradelinePayHistoryByMonthDatum = {
  __typename?: 'CreditFactorTradelinePayHistoryByMonthDatum';
  /** The year that the corresponding statuses were submitted */
  year?: Maybe<Scalars['String']['output']>;
  /**
   * The pay status codes for each month of the tradeline.
   *
   *   `payStatusCodesByMonth` is a fixed array of 12 pay status codes, one per each month of the year. In the scenario where a pay status code does not exist for the month, null is used to represent that month in the array.
   */
  payStatusCodesByMonth?: Maybe<Array<Maybe<CreditHistoryPayStatusCode>>>;
};

export type CreditFactorTradeline = {
  __typename?: 'CreditFactorTradeline';
  /** The condition of the account */
  accountCondition?: Maybe<Scalars['String']['output']>;
  /** The party responsible for the account (e.g. Individual) */
  accountDesignator?: Maybe<Scalars['String']['output']>;
  /** The last 4 digits on the account */
  accountNumberLast4?: Maybe<Scalars['String']['output']>;
  /** The raw representation of the tradeline subtype */
  accountSubtype?: Maybe<Scalars['String']['output']>;
  /** The symbol for the account subtype */
  accountSubtypeSymbol?: Maybe<Scalars['String']['output']>;
  /** The raw representation of the tradeline type */
  accountType?: Maybe<Scalars['String']['output']>;
  /** The 1-character symbol for the account type */
  accountTypeSymbol?: Maybe<Scalars['String']['output']>;
  /** The amount due on the due date */
  amountPastDue?: Maybe<Scalars['Float']['output']>;
  accountDisplayType?: Maybe<Scalars['String']['output']>;
  /** A non-guaranteed unique identifier for this tradeline for this user */
  compositeKey?: Maybe<Scalars['String']['output']>;
  creditLimit?: Maybe<Scalars['Float']['output']>;
  /** The user friendly name for the creditor */
  creditorDisplayName?: Maybe<Scalars['String']['output']>;
  /** A URL for the logo of the creditor */
  creditorLogo?: Maybe<Scalars['String']['output']>;
  /** The raw name of the creditor */
  creditorName?: Maybe<Scalars['String']['output']>;
  /** The balance on the account */
  currentBalance?: Maybe<Scalars['Float']['output']>;
  /** The date the account was opened */
  dateOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The most recent date the account was reported */
  dateReportedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The high balance on the account */
  highBalance?: Maybe<Scalars['Float']['output']>;
  isOpen?: Maybe<Scalars['Boolean']['output']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  /** The monthly payment for the account */
  monthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** The normalized credit limit */
  nwCreditLimitNormalized?: Maybe<Scalars['Float']['output']>;
  /** The number of months the account has been open */
  nwMonthsOpened?: Maybe<Scalars['Int']['output']>;
  /** The utilization on the account (decimal between 0 and 1) */
  nwUtilizationPct?: Maybe<Scalars['Float']['output']>;
  /** The open/closed symbol of the account */
  openClosedSymbol?: Maybe<CreditFactorTradelineOpenClosedSymbol>;
  /** The pay history of the account */
  payHistoryBreakDown?: Maybe<Array<CreditFactorTradelinePayHistoryDatum>>;
  /** The pay history of the account grouped by months */
  payHistoryBreakDownByMonth?: Maybe<Array<CreditFactorTradelinePayHistoryByMonthDatum>>;
  payHistoryStatus?: Maybe<Scalars['String']['output']>;
  /** The current pay status of the account (raw) */
  payStatus?: Maybe<Scalars['String']['output']>;
  /** The current pay status of the account (user-friendly) */
  payStatusDisplayName?: Maybe<Scalars['String']['output']>;
  /** An optional remark on the account */
  remark?: Maybe<Scalars['String']['output']>;
  /** The length of the loan in months */
  termMonths?: Maybe<Scalars['Int']['output']>;
  /** The user-friendly name for the tradeline */
  tradelineDisplayName?: Maybe<Scalars['String']['output']>;
  wasDisputed?: Maybe<Scalars['Boolean']['output']>;
};

export type CreditFactorDelta = {
  __typename?: 'CreditFactorDelta';
  /** The delta in the credit factor value used for showing changes. */
  value: Scalars['Float']['output'];
  /** The units for the delta change of the factor. */
  unit: UserInsightGainUnitEnum;
};

export type CreditFactorCoreMetric = {
  __typename?: 'CreditFactorCoreMetric';
  /** The NerdWallet suggestion for the credit factor */
  commentary?: Maybe<Scalars['String']['output']>;
  /** The tooltip description for the status of the credit factor */
  description?: Maybe<Scalars['String']['output']>;
  /** The main headline figure for the core metric of the factor */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The label for the displayName */
  label?: Maybe<Scalars['String']['output']>;
  /** The primary value of the core metric (for analytics purposes) */
  value?: Maybe<Scalars['String']['output']>;
  /** An optional secondary value for some factors (for analytics purposes) */
  secondaryValue?: Maybe<Scalars['String']['output']>;
};

export type CreditFactorCommonQuestion = {
  __typename?: 'CreditFactorCommonQuestion';
  /** The answer to the question, separated as paragraphs */
  answerParagraphs?: Maybe<Array<Scalars['String']['output']>>;
  /** A unique identifier for this question */
  key?: Maybe<Scalars['String']['output']>;
  /** The question */
  question?: Maybe<Scalars['String']['output']>;
  /** An optional link to find out more (typically links to an article) */
  learnMoreLink?: Maybe<AppAction>;
};

export type CreditFactorInquiry = {
  __typename?: 'CreditFactorInquiry';
  /** The bureau responsible for the inquiry */
  bureau?: Maybe<Scalars['String']['output']>;
  /** A non-guaranteed unique identifier for this inquiry */
  compositeKey?: Maybe<Scalars['String']['output']>;
  /** The industry the inquirer is in */
  industry?: Maybe<Scalars['String']['output']>;
  /** The date of the inquiry */
  inquiredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The type of inquiry */
  inquiryType?: Maybe<Scalars['String']['output']>;
  /** True if the inquiry has "fallen off" of the user's credit report: exists on their second-most-recent credit report, but not on their most recent credit report. */
  isNoLongerValid?: Maybe<Scalars['Boolean']['output']>;
  /** The name of the creditor that made the inquiry */
  subscriberName?: Maybe<Scalars['String']['output']>;
};

/** Metadata passed to analytics events */
export type CreditFactorTrackingMetadata = {
  __typename?: 'CreditFactorTrackingMetadata';
  /** The sentiment of the credit factor or "-" */
  highlightStatus?: Maybe<Scalars['String']['output']>;
  /** The change in account status (used in the ageAndMixOfAccounts factor) */
  accountStatusChange?: Maybe<Scalars['String']['output']>;
  /** The change in inquiry status (used in the recentInquiries factor) */
  inquiryStatusChange?: Maybe<Scalars['String']['output']>;
  /** The derogatory payment type (optional) (used in the paymentHistory factor) */
  paymentDerogatoryType?: Maybe<Scalars['String']['output']>;
  /** The change in payment status (used in the paymentHistory factor) */
  paymentStatusChange?: Maybe<Scalars['String']['output']>;
  /** The current bucket of credit utilization, as defined by NW (used in the creditUtilization factor) */
  utilizationCurrentBucket?: Maybe<Scalars['String']['output']>;
  /** The direction of change of credit utilization (used in the creditUtilization factor) */
  utilizationDirectionChange?: Maybe<Scalars['String']['output']>;
};

export type CreditFactorInquirySection = {
  __typename?: 'CreditFactorInquirySection';
  /** The short form title used in the priority section */
  abbreviatedTitle?: Maybe<Scalars['String']['output']>;
  /** The list of all inquiries on the user's credit report */
  inquiries?: Maybe<Array<CreditFactorInquiry>>;
  /** True for groups of inquiries that should be highlighted for users to indicate changes or importance */
  isPriority?: Maybe<Scalars['Boolean']['output']>;
  /** The user-facing label describing the sentiment of the inquiry section */
  label?: Maybe<Scalars['String']['output']>;
  /** The sentiment of the inquiry section */
  sentiment?: Maybe<CreditFactorSentiment>;
  /** The full length title for the section (only use in priority sections) */
  title?: Maybe<Scalars['String']['output']>;
  /** Tracking metadata for the section */
  trackingMetadata?: Maybe<CreditFactorTrackingMetadata>;
};

export type CreditFactorTradelineSection = {
  __typename?: 'CreditFactorTradelineSection';
  /** The short form title used in the priority section */
  abbreviatedTitle?: Maybe<Scalars['String']['output']>;
  /** True for groups of tradelines that should be highlighted for users to indicate changes or importance */
  isPriority?: Maybe<Scalars['Boolean']['output']>;
  /** A unique identifier for the section */
  key?: Maybe<Scalars['String']['output']>;
  /** The user-facing label describing the sentiment of the tradeline section */
  label?: Maybe<Scalars['String']['output']>;
  /** The sentiment of the tradeline section */
  sentiment?: Maybe<CreditFactorSentiment>;
  /** The subtitle describing the tradeline section */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The title of the tradeline section */
  title?: Maybe<Scalars['String']['output']>;
  /** Tracking metadata for the section */
  trackingMetadata?: Maybe<CreditFactorTrackingMetadata>;
  /** All tradelines associated with this section */
  tradelines?: Maybe<Array<CreditFactorTradeline>>;
};

export type CreditFactor = {
  __typename?: 'CreditFactor';
  /** All common questions about this credit factor */
  commonQuestions?: Maybe<Array<CreditFactorCommonQuestion>>;
  /** Data about the core metric for this factor */
  coreMetric?: Maybe<CreditFactorCoreMetric>;
  /** The impact level of this factor on the user's credit score */
  impactLevel?: Maybe<CreditFactorImpactLevel>;
  /** All inquiry sections (only used in recentInquiries factor) */
  inquirySections?: Maybe<Array<CreditFactorInquirySection>>;
  /** The priority inquiry section (only used in recentInquiries factor) */
  priorityInquirySection?: Maybe<CreditFactorInquirySection>;
  /** A list of links to get more information about this factor */
  moreInfoLinks?: Maybe<Array<AppAction>>;
  /** The datetime the user's credit report was last pulled */
  reportPulledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The priority tradeline section (used in all factors other than recentInquiries) */
  priorityTradelineSection?: Maybe<CreditFactorTradelineSection>;
  /** All tradeline sections (used in all factors other than recentInquiries) */
  tradelineSections?: Maybe<Array<CreditFactorTradelineSection>>;
  /** The delta of the credit factor value since last time their report was pulled. */
  delta?: Maybe<CreditFactorDelta>;
};

export type CreditFactors = {
  __typename?: 'CreditFactors';
  ageAndMixOfAccounts?: Maybe<CreditFactor>;
  balances?: Maybe<CreditFactor>;
  creditUtilization?: Maybe<CreditFactor>;
  paymentHistory?: Maybe<CreditFactor>;
  recentInquiries?: Maybe<CreditFactor>;
  numTradelines?: Maybe<Scalars['Int']['output']>;
};

export type CreditFactorTip = {
  __typename?: 'CreditFactorTip';
  /** Condition for reporting the tip */
  condition?: Maybe<Scalars['String']['output']>;
  /** Link to read more about the tip */
  cta?: Maybe<AppAction>;
  /** Reasons on why the tip may help */
  justification: Scalars['String']['output'];
  /** Unique identifier */
  key: Scalars['String']['output'];
  /** What to keep in mind */
  reminderParagraphs?: Maybe<Array<Scalars['String']['output']>>;
  /** Steps on how to follow the tip */
  steps: Array<Scalars['String']['output']>;
  /** The tip itself */
  title: Scalars['String']['output'];
};

export type CreditFactorTips = {
  __typename?: 'CreditFactorTips';
  ageAndMixOfAccounts?: Maybe<Array<Maybe<CreditFactorTip>>>;
  balances?: Maybe<Array<Maybe<CreditFactorTip>>>;
  creditUtilization?: Maybe<Array<Maybe<CreditFactorTip>>>;
  paymentHistory?: Maybe<Array<Maybe<CreditFactorTip>>>;
  recentInquiries?: Maybe<Array<Maybe<CreditFactorTip>>>;
};

export enum CreditProfileAuthResponseErrorEnum {
  PreconditionFailedDuplicateSsn = 'PRECONDITION_FAILED_DUPLICATE_SSN'
}

export enum CreditProfileAuthStatus {
  Active = 'ACTIVE',
  Authenticated = 'AUTHENTICATED',
  Blocked = 'BLOCKED',
  Deactivated = 'DEACTIVATED',
  Inactive = 'INACTIVE',
  Pending = 'PENDING'
}

export enum CreditProfileAuthThinFileReason {
  /** TU is enforcing rate limiting */
  Duplicate = 'DUPLICATE',
  /** True ThinFile - user lacks enough data to generate exam */
  NoData = 'NO_DATA',
  /** User has been 'fuzzy matched' but something doesn't look right */
  FailVerification = 'FAIL_VERIFICATION',
  /** Catch all */
  Other = 'OTHER'
}

export type CreditProfileAuthCustomerInput = {
  /** User's full SSN (e.g. "123456789") */
  fullSsn?: InputMaybe<Scalars['String']['input']>;
  /** User's last four of SSN (e.g. "1234") */
  partialSsn?: InputMaybe<Scalars['String']['input']>;
  /** User's first name */
  firstName: Scalars['String']['input'];
  /** User's last name */
  lastName: Scalars['String']['input'];
  /** User's date of birth in the format YYYY-MM-DD */
  dateOfBirth: Scalars['Date']['input'];
  /** User's mailing address */
  mailingAddress: IdentityAddressInput;
  /** User's middle name */
  middleName?: InputMaybe<Scalars['String']['input']>;
  /** User's prefix */
  prefix?: InputMaybe<Scalars['String']['input']>;
  /** User's suffix */
  suffix?: InputMaybe<Scalars['String']['input']>;
  /** User's previous address */
  previousAddress?: InputMaybe<IdentityAddressInput>;
  /** User's 11-digit phone number (ex. 14045049006), which includes country code. Set it to initiate OTP (One time passcode) flow, if user qualifies. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

export type CreditProfileAuthAnswerInput = {
  /** The ID of the question */
  questionId: Scalars['String']['input'];
  /** The ID of the answer */
  answerId: Scalars['String']['input'];
  /** For questions that require a user input (such as a passcode for OTP) */
  userInputAnswer?: InputMaybe<Scalars['String']['input']>;
};

export type CreditProfileAuthAnswer = {
  __typename?: 'CreditProfileAuthAnswer';
  /** The ID of the answer */
  id: Scalars['String']['output'];
  /** The value of the answer */
  text: Scalars['String']['output'];
  /** The order to show the answer */
  sequence: Scalars['Int']['output'];
};

export type CreditProfileAuthQuestion = {
  __typename?: 'CreditProfileAuthQuestion';
  /** The ID of the question */
  id: Scalars['String']['output'];
  /** The type of the question */
  type: Scalars['String']['output'];
  /** The question itself as text */
  text: Scalars['String']['output'];
  /** The order to show the question */
  sequence: Scalars['Int']['output'];
  /** The list of answer choices */
  answers: Array<CreditProfileAuthAnswer>;
};

export type CreditProfileAuthResponseError = {
  __typename?: 'CreditProfileAuthResponseError';
  data?: Maybe<Scalars['JSON']['output']>;
  errorType: CreditProfileAuthResponseErrorEnum;
};

/**
 * The `CreditProfileAuthStatusProfile` represents a TransUnion Authentication Status.
 * Github link (TUAuthenticationStatusProfile): https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/profiles.py
 */
export type CreditProfileAuthStatusProfile = {
  __typename?: 'CreditProfileAuthStatusProfile';
  /** What is the status of the TU link (PENDING, ACTIVE, AUTHENTICATED, etc.) */
  status: CreditProfileAuthStatus;
  /** When was the profile authenticated at */
  authenticatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When was the profile activated at */
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When was the profile deactivated at */
  deactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When was the profile reactivated at */
  reactivatedAt?: Maybe<Scalars['DateTime']['output']>;
  /** When was the profile blocked at */
  blockedAt?: Maybe<Scalars['DateTime']['output']>;
  /** List of questions to authenticate */
  questions?: Maybe<Array<CreditProfileAuthQuestion>>;
  /** Set to true if the questions are tied to the OTP flow */
  inOtpFlow?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if the user has a thin file */
  hasThinFile?: Maybe<Scalars['Boolean']['output']>;
  /** Reason for the thin file */
  thinFileReason?: Maybe<CreditProfileAuthThinFileReason>;
  /** Is the user deceased */
  isDeceased?: Maybe<Scalars['Boolean']['output']>;
  /** Indicates if there is not enough data */
  notEnoughData?: Maybe<Scalars['Boolean']['output']>;
  /** Number of pulls in the past 24 hours */
  numPullsInPast24Hours?: Maybe<Scalars['Int']['output']>;
  /** TU ID */
  tuId?: Maybe<Scalars['String']['output']>;
  /** The previous status */
  previousStatus?: Maybe<CreditProfileAuthStatus>;
  /** Short message about the status of the operation (TU Initialized, User Already Active, etc.) */
  message?: Maybe<Scalars['String']['output']>;
  /** More details on top of the message (e.g. User already has activated TU on same NW account) */
  description?: Maybe<Scalars['String']['output']>;
};

export type AuthenticateCreditProfileResponseUnion = TuCreditReportIdentityProfile | CreditProfileAuthStatusProfile;

export type CreditProfileAuthResponseUnion = CreditProfileAuthStatusProfile | CreditProfileAuthResponseError;

/**
 * The input supplied to the trustSessionId query.
 *
 * The blackBox string is an obfuscated device fingerprint obtained from Transunion-owned code running on the user's
 * device.
 */
export type TrustSessionIdInput = {
  blackBox: Scalars['String']['input'];
};

/** The response from the trustSessionId query */
export type TrustSessionIdResponse = {
  __typename?: 'TrustSessionIdResponse';
  /** @deprecated The backend will handle the exchange and usage of the trust session ID.  Clients should no longer be using it. */
  trustSessionId: Scalars['String']['output'];
  success?: Maybe<Scalars['Boolean']['output']>;
};

/** Represents all possible credit score history intervals */
export enum CreditScoreHistoryIntervalEnum {
  All = 'ALL',
  Month = 'MONTH',
  Week = 'WEEK',
  Day = 'DAY'
}

/** Represents a TransUnion credit report as it is used in the NW product experience */
export type TuCreditReport = {
  __typename?: 'TuCreditReport';
  /** A user's numerical credit score */
  vantageScore3?: Maybe<Scalars['Int']['output']>;
  /** A user's credit score bucket (i.e. POOR, GOOD, etc.) */
  vantageScore3Bucket?: Maybe<TuVantageScore3Buckets>;
  /**
   * The numerical change in a user's credit score between their current score and
   *   their most recent prior score
   */
  vantageScore3Delta?: Maybe<Scalars['Int']['output']>;
  /** The TU user's current address */
  currentAddress: IdentityAddress;
  /** The TU employers belonging to the user's credit report */
  employers?: Maybe<Array<TuEmployer>>;
  /** The TU credit inquiries belonging to the user's credit report */
  inquiries?: Maybe<Array<CreditFactorInquiry>>;
  /** Indicates if the user's credit report is considered stale */
  isStale?: Maybe<Scalars['Boolean']['output']>;
  /** The timestamp that the next credit report will be pulled at */
  nextReportPullAt?: Maybe<Scalars['DateTime']['output']>;
  /** The percent utilization based on the user's credit limit */
  percentUtilization?: Maybe<Scalars['Float']['output']>;
  /** The TU public records belonging to the user's credit report */
  publicRecords?: Maybe<Array<TuPublicRecord>>;
  /** The timestamp that the current credit report was pulled at */
  reportPulledAt?: Maybe<Scalars['DateTime']['output']>;
  /** The total credit balance across all accounts */
  totalCreditBalance: Scalars['Float']['output'];
  /** The TU credit tradelines belonging to the user's credit report */
  tradelines?: Maybe<Array<CreditFactorTradeline>>;
};

/** A credit score history data point */
export type CreditScoreHistoryDatum = {
  __typename?: 'CreditScoreHistoryDatum';
  /** The credit score associated with the pull date */
  vantageScore3?: Maybe<Scalars['Int']['output']>;
  /** The date the credit score was pulled at */
  date?: Maybe<Scalars['DateTime']['output']>;
};

export type CreditScoreHistoryResponse = {
  __typename?: 'CreditScoreHistoryResponse';
  /** An array of credit score data points used to represent a user's credit score history */
  data?: Maybe<Array<CreditScoreHistoryDatum>>;
};

export type SimulateCreditScoreResponse = {
  __typename?: 'SimulateCreditScoreResponse';
  /** The simulated credit score when adding child support */
  addChildSupportResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when adding a foreclosure */
  addForeclosureResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when adding a tax lien */
  addTaxLienResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when adding wage garnishment */
  addWageGarnishmentResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when all accounts are past due for a number of days */
  allAccountsPastDueNumDaysResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when applying for a number of credit cards */
  applyForNumberOfCreditCardResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when closing the oldest credit card */
  closeOldestCreditCardResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when decreasing the credit card balance amount */
  decreaseCreditBalanceAmountResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when increasing the credit balance amount */
  increaseCreditBalanceAmountResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when increasing the credit card limit */
  increaseCreditCardLimitResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when moving one account into collection */
  moveOneAccountIntoCollectionResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when obtaining an auto loan limit */
  obtainAutoLoanLimitResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when obtaining a credit card limit */
  obtainCreditCardLimitResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when obtaining a mortgage limit */
  obtainMortgageLimitResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when obtaining a personal loan limit */
  obtainPersonalLoanLimitResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when making on time payments for a number of months */
  onTimePaymentsNumMonthsResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when one account is past due for a number of days */
  oneAccountPastDueNumDaysResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when paying off all credit cards */
  payOffAllCreditCardsResult?: Maybe<Scalars['Int']['output']>;
  /** The simulated credit score when transferring a credit balance amount */
  transferCreditBalanceAmountResult?: Maybe<Scalars['Int']['output']>;
};

export type SimulateVantageScoreResponse = {
  __typename?: 'SimulateVantageScoreResponse';
  result?: Maybe<Scalars['Int']['output']>;
};

export type CreditSimulationInput = {
  /** Simulates a credit score depending if child support is added */
  addChildSupport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Simulates a credit score depending if a foreclosure is added */
  addForeclosure?: InputMaybe<Scalars['Boolean']['input']>;
  /** Simulates a credit score depending if tax lien is added */
  addTaxLien?: InputMaybe<Scalars['Boolean']['input']>;
  /** Simulates a credit score depending if wage garnishment is added */
  addWageGarnishment?: InputMaybe<Scalars['Boolean']['input']>;
  /** Simulates a credit score given all accounts are past due for a number of days (valid number of days: 30, 60 or 90 days) */
  allAccountsPastDueNumDays?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score depending if a number of credit card is applied for */
  applyForNumberOfCreditCard?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score depending if the user's oldest credit card is closed */
  closeOldestCreditCard?: InputMaybe<Scalars['Boolean']['input']>;
  /** Simulates a credit score given the user's credit balance is decreased by a certain amount */
  decreaseCreditBalanceAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score given the user's credit balance is increased by a certain amount */
  increaseCreditBalanceAmount?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score given the user's credit card limit is increased by a certain amount */
  increaseCreditCardLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score depending if an account is moved into collection */
  moveOneAccountIntoCollection?: InputMaybe<Scalars['Boolean']['input']>;
  /** Simulates a credit score given the user obtains an auto loan limit for a certain amount */
  obtainAutoLoanLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score given the user obtains a credit card limit for a certain amount */
  obtainCreditCardLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score given the user obtains a mortgage limit for a certain amount */
  obtainMortgageLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score given the user obtains a personal loan limit for a certain amount */
  obtainPersonalLoanLimit?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score given the user makes on time payments for a certain number of months (minimum months: 1, maximum months: 24) */
  onTimePaymentsNumMonths?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score given the user has one account past due for a certain number of days (valid number of days: 30, 60 or 90 days) */
  oneAccountPastDueNumDays?: InputMaybe<Scalars['Int']['input']>;
  /** Simulates a credit score depending if all credit cards are paid off */
  payOffAllCreditCards?: InputMaybe<Scalars['Boolean']['input']>;
  /** Simulates a credit score given the user transfers their credit balance for a certain amount */
  transferCreditBalanceAmount?: InputMaybe<Scalars['Int']['input']>;
};

export type CreditScoreHistoryInput = {
  /** The interval to obtain the credit score history */
  interval: CreditScoreHistoryIntervalEnum;
  /** The end date to obtain the credit score history */
  endDate: Scalars['DateTime']['input'];
  /** The start date to obtain the credit score history */
  startDate: Scalars['DateTime']['input'];
};

export enum TuVantageScore3Buckets {
  Excellent = 'EXCELLENT',
  Average = 'AVERAGE',
  Good = 'GOOD',
  Poor = 'POOR'
}

export enum TuVantageScore3DeltaBuckets {
  SmallIncrease = 'SMALL_INCREASE',
  LargeIncrease = 'LARGE_INCREASE',
  SmallDecrease = 'SMALL_DECREASE',
  LargeDecrease = 'LARGE_DECREASE',
  NoChange = 'NO_CHANGE'
}

export enum TuVantageScore3ChangeDirections {
  Increase = 'INCREASE',
  Nochange = 'NOCHANGE',
  Decrease = 'DECREASE'
}

export enum TuCreditFactorBucket {
  Poor = 'POOR',
  Fair = 'FAIR',
  Good = 'GOOD'
}

export enum TuTradelineOpenClosed {
  Open = 'Open',
  Closed = 'Closed'
}

export enum TuTradelineOpenClosedSymbol {
  O = 'O',
  C = 'C'
}

export type TuTradelinePayment = {
  __typename?: 'TuTradelinePayment';
  status: Scalars['String']['output'];
  date: Scalars['String']['output'];
};

/**
 * A tradeline used by TU.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/tradeline.py
 */
export type TuTradeline = {
  __typename?: 'TuTradeline';
  /**
   * The name of the Canonical Institution that corresponds to creditorName based on known tu_synonyms.
   *   Queries the Marketplace Canonical Institution Search API in order to determine this.
   */
  canonicalInstitutionName?: Maybe<Scalars['String']['output']>;
  accountType?: Maybe<Scalars['String']['output']>;
  accountTypeSymbol?: Maybe<Scalars['String']['output']>;
  accountSubtype?: Maybe<Scalars['String']['output']>;
  accountSubtypeSymbol?: Maybe<Scalars['String']['output']>;
  accountNumberLast4?: Maybe<Scalars['String']['output']>;
  accountDesignator?: Maybe<Scalars['String']['output']>;
  accountCondition?: Maybe<Scalars['String']['output']>;
  openClosed?: Maybe<TuTradelineOpenClosed>;
  openClosedSymbol?: Maybe<TuTradelineOpenClosedSymbol>;
  highBalance?: Maybe<Scalars['Float']['output']>;
  dateReportedAt?: Maybe<Scalars['DateTime']['output']>;
  dateClosedAt?: Maybe<Scalars['DateTime']['output']>;
  dateOpenedAt?: Maybe<Scalars['DateTime']['output']>;
  dateVerifiedAt?: Maybe<Scalars['DateTime']['output']>;
  dateAccountStatus?: Maybe<Scalars['DateTime']['output']>;
  currentBalance?: Maybe<Scalars['Float']['output']>;
  creditorName?: Maybe<Scalars['String']['output']>;
  bureau?: Maybe<Scalars['String']['output']>;
  creditLimit?: Maybe<Scalars['Float']['output']>;
  disputeFlag?: Maybe<Scalars['String']['output']>;
  payStatus?: Maybe<Scalars['String']['output']>;
  payStatusDescription?: Maybe<Scalars['String']['output']>;
  remark?: Maybe<Scalars['String']['output']>;
  paymentFrequency?: Maybe<Scalars['String']['output']>;
  worstPayStatus?: Maybe<Scalars['String']['output']>;
  worstPayStatusSymbol?: Maybe<Scalars['String']['output']>;
  amountPastDue?: Maybe<Scalars['Float']['output']>;
  collateral?: Maybe<Scalars['String']['output']>;
  lastPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  late30Count?: Maybe<Scalars['Int']['output']>;
  late60Count?: Maybe<Scalars['Int']['output']>;
  late90Count?: Maybe<Scalars['Int']['output']>;
  monthlyPayment?: Maybe<Scalars['Float']['output']>;
  monthsReviewed?: Maybe<Scalars['Int']['output']>;
  termMonths?: Maybe<Scalars['Int']['output']>;
  worstPayStatusCount?: Maybe<Scalars['Int']['output']>;
  payHistoryStatus?: Maybe<Scalars['String']['output']>;
  payHistoryStartDate?: Maybe<Scalars['DateTime']['output']>;
  payHistoryBreakDown?: Maybe<Array<TuTradelinePayment>>;
  subscriberCodeHash?: Maybe<Scalars['String']['output']>;
  accountNumberHash?: Maybe<Scalars['String']['output']>;
  creditType?: Maybe<Scalars['String']['output']>;
  compositeKey?: Maybe<Scalars['String']['output']>;
  nwCreditLimitNormalized?: Maybe<Scalars['Float']['output']>;
  nwUtilizationPct?: Maybe<Scalars['Float']['output']>;
  nwDateOpenedAtNormalized?: Maybe<Scalars['DateTime']['output']>;
  nwMonthsOpened?: Maybe<Scalars['Int']['output']>;
  derogatoryTradelineReason?: Maybe<Scalars['String']['output']>;
  payStatusSymbol?: Maybe<Scalars['String']['output']>;
  nwPayStatusBucket?: Maybe<Scalars['String']['output']>;
  nwLastMissedPaymentDate?: Maybe<Scalars['DateTime']['output']>;
  isIncludedInUtilization?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * A credit inquiry.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/inquiry.py
 */
export type TuInquiry = {
  __typename?: 'TuInquiry';
  /**
   * The name of the Canonical Institution that corresponds to subscriberName based on known tu_synonyms.
   *   Queries the Marketplace Canonical Institution Search API in order to determine this.
   */
  canonicalInstitutionName?: Maybe<Scalars['String']['output']>;
  subscriberName?: Maybe<Scalars['String']['output']>;
  inquiryType?: Maybe<Scalars['String']['output']>;
  bureau?: Maybe<Scalars['String']['output']>;
  inquiredAt?: Maybe<Scalars['DateTime']['output']>;
  industry?: Maybe<Scalars['String']['output']>;
  compositeKey?: Maybe<Scalars['String']['output']>;
};

/**
 * Employer information used by TransUnion.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/employer.py
 */
export type TuEmployer = {
  __typename?: 'TuEmployer';
  name?: Maybe<Scalars['String']['output']>;
  dateReportedAt?: Maybe<Scalars['DateTime']['output']>;
  dateUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * A public record.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/public_record.py
 */
export type TuPublicRecord = {
  __typename?: 'TuPublicRecord';
  courtName?: Maybe<Scalars['String']['output']>;
  filedAt?: Maybe<Scalars['DateTime']['output']>;
  referenceNumber?: Maybe<Scalars['String']['output']>;
  subscriberCode?: Maybe<Scalars['String']['output']>;
  bureau?: Maybe<Scalars['String']['output']>;
  classification?: Maybe<Scalars['String']['output']>;
  status?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/**
 * The `TuCreditReportIdentityProfile` represents a TransUnion Credit Report.
 * Github link: https://github.com/NerdWallet/identity.nerdwallet/blob/master/src/identity/canonical_objects/profiles.py
 */
export type TuCreditReportIdentityProfile = {
  __typename?: 'TuCreditReportIdentityProfile';
  avgAgeOfCredit?: Maybe<Scalars['Float']['output']>;
  currentAddress?: Maybe<IdentityAddress>;
  id?: Maybe<Scalars['String']['output']>;
  inquiryDate?: Maybe<Scalars['Date']['output']>;
  /**
   * The timestamp that this credit report was pulled at.
   *   Example: `2019-07-26T14:38:01.589307Z`
   */
  reportPulledAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The iterable timestamp the credit report was pulled at.
   *   Example: `2017-01-31T09:09:21.162125Z`
   */
  reportPulledAtIterableDatetime?: Maybe<Scalars['DateTime']['output']>;
  nextReportPullAt?: Maybe<Scalars['DateTime']['output']>;
  isStale?: Maybe<Scalars['Boolean']['output']>;
  safetyCheckPassed?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Flag for when NW data validation calculations of summary data fields do not match TU values.
   *   Example: `false`
   */
  hasReportErrors?: Maybe<Scalars['Boolean']['output']>;
  /**
   * A user's numerical credit score.
   *   Example value: `830`
   */
  vantageScore3?: Maybe<Scalars['Int']['output']>;
  /**
   * A word describing the user's credit bucket, based on their score.
   *   Example value: `EXCELLENT`
   */
  vantageScore3Bucket?: Maybe<TuVantageScore3Buckets>;
  /**
   * The credit score percentile.
   *   Example: `95`
   */
  creditScorePopulationRank?: Maybe<Scalars['Int']['output']>;
  /**
   * The current credit score bin (a 10 point credit score range indexed
   *   at the bottom of each range (e.g. 56 -> 560-569)).
   *   Example: `82`
   */
  vantageScore3Bin?: Maybe<Scalars['Int']['output']>;
  /**
   * The credit score bin 7 days ago (a 10 point credit score range indexed at the
   *   bottom of each range (e.g. 56 -> 560-569)).
   *   Example: `82`
   */
  vantageScore3Bin7Days?: Maybe<Scalars['Int']['output']>;
  /**
   * The credit score bin 28 days ago (a 10 point credit score range indexed at the
   *   bottom of each range (e.g. 56 -> 560-569)).
   *   Example: `82`
   */
  vantageScore3Bin28Days?: Maybe<Scalars['Int']['output']>;
  /**
   * The numerical change in a user's credit score between their current score and
   *   their most recent prior score
   *   Example value: `-1`
   */
  vantageScore3Delta?: Maybe<Scalars['Int']['output']>;
  /**
   * The numerical change in a user's credit score between their current score and
   *   their most recent score that is at least 7 days old
   *   Example value: `-1`
   */
  vantageScore3Delta7Days?: Maybe<Scalars['Int']['output']>;
  /**
   * The numerical change in a user's credit score between their current score and
   *   their most recent score that is at least 28 days old
   *   Example value: `-1`
   */
  vantageScore3Delta28Days?: Maybe<Scalars['Int']['output']>;
  /**
   * Credit score change since registration.
   *   Example: `51`
   */
  vantageScore3DeltaSinceReg?: Maybe<Scalars['Int']['output']>;
  /**
   * The bucket in which a user's credit score delta is in
   *   Example value: `NO_CHANGE`
   */
  vantageScore3DeltaBucket?: Maybe<TuVantageScore3DeltaBuckets>;
  /**
   * A description of the directional change in the user's credit score since
   *   the most recent prior credit score pull
   *   Example value: `DECREASE`
   */
  vantageScore3ChangeDirection?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * A description of the directional change in the user's credit score since the
   *   most recent prior credit score pull at least 7 days ago
   *   Example value: `DECREASE`
   */
  vantageScore3ChangeDirection7Days?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * A description of the directional change in the user's credit score since the
   *   most recent prior credit score pull at least 28 days ago
   *   Example value: `DECREASE`
   */
  vantageScore3ChangeDirection28Days?: Maybe<TuVantageScore3ChangeDirections>;
  /**
   * Average age of open tradelines, in months, only for tradelines where open date can
   *   be inferred (`date_opened_at_normalized`).
   *   Example: `13.8`
   */
  nwAvgAgeOfCreditOpenMonths?: Maybe<Scalars['Float']['output']>;
  /**
   * A description of the average age of open credit.
   *   Example: `FAIR`
   */
  nwAvgAgeOfCreditOpenBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Count of tradelines with "current" or "unknown" pay status, for non-derogatory tradelines
   *   (both open and closed).
   *   Example: `5`
   */
  nwNumOntimeAccounts?: Maybe<Scalars['Int']['output']>;
  /**
   * Count of tradelines with late pay status (1,2,3,4,5) in latest credit report,
   *   for open derogatory tradelines (both open and closed).
   *   Example: `4`
   */
  nwNumMissedPaymentsRecent?: Maybe<Scalars['Int']['output']>;
  /**
   * A description of number of missed payments.
   *   Example: `POOR`
   */
  nwNumMissedPaymentsRecentBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Percent utilization based on open revolving tradelines and line of credit tradelines,
   *   where credit limit can be inferred.
   *   Example: `0.954`
   */
  nwPercentUtilization?: Maybe<Scalars['Float']['output']>;
  /**
   * A description of the percent utilization.
   *   Example: `GOOD`
   */
  nwPercentUtilizationBucket?: Maybe<TuCreditFactorBucket>;
  /**
   * Total balances for only open tradelines.
   *   Example: `5400`
   */
  nwSumBalancesOpen?: Maybe<Scalars['Float']['output']>;
  /**
   * Total balances for credit utilization calculation, based on open tradelines
   *   "revolving" or "line of credit" type, where normalized credit limit is available.
   *   Example: `4000`
   */
  nwSumBalancesOpenRevolvingLineOfCredit?: Maybe<Scalars['Float']['output']>;
  /**
   * Total credit limit for credit utilization calculation, based on open tradelines
   *   with "revolving" or "line of credit" type.
   *   Example: `100000`
   */
  nwSumCreditLimitOpenRevolvingLineOfCredit?: Maybe<Scalars['Float']['output']>;
  /**
   * The number of inquiries in the past 2 years.
   *   Example: `6`
   */
  numInquiries?: Maybe<Scalars['Int']['output']>;
  /**
   * The number of inquiries in the past 2 years.
   *   Always the same as `numInquiries`
   *   Example: `6`
   */
  numRecentInquiries?: Maybe<Scalars['Int']['output']>;
  numPublicRecords?: Maybe<Scalars['Int']['output']>;
  numAccounts?: Maybe<Scalars['Int']['output']>;
  numOpenAccounts?: Maybe<Scalars['Int']['output']>;
  /**
   * The delta between the two most recent `num_open_accounts` fields.
   *   Example: `0`
   */
  numOpenAccountsDelta?: Maybe<Scalars['Int']['output']>;
  numClosedAccounts?: Maybe<Scalars['Int']['output']>;
  numDelinquentAccounts?: Maybe<Scalars['Int']['output']>;
  numDerogatoryAccounts?: Maybe<Scalars['Int']['output']>;
  numCreditCardAccounts?: Maybe<Scalars['Int']['output']>;
  numAutoLoanAccounts?: Maybe<Scalars['Int']['output']>;
  numPersonalLoanAccounts?: Maybe<Scalars['Int']['output']>;
  numStudentLoanAccounts?: Maybe<Scalars['Int']['output']>;
  numMissedPayments?: Maybe<Scalars['Int']['output']>;
  numMortgageAccounts?: Maybe<Scalars['Int']['output']>;
  numHelocAccounts?: Maybe<Scalars['Int']['output']>;
  numOtherLoanAccounts?: Maybe<Scalars['Int']['output']>;
  numUtilityAccounts?: Maybe<Scalars['Int']['output']>;
  numOtherAccounts?: Maybe<Scalars['Int']['output']>;
  sumAgeOfCredit?: Maybe<Scalars['Float']['output']>;
  /**
   * The delta between the two most recent `sum_age_of_credit` fields.
   *   Example: `0`
   */
  sumAgeOfCreditDelta?: Maybe<Scalars['Float']['output']>;
  /**
   * Total balances for open and closed tradelines.
   *   Example: `16577`
   */
  sumBalances?: Maybe<Scalars['Float']['output']>;
  sumRevolvingDebtBalances?: Maybe<Scalars['Float']['output']>;
  sumAssetBackedDebtBalances?: Maybe<Scalars['Float']['output']>;
  sumCreditCardBalances?: Maybe<Scalars['Float']['output']>;
  sumAutoLoanBalances?: Maybe<Scalars['Float']['output']>;
  sumPersonalLoanBalances?: Maybe<Scalars['Float']['output']>;
  sumStudentLoanBalances?: Maybe<Scalars['Float']['output']>;
  sumMortgageBalances?: Maybe<Scalars['Float']['output']>;
  sumHelocBalances?: Maybe<Scalars['Float']['output']>;
  sumOtherLoanBalances?: Maybe<Scalars['Float']['output']>;
  sumUtilityBalances?: Maybe<Scalars['Float']['output']>;
  sumOtherBalances?: Maybe<Scalars['Float']['output']>;
  sumCreditCardLimits?: Maybe<Scalars['Float']['output']>;
  sumAvailableCredit?: Maybe<Scalars['Float']['output']>;
  sumMonthlyPayments?: Maybe<Scalars['Float']['output']>;
  /**
   * The percentage of tradelines that have perfect payment history
   *   Example: `0.8543`
   */
  percentOnTimePayments?: Maybe<Scalars['Float']['output']>;
  /**
   * The delta between the two most recent `percent_on_time_payments` fields.
   *   Example: `0`
   */
  percentOnTimePaymentsDelta?: Maybe<Scalars['Float']['output']>;
  percentUtilization?: Maybe<Scalars['Float']['output']>;
  percentUtilizationDelta?: Maybe<Scalars['Float']['output']>;
  nwPercentUtilization28Days?: Maybe<Scalars['Float']['output']>;
  nwNumOntimeAccounts28Days?: Maybe<Scalars['Int']['output']>;
  numAccounts28Days?: Maybe<Scalars['Int']['output']>;
  numDerogatoryAccounts28Days?: Maybe<Scalars['Int']['output']>;
  numOpenAccounts28Days?: Maybe<Scalars['Int']['output']>;
  numClosedAccounts28Days?: Maybe<Scalars['Int']['output']>;
  nwSumBalancesOpen28Days?: Maybe<Scalars['Float']['output']>;
  nwSumCreditLimitOpenRevolvingLineOfCredit28Days?: Maybe<Scalars['Float']['output']>;
  numInquiries28Days?: Maybe<Scalars['Int']['output']>;
  nwAvgAgeOfCreditOpenMonths28Days?: Maybe<Scalars['Float']['output']>;
  nwPercentUtilizationDelta28Days?: Maybe<Scalars['Float']['output']>;
  nwNumOntimeAccountsDelta28Days?: Maybe<Scalars['Int']['output']>;
  numAccountsDelta28Days?: Maybe<Scalars['Int']['output']>;
  numDerogatoryAccountsDelta28Days?: Maybe<Scalars['Int']['output']>;
  numOpenAccountsDelta28Days?: Maybe<Scalars['Int']['output']>;
  numClosedAccountsDelta28Days?: Maybe<Scalars['Int']['output']>;
  nwSumBalancesOpenDelta28Days?: Maybe<Scalars['Float']['output']>;
  nwSumCreditLimitOpenRevolvingLineOfCreditDelta28Days?: Maybe<Scalars['Float']['output']>;
  numInquiriesDelta28Days?: Maybe<Scalars['Int']['output']>;
  nwAvgAgeOfCreditOpenMonthsDelta28Days?: Maybe<Scalars['Float']['output']>;
  tradelines?: Maybe<Array<Maybe<TuTradeline>>>;
  inquiries?: Maybe<Array<Maybe<TuInquiry>>>;
  employers?: Maybe<Array<Maybe<TuEmployer>>>;
  publicRecords?: Maybe<Array<Maybe<TuPublicRecord>>>;
};

export enum AccountLinkingOpportunityEligibilityEnum {
  /** Denotes if a user is eligible to link all types of accounts. */
  All = 'ALL',
  /** Denotes if a user is eligible to link only credit cards or loans. */
  CcsAndLoans = 'CCS_AND_LOANS',
  /** Denotes if a user already has all types of accounts linked or no TU data. */
  None = 'NONE'
}

export type AccountLinkingOpportunity = {
  __typename?: 'AccountLinkingOpportunity';
  institutionCanonicalId?: Maybe<Scalars['ID']['output']>;
  institutionCanonicalName?: Maybe<Scalars['String']['output']>;
  institutionLogoUrl?: Maybe<Scalars['URL']['output']>;
  numberOfAccounts: Scalars['Int']['output'];
};

export type AccountLinkingOpportunitiesResponse = {
  __typename?: 'AccountLinkingOpportunitiesResponse';
  eligibility: AccountLinkingOpportunityEligibilityEnum;
  creditCardLinkingOpportunities?: Maybe<Array<AccountLinkingOpportunity>>;
  loanLinkingOpportunities?: Maybe<Array<AccountLinkingOpportunity>>;
};

export type DebtRecentChange = {
  __typename?: 'DebtRecentChange';
  actions?: Maybe<Array<AppAction>>;
  body?: Maybe<Scalars['String']['output']>;
  condition: Scalars['String']['output'];
  debtType?: Maybe<DebtTypes>;
  label?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  name: Scalars['String']['output'];
  takeaway?: Maybe<Scalars['String']['output']>;
};

export enum DebtActivationState {
  Unknown = 'Unknown',
  Unactivated = 'Unactivated',
  Activated = 'Activated',
  BlockedTu = 'BlockedTU',
  BlockedDti = 'BlockedDTI',
  BlockedNoDebtTradelines = 'BlockedNoDebtTradelines'
}

export enum DebtTypes {
  CreditCard = 'credit_card',
  AutoLoan = 'auto_loan',
  PersonalLoan = 'personal_loan',
  StudentLoan = 'student_loan',
  Deferred = 'deferred'
}

export type DebtSummary = {
  __typename?: 'DebtSummary';
  activatedAt?: Maybe<Scalars['DateTime']['output']>;
  activationState?: Maybe<DebtActivationState>;
  annualGrossIncome?: Maybe<Scalars['Float']['output']>;
  debtFreeDateFormat?: Maybe<Scalars['DateTime']['output']>;
  /**
   * A user-friendly approximation of how much time until they will be debt-free
   *
   *   Example: `9¾ years`
   */
  debtFreeDateDisplayString?: Maybe<Scalars['String']['output']>;
  isRecentlyActivatedUser?: Maybe<Scalars['Boolean']['output']>;
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  previousTotalDebtAmount?: Maybe<Scalars['Float']['output']>;
  primaryDebtMotivation?: Maybe<Scalars['String']['output']>;
  recentChanges?: Maybe<Array<DebtRecentChange>>;
  totalDebtAmount?: Maybe<Scalars['Float']['output']>;
  /** The percent change from the user’s previous total debt amount to their current total debt amount */
  totalDebtChangePercent?: Maybe<Scalars['Float']['output']>;
};

/** DLAN Program Status */
export enum DlanProgramStatusEnum {
  Onboarding = 'ONBOARDING',
  Activated = 'ACTIVATED',
  StartedDriving = 'STARTED_DRIVING',
  CompletedDriving = 'COMPLETED_DRIVING',
  HasOffer = 'HAS_OFFER',
  DidNotQualify = 'DID_NOT_QUALIFY',
  Ineligible = 'INELIGIBLE',
  NotInterested = 'NOT_INTERESTED'
}

/** DLAN User's Profile Response */
export type DlanProfileResponse = {
  __typename?: 'DLANProfileResponse';
  id?: Maybe<Scalars['String']['output']>;
  identityId?: Maybe<Scalars['String']['output']>;
  driverId?: Maybe<Scalars['String']['output']>;
  programStatusUpdatedAt?: Maybe<Scalars['DateTime']['output']>;
  reason?: Maybe<Scalars['String']['output']>;
  programStatus?: Maybe<DlanProgramStatusEnum>;
};

/** The expected payload for the "updateDLANProfile" mutation */
export type DlanProfileInput = {
  driverId?: InputMaybe<Scalars['String']['input']>;
  programStatus?: InputMaybe<DlanProgramStatusEnum>;
  programStatusUpdatedAt?: InputMaybe<Scalars['DateTime']['input']>;
  reason?: InputMaybe<Scalars['String']['input']>;
};

export enum FinancialHealthScoreQuestionTypeEnum {
  Continue = 'CONTINUE',
  Input = 'INPUT',
  MultipleChoice = 'MULTIPLE_CHOICE'
}

export type FinancialHealthScoreQuestionInput = {
  __typename?: 'FinancialHealthScoreQuestionInput';
  errorMessage: Scalars['String']['output'];
  helpMessage: Scalars['String']['output'];
  label: Scalars['String']['output'];
  type: Scalars['String']['output'];
};

export type FinancialHealthScoreRange = {
  __typename?: 'FinancialHealthScoreRange';
  lo?: Maybe<Scalars['Int']['output']>;
  hi?: Maybe<Scalars['Int']['output']>;
};

export type FinancialHealthCreditScore = {
  __typename?: 'FinancialHealthCreditScore';
  points?: Maybe<Scalars['Int']['output']>;
  vantageScore3?: Maybe<Scalars['Int']['output']>;
};

export type DebtToIncome = {
  __typename?: 'DebtToIncome';
  points?: Maybe<Scalars['Int']['output']>;
  income?: Maybe<Scalars['Int']['output']>;
  housing?: Maybe<Scalars['Int']['output']>;
  payments?: Maybe<Scalars['Int']['output']>;
};

export type EmergencyFund = {
  __typename?: 'EmergencyFund';
  numMonths?: Maybe<Scalars['Int']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  savings?: Maybe<Scalars['Int']['output']>;
  avgNeeds?: Maybe<Scalars['Int']['output']>;
};

export type Insurance = {
  __typename?: 'Insurance';
  hi?: Maybe<Scalars['Int']['output']>;
  lo?: Maybe<Scalars['Int']['output']>;
  home?: Maybe<Scalars['Int']['output']>;
  health?: Maybe<Scalars['Int']['output']>;
  vehicle?: Maybe<Scalars['Int']['output']>;
};

export type Planning = {
  __typename?: 'Planning';
  hi?: Maybe<Scalars['Int']['output']>;
  lo?: Maybe<Scalars['Int']['output']>;
};

export type SpendingAndIncome = {
  __typename?: 'SpendingAndIncome';
  numMonths?: Maybe<Scalars['Int']['output']>;
  points?: Maybe<Scalars['Int']['output']>;
  income?: Maybe<Scalars['Int']['output']>;
  expenses?: Maybe<Scalars['Int']['output']>;
};

export type FinancialHealthScoreQuestion = {
  __typename?: 'FinancialHealthScoreQuestion';
  /** An array of possible answers to the question. */
  answers?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** A one-item dictionary that indicates whether this question should be displayed or not. */
  condition?: Maybe<Scalars['JSON']['output']>;
  /** Value to use to post answer and get next/previous question. */
  id: Scalars['String']['output'];
  /** Financial health score input */
  input?: Maybe<FinancialHealthScoreQuestionInput>;
  /** Whether the question is a multi-select question */
  multiSelect?: Maybe<Scalars['Boolean']['output']>;
  /** Progress bar label */
  progressBarLabel?: Maybe<Scalars['String']['output']>;
  /** It can be MULTIPLE_CHOICE, INPUT or CONTINUE. */
  questionType: FinancialHealthScoreQuestionTypeEnum;
  /** If not true, then screen should show a “Skip” option. */
  required?: Maybe<Scalars['Boolean']['output']>;
  /** Subtitle.  Can contain html markup. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The title of the question */
  title: Scalars['String']['output'];
};

export type FinancialHealthScorePrevOrNextQuestion = {
  __typename?: 'FinancialHealthScorePrevOrNextQuestion';
  /** The financial health score question */
  description?: Maybe<FinancialHealthScoreQuestion>;
  /** If true, then there will be no other fields in the response. There is no next slide. Move on to the Calculating page and/or the Results page. */
  done?: Maybe<Scalars['Boolean']['output']>;
  /** It is zero-based. It counts all of the questions, even ones that have been skipped. So, for example, you may ask for the next question after number 6, and receive number 8. */
  questionNumber?: Maybe<Scalars['Int']['output']>;
  /** Counts all of the questions, even the ones after the “Answer a few more questions?” page. (And even the “Answer a few more questions” page itself.) */
  totalQuestions?: Maybe<Scalars['Int']['output']>;
};

export type FinancialHealthScoreAnswer = {
  __typename?: 'FinancialHealthScoreAnswer';
  id: Scalars['String']['output'];
  /** Full text of one of the options of the answer field */
  value: Scalars['String']['output'];
};

export type FinancialHealthScoreInput = {
  id?: InputMaybe<Scalars['String']['input']>;
  value?: InputMaybe<Scalars['String']['input']>;
};

export type UserFinancialHealthScore = {
  __typename?: 'UserFinancialHealthScore';
  /**
   * User's Financial Health Score in one large JSON.
   *   The users FHS range. lo is the bottom of the range, and hi is the top. If the user has fully completed their FHS, then these two numbers should match.
   */
  financialHealthScoreRange?: Maybe<FinancialHealthScoreRange>;
  /**
   * User's spending and income values. numMonths is the number of months of data that were used to calculate the score. (Default is 6.)
   *   Points is the number of points awarded from 0 to 20.
   *   Income is the users total summed income, in cents, over the entire period.
   *   Expenses is the user's entire summed expenses, in cents, over the entire period.
   */
  spendingAndIncome?: Maybe<SpendingAndIncome>;
  /**
   * Debt To Income
   *   Points is the number of points awarded from 0 to 20.
   *   Income is the users monthly gross income, in cents, either calculated or provided.
   *   Housing is the housing payment (mortgage or rent) (or sum of payments if more than one) in the last completed month
   *   Payments is a map of other payments, either from the credit report, or else from the last completed month. The map keys should be short human-readable descriptions, and the values are payments in cents. For example: {“Citibank”:10000, “JPMC Auto”:50000}
   */
  debtToIncome?: Maybe<DebtToIncome>;
  /**
   * Credit Score
   *   VantageScore3 is the credit score up to 850.
   *   Points is the number of points awarded from 0 to 20.
   */
  creditScore?: Maybe<FinancialHealthCreditScore>;
  /**
   * Emergency Fund
   *   numMonths is the number of months of data that were used to calculate the score. (Default is 6.)
   *   Points is the number of points awarded from 0 to 15.
   *   Savings is the users total money in cents right now, summed across his depository accounts (checking, savings, CD, etc.)
   *   AvgNeeds is the user's average monthly spending on Needs categories, in cents, over the period.
   */
  emergencyFund?: Maybe<EmergencyFund>;
  /**
   * Insurance
   *   Points is the number of points awarded from 0 to 10.
   *   Home, health and vehicle are the the number of points awarded for home, health, and vehicle insurance, respectively.
   */
  insurance?: Maybe<Insurance>;
  /**
   * Planning
   *   Points is the number of points awarded from 0 to 10.
   */
  planning?: Maybe<Planning>;
};

export type FinancialHealthScoreEstimatedNumber = {
  __typename?: 'FinancialHealthScoreEstimatedNumber';
  /** Annual gross income in dollars */
  annualGrossIncome?: Maybe<Scalars['Int']['output']>;
  /** Monthly spending on needs in dollars */
  monthlySpendingOnNeeds?: Maybe<Scalars['Int']['output']>;
  /** Monthly housing costs in dollars */
  monthlyHousing?: Maybe<Scalars['Int']['output']>;
  /** Minimum credit card payment from month to month in dollars */
  monthlyCreditCards?: Maybe<Scalars['Int']['output']>;
  /** Total monthly loan payments in dollars */
  monthlyLoan?: Maybe<Scalars['Int']['output']>;
  /** Legally mandated payments in dollars */
  monthlyLegal?: Maybe<Scalars['Int']['output']>;
};

export type FinancialHealthScoreMutations = {
  __typename?: 'FinancialHealthScoreMutations';
  postAnswer?: Maybe<Scalars['Boolean']['output']>;
};


export type FinancialHealthScoreMutationsPostAnswerArgs = {
  answer: Scalars['JSON']['input'];
};

export type FinancialHealthScore = {
  __typename?: 'FinancialHealthScore';
  /** Get estimated numbers */
  estimatedNumbers?: Maybe<FinancialHealthScoreEstimatedNumber>;
  /** Get the next question based on the current question id */
  nextQuestion?: Maybe<FinancialHealthScorePrevOrNextQuestion>;
  /** Get the previous question based on the current question id */
  previousQuestion?: Maybe<FinancialHealthScorePrevOrNextQuestion>;
  /** Get a question by id */
  question?: Maybe<FinancialHealthScoreQuestion>;
  /** Get all questions */
  questions?: Maybe<Array<Maybe<FinancialHealthScoreQuestion>>>;
  /** Get all answers */
  answers?: Maybe<Array<Maybe<FinancialHealthScoreAnswer>>>;
  /** Get an answer by ID */
  answer?: Maybe<FinancialHealthScoreAnswer>;
  /** Get User Financial Health Score */
  userFinancialHealthScore?: Maybe<UserFinancialHealthScore>;
};


export type FinancialHealthScoreEstimatedNumbersArgs = {
  numMonths?: InputMaybe<Scalars['Int']['input']>;
  calculated?: InputMaybe<Scalars['Boolean']['input']>;
};


export type FinancialHealthScoreNextQuestionArgs = {
  currentQuestionId: Scalars['String']['input'];
};


export type FinancialHealthScorePreviousQuestionArgs = {
  currentQuestionId: Scalars['String']['input'];
};


export type FinancialHealthScoreQuestionArgs = {
  id: Scalars['String']['input'];
};


export type FinancialHealthScoreAnswerArgs = {
  id: Scalars['String']['input'];
};


export type FinancialHealthScoreUserFinancialHealthScoreArgs = {
  numMonths?: InputMaybe<Scalars['Int']['input']>;
};

export type FinancialTransactionsSpendingByCategory = {
  __typename?: 'FinancialTransactionsSpendingByCategory';
  entertainment: Scalars['Float']['output'];
  fees: Scalars['Float']['output'];
  groceries: Scalars['Float']['output'];
  health: Scalars['Float']['output'];
  housing: Scalars['Float']['output'];
  income: Scalars['Float']['output'];
  other: Scalars['Float']['output'];
  restaurants: Scalars['Float']['output'];
  shopping: Scalars['Float']['output'];
  transfers: Scalars['Float']['output'];
  transport: Scalars['Float']['output'];
  travel: Scalars['Float']['output'];
  utilities: Scalars['Float']['output'];
};

export type FinancialTransactionsSpendingByCategoryForMonth = {
  __typename?: 'FinancialTransactionsSpendingByCategoryForMonth';
  spendingByCategoryForMonth: FinancialTransactionsSpendingByCategory;
};

export type FinancialTransactionsSpendingOnDate = {
  __typename?: 'FinancialTransactionsSpendingOnDate';
  amount: Scalars['Float']['output'];
  date: Scalars['Date']['output'];
};

export type FinancialTransactionsSpendingByDayOfTheMonthForMonth = {
  __typename?: 'FinancialTransactionsSpendingByDayOfTheMonthForMonth';
  spendingByDayOfTheMonthForPriorMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
  spendingByDayOfTheMonthForTargetMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
};

export type FinancialTransactionsSpendingForDayOfTheMonth = {
  __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth';
  amount: Scalars['Float']['output'];
  dayOfTheMonth: Scalars['Int']['output'];
};

export type FinancialTransactionsAverageSpendingByDayOfTheMonth = {
  __typename?: 'FinancialTransactionsAverageSpendingByDayOfTheMonth';
  averageSpendingByDayOfTheMonth: Array<FinancialTransactionsSpendingForDayOfTheMonth>;
};

export type FinancialTransactionsSpendingAndEarningForDate = {
  __typename?: 'FinancialTransactionsSpendingAndEarningForDate';
  date: Scalars['Date']['output'];
  spending: Scalars['Float']['output'];
  earning: Scalars['Float']['output'];
};

export type FinancialTransactionsSpendingByMonth = {
  __typename?: 'FinancialTransactionsSpendingByMonth';
  spendingByMonth: Array<FinancialTransactionsSpendingOnDate>;
};

export type FinancialTransactionsSpendingAndEarningByMonth = {
  __typename?: 'FinancialTransactionsSpendingAndEarningByMonth';
  spendingAndEarningByMonth: Array<FinancialTransactionsSpendingAndEarningForDate>;
};

export type FinancialTransactionsProjectionForMonth = {
  __typename?: 'FinancialTransactionsProjectionForMonth';
  earning: Scalars['Float']['output'];
};

export type FinancialTransactionsMerchantSpendingAmount = {
  __typename?: 'FinancialTransactionsMerchantSpendingAmount';
  amount: Scalars['Float']['output'];
  merchantName: Scalars['String']['output'];
};

export type FinancialTransactionsCategorySpendingAmount = {
  __typename?: 'FinancialTransactionsCategorySpendingAmount';
  amount: Scalars['Float']['output'];
  /** @deprecated Deprecated in favor of the categoryId field. */
  category?: Maybe<FinancialTransactionCategory>;
  categoryId?: Maybe<Scalars['Int']['output']>;
};

export type FinancialTransactionsTopMerchantsBySpending = {
  __typename?: 'FinancialTransactionsTopMerchantsBySpending';
  topMerchantsBySpending: Array<FinancialTransactionsMerchantSpendingAmount>;
};

export type FinancialTransactionsTopCategoriesBySpending = {
  __typename?: 'FinancialTransactionsTopCategoriesBySpending';
  topCategoriesBySpending: Array<FinancialTransactionsCategorySpendingAmount>;
};

export type FinancialTransactionsSpendingAndEarning = {
  __typename?: 'FinancialTransactionsSpendingAndEarning';
  spending: Scalars['Float']['output'];
  earning: Scalars['Float']['output'];
};

export type FinancialTransactionsSpendingAndEarningForMonthRangeResponse = {
  __typename?: 'FinancialTransactionsSpendingAndEarningForMonthRangeResponse';
  spendingAndEarningForMonthRange: FinancialTransactionsSpendingAndEarning;
};

export type FinancialTransactionsBudgetBreakdownItem = {
  __typename?: 'FinancialTransactionsBudgetBreakdownItem';
  total: Scalars['Float']['output'];
  categories: Array<FinancialTransactionsCategorySpendingAmount>;
  /** Percent of the income spent/saved */
  incomePercent: Scalars['Float']['output'];
  /** If the month's income percent is over the percent threshold */
  isIncomePercentOverThreshold: Scalars['Boolean']['output'];
  /** Amount spent/saved over the goal amount */
  amountOverGoal: Scalars['Float']['output'];
  /** Goal amount spent/saved */
  goal: Scalars['Float']['output'];
};

export type FinancialTransactionsBudgetBreakdown = {
  __typename?: 'FinancialTransactionsBudgetBreakdown';
  wants: FinancialTransactionsBudgetBreakdownItem;
  needs: FinancialTransactionsBudgetBreakdownItem;
  savingsAndDebt: FinancialTransactionsBudgetBreakdownItem;
};

export type FinancialTransactionsBudgetBreakdownMonth = {
  __typename?: 'FinancialTransactionsBudgetBreakdownMonth';
  year: Scalars['Int']['output'];
  month: Scalars['Int']['output'];
  bucketBreakdown: FinancialTransactionsBudgetBreakdown;
  /** Total amount spent in the month */
  spend: Scalars['Float']['output'];
  /** Total amount saved in the month */
  saved: Scalars['Float']['output'];
  /** Total income in the month */
  income: Scalars['Float']['output'];
  /** If the month is within the recommended savings guidelines */
  isInGuidelines: Scalars['Boolean']['output'];
  /** If the percentage of income spent for the month is over the income percentage threshold */
  isSpendingOverIncomePercentThreshold: Scalars['Boolean']['output'];
};

export type FinancialTransactionsBudgetBreakdownBucketsAmount = {
  __typename?: 'FinancialTransactionsBudgetBreakdownBucketsAmount';
  total?: Maybe<Scalars['Float']['output']>;
  needs: Scalars['Float']['output'];
  wants: Scalars['Float']['output'];
  savingsAndDebt: Scalars['Float']['output'];
};

export type FinancialTransactionsBudgetBreakdownCurrentMonth = {
  __typename?: 'FinancialTransactionsBudgetBreakdownCurrentMonth';
  budgetBreakdown: FinancialTransactionsBudgetBreakdownMonth;
  averageIncome: Scalars['Float']['output'];
  relativeIncome: Scalars['Float']['output'];
};

export type FinancialTransactionsBudgetBreakdownByMonthResponse = {
  __typename?: 'FinancialTransactionsBudgetBreakdownByMonthResponse';
  budgetBreakdownByMonth: Array<FinancialTransactionsBudgetBreakdownMonth>;
  /** Holds how many months met the budget per bucket */
  monthsMetBudget: FinancialTransactionsBudgetBreakdownBucketsAmount;
  /** Number of months requested by the client */
  requestedMonths: Scalars['Int']['output'];
  /** The income percentage threshold represented in decimal form */
  decimalIncomePercentThreshold: Scalars['Float']['output'];
  /** Holds the average percent of income per bucket */
  averageIncomePercents: FinancialTransactionsBudgetBreakdownBucketsAmount;
  /** Holds the average amount over the goal per bucket */
  averageOverGoalAmounts: FinancialTransactionsBudgetBreakdownBucketsAmount;
  /** Holds the total amount per bucket */
  totals: FinancialTransactionsBudgetBreakdownBucketsAmount;
  /** Holds the budget breakdown of the current month estimated using the average cash in over the requested range */
  currentMonth?: Maybe<FinancialTransactionsBudgetBreakdownCurrentMonth>;
};

export type FinancialTransactionsCashInCashOutMonthItem = {
  __typename?: 'FinancialTransactionsCashInCashOutMonthItem';
  date: Scalars['DateTime']['output'];
  cashIn: Scalars['Float']['output'];
  cashOut: Scalars['Float']['output'];
  net: Scalars['Float']['output'];
};

export type FinancialTransactionsCashInCashOutSummary = {
  __typename?: 'FinancialTransactionsCashInCashOutSummary';
  monthlySummaries?: Maybe<Array<Maybe<FinancialTransactionsCashInCashOutMonthItem>>>;
  averagePreviousMonths: Scalars['Float']['output'];
};

export type FinancialTransactionsCashInCashOutSummaryForDatePeriodsResponse = {
  __typename?: 'FinancialTransactionsCashInCashOutSummaryForDatePeriodsResponse';
  summaries?: Maybe<Array<Maybe<FinancialTransactionsCashInCashOutMonthItem>>>;
  averageNetPreviousDatePeriods: Scalars['Float']['output'];
};

export type FinancialTransactionsSpendingByDate = {
  __typename?: 'FinancialTransactionsSpendingByDate';
  date: Scalars['String']['output'];
  /**
   * The day/week of the selected date period
   *   e.g. would be 1 if the date is 01/01/2023 for a month period
   */
  intervalPosition: Scalars['Int']['output'];
  amount: Scalars['Float']['output'];
  /**
   * The interval for which the amounts roll up
   *   e.g. WEEK would result in a total amount per week
   */
  dateInterval: FinancialTransactionsSpendingComparisonDateIntervalEnum;
};

export type FinancialTransactionsSpendingPeriodComparisonResponse = {
  __typename?: 'FinancialTransactionsSpendingPeriodComparisonResponse';
  currentPeriodSpending: Array<FinancialTransactionsSpendingByDate>;
  previousPeriodSpending: Array<FinancialTransactionsSpendingByDate>;
};

/** This enum represents the possible activation statuses of a particular feature */
export enum MembershipFeatureActivationStatusEnum {
  Unactivated = 'UNACTIVATED',
  Degraded = 'DEGRADED',
  Blocked = 'BLOCKED',
  Activated = 'ACTIVATED'
}

export type MembershipFeatureActivationStatusInterface = {
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

/**
 * This enum represents each of the possible reasons why the user might be blocked from using the Credit Score feature.
 *
 * Note that it intentionally deviates from the semantics of the underlying data model in order to better align
 * with the product experience.
 */
export enum CreditScoreBlockedReasonEnum {
  Deceased = 'DECEASED',
  DuplicateEmail = 'DUPLICATE_EMAIL',
  NotEnoughData = 'NOT_ENOUGH_DATA',
  RateLimited = 'RATE_LIMITED',
  ThinFile = 'THIN_FILE'
}

export type WebFeatureDiscoveryDetails = {
  __typename?: 'WebFeatureDiscoveryDetails';
  title?: Maybe<Scalars['String']['output']>;
  copy: Scalars['String']['output'];
  destinationUrl: Scalars['String']['output'];
  featuredImageUrl: Scalars['URL']['output'];
  featureName: Scalars['String']['output'];
};

export type FeatureDiscoveryResponse = {
  __typename?: 'FeatureDiscoveryResponse';
  isEnabled: Scalars['Boolean']['output'];
  details?: Maybe<WebFeatureDiscoveryDetails>;
};

/** The `StatementIndexedFeedItem` type represents a generically typed item in the user's feed. */
export type StatementIndexedFeedItem = {
  __typename?: 'StatementIndexedFeedItem';
  statement: FeedStatement;
  cards: Array<FeedCard>;
};

/** The `FeedStatement` represents the statement JSON shape. */
export type FeedStatement = {
  __typename?: 'FeedStatement';
  id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  subtitle?: Maybe<Scalars['String']['output']>;
  priority?: Maybe<Scalars['Int']['output']>;
};

/** The `FeedCard` represents the card JSON shape. */
export type FeedCard = {
  __typename?: 'FeedCard';
  id: Scalars['Int']['output'];
  slug?: Maybe<Scalars['String']['output']>;
  cardTemplate?: Maybe<FeedCardTemplate>;
  recommendation?: Maybe<FeedCardRecommendation>;
  fields?: Maybe<FeedCardFields>;
  displayPlatforms?: Maybe<Scalars['String']['output']>;
  indexInStatement?: Maybe<Scalars['Int']['output']>;
};

/** The `FeedCardTemplate` represents the card_template JSON shape. */
export type FeedCardTemplate = {
  __typename?: 'FeedCardTemplate';
  id?: Maybe<Scalars['String']['output']>;
  renderId?: Maybe<Scalars['String']['output']>;
};

/** The `FeedCardRecommendation` represents the recommendation JSON shape. */
export type FeedCardRecommendation = {
  __typename?: 'FeedCardRecommendation';
  id: Scalars['Int']['output'];
  actionTarget?: Maybe<Scalars['String']['output']>;
  actionText?: Maybe<Scalars['String']['output']>;
  actionType?: Maybe<Scalars['String']['output']>;
  actionMobileTarget?: Maybe<Scalars['String']['output']>;
};

/**
 * The `FeedCardFields` represents the fields JSON shape. Data contains all fields not shared
 * by all card templates. cardActions will be renamed primaryActions to match the JSON response once the apollo plural codegen error is resolved.
 */
export type FeedCardFields = {
  __typename?: 'FeedCardFields';
  data?: Maybe<Scalars['JSON']['output']>;
  primaryAction?: Maybe<FeedCardPrimaryAction>;
  cardActions?: Maybe<Array<Maybe<FeedCardAction>>>;
  primaryCta?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
};

/** The `FeedCardPrimaryAction` represents the primary_action JSON shape. */
export type FeedCardPrimaryAction = {
  __typename?: 'FeedCardPrimaryAction';
  mobileTarget?: Maybe<Scalars['String']['output']>;
  target?: Maybe<Scalars['String']['output']>;
  type?: Maybe<Scalars['String']['output']>;
};

/** The `FeedCardAction` type represents shape each item in the primary_actions JSON array takes. */
export type FeedCardAction = {
  __typename?: 'FeedCardAction';
  href?: Maybe<Scalars['String']['output']>;
  id: Scalars['Int']['output'];
  type?: Maybe<Scalars['String']['output']>;
};

export type FollowedAuthorResponse = {
  __typename?: 'FollowedAuthorResponse';
  /** Unique ID for the follow */
  id: Scalars['ID']['output'];
  /** User Engagement Author follow ID */
  entityId: Scalars['Int']['output'];
  /** WP information about the author */
  author: Author;
};

export type FollowedArticleAuthorsResponse = {
  __typename?: 'FollowedArticleAuthorsResponse';
  /** Article ID */
  articleId: Scalars['Int']['output'];
  /** WP information about the article authors */
  authors: Array<FollowedAuthorResponse>;
};

/** The direction in which to order query results. */
export enum OrderDirectionEnum {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** Hreflink object */
export type Hreflang = {
  __typename?: 'Hreflang';
  /** An hreflang link */
  url: Scalars['String']['output'];
  /** The locale the hreflang link corresponds to */
  locale: Scalars['String']['output'];
};

/**
 * The set of NerdWallet features.  This enum should be a superset of the _enrollable_ features, which are defined in
 * the feature_enrollment_changed analytics event:
 * https://github.com/NerdWallet/app-schemata/blob/master/analytic_pipeline/feature_enrollment_changed.yaml
 */
export enum MembershipFeatureEnum {
  AppLock = 'APP_LOCK',
  AutoValue = 'AUTO_VALUE',
  Bills = 'BILLS',
  Billshark = 'BILLSHARK',
  CardLinkedOffers = 'CARD_LINKED_OFFERS',
  CashFlow = 'CASH_FLOW',
  CreditScore = 'CREDIT_SCORE',
  Debt = 'DEBT',
  EmailNotifications = 'EMAIL_NOTIFICATIONS',
  Eoru = 'EORU',
  FinancialAccountAggregation = 'FINANCIAL_ACCOUNT_AGGREGATION',
  HomeEquity = 'HOME_EQUITY',
  HomeValue = 'HOME_VALUE',
  GeolocationBrowser = 'GEOLOCATION_BROWSER',
  GeolocationNative = 'GEOLOCATION_NATIVE',
  Membership = 'MEMBERSHIP',
  MoneyTransfer = 'MONEY_TRANSFER',
  NetWorth = 'NET_WORTH',
  PlayYourCardsRight = 'PLAY_YOUR_CARDS_RIGHT',
  PushNotifications = 'PUSH_NOTIFICATIONS'
}

/**
 * Comprehensive list of states that gamification checklist items can be in, errored items
 * are not considered completed.
 */
export enum GamificationChecklistStatus {
  Todo = 'TODO',
  Completed = 'COMPLETED',
  Skipped = 'SKIPPED',
  Dismissed = 'DISMISSED'
}

/** List of gamification checklist items and their current state of completion */
export type GamificationChecklistResponse = {
  __typename?: 'GamificationChecklistResponse';
  emailStatus: GamificationChecklistStatus;
  creditScoreActivatedStatus: GamificationChecklistStatus;
  creditCardLinkedStatus: GamificationChecklistStatus;
  checkingLinkedStatus: GamificationChecklistStatus;
  savingsLinkedStatus: GamificationChecklistStatus;
  investmentLinkedStatus: GamificationChecklistStatus;
};

/** The expected payload for the "updateGamificationChecklist" mutation */
export type GamificationChecklistInput = {
  emailStatus?: InputMaybe<GamificationChecklistStatus>;
  creditScoreActivatedStatus?: InputMaybe<GamificationChecklistStatus>;
  creditCardLinkedStatus?: InputMaybe<GamificationChecklistStatus>;
  checkingLinkedStatus?: InputMaybe<GamificationChecklistStatus>;
  savingsLinkedStatus?: InputMaybe<GamificationChecklistStatus>;
  investmentLinkedStatus?: InputMaybe<GamificationChecklistStatus>;
};

export type GreenhouseDepartment = {
  __typename?: 'GreenhouseDepartment';
  /** Unique ID of a GreenhouseDepartment */
  id: Scalars['ID']['output'];
  /** Name of a GreenhouseDepartment */
  name: Scalars['String']['output'];
  /** Kebab Name of a GreenhouseDepartment */
  kebabName: Scalars['String']['output'];
  /** List of jobs available within a GreenhouseDepartment */
  jobs?: Maybe<Array<GreenhouseJob>>;
};

export type GreenhouseJob = {
  __typename?: 'GreenhouseJob';
  /** Unique ID of a GreenhouseJob */
  id: Scalars['ID']['output'];
  /** URL to the job page on nerdwallet.com, of the form `http://www.nerdwallet.com/careers/job/2930840?gh_jid=2930840` */
  absoluteUrl: Scalars['URL']['output'];
  /** Last update date */
  updatedAt: Scalars['DateTime']['output'];
  /** Title of a GreenhouseJob */
  title: Scalars['String']['output'];
  /** Content body of a GreenhouseJob. Contains html-encoded html, e.g. `&lt;p&gt;&lt;span style=&quot;font-weight: 400;&quot;&gt;` */
  content?: Maybe<Scalars['String']['output']>;
  /** Location of the GreenhouseJob */
  location?: Maybe<Scalars['String']['output']>;
  /** Department name */
  department?: Maybe<GreenhouseDepartment>;
};

export type GetStateFromZipCodeResponse = {
  __typename?: 'GetStateFromZipCodeResponse';
  state?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
};

export type HealthNetworkData = {
  __typename?: 'HealthNetworkData';
  /** Url to the health network page */
  redirectUrl: Scalars['String']['output'];
  /** Unique identifier for the health network */
  guid: Scalars['ID']['output'];
};

/** The `RawIdentity` type represents the cookies and any payload related to the logged in identity. */
export type RawIdentity = {
  __typename?: 'RawIdentity';
  authCookies: Array<Cookie>;
  data?: Maybe<Scalars['JSON']['output']>;
};

/** The `RawIdentityProfile` type represents the given profile */
export type RawIdentityProfile = {
  __typename?: 'RawIdentityProfile';
  profileType: Scalars['String']['output'];
  data?: Maybe<Scalars['JSON']['output']>;
};

/**
 * The `SubscriptionIdentityProfile` type currently represents subscription_profile_v3 as mapped from
 * Identity. Not versioned in order to support future evolution of this type.
 */
export type SubscriptionIdentityProfile = {
  __typename?: 'SubscriptionIdentityProfile';
  emailEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The Cash Back feature is deprecated */
  emailCashBackRewardsEnabled?: Maybe<Scalars['Boolean']['output']>;
  emailCreditMonitoringEnabled?: Maybe<Scalars['Boolean']['output']>;
  emailMarketingEnabled?: Maybe<Scalars['Boolean']['output']>;
  emailSpendingAlertsEnabled?: Maybe<Scalars['Boolean']['output']>;
  emailPersonalizedContentEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by emailPersonalizedContentEnabled in v3 */
  emailProductAnnouncementsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by emailTransactionalMarketingEnabled in v3 */
  emailProfileUpdatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Removed from v3 */
  emailProgressUpdatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  emailTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationCenterEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationCenterCreditMonitoringEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationCenterSpendingAlertsEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationCenterMarketingEnabled?: Maybe<Scalars['Boolean']['output']>;
  notificationCenterPersonalizedContentEnabled?: Maybe<Scalars['Boolean']['output']>;
  pushEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated The Cash Back feature is deprecated */
  pushCashBackRewardsEnabled?: Maybe<Scalars['Boolean']['output']>;
  pushCreditMonitoringEnabled?: Maybe<Scalars['Boolean']['output']>;
  pushMarketingUpdatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  pushPersonalizedContentEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by pushPersonalizedContentEnabled in v3 */
  pushProductAnnouncementsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** @deprecated Replaced by pushTransactionalMarketingEnabled in v3 */
  pushProfileUpdatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  pushSpendingAlertsEnabled?: Maybe<Scalars['Boolean']['output']>;
  pushTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']['output']>;
  updateSubscriptionToken?: Maybe<Scalars['String']['output']>;
};

/** List of Account Aggregation CTAs and whether they have been dismissed */
export type AccountAggCtaDismissedResponse = {
  __typename?: 'AccountAggCtaDismissedResponse';
  accountsSmallBanner?: Maybe<Scalars['Boolean']['output']>;
  ageAndMixOfAccountsSmallBanner?: Maybe<Scalars['Boolean']['output']>;
  balancesSmallBanner?: Maybe<Scalars['Boolean']['output']>;
  creditScoreBigBanner?: Maybe<Scalars['Boolean']['output']>;
  creditScoreSmallBanner?: Maybe<Scalars['Boolean']['output']>;
  debtSmallBanner?: Maybe<Scalars['Boolean']['output']>;
  spendingSmallBanner?: Maybe<Scalars['Boolean']['output']>;
  tradelineSmallBanner?: Maybe<Scalars['Boolean']['output']>;
  tradelineTopLink?: Maybe<Scalars['Boolean']['output']>;
  utilizationBigBanner?: Maybe<Scalars['Boolean']['output']>;
  utilizationFaq?: Maybe<Scalars['Boolean']['output']>;
  utilizationSmallBanner?: Maybe<Scalars['Boolean']['output']>;
};

/** The `GlobalIdentityProfile` type represents the global identity profile */
export type GlobalIdentityProfile = {
  __typename?: 'GlobalIdentityProfile';
  phoneNumber?: Maybe<Scalars['String']['output']>;
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
  citizenship?: Maybe<Scalars['String']['output']>;
  mailingAddress?: Maybe<IdentityAddress>;
  age?: Maybe<Scalars['Int']['output']>;
  maritalStatus?: Maybe<Scalars['String']['output']>;
  previousAddress?: Maybe<IdentityAddress>;
  dateOfBirth?: Maybe<Scalars['String']['output']>;
  currentLocation?: Maybe<Scalars['String']['output']>;
  legalFirstName?: Maybe<Scalars['String']['output']>;
  education?: Maybe<Scalars['String']['output']>;
  ageBucket?: Maybe<Scalars['String']['output']>;
};

/** The `IdentityAddress` type represents the address for a global identity profile */
export type IdentityAddress = {
  __typename?: 'IdentityAddress';
  city: Scalars['String']['output'];
  longitude?: Maybe<Scalars['Float']['output']>;
  state: Scalars['String']['output'];
  isValidated?: Maybe<Scalars['Boolean']['output']>;
  validatedAt?: Maybe<Scalars['String']['output']>;
  latitude?: Maybe<Scalars['Float']['output']>;
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  validatedBy?: Maybe<Scalars['String']['output']>;
  zipCode: Scalars['String']['output'];
};

/** The `IdentityAddressInput` input defines the ingress Address model. */
export type IdentityAddressInput = {
  city: Scalars['String']['input'];
  longitude?: InputMaybe<Scalars['Float']['input']>;
  state: Scalars['String']['input'];
  isValidated?: InputMaybe<Scalars['Boolean']['input']>;
  validatedAt?: InputMaybe<Scalars['String']['input']>;
  latitude?: InputMaybe<Scalars['Float']['input']>;
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
  validatedBy?: InputMaybe<Scalars['String']['input']>;
};

/** The `MobileAppProfileDevice` type represents a device a user has */
export type MobileAppProfileDevice = {
  __typename?: 'MobileAppProfileDevice';
  deviceId: Scalars['String']['output'];
  deviceType: Scalars['String']['output'];
  pushNotificationsEnabled?: Maybe<Scalars['Boolean']['output']>;
  appVersion: Scalars['String']['output'];
  deviceLastLogin?: Maybe<Scalars['String']['output']>;
};

/** The `MobileAppIdentityProfile` type represents the user's registered devices */
export type MobileAppIdentityProfile = {
  __typename?: 'MobileAppIdentityProfile';
  id?: Maybe<Scalars['String']['output']>;
  devices: Array<MobileAppProfileDevice>;
  newestAppVersionUsed?: Maybe<Scalars['String']['output']>;
  newestAppVersionUsedOnDeviceType?: Maybe<Scalars['String']['output']>;
};

/** The `FinancialIdentityProfile` type represents the user's financial profile */
export type FinancialIdentityProfile = {
  __typename?: 'FinancialIdentityProfile';
  id?: Maybe<Scalars['ID']['output']>;
  annualIncome?: Maybe<Scalars['Float']['output']>;
  monthlyNetIncome?: Maybe<Scalars['Float']['output']>;
  currentSpousesAnnualIncome?: Maybe<Scalars['Int']['output']>;
  employmentType?: Maybe<Scalars['String']['output']>;
  cashSavingPattern?: Maybe<Scalars['String']['output']>;
  currentSpendingPattern?: Maybe<Scalars['String']['output']>;
  creditScore?: Maybe<Scalars['Int']['output']>;
  creditScoreRange?: Maybe<Scalars['String']['output']>;
  amountOwed?: Maybe<Scalars['Int']['output']>;
  debtTypes?: Maybe<FinancialIdentityDebtTypes>;
  totalSavings?: Maybe<Scalars['Int']['output']>;
  savingTypes?: Maybe<FinancialIdentitySavingTypes>;
  monthlyHousingCost?: Maybe<Scalars['Float']['output']>;
  residenceOwnershipType?: Maybe<Scalars['String']['output']>;
  accounts?: Maybe<Array<Maybe<UserReportedFinancialAccount>>>;
  userPreferredIncomeSource?: Maybe<UserPreferredIncomeSourceEnum>;
};

/**
 * The `UserReportedFinancialAccount` type represents a financial
 * account queried as part of the Financial Identity Profile
 */
export type UserReportedFinancialAccount = {
  __typename?: 'UserReportedFinancialAccount';
  id?: Maybe<Scalars['ID']['output']>;
  type: Scalars['String']['output'];
  displayName?: Maybe<Scalars['String']['output']>;
  ccExtraData?: Maybe<Scalars['JSON']['output']>;
  yodleeFk?: Maybe<Scalars['String']['output']>;
  marketplaceFk?: Maybe<Scalars['String']['output']>;
  transunionFk?: Maybe<Scalars['String']['output']>;
  tuTradelineCompositeKey?: Maybe<Scalars['String']['output']>;
  institutionFk?: Maybe<Scalars['String']['output']>;
  createdBy?: Maybe<Scalars['String']['output']>;
  currentValue?: Maybe<Scalars['Float']['output']>;
};

/** The `FinancialIdentitySavingTypes` type represents saving types of a user */
export type FinancialIdentitySavingTypes = {
  __typename?: 'FinancialIdentitySavingTypes';
  monthlyBills?: Maybe<Scalars['Boolean']['output']>;
  travel?: Maybe<Scalars['Boolean']['output']>;
  carExpenses?: Maybe<Scalars['Boolean']['output']>;
  homeCosts?: Maybe<Scalars['Boolean']['output']>;
  creditCardInterest?: Maybe<Scalars['Boolean']['output']>;
  studentLoans?: Maybe<Scalars['Boolean']['output']>;
};

/** The `FinancialIdentityDebtTypes` type represents debt types of a user */
export type FinancialIdentityDebtTypes = {
  __typename?: 'FinancialIdentityDebtTypes';
  creditDebt?: Maybe<Scalars['Boolean']['output']>;
  personalLoanDebt?: Maybe<Scalars['Boolean']['output']>;
  autoLoanDebt?: Maybe<Scalars['Boolean']['output']>;
  studentLoanDebt?: Maybe<Scalars['Boolean']['output']>;
  mortgageDebt?: Maybe<Scalars['Boolean']['output']>;
  medicalDebt?: Maybe<Scalars['Boolean']['output']>;
  paydayLoanDebt?: Maybe<Scalars['Boolean']['output']>;
  otherDebt?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * The expected payload for the `updateSubscriptionProfile` mutation,
 * should be synced with SubscriptionIdentityProfile.
 */
export type UpdateSubscriptionProfileInput = {
  emailEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailCashBackRewardsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailCreditMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailMarketingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailSpendingAlertsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailPersonalizedContentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailProductAnnouncementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailProfileUpdatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailProgressUpdatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  emailTransactionalMarketingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationCenterEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationCenterCreditMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationCenterSpendingAlertsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationCenterMarketingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  notificationCenterPersonalizedContentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushCashBackRewardsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushCreditMonitoringEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushMarketingUpdatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushPersonalizedContentEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushProductAnnouncementsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushProfileUpdatesEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushSpendingAlertsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  pushTransactionalMarketingEnabled?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The expected payload for the "updateDismissAccountAggCta" mutation. */
export type AccountAggCtaDismissedInput = {
  accountsSmallBanner?: InputMaybe<Scalars['Boolean']['input']>;
  ageAndMixOfAccountsSmallBanner?: InputMaybe<Scalars['Boolean']['input']>;
  balancesSmallBanner?: InputMaybe<Scalars['Boolean']['input']>;
  creditScoreBigBanner?: InputMaybe<Scalars['Boolean']['input']>;
  creditScoreSmallBanner?: InputMaybe<Scalars['Boolean']['input']>;
  debtSmallBanner?: InputMaybe<Scalars['Boolean']['input']>;
  spendingSmallBanner?: InputMaybe<Scalars['Boolean']['input']>;
  tradelineSmallBanner?: InputMaybe<Scalars['Boolean']['input']>;
  tradelineTopLink?: InputMaybe<Scalars['Boolean']['input']>;
  utilizationBigBanner?: InputMaybe<Scalars['Boolean']['input']>;
  utilizationFaq?: InputMaybe<Scalars['Boolean']['input']>;
  utilizationSmallBanner?: InputMaybe<Scalars['Boolean']['input']>;
};

/** The expected payload for the `addMobileAppDevice` mutations */
export type MobileAppProfileDeviceInput = {
  deviceId: Scalars['String']['input'];
  deviceType: Scalars['String']['input'];
  pushNotificationsEnabled?: InputMaybe<Scalars['Boolean']['input']>;
  appVersion: Scalars['String']['input'];
  deviceLastLogin?: InputMaybe<Scalars['String']['input']>;
};

export enum UserPreferredIncomeSourceEnum {
  Projected = 'PROJECTED',
  UserReported = 'USER_REPORTED'
}

/** The expected input for the `updateIncome` mutation */
export type UpdateIncomeInput = {
  annualIncome?: InputMaybe<Scalars['Float']['input']>;
  monthlyNetIncome?: InputMaybe<Scalars['Float']['input']>;
  userPreferredIncomeSource?: InputMaybe<UserPreferredIncomeSourceEnum>;
};

export type UpdateIncomeResponse = {
  __typename?: 'UpdateIncomeResponse';
  success: Scalars['Boolean']['output'];
  annualIncome?: Maybe<Scalars['Float']['output']>;
  monthlyNetIncome?: Maybe<Scalars['Float']['output']>;
  userPreferredIncomeSource?: Maybe<UserPreferredIncomeSourceEnum>;
};

/** The expected input for the `updateName` mutation */
export type UpdateNameInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type UpdateNameResponse = {
  __typename?: 'UpdateNameResponse';
  success: Scalars['Boolean']['output'];
  firstName?: Maybe<Scalars['String']['output']>;
  lastName?: Maybe<Scalars['String']['output']>;
};

/** Each enum entry should be synced with each available field in SubscriptionIdentityProfile. */
export enum SubscriptionTypeEnum {
  EmailEnabled = 'EMAIL_ENABLED',
  /** @deprecated Cash Back feature is deactivated */
  EmailCashBackRewardsEnabled = 'EMAIL_CASH_BACK_REWARDS_ENABLED',
  EmailCreditMonitoringEnabled = 'EMAIL_CREDIT_MONITORING_ENABLED',
  EmailMarketingEnabled = 'EMAIL_MARKETING_ENABLED',
  EmailPersonalizedContentEnabled = 'EMAIL_PERSONALIZED_CONTENT_ENABLED',
  /** @deprecated Replaced by email_personalized_content_enabled in v3 */
  EmailProductAnnouncementsEnabled = 'EMAIL_PRODUCT_ANNOUNCEMENTS_ENABLED',
  /** @deprecated Replaced by email_transactional_marketing_enabled in v3 */
  EmailProfileUpdatesEnabled = 'EMAIL_PROFILE_UPDATES_ENABLED',
  /** @deprecated Removed in v3 */
  EmailProgressUpdatesEnabled = 'EMAIL_PROGRESS_UPDATES_ENABLED',
  EmailSpendingAlertsEnabled = 'EMAIL_SPENDING_ALERTS_ENABLED',
  EmailTransactionalMarketingEnabled = 'EMAIL_TRANSACTIONAL_MARKETING_ENABLED',
  PushEnabled = 'PUSH_ENABLED',
  /** @deprecated Cash Back feature is deactivated */
  PushCashBackRewardsEnabled = 'PUSH_CASH_BACK_REWARDS_ENABLED',
  PushCreditMonitoringEnabled = 'PUSH_CREDIT_MONITORING_ENABLED',
  PushMarketingUpdatesEnabled = 'PUSH_MARKETING_UPDATES_ENABLED',
  PushPersonalizedContentEnabled = 'PUSH_PERSONALIZED_CONTENT_ENABLED',
  /** @deprecated Replaced by push_personalized_content_enabled in v3 */
  PushProductAnnouncementsEnabled = 'PUSH_PRODUCT_ANNOUNCEMENTS_ENABLED',
  /** @deprecated Replaced by push_transactional_marketing_enabled in v3 */
  PushProfileUpdatesEnabled = 'PUSH_PROFILE_UPDATES_ENABLED',
  PushSpendingAlertsEnabled = 'PUSH_SPENDING_ALERTS_ENABLED',
  PushTransactionalMarketingEnabled = 'PUSH_TRANSACTIONAL_MARKETING_ENABLED'
}

export type TermsOfServiceAcknowledgement = {
  __typename?: 'TermsOfServiceAcknowledgement';
  /** The type of terms of service the user is acknowledging. */
  type: Scalars['String']['output'];
  /** The client that is the source of the acknowledgement (MY_NERDWALLET, etc). */
  source: Scalars['String']['output'];
  /** The version of the terms of service being acknowledged. */
  version: Scalars['String']['output'];
};

export type TermsOfServiceIdentityProfile = {
  __typename?: 'TermsOfServiceIdentityProfile';
  acknowledgements?: Maybe<Array<TermsOfServiceAcknowledgement>>;
};

export type AcknowledgeTermsOfServiceInput = {
  type: Scalars['String']['input'];
  source: Scalars['String']['input'];
  version: Scalars['String']['input'];
};

export type AcknowledgeTermsOfServiceResponse = {
  __typename?: 'AcknowledgeTermsOfServiceResponse';
  success: Scalars['Boolean']['output'];
};

/** UserInsightInventorySourceEnum represents all possible sources of truth for user insights. */
export enum UserInsightInventorySourceEnum {
  /**
   * Some insights are derived on-demand by credit-service; specifically, an activation UI&A for user's who have not
   *   yet linked TU
   * @deprecated Should no longer be an inventory source for UIAs
   */
  CreditService = 'CREDIT_SERVICE',
  /**
   * Some insights are generated on-demand by recommendation-service.  Note that the inventory source for such insights
   *   is recommendation-service, not the intermediary orchestration layer through which they were retrieved (e.g.
   *   Factory)
   */
  RecommendationService = 'RECOMMENDATION_SERVICE',
  /**
   * Some insights are generated on-demand by financial-insights service. Note that the inventory source for such insights
   *   is financial-insights service, not FDP which is where the data that determines the UI&A is derived
   */
  FinancialInsightsService = 'FINANCIAL_INSIGHTS_SERVICE',
  /** Some insights are generated on-demand by my-cards-service */
  MyCardsService = 'MY_CARDS_SERVICE'
}

/**
 * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
 * treatment (e.g. red vs. yellow vs. blue accent color).
 */
export enum UserInsightSentimentEnum {
  /** Indicates that the insight is beneficial for the user (e.g., their paycheck was deposited) */
  Positive = 'POSITIVE',
  /** Indicates that the insight is neither inherently beneficial nor cautionary */
  Neutral = 'NEUTRAL',
  /**
   * Indicates that the insight is potentially (but not necessarily) harmful for the user (e.g., a hard credit pull or
   *   detection of a large transaction)
   */
  Cautionary = 'CAUTIONARY'
}

/** The specific insight's regeneration group */
export enum UserInsightRegenerationGroupEnum {
  /** Best card for you regeneration group */
  BestCardForYou = 'BEST_CARD_FOR_YOU',
  /** Credit booster regeneration group (includes WDMSC) */
  CreditBooster = 'CREDIT_BOOSTER',
  /** Credit report regeneration group */
  CreditReport = 'CREDIT_REPORT',
  /** Credit score activation regeneration group */
  CreditScoreActivation = 'CREDIT_SCORE_ACTIVATION',
  /** Fun facts regeneration group */
  FunFacts = 'FUN_FACTS',
  /** My bills regeneration group */
  MyBills = 'MY_BILLS',
  /** My cards activation regeneration group */
  MyCardsActivation = 'MY_CARDS_ACTIVATION',
  /** Net worth activation regeneration group */
  NetWorthActivation = 'NET_WORTH_ACTIVATION',
  /** Net worth regeneration group */
  NetWorth = 'NET_WORTH',
  /** Optimize regeneration group */
  Optimize = 'OPTIMIZE',
  /** Spending regeneration group */
  Spending = 'SPENDING',
  /** NerdWallet+ regeneration group */
  NerdwalletPlus = 'NERDWALLET_PLUS'
}

/** UserInsightDataVisualizationTypeEnum represents all possible data visualizations that might appear with an insight */
export enum UserInsightDataVisualizationTypeEnum {
  /** A visualization of the user's spending in the current month, by the top categories */
  SpendingByTopCategories = 'SPENDING_BY_TOP_CATEGORIES',
  /**
   * A visualization of the user's total spending in the current month to date vs. their total spending as of the same
   *   date in the previous month
   */
  SpendingByMonths = 'SPENDING_BY_MONTHS',
  /**
   * A visualization for credit score activation
   * @deprecated No longer used by any insight
   */
  CreditScoreActivation = 'CREDIT_SCORE_ACTIVATION',
  /**
   * A visualization for financial account(s) activation
   * @deprecated No longer used by any insight
   */
  FinancialAccountsActivation = 'FINANCIAL_ACCOUNTS_ACTIVATION',
  /** A visualization of the user's credit score change */
  WhyDidMyScoreChange = 'WHY_DID_MY_SCORE_CHANGE',
  /** A visualization of the user's potential score change */
  CreditBooster = 'CREDIT_BOOSTER',
  /**
   * A visualization for My Cards activation
   * @deprecated No longer used by any insight
   */
  MyCardsActivation = 'MY_CARDS_ACTIVATION'
}

/**
 *
 * UserInsightGainUnitEnum represents all possible gain units for user insights
 */
export enum UserInsightGainUnitEnum {
  /** Indicates the unit for gain is points */
  CreditScorePoints = 'CREDIT_SCORE_POINTS',
  Accounts = 'ACCOUNTS',
  Inquiries = 'INQUIRIES',
  Dollars = 'DOLLARS',
  Percent = 'PERCENT',
  Years = 'YEARS'
}

/** UserInsightEligibleModulesEnum represents all possible eligible modules */
export enum UserInsightEligibleModulesEnum {
  /** Indicates the insight is eligible for the why did my score change module */
  WhyDidMyScoreChange = 'WHY_DID_MY_SCORE_CHANGE',
  /** Indicates the insight is eligible for the credit booster module */
  CreditBooster = 'CREDIT_BOOSTER',
  /** Indicates the insight is eligible for the member home module */
  MemberHome = 'MEMBER_HOME',
  /** Indicates the insight is eligible for the credit score UI&A module */
  CreditScore = 'CREDIT_SCORE',
  /** Indicates the insight is eligible for the cash flow UI&A module */
  CashFlow = 'CASH_FLOW',
  /** Indicates the insight is eligible for the net worth UI&A module */
  NetWorth = 'NET_WORTH',
  /**
   * Indicates the insight is eligible for the member home activation UI&A module
   * @deprecated This module is no longer in use
   */
  MemberHomeActivationHooks = 'MEMBER_HOME_ACTIVATION_HOOKS',
  /**
   * Indicates the insight is eligible for the credit score activation UI&A module
   * @deprecated This module is no longer in use
   */
  CreditScoreActivationHooks = 'CREDIT_SCORE_ACTIVATION_HOOKS',
  /** Indicates the insight is eligible for the Moment of Delight module at the end of TU Activation */
  TuActivationComplete = 'TU_ACTIVATION_COMPLETE',
  /** Indicates the insight is eligible for the Your Next Money Move module */
  YourNextMoneyMove = 'YOUR_NEXT_MONEY_MOVE'
}

export enum UserInsightImageTreatmentTypeEnum {
  Cautionary = 'CAUTIONARY',
  Congratulatory = 'CONGRATULATORY',
  Informational = 'INFORMATIONAL',
  Persuasive = 'PERSUASIVE',
  None = 'NONE'
}

/**
 *
 * UserInsightPlatformEnum represents clients that display user insights
 */
export enum UserInsightPlatformEnum {
  Native = 'NATIVE',
  Web = 'WEB'
}

/**
 * UserInsightDataVisualizationInterface must be implemented by a concrete type that contains all the data necessary to
 * render a specific data visualization.
 */
export type UserInsightDataVisualizationInterface = {
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

export type CreditScoreChangeInfo = {
  __typename?: 'CreditScoreChangeInfo';
  /** User's current credit score */
  currentScore?: Maybe<Scalars['Int']['output']>;
  /** User's previous credit score */
  previousScore?: Maybe<Scalars['Int']['output']>;
  /** User's projected future credit score */
  projectedScore?: Maybe<Scalars['Int']['output']>;
  /** User's current credit bucket */
  currentBucket?: Maybe<TuVantageScore3Buckets>;
  /** User's previous credit bucket */
  previousBucket?: Maybe<TuVantageScore3Buckets>;
  /** User's projected future credit bucket */
  projectedBucket?: Maybe<TuVantageScore3Buckets>;
};

/**
 * A UserAction is anything that the user might do in response to an insight.  At their simplest, they are just a raw
 * AppAction (e.g., a simple CTA that navigates to an L2), but can be augmented with additional context or even bespoke
 * data visualizations.
 */
export type UserAction = {
  __typename?: 'UserAction';
  /**
   * A human-readable identifier for a particular user action.  Primarily used for analytics.
   *
   *   Example: credit-score-pay-off-account-early
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * Language that summarizes or introduces the UserAction.
   *
   *   This is *not* the CTA text -- that should be supplied in appAction.text
   */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * Language that describes the UserAction in detail.
   *
   *   This is *not* the CTA text -- that should be supplied in appAction.text
   */
  body?: Maybe<Scalars['String']['output']>;
  /** The mechanical action to be performed in the app when the user engages with this UserAction */
  appAction: AppAction;
};

/** A non-actionable suggestion related to a UserInsight */
export type UserInsightTip = {
  __typename?: 'UserInsightTip';
  /** The label under which the tip appears (e.g. "Nerdy Tip") */
  label?: Maybe<Scalars['String']['output']>;
  /** Language that describes the tip in detail */
  description: Scalars['String']['output'];
};

/** A UserInsightImage is an image associated with a user insight. Used to add further detail or exemplify the insight itself. */
export type UserInsightImage = {
  __typename?: 'UserInsightImage';
  /** The link to the image. */
  imageUri: Scalars['String']['output'];
  /** A descriptive title for the image. */
  label?: Maybe<Scalars['String']['output']>;
};

/**
 * This field encapsulates the concept of an increase or gain to a user’s personal finances.
 *
 * This could range from credit score increases to an increase in savings or debt.
 */
export type UserInsightGain = {
  __typename?: 'UserInsightGain';
  /** Represents the minimum gain from this user insight */
  minGain: Scalars['Float']['output'];
  /** Represents the maximum gain from this user insight */
  maxGain: Scalars['Float']['output'];
  /** Represents the type of gain from this user insight */
  gainUnit: UserInsightGainUnitEnum;
  /** Describes the gain impact */
  description: Scalars['String']['output'];
};

/** The personalized ranking score that was used to rank this insight. */
export type UserInsightPersonalizedRankingScore = {
  __typename?: 'UserInsightPersonalizedRankingScore';
  /**
   * The model execution IDs that were involved in producing the user's personalized ranking score for this insight.
   *   These should all be included in analytics events for this insight.
   *
   *   Includes:
   *   - A model execution ID that indicates which ML model produced this ranking score
   *   - A model execution ID that indicates which _variant_ of the ML model produced this ranking score
   */
  modelExecutionIds: Array<Scalars['String']['output']>;
  /**
   * A measure of how compelling this particular insight is to this particular user.  Used as an input into ranking
   *   decisions.  Takes a value from 0 to 1.
   */
  score: Scalars['Float']['output'];
};

export type ClientEligibilityConfig = {
  __typename?: 'ClientEligibilityConfig';
  /** The minimum native app version required to be eligible for this user insight */
  minNativeAppVersion?: Maybe<Scalars['String']['output']>;
  /** The list of native app versions to block for this user insight */
  blocklistedNativeAppVersions?: Maybe<Array<Scalars['String']['output']>>;
  /** Which platforms to exclude the user insight from */
  excludePlatforms?: Maybe<Array<Maybe<UserInsightPlatformEnum>>>;
};

/**
 * A "user insight" is something noteworthy or interesting that NerdWallet has identified about the user.
 *
 * Examples include:
 * - Your credit score changed this week -- here's why
 * - How your cash flow compares to the same day last month
 * - Your monthly spending breakdown by category
 * - You have too much money in your checking account -- consider moving some to a high-yield savings account
 *
 * There are several insight inventory sources, each with a bespoke data model.  This interface represents the fields
 * that are common across each inventory source.
 */
export type UserInsightInterface = {
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   *   Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   *   Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   *   Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   *   be inferred by source-specific heuristics.
   *
   *   Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID']['output'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']['output']>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']['output']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   *   impact)
   *
   *   For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']['output']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   *   urgency)
   *
   *   For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   *   low-urgency.
   */
  urgency?: Maybe<Scalars['Float']['output']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   *   insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   *   treatment (e.g. red vs. yellow vs. blue accent color).
   *
   *   Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   *   the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   *   Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   *   This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /**
   * The URL to an image that insight cards can use to apply additional visual treatment for cases such as:
   *   Celebratory, Cautionary, Light Bulb
   */
  imageTreatmentUrl?: Maybe<Scalars['URL']['output']>;
  imageTreatmentType?: Maybe<UserInsightImageTreatmentTypeEnum>;
  advertiserDisclosure?: Maybe<Scalars['String']['output']>;
  legalDisclaimer?: Maybe<Scalars['String']['output']>;
};

export type UserInsightsFilterInput = {
  /** If specified, only include insights that are eligible for at least one of the specified modules */
  relatedFeatures?: InputMaybe<Array<MembershipFeatureEnum>>;
  /** If specified, only include insights at or above this level of urgency.  Ranges from 0 to 1. */
  minUrgency?: InputMaybe<Scalars['Float']['input']>;
  /** If specified, only include insights at or below this level of urgency.  Ranges from 0 to 1. */
  maxUrgency?: InputMaybe<Scalars['Float']['input']>;
  /** If specified, only include insights that are eligible for at least one of the specified modules */
  eligibleModules?: InputMaybe<Array<UserInsightEligibleModulesEnum>>;
  /** If specified, exclude insights with matching slugs */
  ineligibleInsightSlugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

export type UserInsightsResponse = {
  __typename?: 'UserInsightsResponse';
  userInsights: Array<UserInsightInterface>;
};

/**
 * Response object that holds the user's current weekly insights streak and a boolean value that determines whether
 * the user has already completed the current week's weekly insights.
 */
export type WeeklyInsightsCurrentStreakResponse = {
  __typename?: 'WeeklyInsightsCurrentStreakResponse';
  currentStreak: Scalars['Int']['output'];
  hasCompletedCurrentWeek: Scalars['Boolean']['output'];
  startCurrentWeek: Scalars['DateTime']['output'];
  endCurrentWeek: Scalars['DateTime']['output'];
  currentBadgeUrl: Scalars['URL']['output'];
  nextBadgeUrl: Scalars['URL']['output'];
  currentBadgeSvgUrl: Scalars['URL']['output'];
  nextBadgeSvgUrl: Scalars['URL']['output'];
};

/** Response object that holds the user's updated weekly insights streak. */
export type UpdateWeeklyInsightsCurrentStreakResponse = {
  __typename?: 'UpdateWeeklyInsightsCurrentStreakResponse';
  updatedStreak: Scalars['Int']['output'];
};

/** The info banner details derived from the feature flag payload, all fields required */
export type SitewideInfoBannerDetails = {
  __typename?: 'SitewideInfoBannerDetails';
  bannerName: Scalars['String']['output'];
  btnText: Scalars['String']['output'];
  copy: Scalars['String']['output'];
  link: Scalars['URL']['output'];
  title: Scalars['String']['output'];
};

export type SitewideInfoBannerResponse = {
  __typename?: 'SitewideInfoBannerResponse';
  isEnabled: Scalars['Boolean']['output'];
  details?: Maybe<SitewideInfoBannerDetails>;
};

export type AccountAggregationInstitutionsResponse = {
  __typename?: 'AccountAggregationInstitutionsResponse';
  /** The total number of institutions that match your query */
  total: Scalars['Int']['output'];
  /** The list of institutions that match your query */
  institutions: Array<AccountAggregationInstitution>;
  /** How many top results are excluded from this result set (for pagination) */
  offset: Scalars['Int']['output'];
};

export enum AccountAggregationInstitutionDisplayStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  /** This institution is not supported, but is a major institution that we want to show to the user anyway (with messaging) */
  Unavailable = 'UNAVAILABLE'
}

export enum InstitutionCountryCode {
  Ca = 'CA',
  Us = 'US'
}

/** The aggregator type should only be one of a subset of all marketplace institution types */
export enum MarketplaceAggregatorType {
  Plaid = 'plaid',
  Yodlee = 'yodlee',
  Unknown = 'unknown',
  NonBankFinancialServiceProvider = 'non_bank_financial_service_provider'
}

export enum AccountAggregationProductType {
  Banking = 'BANKING',
  CreditCards = 'CREDIT_CARDS',
  InvestmentAccounts = 'INVESTMENT_ACCOUNTS',
  Mortgages = 'MORTGAGES',
  PersonalLoans = 'PERSONAL_LOANS',
  StudentLoans = 'STUDENT_LOANS'
}

export type TopInstitutionsForLinkingResponse = {
  __typename?: 'TopInstitutionsForLinkingResponse';
  /** The list of top institutions for the selected product type */
  institutions: Array<AccountAggregationInstitution>;
};

export type AccountAggregationInstitutionByIdResponse = {
  __typename?: 'AccountAggregationInstitutionByIdResponse';
  institution?: Maybe<AccountAggregationInstitution>;
};

export type CanonicalInstitutionsResponse = {
  __typename?: 'CanonicalInstitutionsResponse';
  /** The total number of institutions that match your query. */
  total: Scalars['Int']['output'];
  /** The list of institutions that match your query */
  institutions: Array<CanonicalInstitution>;
  /** How many top results are excluded from this result set (for pagination) */
  offset: Scalars['Int']['output'];
};

export type CanonicalInstitution = {
  __typename?: 'CanonicalInstitution';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
  /**
   * The NerdWallet-maintained url for the square logo of the institution, if we have it
   *
   *   Example: `https://www.nerdwallet.com/cdn/financial-institutions/american-express/amex_logo_square%404x.png`
   */
  squareLogoUrl?: Maybe<Scalars['String']['output']>;
  /**
   * The NerdWallet-maintained list of lowercase synonyms for how this institution may show up on a TU credit report
   *
   *   Example: [`amex`, `american express`]
   */
  tuCreditorSynonyms?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * The NerdWallet-maintained mapping to a yodlee provider id
   *
   *   Example: `175e9916-0ca9-4e32-ac2b-56f0c7e70196`
   */
  yodleeProviderId?: Maybe<Scalars['String']['output']>;
};

/** The response from a credit card offer query. */
export type CreditCardOffersResponse = {
  __typename?: 'CreditCardOffersResponse';
  /** The total number of offers that match your query. */
  total: Scalars['Int']['output'];
  offers: Array<CreditCardOffer>;
  offset: Scalars['Int']['output'];
};

/** The response from a credit card offer query. */
export type CreditCardOffersV2Response = {
  __typename?: 'CreditCardOffersV2Response';
  offers: Array<CreditCardsOfferV2>;
};

/** The derived detail section of a credit card offer */
export type CreditCardOfferDerivedDetails = {
  __typename?: 'CreditCardOfferDerivedDetails';
  /** Link to apply for a credit card offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** Interstitial redirect terms and fees link */
  termsFeesRedirectLink?: Maybe<Scalars['URL']['output']>;
  /** The monetary valuation (in cents) per reward point */
  rewardCentsPerUnit?: Maybe<Scalars['Float']['output']>;
  /** The monetary valuation (in cents) per reward point in string format */
  rewardCentsPerUnitString?: Maybe<Scalars['String']['output']>;
  /**
   * The likelihood of approval for the card based on the user's credit score bucket
   * @deprecated Use CreditCardOfferDetails.approvalOdds instead
   */
  approvalLikelihood?: Maybe<Scalars['Float']['output']>;
};

/** The details section of a credit card offer */
export type CreditCardOfferDetails = {
  __typename?: 'CreditCardOfferDetails';
  /** The annual fee for the card */
  annualFee?: Maybe<Scalars['Float']['output']>;
  /** The display string for annual fee */
  annualFeeDetails?: Maybe<Scalars['String']['output']>;
  /** The minimum APR */
  aprMin?: Maybe<Scalars['Float']['output']>;
  /** The maximum APR */
  aprMax?: Maybe<Scalars['Float']['output']>;
  /** The balance transfer fee as a percentage of the transfer amount */
  balanceTransferFee?: Maybe<Scalars['Float']['output']>;
  /** A more detailed description of balance transfer */
  balanceTransferFeeDescription?: Maybe<Scalars['String']['output']>;
  /** The balance transfer APR */
  balanceTransferIntroApr?: Maybe<Scalars['Float']['output']>;
  /** The term of 'balanceTransferIntroApr', in months */
  balanceTransferInfoTime?: Maybe<Scalars['Int']['output']>;
  /** The display string for the unit the billing cycle is calculated in (e.g. "months") */
  billingCycleUnits?: Maybe<Scalars['String']['output']>;
  /** Custom details like 'credit cards great for:...' */
  customDetailsList?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of negative attributes about the card */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The foreign transaction fee as a percentage of the transaction  amount */
  foreignTransactionFee?: Maybe<Scalars['Float']['output']>;
  /** URL of card image */
  imageSource?: Maybe<Scalars['String']['output']>;
  /** URL of card image (larger format) */
  imageSourceLarge?: Maybe<Scalars['String']['output']>;
  /** URL of card image (medium format) */
  imageSourceMedium?: Maybe<Scalars['String']['output']>;
  /** Boolean flag indicating whether or not an offer is monetizing (revenue generating partnership) */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** The card issuer's information page on their domain */
  issuerInfoUrl?: Maybe<Scalars['URL']['output']>;
  legacyId: Scalars['Int']['output'];
  /** A list of marketing strings about the card */
  marketingBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Marketing strings with terms and fees link removed from list */
  marketingBulletsWithoutTermsFeesLink?: Maybe<Array<Scalars['String']['output']>>;
  /** The maximum FICO recommended for approval */
  maxFico?: Maybe<Scalars['Int']['output']>;
  /** The minimum recommended FICO for approval */
  minFico?: Maybe<Scalars['Int']['output']>;
  /** The regular APR rate after the intro APR offer expires */
  ongoingApr?: Maybe<Scalars['String']['output']>;
  /** List of perks this credit card has */
  perks?: Maybe<Array<Scalars['String']['output']>>;
  /** The program name */
  programName?: Maybe<Scalars['String']['output']>;
  /** A list of positive attributes of the card */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** User-friendly string representing the range of 'aprMin' - 'aprMax' */
  purchaseApr?: Maybe<Scalars['String']['output']>;
  /** The introductory purchase APR for new card owners */
  purchaseIntroApr?: Maybe<Scalars['Float']['output']>;
  /** The introductory length of the intro purchase APR in months (maps from purchase_intro_time) */
  purchaseIntroTerm?: Maybe<Scalars['Int']['output']>;
  /** NerdWallet review star rating */
  rating?: Maybe<Scalars['Float']['output']>;
  /** Cards related to this offer */
  relatedCardIds?: Maybe<Array<Scalars['Int']['output']>>;
  /** URL to articles with related content to this card */
  relatedContent?: Maybe<Array<Scalars['String']['output']>>;
  rewardCategoriesBestRates?: Maybe<Array<CreditCardOfferRewardCategories>>;
  /** More in depth detailed notes about the credit card offer */
  rewardRateNotes?: Maybe<Scalars['String']['output']>;
  /** Type of reward units earned by this offer */
  rewardType?: Maybe<CreditCardOfferRewardType>;
  slug?: Maybe<Scalars['String']['output']>;
  /** A link to the card's terms and fees, if applicable */
  termsFeesLink?: Maybe<Scalars['URL']['output']>;
  /** Offer version id */
  versionId?: Maybe<Scalars['Int']['output']>;
  /** Phone number for some issuers that allow calling to apply */
  applyPayPerCall?: Maybe<Scalars['String']['output']>;
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']['output']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
  /** The likelihood of approval for the card based on the user's credit score bucket */
  approvalOdds?: Maybe<Scalars['Float']['output']>;
};

/** Type of rewards this credit card offer gives */
export enum CreditCardOfferRewardType {
  Cash = 'CASH',
  Points = 'POINTS',
  NoRewards = 'NO_REWARDS',
  Miles = 'MILES'
}

/** Breakdown of bonus categories for this credit card offer */
export type CreditCardOfferRewardCategories = {
  __typename?: 'CreditCardOfferRewardCategories';
  category: CreditCardOfferRewardCategoryType;
  rate: Scalars['Float']['output'];
};

/** The various components of a credit card recommendation */
export type RewardsCreditCardRecommendationDetails = {
  __typename?: 'RewardsCreditCardRecommendationDetails';
  /** The reward category of the recommended card */
  categoryType?: Maybe<CreditCardOfferRewardCategoryType>;
  /** The user's current card's legacy ID in this category */
  currentBestCardLegacyId: Scalars['Int']['output'];
  /** The user's current card's best rate in this category */
  currentBestRate?: Maybe<Scalars['Float']['output']>;
  /** The user's current card's reward type */
  currentBestRateUnit?: Maybe<CreditCardOfferRewardType>;
  /** The user's recommended card's best rate in this category */
  newBestRate?: Maybe<Scalars['Float']['output']>;
  /** The user's recommended card's reward type in this category */
  newBestRateUnit?: Maybe<CreditCardOfferRewardType>;
  /** The user's 30 day average spending over the previous 90 days in this rewards category */
  categorySpendingAmount?: Maybe<Scalars['Float']['output']>;
  /** The user's estimated +/- in rewards over two years for the recommended card */
  rewardIncrease?: Maybe<Scalars['Float']['output']>;
  /** The amount of bonus points/miles/rewards a user can expect to receive if they meet signup bonus */
  qualifiedSigningBonusAmount?: Maybe<Scalars['Float']['output']>;
  /** The currency of bonus points/miles/rewards a user can expect to receive if they meet signing bonus */
  qualifiedSigningBonusAmountType?: Maybe<CreditCardOfferRewardType>;
};

export enum RewardsCreditCardRecommendationType {
  All = 'ALL',
  Complementary = 'COMPLEMENTARY',
  Entertainment = 'ENTERTAINMENT',
  Dining = 'DINING',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  Travel = 'TRAVEL',
  Overall = 'OVERALL',
  Other = 'OTHER'
}

/**
 * Bonus categories of credit card offers
 * https://finproservices.nerdwallet.biz/flask_admin/rewardcategory/
 */
export enum CreditCardOfferRewardCategoryType {
  All = 'ALL',
  Airfare = 'AIRFARE',
  Bookstores = 'BOOKSTORES',
  Business = 'BUSINESS',
  CarRental = 'CAR_RENTAL',
  CarWashes = 'CAR_WASHES',
  Charity = 'CHARITY',
  Dining = 'DINING',
  Discount = 'DISCOUNT',
  Drugstores = 'DRUGSTORES',
  Entertainment = 'ENTERTAINMENT',
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  HomeImprove = 'HOME_IMPROVE',
  Hotel = 'HOTEL',
  Lodging = 'LODGING',
  Movies = 'MOVIES',
  Office = 'OFFICE',
  Other = 'OTHER',
  Parking = 'PARKING',
  Playstation = 'PLAYSTATION',
  RentalCars = 'RENTAL_CARS',
  Telecom = 'TELECOM',
  Travel = 'TRAVEL',
  Utilities = 'UTILITIES',
  Wireless = 'WIRELESS',
  Overall = 'OVERALL'
}

/** Input parameters for credit card offers marketplace queries */
export type CreditCardOffersParametersCategorySpend = {
  dining?: InputMaybe<Scalars['Int']['input']>;
  gas?: InputMaybe<Scalars['Int']['input']>;
  groceries?: InputMaybe<Scalars['Int']['input']>;
  office?: InputMaybe<Scalars['Int']['input']>;
  travel?: InputMaybe<Scalars['Int']['input']>;
  other?: InputMaybe<Scalars['Int']['input']>;
};

/** Query variables for the credit card offers query */
export type CreditCardOffersParameters = {
  debtPayment?: InputMaybe<Scalars['Int']['input']>;
  ficoScore?: InputMaybe<Scalars['Int']['input']>;
  numberOfMonths?: InputMaybe<Scalars['Int']['input']>;
  totalDebt?: InputMaybe<Scalars['Int']['input']>;
  categorySpend?: InputMaybe<CreditCardOffersParametersCategorySpend>;
  existingCardApr?: InputMaybe<Scalars['Float']['input']>;
};

/** The `CreditCardRecommendationBundle` represents one recommendation bundle from recommendationServiceApi. */
export type CreditCardRecommendationBundle = {
  __typename?: 'CreditCardRecommendationBundle';
  header?: Maybe<Scalars['String']['output']>;
  image?: Maybe<Scalars['String']['output']>;
  teaser?: Maybe<Scalars['String']['output']>;
  details?: Maybe<Scalars['String']['output']>;
  trackingId?: Maybe<Scalars['String']['output']>;
  creditCardOffers?: Maybe<Array<CreditCardOffer>>;
  primaryAction?: Maybe<AppAction>;
};

/** Institution contains the common base fields for all institutions. */
export type InstitutionInterface = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
  canonicalInstitutionId?: Maybe<Scalars['String']['output']>;
};

export type InvestmentAccountOfferDetails = {
  __typename?: 'InvestmentAccountOfferDetails';
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']['output']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
};

/** OfferInterface contains the common base fields for all offers. */
export type OfferInterface = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
};

/**
 * The `AccountOfferInterface` is the shared fields between savings and investments
 * for the marketplace tab recommendations.
 */
export type AccountOfferInterface = {
  imageUrl?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewUrl?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
};

/** The response from a personal loan offer query. */
export type PersonalLoanOffersResponse = {
  __typename?: 'PersonalLoanOffersResponse';
  /** The total number of offers that match your query. */
  total: Scalars['Int']['output'];
  offers: Array<PersonalLoanOffer>;
  offset: Scalars['Int']['output'];
};

/** Details about the personal loan product */
export type PersonalLoanProductDetails = {
  __typename?: 'PersonalLoanProductDetails';
  allowsPrequal: Scalars['Boolean']['output'];
};

/** Details about the personal loan offer */
export type PersonalLoanOfferDetails = {
  __typename?: 'PersonalLoanOfferDetails';
  aprTooltip?: Maybe<Scalars['String']['output']>;
  consBullets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  delinquencies?: Maybe<Array<Scalars['String']['output']>>;
  disclaimer?: Maybe<Scalars['String']['output']>;
  excludedCitizenshipStatus: Array<Scalars['String']['output']>;
  excludedHousing: Array<Scalars['String']['output']>;
  excludedLoanPurpose: Array<PersonalLoanPurpose>;
  feesBullets?: Maybe<Array<Scalars['String']['output']>>;
  imageAltText?: Maybe<Scalars['String']['output']>;
  imageIsPortrait: Scalars['Boolean']['output'];
  imageSource?: Maybe<Scalars['URL']['output']>;
  imageSourceLarge?: Maybe<Scalars['URL']['output']>;
  imageSourceMedium?: Maybe<Scalars['URL']['output']>;
  keyFactsBullets?: Maybe<Array<Scalars['String']['output']>>;
  legacyId?: Maybe<Scalars['String']['output']>;
  loanTermList: Array<Scalars['Int']['output']>;
  loanTermType: Scalars['String']['output'];
  maxApr: Scalars['Int']['output'];
  maxFico: Scalars['Int']['output'];
  maxHardInquiries?: Maybe<Scalars['Int']['output']>;
  /** This time unit is months. */
  maxHardInquiriesTimeSpanMonths?: Maybe<Scalars['Int']['output']>;
  maxLoanAmount?: Maybe<Scalars['Int']['output']>;
  maxLoanTerm?: Maybe<Scalars['Int']['output']>;
  maxNumberBankruptcies?: Maybe<Scalars['Int']['output']>;
  /** The time unit is months. */
  maxNumberBankruptciesTimeSpanMonths?: Maybe<Scalars['Int']['output']>;
  minApr: Scalars['Int']['output'];
  /** The time unit is months. */
  minCreditHistoryMonths?: Maybe<Scalars['Int']['output']>;
  minFico: Scalars['Int']['output'];
  minFicoAnnotation?: Maybe<Scalars['String']['output']>;
  minFicoDisplayed: Scalars['Int']['output'];
  minFicoTooltip?: Maybe<Scalars['String']['output']>;
  minIncome: Scalars['Int']['output'];
  minLoanAmount?: Maybe<Scalars['Int']['output']>;
  /** This time unit is months. */
  phoneNumberDesktop?: Maybe<Scalars['String']['output']>;
  phoneNumberMobile?: Maybe<Scalars['String']['output']>;
  minLoanTermMonths?: Maybe<Scalars['Int']['output']>;
  primaryOffer: Scalars['Boolean']['output'];
  prosBullets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  qualificationsBullets?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  ratingStars?: Maybe<Scalars['Float']['output']>;
  reviewLink?: Maybe<Scalars['String']['output']>;
  reviewTitle?: Maybe<Scalars['String']['output']>;
  simplifyApr?: Maybe<Scalars['Boolean']['output']>;
  timeToFund?: Maybe<Scalars['Float']['output']>;
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']['output']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
};

/**
 * Derived details about the personal loan offer.
 * Note: This are dependent on having the following query variables supplied:
 * - annualIncome
 * - loanAmount
 * - minCreditScore
 * - maxCreditScore
 * - zipCode
 */
export type PersonalLoanOfferDerivedDetails = {
  __typename?: 'PersonalLoanOfferDerivedDetails';
  applyLink?: Maybe<Scalars['URL']['output']>;
  avgNarrowApr?: Maybe<Scalars['Float']['output']>;
  isAllowedForZipCode?: Maybe<Scalars['Boolean']['output']>;
  maxNarrowApr?: Maybe<Scalars['Float']['output']>;
  minNarrowApr?: Maybe<Scalars['Float']['output']>;
  monthlyPayment?: Maybe<Scalars['Float']['output']>;
};

/**
 * Query variables for the personal loan queries.
 * Note that some of these are required for the
 * query to work, since this query retrieves all
 * fields from the Offer API.
 */
export type PersonalLoanOffersParameters = {
  annualIncome: Scalars['Int']['input'];
  loanAmount: Scalars['Int']['input'];
  loanPurpose?: InputMaybe<PersonalLoanPurpose>;
  maxCreditScore: Scalars['Int']['input'];
  minCreditScore: Scalars['Int']['input'];
  /**
   * The zipCode variable is required if requesting the
   *   isAllowedForZipCode field.
   */
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Valid options for the personal loan's purpose */
export enum PersonalLoanPurpose {
  Business = 'BUSINESS',
  ConsolidateDebt = 'CONSOLIDATE_DEBT',
  EmergencyExpense = 'EMERGENCY_EXPENSE',
  HomeImprovement = 'HOME_IMPROVEMENT',
  Moving = 'MOVING',
  Other = 'OTHER',
  RefinanceCreditCard = 'REFINANCE_CREDIT_CARD',
  Vacation = 'VACATION'
}

/** ProductInterface contains the common base fields for all products. */
export type ProductInterface = {
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

export type MortgageProductDetails = {
  __typename?: 'MortgageProductDetails';
  logo?: Maybe<Scalars['String']['output']>;
  lenderId?: Maybe<Scalars['String']['output']>;
};

export type CreditCardOfferBundlesResponse = {
  __typename?: 'CreditCardOfferBundlesResponse';
  bundles: Array<CreditCardRecommendationBundle>;
};

export type SavingsAccountOffersByNamedQueryResponse = {
  __typename?: 'SavingsAccountOffersByNamedQueryResponse';
  offers?: Maybe<Array<SavingsAccountOffer>>;
};

export type SavingsAccountOfferDetails = {
  __typename?: 'SavingsAccountOfferDetails';
  /** Names of the award badge names this offer won in 2020. */
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']['output']>>;
  /** Names of the award badge names this offer won in 2021. */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
};

export enum MortgagesOfferV2LoanTypeEnum {
  Cashout = 'CASHOUT',
  Conventional = 'CONVENTIONAL',
  Fha = 'FHA',
  Hel = 'HEL',
  Heloc = 'HELOC',
  Jumbo = 'JUMBO',
  Usda = 'USDA',
  Va = 'VA',
  VaCashout = 'VA_CASHOUT'
}

export enum MortgagesProductV2TypeEnum {
  HomeEquity = 'HOME_EQUITY',
  Purchase = 'PURCHASE',
  Refinance = 'REFINANCE'
}

export enum PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum {
  Bankruptcy = 'BANKRUPTCY',
  BorrowAndGrow = 'BORROW_AND_GROW',
  BuyNowPayLater = 'BUY_NOW_PAY_LATER',
  CoSignLoans = 'CO_SIGN_LOANS',
  Contingent = 'CONTINGENT',
  CreditBuilderLoans = 'CREDIT_BUILDER_LOANS',
  CreditCounseling = 'CREDIT_COUNSELING',
  DebtManagementPlans = 'DEBT_MANAGEMENT_PLANS',
  DebtSettlement = 'DEBT_SETTLEMENT',
  FriendsFamilyLoans = 'FRIENDS_FAMILY_LOANS',
  HighInterestPersonalLoans = 'HIGH_INTEREST_PERSONAL_LOANS',
  HomeEquityLoans = 'HOME_EQUITY_LOANS',
  LineOfCredit = 'LINE_OF_CREDIT',
  PaycheckAdvance = 'PAYCHECK_ADVANCE',
  SecuredLoans = 'SECURED_LOANS'
}

export enum StateAbbreviationsEnum {
  Ak = 'AK',
  Al = 'AL',
  Ar = 'AR',
  Az = 'AZ',
  Ca = 'CA',
  Co = 'CO',
  Ct = 'CT',
  Dc = 'DC',
  De = 'DE',
  Fl = 'FL',
  Ga = 'GA',
  Hi = 'HI',
  Ia = 'IA',
  Id = 'ID',
  Il = 'IL',
  In = 'IN',
  Ks = 'KS',
  Ky = 'KY',
  La = 'LA',
  Ma = 'MA',
  Md = 'MD',
  Me = 'ME',
  Mi = 'MI',
  Mn = 'MN',
  Mo = 'MO',
  Ms = 'MS',
  Mt = 'MT',
  Nc = 'NC',
  Nd = 'ND',
  Ne = 'NE',
  Nh = 'NH',
  Nj = 'NJ',
  Nm = 'NM',
  Nv = 'NV',
  Ny = 'NY',
  Oh = 'OH',
  Ok = 'OK',
  Or = 'OR',
  Pa = 'PA',
  Ri = 'RI',
  Sc = 'SC',
  Sd = 'SD',
  Tn = 'TN',
  Tx = 'TX',
  Ut = 'UT',
  Va = 'VA',
  Vt = 'VT',
  Wa = 'WA',
  Wi = 'WI',
  Wv = 'WV',
  Wy = 'WY'
}

export type CreditCardsRecommendedCreditScoreRangeDetails = {
  __typename?: 'CreditCardsRecommendedCreditScoreRangeDetails';
  /** The recommended credit score range for the offer. */
  creditScoreRange?: Maybe<Scalars['String']['output']>;
  /** The recommended credit score range description for the offer. */
  description?: Maybe<Scalars['String']['output']>;
};

export type RewardsRate = {
  __typename?: 'RewardsRate';
  /** The rate of the reward as an integer */
  rate: Scalars['Float']['output'];
  /** The description of the reward attached to the rate */
  description: Scalars['String']['output'];
};

export type CreditCardsCreditScoreComparisonContent = {
  __typename?: 'CreditCardsCreditScoreComparisonContent';
  /** The difference in points from the credit score to the offer preferred score and then padded with the 'points' or 'point' suffix. E.g. 1 point, 10 points */
  pointDifference: Scalars['String']['output'];
  /** The label used to indicate to the user how relative their score is to the offer's preferred score. */
  relativeScoreLabel: Scalars['String']['output'];
  /** The score used to compare. */
  scoreToCompare: Scalars['Int']['output'];
};

export type ReviewRedirect = {
  __typename?: 'ReviewRedirect';
  reviewUrl: Scalars['URL']['output'];
};

export type MarketplaceEntityRelatedReviewUnion = Review | ReviewRedirect;

export type LegacyDriver = {
  __typename?: 'LegacyDriver';
  /** The driver description */
  description?: Maybe<Scalars['String']['output']>;
  /** The driver label */
  label: Scalars['String']['output'];
  /** The value of the driver */
  value?: Maybe<Scalars['String']['output']>;
  /** Tooltip for the value of the driver */
  tooltip?: Maybe<Scalars['String']['output']>;
};

/** Common interface for marketplace entities with qualification bullets */
export type MarketplaceEntityWithQualificationsInterface = {
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']['output']>>;
};

export type RawDriver = {
  __typename?: 'RawDriver';
  /**
   * The synthetic driver id to create a unique cache key to store this data within the Apollo cache.
   *   Without this field the data in this Type will get rolled up under the parent Type,
   *   and there's potential for some cache pollution since some of the field values within
   *   this type are based on the minAccountBalance input.
   */
  id: Scalars['ID']['output'];
  /** The driver description */
  description?: Maybe<Scalars['String']['output']>;
  /** The driver label */
  label: Scalars['String']['output'];
  /** The value of the driver */
  value?: Maybe<Scalars['String']['output']>;
  /** Tooltip for the value of the driver */
  tooltip?: Maybe<Scalars['String']['output']>;
};

/** Input for marketplace query */
export type MarketplaceQueryInput = {
  field: Scalars['String']['input'];
  type: Scalars['String']['input'];
  value: Scalars['JSON']['input'];
};

/** Input for marketplace sort */
export type MarketplaceSortInput = {
  field: Scalars['String']['input'];
  order: OrderDirectionEnum;
};

/** marketplaceSearch query response */
export type MarketplaceSearchResponse = {
  __typename?: 'MarketplaceSearchResponse';
  /** The total number of marketplace entities that match your query. */
  total: Scalars['Int']['output'];
  /** List of marketplace entities that match your query. */
  entities?: Maybe<Array<MarketplaceEntityInterface>>;
};

/** marketplaceField query response */
export type MarketplaceFieldResponse = {
  __typename?: 'MarketplaceFieldResponse';
  /** Boolean value that indicates if the marketplace entity is active */
  isActive: Scalars['Boolean']['output'];
  /** Name of the marketplace entity */
  name: Scalars['String']['output'];
  /** A string value of the requested marketplace field. */
  value: Scalars['String']['output'];
  /** The timestamp for when the entity was created. */
  createdAt: Scalars['DateTime']['output'];
  /** The timestamp for when the entity was last ingested. */
  lastIngested?: Maybe<Scalars['DateTime']['output']>;
  /** The timestamp for when the entity was last updated. */
  updatedAt: Scalars['DateTime']['output'];
  /** The type of product for the entity. */
  productType: Scalars['String']['output'];
  /** The entity type. */
  entityType: Scalars['String']['output'];
};

/** Marketplace Passthrough entity */
export type MarketplacePassthroughEntity = {
  __typename?: 'MarketplacePassthroughEntity';
  id: Scalars['ID']['output'];
  /** Unstructured marketplace entity blob */
  entity?: Maybe<Scalars['JSON']['output']>;
};

/** Response from MarketplaceNamedQueryPassthrough query */
export type MarketplaceNamedQueryPassthroughResponse = {
  __typename?: 'MarketplaceNamedQueryPassthroughResponse';
  /** A stable ID generated by hashing the input to the query */
  id: Scalars['ID']['output'];
  /** unstructured object keyed by named query name with values containing the array of entities */
  namedQueries?: Maybe<Scalars['JSON']['output']>;
};

/** Input for the MarketplaceNamedQueryPassthrough query */
export type MarketplaceNamedQueryPassthroughInput = {
  productType: Scalars['String']['input'];
  entityType: Scalars['String']['input'];
  namedQueries: Array<Scalars['String']['input']>;
  payload?: InputMaybe<Scalars['JSON']['input']>;
};

export enum TopCategory {
  Gas = 'GAS',
  Groceries = 'GROCERIES',
  Dining = 'DINING',
  Entertainment = 'ENTERTAINMENT',
  Shopping = 'SHOPPING',
  Travel = 'TRAVEL'
}

export enum MoneyTransferAccountEligibilityStatusEnum {
  Eligible = 'ELIGIBLE',
  AccountDetailsUnavailable = 'ACCOUNT_DETAILS_UNAVAILABLE',
  AccountNotVerified = 'ACCOUNT_NOT_VERIFIED',
  InsufficientIavData = 'INSUFFICIENT_IAV_DATA',
  AccountNameNotMatching = 'ACCOUNT_NAME_NOT_MATCHING',
  Unknown = 'UNKNOWN',
  UnsupportedAccountType = 'UNSUPPORTED_ACCOUNT_TYPE',
  UnsupportedMoneyMarketAccount = 'UNSUPPORTED_MONEY_MARKET_ACCOUNT'
}

export enum MoneyTransferAccountStatusEnum {
  AccountAchUnverified = 'ACCOUNT_ACH_UNVERIFIED',
  AccountInactive = 'ACCOUNT_INACTIVE',
  AccountNameMatchFailed = 'ACCOUNT_NAME_MATCH_FAILED',
  AccountNotInAchSystem = 'ACCOUNT_NOT_IN_ACH_SYSTEM',
  AccountReady = 'ACCOUNT_READY',
  AccountRemovedInAch = 'ACCOUNT_REMOVED_IN_ACH',
  AccountUninitialized = 'ACCOUNT_UNINITIALIZED',
  AccountUnlinked = 'ACCOUNT_UNLINKED',
  Unknown = 'UNKNOWN'
}

export enum MoneyTransferFinancialAccountTypeEnum {
  Checking = 'CHECKING',
  Savings = 'SAVINGS'
}

export type MoneyTransferAccountEligibility = {
  __typename?: 'MoneyTransferAccountEligibility';
  eligibility: MoneyTransferAccountEligibilityStatusEnum;
  id: Scalars['ID']['output'];
  financialAccountType?: Maybe<MoneyTransferFinancialAccountTypeEnum>;
};

export type MoneyTransferAccount = {
  __typename?: 'MoneyTransferAccount';
  /** The unique identifier for this linked-account in money-management */
  id: Scalars['ID']['output'];
  /** The computed status for this account (combination of money-management + ach statuses) */
  computedStatus?: Maybe<MoneyTransferAccountStatusEnum>;
  /** The identifier found in FDP or legacy-Yodlee */
  financialAccountId: Scalars['ID']['output'];
  /** The type of this account (CHECKING or SAVINGS) */
  financialAccountType: MoneyTransferFinancialAccountTypeEnum;
  /** The last four digits of the account number */
  financialAccountLastFour?: Maybe<Scalars['String']['output']>;
  /** The institution name (e.g. Wells Fargo) */
  institutionName?: Maybe<Scalars['String']['output']>;
  /** Indicates whether the account passed the holder name match check */
  nameMatchSuccess?: Maybe<Scalars['Boolean']['output']>;
};

export type MoneyTransferAccountEligibilityResponse = {
  __typename?: 'MoneyTransferAccountEligibilityResponse';
  accounts: Array<MoneyTransferAccountEligibility>;
};

export type CreateMoneyTransferAccountResponse = {
  __typename?: 'CreateMoneyTransferAccountResponse';
  account: MoneyTransferAccount;
};

export enum MoneyTransferTransferStatusEnum {
  Created = 'CREATED',
  Cancelled = 'CANCELLED',
  CancelInitiatedBySecurity = 'CANCEL_INITIATED_BY_SECURITY',
  CancelInitiatedByUser = 'CANCEL_INITIATED_BY_USER',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  FailedDuringActivation = 'FAILED_DURING_ACTIVATION',
  MockTransfer = 'MOCK_TRANSFER',
  Pending = 'PENDING',
  PendingBalanceCheck = 'PENDING_BALANCE_CHECK',
  Uninitialized = 'UNINITIALIZED'
}

export enum MoneyTransferTransferTypeEnum {
  NextDay = 'NEXT_DAY',
  Standard = 'STANDARD'
}

export type MoneyTransferTransferStatusHistory = {
  __typename?: 'MoneyTransferTransferStatusHistory';
  createdAt: Scalars['DateTime']['output'];
  id: Scalars['ID']['output'];
  status: MoneyTransferTransferStatusEnum;
  transferId: Scalars['ID']['output'];
};

export type MoneyTransferTransfer = {
  __typename?: 'MoneyTransferTransfer';
  /** The unique identifier for this transfer in money-management */
  id: Scalars['ID']['output'];
  /** The current (high-level) status for this transfer (combination of money-management + ach statuses) */
  status: MoneyTransferTransferStatusEnum;
  /** The transfer amount in USD */
  amount: Scalars['Float']['output'];
  /** The source account from where the money is retrieved */
  sourceAccount: MoneyTransferAccount;
  /** The destination account to where the money is deposited */
  destinationAccount: MoneyTransferAccount;
  /** Indicates the speed of the transfer */
  type?: Maybe<MoneyTransferTransferTypeEnum>;
  /** Timestamp indicating when the user attempted to initiate the transfer */
  userInitiatedAt: Scalars['DateTime']['output'];
  /** Timestamp indicating when the (high-level) status was last updated */
  lastStatusUpdatedAt: Scalars['DateTime']['output'];
  /** A JSON blob with additional transfer details */
  achData?: Maybe<Scalars['JSON']['output']>;
  /** Indicates if the user can still cancel this transfer */
  canCancel?: Maybe<Scalars['Boolean']['output']>;
  /**
   * The status histories define when and what state changes occurred over the lifecycle
   *   of the transfer
   */
  statusHistory: Array<MoneyTransferTransferStatusHistory>;
};

export type MoneyTransferDefaultTransferLimits = {
  __typename?: 'MoneyTransferDefaultTransferLimits';
  userDailyLimit: Scalars['Int']['output'];
  checkingAccountDailyLimit: Scalars['Int']['output'];
  savingsAccountDailyLimit: Scalars['Int']['output'];
  userWeeklyLimit: Scalars['Int']['output'];
  checkingAccountWeeklyLimit: Scalars['Int']['output'];
  savingsAccountWeeklyLimit: Scalars['Int']['output'];
  userMonthlyLimit: Scalars['Int']['output'];
  checkingAccountMonthlyLimit: Scalars['Int']['output'];
  savingsAccountMonthlyLimit: Scalars['Int']['output'];
  maxMonthlyTransferAmountDollars: Scalars['Int']['output'];
  minSingleTransferAmountDollars: Scalars['Int']['output'];
  maxSingleTransferAmountDollars: Scalars['Int']['output'];
  balanceCheckBufferAmountDollars: Scalars['Int']['output'];
  balanceCheckBufferAmountDollarsWarning: Scalars['Int']['output'];
};

export type MoneyTransferUserTransferLimits = {
  __typename?: 'MoneyTransferUserTransferLimits';
  userDailyLimit: Scalars['Int']['output'];
  userWeeklyLimit: Scalars['Int']['output'];
  userMonthlyLimit: Scalars['Int']['output'];
  maxMonthlyTransferAmountDollars: Scalars['Int']['output'];
  maxSingleTransferAmountDollars: Scalars['Int']['output'];
};

export type MoneyTransferFinancialAccountTransferLimits = {
  __typename?: 'MoneyTransferFinancialAccountTransferLimits';
  id: Scalars['ID']['output'];
  dayLimit: Scalars['Int']['output'];
  maxTransferAmountDollars: Scalars['Int']['output'];
  weekLimit: Scalars['Int']['output'];
  monthLimit: Scalars['Int']['output'];
};

export type MoneyTransferTransferLimits = {
  __typename?: 'MoneyTransferTransferLimits';
  defaultLimits: MoneyTransferDefaultTransferLimits;
  userLimits: MoneyTransferUserTransferLimits;
  financialAccountLimits: Array<MoneyTransferFinancialAccountTransferLimits>;
};

export type MoneyTransferTransferLimitsResponse = {
  __typename?: 'MoneyTransferTransferLimitsResponse';
  transferLimits: MoneyTransferTransferLimits;
};

export type MoneyTransferKbaAnswer = {
  __typename?: 'MoneyTransferKbaAnswer';
  text: Scalars['String']['output'];
  id: Scalars['ID']['output'];
};

export type MoneyTransferKbaQuestion = {
  __typename?: 'MoneyTransferKbaQuestion';
  text: Scalars['String']['output'];
  id: Scalars['ID']['output'];
  answers: Array<MoneyTransferKbaAnswer>;
};

export type MoneyTransferKbaQuestionsResponse = {
  __typename?: 'MoneyTransferKbaQuestionsResponse';
  questions: Array<MoneyTransferKbaQuestion>;
};

export type MoneyTransferCancelTransferResponse = {
  __typename?: 'MoneyTransferCancelTransferResponse';
  success: Scalars['Boolean']['output'];
};

export type CreateMoneyTransferResponse = {
  __typename?: 'CreateMoneyTransferResponse';
  transfer: MoneyTransferTransfer;
};

export enum MoneyTransferUserStatus {
  Unknown = 'UNKNOWN',
  UserAchDisabled = 'USER_ACH_DISABLED',
  UserAchEnabled = 'USER_ACH_ENABLED',
  UserAchKba = 'USER_ACH_KBA',
  UserAchRetryWithFullSsn = 'USER_ACH_RETRY_WITH_FULL_SSN',
  UserInactive = 'USER_INACTIVE',
  UserNotInAchSystem = 'USER_NOT_IN_ACH_SYSTEM',
  UserReady = 'USER_READY',
  UserUninitialized = 'USER_UNINITIALIZED'
}

export type MoneyTransferUser = {
  __typename?: 'MoneyTransferUser';
  /** KYC first name */
  firstName: Scalars['String']['output'];
  /** KYC last name */
  lastName: Scalars['String']['output'];
  /** Computed status for this user (combination of money-management + ach statuses) */
  computedStatus: MoneyTransferUserStatus;
};

export type MoneyTransferCreateUserResponse = {
  __typename?: 'MoneyTransferCreateUserResponse';
  user?: Maybe<MoneyTransferUser>;
};

export type MoneyTransferCreateUserInput = {
  address: Scalars['String']['input'];
  birthdate: Scalars['String']['input'];
  city: Scalars['String']['input'];
  email: Scalars['String']['input'];
  firstName: Scalars['String']['input'];
  fullSsn?: InputMaybe<Scalars['String']['input']>;
  lastName: Scalars['String']['input'];
  postalCode: Scalars['String']['input'];
  shortSsn: Scalars['String']['input'];
  state: Scalars['String']['input'];
};

export type MortgageLicensed = {
  __typename?: 'MortgageLicensed';
  /** State looked up from user's zipCode */
  state?: Maybe<Scalars['String']['output']>;
  /** Whether NerdWallet a licensed mortgage broker */
  isLicensed: Scalars['Boolean']['output'];
};

/** Response type for a list of mortgage offers */
export type MortgageSavedRecommendedLendersResponse = {
  __typename?: 'MortgageSavedRecommendedLendersResponse';
  /** List of mortgage offers */
  offers?: Maybe<Array<MortgagesOfferV2>>;
};

/** Response type for a list of mortgage offers */
export type MortgageSavedLendersResponse = {
  __typename?: 'MortgageSavedLendersResponse';
  /** List of mortgage offers */
  offers?: Maybe<Array<MortgagesOfferV2>>;
};

/** Response type for a mortgage best of award winner details */
export type MortgageBestOfAwardWinnerDetails = {
  __typename?: 'MortgageBestOfAwardWinnerDetails';
  allWinnersLink?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
  bestForText?: Maybe<Scalars['String']['output']>;
  bestForImage?: Maybe<Scalars['String']['output']>;
  bestForImageAltText?: Maybe<Scalars['String']['output']>;
  whyOurNerdsLoveItText?: Maybe<Scalars['String']['output']>;
  methodologyLink?: Maybe<Scalars['String']['output']>;
  awardCategory?: Maybe<Scalars['String']['output']>;
  marketplaceEntity?: Maybe<MortgagesOfferV2>;
};

/** FIXME: this violates enum best practices by having lowercase values */
export enum MortgageLoanPurposeEnum {
  Purchase = 'purchase',
  Refinance = 'refinance'
}

/** Employment type */
export enum MortgageEmploymentTypeEnum {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  SelfEmployed = 'SELF_EMPLOYED',
  Unemployed = 'UNEMPLOYED'
}

/** Property purpose */
export enum MortgagePropertyPurposeEnum {
  Primary = 'PRIMARY',
  Secondary = 'SECONDARY',
  Investment = 'INVESTMENT'
}

/** Partial address, currently only supports zipCode */
export type MortgageUserAddressInput = {
  zipCode: Scalars['String']['input'];
};

/** Inputs for Mortgage lender match logic.  Subset of Mortgage OSX inputs */
export type MortgageLenderMatchInput = {
  /** User's annual income */
  annualIncome?: InputMaybe<Scalars['Int']['input']>;
  /** Amount of cash-out the user wants */
  cashout?: InputMaybe<Scalars['Int']['input']>;
  /** User's credit score */
  creditScore?: InputMaybe<Scalars['Int']['input']>;
  /** Down payment on the home.  Only applicable to purchase loans. */
  downPayment?: InputMaybe<Scalars['Int']['input']>;
  /** Employment type */
  employmentType?: InputMaybe<MortgageEmploymentTypeEnum>;
  /** Should we match FHA loans? */
  fha?: InputMaybe<Scalars['Boolean']['input']>;
  /** Does the user want cashout with their refinance? */
  isCashoutRefinance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Purpose of the loan, e.g. purchase or refinance */
  loanPurpose?: InputMaybe<MortgageLoanPurposeEnum>;
  /** Offer loan_type */
  loanType?: InputMaybe<MortgagesOfferV2LoanTypeEnum>;
  /** User's current mortgage balance.  Only applicable to refinance loans */
  mortgageBalance?: InputMaybe<Scalars['Int']['input']>;
  /** Property purpose */
  propertyPurpose?: InputMaybe<MortgagePropertyPurposeEnum>;
  /** Purchase price of the home.  Only applicable to purchase loans. */
  purchasePrice?: InputMaybe<Scalars['Int']['input']>;
  /** US state abbrieviation */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Should we match VA (Veterans Affairs) loans? */
  veteran?: InputMaybe<Scalars['Boolean']['input']>;
};

export type HomeLeadMatchInput = {
  /** User's annual income */
  annualIncome?: InputMaybe<Scalars['Int']['input']>;
  /** Amount of cash-out the user wants */
  cashout?: InputMaybe<Scalars['Int']['input']>;
  /** User's credit score */
  creditScore?: InputMaybe<Scalars['Int']['input']>;
  /** Down payment on the home.  Only applicable to purchase loans. */
  downPayment?: InputMaybe<Scalars['Int']['input']>;
  /** Employment type */
  employmentType?: InputMaybe<MortgageEmploymentTypeEnum>;
  /** Does the user want cashout with their refinance? */
  isCashoutRefinance?: InputMaybe<Scalars['Boolean']['input']>;
  /** Purpose of the loan, e.g. purchase or refinance */
  loanPurpose?: InputMaybe<MortgageLoanPurposeEnum>;
  /** User's current mortgage balance.  Only applicable to refinance loans */
  mortgageBalance?: InputMaybe<Scalars['Int']['input']>;
  /** Property purpose */
  propertyPurpose?: InputMaybe<MortgagePropertyPurposeEnum>;
  /** Purchase price of the home.  Only applicable to purchase loans. */
  purchasePrice?: InputMaybe<Scalars['Int']['input']>;
  /** US state abbrieviation */
  state?: InputMaybe<Scalars['String']['input']>;
  /** Should we match VA (Veterans Affairs) loans? */
  veteran?: InputMaybe<Scalars['Boolean']['input']>;
};

export type MortgageSavedLeadMatchInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
};

export type MortgagesOfferWithRates = {
  __typename?: 'MortgagesOfferWithRates';
  placementId?: Maybe<Scalars['String']['output']>;
  marketplaceOffer?: Maybe<MortgagesOfferV2>;
};

export enum NerdUpCreditCardApplicationStatus {
  /** User has been approved for the card */
  Approved = 'APPROVED',
  /** An application has been created */
  Created = 'CREATED',
  /** User has not applied */
  NoStatus = 'NO_STATUS',
  /** User's application has been submitted */
  Pending = 'PENDING',
  /** User applied, but has been rejected */
  Rejected = 'REJECTED',
  /** Application has failed or timed out and needs to be resubmitted */
  ResubmitRequired = 'RESUBMIT_REQUIRED'
}

export enum NerdUpCreditCardStatus {
  /** User has an active NerdUp credit card */
  Active = 'ACTIVE',
  /** User has closed the card */
  Closed = 'CLOSED',
  /** User has not applied */
  Inactive = 'INACTIVE',
  /** User does not have the card */
  NoStatus = 'NO_STATUS',
  /** User's application has been submitted */
  Reissue = 'REISSUE'
}

export type NerdUpCreditCardData = {
  __typename?: 'NerdUpCreditCardData';
  /** Current status of the user's credit card application */
  applicationStatus: NerdUpCreditCardApplicationStatus;
  /** Current status of the user's credit card, if available */
  cardStatus?: Maybe<NerdUpCreditCardStatus>;
};

/** The user’s latest statement information */
export type LatestStatementData = {
  __typename?: 'LatestStatementData';
  /** Credit Account's statement start date */
  statementStartDate: Scalars['String']['output'];
  /** Credit Account's statement end date */
  statementEndDate: Scalars['String']['output'];
  /** Credit Account's statement balance */
  statementBalance: Scalars['Float']['output'];
};

/** Information on the user's Credit Account */
export type CreditAccountData = {
  __typename?: 'CreditAccountData';
  /** The amount the user has spent on the card so far in dollars */
  spentAmount: Scalars['Float']['output'];
  /** The limit of spend on the card AKA the amount deposited in the security deposit */
  limit: Scalars['Float']['output'];
  /** The user’s next payment amount */
  previousStatementBalance: Scalars['Float']['output'];
  /** The user’s latest statement information */
  latestStatement: LatestStatementData;
  /** The user’s remaining payment amount */
  remainingBalance: Scalars['Float']['output'];
};

/** Information on the user's Security Deposit Account */
export type SecurityDepositAccountData = {
  __typename?: 'SecurityDepositAccountData';
  /** The user has funded the account */
  isFunded: Scalars['Boolean']['output'];
  /** The user has linked an external account */
  isExternalAccountLinked: Scalars['Boolean']['output'];
};

export type NerdUpAuthenticationResponse = {
  __typename?: 'NerdUpAuthenticationResponse';
  accessToken: Scalars['String']['output'];
  refreshToken: Scalars['String']['output'];
};

export enum PrimaryPhase {
  Application = 'application',
  Onboarding = 'onboarding',
  Engaged = 'engaged'
}

export enum SecondaryPhase {
  KycDocumentRequired = 'kyc_document_required',
  KycExpired = 'kyc_expired',
  KycFailed = 'kyc_failed',
  KycUnderReview = 'kyc_under_review',
  NotStarted = 'not_started',
  ResubmitRequired = 'resubmit_required',
  Started = 'started',
  Submitted = 'submitted',
  ExternalAccountNotLinked = 'external_account_not_linked',
  FundingFailure = 'funding_failure',
  FundingInProgress = 'funding_in_progress',
  NotFunded = 'not_funded',
  FundAvailable = 'fund_available',
  FundUnavailable = 'fund_unavailable'
}

export type UserOverallStatus = {
  __typename?: 'UserOverallStatus';
  primaryPhase: PrimaryPhase;
  secondaryPhase?: Maybe<SecondaryPhase>;
};

export type NetWorthBalancesAssetSums = {
  __typename?: 'NetWorthBalancesAssetSums';
  /**
   * The sum of all balances in checking accounts (based on each account's
   *   nw_type) for a user.
   *   Null if a user does not have any linked checking accounts.
   */
  checkingSum?: Maybe<Scalars['Float']['output']>;
  /**
   * The sum of all balances in savings accounts (based on each account's
   *   nw_type) for a user.
   *   Null if a user does not have any linked savings accounts.
   */
  savingsSum?: Maybe<Scalars['Float']['output']>;
  /**
   * The sum of all balances in investment accounts (based on each account's
   *   nw_type) for a user.
   *   Null if a user does not have any linked investment accounts.
   */
  investmentSum?: Maybe<Scalars['Float']['output']>;
  /**
   * The sum of all balances in retirement accounts (based on each account's
   *   nw_type) for a user.
   *   Null if a user does not have any linked retirement accounts.
   */
  retirementSum?: Maybe<Scalars['Float']['output']>;
  /**
   * The sum of all home asset values.
   *   Null if a user does not have any linked home assets.
   */
  homeValueSum?: Maybe<Scalars['Float']['output']>;
  /**
   * The sum of all auto asset values.
   *   Null if a user does not have any auto assets.
   */
  autoValueSum?: Maybe<Scalars['Float']['output']>;
  /**
   * The sum of all personal property asset values.
   *   Null if a user does not have any personal property assets.
   */
  personalPropertyValueSum?: Maybe<Scalars['Float']['output']>;
};

export type NetWorthBalancesDebtSums = {
  __typename?: 'NetWorthBalancesDebtSums';
  /**
   * The sum of all balances in loan accounts for a user.
   *   Null if a user does not have any linked loan accounts.
   */
  loanSum?: Maybe<Scalars['Float']['output']>;
  /**
   * The sum of all balances in credit card accounts for a user.
   *   Null if a user does not have any linked credit card accounts.
   */
  creditCardSum?: Maybe<Scalars['Float']['output']>;
  /**
   * The updated loan sum, excluding mortgage accounts.
   *   Null if a user does not have any linked non-mortgage loan accounts.
   */
  nonMortgageLoanSum?: Maybe<Scalars['Float']['output']>;
  /**
   * The sum of all balances in mortgage accounts for a user.
   *   Null if a user does not have any linked mortgage accounts.
   */
  mortgageSum?: Maybe<Scalars['Float']['output']>;
};

export type NetWorthBalances = {
  __typename?: 'NetWorthBalances';
  /**
   * The sum of all balances in asset accounts (checking, savings, investment, retirement)
   *   (based on the account's nw_type) for a user. This sum excludes the sum of the user's
   *   home assets.
   *   Null if a user does not have any linked asset accounts.
   */
  totalAssets?: Maybe<Scalars['Float']['output']>;
  /**
   * The updated sum of all total monetary assets as well as home asset values.
   *   Null if a user does not have any linked asset accounts nor home assets.
   */
  totalAssetsIncludingHomeValues?: Maybe<Scalars['Float']['output']>;
  /**
   * The sum of all balances in debt accounts (loans, credit cards) (based on the account's
   *   nw_type) for a user. This sum includes the sum of the user's mortgage account balances.
   *   Null if a user does not have any linked debt accounts.
   */
  totalDebts?: Maybe<Scalars['Float']['output']>;
  /**
   * The updated sum of all total debts, subtracting the balances of mortgage accounts. This is
   *   for the product scenario where we want to display mortgages alongside their associated home
   *   values, while still showing non-mortgage debts elsewhere.
   *   Null if a user does not have any linked non-mortgage debt accounts.
   */
  totalDebtsExcludingMortgages?: Maybe<Scalars['Float']['output']>;
  /**
   * The total value of homes subtract mortgage debts.
   *   Null if a user does not have any home assets nor linked mortgage accounts.
   */
  totalHomeEquity?: Maybe<Scalars['Float']['output']>;
  /**
   * Defined as totalAssets - totalDebts. This does not include the value of the user's home
   *   equity.
   *   Null if a user does not have any linked accounts.
   */
  totalNetWorth?: Maybe<Scalars['Float']['output']>;
  /**
   * The updated net worth value, which includes home asset values.
   *   Null if a user does not have any linked accounts nor homes.
   */
  totalNetWorthIncludingHomeEquity?: Maybe<Scalars['Float']['output']>;
  /** An object containing the sums of balances in each asset account type */
  assetSums: NetWorthBalancesAssetSums;
  /** An object containing the sums of balances in each debt account type */
  debtSums: NetWorthBalancesDebtSums;
};

export enum NetWorthContributionType {
  Contribution = 'CONTRIBUTION',
  Deposit = 'DEPOSIT',
  Invalid = 'INVALID',
  Rebalance = 'REBALANCE'
}

export enum NetWorthContributionStatus {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export enum NetWorthContributionFinancialAccountType {
  Checking = 'CHECKING',
  Investment = 'INVESTMENT',
  Retirement = 'RETIREMENT',
  Savings = 'SAVINGS'
}

export type NetWorthContributionFinancialAccount = {
  __typename?: 'NetWorthContributionFinancialAccount';
  financialAccountId?: Maybe<Scalars['ID']['output']>;
  financialAccount?: Maybe<FinancialAccount>;
  financialAccountLastFour?: Maybe<Scalars['String']['output']>;
  financialAccountName?: Maybe<Scalars['String']['output']>;
  financialAccountTransactionDate?: Maybe<Scalars['Date']['output']>;
  financialAccountTransactionId?: Maybe<Scalars['ID']['output']>;
  financialAccountType?: Maybe<NetWorthContributionFinancialAccountType>;
};

export type NetWorthContribution = {
  __typename?: 'NetWorthContribution';
  amount: Scalars['Float']['output'];
  contributionId: Scalars['ID']['output'];
  date: Scalars['Date']['output'];
  destinationFinancialAccountData?: Maybe<NetWorthContributionFinancialAccount>;
  sourceFinancialAccountData?: Maybe<NetWorthContributionFinancialAccount>;
  status?: Maybe<NetWorthContributionStatus>;
  transferId?: Maybe<Scalars['ID']['output']>;
  type?: Maybe<NetWorthContributionType>;
};

export type NetWorthContributionSummary = {
  __typename?: 'NetWorthContributionSummary';
  completedContributionSum?: Maybe<Scalars['Float']['output']>;
  contributions: Array<NetWorthContribution>;
  date?: Maybe<Scalars['Date']['output']>;
  month?: Maybe<Scalars['String']['output']>;
  pendingContributionSum?: Maybe<Scalars['Float']['output']>;
  totalContributionSum?: Maybe<Scalars['Float']['output']>;
};

export type NetWorthContributionSummaries = {
  __typename?: 'NetWorthContributionSummaries';
  contributionSummaries: Array<NetWorthContributionSummary>;
};

export enum NetWorthRecommendationType {
  CheckingToSavings = 'CHECKING_TO_SAVINGS',
  IntegratedAccountOpening = 'INTEGRATED_ACCOUNT_OPENING',
  LeftoverIncome = 'LEFTOVER_INCOME',
  NewDeposit = 'NEW_DEPOSIT',
  Refund = 'REFUND',
  SavingsToInvestment = 'SAVINGS_TO_INVESTMENT'
}

export enum NetWorthRecommendationStatus {
  Completed = 'COMPLETED',
  Dismissed = 'DISMISSED',
  InProgress = 'IN_PROGRESS',
  New = 'NEW'
}

export enum NetWorthRecommendationCategory {
  All = 'ALL',
  BigPictureMoves = 'BIG_PICTURE_MOVES',
  Iao = 'IAO',
  QuickWins = 'QUICK_WINS'
}

export type NetWorthRecommendationsFilterInput = {
  category: NetWorthRecommendationCategory;
};

export type NetWorthRecommendation = {
  __typename?: 'NetWorthRecommendation';
  completedAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt: Scalars['DateTime']['output'];
  details?: Maybe<Scalars['JSON']['output']>;
  id: Scalars['ID']['output'];
  identityId: Scalars['ID']['output'];
  secureDetails?: Maybe<Scalars['JSON']['output']>;
  status: NetWorthRecommendationStatus;
  type: NetWorthRecommendationType;
  updatedAt: Scalars['DateTime']['output'];
  version: Scalars['Int']['output'];
};

export type WealthRecommenderUser = {
  __typename?: 'WealthRecommenderUser';
  /** User-defined amount for how much to keep in their checking account */
  checkingTargetBalance?: Maybe<Scalars['Float']['output']>;
  /** ID for wealth-recommender user */
  id: Scalars['ID']['output'];
  /**
   * Whether the user has dismissed notification about saving too much money
   *   before paying off debt
   */
  isDebtWarningDismissed: Scalars['Boolean']['output'];
  /**
   * NW-defined amount that the user should maintain in their checking account
   *   (1.5x average monthly spend)
   */
  recommendedChecking?: Maybe<Scalars['Float']['output']>;
  /**
   * NW-defined amount that the user should maintain in their savings account.
   *   (3x average monthly spend)
   */
  recommendedSavings?: Maybe<Scalars['Float']['output']>;
  /** User-defined amount for how much to keep in their savings account */
  savingsTargetBalance?: Maybe<Scalars['Float']['output']>;
};

export type NetWorthRecommendations = {
  __typename?: 'NetWorthRecommendations';
  /** @deprecated The underlying endpoint has been deprecated */
  recommendations: Array<NetWorthRecommendation>;
};

/** The data shape of an account in Wealth Recommender. This is not an exhaustive set of properties. */
export type NetWorthAccount = {
  __typename?: 'NetWorthAccount';
  id: Scalars['ID']['output'];
  /**
   * Note: Id is used here instead of a GQL relation because of the current state of how clients
   *   source and access financial accounts. In future it would be better practice to resolve the
   *   financial account along with these annotation fields in the same query.
   */
  financialAccountId: Scalars['ID']['output'];
  isHiddenFromNetWorth: Scalars['Boolean']['output'];
};

/**
 * Wraps the set of net worth accounts and leaves the schema open for the addition of metadata or
 * other supplemental data fields in the future
 */
export type NetWorthAccountsResponse = {
  __typename?: 'NetWorthAccountsResponse';
  accounts: Array<NetWorthAccount>;
};

/** Wraps the net worth account API response for flexibility in future property expansion */
export type NetWorthAccountResponse = {
  __typename?: 'NetWorthAccountResponse';
  account: NetWorthAccount;
};

/** The expected data shape of the updateNetWorthAccountVisibility mutation response */
export type UpdateNetWorthAccountVisibilityResponse = {
  __typename?: 'UpdateNetWorthAccountVisibilityResponse';
  account: NetWorthAccount;
};

/** This enum represents the set of Real Asset types that the backend, WR, currently supports. */
export enum NetWorthRealAssetTypeEnum {
  Home = 'HOME',
  Auto = 'AUTO',
  PersonalProperty = 'PERSONAL_PROPERTY'
}

export type NetWorthHomeIntegratedAddress = {
  __typename?: 'NetWorthHomeIntegratedAddress';
  addressLine1?: Maybe<Scalars['String']['output']>;
  addressLine2?: Maybe<Scalars['String']['output']>;
  city?: Maybe<Scalars['String']['output']>;
  state?: Maybe<Scalars['String']['output']>;
  zipCode?: Maybe<Scalars['String']['output']>;
};

/**
 * This enum represents the set of supported home value data source providers. Currently we only
 * support Redfin but our schemas are meant to be shaped for extensibility.
 */
export enum NetWorthHomeValueResultSourceEnum {
  Redfin = 'REDFIN'
}

export type NetWorthHomeIntegratedExternalInfo = {
  __typename?: 'NetWorthHomeIntegratedExternalInfo';
  source: NetWorthHomeValueResultSourceEnum;
  value?: Maybe<Scalars['Float']['output']>;
};

export type NetWorthHomeIntegratedAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

/**
 * These fields are the same as the fields in the NetWorthHomeValueResultResponse type. The client
 * takes these values from the search response and pipes them into the addNetWorthHomeIntegrated
 * mutation.
 */
export type NetWorthHomeIntegratedExternalInfoInput = {
  source: NetWorthHomeValueResultSourceEnum;
  propertyId?: InputMaybe<Scalars['String']['input']>;
  url?: InputMaybe<Scalars['String']['input']>;
  value: Scalars['Float']['input'];
};

/**
 * This interface will represent the amalgamation of the various asset types supported by Wealth
 * Recommender.
 */
export type NetWorthRealAsset = {
  /**
   * Real assets have been migrated from WR to FDP, so this client-facing ID now refers to the FDP
   *   account ID.
   */
  id: Scalars['ID']['output'];
  type: NetWorthRealAssetTypeEnum;
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  /** For helping the client determine if the home is self-reported or not */
  isSelfReported: Scalars['Boolean']['output'];
};

/** Wraps the Net Worth Real Asset API response, which allows for adding fields at a later date */
export type NetWorthRealAssetResponse = {
  __typename?: 'NetWorthRealAssetResponse';
  asset: NetWorthRealAsset;
};

/** Wraps the set of Net Worth Real Assets, which allows for adding fields at a later date */
export type NetWorthRealAssetsResponse = {
  __typename?: 'NetWorthRealAssetsResponse';
  assets: Array<NetWorthRealAsset>;
};

/**
 * Wraps the add Net Worth Home - Integrated API response, which allows for adding fields at a
 * later date
 */
export type AddNetWorthHomeIntegratedResponse = {
  __typename?: 'AddNetWorthHomeIntegratedResponse';
  asset: NetWorthHomeIntegrated;
};

/**
 * Wraps the add Net Worth Real asset Self-Reported API response, which allows for adding fields at a
 * later date
 */
export type AddNetWorthRealAssetSelfReportedResponse = {
  __typename?: 'AddNetWorthRealAssetSelfReportedResponse';
  asset: NetWorthRealAssetSelfReported;
};

/**
 * Wraps the edit Net Worth Real Asset Self-Reported API response, which allows for adding fields at a
 * later date
 */
export type EditNetWorthRealAssetSelfReportedResponse = {
  __typename?: 'EditNetWorthRealAssetSelfReportedResponse';
  asset: NetWorthRealAssetSelfReported;
};

/** Wraps the update net worth real API response, which allows for adding fields at a later date */
export type UpdateNetWorthRealAssetResponse = {
  __typename?: 'UpdateNetWorthRealAssetResponse';
  asset: NetWorthRealAsset;
};

/** Wraps the delete net worth real API response, which allows for adding fields at a later date */
export type DeleteNetWorthRealAssetResponse = {
  __typename?: 'DeleteNetWorthRealAssetResponse';
  success: Scalars['Boolean']['output'];
};

export type NetWorthHomeValueResultAddressInput = {
  addressLine1: Scalars['String']['input'];
  addressLine2?: InputMaybe<Scalars['String']['input']>;
  city: Scalars['String']['input'];
  state: Scalars['String']['input'];
  zipCode: Scalars['String']['input'];
};

export type NetWorthHomeValueResultResponseAddress = {
  __typename?: 'NetWorthHomeValueResultResponseAddress';
  addressLine1: Scalars['String']['output'];
  addressLine2?: Maybe<Scalars['String']['output']>;
  city: Scalars['String']['output'];
  state: Scalars['String']['output'];
  zipCode: Scalars['String']['output'];
};

/** The two types of results that may return from an address search */
export enum NetWorthHomeValueResultTypeEnum {
  /** Denotes that an exact home value match has been found based on the provided address */
  Result = 'RESULT',
  /**
   * Denotes that one or more low-confidence possible results have been found based on the
   *   provided address
   */
  Possibility = 'POSSIBILITY'
}

export type NetWorthHomeValueResultResponseDataInterface = {
  type: NetWorthHomeValueResultTypeEnum;
};

/**
 * The set of canonicalized error types that WR handles.
 * FIXME: this violates enum best practices by having lowercase values
 */
export enum NetWorthHomeValueResultResponseErrorTypeEnum {
  /** These enums represent error types that return from WR */
  HomeSourceApiRetryError = 'HomeSourceApiRetryError',
  HomeSourceApiInputError = 'HomeSourceApiInputError',
  HomeSourceApiNoResultError = 'HomeSourceApiNoResultError',
  HomeSourceApiFatalError = 'HomeSourceApiFatalError',
  InvalidInputError = 'InvalidInputError',
  HomeSourceApiServiceError = 'HomeSourceApiServiceError',
  HomeAlreadyExistsError = 'HomeAlreadyExistsError',
  /**
   * This is an error that is created within the resolver based on more specific error fields.
   *   In the future if we support the ability to present users with ambiguous address options,
   *   we should get rid of this error.
   */
  HomeSourceApiMultipleResultsError = 'HomeSourceApiMultipleResultsError'
}

/**
 * The representation of the error data that the client will need in order to make UX decisions.
 * Currently only contains the error type.
 */
export type NetWorthHomeValueResultResponseError = {
  __typename?: 'NetWorthHomeValueResultResponseError';
  errorType: NetWorthHomeValueResultResponseErrorTypeEnum;
};

export type NetWorthHomeValueResultByPropertyIdResponseData = {
  __typename?: 'NetWorthHomeValueResultByPropertyIdResponseData';
  /**
   * This field denotes which data provider is associated with the search result that is returned
   *   to the client. This is a no-cost schema addition that grants us flexibility for a future
   *   where we may have multiple providers with different prioritizations (e.g. Zillow search
   *   result over Redfin).
   */
  source: NetWorthHomeValueResultSourceEnum;
  /**
   * The source provider's ID for the given home value. This is used by WR to request updated
   *   home values for snapshotting.
   */
  propertyId: Scalars['String']['output'];
  /** The value of the home related to the provided address. */
  value: Scalars['Float']['output'];
};

export type NetWorthHomeValueResultResponse = {
  __typename?: 'NetWorthHomeValueResultResponse';
  /**
   * The response from the search data source is actually an array of results, but for the current
   *   iteration of our clients we only support 1 set of search results. This schema represents the
   *   highest priority search result from the array.
   */
  data?: Maybe<NetWorthHomeValueResultResponseData>;
  /**
   * The response in the scenario where the WR search API returns a canonicalized error type that
   *   is to be handled gracefully. It contains the error data that the client needs in order to
   *   make UX decisions.
   */
  error?: Maybe<NetWorthHomeValueResultResponseError>;
};

export type NetWorthHomeValueResultWithPossibilitiesResponse = {
  __typename?: 'NetWorthHomeValueResultWithPossibilitiesResponse';
  data?: Maybe<NetWorthHomeValueResultResponseDataInterface>;
  /**
   * The response in the scenario where the WR search API returns a canonicalized error type that
   *   is to be handled gracefully. It contains the error data that the client needs in order to
   *   make UX decisions.
   */
  error?: Maybe<NetWorthHomeValueResultResponseError>;
};

export type NetWorthHomeValueResultByPropertyIdResponse = {
  __typename?: 'NetWorthHomeValueResultByPropertyIdResponse';
  /**
   * The data shape for this query will not return "type", "address", nor "url" unlike the other
   *   queries that POST to the same data source endpoint. This is because Redfin's API doesn't
   *   return these fields when querying by "property_id".
   */
  data: NetWorthHomeValueResultByPropertyIdResponseData;
};

export enum NetWorthHistoryFiltersEnum {
  Total = 'TOTAL',
  Cash = 'CASH',
  Investments = 'INVESTMENTS',
  Property = 'PROPERTY',
  CreditCards = 'CREDIT_CARDS',
  Loans = 'LOANS'
}

export type NetWorthHistoryDataPoint = {
  __typename?: 'NetWorthHistoryDataPoint';
  date: Scalars['Date']['output'];
  value: Scalars['Float']['output'];
};

export type NetWorthHistoryResponse = {
  __typename?: 'NetWorthHistoryResponse';
  netWorthFilter: NetWorthHistoryFiltersEnum;
  history: Array<Maybe<NetWorthHistoryDataPoint>>;
};

export type NetWorthHistorySnapshotNotificationResponse = {
  __typename?: 'NetWorthHistorySnapshotNotificationResponse';
  showSnapshotNotification: Scalars['Boolean']['output'];
};

/** Response type for a personal loans best of award winner details */
export type PersonalLoansBestOfAwardWinnerDetails = {
  __typename?: 'PersonalLoansBestOfAwardWinnerDetails';
  allWinnersLink?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
  bestForText?: Maybe<Scalars['String']['output']>;
  bestForImage?: Maybe<Scalars['String']['output']>;
  bestForImageAltText?: Maybe<Scalars['String']['output']>;
  whyOurNerdsLoveItText?: Maybe<Scalars['String']['output']>;
  methodologyLink?: Maybe<Scalars['String']['output']>;
  awardCategory?: Maybe<Scalars['String']['output']>;
  marketplaceEntity?: Maybe<PersonalLoansOfferV2>;
};

/**
 * List of all financial priorities
 * The boolean value denotes whether or not the user has selected the priority.
 */
export type FinancialPrioritiesResponse = {
  __typename?: 'FinancialPrioritiesResponse';
  id?: Maybe<Scalars['ID']['output']>;
  buildCredit?: Maybe<Scalars['Boolean']['output']>;
  buildWealth?: Maybe<Scalars['Boolean']['output']>;
  buyCar?: Maybe<Scalars['Boolean']['output']>;
  buyHome?: Maybe<Scalars['Boolean']['output']>;
  createAndFollowBudget?: Maybe<Scalars['Boolean']['output']>;
  maximizeCreditCardRewards?: Maybe<Scalars['Boolean']['output']>;
  payForHomeImprovements?: Maybe<Scalars['Boolean']['output']>;
  reduceDebt?: Maybe<Scalars['Boolean']['output']>;
  saveForCollege?: Maybe<Scalars['Boolean']['output']>;
  saveForEmergencies?: Maybe<Scalars['Boolean']['output']>;
  saveForRetirement?: Maybe<Scalars['Boolean']['output']>;
  startOrGrowBusiness?: Maybe<Scalars['Boolean']['output']>;
  travel?: Maybe<Scalars['Boolean']['output']>;
};

/** The integer value denotes how many times the user has seen the feature */
export type FinancialPrioritiesFeatureDiscoveryResponse = {
  __typename?: 'FinancialPrioritiesFeatureDiscoveryResponse';
  id?: Maybe<Scalars['ID']['output']>;
  isDismissed?: Maybe<Scalars['Boolean']['output']>;
  impressionCount?: Maybe<Scalars['Int']['output']>;
};

/** The expected payload for the updateFinancialPriorities mutation */
export type FinancialPrioritiesInput = {
  id?: InputMaybe<Scalars['ID']['input']>;
  buildCredit?: InputMaybe<Scalars['Boolean']['input']>;
  buildWealth?: InputMaybe<Scalars['Boolean']['input']>;
  buyCar?: InputMaybe<Scalars['Boolean']['input']>;
  buyHome?: InputMaybe<Scalars['Boolean']['input']>;
  createAndFollowBudget?: InputMaybe<Scalars['Boolean']['input']>;
  maximizeCreditCardRewards?: InputMaybe<Scalars['Boolean']['input']>;
  payForHomeImprovements?: InputMaybe<Scalars['Boolean']['input']>;
  reduceDebt?: InputMaybe<Scalars['Boolean']['input']>;
  saveForCollege?: InputMaybe<Scalars['Boolean']['input']>;
  saveForEmergencies?: InputMaybe<Scalars['Boolean']['input']>;
  saveForRetirement?: InputMaybe<Scalars['Boolean']['input']>;
  startOrGrowBusiness?: InputMaybe<Scalars['Boolean']['input']>;
  travel?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Generic Prequal Offer interface */
export type PrequalOffer = {
  applyLink: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  institutionLogo: Scalars['String']['output'];
  nwRating?: Maybe<Scalars['Float']['output']>;
  providerId?: Maybe<Scalars['ID']['output']>;
};

/** Prequal offers overall status types */
export enum PrequalOverallStatusTypesEnum {
  /** Results are pending */
  Pending = 'PENDING',
  /** All results are resolved (regardless of success or error) */
  Resolved = 'RESOLVED',
  /**
   * An error occurred at the overall request level
   *   If an error occurred for an individual provider, that will be reflected in status.providers
   */
  Error = 'ERROR'
}

export enum PrequalServiceIdEnum {
  PrequalService = 'PREQUAL_SERVICE',
  PersonalLoansService = 'PERSONAL_LOANS_SERVICE',
  StudentLoansService = 'STUDENT_LOANS_SERVICE',
  Homeownership = 'HOMEOWNERSHIP',
  CcPrequalService = 'CC_PREQUAL_SERVICE'
}

export type PrequalUserNameInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
};

export type PrequalUserAddressInput = {
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  streetAddress2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zipCode: Scalars['String']['input'];
};

export enum PrequalDegreeTypeEnum {
  HighSchoolDiploma = 'HIGH_SCHOOL_DIPLOMA',
  Associate = 'ASSOCIATE',
  Bachelors = 'BACHELORS',
  Masters = 'MASTERS',
  Pharmd = 'PHARMD',
  Mba = 'MBA',
  Phd = 'PHD',
  Jd = 'JD',
  Dds = 'DDS',
  Md = 'MD'
}

export enum PrequalEmploymentTypeEnum {
  FullTime = 'FULL_TIME',
  PartTime = 'PART_TIME',
  SelfEmployed = 'SELF_EMPLOYED',
  Military = 'MILITARY',
  Retired = 'RETIRED',
  Unemployed = 'UNEMPLOYED',
  Other = 'OTHER'
}

export enum PrequalResidencyOwnershipEnum {
  Rent = 'RENT',
  OwnFully = 'OWN_FULLY',
  OwnMortgage = 'OWN_MORTGAGE'
}

export enum PrequalCitizenshipStatusEnum {
  Citizen = 'CITIZEN',
  PermanentResident = 'PERMANENT_RESIDENT',
  Other = 'OTHER'
}

/** Generic Prequal Offer Status object */
export type PrequalOfferStatus = {
  __typename?: 'PrequalOfferStatus';
  /** Overall status of fetching all offers */
  overall: PrequalOverallStatusTypesEnum;
  jobIds?: Maybe<Array<Maybe<PrequalOfferJobIdStatus>>>;
};

export type PrequalOfferJobIdStatus = {
  __typename?: 'PrequalOfferJobIdStatus';
  /** Current status of job id */
  jobId: Scalars['ID']['output'];
  status: PrequalOverallStatusTypesEnum;
};

export type PrequalJob = {
  __typename?: 'PrequalJob';
  jobId: Scalars['ID']['output'];
  service: PrequalServiceIdEnum;
  path: Scalars['String']['output'];
};

export type PrequalJobInput = {
  jobId: Scalars['ID']['input'];
  service: PrequalServiceIdEnum;
  path: Scalars['String']['input'];
};

export type PrequalJobStatusResponse = {
  __typename?: 'PrequalJobStatusResponse';
  status: PrequalOfferStatus;
  totalResults: Scalars['Int']['output'];
};

/** Query variables for AutoInsurancePrequalOffers */
export type AutoInsurancePrequalOfferInput = {
  zipCode: Scalars['String']['input'];
  age?: InputMaybe<Scalars['Int']['input']>;
  creditScoreRange?: InputMaybe<QuinStreetCreditScoreRangeEnum>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']['input']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isMarried?: InputMaybe<Scalars['Boolean']['input']>;
  isVeteran?: InputMaybe<Scalars['Boolean']['input']>;
  isGoodDriver?: InputMaybe<Scalars['Boolean']['input']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']['input']>;
  contactName?: InputMaybe<PrequalUserNameInput>;
  contactAddress?: InputMaybe<PrequalUserAddressInput>;
  email?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  gender?: InputMaybe<GenderEnum>;
  requiresSr22?: InputMaybe<Scalars['Boolean']['input']>;
  licenseStatus?: InputMaybe<LicenseStatusEnum>;
  vehicles?: InputMaybe<Array<AutoInsuranceVehicleInput>>;
  vehiclesCount?: InputMaybe<Scalars['Int']['input']>;
  driversCount?: InputMaybe<Scalars['Int']['input']>;
  continuousCoverageMonths?: InputMaybe<Scalars['Int']['input']>;
  hasHadDui?: InputMaybe<Scalars['Boolean']['input']>;
  numRecentIncidents?: InputMaybe<Scalars['Int']['input']>;
  inventoryType?: InputMaybe<Scalars['String']['input']>;
  qsClickKey?: InputMaybe<Scalars['String']['input']>;
};

export type PrequalOfferDriverInfoInput = {
  age?: InputMaybe<Scalars['Int']['input']>;
  contactAddress?: InputMaybe<PrequalUserAddressInput>;
  continuousCoverageMonths?: InputMaybe<Scalars['Int']['input']>;
  creditScoreRange?: InputMaybe<QuinStreetCreditScoreRangeEnum>;
  driversCount?: InputMaybe<Scalars['Int']['input']>;
  gender?: InputMaybe<GenderEnum>;
  hasHadDui?: InputMaybe<Scalars['Boolean']['input']>;
  isVeteran?: InputMaybe<Scalars['Boolean']['input']>;
  isGoodDriver?: InputMaybe<Scalars['Boolean']['input']>;
  licenseStatus?: InputMaybe<LicenseStatusEnum>;
  numRecentIncidents?: InputMaybe<Scalars['Int']['input']>;
  requiresSr22?: InputMaybe<Scalars['Boolean']['input']>;
  vehicles?: InputMaybe<Array<AutoInsuranceVehicleInput>>;
  vehiclesCount?: InputMaybe<Scalars['Int']['input']>;
};

/** Format of response to autoInsurancePrequalOffers query */
export type AutoInsurancePrequalOffersResponse = {
  __typename?: 'autoInsurancePrequalOffersResponse';
  status?: Maybe<PrequalOfferStatus>;
  offers?: Maybe<Array<Maybe<AutoInsurancePrequalOffer>>>;
};

/** Particular prequal job with it's offers populated */
export type AutoInsuranceJobWithOffers = {
  __typename?: 'AutoInsuranceJobWithOffers';
  status?: Maybe<PrequalOfferStatus>;
  offers?: Maybe<Array<InsuranceOfferV2>>;
  job?: Maybe<PrequalJob>;
};

/** Format of response to autoInsurancePrequalOffers (v2) offers */
export type AutoInsurancePrequalOffersResponseV2 = {
  __typename?: 'AutoInsurancePrequalOffersResponseV2';
  jobs?: Maybe<Array<AutoInsuranceJobWithOffers>>;
};

/** Format of response to autoInsurancePrequalOffers (v2) query */
export type AutoInsurancePrequalOffersJobResponse = {
  __typename?: 'AutoInsurancePrequalOffersJobResponse';
  status?: Maybe<PrequalOfferStatus>;
  jobs?: Maybe<Array<PrequalJob>>;
};

/** Enum of providerIds that are accepted by the auto insurance offers route */
export enum AutoInsuranceProviderId {
  Mock = 'MOCK',
  Quinstreet = 'QUINSTREET'
}

/** This creates the schema for a singular credit card/offer and refers to the response JSON. */
export type CreditCardPrequalOffer = {
  __typename?: 'CreditCardPrequalOffer';
  /** Issuer card identifier */
  sourceCode: Scalars['String']['output'];
  /** The card's image details */
  cardImageDetails: CardImageDetails;
  /** Indicates if prescreen or prequal offer */
  isPrescreen: Scalars['Boolean']['output'];
  /** Apply now URL */
  applyNowUrl: Scalars['URL']['output'];
  /** Marketing bullets are used for bonus offer and additional info */
  marketingBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Purchase APR */
  purchaseRegularApr?: Maybe<Scalars['String']['output']>;
  /** Balance transfer APR */
  balanceTransferRegApr?: Maybe<Scalars['String']['output']>;
  /** Purchase introduction APR */
  purchaseIntroductionApr?: Maybe<Scalars['String']['output']>;
  /** Balance transfer intro APR */
  balanceTransferIntroApr?: Maybe<Scalars['String']['output']>;
  /**
   * cc-prequal-service receives a lot of the necessary fields from marketplace, which is passed
   *   into the CreditCardOffer type. The remaining fields above are from the actual cc-prequal-service
   */
  creditCardOffer: CreditCardOffer;
};

export type CardImageDetails = {
  __typename?: 'CardImageDetails';
  /** Determines if the card image is a portrait or not */
  isPortrait: Scalars['Boolean']['output'];
  /** Card image sources from small to large */
  source: Scalars['String']['output'];
  sourceMedium: Scalars['String']['output'];
  sourceLarge?: Maybe<Scalars['String']['output']>;
};

export type CreditCardPrequalOffersResponse = {
  __typename?: 'CreditCardPrequalOffersResponse';
  /** In order to have working apply now links, we need to set the X-PREQUAL-COOKIE-ID cookie */
  prequalCookieId: Scalars['String']['output'];
  offers?: Maybe<Array<CreditCardPrequalOffer>>;
};

/** Enums for issuers. */
export enum CreditCardPrequalIssuersEnum {
  Chase = 'CHASE',
  CapitalOne = 'CAPITAL_ONE',
  AmericanExpress = 'AMERICAN_EXPRESS'
}

/**
 * Since there are overlapping fields across the cc-prequal and personal-loans-prequal
 * services, the inputs are split into 3 different parts for better code reusability.
 */
export type CreditCardPrequalInput = {
  firstName?: InputMaybe<Scalars['String']['input']>;
  middleInitial?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  streetAddress?: InputMaybe<Scalars['String']['input']>;
  streetAddressLine2?: InputMaybe<Scalars['String']['input']>;
  city?: InputMaybe<Scalars['String']['input']>;
  state?: InputMaybe<Scalars['String']['input']>;
  zip: Scalars['String']['input'];
  /** Last four digits of user's SSN */
  lastFour: Scalars['String']['input'];
  /** User's date of birth in MM/DD/YYYY format */
  dateOfBirth: Scalars['String']['input'];
  /** Agrees to terms of service */
  agreeToTos: Scalars['Boolean']['input'];
  /** Credit card issuers they would like to see offers from */
  issuers: Array<CreditCardPrequalIssuersEnum>;
};

/** Input for decline results offers query */
export type DeclineResultsQueryInputs = {
  loanPurpose: PersonalLoansPrequalLoanPurposeEnum;
};

/** declinePersonalLoanOffersSearch response */
export type DeclinePersonalLoanOffers = {
  __typename?: 'DeclinePersonalLoanOffers';
  /** The total number of offers map to the loan purpose. */
  total: Scalars['Int']['output'];
  /** List of marketplace entities that match the query. */
  entities?: Maybe<Array<MarketplaceEntityInterface>>;
};

/** Query variables for InsurancePrequalOffers */
export type HomeInsurancePrequalOfferInput = {
  contactName?: InputMaybe<PrequalUserNameInput>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['String']['input']>;
  inventoryType?: InputMaybe<Scalars['String']['input']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isMarried?: InputMaybe<Scalars['Boolean']['input']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
  qsClickKey?: InputMaybe<Scalars['String']['input']>;
};

/** Query variables for InsurancePrequalOffers */
export type LifeInsurancePrequalOfferInput = {
  tobaccoUse?: InputMaybe<Scalars['Boolean']['input']>;
  age?: InputMaybe<Scalars['Int']['input']>;
};

/** Particular prequal job with it's offers populated (v2) */
export type InsuranceJobWithOffers = {
  __typename?: 'InsuranceJobWithOffers';
  status?: Maybe<PrequalOfferStatus>;
  offers?: Maybe<Array<InsuranceOfferV2>>;
  job?: Maybe<PrequalJob>;
};

/** Format of response to insurancePrequalOffersJob query (v2) */
export type InsurancePrequalOffersJobResponse = {
  __typename?: 'InsurancePrequalOffersJobResponse';
  status?: Maybe<PrequalOfferStatus>;
  jobs?: Maybe<Array<PrequalJob>>;
};

/** Enum of providerIds that are accepted by the insurance offers routes */
export enum InsuranceProviderEnum {
  Mock = 'MOCK',
  Quinstreet = 'QUINSTREET'
}

/** Insurance user input that is shared among verticals */
export type PrequalOfferUserInfoInput = {
  contactName?: InputMaybe<PrequalUserNameInput>;
  /** currentInsurer is a string defined by QuinStreet that will be validated on the unified prequal service */
  currentInsurer?: InputMaybe<Scalars['String']['input']>;
  dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
  email?: InputMaybe<Scalars['EmailAddress']['input']>;
  inventoryType?: InputMaybe<Scalars['String']['input']>;
  isHomeOwner?: InputMaybe<Scalars['Boolean']['input']>;
  isMarried?: InputMaybe<Scalars['Boolean']['input']>;
  /** pricingCode is QuinStreet's way of identifying the purpose of the request */
  pricingCode?: InputMaybe<Scalars['String']['input']>;
  pricingCodeExpiration?: InputMaybe<Scalars['Date']['input']>;
  pricingCodeExpirationDateTime?: InputMaybe<Scalars['DateTime']['input']>;
  qsClickKey?: InputMaybe<Scalars['String']['input']>;
  zipCode?: InputMaybe<Scalars['String']['input']>;
};

/** Format of response to insurancePrequalOffersByJobIdResponse (v2) */
export type InsurancePrequalOffersByJobIdResponse = {
  __typename?: 'InsurancePrequalOffersByJobIdResponse';
  jobs?: Maybe<Array<InsuranceJobWithOffers>>;
};

/** Format of response to insurancePrequalOffers query (v1) */
export type InsurancePrequalOffersResponse = {
  __typename?: 'InsurancePrequalOffersResponse';
  status?: Maybe<PrequalOfferStatus>;
  offers?: Maybe<Array<InsuranceOfferV2>>;
};

/** Saved personal loans prequal offers include expanded marketplace offers, expanded marketplace static offers, and prequal offers */
export type SavedPersonalLoansPrequalOffers = {
  __typename?: 'SavedPersonalLoansPrequalOffers';
  /**
   * API offers include prequal, high interest, and conditional offers
   * @deprecated Use sortedPrequalOffers.
   */
  apiOffers: Array<PrequalPersonalLoansApiOffer>;
  /**
   * List of Best Bets offers (offers that are likely the best for the user),
   *   containing the offer with the lowest APR and the offer with the lowest monthly payment.
   * @deprecated Use the bestBets field on PrequalPersonalLoansApiOffer within sortedPrequalOffers.
   */
  bestBetsOffers?: Maybe<BestBetsOffersResponse>;
  /** Expanded marketplace offers are displayed to the user if they do not prequalify for any offers; one provider may offer multiple expanded marketplace offers */
  expandedMarketplaceOffers: Array<PersonalLoansOfferV2>;
  /** Expanded marketplace static offers are displayed to the user if they do not prequalify for any offers; one provider will only offer one static offer */
  expandedMarketplaceStaticOffers: Array<ExpandedMarketplaceStaticOffer>;
  /** Set to true if there is at least one prequalified offer the user is qualified for; this is false otherwise */
  hasPrequalifiedOffers: Scalars['Boolean']['output'];
  /** Flag indicating if the user is prequalified for personal loans offers */
  isUserPrequalified: Scalars['Boolean']['output'];
  /** List of personal loans providers */
  providers: Array<Provider>;
  /**
   * PENDING RENAME: Misnomer as sorting is not done here.
   *   A prequalified user's offers.
   */
  sortedPrequalOffers: Array<PrequalPersonalLoansApiOffer>;
  /** Personal loan amount requested by the user */
  requestedLoanAmount: Scalars['Float']['output'];
};

export type ExpandedMarketplaceStaticOffer = {
  __typename?: 'ExpandedMarketplaceStaticOffer';
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** Loan amount retrieved from the user's profile */
  loanAmount: Scalars['Float']['output'];
  /** Loan term months is hardcoded to 24 because we don't have an input asking for loan term, but we need loan term to calculate monthly payment */
  loanTermMonths: Scalars['Int']['output'];
};

export type Provider = {
  __typename?: 'Provider';
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** The number of prequal offers provided by this provider is a calculated field */
  numOffers: Scalars['Int']['output'];
};

/**
 * DEPRECATED: Should not be used outside of SavedPersonalLoansPrequalOffers.
 * Response that provides which prequal offers are "best bets" offers.
 */
export type BestBetsOffersResponse = {
  __typename?: 'BestBetsOffersResponse';
  /** Lowest APR best bets offer */
  lowestApr?: Maybe<PrequalPersonalLoansApiOffer>;
  /** Lowest monthly payment best bets offer */
  lowestMonthlyPayment?: Maybe<PrequalPersonalLoansApiOffer>;
};

/** The possible "Best Bets" categories for Personal Loans Prequal Offers. */
export enum PersonalLoansPrequalBestBets {
  LowestApr = 'LOWEST_APR',
  LowestMonthlyPayment = 'LOWEST_MONTHLY_PAYMENT'
}

/**
 * An offer that combines fields from marketplace, the prequal-service, and the
 * user's profile.  This is also referred to as a "personal loans prequal offer"
 */
export type PrequalPersonalLoansApiOffer = {
  __typename?: 'PrequalPersonalLoansApiOffer';
  /** Fields provided by marketplace */
  marketplaceOffer: PersonalLoansOfferV2;
  /** The apply link is generated based on the marketplace offer ID, the prequal ID, and the offer's redirect URL */
  applyLink: Scalars['URL']['output'];
  /** Date and time indicating when the offer was created */
  createdAt: Scalars['String']['output'];
  /** Disclaimer for the offer */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** The value of expanded marketplace category is "null" if the offer is not an expanded marketplace offer */
  expandedMarketplaceCategory?: Maybe<PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum>;
  /** Date and time indicating when the offer expires */
  expiredAt?: Maybe<Scalars['String']['output']>;
  /** Unique prequal identifier */
  id: Scalars['ID']['output'];
  /** Flag indicating whether or not this offer can be surfaced on the expanded marketplace page */
  isExpandedMarketplaceOffer: Scalars['Boolean']['output'];
  /** Flag indicating whether the APR rate is variable */
  isVariableRate: Scalars['Boolean']['output'];
  /** Offered loan amount */
  loanAmount: Scalars['Float']['output'];
  /** The loan APR is calculated as the offer's APR divided by 100 */
  loanApr: Scalars['Float']['output'];
  /** The id of the lender offering the loan */
  loanLenderId?: Maybe<Scalars['String']['output']>;
  /** The name of the lender offering the loan */
  loanLenderProvider?: Maybe<Scalars['String']['output']>;
  /** Includes principal loan balance and interest each month over the life of the loan */
  loanMonthlyPayment: Scalars['Float']['output'];
  /** The offer level NW star rating for the personal loan offer */
  loanStarRating?: Maybe<Scalars['Float']['output']>;
  /** The offer's origination fee */
  loanTotalFees: Scalars['Float']['output'];
  /** Total interest on the loan */
  loanTotalInterest: Scalars['Float']['output'];
  /** Length of time it will take for the user to pay off the loan in months */
  loanTermMonths: Scalars['Int']['output'];
  /** The number of days remaining before the offer expires */
  numberOfDaysBeforeOfferExpiration?: Maybe<Scalars['Int']['output']>;
  /** The drivers for the prequal offer in non structured content format */
  rawDrivers: Array<RawDriver>;
  /** Type of residency ownership */
  residencyOwnership: PrequalResidencyOwnershipEnum;
  /** The "best bets" categories for which the offer is eligible. */
  bestBets?: Maybe<Array<PersonalLoansPrequalBestBets>>;
};

export enum PersonalLoansPrequalLoanPurposeEnum {
  ConsolidateDebt = 'CONSOLIDATE_DEBT',
  RefinanceCreditCard = 'REFINANCE_CREDIT_CARD',
  Vacation = 'VACATION',
  Business = 'BUSINESS',
  Moving = 'MOVING',
  HomeImprovement = 'HOME_IMPROVEMENT',
  EmergencyExpense = 'EMERGENCY_EXPENSE',
  Other = 'OTHER'
}

/** Provider IDs */
export enum PersonalLoansPrequalProviderIdEnum {
  Avant = 'AVANT',
  Bestegg = 'BESTEGG',
  Discover = 'DISCOVER',
  Freedomplus = 'FREEDOMPLUS',
  Goldmansachs = 'GOLDMANSACHS',
  Lendingclub = 'LENDINGCLUB',
  Lendingpoint = 'LENDINGPOINT',
  Lightstream = 'LIGHTSTREAM',
  Onemain = 'ONEMAIN',
  Opploans = 'OPPLOANS',
  Payoff = 'PAYOFF',
  Penfed = 'PENFED',
  Prosper = 'PROSPER',
  Sofi = 'SOFI',
  Universalcredit = 'UNIVERSALCREDIT',
  Upgrade = 'UPGRADE',
  Upstart = 'UPSTART'
}

/** Input from the personal loans prequal interface to be sent to providers */
export type PersonalLoansPrequalOfferInput = {
  loanPurpose: PersonalLoansPrequalLoanPurposeEnum;
  loanAmount: Scalars['Int']['input'];
  degreeType?: InputMaybe<PrequalDegreeTypeEnum>;
  annualIncome: Scalars['Int']['input'];
  employmentType: PrequalEmploymentTypeEnum;
  residencyOwnership: PrequalResidencyOwnershipEnum;
  creditScoreRange: TuVantageScore3Buckets;
  name: PrequalUserNameInput;
  ssn: Scalars['String']['input'];
  dateOfBirth: Scalars['Date']['input'];
  email: Scalars['EmailAddress']['input'];
  address: PrequalUserAddressInput;
  loggerMetadata?: InputMaybe<Scalars['JSON']['input']>;
  citizenshipStatus?: InputMaybe<PrequalCitizenshipStatusEnum>;
  hasCoApplicant?: InputMaybe<Scalars['Boolean']['input']>;
  coApplicantIncome?: InputMaybe<Scalars['Int']['input']>;
  discoverAB?: InputMaybe<Scalars['Boolean']['input']>;
};

export enum ProjectTedFormStatusEnum {
  Error = 'ERROR',
  Success = 'SUCCESS'
}

/** The persisted set of answers that the user submitted in the User reseach flow for project ted. */
export type ProjectTedFormResponse = {
  __typename?: 'ProjectTedFormResponse';
  formStatus?: Maybe<ProjectTedFormStatusEnum>;
};

/** Recently viewed posts by a particular user */
export type RecentlyViewed = {
  __typename?: 'RecentlyViewed';
  /** Date of last visit to the post by the user */
  dateLastVisited: Scalars['Date']['output'];
  /** Amount of times the post has been visited by the user */
  numberOfVisits: Scalars['Int']['output'];
  /** Url path to the page */
  urlPath: Scalars['String']['output'];
  /**
   * WP post data
   * @deprecated post contains neither title nor synopsis, which are the relevant values
   */
  post?: Maybe<PostInterface>;
  /** WP ID for this page */
  id?: Maybe<Scalars['Int']['output']>;
  /** URL link of the resource */
  link?: Maybe<Scalars['URL']['output']>;
  /** The WordPress post_type for the resource. */
  type?: Maybe<Scalars['String']['output']>;
  /** The one-line title of the page */
  title?: Maybe<Scalars['String']['output']>;
  /** The brief page synopsis as an HTML element */
  synopsis?: Maybe<Scalars['StructuredContentDocument']['output']>;
};

export enum RecommendationGuidanceTargetType {
  WebLink = 'WEB_LINK'
}

export type RecommendationGuidanceAction = {
  __typename?: 'RecommendationGuidanceAction';
  /**
   * Target used for the native app, most of the cases this will contain
   *   a deep link.
   */
  mobileTarget: Scalars['String']['output'];
  /** Cannonical name identifier for this action */
  name: Scalars['String']['output'];
  /**
   * Target use for web, most of the cases will contain a url to open.
   *   Also might be used as a fallback if the mobileTarget is not supported in the native app.
   */
  target: Scalars['String']['output'];
  /** Enum for the target type to be used when handling the action targets. */
  targetType: RecommendationGuidanceTargetType;
  /** Friendly text displayed to the user as a CTA. */
  text: Scalars['String']['output'];
};

export type RecommendationGuidance = {
  __typename?: 'RecommendationGuidance';
  /**
   * Contains the information needed to display a CTA and details
   *   to how to handle the action in mobile and web.
   */
  action?: Maybe<RecommendationGuidanceAction>;
  /** Suggested advice description to be shown for the particular guidance */
  advice: Scalars['String']['output'];
  /**
   * Explanation about what we know from the user data that we believe this
   *   particular guidance is surfaced to the user.
   */
  insight: Scalars['String']['output'];
  /**
   * Source of the insight used for this recommendation, mostly used for tracking.
   *   e.g. Credit Utilization, Age of Accounts.
   */
  insightSource: Scalars['String']['output'];
  /** Cannonical name identifier for the particular guidance */
  name: Scalars['String']['output'];
  /** Label used at the top of the guidance card. */
  tag?: Maybe<Scalars['String']['output']>;
};

/** Compliance mandated overrides for specific cards */
export type RewardCategoryCopyOverrides = {
  __typename?: 'RewardCategoryCopyOverrides';
  dining?: Maybe<RewardCategoryCopyOverride>;
  entertainment?: Maybe<RewardCategoryCopyOverride>;
  gas?: Maybe<RewardCategoryCopyOverride>;
  groceries?: Maybe<RewardCategoryCopyOverride>;
  shopping?: Maybe<RewardCategoryCopyOverride>;
  travel?: Maybe<RewardCategoryCopyOverride>;
};

export type RewardCategoryCopyOverride = {
  __typename?: 'RewardCategoryCopyOverride';
  categoryName?: Maybe<Scalars['String']['output']>;
  disclaimer?: Maybe<Scalars['String']['output']>;
};

/** A rewards credit card that is owned by the current user, as reported by that user. */
export type RewardsCreditCard = {
  __typename?: 'RewardsCreditCard';
  /** The Marketplace UUID for a CreditCardOffer, lifted up */
  id: Scalars['ID']['output'];
  /** The currently-active offer that pertains to the credit card *product* */
  offer: CreditCardOffer;
  /** The earning rates by category of this credit card */
  rewardCategoryRates?: Maybe<CreditCardOfferRewardCategoryRates>;
  /** Override data to display instead of default values for compliance reasons */
  categoryCopyOverrides?: Maybe<RewardCategoryCopyOverrides>;
};

export type CreditCardOfferRewardCategoryRates = {
  __typename?: 'CreditCardOfferRewardCategoryRates';
  dining: Scalars['Float']['output'];
  entertainment: Scalars['Float']['output'];
  gas: Scalars['Float']['output'];
  groceries: Scalars['Float']['output'];
  shopping: Scalars['Float']['output'];
  travel: Scalars['Float']['output'];
};

export type RewardsOffer = {
  __typename?: 'RewardsOffer';
  /** Amount, ex: '4.00%' */
  amountText?: Maybe<Scalars['String']['output']>;
  /** Description */
  description?: Maybe<Scalars['String']['output']>;
};

export type UserReportedCreditCardsResult = {
  __typename?: 'UserReportedCreditCardsResult';
  /** User self-reported list of credit cards */
  cards?: Maybe<Array<RewardsCreditCard>>;
};

export type RemoveUserReportedCreditCardResult = {
  __typename?: 'RemoveUserReportedCreditCardResult';
  /** The legacy of the removed card */
  cardId: Scalars['Int']['output'];
};

export type RewardAccountBalance = {
  __typename?: 'RewardAccountBalance';
  /** Units of the account's balance */
  units?: Maybe<RewardAccountBalanceUnit>;
  /** The balance required to reach a reward level. */
  balanceToLevel?: Maybe<Scalars['String']['output']>;
  balanceType?: Maybe<RewardAccountBalanceType>;
  balance: Scalars['Float']['output'];
  description?: Maybe<Scalars['String']['output']>;
  expiryDate?: Maybe<Scalars['Date']['output']>;
  balanceToReward?: Maybe<Scalars['String']['output']>;
};

export enum RewardAccountBalanceUnit {
  Miles = 'MILES',
  Points = 'POINTS',
  Segments = 'SEGMENTS',
  Dollars = 'DOLLARS',
  Credits = 'CREDITS'
}

export enum RewardAccountBalanceType {
  Balance = 'BALANCE',
  BalanceToLevel = 'BALANCE_TO_LEVEL',
  BalanceToReward = 'BALANCE_TO_REWARD',
  ExpiringBalance = 'EXPIRING_BALANCE',
  TotalBalance = 'TOTAL_BALANCE'
}

export type RewardAccountDataset = {
  __typename?: 'RewardAccountDataset';
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  nextUpdateScheduled?: Maybe<Scalars['DateTime']['output']>;
  lastUpdateAttempt?: Maybe<Scalars['DateTime']['output']>;
};

/** The status a reward account can be in */
export enum RewardAccountStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE',
  ToBeClosed = 'TO_BE_CLOSED',
  Closed = 'CLOSED'
}

/** The reward data connected to an account */
export type RewardAccount = {
  __typename?: 'RewardAccount';
  id: Scalars['ID']['output'];
  providerName: Scalars['String']['output'];
  accountNumber?: Maybe<Scalars['String']['output']>;
  providerId: Scalars['ID']['output'];
  accountStatus: RewardAccountStatus;
  providerAccountId: Scalars['ID']['output'];
  lastUpdated?: Maybe<Scalars['DateTime']['output']>;
  createdDate?: Maybe<Scalars['DateTime']['output']>;
  rewardBalance?: Maybe<Array<RewardAccountBalance>>;
  dataset?: Maybe<Array<RewardAccountDataset>>;
};

export type UserReportedCreditCardInput = {
  cardId: Scalars['Int']['input'];
  cardName: Scalars['String']['input'];
};

export type RewardsMutationSuccessResponse = {
  __typename?: 'RewardsMutationSuccessResponse';
  success: Scalars['Boolean']['output'];
};

/** The expected response for one piece of saved content */
export type SavedContentResponse = {
  __typename?: 'SavedContentResponse';
  /** Date the entity was saved */
  savedAt: Scalars['DateTime']['output'];
  /** WP content ID */
  entityId: Scalars['Int']['output'];
  /** WP type, i.e - ARTICLE */
  entityType: Scalars['String']['output'];
  /** Unique id for the saved entity */
  id: Scalars['ID']['output'];
  /** WP Content for the saved entity */
  content?: Maybe<PostInterface>;
};

/** Facets are metadata about the search results, particularly a list of results grouped by category and content type */
export type Facets = {
  __typename?: 'Facets';
  /** The name of the category */
  category?: Maybe<Array<FacetCategory>>;
  /** The content-type */
  contentType?: Maybe<Array<FacetContentType>>;
};

/** FacetCategory represents the category name, the number of matched WP entites, and whether it was selected */
export type FacetCategory = {
  __typename?: 'FacetCategory';
  value: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
};

/** FacetContentType represents more about the WP entities returned by the search */
export type FacetContentType = {
  __typename?: 'FacetContentType';
  value: Scalars['String']['output'];
  count: Scalars['Int']['output'];
  selected: Scalars['Boolean']['output'];
};

export type SearchServiceContentSearchResults = {
  __typename?: 'SearchServiceContentSearchResults';
  /** The facets from the search result, see 'Facets' */
  facets?: Maybe<Facets>;
  /** A list of related content given the parameters of ContentSearchInput */
  searchResults?: Maybe<Array<PostInterface>>;
  /** The current offset in results */
  offset?: Maybe<Scalars['Int']['output']>;
  /** The total number of related content */
  total: Scalars['Int']['output'];
};


export type SearchServiceContentSearchResultsSearchResultsArgs = {
  sortDir?: InputMaybe<ContentSortDirection>;
};

export type ContentSearchInput = {
  /** A set of content categories to match against */
  categories?: InputMaybe<Array<ContentCategory>>;
  /** A flag to include highlights - a snippet of copy */
  includeHighlights?: InputMaybe<Scalars['Boolean']['input']>;
  /** A search string to find related content */
  query?: InputMaybe<Scalars['String']['input']>;
  /** A map of content attributes to relative importance in weighing search result relevancy */
  queryFieldWeights?: InputMaybe<ContentSearchQueryFieldsWeightsInput>;
  /** The "format" of the content requested */
  contentTypes?: InputMaybe<Array<ContentType>>;
  /**
   * The WP Post type is not used to build query params but is used to filter content for requested post types, post-search
   *
   *   This filters on nw_page.content_type, which maps to nw_content_type from the WP API
   *   possible values include 'article', 'roundup', 'review' (supported here)
   *   and 'calculator', 'marketplace', 'product_detail', & 'tool' (not yet supported)
   */
  postTypes?: InputMaybe<Array<PostType>>;
};

/**
 * Each available field carries a weight of 1 relative to it's counterparts. You can weigh certain attributes more than others
 * by supplying a weight. For example, a weight of 'Y' is Y times as important as another specified attribute
 */
export type ContentSearchQueryFieldsWeightsInput = {
  /** Weigh search results against author names */
  authorNames?: InputMaybe<Scalars['Int']['input']>;
  /** Weight search results against category names */
  categoryNames?: InputMaybe<Scalars['Int']['input']>;
  /** Weigh search results aginst the sanitized content */
  contentSanitized?: InputMaybe<Scalars['Int']['input']>;
  /** Weigh search results against the content type */
  contentType?: InputMaybe<Scalars['Int']['input']>;
  /** Weigh search results against the link URL */
  link?: InputMaybe<Scalars['Int']['input']>;
  /** Weigh search results against the tag names */
  tagNames?: InputMaybe<Scalars['Int']['input']>;
  /** Weigh search results against the sanitized title */
  titleSanitized?: InputMaybe<Scalars['Int']['input']>;
};

export enum ContentType {
  Article = 'ARTICLE',
  Review = 'REVIEW',
  Roundup = 'ROUNDUP'
}

export enum ContentCategory {
  Advisors = 'ADVISORS',
  AirlineCreditCards = 'AIRLINE_CREDIT_CARDS',
  AutoInsurance = 'AUTO_INSURANCE',
  AutoLoans = 'AUTO_LOANS',
  BalanceTransferCreditCards = 'BALANCE_TRANSFER_CREDIT_CARDS',
  Banking = 'BANKING',
  BankingBasics = 'BANKING_BASICS',
  BankingNews = 'BANKING_NEWS',
  BanksAndCreditUnions = 'BANKS_AND_CREDIT_UNIONS',
  BestCreditCards = 'BEST_CREDIT_CARDS',
  Bills = 'BILLS',
  BlackFriday = 'BLACK_FRIDAY',
  BlackFridayAdLeaks = 'BLACK_FRIDAY_AD_LEAKS',
  Brokers = 'BROKERS',
  BusinessCreditCards = 'BUSINESS_CREDIT_CARDS',
  Careers = 'CAREERS',
  CarInsurancEstimates = 'CAR_INSURANC_ESTIMATES',
  CashBackCreditCards = 'CASH_BACK_CREDIT_CARDS',
  Cds = 'CDS',
  CellPhones = 'CELL_PHONES',
  CheckingAccounts = 'CHECKING_ACCOUNTS',
  CollegeSavings = 'COLLEGE_SAVINGS',
  CompareCardOffers = 'COMPARE_CARD_OFFERS',
  CorporateNews = 'CORPORATE_NEWS',
  CorporateTaxRates = 'CORPORATE_TAX_RATES',
  CreditCards = 'CREDIT_CARDS',
  CreditCardBasics = 'CREDIT_CARD_BASICS',
  CreditCardData = 'CREDIT_CARD_DATA',
  CreditCardReviews = 'CREDIT_CARD_REVIEWS',
  CreditCardsAverageFairCredit = 'CREDIT_CARDS_AVERAGE_FAIR_CREDIT',
  CreditCardsBadCredit = 'CREDIT_CARDS_BAD_CREDIT',
  CreditScore = 'CREDIT_SCORE',
  DailyDeals = 'DAILY_DEALS',
  EmployeeEqutiy = 'EMPLOYEE_EQUTIY',
  EnergyGasWater = 'ENERGY_GAS_WATER',
  EnergyTaxIncentives = 'ENERGY_TAX_INCENTIVES',
  EstatePlanning = 'ESTATE_PLANNING',
  Finance = 'FINANCE',
  FinancialPlanning = 'FINANCIAL_PLANNING',
  Finanzas = 'FINANZAS',
  FindingHealthInsurance = 'FINDING_HEALTH_INSURANCE',
  FindingRightMortgage = 'FINDING_RIGHT_MORTGAGE',
  GovernmentPolicy = 'GOVERNMENT_POLICY',
  Health = 'HEALTH',
  HolidayTipsNews = 'HOLIDAY_TIPS_NEWS',
  HomeAffordability = 'HOME_AFFORDABILITY',
  Homeownership = 'HOMEOWNERSHIP',
  HomeownershipCosts = 'HOMEOWNERSHIP_COSTS',
  HomeownersInsurance = 'HOMEOWNERS_INSURANCE',
  HomeSearch = 'HOME_SEARCH',
  HowToStartABusiness = 'HOW_TO_START_A_BUSINESS',
  IncomeTaxes = 'INCOME_TAXES',
  Insurance = 'INSURANCE',
  InternetTv = 'INTERNET_TV',
  Investing = 'INVESTING',
  InvestingData = 'INVESTING_DATA',
  InvestingStrategy = 'INVESTING_STRATEGY',
  Investments = 'INVESTMENTS',
  InvestmentTaxes = 'INVESTMENT_TAXES',
  Ira = 'IRA',
  LifeInsurance = 'LIFE_INSURANCE',
  Loans = 'LOANS',
  LowInterestNoFeeCreditCards = 'LOW_INTEREST_NO_FEE_CREDIT_CARDS',
  LoyaltyPrograms = 'LOYALTY_PROGRAMS',
  MakingMoney = 'MAKING_MONEY',
  ManagingHealthInsurance = 'MANAGING_HEALTH_INSURANCE',
  ManagingMedicalBills = 'MANAGING_MEDICAL_BILLS',
  ManagingMoney = 'MANAGING_MONEY',
  ManagingYourMortgage = 'MANAGING_YOUR_MORTGAGE',
  MedicalCosts = 'MEDICAL_COSTS',
  Money = 'MONEY',
  MoneyMarketAccounts = 'MONEY_MARKET_ACCOUNTS',
  MoneyTransfer = 'MONEY_TRANSFER',
  MortgageProcess = 'MORTGAGE_PROCESS',
  MortgageRates = 'MORTGAGE_RATES',
  Mortgages = 'MORTGAGES',
  MyNerdwallet = 'MY_NERDWALLET',
  OtherRetirementAccounts = 'OTHER_RETIREMENT_ACCOUNTS',
  OtherVehicleInsurance = 'OTHER_VEHICLE_INSURANCE',
  PaydayLoans = 'PAYDAY_LOANS',
  PayingOffDebt = 'PAYING_OFF_DEBT',
  Pensions = 'PENSIONS',
  PersonalFinance = 'PERSONAL_FINANCE',
  PersonalLoans = 'PERSONAL_LOANS',
  PersonalLoansReviews = 'PERSONAL_LOANS_REVIEWS',
  PersonalTaxes = 'PERSONAL_TAXES',
  PetInsurance = 'PET_INSURANCE',
  PrepaidDebitCards = 'PREPAID_DEBIT_CARDS',
  ProductComparisons = 'PRODUCT_COMPARISONS',
  Promos = 'PROMOS',
  PropertyTaxes = 'PROPERTY_TAXES',
  RefinanceAutoLoans = 'REFINANCE_AUTO_LOANS',
  RentersInsurance = 'RENTERS_INSURANCE',
  Retirement_401K = 'RETIREMENT_401K',
  RetirementIncome = 'RETIREMENT_INCOME',
  RetirementPlanning = 'RETIREMENT_PLANNING',
  RewardOptimization = 'REWARD_OPTIMIZATION',
  RewardsCreditCards = 'REWARDS_CREDIT_CARDS',
  RothIra = 'ROTH_IRA',
  RunningYourBusiness = 'RUNNING_YOUR_BUSINESS',
  SavingsAccounts = 'SAVINGS_ACCOUNTS',
  SellingYourHome = 'SELLING_YOUR_HOME',
  Shopping = 'SHOPPING',
  ShoppingNews = 'SHOPPING_NEWS',
  ShoppingTips = 'SHOPPING_TIPS',
  SmallBusiness = 'SMALL_BUSINESS',
  SmallBusinessLegal = 'SMALL_BUSINESS_LEGAL',
  SmallBusinessLoans = 'SMALL_BUSINESS_LOANS',
  SmallBusinessTaxes = 'SMALL_BUSINESS_TAXES',
  SocialSecurity = 'SOCIAL_SECURITY',
  StartingABusiness = 'STARTING_A_BUSINESS',
  StoreSavingsGuide = 'STORE_SAVINGS_GUIDE',
  StudentCreditCards = 'STUDENT_CREDIT_CARDS',
  StudentLoans = 'STUDENT_LOANS',
  Studies = 'STUDIES',
  Taxes = 'TAXES',
  Travel = 'TRAVEL',
  TravelCreditCards = 'TRAVEL_CREDIT_CARDS',
  TravelDeals = 'TRAVEL_DEALS',
  TravelInsurance = 'TRAVEL_INSURANCE',
  Utilities = 'UTILITIES',
  VacationAndTripPlanning = 'VACATION_AND_TRIP_PLANNING'
}

export enum ContentSortDirection {
  /** Sort posts in reverse chronological order across all N search queries */
  MostRecent = 'MOST_RECENT',
  /** Sort posts in chronological order across all N search queries */
  Earliest = 'EARLIEST'
}

export enum PostType {
  Article = 'ARTICLE',
  Post = 'POST'
}

/**
 * Options accepted by the GlobalMarkupOptions component.
 * These are generally the options passed to nlOpts when configuring nw-app-module
 */
export type GlobalMarkupOptions = {
  __typename?: 'GlobalMarkupOptions';
  /** The title of the page */
  title?: Maybe<Scalars['String']['output']>;
  /** The description of the page */
  description?: Maybe<Scalars['String']['output']>;
  /** The canonical URL of the page */
  canonicalUrl?: Maybe<Scalars['String']['output']>;
  /** Page meta tags */
  dynamicMeta?: Maybe<Array<GlobalMarkupOptionsDynamicMeta>>;
  /** Taxonomy data for SEO */
  pageTaxonomy?: Maybe<GlobalMarkupOptionsPageTaxonomy>;
  /** robots commands */
  robots?: Maybe<GlobalMarkupOptionsRobots>;
  /** Facebook Open Graph tags */
  ogTags?: Maybe<GlobalMarkupOptionsOgTags>;
  /** Props to pass directly to the global nav React component */
  globalNavProps?: Maybe<GlobalMarkupOptionsGlobalNavProps>;
  /**
   * A list of hreflang links for this structured content page. This is used for SEO purposes.
   *   For more information, see https://support.google.com/webmasters/answer/189077?hl=en
   */
  hreflang?: Maybe<Array<Hreflang>>;
  /** Props to pass directly to Compass */
  compass?: Maybe<Compass>;
};

/** The overrides for the auth button in compass */
export type AuthButtonOverride = {
  __typename?: 'AuthButtonOverride';
  buttonUrl: Scalars['String']['output'];
  buttonLabelDesktop: Scalars['String']['output'];
  buttonLabelMobile?: Maybe<Scalars['String']['output']>;
  buttonStyle?: Maybe<Scalars['String']['output']>;
};

/** The overrides for the auth modal in compass */
export type AuthModalOverride = {
  __typename?: 'AuthModalOverride';
  title?: Maybe<Scalars['String']['output']>;
  body?: Maybe<Scalars['String']['output']>;
  ctaText?: Maybe<Scalars['String']['output']>;
  ctaURL?: Maybe<Scalars['String']['output']>;
  backgroundColor?: Maybe<Scalars['String']['output']>;
  modalName?: Maybe<Scalars['String']['output']>;
  dismissAfter?: Maybe<Scalars['Int']['output']>;
};

/** Props to pass to includeAuth in Compass header when passing object */
export type IncludeAuthProps = {
  __typename?: 'IncludeAuthProps';
  authButtons?: Maybe<Scalars['Boolean']['output']>;
  googleOneTap?: Maybe<Scalars['Boolean']['output']>;
  nerdwalletModals?: Maybe<Scalars['Boolean']['output']>;
};

/** Every header option for Compass */
export type CompassHeader = {
  __typename?: 'CompassHeader';
  authButtonOverride?: Maybe<AuthButtonOverride>;
  includeAuth?: Maybe<IncludeAuthProps>;
  includeSearch?: Maybe<Scalars['Boolean']['output']>;
  isHeaderSticky?: Maybe<Scalars['Boolean']['output']>;
};

export type Compass = {
  __typename?: 'Compass';
  authModalOverride?: Maybe<AuthModalOverride>;
  header?: Maybe<CompassHeader>;
};

export type GlobalMarkupOptionsGlobalNavProps = {
  __typename?: 'GlobalMarkupOptionsGlobalNavProps';
  /** Navigational breadcrumbs to display below the global header */
  breadcrumbs?: Maybe<Breadcrumb>;
  /** Whether the global footer should be disabled */
  disableFooter?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the global header should be disabled */
  disableHeader?: Maybe<Scalars['Boolean']['output']>;
};

export type GlobalMarkupOptionsPageTaxonomy = {
  __typename?: 'GlobalMarkupOptionsPageTaxonomy';
  /** Page vertical */
  attrVertical?: Maybe<Scalars['String']['output']>;
  /** Page topic */
  attrTopic?: Maybe<Scalars['String']['output']>;
  /** Primary content cluster for the page */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** Other secondary content clusters for the page */
  otherContentClusters: Array<Scalars['String']['output']>;
};

export type GlobalMarkupOptionsDynamicMeta = {
  __typename?: 'GlobalMarkupOptionsDynamicMeta';
  name: Scalars['String']['output'];
  property?: Maybe<Scalars['String']['output']>;
  content: Scalars['String']['output'];
};

export type GlobalMarkupOptionsRobots = {
  __typename?: 'GlobalMarkupOptionsRobots';
  /** Do not show this page, media, or resource in search results */
  noindex?: Maybe<Scalars['Boolean']['output']>;
  /** Do not follow the links on this page */
  nofollow?: Maybe<Scalars['Boolean']['output']>;
};

export type GlobalMarkupOptionsOgTags = {
  __typename?: 'GlobalMarkupOptionsOgTags';
  /** The title of your article without any branding such as your site name. */
  title?: Maybe<Scalars['String']['output']>;
  /** A brief description of the content. This will displayed below the title of the post on Facebook. */
  description?: Maybe<Scalars['String']['output']>;
  /** The URL of the image that should appear when someone shares the content to Facebook */
  image?: Maybe<Scalars['URL']['output']>;
  /** https:// URL for the image */
  image_secure_url?: Maybe<Scalars['URL']['output']>;
  /** Width of image in pixels */
  image_width?: Maybe<Scalars['Int']['output']>;
  /** Height of image in pixels */
  image_height?: Maybe<Scalars['Int']['output']>;
  /** The locale of the resource */
  locale?: Maybe<Scalars['String']['output']>;
  /** The type of media of your content. This tag impacts how your content shows up in News Feed. */
  type?: Maybe<Scalars['String']['output']>;
  /** The canonical URL for the page */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Data related to the top level page impression event that should be fired */
export type PageImpressionData = {
  __typename?: 'PageImpressionData';
  /** Name of the top level page impression event that should be fired */
  event: Scalars['String']['output'];
  /** Data payload to pass into the top level page impression event */
  payload?: Maybe<Scalars['JSON']['output']>;
  /** Whether or not to fire the top level page impression event */
  enabled?: Maybe<Scalars['Boolean']['output']>;
};

/** Data related to the top level page impression Segment event */
export type SegmentTrackingAttributes = {
  __typename?: 'SegmentTrackingAttributes';
  /** ID of the top level page impression event that should be fired */
  contentId?: Maybe<Scalars['String']['output']>;
  /** Name of the top level page impression event that should be fired */
  pageName?: Maybe<Scalars['String']['output']>;
  /** Data payload to pass into the top level page impression event */
  properties?: Maybe<Scalars['JSON']['output']>;
};

/** Schema data for the page, as in schema.org schema */
export type SchemaData = {
  __typename?: 'SchemaData';
  /** JSON LD schema data */
  jsonLd?: Maybe<Scalars['JSON']['output']>;
};

/** Layout information for Structured Content Client to use */
export type PageLayout = {
  __typename?: 'PageLayout';
  /** The name of the template the page is using. This will be used for analytics purposes */
  name: Scalars['String']['output'];
  /** The row config for the page layout */
  rows?: Maybe<Array<LayoutRow>>;
};

/** Type modelling the fields for a row within a page layout */
export type LayoutRow = {
  __typename?: 'LayoutRow';
  /** The name of the section in the layout. This will be used for analytics purposes */
  name: Scalars['String']['output'];
  /** Param to toggle full width or centered container */
  fullWidth?: Maybe<Scalars['Boolean']['output']>;
  /** The columns to display within the row */
  columns?: Maybe<Array<LayoutColumn>>;
};

/** Type modeling the data within a particular column in the layout */
export type LayoutColumn = {
  __typename?: 'LayoutColumn';
  /** Name of the column within the row. This will be used for analytics purposes and debugging */
  name: Scalars['String']['output'];
  /** The structured content document to render within this column */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The width properties for the column */
  width?: Maybe<LayoutColumnWidth>;
  /** How the contents within the column should be aligned vertically */
  verticalAlign?: Maybe<LayoutVerticalAlignEnum>;
};

/** Type containing the width settings for the column. */
export type LayoutColumnWidth = {
  __typename?: 'LayoutColumnWidth';
  /** The width of the column within the desktop breakpoint */
  desktop?: Maybe<Scalars['Int']['output']>;
  /** The width of the column within the mobile breakpoint */
  mobile?: Maybe<Scalars['Int']['output']>;
};

/** The vertical alignment options for a column */
export enum LayoutVerticalAlignEnum {
  Bottom = 'BOTTOM',
  Center = 'CENTER',
  Top = 'TOP'
}

/** Input Type for accepting URL params for a query */
export type UrlParamsInput = {
  key: Scalars['String']['input'];
  value?: InputMaybe<Scalars['String']['input']>;
};

/** Response type for a student loans best of award winner details */
export type StudentLoansBestOfAwardWinnerDetails = {
  __typename?: 'StudentLoansBestOfAwardWinnerDetails';
  allWinnersLink?: Maybe<Scalars['String']['output']>;
  offerId?: Maybe<Scalars['String']['output']>;
  bestForText?: Maybe<Scalars['String']['output']>;
  bestForImage?: Maybe<Scalars['String']['output']>;
  bestForImageAltText?: Maybe<Scalars['String']['output']>;
  whyOurNerdsLoveItText?: Maybe<Scalars['String']['output']>;
  methodologyLink?: Maybe<Scalars['String']['output']>;
  awardCategory?: Maybe<Scalars['String']['output']>;
  marketplaceEntity?: Maybe<EducationLoansOfferV2>;
};

export type TrueCarData = {
  __typename?: 'TrueCarData';
  /** List of new makes */
  new?: Maybe<Array<TrueCarMake>>;
  /** List of used makes */
  used?: Maybe<Array<TrueCarMake>>;
};

export type TrueCarMake = {
  __typename?: 'TrueCarMake';
  /** Name of the make */
  name: Scalars['String']['output'];
  /** URL slug of the make */
  slug: Scalars['String']['output'];
  /** List of models for the make */
  models?: Maybe<Array<TrueCarModel>>;
};

export type TrueCarModel = {
  __typename?: 'TrueCarModel';
  /** Name of the model */
  name: Scalars['String']['output'];
  /** URL slug of the model */
  slug: Scalars['String']['output'];
  /** Year for the model */
  model_year: Scalars['Int']['output'];
};

/** This type represents the error blob inside the portal_activity_occurred event. */
export type UserOpsPaoEventDetailsError = {
  __typename?: 'UserOpsPAOEventDetailsError';
  /** The error code from Plaid. */
  errorCode?: Maybe<Scalars['String']['output']>;
  /** The error message from Plaid. */
  errorMessage?: Maybe<Scalars['String']['output']>;
  /** The error type from Plaid. */
  errorType?: Maybe<Scalars['String']['output']>;
};

/** This type holds a subset of fields from the portal_activity_occurred event that is relevant for User Ops. */
export type UserOpsPaoEventDetails = {
  __typename?: 'UserOpsPAOEventDetails';
  /** The activity type that happened (such as linking_process_error). */
  activityType?: Maybe<Scalars['String']['output']>;
  /** Authentication state of the portal. */
  authState?: Maybe<FinancialPortalAuthState>;
  /** When this event occurred */
  eventOccurredAt: Scalars['DateTime']['output'];
  /** app-schemata definition: The raw error payload from FDP Proxy. */
  fdpPrimaryErrorBlob?: Maybe<UserOpsPaoEventDetailsError>;
  /** app-schemata definition: The associated Plaid event_name. */
  plaidEventName?: Maybe<Scalars['String']['output']>;
  /** app-schemata definition: Plaid's link_session_idZ. */
  plaidLinkSessionId?: Maybe<Scalars['ID']['output']>;
  /** app-schemata definition: Plaid's request_id. */
  plaidRequestId?: Maybe<Scalars['String']['output']>;
  /** ID of the portal for which this event was fired */
  portalId?: Maybe<Scalars['ID']['output']>;
  /**
   * app-schemata definition: The identifier of the institution as defined in the underlying source,
   *   i.e. plaid_id or yodlee_id.
   */
  sourceInstitutionId?: Maybe<Scalars['String']['output']>;
};

/** This type holds the individual subscription preference selections. */
export type UserOpsCommsSubscriptionPreferences = {
  __typename?: 'UserOpsCommsSubscriptionPreferences';
  /** Is the emailCreditMonitoringEnabled message type enabled */
  emailCreditMonitoringEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the email channel enabled */
  emailEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the emailMarketingEnabled message type enabled */
  emailMarketingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the emailPersonalizedContentEnabled message type enabled */
  emailPersonalizedContentEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the emailSpendingAlertsEnabled message type enabled */
  emailSpendingAlertsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the emailTransactionalMarketingEnabled message type enabled */
  emailTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the Notification Center channel enabled */
  notificationCenterEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the notificationCenterCreditMonitoringEnabled message type enabled */
  notificationCenterCreditMonitoringEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the notificationCenterSpendingAlertsEnabled message type enabled */
  notificationCenterSpendingAlertsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the notificationCenterMarketingEnabled message type enabled */
  notificationCenterMarketingEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the notificationCenterPersonalizedContentEnabled message type enabled */
  notificationCenterPersonalizedContentEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the push channel enabled */
  pushEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the pushCreditMonitoringEnabled message type enabled */
  pushCreditMonitoringEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the pushMarketingUpdatesEnabled message type enabled */
  pushMarketingUpdatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the pushPersonalizedContentEnabled message type enabled */
  pushPersonalizedContentEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the pushSpendingAlertsEnabled message type enabled */
  pushSpendingAlertsEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Is the pushTransactionalMarketingEnabled message type enabled */
  pushTransactionalMarketingEnabled?: Maybe<Scalars['Boolean']['output']>;
};

/** This type holds the individual financial priorities as presented by UDP. */
export type UdpFinancialPriorities = {
  __typename?: 'UDPFinancialPriorities';
  /** The event id */
  id: Scalars['ID']['output'];
  /** The associated identity id */
  identityId: Scalars['ID']['output'];
  /** The snake_case name of the financial priority */
  financialPriority: Scalars['String']['output'];
  /** The ISO timestamp of when the financial priority was created */
  createdAt: Scalars['DateTime']['output'];
};

/** This type holds the individual financial priorities selections as presented by userops-service */
export type UserOpsFinancialPriorities = {
  __typename?: 'UserOpsFinancialPriorities';
  /** Event ID associated with this snapshot of subscription preferences. Useful for looking up in Snowflake. */
  eventId?: Maybe<Scalars['ID']['output']>;
  /** Timestamp associated with this snapshot of subscription preferences. */
  timestamp?: Maybe<Scalars['DateTime']['output']>;
  /** A list of financial priorities selected by the user */
  financialPriorities: Array<Scalars['String']['output']>;
};

/** This type wraps the users subscription preferences and also includes metadata about the preferences. */
export type UserOpsCommsSubscriptionPreferencesWrapper = {
  __typename?: 'UserOpsCommsSubscriptionPreferencesWrapper';
  /** Event ID associated with this snapshot of subscription preferences. Useful for looking up in Snowflake. */
  eventId: Scalars['ID']['output'];
  /** Timestamp associated with this snapshot of subscription preferences. */
  timestamp: Scalars['DateTime']['output'];
  /** List of subscription preferences sorted in descending order. */
  subscriptionPreferences: UserOpsCommsSubscriptionPreferences;
};

/** The shape of each messaging activity event */
export type UserOpsMessagingActivityEvent = {
  __typename?: 'UserOpsMessagingActivityEvent';
  /** Action that the user took on this message, could be opened, delivered, bounced, or spam report */
  action: Scalars['String']['output'];
  /** Blueshift campaign uuid associated with this message */
  campaignUuid: Scalars['ID']['output'];
  /** Either push-message or email, cannot use enum because of hyphen */
  channel: Scalars['String']['output'];
  /** Event ID associated with this messaging event, useful for Snowflake lookup */
  eventId: Scalars['ID']['output'];
  /** Subject line of the message if applicable */
  subjectLine?: Maybe<Scalars['String']['output']>;
  /** Timestamp associated with this messaging event. */
  timestamp: Scalars['DateTime']['output'];
};

export type UserWalletCard = {
  __typename?: 'UserWalletCard';
  /** The ID of the user's wallet card in the my cards service */
  id: Scalars['ID']['output'];
  /** The credit card offer associated with the user's wallet card */
  offer?: Maybe<CreditCardsOfferV2>;
  /** The FDP financial account associated with the user's wallet card */
  financialAccount?: Maybe<FinancialAccount>;
};

export type UserWalletCardsResponse = {
  __typename?: 'UserWalletCardsResponse';
  cards: Array<Maybe<UserWalletCard>>;
};

export type AddUserWalletCardInput = {
  /** The ID of the marketplace offer to associate with the user's wallet card */
  marketplaceOfferId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the financial account to associate with the user's wallet card */
  financialAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type UpdateUserWalletCardInput = {
  /** The ID of the existing user's wallet card in the my cards service */
  userWalletCardId: Scalars['ID']['input'];
  /** The ID of the marketplace offer to associate with the user's wallet card */
  marketplaceOfferId?: InputMaybe<Scalars['ID']['input']>;
  /** The ID of the financial account to associate with the user's wallet card */
  financialAccountId?: InputMaybe<Scalars['ID']['input']>;
};

export type AddUserWalletCardResponse = {
  __typename?: 'AddUserWalletCardResponse';
  card: UserWalletCard;
};

export type UpdateUserWalletCardResponse = {
  __typename?: 'UpdateUserWalletCardResponse';
  card: UserWalletCard;
};

export type RemoveUserWalletCardResponse = {
  __typename?: 'RemoveUserWalletCardResponse';
  success: Scalars['Boolean']['output'];
};

/** The WordPress author type. */
export type Author = {
  __typename?: 'Author';
  /** An organization the author is affiliated with. */
  affiliation?: Maybe<Scalars['String']['output']>;
  /** The author's alma mater. */
  alumniOf?: Maybe<Scalars['String']['output']>;
  /** The articles published by this author. */
  articles?: Maybe<ArticleConnectionResponse>;
  /** The full media object to use for the user's avatar image. */
  avatar?: Maybe<MediaItem>;
  /** URLs to various avatar sizes. */
  avatarUrls?: Maybe<Array<AuthorAvatarUrl>>;
  /** An award the author has won. */
  award?: Maybe<Scalars['String']['output']>;
  /** The email address to use to contact the author. */
  contactEmail?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the Author as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** Description for the author. */
  description?: Maybe<Scalars['String']['output']>;
  /** The author's education history. */
  education?: Maybe<Scalars['String']['output']>;
  /** Email address for the author. */
  email?: Maybe<Scalars['String']['output']>;
  /** The author's previous experience. */
  experience?: Maybe<Scalars['String']['output']>;
  /** Facebook URL for the author. */
  facebook?: Maybe<Scalars['URL']['output']>;
  /** A collection of publications, organizations, etc. where the author has been featured in. */
  featuredIn?: Maybe<Array<AuthorFeaturedIn>>;
  /** The author's honorific suffix. eg: CFP, CPA */
  honorificSuffix?: Maybe<Scalars['String']['output']>;
  /** The ID for the Author. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The author's job title. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** Full url for the author's archive page. */
  link?: Maybe<Scalars['URL']['output']>;
  /** LinkedIn URL for the author. */
  linkedin?: Maybe<Scalars['URL']['output']>;
  /** Marketplace bio for the author. */
  marketplaceBio?: Maybe<Scalars['String']['output']>;
  /** Name of the author. */
  name?: Maybe<Scalars['String']['output']>;
  /** URI slug for the author. */
  slug?: Maybe<Scalars['String']['output']>;
  /** A comma-separated list of this author's areas of specialty. */
  specialties?: Maybe<Scalars['String']['output']>;
  /** Tagline message for the author. */
  tagline?: Maybe<Scalars['String']['output']>;
  /** Twitter handle for the author. */
  twitter?: Maybe<Scalars['String']['output']>;
  /** External URL for the author. */
  url?: Maybe<Scalars['URL']['output']>;
  /** User Page associated with this User. */
  userPage?: Maybe<ContentUserPage>;
  /** The bio that we display for an author on a roundup page. */
  roundupBio?: Maybe<Scalars['String']['output']>;
  /** The social media links relevant to an author */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
};


/** The WordPress author type. */
export type AuthorArticlesArgs = {
  order?: InputMaybe<OrderInput>;
  pagination?: InputMaybe<OffsetPaginationInput>;
};


/** The WordPress author type. */
export type AuthorAvatarUrlsArgs = {
  sizes?: InputMaybe<Array<AvatarSizeEnum>>;
};

/** Avatar URL Type for authors. */
export type AuthorAvatarUrl = {
  __typename?: 'AuthorAvatarUrl';
  /** The size of the image. */
  size?: Maybe<Scalars['Int']['output']>;
  /** The url for the image. */
  url?: Maybe<Scalars['URL']['output']>;
};

export type ChatbotOptions = {
  __typename?: 'ChatbotOptions';
  /** Whether or not the NerdWallet chatbot should be visible on the page. */
  enabled?: Maybe<Scalars['Boolean']['output']>;
  /** Structured Content document representing the chatbot to render on the page. */
  scDocument?: Maybe<Scalars['JSON']['output']>;
  /** Suggested prompts to show when the chatbot is first opened. */
  suggestedPrompts?: Maybe<Array<Scalars['String']['output']>>;
};

export type SeoSettings = {
  __typename?: 'SeoSettings';
  /** The meta description for the content, used for SEO purposes. */
  description?: Maybe<Scalars['String']['output']>;
  /** The custom JSON-LD schema to add to the existing JSON-LD generated for the content. */
  extraJsonLd?: Maybe<Scalars['JSON']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  facebook?: Maybe<SocialSeoSettings>;
  /** The focus keyword for the content, used for SEO purposes. */
  keyword?: Maybe<Scalars['String']['output']>;
  /** Whether to instruct search engines like Google to not follow links in this content. */
  nofollow?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not the content should be indexed in search engines like Google. */
  noindex?: Maybe<Scalars['Boolean']['output']>;
  /** The meta title for the content, used for SEO purposes. */
  title?: Maybe<Scalars['String']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  twitter?: Maybe<SocialSeoSettings>;
  /** @deprecated This field is no longer backed by a value within the WordPress API, please use the 'link' field on the parent Type instead. */
  canonical?: Maybe<Scalars['URL']['output']>;
};

export type SocialSeoSettings = {
  __typename?: 'SocialSeoSettings';
  /** The description for the content as it should appear when this content is shared on Facebook. */
  description?: Maybe<Scalars['String']['output']>;
  /** The title for the content as it should appear when this content is shared on Facebook. */
  title?: Maybe<Scalars['String']['output']>;
  /** @deprecated This field is no longer backed by a value within the WordPress API, please use the 'featuredMedia' field on the parent Type instead. */
  image?: Maybe<Scalars['URL']['output']>;
};

/** Type modeling the data within the faqs group of fields on the Article type. */
export type ContentFaq = {
  __typename?: 'ContentFaq';
  /** The FAQ Answer. */
  answer?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The FAQ Question. */
  question?: Maybe<Scalars['String']['output']>;
};

/** Type modeling the data within the customTitlesForRssFeeds group of fields on the Article type. */
export type ArticleCustomTitlesForRssFeed = {
  __typename?: 'ArticleCustomTitlesForRssFeed';
  /** The title to show in this feed. */
  customTitle?: Maybe<Scalars['String']['output']>;
  /** The feed this title should show on. */
  feedSlug?: Maybe<Scalars['String']['output']>;
};

/** Type modeling the data within the internationalVersions group of fields on the Article type. */
export type InternationalVersion = {
  __typename?: 'InternationalVersion';
  /** Locale associated with this alternate version. */
  locale?: Maybe<Scalars['String']['output']>;
  /** URL for this content in the associated locale. */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Type modeling the data within the sections group of fields on the BccPage type. */
export type BccPageSection = {
  __typename?: 'BccPageSection';
  /** Cards to display within this section of the BCC page. */
  cards?: Maybe<Array<BccPageCard>>;
  /** Driver Group for this section of the BCC page. */
  driverGroup?: Maybe<BccPageDriverGroupEnum>;
  /** Unique identifier for distinguishing between sections on the front-end. */
  identifier?: Maybe<Scalars['String']['output']>;
  /** Short title text for the current section. */
  shortTitle?: Maybe<Scalars['String']['output']>;
  /** Title of the current section. */
  title?: Maybe<Scalars['String']['output']>;
  /**
   * The Best Credit Cards page drivers for the section based on the identifier,
   *   will optionally accept the category to return that category's drivers. We don't want this on the card
   *   because it would be difficult to distinguish query wise for each card.
   */
  cardsDrivers?: Maybe<Array<BccPageSectionDriver>>;
  /**
   * The credit card offer data for the BccPageCard
   * @deprecated Consumers should specify their desired drivers. See the RFC on Placement Drivers for more info.
   */
  driversCategory: BccPageSectionDriversEnum;
};


/** Type modeling the data within the sections group of fields on the BccPage type. */
export type BccPageSectionCardsDriversArgs = {
  category?: InputMaybe<Scalars['String']['input']>;
};

/** Type modeling the data within the mobileConfig group of fields on the GlobalNavItem type. */
export type GlobalNavItemMobileConfig = {
  __typename?: 'GlobalNavItemMobileConfig';
  backgroundColor?: Maybe<Scalars['String']['output']>;
  foregroundColor?: Maybe<Scalars['String']['output']>;
  /** Global Nav mobile config icons */
  icon?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Type modeling the data within the sections group of fields on the GlobalNavItem type. */
export type GlobalNavItemSection = {
  __typename?: 'GlobalNavItemSection';
  /** Global Nav L1 item's L2 section children. */
  children?: Maybe<Array<GlobalNavItem>>;
  /** Global Nav L1 item section label. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Type modeling the data within the toolsResourcesSections group of fields on the GlobalNavItem type. */
export type GlobalNavItemToolsResourcesSection = {
  __typename?: 'GlobalNavItemToolsResourcesSection';
  /** Global Nav L2 Tools and Resource's L3 section children. */
  children?: Maybe<Array<GlobalNavItem>>;
  /** Tools and Resources item section label. */
  label?: Maybe<Scalars['String']['output']>;
};

/** Type modeling the data within the featuredBoxes group of fields on the Hub type. */
export type HubFeaturedBox = {
  __typename?: 'HubFeaturedBox';
  /** The description text for the featured box. */
  description?: Maybe<Scalars['String']['output']>;
  /** The icon to display within the featured box. */
  icon?: Maybe<Scalars['String']['output']>;
  /** The label text for the featured box. */
  iconLabel?: Maybe<Scalars['String']['output']>;
  /** The post entity the featured box should link to. */
  link?: Maybe<HubLinkUnion>;
  /** The content this featured box should link to. */
  linkedContent?: Maybe<ContentSearchResult>;
  /** The title text for the featured box. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Type modeling the data within the featuredContent group of fields on the Hub type. */
export type HubFeaturedContent = {
  __typename?: 'HubFeaturedContent';
  /** The category the latest content in this section should be displayed from. */
  category?: Maybe<Category>;
  /** The content to display in this section. */
  content?: Maybe<Array<ContentSearchResult>>;
  /** The selected display layout for the section */
  layout?: Maybe<HubLayoutEnum>;
  title?: Maybe<Scalars['String']['output']>;
  /** Whether to display a curated list of content for the section or a latest list of content in a particular category. */
  whatToShow?: Maybe<HubWhatToShowEnum>;
};

/** Type modeling the data within the marketplaceEntities group of fields on the Hub type. */
export type HubMarketplaceEntity = {
  __typename?: 'HubMarketplaceEntity';
  /** The entity id. */
  entity?: Maybe<MarketplaceEntityInterface>;
  /** The entity id. */
  id?: Maybe<Scalars['String']['output']>;
  /** The entity title. */
  title?: Maybe<Scalars['String']['output']>;
};

/** Type modeling the data within the questions group of fields on the Hub type. */
export type HubQuestion = {
  __typename?: 'HubQuestion';
  /** The answer for the question prompt. */
  answer?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The content this question should link to. */
  linkedContent?: Maybe<ContentSearchResult>;
  /** The question prompt. */
  question?: Maybe<Scalars['String']['output']>;
};

export type LegacyLenderMinCreditScore = {
  __typename?: 'LegacyLenderMinCreditScore';
  conventional?: Maybe<Scalars['String']['output']>;
  fha?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  hel?: Maybe<Scalars['String']['output']>;
  heloc?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  usda?: Maybe<Scalars['String']['output']>;
  va?: Maybe<Scalars['String']['output']>;
};

export type LegacyLenderMinDownPayment = {
  __typename?: 'LegacyLenderMinDownPayment';
  conventional?: Maybe<Scalars['String']['output']>;
  fha?: Maybe<Scalars['String']['output']>;
  header?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
  tooltip?: Maybe<Scalars['String']['output']>;
  va?: Maybe<Scalars['String']['output']>;
};

export type LegacyLenderNationalRegional = {
  __typename?: 'LegacyLenderNationalRegional';
  header?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

export type LegacyLenderMaxLtv = {
  __typename?: 'LegacyLenderMaxLTV';
  header?: Maybe<Scalars['String']['output']>;
  text?: Maybe<Scalars['String']['output']>;
};

/** Type modeling the data within the institutionBreakdownSections group of fields on the Review type. */
export type ReviewInstitutionBreakdownSection = {
  __typename?: 'ReviewInstitutionBreakdownSection';
  /** The content to display within the section. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The marketplace entity to use for the 1-year APY value on CDs. */
  marketplace1YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity to use for the 1-year APY value on CDs. */
  marketplace1YearApyId?: Maybe<Scalars['String']['output']>;
  /** The marketplace entity to use for the 3-year APY value on CDs. */
  marketplace3YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity to use for the 3-year APY value on CDs. */
  marketplace3YearApyId?: Maybe<Scalars['String']['output']>;
  /** The marketplace entity to use for the 5-year APY value on CDs. */
  marketplace5YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity to use for the 5-year APY value on CDs. */
  marketplace5YearApyId?: Maybe<Scalars['String']['output']>;
  /** The marketplace entity associated with the current section. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity associated with the current section. */
  marketplaceEntityId?: Maybe<Scalars['String']['output']>;
  /** The section type for the current review section. */
  sectionType?: Maybe<ReviewSectionTypeEnum>;
  /** The tracking params that should be appended to this review section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The drivers for a given institution breakdown section */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** Boolean flag to omit editorial content (e.g., pros/cons/bottom line) from the review */
  omitMarketplaceEditorialContent: Scalars['Boolean']['output'];
  /** Optional title for the institution breakdown section */
  title?: Maybe<Scalars['String']['output']>;
  /** Text size for title field */
  titleSize?: Maybe<Scalars['String']['output']>;
};


/** Type modeling the data within the institutionBreakdownSections group of fields on the Review type. */
export type ReviewInstitutionBreakdownSectionCtaTrackingParamsArgs = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};

/** Type modeling the data within the relatedProducts group of fields on the Review type. */
export type ReviewRelatedProduct = {
  __typename?: 'ReviewRelatedProduct';
  /** The Marketplace entity type for the related product. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The related product to display for 1 year APY on banking reviews. */
  marketplace1YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The related product to display for 1 year APY on banking reviews. */
  marketplace1YearApyId?: Maybe<Scalars['String']['output']>;
  /** The related product to display for 3 year APY on banking reviews. */
  marketplace3YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The related product to display for 3 year APY on banking reviews. */
  marketplace3YearApyId?: Maybe<Scalars['String']['output']>;
  /** The related product to display for 5 year APY on banking reviews. */
  marketplace5YearApy?: Maybe<MarketplaceEntityInterface>;
  /** The related product to display for 5 year APY on banking reviews. */
  marketplace5YearApyId?: Maybe<Scalars['String']['output']>;
  /** The related Marketplace entity for this piece of content. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The related Marketplace entity for this piece of content. */
  marketplaceEntityId?: Maybe<Scalars['String']['output']>;
  /** The Marketplace product type for the related product. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
};

/** Type modeling the data within the alternatePicks group of fields on the Review type. */
export type ReviewAlternatePick = {
  __typename?: 'ReviewAlternatePick';
  /** The URL of the review to link to as an alternate pick. */
  ctaUrl?: Maybe<Scalars['URL']['output']>;
  /** The description text to display for the alternate pick. */
  description?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The Marketplace entity type for the alternate pick. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The label to express how the alternate product is related to the product currently being reviewed. */
  label?: Maybe<Scalars['String']['output']>;
  /** The marketplace entity for the alternative pick. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The marketplace entity for the alternative pick. */
  marketplaceEntityId?: Maybe<Scalars['String']['output']>;
  /** The Marketplace product type for the alternate pick. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
  /** The tagline text to display for the alternate pick. */
  tagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
};

/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSection = {
  __typename?: 'RoundupSection';
  /** The benefits of this product. */
  benefits?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The category description for the Roundup category. */
  categoryDescription?: Maybe<Scalars['String']['output']>;
  /** The name of the Roundup category within this section. */
  categoryName?: Maybe<Scalars['String']['output']>;
  /** Where to link the CTA to. */
  ctaDestination?: Maybe<Scalars['String']['output']>;
  /** The custom URL to use for linking to a review. */
  customReviewUrl?: Maybe<Scalars['URL']['output']>;
  /** The drawbacks of this product. */
  drawbacks?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The Marketplace Entity type. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  fiveYearApyEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  fiveYearApyId?: Maybe<Scalars['String']['output']>;
  /** The lender associated with the roundup. */
  legacyLender?: Maybe<LegacyLender>;
  /** The Marketplace entity UUID. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity UUID. */
  marketplaceEntityId?: Maybe<Scalars['String']['output']>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  oneYearApyEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  oneYearApyId?: Maybe<Scalars['String']['output']>;
  /** The Marketplace product type. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
  /** Text for the "More" link, excluding the "More" prefix. */
  roundupMoreLinkText?: Maybe<Scalars['String']['output']>;
  /** The URL associated with the "More" link. */
  roundupMoreLinkUrl?: Maybe<Scalars['URL']['output']>;
  /** The spotlight details text to display for the card. */
  roundupSpotlightDetails?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The spotlight heading text for the card. */
  roundupSpotlightHeading?: Maybe<Scalars['String']['output']>;
  /** Whether or not to display this roundup section in more options instead of a product card. */
  showInAdditionalRecommendations?: Maybe<Scalars['Boolean']['output']>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  threeYearApyEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity to use for one year APY on CD Roundups. */
  threeYearApyId?: Maybe<Scalars['String']['output']>;
  /**
   * The text to show in the Why We Like It section of a product card. Overrides
   *   the bottomLine provided by the Marketplace Entity.
   */
  bottomLine?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The list of cons that will override this roundup section's marketplace entity's cons */
  cons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The CTA that will override this roundup section's marketplace entity's CTA */
  cta?: Maybe<EntityPlacementCta>;
  /** The tracking params that should be appended to this roundup section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /**
   * The driver group for a Product Card that will override this roundup section's default drivers
   *   TODO: (SHOP-13277) After the Product Cards have been updated to accept drivers return override
   *   drivers directly instead of a group
   * @deprecated This field is only used while we migrate to using the drivers field.
   */
  driverGroup?: Maybe<Scalars['String']['output']>;
  /** The driver overrides for a given roundup section. */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** Boolean flag to indicate if model execution id should be excluded from impressions for this roundup section. */
  excludeModelExecutionIds: Scalars['Boolean']['output'];
  /** The "key facts: for this roundup section. */
  keyFacts?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The product card Component to use for this roundup section */
  productCardComponent: ProductCardComponentEnum;
  /** The "product details" for this roundup section. */
  productDetails?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The list of pros that will override this roundup section's marketplace entity's pros */
  pros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /**
   * The description to show in the recap list for this roundup section - Note that this
   *   field should only be used as a child of 'recapListSection.recapItems'
   */
  recapDescription?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to indicate if the "Add to Compare" button should be enabled */
  shouldEnableAddToCompare: Scalars['Boolean']['output'];
  /** Boolean flag to indicate if the images should lazy load for this roundup section */
  shouldEnableImageLazyLoad: Scalars['Boolean']['output'];
};


/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSectionDriversArgs = {
  driversVariant?: InputMaybe<DriversVariationTypeEnum>;
};


/** Type modeling the data within the roundupSections group of fields on the Roundup type. */
export type RoundupSectionProductCardComponentArgs = {
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Type modeling the data within the yearsOfExperience group of fields on the ContentUserPage type. */
export type ContentUserPageYearsOfExperience = {
  __typename?: 'ContentUserPageYearsOfExperience';
  area?: Maybe<Scalars['String']['output']>;
  startDate?: Maybe<Scalars['DateTime']['output']>;
};

export type UserPageVideo = {
  __typename?: 'UserPageVideo';
  /** Featured video length for this User Page. */
  length?: Maybe<Scalars['String']['output']>;
  /** Featured video synopsis for this User Page. */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** Featured video title for this User Page. */
  title?: Maybe<Scalars['String']['output']>;
  /** Featured video Youtube URL for this User Page. */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Type modeling the data within the quotesAndInterviews group of fields on the ContentUserPage type. */
export type ContentUserPageQuotesAndInterview = {
  __typename?: 'ContentUserPageQuotesAndInterview';
  /** Publication name for this quote/interview. */
  name?: Maybe<Scalars['String']['output']>;
  /** Publication title for this quote/interview. */
  title?: Maybe<Scalars['String']['output']>;
  /** URL for this quote/interview. */
  url?: Maybe<Scalars['URL']['output']>;
};

/** Type modeling the data within the featuredIn group of fields on the Author type. */
export type AuthorFeaturedIn = {
  __typename?: 'AuthorFeaturedIn';
  /** The name of the publication, organization, etc. where the author has been featured. */
  name?: Maybe<Scalars['String']['output']>;
  /** The URL of the publication, organization, etc. where the author was featured. */
  url?: Maybe<Scalars['URL']['output']>;
};

/** The media details type for media items. */
export type MediaDetails = {
  __typename?: 'MediaDetails';
  /**
   * The file path to the image within the uploads directory.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  file?: Maybe<Scalars['String']['output']>;
  /**
   * The height of the original image in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  height?: Maybe<Scalars['Int']['output']>;
  /**
   * All of the different image crop sizes for a particular media item.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  sizes?: Maybe<Array<MediaSize>>;
  /**
   * The width of the original image in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  width?: Maybe<Scalars['Int']['output']>;
  /**
   * A unique ID. A hash of the 'file' key.
   *   This is necessary in order for ApolloClient 3 to cache the object
   */
  id: Scalars['ID']['output'];
  /**
   * A srcSet string including the image sizes requested
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  srcSet?: Maybe<Scalars['String']['output']>;
};


/** The media details type for media items. */
export type MediaDetailsSizesArgs = {
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
};


/** The media details type for media items. */
export type MediaDetailsSrcSetArgs = {
  sizes?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The object representing the size of the image. */
export type CroppedImageSize = {
  __typename?: 'CroppedImageSize';
  /** The file name for this crop size. */
  file?: Maybe<Scalars['String']['output']>;
  /** The height of this crop size in pixels. */
  height?: Maybe<Scalars['Int']['output']>;
  /** The mime type for this crop size. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The name of the crop size. */
  size: MediaItemImageSizeEnum;
  /** The full url path to the crop of this image. */
  sourceUrl?: Maybe<Scalars['URL']['output']>;
  /** The width of this crop size in pixels. */
  width?: Maybe<Scalars['Int']['output']>;
};

/** The media size type for media details. */
export type MediaSize = {
  __typename?: 'MediaSize';
  /**
   * The file name for this crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  file?: Maybe<Scalars['String']['output']>;
  /**
   * The height of this crop size in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  height?: Maybe<Scalars['Int']['output']>;
  /**
   * The mime type for this crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  mimeType?: Maybe<Scalars['String']['output']>;
  /**
   * The name of the crop size.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  size?: Maybe<Scalars['String']['output']>;
  /**
   * The full url path to the crop of this image.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  sourceUrl?: Maybe<Scalars['URL']['output']>;
  /**
   * The width of this crop size in pixels.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  width?: Maybe<Scalars['Int']['output']>;
};

/** Enum values for layout field on Article type. */
export enum ArticleLayoutEnum {
  Default = 'DEFAULT',
  Full = 'FULL',
  Sidebar = 'SIDEBAR'
}

/** Enum values for articleType field on Article type. */
export enum ArticleTypeEnum {
  GeneralAnswer = 'GENERAL_ANSWER',
  HeroBanner = 'HERO_BANNER',
  Listicle = 'LISTICLE',
  StepByStep = 'STEP_BY_STEP',
  TableOfContents = 'TABLE_OF_CONTENTS'
}

/** The list of avatar sizes available to choose from. */
export enum AvatarSizeEnum {
  Size_24 = 'SIZE_24',
  Size_48 = 'SIZE_48',
  Size_96 = 'SIZE_96'
}

/** Enum values for driverGroup field on BccPage type. */
export enum BccPageDriverGroupEnum {
  BalanceTransfer = 'BALANCE_TRANSFER',
  Default = 'DEFAULT',
  Rewards = 'REWARDS'
}

/** Enum values for hubType field on ContentHub type. */
export enum ContentHubHubTypeEnum {
  Calculators = 'CALCULATORS',
  Category = 'CATEGORY',
  Data = 'DATA',
  News = 'NEWS',
  Reviews = 'REVIEWS',
  SmartMoneyPodcast = 'SMART_MONEY_PODCAST',
  Topic = 'TOPIC'
}

/** Enum values for curationType field on ContentPack type. */
export enum ContentPackCurationTypeEnum {
  Default = 'DEFAULT',
  Manual = 'MANUAL',
  MobileContentRecs = 'MOBILE_CONTENT_RECS'
}

/** Enum values for listDisplayType field on ContentPack type. */
export enum ContentPackListDisplayTypeEnum {
  Card = 'CARD',
  Carousel = 'CAROUSEL',
  Default = 'DEFAULT'
}

/** Enum values for pageType field on ContentUserPage type. */
export enum ContentUserPagePageTypeEnum {
  Author = 'AUTHOR'
}

/** Enum values for dateDisplayFormat field on Article type. */
export enum DateDisplayFormatEnum {
  Default = 'DEFAULT',
  MonthAndYear = 'MONTH_AND_YEAR'
}

/** Enum values for level field on GlobalNavItem type. */
export enum GlobalNavItemLevelEnum {
  Default = 'DEFAULT',
  L0 = 'L0',
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3'
}

/** Enum values for ctaType field on HouseAd type. */
export enum HouseAdCtaTypeEnum {
  AuthLink = 'AUTH_LINK',
  WebLink = 'WEB_LINK'
}

/** Enum values for illustration field on HouseAd type. */
export enum HouseAdIllustrationEnum {
  Auto = 'AUTO',
  Home = 'HOME',
  HouseAndCloudsGreen = 'HOUSE_AND_CLOUDS_GREEN',
  HouseInHands = 'HOUSE_IN_HANDS',
  Renters = 'RENTERS'
}

/** Enum values for template field on HouseAd type. */
export enum HouseAdTemplateEnum {
  BlueEntryBanner = 'BLUE_ENTRY_BANNER',
  Card = 'CARD',
  EntryBanner = 'ENTRY_BANNER',
  EntryBannerWithImage = 'ENTRY_BANNER_WITH_IMAGE',
  GreenEntryBannerNwPlus = 'GREEN_ENTRY_BANNER_NW_PLUS',
  GreenMobileDownload = 'GREEN_MOBILE_DOWNLOAD',
  Horizontal = 'HORIZONTAL',
  Vertical = 'VERTICAL'
}

/** Enum values for layout field on Hub type. */
export enum HubLayoutEnum {
  Default = 'DEFAULT',
  FeatureVertical = 'FEATURE_VERTICAL',
  ThreeInline = 'THREE_INLINE',
  TwoInline = 'TWO_INLINE'
}

/** Enum values for hubType field on Hub type. */
export enum HubTypeEnum {
  Category = 'CATEGORY',
  Topic = 'TOPIC'
}

/** Enum values for whatToShow field on Hub type. */
export enum HubWhatToShowEnum {
  Default = 'DEFAULT',
  LatestContent = 'LATEST_CONTENT',
  Manual = 'MANUAL'
}

/** Enum values for insurancePageType field on InsurancePage type. */
export enum InsurancePageTypeEnum {
  City = 'CITY',
  MakeModel = 'MAKE_MODEL'
}

/** Enum values for entityType field on Review type. */
export enum MarketplaceEntityTypeEnum {
  Default = 'DEFAULT',
  Institutions = 'INSTITUTIONS',
  Offers = 'OFFERS',
  Products = 'PRODUCTS'
}

/** Enum values for template field on MarketplaceEntryPoint type. */
export enum MarketplaceEntryPointTemplateEnum {
  Card = 'CARD',
  Default = 'DEFAULT',
  Detailed = 'DETAILED',
  Horizontal = 'HORIZONTAL',
  Minimal = 'MINIMAL',
  Vertical = 'VERTICAL'
}

/** Enum values for productType field on Review type. */
export enum MarketplaceProductTypeEnum {
  AutoLoans = 'AUTO_LOANS',
  AutoServices = 'AUTO_SERVICES',
  Banking = 'BANKING',
  CaBanking = 'CA_BANKING',
  CaCreditCards = 'CA_CREDIT_CARDS',
  CaMortgages = 'CA_MORTGAGES',
  CaPersonalLoans = 'CA_PERSONAL_LOANS',
  CreditCards = 'CREDIT_CARDS',
  Default = 'DEFAULT',
  EducationLoans = 'EDUCATION_LOANS',
  EstatePlanning = 'ESTATE_PLANNING',
  Expansion = 'EXPANSION',
  FirstTimeHomeBuyerPrograms = 'FIRST_TIME_HOME_BUYER_PROGRAMS',
  Insurance = 'INSURANCE',
  Investing = 'INVESTING',
  Mortgages = 'MORTGAGES',
  Moving = 'MOVING',
  NerdwalletPlus = 'NERDWALLET_PLUS',
  PersonalLoans = 'PERSONAL_LOANS',
  RiaAdvisorMatch = 'RIA_ADVISOR_MATCH',
  SmallMediumBusinessLoans = 'SMALL_MEDIUM_BUSINESS_LOANS',
  Software = 'SOFTWARE',
  Taxes = 'TAXES',
  Travel = 'TRAVEL',
  UkBusinessBanking = 'UK_BUSINESS_BANKING',
  UkBusinessLoans = 'UK_BUSINESS_LOANS',
  Utilities = 'UTILITIES'
}

/** Image crop sizes supported by WP */
export enum MediaItemImageSizeEnum {
  BbArticle = 'BB_ARTICLE',
  FourThreeL = 'FOUR_THREE_L',
  FourThreeM = 'FOUR_THREE_M',
  FourThreeS = 'FOUR_THREE_S',
  FourThreeXl = 'FOUR_THREE_XL',
  FourThreeXs = 'FOUR_THREE_XS',
  FourThreeXxs = 'FOUR_THREE_XXS',
  Full = 'FULL',
  Large = 'LARGE',
  Medium = 'MEDIUM',
  MediumLarge = 'MEDIUM_LARGE',
  PrimaryL = 'PRIMARY_L',
  PrimaryLUncropped = 'PRIMARY_L_UNCROPPED',
  PrimaryM = 'PRIMARY_M',
  PrimaryMUncropped = 'PRIMARY_M_UNCROPPED',
  PrimaryS = 'PRIMARY_S',
  PrimarySUncropped = 'PRIMARY_S_UNCROPPED',
  PrimaryXl = 'PRIMARY_XL',
  PrimaryXlUncropped = 'PRIMARY_XL_UNCROPPED',
  PrimaryXs = 'PRIMARY_XS',
  PrimaryXsUncropped = 'PRIMARY_XS_UNCROPPED',
  PrimaryXxl = 'PRIMARY_XXL',
  PrimaryXxs = 'PRIMARY_XXS',
  PrimaryXxsUncropped = 'PRIMARY_XXS_UNCROPPED',
  PrimaryXxxl = 'PRIMARY_XXXL',
  Square = 'SQUARE',
  Square_160 = 'SQUARE_160',
  Square_350 = 'SQUARE_350'
}

/** Enum values to express which field to order collection query results by. */
export enum OrderByFieldEnum {
  Date = 'DATE',
  Id = 'ID',
  Include = 'INCLUDE',
  ModifiedDate = 'MODIFIED_DATE',
  Slug = 'SLUG'
}

/** Enum values for overrideLastModifiedDateWithCurrentDate field on Article type. */
export enum OverrideLastModifiedDateEnum {
  Default = 'DEFAULT',
  UseCurrentDay = 'USE_CURRENT_DAY',
  UseCurrentMonth = 'USE_CURRENT_MONTH'
}

/** WordPress post types supported in GraphQL. */
export enum PostTypeEnum {
  Article = 'ARTICLE',
  AuFlexPage = 'AU_FLEX_PAGE',
  AuTemplate = 'AU_TEMPLATE',
  BccPage = 'BCC_PAGE',
  BccPageCard = 'BCC_PAGE_CARD',
  Block = 'BLOCK',
  BlockGroup = 'BLOCK_GROUP',
  CaFlexPage = 'CA_FLEX_PAGE',
  CaTemplate = 'CA_TEMPLATE',
  CalcPage = 'CALC_PAGE',
  Calculator = 'CALCULATOR',
  ContentPack = 'CONTENT_PACK',
  EngPost = 'ENG_POST',
  FlexPage = 'FLEX_PAGE',
  GnavItem = 'GNAV_ITEM',
  HouseAd = 'HOUSE_AD',
  Hub = 'HUB',
  HubNew = 'HUB_NEW',
  InsFlexPage = 'INS_FLEX_PAGE',
  InsTemplate = 'INS_TEMPLATE',
  Landing = 'LANDING',
  Lender = 'LENDER',
  MktEntry = 'MKT_ENTRY',
  Page = 'PAGE',
  Placement = 'PLACEMENT',
  Post = 'POST',
  PressRelease = 'PRESS_RELEASE',
  Review = 'REVIEW',
  Reviewer = 'REVIEWER',
  Roundup = 'ROUNDUP',
  TablepressTable = 'TABLEPRESS_TABLE',
  Template = 'TEMPLATE',
  UrlRecord = 'URL_RECORD',
  UserPage = 'USER_PAGE'
}

/** The enum for selecting the text formatting to return on rendered text fields. */
export enum RenderedTextFormatEnum {
  Html = 'HTML',
  PlainText = 'PLAIN_TEXT'
}

/** Enum values for driverGroup field on Review type. */
export enum ReviewDriverGroupEnum {
  BalanceTransfer = 'BALANCE_TRANSFER',
  Default = 'DEFAULT',
  Rewards = 'REWARDS'
}

/** Enum values for sectionType field on Review type. */
export enum ReviewSectionTypeEnum {
  BankExperience = 'BANK_EXPERIENCE',
  Default = 'DEFAULT',
  MarketplaceEntity = 'MARKETPLACE_ENTITY',
  OverdraftFee = 'OVERDRAFT_FEE'
}

/** Enum values for subproductType field on Review type. */
export enum ReviewSubproductTypeEnum {
  Cd = 'CD',
  Checking = 'CHECKING',
  Default = 'DEFAULT',
  Savings = 'SAVINGS'
}

/** Enum values for crossSellCcCategory field on Roundup type. */
export enum RoundupCrossSellCcCategoryEnum {
  AirlineCreditCards = 'AIRLINE_CREDIT_CARDS',
  BadCreditCards = 'BAD_CREDIT_CARDS',
  BalanceTransferCreditCards = 'BALANCE_TRANSFER_CREDIT_CARDS',
  CashRewardsCreditCards = 'CASH_REWARDS_CREDIT_CARDS',
  HotelCreditCards = 'HOTEL_CREDIT_CARDS',
  None = 'NONE',
  StudentCreditCards = 'STUDENT_CREDIT_CARDS',
  TravelMilesCreditCards = 'TRAVEL_MILES_CREDIT_CARDS'
}

/** Enum values for crossSellSource field on Roundup type. */
export enum RoundupCrossSellSourceEnum {
  CcRecs = 'CC_RECS',
  Default = 'DEFAULT',
  NamedQuery = 'NAMED_QUERY',
  SpecificEntities = 'SPECIFIC_ENTITIES'
}

/** Enum values for driverGroup field on Roundup type. */
export enum RoundupDriverGroupEnum {
  BalanceTransfer = 'BALANCE_TRANSFER',
  Default = 'DEFAULT',
  Rewards = 'REWARDS'
}

/** Enum values for summaryListQuickFacts field on Roundup type. */
export enum RoundupSummaryListQuickFactsEnum {
  Apy = 'APY',
  Bonus = 'BONUS',
  Default = 'DEFAULT',
  MinimumBalance = 'MINIMUM_BALANCE',
  MonthlyFee = 'MONTHLY_FEE',
  OutOfNetworkAtmFee = 'OUT_OF_NETWORK_ATM_FEE'
}

/** Enum values for summaryTablePosition field on Roundup type. */
export enum RoundupSummaryTablePositionEnum {
  AboveProductCards = 'ABOVE_PRODUCT_CARDS',
  BelowProductCards = 'BELOW_PRODUCT_CARDS',
  Default = 'DEFAULT'
}

/** Enum values for roundupType field on Roundup type. */
export enum RoundupTypeEnum {
  MarketingRoundup = 'MARKETING_ROUNDUP',
  OrganicRoundup = 'ORGANIC_ROUNDUP'
}

/** Enum values for tableBolding field on Table type. */
export enum TableBoldingEnum {
  Default = 'DEFAULT',
  FirstColumn = 'FIRST_COLUMN',
  FirstRow = 'FIRST_ROW',
  FirstRowColumn = 'FIRST_ROW_COLUMN',
  None = 'NONE'
}

/** Enum values for tableVisibility field on Table type. */
export enum TableVisibilityEnum {
  Private = 'PRIVATE',
  Public = 'PUBLIC'
}

/** The union containing the Type members that can be returned by the items field on the ContentPack type. */
export type ContentPackItemsUnion = Article | ContentHub | FlexPage | Hub | LandingPage | Page | Post | Review | Roundup;

/** The related content type for this content search result via a Union. */
export type ContentSearchResultRelatedContentTypeUnion = Article | CalculatorPage | ContentHub | FlexPage | Hub | InsuranceFlexPage | LandingPage | Page | Post | Review | Roundup | UrlRecord;

/** The union containing the Type members that can be returned by the contentPicks field on the ContentUserPage type. */
export type ContentUserPageContentPicksUnion = Article | ContentHub | FlexPage | Hub | LandingPage | Page | Post | Review | Roundup;

/** The union containing the Type members that can be returned by the itemLink field on the GlobalNavItem type. */
export type GlobalNavItemItemLinkUnion = Article | CalculatorPage | ContentHub | FlexPage | Hub | InsuranceFlexPage | LandingPage | Page | Post | Review | Roundup | UrlRecord;

/** The union containing the Type members that can be returned by the moreInfoLink field on the GlobalNavItem type. */
export type GlobalNavItemMoreInfoLinkUnion = Article | CalculatorPage | ContentHub | FlexPage | Hub | InsuranceFlexPage | LandingPage | Page | Post | Review | Roundup | UrlRecord;

/** The union containing the Type members that can be returned by the link field on the Hub type. */
export type HubLinkUnion = Article | CalculatorPage | ContentHub | FlexPage | Hub | InsuranceFlexPage | LandingPage | Page | Post | Review | Roundup | UrlRecord;

/** The union containing the Type members that can be returned by the review field on the LegacyLender type. */
export type LegacyLenderReviewUnion = Post | Review;

/** The union containing the Type members that can be returned by the footerPosts field on the Roundup type. */
export type RoundupFooterPostsUnion = Article | Page | Post | Roundup;

/** The Post interface for modeling other custom post types. */
export type PostInterface = {
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
};


/** The Post interface for modeling other custom post types. */
export type PostInterfaceDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** The Post interface for modeling other custom post types. */
export type PostInterfaceModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};

/** The interface for post types that support authors. */
export type PostWithAuthorsInterface = {
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
};

export type PostWithChatbotInterface = {
  /** Field connecting to the ChatbotOptions Type and all of its nested fields. */
  chatbot?: Maybe<ChatbotOptions>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
};

export type PostWithContentClassificationInterface = {
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
};

/** The interface for post types that support the content field. */
export type PostWithContentInterface = {
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
};

export type PostWithEditorInterface = {
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
};

/** The interface for post types that support excerpts. */
export type PostWithExcerptInterface = {
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
};


/** The interface for post types that support excerpts. */
export type PostWithExcerptInterfaceExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

export type PostWithFaQsInterface = {
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
};

/** The interface for post types that support featured images. */
export type PostWithFeaturedImageInterface = {
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
};

export type PostWithInternationalVersionsInterface = {
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Information about alternate versions of the content that exist for other locales. */
  internationalVersions?: Maybe<Array<InternationalVersion>>;
};

/** The interface for post types that support gms page taxonomy. */
export type PostWithPageTaxonomyInterface = {
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']['output']>;
};

export type PostWithReviewerInterface = {
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The internal reviewers that this Article has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** The reviewers that this Article has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
};

export type PostWithSeoInterface = {
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
};

/** The interface for post types that support the title field. */
export type PostWithTitleInterface = {
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
};


/** The interface for post types that support the title field. */
export type PostWithTitleInterfaceTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** The Term interface for modeling terms within custom taxonomies. */
export type TermInterface = {
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL']['output'];
  /** The name of the term. */
  name?: Maybe<Scalars['String']['output']>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ArticleConnectionResponse = {
  __typename?: 'ArticleConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The Article returned for the connection. */
  items?: Maybe<Array<Article>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type AuFlexPageConnectionResponse = {
  __typename?: 'AUFlexPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The AUFlexPage returned for the connection. */
  items?: Maybe<Array<AuFlexPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type AuFlexTemplateConnectionResponse = {
  __typename?: 'AUFlexTemplateConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The AUFlexTemplate returned for the connection. */
  items?: Maybe<Array<AuFlexTemplate>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BccPageCardConnectionResponse = {
  __typename?: 'BccPageCardConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The BccPageCard returned for the connection. */
  items?: Maybe<Array<BccPageCard>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BccPageConnectionResponse = {
  __typename?: 'BccPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The BccPage returned for the connection. */
  items?: Maybe<Array<BccPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BlockConnectionResponse = {
  __typename?: 'BlockConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The Block returned for the connection. */
  items?: Maybe<Array<Block>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type BlockGroupConnectionResponse = {
  __typename?: 'BlockGroupConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The BlockGroup returned for the connection. */
  items?: Maybe<Array<BlockGroup>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type CaFlexPageConnectionResponse = {
  __typename?: 'CAFlexPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The CAFlexPage returned for the connection. */
  items?: Maybe<Array<CaFlexPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type CaFlexTemplateConnectionResponse = {
  __typename?: 'CAFlexTemplateConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The CAFlexTemplate returned for the connection. */
  items?: Maybe<Array<CaFlexTemplate>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type CalculatorPageConnectionResponse = {
  __typename?: 'CalculatorPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The CalculatorPage returned for the connection. */
  items?: Maybe<Array<CalculatorPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentHubConnectionResponse = {
  __typename?: 'ContentHubConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The ContentHub returned for the connection. */
  items?: Maybe<Array<ContentHub>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentPackConnectionResponse = {
  __typename?: 'ContentPackConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The ContentPack returned for the connection. */
  items?: Maybe<Array<ContentPack>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentReviewerConnectionResponse = {
  __typename?: 'ContentReviewerConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The ContentReviewer returned for the connection. */
  items?: Maybe<Array<ContentReviewer>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentSearchResultConnectionResponse = {
  __typename?: 'ContentSearchResultConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The ContentSearchResult returned for the connection. */
  items?: Maybe<Array<ContentSearchResult>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ContentUserPageConnectionResponse = {
  __typename?: 'ContentUserPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The ContentUserPage returned for the connection. */
  items?: Maybe<Array<ContentUserPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type DynamicPlacementConnectionResponse = {
  __typename?: 'DynamicPlacementConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The DynamicPlacement returned for the connection. */
  items?: Maybe<Array<DynamicPlacement>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type EngineeringPostConnectionResponse = {
  __typename?: 'EngineeringPostConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The EngineeringPost returned for the connection. */
  items?: Maybe<Array<EngineeringPost>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type FlexPageConnectionResponse = {
  __typename?: 'FlexPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The FlexPage returned for the connection. */
  items?: Maybe<Array<FlexPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type FlexTemplateConnectionResponse = {
  __typename?: 'FlexTemplateConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The FlexTemplate returned for the connection. */
  items?: Maybe<Array<FlexTemplate>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type GlobalNavItemConnectionResponse = {
  __typename?: 'GlobalNavItemConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The GlobalNavItem returned for the connection. */
  items?: Maybe<Array<GlobalNavItem>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type HouseAdConnectionResponse = {
  __typename?: 'HouseAdConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The HouseAd returned for the connection. */
  items?: Maybe<Array<HouseAd>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type HubConnectionResponse = {
  __typename?: 'HubConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The Hub returned for the connection. */
  items?: Maybe<Array<Hub>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type InsuranceFlexPageConnectionResponse = {
  __typename?: 'InsuranceFlexPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The InsuranceFlexPage returned for the connection. */
  items?: Maybe<Array<InsuranceFlexPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type InsurancePageConnectionResponse = {
  __typename?: 'InsurancePageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The InsurancePage returned for the connection. */
  items?: Maybe<Array<InsurancePage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type InsuranceTemplateConnectionResponse = {
  __typename?: 'InsuranceTemplateConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The InsuranceTemplate returned for the connection. */
  items?: Maybe<Array<InsuranceTemplate>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type LandingPageConnectionResponse = {
  __typename?: 'LandingPageConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The LandingPage returned for the connection. */
  items?: Maybe<Array<LandingPage>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type LegacyLenderConnectionResponse = {
  __typename?: 'LegacyLenderConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The LegacyLender returned for the connection. */
  items?: Maybe<Array<LegacyLender>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type MarketplaceEntryPointConnectionResponse = {
  __typename?: 'MarketplaceEntryPointConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The MarketplaceEntryPoint returned for the connection. */
  items?: Maybe<Array<MarketplaceEntryPoint>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type MediaItemConnectionResponse = {
  __typename?: 'MediaItemConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The MediaItem returned for the connection. */
  items?: Maybe<Array<MediaItem>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type PressReleaseConnectionResponse = {
  __typename?: 'PressReleaseConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The PressRelease returned for the connection. */
  items?: Maybe<Array<PressRelease>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type ReviewConnectionResponse = {
  __typename?: 'ReviewConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The Review returned for the connection. */
  items?: Maybe<Array<Review>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type RoundupConnectionResponse = {
  __typename?: 'RoundupConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The Roundup returned for the connection. */
  items?: Maybe<Array<Roundup>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type StructuredContentCalculatorConnectionResponse = {
  __typename?: 'StructuredContentCalculatorConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The StructuredContentCalculator returned for the connection. */
  items?: Maybe<Array<StructuredContentCalculator>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type TableConnectionResponse = {
  __typename?: 'TableConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The Table returned for the connection. */
  items?: Maybe<Array<Table>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** The connnection response object containing meta data about the connection and the returned data for the Type. */
export type UrlRecordConnectionResponse = {
  __typename?: 'UrlRecordConnectionResponse';
  /** The amount of items the query results are currently offset by. */
  currentOffset: Scalars['Int']['output'];
  /** Whether or not there is enough data to make another query. */
  hasNextPage: Scalars['Boolean']['output'];
  /** The UrlRecord returned for the connection. */
  items?: Maybe<Array<UrlRecord>>;
  /** The total number of items matching your that could possibly be returned in the connection. */
  total: Scalars['Int']['output'];
};

/** Query to fetch a collection of Article objects. */
export type ArticleFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to Articles published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Articles within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to items with the specified content tags. */
  contentTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to Articles with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to Articles with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of AUFlexPage objects. */
export type AuFlexPageFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to AUFlexPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to AUFlexPages within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to AUFlexPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to AUFlexPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of AUFlexTemplate objects. */
export type AuFlexTemplateFilterInput = {
  /** Limit collection to AUFlexTemplates published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to AUFlexTemplates with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to AUFlexTemplates with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input for retrieving a single author. */
export type AuthorItemInput = {
  /** The WordPress ID for the Author. */
  identifier: Scalars['ID']['input'];
};

/** Query to fetch a collection of BccPageCard objects. */
export type BccPageCardFilterInput = {
  /** Limit collection to BccPageCards published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to BccPageCards with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to BccPageCards with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of BccPage objects. */
export type BccPageFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to BccPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to BccPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to BccPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of Block objects. */
export type BlockFilterInput = {
  /** Limit collection to Blocks published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Blocks within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit collection to Blocks with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to Blocks with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of BlockGroup objects. */
export type BlockGroupFilterInput = {
  /** Limit collection to BlockGroups published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to BlockGroups within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit collection to BlockGroups with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to BlockGroups with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of CAFlexPage objects. */
export type CaFlexPageFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to CAFlexPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to CAFlexPages within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to CAFlexPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to CAFlexPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of CAFlexTemplate objects. */
export type CaFlexTemplateFilterInput = {
  /** Limit collection to CAFlexTemplates published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to CAFlexTemplates with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to CAFlexTemplates with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of CalculatorPage objects. */
export type CalculatorPageFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to CalculatorPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to CalculatorPages within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to items with the specified content tags. */
  contentTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to CalculatorPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to CalculatorPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of ContentHub objects. */
export type ContentHubFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to ContentHubs published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentHubs within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit collection to ContentHubs with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to ContentHubs with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of ContentPack objects. */
export type ContentPackFilterInput = {
  /** Limit collection to ContentPacks published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentPacks within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit collection to ContentPacks with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Query to fetch a collection of ContentReviewer objects. */
export type ContentReviewerFilterInput = {
  /** Limit collection to ContentReviewers published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentReviewers with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentReviewers with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Input args to filter collections of content search results. */
export type ContentSearchFilterInput = {
  /** Limit result set to content with a particular topic(s). */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit result set to content with a particular vertical(s). */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to Articles published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Articles published OR edited by user */
  authorOrEditor?: InputMaybe<Scalars['Int']['input']>;
  /** Limit collection to search results within a specific Category. This field accepts an array of integer IDs or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit result set to content with a particular content tag(s). */
  contentTags?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to search results within specific content types. */
  contentTypes?: InputMaybe<Array<PostTypeEnum>>;
  /** Limit collection to search results with or without specific IDs. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Whether to return only content marked as news content. NOTE: Using this field means only articles will be returned. */
  onlyNews?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit result set to content with a particular other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit result set to content with a particular other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit result set to content with particular other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit result set to content with a particular page type(s). */
  pageType?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit result set to content with a particular primary cluster(s). */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit result set to content containing a particular string of text. It should be noted that using this input field will cause a cache miss in the WP API and SHOULD NOT BE USED FOR CONSUMER FACING EXPERIENCES! */
  searchText?: InputMaybe<Scalars['String']['input']>;
};

/** Query to fetch a collection of ContentUserPage objects. */
export type ContentUserPageFilterInput = {
  /** Limit collection to ContentUserPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentUserPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to ContentUserPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of DynamicPlacement objects. */
export type DynamicPlacementFilterInput = {
  /** Limit collection to DynamicPlacements published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to DynamicPlacements with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to DynamicPlacements with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of EngineeringPost objects. */
export type EngineeringPostFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to EngineeringPosts published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to EngineeringPosts with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to EngineeringPosts with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of FlexPage objects. */
export type FlexPageFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to FlexPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to FlexPages within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to FlexPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to FlexPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of FlexTemplate objects. */
export type FlexTemplateFilterInput = {
  /** Limit collection to FlexTemplates published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to FlexTemplates with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to FlexTemplates with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of GlobalNavItem objects. */
export type GlobalNavItemFilterInput = {
  /** Limit collection to GlobalNavItems with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Query to fetch a collection of HouseAd objects. */
export type HouseAdFilterInput = {
  /** Limit collection to HouseAds published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to HouseAds with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Query to fetch a collection of Hub objects. */
export type HubFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to Hubs published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit collection to Hubs with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to Hubs with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input for filtering results by ID. */
export type IdFilterInput = {
  /** Exclude items with specific IDs from the collection. */
  exclude?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to items with specific IDs. */
  include?: InputMaybe<Array<Scalars['Int']['input']>>;
};

/** Query to fetch a collection of InsuranceFlexPage objects. */
export type InsuranceFlexPageFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to InsuranceFlexPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to InsuranceFlexPages within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to InsuranceFlexPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to InsuranceFlexPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of InsurancePage objects. */
export type InsurancePageFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to InsurancePages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to InsurancePages within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit collection to InsurancePages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to insurance pages of a specific page type. */
  insurancePageType?: InputMaybe<Scalars['String']['input']>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit result set to the item with the specified make. */
  make?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to InsurancePages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit result set to the item with the specified URL. */
  urlPath?: InputMaybe<Scalars['String']['input']>;
};

/** Query to fetch a collection of InsuranceTemplate objects. */
export type InsuranceTemplateFilterInput = {
  /** Limit collection to InsuranceTemplates published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to InsuranceTemplates with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to InsuranceTemplates with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of LandingPage objects. */
export type LandingPageFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to LandingPages published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to LandingPages with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to LandingPages with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of LegacyLender objects. */
export type LegacyLenderFilterInput = {
  /** Limit collection to LegacyLenders published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to LegacyLenders within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit collection to LegacyLenders with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to LegacyLenders with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of MarketplaceEntryPoint objects. */
export type MarketplaceEntryPointFilterInput = {
  /** Limit collection to MarketplaceEntryPoints published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to MarketplaceEntryPoints with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
};

/** Query to fetch a collection of MediaItem objects. */
export type MediaItemFilterInput = {
  /** Limit collection to MediaItems published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to MediaItems with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to MediaItems with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input type for ordering results. */
export type OrderInput = {
  /** Sort collection by object attribute. */
  field?: OrderByFieldEnum;
  /** Order sort attribute ascending or descending. */
  sortDirection?: OrderDirectionEnum;
};

/** The input for fetching a single forked post. */
export type PostForkItemInput = {
  /** The WordPress ID for the forked entity. */
  forkIdentifier: Scalars['Int']['input'];
  /** The security nonce for viewing the fork. */
  forkNonce?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not to preview the forked version of the data. */
  forkPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /** The slug for the entity this fork was created from or the WordPress ID. */
  identifier: Scalars['ID']['input'];
  /** The security nonce for viewing the entity. */
  wpnonce?: InputMaybe<Scalars['String']['input']>;
};

/** The input for retrieving a single resource. */
export type PostItemInput = {
  /** The WordPress ID for the forked entity. */
  forkIdentifier?: InputMaybe<Scalars['Int']['input']>;
  /** The security nonce for viewing the fork. */
  forkNonce?: InputMaybe<Scalars['String']['input']>;
  /** Whether or not to preview the forked version of the data. */
  forkPreview?: InputMaybe<Scalars['Boolean']['input']>;
  /** The slug for the post or the WordPress ID. */
  identifier: Scalars['ID']['input'];
  /** Whether or not to retrieve the preview of the post. */
  preview?: InputMaybe<Scalars['Boolean']['input']>;
  /** The security nonce for viewing a preview. */
  wpnonce?: InputMaybe<Scalars['ID']['input']>;
};

/** Query to fetch a collection of PressRelease objects. */
export type PressReleaseFilterInput = {
  /** Limit collection to PressReleases published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit results to Press Releases with a specific featured status. */
  featured?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit collection to PressReleases with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to PressReleases within a specific MediaSite. This field accepts an array of integer ID's or slugs. */
  mediaSiteIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
};

/** Query to fetch a collection of Review objects. */
export type ReviewFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to Reviews published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Reviews within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to Reviews with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified Marketplace entity UUIDs, either Offer, Product, or Institution UUIDs. */
  marketplaceEntity?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to Reviews with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of Roundup objects. */
export type RoundupFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to Roundups published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to Roundups within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to Roundups with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to Roundups with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of StructuredContentCalculator objects. */
export type StructuredContentCalculatorFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to StructuredContentCalculators published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to StructuredContentCalculators within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit collection to StructuredContentCalculators with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** Query to fetch a collection of Table objects. */
export type TableFilterInput = {
  /** Limit collection to Tables with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit collection to Tables with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
};

/** The input for retrieving a single resource. */
export type TermItemInput = {
  /** The slug for the term or the WordPress ID. */
  identifier: Scalars['ID']['input'];
};

/** Query to fetch a collection of UrlRecord objects. */
export type UrlRecordFilterInput = {
  /** Limit results to those with the specified attribution topic. */
  attributionTopic?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified attribution topic. */
  attributionVertical?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit collection to UrlRecords published by particular authors, or not published by particular authors. */
  authorIds?: InputMaybe<IdFilterInput>;
  /** Limit collection to UrlRecords within a specific Category. This field accepts an array of integer ID's or slugs. */
  categoryIdentifiers?: InputMaybe<Array<Scalars['ID']['input']>>;
  /** Limit results to those with the specified cluster set as either the primary or among the other clusters. */
  cluster?: InputMaybe<Scalars['String']['input']>;
  /** Limit results to those with the specified Assigning Editor, filtered by ID. */
  editorIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to UrlRecords with or without specific ID's. */
  ids?: InputMaybe<IdFilterInput>;
  /** Limit result set to content that is eligible or not to appear on hub and author pages. */
  isArchivesEligible?: InputMaybe<Scalars['Boolean']['input']>;
  /** Limit results to those with the specified cluster set among the other clusters. */
  otherClusters?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other topics. */
  otherTopics?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified other verticals. */
  otherVerticals?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to items with the specified page types. */
  pageTypes?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified primary content cluster. */
  primaryCluster?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit results to those with the specified Reviewer, filtered by ID. */
  reviewerIds?: InputMaybe<Array<Scalars['Int']['input']>>;
  /** Limit collection to UrlRecords with a specific slug or multiple slugs. */
  slugs?: InputMaybe<Array<Scalars['String']['input']>>;
  /** Limit result set to the item with the specified URL. */
  urlPath?: InputMaybe<Scalars['String']['input']>;
};

/** The interface for PostWithHubLinks that exposes related Hubs and subhubs links. */
export type PostWithHubLinks = {
  /** Collection of related hubs and subhubs. */
  hubLinks?: Maybe<Array<ContentHub>>;
};

/** Available date status based on flags and custom dates set on entity */
export enum DisplayDateStatus {
  Update = 'UPDATE',
  Publish = 'PUBLISH'
}

/** How long it takes to read the article */
export type TimeToRead = {
  __typename?: 'TimeToRead';
  /** The total time to read the article in minutes */
  minutes?: Maybe<Scalars['Int']['output']>;
  /** The total time to read the article in seconds */
  seconds?: Maybe<Scalars['Int']['output']>;
};

/** The input for retrieving a collection of related articles. */
export type RelatedArticlesInput = {
  /** A WordPress ID to exclude from the query. */
  exclude: Scalars['ID']['input'];
  /** The type of article to return. */
  articleType: Scalars['String']['input'];
  /** Limit of number of results. Default: 6 */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

export enum AuthorSocialMediaLinkTypeEnum {
  Twitter = 'twitter',
  Email = 'email',
  Facebook = 'facebook',
  Linkedin = 'linkedin'
}

/**
 * A social media link related to an author
 * Includes a type, a displayable name, and a URL to the social media
 */
export type AuthorSocialMediaLink = {
  __typename?: 'AuthorSocialMediaLink';
  /** The type of social media link. */
  type: AuthorSocialMediaLinkTypeEnum;
  /** Displayable name for social media link. */
  name: Scalars['String']['output'];
  /** URL for social media link. */
  url: Scalars['String']['output'];
};

export type UserBestCreditCardRecommendations = {
  __typename?: 'userBestCreditCardRecommendations';
  recommendations: Array<BccPageCard>;
};

export type UserBestCreditCardRecommendationsInput = {
  limit?: InputMaybe<Scalars['Int']['input']>;
  pageId?: InputMaybe<Scalars['String']['input']>;
};

export type BccPagePreferredSection = {
  __typename?: 'BccPagePreferredSection';
  /** The BccPage section */
  section: BccPageSection;
  /** The preferred offer for the attached section */
  sectionOffer: Scalars['String']['output'];
};

/** BccPageSectionDriversEnum represents the mobile type of drivers to display for the cards categorized under this section */
export enum BccPageSectionDriversEnum {
  /**
   * Indicates to display classic drivers such as APR
   * @deprecated Consumers should specify their desired drivers. See the RFC on Placement Drivers for more info.
   */
  Classic = 'CLASSIC',
  /**
   * Indicates to display reward related drivers such as Reward Rate
   * @deprecated Consumers should specify their desired drivers. See the RFC on Placement Drivers for more info.
   */
  Rewards = 'REWARDS'
}

export type BccPageSectionDriver = {
  __typename?: 'BccPageSectionDriver';
  /** @deprecated Consumers should specify their desired drivers. See the RFC on Placement Drivers for more info. */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  id: Scalars['ID']['output'];
  identifier?: Maybe<Scalars['String']['output']>;
};

export type CombinedBlockGroupBlock = {
  __typename?: 'CombinedBlockGroupBlock';
  type?: Maybe<Scalars['String']['output']>;
  title?: Maybe<Scalars['String']['output']>;
  data?: Maybe<Scalars['JSON']['output']>;
};

/** Breadcrumb Page object with a title */
export type BreadcrumbPage = {
  __typename?: 'BreadcrumbPage';
  title: Scalars['String']['output'];
};

/** Breadcrumb to be used by global-nav */
export type Breadcrumb = {
  __typename?: 'Breadcrumb';
  slug?: Maybe<Scalars['String']['output']>;
  page?: Maybe<BreadcrumbPage>;
};

/** Common interface containing fields to display within the ContentPageHeader component. */
export type ContentPageHeaderInterface = {
  id: Scalars['ID']['output'];
  title?: Maybe<Scalars['String']['output']>;
  authors?: Maybe<Array<Author>>;
  primaryCategory?: Maybe<Category>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType?: Maybe<Scalars['String']['output']>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
};

/** The interface for content types that exposes social media links. */
export type PostWithContactInfoInterface = {
  /** The social media link fields to display for the content type. */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
};

/** The interface for content types that exposes user information. */
export type PostWithUserInfoInterface = {
  /** The users's previous experience. */
  experience?: Maybe<Scalars['String']['output']>;
  /** The user's full name */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The user's job title */
  jobTitle?: Maybe<Scalars['String']['output']>;
};

export enum ComparisonTableLocationEnum {
  AboveFullReview = 'ABOVE_FULL_REVIEW',
  PageBottom = 'PAGE_BOTTOM',
  ReviewContentSections = 'REVIEW_CONTENT_SECTIONS'
}

/** Describes the details of a comparison table column */
export type ComparisonTableColumnDetails = {
  __typename?: 'ComparisonTableColumnDetails';
  /** The tracking params that should be appended to this column's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The drivers to display for this column */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** Whether or not the column contains the primary entity */
  isPrimaryEntity: Scalars['Boolean']['output'];
  /** The marketplace entity associated with this column */
  marketplaceEntity: MarketplaceEntityInterface;
};


/** Describes the details of a comparison table column */
export type ComparisonTableColumnDetailsCtaTrackingParamsArgs = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};


/** Describes the details of a comparison table column */
export type ComparisonTableColumnDetailsDriversArgs = {
  useDriverGroupToOrderDrivers?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Describes the details of the comparison table */
export type ComparisonTableDetails = {
  __typename?: 'ComparisonTableDetails';
  /** Data used for rendering the columns of the comparison table */
  columns?: Maybe<Array<ComparisonTableColumnDetails>>;
  /** Whether or not the comparison table should include compare rates */
  hasCompareRates: Scalars['Boolean']['output'];
  /** The header text for the comparison table */
  heading?: Maybe<Scalars['String']['output']>;
};


/** Describes the details of the comparison table */
export type ComparisonTableDetailsColumnsArgs = {
  userState?: InputMaybe<StateCodeEnum>;
};

/** The RelatedLink type to encapsulate the properties within each of the related links. */
export type ReviewRelatedLinkSection = {
  __typename?: 'ReviewRelatedLinkSection';
  heading?: Maybe<Scalars['String']['output']>;
  links?: Maybe<Array<ReviewRelatedLinks>>;
};

/** The Link type to encapsulate the properties within each of the links. */
export type ReviewRelatedLinks = {
  __typename?: 'ReviewRelatedLinks';
  text: Scalars['String']['output'];
  url: Scalars['String']['output'];
};

/** Types of TemplateSections for a Roundup. */
export enum RoundupTemplateSectionTypeEnum {
  Header = 'HEADER',
  Insurance = 'INSURANCE',
  RecapWithAccordion = 'RECAP_WITH_ACCORDION',
  IntroContent = 'INTRO_CONTENT',
  NerdyTip = 'NERDY_TIP',
  GeodataDropdown = 'GEODATA_DROPDOWN',
  SummaryTablePretty = 'SUMMARY_TABLE_PRETTY',
  ProductCards = 'PRODUCT_CARDS',
  SmbAggregatorPartnership = 'SMB_AGGREGATOR_PARTNERSHIP',
  LearnContent = 'LEARN_CONTENT',
  CrossSellModule = 'CROSS_SELL_MODULE',
  UpdatedDate = 'UPDATED_DATE',
  Methodology = 'METHODOLOGY',
  Recap = 'RECAP',
  Faq = 'FAQ',
  AuthorBox = 'AUTHOR_BOX',
  FooterPosts = 'FOOTER_POSTS',
  CompareBar = 'COMPARE_BAR',
  SideBySideCompare = 'SIDE_BY_SIDE_COMPARE'
}

/** Types of tabbed content that may appear within Roundup product cards. */
export enum ProductCardContentTabEnum {
  KeyFacts = 'KEY_FACTS',
  ProductDetails = 'PRODUCT_DETAILS',
  ProsCons = 'PROS_CONS',
  WhyWeLikeIt = 'WHY_WE_LIKE_IT'
}

/** Describes a category that contains a group of roundup sections to display */
export type RoundupCategorySection = {
  __typename?: 'RoundupCategorySection';
  /** The eyebrow text that prepends the category title in the Product Cards section of a roundup */
  eyebrowText?: Maybe<Scalars['String']['output']>;
  /** The name of the roundup category to be displayed in the Product Cards section of a roundup */
  title?: Maybe<Scalars['String']['output']>;
  /** The description of the roundup category to be displayed in the Product Cards section of a roundup */
  description?: Maybe<Scalars['String']['output']>;
  /** The text to show in spotlights promotional description for this product card. */
  spotlightDetails?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The text to show in spotlights heading title banner for this product card. */
  spotlightHeading?: Maybe<Scalars['String']['output']>;
  /** The list of product cards to display for this roundup category */
  productCards?: Maybe<Array<RoundupSection>>;
  /** The list of all product cards to display for this roundup category */
  allProductCards?: Maybe<Array<RoundupSection>>;
};

/** Describes the details of the recap list section of a roundup */
export type RecapListDetails = {
  __typename?: 'RecapListDetails';
  /** The title to use for the recap list section */
  title: Scalars['String']['output'];
  recapItems?: Maybe<Array<RoundupSection>>;
};


/** Describes the details of the recap list section of a roundup */
export type RecapListDetailsRecapItemsArgs = {
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Describes a card in the roundup's cross sell section */
export type RoundupCrossSellSection = {
  __typename?: 'RoundupCrossSellSection';
  /** The tracking params that should be appended to this cross sell section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The marketplace entity associated with this cross sell section */
  marketplaceEntity: MarketplaceEntityInterface;
  /**
   * The raw marketplace entity for this cross sell section
   *   TODO: replace with a proper marketplaceEntity schema
   */
  rawMarketplaceEntity: Scalars['JSON']['output'];
  /**
   * The drivers to display for this marketplaceEntity's product card when drivers
   *   are defined, i.e for Credit Card Roundups
   *   Returns null when there are no specific drivers defined
   */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
};

/** Input to determine if geotargeting test is active and it's marketing region */
export type GeotargetingAbTestInput = {
  isTestActive?: InputMaybe<Scalars['Boolean']['input']>;
  marketingRegion?: InputMaybe<Scalars['String']['input']>;
};

/** Describes the details of the cross sell section of a roundup */
export type RoundupCrossSellDetails = {
  __typename?: 'RoundupCrossSellDetails';
  productCards?: Maybe<Array<RoundupCrossSellSection>>;
  subtext: Scalars['String']['output'];
};


/** Describes the details of the cross sell section of a roundup */
export type RoundupCrossSellDetailsProductCardsArgs = {
  crossSellVariant?: InputMaybe<Scalars['String']['input']>;
};

/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetails = {
  __typename?: 'RoundupProductCardsDetails';
  /** The list of category sections to display in the Product Cards Section */
  categorySections?: Maybe<Array<RoundupCategorySection>>;
  /** The title to use for the product cards section. */
  title?: Maybe<Scalars['String']['output']>;
  /** The content tabs to display within the product cards. */
  contentTabs?: Maybe<Array<ProductCardContentTabEnum>>;
};


/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetailsCategorySectionsArgs = {
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestCCEPCProductOrderingIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestBmlRedesignIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestCCGeotargeting?: InputMaybe<GeotargetingAbTestInput>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Describes the details of the product cards section of a roundup */
export type RoundupProductCardsDetailsContentTabsArgs = {
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Describes the details of the summary table section of a roundup */
export type RoundupSummaryTableDetails = {
  __typename?: 'RoundupSummaryTableDetails';
  /** Whether to enable row truncation behavior */
  allowTruncatingRows: Scalars['Boolean']['output'];
  /** Text to be added at the bottom of the summary table */
  disclaimerText?: Maybe<Scalars['String']['output']>;
  /** Title that should be used as the header for each marketplace entity */
  marketplaceEntityHeader: Scalars['String']['output'];
  /** The maximum number of rows that can be present before any truncation can be applied */
  maxRows: Scalars['Int']['output'];
  /** The number of rows to show after applying truncation */
  numTruncatedRows: Scalars['Int']['output'];
  /** The rows within the summary table */
  rows?: Maybe<Array<RoundupSection>>;
  /** The title to use for the Summary Table Section */
  title: Scalars['String']['output'];
};


/** Describes the details of the summary table section of a roundup */
export type RoundupSummaryTableDetailsRowsArgs = {
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestCCEPCProductOrderingIsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestCCGeotargeting?: InputMaybe<GeotargetingAbTestInput>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Types of drivers variations for a Roundup section */
export enum DriversVariationTypeEnum {
  DefaultDrivers = 'DEFAULT_DRIVERS',
  NativeDrivers = 'NATIVE_DRIVERS'
}

/** Types of Product Cards for a Roundup */
export enum ProductCardComponentEnum {
  Institution = 'INSTITUTION',
  Keto = 'KETO',
  MarketplaceProductCard = 'MARKETPLACE_PRODUCT_CARD',
  Slim = 'SLIM'
}

export type TrackingParam = {
  __typename?: 'TrackingParam';
  key: Scalars['String']['output'];
  value: Scalars['String']['output'];
};

/** The TableColumn type to encapsulate the properties within each of the columns on a table. */
export type TableColumn = {
  __typename?: 'TableColumn';
  /** The heading for the column. */
  heading?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The unique ID for the table to use for mapping the rows to each column, and for using as a key in React. */
  id: Scalars['ID']['output'];
  /** Whether or not the column should be centered. */
  isCentered: Scalars['Boolean']['output'];
  /** The number of columns a table cell should span. */
  colspan?: Maybe<Scalars['Int']['output']>;
};

/** The available centering options for rows and columns within a table. */
export enum TableCenteringOptionsEnum {
  First = 'FIRST',
  Last = 'LAST'
}

/** The return type of publish a single Yak message */
export type PublishYakMessageResult = {
  __typename?: 'PublishYakMessageResult';
  /** Whether the message was published successfully */
  success: Scalars['Boolean']['output'];
};

/** The input type representing the Yak message to be published */
export type YakMessageInput = {
  /**
   * The Yak exchange to which the message should be delivered. Supplied on the message envelope.
   *
   *   Example: `ANALYTIC_PIPELINE_MOUTH`
   */
  exchangeId: Scalars['String']['input'];
  /** A GUID (UUID) for this specific message. Supplied on the message envelope. */
  id?: InputMaybe<Scalars['String']['input']>;
  /**
   * The Yak message type. Supplied on the message envelope.
   *
   *   Example: `navigate` (for a navigation analytics event)
   */
  type?: InputMaybe<Scalars['String']['input']>;
  /** The Yak message subtype. Supplied on the message envelope. */
  subType?: InputMaybe<Scalars['String']['input']>;
  /** The Yak message payload. */
  payload?: InputMaybe<Scalars['JSON']['input']>;
};

export type VideoThumbnail = {
  __typename?: 'VideoThumbnail';
  /** The image's URL. */
  url: Scalars['String']['output'];
  /** The image's width. */
  width: Scalars['Int']['output'];
  /** The image's height. */
  height: Scalars['Int']['output'];
};

export type YoutubeThumbnail = {
  __typename?: 'YoutubeThumbnail';
  /** The default thumbnail image. */
  default?: Maybe<VideoThumbnail>;
  /** A higher resolution version of the thumbnail image. For a video (or a resource that refers to a video), this image is 320px wide and 180px tall. */
  medium?: Maybe<VideoThumbnail>;
  /** A high resolution version of the thumbnail image. For a video (or a resource that refers to a video), this image is 480px wide and 360px tall. */
  high?: Maybe<VideoThumbnail>;
  /** An even higher resolution version of the thumbnail image than the high resolution image. This image is available for some videos and other resources that refer to videos, like playlist items or search results */
  standard?: Maybe<VideoThumbnail>;
  /** The highest resolution version of the thumbnail image. This image size is available for some videos and other resources that refer to videos, like playlist items or search results. */
  maxres?: Maybe<VideoThumbnail>;
};

export type YoutubeSnippetObject = {
  __typename?: 'YoutubeSnippetObject';
  /** The date and time that the video was published. Note that this time might be different than the time that the video was uploaded. */
  publishedAt: Scalars['String']['output'];
  /** The ID that YouTube uses to uniquely identify the channel that the video was uploaded to. */
  channelId: Scalars['String']['output'];
  /** The video's title. The property value has a maximum length of 100 characters and may contain all valid UTF-8 characters except < and > */
  title: Scalars['String']['output'];
  /** The video's description. The property value has a maximum length of 5000 bytes and may contain all valid UTF-8 characters except < and >. */
  description: Scalars['String']['output'];
  /** A map of thumbnail images associated with the video. */
  thumbnails?: Maybe<YoutubeThumbnail>;
  /** Channel title for the channel that the video belongs to. */
  channelTitle: Scalars['String']['output'];
};

export type YoutubeVideoContentDetails = {
  __typename?: 'YoutubeVideoContentDetails';
  /** The length of the video. The property value is an ISO 8601 duration. */
  duration: Scalars['String']['output'];
};

export type YoutubePlayerDetails = {
  __typename?: 'YoutubePlayerDetails';
  /** An <iframe> tag that embeds a player that plays the video. */
  embedHtml: Scalars['String']['output'];
  /** The height of the embedded player returned in the player.embedHtml property. This property is only returned if the request specified a value for the maxHeight and/or maxWidth parameters and the video's aspect ratio is known. */
  embedHeight?: Maybe<Scalars['BigInt']['output']>;
  /** The width of the embedded player returned in the player.embedHtml property. This property is only returned if the request specified a value for the maxHeight and/or maxWidth parameters and the video's aspect ratio is known. */
  embedWidth?: Maybe<Scalars['BigInt']['output']>;
};

export type YoutubeVideo = {
  __typename?: 'YoutubeVideo';
  /** Unique ID of a Youtube Video */
  id: Scalars['ID']['output'];
  /** API resource's type */
  kind: Scalars['String']['output'];
  /** The snippet object contains basic details about the video, such as its title, description, and category */
  snippet?: Maybe<YoutubeSnippetObject>;
  /** The contentDetails object contains information about the video content, including the length of the video and an indication of whether captions are available for the video */
  contentDetails?: Maybe<YoutubeVideoContentDetails>;
  /** The player object contains information that you would use to play the video in an embedded player. */
  player?: Maybe<YoutubePlayerDetails>;
};

export type CreditCardApprovalOddsPrediction = {
  __typename?: 'CreditCardApprovalOddsPrediction';
  /** A user's likelihood of being approved for a credit card as a decimal value. */
  approvalOdds?: Maybe<Scalars['Float']['output']>;
  /**
   * The ID of the credit card that the approval odds have been calculated for. This ID
   *   corresponds to a CreditCardOfferV2's id field.
   */
  id: Scalars['String']['output'];
  /** The name of the offer */
  name: Scalars['String']['output'];
};

export type CreditCardApprovalOddsPredictionResponse = {
  __typename?: 'CreditCardApprovalOddsPredictionResponse';
  predictions: Array<CreditCardApprovalOddsPrediction>;
};

export type CreditCardOfferIdsWithApprovalOddsPredictionResponse = {
  __typename?: 'CreditCardOfferIdsWithApprovalOddsPredictionResponse';
  offerIds: Array<Scalars['Int']['output']>;
};

/** TU fraud engine decisions */
export enum FraudEngineDecision {
  Pass = 'PASS',
  Ban = 'BAN',
  Block = 'BLOCK',
  RequireSms = 'REQUIRE_SMS'
}

/** TU pre-generated mock reports */
export enum TuMockReportType {
  Default = 'default',
  Debt = 'debt'
}

/** Identity Test States */
export type IdentityTestStates = {
  __typename?: 'IdentityTestStates';
  /** Automatically mark an identity's email as verified during registration */
  autoVerifyEmail?: Maybe<Scalars['Boolean']['output']>;
  /** Automatically grant an identity the 'nerdwallet/quality-assurance' role during registration */
  autoGrantQaRole?: Maybe<Scalars['Boolean']['output']>;
};

/** Identity Test States (input) */
export type IdentityTestStatesInput = {
  /** Automatically mark an identity's email as verified during registration */
  autoVerifyEmail?: InputMaybe<Scalars['Boolean']['input']>;
  /** Automatically grant an identity the 'nerdwallet/quality-assurance' role during registration */
  autoGrantQaRole?: InputMaybe<Scalars['Boolean']['input']>;
};

/** SMS Test States */
export type SmsTestStates = {
  __typename?: 'SmsTestStates';
  /** Skip actual sending of SMS verification messages */
  skipSend?: Maybe<Scalars['Boolean']['output']>;
  /** Cause SMS verification to always succeed, regardless of what code is entered */
  alwaysSucceed?: Maybe<Scalars['Boolean']['output']>;
  /** Allow SMS verification sending to proceed even if the phone number doesn't pass Twilio validation */
  allowAnyNumber?: Maybe<Scalars['Boolean']['output']>;
  /** Allow SMS verification sending to proceed even if it will change the phone number on file for the identity */
  allowNumberChange?: Maybe<Scalars['Boolean']['output']>;
  /** Allow SMS verification sending to proceed even if the phone number is already associated with other identities */
  allowDuplicateNumber?: Maybe<Scalars['Boolean']['output']>;
};

/** SMS Test States (input) */
export type SmsTestStatesInput = {
  /** Skip actual sending of SMS verification messages */
  skipSend?: InputMaybe<Scalars['Boolean']['input']>;
  /** Cause SMS verification to always succeed, regardless of what code is entered */
  alwaysSucceed?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow SMS verification sending to proceed even if the phone number doesn't pass Twilio validation */
  allowAnyNumber?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow SMS verification sending to proceed even if it will change the phone number on file for the identity */
  allowNumberChange?: InputMaybe<Scalars['Boolean']['input']>;
  /** Allow SMS verification sending to proceed even if the phone number is already associated with other identities */
  allowDuplicateNumber?: InputMaybe<Scalars['Boolean']['input']>;
};

/** TU Test States */
export type TuTestStates = {
  __typename?: 'TuTestStates';
  /** TBD Record<string, any> | null; */
  blocked?: Maybe<Scalars['String']['output']>;
  /** TBD Record<string, any> | null; */
  mockAlerts?: Maybe<Scalars['String']['output']>;
  /** TBD */
  fixedCreditReport?: Maybe<Scalars['Boolean']['output']>;
  /** Override the "TU anti-fraud engine library" decision during TU onboarding */
  fraudEngineDecisionOverride?: Maybe<FraudEngineDecision>;
  /** Always pass TU onboarding and use one of our pre-generated mock reports */
  alwaysPassOnboardingWithMockReport?: Maybe<TuMockReportType>;
};

/** TU Test States (input) */
export type TuTestStatesInput = {
  /** TBD Record<string, any> | null; */
  blocked?: InputMaybe<Scalars['String']['input']>;
  /** TBD Record<string, any> | null; */
  mockAlerts?: InputMaybe<Scalars['String']['input']>;
  /** TBD */
  fixedCreditReport?: InputMaybe<Scalars['Boolean']['input']>;
  /** Override the "TU anti-fraud engine library" decision during TU onboarding */
  fraudEngineDecisionOverride?: InputMaybe<FraudEngineDecision>;
  /** Always pass TU onboarding and use one of our pre-generated mock reports */
  alwaysPassOnboardingWithMockReport?: InputMaybe<TuMockReportType>;
};

/** Test States */
export type ServiceTestState = {
  __typename?: 'ServiceTestState';
  /** antifraud */
  antifraud?: Maybe<Scalars['Boolean']['output']>;
  /** captcha */
  captcha?: Maybe<Scalars['Boolean']['output']>;
  /** Identity Test States */
  identity?: Maybe<IdentityTestStates>;
  /** SMS Test States */
  sms?: Maybe<SmsTestStates>;
  /** TU Test States */
  tu?: Maybe<TuTestStates>;
};

/** Test States (input) */
export type ServiceTestStateInput = {
  /** antifraud */
  antifraud?: InputMaybe<Scalars['Boolean']['input']>;
  /** captcha */
  captcha?: InputMaybe<Scalars['Boolean']['input']>;
  /** Identity Test States */
  identity?: InputMaybe<IdentityTestStatesInput>;
  /** SMS Test States */
  sms?: InputMaybe<SmsTestStatesInput>;
  /** TU Test States */
  tu?: InputMaybe<TuTestStatesInput>;
};

/** Service Test State Profile */
export type ServiceTestStateProfile = {
  __typename?: 'ServiceTestStateProfile';
  /** Profile Id */
  id?: Maybe<Scalars['ID']['output']>;
  /** Identity Id */
  identityId?: Maybe<Scalars['String']['output']>;
  /** Test States */
  testState?: Maybe<ServiceTestState>;
};

/** Generated report containing Healthability information for a given repo */
export type HealthabilityReport = {
  __typename?: 'HealthabilityReport';
  /** Metadata properties for the given HealthabilityReport */
  meta?: Maybe<HealthabilityMeta>;
  /** An array of HealthabilitySpecs containing information about the given repo */
  specs?: Maybe<Array<HealthabilitySpec>>;
  /** An array containing all the BuildSpecs that were active when Healthability ran */
  buildSpecs?: Maybe<Array<BuildSpec>>;
  /** The number of views that this application received in the last 30 days, if applicable */
  cumulativeViewCount?: Maybe<Scalars['Int']['output']>;
};

/** Metadata properties for the given HealthabilityReport */
export type HealthabilityMeta = {
  __typename?: 'HealthabilityMeta';
  /** Indy version used to generate the HealthabilityReport */
  indyVersion: Scalars['String']['output'];
  /** Name of the repo Healthability ran on to generate the given HealthabilityReport */
  repoName: Scalars['String']['output'];
  /** Repo version Healthability ran on to generate the given HealthabilityReport */
  repoVersion: Scalars['String']['output'];
  /** Time when the HealthabilityReport was generated */
  time: Scalars['String']['output'];
};

/** Encapsulate information regarding a specific type of technical debt */
export type HealthabilitySpec = {
  __typename?: 'HealthabilitySpec';
  /** Name of the HealthabilitySpec */
  name: Scalars['String']['output'];
  /** Human-readable title of the HealthabilitySpec */
  title: Scalars['String']['output'];
  /** Indicates whether the HealthabilitySpec is scored or unscored */
  scored: Scalars['Boolean']['output'];
  /** Maximum points possible for the given HealthabilitySpec */
  maxPoints: Scalars['Int']['output'];
  /** Points achieved by the repo for the given HealthabilitySpec */
  points: Scalars['Int']['output'];
  /** Indicates whether the results of the HealthabilitySpec is displayed to console, and on PR comments */
  disabled: Scalars['Boolean']['output'];
  /** Detailed feedback surfacing detected technical debt and suggested improvements for the given HealthabilitySpec */
  comments: Scalars['String']['output'];
  /** Indicates whether the HealthabilitySpec errored during execution */
  errored: Scalars['Boolean']['output'];
  /** Optional summary of the comments for the spec */
  summary?: Maybe<Scalars['String']['output']>;
};

export type BuildSpec = {
  __typename?: 'BuildSpec';
  /** The name of the build spec, e.g. "NodeSpec" */
  name: Scalars['String']['output'];
  /** The TARGET file of the spec, e.g. "package.json" */
  target: Scalars['String']['output'];
};

/** A Insurance offer */
export type InsuranceOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'InsuranceOfferV2';
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** Short summary of why NerdWallet recommends this insurance offer (offer-level). */
  bottomLineText?: Maybe<Scalars['String']['output']>;
  /** The highest coverage limit the company offers per year. */
  annualMaxCoverage?: Maybe<Scalars['String']['output']>;
  /** The highest coverage limit the company offers per year. */
  driverAnnualMaxCoverage?: Maybe<EntityPlacementDriver>;
  /** Options for how much the insurer will reimburse you after you’ve met your deductible. */
  reimbursementRates?: Maybe<Scalars['String']['output']>;
  /** Options for how much the insurer will reimburse you after you’ve met your deductible. */
  driverReimbursementRates?: Maybe<EntityPlacementDriver>;
  /** Options for how much of your vet expenses you need to pay before the insurer starts reimbursing you. */
  deductibles?: Maybe<Scalars['String']['output']>;
  /** Options for how much of your vet expenses you need to pay before the insurer starts reimbursing you. */
  driverDeductibles?: Maybe<EntityPlacementDriver>;
  /** A standout feature of this company’s plans. */
  policyHighlight?: Maybe<Scalars['String']['output']>;
  /** A standout feature of this company’s plans. */
  driverPolicyHighlight?: Maybe<EntityPlacementDriver>;
  /** The tooltip value that should be displayed alongside the entity name */
  displayNameTooltip?: Maybe<Scalars['String']['output']>;
  /** The driver can buy online associated with the entity */
  driverCanBuyOnline?: Maybe<EntityPlacementDriver>;
  /** The driver coverage options associated with the entity */
  driverCoverageOptions?: Maybe<EntityPlacementDriver>;
  /** The driver discounts associated with the entity */
  driverDiscounts?: Maybe<EntityPlacementDriver>;
  /** The driver ease of use associated with the entity */
  driverEaseOfUse?: Maybe<EntityPlacementDriver>;
  /** The driver NAIC complaints associated with the entity */
  driverNAICComplaints?: Maybe<EntityPlacementDriver>;
  /** The driver financial strength rating associated with the entity */
  driverFinancialStrengthRating?: Maybe<EntityPlacementDriver>;
  /** The driver policies offered associated with the entity */
  driverPoliciesOffered?: Maybe<EntityPlacementDriver>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
  /** Cons bullet points */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Phone number by carrier */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  product: InsuranceProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** Pros bullet points */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Offer rank based on QS ranking. 1 to X */
  rank?: Maybe<Scalars['Int']['output']>;
  /** The URL to the NerdWallet review of this offer's product. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Short summary of why NerdWallet recommends this insurance provider */
  tagline?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Ability to customize plan, options are 'poor', 'below average', 'average', 'good', 'excellent' */
  abilityToCustomizePlan?: Maybe<Scalars['String']['output']>;
  /** Pay vet directly, options are 'yes', 'no' */
  payVetDirectly?: Maybe<Scalars['String']['output']>;
  /** Scope of coverage, options are 'poor', 'below average', 'average', 'good', 'excellent' */
  scopeOfCoverage?: Maybe<Scalars['String']['output']>;
  /** Consumer experience, options are 'below average', 'average', 'above average' */
  consumerExperience?: Maybe<Scalars['String']['output']>;
  /** Costs, options are 'cheap', 'lower cost', 'average cost', 'higher cost', 'expensive' */
  costs?: Maybe<Scalars['String']['output']>;
  /** EPC (Earning Per Click) that we a user clicks a monetizing link */
  epc?: Maybe<Scalars['Float']['output']>;
  /** Monetizing click URL, as provided by the partner API */
  clickUrl?: Maybe<Scalars['URL']['output']>;
  /** Impression Pixel, as provided by the partner API */
  impressionPixel?: Maybe<Scalars['URL']['output']>;
  /** CMS star rating */
  cmsStarRating?: Maybe<Scalars['Float']['output']>;
  /** Tooltip for the CMS star rating */
  cmsStarRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Cost sharing */
  costSharing?: Maybe<Scalars['String']['output']>;
  /** Annotation for the CTA button */
  ctaAnnotation?: Maybe<Scalars['String']['output']>;
  /** Label */
  label?: Maybe<Scalars['String']['output']>;
  /** Medicare plan type */
  medicarePlanType?: Maybe<Scalars['String']['output']>;
  /** Medicare in high rated plans */
  memberInHighRatedPlans?: Maybe<Scalars['String']['output']>;
  /** Member satisfaction */
  memberSatisfaction?: Maybe<Scalars['String']['output']>;
  /** NAIC complaints annotation */
  naicComplaintsAnnotation?: Maybe<Scalars['String']['output']>;
  /** Phone number for this Offer */
  offerPhoneNumber?: Maybe<Scalars['String']['output']>;
  /** Annotation for the phone number */
  offerPhoneNumberAnnotation?: Maybe<Scalars['String']['output']>;
  /** TTY number for this Offer */
  offerTtyNumber?: Maybe<Scalars['String']['output']>;
  /** Plan types offered */
  planTypesOffered?: Maybe<Scalars['String']['output']>;
  /** Premium discounts available */
  premiumDiscountsAvailable?: Maybe<Scalars['String']['output']>;
  /** State available */
  stateAvailable?: Maybe<Scalars['String']['output']>;
  /** Special phone number for persons with a hearing or speech disability */
  ttyNumber?: Maybe<Scalars['String']['output']>;
  /** Working schedule for this Offer */
  wokingSchedule?: Maybe<Scalars['String']['output']>;
};

/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePage = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'InsurancePage';
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The state the content on the insurance page is for. */
  state?: Maybe<Scalars['String']['output']>;
  /** The city the content on the insurance page is for. */
  city?: Maybe<Scalars['String']['output']>;
  /** The make of the car this insurance page is for. */
  make?: Maybe<Scalars['String']['output']>;
  /** The model of the car this insurance page is for. */
  model?: Maybe<Scalars['String']['output']>;
  /** Determines if data exists in DRC to support the city or vehicle page */
  hasDRCData?: Maybe<Scalars['Boolean']['output']>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the InsurancePage object. */
  categories?: Maybe<Array<Category>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** The type of insurance page. */
  insurancePageType?: Maybe<InsurancePageTypeEnum>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The pricing code for an insurance page. Default: 665689. */
  pricingCode?: Maybe<Scalars['String']['output']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** The URL path to query for Insurance Pages by. */
  url?: Maybe<Scalars['URL']['output']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
};


/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePageDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePageModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_ins_page post type from WordPress. */
export type InsurancePageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

export type SearchResultsPage = StructuredContentPageInterface & {
  __typename?: 'SearchResultsPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type CostOfLivingCity = CostOfLivingCityFields & {
  __typename?: 'CostOfLivingCity';
  slug: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  state_abbr: Scalars['String']['output'];
  has_city_life_data: Scalars['Boolean']['output'];
  photo?: Maybe<Scalars['String']['output']>;
  suggested_ranking?: Maybe<Scalars['Int']['output']>;
  milk_cost?: Maybe<Scalars['Float']['output']>;
  eggs_cost?: Maybe<Scalars['Float']['output']>;
  bread_cost?: Maybe<Scalars['Float']['output']>;
  apt_rent_cost?: Maybe<Scalars['Float']['output']>;
  home_cost?: Maybe<Scalars['Float']['output']>;
  mortgage_plus_interest_cost?: Maybe<Scalars['Float']['output']>;
  gas_cost?: Maybe<Scalars['Float']['output']>;
  optometrist_cost?: Maybe<Scalars['Float']['output']>;
  doctor_cost?: Maybe<Scalars['Float']['output']>;
  dentist_cost?: Maybe<Scalars['Float']['output']>;
  lipitor_cost?: Maybe<Scalars['Float']['output']>;
  quarter_pounder_cost?: Maybe<Scalars['Float']['output']>;
  pizza_cost?: Maybe<Scalars['Float']['output']>;
  movie_cost?: Maybe<Scalars['Float']['output']>;
  yoga_cost?: Maybe<Scalars['Float']['output']>;
  heineken_cost?: Maybe<Scalars['Float']['output']>;
  composite_index?: Maybe<Scalars['Float']['output']>;
  grocery_index?: Maybe<Scalars['Float']['output']>;
  housing_index?: Maybe<Scalars['Float']['output']>;
  utilities_index?: Maybe<Scalars['Float']['output']>;
  transportation_index?: Maybe<Scalars['Float']['output']>;
  healthcare_index?: Maybe<Scalars['Float']['output']>;
  misc_index?: Maybe<Scalars['Float']['output']>;
  ranking?: Maybe<Scalars['Float']['output']>;
  greatschools_rating?: Maybe<Scalars['Float']['output']>;
};

export type CostOfLivingCityWithCityLife = CostOfLivingCityFields & {
  __typename?: 'CostOfLivingCityWithCityLife';
  slug: Scalars['String']['output'];
  name: Scalars['String']['output'];
  state: Scalars['String']['output'];
  state_abbr: Scalars['String']['output'];
  has_city_life_data: Scalars['Boolean']['output'];
  photo?: Maybe<Scalars['String']['output']>;
  suggested_ranking?: Maybe<Scalars['Int']['output']>;
  milk_cost?: Maybe<Scalars['Float']['output']>;
  eggs_cost?: Maybe<Scalars['Float']['output']>;
  bread_cost?: Maybe<Scalars['Float']['output']>;
  apt_rent_cost?: Maybe<Scalars['Float']['output']>;
  home_cost?: Maybe<Scalars['Float']['output']>;
  mortgage_plus_interest_cost?: Maybe<Scalars['Float']['output']>;
  gas_cost?: Maybe<Scalars['Float']['output']>;
  optometrist_cost?: Maybe<Scalars['Float']['output']>;
  doctor_cost?: Maybe<Scalars['Float']['output']>;
  dentist_cost?: Maybe<Scalars['Float']['output']>;
  lipitor_cost?: Maybe<Scalars['Float']['output']>;
  quarter_pounder_cost?: Maybe<Scalars['Float']['output']>;
  pizza_cost?: Maybe<Scalars['Float']['output']>;
  movie_cost?: Maybe<Scalars['Float']['output']>;
  yoga_cost?: Maybe<Scalars['Float']['output']>;
  heineken_cost?: Maybe<Scalars['Float']['output']>;
  composite_index?: Maybe<Scalars['Float']['output']>;
  grocery_index?: Maybe<Scalars['Float']['output']>;
  housing_index?: Maybe<Scalars['Float']['output']>;
  utilities_index?: Maybe<Scalars['Float']['output']>;
  transportation_index?: Maybe<Scalars['Float']['output']>;
  healthcare_index?: Maybe<Scalars['Float']['output']>;
  misc_index?: Maybe<Scalars['Float']['output']>;
  ranking?: Maybe<Scalars['Float']['output']>;
  greatschools_rating?: Maybe<Scalars['Float']['output']>;
  population?: Maybe<Scalars['Float']['output']>;
  median_age?: Maybe<Scalars['Float']['output']>;
  median_salary?: Maybe<Scalars['Float']['output']>;
  annual_per_capita_income?: Maybe<Scalars['Float']['output']>;
  age_under_18?: Maybe<Scalars['Float']['output']>;
  age_18_to_24?: Maybe<Scalars['Float']['output']>;
  age_25_to_44?: Maybe<Scalars['Float']['output']>;
  age_45_to_64?: Maybe<Scalars['Float']['output']>;
  age_65_plus?: Maybe<Scalars['Float']['output']>;
  percent_population_change?: Maybe<Scalars['Float']['output']>;
  percent_women?: Maybe<Scalars['Float']['output']>;
  percent_foreign_born?: Maybe<Scalars['Float']['output']>;
  percent_home_ownership_rate?: Maybe<Scalars['Float']['output']>;
  percent_below_poverty?: Maybe<Scalars['Float']['output']>;
  persons_per_household?: Maybe<Scalars['Float']['output']>;
  average_travel_time_to_work_min?: Maybe<Scalars['Float']['output']>;
  gyms_per_1000_people?: Maybe<Scalars['Float']['output']>;
  bars_per_1000_people?: Maybe<Scalars['Float']['output']>;
  percent_college?: Maybe<Scalars['Float']['output']>;
  percent_black?: Maybe<Scalars['Float']['output']>;
  percent_asian?: Maybe<Scalars['Float']['output']>;
  percent_latino_or_hispanic?: Maybe<Scalars['Float']['output']>;
  percent_white?: Maybe<Scalars['Float']['output']>;
  percent_other?: Maybe<Scalars['Float']['output']>;
  ratio_unmarried_men_women?: Maybe<Scalars['Float']['output']>;
  unemployment_rate?: Maybe<Scalars['Float']['output']>;
  diversity_index?: Maybe<Scalars['Float']['output']>;
  violent_crime_rate?: Maybe<Scalars['Float']['output']>;
  walkscore?: Maybe<Scalars['Float']['output']>;
  walkscore_explanation?: Maybe<Scalars['String']['output']>;
  walkscore_link?: Maybe<Scalars['String']['output']>;
  public_transit_score?: Maybe<Scalars['Float']['output']>;
  total_private_schools?: Maybe<Scalars['Float']['output']>;
  total_private_k_8_schools?: Maybe<Scalars['Float']['output']>;
  total_private_high_schools?: Maybe<Scalars['Float']['output']>;
  private_school_tuition_cost?: Maybe<Scalars['Float']['output']>;
  weather?: Maybe<Scalars['String']['output']>;
};

export type CostOfLivingCalculatorPage = StructuredContentPageInterface & {
  __typename?: 'CostOfLivingCalculatorPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

/**
 * Annual Income Pre Fill Field
 * Our GraphQL Schema will be our source of truth for documentation
 * Once we standardize these fields we will provide information here
 */
export type AnnualIncome = BaseField & {
  __typename?: 'AnnualIncome';
  /** Value of the field */
  value?: Maybe<Scalars['String']['output']>;
};

export type Age = BaseField & {
  __typename?: 'Age';
  /** Value of the field */
  value?: Maybe<Scalars['String']['output']>;
};

export type ZipCode = BaseField & {
  __typename?: 'ZipCode';
  /** Value of the field */
  value?: Maybe<Scalars['String']['output']>;
};

/** A Credit Cards offer */
export type CreditCardsOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'CreditCardsOfferV2';
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  crinkoDetails?: Maybe<CrinkoDetails>;
  /** Numeric value of a product's annual fee. */
  annualFee?: Maybe<Scalars['Float']['output']>;
  /** Stylized version of annual fee + annual_fee_first_year. ex. '$0*' or '$0 intro first year, then $95' */
  annualFeeDetails?: Maybe<Scalars['String']['output']>;
  /** Numeric value of the product's first year annual fee. This should match annual_fee if the card doesn't have a special fee in the first year. */
  annualFeeFirstYear?: Maybe<Scalars['Float']['output']>;
  /** The offer_url or issuer_info_page_url for this cc offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** The approval calculation for logged in members. */
  approvalLikelihood?: Maybe<Scalars['Float']['output']>;
  /** List of stylized APRs. Typically shown under Ongoing APR on Card Details pages. */
  aprDisplayList?: Maybe<Array<Scalars['String']['output']>>;
  /** Powers the shortcodes Content uses to discuss Intro Apr:  ex. '0% intro APR on Purchases for 15 months, and then the ongoing APR of 14.99% - 23.74% Variable APR' */
  aprIntroMessage?: Maybe<Scalars['String']['output']>;
  /** Displays short version of intro text. Usually under 'Intro APR' field on Card Details and Product Cards */
  aprIntroMessageList?: Maybe<Array<Scalars['String']['output']>>;
  /** Numeric value for high end of APR range. ex. '23.74' */
  aprMax?: Maybe<Scalars['Float']['output']>;
  /** Numeric value for low end of APR range. ex. '14.99' */
  aprMin?: Maybe<Scalars['Float']['output']>;
  /** Used to display greater details of a balance transfer fee. ex. 'Either $5 or 5% of the amount of each transfer, whichever is greater.' */
  balanceTransferFeeDescription?: Maybe<Scalars['String']['output']>;
  /** Numeric value of balance transfer intro APR */
  balanceTransferIntroApr?: Maybe<Scalars['Float']['output']>;
  /** Numeric value for the number of months the intro APR applies to a balance transfer */
  balanceTransferIntroTime?: Maybe<Scalars['Int']['output']>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
  /** 'Months' or 'Billing Cycles' */
  billingCycleUnits?: Maybe<Scalars['String']['output']>;
  /** Categorizes cards and makes them eligible to show up in different site features, like site search, and compare marketplace. */
  compareCategories?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Populates the 'great for' text on Marketplace Landing Pages. ex. 'Great for: Airline Miles and a Large Bonus' */
  customDetailsList?: Maybe<Array<Scalars['String']['output']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** This credit card is eligible for an additional $100 bonus when user joins the NerdWallet+ rewards program, and pays their first statement on time. */
  eligibleForNerdWalletPlusBonus?: Maybe<Scalars['Boolean']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** Stylized version of foreign transaction fee ex. '0%' or '3% of each transaction in U.S. dollars' */
  foreignTransactionFeeDescription?: Maybe<Scalars['String']['output']>;
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Balance transfer portion of text from Intro APR ex. '0% intro APR for 18 billing cycles on any balance transfers made in the first 60 days' */
  introBalanceTransfers?: Maybe<Scalars['String']['output']>;
  /** Purchases portion of text from Intro APR ex. '0% intro APR for 18 billing cycles on purchases' */
  introPurchases?: Maybe<Scalars['String']['output']>;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Used to store product details page on issuer site. Particularly when that page is hard to locate. */
  issuerInfoPageUrl?: Maybe<Scalars['String']['output']>;
  /** The late payment fee in dollars. */
  latePaymentFee?: Maybe<Scalars['Int']['output']>;
  /** The late payment fee as as a string as provided by the partner. */
  latePaymentFeeDescription?: Maybe<Scalars['String']['output']>;
  /** Legacy ID used by some Credit Card specific components. */
  legacyId?: Maybe<Scalars['Int']['output']>;
  /** More information about the product. Appears under 'Card Details' or 'Product Details' depending on the experience. It does not include the 'See Rates and Fees' link when applicable. */
  marketingBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum reccommended FICO score */
  maxFico?: Maybe<Scalars['Int']['output']>;
  /** Minimum reccommended FICO score */
  minFico?: Maybe<Scalars['Int']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Displays the range of the ongoing APR */
  ongoingApr?: Maybe<Scalars['String']['output']>;
  /** A product's apply by phone telephone number, if applicable. Displays below the CTA on product cards, typically. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Path for Prequal CTAs when applicable */
  prequalLink?: Maybe<Scalars['URL']['output']>;
  /** Display text for Prequal CTA or Link */
  prequalLinkText?: Maybe<Scalars['String']['output']>;
  product: CreditCardsProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Numeric value of purchase intro APR */
  purchaseIntroApr?: Maybe<Scalars['Float']['output']>;
  /** Numeric value for the number of months the intro APR applies to purchases */
  purchaseIntroTime?: Maybe<Scalars['Int']['output']>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** Numeric value of the base reward rate of the product */
  rewardRate?: Maybe<Scalars['Float']['output']>;
  /** String value of the rewards rate range for the product. ex. '1.5%-5%' */
  rewardRateDetails?: Maybe<Scalars['String']['output']>;
  /** Full, detailed text of the rewards rates for the product. ex. 'Earn 5% cash back on grocery store purchases (not including Target® or Walmart® purchases) on up to $12,000 spent in the first year. Earn unlimited 1.5% cash back on all other purchases.' */
  rewardRateNotes?: Maybe<Scalars['String']['output']>;
  /** Currency type for the reward program. ex. CASH, POINTS, MILES, or NO REWARDS */
  rewardType?: Maybe<Scalars['String']['output']>;
  /** Numeric value of the product's intro offer */
  signUpBonus?: Maybe<Scalars['Int']['output']>;
  /** Please make sure the text in this field ends with a period. Description of terms to earn intro offer. ex. 'Earn a $200 Bonus after you spend $500 on purchases in your first 3 months from account opening.' */
  signUpBonusDetails?: Maybe<Scalars['String']['output']>;
  /** Please make sure the text in this field ends with a period. Should match sign_up_bonus_details. Unless the product is from Discover and has a Match feature as an Intro Offer. */
  signUpBonusDetailsAnnotation?: Maybe<Scalars['String']['output']>;
  /** The type of bonus received for signing up to this card. Can be different to the Reward bonus. */
  signUpBonusType?: Maybe<Scalars['String']['output']>;
  /** Path to the product's card details page. Keep it simple, and avoid including payment network where possible. ex. 'chase-freedom-unlimited' or 'us-bank-altitude-go-card' */
  slug?: Maybe<Scalars['String']['output']>;
  /** Numeric value of the rating Content has assigned the product */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Prefer this over terms_and_fees_link since this goes to interstitial-client. Link to a product's rates & fees. Should display Rates & fees on most product cards on the site. Marketing bullets require you to add the link directly there. */
  termsAndFeesLink?: Maybe<Scalars['URL']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The credit score comparison content used to display to the user information regarding how close the user is to the preferred offer score. */
  creditScoreComparisonContent?: Maybe<CreditCardsCreditScoreComparisonContent>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver annual fee associated with the entity */
  driverAnnualFee?: Maybe<EntityPlacementDriver>;
  /** The driver balance transfer fee description associated with the entity */
  driverBalanceTransferFeeDescription?: Maybe<EntityPlacementDriver>;
  /** The driver bonus associated with the entity */
  driverBonus?: Maybe<EntityPlacementDriver>;
  /** The driver foreign transaction fee associated with the entity */
  driverForeignTransactionFee?: Maybe<EntityPlacementDriver>;
  /** The driver intro APR associated with the entity */
  driverIntroApr?: Maybe<EntityPlacementDriver>;
  /** The driver intro offer associated with the entity */
  driverIntroOffer?: Maybe<EntityPlacementDriver>;
  /** The driver minimum deposit associated with the entity */
  driverMinimumDeposit?: Maybe<EntityPlacementDriver>;
  /** The driver regular APR associated with the entity */
  driverRegularApr?: Maybe<EntityPlacementDriver>;
  /** The driver reward rate associated with the entity */
  driverRewardRate?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A secondary placement config CTA reserved for monetizing marketplace entities */
  ratesAndFeesCta?: Maybe<EntityPlacementCta>;
  /** The recommended credit score range text */
  recommendedCreditScoreRangeDetails?: Maybe<CreditCardsRecommendedCreditScoreRangeDetails>;
  /** Connection field to the review */
  review?: Maybe<MarketplaceEntityRelatedReviewUnion>;
  /** Detailed bullets about the cards' reward rates */
  rewardsRates?: Maybe<Array<RewardsRate>>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
  /** Flag for if this credit card supports a limited credit history */
  limitedCreditHistory: Scalars['Boolean']['output'];
  /** The processing network ass ociated with the entity (E.g.: visa, mastercard) */
  processingNetwork?: Maybe<Scalars['String']['output']>;
};

/** A Insurance product */
export type InsuranceProductV2 = MarketplaceEntityInterface & MarketplaceEntityWithReviewInterface & MarketplaceProductInterface & {
  __typename?: 'InsuranceProductV2';
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Entity type */
  entityType: Scalars['String']['output'];
  institution: InsuranceInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Phone number by carrier */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Short summary of why NerdWallet recommends this insurance provider (product-level) */
  productBottomLineText?: Maybe<Scalars['String']['output']>;
  /** Product type */
  productType: Scalars['String']['output'];
  /** Sub Product type */
  subProductType?: Maybe<Scalars['String']['output']>;
  /** The URL to the NerdWallet review of this product. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Ability to customize plan, options are 'poor', 'below average', 'average', 'good', 'excellent' */
  abilityToCustomizePlan?: Maybe<Scalars['String']['output']>;
  /** Pay vet directly, options are 'yes', 'no' */
  payVetDirectly?: Maybe<Scalars['String']['output']>;
  /** Scope of coverage, options are 'poor', 'below average', 'average', 'good', 'excellent' */
  scopeOfCoverage?: Maybe<Scalars['String']['output']>;
  /** Consumer experience, options are 'below average', 'average', 'above average' */
  consumerExperience?: Maybe<Scalars['String']['output']>;
  /** Costs, options are 'cheap', 'lower cost', 'average cost', 'higher cost', 'expensive' */
  costs?: Maybe<Scalars['String']['output']>;
  /** A URL that points to the logo for the institution */
  imageRaw?: Maybe<Scalars['URL']['output']>;
  /** Percentage of claims denied by a health insurance carrier for services */
  inNetworkClaimsDenied?: Maybe<Scalars['String']['output']>;
  /** The cheapest monthly premium available for a Silver-tier plan */
  lowersSilverPremium?: Maybe<Scalars['Float']['output']>;
  /** Member experience (Medicare Only) */
  memberExperience?: Maybe<Scalars['String']['output']>;
  /** Description for tooltip of Member experience for Medicare Advantage (Medicare Only) */
  memberExperienceAdvantageAnnotation?: Maybe<Scalars['String']['output']>;
  /** Description for tooltip of Member experience for Medicare Part D (Medicare Only) */
  memberExperienceAnnotation?: Maybe<Scalars['String']['output']>;
  /** Description for tooltip of Percent of members in high rated plans (Medicare Only) */
  memberInHighRatedPlansAnnotation?: Maybe<Scalars['String']['output']>;
  /** Description for tooltip of Member satisfaction (Medicare Only) */
  memberSatisfactionAnnotation?: Maybe<Scalars['String']['output']>;
  /** Out-of-pocket costs (Medicare Only) */
  outOfPocketCost?: Maybe<Scalars['String']['output']>;
  /** Description for tooltip of Out-of-pocket costs (Medicare Only) */
  outOfPocketCostsAnnotation?: Maybe<Scalars['String']['output']>;
  /** The types of plans the company offers. (Medicare and U65 Health Insurance) */
  planTypesOfferedAnnotation?: Maybe<Scalars['String']['output']>;
  /** Description for tooltip of Premium discounts available (Medicare Only) */
  premiumDiscountsAvailableAnnotation?: Maybe<Scalars['String']['output']>;
  /** State(s) where offer is available. If no states are specified, we will consider the offer to be nationally available. */
  stateAvailability?: Maybe<Array<StateAbbreviationsEnum>>;
  /** Special phone number for persons with a hearing or speech disability */
  ttyNumber?: Maybe<Scalars['String']['output']>;
};

/** A Insurance institution */
export type InsuranceInstitutionV2 = MarketplaceEntityInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceInstitutionInterface & {
  __typename?: 'InsuranceInstitutionV2';
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Cons bullet points */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Pros bullet points */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** The overall editorial rating for the institution */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** Short summary of why NerdWallet recommends this insurance provider */
  tagline?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** A URL that points to the logo for the institution */
  imageRaw?: Maybe<Scalars['URL']['output']>;
};

/** A marketplace entity that represents a banking institution for the Canadian market */
export type CaBankingInstitutionV2 = MarketplaceEntityInterface & {
  __typename?: 'CaBankingInstitutionV2';
  /** Type of entity */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Institution logo */
  logo?: Maybe<Scalars['String']['output']>;
  /** Star rating of the institution */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Type of product */
  productType: Scalars['String']['output'];
  /** Status of the product in marketplace */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A marketplace entity that represents a banking product for the Canadian market */
export type CaBankingProductV2 = MarketplaceEntityInterface & {
  __typename?: 'CaBankingProductV2';
  /** Display value for APY */
  apyDisplay?: Maybe<Scalars['String']['output']>;
  /** APY in plain text */
  apyPlain?: Maybe<Scalars['Float']['output']>;
  /** Subtext for APY */
  apySubtext?: Maybe<Scalars['String']['output']>;
  /** Tooltip text for APY */
  apyTooltip?: Maybe<Scalars['String']['output']>;
  /**
   * List of categories the product belongs to
   * @deprecated Field is deprecated.
   */
  categories?: Maybe<Array<Scalars['String']['output']>>;
  /** Max deposit amount display */
  depositMaxDisplay?: Maybe<Scalars['String']['output']>;
  /** Max deposit amount in plain text */
  depositMaxPlain?: Maybe<Scalars['Float']['output']>;
  /** Tooltip text for max deposit amount */
  depositMaxTooltip?: Maybe<Scalars['String']['output']>;
  /** Min deposit amount display */
  depositMinDisplay?: Maybe<Scalars['String']['output']>;
  /** Min deposit amount in plain text */
  depositMinPlain?: Maybe<Scalars['Float']['output']>;
  /** Tooltip text for min deposit amount */
  depositMinTooltip?: Maybe<Scalars['String']['output']>;
  /** Type of entity */
  entityType: Scalars['String']['output'];
  /** Monthly fee display */
  feeMonthlyDisplay?: Maybe<Scalars['String']['output']>;
  /** Monthly fee subtext */
  feeMonthlySubtext?: Maybe<Scalars['String']['output']>;
  /** Monthly fee tooltip */
  feeMonthlyTooltip?: Maybe<Scalars['String']['output']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Institution associated with the product */
  institution?: Maybe<CaBankingInstitutionV2>;
  /** Marketing bullets for the product */
  marketingBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Our take or review of the product */
  ourTake?: Maybe<Array<Scalars['String']['output']>>;
  /** URL link to the review */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** Type of product */
  productType: Scalars['String']['output'];
  /** Sign-up bonus display */
  signUpBonusDisplay?: Maybe<Scalars['String']['output']>;
  /** Sign-up bonus in plain text */
  signUpBonusPlain?: Maybe<Scalars['Float']['output']>;
  /** Sign-up bonus tooltip */
  signUpBonusTooltip?: Maybe<Scalars['String']['output']>;
  /** Status of the product in marketplace */
  status: MarketplaceStatusEnum;
  /** Transactions display */
  transactionsDisplay?: Maybe<Scalars['String']['output']>;
  /** Transaction subtext */
  transactionsSubtext?: Maybe<Scalars['String']['output']>;
  /** Transactions tooltip */
  transactionsTooltip?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A marketplace entity that represents a banking offer for the Canadian market */
export type CaBankingOfferV2 = MarketplaceEntityInterface & {
  __typename?: 'CaBankingOfferV2';
  /** Platform where the offer is available */
  affiliatePlatform?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** URL to apply for the offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** Display value for APY */
  apyDisplay?: Maybe<Scalars['String']['output']>;
  /** APY in plain text */
  apyPlain?: Maybe<Scalars['Float']['output']>;
  /** Subtext for APY */
  apySubtext?: Maybe<Scalars['String']['output']>;
  /** Tooltip text for APY */
  apyTooltip?: Maybe<Scalars['String']['output']>;
  /** List of categories the offer belongs to */
  categories?: Maybe<Array<Scalars['String']['output']>>;
  /** Call to action entity placement */
  cta?: Maybe<EntityPlacementCta>;
  /** Minimum deposit required */
  depositMinDisplay?: Maybe<Scalars['String']['output']>;
  /** Minimum deposit tooltip */
  depositMinTooltip?: Maybe<Scalars['String']['output']>;
  /** Driver for APY */
  driverApy?: Maybe<EntityPlacementDriver>;
  /** Driver for deposit term */
  driverTerm?: Maybe<EntityPlacementDriver>;
  /** Driver for minimum deposit */
  driverDepositMin?: Maybe<EntityPlacementDriver>;
  /** Driver for maximum deposit */
  driverDepositMax?: Maybe<EntityPlacementDriver>;
  /** Driver for monthly fee */
  driverMonthlyFee?: Maybe<EntityPlacementDriver>;
  /** Driver for sign up bonus */
  driverSignUpBonus?: Maybe<EntityPlacementDriver>;
  /** Driver for transactions */
  driverTransactions?: Maybe<EntityPlacementDriver>;
  /** Type of entity */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Image associated with the entity placement */
  image?: Maybe<EntityPlacementImage>;
  /** Indicates if the entity is monetizable */
  monetizable: Scalars['String']['output'];
  /** Indicates if the product is monetizing */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Star rating of the offer */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product associated with the offer */
  product?: Maybe<CaBankingProductV2>;
  /** Type of product */
  productType: Scalars['String']['output'];
  /** Status of the product */
  status: MarketplaceStatusEnum;
  /** The term of the offer display value */
  termDisplay?: Maybe<Scalars['String']['output']>;
  /** The term of the offer in plain text */
  termPlain?: Maybe<Scalars['Int']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A marketplace entity that represents a credit card institution for the Canadian market */
export type CaCreditCardsInstitutionV2 = MarketplaceEntityInterface & {
  __typename?: 'CaCreditCardsInstitutionV2';
  /** Type of entity */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Type of product */
  productType: Scalars['String']['output'];
  /** Status of the product in marketplace */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A marketplace entity that represents a credit card product for the Canadian market */
export type CaCreditCardsProductV2 = MarketplaceEntityInterface & {
  __typename?: 'CaCreditCardsProductV2';
  /** Annual Percentage Rate for balance transfers */
  aprBalanceTransfer?: Maybe<Scalars['Float']['output']>;
  /** Annual Percentage Rate for cash advances */
  aprCashAdvance?: Maybe<Scalars['Float']['output']>;
  /** Display string for APR */
  aprDisplay?: Maybe<Scalars['String']['output']>;
  /** Introductory APR for balance transfers */
  aprIntroBalanceTransfer?: Maybe<Scalars['Float']['output']>;
  /** Duration of introductory APR for balance transfers in months */
  aprIntroBalanceTransferTime?: Maybe<Scalars['Int']['output']>;
  /** Display string for introductory APR */
  aprIntroDisplay?: Maybe<Scalars['String']['output']>;
  /** Introductory APR for purchases */
  aprIntroPurchase?: Maybe<Scalars['Float']['output']>;
  /** Duration of introductory APR for purchases in months */
  aprIntroPurchaseTime?: Maybe<Scalars['Int']['output']>;
  /** Tooltip text for introductory APR */
  aprIntroTooltip?: Maybe<Scalars['String']['output']>;
  /** Annual Percentage Rate for purchases */
  aprPurchase?: Maybe<Scalars['Float']['output']>;
  /** Tooltip text for APR */
  aprTooltip?: Maybe<Scalars['String']['output']>;
  /** List of categories the product belongs to */
  categories?: Maybe<Array<Scalars['String']['output']>>;
  /**
   * List of categories for comparison
   * @deprecated Field is deprecated.
   */
  compareCategories?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** List of cons or disadvantages */
  cons?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum suggested credit score */
  creditScoreMax?: Maybe<Scalars['Int']['output']>;
  /** Minimum credit score required */
  creditScoreMin?: Maybe<Scalars['Int']['output']>;
  /** Type of entity */
  entityType: Scalars['String']['output'];
  /** Annual fee */
  feeAnnual?: Maybe<Scalars['Float']['output']>;
  /** Display string for annual fee */
  feeAnnualDisplay?: Maybe<Scalars['String']['output']>;
  /** Annual fee for the first year */
  feeAnnualFirstYear?: Maybe<Scalars['Float']['output']>;
  /** Subtext for annual fee */
  feeAnnualSubtext?: Maybe<Scalars['String']['output']>;
  /** Tooltip text for annual fee */
  feeAnnualTooltip?: Maybe<Scalars['String']['output']>;
  /** Fee for balance transfers */
  feeBalanceTransfer?: Maybe<Scalars['Float']['output']>;
  /** Display string for balance transfer fee */
  feeBalanceTransferDisplay?: Maybe<Scalars['String']['output']>;
  /** Fee for cash advances */
  feeCashAdvance?: Maybe<Scalars['Float']['output']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Institution associated with the product */
  institution?: Maybe<CaCreditCardsInstitutionV2>;
  /** Indicates if the product is monetizing */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** List of marketing bullet points */
  marketingBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Our take or review of the product */
  ourTake?: Maybe<Scalars['String']['output']>;
  /** Contact phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Processing network (e.g., Visa, MasterCard) */
  processingNetwork?: Maybe<Scalars['String']['output']>;
  /** Type of product */
  productType: Scalars['String']['output'];
  /** List of pros or advantages */
  pros?: Maybe<Array<Scalars['String']['output']>>;
  /** URL link to the review */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** Breakdown of reward rates */
  rewardRateBreakdown?: Maybe<Array<Maybe<RewardRateBreakdown>>>;
  /** Display string for reward rate */
  rewardRateDisplay?: Maybe<Scalars['String']['output']>;
  /** Tooltip text for reward rate */
  rewardRateTooltip?: Maybe<Scalars['String']['output']>;
  /** Type of reward */
  rewardType?: Maybe<Scalars['String']['output']>;
  /** Sign-up bonus amount */
  signUpBonus?: Maybe<Scalars['Int']['output']>;
  /** Display string for sign-up bonus */
  signUpBonusDisplay?: Maybe<Scalars['String']['output']>;
  /** Tooltip text for sign-up bonus */
  signUpBonusTooltip?: Maybe<Scalars['String']['output']>;
  /** Type of sign-up bonus */
  signUpBonusType?: Maybe<Scalars['String']['output']>;
  /** Star rating of the product */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Status of the product in marketplace */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A marketplace entity that represents a credit card offer for the Canadian market */
export type CaCreditCardsOfferV2 = MarketplaceEntityInterface & {
  __typename?: 'CaCreditCardsOfferV2';
  /** URL link to apply for the product */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** Call to action entity placement */
  cta?: Maybe<EntityPlacementCta>;
  /** Display name of the product */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Driver for annual fee */
  driverAnnualFee?: Maybe<EntityPlacementDriver>;
  /** Driver for first-year annual fee */
  driverAnnualFeeFirstYear?: Maybe<EntityPlacementDriver>;
  /** Driver for introductory APR on balance transfers */
  driverBalanceTransferIntroApr?: Maybe<EntityPlacementDriver>;
  /** Driver for credit score */
  driverCreditScore?: Maybe<EntityPlacementDriver>;
  /** Driver for introductory APR */
  driverIntroApr?: Maybe<EntityPlacementDriver>;
  /** Driver for introductory offer */
  driverIntroOffer?: Maybe<EntityPlacementDriver>;
  /** Driver for regular APR */
  driverRegularApr?: Maybe<EntityPlacementDriver>;
  /** Driver for rewards rate */
  driverRewardsRate?: Maybe<EntityPlacementDriver>;
  /** Driver for sign-up bonus */
  driverSignUpBonus?: Maybe<EntityPlacementDriver>;
  /** Type of entity */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Image associated with the entity placement */
  image?: Maybe<EntityPlacementImage>;
  /** Indicates if the entity is monetizable */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product associated with the entity placement */
  product?: Maybe<CaCreditCardsProductV2>;
  /** Type of product */
  productType: Scalars['String']['output'];
  /** Star rating of the product */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Tooltip text for star rating */
  starRatingTooltip: Scalars['String']['output'];
  /** Status of the product in marketplace */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Investing offer */
export type InvestingOfferV2 = MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithReviewInterface & MarketplaceOfferInterface & {
  __typename?: 'InvestingOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** Short description of what the offer is best for e.g. customer service */
  bestForBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
  /** A list of brokerage features for this offer such as promotion, low cost, advisor, etc. */
  brokerageFeatures?: Maybe<Array<Scalars['String']['output']>>;
  /** Brokerage feature for this offer such as self or robo management. */
  brokerageManagement?: Maybe<Scalars['String']['output']>;
  /** The categories that apply to this investing offer. */
  categories?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the NerdWallet review of this offer's product */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Short sentence summary of the Investing Offer */
  summaryShort?: Maybe<Scalars['String']['output']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']['output']>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  product: InvestingProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** Trading frequency such as weekly, monthly or occasionally. */
  tradingFrequency?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver account minimum associated with the entity */
  driverAccountMinimum?: Maybe<EntityPlacementDriver>;
  /** The driver fees associated with the entity */
  driverFees?: Maybe<EntityPlacementDriver>;
  /** The options contract driver fees associated with the entity */
  driverOptionsContractFee?: Maybe<EntityPlacementDriver>;
  /** The driver promotion associated with the entity */
  driverPromotion?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** Checks if the current investing offer is a Fidelity Offer */
  isFidelityOffer?: Maybe<Scalars['Boolean']['output']>;
  /** Checks if the current investing offer is an RIA (registered investment advisor) offer */
  isRiaOffer?: Maybe<Scalars['Boolean']['output']>;
  /**
   * Renders an Investing Offer Driver in non structured content format.
   *   TODO: We eventually want to be consistent and use structured content
   *   formatting going forward.  However this most likely will not be implemented
   *   until we have our Currency OfferCard completed
   */
  legacyDrivers: Array<LegacyDriver>;
  /** The month and year range the reviewedAtDate covers */
  periodConsideredDate?: Maybe<Scalars['String']['output']>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The disclaimer text that should be rendered for RIA offers */
  riaDisclaimerText?: Maybe<Scalars['String']['output']>;
  /** The month and date that an offer was reviewed in string format */
  reviewedAtDate?: Maybe<Scalars['String']['output']>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};

/** A Investing product */
export type InvestingProductV2 = MarketplaceEntityWithReviewInterface & MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'InvestingProductV2';
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** The URL to the NerdWallet review of this product. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  institution: InvestingInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Investing institution */
export type InvestingInstitutionV2 = MarketplaceEntityWithStarRatingInterface & MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'InvestingInstitutionV2';
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The overall, editorial rating for the institution. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
};

/** A Nerdwallet Plus institution */
export type NerdwalletPlusInstitutionV2 = MarketplaceEntityInterface & {
  __typename?: 'NerdwalletPlusInstitutionV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Nerdwallet Plus product */
export type NerdwalletPlusProductV2 = MarketplaceEntityInterface & {
  __typename?: 'NerdwalletPlusProductV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Type of NerdWallet+ product */
  nerdwalletPlusType: Scalars['String']['output'];
  /** Institution associated with the entity placement */
  institution: NerdwalletPlusInstitutionV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Nerdwallet Plus offer */
export type NerdwalletPlusOfferV2 = MarketplaceEntityInterface & {
  __typename?: 'NerdwalletPlusOfferV2';
  /** URL to apply for the offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** A short summary of the offer, usually a sentence or two. */
  bottomLine?: Maybe<Scalars['String']['output']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Whether this offer is eligible for a NerdWallet+ bonus. */
  nerdwalletPlusBonusEligible?: Maybe<Scalars['Boolean']['output']>;
  /** More information about the product. Appears under 'Card Details' or 'Product Details' depending on the experience. */
  marketingBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Price in dollars of the offer. */
  price: Scalars['Float']['output'];
  /** The price of the offer as a string. This field is used to display the price in a more human-readable format. For example, '$100 plus taxes and fees'. */
  priceDescription?: Maybe<Scalars['String']['output']>;
  /** The frequency of the offer; for some types of products it might be a 'per month' or 'per year' offer; this field would hold a string that would be displayed after the dollar amount. */
  priceFrequency?: Maybe<Scalars['String']['output']>;
  /** What would be displayed in a tooltip for the price. */
  priceTooltip?: Maybe<Scalars['String']['output']>;
  /** Product associated with the entity placement */
  product: NerdwalletPlusProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** A promotion that is currently running for this offer. For example 'Free Trial'. */
  promotion?: Maybe<Scalars['String']['output']>;
  /** A description of the promotion that is currently running for this offer. For example, 'for 3 months when you refer a friend'. */
  promotionDescription?: Maybe<Scalars['String']['output']>;
  /** What would be displayed in a tooltip for the promotion. For example, 'Terms Apply, etc'. */
  promotionTooltip?: Maybe<Scalars['String']['output']>;
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Auto Loans offer */
export type AutoLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceOfferInterface & {
  __typename?: 'AutoLoansOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** US States that the lender will not service */
  excludedStates?: Maybe<Array<Scalars['String']['output']>>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum loan amount */
  maxLoanAmount?: Maybe<Scalars['Float']['output']>;
  /** Minimum loan amount */
  minLoanAmount?: Maybe<Scalars['Float']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** List of tags associated with the offer */
  offerTags?: Maybe<Array<Scalars['String']['output']>>;
  /** Product type */
  productType: Scalars['String']['output'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** The overall editorial rating for this offer */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Short custom label to be used with rating stars (should be 20 characters or less) */
  starRatingLabel?: Maybe<Scalars['String']['output']>;
  /** Custom tooltip to be used with the rating stars label */
  starRatingLabelTooltip?: Maybe<Scalars['String']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  product: AutoLoansProductV2;
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver estimated apr associated with the entity */
  driverEstimatedApr?: Maybe<EntityPlacementDriver>;
  /** The driver loan amount associated with the entity */
  driverLoanAmount?: Maybe<EntityPlacementDriver>;
  /** The driver min credit score associated with the entity */
  driverMinCreditScore?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};

/** A Auto Services institution */
export type AutoServicesInstitutionV2 = MarketplaceEntityInterface & {
  __typename?: 'AutoServicesInstitutionV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** A URL that points to the logo for the institution */
  imageRaw?: Maybe<Scalars['URL']['output']>;
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Auto Services offer */
export type AutoServicesOfferV2 = MarketplaceEntityWithPlacementInterface & MarketplaceEntityInterface & {
  __typename?: 'AutoServicesOfferV2';
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** Call to action entity placement */
  cta?: Maybe<EntityPlacementCta>;
  /** Display name of the product */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Image associated with the entity placement */
  image?: Maybe<EntityPlacementImage>;
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  product: AutoServicesProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Custom tooltip to be used with the star rating. */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Auto Services product */
export type AutoServicesProductV2 = MarketplaceEntityInterface & {
  __typename?: 'AutoServicesProductV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: AutoServicesInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

export type ContentConfigTextItem = ContentConfigItem & {
  __typename?: 'ContentConfigTextItem';
  type: ContentConfigItemType;
  text: Scalars['String']['output'];
};

export type ContentConfigPodcastItem = ContentConfigItem & {
  __typename?: 'ContentConfigPodcastItem';
  type: ContentConfigItemType;
  podcastId: Scalars['String']['output'];
  source: ContentConfigPodcastSource;
  podcastName: Scalars['String']['output'];
  title: Scalars['String']['output'];
  body: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
};

export type ContentConfigVideoItem = ContentConfigItem & {
  __typename?: 'ContentConfigVideoItem';
  type: ContentConfigItemType;
  videoId: Scalars['String']['output'];
  thumbnailUrl: Scalars['URL']['output'];
  title: Scalars['String']['output'];
  publishedAt?: Maybe<Scalars['DateTime']['output']>;
  durationInSeconds?: Maybe<Scalars['Int']['output']>;
  viewCount?: Maybe<Scalars['Int']['output']>;
};

export type ContentConfigLinkItem = ContentConfigItem & {
  __typename?: 'ContentConfigLinkItem';
  type: ContentConfigItemType;
  text: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type ContentConfigButtonItem = ContentConfigItem & {
  __typename?: 'ContentConfigButtonItem';
  type: ContentConfigItemType;
  text: Scalars['String']['output'];
  url: Scalars['URL']['output'];
};

export type ContentConfigPostItem = ContentConfigItem & {
  __typename?: 'ContentConfigPostItem';
  type: ContentConfigItemType;
  postId: Scalars['String']['output'];
  postType: ContentConfigPostItemType;
  override?: Maybe<ContentConfigPostOverrideItem>;
};

/** The Full Screen feature discvoery module implementation */
export type FeatureDiscoveryFullScreenModule = FeatureDiscoveryModuleInterface & {
  __typename?: 'FeatureDiscoveryFullScreenModule';
  /**
   * Intended to be a unique identifier. Could technically use featureName as a unique identifier
   *   but technically the same feature could be featured multiple times
   */
  id: Scalars['ID']['output'];
  /** The type of module for feature highlighting */
  type: FeatureDiscoveryTypeEnum;
  /**
   * The priority value of the module. Currently based on the array order of the FEATURE_DISCOVERY
   *   app-config. This is a new value from the legacy Feature Discovery which allows multiple
   *   modules of the same type. E.g. we may want mulitple full screen modules to be highlighted
   *   at startup, so the lower priority modules will appear in subsequent startups.
   */
  priority: Scalars['Int']['output'];
  /** The name of the feature */
  featureName: Scalars['String']['output'];
  /** The title copy in the UI */
  featureTitle: Scalars['String']['output'];
  /** The color name of the title copy */
  titleColorName?: Maybe<Scalars['String']['output']>;
  /** The body copy in the UI */
  featureBody: Scalars['String']['output'];
  /** The disclaimer copy in the UI */
  featureDisclaimer?: Maybe<Scalars['String']['output']>;
  /** The properties pertaining to the content and destination of the primary CTA in the UI */
  primaryAction?: Maybe<FeatureDiscoveryFullScreenModulePrimaryAction>;
  /** Specifies the layout of the image at the top of the Full Screen module */
  imageType: FeatureDiscoveryFullScreenImageTypeEnum;
  /** The URL to the image asset in the UI */
  imageUrl: Scalars['URL']['output'];
  /** The properties pertaining to the pill in the UI */
  pill?: Maybe<FeatureDiscoveryFullScreenPill>;
  /**
   * The ways in which the module can appear. Currently only supporting Full Screen
   *   discovery at startup, but can feasibly trigger
   */
  moduleTriggers: Array<Maybe<FeatureDiscoveryFullScreenModuleTriggerEnum>>;
  /**
   * The maximum number of times the module can be dismissed. Currently handled by the client
   *   using a cached var.
   */
  maxDismissalCount: Scalars['Int']['output'];
};

export type FeatureDiscoveryContextualSectionListPopupModule = FeatureDiscoveryModuleInterface & {
  __typename?: 'FeatureDiscoveryContextualSectionListPopupModule';
  /**
   * Intended to be a unique identifier. Could technically use featureName as a unique identifier
   *   but technically the same feature could be featured multiple times
   */
  id: Scalars['ID']['output'];
  /** The type of module for feature highlighting */
  type: FeatureDiscoveryTypeEnum;
  /**
   * The priority value of the module. Currently based on the array order of the FEATURE_DISCOVERY
   *   app-config. This is a new value from the legacy Feature Discovery which allows multiple
   *   modules of the same type. E.g. we may want mulitple full screen modules to be highlighted
   *   at startup, so the lower priority modules will appear in subsequent startups.
   */
  priority: Scalars['Int']['output'];
  /** The name of the feature */
  featureName: Scalars['String']['output'];
  /**
   * The maximum number of times the module can be dismissed. Currently handled by the client
   *   using a cached var.
   */
  maxDismissalCount: Scalars['Int']['output'];
  /** The unique ID of the target SectionList */
  sectionListId: Scalars['String']['output'];
  /** The unique key (amongst the SectionList's keys) pertaining to the target section */
  sectionKey: Scalars['String']['output'];
  /** The unique key for the tab you wish to update */
  tabId?: Maybe<Scalars['String']['output']>;
  /** The position, relative to the target section, for the popup to appear */
  popupPosition: FeatureDiscoveryContextualSectionListPopupPositionEnum;
  /** The text used to highlight the popup's purpose. e.g. New or Beta */
  highlight?: Maybe<FeatureDiscoveryContextualPopupHighlight>;
  /** The body text/description */
  bodyText: Scalars['String']['output'];
  /** The vertical positioning offset to help adjust the module beyond its default positioning */
  verticalOffset?: Maybe<Scalars['Int']['output']>;
};

export type FinancialCreditCardRewardEvent = FinancialNwPlusRewardEventInterface & {
  __typename?: 'FinancialCreditCardRewardEvent';
  /** Unique ID for credit card reward event */
  id: Scalars['ID']['output'];
  /** The date when the event that was emitted */
  emittedAt: Scalars['DateTime']['output'];
  /** When the rewarded event has been viewed by a user */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The points earned for the reward */
  pointsRewarded?: Maybe<Scalars['Int']['output']>;
  /** The event type that was emitted */
  eventType: FinancialCreditCardRewardEnum;
};

export type FinancialBankingRewardEvent = FinancialNwPlusRewardEventInterface & {
  __typename?: 'FinancialBankingRewardEvent';
  /** Unique ID for credit card reward event */
  id: Scalars['ID']['output'];
  /** The date when the event that was emitted */
  emittedAt: Scalars['DateTime']['output'];
  /** When the rewarded event has been viewed by a user */
  viewedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The points earned for the reward */
  pointsRewarded?: Maybe<Scalars['Int']['output']>;
  /** The event type that was emitted */
  eventType: FinancialBankingRewardEnum;
};

export type FinancialCreditCardReward = FinancialNwPlusRewardInterface & {
  __typename?: 'FinancialCreditCardReward';
  /** Unique ID for NW+ product reward tracking */
  id: Scalars['ID']['output'];
  /**
   * ID of the shopping finished event
   * @deprecated Same as id
   */
  shoppingFinishedId: Scalars['ID']['output'];
  /** When the Shopping Finished event has occurred */
  shoppingFinishedAt: Scalars['DateTime']['output'];
  /** Represents the type of product */
  productType?: Maybe<FinancialNwPlusRewardProductEnum>;
  /**
   * When we've received a Transaction Completed event, confirming that a user has successfully
   *   acquired the product through NW
   * @deprecated Use shoppingFinishedAt
   */
  transactionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Marketplace Institution ID associated with the Shopping Finished event */
  marketplaceInstitutionId: Scalars['ID']['output'];
  /** The Marketplace Product ID associated with the Shopping Finished event */
  marketplaceProductId: Scalars['ID']['output'];
  /** The Marketplace Offer ID associated with the Shopping Finished event */
  marketplaceOfferId: Scalars['ID']['output'];
  /**
   * NerdWallet+ reward eligibility status based on when a user became a NW+ member,
   *   relative to the shopping event
   */
  nwPlusActivationStatus: NerdWalletPlusCreditCardActivationStatusEnum;
  /** Whether the user has dismissed the reward */
  isUserDismissed?: Maybe<Scalars['Boolean']['output']>;
  /** NerdWallet+ reward eligibility status based on the offer, relative to similar products */
  rewardEligibilityStatus?: Maybe<NwPlusShoppingRewardEligibilityStatusEnum>;
  /** The type of reward this shopping event can earn points for */
  rewardPathType?: Maybe<NwPlusShoppingRewardPathEnum>;
  /** The ID of the FDP Account associated with the marketplace product */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** When a user has associated an FDP account */
  accountLinkedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of account linking */
  accountLinkStatus?: Maybe<FinancialAccountLinkStatusEnum>;
  /** The FDP Account associated with the marketplace product */
  fdpAccount?: Maybe<FinancialAccount>;
  /** The Marketplace Credit Card Offer associated with the Shopping Finished event */
  marketplaceCreditCardOffer: CreditCardsOfferV2;
  /** List of rewardable events emitted for a NerdWallet+ member */
  events: Array<FinancialCreditCardRewardEvent>;
  /** Derived fields to indicate a NerdWallet+ member's progress towards earning their rewards */
  rewardsProgress: FinancialCreditCardRewardProgress;
  /** When a user has completed first transaction */
  firstTransactionOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  /** The steps for completing this reward. */
  steps: Array<FinancialNwPlusRewardStep>;
};


export type FinancialCreditCardRewardRewardsProgressArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type FinancialCreditCardRewardStepsArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};

export type FinancialBankingReward = FinancialNwPlusRewardInterface & {
  __typename?: 'FinancialBankingReward';
  /** Unique ID for NW+ product reward tracking */
  id: Scalars['ID']['output'];
  /**
   * ID of the shopping finished event
   * @deprecated Same as id
   */
  shoppingFinishedId: Scalars['ID']['output'];
  /** When the Shopping Finished event has occurred */
  shoppingFinishedAt: Scalars['DateTime']['output'];
  /** Represents the type of product */
  productType?: Maybe<FinancialNwPlusRewardProductEnum>;
  /**
   * When we've received a Transaction Completed event, confirming that a user has successfully
   *   acquired the product through NW
   * @deprecated Use shoppingFinishedAt
   */
  transactionCompletedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The Marketplace Institution ID associated with the Shopping Finished event */
  marketplaceInstitutionId: Scalars['ID']['output'];
  /** The Marketplace Product ID associated with the Shopping Finished event */
  marketplaceProductId: Scalars['ID']['output'];
  /** The Marketplace Offer ID associated with the Shopping Finished event */
  marketplaceOfferId: Scalars['ID']['output'];
  /**
   * NerdWallet+ reward eligibility status based on when a user became a NW+ member,
   *   relative to the shopping event
   */
  nwPlusActivationStatus: NerdWalletPlusCreditCardActivationStatusEnum;
  /** Whether the user has dismissed the reward */
  isUserDismissed?: Maybe<Scalars['Boolean']['output']>;
  /** NerdWallet+ reward eligibility status based on the offer, relative to similar products */
  rewardEligibilityStatus?: Maybe<NwPlusShoppingRewardEligibilityStatusEnum>;
  /** The type of reward this shopping event can earn points for */
  rewardPathType?: Maybe<NwPlusShoppingRewardPathEnum>;
  /** The ID of the FDP Account associated with the marketplace product */
  accountId?: Maybe<Scalars['ID']['output']>;
  /** When a user has associated an FDP account */
  accountLinkedAt?: Maybe<Scalars['DateTime']['output']>;
  /** The status of account linking */
  accountLinkStatus?: Maybe<FinancialAccountLinkStatusEnum>;
  /** The FDP Account associated with the marketplace product */
  fdpAccount?: Maybe<FinancialAccount>;
  /** The Marketplace Banking Offer associated with the Shopping Finished event */
  marketplaceBankingOffer: BankingOfferV2;
  /** List of rewardable events emitted for a NerdWallet+ member */
  events: Array<FinancialBankingRewardEvent>;
  /** Derived fields to indicate a NerdWallet+ member's progress towards earning their rewards */
  rewardsProgress: FinancialBankingRewardProgress;
  /**
   * When a direct deposit first occurred
   * @deprecated Unnecessary detail
   */
  firstDirectDepositOccurredAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * Amount associated with first direct deposit
   * @deprecated Unnecessary detail
   */
  firstDirectDepositAmount?: Maybe<Scalars['Float']['output']>;
  /** The steps for completing this reward. */
  steps: Array<FinancialNwPlusRewardStep>;
};


export type FinancialBankingRewardRewardsProgressArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};


export type FinancialBankingRewardStepsArgs = {
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
};

/** A Banking offer */
export type BankingOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'BankingOfferV2';
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** The additional details of an offer that are rendered in the 'See details' dropdown of an offer card.  The account details are typically a mix of promotions, disclaimers, and high level summaries of the offer */
  accountDetails?: Maybe<Array<Scalars['String']['output']>>;
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  apy?: Maybe<Scalars['Float']['output']>;
  apyAnnotation?: Maybe<Scalars['String']['output']>;
  /** Overrides default apy behavior. Should be EMPTY unless offer has a special override. */
  apyOverride?: Maybe<Scalars['String']['output']>;
  /** Information about limitations or constraints of ATM access whether free or not. */
  atmAccessDetails?: Maybe<Scalars['String']['output']>;
  balanceToAvoidFees?: Maybe<Scalars['Float']['output']>;
  /** List of the benefits associated with a given banking offer */
  benefits?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
  /** Overrides default bonus amount behavior. Should be EMPTY unless offer has a special bonus offer. */
  bonusAmountOverride?: Maybe<Scalars['String']['output']>;
  bonusDetails?: Maybe<Scalars['String']['output']>;
  /** The type of bonus received for signing up to this card. Can be different to the Reward bonus. */
  bonusType?: Maybe<Scalars['String']['output']>;
  /** The CD deposit term for a CD banking offer in days. */
  cdDepositTerm?: Maybe<Scalars['Int']['output']>;
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** APY formatted for display in clients, with 2 decimal places and % symbol */
  displayApy?: Maybe<Scalars['String']['output']>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']['output']>;
  /** The array of display pages */
  displayPages?: Maybe<Array<Scalars['String']['output']>>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  feeAtm?: Maybe<Scalars['Float']['output']>;
  feeEarlyClosure?: Maybe<Scalars['Float']['output']>;
  feeMonthly?: Maybe<Scalars['Float']['output']>;
  /** Holds the monthly fee sub copy such as 'Waived with one transaction per month' */
  feeMonthlySubCopy?: Maybe<Scalars['String']['output']>;
  feeOverdraft?: Maybe<Scalars['Float']['output']>;
  /** The URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Calculates if this offer is monetizing for a specific user (after taking throttling into account) */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Generally used as the min balance for APY */
  minimumBalance?: Maybe<Scalars['Float']['output']>;
  /** Minimum deposit needed to open an account. */
  minOpeningDeposit?: Maybe<Scalars['Float']['output']>;
  /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  product: BankingProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the NerdWallet review of this offer's institution */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** The slug associated with the product */
  slug?: Maybe<Scalars['String']['output']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** State(s) where offer is available. If no states are specified, we will consider the offer to be nationally available */
  states?: Maybe<Array<StateAbbreviationsEnum>>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** String representing a product's subtype */
  subProductType?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /**
   * The CD Deposit Term Formatted with unit and value
   * @deprecated The logic was moved to client-side.
   */
  cdDepositTermFormatted?: Maybe<Scalars['String']['output']>;
  /** The driver apy associated with the entity */
  driverApy?: Maybe<EntityPlacementDriver>;
  /** The driver apy with override associated with the entity */
  driverApyWithOverride?: Maybe<EntityPlacementDriver>;
  /** The driver bonus associated with the entity */
  driverBonus?: Maybe<EntityPlacementDriver>;
  /** The driver bonus with override associated with the entity */
  driverBonusWithOverride?: Maybe<EntityPlacementDriver>;
  /** The driver minimum balance associated with the entity */
  driverMinimumBalance?: Maybe<EntityPlacementDriver>;
  /** The driver monthly fee associated with the entity */
  driverMonthlyFee?: Maybe<EntityPlacementDriver>;
  /** The driver overdraft star rating associated with the entity */
  driverOverdraftStarRating?: Maybe<EntityPlacementDriver>;
  /** This offer is eligible for NW+ bonus. */
  eligibleForNerdWalletPlusBonus?: Maybe<Scalars['Boolean']['output']>;
  /** The annotation for the agency that federally insures the institution */
  federallyInsuredAnnotation?: Maybe<Scalars['String']['output']>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** The drivers for the entity in non structured content format */
  rawDrivers: Array<RawDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Human readable string describing a product's subtype */
  subProductTypeLabel?: Maybe<Scalars['String']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};


/** A Banking offer */
export type BankingOfferV2RawDriversArgs = {
  minAccountBalance?: InputMaybe<Scalars['Int']['input']>;
};

export type SavingsOfferRecommendation = OfferRecommendation & {
  __typename?: 'SavingsOfferRecommendation';
  type: OfferRecommendationType;
  confidence: OfferRecommendationConfidence;
  appAction: ApplicationAction;
  body?: Maybe<Scalars['String']['output']>;
  offer?: Maybe<BankingOfferV2>;
  bestLinkedSavingsOffer?: Maybe<BankingOfferV2>;
  starRating?: Maybe<Scalars['Float']['output']>;
  apy?: Maybe<Scalars['Float']['output']>;
};

export type RegisterUserResponse = AuthenticationResponseInterface & {
  __typename?: 'RegisterUserResponse';
  /** Determines whether user registration was successful */
  success: Scalars['Boolean']['output'];
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
};

export type LogInUserResponse = AuthenticationResponseInterface & {
  __typename?: 'LogInUserResponse';
  /** Determines whether user registration was successful */
  success: Scalars['Boolean']['output'];
  /** The feature flags associated with the current user for the calling application */
  featureFlags?: Maybe<Array<FeatureFlag>>;
};

export type CreditScoreActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'CreditScoreActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
  /** If the user is blocked from using the Credit Score feature, this field indicates the reason why. */
  blockedReason?: Maybe<CreditScoreBlockedReasonEnum>;
  /** If the user has a thin file, this field indicates the reason why. */
  thinFileReason?: Maybe<CreditProfileAuthThinFileReason>;
};

export type CashFlowActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'CashFlowActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

export type NetWorthActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'NetWorthActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

export type EmailOnlyRegisteredUserActivationStatusResponse = MembershipFeatureActivationStatusInterface & {
  __typename?: 'EmailOnlyRegisteredUserActivationStatusResponse';
  id: MembershipFeatureEnum;
  status: MembershipFeatureActivationStatusEnum;
};

export type SpendingByMonthsDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'SpendingByMonthsDataVisualization';
  /** This will always be SPENDING_BY_MONTHS */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /**
   * The user's total spending on each day of the current month to the current date, and each day of the _previous_
   *   month (e.g. if today is 6/17, this field would include spending data for 5/1-5/30 and 6/1-6/17).
   *
   *   Note that SpendingByMonthsDataVisualization utilizes the same type as the existing manifestation of this data
   *   visualization in the Cash Flow product experience.
   */
  spendingByDateForTargetAndPriorMonthToDate: FinancialTransactionsSpendingByDayOfTheMonthForMonth;
};


export type SpendingByMonthsDataVisualizationSpendingByDateForTargetAndPriorMonthToDateArgs = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
};

export type SpendingByTopCategoriesDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'SpendingByTopCategoriesDataVisualization';
  /** This will always be SPENDING_BY_TOP_CATEGORIES */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /**
   * The user's top spending categories for the current month, to date.
   *
   *   Note that SpendingByTopCategoriesDataVisualization utilizes the same type as the existing manifestation of this data
   *   visualization in the Cash Flow product experience.
   */
  topCategoriesBySpending: FinancialTransactionsTopCategoriesBySpending;
};


export type SpendingByTopCategoriesDataVisualizationTopCategoriesBySpendingArgs = {
  effectiveDate?: InputMaybe<Scalars['String']['input']>;
};

export type CreditScoreActivationVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'CreditScoreActivationVisualization';
  /** This will always be CREDIT_SCORE_ACTIVATION */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

export type FinancialAccountsActivationVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'FinancialAccountsActivationVisualization';
  /** This will always be FINANCIAL_ACCOUNTS_ACTIVATION */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

export type MyCardsActivationVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'MyCardsActivationVisualization';
  /** This will always be MY_CARDS_ACTIVATION */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
};

export type CreditBoosterDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'CreditBoosterDataVisualization';
  /** This will always be CREDIT_BOOSTER */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /** User's credit score info dating back to a week */
  creditScoreChangeInfo: CreditScoreChangeInfo;
};

export type WhyDidMyScoreChangeDataVisualization = UserInsightDataVisualizationInterface & {
  __typename?: 'WhyDidMyScoreChangeDataVisualization';
  /** This will always be WHY_DID_MY_SCORE_CHANGE */
  dataVisualizationType: UserInsightDataVisualizationTypeEnum;
  /** User's current credit score info */
  creditScoreChangeInfo: CreditScoreChangeInfo;
};

/**
 * Deprecated: The service that serves this insight type has been retired as an inventory source
 *
 * A user insight sourced from the Feed CMS (includes feed cards and Nerds-Eye View items)
 */
export type FeedCardInsight = UserInsightInterface & {
  __typename?: 'FeedCardInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   *   Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   *   Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   *   Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   *   be inferred by source-specific heuristics.
   *
   *   Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID']['output'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']['output']>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']['output']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   *   impact)
   *
   *   For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']['output']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   *   urgency)
   *
   *   For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   *   low-urgency.
   */
  urgency?: Maybe<Scalars['Float']['output']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   *   insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   *   treatment (e.g. red vs. yellow vs. blue accent color).
   *
   *   Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   *   the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   *   Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   *   This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /**
   * The URL to an image that insight cards can use to apply additional visual treatment for cases such as:
   *   Celebratory, Cautionary, Light Bulb
   */
  imageTreatmentUrl?: Maybe<Scalars['URL']['output']>;
  imageTreatmentType?: Maybe<UserInsightImageTreatmentTypeEnum>;
  advertiserDisclosure?: Maybe<Scalars['String']['output']>;
  legalDisclaimer?: Maybe<Scalars['String']['output']>;
  /**
   * The number of days after which a FeedCardInsight can be considered "new" to the user.
   *   Clients should disregard all local user engagement data that is older than this value.
   * @deprecated All returned UIAs should be considered non-expired.
   */
  expiresInDays?: Maybe<Scalars['Int']['output']>;
};

/**
 * A user insight sourced from the recommendation-service and retrieved via Factory.
 *
 * Note that the prefix "Recommendation" indicates only the origin of this insight -- not that it is semantically more
 * worthy of "recommendation" than insights from other sources.
 */
export type RecommendationInsight = UserInsightInterface & {
  __typename?: 'RecommendationInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   *   Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   *   Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   *   Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   *   be inferred by source-specific heuristics.
   *
   *   Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID']['output'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']['output']>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']['output']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   *   impact)
   *
   *   For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']['output']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   *   urgency)
   *
   *   For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   *   low-urgency.
   */
  urgency?: Maybe<Scalars['Float']['output']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   *   insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   *   treatment (e.g. red vs. yellow vs. blue accent color).
   *
   *   Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   *   the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   *   Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   *   This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /**
   * The URL to an image that insight cards can use to apply additional visual treatment for cases such as:
   *   Celebratory, Cautionary, Light Bulb
   */
  imageTreatmentUrl?: Maybe<Scalars['URL']['output']>;
  imageTreatmentType?: Maybe<UserInsightImageTreatmentTypeEnum>;
  advertiserDisclosure?: Maybe<Scalars['String']['output']>;
  legalDisclaimer?: Maybe<Scalars['String']['output']>;
  /** Flag for whether generated user insight is stale compared to a user's new credit report pull */
  isStale?: Maybe<Scalars['Boolean']['output']>;
};

/** A user insight sourced from financial-insights service */
export type FinancialInsight = UserInsightInterface & {
  __typename?: 'FinancialInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   *   Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   *   Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   *   Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   *   be inferred by source-specific heuristics.
   *
   *   Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID']['output'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']['output']>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']['output']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   *   impact)
   *
   *   For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']['output']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   *   urgency)
   *
   *   For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   *   low-urgency.
   */
  urgency?: Maybe<Scalars['Float']['output']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   *   insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   *   treatment (e.g. red vs. yellow vs. blue accent color).
   *
   *   Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   *   the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   *   Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   *   This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /**
   * The URL to an image that insight cards can use to apply additional visual treatment for cases such as:
   *   Celebratory, Cautionary, Light Bulb
   */
  imageTreatmentUrl?: Maybe<Scalars['URL']['output']>;
  imageTreatmentType?: Maybe<UserInsightImageTreatmentTypeEnum>;
  advertiserDisclosure?: Maybe<Scalars['String']['output']>;
  legalDisclaimer?: Maybe<Scalars['String']['output']>;
};

/**
 * Deprecated: The service that serves this insight type has been retired as an inventory source
 *
 * A user insight sourced from credit-service
 */
export type CreditScoreInsight = UserInsightInterface & {
  __typename?: 'CreditScoreInsight';
  /**
   * A human-readable identifier for a particular insight inventory item.  Primarily used for analytics.
   *
   *   Note that the slug field is the same across all instances of a particular insight (whereas the id field is unique).
   *
   *   Example: credit-score-utilization-increase-by-ten-or-more-points
   */
  slug?: Maybe<Scalars['String']['output']>;
  /**
   * The primary identifier for a UserInsight.  Primarily used for tracking user engagement.
   *
   *   Because insight inventory items are typically stateless and do not have proper database IDs, this field will generally
   *   be inferred by source-specific heuristics.
   *
   *   Note that the id field is unique across all instances of a particular insight (whereas the slug field is not).
   */
  id: Scalars['ID']['output'];
  /** Language that summarizes or introduces the insight. */
  title?: Maybe<Scalars['String']['output']>;
  /** The insights regeneration group. */
  regenerationGroup?: Maybe<UserInsightRegenerationGroupEnum>;
  /** Language that describes the insight in detail. */
  description?: Maybe<Scalars['String']['output']>;
  /** General suggestions related to this insight that are not immediately actionable are surfaced as a "tip" */
  tip?: Maybe<UserInsightTip>;
  /**
   * A measure of how impactful this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   *   impact)
   *
   *   For example, a large transaction alert would be high-urgency while a credit card recommendation would be low-urgency.
   */
  impact?: Maybe<Scalars['Float']['output']>;
  /**
   * A measure of how urgent this insight is to the user, on a scale of 0 to 1 (where 1 indicates maximum
   *   urgency)
   *
   *   For example, a large transaction alert would be high-urgency while a credit card recommendation would be
   *   low-urgency.
   */
  urgency?: Maybe<Scalars['Float']['output']>;
  /**
   * Information about the ML model used to produce a personalized ranking score for the current user about a particular
   *   insight.
   */
  personalizedRankingScore?: Maybe<UserInsightPersonalizedRankingScore>;
  /**
   * A qualitative indication of how the user should feel about a particular insight.  Used primarily to inform UI
   *   treatment (e.g. red vs. yellow vs. blue accent color).
   *
   *   Note that a NEUTRAL sentiment value means that the insight is explicitly assessed to be of neutral sentiment, whereas
   *   the absence of a sentiment value means that the sentiment is unknown.
   */
  sentiment?: Maybe<UserInsightSentimentEnum>;
  /** The actions that we recommend for the user to perform based on this insight. */
  actions: Array<UserAction>;
  /** Insights may be related to one or more features, which are represented via this field. */
  relatedFeatures?: Maybe<Array<MembershipFeatureEnum>>;
  /**
   * The source of truth for this particular insight (typically a service or a CMS).
   *
   *   Used primarily to infer the type of a particular UserInsightInterface instance.
   */
  inventorySource: UserInsightInventorySourceEnum;
  /** An object containing the data necessary to render the data visualization for this insight. */
  dataVisualization?: Maybe<UserInsightDataVisualizationInterface>;
  /** An image to be displayed with the insight near the description. */
  bodyImage?: Maybe<UserInsightImage>;
  /**
   * This field encapsulates the concept of an increase or gain to a user’s personal finances.
   *
   *   This could range from credit score increases to an increase in savings or debt.
   */
  gain?: Maybe<UserInsightGain>;
  /** The UX modules that this insight may appear in. */
  eligibleModules?: Maybe<Array<UserInsightEligibleModulesEnum>>;
  /** The eligibility configuration for the current client */
  clientEligibilityConfig?: Maybe<ClientEligibilityConfig>;
  /**
   * The URL to an image that insight cards can use to apply additional visual treatment for cases such as:
   *   Celebratory, Cautionary, Light Bulb
   */
  imageTreatmentUrl?: Maybe<Scalars['URL']['output']>;
  imageTreatmentType?: Maybe<UserInsightImageTreatmentTypeEnum>;
  advertiserDisclosure?: Maybe<Scalars['String']['output']>;
  legalDisclaimer?: Maybe<Scalars['String']['output']>;
};

/** Credit card offer */
export type CreditCardOffer = OfferInterface & {
  __typename?: 'CreditCardOffer';
  derivedDetails?: Maybe<CreditCardOfferDerivedDetails>;
  details: CreditCardOfferDetails;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  institution: CreditCardInstitution;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  product?: Maybe<CreditCardProduct>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
  /**
   * All active related card offers, must query for relatedCardIds in the parent details, and status in relatedCardOffers
   *   For example
   *   creditCardOffer {
   *   details {
   *   relatedCardIds
   *   }
   *   relatedCardOffers {
   *   status
   *   }
   *   }
   */
  relatedCreditCardOffers?: Maybe<Array<CreditCardOffer>>;
};

/** Credit Card Institutions */
export type CreditCardInstitution = InstitutionInterface & {
  __typename?: 'CreditCardInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

/** Credit Card Product */
export type CreditCardProduct = ProductInterface & {
  __typename?: 'CreditCardProduct';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

export type InvestmentAccountOffer = OfferInterface & AccountOfferInterface & {
  __typename?: 'InvestmentAccountOffer';
  advisorFee?: Maybe<Scalars['String']['output']>;
  applyLink?: Maybe<Scalars['URL']['output']>;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  flatTradePrice?: Maybe<Scalars['Float']['output']>;
  institution?: Maybe<InvestmentAccountInstitution>;
  details?: Maybe<InvestmentAccountOfferDetails>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewUrl?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
};

export type InvestmentAccountInstitution = InstitutionInterface & {
  __typename?: 'InvestmentAccountInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

/** Personal Loan Offers */
export type PersonalLoanOffer = OfferInterface & {
  __typename?: 'PersonalLoanOffer';
  details: PersonalLoanOfferDetails;
  derivedDetails: PersonalLoanOfferDerivedDetails;
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  product: PersonalLoanProduct;
  startsAt?: Maybe<Scalars['DateTime']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
};

/** Personal Loan Products */
export type PersonalLoanProduct = ProductInterface & {
  __typename?: 'PersonalLoanProduct';
  details: PersonalLoanProductDetails;
  institution: PersonalLoanInstitution;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

/** Personal Loan Institutions */
export type PersonalLoanInstitution = InstitutionInterface & {
  __typename?: 'PersonalLoanInstitution';
  /** There were no details when this schema was constructed. */
  details: EmptyObject;
  canonicalInstitutionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

/** The `MortgageProduct` type contains mortgage specific fields from marketplace */
export type MortgageProduct = ProductInterface & {
  __typename?: 'MortgageProduct';
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
  details?: Maybe<MortgageProductDetails>;
};

export type SavingsAccountOffer = OfferInterface & AccountOfferInterface & {
  __typename?: 'SavingsAccountOffer';
  endsAt?: Maybe<Scalars['DateTime']['output']>;
  applyLink?: Maybe<Scalars['URL']['output']>;
  apy?: Maybe<Scalars['Float']['output']>;
  institution?: Maybe<SavingsAccountInstitution>;
  details?: Maybe<SavingsAccountOfferDetails>;
  imageUrl?: Maybe<Scalars['String']['output']>;
  rating?: Maybe<Scalars['Float']['output']>;
  reviewUrl?: Maybe<Scalars['String']['output']>;
  providerName?: Maybe<Scalars['String']['output']>;
  slug?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
  productId?: Maybe<Scalars['ID']['output']>;
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
};

export type SavingsAccountInstitution = InstitutionInterface & {
  __typename?: 'SavingsAccountInstitution';
  canonicalInstitutionId?: Maybe<Scalars['String']['output']>;
  createdAt?: Maybe<Scalars['DateTime']['output']>;
  dataHash?: Maybe<Scalars['String']['output']>;
  entityType: Scalars['String']['output'];
  externalId?: Maybe<Scalars['String']['output']>;
  id: Scalars['ID']['output'];
  name: Scalars['String']['output'];
  productType: Scalars['String']['output'];
  status: Scalars['String']['output'];
  tags: Array<Scalars['String']['output']>;
  updatedAt?: Maybe<Scalars['DateTime']['output']>;
  versionId?: Maybe<Scalars['ID']['output']>;
};

/** A Education Loans offer */
export type EducationLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'EducationLoansOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** Available term lengths for the offer */
  availableTermLengths?: Maybe<Scalars['String']['output']>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Disclaimer for the offer */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** US States that the lender will not service */
  excludedStates?: Maybe<Array<Scalars['String']['output']>>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Min. FICO (credit score) */
  minFico?: Maybe<Scalars['Int']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Indicates the offer has a partner */
  partner?: Maybe<Scalars['String']['output']>;
  product: EducationLoansProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Short custom label to be used with rating stars (should be 20 characters or less) */
  starRatingLabel?: Maybe<Scalars['String']['output']>;
  /** Custom tooltip to be used with the rating stars label */
  starRatingLabelTooltip?: Maybe<Scalars['String']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver min credit score associated with the entity */
  driverMinCreditScore?: Maybe<EntityPlacementDriver>;
  /** The driver fixed apr with annotation associated with the entity */
  driverFixedAprWithAnnotation?: Maybe<EntityPlacementDriver>;
  /** The driver variable apr with annotation associated with the entity */
  driverVariableAprWithAnnotation?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};

/** A Mortgages offer */
export type MortgagesOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'MortgagesOfferV2';
  /** Long-form text about the lender, each item is a paragraph */
  aboutLender?: Maybe<Array<Scalars['String']['output']>>;
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** Short description of what the lender is best for e.g. customer service */
  bestForBullets?: Maybe<Array<Scalars['String']['output']>>;
  bestOfBadgeWinner2020?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Coverage area for the lender */
  coverageArea?: Maybe<Scalars['String']['output']>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Which drivers should be highlighted for this offer */
  drivers?: Maybe<Array<Scalars['String']['output']>>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** US States that the lender will not service */
  excludedStates?: Maybe<Array<Scalars['String']['output']>>;
  /** Short tagline that specifies what is the lender good for (max: 1 line) */
  goodFor?: Maybe<Scalars['String']['output']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Used to determine if placement is monetizing */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Loan type this offer represents */
  loanType?: Maybe<MortgagesOfferV2LoanTypeEnum>;
  /** Maximum credit score lender will service */
  maxCreditScoreFilter?: Maybe<Scalars['Int']['output']>;
  /** Maximum loan amount */
  maxLoanAmount?: Maybe<Scalars['Float']['output']>;
  /** Overrides tooltip value for max loan amount */
  maxLoanAmountTooltip?: Maybe<Scalars['String']['output']>;
  /** Display value for maximum loan-to-value */
  maxLtv?: Maybe<Scalars['String']['output']>;
  /** Overrides tooltip value for maximum loan-to-value */
  maxLtvTooltip?: Maybe<Scalars['String']['output']>;
  /** Display value for minimum credit score */
  minCreditScore?: Maybe<Scalars['String']['output']>;
  /** Minimum credit score lender will service */
  minCreditScoreFilter?: Maybe<Scalars['Int']['output']>;
  /** Overrides tooltip value for minimum credit score */
  minCreditScoreTooltip?: Maybe<Scalars['String']['output']>;
  /** Display value for minimum down payment. Only applicable to PURCHASE loans */
  minDownPayment?: Maybe<Scalars['String']['output']>;
  /** Overrides tooltip value for minimum down payment */
  minDownPaymentTooltip?: Maybe<Scalars['String']['output']>;
  /** Minimum loan amount */
  minLoanAmount?: Maybe<Scalars['Float']['output']>;
  /** Overrides tooltip value for min loan amount */
  minLoanAmountTooltip?: Maybe<Scalars['String']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** NMLS (Nationwide Mortgage Licensing System and Registry) Unique Identifier */
  nmlsId?: Maybe<Scalars['String']['output']>;
  /** List of tags associated with the offer */
  offerTags?: Maybe<Array<Scalars['String']['output']>>;
  /** Bullet points providing an overview of the lender */
  overview?: Maybe<Array<Scalars['String']['output']>>;
  /** Lender's phone number */
  payPerCall?: Maybe<Scalars['String']['output']>;
  product: MortgagesProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Disclaimer for the NerdWallet rating */
  ratingDisclaimer?: Maybe<Scalars['String']['output']>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** NerdWallet review rating stars */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Short custom label to be used with rating stars (should be 20 characters or less) */
  starRatingLabel?: Maybe<Scalars['String']['output']>;
  /** Custom tooltip to be used with the rating stars label */
  starRatingLabelTooltip?: Maybe<Scalars['String']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Short summary of why NerdWallet recommends this lender */
  tagline?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver max ltv associated with the entity */
  driverMaxLtv?: Maybe<EntityPlacementDriver>;
  /** The driver min credit score associated with the entity */
  driverMinCreditScore?: Maybe<EntityPlacementDriver>;
  /** The driver min down payment associated with the entity */
  driverMinDownPayment?: Maybe<EntityPlacementDriver>;
  /** The driver national regional associated with the entity */
  driverNationalRegional?: Maybe<EntityPlacementDriver>;
  /** The driver max loan amount associated with the entity */
  driverMaxLoanAmount?: Maybe<EntityPlacementDriver>;
  /** The driver min loan amount associated with the entity */
  driverMinLoanAmount?: Maybe<EntityPlacementDriver>;
  /** The driver loan types and products associated with the entity */
  driverLoanTypesAndProducts?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** If the offer has Lead Form enabled */
  hasLeadForm?: Maybe<Scalars['Boolean']['output']>;
  /** The overview associated with the product */
  productOverview?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};

/** A Software offer */
export type SoftwareOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'SoftwareOfferV2';
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** Cons for the offer. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Text presented as part of CTA */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** The display name for the entity */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** The cost of any hardware the offer requires. */
  hardwareCost?: Maybe<Scalars['Float']['output']>;
  /** Indicates if the offer has separate interchange fees from card networks. */
  hasInterchangeFees?: Maybe<Scalars['Boolean']['output']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The flat fee per transaction when the transaction is in person. ex. '0.05' */
  inPersonTransactionFlatFee?: Maybe<Scalars['Float']['output']>;
  /** The percentage fee per transaction when the transaction is in person. For 2.7%, set to '2.7'. */
  inPersonTransactionPercentageFee?: Maybe<Scalars['Float']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Used to determine if placement is monetizing. */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** The flat fee per transaction when the transaction is online. ex. '0.05' */
  onlineTransactionFlatFee?: Maybe<Scalars['Float']['output']>;
  /** The percentage fee per transaction when the transaction is online. For 2.7%, set to '2.7'. */
  onlineTransactionPercentageFee?: Maybe<Scalars['Float']['output']>;
  /** The processing fees charged by the payment provider. */
  paymentsCost?: Maybe<Scalars['String']['output']>;
  /** Additional context on the processing fees charged by the payment provider. */
  paymentsDetails?: Maybe<Scalars['String']['output']>;
  product: SoftwareProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** Pros for the offer. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** The cost of any required software subscription. */
  softwareCost?: Maybe<Scalars['Float']['output']>;
  /** Standard flat fee per transaction. Used to represent the transaction flat fee when there is no separate in-person or online fee. ex. '0.05' */
  standardTransactionFlatFee?: Maybe<Scalars['Float']['output']>;
  /** Standard percentage fee per transaction. Used to represent the transaction percentange fee when there is no separate in-person or online fee. For 2.7%, set to '2.7'. */
  standardTransactionPercentageFee?: Maybe<Scalars['Float']['output']>;
  /** The overall editorial rating for this Offer. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Product description. */
  tagline?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver price associated with the entity */
  driverPrice?: Maybe<EntityPlacementDriver>;
  /** The driver bonus associated with the entity */
  driverBonus?: Maybe<EntityPlacementDriver>;
  /** The annotation for the agency that federally insures the institution */
  federallyInsuredAnnotation?: Maybe<Scalars['String']['output']>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};

/** A Estate Planning offer */
export type EstatePlanningOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'EstatePlanningOfferV2';
  /** Indicates if offer has access to attorney support */
  accessToAttorneySupport?: Maybe<Scalars['Boolean']['output']>;
  /** Numeric value of the annual price of the offer */
  annualPrice?: Maybe<Scalars['Float']['output']>;
  /** Stylized version of the annual price of the offer. ex. '$19 annual membership fee.' */
  annualPriceDetails?: Maybe<Scalars['String']['output']>;
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** Short description of what the offer is best for e.g. customer service */
  bestForBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Annotation for the CTA button */
  ctaAnnotation?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  descriptionBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Used to determine if offer is monetizing. */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Label */
  label?: Maybe<Scalars['String']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Numeric value of the one-time price of the offer */
  price?: Maybe<Scalars['Float']['output']>;
  /** Stylized version of the price. ex. 'One-time fee of $159 per individual or $259 for couples.' */
  priceDetails?: Maybe<Scalars['String']['output']>;
  product: EstatePlanningProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** The overall editorial rating for this offer */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};

/** A Expansion offer */
export type ExpansionOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'ExpansionOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** BBB rating as a string for the offer. */
  bbbGradeDescription?: Maybe<Scalars['String']['output']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Annotation for the offer CTA */
  ctaAnnotation?: Maybe<Scalars['String']['output']>;
  /** Deposit required as a string for the offer. */
  depositRequiredDescription?: Maybe<Scalars['String']['output']>;
  /** A description for the offer. */
  description?: Maybe<Scalars['String']['output']>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Driver for banners */
  driver1?: Maybe<Scalars['String']['output']>;
  /** Text that provides more details on the driver1 value */
  driver1ExplanationText?: Maybe<Scalars['String']['output']>;
  /** Driver for banners */
  driver2?: Maybe<Scalars['String']['output']>;
  /** Text that provides more details on the driver2 value */
  driver2ExplanationText?: Maybe<Scalars['String']['output']>;
  /** Driver for banners */
  driver3?: Maybe<Scalars['String']['output']>;
  /** Text that provides more details on the driver3 value */
  driver3ExplanationText?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** Financing options available as a string for the offer. */
  financingOptionsDescription?: Maybe<Scalars['String']['output']>;
  /** Full service packing as a string is available for the offer. */
  fullServicePackingDescription?: Maybe<Scalars['String']['output']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Best label for describing an offer */
  label?: Maybe<Scalars['String']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Phone number as a string for the offer. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Phone number annotation as a string for the offer. */
  phoneNumberAnnotation?: Maybe<Scalars['String']['output']>;
  /** Plans available as a string for the offer. */
  plansAvailableDescription?: Maybe<Scalars['String']['output']>;
  product: ExpansionProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Response time as a string for the offer. */
  responseTimeDescription?: Maybe<Scalars['String']['output']>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** Service availability as a string for the offer. */
  serviceAvailabilityDescription?: Maybe<Scalars['String']['output']>;
  /** The overall editorial rating for the offer. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Custom tooltip to be used with the star rating. */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** States covered by the offer. */
  statesCovered?: Maybe<Array<StateAbbreviationsEnum>>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Teletypewriters (TTY) as a string for the offer. */
  tty?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Working schedule as a string for the offer */
  workingSchedule?: Maybe<Scalars['String']['output']>;
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};

/** A Auto Loans institution */
export type AutoLoansInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'AutoLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Auto Loans product */
export type AutoLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'AutoLoansProductV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: AutoLoansInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Banking institution */
export type BankingInstitutionV2 = MarketplaceEntityInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceInstitutionInterface & {
  __typename?: 'BankingInstitutionV2';
  /** The display name for the entity. */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** The editorial rating on the banking experience for the institution. */
  ratingBankExperience?: Maybe<Scalars['Float']['output']>;
  /** The editorial rating on overdraft fees for the institution. */
  ratingOverdraftFee?: Maybe<Scalars['Float']['output']>;
  /** The URL to the NerdWallet review of this institution. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** The overall, editorial rating for the institution. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /** Monetizable status that conforms to one of the values defined by NerdWallet analytics */
  monetizable: Scalars['String']['output'];
  /** The type of the banking institution */
  institutionType?: Maybe<Scalars['String']['output']>;
  /** The Banking Offer to use for related apply links (filtered based on monetizable status and geotargeting) */
  offerForCta?: Maybe<BankingOfferV2>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};


/** A Banking institution */
export type BankingInstitutionV2OfferForCtaArgs = {
  userState?: InputMaybe<StateAbbreviationsEnum>;
};

/** A Banking product */
export type BankingProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'BankingProductV2';
  /** Indicates whether wire transfers are offered by the bank account. */
  allowsWireTransfers?: Maybe<Scalars['Boolean']['output']>;
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** Indicates whether bank charges a fee for depositing cash. */
  freeCashDeposits?: Maybe<Scalars['Boolean']['output']>;
  /** Information about limitations or constraints of Cash Deposits whether free or not. */
  freeCashDepositsDetails?: Maybe<Scalars['String']['output']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: BankingInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** Indicates whether account holders can execute an unlimited amount of transactions per month. */
  unlimitedTransactions?: Maybe<Scalars['Boolean']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Additional information about wire transfers (e.g. the incurred fees). */
  wireTransferDetails?: Maybe<Scalars['String']['output']>;
};

/** A Credit Cards institution */
export type CreditCardsInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'CreditCardsInstitutionV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Credit Cards product */
export type CreditCardsProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'CreditCardsProductV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: CreditCardsInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Education Loans institution */
export type EducationLoansInstitutionV2 = MarketplaceEntityInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceInstitutionInterface & {
  __typename?: 'EducationLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** The overall editorial rating for the institution. */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Short custom label to be used with rating stars (should be 20 characters or less) */
  starRatingLabel?: Maybe<Scalars['String']['output']>;
  /** Custom tooltip to be used with the rating stars label */
  starRatingLabelTooltip?: Maybe<Scalars['String']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
};

/** A Education Loans product */
export type EducationLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'EducationLoansProductV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: EducationLoansInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Short custom label to be used with rating stars (should be 20 characters or less) */
  starRatingLabel?: Maybe<Scalars['String']['output']>;
  /** Custom tooltip to be used with the rating stars label */
  starRatingLabelTooltip?: Maybe<Scalars['String']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Estate Planning institution */
export type EstatePlanningInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'EstatePlanningInstitutionV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** A URL that points to the logo for the institution */
  imageRaw?: Maybe<Scalars['URL']['output']>;
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** A URL that points to the logo for the institution */
  logoUrl?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Estate Planning product */
export type EstatePlanningProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'EstatePlanningProductV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: EstatePlanningInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Expansion institution */
export type ExpansionInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'ExpansionInstitutionV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** A URL that points to the logo for the institution */
  imageRaw?: Maybe<Scalars['URL']['output']>;
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** A URL that points to the cloudflare auto-resizing image service for an image that represents the logo. This service can provide images in any size on the fly in an efficient manner and is the standard at NW for serving images in a high performance way. */
  logoUrl?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Expansion product */
export type ExpansionProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'ExpansionProductV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** This would be a list of defined strings such as “moving” and “software”. A given institution may provide products/offers in multiple areas, so we need to be able to express this. */
  expansionVerticalType?: Maybe<Scalars['String']['output']>;
  /** Explanation for vertical type 'OTHER' */
  expansionVerticalTypeDescription?: Maybe<Scalars['String']['output']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: ExpansionInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Mortgages institution */
export type MortgagesInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'MortgagesInstitutionV2';
  /** Lender name to display */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** Loan programs and types to feature for the lender */
  featuredLoanAttributes?: Maybe<Array<Scalars['String']['output']>>;
  /** Lead form enabled? */
  hasLeadForm?: Maybe<Scalars['Boolean']['output']>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** A URL that points to the logo for the institution */
  imageRaw?: Maybe<Scalars['URL']['output']>;
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Are personalized rates enabled for HELOC/HELOAN? */
  isHomeEquityRatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Are personalized rates enabled? */
  isRatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** Should institution be included on Home widgetized table? */
  isWidgetEnabled?: Maybe<Scalars['Boolean']['output']>;
  /** The API provider name for mortgage lenders that support lead form or lead match */
  leadProviderName?: Maybe<Scalars['String']['output']>;
  lenderWebsiteConfig?: Maybe<Scalars['JSON']['output']>;
  mortechId?: Maybe<Scalars['String']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** NMLS Unique Identifier */
  nmlsId?: Maybe<Scalars['String']['output']>;
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Mortgages product */
export type MortgagesProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'MortgagesProductV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: MortgagesInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** The lender's phone number */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The type of loan */
  type?: Maybe<MortgagesProductV2TypeEnum>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Personal Loans institution */
export type PersonalLoansInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'PersonalLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Personal Loans offer */
export type PersonalLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwards2021Interface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'PersonalLoansOfferV2';
  /** Apply link for the offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** Average narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
  avgNarrowApr?: Maybe<Scalars['Float']['output']>;
  /** The list of NW Best-Of Awards this offer has won for 2021 */
  bestOfBadgeWinner2021?: Maybe<Array<Scalars['String']['output']>>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Disclaimer for the offer */
  disclaimer?: Maybe<Scalars['String']['output']>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** Loan purpose that the lender will not service */
  excludedLoanPurpose?: Maybe<Array<Scalars['String']['output']>>;
  /** US States that the lender will not service */
  excludedStates?: Maybe<Array<Scalars['String']['output']>>;
  /** Exclusive Offer Disclaimer for the offer */
  exclusiveDisclaimer?: Maybe<Scalars['String']['output']>;
  /** Category used to group offers on the expanded marketplace */
  expandedMarketplaceCategory?: Maybe<PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum>;
  /** List of fees associated with the offer */
  feesBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Provider's logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Provider's logo (large) */
  imageSourceLarge?: Maybe<Scalars['URL']['output']>;
  /** Provider's logo (medium) */
  imageSourceMedium?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Flag indicating whether or not this offer can be surfaced on the expanded marketplace page */
  isExpandedMarketplaceOffer?: Maybe<Scalars['Boolean']['output']>;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Flag indiciating whether or not prequal is allowed for this offer */
  isPrequalOffer?: Maybe<Scalars['Boolean']['output']>;
  keyFactsBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** Maximum annual percentage rate (APR) entered in basis points. For example, entering 1234 will represent 12.34%. */
  maxApr?: Maybe<Scalars['Float']['output']>;
  /** Maximum loan amount */
  maxLoanAmount?: Maybe<Scalars['Float']['output']>;
  /** Maximum loan term */
  maxLoanTerm?: Maybe<Scalars['Int']['output']>;
  /** Maximum narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
  maxNarrowApr?: Maybe<Scalars['Float']['output']>;
  /** Minimum annual percentage rate (APR) entered in basis points. For example, entering 1234 will represent 12.34%. */
  minApr?: Maybe<Scalars['Float']['output']>;
  /** Text for overriding the 'min_fico' value. */
  minFicoOverrideText?: Maybe<Scalars['String']['output']>;
  /** Minimum loan amount */
  minLoanAmount?: Maybe<Scalars['Float']['output']>;
  /** Minimum loan term in months */
  minLoanTermMonths?: Maybe<Scalars['Int']['output']>;
  /** Minimum narrow annual percentage rate (APR) range in percentage points. For example, 12.34 will represent 12.34%. */
  minNarrowApr?: Maybe<Scalars['Float']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** Estimated monthly payment */
  monthlyPayment?: Maybe<Scalars['Float']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** List of tags associated with the offer */
  offerTags?: Maybe<Array<Scalars['String']['output']>>;
  /** Phone number that users can call to reach out to the partner on desktop, in place of the CTA on lender card. Enter value as 1231231234 to represent a phone number like (123) 123 - 1234. */
  phoneNumberDesktop?: Maybe<Scalars['String']['output']>;
  /** Phone number that users can call to reach out to the partner on mobile, in place of the CTA on lender card. Enter value as 1231231234 to represent a phone number like (123) 123 - 1234. */
  phoneNumberMobile?: Maybe<Scalars['String']['output']>;
  product: PersonalLoansProductV2;
  /** Product type */
  productType: Scalars['String']['output'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** Star rating */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Short custom label to be used with rating stars (should be 20 characters or less) */
  starRatingLabel?: Maybe<Scalars['String']['output']>;
  /** Custom tooltip to be used with the rating stars label */
  starRatingLabelTooltip?: Maybe<Scalars['String']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Short summary of why NerdWallet recommends this provider */
  tagline?: Maybe<Scalars['String']['output']>;
  /** Time to fund in days */
  timeToFund?: Maybe<Scalars['Float']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** Available term lengths for the entity */
  availableTermLengths?: Maybe<Scalars['String']['output']>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver estimated apr associated with the entity */
  driverEstimatedApr?: Maybe<EntityPlacementDriver>;
  /** The driver loan amount associated with the entity */
  driverLoanAmount?: Maybe<EntityPlacementDriver>;
  /** The driver loan term associated with the entity */
  driverLoanTerm?: Maybe<EntityPlacementDriver>;
  /** The driver min credit score associated with the entity */
  driverMinCreditScore?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};

/** A Personal Loans product */
export type PersonalLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'PersonalLoansProductV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: PersonalLoansInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Small Medium Business Loans institution */
export type SmallMediumBusinessLoansInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'SmallMediumBusinessLoansInstitutionV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Small Medium Business Loans offer */
export type SmallMediumBusinessLoansOfferV2 = MarketplaceEntityInterface & MarketplaceEntityWithBestOfAwardsInterface & MarketplaceEntityWithPlacementInterface & MarketplaceEntityWithQualificationsInterface & MarketplaceEntityWithReviewInterface & MarketplaceEntityWithStarRatingInterface & MarketplaceOfferInterface & {
  __typename?: 'SmallMediumBusinessLoansOfferV2';
  /** Redirect link for this Offer */
  applyLink?: Maybe<Scalars['URL']['output']>;
  /** The list of disadvantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The display name for the entity (auto-generated) */
  displayName?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** URL for the logo */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** The parent Institution of this Offer */
  institution: MarketplaceEntityInterface;
  /** Whether this Offer is monetizing. Client apps use this field to decide display behaviors, e.g. show/hide offer, show Apply Now or Learn More CTA */
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Maximum loan amount (i.e., $5,000,000 is entered as 5000000) */
  maxLoanAmount?: Maybe<Scalars['Float']['output']>;
  /** Maximum loan term in months (i.e., 5 years is entered as 60) */
  maxLoanTerm?: Maybe<Scalars['Int']['output']>;
  /** Minimum loan term in months (i.e., 5 years is entered as 60) */
  minLoanTerm?: Maybe<Scalars['Int']['output']>;
  /** Return a string with only 1 of 3 possible values 'yes_assumed', 'no', 'no_because_of_limit' */
  monetizable: Scalars['String']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  product: SmallMediumBusinessLoansProductV2;
  /** Use this if the product has any notable features you want to highlight on the product card */
  productLabel?: Maybe<Scalars['String']['output']>;
  /** Product type */
  productType: Scalars['String']['output'];
  /** The list of advantages this offer provides, each item is a separate bullet. Usually chosen by the Content team. */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** List of qualifications for the offer */
  qualificationsBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** The URL to the NerdWallet review of this offer. */
  reviewLink?: Maybe<Scalars['URL']['output']>;
  /** Speed to funding duration value */
  speedToFunding?: Maybe<Scalars['Int']['output']>;
  /** Speed to funding duration type */
  speedToFundingDuration?: Maybe<Scalars['String']['output']>;
  /** The overall editorial rating for this offer */
  starRating?: Maybe<Scalars['Float']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** The list of disadvantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentCons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The list of advantages this offer provides, each item is a separate bullet as structured content. Usually chosen by the Content team. */
  structuredContentPros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  structuredContentTagline?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Short summary of why NerdWallet recommends this provider (aka bottom line) */
  tagline?: Maybe<Scalars['String']['output']>;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
  /** Data used for building analytics events */
  analyticsProps?: Maybe<EntityPlacementAnalyticsProps>;
  /** The Best Of Awards that this offer has won */
  bestOfAwards?: Maybe<Array<BestOfAward>>;
  /** The CTA for the marketplace entity */
  cta?: Maybe<EntityPlacementCta>;
  /** The driver estimated apr associated with the entity */
  driverEstimatedApr?: Maybe<EntityPlacementDriver>;
  /** The driver min credit score associated with the entity */
  driverMinCreditScore?: Maybe<EntityPlacementDriver>;
  /** The image data associated with the entity */
  image?: Maybe<EntityPlacementImage>;
  /**
   * The drivers associated with the entity
   * @deprecated Drivers are being unwrapped from the placementDrivers. Each driver is now declared separately.
   */
  placementDrivers: Array<EntityPlacementDriver>;
  /** A boolean indicating if the display name should be shown in the comparison table component */
  showNameInComparisonTable: Scalars['Boolean']['output'];
  /** The tooltip value for NerdWallet's star rating */
  starRatingTooltip?: Maybe<Scalars['String']['output']>;
  /** Flag for whether to use the large product card image styles */
  useLargeImageFootprint: Scalars['Boolean']['output'];
};

/** A Small Medium Business Loans product */
export type SmallMediumBusinessLoansProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'SmallMediumBusinessLoansProductV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: SmallMediumBusinessLoansInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Software institution */
export type SoftwareInstitutionV2 = MarketplaceEntityInterface & MarketplaceInstitutionInterface & {
  __typename?: 'SoftwareInstitutionV2';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** A URL that points to the logo for the institution */
  imageRaw?: Maybe<Scalars['URL']['output']>;
  /** A URL that points to the logo for the institution */
  imageSource?: Maybe<Scalars['URL']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Software product */
export type SoftwareProductV2 = MarketplaceEntityInterface & MarketplaceProductInterface & {
  __typename?: 'SoftwareProductV2';
  /** Essentially helps create a sub vertical. */
  category?: Maybe<Scalars['String']['output']>;
  description?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  institution: SoftwareInstitutionV2;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Third Party Embeds institution */
export type ThirdPartyEmbedsInstitution = MarketplaceEntityInterface & {
  __typename?: 'ThirdPartyEmbedsInstitution';
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/** A Third Party Embeds product */
export type ThirdPartyEmbedsProduct = MarketplaceEntityInterface & {
  __typename?: 'ThirdPartyEmbedsProduct';
  /** Enter the HTML for this embed. This comes from the partner. */
  embedCode?: Maybe<Scalars['String']['output']>;
  /** Entity type */
  entityType: Scalars['String']['output'];
  /** UUID primary key for the Marketplace entity */
  id: Scalars['ID']['output'];
  /** Custom height for embeds. */
  iframeHeight?: Maybe<Scalars['Float']['output']>;
  institution: ThirdPartyEmbedsInstitution;
  isMonetizing?: Maybe<Scalars['Boolean']['output']>;
  /** Loading text for embeds. */
  loadingCopy?: Maybe<Scalars['String']['output']>;
  /** Marketplace product type to use in analytics events. */
  marketplaceProductType?: Maybe<Scalars['String']['output']>;
  /** Name of the entity. Varies with the product type. Examples: `Ally Clearlane - Refinance loan` for an Auto Loans Offer. `01MCD10K` for an ingested Banking Offer */
  name: Scalars['String']['output'];
  /** Product type */
  productType: Scalars['String']['output'];
  /** Toggles ad banner for third party embeds */
  showAdBanner?: Maybe<Scalars['Boolean']['output']>;
  /** Entity status */
  status: MarketplaceStatusEnum;
  /** When the entity was last updated in the DB */
  updatedAt: Scalars['DateTime']['output'];
  /** The current version number of the entity */
  versionId: Scalars['Int']['output'];
};

/**
 * The data shape of a Home — integrated with Redfin, in Wealth Recommender. "Integrated"
 * describes the fact that this asset's data is sourced from a 3rd-party integration with a data
 * provider, e.g. Redfin. This is meant to be a differentiator for self-reported Home values.
 */
export type NetWorthHomeIntegrated = NetWorthRealAsset & {
  __typename?: 'NetWorthHomeIntegrated';
  id: Scalars['ID']['output'];
  type: NetWorthRealAssetTypeEnum;
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  address: NetWorthHomeIntegratedAddress;
  externalInfo?: Maybe<NetWorthHomeIntegratedExternalInfo>;
  isSelfReported: Scalars['Boolean']['output'];
};

/**
 * The data shape of a Real Asset — self-reported by the user, in Wealth Recommender. This is a
 * different data model from the "Integrated" version of homes, which are synced with Redfin and
 * have their own set of requirements.
 */
export type NetWorthRealAssetSelfReported = NetWorthRealAsset & {
  __typename?: 'NetWorthRealAssetSelfReported';
  id: Scalars['ID']['output'];
  type: NetWorthRealAssetTypeEnum;
  isHiddenFromNetWorth?: Maybe<Scalars['Boolean']['output']>;
  amount?: Maybe<Scalars['Float']['output']>;
  lastReportedOrSyncedAt?: Maybe<Scalars['DateTime']['output']>;
  /**
   * The unique identifier for a self-reported asset in the UX. For contrast, NetWorthIntegrated
   *   we use the address fields for uniqueness.
   */
  nickname: Scalars['String']['output'];
  isSelfReported: Scalars['Boolean']['output'];
};

export type NetWorthHomeValueResultResponseData = NetWorthHomeValueResultResponseDataInterface & {
  __typename?: 'NetWorthHomeValueResultResponseData';
  /** The enum type of the response data, whether it's a Result or a Possibility. In this case it will always be Result. */
  type: NetWorthHomeValueResultTypeEnum;
  /**
   * This field denotes which data provider is associated with the search result that is returned
   *   to the client. This is a no-cost schema addition that grants us flexibility for a future
   *   where we may have multiple providers with different prioritizations (e.g. Zillow search
   *   result over Redfin).
   */
  source: NetWorthHomeValueResultSourceEnum;
  /**
   * The source provider's ID for the given home value. This is used by WR to request updated
   *   home values for snapshotting.
   */
  propertyId?: Maybe<Scalars['String']['output']>;
  /** The browser URL that maps to the property's posting. */
  url?: Maybe<Scalars['String']['output']>;
  /** The value of the home related to the provided address. */
  value?: Maybe<Scalars['Float']['output']>;
  address?: Maybe<NetWorthHomeValueResultResponseAddress>;
};

export type NetWorthHomeValuePossibilityResponseData = NetWorthHomeValueResultResponseDataInterface & {
  __typename?: 'NetWorthHomeValuePossibilityResponseData';
  /** The enum type of the response data, whether it's a Result or a Possibility. In this case it will always be Possibility. */
  type: NetWorthHomeValueResultTypeEnum;
  /** The list of possible home values for ambiguous cases */
  possibilities?: Maybe<Array<NetWorthHomeValueResultResponseData>>;
};

/** Auto Insurance Prequal Offer */
export type AutoInsurancePrequalOffer = PrequalOffer & {
  __typename?: 'AutoInsurancePrequalOffer';
  applyLink: Scalars['String']['output'];
  institutionName: Scalars['String']['output'];
  institutionLogo: Scalars['String']['output'];
  nwRating?: Maybe<Scalars['Float']['output']>;
  providerId?: Maybe<Scalars['ID']['output']>;
  /** The marketplace institution id for the offer */
  institutionId: Scalars['ID']['output'];
  /** offerId indicates the corresponding marketplace id for the offer */
  offerId: Scalars['ID']['output'];
  /** The marketplace product id for the offer */
  productId: Scalars['ID']['output'];
  /** rank tells the client what order the offers should be shown */
  rank: Scalars['Int']['output'];
  /** prosBullets is a list of advantages this offer provides, */
  prosBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** consBullets is a list of disadvantages this offer provides, */
  consBullets?: Maybe<Array<Scalars['String']['output']>>;
  /** reviewLink is the URL to the NerdWallet review of this offer */
  reviewLink?: Maybe<Scalars['URL']['output']>;
};

export type ArticlePage = StructuredContentPageInterface & {
  __typename?: 'ArticlePage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type SmbArticlePage = StructuredContentPageInterface & {
  __typename?: 'SmbArticlePage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type ScAuFlexPage = StructuredContentPageInterface & {
  __typename?: 'SCAuFlexPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type AuthorPage = StructuredContentPageInterface & {
  __typename?: 'AuthorPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type ExactPathScCalculatorPage = StructuredContentPageInterface & {
  __typename?: 'ExactPathSCCalculatorPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type ScCaFlexPage = StructuredContentPageInterface & {
  __typename?: 'SCCaFlexPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type ScCalculatorPage = StructuredContentPageInterface & {
  __typename?: 'SCCalculatorPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type CreditCardsRoundupsPage = StructuredContentPageInterface & {
  __typename?: 'CreditCardsRoundupsPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type ContentHubPage = StructuredContentPageInterface & {
  __typename?: 'ContentHubPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type UrlRecordCalcPage = StructuredContentPageInterface & {
  __typename?: 'UrlRecordCalcPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type ReviewerPage = StructuredContentPageInterface & {
  __typename?: 'ReviewerPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type CreditCardsReviewPage = StructuredContentPageInterface & {
  __typename?: 'CreditCardsReviewPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type SmbReviewPage = StructuredContentPageInterface & {
  __typename?: 'SmbReviewPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

export type ScFlexPage = StructuredContentPageInterface & {
  __typename?: 'SCFlexPage';
  /** Synthetic ID to use for caching in Apollo created by base64 encoding the incoming URI */
  id: Scalars['ID']['output'];
  /** WordPress ID for the primary page-level entity, if applicable */
  wpId?: Maybe<Scalars['ID']['output']>;
  /** The data to pass in to global markup in the client */
  globalMarkupOptions?: Maybe<GlobalMarkupOptions>;
  /** The data to use when firing the top level page impression event */
  pageImpressionData?: Maybe<PageImpressionData>;
  /** The data to use when firing the top level page impression Segment event */
  segmentTrackingAttributes?: Maybe<SegmentTrackingAttributes>;
  /** The schema data to use, as in schema.org schema */
  schemaData?: Maybe<SchemaData>;
  /** The layout info for the SC page */
  layout?: Maybe<PageLayout>;
  /** The template as a structured content document if it's supported */
  structuredContentTemplate?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether or not to show the WP admin bar at the top of the page */
  showWPAdminBar?: Maybe<Scalars['Boolean']['output']>;
};

/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type Article = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithChatbotInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithEditorInterface & PostWithExcerptInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithHubLinks & PostWithInternationalVersionsInterface & PostWithPageTaxonomyInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Article';
  /** Whether or not to show the advertiser disclosure. An empty value here indicates it should be shown. */
  advertiserDisclosure?: Maybe<Scalars['String']['output']>;
  /** The type of Article this is. */
  articleType?: Maybe<ArticleTypeEnum>;
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Article object. */
  categories?: Maybe<Array<Category>>;
  /** Field connecting to the ChatbotOptions Type and all of its nested fields. */
  chatbot?: Maybe<ChatbotOptions>;
  /** The Disqus thread ID for this content. */
  commentThreadId?: Maybe<Scalars['Int']['output']>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** Content tags associated with the content. */
  contentTags?: Maybe<Array<Scalars['String']['output']>>;
  /** The BlockGroups to use as custom content below the main content of the Article. */
  customBelowContent?: Maybe<BlockGroup>;
  /** The custom HouseAd to use on this Article. */
  customHouseAd?: Maybe<HouseAd>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The BlockGroups to use as the custom next steps for this Article. */
  customNextSteps?: Maybe<BlockGroup>;
  /** The BlockGroups to use as custom Related Links for this Article. */
  customRelatedLinks?: Maybe<BlockGroup>;
  /** The block group to use as the custom sidebar on this Article. */
  customSidebar?: Maybe<BlockGroup>;
  /** The custom title to use for this piece of content on a feed by feed basis. */
  customTitlesForRssFeeds?: Maybe<Array<ArticleCustomTitlesForRssFeed>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** Editorial disclaimer setting to show, hide, or display a specific disclaimer. An empty value here indicates it should be shown. */
  editorialDisclaimer?: Maybe<Scalars['String']['output']>;
  /** Whether or not to disable comments on this piece of content. */
  enableComments?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to display the Table of Contents in the sidebar of this Article. */
  enableTocInSidebar?: Maybe<Scalars['Boolean']['output']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']['output']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** Whether there is an expired offer in the content which should trigger expired or out of date messaging. */
  hasExpiredOffer?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to hide the Author information from the header of this piece of content. */
  hideAuthor?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to hide the banner for this piece of content. */
  hideBanner?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to hide the custom content to display below the main content for this Article. */
  hideBelowContent?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to hide the featured image for this piece of content. */
  hideFeaturedImage?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to hide the featured image on mobile/small screens. */
  hideFeaturedImageOnMobile?: Maybe<Scalars['Boolean']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The internal reviewers that this Article has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** Information about alternate versions of the content that exist for other locales. */
  internationalVersions?: Maybe<Array<InternationalVersion>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent the content from getting syndicated to NerdWalletWire.com and other services that use our full-text feeds. */
  isSyndicationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The layout to use for the content. */
  layout?: Maybe<ArticleLayoutEnum>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The block to use as the methodology for this piece of content. */
  methodology?: Maybe<Block>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The reviewers that this Article has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** The product, offer, or institution name that the Article represents a review about. */
  reviewProductName?: Maybe<Scalars['String']['output']>;
  /** The rating value to use with the Review schema type. */
  reviewRating?: Maybe<Scalars['Float']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to show the author box in the footer of this piece of content. */
  showAuthorBox?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Structured Content document representing the Table of Contents component for display in the sidebar of this Article. */
  tocSidebarDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Whether or not to use the custom content below the main content for this Article. */
  useCustomBelowContent?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to use a custom House Ad on this Article. */
  useCustomHouseAd?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to use the custom next steps for this Article. */
  useCustomNextSteps?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to use the custom related links for this Article. */
  useCustomRelatedLinks?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to use a custom sidebar for this Article. */
  useCustomSidebar?: Maybe<Scalars['Boolean']['output']>;
  /** Whether the Article should use the Review schema type. */
  useReviewSchemaType?: Maybe<Scalars['Boolean']['output']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** Structured Content Document for rendering content above Content Page Header */
  aboveContentPageHeaderDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** The structured content to display above the main article content */
  topDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The master structured content to display below the main article content: includes bottomDocument and WPDynamicPlacement */
  bottomContentDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /**
   * The structured content to display below the main article content
   * @deprecated Included within bottomContentDocument. Use bottomContentDocument instead.
   */
  bottomDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /**
   * The structured content to display at the bottom of the left or right sidebar under sidebarDocument and relatedLinks
   * @deprecated Included within rightSideContentDocument. Use rightSideContentDocument instead.
   */
  bottomSidebarDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** A structured content component that is sticky to the bottom of the article when scrolling */
  bottomStickyDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** the breadcrumb to display on an article */
  breadcrumb?: Maybe<Breadcrumb>;
  /** Structured Content document for Breadcrumbs section */
  breadcrumbsDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** A structured content document to go below the disclaimer */
  contentEngagementDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The credit cards to display for the CCHeadToHead component. */
  creditCardsHeadToHead?: Maybe<Array<Maybe<MarketplaceEntityInterface>>>;
  /** Structured Content Document for the Content Page Header */
  contentPageHeaderDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Display date based on flags and custom dates set on entity */
  displayDate?: Maybe<Scalars['DateTime']['output']>;
  /** Display date status based on flags and custom dates set on entity */
  displayDateStatus?: Maybe<DisplayDateStatus>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** The structured content document to display for gated content */
  gatedContentDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /**
   * A list of hreflang links for this article. This is used for SEO purposes.
   *   For more information, see https://support.google.com/webmasters/answer/189077?hl=en
   */
  hreflang?: Maybe<Array<Hreflang>>;
  /** The structured content to use as Hero Banner for this Article */
  heroBannerDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /**
   * HouseAd to be rendered for house ad.
   * @deprecated Use houseAdDocument instead.
   */
  houseAd?: Maybe<HouseAd>;
  /** The structured content to use as this article's house ad. */
  houseAdDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Collection of related hubs and subhubs. */
  hubLinks?: Maybe<Array<ContentHub>>;
  /** Structured Content document for Hub Links section */
  hubLinksDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether the article's status is PUBLISHED or not. */
  isPublished: Scalars['Boolean']['output'];
  /** The structured content to use as the Marketplace Entity Logo Row Section for this Article */
  marketplaceEntityLogoRowDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The structured content to use as the Methodology Section for this Article */
  methodologyDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /**
   * Block group to be rendered as 'next steps'.
   * @deprecated Use nextStepsDocument instead.
   */
  nextSteps?: Maybe<BlockGroup>;
  /** Structured Content document for Next Steps section */
  nextStepsDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /**
   * Block group to be rendered as related links.
   * @deprecated Included within rightSideContentDocument. Use rightSideContentDocument instead.
   */
  relatedLinks?: Maybe<BlockGroup>;
  /** Whether or not to show the advertiser disclosure. */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Whether or not to show the editorial disclaimer. */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
  /** The structured content to use as this article's editorial standards. */
  editorialStandardsDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The master structured content to display in right or left of the main article content: includes sideBar, relatedLinks, bottomSideBar and WPDynamicPlacement */
  rightSideContentDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /**
   * The structured content to display in right or left of the main article content; currently where relatedLinks is
   * @deprecated Included within rightSideContentDocument. Use rightSideContentDocument instead.
   */
  sidebarDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  tableOfContentsDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The structured content for the NerdyTakeaways component. */
  takeaways?: Maybe<Scalars['StructuredContentDocument']['output']>;
  timeToRead?: Maybe<TimeToRead>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleContentPageHeaderDocumentArgs = {
  hideEditorialStandards?: InputMaybe<Scalars['Boolean']['input']>;
  hideAuthorByline?: InputMaybe<Scalars['Boolean']['input']>;
  hideFeaturedImage?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleRightSideContentDocumentArgs = {
  isTocExperiment?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Type modeling the data for posts within the nw_article post type from WordPress. */
export type ArticleTableOfContentsDocumentArgs = {
  autoPopulateItems?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Type modeling the data for posts within the nw_au_flex_page post type from WordPress. */
export type AuFlexPage = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithEditorInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithPageTaxonomyInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'AUFlexPage';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the AUFlexPage object. */
  categories?: Maybe<Array<Category>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The internal reviewers that this AU Flex Page has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The Structured Content document resulting from the merging of the template and page level documents. */
  mergedTemplateDocument?: Maybe<Scalars['JSON']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The reviewers that this AU Flex Page has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** The product, offer, or institution that the page represents a review about. */
  reviewProductName?: Maybe<Scalars['String']['output']>;
  /** The rating that should appear on search result pages. */
  reviewRating?: Maybe<Scalars['Float']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The Flex Template this page should utilize. */
  template?: Maybe<AuFlexTemplate>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
  displayDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
};


/** Type modeling the data for posts within the nw_au_flex_page post type from WordPress. */
export type AuFlexPageDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_au_flex_page post type from WordPress. */
export type AuFlexPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_au_flex_page post type from WordPress. */
export type AuFlexPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_au_template post type from WordPress. */
export type AuFlexTemplate = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentInterface & PostWithTitleInterface & {
  __typename?: 'AUFlexTemplate';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The padding to apply below the content using this template. */
  bottomPadding?: Maybe<Scalars['String']['output']>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page type classification value set for this template. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The overall width constraint for the page content for this template. */
  pageWidth?: Maybe<Scalars['String']['output']>;
  /** Whether or not to display breadcrumbs for all pages using this template. */
  showBreadcrumbs?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The padding to apply above the content using this template. */
  topPadding?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
  /** The primary category of the Flex Template */
  primaryCategory?: Maybe<Category>;
};


/** Type modeling the data for posts within the nw_au_template post type from WordPress. */
export type AuFlexTemplateDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_au_template post type from WordPress. */
export type AuFlexTemplateModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_au_template post type from WordPress. */
export type AuFlexTemplateTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPage = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithEditorInterface & PostWithFaQsInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'BccPage';
  /** The custom content to display above the BCC sections. */
  aboveSections?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The Disqus thread ID for this content. */
  commentThreadId?: Maybe<Scalars['Int']['output']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** Editorial content for the page. */
  editorialLearnContent?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The internal reviewers that this BccPage has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** The Reviewers that this BccPage has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  sections?: Maybe<Array<BccPageSection>>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** The aggregate list of all section categories. */
  imageForBccArticleSchema?: Maybe<Scalars['String']['output']>;
  summarySectionOffers: Array<BccPagePreferredSection>;
  displayDate?: Maybe<Scalars['String']['output']>;
};


/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPageDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_bcc_page post type from WordPress. */
export type BccPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCard = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'BccPageCard';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The bottom line text to display for the card. */
  bottomLine?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The Marketplace entity UUID. */
  cardEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity UUID. */
  cardId?: Maybe<Scalars['String']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The description text for the card. */
  description?: Maybe<Scalars['String']['output']>;
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The spotlight details text to display for the card. */
  spotlightDetails?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The spotlight heading text for the card. */
  spotlightHeading?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The summary table text to display for the card. */
  summaryTableText?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** The credit card offer data for the BccPageCard */
  creditCardOffer?: Maybe<CreditCardsOfferV2>;
  /** Summary text for credit card for display in MORE ABOUT THE CARDS FEATURED ON THIS PAGE of BCC */
  summaryTableContent?: Maybe<Scalars['StructuredContentDocument']['output']>;
};


/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCardDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCardModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_bcc_page_card post type from WordPress. */
export type BccPageCardTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type Block = PostInterface & PostWithAuthorsInterface & PostWithContentInterface & PostWithTitleInterface & {
  __typename?: 'Block';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Block object. */
  categories?: Maybe<Array<Category>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Whether or not the Block's content is inline compatible. */
  inlineCompatible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
};


/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_block post type from WordPress. */
export type BlockTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroup = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'BlockGroup';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the BlockGroup object. */
  categories?: Maybe<Array<Category>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  blocks?: Maybe<Array<CombinedBlockGroupBlock>>;
};


/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_block_group post type from WordPress. */
export type BlockGroupTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_ca_flex_page post type from WordPress. */
export type CaFlexPage = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithEditorInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithPageTaxonomyInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'CAFlexPage';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the CAFlexPage object. */
  categories?: Maybe<Array<Category>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The internal reviewers that this CA Flex Page has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The Structured Content document resulting from the merging of the template and page level documents. */
  mergedTemplateDocument?: Maybe<Scalars['JSON']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The reviewers that this CA Flex Page has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** The product, offer, or institution that the page represents a review about. */
  reviewProductName?: Maybe<Scalars['String']['output']>;
  /** The rating that should appear on search result pages. */
  reviewRating?: Maybe<Scalars['Float']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The Flex Template this page should utilize. */
  template?: Maybe<CaFlexTemplate>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
  displayDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
};


/** Type modeling the data for posts within the nw_ca_flex_page post type from WordPress. */
export type CaFlexPageDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_ca_flex_page post type from WordPress. */
export type CaFlexPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_ca_flex_page post type from WordPress. */
export type CaFlexPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_ca_template post type from WordPress. */
export type CaFlexTemplate = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentInterface & PostWithTitleInterface & {
  __typename?: 'CAFlexTemplate';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The padding to apply below the content using this template. */
  bottomPadding?: Maybe<Scalars['String']['output']>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page type classification value set for this template. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The overall width constraint for the page content for this template. */
  pageWidth?: Maybe<Scalars['String']['output']>;
  /** Whether or not to display breadcrumbs for all pages using this template. */
  showBreadcrumbs?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The padding to apply above the content using this template. */
  topPadding?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
  /** The primary category of the Flex Template */
  primaryCategory?: Maybe<Category>;
};


/** Type modeling the data for posts within the nw_ca_template post type from WordPress. */
export type CaFlexTemplateDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_ca_template post type from WordPress. */
export type CaFlexTemplateModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_ca_template post type from WordPress. */
export type CaFlexTemplateTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_calc_page post type from WordPress. */
export type CalculatorPage = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithEditorInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithPageTaxonomyInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'CalculatorPage';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the CalculatorPage object. */
  categories?: Maybe<Array<Category>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** Content tags associated with the content. */
  contentTags?: Maybe<Array<Scalars['String']['output']>>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The internal reviewers that this Calculator page has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The reviewers that this Calculator page has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
  displayDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
};


/** Type modeling the data for posts within the nw_calc_page post type from WordPress. */
export type CalculatorPageDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_calc_page post type from WordPress. */
export type CalculatorPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_calc_page post type from WordPress. */
export type CalculatorPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculator = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithTitleInterface & {
  __typename?: 'StructuredContentCalculator';
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the StructuredContentCalculator object. */
  categories?: Maybe<Array<Category>>;
  /** The config JSON for the calculator. */
  config?: Maybe<Scalars['JSON']['output']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
};


/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculatorDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculatorModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_calculator post type from WordPress. */
export type StructuredContentCalculatorTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPack = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'ContentPack';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the ContentPack object. */
  categories?: Maybe<Array<Category>>;
  /** The curation type for this Content Pack. */
  curationType?: Maybe<ContentPackCurationTypeEnum>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The heading for this Content Pack. */
  heading?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The content to display for this Content Pack. */
  items?: Maybe<Array<ContentPackItemsUnion>>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The display type to use for this Content Pack. */
  listDisplayType?: Maybe<ContentPackListDisplayTypeEnum>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The subtitle to display for this Content Pack. */
  subtitle?: Maybe<Scalars['String']['output']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
};


/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_content_pack post type from WordPress. */
export type ContentPackTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPost = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithEditorInterface & PostWithExcerptInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'EngineeringPost';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_eng_post post type from WordPress. */
export type EngineeringPostTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_flex_page post type from WordPress. */
export type FlexPage = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithEditorInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithPageTaxonomyInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'FlexPage';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the FlexPage object. */
  categories?: Maybe<Array<Category>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The internal reviewers that this Flex Page has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The Structured Content document resulting from the merging of the template and page level documents. */
  mergedTemplateDocument?: Maybe<Scalars['JSON']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The reviewers that this Flex Page has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** The product, offer, or institution that the page represents a review about. */
  reviewProductName?: Maybe<Scalars['String']['output']>;
  /** The rating that should appear on search result pages. */
  reviewRating?: Maybe<Scalars['Float']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The Flex Template this page should utilize. */
  template?: Maybe<FlexTemplate>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
  displayDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
};


/** Type modeling the data for posts within the nw_flex_page post type from WordPress. */
export type FlexPageDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_flex_page post type from WordPress. */
export type FlexPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_flex_page post type from WordPress. */
export type FlexPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItem = PostInterface & PostWithTitleInterface & {
  __typename?: 'GlobalNavItem';
  /** Global Nav L0 item's L1 children. */
  children?: Maybe<Array<GlobalNavItem>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Global Nav item link. */
  itemLink?: Maybe<GlobalNavItemItemLinkUnion>;
  /** Global Nav item level. */
  level?: Maybe<GlobalNavItemLevelEnum>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** Global Nav mobile config. */
  mobileConfig?: Maybe<Array<GlobalNavItemMobileConfig>>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Global Nav item More Info link. */
  moreInfoLink?: Maybe<GlobalNavItemMoreInfoLinkUnion>;
  /** Global Nav item More Info text. */
  moreInfoText?: Maybe<Scalars['String']['output']>;
  /** Global Nav item promo spot. */
  promoSpot?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Global Nav L1 item sections. */
  sections?: Maybe<Array<GlobalNavItemSection>>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** Global Nav item sub text. */
  subText?: Maybe<Scalars['String']['output']>;
  /** Global Nav item Test Name. */
  testName?: Maybe<Scalars['String']['output']>;
  /** Global Nav item Test Variant. */
  testVariant?: Maybe<Scalars['String']['output']>;
  /** Global Nav item text. */
  text?: Maybe<Scalars['String']['output']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Global Nav Tools and Resources item sections. */
  toolsResourcesSections?: Maybe<Array<GlobalNavItemToolsResourcesSection>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
};


/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItemDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItemModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_gnav_item post type from WordPress. */
export type GlobalNavItemTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAd = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'HouseAd';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The body text for the house ad. */
  body?: Maybe<Scalars['String']['output']>;
  /** The auth link for the house ad CTA. */
  ctaAuthLink?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** CTA text for the house ad. */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** The type of CTA for the house ad. Either web link or auth link. */
  ctaType?: Maybe<HouseAdCtaTypeEnum>;
  /** The web url for the house ad CTA link. */
  ctaUrl?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The headline to use for the house ad. */
  headline?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The illustration to use for the house ad. */
  illustration?: Maybe<HouseAdIllustrationEnum>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** Which template to use for the house ad. */
  template?: Maybe<HouseAdTemplateEnum>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
};


/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_house_ad post type from WordPress. */
export type HouseAdTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type Hub = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Hub';
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The custom content to display below the featured boxes. */
  customContentBelowFeaturedBoxes?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The boxes to display on the Hub. */
  featuredBoxes?: Maybe<Array<HubFeaturedBox>>;
  /** Represents each of the content sections on the page. */
  featuredContent?: Maybe<Array<HubFeaturedContent>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** The content to display in the header of the hub below the title. */
  headerSubtitle?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Whether this is a Topic hub or Category hub. */
  hubType?: Maybe<HubTypeEnum>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The categories to display the latest content from. */
  latestContentCategories?: Maybe<Array<Scalars['String']['output']>>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The marketplace entities to display for this hub. */
  marketplaceEntities?: Maybe<Array<HubMarketplaceEntity>>;
  /** The title of the Marketplace section. */
  marketplaceSectionTitle?: Maybe<Scalars['String']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The post types to display the latest content from. */
  postTypes?: Maybe<Array<PostTypeEnum>>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** The Q&A to display on this Hub. */
  questions?: Maybe<Array<HubQuestion>>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The curated list of reviews to display. */
  reviews?: Maybe<Array<Review>>;
  /** The section title for the reviews section. */
  reviewSectionTitle?: Maybe<Scalars['String']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
};


/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_hub post type from WordPress. */
export type HubTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_hub_new post type from WordPress. */
export type ContentHub = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithFeaturedImageInterface & PostWithHubLinks & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'ContentHub';
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the ContentHub object. */
  categories?: Maybe<Array<Category>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** Whether this is a Topic hub or Category hub. */
  hubType?: Maybe<ContentHubHubTypeEnum>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The ContentHub object for the parent of this entity. */
  parent?: Maybe<ContentHub>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** Collection of related Sub Hubs. */
  hubLinks?: Maybe<Array<ContentHub>>;
};


/** Type modeling the data for posts within the nw_hub_new post type from WordPress. */
export type ContentHubDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_hub_new post type from WordPress. */
export type ContentHubModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_hub_new post type from WordPress. */
export type ContentHubTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_ins_flex_page post type from WordPress. */
export type InsuranceFlexPage = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithEditorInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'InsuranceFlexPage';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the InsuranceFlexPage object. */
  categories?: Maybe<Array<Category>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The Structured Content documents for all flex editor fields on this page. */
  flexEditorDocuments?: Maybe<Scalars['JSON']['output']>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The internal reviewers that this Insurance Page has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The Structured Content document resulting from the merging of the template and page level documents. */
  mergedTemplateDocument?: Maybe<Scalars['JSON']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The reviewers that this Insurance Page has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** The product, offer, or institution that the page represents a review about. */
  reviewProductName?: Maybe<Scalars['String']['output']>;
  /** The rating that should appear on search result pages. */
  reviewRating?: Maybe<Scalars['Float']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The Flex Template this page should utilize. */
  template?: Maybe<InsuranceTemplate>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
  displayDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
};


/** Type modeling the data for posts within the nw_ins_flex_page post type from WordPress. */
export type InsuranceFlexPageDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_ins_flex_page post type from WordPress. */
export type InsuranceFlexPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_ins_flex_page post type from WordPress. */
export type InsuranceFlexPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_ins_template post type from WordPress. */
export type InsuranceTemplate = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentInterface & PostWithTitleInterface & {
  __typename?: 'InsuranceTemplate';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The padding to apply below the content using this template. */
  bottomPadding?: Maybe<Scalars['String']['output']>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page type classification value set for this template. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The overall width constraint for the page content for this template. */
  pageWidth?: Maybe<Scalars['String']['output']>;
  /** Whether or not to display breadcrumbs for all pages using this template. */
  showBreadcrumbs?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The padding to apply above the content using this template. */
  topPadding?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
  /** The primary category of the Flex Template */
  primaryCategory?: Maybe<Category>;
};


/** Type modeling the data for posts within the nw_ins_template post type from WordPress. */
export type InsuranceTemplateDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_ins_template post type from WordPress. */
export type InsuranceTemplateModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_ins_template post type from WordPress. */
export type InsuranceTemplateTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPage = PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithEditorInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'LandingPage';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the LandingPage object. */
  categories?: Maybe<Array<Category>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
};


/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_landing post type from WordPress. */
export type LandingPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLender = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'LegacyLender';
  applyDisclaimerText?: Maybe<Scalars['String']['output']>;
  applyText?: Maybe<Scalars['String']['output']>;
  applyUrl?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the LegacyLender object. */
  categories?: Maybe<Array<Category>>;
  /** The negative bullet points about the product. */
  cons?: Maybe<Array<Scalars['String']['output']>>;
  /** The custom URL to use for linking to a review. */
  customReviewUrl?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  lenderId?: Maybe<Scalars['String']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** Field connecting to the LegacyLenderMaxLTV Type and all of its nested fields. */
  maxLTV?: Maybe<LegacyLenderMaxLtv>;
  /** Field connecting to the LegacyLenderMinCreditScore Type and all of its nested fields. */
  minCreditScore?: Maybe<LegacyLenderMinCreditScore>;
  /** Field connecting to the LegacyLenderMinDownPayment Type and all of its nested fields. */
  minDownPayment?: Maybe<LegacyLenderMinDownPayment>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Field connecting to the LegacyLenderNationalRegional Type and all of its nested fields. */
  nationalRegional?: Maybe<LegacyLenderNationalRegional>;
  personalizedRatesEnabled?: Maybe<Scalars['Boolean']['output']>;
  productEntity?: Maybe<MarketplaceEntityInterface>;
  productId?: Maybe<Scalars['String']['output']>;
  /** The positive bullet points about the product. */
  pros?: Maybe<Array<Scalars['String']['output']>>;
  /** The NerdWallet rating for the product. */
  rating?: Maybe<Scalars['Float']['output']>;
  /** Reviews associated with this content. */
  review?: Maybe<LegacyLenderReviewUnion>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  whyWeLikeIt?: Maybe<Scalars['String']['output']>;
};


/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_lender post type from WordPress. */
export type LegacyLenderTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPoint = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'MarketplaceEntryPoint';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The body text to use in this Marketplace Entry Point. */
  body?: Maybe<Scalars['String']['output']>;
  /** The CTA annotation to use in this Marketplace Entry Point. */
  ctaAnnotation?: Maybe<Scalars['String']['output']>;
  /** The CTA text to use in this Marketplace Entry Point. */
  ctaText?: Maybe<Scalars['String']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The heading text to use in this Marketplace Entry Point. */
  heading?: Maybe<Scalars['String']['output']>;
  /** The text to use in the Highlights section in this Marketplace Entry Point. */
  highlights?: Maybe<Array<Scalars['String']['output']>>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The Marketplace entity associated with this Marketplace Entry Point. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity associated with this Marketplace Entry Point. */
  marketplaceEntityId?: Maybe<Scalars['String']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The short body text to use in this Marketplace Entry Point. Rendered in the "Minimal" template only. */
  shortBody?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The template to use for this entry point. */
  template?: Maybe<MarketplaceEntryPointTemplateEnum>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
};


/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPointDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPointModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_mkt_entry post type from WordPress. */
export type MarketplaceEntryPointTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_placement post type from WordPress. */
export type DynamicPlacement = PostInterface & PostWithAuthorsInterface & PostWithContentInterface & PostWithTitleInterface & {
  __typename?: 'DynamicPlacement';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
};


/** Type modeling the data for posts within the nw_placement post type from WordPress. */
export type DynamicPlacementDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_placement post type from WordPress. */
export type DynamicPlacementModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_placement post type from WordPress. */
export type DynamicPlacementTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressRelease = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'PressRelease';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** Whether or not this Press Release is considered featured. */
  featured?: Maybe<Scalars['Boolean']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** A list of MediaSite objects on the PressRelease object. */
  mediaSites?: Maybe<Array<MediaSite>>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** The external URL for this Press Release. */
  url?: Maybe<Scalars['URL']['output']>;
};


/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressReleaseDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressReleaseModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_press_release post type from WordPress. */
export type PressReleaseTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type Review = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithContentInterface & PostWithEditorInterface & PostWithExcerptInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithInternationalVersionsInterface & PostWithPageTaxonomyInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Review';
  /** The alternate products to display. */
  alternatePicks?: Maybe<Array<ReviewAlternatePick>>;
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The Benefits and Perks content section for a Review. */
  benefitsAndPerks?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Short summary of the roundup/review. */
  bottomLine?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** A list of Category objects on the Review object. */
  categories?: Maybe<Array<Category>>;
  /** The source of the comparison table to display. */
  comparisonTableSource?: Maybe<Scalars['String']['output']>;
  /** The negative bullet points about the product. */
  cons?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The Detailed Review content section for a Review. */
  detailedReview?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The Drawbacks and Considerations content section for a Review. */
  drawbacksAndConsiderations?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The type driver group to configure for this piece of content. */
  driverGroup?: Maybe<ReviewDriverGroupEnum>;
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The Marketplace Entity type. */
  entityType?: Maybe<MarketplaceEntityTypeEnum>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']['output']>;
  /** Whether or not to exclude related products. */
  excludeRelatedProducts?: Maybe<Scalars['Boolean']['output']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The footnotes section for a Review. */
  footnotes?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to hide the title anchor on the review. */
  hideFullReviewAnchor?: Maybe<Scalars['Boolean']['output']>;
  /** The How to Decide content section for a Review. */
  howToDecide?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The content sections for an institution Review. */
  institutionBreakdownSections?: Maybe<Array<ReviewInstitutionBreakdownSection>>;
  /** The Insurance component to use on this Review. */
  insuranceComponent?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The internal reviewers that this Review has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** Information about alternate versions of the content that exist for other locales. */
  internationalVersions?: Maybe<Array<InternationalVersion>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The Marketplace entity UUID. */
  marketplaceEntity?: Maybe<MarketplaceEntityInterface>;
  /** The Marketplace entity UUID. */
  marketplaceEntityId?: Maybe<Scalars['String']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** The Marketplace product type. */
  productType?: Maybe<MarketplaceProductTypeEnum>;
  /** The positive bullet points about the product. */
  pros?: Maybe<Array<Scalars['StructuredContentDocument']['output']>>;
  /** The disclaimer for how the rating was derived. */
  ratingDisclaimer?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The products related to the current one to display on the page. */
  relatedProducts?: Maybe<Array<ReviewRelatedProduct>>;
  /** The reviewers that this Review has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The Marketplace subproduct type for the banking vertical. */
  subproductType?: Maybe<ReviewSubproductTypeEnum>;
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** The video section for a Review. */
  videoDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** The Breadcrumb to be displayed on a review */
  breadcrumb?: Maybe<Breadcrumb>;
  /** Data used for rendering the comparison table */
  comparisonTable?: Maybe<ComparisonTableDetails>;
  /** The location where the Comparison Table should be rendered on a Review */
  comparisonTableLocation: ComparisonTableLocationEnum;
  /** The tracking params that should be appended to this review section's marketplace entity's CTA */
  ctaTrackingParams?: Maybe<Array<TrackingParam>>;
  /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
  displayDate?: Maybe<Scalars['DateTime']['output']>;
  /** The drivers associated with the entity of this review */
  drivers?: Maybe<Array<EntityPlacementDriver>>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /**
   * Get the list of review content sections filtered by the provided geolocation
   *   Notes:
   *   - Filtering applies to Banking only
   *   - Does not filter CD offers
   */
  filteredReviewContentSections?: Maybe<Array<ReviewInstitutionBreakdownSection>>;
  /** Whether or not the review has local offers */
  hasLocalOffers?: Maybe<Scalars['Boolean']['output']>;
  /** Heading text for the institution breakdown */
  institutionBreakdownHeading?: Maybe<Scalars['String']['output']>;
  /**
   * The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates)
   * @deprecated Deprecating in favor of using 'displaydate' moving forward, as it more accurately reflects the return value.
   */
  lastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The vertical-specific methodology to display for the review */
  methodology?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** List of related links. */
  relatedLinks?: Maybe<Array<ReviewRelatedLinkSection>>;
  /** The master structured content to display in right of the main review content: includes WPDynamicPlacement */
  rightSideContentDocument?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Boolean flag to indicate if all Marketplace Entity CTAs should be omitted on the page */
  shouldOmitCta: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
  /** Whether or not the page qualifies to show a sign up banner */
  showSignUpBanner: Scalars['Boolean']['output'];
  /**
   * Whether the review content for the institution breakdown is nested in an accordion
   * @deprecated Deprecating in favor of control on A/B test reference: https://nerdwallet.atlassian.net/browse/BAIN-514
   */
  useMobileAccordionForInstitutionBreakdown: Scalars['Boolean']['output'];
  /** The heading for the review intro */
  introHeading?: Maybe<Scalars['String']['output']>;
  /**
   * A list of hreflang links for this review. This is used for SEO purposes.
   *   For more information, see https://support.google.com/webmasters/answer/189077?hl=en
   */
  hreflang?: Maybe<Array<Hreflang>>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewCtaTrackingParamsArgs = {
  utmCampaign?: InputMaybe<Scalars['String']['input']>;
  sourceUrl?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_review post type from WordPress. */
export type ReviewFilteredReviewContentSectionsArgs = {
  userState?: InputMaybe<StateCodeEnum>;
};

/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewer = PostInterface & PostWithAuthorsInterface & PostWithContactInfoInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & PostWithUserInfoInterface & {
  __typename?: 'ContentReviewer';
  /** Organizations this Reviewer is an alumni of. */
  alumniOf?: Maybe<Array<Scalars['String']['output']>>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** Description for this Reviewer. */
  description?: Maybe<Scalars['String']['output']>;
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The email address for the Reviewer. */
  emailAddress?: Maybe<Scalars['EmailAddress']['output']>;
  /** KnowsAbout schema data value for this Reviewer. */
  experience?: Maybe<Scalars['String']['output']>;
  /** The facebook link for the Reviewer. */
  facebookLink?: Maybe<Scalars['URL']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** Honorific suffix for this Reviewer. */
  honorificSuffix?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Job title for this Reviewer. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The facebook link for the Reviewer. */
  linkedinLink?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Name for this Reviewer. */
  name?: Maybe<Scalars['String']['output']>;
  /** SameAs schema data value for this Reviewer. */
  sameAs?: Maybe<Scalars['URL']['output']>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The twitter link for the Reviewer. */
  twitterLink?: Maybe<Scalars['URL']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** The social media links for the content reviewer */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
  /**
   * DEPRECATED: Field containing the information that the content reviewer knows about.
   * @deprecated Use the 'experience' field instead.
   */
  knowsAbout?: Maybe<Scalars['String']['output']>;
  /** The full name of the content reviewer. This isn't currently implemented, but is needed for PostWithUserInfoInterface. */
  fullName?: Maybe<Scalars['String']['output']>;
};


/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewerDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewerModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_reviewer post type from WordPress. */
export type ContentReviewerTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type Roundup = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithEditorInterface & PostWithExcerptInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithInternationalVersionsInterface & PostWithPageTaxonomyInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'Roundup';
  /** The custom content to display above the Roundup sections. */
  aboveSections?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Marketplace Institutions to use affiliate logos from. */
  affiliateLogosInstitutions?: Maybe<Array<MarketplaceEntityInterface>>;
  /** Optional title to display above affiliate logos. */
  affiliateLogosTitle?: Maybe<Scalars['String']['output']>;
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The content to display below the Roundup sections. */
  belowSections?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** A list of Category objects on the Roundup object. */
  categories?: Maybe<Array<Category>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The cross-sell category associated with this Roundup. Relevant only for Credit Card Roundups. */
  crossSellCcCategory?: Maybe<RoundupCrossSellCcCategoryEnum>;
  /** Marketplace named query to use on the cross sell comparison table on Marketing Roundups. */
  crossSellNamedQuery?: Maybe<Scalars['String']['output']>;
  /** The source to use to populate cross sells on this Roundup. */
  crossSellSource?: Maybe<RoundupCrossSellSourceEnum>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The type driver group to configure for this piece of content. */
  driverGroup?: Maybe<RoundupDriverGroupEnum>;
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']['output']>;
  /** Whether or not to include the number of Marketplace entities in the title. */
  excludeEntityCountFromTitle?: Maybe<Scalars['Boolean']['output']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** Posts to display in the footer of this Roundup. */
  footerPosts?: Maybe<Array<RoundupFooterPostsUnion>>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** Whether or not to split the product cards by category name. */
  hideCategoriesInProductCardsSection?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to hide the product cards. */
  hideProductCards?: Maybe<Scalars['Boolean']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Whether or not to include the date in the SEO title. */
  includeDateInSeoTitle?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to include the date in the editorial title. */
  includeDateInTitle?: Maybe<Scalars['Boolean']['output']>;
  includeExpandedProductDetails?: Maybe<Scalars['Boolean']['output']>;
  /** The insurance component to use on the Roundup. */
  insuranceComponent?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The internal reviewers that this Roundup has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** Information about alternate versions of the content that exist for other locales. */
  internationalVersions?: Maybe<Array<InternationalVersion>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The Marketplace product type. */
  marketplaceProductType?: Maybe<MarketplaceProductTypeEnum>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Content that should appear inside a Nerdy Tip component. */
  nerdyTipContent?: Maybe<Scalars['String']['output']>;
  numProductCardsToExpand?: Maybe<Scalars['Int']['output']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** Page taxonomy data. This array is designed to be passed directly to GMS. See https://github.com/NerdWallet/global-markup/tree/b3af4e1f2c68485514145ff31b9137d619e910e1#v2-options */
  pageTaxonomy?: Maybe<Scalars['JSON']['output']>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The reviewers that this Roundup has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** The ordered, augmented Roundup product sections to display on this Roundup. */
  roundupSections?: Maybe<Array<RoundupSection>>;
  /** The type of roundup this piece of content is. */
  roundupType?: Maybe<RoundupTypeEnum>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to display the CTA at the bottom of the Roundup. */
  showFooterCta?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to display the CTA at the top of the Roundup. */
  showIntroCta?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to disable the Personal Recommendation Banner in the Roundup. */
  showPersRecsBanner?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to show the summary table. */
  showSummaryTable?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The quick facts to use in the summary list for banking roundups. */
  summaryListQuickFacts?: Maybe<Array<RoundupSummaryListQuickFactsEnum>>;
  /** The custom title to display for the Summary List on this Roundup. */
  summaryListTitle?: Maybe<Scalars['String']['output']>;
  /** The choice for the behavior of the summary table positioning. */
  summaryTablePosition?: Maybe<RoundupSummaryTablePositionEnum>;
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The editorial title of the Roundup. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /**
   * Whether or not to use ALPS for ordering the roundup sections. This option is deprecated and the selection will be ignored.
   * @deprecated The ALPS Service has been deprecated and this field is no longer used.
   */
  useAlpOrderingForSections?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** Roundup sections to display in the Additional Recommendations section of the roundup */
  additionalRecommendations?: Maybe<Array<RoundupSection>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** The Breadcrumb to display on a Roundup */
  breadcrumb?: Maybe<Breadcrumb>;
  /** Contains display information for the cross sell section of a roundup */
  crossSellSection?: Maybe<RoundupCrossSellDetails>;
  /**
   * The DateTime in UTC to display for the roundup based on flags, custom dates,
   *   and Marketplace entities set on the roundup
   */
  displayDate?: Maybe<Scalars['String']['output']>;
  /**
   * Returns a JSON object containing entity counts keyed by location.
   *   The "none" key will be used to indicate entities that are not localized.
   */
  entityCountByLocation: Scalars['JSON']['output'];
  /** Eyebrow header text for a roundup. */
  eyebrowText?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to indicate if the roundup has local offers to display */
  hasLocalOffers: Scalars['Boolean']['output'];
  /** The vertical-specific methodology to display for the roundup */
  methodology?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The model execution ids used for ALPS ordering */
  modelExecutionIds?: Maybe<Array<Scalars['String']['output']>>;
  /** Contains display information for the product cards section of a roundup */
  productCardsSection: RoundupProductCardsDetails;
  /** Contains display information for the recap list section of a roundup */
  recapListSection: RecapListDetails;
  /** Boolean flag that determines if the first product card's details should be expanded on page load */
  shouldExpandFirstProductCard: Scalars['Boolean']['output'];
  /** Boolean flag that determines if the CTA should be omitted throughout the roundup */
  shouldOmitCta: Scalars['Boolean']['output'];
  /** Boolean flag that determines if ratings should be omitted throughout the roundup */
  shouldOmitRating: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
  /** The marketplace entity to display in the SMB aggregator partnership banner */
  smbAggregatorPartnershipEntity?: Maybe<MarketplaceEntityInterface>;
  /** Contains display information for the summary table section of a roundup */
  summaryTableSection: RoundupSummaryTableDetails;
  /** Ordered template sections for a roundup. */
  templateSections?: Maybe<Array<RoundupTemplateSectionTypeEnum>>;
  /**
   * The page title without the entity count. This is meant to be used for
   *   pages with localized entities.
   */
  titleWithoutEntityCount: Scalars['String']['output'];
  /** The title that is displayed above either the product cards or the summary table. */
  sectionTitle: Scalars['String']['output'];
  /**
   * A list of hreflang links for this roundup. This is used for SEO purposes.
   *   For more information, see https://support.google.com/webmasters/answer/189077?hl=en
   */
  hreflang?: Maybe<Array<Hreflang>>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupRoundupSectionsArgs = {
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupAdditionalRecommendationsArgs = {
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupDisplayDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupModelExecutionIdsArgs = {
  abTestCCPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestBankingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestInvestingPepPhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  abTestDeviceTypePhase1IsActive?: InputMaybe<Scalars['Boolean']['input']>;
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupShouldExpandFirstProductCardArgs = {
  isDesktopUserAgent?: InputMaybe<Scalars['Boolean']['input']>;
};


/** Type modeling the data for posts within the nw_roundup post type from WordPress. */
export type RoundupTemplateSectionsArgs = {
  abTestBmlRedesignIsActive?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Type modeling the data for posts within the nw_template post type from WordPress. */
export type FlexTemplate = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentInterface & PostWithTitleInterface & {
  __typename?: 'FlexTemplate';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The padding to apply below the content using this template. */
  bottomPadding?: Maybe<Scalars['String']['output']>;
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The page type classification value set for this template. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The overall width constraint for the page content for this template. */
  pageWidth?: Maybe<Scalars['String']['output']>;
  /** Whether or not to display breadcrumbs for all pages using this template. */
  showBreadcrumbs?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The padding to apply above the content using this template. */
  topPadding?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /** Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
  /** The primary category of the Flex Template */
  primaryCategory?: Maybe<Category>;
};


/** Type modeling the data for posts within the nw_template post type from WordPress. */
export type FlexTemplateDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_template post type from WordPress. */
export type FlexTemplateModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_template post type from WordPress. */
export type FlexTemplateTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecord = ContentPageHeaderInterface & PostInterface & PostWithAuthorsInterface & PostWithContentClassificationInterface & PostWithEditorInterface & PostWithFaQsInterface & PostWithFeaturedImageInterface & PostWithReviewerInterface & PostWithSeoInterface & PostWithTitleInterface & {
  __typename?: 'UrlRecord';
  /** The assigning editor set on the content. */
  assigningEditor?: Maybe<Author>;
  /** The topic that should be used as the 'Attribution Topic' for this piece of content. This value is used for attributing metrics related to this piece of content in analytics reports. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The vertical that is set as the 'Attribution Vertical' for this piece of content. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the UrlRecord object. */
  categories?: Maybe<Array<Category>>;
  /** Additional content clusters for this piece of content. */
  contentClusters?: Maybe<Array<Scalars['String']['output']>>;
  /** The custom last modified date for the content. */
  customLastModifiedDate?: Maybe<Scalars['DateTime']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** The format to use when displaying the date. */
  dateDisplayFormat?: Maybe<DateDisplayFormatEnum>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The faqs to display on this piece of content. */
  faqs?: Maybe<Array<ContentFaq>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The funnel stage for a piece of content. */
  funnelStage?: Maybe<Scalars['String']['output']>;
  /** Whether or not to hide the Author information from the header of this piece of content. */
  hideAuthor?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to hide the date for this piece of content. */
  hideDate?: Maybe<Scalars['Boolean']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The internal reviewers that this Article has been reviewed by. */
  internallyReviewedBy?: Maybe<Array<Author>>;
  /** Whether or not to prevent this piece of content from appearing in Hub and Author pages on NerdWallet.com */
  isArchivesEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from being recommended to users. */
  isRecommendationEligible?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to prevent this piece of content from appearing in search results on NerdWallet.com */
  isSearchEligible?: Maybe<Scalars['Boolean']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Whether to override the last modified date for the content using one of the available options. */
  overrideLastModifiedDateWithCurrentDate?: Maybe<OverrideLastModifiedDateEnum>;
  /** The page template selected for this piece of content. */
  pageTemplate?: Maybe<Scalars['String']['output']>;
  /** The page type selected for the piece of content. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary category object for the content. */
  primaryCategory?: Maybe<Category>;
  /** The primary content field for this URL record. */
  primaryContent?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The primary content cluster for this piece of content. */
  primaryContentCluster?: Maybe<Scalars['String']['output']>;
  /** A date after which this content should no longer be recommended. */
  recommendationEligibleExpirationDate?: Maybe<Scalars['DateTime']['output']>;
  /** The reviewers that this URL has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** Whether or not to display the FAQ's. */
  showFaqs?: Maybe<Scalars['Boolean']['output']>;
  /** Whether or not to show the last modified date. */
  showLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The content to display below the title of a piece of content. */
  synopsis?: Maybe<Scalars['String']['output']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** Other topics also associated with this piece of content. */
  topics?: Maybe<Array<Scalars['String']['output']>>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** The URL path to query for URL Records by. */
  url?: Maybe<Scalars['URL']['output']>;
  /** Whether or not to use a custom last modified date for this piece of content. */
  useCustomLastModifiedDate?: Maybe<Scalars['Boolean']['output']>;
  /** Other verticals also associated with this piece of content. */
  verticals?: Maybe<Array<Scalars['String']['output']>>;
  /** Type of advertiser disclosure to display (default credit_cards) */
  advertiserDisclosureType: Scalars['String']['output'];
  /** The Breadcrumb to display */
  breadcrumb?: Maybe<Breadcrumb>;
  /** The display date (depends on checked boxes in WP, could be custom_last_modified_date, modified, or published dates) */
  displayDate?: Maybe<Scalars['DateTime']['output']>;
  /** Type of article, which will determine what (if any) additional editorial standards message to display. */
  editorialDisclaimerType?: Maybe<Scalars['String']['output']>;
  /**
   * A list of hreflang links for this url record. This is used for SEO purposes.
   *   For more information, see https://support.google.com/webmasters/answer/189077?hl=en
   */
  hreflang?: Maybe<Array<Hreflang>>;
  /**  Boolean flag to show/hide the advertiser disclosure in the page header */
  showAdvertiserDisclosure: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide author byline in the page header */
  showAuthorByline: Scalars['Boolean']['output'];
  /** Boolean flag to show/hide the editorial disclaimer in the page header */
  showEditorialDisclaimer: Scalars['Boolean']['output'];
};


/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_url_record post type from WordPress. */
export type UrlRecordTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPage = PostInterface & PostWithAuthorsInterface & PostWithContactInfoInterface & PostWithFeaturedImageInterface & PostWithSeoInterface & PostWithTitleInterface & PostWithUserInfoInterface & {
  __typename?: 'ContentUserPage';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** Awards for the user featured on this User Page. */
  awards?: Maybe<Array<Scalars['String']['output']>>;
  /** Bio for this User Page. */
  bio?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** Content picks to display on this User Page. */
  contentPicks?: Maybe<Array<ContentUserPageContentPicksUnion>>;
  /** Credentials for the user featured on this User Page. */
  credentials?: Maybe<Array<Scalars['String']['output']>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** Education for the user featured on this User Page. */
  education?: Maybe<Array<Scalars['String']['output']>>;
  /** Expertise for the user featured on this User Page. */
  expertise?: Maybe<Array<Scalars['String']['output']>>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** First name for the user featured on this User Page. */
  firstName?: Maybe<Scalars['String']['output']>;
  /** Full name for the user featured on this User Page. */
  fullName?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** Job title for this User Page. */
  jobTitle?: Maybe<Scalars['String']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** Organizations for the user featured on this User Page. */
  organizations?: Maybe<Array<Scalars['String']['output']>>;
  /** Other publications for the user featured on this User Page. */
  otherPublications?: Maybe<Array<Scalars['String']['output']>>;
  /** Page type for this User Page. */
  pageType?: Maybe<ContentUserPagePageTypeEnum>;
  /** Previous experience for the user featured on this User Page. */
  previousExperience?: Maybe<Array<Scalars['String']['output']>>;
  /** A collection of articles, podcasts, and/or TV clips to display on this User Page. */
  quotesAndInterviews?: Maybe<Array<ContentUserPageQuotesAndInterview>>;
  /** Field connecting to the SeoSettings Type and all of its nested fields. */
  seo?: Maybe<SeoSettings>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** User represented by this User Page. */
  user?: Maybe<Author>;
  /** Field connecting to the UserPageVideo Type and all of its nested fields. */
  video?: Maybe<UserPageVideo>;
  /** The years of experience for this User Page. */
  yearsOfExperience?: Maybe<Array<ContentUserPageYearsOfExperience>>;
  /** The users's previous experience. */
  experience?: Maybe<Scalars['String']['output']>;
  /** The social media links to display on the author/editor page. */
  socialMediaLinks?: Maybe<Array<AuthorSocialMediaLink>>;
};


/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPageDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPageModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the nw_user_page post type from WordPress. */
export type ContentUserPageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the page post type from WordPress. */
export type Page = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'Page';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Page object. */
  categories?: Maybe<Array<Category>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The Page object for the parent of this entity. */
  parent?: Maybe<Page>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
};


/** Type modeling the data for posts within the page post type from WordPress. */
export type PageDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the page post type from WordPress. */
export type PageModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the page post type from WordPress. */
export type PageTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the post post type from WordPress. */
export type Post = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'Post';
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** A list of Category objects on the Post object. */
  categories?: Maybe<Array<Category>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
};


/** Type modeling the data for posts within the post post type from WordPress. */
export type PostDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the post post type from WordPress. */
export type PostModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the post post type from WordPress. */
export type PostTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type Table = PostInterface & PostWithContentInterface & PostWithExcerptInterface & PostWithTitleInterface & {
  __typename?: 'Table';
  /** The structured content for the resource. */
  content?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The editorial excerpt of the resource. */
  excerpt?: Maybe<Scalars['String']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The bolding style to apply to this table. */
  tableBolding?: Maybe<TableBoldingEnum>;
  /** The type of visibility for the table. */
  tableVisibility?: Maybe<TableVisibilityEnum>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** The column centering options selected for the table. */
  columnCentering?: Maybe<TableCenteringOptionsEnum>;
  /** The columns for the table. */
  columns?: Maybe<Array<TableColumn>>;
  /** The data to display within the columns for the table. */
  data?: Maybe<Scalars['JSON']['output']>;
  /** Whether or not the the table has a header. */
  hasTableHeader: Scalars['Boolean']['output'];
  /** Whether or not the table should be stylized with alternating stripes. */
  isStriped: Scalars['Boolean']['output'];
  /** Whether or not the table is structured content eligible. */
  isStructuredContentEligible: Scalars['Boolean']['output'];
  /** The row centering options selected for the table. */
  rowCentering?: Maybe<TableCenteringOptionsEnum>;
  /** Whether or not the table has the rowHover feature enabled. */
  rowHover: Scalars['Boolean']['output'];
  /** Whether or not the title of the table should be displayed. */
  showTableTitle: Scalars['Boolean']['output'];
};


/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableExcerptArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** Type modeling the data for posts within the tablepress_table post type from WordPress. */
export type TableTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

/** Type modeling the data for terms within the category taxonomy from WordPress. */
export type Category = TermInterface & {
  __typename?: 'Category';
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The default Block Group to use in the "Below Content" section for content in this category. */
  defaultBelowContent?: Maybe<BlockGroup>;
  /** The default House Ad to use for content in this category. */
  defaultHouseAd?: Maybe<HouseAd>;
  /** The default Block Group to use in the "Next Steps" section for content in this category. */
  defaultNextSteps?: Maybe<BlockGroup>;
  /** The default Block Group to use in the "Related Links" section for content in this category. */
  defaultRelatedLinks?: Maybe<BlockGroup>;
  /** The default Block Group to use as the sidebar for content in this category. */
  defaultSidebar?: Maybe<BlockGroup>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL']['output'];
  /** The name of the term. */
  name?: Maybe<Scalars['String']['output']>;
  /** The Category object for the parent of this entity. */
  parent?: Maybe<Category>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String']['output'];
};

/** Type modeling the data for terms within the nw_media_site taxonomy from WordPress. */
export type MediaSite = TermInterface & {
  __typename?: 'MediaSite';
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The WordPress front end URL for this resource. */
  link: Scalars['URL']['output'];
  /** The logo to display for the media site. */
  logo?: Maybe<MediaItem>;
  /** The name of the term. */
  name?: Maybe<Scalars['String']['output']>;
  /** The MediaSite object for the parent of this entity. */
  parent?: Maybe<MediaSite>;
  /** The slug for the term. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The taxonomy the term is in. */
  taxonomy: Scalars['String']['output'];
};

/** The WordPress media item type. */
export type MediaItem = PostInterface & PostWithAuthorsInterface & PostWithTitleInterface & {
  __typename?: 'MediaItem';
  /** The alt text for the image. */
  altText?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The caption for the image. */
  caption?: Maybe<Scalars['String']['output']>;
  /** The cropped version of an image filtered by size. */
  croppedImage?: Maybe<CroppedImageSize>;
  /** An array of cropped versions of an image filtered by size. */
  croppedImages?: Maybe<Array<CroppedImageSize>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The height of the original image in pixels. */
  height?: Maybe<Scalars['Int']['output']>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /**
   * Details about the media item.
   * @deprecated This field is going away soon and will be replaced by fields added to the top level of the MediaItem Type.
   */
  mediaDetails?: Maybe<MediaDetails>;
  /** The type of media. */
  mediaType?: Maybe<Scalars['String']['output']>;
  /** The mime type of media item. */
  mimeType?: Maybe<Scalars['String']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The permalink for where the image lives. */
  sourceUrl?: Maybe<Scalars['URL']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
  /** The width of the original image in pixels. */
  width?: Maybe<Scalars['Int']['output']>;
  /** A srcSet string including the image sizes requested */
  srcSet?: Maybe<Scalars['String']['output']>;
  /** List of available image sizes for a particular image. */
  availableSizes: Array<Scalars['String']['output']>;
};


/** The WordPress media item type. */
export type MediaItemCaptionArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** The WordPress media item type. */
export type MediaItemCroppedImageArgs = {
  size?: InputMaybe<MediaItemImageSizeEnum>;
};


/** The WordPress media item type. */
export type MediaItemCroppedImagesArgs = {
  sizes?: InputMaybe<Array<MediaItemImageSizeEnum>>;
};


/** The WordPress media item type. */
export type MediaItemDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** The WordPress media item type. */
export type MediaItemModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** The WordPress media item type. */
export type MediaItemTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};


/** The WordPress media item type. */
export type MediaItemSrcSetArgs = {
  sizes?: InputMaybe<Array<MediaItemImageSizeEnum>>;
};

/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResult = PostInterface & PostWithAuthorsInterface & PostWithFeaturedImageInterface & PostWithTitleInterface & {
  __typename?: 'ContentSearchResult';
  /** The attribution topic associated with the search result. */
  attributionTopic?: Maybe<Scalars['String']['output']>;
  /** The attribution vertical associated with the search result. */
  attributionVertical?: Maybe<Scalars['String']['output']>;
  /** The Authors for the resource. */
  authors?: Maybe<Array<Author>>;
  /** The content tag associated with the search result. */
  contentTags?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The DateTime the resource was published in UTC. */
  date?: Maybe<Scalars['String']['output']>;
  /** This field is a direct representation of the ID for the entity as WordPress understands it. The value returned by this field is safe to use for things like analytics reporting and logging. */
  dbId: Scalars['Int']['output'];
  /** The link to edit this resource in WordPress. */
  editLink?: Maybe<Scalars['URL']['output']>;
  /** The featured image for the resource. */
  featuredMedia?: Maybe<MediaItem>;
  /** The ID for the entity. This value for this field should be considered opaque and should mostly be used for the Apollo Client cache and for making follow up requests to GraphQL. For most use cases you'll want to use the dbId field instead. */
  id: Scalars['ID']['output'];
  /** The legacy synopsis field for a search result. Once we support structured content for the synopsis field we will return a structured content document. */
  legacySynopsis?: Maybe<Scalars['String']['output']>;
  /** The permalink of the resource. */
  link?: Maybe<Scalars['URL']['output']>;
  /** The DateTime the resource was last modified in UTC. */
  modified?: Maybe<Scalars['String']['output']>;
  /** The other content clusters associated with the search result. */
  otherClusters?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The other attribution topics associated with the search result. */
  otherTopics?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The other attribution verticals associated with the search result. */
  otherVerticals?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The page type associated with the search result. */
  pageType?: Maybe<Scalars['String']['output']>;
  /** The primary category object for the resource. */
  primaryCategory?: Maybe<Category>;
  /** The primary content cluster associated with the search result. */
  primaryCluster?: Maybe<Scalars['String']['output']>;
  /** The content type associated with the search result. */
  relatedContentType?: Maybe<ContentSearchResultRelatedContentTypeUnion>;
  /** The reviewers that this Article has been reviewed by. */
  reviewedBy?: Maybe<Array<ContentReviewer>>;
  /** The uri slug for the resource. */
  slug?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_status for the resource. */
  status: Scalars['String']['output'];
  /** The synopsis of a search result. */
  synopsis?: Maybe<Scalars['StructuredContentDocument']['output']>;
  /** The editorial title of the resource. */
  title?: Maybe<Scalars['String']['output']>;
  /** The WordPress post_type for the resource. */
  type: Scalars['String']['output'];
};


/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultDateArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultModifiedArgs = {
  format?: InputMaybe<Scalars['String']['input']>;
  timezone?: InputMaybe<Scalars['String']['input']>;
};


/** The Type modeling the results returned from the WP search endpoint. */
export type ContentSearchResultTitleArgs = {
  format?: InputMaybe<RenderedTextFormatEnum>;
};

type GetProductShoppingAttributes_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', productType: string };

type GetProductShoppingAttributes_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2', productType: string };

type GetProductShoppingAttributes_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2', productType: string };

type GetProductShoppingAttributes_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2', productType: string };

type GetProductShoppingAttributes_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2', productType: string };

type GetProductShoppingAttributes_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2', productType: string };

type GetProductShoppingAttributes_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2', productType: string };

type GetProductShoppingAttributes_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2', productType: string };

type GetProductShoppingAttributes_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', productType: string };

type GetProductShoppingAttributes_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2', productType: string };

type GetProductShoppingAttributes_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2', productType: string };

type GetProductShoppingAttributes_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2', productType: string };

type GetProductShoppingAttributes_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2', productType: string };

type GetProductShoppingAttributes_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2', productType: string };

type GetProductShoppingAttributes_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2', productType: string };

type GetProductShoppingAttributes_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2', productType: string };

type GetProductShoppingAttributes_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2', productType: string };

type GetProductShoppingAttributes_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_BankingProductV2_Fragment = { __typename?: 'BankingProductV2', productType: string };

type GetProductShoppingAttributes_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2', productType: string };

type GetProductShoppingAttributes_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2', productType: string };

type GetProductShoppingAttributes_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2', productType: string };

type GetProductShoppingAttributes_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2', productType: string };

type GetProductShoppingAttributes_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2', productType: string };

type GetProductShoppingAttributes_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2', productType: string };

type GetProductShoppingAttributes_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2', productType: string };

type GetProductShoppingAttributes_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2', productType: string };

type GetProductShoppingAttributes_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2', productType: string };

type GetProductShoppingAttributes_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2', productType: string };

type GetProductShoppingAttributes_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2', productType: string };

type GetProductShoppingAttributes_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2', productType: string };

type GetProductShoppingAttributes_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string };

type GetProductShoppingAttributes_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductShoppingAttributes_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string };

type GetProductShoppingAttributes_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2', productType: string };

type GetProductShoppingAttributes_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2', productType: string };

type GetProductShoppingAttributes_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution', productType: string };

type GetProductShoppingAttributes_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct', productType: string };

export type GetProductShoppingAttributesFragment = GetProductShoppingAttributes_InsuranceOfferV2_Fragment | GetProductShoppingAttributes_CreditCardsOfferV2_Fragment | GetProductShoppingAttributes_InsuranceProductV2_Fragment | GetProductShoppingAttributes_InsuranceInstitutionV2_Fragment | GetProductShoppingAttributes_CaBankingInstitutionV2_Fragment | GetProductShoppingAttributes_CaBankingProductV2_Fragment | GetProductShoppingAttributes_CaBankingOfferV2_Fragment | GetProductShoppingAttributes_CaCreditCardsInstitutionV2_Fragment | GetProductShoppingAttributes_CaCreditCardsProductV2_Fragment | GetProductShoppingAttributes_CaCreditCardsOfferV2_Fragment | GetProductShoppingAttributes_InvestingOfferV2_Fragment | GetProductShoppingAttributes_InvestingProductV2_Fragment | GetProductShoppingAttributes_InvestingInstitutionV2_Fragment | GetProductShoppingAttributes_NerdwalletPlusInstitutionV2_Fragment | GetProductShoppingAttributes_NerdwalletPlusProductV2_Fragment | GetProductShoppingAttributes_NerdwalletPlusOfferV2_Fragment | GetProductShoppingAttributes_AutoLoansOfferV2_Fragment | GetProductShoppingAttributes_AutoServicesInstitutionV2_Fragment | GetProductShoppingAttributes_AutoServicesOfferV2_Fragment | GetProductShoppingAttributes_AutoServicesProductV2_Fragment | GetProductShoppingAttributes_BankingOfferV2_Fragment | GetProductShoppingAttributes_EducationLoansOfferV2_Fragment | GetProductShoppingAttributes_MortgagesOfferV2_Fragment | GetProductShoppingAttributes_SoftwareOfferV2_Fragment | GetProductShoppingAttributes_EstatePlanningOfferV2_Fragment | GetProductShoppingAttributes_ExpansionOfferV2_Fragment | GetProductShoppingAttributes_AutoLoansInstitutionV2_Fragment | GetProductShoppingAttributes_AutoLoansProductV2_Fragment | GetProductShoppingAttributes_BankingInstitutionV2_Fragment | GetProductShoppingAttributes_BankingProductV2_Fragment | GetProductShoppingAttributes_CreditCardsInstitutionV2_Fragment | GetProductShoppingAttributes_CreditCardsProductV2_Fragment | GetProductShoppingAttributes_EducationLoansInstitutionV2_Fragment | GetProductShoppingAttributes_EducationLoansProductV2_Fragment | GetProductShoppingAttributes_EstatePlanningInstitutionV2_Fragment | GetProductShoppingAttributes_EstatePlanningProductV2_Fragment | GetProductShoppingAttributes_ExpansionInstitutionV2_Fragment | GetProductShoppingAttributes_ExpansionProductV2_Fragment | GetProductShoppingAttributes_MortgagesInstitutionV2_Fragment | GetProductShoppingAttributes_MortgagesProductV2_Fragment | GetProductShoppingAttributes_PersonalLoansInstitutionV2_Fragment | GetProductShoppingAttributes_PersonalLoansOfferV2_Fragment | GetProductShoppingAttributes_PersonalLoansProductV2_Fragment | GetProductShoppingAttributes_SmallMediumBusinessLoansInstitutionV2_Fragment | GetProductShoppingAttributes_SmallMediumBusinessLoansOfferV2_Fragment | GetProductShoppingAttributes_SmallMediumBusinessLoansProductV2_Fragment | GetProductShoppingAttributes_SoftwareInstitutionV2_Fragment | GetProductShoppingAttributes_SoftwareProductV2_Fragment | GetProductShoppingAttributes_ThirdPartyEmbedsInstitution_Fragment | GetProductShoppingAttributes_ThirdPartyEmbedsProduct_Fragment;

type GetProductImpressionPayload_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', productType: string };

type GetProductImpressionPayload_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2', productType: string };

type GetProductImpressionPayload_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2', productType: string };

type GetProductImpressionPayload_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2', productType: string };

type GetProductImpressionPayload_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2', productType: string };

type GetProductImpressionPayload_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2', productType: string };

type GetProductImpressionPayload_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2', productType: string };

type GetProductImpressionPayload_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2', productType: string };

type GetProductImpressionPayload_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', productType: string };

type GetProductImpressionPayload_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2', productType: string };

type GetProductImpressionPayload_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2', productType: string };

type GetProductImpressionPayload_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2', productType: string };

type GetProductImpressionPayload_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2', productType: string };

type GetProductImpressionPayload_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2', productType: string };

type GetProductImpressionPayload_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2', productType: string };

type GetProductImpressionPayload_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2', productType: string };

type GetProductImpressionPayload_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2', productType: string };

type GetProductImpressionPayload_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_BankingProductV2_Fragment = { __typename?: 'BankingProductV2', productType: string };

type GetProductImpressionPayload_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2', productType: string };

type GetProductImpressionPayload_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2', productType: string };

type GetProductImpressionPayload_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2', productType: string };

type GetProductImpressionPayload_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2', productType: string };

type GetProductImpressionPayload_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2', productType: string };

type GetProductImpressionPayload_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2', productType: string };

type GetProductImpressionPayload_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2', productType: string };

type GetProductImpressionPayload_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2', productType: string };

type GetProductImpressionPayload_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2', productType: string };

type GetProductImpressionPayload_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2', productType: string };

type GetProductImpressionPayload_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2', productType: string };

type GetProductImpressionPayload_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2', productType: string };

type GetProductImpressionPayload_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string };

type GetProductImpressionPayload_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetProductImpressionPayload_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string };

type GetProductImpressionPayload_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2', productType: string };

type GetProductImpressionPayload_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2', productType: string };

type GetProductImpressionPayload_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution', productType: string };

type GetProductImpressionPayload_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct', productType: string };

export type GetProductImpressionPayloadFragment = GetProductImpressionPayload_InsuranceOfferV2_Fragment | GetProductImpressionPayload_CreditCardsOfferV2_Fragment | GetProductImpressionPayload_InsuranceProductV2_Fragment | GetProductImpressionPayload_InsuranceInstitutionV2_Fragment | GetProductImpressionPayload_CaBankingInstitutionV2_Fragment | GetProductImpressionPayload_CaBankingProductV2_Fragment | GetProductImpressionPayload_CaBankingOfferV2_Fragment | GetProductImpressionPayload_CaCreditCardsInstitutionV2_Fragment | GetProductImpressionPayload_CaCreditCardsProductV2_Fragment | GetProductImpressionPayload_CaCreditCardsOfferV2_Fragment | GetProductImpressionPayload_InvestingOfferV2_Fragment | GetProductImpressionPayload_InvestingProductV2_Fragment | GetProductImpressionPayload_InvestingInstitutionV2_Fragment | GetProductImpressionPayload_NerdwalletPlusInstitutionV2_Fragment | GetProductImpressionPayload_NerdwalletPlusProductV2_Fragment | GetProductImpressionPayload_NerdwalletPlusOfferV2_Fragment | GetProductImpressionPayload_AutoLoansOfferV2_Fragment | GetProductImpressionPayload_AutoServicesInstitutionV2_Fragment | GetProductImpressionPayload_AutoServicesOfferV2_Fragment | GetProductImpressionPayload_AutoServicesProductV2_Fragment | GetProductImpressionPayload_BankingOfferV2_Fragment | GetProductImpressionPayload_EducationLoansOfferV2_Fragment | GetProductImpressionPayload_MortgagesOfferV2_Fragment | GetProductImpressionPayload_SoftwareOfferV2_Fragment | GetProductImpressionPayload_EstatePlanningOfferV2_Fragment | GetProductImpressionPayload_ExpansionOfferV2_Fragment | GetProductImpressionPayload_AutoLoansInstitutionV2_Fragment | GetProductImpressionPayload_AutoLoansProductV2_Fragment | GetProductImpressionPayload_BankingInstitutionV2_Fragment | GetProductImpressionPayload_BankingProductV2_Fragment | GetProductImpressionPayload_CreditCardsInstitutionV2_Fragment | GetProductImpressionPayload_CreditCardsProductV2_Fragment | GetProductImpressionPayload_EducationLoansInstitutionV2_Fragment | GetProductImpressionPayload_EducationLoansProductV2_Fragment | GetProductImpressionPayload_EstatePlanningInstitutionV2_Fragment | GetProductImpressionPayload_EstatePlanningProductV2_Fragment | GetProductImpressionPayload_ExpansionInstitutionV2_Fragment | GetProductImpressionPayload_ExpansionProductV2_Fragment | GetProductImpressionPayload_MortgagesInstitutionV2_Fragment | GetProductImpressionPayload_MortgagesProductV2_Fragment | GetProductImpressionPayload_PersonalLoansInstitutionV2_Fragment | GetProductImpressionPayload_PersonalLoansOfferV2_Fragment | GetProductImpressionPayload_PersonalLoansProductV2_Fragment | GetProductImpressionPayload_SmallMediumBusinessLoansInstitutionV2_Fragment | GetProductImpressionPayload_SmallMediumBusinessLoansOfferV2_Fragment | GetProductImpressionPayload_SmallMediumBusinessLoansProductV2_Fragment | GetProductImpressionPayload_SoftwareInstitutionV2_Fragment | GetProductImpressionPayload_SoftwareProductV2_Fragment | GetProductImpressionPayload_ThirdPartyEmbedsInstitution_Fragment | GetProductImpressionPayload_ThirdPartyEmbedsProduct_Fragment;

type GetShoppingFinishedPayload_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', productType: string };

type GetShoppingFinishedPayload_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2', productType: string };

type GetShoppingFinishedPayload_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2', productType: string };

type GetShoppingFinishedPayload_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2', productType: string };

type GetShoppingFinishedPayload_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2', productType: string };

type GetShoppingFinishedPayload_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2', productType: string };

type GetShoppingFinishedPayload_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2', productType: string };

type GetShoppingFinishedPayload_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2', productType: string };

type GetShoppingFinishedPayload_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', productType: string };

type GetShoppingFinishedPayload_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2', productType: string };

type GetShoppingFinishedPayload_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2', productType: string };

type GetShoppingFinishedPayload_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2', productType: string };

type GetShoppingFinishedPayload_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2', productType: string };

type GetShoppingFinishedPayload_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2', productType: string };

type GetShoppingFinishedPayload_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2', productType: string };

type GetShoppingFinishedPayload_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2', productType: string };

type GetShoppingFinishedPayload_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2', productType: string };

type GetShoppingFinishedPayload_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_BankingProductV2_Fragment = { __typename?: 'BankingProductV2', productType: string };

type GetShoppingFinishedPayload_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2', productType: string };

type GetShoppingFinishedPayload_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2', productType: string };

type GetShoppingFinishedPayload_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2', productType: string };

type GetShoppingFinishedPayload_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2', productType: string };

type GetShoppingFinishedPayload_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2', productType: string };

type GetShoppingFinishedPayload_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2', productType: string };

type GetShoppingFinishedPayload_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2', productType: string };

type GetShoppingFinishedPayload_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2', productType: string };

type GetShoppingFinishedPayload_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2', productType: string };

type GetShoppingFinishedPayload_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2', productType: string };

type GetShoppingFinishedPayload_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2', productType: string };

type GetShoppingFinishedPayload_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2', productType: string };

type GetShoppingFinishedPayload_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string };

type GetShoppingFinishedPayload_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type GetShoppingFinishedPayload_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string };

type GetShoppingFinishedPayload_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2', productType: string };

type GetShoppingFinishedPayload_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2', productType: string };

type GetShoppingFinishedPayload_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution', productType: string };

type GetShoppingFinishedPayload_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct', productType: string };

export type GetShoppingFinishedPayloadFragment = GetShoppingFinishedPayload_InsuranceOfferV2_Fragment | GetShoppingFinishedPayload_CreditCardsOfferV2_Fragment | GetShoppingFinishedPayload_InsuranceProductV2_Fragment | GetShoppingFinishedPayload_InsuranceInstitutionV2_Fragment | GetShoppingFinishedPayload_CaBankingInstitutionV2_Fragment | GetShoppingFinishedPayload_CaBankingProductV2_Fragment | GetShoppingFinishedPayload_CaBankingOfferV2_Fragment | GetShoppingFinishedPayload_CaCreditCardsInstitutionV2_Fragment | GetShoppingFinishedPayload_CaCreditCardsProductV2_Fragment | GetShoppingFinishedPayload_CaCreditCardsOfferV2_Fragment | GetShoppingFinishedPayload_InvestingOfferV2_Fragment | GetShoppingFinishedPayload_InvestingProductV2_Fragment | GetShoppingFinishedPayload_InvestingInstitutionV2_Fragment | GetShoppingFinishedPayload_NerdwalletPlusInstitutionV2_Fragment | GetShoppingFinishedPayload_NerdwalletPlusProductV2_Fragment | GetShoppingFinishedPayload_NerdwalletPlusOfferV2_Fragment | GetShoppingFinishedPayload_AutoLoansOfferV2_Fragment | GetShoppingFinishedPayload_AutoServicesInstitutionV2_Fragment | GetShoppingFinishedPayload_AutoServicesOfferV2_Fragment | GetShoppingFinishedPayload_AutoServicesProductV2_Fragment | GetShoppingFinishedPayload_BankingOfferV2_Fragment | GetShoppingFinishedPayload_EducationLoansOfferV2_Fragment | GetShoppingFinishedPayload_MortgagesOfferV2_Fragment | GetShoppingFinishedPayload_SoftwareOfferV2_Fragment | GetShoppingFinishedPayload_EstatePlanningOfferV2_Fragment | GetShoppingFinishedPayload_ExpansionOfferV2_Fragment | GetShoppingFinishedPayload_AutoLoansInstitutionV2_Fragment | GetShoppingFinishedPayload_AutoLoansProductV2_Fragment | GetShoppingFinishedPayload_BankingInstitutionV2_Fragment | GetShoppingFinishedPayload_BankingProductV2_Fragment | GetShoppingFinishedPayload_CreditCardsInstitutionV2_Fragment | GetShoppingFinishedPayload_CreditCardsProductV2_Fragment | GetShoppingFinishedPayload_EducationLoansInstitutionV2_Fragment | GetShoppingFinishedPayload_EducationLoansProductV2_Fragment | GetShoppingFinishedPayload_EstatePlanningInstitutionV2_Fragment | GetShoppingFinishedPayload_EstatePlanningProductV2_Fragment | GetShoppingFinishedPayload_ExpansionInstitutionV2_Fragment | GetShoppingFinishedPayload_ExpansionProductV2_Fragment | GetShoppingFinishedPayload_MortgagesInstitutionV2_Fragment | GetShoppingFinishedPayload_MortgagesProductV2_Fragment | GetShoppingFinishedPayload_PersonalLoansInstitutionV2_Fragment | GetShoppingFinishedPayload_PersonalLoansOfferV2_Fragment | GetShoppingFinishedPayload_PersonalLoansProductV2_Fragment | GetShoppingFinishedPayload_SmallMediumBusinessLoansInstitutionV2_Fragment | GetShoppingFinishedPayload_SmallMediumBusinessLoansOfferV2_Fragment | GetShoppingFinishedPayload_SmallMediumBusinessLoansProductV2_Fragment | GetShoppingFinishedPayload_SoftwareInstitutionV2_Fragment | GetShoppingFinishedPayload_SoftwareProductV2_Fragment | GetShoppingFinishedPayload_ThirdPartyEmbedsInstitution_Fragment | GetShoppingFinishedPayload_ThirdPartyEmbedsProduct_Fragment;

type TrackNonMonetizingShoppingFinished_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2', productType: string };

type TrackNonMonetizingShoppingFinished_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2', productType: string };

type TrackNonMonetizingShoppingFinished_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2', productType: string };

type TrackNonMonetizingShoppingFinished_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_BankingProductV2_Fragment = { __typename?: 'BankingProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, offerId?: string | null, productId?: string | null } | null };

type TrackNonMonetizingShoppingFinished_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2', productType: string };

type TrackNonMonetizingShoppingFinished_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2', productType: string };

type TrackNonMonetizingShoppingFinished_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution', productType: string };

type TrackNonMonetizingShoppingFinished_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct', productType: string };

export type TrackNonMonetizingShoppingFinishedFragment = TrackNonMonetizingShoppingFinished_InsuranceOfferV2_Fragment | TrackNonMonetizingShoppingFinished_CreditCardsOfferV2_Fragment | TrackNonMonetizingShoppingFinished_InsuranceProductV2_Fragment | TrackNonMonetizingShoppingFinished_InsuranceInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_CaBankingInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_CaBankingProductV2_Fragment | TrackNonMonetizingShoppingFinished_CaBankingOfferV2_Fragment | TrackNonMonetizingShoppingFinished_CaCreditCardsInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_CaCreditCardsProductV2_Fragment | TrackNonMonetizingShoppingFinished_CaCreditCardsOfferV2_Fragment | TrackNonMonetizingShoppingFinished_InvestingOfferV2_Fragment | TrackNonMonetizingShoppingFinished_InvestingProductV2_Fragment | TrackNonMonetizingShoppingFinished_InvestingInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_NerdwalletPlusInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_NerdwalletPlusProductV2_Fragment | TrackNonMonetizingShoppingFinished_NerdwalletPlusOfferV2_Fragment | TrackNonMonetizingShoppingFinished_AutoLoansOfferV2_Fragment | TrackNonMonetizingShoppingFinished_AutoServicesInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_AutoServicesOfferV2_Fragment | TrackNonMonetizingShoppingFinished_AutoServicesProductV2_Fragment | TrackNonMonetizingShoppingFinished_BankingOfferV2_Fragment | TrackNonMonetizingShoppingFinished_EducationLoansOfferV2_Fragment | TrackNonMonetizingShoppingFinished_MortgagesOfferV2_Fragment | TrackNonMonetizingShoppingFinished_SoftwareOfferV2_Fragment | TrackNonMonetizingShoppingFinished_EstatePlanningOfferV2_Fragment | TrackNonMonetizingShoppingFinished_ExpansionOfferV2_Fragment | TrackNonMonetizingShoppingFinished_AutoLoansInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_AutoLoansProductV2_Fragment | TrackNonMonetizingShoppingFinished_BankingInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_BankingProductV2_Fragment | TrackNonMonetizingShoppingFinished_CreditCardsInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_CreditCardsProductV2_Fragment | TrackNonMonetizingShoppingFinished_EducationLoansInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_EducationLoansProductV2_Fragment | TrackNonMonetizingShoppingFinished_EstatePlanningInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_EstatePlanningProductV2_Fragment | TrackNonMonetizingShoppingFinished_ExpansionInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_ExpansionProductV2_Fragment | TrackNonMonetizingShoppingFinished_MortgagesInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_MortgagesProductV2_Fragment | TrackNonMonetizingShoppingFinished_PersonalLoansInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_PersonalLoansOfferV2_Fragment | TrackNonMonetizingShoppingFinished_PersonalLoansProductV2_Fragment | TrackNonMonetizingShoppingFinished_SmallMediumBusinessLoansInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_SmallMediumBusinessLoansOfferV2_Fragment | TrackNonMonetizingShoppingFinished_SmallMediumBusinessLoansProductV2_Fragment | TrackNonMonetizingShoppingFinished_SoftwareInstitutionV2_Fragment | TrackNonMonetizingShoppingFinished_SoftwareProductV2_Fragment | TrackNonMonetizingShoppingFinished_ThirdPartyEmbedsInstitution_Fragment | TrackNonMonetizingShoppingFinished_ThirdPartyEmbedsProduct_Fragment;

type BaseMarketplaceCta_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', phoneNumber?: string | null, monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', productType: string, versionId: number, reviewLink?: any | null };

type BaseMarketplaceCta_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2', productType: string, versionId: number };

type BaseMarketplaceCta_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2', productType: string, versionId: number };

type BaseMarketplaceCta_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', productType: string, versionId: number, reviewLink?: any | null };

type BaseMarketplaceCta_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2', productType: string, versionId: number };

type BaseMarketplaceCta_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', monetizable: string, productType: string, versionId: number, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', federallyInsuredAnnotation?: string | null, monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_BankingProductV2_Fragment = { __typename?: 'BankingProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null };

type BaseMarketplaceCta_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2', productType: string, versionId: number };

type BaseMarketplaceCta_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2', productType: string, versionId: number };

type BaseMarketplaceCta_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution', productType: string, versionId: number };

type BaseMarketplaceCta_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct', productType: string, versionId: number };

export type BaseMarketplaceCtaFragment = BaseMarketplaceCta_InsuranceOfferV2_Fragment | BaseMarketplaceCta_CreditCardsOfferV2_Fragment | BaseMarketplaceCta_InsuranceProductV2_Fragment | BaseMarketplaceCta_InsuranceInstitutionV2_Fragment | BaseMarketplaceCta_CaBankingInstitutionV2_Fragment | BaseMarketplaceCta_CaBankingProductV2_Fragment | BaseMarketplaceCta_CaBankingOfferV2_Fragment | BaseMarketplaceCta_CaCreditCardsInstitutionV2_Fragment | BaseMarketplaceCta_CaCreditCardsProductV2_Fragment | BaseMarketplaceCta_CaCreditCardsOfferV2_Fragment | BaseMarketplaceCta_InvestingOfferV2_Fragment | BaseMarketplaceCta_InvestingProductV2_Fragment | BaseMarketplaceCta_InvestingInstitutionV2_Fragment | BaseMarketplaceCta_NerdwalletPlusInstitutionV2_Fragment | BaseMarketplaceCta_NerdwalletPlusProductV2_Fragment | BaseMarketplaceCta_NerdwalletPlusOfferV2_Fragment | BaseMarketplaceCta_AutoLoansOfferV2_Fragment | BaseMarketplaceCta_AutoServicesInstitutionV2_Fragment | BaseMarketplaceCta_AutoServicesOfferV2_Fragment | BaseMarketplaceCta_AutoServicesProductV2_Fragment | BaseMarketplaceCta_BankingOfferV2_Fragment | BaseMarketplaceCta_EducationLoansOfferV2_Fragment | BaseMarketplaceCta_MortgagesOfferV2_Fragment | BaseMarketplaceCta_SoftwareOfferV2_Fragment | BaseMarketplaceCta_EstatePlanningOfferV2_Fragment | BaseMarketplaceCta_ExpansionOfferV2_Fragment | BaseMarketplaceCta_AutoLoansInstitutionV2_Fragment | BaseMarketplaceCta_AutoLoansProductV2_Fragment | BaseMarketplaceCta_BankingInstitutionV2_Fragment | BaseMarketplaceCta_BankingProductV2_Fragment | BaseMarketplaceCta_CreditCardsInstitutionV2_Fragment | BaseMarketplaceCta_CreditCardsProductV2_Fragment | BaseMarketplaceCta_EducationLoansInstitutionV2_Fragment | BaseMarketplaceCta_EducationLoansProductV2_Fragment | BaseMarketplaceCta_EstatePlanningInstitutionV2_Fragment | BaseMarketplaceCta_EstatePlanningProductV2_Fragment | BaseMarketplaceCta_ExpansionInstitutionV2_Fragment | BaseMarketplaceCta_ExpansionProductV2_Fragment | BaseMarketplaceCta_MortgagesInstitutionV2_Fragment | BaseMarketplaceCta_MortgagesProductV2_Fragment | BaseMarketplaceCta_PersonalLoansInstitutionV2_Fragment | BaseMarketplaceCta_PersonalLoansOfferV2_Fragment | BaseMarketplaceCta_PersonalLoansProductV2_Fragment | BaseMarketplaceCta_SmallMediumBusinessLoansInstitutionV2_Fragment | BaseMarketplaceCta_SmallMediumBusinessLoansOfferV2_Fragment | BaseMarketplaceCta_SmallMediumBusinessLoansProductV2_Fragment | BaseMarketplaceCta_SoftwareInstitutionV2_Fragment | BaseMarketplaceCta_SoftwareProductV2_Fragment | BaseMarketplaceCta_ThirdPartyEmbedsInstitution_Fragment | BaseMarketplaceCta_ThirdPartyEmbedsProduct_Fragment;

export type BaseMarketplaceCtaOnEntityPlacementCtaFragment = { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum };

type MarketplaceCta_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', phoneNumber?: string | null, monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', productType: string, versionId: number, reviewLink?: any | null };

type MarketplaceCta_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2', productType: string, versionId: number };

type MarketplaceCta_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2', productType: string, versionId: number };

type MarketplaceCta_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2', productType: string, versionId: number };

type MarketplaceCta_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2', productType: string, versionId: number };

type MarketplaceCta_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', productType: string, versionId: number, reviewLink?: any | null };

type MarketplaceCta_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2', productType: string, versionId: number };

type MarketplaceCta_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2', productType: string, versionId: number };

type MarketplaceCta_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', monetizable: string, productType: string, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2', productType: string, versionId: number };

type MarketplaceCta_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', federallyInsuredAnnotation?: string | null, monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2', productType: string, versionId: number };

type MarketplaceCta_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_BankingProductV2_Fragment = { __typename?: 'BankingProductV2', productType: string, versionId: number };

type MarketplaceCta_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2', productType: string, versionId: number };

type MarketplaceCta_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2', productType: string, versionId: number };

type MarketplaceCta_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2', productType: string, versionId: number };

type MarketplaceCta_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2', productType: string, versionId: number };

type MarketplaceCta_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2', productType: string, versionId: number };

type MarketplaceCta_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2', productType: string, versionId: number };

type MarketplaceCta_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', monetizable: string, productType: string, versionId: number, reviewLink?: any | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null };

type MarketplaceCta_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2', productType: string, versionId: number };

type MarketplaceCta_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2', productType: string, versionId: number };

type MarketplaceCta_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2', productType: string, versionId: number };

type MarketplaceCta_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution', productType: string, versionId: number };

type MarketplaceCta_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct', productType: string, versionId: number };

export type MarketplaceCtaFragment = MarketplaceCta_InsuranceOfferV2_Fragment | MarketplaceCta_CreditCardsOfferV2_Fragment | MarketplaceCta_InsuranceProductV2_Fragment | MarketplaceCta_InsuranceInstitutionV2_Fragment | MarketplaceCta_CaBankingInstitutionV2_Fragment | MarketplaceCta_CaBankingProductV2_Fragment | MarketplaceCta_CaBankingOfferV2_Fragment | MarketplaceCta_CaCreditCardsInstitutionV2_Fragment | MarketplaceCta_CaCreditCardsProductV2_Fragment | MarketplaceCta_CaCreditCardsOfferV2_Fragment | MarketplaceCta_InvestingOfferV2_Fragment | MarketplaceCta_InvestingProductV2_Fragment | MarketplaceCta_InvestingInstitutionV2_Fragment | MarketplaceCta_NerdwalletPlusInstitutionV2_Fragment | MarketplaceCta_NerdwalletPlusProductV2_Fragment | MarketplaceCta_NerdwalletPlusOfferV2_Fragment | MarketplaceCta_AutoLoansOfferV2_Fragment | MarketplaceCta_AutoServicesInstitutionV2_Fragment | MarketplaceCta_AutoServicesOfferV2_Fragment | MarketplaceCta_AutoServicesProductV2_Fragment | MarketplaceCta_BankingOfferV2_Fragment | MarketplaceCta_EducationLoansOfferV2_Fragment | MarketplaceCta_MortgagesOfferV2_Fragment | MarketplaceCta_SoftwareOfferV2_Fragment | MarketplaceCta_EstatePlanningOfferV2_Fragment | MarketplaceCta_ExpansionOfferV2_Fragment | MarketplaceCta_AutoLoansInstitutionV2_Fragment | MarketplaceCta_AutoLoansProductV2_Fragment | MarketplaceCta_BankingInstitutionV2_Fragment | MarketplaceCta_BankingProductV2_Fragment | MarketplaceCta_CreditCardsInstitutionV2_Fragment | MarketplaceCta_CreditCardsProductV2_Fragment | MarketplaceCta_EducationLoansInstitutionV2_Fragment | MarketplaceCta_EducationLoansProductV2_Fragment | MarketplaceCta_EstatePlanningInstitutionV2_Fragment | MarketplaceCta_EstatePlanningProductV2_Fragment | MarketplaceCta_ExpansionInstitutionV2_Fragment | MarketplaceCta_ExpansionProductV2_Fragment | MarketplaceCta_MortgagesInstitutionV2_Fragment | MarketplaceCta_MortgagesProductV2_Fragment | MarketplaceCta_PersonalLoansInstitutionV2_Fragment | MarketplaceCta_PersonalLoansOfferV2_Fragment | MarketplaceCta_PersonalLoansProductV2_Fragment | MarketplaceCta_SmallMediumBusinessLoansInstitutionV2_Fragment | MarketplaceCta_SmallMediumBusinessLoansOfferV2_Fragment | MarketplaceCta_SmallMediumBusinessLoansProductV2_Fragment | MarketplaceCta_SoftwareInstitutionV2_Fragment | MarketplaceCta_SoftwareProductV2_Fragment | MarketplaceCta_ThirdPartyEmbedsInstitution_Fragment | MarketplaceCta_ThirdPartyEmbedsProduct_Fragment;

export type MarketplaceCtaOnEntityPlacementCtaFragment = { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum };

type MarketplaceReviewLink_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', reviewLink?: any | null };

type MarketplaceReviewLink_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', reviewLink?: any | null };

type MarketplaceReviewLink_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', reviewLink?: any | null };

type MarketplaceReviewLink_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', reviewLink?: any | null };

type MarketplaceReviewLink_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', reviewLink?: any | null };

export type MarketplaceReviewLinkFragment = MarketplaceReviewLink_InsuranceOfferV2_Fragment | MarketplaceReviewLink_CreditCardsOfferV2_Fragment | MarketplaceReviewLink_InsuranceProductV2_Fragment | MarketplaceReviewLink_InvestingOfferV2_Fragment | MarketplaceReviewLink_InvestingProductV2_Fragment | MarketplaceReviewLink_AutoLoansOfferV2_Fragment | MarketplaceReviewLink_BankingOfferV2_Fragment | MarketplaceReviewLink_EducationLoansOfferV2_Fragment | MarketplaceReviewLink_MortgagesOfferV2_Fragment | MarketplaceReviewLink_SoftwareOfferV2_Fragment | MarketplaceReviewLink_EstatePlanningOfferV2_Fragment | MarketplaceReviewLink_ExpansionOfferV2_Fragment | MarketplaceReviewLink_BankingInstitutionV2_Fragment | MarketplaceReviewLink_PersonalLoansOfferV2_Fragment | MarketplaceReviewLink_SmallMediumBusinessLoansOfferV2_Fragment;

type BaseMarketplaceStarRating_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2' };

type BaseMarketplaceStarRating_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2' };

type BaseMarketplaceStarRating_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2' };

type BaseMarketplaceStarRating_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2' };

type BaseMarketplaceStarRating_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2' };

type BaseMarketplaceStarRating_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2' };

type BaseMarketplaceStarRating_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2' };

type BaseMarketplaceStarRating_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2' };

type BaseMarketplaceStarRating_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2' };

type BaseMarketplaceStarRating_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2' };

type BaseMarketplaceStarRating_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2' };

type BaseMarketplaceStarRating_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2' };

type BaseMarketplaceStarRating_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2' };

type BaseMarketplaceStarRating_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2' };

type BaseMarketplaceStarRating_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2' };

type BaseMarketplaceStarRating_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2' };

type BaseMarketplaceStarRating_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_BankingProductV2_Fragment = { __typename?: 'BankingProductV2' };

type BaseMarketplaceStarRating_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2' };

type BaseMarketplaceStarRating_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2' };

type BaseMarketplaceStarRating_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2' };

type BaseMarketplaceStarRating_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2' };

type BaseMarketplaceStarRating_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2' };

type BaseMarketplaceStarRating_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2' };

type BaseMarketplaceStarRating_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2' };

type BaseMarketplaceStarRating_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2' };

type BaseMarketplaceStarRating_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2' };

type BaseMarketplaceStarRating_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2' };

type BaseMarketplaceStarRating_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2' };

type BaseMarketplaceStarRating_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2' };

type BaseMarketplaceStarRating_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2' };

type BaseMarketplaceStarRating_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', reviewLink?: any | null };

type BaseMarketplaceStarRating_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2' };

type BaseMarketplaceStarRating_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2' };

type BaseMarketplaceStarRating_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2' };

type BaseMarketplaceStarRating_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution' };

type BaseMarketplaceStarRating_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct' };

export type BaseMarketplaceStarRatingFragment = BaseMarketplaceStarRating_InsuranceOfferV2_Fragment | BaseMarketplaceStarRating_CreditCardsOfferV2_Fragment | BaseMarketplaceStarRating_InsuranceProductV2_Fragment | BaseMarketplaceStarRating_InsuranceInstitutionV2_Fragment | BaseMarketplaceStarRating_CaBankingInstitutionV2_Fragment | BaseMarketplaceStarRating_CaBankingProductV2_Fragment | BaseMarketplaceStarRating_CaBankingOfferV2_Fragment | BaseMarketplaceStarRating_CaCreditCardsInstitutionV2_Fragment | BaseMarketplaceStarRating_CaCreditCardsProductV2_Fragment | BaseMarketplaceStarRating_CaCreditCardsOfferV2_Fragment | BaseMarketplaceStarRating_InvestingOfferV2_Fragment | BaseMarketplaceStarRating_InvestingProductV2_Fragment | BaseMarketplaceStarRating_InvestingInstitutionV2_Fragment | BaseMarketplaceStarRating_NerdwalletPlusInstitutionV2_Fragment | BaseMarketplaceStarRating_NerdwalletPlusProductV2_Fragment | BaseMarketplaceStarRating_NerdwalletPlusOfferV2_Fragment | BaseMarketplaceStarRating_AutoLoansOfferV2_Fragment | BaseMarketplaceStarRating_AutoServicesInstitutionV2_Fragment | BaseMarketplaceStarRating_AutoServicesOfferV2_Fragment | BaseMarketplaceStarRating_AutoServicesProductV2_Fragment | BaseMarketplaceStarRating_BankingOfferV2_Fragment | BaseMarketplaceStarRating_EducationLoansOfferV2_Fragment | BaseMarketplaceStarRating_MortgagesOfferV2_Fragment | BaseMarketplaceStarRating_SoftwareOfferV2_Fragment | BaseMarketplaceStarRating_EstatePlanningOfferV2_Fragment | BaseMarketplaceStarRating_ExpansionOfferV2_Fragment | BaseMarketplaceStarRating_AutoLoansInstitutionV2_Fragment | BaseMarketplaceStarRating_AutoLoansProductV2_Fragment | BaseMarketplaceStarRating_BankingInstitutionV2_Fragment | BaseMarketplaceStarRating_BankingProductV2_Fragment | BaseMarketplaceStarRating_CreditCardsInstitutionV2_Fragment | BaseMarketplaceStarRating_CreditCardsProductV2_Fragment | BaseMarketplaceStarRating_EducationLoansInstitutionV2_Fragment | BaseMarketplaceStarRating_EducationLoansProductV2_Fragment | BaseMarketplaceStarRating_EstatePlanningInstitutionV2_Fragment | BaseMarketplaceStarRating_EstatePlanningProductV2_Fragment | BaseMarketplaceStarRating_ExpansionInstitutionV2_Fragment | BaseMarketplaceStarRating_ExpansionProductV2_Fragment | BaseMarketplaceStarRating_MortgagesInstitutionV2_Fragment | BaseMarketplaceStarRating_MortgagesProductV2_Fragment | BaseMarketplaceStarRating_PersonalLoansInstitutionV2_Fragment | BaseMarketplaceStarRating_PersonalLoansOfferV2_Fragment | BaseMarketplaceStarRating_PersonalLoansProductV2_Fragment | BaseMarketplaceStarRating_SmallMediumBusinessLoansInstitutionV2_Fragment | BaseMarketplaceStarRating_SmallMediumBusinessLoansOfferV2_Fragment | BaseMarketplaceStarRating_SmallMediumBusinessLoansProductV2_Fragment | BaseMarketplaceStarRating_SoftwareInstitutionV2_Fragment | BaseMarketplaceStarRating_SoftwareProductV2_Fragment | BaseMarketplaceStarRating_ThirdPartyEmbedsInstitution_Fragment | BaseMarketplaceStarRating_ThirdPartyEmbedsProduct_Fragment;

type MarketplaceStarRating_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', reviewLink?: any | null };

type MarketplaceStarRating_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2', starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2' };

type MarketplaceStarRating_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2' };

type MarketplaceStarRating_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2' };

type MarketplaceStarRating_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2' };

type MarketplaceStarRating_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2' };

type MarketplaceStarRating_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2' };

type MarketplaceStarRating_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', reviewLink?: any | null };

type MarketplaceStarRating_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2', starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2' };

type MarketplaceStarRating_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2' };

type MarketplaceStarRating_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2' };

type MarketplaceStarRating_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2' };

type MarketplaceStarRating_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2' };

type MarketplaceStarRating_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2' };

type MarketplaceStarRating_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2' };

type MarketplaceStarRating_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2' };

type MarketplaceStarRating_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_BankingProductV2_Fragment = { __typename?: 'BankingProductV2' };

type MarketplaceStarRating_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2' };

type MarketplaceStarRating_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2' };

type MarketplaceStarRating_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2', starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2' };

type MarketplaceStarRating_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2' };

type MarketplaceStarRating_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2' };

type MarketplaceStarRating_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2' };

type MarketplaceStarRating_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2' };

type MarketplaceStarRating_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2' };

type MarketplaceStarRating_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2' };

type MarketplaceStarRating_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2' };

type MarketplaceStarRating_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2' };

type MarketplaceStarRating_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2' };

type MarketplaceStarRating_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null };

type MarketplaceStarRating_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2' };

type MarketplaceStarRating_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2' };

type MarketplaceStarRating_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2' };

type MarketplaceStarRating_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution' };

type MarketplaceStarRating_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct' };

export type MarketplaceStarRatingFragment = MarketplaceStarRating_InsuranceOfferV2_Fragment | MarketplaceStarRating_CreditCardsOfferV2_Fragment | MarketplaceStarRating_InsuranceProductV2_Fragment | MarketplaceStarRating_InsuranceInstitutionV2_Fragment | MarketplaceStarRating_CaBankingInstitutionV2_Fragment | MarketplaceStarRating_CaBankingProductV2_Fragment | MarketplaceStarRating_CaBankingOfferV2_Fragment | MarketplaceStarRating_CaCreditCardsInstitutionV2_Fragment | MarketplaceStarRating_CaCreditCardsProductV2_Fragment | MarketplaceStarRating_CaCreditCardsOfferV2_Fragment | MarketplaceStarRating_InvestingOfferV2_Fragment | MarketplaceStarRating_InvestingProductV2_Fragment | MarketplaceStarRating_InvestingInstitutionV2_Fragment | MarketplaceStarRating_NerdwalletPlusInstitutionV2_Fragment | MarketplaceStarRating_NerdwalletPlusProductV2_Fragment | MarketplaceStarRating_NerdwalletPlusOfferV2_Fragment | MarketplaceStarRating_AutoLoansOfferV2_Fragment | MarketplaceStarRating_AutoServicesInstitutionV2_Fragment | MarketplaceStarRating_AutoServicesOfferV2_Fragment | MarketplaceStarRating_AutoServicesProductV2_Fragment | MarketplaceStarRating_BankingOfferV2_Fragment | MarketplaceStarRating_EducationLoansOfferV2_Fragment | MarketplaceStarRating_MortgagesOfferV2_Fragment | MarketplaceStarRating_SoftwareOfferV2_Fragment | MarketplaceStarRating_EstatePlanningOfferV2_Fragment | MarketplaceStarRating_ExpansionOfferV2_Fragment | MarketplaceStarRating_AutoLoansInstitutionV2_Fragment | MarketplaceStarRating_AutoLoansProductV2_Fragment | MarketplaceStarRating_BankingInstitutionV2_Fragment | MarketplaceStarRating_BankingProductV2_Fragment | MarketplaceStarRating_CreditCardsInstitutionV2_Fragment | MarketplaceStarRating_CreditCardsProductV2_Fragment | MarketplaceStarRating_EducationLoansInstitutionV2_Fragment | MarketplaceStarRating_EducationLoansProductV2_Fragment | MarketplaceStarRating_EstatePlanningInstitutionV2_Fragment | MarketplaceStarRating_EstatePlanningProductV2_Fragment | MarketplaceStarRating_ExpansionInstitutionV2_Fragment | MarketplaceStarRating_ExpansionProductV2_Fragment | MarketplaceStarRating_MortgagesInstitutionV2_Fragment | MarketplaceStarRating_MortgagesProductV2_Fragment | MarketplaceStarRating_PersonalLoansInstitutionV2_Fragment | MarketplaceStarRating_PersonalLoansOfferV2_Fragment | MarketplaceStarRating_PersonalLoansProductV2_Fragment | MarketplaceStarRating_SmallMediumBusinessLoansInstitutionV2_Fragment | MarketplaceStarRating_SmallMediumBusinessLoansOfferV2_Fragment | MarketplaceStarRating_SmallMediumBusinessLoansProductV2_Fragment | MarketplaceStarRating_SoftwareInstitutionV2_Fragment | MarketplaceStarRating_SoftwareProductV2_Fragment | MarketplaceStarRating_ThirdPartyEmbedsInstitution_Fragment | MarketplaceStarRating_ThirdPartyEmbedsProduct_Fragment;

type GetCardDetailsConfig_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2' };

type GetCardDetailsConfig_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2' };

type GetCardDetailsConfig_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2' };

type GetCardDetailsConfig_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2' };

type GetCardDetailsConfig_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2' };

type GetCardDetailsConfig_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2' };

type GetCardDetailsConfig_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2' };

type GetCardDetailsConfig_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2' };

type GetCardDetailsConfig_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2' };

type GetCardDetailsConfig_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2' };

type GetCardDetailsConfig_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2' };

type GetCardDetailsConfig_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2' };

type GetCardDetailsConfig_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2' };

type GetCardDetailsConfig_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2' };

type GetCardDetailsConfig_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2' };

type GetCardDetailsConfig_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2' };

type GetCardDetailsConfig_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', qualificationsBullets?: Array<string> | null };

type GetCardDetailsConfig_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2' };

type GetCardDetailsConfig_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2' };

type GetCardDetailsConfig_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2' };

type GetCardDetailsConfig_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2' };

type GetCardDetailsConfig_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', qualificationsBullets?: Array<string> | null, availableTermLengths?: string | null };

type GetCardDetailsConfig_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2' };

type GetCardDetailsConfig_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2' };

type GetCardDetailsConfig_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2' };

type GetCardDetailsConfig_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2' };

type GetCardDetailsConfig_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2' };

type GetCardDetailsConfig_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2' };

type GetCardDetailsConfig_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2' };

type GetCardDetailsConfig_BankingProductV2_Fragment = { __typename?: 'BankingProductV2' };

type GetCardDetailsConfig_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2' };

type GetCardDetailsConfig_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2' };

type GetCardDetailsConfig_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2' };

type GetCardDetailsConfig_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2' };

type GetCardDetailsConfig_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2' };

type GetCardDetailsConfig_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2' };

type GetCardDetailsConfig_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2' };

type GetCardDetailsConfig_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2' };

type GetCardDetailsConfig_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2' };

type GetCardDetailsConfig_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2' };

type GetCardDetailsConfig_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2' };

type GetCardDetailsConfig_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', qualificationsBullets?: Array<string> | null, availableTermLengths?: string | null, feesBullets?: Array<string> | null };

type GetCardDetailsConfig_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2' };

type GetCardDetailsConfig_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2' };

type GetCardDetailsConfig_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', qualificationsBullets?: Array<string> | null };

type GetCardDetailsConfig_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2' };

type GetCardDetailsConfig_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2' };

type GetCardDetailsConfig_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2' };

type GetCardDetailsConfig_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution' };

type GetCardDetailsConfig_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct' };

export type GetCardDetailsConfigFragment = GetCardDetailsConfig_InsuranceOfferV2_Fragment | GetCardDetailsConfig_CreditCardsOfferV2_Fragment | GetCardDetailsConfig_InsuranceProductV2_Fragment | GetCardDetailsConfig_InsuranceInstitutionV2_Fragment | GetCardDetailsConfig_CaBankingInstitutionV2_Fragment | GetCardDetailsConfig_CaBankingProductV2_Fragment | GetCardDetailsConfig_CaBankingOfferV2_Fragment | GetCardDetailsConfig_CaCreditCardsInstitutionV2_Fragment | GetCardDetailsConfig_CaCreditCardsProductV2_Fragment | GetCardDetailsConfig_CaCreditCardsOfferV2_Fragment | GetCardDetailsConfig_InvestingOfferV2_Fragment | GetCardDetailsConfig_InvestingProductV2_Fragment | GetCardDetailsConfig_InvestingInstitutionV2_Fragment | GetCardDetailsConfig_NerdwalletPlusInstitutionV2_Fragment | GetCardDetailsConfig_NerdwalletPlusProductV2_Fragment | GetCardDetailsConfig_NerdwalletPlusOfferV2_Fragment | GetCardDetailsConfig_AutoLoansOfferV2_Fragment | GetCardDetailsConfig_AutoServicesInstitutionV2_Fragment | GetCardDetailsConfig_AutoServicesOfferV2_Fragment | GetCardDetailsConfig_AutoServicesProductV2_Fragment | GetCardDetailsConfig_BankingOfferV2_Fragment | GetCardDetailsConfig_EducationLoansOfferV2_Fragment | GetCardDetailsConfig_MortgagesOfferV2_Fragment | GetCardDetailsConfig_SoftwareOfferV2_Fragment | GetCardDetailsConfig_EstatePlanningOfferV2_Fragment | GetCardDetailsConfig_ExpansionOfferV2_Fragment | GetCardDetailsConfig_AutoLoansInstitutionV2_Fragment | GetCardDetailsConfig_AutoLoansProductV2_Fragment | GetCardDetailsConfig_BankingInstitutionV2_Fragment | GetCardDetailsConfig_BankingProductV2_Fragment | GetCardDetailsConfig_CreditCardsInstitutionV2_Fragment | GetCardDetailsConfig_CreditCardsProductV2_Fragment | GetCardDetailsConfig_EducationLoansInstitutionV2_Fragment | GetCardDetailsConfig_EducationLoansProductV2_Fragment | GetCardDetailsConfig_EstatePlanningInstitutionV2_Fragment | GetCardDetailsConfig_EstatePlanningProductV2_Fragment | GetCardDetailsConfig_ExpansionInstitutionV2_Fragment | GetCardDetailsConfig_ExpansionProductV2_Fragment | GetCardDetailsConfig_MortgagesInstitutionV2_Fragment | GetCardDetailsConfig_MortgagesProductV2_Fragment | GetCardDetailsConfig_PersonalLoansInstitutionV2_Fragment | GetCardDetailsConfig_PersonalLoansOfferV2_Fragment | GetCardDetailsConfig_PersonalLoansProductV2_Fragment | GetCardDetailsConfig_SmallMediumBusinessLoansInstitutionV2_Fragment | GetCardDetailsConfig_SmallMediumBusinessLoansOfferV2_Fragment | GetCardDetailsConfig_SmallMediumBusinessLoansProductV2_Fragment | GetCardDetailsConfig_SoftwareInstitutionV2_Fragment | GetCardDetailsConfig_SoftwareProductV2_Fragment | GetCardDetailsConfig_ThirdPartyEmbedsInstitution_Fragment | GetCardDetailsConfig_ThirdPartyEmbedsProduct_Fragment;

type ApprovalOddsDriver_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2' };

type ApprovalOddsDriver_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', maxFico?: number | null, minFico?: number | null };

type ApprovalOddsDriver_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2' };

type ApprovalOddsDriver_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2' };

type ApprovalOddsDriver_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2' };

type ApprovalOddsDriver_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2' };

type ApprovalOddsDriver_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2' };

type ApprovalOddsDriver_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2' };

type ApprovalOddsDriver_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2' };

type ApprovalOddsDriver_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2' };

type ApprovalOddsDriver_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2' };

type ApprovalOddsDriver_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2' };

type ApprovalOddsDriver_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2' };

type ApprovalOddsDriver_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2' };

type ApprovalOddsDriver_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2' };

type ApprovalOddsDriver_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2' };

type ApprovalOddsDriver_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2' };

type ApprovalOddsDriver_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2' };

type ApprovalOddsDriver_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2' };

type ApprovalOddsDriver_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2' };

type ApprovalOddsDriver_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2' };

type ApprovalOddsDriver_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2' };

type ApprovalOddsDriver_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2' };

type ApprovalOddsDriver_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2' };

type ApprovalOddsDriver_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2' };

type ApprovalOddsDriver_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2' };

type ApprovalOddsDriver_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2' };

type ApprovalOddsDriver_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2' };

type ApprovalOddsDriver_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2' };

type ApprovalOddsDriver_BankingProductV2_Fragment = { __typename?: 'BankingProductV2' };

type ApprovalOddsDriver_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2' };

type ApprovalOddsDriver_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2' };

type ApprovalOddsDriver_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2' };

type ApprovalOddsDriver_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2' };

type ApprovalOddsDriver_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2' };

type ApprovalOddsDriver_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2' };

type ApprovalOddsDriver_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2' };

type ApprovalOddsDriver_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2' };

type ApprovalOddsDriver_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2' };

type ApprovalOddsDriver_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2' };

type ApprovalOddsDriver_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2' };

type ApprovalOddsDriver_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2' };

type ApprovalOddsDriver_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2' };

type ApprovalOddsDriver_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2' };

type ApprovalOddsDriver_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2' };

type ApprovalOddsDriver_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2' };

type ApprovalOddsDriver_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2' };

type ApprovalOddsDriver_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2' };

type ApprovalOddsDriver_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution' };

type ApprovalOddsDriver_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct' };

export type ApprovalOddsDriverFragment = ApprovalOddsDriver_InsuranceOfferV2_Fragment | ApprovalOddsDriver_CreditCardsOfferV2_Fragment | ApprovalOddsDriver_InsuranceProductV2_Fragment | ApprovalOddsDriver_InsuranceInstitutionV2_Fragment | ApprovalOddsDriver_CaBankingInstitutionV2_Fragment | ApprovalOddsDriver_CaBankingProductV2_Fragment | ApprovalOddsDriver_CaBankingOfferV2_Fragment | ApprovalOddsDriver_CaCreditCardsInstitutionV2_Fragment | ApprovalOddsDriver_CaCreditCardsProductV2_Fragment | ApprovalOddsDriver_CaCreditCardsOfferV2_Fragment | ApprovalOddsDriver_InvestingOfferV2_Fragment | ApprovalOddsDriver_InvestingProductV2_Fragment | ApprovalOddsDriver_InvestingInstitutionV2_Fragment | ApprovalOddsDriver_NerdwalletPlusInstitutionV2_Fragment | ApprovalOddsDriver_NerdwalletPlusProductV2_Fragment | ApprovalOddsDriver_NerdwalletPlusOfferV2_Fragment | ApprovalOddsDriver_AutoLoansOfferV2_Fragment | ApprovalOddsDriver_AutoServicesInstitutionV2_Fragment | ApprovalOddsDriver_AutoServicesOfferV2_Fragment | ApprovalOddsDriver_AutoServicesProductV2_Fragment | ApprovalOddsDriver_BankingOfferV2_Fragment | ApprovalOddsDriver_EducationLoansOfferV2_Fragment | ApprovalOddsDriver_MortgagesOfferV2_Fragment | ApprovalOddsDriver_SoftwareOfferV2_Fragment | ApprovalOddsDriver_EstatePlanningOfferV2_Fragment | ApprovalOddsDriver_ExpansionOfferV2_Fragment | ApprovalOddsDriver_AutoLoansInstitutionV2_Fragment | ApprovalOddsDriver_AutoLoansProductV2_Fragment | ApprovalOddsDriver_BankingInstitutionV2_Fragment | ApprovalOddsDriver_BankingProductV2_Fragment | ApprovalOddsDriver_CreditCardsInstitutionV2_Fragment | ApprovalOddsDriver_CreditCardsProductV2_Fragment | ApprovalOddsDriver_EducationLoansInstitutionV2_Fragment | ApprovalOddsDriver_EducationLoansProductV2_Fragment | ApprovalOddsDriver_EstatePlanningInstitutionV2_Fragment | ApprovalOddsDriver_EstatePlanningProductV2_Fragment | ApprovalOddsDriver_ExpansionInstitutionV2_Fragment | ApprovalOddsDriver_ExpansionProductV2_Fragment | ApprovalOddsDriver_MortgagesInstitutionV2_Fragment | ApprovalOddsDriver_MortgagesProductV2_Fragment | ApprovalOddsDriver_PersonalLoansInstitutionV2_Fragment | ApprovalOddsDriver_PersonalLoansOfferV2_Fragment | ApprovalOddsDriver_PersonalLoansProductV2_Fragment | ApprovalOddsDriver_SmallMediumBusinessLoansInstitutionV2_Fragment | ApprovalOddsDriver_SmallMediumBusinessLoansOfferV2_Fragment | ApprovalOddsDriver_SmallMediumBusinessLoansProductV2_Fragment | ApprovalOddsDriver_SoftwareInstitutionV2_Fragment | ApprovalOddsDriver_SoftwareProductV2_Fragment | ApprovalOddsDriver_ThirdPartyEmbedsInstitution_Fragment | ApprovalOddsDriver_ThirdPartyEmbedsProduct_Fragment;

type GetExtendedDrivers_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }>, recommendedCreditScoreRangeDetails?: { __typename?: 'CreditCardsRecommendedCreditScoreRangeDetails', creditScoreRange?: string | null, description?: string | null } | null };

type GetExtendedDrivers_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2' };

type GetExtendedDrivers_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2' };

type GetExtendedDrivers_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2' };

type GetExtendedDrivers_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2' };

type GetExtendedDrivers_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2' };

type GetExtendedDrivers_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2' };

type GetExtendedDrivers_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2' };

type GetExtendedDrivers_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2' };

type GetExtendedDrivers_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2' };

type GetExtendedDrivers_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2' };

type GetExtendedDrivers_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2' };

type GetExtendedDrivers_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2' };

type GetExtendedDrivers_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2' };

type GetExtendedDrivers_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2' };

type GetExtendedDrivers_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2' };

type GetExtendedDrivers_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2' };

type GetExtendedDrivers_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2' };

type GetExtendedDrivers_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_BankingProductV2_Fragment = { __typename?: 'BankingProductV2' };

type GetExtendedDrivers_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2' };

type GetExtendedDrivers_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2' };

type GetExtendedDrivers_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2' };

type GetExtendedDrivers_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2' };

type GetExtendedDrivers_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2' };

type GetExtendedDrivers_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2' };

type GetExtendedDrivers_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2' };

type GetExtendedDrivers_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2' };

type GetExtendedDrivers_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2' };

type GetExtendedDrivers_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2' };

type GetExtendedDrivers_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2' };

type GetExtendedDrivers_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2' };

type GetExtendedDrivers_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2' };

type GetExtendedDrivers_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', placementDrivers: Array<{ __typename: 'EntityPlacementDriver' }> };

type GetExtendedDrivers_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2' };

type GetExtendedDrivers_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2' };

type GetExtendedDrivers_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2' };

type GetExtendedDrivers_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution' };

type GetExtendedDrivers_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct' };

export type GetExtendedDriversFragment = GetExtendedDrivers_InsuranceOfferV2_Fragment | GetExtendedDrivers_CreditCardsOfferV2_Fragment | GetExtendedDrivers_InsuranceProductV2_Fragment | GetExtendedDrivers_InsuranceInstitutionV2_Fragment | GetExtendedDrivers_CaBankingInstitutionV2_Fragment | GetExtendedDrivers_CaBankingProductV2_Fragment | GetExtendedDrivers_CaBankingOfferV2_Fragment | GetExtendedDrivers_CaCreditCardsInstitutionV2_Fragment | GetExtendedDrivers_CaCreditCardsProductV2_Fragment | GetExtendedDrivers_CaCreditCardsOfferV2_Fragment | GetExtendedDrivers_InvestingOfferV2_Fragment | GetExtendedDrivers_InvestingProductV2_Fragment | GetExtendedDrivers_InvestingInstitutionV2_Fragment | GetExtendedDrivers_NerdwalletPlusInstitutionV2_Fragment | GetExtendedDrivers_NerdwalletPlusProductV2_Fragment | GetExtendedDrivers_NerdwalletPlusOfferV2_Fragment | GetExtendedDrivers_AutoLoansOfferV2_Fragment | GetExtendedDrivers_AutoServicesInstitutionV2_Fragment | GetExtendedDrivers_AutoServicesOfferV2_Fragment | GetExtendedDrivers_AutoServicesProductV2_Fragment | GetExtendedDrivers_BankingOfferV2_Fragment | GetExtendedDrivers_EducationLoansOfferV2_Fragment | GetExtendedDrivers_MortgagesOfferV2_Fragment | GetExtendedDrivers_SoftwareOfferV2_Fragment | GetExtendedDrivers_EstatePlanningOfferV2_Fragment | GetExtendedDrivers_ExpansionOfferV2_Fragment | GetExtendedDrivers_AutoLoansInstitutionV2_Fragment | GetExtendedDrivers_AutoLoansProductV2_Fragment | GetExtendedDrivers_BankingInstitutionV2_Fragment | GetExtendedDrivers_BankingProductV2_Fragment | GetExtendedDrivers_CreditCardsInstitutionV2_Fragment | GetExtendedDrivers_CreditCardsProductV2_Fragment | GetExtendedDrivers_EducationLoansInstitutionV2_Fragment | GetExtendedDrivers_EducationLoansProductV2_Fragment | GetExtendedDrivers_EstatePlanningInstitutionV2_Fragment | GetExtendedDrivers_EstatePlanningProductV2_Fragment | GetExtendedDrivers_ExpansionInstitutionV2_Fragment | GetExtendedDrivers_ExpansionProductV2_Fragment | GetExtendedDrivers_MortgagesInstitutionV2_Fragment | GetExtendedDrivers_MortgagesProductV2_Fragment | GetExtendedDrivers_PersonalLoansInstitutionV2_Fragment | GetExtendedDrivers_PersonalLoansOfferV2_Fragment | GetExtendedDrivers_PersonalLoansProductV2_Fragment | GetExtendedDrivers_SmallMediumBusinessLoansInstitutionV2_Fragment | GetExtendedDrivers_SmallMediumBusinessLoansOfferV2_Fragment | GetExtendedDrivers_SmallMediumBusinessLoansProductV2_Fragment | GetExtendedDrivers_SoftwareInstitutionV2_Fragment | GetExtendedDrivers_SoftwareProductV2_Fragment | GetExtendedDrivers_ThirdPartyEmbedsInstitution_Fragment | GetExtendedDrivers_ThirdPartyEmbedsProduct_Fragment;

export type DriverFragment = { __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean };

export type DriversFragment = { __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean };

type DriversOnMarketplaceEntityInterface_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', maxFico?: number | null, minFico?: number | null, placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }>, recommendedCreditScoreRangeDetails?: { __typename?: 'CreditCardsRecommendedCreditScoreRangeDetails', creditScoreRange?: string | null, description?: string | null } | null };

type DriversOnMarketplaceEntityInterface_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2' };

type DriversOnMarketplaceEntityInterface_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2' };

type DriversOnMarketplaceEntityInterface_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2' };

type DriversOnMarketplaceEntityInterface_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2' };

type DriversOnMarketplaceEntityInterface_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2' };

type DriversOnMarketplaceEntityInterface_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2' };

type DriversOnMarketplaceEntityInterface_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2' };

type DriversOnMarketplaceEntityInterface_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2' };

type DriversOnMarketplaceEntityInterface_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2' };

type DriversOnMarketplaceEntityInterface_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2' };

type DriversOnMarketplaceEntityInterface_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2' };

type DriversOnMarketplaceEntityInterface_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2' };

type DriversOnMarketplaceEntityInterface_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2' };

type DriversOnMarketplaceEntityInterface_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2' };

type DriversOnMarketplaceEntityInterface_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2' };

type DriversOnMarketplaceEntityInterface_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2' };

type DriversOnMarketplaceEntityInterface_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2' };

type DriversOnMarketplaceEntityInterface_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_BankingProductV2_Fragment = { __typename?: 'BankingProductV2' };

type DriversOnMarketplaceEntityInterface_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2' };

type DriversOnMarketplaceEntityInterface_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2' };

type DriversOnMarketplaceEntityInterface_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2' };

type DriversOnMarketplaceEntityInterface_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2' };

type DriversOnMarketplaceEntityInterface_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2' };

type DriversOnMarketplaceEntityInterface_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2' };

type DriversOnMarketplaceEntityInterface_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2' };

type DriversOnMarketplaceEntityInterface_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2' };

type DriversOnMarketplaceEntityInterface_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2' };

type DriversOnMarketplaceEntityInterface_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2' };

type DriversOnMarketplaceEntityInterface_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2' };

type DriversOnMarketplaceEntityInterface_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2' };

type DriversOnMarketplaceEntityInterface_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2' };

type DriversOnMarketplaceEntityInterface_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type DriversOnMarketplaceEntityInterface_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2' };

type DriversOnMarketplaceEntityInterface_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2' };

type DriversOnMarketplaceEntityInterface_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2' };

type DriversOnMarketplaceEntityInterface_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution' };

type DriversOnMarketplaceEntityInterface_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct' };

export type DriversOnMarketplaceEntityInterfaceFragment = DriversOnMarketplaceEntityInterface_InsuranceOfferV2_Fragment | DriversOnMarketplaceEntityInterface_CreditCardsOfferV2_Fragment | DriversOnMarketplaceEntityInterface_InsuranceProductV2_Fragment | DriversOnMarketplaceEntityInterface_InsuranceInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_CaBankingInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_CaBankingProductV2_Fragment | DriversOnMarketplaceEntityInterface_CaBankingOfferV2_Fragment | DriversOnMarketplaceEntityInterface_CaCreditCardsInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_CaCreditCardsProductV2_Fragment | DriversOnMarketplaceEntityInterface_CaCreditCardsOfferV2_Fragment | DriversOnMarketplaceEntityInterface_InvestingOfferV2_Fragment | DriversOnMarketplaceEntityInterface_InvestingProductV2_Fragment | DriversOnMarketplaceEntityInterface_InvestingInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_NerdwalletPlusInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_NerdwalletPlusProductV2_Fragment | DriversOnMarketplaceEntityInterface_NerdwalletPlusOfferV2_Fragment | DriversOnMarketplaceEntityInterface_AutoLoansOfferV2_Fragment | DriversOnMarketplaceEntityInterface_AutoServicesInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_AutoServicesOfferV2_Fragment | DriversOnMarketplaceEntityInterface_AutoServicesProductV2_Fragment | DriversOnMarketplaceEntityInterface_BankingOfferV2_Fragment | DriversOnMarketplaceEntityInterface_EducationLoansOfferV2_Fragment | DriversOnMarketplaceEntityInterface_MortgagesOfferV2_Fragment | DriversOnMarketplaceEntityInterface_SoftwareOfferV2_Fragment | DriversOnMarketplaceEntityInterface_EstatePlanningOfferV2_Fragment | DriversOnMarketplaceEntityInterface_ExpansionOfferV2_Fragment | DriversOnMarketplaceEntityInterface_AutoLoansInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_AutoLoansProductV2_Fragment | DriversOnMarketplaceEntityInterface_BankingInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_BankingProductV2_Fragment | DriversOnMarketplaceEntityInterface_CreditCardsInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_CreditCardsProductV2_Fragment | DriversOnMarketplaceEntityInterface_EducationLoansInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_EducationLoansProductV2_Fragment | DriversOnMarketplaceEntityInterface_EstatePlanningInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_EstatePlanningProductV2_Fragment | DriversOnMarketplaceEntityInterface_ExpansionInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_ExpansionProductV2_Fragment | DriversOnMarketplaceEntityInterface_MortgagesInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_MortgagesProductV2_Fragment | DriversOnMarketplaceEntityInterface_PersonalLoansInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_PersonalLoansOfferV2_Fragment | DriversOnMarketplaceEntityInterface_PersonalLoansProductV2_Fragment | DriversOnMarketplaceEntityInterface_SmallMediumBusinessLoansInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_SmallMediumBusinessLoansOfferV2_Fragment | DriversOnMarketplaceEntityInterface_SmallMediumBusinessLoansProductV2_Fragment | DriversOnMarketplaceEntityInterface_SoftwareInstitutionV2_Fragment | DriversOnMarketplaceEntityInterface_SoftwareProductV2_Fragment | DriversOnMarketplaceEntityInterface_ThirdPartyEmbedsInstitution_Fragment | DriversOnMarketplaceEntityInterface_ThirdPartyEmbedsProduct_Fragment;

type RecCreditScoreDriver_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2' };

type RecCreditScoreDriver_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', maxFico?: number | null, minFico?: number | null, recommendedCreditScoreRangeDetails?: { __typename?: 'CreditCardsRecommendedCreditScoreRangeDetails', creditScoreRange?: string | null, description?: string | null } | null };

type RecCreditScoreDriver_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2' };

type RecCreditScoreDriver_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2' };

type RecCreditScoreDriver_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2' };

type RecCreditScoreDriver_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2' };

type RecCreditScoreDriver_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2' };

type RecCreditScoreDriver_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2' };

type RecCreditScoreDriver_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2' };

type RecCreditScoreDriver_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2' };

type RecCreditScoreDriver_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2' };

type RecCreditScoreDriver_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2' };

type RecCreditScoreDriver_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2' };

type RecCreditScoreDriver_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2' };

type RecCreditScoreDriver_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2' };

type RecCreditScoreDriver_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2' };

type RecCreditScoreDriver_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2' };

type RecCreditScoreDriver_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2' };

type RecCreditScoreDriver_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2' };

type RecCreditScoreDriver_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2' };

type RecCreditScoreDriver_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2' };

type RecCreditScoreDriver_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2' };

type RecCreditScoreDriver_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2' };

type RecCreditScoreDriver_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2' };

type RecCreditScoreDriver_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2' };

type RecCreditScoreDriver_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2' };

type RecCreditScoreDriver_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2' };

type RecCreditScoreDriver_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2' };

type RecCreditScoreDriver_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2' };

type RecCreditScoreDriver_BankingProductV2_Fragment = { __typename?: 'BankingProductV2' };

type RecCreditScoreDriver_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2' };

type RecCreditScoreDriver_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2' };

type RecCreditScoreDriver_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2' };

type RecCreditScoreDriver_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2' };

type RecCreditScoreDriver_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2' };

type RecCreditScoreDriver_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2' };

type RecCreditScoreDriver_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2' };

type RecCreditScoreDriver_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2' };

type RecCreditScoreDriver_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2' };

type RecCreditScoreDriver_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2' };

type RecCreditScoreDriver_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2' };

type RecCreditScoreDriver_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2' };

type RecCreditScoreDriver_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2' };

type RecCreditScoreDriver_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2' };

type RecCreditScoreDriver_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2' };

type RecCreditScoreDriver_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2' };

type RecCreditScoreDriver_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2' };

type RecCreditScoreDriver_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2' };

type RecCreditScoreDriver_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution' };

type RecCreditScoreDriver_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct' };

export type RecCreditScoreDriverFragment = RecCreditScoreDriver_InsuranceOfferV2_Fragment | RecCreditScoreDriver_CreditCardsOfferV2_Fragment | RecCreditScoreDriver_InsuranceProductV2_Fragment | RecCreditScoreDriver_InsuranceInstitutionV2_Fragment | RecCreditScoreDriver_CaBankingInstitutionV2_Fragment | RecCreditScoreDriver_CaBankingProductV2_Fragment | RecCreditScoreDriver_CaBankingOfferV2_Fragment | RecCreditScoreDriver_CaCreditCardsInstitutionV2_Fragment | RecCreditScoreDriver_CaCreditCardsProductV2_Fragment | RecCreditScoreDriver_CaCreditCardsOfferV2_Fragment | RecCreditScoreDriver_InvestingOfferV2_Fragment | RecCreditScoreDriver_InvestingProductV2_Fragment | RecCreditScoreDriver_InvestingInstitutionV2_Fragment | RecCreditScoreDriver_NerdwalletPlusInstitutionV2_Fragment | RecCreditScoreDriver_NerdwalletPlusProductV2_Fragment | RecCreditScoreDriver_NerdwalletPlusOfferV2_Fragment | RecCreditScoreDriver_AutoLoansOfferV2_Fragment | RecCreditScoreDriver_AutoServicesInstitutionV2_Fragment | RecCreditScoreDriver_AutoServicesOfferV2_Fragment | RecCreditScoreDriver_AutoServicesProductV2_Fragment | RecCreditScoreDriver_BankingOfferV2_Fragment | RecCreditScoreDriver_EducationLoansOfferV2_Fragment | RecCreditScoreDriver_MortgagesOfferV2_Fragment | RecCreditScoreDriver_SoftwareOfferV2_Fragment | RecCreditScoreDriver_EstatePlanningOfferV2_Fragment | RecCreditScoreDriver_ExpansionOfferV2_Fragment | RecCreditScoreDriver_AutoLoansInstitutionV2_Fragment | RecCreditScoreDriver_AutoLoansProductV2_Fragment | RecCreditScoreDriver_BankingInstitutionV2_Fragment | RecCreditScoreDriver_BankingProductV2_Fragment | RecCreditScoreDriver_CreditCardsInstitutionV2_Fragment | RecCreditScoreDriver_CreditCardsProductV2_Fragment | RecCreditScoreDriver_EducationLoansInstitutionV2_Fragment | RecCreditScoreDriver_EducationLoansProductV2_Fragment | RecCreditScoreDriver_EstatePlanningInstitutionV2_Fragment | RecCreditScoreDriver_EstatePlanningProductV2_Fragment | RecCreditScoreDriver_ExpansionInstitutionV2_Fragment | RecCreditScoreDriver_ExpansionProductV2_Fragment | RecCreditScoreDriver_MortgagesInstitutionV2_Fragment | RecCreditScoreDriver_MortgagesProductV2_Fragment | RecCreditScoreDriver_PersonalLoansInstitutionV2_Fragment | RecCreditScoreDriver_PersonalLoansOfferV2_Fragment | RecCreditScoreDriver_PersonalLoansProductV2_Fragment | RecCreditScoreDriver_SmallMediumBusinessLoansInstitutionV2_Fragment | RecCreditScoreDriver_SmallMediumBusinessLoansOfferV2_Fragment | RecCreditScoreDriver_SmallMediumBusinessLoansProductV2_Fragment | RecCreditScoreDriver_SoftwareInstitutionV2_Fragment | RecCreditScoreDriver_SoftwareProductV2_Fragment | RecCreditScoreDriver_ThirdPartyEmbedsInstitution_Fragment | RecCreditScoreDriver_ThirdPartyEmbedsProduct_Fragment;

type GetResizableImagePath_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2' };

type GetResizableImagePath_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2' };

type GetResizableImagePath_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2' };

type GetResizableImagePath_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2' };

type GetResizableImagePath_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2' };

type GetResizableImagePath_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2' };

type GetResizableImagePath_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2' };

type GetResizableImagePath_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2' };

type GetResizableImagePath_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2' };

type GetResizableImagePath_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2' };

type GetResizableImagePath_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2' };

type GetResizableImagePath_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2' };

type GetResizableImagePath_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2' };

type GetResizableImagePath_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2' };

type GetResizableImagePath_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2' };

type GetResizableImagePath_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2' };

type GetResizableImagePath_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2' };

type GetResizableImagePath_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_BankingProductV2_Fragment = { __typename?: 'BankingProductV2' };

type GetResizableImagePath_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2' };

type GetResizableImagePath_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2' };

type GetResizableImagePath_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2' };

type GetResizableImagePath_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2' };

type GetResizableImagePath_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2' };

type GetResizableImagePath_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2' };

type GetResizableImagePath_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2' };

type GetResizableImagePath_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2' };

type GetResizableImagePath_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2' };

type GetResizableImagePath_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2' };

type GetResizableImagePath_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2' };

type GetResizableImagePath_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2' };

type GetResizableImagePath_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2' };

type GetResizableImagePath_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', useLargeImageFootprint: boolean, image?: { __typename?: 'EntityPlacementImage', height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null };

type GetResizableImagePath_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2' };

type GetResizableImagePath_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2' };

type GetResizableImagePath_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2' };

type GetResizableImagePath_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution' };

type GetResizableImagePath_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct' };

export type GetResizableImagePathFragment = GetResizableImagePath_InsuranceOfferV2_Fragment | GetResizableImagePath_CreditCardsOfferV2_Fragment | GetResizableImagePath_InsuranceProductV2_Fragment | GetResizableImagePath_InsuranceInstitutionV2_Fragment | GetResizableImagePath_CaBankingInstitutionV2_Fragment | GetResizableImagePath_CaBankingProductV2_Fragment | GetResizableImagePath_CaBankingOfferV2_Fragment | GetResizableImagePath_CaCreditCardsInstitutionV2_Fragment | GetResizableImagePath_CaCreditCardsProductV2_Fragment | GetResizableImagePath_CaCreditCardsOfferV2_Fragment | GetResizableImagePath_InvestingOfferV2_Fragment | GetResizableImagePath_InvestingProductV2_Fragment | GetResizableImagePath_InvestingInstitutionV2_Fragment | GetResizableImagePath_NerdwalletPlusInstitutionV2_Fragment | GetResizableImagePath_NerdwalletPlusProductV2_Fragment | GetResizableImagePath_NerdwalletPlusOfferV2_Fragment | GetResizableImagePath_AutoLoansOfferV2_Fragment | GetResizableImagePath_AutoServicesInstitutionV2_Fragment | GetResizableImagePath_AutoServicesOfferV2_Fragment | GetResizableImagePath_AutoServicesProductV2_Fragment | GetResizableImagePath_BankingOfferV2_Fragment | GetResizableImagePath_EducationLoansOfferV2_Fragment | GetResizableImagePath_MortgagesOfferV2_Fragment | GetResizableImagePath_SoftwareOfferV2_Fragment | GetResizableImagePath_EstatePlanningOfferV2_Fragment | GetResizableImagePath_ExpansionOfferV2_Fragment | GetResizableImagePath_AutoLoansInstitutionV2_Fragment | GetResizableImagePath_AutoLoansProductV2_Fragment | GetResizableImagePath_BankingInstitutionV2_Fragment | GetResizableImagePath_BankingProductV2_Fragment | GetResizableImagePath_CreditCardsInstitutionV2_Fragment | GetResizableImagePath_CreditCardsProductV2_Fragment | GetResizableImagePath_EducationLoansInstitutionV2_Fragment | GetResizableImagePath_EducationLoansProductV2_Fragment | GetResizableImagePath_EstatePlanningInstitutionV2_Fragment | GetResizableImagePath_EstatePlanningProductV2_Fragment | GetResizableImagePath_ExpansionInstitutionV2_Fragment | GetResizableImagePath_ExpansionProductV2_Fragment | GetResizableImagePath_MortgagesInstitutionV2_Fragment | GetResizableImagePath_MortgagesProductV2_Fragment | GetResizableImagePath_PersonalLoansInstitutionV2_Fragment | GetResizableImagePath_PersonalLoansOfferV2_Fragment | GetResizableImagePath_PersonalLoansProductV2_Fragment | GetResizableImagePath_SmallMediumBusinessLoansInstitutionV2_Fragment | GetResizableImagePath_SmallMediumBusinessLoansOfferV2_Fragment | GetResizableImagePath_SmallMediumBusinessLoansProductV2_Fragment | GetResizableImagePath_SoftwareInstitutionV2_Fragment | GetResizableImagePath_SoftwareProductV2_Fragment | GetResizableImagePath_ThirdPartyEmbedsInstitution_Fragment | GetResizableImagePath_ThirdPartyEmbedsProduct_Fragment;

type IsImagePortraitOrientation_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

type IsImagePortraitOrientation_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', image?: { __typename?: 'EntityPlacementImage', height?: number | null, width?: number | null } | null };

export type IsImagePortraitOrientationFragment = IsImagePortraitOrientation_InsuranceOfferV2_Fragment | IsImagePortraitOrientation_CreditCardsOfferV2_Fragment | IsImagePortraitOrientation_InvestingOfferV2_Fragment | IsImagePortraitOrientation_AutoLoansOfferV2_Fragment | IsImagePortraitOrientation_AutoServicesOfferV2_Fragment | IsImagePortraitOrientation_BankingOfferV2_Fragment | IsImagePortraitOrientation_EducationLoansOfferV2_Fragment | IsImagePortraitOrientation_MortgagesOfferV2_Fragment | IsImagePortraitOrientation_SoftwareOfferV2_Fragment | IsImagePortraitOrientation_EstatePlanningOfferV2_Fragment | IsImagePortraitOrientation_ExpansionOfferV2_Fragment | IsImagePortraitOrientation_BankingInstitutionV2_Fragment | IsImagePortraitOrientation_PersonalLoansOfferV2_Fragment | IsImagePortraitOrientation_SmallMediumBusinessLoansOfferV2_Fragment;

type BaseUniversalProductCard_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', displayName?: string | null, monetizable: string, termsAndFeesLink?: any | null, maxFico?: number | null, minFico?: number | null, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, phoneNumber?: string | null, versionId: number, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, recommendedCreditScoreRangeDetails?: { __typename?: 'CreditCardsRecommendedCreditScoreRangeDetails', creditScoreRange?: string | null, description?: string | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', id: string, productType: string, reviewLink?: any | null, versionId: number };

type BaseUniversalProductCard_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2', id: string, productType: string, starRating?: number | null, starRatingTooltip?: string | null, versionId: number };

type BaseUniversalProductCard_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', id: string, productType: string, reviewLink?: any | null, versionId: number };

type BaseUniversalProductCard_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2', id: string, productType: string, starRating?: number | null, starRatingTooltip?: string | null, versionId: number };

type BaseUniversalProductCard_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, qualificationsBullets?: Array<string> | null, useLargeImageFootprint: boolean, versionId: number, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, useLargeImageFootprint: boolean, versionId: number, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', displayName?: string | null, monetizable: string, federallyInsuredAnnotation?: string | null, subProductTypeLabel?: string | null, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', displayName?: string | null, monetizable: string, disclaimer?: string | null, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, qualificationsBullets?: Array<string> | null, availableTermLengths?: string | null, useLargeImageFootprint: boolean, versionId: number, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', displayName?: string | null, monetizable: string, bestForBullets?: Array<string> | null, nmlsId?: string | null, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_BankingProductV2_Fragment = { __typename?: 'BankingProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2', id: string, productType: string, starRating?: number | null, starRatingTooltip?: string | null, versionId: number };

type BaseUniversalProductCard_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', displayName?: string | null, monetizable: string, disclaimer?: string | null, expandedMarketplaceCategory?: PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum | null, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, qualificationsBullets?: Array<string> | null, availableTermLengths?: string | null, feesBullets?: Array<string> | null, useLargeImageFootprint: boolean, versionId: number, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, qualificationsBullets?: Array<string> | null, useLargeImageFootprint: boolean, versionId: number, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type BaseUniversalProductCard_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution', id: string, productType: string, versionId: number };

type BaseUniversalProductCard_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct', id: string, productType: string, versionId: number };

export type BaseUniversalProductCardFragment = BaseUniversalProductCard_InsuranceOfferV2_Fragment | BaseUniversalProductCard_CreditCardsOfferV2_Fragment | BaseUniversalProductCard_InsuranceProductV2_Fragment | BaseUniversalProductCard_InsuranceInstitutionV2_Fragment | BaseUniversalProductCard_CaBankingInstitutionV2_Fragment | BaseUniversalProductCard_CaBankingProductV2_Fragment | BaseUniversalProductCard_CaBankingOfferV2_Fragment | BaseUniversalProductCard_CaCreditCardsInstitutionV2_Fragment | BaseUniversalProductCard_CaCreditCardsProductV2_Fragment | BaseUniversalProductCard_CaCreditCardsOfferV2_Fragment | BaseUniversalProductCard_InvestingOfferV2_Fragment | BaseUniversalProductCard_InvestingProductV2_Fragment | BaseUniversalProductCard_InvestingInstitutionV2_Fragment | BaseUniversalProductCard_NerdwalletPlusInstitutionV2_Fragment | BaseUniversalProductCard_NerdwalletPlusProductV2_Fragment | BaseUniversalProductCard_NerdwalletPlusOfferV2_Fragment | BaseUniversalProductCard_AutoLoansOfferV2_Fragment | BaseUniversalProductCard_AutoServicesInstitutionV2_Fragment | BaseUniversalProductCard_AutoServicesOfferV2_Fragment | BaseUniversalProductCard_AutoServicesProductV2_Fragment | BaseUniversalProductCard_BankingOfferV2_Fragment | BaseUniversalProductCard_EducationLoansOfferV2_Fragment | BaseUniversalProductCard_MortgagesOfferV2_Fragment | BaseUniversalProductCard_SoftwareOfferV2_Fragment | BaseUniversalProductCard_EstatePlanningOfferV2_Fragment | BaseUniversalProductCard_ExpansionOfferV2_Fragment | BaseUniversalProductCard_AutoLoansInstitutionV2_Fragment | BaseUniversalProductCard_AutoLoansProductV2_Fragment | BaseUniversalProductCard_BankingInstitutionV2_Fragment | BaseUniversalProductCard_BankingProductV2_Fragment | BaseUniversalProductCard_CreditCardsInstitutionV2_Fragment | BaseUniversalProductCard_CreditCardsProductV2_Fragment | BaseUniversalProductCard_EducationLoansInstitutionV2_Fragment | BaseUniversalProductCard_EducationLoansProductV2_Fragment | BaseUniversalProductCard_EstatePlanningInstitutionV2_Fragment | BaseUniversalProductCard_EstatePlanningProductV2_Fragment | BaseUniversalProductCard_ExpansionInstitutionV2_Fragment | BaseUniversalProductCard_ExpansionProductV2_Fragment | BaseUniversalProductCard_MortgagesInstitutionV2_Fragment | BaseUniversalProductCard_MortgagesProductV2_Fragment | BaseUniversalProductCard_PersonalLoansInstitutionV2_Fragment | BaseUniversalProductCard_PersonalLoansOfferV2_Fragment | BaseUniversalProductCard_PersonalLoansProductV2_Fragment | BaseUniversalProductCard_SmallMediumBusinessLoansInstitutionV2_Fragment | BaseUniversalProductCard_SmallMediumBusinessLoansOfferV2_Fragment | BaseUniversalProductCard_SmallMediumBusinessLoansProductV2_Fragment | BaseUniversalProductCard_SoftwareInstitutionV2_Fragment | BaseUniversalProductCard_SoftwareProductV2_Fragment | BaseUniversalProductCard_ThirdPartyEmbedsInstitution_Fragment | BaseUniversalProductCard_ThirdPartyEmbedsProduct_Fragment;

export type UniversalProductCardPropsCtaOverrideFragment = { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum };

export type UniversalProductCardPropsDriversOverridesFragment = { __typename?: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean };

type UniversalProductCard_InsuranceOfferV2_Fragment = { __typename?: 'InsuranceOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_CreditCardsOfferV2_Fragment = { __typename?: 'CreditCardsOfferV2', displayName?: string | null, monetizable: string, termsAndFeesLink?: any | null, maxFico?: number | null, minFico?: number | null, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, phoneNumber?: string | null, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, recommendedCreditScoreRangeDetails?: { __typename?: 'CreditCardsRecommendedCreditScoreRangeDetails', creditScoreRange?: string | null, description?: string | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_InsuranceProductV2_Fragment = { __typename?: 'InsuranceProductV2', id: string, productType: string, reviewLink?: any | null, versionId: number };

type UniversalProductCard_InsuranceInstitutionV2_Fragment = { __typename?: 'InsuranceInstitutionV2', id: string, productType: string, starRating?: number | null, starRatingTooltip?: string | null, versionId: number };

type UniversalProductCard_CaBankingInstitutionV2_Fragment = { __typename?: 'CaBankingInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_CaBankingProductV2_Fragment = { __typename?: 'CaBankingProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_CaBankingOfferV2_Fragment = { __typename?: 'CaBankingOfferV2', id: string, productType: string, versionId: number };

type UniversalProductCard_CaCreditCardsInstitutionV2_Fragment = { __typename?: 'CaCreditCardsInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_CaCreditCardsProductV2_Fragment = { __typename?: 'CaCreditCardsProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_CaCreditCardsOfferV2_Fragment = { __typename?: 'CaCreditCardsOfferV2', id: string, productType: string, versionId: number };

type UniversalProductCard_InvestingOfferV2_Fragment = { __typename?: 'InvestingOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_InvestingProductV2_Fragment = { __typename?: 'InvestingProductV2', id: string, productType: string, reviewLink?: any | null, versionId: number };

type UniversalProductCard_InvestingInstitutionV2_Fragment = { __typename?: 'InvestingInstitutionV2', id: string, productType: string, starRating?: number | null, starRatingTooltip?: string | null, versionId: number };

type UniversalProductCard_NerdwalletPlusInstitutionV2_Fragment = { __typename?: 'NerdwalletPlusInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_NerdwalletPlusProductV2_Fragment = { __typename?: 'NerdwalletPlusProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_NerdwalletPlusOfferV2_Fragment = { __typename?: 'NerdwalletPlusOfferV2', id: string, productType: string, versionId: number };

type UniversalProductCard_AutoLoansOfferV2_Fragment = { __typename?: 'AutoLoansOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, qualificationsBullets?: Array<string> | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_AutoServicesInstitutionV2_Fragment = { __typename?: 'AutoServicesInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_AutoServicesOfferV2_Fragment = { __typename?: 'AutoServicesOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_AutoServicesProductV2_Fragment = { __typename?: 'AutoServicesProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_BankingOfferV2_Fragment = { __typename?: 'BankingOfferV2', displayName?: string | null, monetizable: string, federallyInsuredAnnotation?: string | null, subProductTypeLabel?: string | null, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_EducationLoansOfferV2_Fragment = { __typename?: 'EducationLoansOfferV2', displayName?: string | null, monetizable: string, disclaimer?: string | null, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, qualificationsBullets?: Array<string> | null, availableTermLengths?: string | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_MortgagesOfferV2_Fragment = { __typename?: 'MortgagesOfferV2', displayName?: string | null, monetizable: string, bestForBullets?: Array<string> | null, nmlsId?: string | null, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_SoftwareOfferV2_Fragment = { __typename?: 'SoftwareOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_EstatePlanningOfferV2_Fragment = { __typename?: 'EstatePlanningOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_ExpansionOfferV2_Fragment = { __typename?: 'ExpansionOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_AutoLoansInstitutionV2_Fragment = { __typename?: 'AutoLoansInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_AutoLoansProductV2_Fragment = { __typename?: 'AutoLoansProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_BankingInstitutionV2_Fragment = { __typename?: 'BankingInstitutionV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_BankingProductV2_Fragment = { __typename?: 'BankingProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_CreditCardsInstitutionV2_Fragment = { __typename?: 'CreditCardsInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_CreditCardsProductV2_Fragment = { __typename?: 'CreditCardsProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_EducationLoansInstitutionV2_Fragment = { __typename?: 'EducationLoansInstitutionV2', id: string, productType: string, starRating?: number | null, starRatingTooltip?: string | null, versionId: number };

type UniversalProductCard_EducationLoansProductV2_Fragment = { __typename?: 'EducationLoansProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_EstatePlanningInstitutionV2_Fragment = { __typename?: 'EstatePlanningInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_EstatePlanningProductV2_Fragment = { __typename?: 'EstatePlanningProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_ExpansionInstitutionV2_Fragment = { __typename?: 'ExpansionInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_ExpansionProductV2_Fragment = { __typename?: 'ExpansionProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_MortgagesInstitutionV2_Fragment = { __typename?: 'MortgagesInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_MortgagesProductV2_Fragment = { __typename?: 'MortgagesProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_PersonalLoansInstitutionV2_Fragment = { __typename?: 'PersonalLoansInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_PersonalLoansOfferV2_Fragment = { __typename?: 'PersonalLoansOfferV2', displayName?: string | null, monetizable: string, disclaimer?: string | null, expandedMarketplaceCategory?: PersonalLoansOfferV2ExpandedMarketplaceCategoryEnum | null, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, qualificationsBullets?: Array<string> | null, availableTermLengths?: string | null, feesBullets?: Array<string> | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_PersonalLoansProductV2_Fragment = { __typename?: 'PersonalLoansProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_SmallMediumBusinessLoansInstitutionV2_Fragment = { __typename?: 'SmallMediumBusinessLoansInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_SmallMediumBusinessLoansOfferV2_Fragment = { __typename?: 'SmallMediumBusinessLoansOfferV2', displayName?: string | null, monetizable: string, id: string, productType: string, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, qualificationsBullets?: Array<string> | null, useLargeImageFootprint: boolean, versionId: number, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, bestOfAwards?: Array<{ __typename?: 'BestOfAward', year: number, category: string }> | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyIssuer: string, legacySlug?: string | null, legacyVertical?: string | null, productId?: string | null, institutionId: string, offerId?: string | null } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, height?: number | null, resizableImagePath?: string | null, sourceLarge?: any | null, sourceMedium?: any | null, width?: number | null } | null, placementDrivers: Array<{ __typename: 'EntityPlacementDriver', description?: string | null, label: string, labelTooltip?: string | null, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> };

type UniversalProductCard_SmallMediumBusinessLoansProductV2_Fragment = { __typename?: 'SmallMediumBusinessLoansProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_SoftwareInstitutionV2_Fragment = { __typename?: 'SoftwareInstitutionV2', id: string, productType: string, versionId: number };

type UniversalProductCard_SoftwareProductV2_Fragment = { __typename?: 'SoftwareProductV2', id: string, productType: string, versionId: number };

type UniversalProductCard_ThirdPartyEmbedsInstitution_Fragment = { __typename?: 'ThirdPartyEmbedsInstitution', id: string, productType: string, versionId: number };

type UniversalProductCard_ThirdPartyEmbedsProduct_Fragment = { __typename?: 'ThirdPartyEmbedsProduct', id: string, productType: string, versionId: number };

export type UniversalProductCardFragment = UniversalProductCard_InsuranceOfferV2_Fragment | UniversalProductCard_CreditCardsOfferV2_Fragment | UniversalProductCard_InsuranceProductV2_Fragment | UniversalProductCard_InsuranceInstitutionV2_Fragment | UniversalProductCard_CaBankingInstitutionV2_Fragment | UniversalProductCard_CaBankingProductV2_Fragment | UniversalProductCard_CaBankingOfferV2_Fragment | UniversalProductCard_CaCreditCardsInstitutionV2_Fragment | UniversalProductCard_CaCreditCardsProductV2_Fragment | UniversalProductCard_CaCreditCardsOfferV2_Fragment | UniversalProductCard_InvestingOfferV2_Fragment | UniversalProductCard_InvestingProductV2_Fragment | UniversalProductCard_InvestingInstitutionV2_Fragment | UniversalProductCard_NerdwalletPlusInstitutionV2_Fragment | UniversalProductCard_NerdwalletPlusProductV2_Fragment | UniversalProductCard_NerdwalletPlusOfferV2_Fragment | UniversalProductCard_AutoLoansOfferV2_Fragment | UniversalProductCard_AutoServicesInstitutionV2_Fragment | UniversalProductCard_AutoServicesOfferV2_Fragment | UniversalProductCard_AutoServicesProductV2_Fragment | UniversalProductCard_BankingOfferV2_Fragment | UniversalProductCard_EducationLoansOfferV2_Fragment | UniversalProductCard_MortgagesOfferV2_Fragment | UniversalProductCard_SoftwareOfferV2_Fragment | UniversalProductCard_EstatePlanningOfferV2_Fragment | UniversalProductCard_ExpansionOfferV2_Fragment | UniversalProductCard_AutoLoansInstitutionV2_Fragment | UniversalProductCard_AutoLoansProductV2_Fragment | UniversalProductCard_BankingInstitutionV2_Fragment | UniversalProductCard_BankingProductV2_Fragment | UniversalProductCard_CreditCardsInstitutionV2_Fragment | UniversalProductCard_CreditCardsProductV2_Fragment | UniversalProductCard_EducationLoansInstitutionV2_Fragment | UniversalProductCard_EducationLoansProductV2_Fragment | UniversalProductCard_EstatePlanningInstitutionV2_Fragment | UniversalProductCard_EstatePlanningProductV2_Fragment | UniversalProductCard_ExpansionInstitutionV2_Fragment | UniversalProductCard_ExpansionProductV2_Fragment | UniversalProductCard_MortgagesInstitutionV2_Fragment | UniversalProductCard_MortgagesProductV2_Fragment | UniversalProductCard_PersonalLoansInstitutionV2_Fragment | UniversalProductCard_PersonalLoansOfferV2_Fragment | UniversalProductCard_PersonalLoansProductV2_Fragment | UniversalProductCard_SmallMediumBusinessLoansInstitutionV2_Fragment | UniversalProductCard_SmallMediumBusinessLoansOfferV2_Fragment | UniversalProductCard_SmallMediumBusinessLoansProductV2_Fragment | UniversalProductCard_SoftwareInstitutionV2_Fragment | UniversalProductCard_SoftwareProductV2_Fragment | UniversalProductCard_ThirdPartyEmbedsInstitution_Fragment | UniversalProductCard_ThirdPartyEmbedsProduct_Fragment;

export type FinancialPortalDetailsQueryVariables = Exact<{
  financialAccountId: Scalars['ID']['input'];
}>;


export type FinancialPortalDetailsQuery = { __typename?: 'Query', netWorthAccountByFinancialAccountId?: { __typename?: 'NetWorthAccountResponse', account: { __typename?: 'NetWorthAccount', id: string, financialAccountId: string, isHiddenFromNetWorth: boolean } } | null, financialAccountById?: { __typename?: 'FinancialAccount', balance?: any | null, currency?: any | null, extra?: any | null, id: string, isHidden?: boolean | null, lastSyncedAt?: any | null, mask?: string | null, name?: string | null, primarySource?: FinancialDataSource | null, status?: FinancialAccountStatus | null, subtype?: FinancialAccountSubtype | null, subtypeDetails?: string | null, type?: FinancialAccountType | null, updatedAt: any, financialPortal?: { __typename?: 'FinancialPortal', alertMessage?: FinancialPortalAlertMessage | null, authState?: FinancialPortalAuthState | null, errorMessage?: FinancialPortalErrorMessage | null, isActiveSync?: boolean | null, id: string, isRefreshing?: boolean | null, primaryClientAction?: FinancialPortalPrimaryClientAction | null, primarySource?: FinancialDataSource | null, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', externalId?: string | null, id: string, loginUrl?: string | null, logoUrl?: string | null, name: string } | null } | null } | null };

export type DeleteFinancialAccountMutationVariables = Exact<{
  financialAccountId: Scalars['ID']['input'];
}>;


export type DeleteFinancialAccountMutation = { __typename?: 'Mutation', deleteUserFinancialAccount?: { __typename?: 'DeleteUserFinancialAccountResponse', success: boolean } | null };

export type GetNetWorthRealAssetQueryVariables = Exact<{
  netWorthRealAssetId: Scalars['ID']['input'];
}>;


export type GetNetWorthRealAssetQuery = { __typename?: 'Query', netWorthRealAsset?: { __typename?: 'NetWorthRealAssetResponse', asset: { __typename?: 'NetWorthHomeIntegrated', id: string, type: NetWorthRealAssetTypeEnum, amount?: number | null, isSelfReported: boolean, isHiddenFromNetWorth?: boolean | null, lastReportedOrSyncedAt?: any | null, address: { __typename?: 'NetWorthHomeIntegratedAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null }, externalInfo?: { __typename?: 'NetWorthHomeIntegratedExternalInfo', source: NetWorthHomeValueResultSourceEnum, value?: number | null } | null } | { __typename?: 'NetWorthRealAssetSelfReported', nickname: string, id: string, type: NetWorthRealAssetTypeEnum, amount?: number | null, isSelfReported: boolean, isHiddenFromNetWorth?: boolean | null, lastReportedOrSyncedAt?: any | null } } | null };

export type DeleteNetWorthRealAssetMutationVariables = Exact<{
  netWorthRealAssetId: Scalars['ID']['input'];
}>;


export type DeleteNetWorthRealAssetMutation = { __typename?: 'Mutation', deleteNetWorthRealAsset?: { __typename?: 'DeleteNetWorthRealAssetResponse', success: boolean } | null };

export type EditNetWorthRealAssetSelfReportedMutationVariables = Exact<{
  netWorthRealAssetId: Scalars['ID']['input'];
  amount?: InputMaybe<Scalars['Float']['input']>;
  nickname?: InputMaybe<Scalars['String']['input']>;
}>;


export type EditNetWorthRealAssetSelfReportedMutation = { __typename?: 'Mutation', editNetWorthRealAssetSelfReported?: { __typename?: 'EditNetWorthRealAssetSelfReportedResponse', asset: { __typename?: 'NetWorthRealAssetSelfReported', id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null, amount?: number | null, lastReportedOrSyncedAt?: any | null, nickname: string, isSelfReported: boolean } } | null };

export type UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationVariables = Exact<{
  netWorthRealAssetId: Scalars['ID']['input'];
  isHiddenFromNetWorth: Scalars['Boolean']['input'];
}>;


export type UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation = { __typename?: 'Mutation', updateNetWorthRealAssetIsHiddenFromNetWorth?: { __typename?: 'UpdateNetWorthRealAssetResponse', asset: { __typename?: 'NetWorthHomeIntegrated', id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null, amount?: number | null, lastReportedOrSyncedAt?: any | null, isSelfReported: boolean, address: { __typename?: 'NetWorthHomeIntegratedAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null }, externalInfo?: { __typename?: 'NetWorthHomeIntegratedExternalInfo', source: NetWorthHomeValueResultSourceEnum, value?: number | null } | null } | { __typename?: 'NetWorthRealAssetSelfReported', nickname: string, id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null, amount?: number | null, lastReportedOrSyncedAt?: any | null, isSelfReported: boolean } } | null };

export type GetFinancialTransactionsCashInCashOutSummaryQueryVariables = Exact<{
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
  datePeriod?: InputMaybe<FinancialTransactionsSpendingComparisonDatePeriodEnum>;
  numPreviousDatePeriodsToInclude?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetFinancialTransactionsCashInCashOutSummaryQuery = { __typename?: 'Query', financialTransactionsCashInCashOutSummaryForDatePeriod?: { __typename?: 'FinancialTransactionsCashInCashOutSummaryForDatePeriodsResponse', averageNetPreviousDatePeriods: number, summaries?: Array<{ __typename?: 'FinancialTransactionsCashInCashOutMonthItem', date: any, cashIn: number, cashOut: number, net: number } | null> | null } | null };

export type GetRecentTransactionsQueryVariables = Exact<{
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
}>;


export type GetRecentTransactionsQuery = { __typename?: 'Query', financialTransactions?: { __typename?: 'GetTransactionsResponse', transactions: Array<{ __typename?: 'FinancialTransaction', amount: number, categoryId?: number | null, currency?: any | null, date: any, description?: string | null, id: string, isHidden?: boolean | null, isPending?: boolean | null, merchantName?: string | null, tags?: Array<FinancialTransactionTag> | null, type?: FinancialTransactionType | null }> } | null };

export type FinancialPortalAccountsStateQueryVariables = Exact<{ [key: string]: never; }>;


export type FinancialPortalAccountsStateQuery = { __typename?: 'Query', linkedFinancialPortals?: { __typename?: 'GetPortalsResponse', portals?: Array<{ __typename?: 'FinancialPortal', id: string, isActiveSync?: boolean | null }> | null } | null };

export type AccountTypeItemFragmentFragment = { __typename?: 'CreditFactorTradeline', accountTypeSymbol?: string | null, dateOpenedAt?: any | null, openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null, tradelineDisplayName?: string | null, creditorName?: string | null, compositeKey?: string | null };

export type AccountTypeRightHandFragmentFragment = { __typename?: 'CreditFactorTradeline', dateOpenedAt?: any | null, openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null };

export type AccountTypeSubtitleFragmentFragment = { __typename?: 'CreditFactorTradeline', accountTypeSymbol?: string | null };

export type CreditScoreFactorsAgeAndMixQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditScoreFactorsAgeAndMixQuery = { __typename?: 'Query', creditFactors?: { __typename?: 'CreditFactors', ageAndMixOfAccounts?: { __typename?: 'CreditFactor', tradelineSections?: Array<{ __typename?: 'CreditFactorTradelineSection', isPriority?: boolean | null, title?: string | null, label?: string | null, tradelines?: Array<{ __typename?: 'CreditFactorTradeline', accountTypeSymbol?: string | null, dateOpenedAt?: any | null, openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null, tradelineDisplayName?: string | null, creditorName?: string | null, compositeKey?: string | null }> | null }> | null } | null } | null };

export type CreditFactorTradelineSectionFieldsFragment = { __typename?: 'CreditFactorTradelineSection', tradelines?: Array<{ __typename?: 'CreditFactorTradeline', accountTypeSymbol?: string | null, compositeKey?: string | null, openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null, creditorName?: string | null, currentBalance?: number | null, tradelineDisplayName?: string | null }> | null };

export type CreditFactorTipsQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditFactorTipsQuery = { __typename?: 'Query', creditFactors?: { __typename?: 'CreditFactors', balances?: { __typename?: 'CreditFactor', tradelineSections?: Array<{ __typename?: 'CreditFactorTradelineSection', tradelines?: Array<{ __typename?: 'CreditFactorTradeline', accountTypeSymbol?: string | null, compositeKey?: string | null, openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null, creditorName?: string | null, currentBalance?: number | null, tradelineDisplayName?: string | null }> | null }> | null } | null } | null };

export type CommonQuestionFragmentFragment = { __typename?: 'CreditFactorCommonQuestion', answerParagraphs?: Array<string> | null, question?: string | null, learnMoreLink?: { __typename?: 'AppAction', target?: string | null, text: string } | null };

export type CommonQuestionsFragmentFragment = { __typename?: 'CreditFactorCommonQuestion', key?: string | null, answerParagraphs?: Array<string> | null, question?: string | null, learnMoreLink?: { __typename?: 'AppAction', target?: string | null, text: string } | null };

export type CreditFactorCoreMetricFragmentFragment = { __typename?: 'CreditFactor', coreMetric?: { __typename?: 'CreditFactorCoreMetric', commentary?: string | null, description?: string | null, displayName?: string | null, label?: string | null } | null };

export type GetCreditScoreDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditScoreDataQuery = { __typename?: 'Query', tuCreditReportIdentityProfile?: { __typename?: 'TuCreditReportIdentityProfile', reportPulledAt?: any | null } | null };

export type CreditFactorTipFragmentFragment = { __typename?: 'CreditFactorTip', key: string, title: string };

export type MoreInfoFragmentFragment = { __typename?: 'AppAction', text: string, target?: string | null };

export type UpdateCtaDismissedFlagsMutationVariables = Exact<{
  dismissAccountAggCta: AccountAggCtaDismissedInput;
}>;


export type UpdateCtaDismissedFlagsMutation = { __typename?: 'Mutation', updateDismissAccountAggCta?: { __typename?: 'AccountAggCtaDismissedResponse', creditScoreBigBanner?: boolean | null, creditScoreSmallBanner?: boolean | null, utilizationBigBanner?: boolean | null, utilizationFaq?: boolean | null, utilizationSmallBanner?: boolean | null, ageAndMixOfAccountsSmallBanner?: boolean | null, balancesSmallBanner?: boolean | null, tradelineTopLink?: boolean | null, tradelineSmallBanner?: boolean | null, spendingSmallBanner?: boolean | null, debtSmallBanner?: boolean | null } | null };

export type GetAccountAggregationCtaDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountAggregationCtaDataQuery = { __typename?: 'Query', netWorthAccounts?: { __typename?: 'NetWorthAccountsResponse', accounts: Array<{ __typename?: 'NetWorthAccount', id: string }> } | null, accountAggCtaDismissedFlags?: { __typename?: 'AccountAggCtaDismissedResponse', creditScoreBigBanner?: boolean | null, creditScoreSmallBanner?: boolean | null, utilizationBigBanner?: boolean | null, utilizationFaq?: boolean | null, utilizationSmallBanner?: boolean | null, ageAndMixOfAccountsSmallBanner?: boolean | null, balancesSmallBanner?: boolean | null, tradelineTopLink?: boolean | null, tradelineSmallBanner?: boolean | null, spendingSmallBanner?: boolean | null, accountsSmallBanner?: boolean | null, debtSmallBanner?: boolean | null } | null };

export type CollapsibleTradelineSectionsFragmentFragment = { __typename?: 'CreditFactorTradelineSection', isPriority?: boolean | null, title?: string | null, subtitle?: string | null, label?: string | null };

export type HighlightWrapperTradelineFragmentFragment = { __typename?: 'CreditFactorTradelineSection', isPriority?: boolean | null, label?: string | null, title?: string | null };

export type HighlightWrapperInquiryFragmentFragment = { __typename?: 'CreditFactorInquirySection', isPriority?: boolean | null, label?: string | null, title?: string | null };

export type TradelineItemFragmentFragment = { __typename?: 'CreditFactorTradeline', tradelineDisplayName?: string | null, creditorName?: string | null, compositeKey?: string | null, openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null };

export type TradelineSectionFragmentFragment = { __typename?: 'CreditFactorTradelineSection', isPriority?: boolean | null, label?: string | null, title?: string | null };

export type TradelineSectionsFragmentFragment = { __typename?: 'CreditFactorTradelineSection', isPriority?: boolean | null, title?: string | null, label?: string | null };

export type InquiriesSectionFragmentFragment = { __typename?: 'CreditFactorInquiry', compositeKey?: string | null, inquiredAt?: any | null, subscriberName?: string | null };

export type CreditScoreFactorsRecentInquiriesQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditScoreFactorsRecentInquiriesQuery = { __typename?: 'Query', creditFactors?: { __typename?: 'CreditFactors', recentInquiries?: { __typename?: 'CreditFactor', inquirySections?: Array<{ __typename?: 'CreditFactorInquirySection', isPriority?: boolean | null, label?: string | null, title?: string | null, inquiries?: Array<{ __typename?: 'CreditFactorInquiry', compositeKey?: string | null, inquiredAt?: any | null, subscriberName?: string | null }> | null }> | null } | null } | null };

export type CreditScoreFactorsPaymentHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditScoreFactorsPaymentHistoryQuery = { __typename?: 'Query', creditFactors?: { __typename?: 'CreditFactors', paymentHistory?: { __typename?: 'CreditFactor', tradelineSections?: Array<{ __typename?: 'CreditFactorTradelineSection', isPriority?: boolean | null, title?: string | null, subtitle?: string | null, label?: string | null, tradelines?: Array<{ __typename?: 'CreditFactorTradeline', tradelineDisplayName?: string | null, creditorName?: string | null, compositeKey?: string | null, payStatusDisplayName?: string | null, payStatus?: string | null, openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null }> | null }> | null } | null } | null };

export type PaymentTradelineItemFragmentFragment = { __typename?: 'CreditFactorTradeline', tradelineDisplayName?: string | null, creditorName?: string | null, compositeKey?: string | null, payStatusDisplayName?: string | null, payStatus?: string | null, openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null };

export type PaymentIconTradelineFragmentFragment = { __typename?: 'CreditFactorTradeline', payStatusDisplayName?: string | null, payStatus?: string | null };

export type PaymentSubtitleTradelineFragmentFragment = { __typename?: 'CreditFactorTradeline', payStatusDisplayName?: string | null };

export type CreditUtilizationBarFragmentFragment = { __typename?: 'CreditFactorTradeline', currentBalance?: number | null, nwCreditLimitNormalized?: number | null, nwUtilizationPct?: number | null };

export type CreditUtilizationItemFragmentFragment = { __typename?: 'CreditFactorTradeline', currentBalance?: number | null, nwCreditLimitNormalized?: number | null, nwUtilizationPct?: number | null, tradelineDisplayName?: string | null, creditorName?: string | null, compositeKey?: string | null, openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null };

export type CreditUtilizationPercentageFragmentFragment = { __typename?: 'CreditFactorTradeline', nwUtilizationPct?: number | null };

export type CreditScoreFactorsCreditUtilizationQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditScoreFactorsCreditUtilizationQuery = { __typename?: 'Query', creditFactors?: { __typename?: 'CreditFactors', creditUtilization?: { __typename?: 'CreditFactor', tradelineSections?: Array<{ __typename?: 'CreditFactorTradelineSection', isPriority?: boolean | null, title?: string | null, label?: string | null, tradelines?: Array<{ __typename?: 'CreditFactorTradeline', currentBalance?: number | null, nwCreditLimitNormalized?: number | null, nwUtilizationPct?: number | null, tradelineDisplayName?: string | null, creditorName?: string | null, compositeKey?: string | null, openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null }> | null }> | null } | null } | null };

export type CreditFactorItemFragmentFragment = { __typename?: 'CreditFactor', priorityInquirySection?: { __typename?: 'CreditFactorInquirySection', abbreviatedTitle?: string | null, label?: string | null, title?: string | null, trackingMetadata?: { __typename?: 'CreditFactorTrackingMetadata', accountStatusChange?: string | null, highlightStatus?: string | null, inquiryStatusChange?: string | null, paymentDerogatoryType?: string | null, paymentStatusChange?: string | null, utilizationCurrentBucket?: string | null, utilizationDirectionChange?: string | null } | null } | null, priorityTradelineSection?: { __typename?: 'CreditFactorTradelineSection', abbreviatedTitle?: string | null, label?: string | null, title?: string | null, trackingMetadata?: { __typename?: 'CreditFactorTrackingMetadata', accountStatusChange?: string | null, highlightStatus?: string | null, inquiryStatusChange?: string | null, paymentDerogatoryType?: string | null, paymentStatusChange?: string | null, utilizationCurrentBucket?: string | null, utilizationDirectionChange?: string | null } | null } | null, coreMetric?: { __typename?: 'CreditFactorCoreMetric', value?: string | null, secondaryValue?: string | null } | null, delta?: { __typename?: 'CreditFactorDelta', value: number } | null };

export type GetSegmentEventPropsFragmentFragment = { __typename?: 'CreditFactorCoreMetric', value?: string | null, secondaryValue?: string | null };

export type GetTrackingMetadataCoreMetricFragmentFragment = { __typename?: 'CreditFactorCoreMetric', value?: string | null, secondaryValue?: string | null };

export type GetTrackingMetadataTradelineSectionFragmentFragment = { __typename?: 'CreditFactorTradelineSection', trackingMetadata?: { __typename?: 'CreditFactorTrackingMetadata', accountStatusChange?: string | null, highlightStatus?: string | null, inquiryStatusChange?: string | null, paymentDerogatoryType?: string | null, paymentStatusChange?: string | null, utilizationCurrentBucket?: string | null, utilizationDirectionChange?: string | null } | null };

export type GetTrackingMetadataInquirySectionFragmentFragment = { __typename?: 'CreditFactorInquirySection', trackingMetadata?: { __typename?: 'CreditFactorTrackingMetadata', accountStatusChange?: string | null, highlightStatus?: string | null, inquiryStatusChange?: string | null, paymentDerogatoryType?: string | null, paymentStatusChange?: string | null, utilizationCurrentBucket?: string | null, utilizationDirectionChange?: string | null } | null };

export type GetCreditUtilizationEventCoreMetricFragmentFragment = { __typename?: 'CreditFactorCoreMetric', value?: string | null };

export type GetCreditUtilizationEventDeltaFragmentFragment = { __typename?: 'CreditFactorDelta', value: number };

export type HighlightStatusTradelineFragmentFragment = { __typename?: 'CreditFactorTradelineSection', abbreviatedTitle?: string | null, label?: string | null, title?: string | null };

export type HighlightStatusInquiriesFragmentFragment = { __typename?: 'CreditFactorInquirySection', abbreviatedTitle?: string | null, label?: string | null, title?: string | null };

export type CreditHeaderQueryVariables = Exact<{ [key: string]: never; }>;


export type CreditHeaderQuery = { __typename?: 'Query', tuCreditReportIdentityProfile?: { __typename?: 'TuCreditReportIdentityProfile', vantageScore3?: number | null, vantageScore3Bucket?: TuVantageScore3Buckets | null, vantageScore3Delta?: number | null, reportPulledAt?: any | null } | null };

export type CreditScoreHistoryQueryQueryVariables = Exact<{
  input: CreditScoreHistoryInput;
}>;


export type CreditScoreHistoryQueryQuery = { __typename?: 'Query', creditScoreHistory?: { __typename?: 'CreditScoreHistoryResponse', data?: Array<{ __typename?: 'CreditScoreHistoryDatum', vantageScore3?: number | null, date?: any | null }> | null } | null };

export type GetCreditScoreInsightsQueryVariables = Exact<{
  eligibleModule: UserInsightEligibleModulesEnum;
}>;


export type GetCreditScoreInsightsQuery = { __typename?: 'Query', userInsights: { __typename?: 'UserInsightsResponse', userInsights: Array<{ __typename?: 'FeedCardInsight', id: string, description?: string | null, sentiment?: UserInsightSentimentEnum | null, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', text: string, target?: string | null, targetType?: AppActionTargetType | null } }>, gain?: { __typename?: 'UserInsightGain', description: string } | null, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null } | { __typename?: 'RecommendationInsight', id: string, description?: string | null, sentiment?: UserInsightSentimentEnum | null, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', text: string, target?: string | null, targetType?: AppActionTargetType | null } }>, gain?: { __typename?: 'UserInsightGain', description: string } | null, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null } | { __typename?: 'FinancialInsight', id: string, description?: string | null, sentiment?: UserInsightSentimentEnum | null, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', text: string, target?: string | null, targetType?: AppActionTargetType | null } }>, gain?: { __typename?: 'UserInsightGain', description: string } | null, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null } | { __typename?: 'CreditScoreInsight', id: string, description?: string | null, sentiment?: UserInsightSentimentEnum | null, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', text: string, target?: string | null, targetType?: AppActionTargetType | null } }>, gain?: { __typename?: 'UserInsightGain', description: string } | null, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null }> } };

type CreditScoreUserInsightCardFragment_FeedCardInsight_Fragment = { __typename?: 'FeedCardInsight', description?: string | null, sentiment?: UserInsightSentimentEnum | null, id: string, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', text: string, target?: string | null, targetType?: AppActionTargetType | null } }>, gain?: { __typename?: 'UserInsightGain', description: string } | null, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null };

type CreditScoreUserInsightCardFragment_RecommendationInsight_Fragment = { __typename?: 'RecommendationInsight', description?: string | null, sentiment?: UserInsightSentimentEnum | null, id: string, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', text: string, target?: string | null, targetType?: AppActionTargetType | null } }>, gain?: { __typename?: 'UserInsightGain', description: string } | null, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null };

type CreditScoreUserInsightCardFragment_FinancialInsight_Fragment = { __typename?: 'FinancialInsight', description?: string | null, sentiment?: UserInsightSentimentEnum | null, id: string, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', text: string, target?: string | null, targetType?: AppActionTargetType | null } }>, gain?: { __typename?: 'UserInsightGain', description: string } | null, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null };

type CreditScoreUserInsightCardFragment_CreditScoreInsight_Fragment = { __typename?: 'CreditScoreInsight', description?: string | null, sentiment?: UserInsightSentimentEnum | null, id: string, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', text: string, target?: string | null, targetType?: AppActionTargetType | null } }>, gain?: { __typename?: 'UserInsightGain', description: string } | null, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null };

export type CreditScoreUserInsightCardFragmentFragment = CreditScoreUserInsightCardFragment_FeedCardInsight_Fragment | CreditScoreUserInsightCardFragment_RecommendationInsight_Fragment | CreditScoreUserInsightCardFragment_FinancialInsight_Fragment | CreditScoreUserInsightCardFragment_CreditScoreInsight_Fragment;

type GetSegmentPayloadFragment_FeedCardInsight_Fragment = { __typename?: 'FeedCardInsight', id: string, sentiment?: UserInsightSentimentEnum | null, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', target?: string | null, text: string } }>, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null };

type GetSegmentPayloadFragment_RecommendationInsight_Fragment = { __typename?: 'RecommendationInsight', id: string, sentiment?: UserInsightSentimentEnum | null, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', target?: string | null, text: string } }>, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null };

type GetSegmentPayloadFragment_FinancialInsight_Fragment = { __typename?: 'FinancialInsight', id: string, sentiment?: UserInsightSentimentEnum | null, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', target?: string | null, text: string } }>, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null };

type GetSegmentPayloadFragment_CreditScoreInsight_Fragment = { __typename?: 'CreditScoreInsight', id: string, sentiment?: UserInsightSentimentEnum | null, slug?: string | null, actions: Array<{ __typename?: 'UserAction', slug?: string | null, appAction: { __typename?: 'AppAction', target?: string | null, text: string } }>, dataVisualization?: { __typename?: 'SpendingByMonthsDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'SpendingByTopCategoriesDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditScoreActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'FinancialAccountsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'MyCardsActivationVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'CreditBoosterDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | { __typename?: 'WhyDidMyScoreChangeDataVisualization', dataVisualizationType: UserInsightDataVisualizationTypeEnum } | null };

export type GetSegmentPayloadFragmentFragment = GetSegmentPayloadFragment_FeedCardInsight_Fragment | GetSegmentPayloadFragment_RecommendationInsight_Fragment | GetSegmentPayloadFragment_FinancialInsight_Fragment | GetSegmentPayloadFragment_CreditScoreInsight_Fragment;

export type HandleCardActionFragmentFragment = { __typename?: 'AppAction', target?: string | null, targetType?: AppActionTargetType | null };

export type GetCreditScoreRewardsEmitterDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditScoreRewardsEmitterDataQuery = { __typename?: 'Query', tuCreditReportIdentityProfile?: { __typename?: 'TuCreditReportIdentityProfile', vantageScore3?: number | null, vantageScore3Bucket?: TuVantageScore3Buckets | null, vantageScore3Delta?: number | null } | null };

export type GetUnactivatedCreditScoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUnactivatedCreditScoreQuery = { __typename?: 'Query', tuAuthenticationStatusProfile?: { __typename?: 'CreditProfileAuthStatusProfile', blockedAt?: any | null, thinFileReason?: CreditProfileAuthThinFileReason | null, isDeceased?: boolean | null, hasThinFile?: boolean | null, notEnoughData?: boolean | null } | null };

export type SimulateVantageScoreQueryVariables = Exact<{
  input: CreditSimulationInput;
}>;


export type SimulateVantageScoreQuery = { __typename?: 'Query', simulateVantageScore?: { __typename?: 'SimulateVantageScoreResponse', result?: number | null } | null };

export type GetCreditScoreQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditScoreQuery = { __typename?: 'Query', tuCreditReportIdentityProfile?: { __typename?: 'TuCreditReportIdentityProfile', nwSumBalancesOpenRevolvingLineOfCredit?: number | null, vantageScore3?: number | null } | null };

export type GetTuAuthenticationStatusProfileQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTuAuthenticationStatusProfileQueryQuery = { __typename?: 'Query', tuAuthenticationStatusProfile?: { __typename?: 'CreditProfileAuthStatusProfile', status: CreditProfileAuthStatus } | null };

export type InSituFragment = { __typename?: 'NwPlusPoints', type: NwPlusPointType, value: number };

export type ExclusiveFeaturesCardFragment = { __typename?: 'NwPlusExclusiveFeatureCard', id: string, title: string, body: string, ctaText: string, ctaUrl: string, imageUrl: string, isNew?: boolean | null, points?: { __typename?: 'NwPlusPoints', value: number, type: NwPlusPointType } | null };

export type GetNwPlusExclusiveFeaturesCardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusExclusiveFeaturesCardsQuery = { __typename?: 'Query', nwPlusExclusiveFeatureCards?: { __typename?: 'NwPlusExclusiveFeatureCardsResponse', cards?: Array<{ __typename?: 'NwPlusExclusiveFeatureCard', id: string, title: string, body: string, ctaText: string, ctaUrl: string, imageUrl: string, isNew?: boolean | null, points?: { __typename?: 'NwPlusPoints', value: number, type: NwPlusPointType } | null }> | null } | null };

export type CashFlowTileQueryFragmentFragment = { __typename?: 'Query', financialTransactionsSpendingByDateForMonth?: { __typename?: 'FinancialTransactionsSpendingByDayOfTheMonthForMonth', spendingByDayOfTheMonthForTargetMonth: Array<{ __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth', amount: number, dayOfTheMonth: number }>, spendingByDayOfTheMonthForPriorMonth: Array<{ __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth', amount: number, dayOfTheMonth: number }> } | null, currentMonthEarning?: { __typename?: 'FinancialTransactionsSpendingAndEarningForMonthRangeResponse', spendingAndEarningForMonthRange: { __typename?: 'FinancialTransactionsSpendingAndEarning', earning: number } } | null };

export type GetCashFlowDataQueryVariables = Exact<{
  currentDate: Scalars['String']['input'];
  dateInTargetMonth: Scalars['Date']['input'];
  dateInStartMonth: Scalars['Date']['input'];
}>;


export type GetCashFlowDataQuery = { __typename?: 'Query', cashFlowBreakdown?: { __typename?: 'CashFlowBreakdown', spending: number, estimatedIncome: number, remaining: number } | null, financialTransactionsSpendingByDateForMonth?: { __typename?: 'FinancialTransactionsSpendingByDayOfTheMonthForMonth', spendingByDayOfTheMonthForTargetMonth: Array<{ __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth', amount: number, dayOfTheMonth: number }>, spendingByDayOfTheMonthForPriorMonth: Array<{ __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth', amount: number, dayOfTheMonth: number }> } | null, currentMonthEarning?: { __typename?: 'FinancialTransactionsSpendingAndEarningForMonthRangeResponse', spendingAndEarningForMonthRange: { __typename?: 'FinancialTransactionsSpendingAndEarning', earning: number } } | null };

export type GetCashFlowTileDataQueryVariables = Exact<{
  dateInTargetMonth: Scalars['Date']['input'];
  currentDate: Scalars['DateTime']['input'];
  dateInStartMonth: Scalars['Date']['input'];
  numPreviousMonthsToInclude?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCashFlowTileDataQuery = { __typename?: 'Query', financialTransactionsCashInCashOutSummaryForDatePeriod?: { __typename?: 'FinancialTransactionsCashInCashOutSummaryForDatePeriodsResponse', averageNetPreviousDatePeriods: number, summaries?: Array<{ __typename?: 'FinancialTransactionsCashInCashOutMonthItem', date: any, cashIn: number, cashOut: number, net: number } | null> | null } | null, financialTransactionsSpendingByDateForMonth?: { __typename?: 'FinancialTransactionsSpendingByDayOfTheMonthForMonth', spendingByDayOfTheMonthForTargetMonth: Array<{ __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth', amount: number, dayOfTheMonth: number }>, spendingByDayOfTheMonthForPriorMonth: Array<{ __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth', amount: number, dayOfTheMonth: number }> } | null, currentMonthEarning?: { __typename?: 'FinancialTransactionsSpendingAndEarningForMonthRangeResponse', spendingAndEarningForMonthRange: { __typename?: 'FinancialTransactionsSpendingAndEarning', earning: number } } | null };

export type GetRewardEventPointsQueryVariables = Exact<{
  eventTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetRewardEventPointsQuery = { __typename?: 'Query', rewardEventPoints: { __typename?: 'RewardEventPointsResponse', aggregateRewards?: Array<{ __typename?: 'RewardEventPoints', eventType: string, points?: number | null }> | null } };

export type GetCreditScoreDataCreditScoreTileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditScoreDataCreditScoreTileQuery = { __typename?: 'Query', tuCreditReportIdentityProfile?: { __typename?: 'TuCreditReportIdentityProfile', vantageScore3?: number | null, reportPulledAt?: any | null, vantageScore3Bucket?: TuVantageScore3Buckets | null, vantageScore3Delta?: number | null, vantageScore3Delta7Days?: number | null, vantageScore3DeltaBucket?: TuVantageScore3DeltaBuckets | null, vantageScore3ChangeDirection?: TuVantageScore3ChangeDirections | null, vantageScore3ChangeDirection7Days?: TuVantageScore3ChangeDirections | null } | null };

export type ActivatedInsuranceFragmentFragment = { __typename?: 'InsurancePolicy', isExpired?: boolean | null, monthlyPremiumCents?: number | null, friendlyCarrierName: string, requiresReconnect: boolean };

export type InsurancePoliciesForKeyNumberQueryVariables = Exact<{ [key: string]: never; }>;


export type InsurancePoliciesForKeyNumberQuery = { __typename?: 'Query', insurancePolicies: { __typename?: 'InsurancePoliciesResponse', policies?: Array<{ __typename?: 'InsurancePolicy', policyType: string, isExpired?: boolean | null, monthlyPremiumCents?: number | null, friendlyCarrierName: string, requiresReconnect: boolean }> | null } };

export type InsuranceErrorBannerFragmentFragment = { __typename?: 'InsurancePolicy', friendlyCarrierName: string, requiresReconnect: boolean };

export type GetInvestmentAccountsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvestmentAccountsSummaryQuery = { __typename?: 'Query', investmentAccountsSummary?: { __typename?: 'InvestmentAccountsSummary', automatedInvesting?: { __typename?: 'AutomatedInvestingSummary', createdAt?: any | null, pnl?: { __typename?: 'AutomatedInvestingEarnings', allTime?: { __typename?: 'EarningsByPercentage', value?: string | null, percentage?: string | null } | null, daily?: { __typename?: 'EarningsByPercentage', percentage?: string | null, value?: string | null } | null } | null, timeWeightedReturn?: { __typename?: 'Earnings', value?: string | null } | null, totalValue?: { __typename?: 'Earnings', value?: string | null } | null } | null, treasury?: { __typename?: 'TreasurySummary', createdAt?: any | null, earnings?: { __typename?: 'TreasuryEarnings', allTime?: { __typename?: 'Earnings', value?: string | null } | null, byMonth?: Array<{ __typename?: 'EarningsByMonth', month?: string | null, value?: string | null } | null> | null } | null, totalValue?: { __typename?: 'Earnings', value?: string | null } | null, yieldToMaturity?: { __typename?: 'Earnings', value?: string | null } | null } | null } | null };

export type GetInvestmentAccountsStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInvestmentAccountsStatusQuery = { __typename?: 'Query', investmentAccountsStatus?: { __typename?: 'InvestmentAccountsStatus', accountStatus?: string | null, hasAutomatedInvesting?: boolean | null, hasTreasury?: boolean | null } | null };

export type GetTreasuryAccountApyQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTreasuryAccountApyQuery = { __typename?: 'Query', treasuryAccountMarketing?: { __typename?: 'TreasuryAccountMarketing', annualPercentageYield: number } | null };

export type GetNetWorthDataActivatedNetWorthQueryVariables = Exact<{
  netWorthFilter: NetWorthHistoryFiltersEnum;
  effectiveDate: Scalars['DateTimeWithTimeOffset']['input'];
}>;


export type GetNetWorthDataActivatedNetWorthQuery = { __typename?: 'Query', netWorthHistory?: { __typename?: 'NetWorthHistoryResponse', history: Array<{ __typename?: 'NetWorthHistoryDataPoint', date: any, value: number } | null> } | null };

export type GetNetWorthDataQueryVariables = Exact<{
  eventTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetNetWorthDataQuery = { __typename?: 'Query', netWorthBalancesByFinancialDataCategorization?: { __typename?: 'NetWorthBalances', totalNetWorthIncludingHomeEquity?: number | null } | null, rewardEventPoints: { __typename?: 'RewardEventPointsResponse', aggregateRewards?: Array<{ __typename?: 'RewardEventPoints', eventType: string, points?: number | null }> | null } };

export type GetNwPlusWalletQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusWalletQuery = { __typename?: 'Query', nwPlusWallet?: { __typename?: 'NwPlusWalletResponse', points: number } | null };

export type GetNwPlusEstimatedPointsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusEstimatedPointsQuery = { __typename?: 'Query', nwPlusPointsEstimate?: { __typename?: 'NwPlusPointsEstimateResponse', points: number, breakdown?: Array<{ __typename?: 'NwPlusPointBreakdown', id: string, points: number, text: string }> | null } | null };

export type UnactivatedRewardsFragmentFragment = { __typename?: 'NwPlusPointBreakdown', id: string, points: number, text: string };

type PostTemplate_InsurancePage_Fragment = { __typename?: 'InsurancePage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_Article_Fragment = { __typename?: 'Article', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_AuFlexPage_Fragment = { __typename?: 'AUFlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_AuFlexTemplate_Fragment = { __typename?: 'AUFlexTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_BccPage_Fragment = { __typename?: 'BccPage', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_BccPageCard_Fragment = { __typename?: 'BccPageCard', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_Block_Fragment = { __typename?: 'Block', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_BlockGroup_Fragment = { __typename?: 'BlockGroup', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_CaFlexPage_Fragment = { __typename?: 'CAFlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_CaFlexTemplate_Fragment = { __typename?: 'CAFlexTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_CalculatorPage_Fragment = { __typename?: 'CalculatorPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_StructuredContentCalculator_Fragment = { __typename?: 'StructuredContentCalculator', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_ContentPack_Fragment = { __typename?: 'ContentPack', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_EngineeringPost_Fragment = { __typename?: 'EngineeringPost', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_FlexPage_Fragment = { __typename?: 'FlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_GlobalNavItem_Fragment = { __typename?: 'GlobalNavItem', title?: string | null, dbId: number, link?: any | null };

type PostTemplate_HouseAd_Fragment = { __typename?: 'HouseAd', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_Hub_Fragment = { __typename?: 'Hub', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_ContentHub_Fragment = { __typename?: 'ContentHub', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_InsuranceFlexPage_Fragment = { __typename?: 'InsuranceFlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_InsuranceTemplate_Fragment = { __typename?: 'InsuranceTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_LandingPage_Fragment = { __typename?: 'LandingPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_LegacyLender_Fragment = { __typename?: 'LegacyLender', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_MarketplaceEntryPoint_Fragment = { __typename?: 'MarketplaceEntryPoint', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_DynamicPlacement_Fragment = { __typename?: 'DynamicPlacement', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_PressRelease_Fragment = { __typename?: 'PressRelease', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_Review_Fragment = { __typename?: 'Review', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_ContentReviewer_Fragment = { __typename?: 'ContentReviewer', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_Roundup_Fragment = { __typename?: 'Roundup', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_FlexTemplate_Fragment = { __typename?: 'FlexTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_UrlRecord_Fragment = { __typename?: 'UrlRecord', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_ContentUserPage_Fragment = { __typename?: 'ContentUserPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_Page_Fragment = { __typename?: 'Page', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_Post_Fragment = { __typename?: 'Post', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_Table_Fragment = { __typename?: 'Table', title?: string | null, dbId: number, link?: any | null };

type PostTemplate_MediaItem_Fragment = { __typename?: 'MediaItem', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type PostTemplate_ContentSearchResult_Fragment = { __typename?: 'ContentSearchResult', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

export type PostTemplateFragment = PostTemplate_InsurancePage_Fragment | PostTemplate_Article_Fragment | PostTemplate_AuFlexPage_Fragment | PostTemplate_AuFlexTemplate_Fragment | PostTemplate_BccPage_Fragment | PostTemplate_BccPageCard_Fragment | PostTemplate_Block_Fragment | PostTemplate_BlockGroup_Fragment | PostTemplate_CaFlexPage_Fragment | PostTemplate_CaFlexTemplate_Fragment | PostTemplate_CalculatorPage_Fragment | PostTemplate_StructuredContentCalculator_Fragment | PostTemplate_ContentPack_Fragment | PostTemplate_EngineeringPost_Fragment | PostTemplate_FlexPage_Fragment | PostTemplate_GlobalNavItem_Fragment | PostTemplate_HouseAd_Fragment | PostTemplate_Hub_Fragment | PostTemplate_ContentHub_Fragment | PostTemplate_InsuranceFlexPage_Fragment | PostTemplate_InsuranceTemplate_Fragment | PostTemplate_LandingPage_Fragment | PostTemplate_LegacyLender_Fragment | PostTemplate_MarketplaceEntryPoint_Fragment | PostTemplate_DynamicPlacement_Fragment | PostTemplate_PressRelease_Fragment | PostTemplate_Review_Fragment | PostTemplate_ContentReviewer_Fragment | PostTemplate_Roundup_Fragment | PostTemplate_FlexTemplate_Fragment | PostTemplate_UrlRecord_Fragment | PostTemplate_ContentUserPage_Fragment | PostTemplate_Page_Fragment | PostTemplate_Post_Fragment | PostTemplate_Table_Fragment | PostTemplate_MediaItem_Fragment | PostTemplate_ContentSearchResult_Fragment;

export type GetContentRecsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetContentRecsQuery = { __typename?: 'Query', contentRecommendationPosts?: { __typename?: 'ContentRecommendations', personalised?: Array<{ __typename?: 'InsurancePage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'Article', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'AUFlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'AUFlexTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'BccPage', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'BccPageCard', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'Block', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'BlockGroup', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'CAFlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'CAFlexTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'CalculatorPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'StructuredContentCalculator', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'ContentPack', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'EngineeringPost', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'FlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'GlobalNavItem', title?: string | null, dbId: number, link?: any | null } | { __typename?: 'HouseAd', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'Hub', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'ContentHub', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'InsuranceFlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'InsuranceTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'LandingPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'LegacyLender', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'MarketplaceEntryPoint', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'DynamicPlacement', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'PressRelease', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'Review', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'ContentReviewer', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'Roundup', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'FlexTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'UrlRecord', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'ContentUserPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'Page', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'Post', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'Table', title?: string | null, dbId: number, link?: any | null } | { __typename?: 'MediaItem', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | { __typename?: 'ContentSearchResult', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null }> | null } | null };

export type RecentlyViewedQueryIdsQueryVariables = Exact<{
  maxPagesCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentlyViewedQueryIdsQuery = { __typename?: 'Query', recentlyViewed?: Array<{ __typename?: 'RecentlyViewed', id?: number | null }> | null };

type WeeklyReads_InsurancePage_Fragment = { __typename?: 'InsurancePage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_Article_Fragment = { __typename?: 'Article', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_AuFlexPage_Fragment = { __typename?: 'AUFlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_AuFlexTemplate_Fragment = { __typename?: 'AUFlexTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_BccPage_Fragment = { __typename?: 'BccPage', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_BccPageCard_Fragment = { __typename?: 'BccPageCard', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_Block_Fragment = { __typename?: 'Block', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_BlockGroup_Fragment = { __typename?: 'BlockGroup', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_CaFlexPage_Fragment = { __typename?: 'CAFlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_CaFlexTemplate_Fragment = { __typename?: 'CAFlexTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_CalculatorPage_Fragment = { __typename?: 'CalculatorPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_StructuredContentCalculator_Fragment = { __typename?: 'StructuredContentCalculator', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_ContentPack_Fragment = { __typename?: 'ContentPack', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_EngineeringPost_Fragment = { __typename?: 'EngineeringPost', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_FlexPage_Fragment = { __typename?: 'FlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_GlobalNavItem_Fragment = { __typename?: 'GlobalNavItem', title?: string | null, dbId: number, link?: any | null };

type WeeklyReads_HouseAd_Fragment = { __typename?: 'HouseAd', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_Hub_Fragment = { __typename?: 'Hub', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_ContentHub_Fragment = { __typename?: 'ContentHub', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_InsuranceFlexPage_Fragment = { __typename?: 'InsuranceFlexPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_InsuranceTemplate_Fragment = { __typename?: 'InsuranceTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_LandingPage_Fragment = { __typename?: 'LandingPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_LegacyLender_Fragment = { __typename?: 'LegacyLender', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_MarketplaceEntryPoint_Fragment = { __typename?: 'MarketplaceEntryPoint', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_DynamicPlacement_Fragment = { __typename?: 'DynamicPlacement', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_PressRelease_Fragment = { __typename?: 'PressRelease', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_Review_Fragment = { __typename?: 'Review', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_ContentReviewer_Fragment = { __typename?: 'ContentReviewer', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_Roundup_Fragment = { __typename?: 'Roundup', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_FlexTemplate_Fragment = { __typename?: 'FlexTemplate', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_UrlRecord_Fragment = { __typename?: 'UrlRecord', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_ContentUserPage_Fragment = { __typename?: 'ContentUserPage', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_Page_Fragment = { __typename?: 'Page', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_Post_Fragment = { __typename?: 'Post', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_Table_Fragment = { __typename?: 'Table', title?: string | null, dbId: number, link?: any | null };

type WeeklyReads_MediaItem_Fragment = { __typename?: 'MediaItem', title?: string | null, dbId: number, link?: any | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

type WeeklyReads_ContentSearchResult_Fragment = { __typename?: 'ContentSearchResult', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null };

export type WeeklyReadsFragment = WeeklyReads_InsurancePage_Fragment | WeeklyReads_Article_Fragment | WeeklyReads_AuFlexPage_Fragment | WeeklyReads_AuFlexTemplate_Fragment | WeeklyReads_BccPage_Fragment | WeeklyReads_BccPageCard_Fragment | WeeklyReads_Block_Fragment | WeeklyReads_BlockGroup_Fragment | WeeklyReads_CaFlexPage_Fragment | WeeklyReads_CaFlexTemplate_Fragment | WeeklyReads_CalculatorPage_Fragment | WeeklyReads_StructuredContentCalculator_Fragment | WeeklyReads_ContentPack_Fragment | WeeklyReads_EngineeringPost_Fragment | WeeklyReads_FlexPage_Fragment | WeeklyReads_GlobalNavItem_Fragment | WeeklyReads_HouseAd_Fragment | WeeklyReads_Hub_Fragment | WeeklyReads_ContentHub_Fragment | WeeklyReads_InsuranceFlexPage_Fragment | WeeklyReads_InsuranceTemplate_Fragment | WeeklyReads_LandingPage_Fragment | WeeklyReads_LegacyLender_Fragment | WeeklyReads_MarketplaceEntryPoint_Fragment | WeeklyReads_DynamicPlacement_Fragment | WeeklyReads_PressRelease_Fragment | WeeklyReads_Review_Fragment | WeeklyReads_ContentReviewer_Fragment | WeeklyReads_Roundup_Fragment | WeeklyReads_FlexTemplate_Fragment | WeeklyReads_UrlRecord_Fragment | WeeklyReads_ContentUserPage_Fragment | WeeklyReads_Page_Fragment | WeeklyReads_Post_Fragment | WeeklyReads_Table_Fragment | WeeklyReads_MediaItem_Fragment | WeeklyReads_ContentSearchResult_Fragment;

export type GetWeeklyReadsArticlesQueryVariables = Exact<{
  pagination?: InputMaybe<OffsetPaginationInput>;
  filter?: InputMaybe<ArticleFilterInput>;
}>;


export type GetWeeklyReadsArticlesQuery = { __typename?: 'Query', articles?: { __typename?: 'ArticleConnectionResponse', items?: Array<{ __typename?: 'Article', title?: string | null, dbId: number, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, sourceUrl?: any | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', size: MediaItemImageSizeEnum, sourceUrl?: any | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null }> | null } | null };

export type GetLearningUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLearningUserInfoQuery = { __typename?: 'Query', globalIdentityProfile?: { __typename?: 'GlobalIdentityProfile', firstName?: string | null } | null };

export type NerdUpBannerGetNerdUpCardStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type NerdUpBannerGetNerdUpCardStatusQuery = { __typename?: 'Query', nerdUpCreditCard: { __typename?: 'NerdUpCreditCardData', applicationStatus: NerdUpCreditCardApplicationStatus } };

export type TreasuryAccountQueryVariables = Exact<{ [key: string]: never; }>;


export type TreasuryAccountQuery = { __typename?: 'Query', treasuryAccountMarketing?: { __typename?: 'TreasuryAccountMarketing', yieldToMaturityPercentage: number } | null };

export type NerdyNudgeFragmentFragment = { __typename?: 'NwPlusOutstandingEvent', ctaLink?: any | null, ctaText?: string | null, eventType: string, iconUrl?: any | null, id: string, points: number, subtitle?: string | null, title?: string | null };

export type GetNwPlusOutstandingEventsQueryQueryVariables = Exact<{
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetNwPlusOutstandingEventsQueryQuery = { __typename?: 'Query', nwPlusOutstandingEvents?: { __typename?: 'NwPlusOutstandingEventsResponse', events?: Array<{ __typename?: 'NwPlusOutstandingEvent', id: string, points: number, slug?: string | null, ctaLink?: any | null, ctaText?: string | null, eventType: string, iconUrl?: any | null, subtitle?: string | null, title?: string | null }> | null } | null };

export type GetQuickStartGuideQueryVariables = Exact<{ [key: string]: never; }>;


export type GetQuickStartGuideQuery = { __typename?: 'Query', mobileAppIdentityProfile?: { __typename?: 'MobileAppIdentityProfile', devices: Array<{ __typename?: 'MobileAppProfileDevice', deviceLastLogin?: string | null }> } | null };

export type InsurancePoliciesForQuickStartGuideQueryVariables = Exact<{ [key: string]: never; }>;


export type InsurancePoliciesForQuickStartGuideQuery = { __typename?: 'Query', insurancePolicies: { __typename?: 'InsurancePoliciesResponse', policies?: Array<{ __typename?: 'InsurancePolicy', id: string, isExpired?: boolean | null, policyType: string }> | null } };

export type GetTuAuthenticationStatusProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTuAuthenticationStatusProfileQuery = { __typename?: 'Query', tuAuthenticationStatusProfile?: { __typename?: 'CreditProfileAuthStatusProfile', status: CreditProfileAuthStatus } | null };

export type ExperimentationQueryVariables = Exact<{
  testName: Scalars['String']['input'];
  userAttributes: Scalars['JSON']['input'];
  anonymousId: Scalars['String']['input'];
}>;


export type ExperimentationQuery = { __typename?: 'Query', experimentDecisions?: Array<{ __typename: 'ExperimentDecision', experimentName: string, assignedVariantName: string, modelExecutionIds: Array<string>, message?: string | null }> | null };

export type ExperimentQueryFieldsFragment = { __typename: 'ExperimentDecision', experimentName: string, assignedVariantName: string, modelExecutionIds: Array<string>, message?: string | null };

export type NerdUpAuthenticationMutationVariables = Exact<{ [key: string]: never; }>;


export type NerdUpAuthenticationMutation = { __typename?: 'Mutation', generateNerdUpAuthenticationTokens: { __typename?: 'NerdUpAuthenticationResponse', accessToken: string, refreshToken: string } };

export type GetNerdUpCardStatusNerdUpQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNerdUpCardStatusNerdUpQuery = { __typename?: 'Query', nerdUpCreditCard: { __typename?: 'NerdUpCreditCardData', applicationStatus: NerdUpCreditCardApplicationStatus } };

export type RecentlyViewedDashboardQueryQueryVariables = Exact<{
  maxPagesCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentlyViewedDashboardQueryQuery = { __typename?: 'Query', recentlyViewed?: Array<{ __typename?: 'RecentlyViewed', dateLastVisited: any, id?: number | null, numberOfVisits: number, synopsis?: any | null, title?: string | null, type?: string | null, urlPath: string }> | null };

export type ClearRecentlyViewedHistoryMutationVariables = Exact<{ [key: string]: never; }>;


export type ClearRecentlyViewedHistoryMutation = { __typename?: 'Mutation', clearRecentlyViewedHistory?: boolean | null };

export type SavedContentByEntityTypeQueryVariables = Exact<{
  entityType: Scalars['String']['input'];
}>;


export type SavedContentByEntityTypeQuery = { __typename?: 'Query', savedContentByEntityType: Array<{ __typename?: 'SavedContentResponse', savedAt: any, content?: { __typename?: 'InsurancePage' } | { __typename?: 'Article', title?: string | null, synopsis?: string | null, id: string, link?: any | null } | { __typename?: 'AUFlexPage' } | { __typename?: 'AUFlexTemplate' } | { __typename?: 'BccPage' } | { __typename?: 'BccPageCard' } | { __typename?: 'Block' } | { __typename?: 'BlockGroup' } | { __typename?: 'CAFlexPage' } | { __typename?: 'CAFlexTemplate' } | { __typename?: 'CalculatorPage' } | { __typename?: 'StructuredContentCalculator' } | { __typename?: 'ContentPack' } | { __typename?: 'EngineeringPost' } | { __typename?: 'FlexPage' } | { __typename?: 'GlobalNavItem' } | { __typename?: 'HouseAd' } | { __typename?: 'Hub' } | { __typename?: 'ContentHub' } | { __typename?: 'InsuranceFlexPage' } | { __typename?: 'InsuranceTemplate' } | { __typename?: 'LandingPage' } | { __typename?: 'LegacyLender' } | { __typename?: 'MarketplaceEntryPoint' } | { __typename?: 'DynamicPlacement' } | { __typename?: 'PressRelease' } | { __typename?: 'Review' } | { __typename?: 'ContentReviewer' } | { __typename?: 'Roundup' } | { __typename?: 'FlexTemplate' } | { __typename?: 'UrlRecord' } | { __typename?: 'ContentUserPage' } | { __typename?: 'Page' } | { __typename?: 'Post' } | { __typename?: 'Table' } | { __typename?: 'MediaItem' } | { __typename?: 'ContentSearchResult' } | null }> };

export type GetNetWorthRealAssetsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNetWorthRealAssetsQuery = { __typename?: 'Query', netWorthRealAssets?: { __typename?: 'NetWorthRealAssetsResponse', assets: Array<{ __typename?: 'NetWorthHomeIntegrated', id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null, amount?: number | null, lastReportedOrSyncedAt?: any | null, isSelfReported: boolean, address: { __typename?: 'NetWorthHomeIntegratedAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null }, externalInfo?: { __typename?: 'NetWorthHomeIntegratedExternalInfo', source: NetWorthHomeValueResultSourceEnum, value?: number | null } | null } | { __typename?: 'NetWorthRealAssetSelfReported', nickname: string, id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null, amount?: number | null, lastReportedOrSyncedAt?: any | null, isSelfReported: boolean }> } | null };

export type GetInsuranceAccountsForSettingsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInsuranceAccountsForSettingsQuery = { __typename?: 'Query', insuranceAccounts: { __typename?: 'InsuranceAccountsResponse', success: boolean, insuranceAccounts?: Array<{ __typename?: 'InsuranceAccounts', id: string, insuranceProviderName: string, friendlyInsuranceProviderName: string, requiresReconnect: boolean }> | null } };

export type GetReconnectTokenForSettingsQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetReconnectTokenForSettingsQuery = { __typename?: 'Query', accountReconnectToken?: { __typename?: 'InsuranceAccountReconnectTokenResponse', reconnectToken?: string | null } | null };

export type DeleteInsuranceByAccountIdMutationVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type DeleteInsuranceByAccountIdMutation = { __typename?: 'Mutation', deleteInsuranceByAccountId?: { __typename?: 'DeleteInsuranceByAccountIdResponse', success: boolean } | null };

export type FollowAuthorMutationVariables = Exact<{
  entityId: Scalars['Int']['input'];
}>;


export type FollowAuthorMutation = { __typename?: 'Mutation', followAuthor?: { __typename?: 'FollowedAuthorResponse', id: string, entityId: number } | null };

export type UnfollowAuthorMutationVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type UnfollowAuthorMutation = { __typename?: 'Mutation', unfollowAuthor?: boolean | null };

export type NewFollowFragment = { __typename?: 'FollowedAuthorResponse', id: string, entityId: number };

export type FollowedAuthorsQueryVariables = Exact<{ [key: string]: never; }>;


export type FollowedAuthorsQuery = { __typename?: 'Query', followedAuthors: Array<{ __typename?: 'FollowedAuthorResponse', id: string, entityId: number, author: { __typename?: 'Author', link?: any | null, name?: string | null, slug?: string | null, tagline?: string | null } }> };

export type GetNerdUpCardStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNerdUpCardStatusQuery = { __typename?: 'Query', nerdUpCreditCard: { __typename?: 'NerdUpCreditCardData', applicationStatus: NerdUpCreditCardApplicationStatus, cardStatus?: NerdUpCreditCardStatus | null } };

export type GetUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoQuery = { __typename?: 'Query', financialIdentityProfile?: { __typename?: 'FinancialIdentityProfile', annualIncome?: number | null, monthlyNetIncome?: number | null } | null, identity?: { __typename?: 'IdentityResponse', email: string } | null, globalIdentityProfile?: { __typename?: 'GlobalIdentityProfile', firstName?: string | null, lastName?: string | null } | null };

export type UpdateNameMutationVariables = Exact<{
  input: UpdateNameInput;
}>;


export type UpdateNameMutation = { __typename?: 'Mutation', updateName: { __typename?: 'UpdateNameResponse', lastName?: string | null, firstName?: string | null } };

export type UpdateIncomeMutationVariables = Exact<{
  input: UpdateIncomeInput;
}>;


export type UpdateIncomeMutation = { __typename?: 'Mutation', updateIncome: { __typename?: 'UpdateIncomeResponse', annualIncome?: number | null, monthlyNetIncome?: number | null } };

export type GetIdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdentityQuery = { __typename?: 'Query', identity?: { __typename?: 'IdentityResponse', id: string, identityId?: string | null } | null };

export type GetNotificationsPreferencesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNotificationsPreferencesQuery = { __typename?: 'Query', mobileAppIdentityProfile?: { __typename?: 'MobileAppIdentityProfile', devices: Array<{ __typename?: 'MobileAppProfileDevice', deviceLastLogin?: string | null }> } | null, subscriptionIdentityProfile?: { __typename?: 'SubscriptionIdentityProfile', emailEnabled?: boolean | null, emailCreditMonitoringEnabled?: boolean | null, emailSpendingAlertsEnabled?: boolean | null, emailMarketingEnabled?: boolean | null, emailPersonalizedContentEnabled?: boolean | null, pushEnabled?: boolean | null, pushCreditMonitoringEnabled?: boolean | null, pushSpendingAlertsEnabled?: boolean | null, pushMarketingUpdatesEnabled?: boolean | null, pushPersonalizedContentEnabled?: boolean | null } | null };

export type UpdateSubscriptionProfileV2MutationVariables = Exact<{
  subscriptionProfile: UpdateSubscriptionProfileInput;
  identityId: Scalars['String']['input'];
}>;


export type UpdateSubscriptionProfileV2Mutation = { __typename?: 'Mutation', updateSubscriptionProfile?: { __typename?: 'SubscriptionIdentityProfile', emailEnabled?: boolean | null, emailCreditMonitoringEnabled?: boolean | null, emailSpendingAlertsEnabled?: boolean | null, emailMarketingEnabled?: boolean | null, emailPersonalizedContentEnabled?: boolean | null, pushEnabled?: boolean | null, pushCreditMonitoringEnabled?: boolean | null, pushSpendingAlertsEnabled?: boolean | null, pushMarketingUpdatesEnabled?: boolean | null, pushPersonalizedContentEnabled?: boolean | null } | null };

export type GetUserScopesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserScopesQuery = { __typename?: 'Query', identity?: { __typename?: 'IdentityResponse', id: string, scopes: Array<string> } | null };

export type GetEmailAndHasPasswordQueryVariables = Exact<{ [key: string]: never; }>;


export type GetEmailAndHasPasswordQuery = { __typename?: 'Query', identity?: { __typename?: 'IdentityResponse', email: string, hasPassword: boolean } | null };

export type UpdateRecurlyBillingInfoMutationVariables = Exact<{
  token_id?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateRecurlyBillingInfoMutation = { __typename?: 'Mutation', updateRecurlyBillingInfo: { __typename?: 'RecurlyBillingInfoMutationResponse', success: boolean, error?: string | null } };

export type ReactivateNwPlusSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type ReactivateNwPlusSubscriptionMutation = { __typename?: 'Mutation', reactivateNwPlusSubscription: { __typename?: 'SubscriptionCancelReactivateResponse', success?: boolean | null, error?: string | null } };

export type CancelNwPlusSubscriptionMutationVariables = Exact<{ [key: string]: never; }>;


export type CancelNwPlusSubscriptionMutation = { __typename?: 'Mutation', cancelNwPlusSubscription: { __typename?: 'SubscriptionCancelReactivateResponse', success?: boolean | null, error?: string | null } };

export type RecurlyAccountInfoQueryFragmentFragment = { __typename?: 'Query', recurlyAccountInfo?: { __typename?: 'RecurlyAccountInfoResponse', address?: { __typename?: 'RecurlyAddress', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null, billingInfo?: { __typename?: 'RecurlyBillingInfo', firstName?: string | null, lastName?: string | null, paymentMethod?: { __typename?: 'RecurlyPaymentMethod', cardType?: string | null, lastFour?: string | null, expMonth?: number | null, expYear?: number | null, method?: string | null } | null } | null } | null };

export type NwPlusMembershipStatusQueryFragmentFragment = { __typename?: 'Query', nwPlusMembershipStatus?: { __typename?: 'NwPlusMembershipStatus', autoRenew?: boolean | null, currentPeriodEndsAt?: any | null, unitAmount?: number | null, state?: string | null } | null };

export type RecurlyBillingHistoryQueryFragmentFragment = { __typename?: 'Query', recurlyBillingHistory: { __typename?: 'RecurlyBillingHistoryResponse', billingHistory?: Array<{ __typename?: 'RecurlyBillingInvoice', invoiceNumber: string, dueDate: any, issuedDate: any, status: string, total: string, invoiceHref: string, downloadHref: string } | null> | null } };

export type UpdateRecurlyAccountAddressInfoMutationVariables = Exact<{
  address?: InputMaybe<RecurlyAddressInput>;
}>;


export type UpdateRecurlyAccountAddressInfoMutation = { __typename?: 'Mutation', updateRecurlyAccountAddressInfo: { __typename?: 'RecurlyAccountInfoMutationResponse', address?: { __typename?: 'RecurlyAddress', street1?: string | null, street2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null } | null } };

export type GetNwPlusMembershipStatusQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusMembershipStatusQuery = { __typename?: 'Query', nwPlusMembershipStatus?: { __typename?: 'NwPlusMembershipStatus', autoRenew?: boolean | null, currentPeriodEndsAt?: any | null, unitAmount?: number | null, state?: string | null } | null };

export type GetRecurlyBillingHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecurlyBillingHistoryQuery = { __typename?: 'Query', recurlyBillingHistory: { __typename?: 'RecurlyBillingHistoryResponse', billingHistory?: Array<{ __typename?: 'RecurlyBillingInvoice', invoiceNumber: string, dueDate: any, issuedDate: any, status: string, total: string, invoiceHref: string, downloadHref: string } | null> | null } };

export type GetRecurlyAccountInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRecurlyAccountInfoQuery = { __typename?: 'Query', recurlyAccountInfo?: { __typename?: 'RecurlyAccountInfoResponse', address?: { __typename?: 'RecurlyAddress', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null, billingInfo?: { __typename?: 'RecurlyBillingInfo', firstName?: string | null, lastName?: string | null, paymentMethod?: { __typename?: 'RecurlyPaymentMethod', cardType?: string | null, lastFour?: string | null, expMonth?: number | null, expYear?: number | null, method?: string | null } | null } | null } | null };

export type GetAllSubscriptionManagementDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllSubscriptionManagementDataQuery = { __typename?: 'Query', recurlyAccountInfo?: { __typename?: 'RecurlyAccountInfoResponse', address?: { __typename?: 'RecurlyAddress', street1?: string | null, street2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null } | null, billingInfo?: { __typename?: 'RecurlyBillingInfo', firstName?: string | null, lastName?: string | null, paymentMethod?: { __typename?: 'RecurlyPaymentMethod', cardType?: string | null, lastFour?: string | null, expMonth?: number | null, expYear?: number | null, method?: string | null } | null } | null } | null, nwPlusMembershipStatus?: { __typename?: 'NwPlusMembershipStatus', autoRenew?: boolean | null, currentPeriodEndsAt?: any | null, unitAmount?: number | null, state?: string | null } | null, recurlyBillingHistory: { __typename?: 'RecurlyBillingHistoryResponse', billingHistory?: Array<{ __typename?: 'RecurlyBillingInvoice', invoiceNumber: string, dueDate: any, issuedDate: any, status: string, total: string, invoiceHref: string, downloadHref: string } | null> | null } };

export type GetFinancialTransactionByIdQueryVariables = Exact<{
  transactionId: Scalars['ID']['input'];
}>;


export type GetFinancialTransactionByIdQuery = { __typename?: 'Query', financialTransactionById?: { __typename?: 'FinancialTransaction', amount: number, categoryId?: number | null, currency?: any | null, date: any, description?: string | null, id: string, isHidden?: boolean | null, isPending?: boolean | null, merchantName?: string | null, type?: FinancialTransactionType | null, account?: { __typename?: 'FinancialAccount', id: string, name?: string | null, mask?: string | null, financialPortal?: { __typename?: 'FinancialPortal', id: string, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', id: string, name: string } | null } | null } | null } | null };

export type FinancialTransactionsSpendingByMonthQueryVariables = Exact<{
  dateInStartMonth: Scalars['Date']['input'];
  dateInEndMonth: Scalars['Date']['input'];
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
}>;


export type FinancialTransactionsSpendingByMonthQuery = { __typename?: 'Query', financialTransactionsSpendingByMonth?: { __typename?: 'FinancialTransactionsSpendingByMonth', spendingByMonth: Array<{ __typename?: 'FinancialTransactionsSpendingOnDate', date: any, amount: number }> } | null };

export type GetTransactionsQueryVariables = Exact<{
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
}>;


export type GetTransactionsQuery = { __typename?: 'Query', financialTransactions?: { __typename?: 'GetTransactionsResponse', pagination: { __typename?: 'AdvancedOffsetPaginationInfo', limit?: number | null, offset?: number | null, resultSetToken?: string | null }, transactions: Array<{ __typename?: 'FinancialTransaction', amount: number, category?: FinancialTransactionCategory | null, categoryId?: number | null, currency?: any | null, date: any, description?: string | null, id: string, isHidden?: boolean | null, isPending?: boolean | null, merchantName?: string | null, type?: FinancialTransactionType | null, account?: { __typename?: 'FinancialAccount', id: string, name?: string | null, mask?: string | null, financialPortal?: { __typename?: 'FinancialPortal', id: string, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', id: string, name: string } | null } | null } | null }> } | null };

export type HasFinancialPortalsQueryVariables = Exact<{ [key: string]: never; }>;


export type HasFinancialPortalsQuery = { __typename?: 'Query', linkedFinancialPortals?: { __typename?: 'GetPortalsResponse', portals?: Array<{ __typename?: 'FinancialPortal', id: string }> | null } | null };

export type GetIsTransactionTooltipFilterSeenQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsTransactionTooltipFilterSeenQuery = { __typename?: 'Query', membershipAppActivity?: { __typename?: 'MembershipAppActivityResponse', isTransactionsFilterTooltipSeen?: boolean | null } | null };

export type UpdateIsTransactionsFilterTooltipSeenMutationVariables = Exact<{
  membershipAppActivity: MembershipAppActivityInput;
}>;


export type UpdateIsTransactionsFilterTooltipSeenMutation = { __typename?: 'Mutation', updateMembershipAppActivity?: { __typename?: 'MembershipAppActivityResponse', isTransactionsFilterTooltipSeen?: boolean | null } | null };

export type GetInsuranceDocumentUrlQueryVariables = Exact<{
  documentId: Scalars['ID']['input'];
}>;


export type GetInsuranceDocumentUrlQuery = { __typename?: 'Query', insuranceDocumentUrl: { __typename?: 'InsuranceDocumentUrlResponse', success: boolean, documentUrl?: string | null } };

export type InsuranceFreePoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type InsuranceFreePoliciesQuery = { __typename?: 'Query', insurancePolicies: { __typename?: 'InsurancePoliciesResponse', success: boolean, policies?: Array<{ __typename?: 'InsurancePolicy', id: string, identityId: string, accountId: string, policyType: string, policyDurationMonths?: number | null, carrierName?: string | null, friendlyInsuranceProviderName: string, totalPremiumCents?: number | null, expiryDate?: any | null, status?: string | null, effectiveDate?: any | null, renewalDate?: any | null, isExpired?: boolean | null, insuranceProviderLogo: string, requiresReconnect: boolean, vehicles: Array<{ __typename?: 'InsuredVehicles', make?: string | null, model?: string | null }>, dwellings: Array<{ __typename?: 'InsuredDwellings', address?: { __typename?: 'InsuredAddress', fullAddress?: string | null } | null }> }> | null } };

export type InsurancePolicyPageQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type InsurancePolicyPageQuery = { __typename?: 'Query', insurancePolicy: { __typename?: 'InsurancePolicyResponse', policy?: { __typename?: 'InsurancePolicy', id: string, isExpired?: boolean | null, policyType: string, updatedAt?: any | null, friendlyInsuranceProviderName: string } | null } };

export type GetPartialRateReportPageDataQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPartialRateReportPageDataQuery = { __typename?: 'Query', insurancePolicyRateReport: { __typename?: 'InsurancePolicyRateReportResponse', rateReport?: { __typename?: 'InsurancePolicyRateReport', rates: Array<{ __typename?: 'InsurancePolicyRate', id: string, annualPremium: number }> } | null } };

export type GetRateReportPolicyTypeQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type GetRateReportPolicyTypeQuery = { __typename?: 'Query', insurancePolicy: { __typename?: 'InsurancePolicyResponse', policy?: { __typename?: 'InsurancePolicy', id: string, carrierName?: string | null, monthlyPremiumCents?: number | null, policyDurationMonths?: number | null, policyType: string, totalPremiumCents?: number | null } | null } };

export type GetUserInfoActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserInfoActivityQuery = { __typename?: 'Query', globalIdentityProfile?: { __typename?: 'GlobalIdentityProfile', firstName?: string | null } | null };

export type GetNwPlusCompletedEventsQueryVariables = Exact<{
  filter?: InputMaybe<NwPlusRewardedCompletedEventFilter>;
}>;


export type GetNwPlusCompletedEventsQuery = { __typename?: 'Query', nwPlusRewardedCompletedEvents: Array<{ __typename?: 'NwPlusRewardedCompletedEvent', eventId: string, eventType: string, points: number, reportedAt: any, category: string, title: string }> };

export type GetNwPlusUserRedeemedRewardsQueryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  skip?: InputMaybe<Scalars['Int']['input']>;
  order?: InputMaybe<NwPlusCompletedEventOrder>;
  sort?: InputMaybe<NwPlusCompletedEventSort>;
}>;


export type GetNwPlusUserRedeemedRewardsQueryQuery = { __typename?: 'Query', nwPlusRedeemedRewardsHistory?: { __typename?: 'NwPlusUserRedeemedRewardsHistoryResponse', rewards?: Array<{ __typename?: 'NwPlusRedeemedRewardEvent', id: string, redeemedPoints: number, reportedAt: string, rewardCategories?: Array<string | null> | null, rewardName: string }> | null } | null };

export type GetNwPlusRedeemableRewardsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusRedeemableRewardsQueryQuery = { __typename?: 'Query', nwPlusRedeemableRewards?: { __typename?: 'NwPlusUserRedeemableRewardsResponse', rewards?: Array<{ __typename?: 'NwPlusRedeemableReward', id: string, name: string, price: number, priority: number, pictureUrl: string }> | null } | null };

export type NwPlusReferralQueryQueryVariables = Exact<{
  eventTypes: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type NwPlusReferralQueryQuery = { __typename?: 'Query', nwPlusReferralCode?: { __typename?: 'NwPlusReferralCodeResponse', referralCode: string } | null, nwPlusReferralCodeStats?: { __typename?: 'NwPlusReferralCodeStatsResponse', numberOfReferredUsers: number } | null, rewardEventPoints: { __typename?: 'RewardEventPointsResponse', rewards: Array<{ __typename?: 'RewardEventPoints', points?: number | null }> } };

export type GetPointsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPointsQueryQuery = { __typename?: 'Query', nwPlusPointsSummary?: { __typename?: 'NwPlusPointsSummaryResponse', points: number, earnedYearlyPoints?: number | null } | null };

export type NerdwalletPlusRichTextFragmentFragment = { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null };

export type NerdwalletPlusShoppingRewardStepFragmentFragment = { __typename?: 'FinancialNwPlusRewardStep', analyticsStatus: string, status: NwPlusRewardStepStatus, alertMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, ctaText?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, extraTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, failedTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, infoMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, tagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, title: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } };

export type NerdwalletPlusShoppingRewardTrackerResponseFragmentFragment = { __typename?: 'FinancialNwPlusRewardResponse', creditCards: Array<{ __typename?: 'FinancialCreditCardReward', id: string, shoppingFinishedAt: any, accountLinkStatus?: FinancialAccountLinkStatusEnum | null, nwPlusActivationStatus: NerdWalletPlusCreditCardActivationStatusEnum, productType?: FinancialNwPlusRewardProductEnum | null, marketplaceOfferId: string, marketplaceCreditCardOffer: { __typename?: 'CreditCardsOfferV2', displayName?: string | null, institution: { __typename?: 'InsuranceOfferV2', name: string, id: string } | { __typename?: 'CreditCardsOfferV2', name: string, id: string } | { __typename?: 'InsuranceProductV2', name: string, id: string } | { __typename?: 'InsuranceInstitutionV2', name: string, id: string } | { __typename?: 'CaBankingInstitutionV2', name: string, id: string } | { __typename?: 'CaBankingProductV2', name: string, id: string } | { __typename?: 'CaBankingOfferV2', name: string, id: string } | { __typename?: 'CaCreditCardsInstitutionV2', name: string, id: string } | { __typename?: 'CaCreditCardsProductV2', name: string, id: string } | { __typename?: 'CaCreditCardsOfferV2', name: string, id: string } | { __typename?: 'InvestingOfferV2', name: string, id: string } | { __typename?: 'InvestingProductV2', name: string, id: string } | { __typename?: 'InvestingInstitutionV2', name: string, id: string } | { __typename?: 'NerdwalletPlusInstitutionV2', name: string, id: string } | { __typename?: 'NerdwalletPlusProductV2', name: string, id: string } | { __typename?: 'NerdwalletPlusOfferV2', name: string, id: string } | { __typename?: 'AutoLoansOfferV2', name: string, id: string } | { __typename?: 'AutoServicesInstitutionV2', name: string, id: string } | { __typename?: 'AutoServicesOfferV2', name: string, id: string } | { __typename?: 'AutoServicesProductV2', name: string, id: string } | { __typename?: 'BankingOfferV2', name: string, id: string } | { __typename?: 'EducationLoansOfferV2', name: string, id: string } | { __typename?: 'MortgagesOfferV2', name: string, id: string } | { __typename?: 'SoftwareOfferV2', name: string, id: string } | { __typename?: 'EstatePlanningOfferV2', name: string, id: string } | { __typename?: 'ExpansionOfferV2', name: string, id: string } | { __typename?: 'AutoLoansInstitutionV2', name: string, id: string } | { __typename?: 'AutoLoansProductV2', name: string, id: string } | { __typename?: 'BankingInstitutionV2', name: string, id: string } | { __typename?: 'BankingProductV2', name: string, id: string } | { __typename?: 'CreditCardsInstitutionV2', name: string, id: string } | { __typename?: 'CreditCardsProductV2', name: string, id: string } | { __typename?: 'EducationLoansInstitutionV2', name: string, id: string } | { __typename?: 'EducationLoansProductV2', name: string, id: string } | { __typename?: 'EstatePlanningInstitutionV2', name: string, id: string } | { __typename?: 'EstatePlanningProductV2', name: string, id: string } | { __typename?: 'ExpansionInstitutionV2', name: string, id: string } | { __typename?: 'ExpansionProductV2', name: string, id: string } | { __typename?: 'MortgagesInstitutionV2', name: string, id: string } | { __typename?: 'MortgagesProductV2', name: string, id: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string, id: string } | { __typename?: 'PersonalLoansOfferV2', name: string, id: string } | { __typename?: 'PersonalLoansProductV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string, id: string } | { __typename?: 'SoftwareInstitutionV2', name: string, id: string } | { __typename?: 'SoftwareProductV2', name: string, id: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string, id: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string, id: string } }, events: Array<{ __typename?: 'FinancialCreditCardRewardEvent', id: string, eventType: FinancialCreditCardRewardEnum, emittedAt: any, viewedAt?: any | null, pointsRewarded?: number | null }>, steps: Array<{ __typename?: 'FinancialNwPlusRewardStep', analyticsStatus: string, status: NwPlusRewardStepStatus, alertMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, ctaText?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, extraTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, failedTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, infoMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, tagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, title: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } }>, rewardsProgress: { __typename?: 'FinancialCreditCardRewardProgress', hasAppliedForCard: boolean, hasConfirmedCardApproval: boolean, hasExpiredErrorsToReport: boolean, hasLinkedAccount: boolean, hasMadeOnTimePayment: boolean, hasCardApprovalConfirmationExpired: boolean, hasOnTimePaymentRewardExpired: boolean } }>, bankingAccounts: Array<{ __typename?: 'FinancialBankingReward', accountId?: string | null, accountLinkStatus?: FinancialAccountLinkStatusEnum | null, id: string, shoppingFinishedId: string, shoppingFinishedAt: any, productType?: FinancialNwPlusRewardProductEnum | null, marketplaceInstitutionId: string, marketplaceProductId: string, marketplaceOfferId: string, nwPlusActivationStatus: NerdWalletPlusCreditCardActivationStatusEnum, rewardEligibilityStatus?: NwPlusShoppingRewardEligibilityStatusEnum | null, rewardPathType?: NwPlusShoppingRewardPathEnum | null, accountLinkedAt?: any | null, events: Array<{ __typename?: 'FinancialBankingRewardEvent', id: string, emittedAt: any, viewedAt?: any | null, pointsRewarded?: number | null, eventType: FinancialBankingRewardEnum }>, steps: Array<{ __typename?: 'FinancialNwPlusRewardStep', analyticsStatus: string, status: NwPlusRewardStepStatus, alertMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, ctaText?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, extraTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, failedTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, infoMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, tagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, title: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } }>, marketplaceBankingOffer: { __typename?: 'BankingOfferV2', displayName?: string | null, institution: { __typename?: 'InsuranceOfferV2', name: string, id: string } | { __typename?: 'CreditCardsOfferV2', name: string, id: string } | { __typename?: 'InsuranceProductV2', name: string, id: string } | { __typename?: 'InsuranceInstitutionV2', name: string, id: string } | { __typename?: 'CaBankingInstitutionV2', name: string, id: string } | { __typename?: 'CaBankingProductV2', name: string, id: string } | { __typename?: 'CaBankingOfferV2', name: string, id: string } | { __typename?: 'CaCreditCardsInstitutionV2', name: string, id: string } | { __typename?: 'CaCreditCardsProductV2', name: string, id: string } | { __typename?: 'CaCreditCardsOfferV2', name: string, id: string } | { __typename?: 'InvestingOfferV2', name: string, id: string } | { __typename?: 'InvestingProductV2', name: string, id: string } | { __typename?: 'InvestingInstitutionV2', name: string, id: string } | { __typename?: 'NerdwalletPlusInstitutionV2', name: string, id: string } | { __typename?: 'NerdwalletPlusProductV2', name: string, id: string } | { __typename?: 'NerdwalletPlusOfferV2', name: string, id: string } | { __typename?: 'AutoLoansOfferV2', name: string, id: string } | { __typename?: 'AutoServicesInstitutionV2', name: string, id: string } | { __typename?: 'AutoServicesOfferV2', name: string, id: string } | { __typename?: 'AutoServicesProductV2', name: string, id: string } | { __typename?: 'BankingOfferV2', name: string, id: string } | { __typename?: 'EducationLoansOfferV2', name: string, id: string } | { __typename?: 'MortgagesOfferV2', name: string, id: string } | { __typename?: 'SoftwareOfferV2', name: string, id: string } | { __typename?: 'EstatePlanningOfferV2', name: string, id: string } | { __typename?: 'ExpansionOfferV2', name: string, id: string } | { __typename?: 'AutoLoansInstitutionV2', name: string, id: string } | { __typename?: 'AutoLoansProductV2', name: string, id: string } | { __typename?: 'BankingInstitutionV2', name: string, id: string } | { __typename?: 'BankingProductV2', name: string, id: string } | { __typename?: 'CreditCardsInstitutionV2', name: string, id: string } | { __typename?: 'CreditCardsProductV2', name: string, id: string } | { __typename?: 'EducationLoansInstitutionV2', name: string, id: string } | { __typename?: 'EducationLoansProductV2', name: string, id: string } | { __typename?: 'EstatePlanningInstitutionV2', name: string, id: string } | { __typename?: 'EstatePlanningProductV2', name: string, id: string } | { __typename?: 'ExpansionInstitutionV2', name: string, id: string } | { __typename?: 'ExpansionProductV2', name: string, id: string } | { __typename?: 'MortgagesInstitutionV2', name: string, id: string } | { __typename?: 'MortgagesProductV2', name: string, id: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string, id: string } | { __typename?: 'PersonalLoansOfferV2', name: string, id: string } | { __typename?: 'PersonalLoansProductV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string, id: string } | { __typename?: 'SoftwareInstitutionV2', name: string, id: string } | { __typename?: 'SoftwareProductV2', name: string, id: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string, id: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string, id: string } }, rewardsProgress: { __typename?: 'FinancialBankingRewardProgress', hasAppliedForBankingAccount: boolean, hasConfirmedBankingAccount: boolean, hasLinkedAccount: boolean, hasMadeDirectDeposit: boolean, hasFundedAccount: boolean, hasBankAccountConfirmationExpired: boolean, hasDirectDepositRewardExpired: boolean, hasFundedAccountRewardExpired: boolean, hasExpiredErrorsToReport: boolean } }> };

export type GetFinancialNerdWalletPlusShoppingRewardsQueryVariables = Exact<{
  filter?: InputMaybe<FinancialNwPlusRewardFilterInput>;
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetFinancialNerdWalletPlusShoppingRewardsQuery = { __typename?: 'Query', financialNwPlusRewards: { __typename?: 'FinancialNwPlusRewardResponse', creditCards: Array<{ __typename?: 'FinancialCreditCardReward', id: string, shoppingFinishedAt: any, accountLinkStatus?: FinancialAccountLinkStatusEnum | null, nwPlusActivationStatus: NerdWalletPlusCreditCardActivationStatusEnum, productType?: FinancialNwPlusRewardProductEnum | null, marketplaceOfferId: string, marketplaceCreditCardOffer: { __typename?: 'CreditCardsOfferV2', displayName?: string | null, institution: { __typename?: 'InsuranceOfferV2', name: string, id: string } | { __typename?: 'CreditCardsOfferV2', name: string, id: string } | { __typename?: 'InsuranceProductV2', name: string, id: string } | { __typename?: 'InsuranceInstitutionV2', name: string, id: string } | { __typename?: 'CaBankingInstitutionV2', name: string, id: string } | { __typename?: 'CaBankingProductV2', name: string, id: string } | { __typename?: 'CaBankingOfferV2', name: string, id: string } | { __typename?: 'CaCreditCardsInstitutionV2', name: string, id: string } | { __typename?: 'CaCreditCardsProductV2', name: string, id: string } | { __typename?: 'CaCreditCardsOfferV2', name: string, id: string } | { __typename?: 'InvestingOfferV2', name: string, id: string } | { __typename?: 'InvestingProductV2', name: string, id: string } | { __typename?: 'InvestingInstitutionV2', name: string, id: string } | { __typename?: 'NerdwalletPlusInstitutionV2', name: string, id: string } | { __typename?: 'NerdwalletPlusProductV2', name: string, id: string } | { __typename?: 'NerdwalletPlusOfferV2', name: string, id: string } | { __typename?: 'AutoLoansOfferV2', name: string, id: string } | { __typename?: 'AutoServicesInstitutionV2', name: string, id: string } | { __typename?: 'AutoServicesOfferV2', name: string, id: string } | { __typename?: 'AutoServicesProductV2', name: string, id: string } | { __typename?: 'BankingOfferV2', name: string, id: string } | { __typename?: 'EducationLoansOfferV2', name: string, id: string } | { __typename?: 'MortgagesOfferV2', name: string, id: string } | { __typename?: 'SoftwareOfferV2', name: string, id: string } | { __typename?: 'EstatePlanningOfferV2', name: string, id: string } | { __typename?: 'ExpansionOfferV2', name: string, id: string } | { __typename?: 'AutoLoansInstitutionV2', name: string, id: string } | { __typename?: 'AutoLoansProductV2', name: string, id: string } | { __typename?: 'BankingInstitutionV2', name: string, id: string } | { __typename?: 'BankingProductV2', name: string, id: string } | { __typename?: 'CreditCardsInstitutionV2', name: string, id: string } | { __typename?: 'CreditCardsProductV2', name: string, id: string } | { __typename?: 'EducationLoansInstitutionV2', name: string, id: string } | { __typename?: 'EducationLoansProductV2', name: string, id: string } | { __typename?: 'EstatePlanningInstitutionV2', name: string, id: string } | { __typename?: 'EstatePlanningProductV2', name: string, id: string } | { __typename?: 'ExpansionInstitutionV2', name: string, id: string } | { __typename?: 'ExpansionProductV2', name: string, id: string } | { __typename?: 'MortgagesInstitutionV2', name: string, id: string } | { __typename?: 'MortgagesProductV2', name: string, id: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string, id: string } | { __typename?: 'PersonalLoansOfferV2', name: string, id: string } | { __typename?: 'PersonalLoansProductV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string, id: string } | { __typename?: 'SoftwareInstitutionV2', name: string, id: string } | { __typename?: 'SoftwareProductV2', name: string, id: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string, id: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string, id: string } }, events: Array<{ __typename?: 'FinancialCreditCardRewardEvent', id: string, eventType: FinancialCreditCardRewardEnum, emittedAt: any, viewedAt?: any | null, pointsRewarded?: number | null }>, steps: Array<{ __typename?: 'FinancialNwPlusRewardStep', analyticsStatus: string, status: NwPlusRewardStepStatus, alertMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, ctaText?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, extraTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, failedTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, infoMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, tagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, title: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } }>, rewardsProgress: { __typename?: 'FinancialCreditCardRewardProgress', hasAppliedForCard: boolean, hasConfirmedCardApproval: boolean, hasExpiredErrorsToReport: boolean, hasLinkedAccount: boolean, hasMadeOnTimePayment: boolean, hasCardApprovalConfirmationExpired: boolean, hasOnTimePaymentRewardExpired: boolean } }>, bankingAccounts: Array<{ __typename?: 'FinancialBankingReward', accountId?: string | null, accountLinkStatus?: FinancialAccountLinkStatusEnum | null, id: string, shoppingFinishedId: string, shoppingFinishedAt: any, productType?: FinancialNwPlusRewardProductEnum | null, marketplaceInstitutionId: string, marketplaceProductId: string, marketplaceOfferId: string, nwPlusActivationStatus: NerdWalletPlusCreditCardActivationStatusEnum, rewardEligibilityStatus?: NwPlusShoppingRewardEligibilityStatusEnum | null, rewardPathType?: NwPlusShoppingRewardPathEnum | null, accountLinkedAt?: any | null, events: Array<{ __typename?: 'FinancialBankingRewardEvent', id: string, emittedAt: any, viewedAt?: any | null, pointsRewarded?: number | null, eventType: FinancialBankingRewardEnum }>, steps: Array<{ __typename?: 'FinancialNwPlusRewardStep', analyticsStatus: string, status: NwPlusRewardStepStatus, alertMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, ctaText?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, extraTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, failedTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, infoMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, tagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } | null, title: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', tag: string, url: string, type: NwPlusFaqLinkType, text: string }> | null } }>, marketplaceBankingOffer: { __typename?: 'BankingOfferV2', displayName?: string | null, institution: { __typename?: 'InsuranceOfferV2', name: string, id: string } | { __typename?: 'CreditCardsOfferV2', name: string, id: string } | { __typename?: 'InsuranceProductV2', name: string, id: string } | { __typename?: 'InsuranceInstitutionV2', name: string, id: string } | { __typename?: 'CaBankingInstitutionV2', name: string, id: string } | { __typename?: 'CaBankingProductV2', name: string, id: string } | { __typename?: 'CaBankingOfferV2', name: string, id: string } | { __typename?: 'CaCreditCardsInstitutionV2', name: string, id: string } | { __typename?: 'CaCreditCardsProductV2', name: string, id: string } | { __typename?: 'CaCreditCardsOfferV2', name: string, id: string } | { __typename?: 'InvestingOfferV2', name: string, id: string } | { __typename?: 'InvestingProductV2', name: string, id: string } | { __typename?: 'InvestingInstitutionV2', name: string, id: string } | { __typename?: 'NerdwalletPlusInstitutionV2', name: string, id: string } | { __typename?: 'NerdwalletPlusProductV2', name: string, id: string } | { __typename?: 'NerdwalletPlusOfferV2', name: string, id: string } | { __typename?: 'AutoLoansOfferV2', name: string, id: string } | { __typename?: 'AutoServicesInstitutionV2', name: string, id: string } | { __typename?: 'AutoServicesOfferV2', name: string, id: string } | { __typename?: 'AutoServicesProductV2', name: string, id: string } | { __typename?: 'BankingOfferV2', name: string, id: string } | { __typename?: 'EducationLoansOfferV2', name: string, id: string } | { __typename?: 'MortgagesOfferV2', name: string, id: string } | { __typename?: 'SoftwareOfferV2', name: string, id: string } | { __typename?: 'EstatePlanningOfferV2', name: string, id: string } | { __typename?: 'ExpansionOfferV2', name: string, id: string } | { __typename?: 'AutoLoansInstitutionV2', name: string, id: string } | { __typename?: 'AutoLoansProductV2', name: string, id: string } | { __typename?: 'BankingInstitutionV2', name: string, id: string } | { __typename?: 'BankingProductV2', name: string, id: string } | { __typename?: 'CreditCardsInstitutionV2', name: string, id: string } | { __typename?: 'CreditCardsProductV2', name: string, id: string } | { __typename?: 'EducationLoansInstitutionV2', name: string, id: string } | { __typename?: 'EducationLoansProductV2', name: string, id: string } | { __typename?: 'EstatePlanningInstitutionV2', name: string, id: string } | { __typename?: 'EstatePlanningProductV2', name: string, id: string } | { __typename?: 'ExpansionInstitutionV2', name: string, id: string } | { __typename?: 'ExpansionProductV2', name: string, id: string } | { __typename?: 'MortgagesInstitutionV2', name: string, id: string } | { __typename?: 'MortgagesProductV2', name: string, id: string } | { __typename?: 'PersonalLoansInstitutionV2', name: string, id: string } | { __typename?: 'PersonalLoansOfferV2', name: string, id: string } | { __typename?: 'PersonalLoansProductV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', name: string, id: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', name: string, id: string } | { __typename?: 'SoftwareInstitutionV2', name: string, id: string } | { __typename?: 'SoftwareProductV2', name: string, id: string } | { __typename?: 'ThirdPartyEmbedsInstitution', name: string, id: string } | { __typename?: 'ThirdPartyEmbedsProduct', name: string, id: string } }, rewardsProgress: { __typename?: 'FinancialBankingRewardProgress', hasAppliedForBankingAccount: boolean, hasConfirmedBankingAccount: boolean, hasLinkedAccount: boolean, hasMadeDirectDeposit: boolean, hasFundedAccount: boolean, hasBankAccountConfirmationExpired: boolean, hasDirectDepositRewardExpired: boolean, hasFundedAccountRewardExpired: boolean, hasExpiredErrorsToReport: boolean } }> } };

export type NwPlusUserReviewsQueryVariables = Exact<{ [key: string]: never; }>;


export type NwPlusUserReviewsQuery = { __typename?: 'Query', nwPlusUserReviews?: { __typename?: 'NwPlusUserReviewsResponse', reviews?: Array<{ __typename?: 'NwPlusUserReview', userName: string, userReview: string }> | null } | null };

export type GetWllMicrositeCashUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWllMicrositeCashUrlQuery = { __typename?: 'Query', wllMicrositeUrl?: string | null };

export type NwPlusPurchaseRewardMutationVariables = Exact<{
  rewardId: Scalars['String']['input'];
}>;


export type NwPlusPurchaseRewardMutation = { __typename?: 'Mutation', nwPlusPurchaseReward: { __typename?: 'NwPlusPurchaseRewardResponse', status: NwPlusRedeemRewardStatus, benefit?: { __typename?: 'NwPlusRewardBenefit', id: string, type: string, createdAt: string, redeemedAt?: string | null } | null } };

export type GetNwPlusRedeemableRewardsPageQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusRedeemableRewardsPageQuery = { __typename?: 'Query', nwPlusRedeemableRewards?: { __typename?: 'NwPlusUserRedeemableRewardsResponse', rewards?: Array<{ __typename?: 'NwPlusRedeemableReward', id: string, name: string, price: number, priority: number, pictureUrl: string, type?: string | null, description?: string | null, detailPictureUrl?: string | null, terms?: string | null }> | null } | null };

export type GetWllMicrositeRewardsUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetWllMicrositeRewardsUrlQuery = { __typename?: 'Query', wllMicrositeUrl?: string | null };

export type QualifiedRewardFragment = { __typename?: 'NwPlusQualifiedReward', cardCtaText: string, cardImageUrl: any, cardTitle: string, category: string, detailCtaAction?: NwPlusRewardAppAction | null, detailCtaWebLink?: any | null, detailCtaWebText?: string | null, detailDisclaimer?: string | null, detailImageUrl: any, detailMarketplaceOfferId?: string | null, detailSecondaryCtaAction?: NwPlusRewardAppAction | null, detailSecondaryCtaWebLink?: any | null, detailSecondaryCtaWebText?: string | null, detailSecondaryDescription?: string | null, detailSubtitle: string, detailTitle: string, eventTypes?: Array<string> | null, forYouOrder?: number | null, id: string, order: number, placement?: NwPlusRewardPlacementType | null, points: number, pointsPrefix?: string | null, prerequisiteLink?: string | null, subscriberExclusive: boolean, prerequisites?: Array<{ __typename?: 'NwPlusRewardPrerequisite', type: NwPlusRewardPrerequisiteType, description: string, ctaText: string }> | null };

export type GetNwPlusUserQualifiedRewardsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusUserQualifiedRewardsQueryQuery = { __typename?: 'Query', nwPlusUserQualifiedRewards?: { __typename?: 'NwPlusUserQualifiedRewardsResponse', allRewards?: Array<{ __typename?: 'NwPlusQualifiedReward', cardCtaText: string, cardImageUrl: any, cardTitle: string, category: string, detailCtaAction?: NwPlusRewardAppAction | null, detailCtaWebLink?: any | null, detailCtaWebText?: string | null, detailDisclaimer?: string | null, detailImageUrl: any, detailMarketplaceOfferId?: string | null, detailSecondaryCtaAction?: NwPlusRewardAppAction | null, detailSecondaryCtaWebLink?: any | null, detailSecondaryCtaWebText?: string | null, detailSecondaryDescription?: string | null, detailSubtitle: string, detailTitle: string, eventTypes?: Array<string> | null, forYouOrder?: number | null, id: string, order: number, placement?: NwPlusRewardPlacementType | null, points: number, pointsPrefix?: string | null, prerequisiteLink?: string | null, subscriberExclusive: boolean, prerequisites?: Array<{ __typename?: 'NwPlusRewardPrerequisite', type: NwPlusRewardPrerequisiteType, description: string, ctaText: string }> | null }> | null, featuredRewards?: Array<{ __typename?: 'NwPlusQualifiedReward', cardCtaText: string, cardImageUrl: any, cardTitle: string, category: string, detailCtaAction?: NwPlusRewardAppAction | null, detailCtaWebLink?: any | null, detailCtaWebText?: string | null, detailDisclaimer?: string | null, detailImageUrl: any, detailMarketplaceOfferId?: string | null, detailSecondaryCtaAction?: NwPlusRewardAppAction | null, detailSecondaryCtaWebLink?: any | null, detailSecondaryCtaWebText?: string | null, detailSecondaryDescription?: string | null, detailSubtitle: string, detailTitle: string, eventTypes?: Array<string> | null, forYouOrder?: number | null, id: string, order: number, placement?: NwPlusRewardPlacementType | null, points: number, pointsPrefix?: string | null, prerequisiteLink?: string | null, subscriberExclusive: boolean, prerequisites?: Array<{ __typename?: 'NwPlusRewardPrerequisite', type: NwPlusRewardPrerequisiteType, description: string, ctaText: string }> | null }> | null } | null };

export type GetNwPlusPerkRewardsOfferQueryVariables = Exact<{
  marketplaceId: Scalars['ID']['input'];
}>;


export type GetNwPlusPerkRewardsOfferQuery = { __typename?: 'Query', marketplaceEntityV2?: { __typename?: 'InsuranceOfferV2', id: string } | { __typename?: 'CreditCardsOfferV2', id: string } | { __typename?: 'InsuranceProductV2', id: string } | { __typename?: 'InsuranceInstitutionV2', id: string } | { __typename?: 'CaBankingInstitutionV2', id: string } | { __typename?: 'CaBankingProductV2', id: string } | { __typename?: 'CaBankingOfferV2', id: string } | { __typename?: 'CaCreditCardsInstitutionV2', id: string } | { __typename?: 'CaCreditCardsProductV2', id: string } | { __typename?: 'CaCreditCardsOfferV2', id: string } | { __typename?: 'InvestingOfferV2', id: string } | { __typename?: 'InvestingProductV2', id: string } | { __typename?: 'InvestingInstitutionV2', id: string } | { __typename?: 'NerdwalletPlusInstitutionV2', id: string } | { __typename?: 'NerdwalletPlusProductV2', id: string } | { __typename?: 'NerdwalletPlusOfferV2', applyLink?: any | null, productType: string, entityType: string, name: string, id: string } | { __typename?: 'AutoLoansOfferV2', id: string } | { __typename?: 'AutoServicesInstitutionV2', id: string } | { __typename?: 'AutoServicesOfferV2', id: string } | { __typename?: 'AutoServicesProductV2', id: string } | { __typename?: 'BankingOfferV2', id: string } | { __typename?: 'EducationLoansOfferV2', id: string } | { __typename?: 'MortgagesOfferV2', id: string } | { __typename?: 'SoftwareOfferV2', id: string } | { __typename?: 'EstatePlanningOfferV2', id: string } | { __typename?: 'ExpansionOfferV2', id: string } | { __typename?: 'AutoLoansInstitutionV2', id: string } | { __typename?: 'AutoLoansProductV2', id: string } | { __typename?: 'BankingInstitutionV2', id: string } | { __typename?: 'BankingProductV2', id: string } | { __typename?: 'CreditCardsInstitutionV2', id: string } | { __typename?: 'CreditCardsProductV2', id: string } | { __typename?: 'EducationLoansInstitutionV2', id: string } | { __typename?: 'EducationLoansProductV2', id: string } | { __typename?: 'EstatePlanningInstitutionV2', id: string } | { __typename?: 'EstatePlanningProductV2', id: string } | { __typename?: 'ExpansionInstitutionV2', id: string } | { __typename?: 'ExpansionProductV2', id: string } | { __typename?: 'MortgagesInstitutionV2', id: string } | { __typename?: 'MortgagesProductV2', id: string } | { __typename?: 'PersonalLoansInstitutionV2', id: string } | { __typename?: 'PersonalLoansOfferV2', id: string } | { __typename?: 'PersonalLoansProductV2', id: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', id: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', id: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', id: string } | { __typename?: 'SoftwareInstitutionV2', id: string } | { __typename?: 'SoftwareProductV2', id: string } | { __typename?: 'ThirdPartyEmbedsInstitution', id: string } | { __typename?: 'ThirdPartyEmbedsProduct', id: string } | null };

export type GetNwPlusDashboardDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusDashboardDataQuery = { __typename?: 'Query', identity?: { __typename?: 'IdentityResponse', roles: Array<string>, isNerdWalletPlusMember: boolean } | null, globalIdentityProfile?: { __typename?: 'GlobalIdentityProfile', firstName?: string | null } | null, membershipAppActivity?: { __typename?: 'MembershipAppActivityResponse', nwPlusMaxEarnedPointsModalDismissedAt?: any | null } | null, nwPlusPredictions?: { __typename?: 'NwPlusPredictionsResponse', pointsEarnPrediction?: { __typename?: 'NwPlusPointsPrediction', overallSummary?: { __typename?: 'NwPlusPointsPredictionOverallSummary', type: string, summary: { __typename?: 'NwPlusPointsSummary', remainingPoints: number } } | null } | null } | null, nwPlusPointsSummary?: { __typename?: 'NwPlusPointsSummaryResponse', points: number, earnedYearlyPoints?: number | null } | null };

export type GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusMonthlyCreditCardPaymentInfoQuery = { __typename?: 'Query', nwPlusMonthlyCreditCardPaymentInfo?: { __typename?: 'NwPlusMonthlyCreditCardPaymentInfoResponse', creditCardSelectedAccountId?: string | null, creditCardAccounts: Array<{ __typename?: 'FinancialAccount', id: string, name?: string | null, mask?: string | null }> } | null };

export type UpdateCreditCardForMonitoringMutationVariables = Exact<{
  membershipAppActivity: MembershipAppActivityInput;
}>;


export type UpdateCreditCardForMonitoringMutation = { __typename?: 'Mutation', updateMembershipAppActivity?: { __typename?: 'MembershipAppActivityResponse', nwPlusRewards?: any | null } | null };

export type GetNerdWalletPlusCheckoutUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNerdWalletPlusCheckoutUserInfoQuery = { __typename?: 'Query', identity?: { __typename?: 'IdentityResponse', email: string, id: string } | null, globalIdentityProfile?: { __typename?: 'GlobalIdentityProfile', firstName?: string | null, lastName?: string | null } | null };

export type CreateRecurlyPurchaseMutationVariables = Exact<{
  tokenId: Scalars['String']['input'];
  anonymousId?: InputMaybe<Scalars['String']['input']>;
  firstName?: InputMaybe<Scalars['String']['input']>;
  lastName?: InputMaybe<Scalars['String']['input']>;
  referralCode?: InputMaybe<Scalars['String']['input']>;
  couponCodes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>> | InputMaybe<Scalars['String']['input']>>;
  autoRenew?: InputMaybe<Scalars['Boolean']['input']>;
  mailingAddress?: InputMaybe<RecurlyAddressInput>;
}>;


export type CreateRecurlyPurchaseMutation = { __typename?: 'Mutation', createRecurlyPurchase: { __typename?: 'RecurlyPurchaseResponse', id: string, success: boolean, error?: string | null, referralSucceeded?: boolean | null } };

export type RateReportsForPolicyTileQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RateReportsForPolicyTileQuery = { __typename?: 'Query', insurancePoliciesRateReports: { __typename?: 'InsurancePoliciesRateReportsResponse', rateReports: Array<{ __typename?: 'InsurancePolicyRateReport', policyId: string, rates: Array<{ __typename?: 'InsurancePolicyRate', id: string, annualPremium: number }> }> } };

export type GetWpArticleByIdQueryVariables = Exact<{
  input?: InputMaybe<PostItemInput>;
  sizes?: InputMaybe<Array<MediaItemImageSizeEnum> | MediaItemImageSizeEnum>;
}>;


export type GetWpArticleByIdQuery = { __typename?: 'Query', article?: { __typename?: 'Article', id: string, title?: string | null, synopsis?: string | null, link?: any | null, featuredMedia?: { __typename?: 'MediaItem', altText?: string | null, croppedImages?: Array<{ __typename?: 'CroppedImageSize', file?: string | null, height?: number | null, size: MediaItemImageSizeEnum, sourceUrl?: any | null, width?: number | null }> | null } | null, authors?: Array<{ __typename?: 'Author', id: string, link?: any | null, name?: string | null, avatarUrls?: Array<{ __typename?: 'AuthorAvatarUrl', size?: number | null, url?: any | null }> | null }> | null } | null };

export type InsurancePoliciesQueryVariables = Exact<{ [key: string]: never; }>;


export type InsurancePoliciesQuery = { __typename?: 'Query', insurancePolicies: { __typename?: 'InsurancePoliciesResponse', success: boolean, policies?: Array<{ __typename?: 'InsurancePolicy', id: string, accountId: string, identityId: string, policyType: string, policyDurationMonths?: number | null, carrierName?: string | null, friendlyInsuranceProviderName: string, totalPremiumCents?: number | null, status?: string | null, expiryDate?: any | null, effectiveDate?: any | null, renewalDate?: any | null, isExpired?: boolean | null, insuranceProviderLogo: string, requiresReconnect: boolean, vehicles: Array<{ __typename?: 'InsuredVehicles', make?: string | null, model?: string | null }>, dwellings: Array<{ __typename?: 'InsuredDwellings', address?: { __typename?: 'InsuredAddress', fullAddress?: string | null } | null }> }> | null } };

export type GetRateReportPageDataQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetRateReportPageDataQuery = { __typename?: 'Query', tuCreditReportIdentityProfile?: { __typename?: 'TuCreditReportIdentityProfile', vantageScore3?: number | null } | null, insurancePolicyRateReport: { __typename?: 'InsurancePolicyRateReportResponse', rateReport?: { __typename?: 'InsurancePolicyRateReport', policyId: string, updatedAt: any, rates: Array<{ __typename?: 'InsurancePolicyRate', id: string, annualPremium: number, marketplaceProductId?: string | null, marketplaceProductName?: string | null, marketplaceEntity?: { __typename?: 'MarketplaceEntity', starRating?: number | null, reviewLink?: string | null, productBottomLine?: string | null, institution?: { __typename?: 'MarketplaceInstitution', id: string, name: string, logo: string } | null } | null }> } | null }, insurancePolicy: { __typename?: 'InsurancePolicyResponse', policy?: { __typename?: 'InsurancePolicy', id: string, name?: string | null, carrierName?: string | null, policyType: string, policyDurationMonths?: number | null, effectiveDate?: any | null, expiryDate?: any | null, isExpired?: boolean | null, totalPremiumCents?: number | null, monthlyPremiumCents?: number | null, updatedAt?: any | null, vehicles: Array<{ __typename?: 'InsuredVehicles', garagingAddress?: { __typename?: 'InsuredAddress', zip?: string | null, state?: string | null } | null, drivers: Array<{ __typename?: 'VehicleDrivers', birthdate?: string | null }> }>, dwellings: Array<{ __typename?: 'InsuredDwellings', id: string, address?: { __typename?: 'InsuredAddress', state?: string | null } | null }> } | null }, insurancePolicyOverrides?: { __typename?: 'InsurancePolicyOverridesResponse', id: string, overrides?: { __typename?: 'InsurancePolicyOverrides', global?: { __typename?: 'GlobalInsurancePolicyOverrides', creditScore?: number | null, birthdate?: string | null } | null, policy?: { __typename?: 'LocalInsurancePolicyOverrides', carMake?: string | null, carYear?: number | null, carModel?: string | null, zipCode?: string | null } | null } | null } | null };

export type GetManageSubscriptionUrlQueryVariables = Exact<{ [key: string]: never; }>;


export type GetManageSubscriptionUrlQuery = { __typename?: 'Query', recurlyAccountManagementPageUrl?: string | null, identity?: { __typename?: 'IdentityResponse', id: string, isNerdWalletPlusMember: boolean } | null };

export type RegisterSubscriptionSuccessMutationVariables = Exact<{
  anonymousId?: InputMaybe<Scalars['String']['input']>;
}>;


export type RegisterSubscriptionSuccessMutation = { __typename?: 'Mutation', registerNwPlusSubscriptionSuccess?: { __typename?: 'IdentityResponse', id: string, isNerdWalletPlusMember: boolean } | null };

export type RetrieveIdentityQueryVariables = Exact<{ [key: string]: never; }>;


export type RetrieveIdentityQuery = { __typename?: 'Query', identity?: { __typename?: 'IdentityResponse', id: string, identityId?: string | null } | null };

export type SubscriptionProfileFieldsFragment = { __typename?: 'SubscriptionIdentityProfile', emailEnabled?: boolean | null, emailCreditMonitoringEnabled?: boolean | null, emailSpendingAlertsEnabled?: boolean | null, emailMarketingEnabled?: boolean | null, emailPersonalizedContentEnabled?: boolean | null, updateSubscriptionToken?: string | null };

export type UnsubscribeFromNotificationMutationVariables = Exact<{
  subscriptionField: SubscriptionTypeEnum;
  unsubscribeToken: Scalars['String']['input'];
}>;


export type UnsubscribeFromNotificationMutation = { __typename?: 'Mutation', unsubscribeFromNotification?: { __typename?: 'SubscriptionIdentityProfile', emailEnabled?: boolean | null, emailCreditMonitoringEnabled?: boolean | null, emailSpendingAlertsEnabled?: boolean | null, emailMarketingEnabled?: boolean | null, emailPersonalizedContentEnabled?: boolean | null, updateSubscriptionToken?: string | null } | null };

export type UpdateSubscriptionWithoutIdentityMutationVariables = Exact<{
  subscriptionSettings: UpdateSubscriptionProfileInput;
  updateSubscriptionToken?: InputMaybe<Scalars['String']['input']>;
}>;


export type UpdateSubscriptionWithoutIdentityMutation = { __typename?: 'Mutation', updateSubscriptionWithoutIdentity?: { __typename?: 'SubscriptionIdentityProfile', emailEnabled?: boolean | null, emailCreditMonitoringEnabled?: boolean | null, emailSpendingAlertsEnabled?: boolean | null, emailMarketingEnabled?: boolean | null, emailPersonalizedContentEnabled?: boolean | null, updateSubscriptionToken?: string | null } | null };

export type GetAccountListForNetWorthQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAccountListForNetWorthQuery = { __typename?: 'Query', netWorthRealAssets?: { __typename?: 'NetWorthRealAssetsResponse', assets: Array<{ __typename?: 'NetWorthHomeIntegrated', amount?: number | null, id: string, isHiddenFromNetWorth?: boolean | null, isSelfReported: boolean, lastReportedOrSyncedAt?: any | null, type: NetWorthRealAssetTypeEnum, address: { __typename?: 'NetWorthHomeIntegratedAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null }, externalInfo?: { __typename?: 'NetWorthHomeIntegratedExternalInfo', source: NetWorthHomeValueResultSourceEnum, value?: number | null } | null } | { __typename?: 'NetWorthRealAssetSelfReported', nickname: string, amount?: number | null, id: string, isHiddenFromNetWorth?: boolean | null, isSelfReported: boolean, lastReportedOrSyncedAt?: any | null, type: NetWorthRealAssetTypeEnum }> } | null, netWorthAccounts?: { __typename?: 'NetWorthAccountsResponse', accounts: Array<{ __typename?: 'NetWorthAccount', financialAccountId: string, id: string, isHiddenFromNetWorth: boolean }> } | null, financialAccounts?: { __typename?: 'GetFinancialAccountsResponse', accounts?: Array<{ __typename?: 'FinancialAccount', balance?: any | null, currency?: any | null, id: string, isHidden?: boolean | null, isHiddenFromNetWorth?: boolean | null, lastSyncedAt?: any | null, mask?: string | null, name?: string | null, status?: FinancialAccountStatus | null, subtype?: FinancialAccountSubtype | null, updatedAt: any, financialPortal?: { __typename?: 'FinancialPortal', authState?: FinancialPortalAuthState | null, id: string, isActiveSync?: boolean | null, primarySource?: FinancialDataSource | null, transactionsState?: FinancialPortalProductState | null, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', id: string, logoUrl?: string | null, name: string } | null } | null }> | null } | null, netWorthBalancesByFinancialDataCategorization?: { __typename?: 'NetWorthBalances', assetSums: { __typename?: 'NetWorthBalancesAssetSums', autoValueSum?: number | null, checkingSum?: number | null, homeValueSum?: number | null, investmentSum?: number | null, personalPropertyValueSum?: number | null, retirementSum?: number | null, savingsSum?: number | null }, debtSums: { __typename?: 'NetWorthBalancesDebtSums', creditCardSum?: number | null, loanSum?: number | null, mortgageSum?: number | null } } | null };

export type GetIdentityProfileQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdentityProfileQueryQuery = { __typename?: 'Query', tuCreditReportIdentityProfile?: { __typename?: 'TuCreditReportIdentityProfile', vantageScore3?: number | null, reportPulledAt?: any | null, vantageScore3Bucket?: TuVantageScore3Buckets | null } | null };

export type GetTermsOfServiceAcknowledgementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTermsOfServiceAcknowledgementsQuery = { __typename?: 'Query', termsOfServiceIdentityProfile?: { __typename?: 'TermsOfServiceIdentityProfile', acknowledgements?: Array<{ __typename?: 'TermsOfServiceAcknowledgement', type: string, source: string, version: string }> | null } | null };

export type NotifyPlaidLinkEventMutationVariables = Exact<{
  event: ProxyEventType;
  eventBody?: InputMaybe<Scalars['JSON']['input']>;
  financialPortalId?: InputMaybe<Scalars['ID']['input']>;
  isMigrate?: InputMaybe<Scalars['Boolean']['input']>;
  linkToken?: InputMaybe<Scalars['String']['input']>;
  marketplaceInstitutionId?: InputMaybe<Scalars['ID']['input']>;
  source?: InputMaybe<FinancialDataSource>;
  sourceEntityId?: InputMaybe<Scalars['ID']['input']>;
  sourceInstitutionId?: InputMaybe<Scalars['ID']['input']>;
}>;


export type NotifyPlaidLinkEventMutation = { __typename?: 'Mutation', publishFinancialDataLinkEvent?: { __typename?: 'FinancialPortalMessageResponse', success: boolean } | null };

export type ReinitializeFinancialPortalMutationMutationVariables = Exact<{
  financialPortalId: Scalars['ID']['input'];
  redirectUri?: InputMaybe<Scalars['String']['input']>;
}>;


export type ReinitializeFinancialPortalMutationMutation = { __typename?: 'Mutation', reinitializeFinancialPortal?: { __typename?: 'ReinitializeFinancialPortalResponse', details?: { __typename?: 'ReinitializeFinancialPortalResponseDetails', publicToken?: string | null, recommendedInstitutionId?: string | null, recommendedSourceInstitutionId?: string | null } | null, financialPortal?: { __typename?: 'FinancialPortal', id: string, primaryClientAction?: FinancialPortalPrimaryClientAction | null } | null } | null };

export type AcknowledgeTermsOfServiceMutationVariables = Exact<{
  input: AcknowledgeTermsOfServiceInput;
}>;


export type AcknowledgeTermsOfServiceMutation = { __typename?: 'Mutation', acknowledgeTermsOfService?: { __typename?: 'AcknowledgeTermsOfServiceResponse', success: boolean } | null };

export type DeleteFinancialPortalMutationVariables = Exact<{
  financialPortalId: Scalars['ID']['input'];
}>;


export type DeleteFinancialPortalMutation = { __typename?: 'Mutation', deleteFinancialPortal?: { __typename?: 'DeleteFinancialPortalResponse', success: boolean } | null };

export type FinancialAccountFragmentFragment = { __typename?: 'FinancialAccount', autoRefreshRequired?: boolean | null, balance?: any | null, createdAt: any, currency?: any | null, extra?: any | null, iavVerified?: boolean | null, id: string, isHidden?: boolean | null, lastSyncedAt?: any | null, mask?: string | null, name?: string | null, primarySource?: FinancialDataSource | null, status?: FinancialAccountStatus | null, subtype?: FinancialAccountSubtype | null, subtypeDetails?: string | null, transactionsSyncedAt?: any | null, type?: FinancialAccountType | null, updatedAt: any, verificationState?: string | null, deleteQueuedAt?: string | null, flaggedForClosureAt?: string | null, financialPortal?: { __typename?: 'FinancialPortal', accountsState?: FinancialPortalProductState | null, activeMigration?: boolean | null, alertMessage?: FinancialPortalAlertMessage | null, alertName?: string | null, alertPriority?: string | null, authState?: FinancialPortalAuthState | null, authStateSetAt?: any | null, canonicalInstitutionId?: string | null, createdAt: any, errorMessage?: FinancialPortalErrorMessage | null, errorName?: string | null, errorPriority?: string | null, id: string, identityId: string, isActiveSync?: boolean | null, isAutoRefreshing?: boolean | null, isBalanceRefreshing?: boolean | null, isManualRefreshing?: boolean | null, lastRefreshedAt?: any | null, primarySource?: FinancialDataSource | null, sequenceNumber: number, source?: FinancialDataSource | null, sourceEntityId?: string | null, sourceInstitutionId: string, transactionsState?: FinancialPortalProductState | null, updatedAt: any, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', iavAdminDeactivated?: boolean | null, iavEnabled: boolean, id: string, loginUrl?: string | null, logoUrl?: string | null, name: string } | null } | null };

export type FinancialAccountsForUserFragmentFragment = { __typename?: 'Query', financialAccounts?: { __typename?: 'GetFinancialAccountsResponse', accounts?: Array<{ __typename?: 'FinancialAccount', autoRefreshRequired?: boolean | null, balance?: any | null, createdAt: any, currency?: any | null, extra?: any | null, iavVerified?: boolean | null, id: string, isHidden?: boolean | null, lastSyncedAt?: any | null, mask?: string | null, name?: string | null, primarySource?: FinancialDataSource | null, status?: FinancialAccountStatus | null, subtype?: FinancialAccountSubtype | null, subtypeDetails?: string | null, transactionsSyncedAt?: any | null, type?: FinancialAccountType | null, updatedAt: any, verificationState?: string | null, deleteQueuedAt?: string | null, flaggedForClosureAt?: string | null, financialPortal?: { __typename?: 'FinancialPortal', accountsState?: FinancialPortalProductState | null, activeMigration?: boolean | null, alertMessage?: FinancialPortalAlertMessage | null, alertName?: string | null, alertPriority?: string | null, authState?: FinancialPortalAuthState | null, authStateSetAt?: any | null, canonicalInstitutionId?: string | null, createdAt: any, errorMessage?: FinancialPortalErrorMessage | null, errorName?: string | null, errorPriority?: string | null, id: string, identityId: string, isActiveSync?: boolean | null, isAutoRefreshing?: boolean | null, isBalanceRefreshing?: boolean | null, isManualRefreshing?: boolean | null, lastRefreshedAt?: any | null, primarySource?: FinancialDataSource | null, sequenceNumber: number, source?: FinancialDataSource | null, sourceEntityId?: string | null, sourceInstitutionId: string, transactionsState?: FinancialPortalProductState | null, updatedAt: any, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', iavAdminDeactivated?: boolean | null, iavEnabled: boolean, id: string, loginUrl?: string | null, logoUrl?: string | null, name: string } | null } | null }> | null } | null };

export type GetFinancialAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialAccountsQuery = { __typename?: 'Query', financialAccounts?: { __typename?: 'GetFinancialAccountsResponse', accounts?: Array<{ __typename?: 'FinancialAccount', autoRefreshRequired?: boolean | null, balance?: any | null, createdAt: any, currency?: any | null, extra?: any | null, iavVerified?: boolean | null, id: string, isHidden?: boolean | null, lastSyncedAt?: any | null, mask?: string | null, name?: string | null, primarySource?: FinancialDataSource | null, status?: FinancialAccountStatus | null, subtype?: FinancialAccountSubtype | null, subtypeDetails?: string | null, transactionsSyncedAt?: any | null, type?: FinancialAccountType | null, updatedAt: any, verificationState?: string | null, deleteQueuedAt?: string | null, flaggedForClosureAt?: string | null, financialPortal?: { __typename?: 'FinancialPortal', accountsState?: FinancialPortalProductState | null, activeMigration?: boolean | null, alertMessage?: FinancialPortalAlertMessage | null, alertName?: string | null, alertPriority?: string | null, authState?: FinancialPortalAuthState | null, authStateSetAt?: any | null, canonicalInstitutionId?: string | null, createdAt: any, errorMessage?: FinancialPortalErrorMessage | null, errorName?: string | null, errorPriority?: string | null, id: string, identityId: string, isActiveSync?: boolean | null, isAutoRefreshing?: boolean | null, isBalanceRefreshing?: boolean | null, isManualRefreshing?: boolean | null, lastRefreshedAt?: any | null, primarySource?: FinancialDataSource | null, sequenceNumber: number, source?: FinancialDataSource | null, sourceEntityId?: string | null, sourceInstitutionId: string, transactionsState?: FinancialPortalProductState | null, updatedAt: any, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', iavAdminDeactivated?: boolean | null, iavEnabled: boolean, id: string, loginUrl?: string | null, logoUrl?: string | null, name: string } | null } | null }> | null } | null };

export type GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetLinkedFinancialPortalsForFinancialInstitutionsQuery = { __typename?: 'Query', linkedFinancialPortals?: { __typename?: 'GetPortalsResponse', portals?: Array<{ __typename?: 'FinancialPortal', accountsState?: FinancialPortalProductState | null, authState?: FinancialPortalAuthState | null, id: string, isActiveSync?: boolean | null, isRefreshing?: boolean | null, primarySource?: FinancialDataSource | null, transactionsState?: FinancialPortalProductState | null, sourceInstitutionId: string, updatedAt: any, deleteQueuedAt?: any | null, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', externalId?: string | null, id: string, logoUrl?: string | null, name: string } | null, migrationDetails?: { __typename?: 'FinancialPortalMigrationDetails', hasUserConfirmed: boolean } | null }> | null } | null };

export type UpdateFinancialPrioritiesMutationVariables = Exact<{
  financialPriorities: FinancialPrioritiesInput;
}>;


export type UpdateFinancialPrioritiesMutation = { __typename?: 'Mutation', updateFinancialPriorities?: { __typename?: 'FinancialPrioritiesResponse', id?: string | null, buildCredit?: boolean | null, buildWealth?: boolean | null, buyCar?: boolean | null, buyHome?: boolean | null, createAndFollowBudget?: boolean | null, maximizeCreditCardRewards?: boolean | null, payForHomeImprovements?: boolean | null, reduceDebt?: boolean | null, saveForEmergencies?: boolean | null, saveForCollege?: boolean | null, saveForRetirement?: boolean | null, startOrGrowBusiness?: boolean | null, travel?: boolean | null } | null };

export type GetCanopyIdentityIdQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCanopyIdentityIdQuery = { __typename?: 'Query', canopyIdentityId: string };

export type FetchRateReportQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type FetchRateReportQuery = { __typename?: 'Query', insurancePolicyRateReport: { __typename?: 'InsurancePolicyRateReportResponse', rateReport?: { __typename?: 'InsurancePolicyRateReport', rates: Array<{ __typename?: 'InsurancePolicyRate', id: string }> } | null } };

export type AcknowledgementCanopyTermsOfServiceMutationVariables = Exact<{
  source: Scalars['String']['input'];
  version: Scalars['String']['input'];
}>;


export type AcknowledgementCanopyTermsOfServiceMutation = { __typename?: 'Mutation', acknowledgeCanopyTermsOfServiceAgreement?: { __typename?: 'AcknowledgeCanopyTermsOfServiceAgreementResponse', success: boolean } | null };

export type AcknowledgeCoveredTermsOfServiceMutationVariables = Exact<{ [key: string]: never; }>;


export type AcknowledgeCoveredTermsOfServiceMutation = { __typename?: 'Mutation', acknowledgeCoveredTermsOfService: { __typename?: 'AcknowledgeCoveredTermsOfServiceResponse', success: boolean } };

export type GetCanopyFlowInitialDataQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCanopyFlowInitialDataQuery = { __typename?: 'Query', canopyTermsOfServiceAgreements: { __typename?: 'CanopyTermsOfServiceAgreementsResponse', success: boolean, acknowledgements?: Array<{ __typename?: 'CanopyTermsOfServiceAcknowledgement', source: string, type: string, version: string }> | null }, hasAcknowledgedCoveredTermsOfService: { __typename?: 'HasAcknowledgedCoveredTermsOfServiceResponse', acknowledged: boolean }, insurancePolicies: { __typename?: 'InsurancePoliciesResponse', policies?: Array<{ __typename?: 'InsurancePolicy', id: string, carrierName?: string | null, policyType: string }> | null } };

export type AcknowledgeCoveredTcpaConsentMutationVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type AcknowledgeCoveredTcpaConsentMutation = { __typename?: 'Mutation', acknowledgeCoveredTCPAConsent: { __typename?: 'AcknowledgeCoveredTCPAConsentResponse', success: boolean, quoteUrl: string, shoppingFinishId: string } };

export type InsurancePolicyQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type InsurancePolicyQuery = { __typename?: 'Query', insurancePolicy: { __typename?: 'InsurancePolicyResponse', success: boolean, policy?: { __typename?: 'InsurancePolicy', id: string, name?: string | null, policyNumber?: string | null, policyType: string, effectiveDate?: any | null, expiryDate?: any | null, isExpired?: boolean | null, totalPremiumCents?: number | null, carrierName?: string | null, friendlyInsuranceProviderName: string, updatedAt?: any | null, vehicles: Array<{ __typename?: 'InsuredVehicles', id: string, year?: number | null, make?: string | null, model?: string | null, type?: string | null, vin?: string | null, garagingAddress?: { __typename?: 'InsuredAddress', id: string, fullAddress?: string | null } | null, drivers: Array<{ __typename?: 'VehicleDrivers', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null, gender?: CanopyGender | null, birthdate?: string | null }> }>, dwellings: Array<{ __typename?: 'InsuredDwellings', id: string, yearBuilt?: number | null, type?: string | null, address?: { __typename?: 'InsuredAddress', fullAddress?: string | null } | null }>, namedInsureds: Array<{ __typename?: 'InsuranceNamedInsureds', id: string, firstName?: string | null, middleName?: string | null, lastName?: string | null }>, documents: Array<{ __typename?: 'InsuranceDocuments', id: string, title: string, dateAdded?: any | null, documentType?: string | null, policyId?: string | null }> } | null } };

export type HidePolicyMutationVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type HidePolicyMutation = { __typename?: 'Mutation', hidePolicy: { __typename?: 'InsurancePoliciesResponse', success: boolean, policies?: Array<{ __typename?: 'InsurancePolicy', id: string }> | null } };

export type GetRelinkNudgeReconnectTokenQueryVariables = Exact<{
  accountId: Scalars['ID']['input'];
}>;


export type GetRelinkNudgeReconnectTokenQuery = { __typename?: 'Query', accountReconnectToken?: { __typename?: 'InsuranceAccountReconnectTokenResponse', reconnectToken?: string | null } | null };

export type NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables = Exact<{
  address: NetWorthHomeValueResultAddressInput;
  source?: InputMaybe<NetWorthHomeValueResultSourceEnum>;
}>;


export type NetWorthHomeValueResultWithPossibilitiesByAddressQuery = { __typename?: 'Query', netWorthHomeValueResultWithPossibilitiesByAddress?: { __typename?: 'NetWorthHomeValueResultWithPossibilitiesResponse', data?: { __typename?: 'NetWorthHomeValueResultResponseData', propertyId?: string | null, source: NetWorthHomeValueResultSourceEnum, value?: number | null, type: NetWorthHomeValueResultTypeEnum, address?: { __typename?: 'NetWorthHomeValueResultResponseAddress', addressLine1: string, addressLine2?: string | null, city: string, state: string, zipCode: string } | null } | { __typename?: 'NetWorthHomeValuePossibilityResponseData', type: NetWorthHomeValueResultTypeEnum, possibilities?: Array<{ __typename?: 'NetWorthHomeValueResultResponseData', propertyId?: string | null, source: NetWorthHomeValueResultSourceEnum, url?: string | null, value?: number | null, address?: { __typename?: 'NetWorthHomeValueResultResponseAddress', addressLine1: string, addressLine2?: string | null, city: string, state: string, zipCode: string } | null }> | null } | null, error?: { __typename?: 'NetWorthHomeValueResultResponseError', errorType: NetWorthHomeValueResultResponseErrorTypeEnum } | null } | null };

export type NetWorthHomeValueResultByPropertyIdQueryVariables = Exact<{
  propertyId: Scalars['ID']['input'];
  source: NetWorthHomeValueResultSourceEnum;
}>;


export type NetWorthHomeValueResultByPropertyIdQuery = { __typename?: 'Query', netWorthHomeValueResultByPropertyId?: { __typename?: 'NetWorthHomeValueResultByPropertyIdResponse', data: { __typename?: 'NetWorthHomeValueResultByPropertyIdResponseData', propertyId: string, source: NetWorthHomeValueResultSourceEnum, value: number } } | null };

export type UpdateModalDismissedAtMutationVariables = Exact<{
  membershipAppActivity: MembershipAppActivityInput;
}>;


export type UpdateModalDismissedAtMutation = { __typename?: 'Mutation', updateMembershipAppActivity?: { __typename?: 'MembershipAppActivityResponse', nwPlusMaxEarnedPointsModalDismissedAt?: any | null } | null };

export type GetNwPlusPointsSummaryNwPlusContextQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusPointsSummaryNwPlusContextQuery = { __typename?: 'Query', nwPlusPointsSummary?: { __typename?: 'NwPlusPointsSummaryResponse', points: number } | null };

export type GetNetWorthQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNetWorthQuery = { __typename?: 'Query', netWorthBalancesByFinancialDataCategorization?: { __typename?: 'NetWorthBalances', totalNetWorthIncludingHomeEquity?: number | null } | null, netWorthAccounts?: { __typename?: 'NetWorthAccountsResponse', accounts: Array<{ __typename?: 'NetWorthAccount', id: string, financialAccountId: string, isHiddenFromNetWorth: boolean }> } | null, netWorthRealAssets?: { __typename?: 'NetWorthRealAssetsResponse', assets: Array<{ __typename?: 'NetWorthHomeIntegrated', id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null } | { __typename?: 'NetWorthRealAssetSelfReported', id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null }> } | null, linkedFinancialPortals?: { __typename?: 'GetPortalsResponse', portals?: Array<{ __typename?: 'FinancialPortal', id: string, accounts?: Array<{ __typename?: 'FinancialAccount', id: string, isHidden?: boolean | null, type?: FinancialAccountType | null, subtype?: FinancialAccountSubtype | null }> | null }> | null } | null, wealthRecommenderUser?: { __typename?: 'WealthRecommenderUser', id: string } | null };

export type GetNetWorthHistoryQueryVariables = Exact<{
  netWorthFilter: NetWorthHistoryFiltersEnum;
  effectiveDate: Scalars['DateTimeWithTimeOffset']['input'];
}>;


export type GetNetWorthHistoryQuery = { __typename?: 'Query', netWorthHistory?: { __typename?: 'NetWorthHistoryResponse', netWorthFilter: NetWorthHistoryFiltersEnum, history: Array<{ __typename?: 'NetWorthHistoryDataPoint', date: any, value: number } | null> } | null };

export type GetNetWorthBalancesForSummaryGraphsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNetWorthBalancesForSummaryGraphsQuery = { __typename?: 'Query', netWorthBalancesByFinancialDataCategorization?: { __typename?: 'NetWorthBalances', assetSums: { __typename?: 'NetWorthBalancesAssetSums', auto_value?: number | null, checking?: number | null, home_value?: number | null, investment?: number | null, personal_property_value?: number | null, retirement?: number | null, savings?: number | null }, debtSums: { __typename?: 'NetWorthBalancesDebtSums', credit_card?: number | null, loan?: number | null, mortgage?: number | null, non_mortgage_loan?: number | null } } | null };

export type FinancialPrioritiesFeatureDiscoveryQueryVariables = Exact<{ [key: string]: never; }>;


export type FinancialPrioritiesFeatureDiscoveryQuery = { __typename?: 'Query', financialPrioritiesFeatureDiscovery?: { __typename?: 'FinancialPrioritiesFeatureDiscoveryResponse', id?: string | null, isDismissed?: boolean | null, impressionCount?: number | null } | null };

export type UpdateFinancialPrioritiesFeatureDiscoveryMutationVariables = Exact<{
  isDismissed?: InputMaybe<Scalars['Boolean']['input']>;
  impressionCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type UpdateFinancialPrioritiesFeatureDiscoveryMutation = { __typename?: 'Mutation', updateFinancialPrioritiesFeatureDiscovery?: { __typename?: 'FinancialPrioritiesFeatureDiscoveryResponse', id?: string | null, isDismissed?: boolean | null, impressionCount?: number | null } | null };

export type RecentlyViewedQueryQueryVariables = Exact<{
  maxPagesCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type RecentlyViewedQueryQuery = { __typename?: 'Query', recentlyViewed?: Array<{ __typename?: 'RecentlyViewed', numberOfVisits: number, dateLastVisited: any, urlPath: string, id?: number | null, title?: string | null, synopsis?: any | null }> | null };

export type RewardItemFragmentFragment = { __typename?: 'RewardAvailableElement', codes?: Array<RewardableEventType> | null, copy: string, dollarValue: string, points: number, recurringPattern?: NwPlusRewardRecurringPattern | null, tooltipContent?: string | null };

export type GetCreditScoreUserInfoQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCreditScoreUserInfoQuery = { __typename?: 'Query', globalIdentityProfile?: { __typename?: 'GlobalIdentityProfile', firstName?: string | null, lastName?: string | null, phoneNumber?: string | null, dateOfBirth?: string | null, mailingAddress?: { __typename?: 'IdentityAddress', city: string, state: string, addressLine1: string, addressLine2?: string | null, zipCode: string } | null } | null };

export type GetTuTermsOfServiceAcknowledgementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTuTermsOfServiceAcknowledgementsQuery = { __typename?: 'Query', termsOfServiceIdentityProfile?: { __typename?: 'TermsOfServiceIdentityProfile', acknowledgements?: Array<{ __typename?: 'TermsOfServiceAcknowledgement', type: string, source: string, version: string }> | null } | null };

export type CreditProfileAuthStatusProfileFragmentFragment = { __typename?: 'CreditProfileAuthStatusProfile', status: CreditProfileAuthStatus, authenticatedAt?: any | null, activatedAt?: any | null, deactivatedAt?: any | null, reactivatedAt?: any | null, blockedAt?: any | null, inOtpFlow?: boolean | null, hasThinFile?: boolean | null, thinFileReason?: CreditProfileAuthThinFileReason | null, isDeceased?: boolean | null, notEnoughData?: boolean | null, numPullsInPast24Hours?: number | null, tuId?: string | null, previousStatus?: CreditProfileAuthStatus | null, message?: string | null, description?: string | null, questions?: Array<{ __typename?: 'CreditProfileAuthQuestion', id: string, type: string, text: string, sequence: number, answers: Array<{ __typename?: 'CreditProfileAuthAnswer', id: string, text: string, sequence: number }> }> | null };

export type TuCreditReportIdentityProfileFragmentFragment = { __typename?: 'TuCreditReportIdentityProfile', id?: string | null, inquiryDate?: any | null, safetyCheckPassed?: boolean | null, hasReportErrors?: boolean | null, isStale?: boolean | null, reportPulledAt?: any | null, reportPulledAtIterableDatetime?: any | null, nextReportPullAt?: any | null, vantageScore3?: number | null, vantageScore3Bucket?: TuVantageScore3Buckets | null, vantageScore3Bin?: number | null, vantageScore3Bin7Days?: number | null, vantageScore3Bin28Days?: number | null, creditScorePopulationRank?: number | null, vantageScore3ChangeDirection7Days?: TuVantageScore3ChangeDirections | null, vantageScore3ChangeDirection28Days?: TuVantageScore3ChangeDirections | null, vantageScore3ChangeDirection?: TuVantageScore3ChangeDirections | null, vantageScore3Delta?: number | null, vantageScore3Delta7Days?: number | null, vantageScore3Delta28Days?: number | null, vantageScore3DeltaBucket?: TuVantageScore3DeltaBuckets | null, numAccounts?: number | null, numOpenAccounts?: number | null, numClosedAccounts?: number | null, numInquiries?: number | null, numRecentInquiries?: number | null, numDerogatoryAccounts?: number | null, numDelinquentAccounts?: number | null, numPublicRecords?: number | null, percentUtilization?: number | null, percentOnTimePayments?: number | null, sumAgeOfCredit?: number | null, sumAvailableCredit?: number | null, sumBalances?: number | null, sumMonthlyPayments?: number | null, percentUtilizationDelta?: number | null, percentOnTimePaymentsDelta?: number | null, sumAgeOfCreditDelta?: number | null, numOpenAccountsDelta?: number | null, sumRevolvingDebtBalances?: number | null, sumAssetBackedDebtBalances?: number | null, numCreditCardAccounts?: number | null, sumCreditCardBalances?: number | null, sumCreditCardLimits?: number | null, numStudentLoanAccounts?: number | null, sumStudentLoanBalances?: number | null, numAutoLoanAccounts?: number | null, sumAutoLoanBalances?: number | null, numPersonalLoanAccounts?: number | null, sumPersonalLoanBalances?: number | null, numMortgageAccounts?: number | null, sumMortgageBalances?: number | null, numOtherLoanAccounts?: number | null, sumOtherLoanBalances?: number | null, numHelocAccounts?: number | null, sumHelocBalances?: number | null, numUtilityAccounts?: number | null, sumUtilityBalances?: number | null, numOtherAccounts?: number | null, sumOtherBalances?: number | null, numMissedPayments?: number | null, vantageScore3DeltaSinceReg?: number | null, avgAgeOfCredit?: number | null, nwSumBalancesOpenRevolvingLineOfCredit?: number | null, nwSumCreditLimitOpenRevolvingLineOfCredit?: number | null, nwPercentUtilization?: number | null, nwNumMissedPaymentsRecent?: number | null, nwAvgAgeOfCreditOpenMonths?: number | null, nwSumBalancesOpen?: number | null, nwNumMissedPaymentsRecentBucket?: TuCreditFactorBucket | null, nwPercentUtilizationBucket?: TuCreditFactorBucket | null, nwAvgAgeOfCreditOpenBucket?: TuCreditFactorBucket | null, nwNumOntimeAccounts?: number | null, nwPercentUtilization28Days?: number | null, nwNumOntimeAccounts28Days?: number | null, numAccounts28Days?: number | null, numDerogatoryAccounts28Days?: number | null, numOpenAccounts28Days?: number | null, numClosedAccounts28Days?: number | null, nwSumBalancesOpen28Days?: number | null, nwSumCreditLimitOpenRevolvingLineOfCredit28Days?: number | null, numInquiries28Days?: number | null, nwAvgAgeOfCreditOpenMonths28Days?: number | null, nwPercentUtilizationDelta28Days?: number | null, nwNumOntimeAccountsDelta28Days?: number | null, numAccountsDelta28Days?: number | null, numDerogatoryAccountsDelta28Days?: number | null, numOpenAccountsDelta28Days?: number | null, numClosedAccountsDelta28Days?: number | null, nwSumBalancesOpenDelta28Days?: number | null, nwSumCreditLimitOpenRevolvingLineOfCreditDelta28Days?: number | null, numInquiriesDelta28Days?: number | null, nwAvgAgeOfCreditOpenMonthsDelta28Days?: number | null, currentAddress?: { __typename?: 'IdentityAddress', addressLine1: string, addressLine2?: string | null, city: string, state: string, zipCode: string, longitude?: number | null, latitude?: number | null, isValidated?: boolean | null, validatedAt?: string | null, validatedBy?: string | null } | null, inquiries?: Array<{ __typename?: 'TuInquiry', subscriberName?: string | null, inquiryType?: string | null, bureau?: string | null, inquiredAt?: any | null, industry?: string | null, compositeKey?: string | null } | null> | null, tradelines?: Array<{ __typename?: 'TuTradeline', accountType?: string | null, accountTypeSymbol?: string | null, accountSubtype?: string | null, accountSubtypeSymbol?: string | null, accountNumberLast4?: string | null, accountDesignator?: string | null, accountCondition?: string | null, openClosed?: TuTradelineOpenClosed | null, openClosedSymbol?: TuTradelineOpenClosedSymbol | null, highBalance?: number | null, dateReportedAt?: any | null, dateOpenedAt?: any | null, dateClosedAt?: any | null, dateVerifiedAt?: any | null, dateAccountStatus?: any | null, currentBalance?: number | null, creditorName?: string | null, bureau?: string | null, creditLimit?: number | null, disputeFlag?: string | null, payStatus?: string | null, payStatusDescription?: string | null, remark?: string | null, paymentFrequency?: string | null, worstPayStatus?: string | null, worstPayStatusSymbol?: string | null, amountPastDue?: number | null, collateral?: string | null, lastPaymentDate?: any | null, late30Count?: number | null, late60Count?: number | null, late90Count?: number | null, monthlyPayment?: number | null, monthsReviewed?: number | null, termMonths?: number | null, worstPayStatusCount?: number | null, payHistoryStatus?: string | null, payHistoryStartDate?: any | null, accountNumberHash?: string | null, creditType?: string | null, compositeKey?: string | null, nwCreditLimitNormalized?: number | null, nwUtilizationPct?: number | null, nwDateOpenedAtNormalized?: any | null, nwMonthsOpened?: number | null, derogatoryTradelineReason?: string | null, payStatusSymbol?: string | null, nwPayStatusBucket?: string | null, nwLastMissedPaymentDate?: any | null, isIncludedInUtilization?: boolean | null, payHistoryBreakDown?: Array<{ __typename?: 'TuTradelinePayment', status: string, date: string }> | null } | null> | null, employers?: Array<{ __typename?: 'TuEmployer', name?: string | null, dateReportedAt?: any | null, dateUpdatedAt?: any | null } | null> | null, publicRecords?: Array<{ __typename?: 'TuPublicRecord', courtName?: string | null, filedAt?: any | null, referenceNumber?: string | null, subscriberCode?: string | null, bureau?: string | null, classification?: string | null, status?: string | null, type?: string | null } | null> | null };

export type InitializeCreditProfileMutationVariables = Exact<{
  customer: CreditProfileAuthCustomerInput;
}>;


export type InitializeCreditProfileMutation = { __typename?: 'Mutation', initializeCreditProfile: { __typename?: 'CreditProfileAuthStatusProfile', status: CreditProfileAuthStatus, authenticatedAt?: any | null, activatedAt?: any | null, deactivatedAt?: any | null, reactivatedAt?: any | null, blockedAt?: any | null, inOtpFlow?: boolean | null, hasThinFile?: boolean | null, thinFileReason?: CreditProfileAuthThinFileReason | null, isDeceased?: boolean | null, notEnoughData?: boolean | null, numPullsInPast24Hours?: number | null, tuId?: string | null, previousStatus?: CreditProfileAuthStatus | null, message?: string | null, description?: string | null, questions?: Array<{ __typename?: 'CreditProfileAuthQuestion', id: string, type: string, text: string, sequence: number, answers: Array<{ __typename?: 'CreditProfileAuthAnswer', id: string, text: string, sequence: number }> }> | null } };

export type AuthenticateCreditProfileQuestionsMutationVariables = Exact<{
  answers: Array<CreditProfileAuthAnswerInput> | CreditProfileAuthAnswerInput;
  resetPasscode?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type AuthenticateCreditProfileQuestionsMutation = { __typename?: 'Mutation', authenticateCreditProfileQuestions: { __typename?: 'TuCreditReportIdentityProfile', id?: string | null, inquiryDate?: any | null, safetyCheckPassed?: boolean | null, hasReportErrors?: boolean | null, isStale?: boolean | null, reportPulledAt?: any | null, reportPulledAtIterableDatetime?: any | null, nextReportPullAt?: any | null, vantageScore3?: number | null, vantageScore3Bucket?: TuVantageScore3Buckets | null, vantageScore3Bin?: number | null, vantageScore3Bin7Days?: number | null, vantageScore3Bin28Days?: number | null, creditScorePopulationRank?: number | null, vantageScore3ChangeDirection7Days?: TuVantageScore3ChangeDirections | null, vantageScore3ChangeDirection28Days?: TuVantageScore3ChangeDirections | null, vantageScore3ChangeDirection?: TuVantageScore3ChangeDirections | null, vantageScore3Delta?: number | null, vantageScore3Delta7Days?: number | null, vantageScore3Delta28Days?: number | null, vantageScore3DeltaBucket?: TuVantageScore3DeltaBuckets | null, numAccounts?: number | null, numOpenAccounts?: number | null, numClosedAccounts?: number | null, numInquiries?: number | null, numRecentInquiries?: number | null, numDerogatoryAccounts?: number | null, numDelinquentAccounts?: number | null, numPublicRecords?: number | null, percentUtilization?: number | null, percentOnTimePayments?: number | null, sumAgeOfCredit?: number | null, sumAvailableCredit?: number | null, sumBalances?: number | null, sumMonthlyPayments?: number | null, percentUtilizationDelta?: number | null, percentOnTimePaymentsDelta?: number | null, sumAgeOfCreditDelta?: number | null, numOpenAccountsDelta?: number | null, sumRevolvingDebtBalances?: number | null, sumAssetBackedDebtBalances?: number | null, numCreditCardAccounts?: number | null, sumCreditCardBalances?: number | null, sumCreditCardLimits?: number | null, numStudentLoanAccounts?: number | null, sumStudentLoanBalances?: number | null, numAutoLoanAccounts?: number | null, sumAutoLoanBalances?: number | null, numPersonalLoanAccounts?: number | null, sumPersonalLoanBalances?: number | null, numMortgageAccounts?: number | null, sumMortgageBalances?: number | null, numOtherLoanAccounts?: number | null, sumOtherLoanBalances?: number | null, numHelocAccounts?: number | null, sumHelocBalances?: number | null, numUtilityAccounts?: number | null, sumUtilityBalances?: number | null, numOtherAccounts?: number | null, sumOtherBalances?: number | null, numMissedPayments?: number | null, vantageScore3DeltaSinceReg?: number | null, avgAgeOfCredit?: number | null, nwSumBalancesOpenRevolvingLineOfCredit?: number | null, nwSumCreditLimitOpenRevolvingLineOfCredit?: number | null, nwPercentUtilization?: number | null, nwNumMissedPaymentsRecent?: number | null, nwAvgAgeOfCreditOpenMonths?: number | null, nwSumBalancesOpen?: number | null, nwNumMissedPaymentsRecentBucket?: TuCreditFactorBucket | null, nwPercentUtilizationBucket?: TuCreditFactorBucket | null, nwAvgAgeOfCreditOpenBucket?: TuCreditFactorBucket | null, nwNumOntimeAccounts?: number | null, nwPercentUtilization28Days?: number | null, nwNumOntimeAccounts28Days?: number | null, numAccounts28Days?: number | null, numDerogatoryAccounts28Days?: number | null, numOpenAccounts28Days?: number | null, numClosedAccounts28Days?: number | null, nwSumBalancesOpen28Days?: number | null, nwSumCreditLimitOpenRevolvingLineOfCredit28Days?: number | null, numInquiries28Days?: number | null, nwAvgAgeOfCreditOpenMonths28Days?: number | null, nwPercentUtilizationDelta28Days?: number | null, nwNumOntimeAccountsDelta28Days?: number | null, numAccountsDelta28Days?: number | null, numDerogatoryAccountsDelta28Days?: number | null, numOpenAccountsDelta28Days?: number | null, numClosedAccountsDelta28Days?: number | null, nwSumBalancesOpenDelta28Days?: number | null, nwSumCreditLimitOpenRevolvingLineOfCreditDelta28Days?: number | null, numInquiriesDelta28Days?: number | null, nwAvgAgeOfCreditOpenMonthsDelta28Days?: number | null, currentAddress?: { __typename?: 'IdentityAddress', addressLine1: string, addressLine2?: string | null, city: string, state: string, zipCode: string, longitude?: number | null, latitude?: number | null, isValidated?: boolean | null, validatedAt?: string | null, validatedBy?: string | null } | null, inquiries?: Array<{ __typename?: 'TuInquiry', subscriberName?: string | null, inquiryType?: string | null, bureau?: string | null, inquiredAt?: any | null, industry?: string | null, compositeKey?: string | null } | null> | null, tradelines?: Array<{ __typename?: 'TuTradeline', accountType?: string | null, accountTypeSymbol?: string | null, accountSubtype?: string | null, accountSubtypeSymbol?: string | null, accountNumberLast4?: string | null, accountDesignator?: string | null, accountCondition?: string | null, openClosed?: TuTradelineOpenClosed | null, openClosedSymbol?: TuTradelineOpenClosedSymbol | null, highBalance?: number | null, dateReportedAt?: any | null, dateOpenedAt?: any | null, dateClosedAt?: any | null, dateVerifiedAt?: any | null, dateAccountStatus?: any | null, currentBalance?: number | null, creditorName?: string | null, bureau?: string | null, creditLimit?: number | null, disputeFlag?: string | null, payStatus?: string | null, payStatusDescription?: string | null, remark?: string | null, paymentFrequency?: string | null, worstPayStatus?: string | null, worstPayStatusSymbol?: string | null, amountPastDue?: number | null, collateral?: string | null, lastPaymentDate?: any | null, late30Count?: number | null, late60Count?: number | null, late90Count?: number | null, monthlyPayment?: number | null, monthsReviewed?: number | null, termMonths?: number | null, worstPayStatusCount?: number | null, payHistoryStatus?: string | null, payHistoryStartDate?: any | null, accountNumberHash?: string | null, creditType?: string | null, compositeKey?: string | null, nwCreditLimitNormalized?: number | null, nwUtilizationPct?: number | null, nwDateOpenedAtNormalized?: any | null, nwMonthsOpened?: number | null, derogatoryTradelineReason?: string | null, payStatusSymbol?: string | null, nwPayStatusBucket?: string | null, nwLastMissedPaymentDate?: any | null, isIncludedInUtilization?: boolean | null, payHistoryBreakDown?: Array<{ __typename?: 'TuTradelinePayment', status: string, date: string }> | null } | null> | null, employers?: Array<{ __typename?: 'TuEmployer', name?: string | null, dateReportedAt?: any | null, dateUpdatedAt?: any | null } | null> | null, publicRecords?: Array<{ __typename?: 'TuPublicRecord', courtName?: string | null, filedAt?: any | null, referenceNumber?: string | null, subscriberCode?: string | null, bureau?: string | null, classification?: string | null, status?: string | null, type?: string | null } | null> | null } | { __typename?: 'CreditProfileAuthStatusProfile', status: CreditProfileAuthStatus, authenticatedAt?: any | null, activatedAt?: any | null, deactivatedAt?: any | null, reactivatedAt?: any | null, blockedAt?: any | null, inOtpFlow?: boolean | null, hasThinFile?: boolean | null, thinFileReason?: CreditProfileAuthThinFileReason | null, isDeceased?: boolean | null, notEnoughData?: boolean | null, numPullsInPast24Hours?: number | null, tuId?: string | null, previousStatus?: CreditProfileAuthStatus | null, message?: string | null, description?: string | null, questions?: Array<{ __typename?: 'CreditProfileAuthQuestion', id: string, type: string, text: string, sequence: number, answers: Array<{ __typename?: 'CreditProfileAuthAnswer', id: string, text: string, sequence: number }> }> | null } };

export type CreateTrustSessionIdMutationVariables = Exact<{
  blackBox: Scalars['String']['input'];
}>;


export type CreateTrustSessionIdMutation = { __typename?: 'Mutation', createTrustSessionId: { __typename?: 'TrustSessionIdResponse', success?: boolean | null } };

export type TuAuthenticationStatusProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type TuAuthenticationStatusProfileQuery = { __typename?: 'Query', tuAuthenticationStatusProfile?: { __typename?: 'CreditProfileAuthStatusProfile', status: CreditProfileAuthStatus, authenticatedAt?: any | null, activatedAt?: any | null, deactivatedAt?: any | null, reactivatedAt?: any | null, blockedAt?: any | null, inOtpFlow?: boolean | null, hasThinFile?: boolean | null, thinFileReason?: CreditProfileAuthThinFileReason | null, isDeceased?: boolean | null, notEnoughData?: boolean | null, numPullsInPast24Hours?: number | null, tuId?: string | null, previousStatus?: CreditProfileAuthStatus | null, message?: string | null, description?: string | null, questions?: Array<{ __typename?: 'CreditProfileAuthQuestion', id: string, type: string, text: string, sequence: number, answers: Array<{ __typename?: 'CreditProfileAuthAnswer', id: string, text: string, sequence: number }> }> | null } | null };

export type EnrollCreditProfileMutationVariables = Exact<{ [key: string]: never; }>;


export type EnrollCreditProfileMutation = { __typename?: 'Mutation', enrollCreditProfile: { __typename?: 'TuCreditReportIdentityProfile', id?: string | null, inquiryDate?: any | null, safetyCheckPassed?: boolean | null, hasReportErrors?: boolean | null, isStale?: boolean | null, reportPulledAt?: any | null, reportPulledAtIterableDatetime?: any | null, nextReportPullAt?: any | null, vantageScore3?: number | null, vantageScore3Bucket?: TuVantageScore3Buckets | null, vantageScore3Bin?: number | null, vantageScore3Bin7Days?: number | null, vantageScore3Bin28Days?: number | null, creditScorePopulationRank?: number | null, vantageScore3ChangeDirection7Days?: TuVantageScore3ChangeDirections | null, vantageScore3ChangeDirection28Days?: TuVantageScore3ChangeDirections | null, vantageScore3ChangeDirection?: TuVantageScore3ChangeDirections | null, vantageScore3Delta?: number | null, vantageScore3Delta7Days?: number | null, vantageScore3Delta28Days?: number | null, vantageScore3DeltaBucket?: TuVantageScore3DeltaBuckets | null, numAccounts?: number | null, numOpenAccounts?: number | null, numClosedAccounts?: number | null, numInquiries?: number | null, numRecentInquiries?: number | null, numDerogatoryAccounts?: number | null, numDelinquentAccounts?: number | null, numPublicRecords?: number | null, percentUtilization?: number | null, percentOnTimePayments?: number | null, sumAgeOfCredit?: number | null, sumAvailableCredit?: number | null, sumBalances?: number | null, sumMonthlyPayments?: number | null, percentUtilizationDelta?: number | null, percentOnTimePaymentsDelta?: number | null, sumAgeOfCreditDelta?: number | null, numOpenAccountsDelta?: number | null, sumRevolvingDebtBalances?: number | null, sumAssetBackedDebtBalances?: number | null, numCreditCardAccounts?: number | null, sumCreditCardBalances?: number | null, sumCreditCardLimits?: number | null, numStudentLoanAccounts?: number | null, sumStudentLoanBalances?: number | null, numAutoLoanAccounts?: number | null, sumAutoLoanBalances?: number | null, numPersonalLoanAccounts?: number | null, sumPersonalLoanBalances?: number | null, numMortgageAccounts?: number | null, sumMortgageBalances?: number | null, numOtherLoanAccounts?: number | null, sumOtherLoanBalances?: number | null, numHelocAccounts?: number | null, sumHelocBalances?: number | null, numUtilityAccounts?: number | null, sumUtilityBalances?: number | null, numOtherAccounts?: number | null, sumOtherBalances?: number | null, numMissedPayments?: number | null, vantageScore3DeltaSinceReg?: number | null, avgAgeOfCredit?: number | null, nwSumBalancesOpenRevolvingLineOfCredit?: number | null, nwSumCreditLimitOpenRevolvingLineOfCredit?: number | null, nwPercentUtilization?: number | null, nwNumMissedPaymentsRecent?: number | null, nwAvgAgeOfCreditOpenMonths?: number | null, nwSumBalancesOpen?: number | null, nwNumMissedPaymentsRecentBucket?: TuCreditFactorBucket | null, nwPercentUtilizationBucket?: TuCreditFactorBucket | null, nwAvgAgeOfCreditOpenBucket?: TuCreditFactorBucket | null, nwNumOntimeAccounts?: number | null, nwPercentUtilization28Days?: number | null, nwNumOntimeAccounts28Days?: number | null, numAccounts28Days?: number | null, numDerogatoryAccounts28Days?: number | null, numOpenAccounts28Days?: number | null, numClosedAccounts28Days?: number | null, nwSumBalancesOpen28Days?: number | null, nwSumCreditLimitOpenRevolvingLineOfCredit28Days?: number | null, numInquiries28Days?: number | null, nwAvgAgeOfCreditOpenMonths28Days?: number | null, nwPercentUtilizationDelta28Days?: number | null, nwNumOntimeAccountsDelta28Days?: number | null, numAccountsDelta28Days?: number | null, numDerogatoryAccountsDelta28Days?: number | null, numOpenAccountsDelta28Days?: number | null, numClosedAccountsDelta28Days?: number | null, nwSumBalancesOpenDelta28Days?: number | null, nwSumCreditLimitOpenRevolvingLineOfCreditDelta28Days?: number | null, numInquiriesDelta28Days?: number | null, nwAvgAgeOfCreditOpenMonthsDelta28Days?: number | null, currentAddress?: { __typename?: 'IdentityAddress', addressLine1: string, addressLine2?: string | null, city: string, state: string, zipCode: string, longitude?: number | null, latitude?: number | null, isValidated?: boolean | null, validatedAt?: string | null, validatedBy?: string | null } | null, inquiries?: Array<{ __typename?: 'TuInquiry', subscriberName?: string | null, inquiryType?: string | null, bureau?: string | null, inquiredAt?: any | null, industry?: string | null, compositeKey?: string | null } | null> | null, tradelines?: Array<{ __typename?: 'TuTradeline', accountType?: string | null, accountTypeSymbol?: string | null, accountSubtype?: string | null, accountSubtypeSymbol?: string | null, accountNumberLast4?: string | null, accountDesignator?: string | null, accountCondition?: string | null, openClosed?: TuTradelineOpenClosed | null, openClosedSymbol?: TuTradelineOpenClosedSymbol | null, highBalance?: number | null, dateReportedAt?: any | null, dateOpenedAt?: any | null, dateClosedAt?: any | null, dateVerifiedAt?: any | null, dateAccountStatus?: any | null, currentBalance?: number | null, creditorName?: string | null, bureau?: string | null, creditLimit?: number | null, disputeFlag?: string | null, payStatus?: string | null, payStatusDescription?: string | null, remark?: string | null, paymentFrequency?: string | null, worstPayStatus?: string | null, worstPayStatusSymbol?: string | null, amountPastDue?: number | null, collateral?: string | null, lastPaymentDate?: any | null, late30Count?: number | null, late60Count?: number | null, late90Count?: number | null, monthlyPayment?: number | null, monthsReviewed?: number | null, termMonths?: number | null, worstPayStatusCount?: number | null, payHistoryStatus?: string | null, payHistoryStartDate?: any | null, accountNumberHash?: string | null, creditType?: string | null, compositeKey?: string | null, nwCreditLimitNormalized?: number | null, nwUtilizationPct?: number | null, nwDateOpenedAtNormalized?: any | null, nwMonthsOpened?: number | null, derogatoryTradelineReason?: string | null, payStatusSymbol?: string | null, nwPayStatusBucket?: string | null, nwLastMissedPaymentDate?: any | null, isIncludedInUtilization?: boolean | null, payHistoryBreakDown?: Array<{ __typename?: 'TuTradelinePayment', status: string, date: string }> | null } | null> | null, employers?: Array<{ __typename?: 'TuEmployer', name?: string | null, dateReportedAt?: any | null, dateUpdatedAt?: any | null } | null> | null, publicRecords?: Array<{ __typename?: 'TuPublicRecord', courtName?: string | null, filedAt?: any | null, referenceNumber?: string | null, subscriberCode?: string | null, bureau?: string | null, classification?: string | null, status?: string | null, type?: string | null } | null> | null } };

export type AcknowledgeTuTermsOfServiceMutationVariables = Exact<{
  input: AcknowledgeTermsOfServiceInput;
}>;


export type AcknowledgeTuTermsOfServiceMutation = { __typename?: 'Mutation', acknowledgeTermsOfService?: { __typename?: 'AcknowledgeTermsOfServiceResponse', success: boolean } | null };

export type ZendeskUserInfoQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type ZendeskUserInfoQueryQuery = { __typename?: 'Query', identity?: { __typename?: 'IdentityResponse', email: string } | null, globalIdentityProfile?: { __typename?: 'GlobalIdentityProfile', firstName?: string | null, lastName?: string | null } | null };

export type ExperimentDecisionsQueryVariables = Exact<{
  testNames: Array<Scalars['String']['input']> | Scalars['String']['input'];
  userAttributes: Scalars['JSON']['input'];
}>;


export type ExperimentDecisionsQuery = { __typename?: 'Query', experimentDecisions?: Array<{ __typename?: 'ExperimentDecision', experimentName: string, assignedVariantName: string }> | null };

export type GetCanopyTermsOfServiceAgreementsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCanopyTermsOfServiceAgreementsQuery = { __typename?: 'Query', canopyTermsOfServiceAgreements: { __typename?: 'CanopyTermsOfServiceAgreementsResponse', success: boolean, acknowledgements?: Array<{ __typename?: 'CanopyTermsOfServiceAcknowledgement', source: string, type: string, version: string }> | null } };

export type GetCoveredTermsOfServiceAcknowledgementQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCoveredTermsOfServiceAcknowledgementQuery = { __typename?: 'Query', hasAcknowledgedCoveredTermsOfService: { __typename?: 'HasAcknowledgedCoveredTermsOfServiceResponse', acknowledged: boolean } };

export type GetNwPlusAvailableRewardsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusAvailableRewardsQuery = { __typename?: 'Query', nwPlusAvailableRewards?: { __typename?: 'NwPlusAvailableRewardsResponse', oneTimeRewards?: Array<{ __typename?: 'RewardAvailableElement', codes?: Array<RewardableEventType> | null, copy: string, dollarValue: string, points: number, recurringPattern?: NwPlusRewardRecurringPattern | null, tooltipContent?: string | null }> | null, premiumRewards?: Array<{ __typename?: 'RewardAvailableElement', codes?: Array<RewardableEventType> | null, copy: string, dollarValue: string, points: number, recurringPattern?: NwPlusRewardRecurringPattern | null, tooltipContent?: string | null }> | null, recurringRewards?: Array<{ __typename?: 'RewardAvailableElement', codes?: Array<RewardableEventType> | null, copy: string, dollarValue: string, points: number, recurringPattern?: NwPlusRewardRecurringPattern | null, tooltipContent?: string | null }> | null } | null };

export type CoveredQuoteStatusQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type CoveredQuoteStatusQuery = { __typename?: 'Query', coveredQuoteStatus: { __typename?: 'CoveredQuoteStatusResponse', status: QuoteStatus, quoteUrl?: string | null, shoppingFinishId: string } };

export type EmitRewardableEventMutationVariables = Exact<{
  type: Scalars['String']['input'];
  payload?: InputMaybe<Scalars['JSON']['input']>;
}>;


export type EmitRewardableEventMutation = { __typename?: 'Mutation', earnReward: { __typename?: 'EarnRewardResponse', eventId: string, status: EarnRewardSuccessStatus, points?: number | null } };

export type GetClickedBankingOffersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetClickedBankingOffersQuery = { __typename?: 'Query', financialNwPlusRewards: { __typename?: 'FinancialNwPlusRewardResponse', bankingAccounts: Array<{ __typename?: 'FinancialBankingReward', shoppingFinishedAt: any, marketplaceBankingOffer: { __typename?: 'BankingOfferV2', id: string } }> } };

export type AnonymousShoppingEventsQueryVariables = Exact<{
  anonymousId: Scalars['ID']['input'];
}>;


export type AnonymousShoppingEventsQuery = { __typename?: 'Query', anonymousShoppingEvents?: { __typename?: 'AnonymousShoppingEventsResponse', items?: Array<{ __typename?: 'ShoppingEventItem', shoppingFinishedId?: string | null, shoppingFinishedAt?: string | null, marketplaceInstitutionId?: string | null, marketplaceProductId?: string | null, marketplaceOfferId?: string | null, productType?: string | null, nwPlusActivationStatus?: string | null } | null> | null } | null };

export type EligibleBankingAccountsQueryVariables = Exact<{
  productType: Scalars['String']['input'];
  query?: InputMaybe<Array<MarketplaceQueryInput> | MarketplaceQueryInput>;
}>;


export type EligibleBankingAccountsQuery = { __typename?: 'Query', marketplaceSearch: { __typename?: 'MarketplaceSearchResponse', entities?: Array<{ __typename?: 'InsuranceOfferV2' } | { __typename?: 'CreditCardsOfferV2' } | { __typename?: 'InsuranceProductV2' } | { __typename?: 'InsuranceInstitutionV2' } | { __typename?: 'CaBankingInstitutionV2' } | { __typename?: 'CaBankingProductV2' } | { __typename?: 'CaBankingOfferV2' } | { __typename?: 'CaCreditCardsInstitutionV2' } | { __typename?: 'CaCreditCardsProductV2' } | { __typename?: 'CaCreditCardsOfferV2' } | { __typename?: 'InvestingOfferV2' } | { __typename?: 'InvestingProductV2' } | { __typename?: 'InvestingInstitutionV2' } | { __typename?: 'NerdwalletPlusInstitutionV2' } | { __typename?: 'NerdwalletPlusProductV2' } | { __typename?: 'NerdwalletPlusOfferV2' } | { __typename?: 'AutoLoansOfferV2' } | { __typename?: 'AutoServicesInstitutionV2' } | { __typename?: 'AutoServicesOfferV2' } | { __typename?: 'AutoServicesProductV2' } | { __typename?: 'BankingOfferV2', displayName?: string | null, id: string, institution: { __typename?: 'InsuranceOfferV2', id: string, name: string } | { __typename?: 'CreditCardsOfferV2', id: string, name: string } | { __typename?: 'InsuranceProductV2', id: string, name: string } | { __typename?: 'InsuranceInstitutionV2', id: string, name: string } | { __typename?: 'CaBankingInstitutionV2', id: string, name: string } | { __typename?: 'CaBankingProductV2', id: string, name: string } | { __typename?: 'CaBankingOfferV2', id: string, name: string } | { __typename?: 'CaCreditCardsInstitutionV2', id: string, name: string } | { __typename?: 'CaCreditCardsProductV2', id: string, name: string } | { __typename?: 'CaCreditCardsOfferV2', id: string, name: string } | { __typename?: 'InvestingOfferV2', id: string, name: string } | { __typename?: 'InvestingProductV2', id: string, name: string } | { __typename?: 'InvestingInstitutionV2', id: string, name: string } | { __typename?: 'NerdwalletPlusInstitutionV2', id: string, name: string } | { __typename?: 'NerdwalletPlusProductV2', id: string, name: string } | { __typename?: 'NerdwalletPlusOfferV2', id: string, name: string } | { __typename?: 'AutoLoansOfferV2', id: string, name: string } | { __typename?: 'AutoServicesInstitutionV2', id: string, name: string } | { __typename?: 'AutoServicesOfferV2', id: string, name: string } | { __typename?: 'AutoServicesProductV2', id: string, name: string } | { __typename?: 'BankingOfferV2', id: string, name: string } | { __typename?: 'EducationLoansOfferV2', id: string, name: string } | { __typename?: 'MortgagesOfferV2', id: string, name: string } | { __typename?: 'SoftwareOfferV2', id: string, name: string } | { __typename?: 'EstatePlanningOfferV2', id: string, name: string } | { __typename?: 'ExpansionOfferV2', id: string, name: string } | { __typename?: 'AutoLoansInstitutionV2', id: string, name: string } | { __typename?: 'AutoLoansProductV2', id: string, name: string } | { __typename?: 'BankingInstitutionV2', id: string, name: string } | { __typename?: 'BankingProductV2', id: string, name: string } | { __typename?: 'CreditCardsInstitutionV2', id: string, name: string } | { __typename?: 'CreditCardsProductV2', id: string, name: string } | { __typename?: 'EducationLoansInstitutionV2', id: string, name: string } | { __typename?: 'EducationLoansProductV2', id: string, name: string } | { __typename?: 'EstatePlanningInstitutionV2', id: string, name: string } | { __typename?: 'EstatePlanningProductV2', id: string, name: string } | { __typename?: 'ExpansionInstitutionV2', id: string, name: string } | { __typename?: 'ExpansionProductV2', id: string, name: string } | { __typename?: 'MortgagesInstitutionV2', id: string, name: string } | { __typename?: 'MortgagesProductV2', id: string, name: string } | { __typename?: 'PersonalLoansInstitutionV2', id: string, name: string } | { __typename?: 'PersonalLoansOfferV2', id: string, name: string } | { __typename?: 'PersonalLoansProductV2', id: string, name: string } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2', id: string, name: string } | { __typename?: 'SmallMediumBusinessLoansOfferV2', id: string, name: string } | { __typename?: 'SmallMediumBusinessLoansProductV2', id: string, name: string } | { __typename?: 'SoftwareInstitutionV2', id: string, name: string } | { __typename?: 'SoftwareProductV2', id: string, name: string } | { __typename?: 'ThirdPartyEmbedsInstitution', id: string, name: string } | { __typename?: 'ThirdPartyEmbedsProduct', id: string, name: string }, product: { __typename?: 'BankingProductV2', id: string, name: string } } | { __typename?: 'EducationLoansOfferV2' } | { __typename?: 'MortgagesOfferV2' } | { __typename?: 'SoftwareOfferV2' } | { __typename?: 'EstatePlanningOfferV2' } | { __typename?: 'ExpansionOfferV2' } | { __typename?: 'AutoLoansInstitutionV2' } | { __typename?: 'AutoLoansProductV2' } | { __typename?: 'BankingInstitutionV2' } | { __typename?: 'BankingProductV2' } | { __typename?: 'CreditCardsInstitutionV2' } | { __typename?: 'CreditCardsProductV2' } | { __typename?: 'EducationLoansInstitutionV2' } | { __typename?: 'EducationLoansProductV2' } | { __typename?: 'EstatePlanningInstitutionV2' } | { __typename?: 'EstatePlanningProductV2' } | { __typename?: 'ExpansionInstitutionV2' } | { __typename?: 'ExpansionProductV2' } | { __typename?: 'MortgagesInstitutionV2' } | { __typename?: 'MortgagesProductV2' } | { __typename?: 'PersonalLoansInstitutionV2' } | { __typename?: 'PersonalLoansOfferV2' } | { __typename?: 'PersonalLoansProductV2' } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2' } | { __typename?: 'SmallMediumBusinessLoansOfferV2' } | { __typename?: 'SmallMediumBusinessLoansProductV2' } | { __typename?: 'SoftwareInstitutionV2' } | { __typename?: 'SoftwareProductV2' } | { __typename?: 'ThirdPartyEmbedsInstitution' } | { __typename?: 'ThirdPartyEmbedsProduct' }> | null } };

export type EligibleBankingNwPlusAccountsQueryVariables = Exact<{
  productType: Scalars['String']['input'];
  query?: InputMaybe<Array<MarketplaceQueryInput> | MarketplaceQueryInput>;
}>;


export type EligibleBankingNwPlusAccountsQuery = { __typename?: 'Query', marketplaceSearch: { __typename?: 'MarketplaceSearchResponse', entities?: Array<{ __typename?: 'InsuranceOfferV2' } | { __typename?: 'CreditCardsOfferV2' } | { __typename?: 'InsuranceProductV2' } | { __typename?: 'InsuranceInstitutionV2' } | { __typename?: 'CaBankingInstitutionV2' } | { __typename?: 'CaBankingProductV2' } | { __typename?: 'CaBankingOfferV2' } | { __typename?: 'CaCreditCardsInstitutionV2' } | { __typename?: 'CaCreditCardsProductV2' } | { __typename?: 'CaCreditCardsOfferV2' } | { __typename?: 'InvestingOfferV2' } | { __typename?: 'InvestingProductV2' } | { __typename?: 'InvestingInstitutionV2' } | { __typename?: 'NerdwalletPlusInstitutionV2' } | { __typename?: 'NerdwalletPlusProductV2' } | { __typename?: 'NerdwalletPlusOfferV2' } | { __typename?: 'AutoLoansOfferV2' } | { __typename?: 'AutoServicesInstitutionV2' } | { __typename?: 'AutoServicesOfferV2' } | { __typename?: 'AutoServicesProductV2' } | { __typename?: 'BankingOfferV2', id: string, productType: string, status: MarketplaceStatusEnum, federallyInsuredAnnotation?: string | null, displayName?: string | null, monetizable: string, showNameInComparisonTable: boolean, isMonetizing?: boolean | null, versionId: number, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, legacyIssuer: string, legacySlug?: string | null, offerId?: string | null, productId?: string | null, hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyVertical?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, source?: any | null } | null, placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, id: string, label: string, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> } | { __typename?: 'EducationLoansOfferV2' } | { __typename?: 'MortgagesOfferV2' } | { __typename?: 'SoftwareOfferV2' } | { __typename?: 'EstatePlanningOfferV2' } | { __typename?: 'ExpansionOfferV2' } | { __typename?: 'AutoLoansInstitutionV2' } | { __typename?: 'AutoLoansProductV2' } | { __typename?: 'BankingInstitutionV2' } | { __typename?: 'BankingProductV2' } | { __typename?: 'CreditCardsInstitutionV2' } | { __typename?: 'CreditCardsProductV2' } | { __typename?: 'EducationLoansInstitutionV2' } | { __typename?: 'EducationLoansProductV2' } | { __typename?: 'EstatePlanningInstitutionV2' } | { __typename?: 'EstatePlanningProductV2' } | { __typename?: 'ExpansionInstitutionV2' } | { __typename?: 'ExpansionProductV2' } | { __typename?: 'MortgagesInstitutionV2' } | { __typename?: 'MortgagesProductV2' } | { __typename?: 'PersonalLoansInstitutionV2' } | { __typename?: 'PersonalLoansOfferV2' } | { __typename?: 'PersonalLoansProductV2' } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2' } | { __typename?: 'SmallMediumBusinessLoansOfferV2' } | { __typename?: 'SmallMediumBusinessLoansProductV2' } | { __typename?: 'SoftwareInstitutionV2' } | { __typename?: 'SoftwareProductV2' } | { __typename?: 'ThirdPartyEmbedsInstitution' } | { __typename?: 'ThirdPartyEmbedsProduct' }> | null } };

export type GetInsurancePullQueryVariables = Exact<{
  pullId: Scalars['ID']['input'];
}>;


export type GetInsurancePullQuery = { __typename?: 'Query', insurancePull: { __typename?: 'InsurancePullResponse', success: boolean, pull?: { __typename?: 'InsurancePull', id: string, carrierName?: string | null, friendlyCarrierName?: string | null, policies?: Array<{ __typename?: 'InsurancePolicy', id: string, carrierName?: string | null, friendlyCarrierName: string, isExpired?: boolean | null, policyDurationMonths?: number | null, policyType: string, totalPremiumCents?: number | null }> | null, unsupportedPolicies: Array<{ __typename?: 'UnsupportedPolicyTypes', rawValue: string, friendlyValue: string }> } | null } };

export type GetIsNerdWalletPlusMemberQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIsNerdWalletPlusMemberQuery = { __typename?: 'Query', identity?: { __typename?: 'IdentityResponse', id: string, isNerdWalletPlusMember: boolean, roles: Array<string> } | null };

export type RichTextFragmentFragment = { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', url: string, text: string, tag: string, type: NwPlusFaqLinkType }> | null };

export type GetInvestmentAccountsRewardsQueryVariables = Exact<{
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type GetInvestmentAccountsRewardsQuery = { __typename?: 'Query', investmentAccountsNwPlusRewards: { __typename?: 'InvestmentAccountNwPlusRewardResponse', rewards: Array<{ __typename?: 'InvestmentAccountNwPlusRewardStatus', rewardTypes: Array<{ __typename?: 'RewardEventPoints', points?: number | null, eventType: string }>, steps: Array<{ __typename?: 'FinancialNwPlusRewardStep', status: NwPlusRewardStepStatus, analyticsStatus: string, title: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', url: string, text: string, tag: string, type: NwPlusFaqLinkType }> | null }, tagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', url: string, text: string, tag: string, type: NwPlusFaqLinkType }> | null } | null, alertMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', url: string, text: string, tag: string, type: NwPlusFaqLinkType }> | null } | null, extraTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', url: string, text: string, tag: string, type: NwPlusFaqLinkType }> | null } | null, failedTagline?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', url: string, text: string, tag: string, type: NwPlusFaqLinkType }> | null } | null, ctaText?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', url: string, text: string, tag: string, type: NwPlusFaqLinkType }> | null } | null, infoMessage?: { __typename?: 'NwPlusRichText', text: string, links?: Array<{ __typename?: 'NwPlusFaqLink', url: string, text: string, tag: string, type: NwPlusFaqLinkType }> | null } | null }> }> } };

export type UpdateFinancialNwPlusRewardViewedMutationVariables = Exact<{
  id: Scalars['ID']['input'];
  eventId: Scalars['ID']['input'];
}>;


export type UpdateFinancialNwPlusRewardViewedMutation = { __typename?: 'Mutation', updateFinancialNwPlusRewardViewed?: { __typename?: 'UpdateFinancialRewardViewedResponse', creditCard?: { __typename?: 'FinancialCreditCardReward', id: string, events: Array<{ __typename?: 'FinancialCreditCardRewardEvent', id: string, eventType: FinancialCreditCardRewardEnum, emittedAt: any, viewedAt?: any | null, pointsRewarded?: number | null }> } | null, bankingAccount?: { __typename?: 'FinancialBankingReward', id: string, events: Array<{ __typename?: 'FinancialBankingRewardEvent', id: string, eventType: FinancialBankingRewardEnum, emittedAt: any, viewedAt?: any | null, pointsRewarded?: number | null }> } | null } | null };

export type GetRewardEventPointsUseRewardsPointsHookQueryVariables = Exact<{
  eventTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
  includeAll?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetRewardEventPointsUseRewardsPointsHookQuery = { __typename?: 'Query', rewardEventPoints: { __typename?: 'RewardEventPointsResponse', rewards: Array<{ __typename?: 'RewardEventPoints', eventType: string, points?: number | null }> } };

export type GetInsurancePolicyRateReportQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetInsurancePolicyRateReportQuery = { __typename?: 'Query', insurancePolicyRateReport: { __typename?: 'InsurancePolicyRateReportResponse', rateReport?: { __typename?: 'InsurancePolicyRateReport', policyId: string, updatedAt: any, rates: Array<{ __typename?: 'InsurancePolicyRate', id: string, annualPremium: number, marketplaceProductId?: string | null, marketplaceProductName?: string | null, marketplaceEntity?: { __typename?: 'MarketplaceEntity', starRating?: number | null, reviewLink?: string | null, productBottomLine?: string | null, institution?: { __typename?: 'MarketplaceInstitution', id: string, name: string } | null } | null }> } | null } };

export type BudgetBreakdownByMonthQueryVariables = Exact<{
  numMonths?: InputMaybe<Scalars['Int']['input']>;
  today?: InputMaybe<Scalars['DateTime']['input']>;
}>;


export type BudgetBreakdownByMonthQuery = { __typename?: 'Query', financialTransactionsBudgetBreakdownByMonth?: { __typename?: 'FinancialTransactionsBudgetBreakdownByMonthResponse', budgetBreakdownByMonth: Array<{ __typename?: 'FinancialTransactionsBudgetBreakdownMonth', year: number, month: number, spend: number, saved: number, income: number, isInGuidelines: boolean, bucketBreakdown: { __typename?: 'FinancialTransactionsBudgetBreakdown', wants: { __typename?: 'FinancialTransactionsBudgetBreakdownItem', total: number, incomePercent: number, amountOverGoal: number, goal: number, categories: Array<{ __typename?: 'FinancialTransactionsCategorySpendingAmount', amount: number, category?: FinancialTransactionCategory | null, categoryId?: number | null }> }, needs: { __typename?: 'FinancialTransactionsBudgetBreakdownItem', total: number, incomePercent: number, amountOverGoal: number, goal: number, categories: Array<{ __typename?: 'FinancialTransactionsCategorySpendingAmount', amount: number, category?: FinancialTransactionCategory | null, categoryId?: number | null }> }, savingsAndDebt: { __typename?: 'FinancialTransactionsBudgetBreakdownItem', total: number, incomePercent: number, amountOverGoal: number, goal: number, categories: Array<{ __typename?: 'FinancialTransactionsCategorySpendingAmount', amount: number, category?: FinancialTransactionCategory | null, categoryId?: number | null }> } } }> } | null };

export type GetFinancialTransactionCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialTransactionCategoriesQuery = { __typename?: 'Query', financialTransactionCategories?: { __typename?: 'FinancialTransactionCategoriesResponse', categories: Array<{ __typename?: 'FinancialTransactionCategoryConfig', id: number, iconUri: string, displayName: string }> } | null };

export type GetFeatureFlagQueryVariables = Exact<{
  name: Scalars['String']['input'];
}>;


export type GetFeatureFlagQuery = { __typename?: 'Query', featureFlag?: { __typename?: 'FeatureFlag', name: string, value: boolean } | null };

export type GetScopesForMfaMiddlewareQueryVariables = Exact<{ [key: string]: never; }>;


export type GetScopesForMfaMiddlewareQuery = { __typename?: 'Query', identity?: { __typename?: 'IdentityResponse', id: string, isNerdWalletPlusMember: boolean, scopes: Array<string>, roles: Array<string> } | null };

export type BankingOfferQueryQueryVariables = Exact<{
  namedQuery: Scalars['String']['input'];
}>;


export type BankingOfferQueryQuery = { __typename?: 'Query', marketplaceSearch: { __typename?: 'MarketplaceSearchResponse', entities?: Array<{ __typename?: 'InsuranceOfferV2' } | { __typename?: 'CreditCardsOfferV2' } | { __typename?: 'InsuranceProductV2' } | { __typename?: 'InsuranceInstitutionV2' } | { __typename?: 'CaBankingInstitutionV2' } | { __typename?: 'CaBankingProductV2' } | { __typename?: 'CaBankingOfferV2' } | { __typename?: 'CaCreditCardsInstitutionV2' } | { __typename?: 'CaCreditCardsProductV2' } | { __typename?: 'CaCreditCardsOfferV2' } | { __typename?: 'InvestingOfferV2' } | { __typename?: 'InvestingProductV2' } | { __typename?: 'InvestingInstitutionV2' } | { __typename?: 'NerdwalletPlusInstitutionV2' } | { __typename?: 'NerdwalletPlusProductV2' } | { __typename?: 'NerdwalletPlusOfferV2' } | { __typename?: 'AutoLoansOfferV2' } | { __typename?: 'AutoServicesInstitutionV2' } | { __typename?: 'AutoServicesOfferV2' } | { __typename?: 'AutoServicesProductV2' } | { __typename?: 'BankingOfferV2', id: string, productType: string, status: MarketplaceStatusEnum, federallyInsuredAnnotation?: string | null, displayName?: string | null, monetizable: string, showNameInComparisonTable: boolean, isMonetizing?: boolean | null, versionId: number, reviewLink?: any | null, starRating?: number | null, starRatingTooltip?: string | null, analyticsProps?: { __typename?: 'EntityPlacementAnalyticsProps', institutionId: string, legacyIssuer: string, legacySlug?: string | null, offerId?: string | null, productId?: string | null, hasLegacyImpression: boolean, legacyAdditionalEventData?: any | null, legacyVertical?: string | null } | null, cta?: { __typename?: 'EntityPlacementCTA', link: any, subtext?: string | null, text: string, type: EntityPlacementCtaTypeEnum } | null, image?: { __typename?: 'EntityPlacementImage', alt?: string | null, source?: any | null } | null, placementDrivers: Array<{ __typename?: 'EntityPlacementDriver', description?: string | null, id: string, label: string, value?: string | null, valueTooltip?: string | null, valueTooltipHasHtml: boolean }> } | { __typename?: 'EducationLoansOfferV2' } | { __typename?: 'MortgagesOfferV2' } | { __typename?: 'SoftwareOfferV2' } | { __typename?: 'EstatePlanningOfferV2' } | { __typename?: 'ExpansionOfferV2' } | { __typename?: 'AutoLoansInstitutionV2' } | { __typename?: 'AutoLoansProductV2' } | { __typename?: 'BankingInstitutionV2' } | { __typename?: 'BankingProductV2' } | { __typename?: 'CreditCardsInstitutionV2' } | { __typename?: 'CreditCardsProductV2' } | { __typename?: 'EducationLoansInstitutionV2' } | { __typename?: 'EducationLoansProductV2' } | { __typename?: 'EstatePlanningInstitutionV2' } | { __typename?: 'EstatePlanningProductV2' } | { __typename?: 'ExpansionInstitutionV2' } | { __typename?: 'ExpansionProductV2' } | { __typename?: 'MortgagesInstitutionV2' } | { __typename?: 'MortgagesProductV2' } | { __typename?: 'PersonalLoansInstitutionV2' } | { __typename?: 'PersonalLoansOfferV2' } | { __typename?: 'PersonalLoansProductV2' } | { __typename?: 'SmallMediumBusinessLoansInstitutionV2' } | { __typename?: 'SmallMediumBusinessLoansOfferV2' } | { __typename?: 'SmallMediumBusinessLoansProductV2' } | { __typename?: 'SoftwareInstitutionV2' } | { __typename?: 'SoftwareProductV2' } | { __typename?: 'ThirdPartyEmbedsInstitution' } | { __typename?: 'ThirdPartyEmbedsProduct' }> | null } };

export type GetInsurancePolicyQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type GetInsurancePolicyQuery = { __typename?: 'Query', insurancePolicy: { __typename?: 'InsurancePolicyResponse', success: boolean, policy?: { __typename?: 'InsurancePolicy', id: string, name?: string | null, carrierName?: string | null, policyType: string, policyDurationMonths?: number | null, effectiveDate?: any | null, expiryDate?: any | null, isExpired?: boolean | null, totalPremiumCents?: number | null, monthlyPremiumCents?: number | null, updatedAt?: any | null, vehicles: Array<{ __typename?: 'InsuredVehicles', garagingAddress?: { __typename?: 'InsuredAddress', zip?: string | null, state?: string | null } | null }>, dwellings: Array<{ __typename?: 'InsuredDwellings', id: string, address?: { __typename?: 'InsuredAddress', state?: string | null } | null }> } | null }, insurancePolicyOverrides?: { __typename?: 'InsurancePolicyOverridesResponse', id: string, overrides?: { __typename?: 'InsurancePolicyOverrides', policy?: { __typename?: 'LocalInsurancePolicyOverrides', zipCode?: string | null } | null } | null } | null };

export type GetInsurancePolicyOverridesQueryVariables = Exact<{
  policyId: Scalars['ID']['input'];
}>;


export type GetInsurancePolicyOverridesQuery = { __typename?: 'Query', tuCreditReportIdentityProfile?: { __typename?: 'TuCreditReportIdentityProfile', vantageScore3?: number | null } | null, insurancePolicyOverrides?: { __typename?: 'InsurancePolicyOverridesResponse', id: string, policy?: { __typename?: 'InsurancePolicyOverridePolicy', id: string, type: string } | null, overrides?: { __typename?: 'InsurancePolicyOverrides', global?: { __typename?: 'GlobalInsurancePolicyOverrides', birthdate?: string | null, creditScore?: number | null, gender?: CanopyGender | null } | null, policy?: { __typename?: 'LocalInsurancePolicyOverrides', carYear?: number | null, carMake?: string | null, carModel?: string | null, zipCode?: string | null, yearBuilt?: number | null } | null } | null } | null };

export type UpdateInsurancePolicyOverridesMutationVariables = Exact<{
  policyId: Scalars['ID']['input'];
  globalOverrides: GlobalInsurancePolicyOverridesInput;
  localOverrides: LocalInsurancePolicyOverridesInput;
}>;


export type UpdateInsurancePolicyOverridesMutation = { __typename?: 'Mutation', updateInsurancePolicyOverrides: { __typename?: 'InsurancePolicyOverridesResponse', id: string, policy?: { __typename?: 'InsurancePolicyOverridePolicy', id: string, type: string } | null, overrides?: { __typename?: 'InsurancePolicyOverrides', global?: { __typename?: 'GlobalInsurancePolicyOverrides', birthdate?: string | null, creditScore?: number | null, gender?: CanopyGender | null } | null, policy?: { __typename?: 'LocalInsurancePolicyOverrides', carYear?: number | null, carMake?: string | null, carModel?: string | null, yearBuilt?: number | null, zipCode?: string | null } | null } | null } };

export type FinancialPrioritiesFragmentFragment = { __typename?: 'FinancialPrioritiesResponse', buildCredit?: boolean | null, buildWealth?: boolean | null, buyCar?: boolean | null, buyHome?: boolean | null, createAndFollowBudget?: boolean | null, maximizeCreditCardRewards?: boolean | null, payForHomeImprovements?: boolean | null, reduceDebt?: boolean | null, saveForEmergencies?: boolean | null, saveForCollege?: boolean | null, saveForRetirement?: boolean | null, startOrGrowBusiness?: boolean | null, travel?: boolean | null };

export type GetFinancialPrioritiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialPrioritiesQuery = { __typename?: 'Query', financialPriorities?: { __typename?: 'FinancialPrioritiesResponse', id?: string | null, buildCredit?: boolean | null, buildWealth?: boolean | null, buyCar?: boolean | null, buyHome?: boolean | null, createAndFollowBudget?: boolean | null, maximizeCreditCardRewards?: boolean | null, payForHomeImprovements?: boolean | null, reduceDebt?: boolean | null, saveForEmergencies?: boolean | null, saveForCollege?: boolean | null, saveForRetirement?: boolean | null, startOrGrowBusiness?: boolean | null, travel?: boolean | null } | null };

export type AddNetWorthHomeIntegratedMutationVariables = Exact<{
  address: NetWorthHomeIntegratedAddressInput;
  externalInfo: NetWorthHomeIntegratedExternalInfoInput;
}>;


export type AddNetWorthHomeIntegratedMutation = { __typename?: 'Mutation', addNetWorthHomeIntegrated?: { __typename?: 'AddNetWorthHomeIntegratedResponse', asset: { __typename?: 'NetWorthHomeIntegrated', id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null, amount?: number | null, lastReportedOrSyncedAt?: any | null, isSelfReported: boolean, address: { __typename?: 'NetWorthHomeIntegratedAddress', addressLine1?: string | null, addressLine2?: string | null, city?: string | null, state?: string | null, zipCode?: string | null }, externalInfo?: { __typename?: 'NetWorthHomeIntegratedExternalInfo', source: NetWorthHomeValueResultSourceEnum, value?: number | null } | null } } | null };

export type AddNetWorthRealAssetSelfReportedMutationVariables = Exact<{
  type: NetWorthRealAssetTypeEnum;
  amount: Scalars['Float']['input'];
  nickname: Scalars['String']['input'];
}>;


export type AddNetWorthRealAssetSelfReportedMutation = { __typename?: 'Mutation', addNetWorthRealAssetSelfReported?: { __typename?: 'AddNetWorthRealAssetSelfReportedResponse', asset: { __typename?: 'NetWorthRealAssetSelfReported', id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null, amount?: number | null, lastReportedOrSyncedAt?: any | null, nickname: string, isSelfReported: boolean } } | null };

export type DeactivateCreditProfileMutationVariables = Exact<{ [key: string]: never; }>;


export type DeactivateCreditProfileMutation = { __typename?: 'Mutation', deactivateCreditProfile: { __typename?: 'CreditProfileAuthStatusProfile', status: CreditProfileAuthStatus, authenticatedAt?: any | null, activatedAt?: any | null, deactivatedAt?: any | null, reactivatedAt?: any | null, blockedAt?: any | null, inOtpFlow?: boolean | null, hasThinFile?: boolean | null, thinFileReason?: CreditProfileAuthThinFileReason | null, isDeceased?: boolean | null, notEnoughData?: boolean | null, numPullsInPast24Hours?: number | null, tuId?: string | null, previousStatus?: CreditProfileAuthStatus | null, message?: string | null, description?: string | null, questions?: Array<{ __typename?: 'CreditProfileAuthQuestion', id: string, type: string, text: string, sequence: number, answers: Array<{ __typename?: 'CreditProfileAuthAnswer', id: string, text: string, sequence: number }> }> | null } };

export type FinancialPortalFragmentFragment = { __typename?: 'FinancialPortal', createdAt: any, id: string, identityId: string, primarySource?: FinancialDataSource | null, sequenceNumber: number, source?: FinancialDataSource | null, sourceEntityId?: string | null, updatedAt: any, accountsState?: FinancialPortalProductState | null, activeMigration?: boolean | null, alertMessage?: FinancialPortalAlertMessage | null, alertName?: string | null, alertPriority?: string | null, authState?: FinancialPortalAuthState | null, authStateSetAt?: any | null, deleteQueuedAt?: any | null, canonicalInstitutionId?: string | null, errorMessage?: FinancialPortalErrorMessage | null, errorName?: string | null, errorPriority?: string | null, isActiveSync?: boolean | null, isAutoRefreshing?: boolean | null, isBalanceRefreshing?: boolean | null, isManualRefreshing?: boolean | null, isRefreshing?: boolean | null, lastRefreshedAt?: any | null, primaryClientAction?: FinancialPortalPrimaryClientAction | null, sourceInstitutionId: string, transactionsState?: FinancialPortalProductState | null, migrationDetails?: { __typename?: 'FinancialPortalMigrationDetails', hasUserConfirmed: boolean } | null, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', id: string, name: string, loginUrl?: string | null, logoUrl?: string | null, iavEnabled: boolean, iavAdminDeactivated?: boolean | null, externalId?: string | null, aggregatorType?: MarketplaceAggregatorType | null } | null };

export type LinkedFinancialPortalsForUserFragmentFragment = { __typename?: 'Query', linkedFinancialPortals?: { __typename?: 'GetPortalsResponse', portals?: Array<{ __typename?: 'FinancialPortal', createdAt: any, id: string, identityId: string, primarySource?: FinancialDataSource | null, sequenceNumber: number, source?: FinancialDataSource | null, sourceEntityId?: string | null, updatedAt: any, accountsState?: FinancialPortalProductState | null, activeMigration?: boolean | null, alertMessage?: FinancialPortalAlertMessage | null, alertName?: string | null, alertPriority?: string | null, authState?: FinancialPortalAuthState | null, authStateSetAt?: any | null, deleteQueuedAt?: any | null, canonicalInstitutionId?: string | null, errorMessage?: FinancialPortalErrorMessage | null, errorName?: string | null, errorPriority?: string | null, isActiveSync?: boolean | null, isAutoRefreshing?: boolean | null, isBalanceRefreshing?: boolean | null, isManualRefreshing?: boolean | null, isRefreshing?: boolean | null, lastRefreshedAt?: any | null, primaryClientAction?: FinancialPortalPrimaryClientAction | null, sourceInstitutionId: string, transactionsState?: FinancialPortalProductState | null, migrationDetails?: { __typename?: 'FinancialPortalMigrationDetails', hasUserConfirmed: boolean } | null, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', id: string, name: string, loginUrl?: string | null, logoUrl?: string | null, iavEnabled: boolean, iavAdminDeactivated?: boolean | null, externalId?: string | null, aggregatorType?: MarketplaceAggregatorType | null } | null }> | null } | null };

export type FinancialAccountTypeSumsFragmentFragment = { __typename?: 'Query', financialAccountTypeSums?: { __typename?: 'FinancialAccountTypeSumsResponse', assets: any, banks: any, bills: any, creditCards: any, debts: any, investments: any, loans: any, other: any } | null };

export type GetFinancialDataProfileForUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetFinancialDataProfileForUserQuery = { __typename?: 'Query', financialAccounts?: { __typename?: 'GetFinancialAccountsResponse', accounts?: Array<{ __typename?: 'FinancialAccount', autoRefreshRequired?: boolean | null, balance?: any | null, createdAt: any, currency?: any | null, extra?: any | null, iavVerified?: boolean | null, id: string, isHidden?: boolean | null, lastSyncedAt?: any | null, mask?: string | null, name?: string | null, primarySource?: FinancialDataSource | null, status?: FinancialAccountStatus | null, subtype?: FinancialAccountSubtype | null, subtypeDetails?: string | null, transactionsSyncedAt?: any | null, type?: FinancialAccountType | null, updatedAt: any, verificationState?: string | null, deleteQueuedAt?: string | null, flaggedForClosureAt?: string | null, financialPortal?: { __typename?: 'FinancialPortal', accountsState?: FinancialPortalProductState | null, activeMigration?: boolean | null, alertMessage?: FinancialPortalAlertMessage | null, alertName?: string | null, alertPriority?: string | null, authState?: FinancialPortalAuthState | null, authStateSetAt?: any | null, canonicalInstitutionId?: string | null, createdAt: any, errorMessage?: FinancialPortalErrorMessage | null, errorName?: string | null, errorPriority?: string | null, id: string, identityId: string, isActiveSync?: boolean | null, isAutoRefreshing?: boolean | null, isBalanceRefreshing?: boolean | null, isManualRefreshing?: boolean | null, lastRefreshedAt?: any | null, primarySource?: FinancialDataSource | null, sequenceNumber: number, source?: FinancialDataSource | null, sourceEntityId?: string | null, sourceInstitutionId: string, transactionsState?: FinancialPortalProductState | null, updatedAt: any, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', iavAdminDeactivated?: boolean | null, iavEnabled: boolean, id: string, loginUrl?: string | null, logoUrl?: string | null, name: string } | null } | null }> | null } | null, linkedFinancialPortals?: { __typename?: 'GetPortalsResponse', portals?: Array<{ __typename?: 'FinancialPortal', createdAt: any, id: string, identityId: string, primarySource?: FinancialDataSource | null, sequenceNumber: number, source?: FinancialDataSource | null, sourceEntityId?: string | null, updatedAt: any, accountsState?: FinancialPortalProductState | null, activeMigration?: boolean | null, alertMessage?: FinancialPortalAlertMessage | null, alertName?: string | null, alertPriority?: string | null, authState?: FinancialPortalAuthState | null, authStateSetAt?: any | null, deleteQueuedAt?: any | null, canonicalInstitutionId?: string | null, errorMessage?: FinancialPortalErrorMessage | null, errorName?: string | null, errorPriority?: string | null, isActiveSync?: boolean | null, isAutoRefreshing?: boolean | null, isBalanceRefreshing?: boolean | null, isManualRefreshing?: boolean | null, isRefreshing?: boolean | null, lastRefreshedAt?: any | null, primaryClientAction?: FinancialPortalPrimaryClientAction | null, sourceInstitutionId: string, transactionsState?: FinancialPortalProductState | null, migrationDetails?: { __typename?: 'FinancialPortalMigrationDetails', hasUserConfirmed: boolean } | null, marketplaceInstitution?: { __typename?: 'AccountAggregationInstitution', id: string, name: string, loginUrl?: string | null, logoUrl?: string | null, iavEnabled: boolean, iavAdminDeactivated?: boolean | null, externalId?: string | null, aggregatorType?: MarketplaceAggregatorType | null } | null }> | null } | null, financialAccountTypeSums?: { __typename?: 'FinancialAccountTypeSumsResponse', assets: any, banks: any, bills: any, creditCards: any, debts: any, investments: any, loans: any, other: any } | null };

export type GetFinancialTransactionsProjectionForMonthQueryVariables = Exact<{
  dateInTargetMonth: Scalars['Date']['input'];
}>;


export type GetFinancialTransactionsProjectionForMonthQuery = { __typename?: 'Query', financialTransactionsProjectionForMonth?: { __typename?: 'FinancialTransactionsProjectionForMonth', earning: number } | null };

export type GetFinancialTransactionsTopCategoriesBySpendingQueryVariables = Exact<{
  dateInTargetStartMonth: Scalars['Date']['input'];
  dateInTargetEndMonth: Scalars['Date']['input'];
}>;


export type GetFinancialTransactionsTopCategoriesBySpendingQuery = { __typename?: 'Query', financialTransactionsTopCategoriesBySpending?: { __typename?: 'FinancialTransactionsTopCategoriesBySpending', topCategoriesBySpending: Array<{ __typename?: 'FinancialTransactionsCategorySpendingAmount', amount: number, category?: FinancialTransactionCategory | null, categoryId?: number | null }> } | null };

export type GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables = Exact<{
  dateInTargetStartMonth: Scalars['Date']['input'];
  dateInTargetEndMonth: Scalars['Date']['input'];
}>;


export type GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery = { __typename?: 'Query', financialTransactionsAverageSpendingByDayOfTheMonth?: { __typename?: 'FinancialTransactionsAverageSpendingByDayOfTheMonth', averageSpendingByDayOfTheMonth: Array<{ __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth', amount: number, dayOfTheMonth: number }> } | null };

export type GetFinancialTransactionsSpendingByDateForMonthQueryVariables = Exact<{
  dateInTargetMonth: Scalars['Date']['input'];
}>;


export type GetFinancialTransactionsSpendingByDateForMonthQuery = { __typename?: 'Query', financialTransactionsSpendingByDateForMonth?: { __typename?: 'FinancialTransactionsSpendingByDayOfTheMonthForMonth', spendingByDayOfTheMonthForPriorMonth: Array<{ __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth', dayOfTheMonth: number, amount: number }>, spendingByDayOfTheMonthForTargetMonth: Array<{ __typename?: 'FinancialTransactionsSpendingForDayOfTheMonth', dayOfTheMonth: number, amount: number }> } | null };

export type GetFinancialTransactionsTopMerchantsBySpendingQueryVariables = Exact<{
  dateInTargetStartMonth: Scalars['Date']['input'];
  dateInTargetEndMonth: Scalars['Date']['input'];
  pagination?: InputMaybe<AdvancedOffsetPaginationInput>;
}>;


export type GetFinancialTransactionsTopMerchantsBySpendingQuery = { __typename?: 'Query', financialTransactionsTopMerchantsBySpending?: { __typename?: 'FinancialTransactionsTopMerchantsBySpending', topMerchantsBySpending: Array<{ __typename?: 'FinancialTransactionsMerchantSpendingAmount', amount: number, merchantName: string }> } | null };

export type GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables = Exact<{
  dateInStartMonth: Scalars['Date']['input'];
  dateInEndMonth: Scalars['Date']['input'];
  filter?: InputMaybe<FinancialTransactionsFilterInput>;
}>;


export type GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery = { __typename?: 'Query', financialTransactionsSpendingAndEarningForMonthRange?: { __typename?: 'FinancialTransactionsSpendingAndEarningForMonthRangeResponse', spendingAndEarningForMonthRange: { __typename?: 'FinancialTransactionsSpendingAndEarning', spending: number, earning: number } } | null };

export type ProviderAccountsQueryVariables = Exact<{ [key: string]: never; }>;


export type ProviderAccountsQuery = { __typename?: 'Query', financialPortals?: { __typename?: 'GetPortalsResponse', portals?: Array<{ __typename?: 'FinancialPortal', primarySource?: FinancialDataSource | null }> | null } | null };

export type GetIdentityAndProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetIdentityAndProfileQuery = { __typename?: 'Query', identity?: { __typename?: 'IdentityResponse', id: string, identityId?: string | null, isNerdWalletPlusMember: boolean, roles: Array<string> } | null, globalIdentityProfile?: { __typename?: 'GlobalIdentityProfile', firstName?: string | null } | null };

export type GetNwPlusInProgressPointsQueryVariables = Exact<{
  filter?: InputMaybe<FinancialNwPlusRewardFilterInput>;
  currentDate?: InputMaybe<Scalars['DateTime']['input']>;
  eventTypes?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetNwPlusInProgressPointsQuery = { __typename?: 'Query', financialNwPlusRewards: { __typename?: 'FinancialNwPlusRewardResponse', creditCards: Array<{ __typename?: 'FinancialCreditCardReward', id: string, steps: Array<{ __typename?: 'FinancialNwPlusRewardStep', status: NwPlusRewardStepStatus }>, rewardsProgress: { __typename?: 'FinancialCreditCardRewardProgress', hasMadeOnTimePayment: boolean } }>, bankingAccounts: Array<{ __typename?: 'FinancialBankingReward', id: string, steps: Array<{ __typename?: 'FinancialNwPlusRewardStep', status: NwPlusRewardStepStatus }>, rewardsProgress: { __typename?: 'FinancialBankingRewardProgress', hasFundedAccount: boolean } }> }, rewardEventPoints: { __typename?: 'RewardEventPointsResponse', rewards: Array<{ __typename?: 'RewardEventPoints', points?: number | null, eventType: string }> } };

export type GetMembershipAppActivityQueryVariables = Exact<{ [key: string]: never; }>;


export type GetMembershipAppActivityQuery = { __typename?: 'Query', membershipAppActivity?: { __typename?: 'MembershipAppActivityResponse', nwPlusMaxEarnedPointsModalDismissedAt?: any | null } | null };

export type GetNerdWalletPlusPointsEstimateQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNerdWalletPlusPointsEstimateQuery = { __typename?: 'Query', nwPlusPointsEstimate?: { __typename?: 'NwPlusPointsEstimateResponse', points: number } | null };

export type GetNwPlusPointsSummaryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusPointsSummaryQuery = { __typename?: 'Query', nwPlusPointsSummary?: { __typename?: 'NwPlusPointsSummaryResponse', points: number, earnedYearlyPoints?: number | null } | null };

export type GetNwPlusPredictionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusPredictionsQuery = { __typename?: 'Query', nwPlusPredictions?: { __typename?: 'NwPlusPredictionsResponse', pointsEarnPrediction?: { __typename?: 'NwPlusPointsPrediction', overallSummary?: { __typename?: 'NwPlusPointsPredictionOverallSummary', type: string, summary: { __typename?: 'NwPlusPointsSummary', remainingPoints: number } } | null } | null } | null };

export type GetNwPlusAllAndCompletedRewardsQueryQueryVariables = Exact<{ [key: string]: never; }>;


export type GetNwPlusAllAndCompletedRewardsQueryQuery = { __typename?: 'Query', nwPlusUserQualifiedRewards?: { __typename?: 'NwPlusUserQualifiedRewardsResponse', allRewards?: Array<{ __typename?: 'NwPlusQualifiedReward', cardCtaText: string, cardImageUrl: any, cardTitle: string, category: string, detailCtaAction?: NwPlusRewardAppAction | null, detailCtaWebLink?: any | null, detailCtaWebText?: string | null, detailDisclaimer?: string | null, detailImageUrl: any, detailMarketplaceOfferId?: string | null, detailSecondaryCtaAction?: NwPlusRewardAppAction | null, detailSecondaryCtaWebLink?: any | null, detailSecondaryCtaWebText?: string | null, detailSecondaryDescription?: string | null, detailSubtitle: string, detailTitle: string, eventTypes?: Array<string> | null, forYouOrder?: number | null, id: string, order: number, placement?: NwPlusRewardPlacementType | null, points: number, pointsPrefix?: string | null, prerequisiteLink?: string | null, subscriberExclusive: boolean, prerequisites?: Array<{ __typename?: 'NwPlusRewardPrerequisite', type: NwPlusRewardPrerequisiteType, description: string, ctaText: string }> | null }> | null, completedRewards?: Array<{ __typename?: 'NwPlusQualifiedReward', cardCtaText: string, cardImageUrl: any, cardTitle: string, category: string, detailCtaAction?: NwPlusRewardAppAction | null, detailCtaWebLink?: any | null, detailCtaWebText?: string | null, detailDisclaimer?: string | null, detailImageUrl: any, detailMarketplaceOfferId?: string | null, detailSecondaryCtaAction?: NwPlusRewardAppAction | null, detailSecondaryCtaWebLink?: any | null, detailSecondaryCtaWebText?: string | null, detailSecondaryDescription?: string | null, detailSubtitle: string, detailTitle: string, eventTypes?: Array<string> | null, forYouOrder?: number | null, id: string, order: number, placement?: NwPlusRewardPlacementType | null, points: number, pointsPrefix?: string | null, prerequisiteLink?: string | null, subscriberExclusive: boolean, prerequisites?: Array<{ __typename?: 'NwPlusRewardPrerequisite', type: NwPlusRewardPrerequisiteType, description: string, ctaText: string }> | null }> | null } | null };

export type IsTradelineOpenFragmentFragment = { __typename?: 'CreditFactorTradeline', openClosedSymbol?: CreditFactorTradelineOpenClosedSymbol | null };

export type GetLinkTokenForLinkingQueryVariables = Exact<{
  redirectUri?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetLinkTokenForLinkingQuery = { __typename?: 'Query', initializeLinkToken?: { __typename?: 'InitializeLinkTokenResponse', token: string } | null };

export type GetNumVisibleAccountsFragmentFragment = { __typename?: 'Query', netWorthAccounts?: { __typename?: 'NetWorthAccountsResponse', accounts: Array<{ __typename?: 'NetWorthAccount', id: string, financialAccountId: string, isHiddenFromNetWorth: boolean }> } | null, netWorthRealAssets?: { __typename?: 'NetWorthRealAssetsResponse', assets: Array<{ __typename?: 'NetWorthHomeIntegrated', id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null } | { __typename?: 'NetWorthRealAssetSelfReported', id: string, type: NetWorthRealAssetTypeEnum, isHiddenFromNetWorth?: boolean | null }> } | null, linkedFinancialPortals?: { __typename?: 'GetPortalsResponse', portals?: Array<{ __typename?: 'FinancialPortal', id: string, accounts?: Array<{ __typename?: 'FinancialAccount', id: string, isHidden?: boolean | null, type?: FinancialAccountType | null, subtype?: FinancialAccountSubtype | null }> | null }> | null } | null };

export const DriverFragmentDoc = gql`
    fragment Driver on EntityPlacementDriver {
  description
  label
  labelTooltip
  value
  valueTooltip
  valueTooltipHasHtml
}
    `;
export const DriversFragmentDoc = gql`
    fragment Drivers on EntityPlacementDriver {
  ...Driver
}
    ${DriverFragmentDoc}`;
export const UniversalProductCardPropsDriversOverridesFragmentDoc = gql`
    fragment UniversalProductCardPropsDriversOverrides on EntityPlacementDriver {
  ...Drivers
}
    ${DriversFragmentDoc}`;
export const BaseMarketplaceCtaOnEntityPlacementCtaFragmentDoc = gql`
    fragment BaseMarketplaceCtaOnEntityPlacementCTA on EntityPlacementCTA {
  link
  subtext
  text
  type
}
    `;
export const MarketplaceCtaOnEntityPlacementCtaFragmentDoc = gql`
    fragment MarketplaceCtaOnEntityPlacementCTA on EntityPlacementCTA {
  link
  ...BaseMarketplaceCtaOnEntityPlacementCTA
}
    ${BaseMarketplaceCtaOnEntityPlacementCtaFragmentDoc}`;
export const UniversalProductCardPropsCtaOverrideFragmentDoc = gql`
    fragment UniversalProductCardPropsCtaOverride on EntityPlacementCTA {
  link
  ...MarketplaceCtaOnEntityPlacementCTA
}
    ${MarketplaceCtaOnEntityPlacementCtaFragmentDoc}`;
export const ApprovalOddsDriverFragmentDoc = gql`
    fragment ApprovalOddsDriver on MarketplaceEntityInterface {
  ... on CreditCardsOfferV2 {
    maxFico
    minFico
  }
}
    `;
export const RecCreditScoreDriverFragmentDoc = gql`
    fragment RecCreditScoreDriver on MarketplaceEntityInterface {
  ... on CreditCardsOfferV2 {
    maxFico
    minFico
    recommendedCreditScoreRangeDetails {
      creditScoreRange
      description
    }
  }
  ...ApprovalOddsDriver
}
    ${ApprovalOddsDriverFragmentDoc}`;
export const DriversOnMarketplaceEntityInterfaceFragmentDoc = gql`
    fragment DriversOnMarketplaceEntityInterface on MarketplaceEntityInterface {
  ...RecCreditScoreDriver
  ... on MarketplaceEntityWithPlacementInterface {
    placementDrivers {
      ...Driver
    }
  }
}
    ${RecCreditScoreDriverFragmentDoc}
${DriverFragmentDoc}`;
export const MarketplaceReviewLinkFragmentDoc = gql`
    fragment MarketplaceReviewLink on MarketplaceEntityWithReviewInterface {
  reviewLink
}
    `;
export const GetProductShoppingAttributesFragmentDoc = gql`
    fragment getProductShoppingAttributes on MarketplaceEntityInterface {
  productType
  ... on MarketplaceEntityWithPlacementInterface {
    analyticsProps {
      institutionId
      offerId
      productId
    }
    monetizable
  }
}
    `;
export const GetShoppingFinishedPayloadFragmentDoc = gql`
    fragment getShoppingFinishedPayload on MarketplaceEntityInterface {
  ...getProductShoppingAttributes
}
    ${GetProductShoppingAttributesFragmentDoc}`;
export const TrackNonMonetizingShoppingFinishedFragmentDoc = gql`
    fragment trackNonMonetizingShoppingFinished on MarketplaceEntityInterface {
  ...getShoppingFinishedPayload
}
    ${GetShoppingFinishedPayloadFragmentDoc}`;
export const BaseMarketplaceCtaFragmentDoc = gql`
    fragment BaseMarketplaceCta on MarketplaceEntityInterface {
  productType
  versionId
  ... on BankingOfferV2 {
    federallyInsuredAnnotation
  }
  ... on CreditCardsOfferV2 {
    phoneNumber
  }
  ... on MarketplaceEntityWithPlacementInterface {
    analyticsProps {
      hasLegacyImpression
      legacyAdditionalEventData
      legacyIssuer
      legacySlug
      legacyVertical
      productId
    }
    cta {
      ...BaseMarketplaceCtaOnEntityPlacementCTA
    }
    monetizable
  }
  ...MarketplaceReviewLink
  ...trackNonMonetizingShoppingFinished
}
    ${BaseMarketplaceCtaOnEntityPlacementCtaFragmentDoc}
${MarketplaceReviewLinkFragmentDoc}
${TrackNonMonetizingShoppingFinishedFragmentDoc}`;
export const GetProductImpressionPayloadFragmentDoc = gql`
    fragment getProductImpressionPayload on MarketplaceEntityInterface {
  ...getProductShoppingAttributes
}
    ${GetProductShoppingAttributesFragmentDoc}`;
export const MarketplaceCtaFragmentDoc = gql`
    fragment MarketplaceCta on MarketplaceEntityInterface {
  ... on MarketplaceEntityWithPlacementInterface {
    cta {
      link
      ...MarketplaceCtaOnEntityPlacementCTA
    }
  }
  ...BaseMarketplaceCta
  ...getProductImpressionPayload
}
    ${MarketplaceCtaOnEntityPlacementCtaFragmentDoc}
${BaseMarketplaceCtaFragmentDoc}
${GetProductImpressionPayloadFragmentDoc}`;
export const BaseMarketplaceStarRatingFragmentDoc = gql`
    fragment BaseMarketplaceStarRating on MarketplaceEntityInterface {
  ...MarketplaceReviewLink
}
    ${MarketplaceReviewLinkFragmentDoc}`;
export const MarketplaceStarRatingFragmentDoc = gql`
    fragment MarketplaceStarRating on MarketplaceEntityInterface {
  ... on MarketplaceEntityWithReviewInterface {
    reviewLink
  }
  ... on MarketplaceEntityWithStarRatingInterface {
    starRating
    starRatingTooltip
  }
  ...BaseMarketplaceStarRating
}
    ${BaseMarketplaceStarRatingFragmentDoc}`;
export const GetCardDetailsConfigFragmentDoc = gql`
    fragment getCardDetailsConfig on MarketplaceEntityInterface {
  ... on MarketplaceEntityWithQualificationsInterface {
    qualificationsBullets
  }
  ... on EducationLoansOfferV2 {
    availableTermLengths
  }
  ... on PersonalLoansOfferV2 {
    availableTermLengths
    feesBullets
  }
}
    `;
export const GetExtendedDriversFragmentDoc = gql`
    fragment getExtendedDrivers on MarketplaceEntityInterface {
  ... on MarketplaceEntityWithPlacementInterface {
    placementDrivers {
      __typename
    }
  }
  ... on CreditCardsOfferV2 {
    recommendedCreditScoreRangeDetails {
      creditScoreRange
      description
    }
  }
}
    `;
export const GetResizableImagePathFragmentDoc = gql`
    fragment getResizableImagePath on MarketplaceEntityInterface {
  ... on MarketplaceEntityWithPlacementInterface {
    image {
      height
      resizableImagePath
      sourceLarge
      sourceMedium
      width
    }
    useLargeImageFootprint
  }
}
    `;
export const IsImagePortraitOrientationFragmentDoc = gql`
    fragment isImagePortraitOrientation on MarketplaceEntityWithPlacementInterface {
  image {
    height
    width
  }
}
    `;
export const BaseUniversalProductCardFragmentDoc = gql`
    fragment BaseUniversalProductCard on MarketplaceEntityInterface {
  id
  productType
  ... on MarketplaceEntityWithBestOfAwardsInterface {
    bestOfAwards {
      year
      category
    }
  }
  ... on MarketplaceEntityWithPlacementInterface {
    analyticsProps {
      legacyIssuer
      legacySlug
      productId
    }
    cta {
      ...UniversalProductCardPropsCtaOverride
    }
    displayName
    image {
      alt
    }
    monetizable
  }
  ... on BankingOfferV2 {
    federallyInsuredAnnotation
    subProductTypeLabel
  }
  ... on CreditCardsOfferV2 {
    termsAndFeesLink
    maxFico
    minFico
    recommendedCreditScoreRangeDetails {
      creditScoreRange
      description
    }
  }
  ... on EducationLoansOfferV2 {
    disclaimer
  }
  ... on MortgagesOfferV2 {
    bestForBullets
    nmlsId
  }
  ... on PersonalLoansOfferV2 {
    disclaimer
    expandedMarketplaceCategory
  }
  ...DriversOnMarketplaceEntityInterface
  ...MarketplaceCta
  ...MarketplaceStarRating
  ...RecCreditScoreDriver
  ...getCardDetailsConfig
  ...getExtendedDrivers
  ...getResizableImagePath
  ...isImagePortraitOrientation
}
    ${UniversalProductCardPropsCtaOverrideFragmentDoc}
${DriversOnMarketplaceEntityInterfaceFragmentDoc}
${MarketplaceCtaFragmentDoc}
${MarketplaceStarRatingFragmentDoc}
${RecCreditScoreDriverFragmentDoc}
${GetCardDetailsConfigFragmentDoc}
${GetExtendedDriversFragmentDoc}
${GetResizableImagePathFragmentDoc}
${IsImagePortraitOrientationFragmentDoc}`;
export const UniversalProductCardFragmentDoc = gql`
    fragment UniversalProductCard on MarketplaceEntityInterface {
  ... on MarketplaceEntityWithPlacementInterface {
    cta {
      link
    }
  }
  ...BaseUniversalProductCard
  ...getProductImpressionPayload
}
    ${BaseUniversalProductCardFragmentDoc}
${GetProductImpressionPayloadFragmentDoc}`;
export const AccountTypeSubtitleFragmentFragmentDoc = gql`
    fragment accountTypeSubtitleFragment on CreditFactorTradeline {
  accountTypeSymbol
}
    `;
export const AccountTypeRightHandFragmentFragmentDoc = gql`
    fragment accountTypeRightHandFragment on CreditFactorTradeline {
  dateOpenedAt
  openClosedSymbol
}
    `;
export const IsTradelineOpenFragmentFragmentDoc = gql`
    fragment isTradelineOpenFragment on CreditFactorTradeline {
  openClosedSymbol
}
    `;
export const TradelineItemFragmentFragmentDoc = gql`
    fragment tradelineItemFragment on CreditFactorTradeline {
  tradelineDisplayName
  creditorName
  compositeKey
  ...isTradelineOpenFragment
}
    ${IsTradelineOpenFragmentFragmentDoc}`;
export const AccountTypeItemFragmentFragmentDoc = gql`
    fragment accountTypeItemFragment on CreditFactorTradeline {
  ...accountTypeSubtitleFragment
  ...accountTypeRightHandFragment
  ...tradelineItemFragment
}
    ${AccountTypeSubtitleFragmentFragmentDoc}
${AccountTypeRightHandFragmentFragmentDoc}
${TradelineItemFragmentFragmentDoc}`;
export const CreditFactorTradelineSectionFieldsFragmentDoc = gql`
    fragment CreditFactorTradelineSectionFields on CreditFactorTradelineSection {
  tradelines {
    accountTypeSymbol
    compositeKey
    openClosedSymbol
    creditorName
    currentBalance
    tradelineDisplayName
  }
}
    `;
export const CommonQuestionFragmentFragmentDoc = gql`
    fragment commonQuestionFragment on CreditFactorCommonQuestion {
  answerParagraphs
  learnMoreLink {
    target
    text
  }
  question
}
    `;
export const CommonQuestionsFragmentFragmentDoc = gql`
    fragment commonQuestionsFragment on CreditFactorCommonQuestion {
  key
  ...commonQuestionFragment
}
    ${CommonQuestionFragmentFragmentDoc}`;
export const CreditFactorCoreMetricFragmentFragmentDoc = gql`
    fragment creditFactorCoreMetricFragment on CreditFactor {
  coreMetric {
    commentary
    description
    displayName
    label
  }
}
    `;
export const CreditFactorTipFragmentFragmentDoc = gql`
    fragment creditFactorTipFragment on CreditFactorTip {
  key
  title
}
    `;
export const MoreInfoFragmentFragmentDoc = gql`
    fragment moreInfoFragment on AppAction {
  text
  target
}
    `;
export const HighlightWrapperTradelineFragmentFragmentDoc = gql`
    fragment highlightWrapperTradelineFragment on CreditFactorTradelineSection {
  isPriority
  label
  title
}
    `;
export const TradelineSectionFragmentFragmentDoc = gql`
    fragment tradelineSectionFragment on CreditFactorTradelineSection {
  ...highlightWrapperTradelineFragment
}
    ${HighlightWrapperTradelineFragmentFragmentDoc}`;
export const CollapsibleTradelineSectionsFragmentFragmentDoc = gql`
    fragment collapsibleTradelineSectionsFragment on CreditFactorTradelineSection {
  isPriority
  title
  subtitle
  ...tradelineSectionFragment
}
    ${TradelineSectionFragmentFragmentDoc}`;
export const HighlightWrapperInquiryFragmentFragmentDoc = gql`
    fragment highlightWrapperInquiryFragment on CreditFactorInquirySection {
  isPriority
  label
  title
}
    `;
export const TradelineSectionsFragmentFragmentDoc = gql`
    fragment tradelineSectionsFragment on CreditFactorTradelineSection {
  isPriority
  title
  ...tradelineSectionFragment
}
    ${TradelineSectionFragmentFragmentDoc}`;
export const InquiriesSectionFragmentFragmentDoc = gql`
    fragment inquiriesSectionFragment on CreditFactorInquiry {
  compositeKey
  inquiredAt
  subscriberName
}
    `;
export const PaymentIconTradelineFragmentFragmentDoc = gql`
    fragment paymentIconTradelineFragment on CreditFactorTradeline {
  payStatusDisplayName
  payStatus
}
    `;
export const PaymentSubtitleTradelineFragmentFragmentDoc = gql`
    fragment paymentSubtitleTradelineFragment on CreditFactorTradeline {
  payStatusDisplayName
}
    `;
export const PaymentTradelineItemFragmentFragmentDoc = gql`
    fragment paymentTradelineItemFragment on CreditFactorTradeline {
  ...tradelineItemFragment
  ...paymentIconTradelineFragment
  ...paymentSubtitleTradelineFragment
}
    ${TradelineItemFragmentFragmentDoc}
${PaymentIconTradelineFragmentFragmentDoc}
${PaymentSubtitleTradelineFragmentFragmentDoc}`;
export const CreditUtilizationBarFragmentFragmentDoc = gql`
    fragment creditUtilizationBarFragment on CreditFactorTradeline {
  currentBalance
  nwCreditLimitNormalized
  nwUtilizationPct
}
    `;
export const CreditUtilizationPercentageFragmentFragmentDoc = gql`
    fragment creditUtilizationPercentageFragment on CreditFactorTradeline {
  nwUtilizationPct
}
    `;
export const CreditUtilizationItemFragmentFragmentDoc = gql`
    fragment creditUtilizationItemFragment on CreditFactorTradeline {
  ...creditUtilizationBarFragment
  ...creditUtilizationPercentageFragment
  ...tradelineItemFragment
}
    ${CreditUtilizationBarFragmentFragmentDoc}
${CreditUtilizationPercentageFragmentFragmentDoc}
${TradelineItemFragmentFragmentDoc}`;
export const HighlightStatusInquiriesFragmentFragmentDoc = gql`
    fragment highlightStatusInquiriesFragment on CreditFactorInquirySection {
  abbreviatedTitle
  label
  title
}
    `;
export const GetTrackingMetadataInquirySectionFragmentFragmentDoc = gql`
    fragment getTrackingMetadataInquirySectionFragment on CreditFactorInquirySection {
  trackingMetadata {
    accountStatusChange
    highlightStatus
    inquiryStatusChange
    paymentDerogatoryType
    paymentStatusChange
    utilizationCurrentBucket
    utilizationDirectionChange
  }
}
    `;
export const HighlightStatusTradelineFragmentFragmentDoc = gql`
    fragment highlightStatusTradelineFragment on CreditFactorTradelineSection {
  abbreviatedTitle
  label
  title
}
    `;
export const GetTrackingMetadataTradelineSectionFragmentFragmentDoc = gql`
    fragment getTrackingMetadataTradelineSectionFragment on CreditFactorTradelineSection {
  trackingMetadata {
    accountStatusChange
    highlightStatus
    inquiryStatusChange
    paymentDerogatoryType
    paymentStatusChange
    utilizationCurrentBucket
    utilizationDirectionChange
  }
}
    `;
export const GetCreditUtilizationEventCoreMetricFragmentFragmentDoc = gql`
    fragment getCreditUtilizationEventCoreMetricFragment on CreditFactorCoreMetric {
  value
}
    `;
export const GetSegmentEventPropsFragmentFragmentDoc = gql`
    fragment getSegmentEventPropsFragment on CreditFactorCoreMetric {
  value
  secondaryValue
}
    `;
export const GetTrackingMetadataCoreMetricFragmentFragmentDoc = gql`
    fragment getTrackingMetadataCoreMetricFragment on CreditFactorCoreMetric {
  value
  secondaryValue
}
    `;
export const GetCreditUtilizationEventDeltaFragmentFragmentDoc = gql`
    fragment getCreditUtilizationEventDeltaFragment on CreditFactorDelta {
  value
}
    `;
export const CreditFactorItemFragmentFragmentDoc = gql`
    fragment creditFactorItemFragment on CreditFactor {
  priorityInquirySection {
    ...highlightStatusInquiriesFragment
    ...getTrackingMetadataInquirySectionFragment
  }
  priorityTradelineSection {
    ...highlightStatusTradelineFragment
    ...getTrackingMetadataTradelineSectionFragment
  }
  coreMetric {
    ...getCreditUtilizationEventCoreMetricFragment
    ...getSegmentEventPropsFragment
    ...getTrackingMetadataCoreMetricFragment
  }
  delta {
    ...getCreditUtilizationEventDeltaFragment
  }
}
    ${HighlightStatusInquiriesFragmentFragmentDoc}
${GetTrackingMetadataInquirySectionFragmentFragmentDoc}
${HighlightStatusTradelineFragmentFragmentDoc}
${GetTrackingMetadataTradelineSectionFragmentFragmentDoc}
${GetCreditUtilizationEventCoreMetricFragmentFragmentDoc}
${GetSegmentEventPropsFragmentFragmentDoc}
${GetTrackingMetadataCoreMetricFragmentFragmentDoc}
${GetCreditUtilizationEventDeltaFragmentFragmentDoc}`;
export const HandleCardActionFragmentFragmentDoc = gql`
    fragment handleCardActionFragment on AppAction {
  target
  targetType
}
    `;
export const GetSegmentPayloadFragmentFragmentDoc = gql`
    fragment getSegmentPayloadFragment on UserInsightInterface {
  actions {
    appAction {
      target
      text
    }
    slug
  }
  dataVisualization {
    dataVisualizationType
  }
  id
  sentiment
  slug
}
    `;
export const CreditScoreUserInsightCardFragmentFragmentDoc = gql`
    fragment creditScoreUserInsightCardFragment on UserInsightInterface {
  actions {
    appAction {
      text
      ...handleCardActionFragment
    }
  }
  description
  gain {
    description
  }
  sentiment
  ...getSegmentPayloadFragment
}
    ${HandleCardActionFragmentFragmentDoc}
${GetSegmentPayloadFragmentFragmentDoc}`;
export const InSituFragmentDoc = gql`
    fragment InSitu on NwPlusPoints {
  type
  value
}
    `;
export const ExclusiveFeaturesCardFragmentDoc = gql`
    fragment ExclusiveFeaturesCard on NwPlusExclusiveFeatureCard {
  id
  title
  body
  points {
    value
    ...InSitu
  }
  ctaText
  ctaUrl
  imageUrl
  isNew
}
    ${InSituFragmentDoc}`;
export const CashFlowTileQueryFragmentFragmentDoc = gql`
    fragment CashFlowTileQueryFragment on Query {
  financialTransactionsSpendingByDateForMonth(
    dateInTargetMonth: $dateInTargetMonth
  ) {
    spendingByDayOfTheMonthForTargetMonth {
      amount
      dayOfTheMonth
    }
    spendingByDayOfTheMonthForPriorMonth {
      amount
      dayOfTheMonth
    }
  }
  currentMonthEarning: financialTransactionsSpendingAndEarningForMonthRange(
    dateInStartMonth: $dateInStartMonth
    dateInEndMonth: $dateInTargetMonth
  ) {
    spendingAndEarningForMonthRange {
      earning
    }
  }
}
    `;
export const InsuranceErrorBannerFragmentFragmentDoc = gql`
    fragment insuranceErrorBannerFragment on InsurancePolicy {
  friendlyCarrierName
  requiresReconnect
}
    `;
export const ActivatedInsuranceFragmentFragmentDoc = gql`
    fragment activatedInsuranceFragment on InsurancePolicy {
  isExpired
  monthlyPremiumCents
  ...insuranceErrorBannerFragment
}
    ${InsuranceErrorBannerFragmentFragmentDoc}`;
export const UnactivatedRewardsFragmentFragmentDoc = gql`
    fragment unactivatedRewardsFragment on NwPlusPointBreakdown {
  id
  points
  text
}
    `;
export const PostTemplateFragmentDoc = gql`
    fragment PostTemplate on PostInterface {
  dbId
  link
  ... on PostWithFeaturedImageInterface {
    featuredMedia {
      altText
      sourceUrl
      croppedImages {
        size
        sourceUrl
      }
    }
  }
  ... on PostWithTitleInterface {
    title
  }
  ... on PostWithAuthorsInterface {
    authors {
      avatarUrls {
        size
        url
      }
      id
      link
      name
    }
  }
}
    `;
export const WeeklyReadsFragmentDoc = gql`
    fragment WeeklyReads on PostInterface {
  ...PostTemplate
}
    ${PostTemplateFragmentDoc}`;
export const NerdyNudgeFragmentFragmentDoc = gql`
    fragment NerdyNudgeFragment on NwPlusOutstandingEvent {
  ctaLink
  ctaText
  eventType
  iconUrl
  id
  points
  subtitle
  title
}
    `;
export const ExperimentQueryFieldsFragmentDoc = gql`
    fragment ExperimentQueryFields on ExperimentDecision {
  experimentName
  assignedVariantName
  modelExecutionIds
  message
  __typename
}
    `;
export const NewFollowFragmentDoc = gql`
    fragment NewFollow on FollowedAuthorResponse {
  id
  entityId
}
    `;
export const RecurlyAccountInfoQueryFragmentFragmentDoc = gql`
    fragment RecurlyAccountInfoQueryFragment on Query {
  recurlyAccountInfo {
    address {
      street1
      street2
      city
      state: region
      zipCode: postalCode
    }
    billingInfo {
      firstName
      lastName
      paymentMethod {
        cardType
        lastFour
        expMonth
        expYear
        method
      }
    }
  }
}
    `;
export const NwPlusMembershipStatusQueryFragmentFragmentDoc = gql`
    fragment nwPlusMembershipStatusQueryFragment on Query {
  nwPlusMembershipStatus {
    autoRenew
    currentPeriodEndsAt
    unitAmount
    state
  }
}
    `;
export const RecurlyBillingHistoryQueryFragmentFragmentDoc = gql`
    fragment RecurlyBillingHistoryQueryFragment on Query {
  recurlyBillingHistory {
    billingHistory {
      invoiceNumber
      dueDate
      issuedDate
      status
      total
      invoiceHref
      downloadHref
    }
  }
}
    `;
export const NerdwalletPlusRichTextFragmentFragmentDoc = gql`
    fragment NerdwalletPlusRichTextFragment on NwPlusRichText {
  text
  links {
    tag
    url
    type
    text
  }
}
    `;
export const NerdwalletPlusShoppingRewardStepFragmentFragmentDoc = gql`
    fragment NerdwalletPlusShoppingRewardStepFragment on FinancialNwPlusRewardStep {
  alertMessage {
    ...NerdwalletPlusRichTextFragment
  }
  analyticsStatus
  ctaText {
    ...NerdwalletPlusRichTextFragment
  }
  extraTagline {
    ...NerdwalletPlusRichTextFragment
  }
  failedTagline {
    ...NerdwalletPlusRichTextFragment
  }
  infoMessage {
    ...NerdwalletPlusRichTextFragment
  }
  status
  tagline {
    ...NerdwalletPlusRichTextFragment
  }
  title {
    ...NerdwalletPlusRichTextFragment
  }
}
    ${NerdwalletPlusRichTextFragmentFragmentDoc}`;
export const NerdwalletPlusShoppingRewardTrackerResponseFragmentFragmentDoc = gql`
    fragment NerdwalletPlusShoppingRewardTrackerResponseFragment on FinancialNwPlusRewardResponse {
  creditCards {
    id
    shoppingFinishedAt
    accountLinkStatus
    nwPlusActivationStatus
    productType
    marketplaceOfferId
    marketplaceCreditCardOffer {
      displayName
      institution {
        name
        id
      }
    }
    events {
      id
      eventType
      emittedAt
      viewedAt
      pointsRewarded
    }
    steps(currentDate: $currentDate) {
      ...NerdwalletPlusShoppingRewardStepFragment
    }
    rewardsProgress(currentDate: $currentDate) {
      hasAppliedForCard
      hasConfirmedCardApproval
      hasExpiredErrorsToReport
      hasLinkedAccount
      hasMadeOnTimePayment
      hasCardApprovalConfirmationExpired
      hasOnTimePaymentRewardExpired
    }
  }
  bankingAccounts {
    accountId
    accountLinkStatus
    id
    events {
      id
      emittedAt
      viewedAt
      pointsRewarded
      eventType
    }
    steps {
      ...NerdwalletPlusShoppingRewardStepFragment
    }
    shoppingFinishedId
    shoppingFinishedAt
    productType
    marketplaceBankingOffer {
      displayName
      institution {
        name
        id
      }
    }
    marketplaceInstitutionId
    marketplaceProductId
    marketplaceOfferId
    nwPlusActivationStatus
    rewardEligibilityStatus
    rewardPathType
    accountLinkedAt
    rewardsProgress(currentDate: $currentDate) {
      hasAppliedForBankingAccount
      hasConfirmedBankingAccount
      hasLinkedAccount
      hasMadeDirectDeposit
      hasFundedAccount
      hasBankAccountConfirmationExpired
      hasDirectDepositRewardExpired
      hasFundedAccountRewardExpired
      hasExpiredErrorsToReport
    }
  }
}
    ${NerdwalletPlusShoppingRewardStepFragmentFragmentDoc}`;
export const QualifiedRewardFragmentDoc = gql`
    fragment QualifiedReward on NwPlusQualifiedReward {
  cardCtaText
  cardImageUrl
  cardTitle
  category
  detailCtaAction
  detailCtaWebLink
  detailCtaWebText
  detailDisclaimer
  detailImageUrl
  detailMarketplaceOfferId
  detailSecondaryCtaAction
  detailSecondaryCtaWebLink
  detailSecondaryCtaWebText
  detailSecondaryDescription
  detailSubtitle
  detailTitle
  eventTypes
  forYouOrder
  id
  order
  placement
  points
  pointsPrefix
  prerequisites {
    type
    description
    ctaText
  }
  prerequisiteLink
  subscriberExclusive
}
    `;
export const SubscriptionProfileFieldsFragmentDoc = gql`
    fragment SubscriptionProfileFields on SubscriptionIdentityProfile {
  emailEnabled
  emailCreditMonitoringEnabled
  emailSpendingAlertsEnabled
  emailMarketingEnabled
  emailPersonalizedContentEnabled
  updateSubscriptionToken
}
    `;
export const FinancialAccountFragmentFragmentDoc = gql`
    fragment FinancialAccountFragment on FinancialAccount {
  autoRefreshRequired
  balance
  createdAt
  currency
  extra
  financialPortal {
    accountsState
    activeMigration
    alertMessage
    alertName
    alertPriority
    authState
    authStateSetAt
    canonicalInstitutionId
    createdAt
    errorMessage
    errorName
    errorPriority
    id
    identityId
    isActiveSync
    isAutoRefreshing
    isBalanceRefreshing
    isManualRefreshing
    lastRefreshedAt
    marketplaceInstitution {
      iavAdminDeactivated
      iavEnabled
      id
      loginUrl
      logoUrl
      name
    }
    primarySource
    sequenceNumber
    source
    sourceEntityId
    sourceInstitutionId
    transactionsState
    updatedAt
  }
  iavVerified
  id
  isHidden
  lastSyncedAt
  mask
  name
  primarySource
  status
  subtype
  subtypeDetails
  transactionsSyncedAt
  type
  updatedAt
  verificationState
  deleteQueuedAt
  flaggedForClosureAt
}
    `;
export const FinancialAccountsForUserFragmentFragmentDoc = gql`
    fragment FinancialAccountsForUserFragment on Query {
  financialAccounts {
    accounts {
      ...FinancialAccountFragment
    }
  }
}
    ${FinancialAccountFragmentFragmentDoc}`;
export const RewardItemFragmentFragmentDoc = gql`
    fragment rewardItemFragment on RewardAvailableElement {
  codes
  copy
  dollarValue
  points
  recurringPattern
  tooltipContent
}
    `;
export const CreditProfileAuthStatusProfileFragmentFragmentDoc = gql`
    fragment CreditProfileAuthStatusProfileFragment on CreditProfileAuthStatusProfile {
  status
  authenticatedAt
  activatedAt
  deactivatedAt
  reactivatedAt
  blockedAt
  questions {
    id
    type
    text
    sequence
    answers {
      id
      text
      sequence
    }
  }
  inOtpFlow
  hasThinFile
  thinFileReason
  isDeceased
  notEnoughData
  numPullsInPast24Hours
  tuId
  previousStatus
  message
  description
}
    `;
export const TuCreditReportIdentityProfileFragmentFragmentDoc = gql`
    fragment TuCreditReportIdentityProfileFragment on TuCreditReportIdentityProfile {
  id
  inquiryDate
  safetyCheckPassed
  hasReportErrors
  isStale
  reportPulledAt
  reportPulledAtIterableDatetime
  nextReportPullAt
  vantageScore3
  vantageScore3Bucket
  vantageScore3Bin
  vantageScore3Bin7Days
  vantageScore3Bin28Days
  creditScorePopulationRank
  vantageScore3ChangeDirection7Days
  vantageScore3ChangeDirection28Days
  vantageScore3ChangeDirection
  vantageScore3Delta
  vantageScore3Delta7Days
  vantageScore3Delta28Days
  vantageScore3DeltaBucket
  numAccounts
  numOpenAccounts
  numClosedAccounts
  numInquiries
  numRecentInquiries
  numDerogatoryAccounts
  numDelinquentAccounts
  numPublicRecords
  percentUtilization
  percentOnTimePayments
  sumAgeOfCredit
  sumAvailableCredit
  sumBalances
  sumMonthlyPayments
  percentUtilizationDelta
  percentOnTimePaymentsDelta
  sumAgeOfCreditDelta
  numOpenAccountsDelta
  sumRevolvingDebtBalances
  sumAssetBackedDebtBalances
  numCreditCardAccounts
  sumCreditCardBalances
  sumCreditCardLimits
  numStudentLoanAccounts
  sumStudentLoanBalances
  numAutoLoanAccounts
  sumAutoLoanBalances
  numPersonalLoanAccounts
  sumPersonalLoanBalances
  numMortgageAccounts
  sumMortgageBalances
  numOtherLoanAccounts
  sumOtherLoanBalances
  numHelocAccounts
  sumHelocBalances
  numUtilityAccounts
  sumUtilityBalances
  numOtherAccounts
  sumOtherBalances
  numMissedPayments
  vantageScore3DeltaSinceReg
  avgAgeOfCredit
  nwSumBalancesOpenRevolvingLineOfCredit
  nwSumCreditLimitOpenRevolvingLineOfCredit
  nwPercentUtilization
  nwNumMissedPaymentsRecent
  nwAvgAgeOfCreditOpenMonths
  nwSumBalancesOpen
  nwNumMissedPaymentsRecentBucket
  nwPercentUtilizationBucket
  nwAvgAgeOfCreditOpenBucket
  nwNumOntimeAccounts
  nwPercentUtilization28Days
  nwNumOntimeAccounts28Days
  numAccounts28Days
  numDerogatoryAccounts28Days
  numOpenAccounts28Days
  numClosedAccounts28Days
  nwSumBalancesOpen28Days
  nwSumCreditLimitOpenRevolvingLineOfCredit28Days
  numInquiries28Days
  nwAvgAgeOfCreditOpenMonths28Days
  nwPercentUtilizationDelta28Days
  nwNumOntimeAccountsDelta28Days
  numAccountsDelta28Days
  numDerogatoryAccountsDelta28Days
  numOpenAccountsDelta28Days
  numClosedAccountsDelta28Days
  nwSumBalancesOpenDelta28Days
  nwSumCreditLimitOpenRevolvingLineOfCreditDelta28Days
  numInquiriesDelta28Days
  nwAvgAgeOfCreditOpenMonthsDelta28Days
  currentAddress {
    addressLine1
    addressLine2
    city
    state
    zipCode
    longitude
    latitude
    isValidated
    validatedAt
    validatedBy
  }
  inquiries {
    subscriberName
    inquiryType
    bureau
    inquiredAt
    industry
    compositeKey
  }
  tradelines {
    accountType
    accountTypeSymbol
    accountSubtype
    accountSubtypeSymbol
    accountNumberLast4
    accountDesignator
    accountCondition
    openClosed
    openClosedSymbol
    highBalance
    dateReportedAt
    dateOpenedAt
    dateClosedAt
    dateVerifiedAt
    dateAccountStatus
    currentBalance
    creditorName
    bureau
    creditLimit
    disputeFlag
    payStatus
    payStatusDescription
    remark
    paymentFrequency
    worstPayStatus
    worstPayStatusSymbol
    amountPastDue
    collateral
    lastPaymentDate
    late30Count
    late60Count
    late90Count
    monthlyPayment
    monthsReviewed
    termMonths
    worstPayStatusCount
    payHistoryStatus
    payHistoryStartDate
    payHistoryBreakDown {
      status
      date
    }
    accountNumberHash
    creditType
    compositeKey
    nwCreditLimitNormalized
    nwUtilizationPct
    nwDateOpenedAtNormalized
    nwMonthsOpened
    derogatoryTradelineReason
    payStatusSymbol
    nwPayStatusBucket
    nwLastMissedPaymentDate
    isIncludedInUtilization
  }
  employers {
    name
    dateReportedAt
    dateUpdatedAt
  }
  publicRecords {
    courtName
    filedAt
    referenceNumber
    subscriberCode
    bureau
    classification
    status
    type
  }
}
    `;
export const RichTextFragmentFragmentDoc = gql`
    fragment RichTextFragment on NwPlusRichText {
  text
  links {
    url
    text
    tag
    type
  }
}
    `;
export const FinancialPrioritiesFragmentFragmentDoc = gql`
    fragment FinancialPrioritiesFragment on FinancialPrioritiesResponse {
  buildCredit
  buildWealth
  buyCar
  buyHome
  createAndFollowBudget
  maximizeCreditCardRewards
  payForHomeImprovements
  reduceDebt
  saveForEmergencies
  saveForCollege
  saveForRetirement
  startOrGrowBusiness
  travel
}
    `;
export const FinancialPortalFragmentFragmentDoc = gql`
    fragment FinancialPortalFragment on FinancialPortal {
  createdAt
  id
  identityId
  primarySource
  sequenceNumber
  source
  sourceEntityId
  updatedAt
  accountsState
  activeMigration
  alertMessage
  alertName
  alertPriority
  authState
  authStateSetAt
  deleteQueuedAt
  canonicalInstitutionId
  errorMessage
  errorName
  errorPriority
  isActiveSync
  isAutoRefreshing
  isBalanceRefreshing
  isManualRefreshing
  isRefreshing
  lastRefreshedAt
  migrationDetails {
    hasUserConfirmed
  }
  marketplaceInstitution {
    id
    name
    loginUrl
    logoUrl
    iavEnabled
    iavAdminDeactivated
    externalId
    aggregatorType
  }
  primaryClientAction
  sourceInstitutionId
  transactionsState
}
    `;
export const LinkedFinancialPortalsForUserFragmentFragmentDoc = gql`
    fragment LinkedFinancialPortalsForUserFragment on Query {
  linkedFinancialPortals {
    portals {
      ...FinancialPortalFragment
    }
  }
}
    ${FinancialPortalFragmentFragmentDoc}`;
export const FinancialAccountTypeSumsFragmentFragmentDoc = gql`
    fragment FinancialAccountTypeSumsFragment on Query {
  financialAccountTypeSums {
    assets
    banks
    bills
    creditCards
    debts
    investments
    loans
    other
  }
}
    `;
export const GetNumVisibleAccountsFragmentFragmentDoc = gql`
    fragment GetNumVisibleAccountsFragment on Query {
  netWorthAccounts {
    accounts {
      id
      financialAccountId
      isHiddenFromNetWorth
    }
  }
  netWorthRealAssets {
    assets {
      id
      type
      isHiddenFromNetWorth
    }
  }
  linkedFinancialPortals {
    portals {
      id
      accounts {
        id
        isHidden
        type
        subtype
      }
    }
  }
}
    `;
export const FinancialPortalDetailsDocument = gql`
    query FinancialPortalDetails($financialAccountId: ID!) {
  netWorthAccountByFinancialAccountId(financialAccountId: $financialAccountId) {
    account {
      id
      financialAccountId
      isHiddenFromNetWorth
    }
  }
  financialAccountById(financialAccountId: $financialAccountId) {
    balance
    currency
    extra
    financialPortal {
      alertMessage
      authState
      errorMessage
      isActiveSync
      id
      isRefreshing
      marketplaceInstitution {
        externalId
        id
        loginUrl
        logoUrl
        name
      }
      primaryClientAction
      primarySource
    }
    id
    isHidden
    lastSyncedAt
    mask
    name
    primarySource
    status
    subtype
    subtypeDetails
    type
    updatedAt
  }
}
    `;
export type FinancialPortalDetailsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables>, 'query'> & ({ variables: FinancialPortalDetailsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FinancialPortalDetailsComponent = (props: FinancialPortalDetailsComponentProps) => (
      <ApolloReactComponents.Query<FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables> query={FinancialPortalDetailsDocument} {...props} />
    );
    
export type FinancialPortalDetailsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables>
    } & TChildProps;
export function withFinancialPortalDetails<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FinancialPortalDetailsQuery,
  FinancialPortalDetailsQueryVariables,
  FinancialPortalDetailsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables, FinancialPortalDetailsProps<TChildProps, TDataName>>(FinancialPortalDetailsDocument, {
      alias: 'financialPortalDetails',
      ...operationOptions
    });
};

/**
 * __useFinancialPortalDetailsQuery__
 *
 * To run a query within a React component, call `useFinancialPortalDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialPortalDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialPortalDetailsQuery({
 *   variables: {
 *      financialAccountId: // value for 'financialAccountId'
 *   },
 * });
 */
export function useFinancialPortalDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables> & ({ variables: FinancialPortalDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables>(FinancialPortalDetailsDocument, options);
      }
export function useFinancialPortalDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables>(FinancialPortalDetailsDocument, options);
        }
export function useFinancialPortalDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables>(FinancialPortalDetailsDocument, options);
        }
export type FinancialPortalDetailsQueryHookResult = ReturnType<typeof useFinancialPortalDetailsQuery>;
export type FinancialPortalDetailsLazyQueryHookResult = ReturnType<typeof useFinancialPortalDetailsLazyQuery>;
export type FinancialPortalDetailsSuspenseQueryHookResult = ReturnType<typeof useFinancialPortalDetailsSuspenseQuery>;
export type FinancialPortalDetailsQueryResult = ApolloReactCommon.QueryResult<FinancialPortalDetailsQuery, FinancialPortalDetailsQueryVariables>;
export const DeleteFinancialAccountDocument = gql`
    mutation DeleteFinancialAccount($financialAccountId: ID!) {
  deleteUserFinancialAccount(financialAccountId: $financialAccountId) {
    success
  }
}
    `;
export type DeleteFinancialAccountMutationFn = ApolloReactCommon.MutationFunction<DeleteFinancialAccountMutation, DeleteFinancialAccountMutationVariables>;
export type DeleteFinancialAccountComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteFinancialAccountMutation, DeleteFinancialAccountMutationVariables>, 'mutation'>;

    export const DeleteFinancialAccountComponent = (props: DeleteFinancialAccountComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteFinancialAccountMutation, DeleteFinancialAccountMutationVariables> mutation={DeleteFinancialAccountDocument} {...props} />
    );
    
export type DeleteFinancialAccountProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteFinancialAccountMutation, DeleteFinancialAccountMutationVariables>
    } & TChildProps;
export function withDeleteFinancialAccount<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteFinancialAccountMutation,
  DeleteFinancialAccountMutationVariables,
  DeleteFinancialAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteFinancialAccountMutation, DeleteFinancialAccountMutationVariables, DeleteFinancialAccountProps<TChildProps, TDataName>>(DeleteFinancialAccountDocument, {
      alias: 'deleteFinancialAccount',
      ...operationOptions
    });
};

/**
 * __useDeleteFinancialAccountMutation__
 *
 * To run a mutation, you first call `useDeleteFinancialAccountMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFinancialAccountMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFinancialAccountMutation, { data, loading, error }] = useDeleteFinancialAccountMutation({
 *   variables: {
 *      financialAccountId: // value for 'financialAccountId'
 *   },
 * });
 */
export function useDeleteFinancialAccountMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFinancialAccountMutation, DeleteFinancialAccountMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFinancialAccountMutation, DeleteFinancialAccountMutationVariables>(DeleteFinancialAccountDocument, options);
      }
export type DeleteFinancialAccountMutationHookResult = ReturnType<typeof useDeleteFinancialAccountMutation>;
export type DeleteFinancialAccountMutationResult = ApolloReactCommon.MutationResult<DeleteFinancialAccountMutation>;
export type DeleteFinancialAccountMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFinancialAccountMutation, DeleteFinancialAccountMutationVariables>;
export const GetNetWorthRealAssetDocument = gql`
    query GetNetWorthRealAsset($netWorthRealAssetId: ID!) {
  netWorthRealAsset(netWorthRealAssetId: $netWorthRealAssetId) {
    asset {
      id
      type
      amount
      isSelfReported
      isHiddenFromNetWorth
      lastReportedOrSyncedAt
      ... on NetWorthHomeIntegrated {
        address {
          addressLine1
          addressLine2
          city
          state
          zipCode
        }
        externalInfo {
          source
          value
        }
      }
      ... on NetWorthRealAssetSelfReported {
        nickname
      }
    }
  }
}
    `;
export type GetNetWorthRealAssetComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables>, 'query'> & ({ variables: GetNetWorthRealAssetQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNetWorthRealAssetComponent = (props: GetNetWorthRealAssetComponentProps) => (
      <ApolloReactComponents.Query<GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables> query={GetNetWorthRealAssetDocument} {...props} />
    );
    
export type GetNetWorthRealAssetProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables>
    } & TChildProps;
export function withGetNetWorthRealAsset<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNetWorthRealAssetQuery,
  GetNetWorthRealAssetQueryVariables,
  GetNetWorthRealAssetProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables, GetNetWorthRealAssetProps<TChildProps, TDataName>>(GetNetWorthRealAssetDocument, {
      alias: 'getNetWorthRealAsset',
      ...operationOptions
    });
};

/**
 * __useGetNetWorthRealAssetQuery__
 *
 * To run a query within a React component, call `useGetNetWorthRealAssetQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetWorthRealAssetQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetWorthRealAssetQuery({
 *   variables: {
 *      netWorthRealAssetId: // value for 'netWorthRealAssetId'
 *   },
 * });
 */
export function useGetNetWorthRealAssetQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables> & ({ variables: GetNetWorthRealAssetQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables>(GetNetWorthRealAssetDocument, options);
      }
export function useGetNetWorthRealAssetLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables>(GetNetWorthRealAssetDocument, options);
        }
export function useGetNetWorthRealAssetSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables>(GetNetWorthRealAssetDocument, options);
        }
export type GetNetWorthRealAssetQueryHookResult = ReturnType<typeof useGetNetWorthRealAssetQuery>;
export type GetNetWorthRealAssetLazyQueryHookResult = ReturnType<typeof useGetNetWorthRealAssetLazyQuery>;
export type GetNetWorthRealAssetSuspenseQueryHookResult = ReturnType<typeof useGetNetWorthRealAssetSuspenseQuery>;
export type GetNetWorthRealAssetQueryResult = ApolloReactCommon.QueryResult<GetNetWorthRealAssetQuery, GetNetWorthRealAssetQueryVariables>;
export const DeleteNetWorthRealAssetDocument = gql`
    mutation DeleteNetWorthRealAsset($netWorthRealAssetId: ID!) {
  deleteNetWorthRealAsset(netWorthRealAssetId: $netWorthRealAssetId) {
    success
  }
}
    `;
export type DeleteNetWorthRealAssetMutationFn = ApolloReactCommon.MutationFunction<DeleteNetWorthRealAssetMutation, DeleteNetWorthRealAssetMutationVariables>;
export type DeleteNetWorthRealAssetComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteNetWorthRealAssetMutation, DeleteNetWorthRealAssetMutationVariables>, 'mutation'>;

    export const DeleteNetWorthRealAssetComponent = (props: DeleteNetWorthRealAssetComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteNetWorthRealAssetMutation, DeleteNetWorthRealAssetMutationVariables> mutation={DeleteNetWorthRealAssetDocument} {...props} />
    );
    
export type DeleteNetWorthRealAssetProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteNetWorthRealAssetMutation, DeleteNetWorthRealAssetMutationVariables>
    } & TChildProps;
export function withDeleteNetWorthRealAsset<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteNetWorthRealAssetMutation,
  DeleteNetWorthRealAssetMutationVariables,
  DeleteNetWorthRealAssetProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteNetWorthRealAssetMutation, DeleteNetWorthRealAssetMutationVariables, DeleteNetWorthRealAssetProps<TChildProps, TDataName>>(DeleteNetWorthRealAssetDocument, {
      alias: 'deleteNetWorthRealAsset',
      ...operationOptions
    });
};

/**
 * __useDeleteNetWorthRealAssetMutation__
 *
 * To run a mutation, you first call `useDeleteNetWorthRealAssetMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteNetWorthRealAssetMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteNetWorthRealAssetMutation, { data, loading, error }] = useDeleteNetWorthRealAssetMutation({
 *   variables: {
 *      netWorthRealAssetId: // value for 'netWorthRealAssetId'
 *   },
 * });
 */
export function useDeleteNetWorthRealAssetMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteNetWorthRealAssetMutation, DeleteNetWorthRealAssetMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteNetWorthRealAssetMutation, DeleteNetWorthRealAssetMutationVariables>(DeleteNetWorthRealAssetDocument, options);
      }
export type DeleteNetWorthRealAssetMutationHookResult = ReturnType<typeof useDeleteNetWorthRealAssetMutation>;
export type DeleteNetWorthRealAssetMutationResult = ApolloReactCommon.MutationResult<DeleteNetWorthRealAssetMutation>;
export type DeleteNetWorthRealAssetMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteNetWorthRealAssetMutation, DeleteNetWorthRealAssetMutationVariables>;
export const EditNetWorthRealAssetSelfReportedDocument = gql`
    mutation EditNetWorthRealAssetSelfReported($netWorthRealAssetId: ID!, $amount: Float, $nickname: String) {
  editNetWorthRealAssetSelfReported(
    amount: $amount
    netWorthRealAssetId: $netWorthRealAssetId
    nickname: $nickname
  ) {
    asset {
      id
      type
      isHiddenFromNetWorth
      amount
      lastReportedOrSyncedAt
      nickname
      isSelfReported
    }
  }
}
    `;
export type EditNetWorthRealAssetSelfReportedMutationFn = ApolloReactCommon.MutationFunction<EditNetWorthRealAssetSelfReportedMutation, EditNetWorthRealAssetSelfReportedMutationVariables>;
export type EditNetWorthRealAssetSelfReportedComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EditNetWorthRealAssetSelfReportedMutation, EditNetWorthRealAssetSelfReportedMutationVariables>, 'mutation'>;

    export const EditNetWorthRealAssetSelfReportedComponent = (props: EditNetWorthRealAssetSelfReportedComponentProps) => (
      <ApolloReactComponents.Mutation<EditNetWorthRealAssetSelfReportedMutation, EditNetWorthRealAssetSelfReportedMutationVariables> mutation={EditNetWorthRealAssetSelfReportedDocument} {...props} />
    );
    
export type EditNetWorthRealAssetSelfReportedProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<EditNetWorthRealAssetSelfReportedMutation, EditNetWorthRealAssetSelfReportedMutationVariables>
    } & TChildProps;
export function withEditNetWorthRealAssetSelfReported<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EditNetWorthRealAssetSelfReportedMutation,
  EditNetWorthRealAssetSelfReportedMutationVariables,
  EditNetWorthRealAssetSelfReportedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EditNetWorthRealAssetSelfReportedMutation, EditNetWorthRealAssetSelfReportedMutationVariables, EditNetWorthRealAssetSelfReportedProps<TChildProps, TDataName>>(EditNetWorthRealAssetSelfReportedDocument, {
      alias: 'editNetWorthRealAssetSelfReported',
      ...operationOptions
    });
};

/**
 * __useEditNetWorthRealAssetSelfReportedMutation__
 *
 * To run a mutation, you first call `useEditNetWorthRealAssetSelfReportedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEditNetWorthRealAssetSelfReportedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [editNetWorthRealAssetSelfReportedMutation, { data, loading, error }] = useEditNetWorthRealAssetSelfReportedMutation({
 *   variables: {
 *      netWorthRealAssetId: // value for 'netWorthRealAssetId'
 *      amount: // value for 'amount'
 *      nickname: // value for 'nickname'
 *   },
 * });
 */
export function useEditNetWorthRealAssetSelfReportedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EditNetWorthRealAssetSelfReportedMutation, EditNetWorthRealAssetSelfReportedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EditNetWorthRealAssetSelfReportedMutation, EditNetWorthRealAssetSelfReportedMutationVariables>(EditNetWorthRealAssetSelfReportedDocument, options);
      }
export type EditNetWorthRealAssetSelfReportedMutationHookResult = ReturnType<typeof useEditNetWorthRealAssetSelfReportedMutation>;
export type EditNetWorthRealAssetSelfReportedMutationResult = ApolloReactCommon.MutationResult<EditNetWorthRealAssetSelfReportedMutation>;
export type EditNetWorthRealAssetSelfReportedMutationOptions = ApolloReactCommon.BaseMutationOptions<EditNetWorthRealAssetSelfReportedMutation, EditNetWorthRealAssetSelfReportedMutationVariables>;
export const UpdateNetWorthRealAssetIsHiddenFromNetWorthDocument = gql`
    mutation UpdateNetWorthRealAssetIsHiddenFromNetWorth($netWorthRealAssetId: ID!, $isHiddenFromNetWorth: Boolean!) {
  updateNetWorthRealAssetIsHiddenFromNetWorth(
    netWorthRealAssetId: $netWorthRealAssetId
    isHiddenFromNetWorth: $isHiddenFromNetWorth
  ) {
    asset {
      id
      type
      isHiddenFromNetWorth
      amount
      lastReportedOrSyncedAt
      isSelfReported
      ... on NetWorthHomeIntegrated {
        address {
          addressLine1
          addressLine2
          city
          state
          zipCode
        }
        externalInfo {
          source
          value
        }
      }
      ... on NetWorthRealAssetSelfReported {
        nickname
      }
    }
  }
}
    `;
export type UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationFn = ApolloReactCommon.MutationFunction<UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation, UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationVariables>;
export type UpdateNetWorthRealAssetIsHiddenFromNetWorthComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation, UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationVariables>, 'mutation'>;

    export const UpdateNetWorthRealAssetIsHiddenFromNetWorthComponent = (props: UpdateNetWorthRealAssetIsHiddenFromNetWorthComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation, UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationVariables> mutation={UpdateNetWorthRealAssetIsHiddenFromNetWorthDocument} {...props} />
    );
    
export type UpdateNetWorthRealAssetIsHiddenFromNetWorthProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation, UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationVariables>
    } & TChildProps;
export function withUpdateNetWorthRealAssetIsHiddenFromNetWorth<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation,
  UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationVariables,
  UpdateNetWorthRealAssetIsHiddenFromNetWorthProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation, UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationVariables, UpdateNetWorthRealAssetIsHiddenFromNetWorthProps<TChildProps, TDataName>>(UpdateNetWorthRealAssetIsHiddenFromNetWorthDocument, {
      alias: 'updateNetWorthRealAssetIsHiddenFromNetWorth',
      ...operationOptions
    });
};

/**
 * __useUpdateNetWorthRealAssetIsHiddenFromNetWorthMutation__
 *
 * To run a mutation, you first call `useUpdateNetWorthRealAssetIsHiddenFromNetWorthMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNetWorthRealAssetIsHiddenFromNetWorthMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNetWorthRealAssetIsHiddenFromNetWorthMutation, { data, loading, error }] = useUpdateNetWorthRealAssetIsHiddenFromNetWorthMutation({
 *   variables: {
 *      netWorthRealAssetId: // value for 'netWorthRealAssetId'
 *      isHiddenFromNetWorth: // value for 'isHiddenFromNetWorth'
 *   },
 * });
 */
export function useUpdateNetWorthRealAssetIsHiddenFromNetWorthMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation, UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation, UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationVariables>(UpdateNetWorthRealAssetIsHiddenFromNetWorthDocument, options);
      }
export type UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationHookResult = ReturnType<typeof useUpdateNetWorthRealAssetIsHiddenFromNetWorthMutation>;
export type UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationResult = ApolloReactCommon.MutationResult<UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation>;
export type UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNetWorthRealAssetIsHiddenFromNetWorthMutation, UpdateNetWorthRealAssetIsHiddenFromNetWorthMutationVariables>;
export const GetFinancialTransactionsCashInCashOutSummaryDocument = gql`
    query GetFinancialTransactionsCashInCashOutSummary($currentDate: DateTime, $datePeriod: FinancialTransactionsSpendingComparisonDatePeriodEnum, $numPreviousDatePeriodsToInclude: Int) {
  financialTransactionsCashInCashOutSummaryForDatePeriod(
    currentDate: $currentDate
    datePeriod: $datePeriod
    numPreviousDatePeriodsToInclude: $numPreviousDatePeriodsToInclude
  ) {
    averageNetPreviousDatePeriods
    summaries {
      date
      cashIn
      cashOut
      net
    }
  }
}
    `;
export type GetFinancialTransactionsCashInCashOutSummaryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables>, 'query'>;

    export const GetFinancialTransactionsCashInCashOutSummaryComponent = (props: GetFinancialTransactionsCashInCashOutSummaryComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables> query={GetFinancialTransactionsCashInCashOutSummaryDocument} {...props} />
    );
    
export type GetFinancialTransactionsCashInCashOutSummaryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables>
    } & TChildProps;
export function withGetFinancialTransactionsCashInCashOutSummary<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialTransactionsCashInCashOutSummaryQuery,
  GetFinancialTransactionsCashInCashOutSummaryQueryVariables,
  GetFinancialTransactionsCashInCashOutSummaryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables, GetFinancialTransactionsCashInCashOutSummaryProps<TChildProps, TDataName>>(GetFinancialTransactionsCashInCashOutSummaryDocument, {
      alias: 'getFinancialTransactionsCashInCashOutSummary',
      ...operationOptions
    });
};

/**
 * __useGetFinancialTransactionsCashInCashOutSummaryQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionsCashInCashOutSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionsCashInCashOutSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionsCashInCashOutSummaryQuery({
 *   variables: {
 *      currentDate: // value for 'currentDate'
 *      datePeriod: // value for 'datePeriod'
 *      numPreviousDatePeriodsToInclude: // value for 'numPreviousDatePeriodsToInclude'
 *   },
 * });
 */
export function useGetFinancialTransactionsCashInCashOutSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables>(GetFinancialTransactionsCashInCashOutSummaryDocument, options);
      }
export function useGetFinancialTransactionsCashInCashOutSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables>(GetFinancialTransactionsCashInCashOutSummaryDocument, options);
        }
export function useGetFinancialTransactionsCashInCashOutSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables>(GetFinancialTransactionsCashInCashOutSummaryDocument, options);
        }
export type GetFinancialTransactionsCashInCashOutSummaryQueryHookResult = ReturnType<typeof useGetFinancialTransactionsCashInCashOutSummaryQuery>;
export type GetFinancialTransactionsCashInCashOutSummaryLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionsCashInCashOutSummaryLazyQuery>;
export type GetFinancialTransactionsCashInCashOutSummarySuspenseQueryHookResult = ReturnType<typeof useGetFinancialTransactionsCashInCashOutSummarySuspenseQuery>;
export type GetFinancialTransactionsCashInCashOutSummaryQueryResult = ApolloReactCommon.QueryResult<GetFinancialTransactionsCashInCashOutSummaryQuery, GetFinancialTransactionsCashInCashOutSummaryQueryVariables>;
export const GetRecentTransactionsDocument = gql`
    query GetRecentTransactions($pagination: AdvancedOffsetPaginationInput) {
  financialTransactions(pagination: $pagination) {
    transactions {
      amount
      categoryId
      currency
      date
      description
      id
      isHidden
      isPending
      merchantName
      tags
      type
    }
  }
}
    `;
export type GetRecentTransactionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables>, 'query'>;

    export const GetRecentTransactionsComponent = (props: GetRecentTransactionsComponentProps) => (
      <ApolloReactComponents.Query<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables> query={GetRecentTransactionsDocument} {...props} />
    );
    
export type GetRecentTransactionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables>
    } & TChildProps;
export function withGetRecentTransactions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRecentTransactionsQuery,
  GetRecentTransactionsQueryVariables,
  GetRecentTransactionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables, GetRecentTransactionsProps<TChildProps, TDataName>>(GetRecentTransactionsDocument, {
      alias: 'getRecentTransactions',
      ...operationOptions
    });
};

/**
 * __useGetRecentTransactionsQuery__
 *
 * To run a query within a React component, call `useGetRecentTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecentTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecentTransactionsQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetRecentTransactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables>(GetRecentTransactionsDocument, options);
      }
export function useGetRecentTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables>(GetRecentTransactionsDocument, options);
        }
export function useGetRecentTransactionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables>(GetRecentTransactionsDocument, options);
        }
export type GetRecentTransactionsQueryHookResult = ReturnType<typeof useGetRecentTransactionsQuery>;
export type GetRecentTransactionsLazyQueryHookResult = ReturnType<typeof useGetRecentTransactionsLazyQuery>;
export type GetRecentTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetRecentTransactionsSuspenseQuery>;
export type GetRecentTransactionsQueryResult = ApolloReactCommon.QueryResult<GetRecentTransactionsQuery, GetRecentTransactionsQueryVariables>;
export const FinancialPortalAccountsStateDocument = gql`
    query FinancialPortalAccountsState {
  linkedFinancialPortals {
    portals {
      id
      isActiveSync
    }
  }
}
    `;
export type FinancialPortalAccountsStateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables>, 'query'>;

    export const FinancialPortalAccountsStateComponent = (props: FinancialPortalAccountsStateComponentProps) => (
      <ApolloReactComponents.Query<FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables> query={FinancialPortalAccountsStateDocument} {...props} />
    );
    
export type FinancialPortalAccountsStateProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables>
    } & TChildProps;
export function withFinancialPortalAccountsState<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FinancialPortalAccountsStateQuery,
  FinancialPortalAccountsStateQueryVariables,
  FinancialPortalAccountsStateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables, FinancialPortalAccountsStateProps<TChildProps, TDataName>>(FinancialPortalAccountsStateDocument, {
      alias: 'financialPortalAccountsState',
      ...operationOptions
    });
};

/**
 * __useFinancialPortalAccountsStateQuery__
 *
 * To run a query within a React component, call `useFinancialPortalAccountsStateQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialPortalAccountsStateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialPortalAccountsStateQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinancialPortalAccountsStateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables>(FinancialPortalAccountsStateDocument, options);
      }
export function useFinancialPortalAccountsStateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables>(FinancialPortalAccountsStateDocument, options);
        }
export function useFinancialPortalAccountsStateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables>(FinancialPortalAccountsStateDocument, options);
        }
export type FinancialPortalAccountsStateQueryHookResult = ReturnType<typeof useFinancialPortalAccountsStateQuery>;
export type FinancialPortalAccountsStateLazyQueryHookResult = ReturnType<typeof useFinancialPortalAccountsStateLazyQuery>;
export type FinancialPortalAccountsStateSuspenseQueryHookResult = ReturnType<typeof useFinancialPortalAccountsStateSuspenseQuery>;
export type FinancialPortalAccountsStateQueryResult = ApolloReactCommon.QueryResult<FinancialPortalAccountsStateQuery, FinancialPortalAccountsStateQueryVariables>;
export const CreditScoreFactorsAgeAndMixDocument = gql`
    query CreditScoreFactorsAgeAndMix {
  creditFactors {
    ageAndMixOfAccounts {
      tradelineSections {
        ...tradelineSectionsFragment
        tradelines {
          ...accountTypeItemFragment
        }
      }
    }
  }
}
    ${TradelineSectionsFragmentFragmentDoc}
${AccountTypeItemFragmentFragmentDoc}`;
export type CreditScoreFactorsAgeAndMixComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables>, 'query'>;

    export const CreditScoreFactorsAgeAndMixComponent = (props: CreditScoreFactorsAgeAndMixComponentProps) => (
      <ApolloReactComponents.Query<CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables> query={CreditScoreFactorsAgeAndMixDocument} {...props} />
    );
    
export type CreditScoreFactorsAgeAndMixProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables>
    } & TChildProps;
export function withCreditScoreFactorsAgeAndMix<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreditScoreFactorsAgeAndMixQuery,
  CreditScoreFactorsAgeAndMixQueryVariables,
  CreditScoreFactorsAgeAndMixProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables, CreditScoreFactorsAgeAndMixProps<TChildProps, TDataName>>(CreditScoreFactorsAgeAndMixDocument, {
      alias: 'creditScoreFactorsAgeAndMix',
      ...operationOptions
    });
};

/**
 * __useCreditScoreFactorsAgeAndMixQuery__
 *
 * To run a query within a React component, call `useCreditScoreFactorsAgeAndMixQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditScoreFactorsAgeAndMixQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditScoreFactorsAgeAndMixQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditScoreFactorsAgeAndMixQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables>(CreditScoreFactorsAgeAndMixDocument, options);
      }
export function useCreditScoreFactorsAgeAndMixLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables>(CreditScoreFactorsAgeAndMixDocument, options);
        }
export function useCreditScoreFactorsAgeAndMixSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables>(CreditScoreFactorsAgeAndMixDocument, options);
        }
export type CreditScoreFactorsAgeAndMixQueryHookResult = ReturnType<typeof useCreditScoreFactorsAgeAndMixQuery>;
export type CreditScoreFactorsAgeAndMixLazyQueryHookResult = ReturnType<typeof useCreditScoreFactorsAgeAndMixLazyQuery>;
export type CreditScoreFactorsAgeAndMixSuspenseQueryHookResult = ReturnType<typeof useCreditScoreFactorsAgeAndMixSuspenseQuery>;
export type CreditScoreFactorsAgeAndMixQueryResult = ApolloReactCommon.QueryResult<CreditScoreFactorsAgeAndMixQuery, CreditScoreFactorsAgeAndMixQueryVariables>;
export const CreditFactorTipsDocument = gql`
    query CreditFactorTips {
  creditFactors {
    balances {
      tradelineSections {
        ...CreditFactorTradelineSectionFields
      }
    }
  }
}
    ${CreditFactorTradelineSectionFieldsFragmentDoc}`;
export type CreditFactorTipsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CreditFactorTipsQuery, CreditFactorTipsQueryVariables>, 'query'>;

    export const CreditFactorTipsComponent = (props: CreditFactorTipsComponentProps) => (
      <ApolloReactComponents.Query<CreditFactorTipsQuery, CreditFactorTipsQueryVariables> query={CreditFactorTipsDocument} {...props} />
    );
    
export type CreditFactorTipsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CreditFactorTipsQuery, CreditFactorTipsQueryVariables>
    } & TChildProps;
export function withCreditFactorTips<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreditFactorTipsQuery,
  CreditFactorTipsQueryVariables,
  CreditFactorTipsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CreditFactorTipsQuery, CreditFactorTipsQueryVariables, CreditFactorTipsProps<TChildProps, TDataName>>(CreditFactorTipsDocument, {
      alias: 'creditFactorTips',
      ...operationOptions
    });
};

/**
 * __useCreditFactorTipsQuery__
 *
 * To run a query within a React component, call `useCreditFactorTipsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditFactorTipsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditFactorTipsQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditFactorTipsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreditFactorTipsQuery, CreditFactorTipsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditFactorTipsQuery, CreditFactorTipsQueryVariables>(CreditFactorTipsDocument, options);
      }
export function useCreditFactorTipsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditFactorTipsQuery, CreditFactorTipsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditFactorTipsQuery, CreditFactorTipsQueryVariables>(CreditFactorTipsDocument, options);
        }
export function useCreditFactorTipsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreditFactorTipsQuery, CreditFactorTipsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreditFactorTipsQuery, CreditFactorTipsQueryVariables>(CreditFactorTipsDocument, options);
        }
export type CreditFactorTipsQueryHookResult = ReturnType<typeof useCreditFactorTipsQuery>;
export type CreditFactorTipsLazyQueryHookResult = ReturnType<typeof useCreditFactorTipsLazyQuery>;
export type CreditFactorTipsSuspenseQueryHookResult = ReturnType<typeof useCreditFactorTipsSuspenseQuery>;
export type CreditFactorTipsQueryResult = ApolloReactCommon.QueryResult<CreditFactorTipsQuery, CreditFactorTipsQueryVariables>;
export const GetCreditScoreDataDocument = gql`
    query GetCreditScoreData {
  tuCreditReportIdentityProfile {
    reportPulledAt
  }
}
    `;
export type GetCreditScoreDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables>, 'query'>;

    export const GetCreditScoreDataComponent = (props: GetCreditScoreDataComponentProps) => (
      <ApolloReactComponents.Query<GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables> query={GetCreditScoreDataDocument} {...props} />
    );
    
export type GetCreditScoreDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables>
    } & TChildProps;
export function withGetCreditScoreData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCreditScoreDataQuery,
  GetCreditScoreDataQueryVariables,
  GetCreditScoreDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables, GetCreditScoreDataProps<TChildProps, TDataName>>(GetCreditScoreDataDocument, {
      alias: 'getCreditScoreData',
      ...operationOptions
    });
};

/**
 * __useGetCreditScoreDataQuery__
 *
 * To run a query within a React component, call `useGetCreditScoreDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditScoreDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditScoreDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditScoreDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables>(GetCreditScoreDataDocument, options);
      }
export function useGetCreditScoreDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables>(GetCreditScoreDataDocument, options);
        }
export function useGetCreditScoreDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables>(GetCreditScoreDataDocument, options);
        }
export type GetCreditScoreDataQueryHookResult = ReturnType<typeof useGetCreditScoreDataQuery>;
export type GetCreditScoreDataLazyQueryHookResult = ReturnType<typeof useGetCreditScoreDataLazyQuery>;
export type GetCreditScoreDataSuspenseQueryHookResult = ReturnType<typeof useGetCreditScoreDataSuspenseQuery>;
export type GetCreditScoreDataQueryResult = ApolloReactCommon.QueryResult<GetCreditScoreDataQuery, GetCreditScoreDataQueryVariables>;
export const UpdateCtaDismissedFlagsDocument = gql`
    mutation UpdateCtaDismissedFlags($dismissAccountAggCta: AccountAggCtaDismissedInput!) {
  updateDismissAccountAggCta(dismissAccountAggCta: $dismissAccountAggCta) {
    creditScoreBigBanner
    creditScoreSmallBanner
    utilizationBigBanner
    utilizationFaq
    utilizationSmallBanner
    ageAndMixOfAccountsSmallBanner
    balancesSmallBanner
    tradelineTopLink
    tradelineSmallBanner
    spendingSmallBanner
    debtSmallBanner
  }
}
    `;
export type UpdateCtaDismissedFlagsMutationFn = ApolloReactCommon.MutationFunction<UpdateCtaDismissedFlagsMutation, UpdateCtaDismissedFlagsMutationVariables>;
export type UpdateCtaDismissedFlagsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCtaDismissedFlagsMutation, UpdateCtaDismissedFlagsMutationVariables>, 'mutation'>;

    export const UpdateCtaDismissedFlagsComponent = (props: UpdateCtaDismissedFlagsComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateCtaDismissedFlagsMutation, UpdateCtaDismissedFlagsMutationVariables> mutation={UpdateCtaDismissedFlagsDocument} {...props} />
    );
    
export type UpdateCtaDismissedFlagsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCtaDismissedFlagsMutation, UpdateCtaDismissedFlagsMutationVariables>
    } & TChildProps;
export function withUpdateCtaDismissedFlags<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCtaDismissedFlagsMutation,
  UpdateCtaDismissedFlagsMutationVariables,
  UpdateCtaDismissedFlagsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCtaDismissedFlagsMutation, UpdateCtaDismissedFlagsMutationVariables, UpdateCtaDismissedFlagsProps<TChildProps, TDataName>>(UpdateCtaDismissedFlagsDocument, {
      alias: 'updateCtaDismissedFlags',
      ...operationOptions
    });
};

/**
 * __useUpdateCtaDismissedFlagsMutation__
 *
 * To run a mutation, you first call `useUpdateCtaDismissedFlagsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCtaDismissedFlagsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCtaDismissedFlagsMutation, { data, loading, error }] = useUpdateCtaDismissedFlagsMutation({
 *   variables: {
 *      dismissAccountAggCta: // value for 'dismissAccountAggCta'
 *   },
 * });
 */
export function useUpdateCtaDismissedFlagsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCtaDismissedFlagsMutation, UpdateCtaDismissedFlagsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCtaDismissedFlagsMutation, UpdateCtaDismissedFlagsMutationVariables>(UpdateCtaDismissedFlagsDocument, options);
      }
export type UpdateCtaDismissedFlagsMutationHookResult = ReturnType<typeof useUpdateCtaDismissedFlagsMutation>;
export type UpdateCtaDismissedFlagsMutationResult = ApolloReactCommon.MutationResult<UpdateCtaDismissedFlagsMutation>;
export type UpdateCtaDismissedFlagsMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCtaDismissedFlagsMutation, UpdateCtaDismissedFlagsMutationVariables>;
export const GetAccountAggregationCtaDataDocument = gql`
    query GetAccountAggregationCtaData {
  netWorthAccounts {
    accounts {
      id
    }
  }
  accountAggCtaDismissedFlags {
    creditScoreBigBanner
    creditScoreSmallBanner
    utilizationBigBanner
    utilizationFaq
    utilizationSmallBanner
    ageAndMixOfAccountsSmallBanner
    balancesSmallBanner
    tradelineTopLink
    tradelineSmallBanner
    spendingSmallBanner
    accountsSmallBanner
    debtSmallBanner
  }
}
    `;
export type GetAccountAggregationCtaDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables>, 'query'>;

    export const GetAccountAggregationCtaDataComponent = (props: GetAccountAggregationCtaDataComponentProps) => (
      <ApolloReactComponents.Query<GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables> query={GetAccountAggregationCtaDataDocument} {...props} />
    );
    
export type GetAccountAggregationCtaDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables>
    } & TChildProps;
export function withGetAccountAggregationCtaData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAccountAggregationCtaDataQuery,
  GetAccountAggregationCtaDataQueryVariables,
  GetAccountAggregationCtaDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables, GetAccountAggregationCtaDataProps<TChildProps, TDataName>>(GetAccountAggregationCtaDataDocument, {
      alias: 'getAccountAggregationCtaData',
      ...operationOptions
    });
};

/**
 * __useGetAccountAggregationCtaDataQuery__
 *
 * To run a query within a React component, call `useGetAccountAggregationCtaDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountAggregationCtaDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountAggregationCtaDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountAggregationCtaDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables>(GetAccountAggregationCtaDataDocument, options);
      }
export function useGetAccountAggregationCtaDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables>(GetAccountAggregationCtaDataDocument, options);
        }
export function useGetAccountAggregationCtaDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables>(GetAccountAggregationCtaDataDocument, options);
        }
export type GetAccountAggregationCtaDataQueryHookResult = ReturnType<typeof useGetAccountAggregationCtaDataQuery>;
export type GetAccountAggregationCtaDataLazyQueryHookResult = ReturnType<typeof useGetAccountAggregationCtaDataLazyQuery>;
export type GetAccountAggregationCtaDataSuspenseQueryHookResult = ReturnType<typeof useGetAccountAggregationCtaDataSuspenseQuery>;
export type GetAccountAggregationCtaDataQueryResult = ApolloReactCommon.QueryResult<GetAccountAggregationCtaDataQuery, GetAccountAggregationCtaDataQueryVariables>;
export const CreditScoreFactorsRecentInquiriesDocument = gql`
    query CreditScoreFactorsRecentInquiries {
  creditFactors {
    recentInquiries {
      inquirySections {
        isPriority
        label
        title
        ...highlightWrapperInquiryFragment
        inquiries {
          ...inquiriesSectionFragment
        }
      }
    }
  }
}
    ${HighlightWrapperInquiryFragmentFragmentDoc}
${InquiriesSectionFragmentFragmentDoc}`;
export type CreditScoreFactorsRecentInquiriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables>, 'query'>;

    export const CreditScoreFactorsRecentInquiriesComponent = (props: CreditScoreFactorsRecentInquiriesComponentProps) => (
      <ApolloReactComponents.Query<CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables> query={CreditScoreFactorsRecentInquiriesDocument} {...props} />
    );
    
export type CreditScoreFactorsRecentInquiriesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables>
    } & TChildProps;
export function withCreditScoreFactorsRecentInquiries<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreditScoreFactorsRecentInquiriesQuery,
  CreditScoreFactorsRecentInquiriesQueryVariables,
  CreditScoreFactorsRecentInquiriesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables, CreditScoreFactorsRecentInquiriesProps<TChildProps, TDataName>>(CreditScoreFactorsRecentInquiriesDocument, {
      alias: 'creditScoreFactorsRecentInquiries',
      ...operationOptions
    });
};

/**
 * __useCreditScoreFactorsRecentInquiriesQuery__
 *
 * To run a query within a React component, call `useCreditScoreFactorsRecentInquiriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditScoreFactorsRecentInquiriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditScoreFactorsRecentInquiriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditScoreFactorsRecentInquiriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables>(CreditScoreFactorsRecentInquiriesDocument, options);
      }
export function useCreditScoreFactorsRecentInquiriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables>(CreditScoreFactorsRecentInquiriesDocument, options);
        }
export function useCreditScoreFactorsRecentInquiriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables>(CreditScoreFactorsRecentInquiriesDocument, options);
        }
export type CreditScoreFactorsRecentInquiriesQueryHookResult = ReturnType<typeof useCreditScoreFactorsRecentInquiriesQuery>;
export type CreditScoreFactorsRecentInquiriesLazyQueryHookResult = ReturnType<typeof useCreditScoreFactorsRecentInquiriesLazyQuery>;
export type CreditScoreFactorsRecentInquiriesSuspenseQueryHookResult = ReturnType<typeof useCreditScoreFactorsRecentInquiriesSuspenseQuery>;
export type CreditScoreFactorsRecentInquiriesQueryResult = ApolloReactCommon.QueryResult<CreditScoreFactorsRecentInquiriesQuery, CreditScoreFactorsRecentInquiriesQueryVariables>;
export const CreditScoreFactorsPaymentHistoryDocument = gql`
    query CreditScoreFactorsPaymentHistory {
  creditFactors {
    paymentHistory {
      tradelineSections {
        ...collapsibleTradelineSectionsFragment
        tradelines {
          ...paymentTradelineItemFragment
        }
      }
    }
  }
}
    ${CollapsibleTradelineSectionsFragmentFragmentDoc}
${PaymentTradelineItemFragmentFragmentDoc}`;
export type CreditScoreFactorsPaymentHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables>, 'query'>;

    export const CreditScoreFactorsPaymentHistoryComponent = (props: CreditScoreFactorsPaymentHistoryComponentProps) => (
      <ApolloReactComponents.Query<CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables> query={CreditScoreFactorsPaymentHistoryDocument} {...props} />
    );
    
export type CreditScoreFactorsPaymentHistoryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables>
    } & TChildProps;
export function withCreditScoreFactorsPaymentHistory<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreditScoreFactorsPaymentHistoryQuery,
  CreditScoreFactorsPaymentHistoryQueryVariables,
  CreditScoreFactorsPaymentHistoryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables, CreditScoreFactorsPaymentHistoryProps<TChildProps, TDataName>>(CreditScoreFactorsPaymentHistoryDocument, {
      alias: 'creditScoreFactorsPaymentHistory',
      ...operationOptions
    });
};

/**
 * __useCreditScoreFactorsPaymentHistoryQuery__
 *
 * To run a query within a React component, call `useCreditScoreFactorsPaymentHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditScoreFactorsPaymentHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditScoreFactorsPaymentHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditScoreFactorsPaymentHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables>(CreditScoreFactorsPaymentHistoryDocument, options);
      }
export function useCreditScoreFactorsPaymentHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables>(CreditScoreFactorsPaymentHistoryDocument, options);
        }
export function useCreditScoreFactorsPaymentHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables>(CreditScoreFactorsPaymentHistoryDocument, options);
        }
export type CreditScoreFactorsPaymentHistoryQueryHookResult = ReturnType<typeof useCreditScoreFactorsPaymentHistoryQuery>;
export type CreditScoreFactorsPaymentHistoryLazyQueryHookResult = ReturnType<typeof useCreditScoreFactorsPaymentHistoryLazyQuery>;
export type CreditScoreFactorsPaymentHistorySuspenseQueryHookResult = ReturnType<typeof useCreditScoreFactorsPaymentHistorySuspenseQuery>;
export type CreditScoreFactorsPaymentHistoryQueryResult = ApolloReactCommon.QueryResult<CreditScoreFactorsPaymentHistoryQuery, CreditScoreFactorsPaymentHistoryQueryVariables>;
export const CreditScoreFactorsCreditUtilizationDocument = gql`
    query CreditScoreFactorsCreditUtilization {
  creditFactors {
    creditUtilization {
      tradelineSections {
        ...tradelineSectionsFragment
        tradelines {
          ...creditUtilizationItemFragment
        }
      }
    }
  }
}
    ${TradelineSectionsFragmentFragmentDoc}
${CreditUtilizationItemFragmentFragmentDoc}`;
export type CreditScoreFactorsCreditUtilizationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables>, 'query'>;

    export const CreditScoreFactorsCreditUtilizationComponent = (props: CreditScoreFactorsCreditUtilizationComponentProps) => (
      <ApolloReactComponents.Query<CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables> query={CreditScoreFactorsCreditUtilizationDocument} {...props} />
    );
    
export type CreditScoreFactorsCreditUtilizationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables>
    } & TChildProps;
export function withCreditScoreFactorsCreditUtilization<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreditScoreFactorsCreditUtilizationQuery,
  CreditScoreFactorsCreditUtilizationQueryVariables,
  CreditScoreFactorsCreditUtilizationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables, CreditScoreFactorsCreditUtilizationProps<TChildProps, TDataName>>(CreditScoreFactorsCreditUtilizationDocument, {
      alias: 'creditScoreFactorsCreditUtilization',
      ...operationOptions
    });
};

/**
 * __useCreditScoreFactorsCreditUtilizationQuery__
 *
 * To run a query within a React component, call `useCreditScoreFactorsCreditUtilizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditScoreFactorsCreditUtilizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditScoreFactorsCreditUtilizationQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditScoreFactorsCreditUtilizationQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables>(CreditScoreFactorsCreditUtilizationDocument, options);
      }
export function useCreditScoreFactorsCreditUtilizationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables>(CreditScoreFactorsCreditUtilizationDocument, options);
        }
export function useCreditScoreFactorsCreditUtilizationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables>(CreditScoreFactorsCreditUtilizationDocument, options);
        }
export type CreditScoreFactorsCreditUtilizationQueryHookResult = ReturnType<typeof useCreditScoreFactorsCreditUtilizationQuery>;
export type CreditScoreFactorsCreditUtilizationLazyQueryHookResult = ReturnType<typeof useCreditScoreFactorsCreditUtilizationLazyQuery>;
export type CreditScoreFactorsCreditUtilizationSuspenseQueryHookResult = ReturnType<typeof useCreditScoreFactorsCreditUtilizationSuspenseQuery>;
export type CreditScoreFactorsCreditUtilizationQueryResult = ApolloReactCommon.QueryResult<CreditScoreFactorsCreditUtilizationQuery, CreditScoreFactorsCreditUtilizationQueryVariables>;
export const CreditHeaderDocument = gql`
    query CreditHeader {
  tuCreditReportIdentityProfile {
    vantageScore3
    vantageScore3Bucket
    vantageScore3Delta
    reportPulledAt
  }
}
    `;
export type CreditHeaderComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CreditHeaderQuery, CreditHeaderQueryVariables>, 'query'>;

    export const CreditHeaderComponent = (props: CreditHeaderComponentProps) => (
      <ApolloReactComponents.Query<CreditHeaderQuery, CreditHeaderQueryVariables> query={CreditHeaderDocument} {...props} />
    );
    
export type CreditHeaderProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CreditHeaderQuery, CreditHeaderQueryVariables>
    } & TChildProps;
export function withCreditHeader<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreditHeaderQuery,
  CreditHeaderQueryVariables,
  CreditHeaderProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CreditHeaderQuery, CreditHeaderQueryVariables, CreditHeaderProps<TChildProps, TDataName>>(CreditHeaderDocument, {
      alias: 'creditHeader',
      ...operationOptions
    });
};

/**
 * __useCreditHeaderQuery__
 *
 * To run a query within a React component, call `useCreditHeaderQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditHeaderQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditHeaderQuery({
 *   variables: {
 *   },
 * });
 */
export function useCreditHeaderQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<CreditHeaderQuery, CreditHeaderQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditHeaderQuery, CreditHeaderQueryVariables>(CreditHeaderDocument, options);
      }
export function useCreditHeaderLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditHeaderQuery, CreditHeaderQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditHeaderQuery, CreditHeaderQueryVariables>(CreditHeaderDocument, options);
        }
export function useCreditHeaderSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreditHeaderQuery, CreditHeaderQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreditHeaderQuery, CreditHeaderQueryVariables>(CreditHeaderDocument, options);
        }
export type CreditHeaderQueryHookResult = ReturnType<typeof useCreditHeaderQuery>;
export type CreditHeaderLazyQueryHookResult = ReturnType<typeof useCreditHeaderLazyQuery>;
export type CreditHeaderSuspenseQueryHookResult = ReturnType<typeof useCreditHeaderSuspenseQuery>;
export type CreditHeaderQueryResult = ApolloReactCommon.QueryResult<CreditHeaderQuery, CreditHeaderQueryVariables>;
export const CreditScoreHistoryQueryDocument = gql`
    query CreditScoreHistoryQuery($input: CreditScoreHistoryInput!) {
  creditScoreHistory(input: $input) {
    data {
      vantageScore3
      date
    }
  }
}
    `;
export type CreditScoreHistoryQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables>, 'query'> & ({ variables: CreditScoreHistoryQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CreditScoreHistoryQueryComponent = (props: CreditScoreHistoryQueryComponentProps) => (
      <ApolloReactComponents.Query<CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables> query={CreditScoreHistoryQueryDocument} {...props} />
    );
    
export type CreditScoreHistoryQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables>
    } & TChildProps;
export function withCreditScoreHistoryQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreditScoreHistoryQueryQuery,
  CreditScoreHistoryQueryQueryVariables,
  CreditScoreHistoryQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables, CreditScoreHistoryQueryProps<TChildProps, TDataName>>(CreditScoreHistoryQueryDocument, {
      alias: 'creditScoreHistoryQuery',
      ...operationOptions
    });
};

/**
 * __useCreditScoreHistoryQueryQuery__
 *
 * To run a query within a React component, call `useCreditScoreHistoryQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useCreditScoreHistoryQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCreditScoreHistoryQueryQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCreditScoreHistoryQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables> & ({ variables: CreditScoreHistoryQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables>(CreditScoreHistoryQueryDocument, options);
      }
export function useCreditScoreHistoryQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables>(CreditScoreHistoryQueryDocument, options);
        }
export function useCreditScoreHistoryQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables>(CreditScoreHistoryQueryDocument, options);
        }
export type CreditScoreHistoryQueryQueryHookResult = ReturnType<typeof useCreditScoreHistoryQueryQuery>;
export type CreditScoreHistoryQueryLazyQueryHookResult = ReturnType<typeof useCreditScoreHistoryQueryLazyQuery>;
export type CreditScoreHistoryQuerySuspenseQueryHookResult = ReturnType<typeof useCreditScoreHistoryQuerySuspenseQuery>;
export type CreditScoreHistoryQueryQueryResult = ApolloReactCommon.QueryResult<CreditScoreHistoryQueryQuery, CreditScoreHistoryQueryQueryVariables>;
export const GetCreditScoreInsightsDocument = gql`
    query GetCreditScoreInsights($eligibleModule: UserInsightEligibleModulesEnum!) {
  userInsights(filter: {eligibleModules: [$eligibleModule]}) {
    userInsights {
      id
      ...creditScoreUserInsightCardFragment
    }
  }
}
    ${CreditScoreUserInsightCardFragmentFragmentDoc}`;
export type GetCreditScoreInsightsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables>, 'query'> & ({ variables: GetCreditScoreInsightsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCreditScoreInsightsComponent = (props: GetCreditScoreInsightsComponentProps) => (
      <ApolloReactComponents.Query<GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables> query={GetCreditScoreInsightsDocument} {...props} />
    );
    
export type GetCreditScoreInsightsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables>
    } & TChildProps;
export function withGetCreditScoreInsights<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCreditScoreInsightsQuery,
  GetCreditScoreInsightsQueryVariables,
  GetCreditScoreInsightsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables, GetCreditScoreInsightsProps<TChildProps, TDataName>>(GetCreditScoreInsightsDocument, {
      alias: 'getCreditScoreInsights',
      ...operationOptions
    });
};

/**
 * __useGetCreditScoreInsightsQuery__
 *
 * To run a query within a React component, call `useGetCreditScoreInsightsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditScoreInsightsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditScoreInsightsQuery({
 *   variables: {
 *      eligibleModule: // value for 'eligibleModule'
 *   },
 * });
 */
export function useGetCreditScoreInsightsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables> & ({ variables: GetCreditScoreInsightsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables>(GetCreditScoreInsightsDocument, options);
      }
export function useGetCreditScoreInsightsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables>(GetCreditScoreInsightsDocument, options);
        }
export function useGetCreditScoreInsightsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables>(GetCreditScoreInsightsDocument, options);
        }
export type GetCreditScoreInsightsQueryHookResult = ReturnType<typeof useGetCreditScoreInsightsQuery>;
export type GetCreditScoreInsightsLazyQueryHookResult = ReturnType<typeof useGetCreditScoreInsightsLazyQuery>;
export type GetCreditScoreInsightsSuspenseQueryHookResult = ReturnType<typeof useGetCreditScoreInsightsSuspenseQuery>;
export type GetCreditScoreInsightsQueryResult = ApolloReactCommon.QueryResult<GetCreditScoreInsightsQuery, GetCreditScoreInsightsQueryVariables>;
export const GetCreditScoreRewardsEmitterDataDocument = gql`
    query GetCreditScoreRewardsEmitterData {
  tuCreditReportIdentityProfile {
    vantageScore3
    vantageScore3Bucket
    vantageScore3Delta
  }
}
    `;
export type GetCreditScoreRewardsEmitterDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables>, 'query'>;

    export const GetCreditScoreRewardsEmitterDataComponent = (props: GetCreditScoreRewardsEmitterDataComponentProps) => (
      <ApolloReactComponents.Query<GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables> query={GetCreditScoreRewardsEmitterDataDocument} {...props} />
    );
    
export type GetCreditScoreRewardsEmitterDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables>
    } & TChildProps;
export function withGetCreditScoreRewardsEmitterData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCreditScoreRewardsEmitterDataQuery,
  GetCreditScoreRewardsEmitterDataQueryVariables,
  GetCreditScoreRewardsEmitterDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables, GetCreditScoreRewardsEmitterDataProps<TChildProps, TDataName>>(GetCreditScoreRewardsEmitterDataDocument, {
      alias: 'getCreditScoreRewardsEmitterData',
      ...operationOptions
    });
};

/**
 * __useGetCreditScoreRewardsEmitterDataQuery__
 *
 * To run a query within a React component, call `useGetCreditScoreRewardsEmitterDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditScoreRewardsEmitterDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditScoreRewardsEmitterDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditScoreRewardsEmitterDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables>(GetCreditScoreRewardsEmitterDataDocument, options);
      }
export function useGetCreditScoreRewardsEmitterDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables>(GetCreditScoreRewardsEmitterDataDocument, options);
        }
export function useGetCreditScoreRewardsEmitterDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables>(GetCreditScoreRewardsEmitterDataDocument, options);
        }
export type GetCreditScoreRewardsEmitterDataQueryHookResult = ReturnType<typeof useGetCreditScoreRewardsEmitterDataQuery>;
export type GetCreditScoreRewardsEmitterDataLazyQueryHookResult = ReturnType<typeof useGetCreditScoreRewardsEmitterDataLazyQuery>;
export type GetCreditScoreRewardsEmitterDataSuspenseQueryHookResult = ReturnType<typeof useGetCreditScoreRewardsEmitterDataSuspenseQuery>;
export type GetCreditScoreRewardsEmitterDataQueryResult = ApolloReactCommon.QueryResult<GetCreditScoreRewardsEmitterDataQuery, GetCreditScoreRewardsEmitterDataQueryVariables>;
export const GetUnactivatedCreditScoreDocument = gql`
    query getUnactivatedCreditScore {
  tuAuthenticationStatusProfile {
    blockedAt
    thinFileReason
    isDeceased
    hasThinFile
    notEnoughData
  }
}
    `;
export type GetUnactivatedCreditScoreComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables>, 'query'>;

    export const GetUnactivatedCreditScoreComponent = (props: GetUnactivatedCreditScoreComponentProps) => (
      <ApolloReactComponents.Query<GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables> query={GetUnactivatedCreditScoreDocument} {...props} />
    );
    
export type GetUnactivatedCreditScoreProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables>
    } & TChildProps;
export function withGetUnactivatedCreditScore<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUnactivatedCreditScoreQuery,
  GetUnactivatedCreditScoreQueryVariables,
  GetUnactivatedCreditScoreProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables, GetUnactivatedCreditScoreProps<TChildProps, TDataName>>(GetUnactivatedCreditScoreDocument, {
      alias: 'getUnactivatedCreditScore',
      ...operationOptions
    });
};

/**
 * __useGetUnactivatedCreditScoreQuery__
 *
 * To run a query within a React component, call `useGetUnactivatedCreditScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUnactivatedCreditScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUnactivatedCreditScoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUnactivatedCreditScoreQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables>(GetUnactivatedCreditScoreDocument, options);
      }
export function useGetUnactivatedCreditScoreLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables>(GetUnactivatedCreditScoreDocument, options);
        }
export function useGetUnactivatedCreditScoreSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables>(GetUnactivatedCreditScoreDocument, options);
        }
export type GetUnactivatedCreditScoreQueryHookResult = ReturnType<typeof useGetUnactivatedCreditScoreQuery>;
export type GetUnactivatedCreditScoreLazyQueryHookResult = ReturnType<typeof useGetUnactivatedCreditScoreLazyQuery>;
export type GetUnactivatedCreditScoreSuspenseQueryHookResult = ReturnType<typeof useGetUnactivatedCreditScoreSuspenseQuery>;
export type GetUnactivatedCreditScoreQueryResult = ApolloReactCommon.QueryResult<GetUnactivatedCreditScoreQuery, GetUnactivatedCreditScoreQueryVariables>;
export const SimulateVantageScoreDocument = gql`
    query SimulateVantageScore($input: CreditSimulationInput!) {
  simulateVantageScore(input: $input) {
    result
  }
}
    `;
export type SimulateVantageScoreComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables>, 'query'> & ({ variables: SimulateVantageScoreQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SimulateVantageScoreComponent = (props: SimulateVantageScoreComponentProps) => (
      <ApolloReactComponents.Query<SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables> query={SimulateVantageScoreDocument} {...props} />
    );
    
export type SimulateVantageScoreProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables>
    } & TChildProps;
export function withSimulateVantageScore<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SimulateVantageScoreQuery,
  SimulateVantageScoreQueryVariables,
  SimulateVantageScoreProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables, SimulateVantageScoreProps<TChildProps, TDataName>>(SimulateVantageScoreDocument, {
      alias: 'simulateVantageScore',
      ...operationOptions
    });
};

/**
 * __useSimulateVantageScoreQuery__
 *
 * To run a query within a React component, call `useSimulateVantageScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useSimulateVantageScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSimulateVantageScoreQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSimulateVantageScoreQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables> & ({ variables: SimulateVantageScoreQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables>(SimulateVantageScoreDocument, options);
      }
export function useSimulateVantageScoreLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables>(SimulateVantageScoreDocument, options);
        }
export function useSimulateVantageScoreSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables>(SimulateVantageScoreDocument, options);
        }
export type SimulateVantageScoreQueryHookResult = ReturnType<typeof useSimulateVantageScoreQuery>;
export type SimulateVantageScoreLazyQueryHookResult = ReturnType<typeof useSimulateVantageScoreLazyQuery>;
export type SimulateVantageScoreSuspenseQueryHookResult = ReturnType<typeof useSimulateVantageScoreSuspenseQuery>;
export type SimulateVantageScoreQueryResult = ApolloReactCommon.QueryResult<SimulateVantageScoreQuery, SimulateVantageScoreQueryVariables>;
export const GetCreditScoreDocument = gql`
    query getCreditScore {
  tuCreditReportIdentityProfile {
    nwSumBalancesOpenRevolvingLineOfCredit
    vantageScore3
  }
}
    `;
export type GetCreditScoreComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCreditScoreQuery, GetCreditScoreQueryVariables>, 'query'>;

    export const GetCreditScoreComponent = (props: GetCreditScoreComponentProps) => (
      <ApolloReactComponents.Query<GetCreditScoreQuery, GetCreditScoreQueryVariables> query={GetCreditScoreDocument} {...props} />
    );
    
export type GetCreditScoreProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCreditScoreQuery, GetCreditScoreQueryVariables>
    } & TChildProps;
export function withGetCreditScore<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCreditScoreQuery,
  GetCreditScoreQueryVariables,
  GetCreditScoreProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCreditScoreQuery, GetCreditScoreQueryVariables, GetCreditScoreProps<TChildProps, TDataName>>(GetCreditScoreDocument, {
      alias: 'getCreditScore',
      ...operationOptions
    });
};

/**
 * __useGetCreditScoreQuery__
 *
 * To run a query within a React component, call `useGetCreditScoreQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditScoreQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditScoreQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditScoreQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCreditScoreQuery, GetCreditScoreQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditScoreQuery, GetCreditScoreQueryVariables>(GetCreditScoreDocument, options);
      }
export function useGetCreditScoreLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditScoreQuery, GetCreditScoreQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditScoreQuery, GetCreditScoreQueryVariables>(GetCreditScoreDocument, options);
        }
export function useGetCreditScoreSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditScoreQuery, GetCreditScoreQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditScoreQuery, GetCreditScoreQueryVariables>(GetCreditScoreDocument, options);
        }
export type GetCreditScoreQueryHookResult = ReturnType<typeof useGetCreditScoreQuery>;
export type GetCreditScoreLazyQueryHookResult = ReturnType<typeof useGetCreditScoreLazyQuery>;
export type GetCreditScoreSuspenseQueryHookResult = ReturnType<typeof useGetCreditScoreSuspenseQuery>;
export type GetCreditScoreQueryResult = ApolloReactCommon.QueryResult<GetCreditScoreQuery, GetCreditScoreQueryVariables>;
export const GetTuAuthenticationStatusProfileQueryDocument = gql`
    query getTuAuthenticationStatusProfileQuery {
  tuAuthenticationStatusProfile {
    status
  }
}
    `;
export type GetTuAuthenticationStatusProfileQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables>, 'query'>;

    export const GetTuAuthenticationStatusProfileQueryComponent = (props: GetTuAuthenticationStatusProfileQueryComponentProps) => (
      <ApolloReactComponents.Query<GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables> query={GetTuAuthenticationStatusProfileQueryDocument} {...props} />
    );
    
export type GetTuAuthenticationStatusProfileQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables>
    } & TChildProps;
export function withGetTuAuthenticationStatusProfileQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTuAuthenticationStatusProfileQueryQuery,
  GetTuAuthenticationStatusProfileQueryQueryVariables,
  GetTuAuthenticationStatusProfileQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables, GetTuAuthenticationStatusProfileQueryProps<TChildProps, TDataName>>(GetTuAuthenticationStatusProfileQueryDocument, {
      alias: 'getTuAuthenticationStatusProfileQuery',
      ...operationOptions
    });
};

/**
 * __useGetTuAuthenticationStatusProfileQueryQuery__
 *
 * To run a query within a React component, call `useGetTuAuthenticationStatusProfileQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTuAuthenticationStatusProfileQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTuAuthenticationStatusProfileQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTuAuthenticationStatusProfileQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables>(GetTuAuthenticationStatusProfileQueryDocument, options);
      }
export function useGetTuAuthenticationStatusProfileQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables>(GetTuAuthenticationStatusProfileQueryDocument, options);
        }
export function useGetTuAuthenticationStatusProfileQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables>(GetTuAuthenticationStatusProfileQueryDocument, options);
        }
export type GetTuAuthenticationStatusProfileQueryQueryHookResult = ReturnType<typeof useGetTuAuthenticationStatusProfileQueryQuery>;
export type GetTuAuthenticationStatusProfileQueryLazyQueryHookResult = ReturnType<typeof useGetTuAuthenticationStatusProfileQueryLazyQuery>;
export type GetTuAuthenticationStatusProfileQuerySuspenseQueryHookResult = ReturnType<typeof useGetTuAuthenticationStatusProfileQuerySuspenseQuery>;
export type GetTuAuthenticationStatusProfileQueryQueryResult = ApolloReactCommon.QueryResult<GetTuAuthenticationStatusProfileQueryQuery, GetTuAuthenticationStatusProfileQueryQueryVariables>;
export const GetNwPlusExclusiveFeaturesCardsDocument = gql`
    query GetNwPlusExclusiveFeaturesCards {
  nwPlusExclusiveFeatureCards {
    cards {
      ...ExclusiveFeaturesCard
    }
  }
}
    ${ExclusiveFeaturesCardFragmentDoc}`;
export type GetNwPlusExclusiveFeaturesCardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables>, 'query'>;

    export const GetNwPlusExclusiveFeaturesCardsComponent = (props: GetNwPlusExclusiveFeaturesCardsComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables> query={GetNwPlusExclusiveFeaturesCardsDocument} {...props} />
    );
    
export type GetNwPlusExclusiveFeaturesCardsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables>
    } & TChildProps;
export function withGetNwPlusExclusiveFeaturesCards<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusExclusiveFeaturesCardsQuery,
  GetNwPlusExclusiveFeaturesCardsQueryVariables,
  GetNwPlusExclusiveFeaturesCardsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables, GetNwPlusExclusiveFeaturesCardsProps<TChildProps, TDataName>>(GetNwPlusExclusiveFeaturesCardsDocument, {
      alias: 'getNwPlusExclusiveFeaturesCards',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusExclusiveFeaturesCardsQuery__
 *
 * To run a query within a React component, call `useGetNwPlusExclusiveFeaturesCardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusExclusiveFeaturesCardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusExclusiveFeaturesCardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusExclusiveFeaturesCardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables>(GetNwPlusExclusiveFeaturesCardsDocument, options);
      }
export function useGetNwPlusExclusiveFeaturesCardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables>(GetNwPlusExclusiveFeaturesCardsDocument, options);
        }
export function useGetNwPlusExclusiveFeaturesCardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables>(GetNwPlusExclusiveFeaturesCardsDocument, options);
        }
export type GetNwPlusExclusiveFeaturesCardsQueryHookResult = ReturnType<typeof useGetNwPlusExclusiveFeaturesCardsQuery>;
export type GetNwPlusExclusiveFeaturesCardsLazyQueryHookResult = ReturnType<typeof useGetNwPlusExclusiveFeaturesCardsLazyQuery>;
export type GetNwPlusExclusiveFeaturesCardsSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusExclusiveFeaturesCardsSuspenseQuery>;
export type GetNwPlusExclusiveFeaturesCardsQueryResult = ApolloReactCommon.QueryResult<GetNwPlusExclusiveFeaturesCardsQuery, GetNwPlusExclusiveFeaturesCardsQueryVariables>;
export const GetCashFlowDataDocument = gql`
    query GetCashFlowData($currentDate: String!, $dateInTargetMonth: Date!, $dateInStartMonth: Date!) {
  cashFlowBreakdown(currentDate: $currentDate) {
    spending
    estimatedIncome
    remaining
  }
  ...CashFlowTileQueryFragment
}
    ${CashFlowTileQueryFragmentFragmentDoc}`;
export type GetCashFlowDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCashFlowDataQuery, GetCashFlowDataQueryVariables>, 'query'> & ({ variables: GetCashFlowDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCashFlowDataComponent = (props: GetCashFlowDataComponentProps) => (
      <ApolloReactComponents.Query<GetCashFlowDataQuery, GetCashFlowDataQueryVariables> query={GetCashFlowDataDocument} {...props} />
    );
    
export type GetCashFlowDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCashFlowDataQuery, GetCashFlowDataQueryVariables>
    } & TChildProps;
export function withGetCashFlowData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCashFlowDataQuery,
  GetCashFlowDataQueryVariables,
  GetCashFlowDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCashFlowDataQuery, GetCashFlowDataQueryVariables, GetCashFlowDataProps<TChildProps, TDataName>>(GetCashFlowDataDocument, {
      alias: 'getCashFlowData',
      ...operationOptions
    });
};

/**
 * __useGetCashFlowDataQuery__
 *
 * To run a query within a React component, call `useGetCashFlowDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFlowDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFlowDataQuery({
 *   variables: {
 *      currentDate: // value for 'currentDate'
 *      dateInTargetMonth: // value for 'dateInTargetMonth'
 *      dateInStartMonth: // value for 'dateInStartMonth'
 *   },
 * });
 */
export function useGetCashFlowDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCashFlowDataQuery, GetCashFlowDataQueryVariables> & ({ variables: GetCashFlowDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCashFlowDataQuery, GetCashFlowDataQueryVariables>(GetCashFlowDataDocument, options);
      }
export function useGetCashFlowDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFlowDataQuery, GetCashFlowDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCashFlowDataQuery, GetCashFlowDataQueryVariables>(GetCashFlowDataDocument, options);
        }
export function useGetCashFlowDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCashFlowDataQuery, GetCashFlowDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCashFlowDataQuery, GetCashFlowDataQueryVariables>(GetCashFlowDataDocument, options);
        }
export type GetCashFlowDataQueryHookResult = ReturnType<typeof useGetCashFlowDataQuery>;
export type GetCashFlowDataLazyQueryHookResult = ReturnType<typeof useGetCashFlowDataLazyQuery>;
export type GetCashFlowDataSuspenseQueryHookResult = ReturnType<typeof useGetCashFlowDataSuspenseQuery>;
export type GetCashFlowDataQueryResult = ApolloReactCommon.QueryResult<GetCashFlowDataQuery, GetCashFlowDataQueryVariables>;
export const GetCashFlowTileDataDocument = gql`
    query GetCashFlowTileData($dateInTargetMonth: Date!, $currentDate: DateTime!, $dateInStartMonth: Date!, $numPreviousMonthsToInclude: Int = 2) {
  financialTransactionsCashInCashOutSummaryForDatePeriod(
    currentDate: $currentDate
    numPreviousDatePeriodsToInclude: $numPreviousMonthsToInclude
  ) {
    averageNetPreviousDatePeriods
    summaries {
      date
      cashIn
      cashOut
      net
    }
  }
  ...CashFlowTileQueryFragment
}
    ${CashFlowTileQueryFragmentFragmentDoc}`;
export type GetCashFlowTileDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables>, 'query'> & ({ variables: GetCashFlowTileDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetCashFlowTileDataComponent = (props: GetCashFlowTileDataComponentProps) => (
      <ApolloReactComponents.Query<GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables> query={GetCashFlowTileDataDocument} {...props} />
    );
    
export type GetCashFlowTileDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables>
    } & TChildProps;
export function withGetCashFlowTileData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCashFlowTileDataQuery,
  GetCashFlowTileDataQueryVariables,
  GetCashFlowTileDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables, GetCashFlowTileDataProps<TChildProps, TDataName>>(GetCashFlowTileDataDocument, {
      alias: 'getCashFlowTileData',
      ...operationOptions
    });
};

/**
 * __useGetCashFlowTileDataQuery__
 *
 * To run a query within a React component, call `useGetCashFlowTileDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCashFlowTileDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCashFlowTileDataQuery({
 *   variables: {
 *      dateInTargetMonth: // value for 'dateInTargetMonth'
 *      currentDate: // value for 'currentDate'
 *      dateInStartMonth: // value for 'dateInStartMonth'
 *      numPreviousMonthsToInclude: // value for 'numPreviousMonthsToInclude'
 *   },
 * });
 */
export function useGetCashFlowTileDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables> & ({ variables: GetCashFlowTileDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables>(GetCashFlowTileDataDocument, options);
      }
export function useGetCashFlowTileDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables>(GetCashFlowTileDataDocument, options);
        }
export function useGetCashFlowTileDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables>(GetCashFlowTileDataDocument, options);
        }
export type GetCashFlowTileDataQueryHookResult = ReturnType<typeof useGetCashFlowTileDataQuery>;
export type GetCashFlowTileDataLazyQueryHookResult = ReturnType<typeof useGetCashFlowTileDataLazyQuery>;
export type GetCashFlowTileDataSuspenseQueryHookResult = ReturnType<typeof useGetCashFlowTileDataSuspenseQuery>;
export type GetCashFlowTileDataQueryResult = ApolloReactCommon.QueryResult<GetCashFlowTileDataQuery, GetCashFlowTileDataQueryVariables>;
export const GetRewardEventPointsDocument = gql`
    query GetRewardEventPoints($eventTypes: [String!]) {
  rewardEventPoints(eventTypes: $eventTypes) {
    aggregateRewards {
      eventType
      points
    }
  }
}
    `;
export type GetRewardEventPointsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables>, 'query'>;

    export const GetRewardEventPointsComponent = (props: GetRewardEventPointsComponentProps) => (
      <ApolloReactComponents.Query<GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables> query={GetRewardEventPointsDocument} {...props} />
    );
    
export type GetRewardEventPointsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables>
    } & TChildProps;
export function withGetRewardEventPoints<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRewardEventPointsQuery,
  GetRewardEventPointsQueryVariables,
  GetRewardEventPointsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables, GetRewardEventPointsProps<TChildProps, TDataName>>(GetRewardEventPointsDocument, {
      alias: 'getRewardEventPoints',
      ...operationOptions
    });
};

/**
 * __useGetRewardEventPointsQuery__
 *
 * To run a query within a React component, call `useGetRewardEventPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardEventPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardEventPointsQuery({
 *   variables: {
 *      eventTypes: // value for 'eventTypes'
 *   },
 * });
 */
export function useGetRewardEventPointsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables>(GetRewardEventPointsDocument, options);
      }
export function useGetRewardEventPointsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables>(GetRewardEventPointsDocument, options);
        }
export function useGetRewardEventPointsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables>(GetRewardEventPointsDocument, options);
        }
export type GetRewardEventPointsQueryHookResult = ReturnType<typeof useGetRewardEventPointsQuery>;
export type GetRewardEventPointsLazyQueryHookResult = ReturnType<typeof useGetRewardEventPointsLazyQuery>;
export type GetRewardEventPointsSuspenseQueryHookResult = ReturnType<typeof useGetRewardEventPointsSuspenseQuery>;
export type GetRewardEventPointsQueryResult = ApolloReactCommon.QueryResult<GetRewardEventPointsQuery, GetRewardEventPointsQueryVariables>;
export const GetCreditScoreDataCreditScoreTileDocument = gql`
    query GetCreditScoreDataCreditScoreTile {
  tuCreditReportIdentityProfile {
    vantageScore3
    reportPulledAt
    vantageScore3Bucket
    vantageScore3Delta
    vantageScore3Delta7Days
    vantageScore3DeltaBucket
    vantageScore3ChangeDirection
    vantageScore3ChangeDirection7Days
  }
}
    `;
export type GetCreditScoreDataCreditScoreTileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables>, 'query'>;

    export const GetCreditScoreDataCreditScoreTileComponent = (props: GetCreditScoreDataCreditScoreTileComponentProps) => (
      <ApolloReactComponents.Query<GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables> query={GetCreditScoreDataCreditScoreTileDocument} {...props} />
    );
    
export type GetCreditScoreDataCreditScoreTileProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables>
    } & TChildProps;
export function withGetCreditScoreDataCreditScoreTile<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCreditScoreDataCreditScoreTileQuery,
  GetCreditScoreDataCreditScoreTileQueryVariables,
  GetCreditScoreDataCreditScoreTileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables, GetCreditScoreDataCreditScoreTileProps<TChildProps, TDataName>>(GetCreditScoreDataCreditScoreTileDocument, {
      alias: 'getCreditScoreDataCreditScoreTile',
      ...operationOptions
    });
};

/**
 * __useGetCreditScoreDataCreditScoreTileQuery__
 *
 * To run a query within a React component, call `useGetCreditScoreDataCreditScoreTileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditScoreDataCreditScoreTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditScoreDataCreditScoreTileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditScoreDataCreditScoreTileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables>(GetCreditScoreDataCreditScoreTileDocument, options);
      }
export function useGetCreditScoreDataCreditScoreTileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables>(GetCreditScoreDataCreditScoreTileDocument, options);
        }
export function useGetCreditScoreDataCreditScoreTileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables>(GetCreditScoreDataCreditScoreTileDocument, options);
        }
export type GetCreditScoreDataCreditScoreTileQueryHookResult = ReturnType<typeof useGetCreditScoreDataCreditScoreTileQuery>;
export type GetCreditScoreDataCreditScoreTileLazyQueryHookResult = ReturnType<typeof useGetCreditScoreDataCreditScoreTileLazyQuery>;
export type GetCreditScoreDataCreditScoreTileSuspenseQueryHookResult = ReturnType<typeof useGetCreditScoreDataCreditScoreTileSuspenseQuery>;
export type GetCreditScoreDataCreditScoreTileQueryResult = ApolloReactCommon.QueryResult<GetCreditScoreDataCreditScoreTileQuery, GetCreditScoreDataCreditScoreTileQueryVariables>;
export const InsurancePoliciesForKeyNumberDocument = gql`
    query InsurancePoliciesForKeyNumber {
  insurancePolicies {
    policies {
      policyType
      ...activatedInsuranceFragment
    }
  }
}
    ${ActivatedInsuranceFragmentFragmentDoc}`;
export type InsurancePoliciesForKeyNumberComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables>, 'query'>;

    export const InsurancePoliciesForKeyNumberComponent = (props: InsurancePoliciesForKeyNumberComponentProps) => (
      <ApolloReactComponents.Query<InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables> query={InsurancePoliciesForKeyNumberDocument} {...props} />
    );
    
export type InsurancePoliciesForKeyNumberProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables>
    } & TChildProps;
export function withInsurancePoliciesForKeyNumber<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsurancePoliciesForKeyNumberQuery,
  InsurancePoliciesForKeyNumberQueryVariables,
  InsurancePoliciesForKeyNumberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables, InsurancePoliciesForKeyNumberProps<TChildProps, TDataName>>(InsurancePoliciesForKeyNumberDocument, {
      alias: 'insurancePoliciesForKeyNumber',
      ...operationOptions
    });
};

/**
 * __useInsurancePoliciesForKeyNumberQuery__
 *
 * To run a query within a React component, call `useInsurancePoliciesForKeyNumberQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsurancePoliciesForKeyNumberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsurancePoliciesForKeyNumberQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsurancePoliciesForKeyNumberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables>(InsurancePoliciesForKeyNumberDocument, options);
      }
export function useInsurancePoliciesForKeyNumberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables>(InsurancePoliciesForKeyNumberDocument, options);
        }
export function useInsurancePoliciesForKeyNumberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables>(InsurancePoliciesForKeyNumberDocument, options);
        }
export type InsurancePoliciesForKeyNumberQueryHookResult = ReturnType<typeof useInsurancePoliciesForKeyNumberQuery>;
export type InsurancePoliciesForKeyNumberLazyQueryHookResult = ReturnType<typeof useInsurancePoliciesForKeyNumberLazyQuery>;
export type InsurancePoliciesForKeyNumberSuspenseQueryHookResult = ReturnType<typeof useInsurancePoliciesForKeyNumberSuspenseQuery>;
export type InsurancePoliciesForKeyNumberQueryResult = ApolloReactCommon.QueryResult<InsurancePoliciesForKeyNumberQuery, InsurancePoliciesForKeyNumberQueryVariables>;
export const GetInvestmentAccountsSummaryDocument = gql`
    query GetInvestmentAccountsSummary {
  investmentAccountsSummary {
    automatedInvesting {
      createdAt
      pnl {
        allTime {
          value
          percentage
        }
        daily {
          percentage
          value
        }
      }
      timeWeightedReturn {
        value
      }
      totalValue {
        value
      }
    }
    treasury {
      createdAt
      earnings {
        allTime {
          value
        }
        byMonth {
          month
          value
        }
      }
      totalValue {
        value
      }
      yieldToMaturity {
        value
      }
    }
  }
}
    `;
export type GetInvestmentAccountsSummaryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables>, 'query'>;

    export const GetInvestmentAccountsSummaryComponent = (props: GetInvestmentAccountsSummaryComponentProps) => (
      <ApolloReactComponents.Query<GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables> query={GetInvestmentAccountsSummaryDocument} {...props} />
    );
    
export type GetInvestmentAccountsSummaryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables>
    } & TChildProps;
export function withGetInvestmentAccountsSummary<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInvestmentAccountsSummaryQuery,
  GetInvestmentAccountsSummaryQueryVariables,
  GetInvestmentAccountsSummaryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables, GetInvestmentAccountsSummaryProps<TChildProps, TDataName>>(GetInvestmentAccountsSummaryDocument, {
      alias: 'getInvestmentAccountsSummary',
      ...operationOptions
    });
};

/**
 * __useGetInvestmentAccountsSummaryQuery__
 *
 * To run a query within a React component, call `useGetInvestmentAccountsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentAccountsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentAccountsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvestmentAccountsSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables>(GetInvestmentAccountsSummaryDocument, options);
      }
export function useGetInvestmentAccountsSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables>(GetInvestmentAccountsSummaryDocument, options);
        }
export function useGetInvestmentAccountsSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables>(GetInvestmentAccountsSummaryDocument, options);
        }
export type GetInvestmentAccountsSummaryQueryHookResult = ReturnType<typeof useGetInvestmentAccountsSummaryQuery>;
export type GetInvestmentAccountsSummaryLazyQueryHookResult = ReturnType<typeof useGetInvestmentAccountsSummaryLazyQuery>;
export type GetInvestmentAccountsSummarySuspenseQueryHookResult = ReturnType<typeof useGetInvestmentAccountsSummarySuspenseQuery>;
export type GetInvestmentAccountsSummaryQueryResult = ApolloReactCommon.QueryResult<GetInvestmentAccountsSummaryQuery, GetInvestmentAccountsSummaryQueryVariables>;
export const GetInvestmentAccountsStatusDocument = gql`
    query GetInvestmentAccountsStatus {
  investmentAccountsStatus {
    accountStatus
    hasAutomatedInvesting
    hasTreasury
  }
}
    `;
export type GetInvestmentAccountsStatusComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables>, 'query'>;

    export const GetInvestmentAccountsStatusComponent = (props: GetInvestmentAccountsStatusComponentProps) => (
      <ApolloReactComponents.Query<GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables> query={GetInvestmentAccountsStatusDocument} {...props} />
    );
    
export type GetInvestmentAccountsStatusProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables>
    } & TChildProps;
export function withGetInvestmentAccountsStatus<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInvestmentAccountsStatusQuery,
  GetInvestmentAccountsStatusQueryVariables,
  GetInvestmentAccountsStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables, GetInvestmentAccountsStatusProps<TChildProps, TDataName>>(GetInvestmentAccountsStatusDocument, {
      alias: 'getInvestmentAccountsStatus',
      ...operationOptions
    });
};

/**
 * __useGetInvestmentAccountsStatusQuery__
 *
 * To run a query within a React component, call `useGetInvestmentAccountsStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentAccountsStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentAccountsStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInvestmentAccountsStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables>(GetInvestmentAccountsStatusDocument, options);
      }
export function useGetInvestmentAccountsStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables>(GetInvestmentAccountsStatusDocument, options);
        }
export function useGetInvestmentAccountsStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables>(GetInvestmentAccountsStatusDocument, options);
        }
export type GetInvestmentAccountsStatusQueryHookResult = ReturnType<typeof useGetInvestmentAccountsStatusQuery>;
export type GetInvestmentAccountsStatusLazyQueryHookResult = ReturnType<typeof useGetInvestmentAccountsStatusLazyQuery>;
export type GetInvestmentAccountsStatusSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentAccountsStatusSuspenseQuery>;
export type GetInvestmentAccountsStatusQueryResult = ApolloReactCommon.QueryResult<GetInvestmentAccountsStatusQuery, GetInvestmentAccountsStatusQueryVariables>;
export const GetTreasuryAccountApyDocument = gql`
    query GetTreasuryAccountAPY {
  treasuryAccountMarketing {
    annualPercentageYield
  }
}
    `;
export type GetTreasuryAccountApyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables>, 'query'>;

    export const GetTreasuryAccountApyComponent = (props: GetTreasuryAccountApyComponentProps) => (
      <ApolloReactComponents.Query<GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables> query={GetTreasuryAccountApyDocument} {...props} />
    );
    
export type GetTreasuryAccountApyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables>
    } & TChildProps;
export function withGetTreasuryAccountApy<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTreasuryAccountApyQuery,
  GetTreasuryAccountApyQueryVariables,
  GetTreasuryAccountApyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables, GetTreasuryAccountApyProps<TChildProps, TDataName>>(GetTreasuryAccountApyDocument, {
      alias: 'getTreasuryAccountApy',
      ...operationOptions
    });
};

/**
 * __useGetTreasuryAccountApyQuery__
 *
 * To run a query within a React component, call `useGetTreasuryAccountApyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTreasuryAccountApyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTreasuryAccountApyQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTreasuryAccountApyQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables>(GetTreasuryAccountApyDocument, options);
      }
export function useGetTreasuryAccountApyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables>(GetTreasuryAccountApyDocument, options);
        }
export function useGetTreasuryAccountApySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables>(GetTreasuryAccountApyDocument, options);
        }
export type GetTreasuryAccountApyQueryHookResult = ReturnType<typeof useGetTreasuryAccountApyQuery>;
export type GetTreasuryAccountApyLazyQueryHookResult = ReturnType<typeof useGetTreasuryAccountApyLazyQuery>;
export type GetTreasuryAccountApySuspenseQueryHookResult = ReturnType<typeof useGetTreasuryAccountApySuspenseQuery>;
export type GetTreasuryAccountApyQueryResult = ApolloReactCommon.QueryResult<GetTreasuryAccountApyQuery, GetTreasuryAccountApyQueryVariables>;
export const GetNetWorthDataActivatedNetWorthDocument = gql`
    query GetNetWorthDataActivatedNetWorth($netWorthFilter: NetWorthHistoryFiltersEnum!, $effectiveDate: DateTimeWithTimeOffset!) {
  netWorthHistory(netWorthFilter: $netWorthFilter, effectiveDate: $effectiveDate) {
    history {
      date
      value
    }
  }
}
    `;
export type GetNetWorthDataActivatedNetWorthComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables>, 'query'> & ({ variables: GetNetWorthDataActivatedNetWorthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNetWorthDataActivatedNetWorthComponent = (props: GetNetWorthDataActivatedNetWorthComponentProps) => (
      <ApolloReactComponents.Query<GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables> query={GetNetWorthDataActivatedNetWorthDocument} {...props} />
    );
    
export type GetNetWorthDataActivatedNetWorthProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables>
    } & TChildProps;
export function withGetNetWorthDataActivatedNetWorth<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNetWorthDataActivatedNetWorthQuery,
  GetNetWorthDataActivatedNetWorthQueryVariables,
  GetNetWorthDataActivatedNetWorthProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables, GetNetWorthDataActivatedNetWorthProps<TChildProps, TDataName>>(GetNetWorthDataActivatedNetWorthDocument, {
      alias: 'getNetWorthDataActivatedNetWorth',
      ...operationOptions
    });
};

/**
 * __useGetNetWorthDataActivatedNetWorthQuery__
 *
 * To run a query within a React component, call `useGetNetWorthDataActivatedNetWorthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetWorthDataActivatedNetWorthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetWorthDataActivatedNetWorthQuery({
 *   variables: {
 *      netWorthFilter: // value for 'netWorthFilter'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useGetNetWorthDataActivatedNetWorthQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables> & ({ variables: GetNetWorthDataActivatedNetWorthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables>(GetNetWorthDataActivatedNetWorthDocument, options);
      }
export function useGetNetWorthDataActivatedNetWorthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables>(GetNetWorthDataActivatedNetWorthDocument, options);
        }
export function useGetNetWorthDataActivatedNetWorthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables>(GetNetWorthDataActivatedNetWorthDocument, options);
        }
export type GetNetWorthDataActivatedNetWorthQueryHookResult = ReturnType<typeof useGetNetWorthDataActivatedNetWorthQuery>;
export type GetNetWorthDataActivatedNetWorthLazyQueryHookResult = ReturnType<typeof useGetNetWorthDataActivatedNetWorthLazyQuery>;
export type GetNetWorthDataActivatedNetWorthSuspenseQueryHookResult = ReturnType<typeof useGetNetWorthDataActivatedNetWorthSuspenseQuery>;
export type GetNetWorthDataActivatedNetWorthQueryResult = ApolloReactCommon.QueryResult<GetNetWorthDataActivatedNetWorthQuery, GetNetWorthDataActivatedNetWorthQueryVariables>;
export const GetNetWorthDataDocument = gql`
    query GetNetWorthData($eventTypes: [String!]) {
  netWorthBalancesByFinancialDataCategorization {
    totalNetWorthIncludingHomeEquity
  }
  rewardEventPoints(eventTypes: $eventTypes) {
    aggregateRewards {
      eventType
      points
    }
  }
}
    `;
export type GetNetWorthDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNetWorthDataQuery, GetNetWorthDataQueryVariables>, 'query'>;

    export const GetNetWorthDataComponent = (props: GetNetWorthDataComponentProps) => (
      <ApolloReactComponents.Query<GetNetWorthDataQuery, GetNetWorthDataQueryVariables> query={GetNetWorthDataDocument} {...props} />
    );
    
export type GetNetWorthDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNetWorthDataQuery, GetNetWorthDataQueryVariables>
    } & TChildProps;
export function withGetNetWorthData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNetWorthDataQuery,
  GetNetWorthDataQueryVariables,
  GetNetWorthDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNetWorthDataQuery, GetNetWorthDataQueryVariables, GetNetWorthDataProps<TChildProps, TDataName>>(GetNetWorthDataDocument, {
      alias: 'getNetWorthData',
      ...operationOptions
    });
};

/**
 * __useGetNetWorthDataQuery__
 *
 * To run a query within a React component, call `useGetNetWorthDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetWorthDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetWorthDataQuery({
 *   variables: {
 *      eventTypes: // value for 'eventTypes'
 *   },
 * });
 */
export function useGetNetWorthDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNetWorthDataQuery, GetNetWorthDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNetWorthDataQuery, GetNetWorthDataQueryVariables>(GetNetWorthDataDocument, options);
      }
export function useGetNetWorthDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNetWorthDataQuery, GetNetWorthDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNetWorthDataQuery, GetNetWorthDataQueryVariables>(GetNetWorthDataDocument, options);
        }
export function useGetNetWorthDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNetWorthDataQuery, GetNetWorthDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNetWorthDataQuery, GetNetWorthDataQueryVariables>(GetNetWorthDataDocument, options);
        }
export type GetNetWorthDataQueryHookResult = ReturnType<typeof useGetNetWorthDataQuery>;
export type GetNetWorthDataLazyQueryHookResult = ReturnType<typeof useGetNetWorthDataLazyQuery>;
export type GetNetWorthDataSuspenseQueryHookResult = ReturnType<typeof useGetNetWorthDataSuspenseQuery>;
export type GetNetWorthDataQueryResult = ApolloReactCommon.QueryResult<GetNetWorthDataQuery, GetNetWorthDataQueryVariables>;
export const GetNwPlusWalletDocument = gql`
    query GetNwPlusWallet {
  nwPlusWallet {
    points
  }
}
    `;
export type GetNwPlusWalletComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables>, 'query'>;

    export const GetNwPlusWalletComponent = (props: GetNwPlusWalletComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables> query={GetNwPlusWalletDocument} {...props} />
    );
    
export type GetNwPlusWalletProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables>
    } & TChildProps;
export function withGetNwPlusWallet<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusWalletQuery,
  GetNwPlusWalletQueryVariables,
  GetNwPlusWalletProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables, GetNwPlusWalletProps<TChildProps, TDataName>>(GetNwPlusWalletDocument, {
      alias: 'getNwPlusWallet',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusWalletQuery__
 *
 * To run a query within a React component, call `useGetNwPlusWalletQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusWalletQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusWalletQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusWalletQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables>(GetNwPlusWalletDocument, options);
      }
export function useGetNwPlusWalletLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables>(GetNwPlusWalletDocument, options);
        }
export function useGetNwPlusWalletSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables>(GetNwPlusWalletDocument, options);
        }
export type GetNwPlusWalletQueryHookResult = ReturnType<typeof useGetNwPlusWalletQuery>;
export type GetNwPlusWalletLazyQueryHookResult = ReturnType<typeof useGetNwPlusWalletLazyQuery>;
export type GetNwPlusWalletSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusWalletSuspenseQuery>;
export type GetNwPlusWalletQueryResult = ApolloReactCommon.QueryResult<GetNwPlusWalletQuery, GetNwPlusWalletQueryVariables>;
export const GetNwPlusEstimatedPointsDocument = gql`
    query GetNwPlusEstimatedPoints {
  nwPlusPointsEstimate {
    points
    breakdown {
      ...unactivatedRewardsFragment
    }
  }
}
    ${UnactivatedRewardsFragmentFragmentDoc}`;
export type GetNwPlusEstimatedPointsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables>, 'query'>;

    export const GetNwPlusEstimatedPointsComponent = (props: GetNwPlusEstimatedPointsComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables> query={GetNwPlusEstimatedPointsDocument} {...props} />
    );
    
export type GetNwPlusEstimatedPointsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables>
    } & TChildProps;
export function withGetNwPlusEstimatedPoints<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusEstimatedPointsQuery,
  GetNwPlusEstimatedPointsQueryVariables,
  GetNwPlusEstimatedPointsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables, GetNwPlusEstimatedPointsProps<TChildProps, TDataName>>(GetNwPlusEstimatedPointsDocument, {
      alias: 'getNwPlusEstimatedPoints',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusEstimatedPointsQuery__
 *
 * To run a query within a React component, call `useGetNwPlusEstimatedPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusEstimatedPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusEstimatedPointsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusEstimatedPointsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables>(GetNwPlusEstimatedPointsDocument, options);
      }
export function useGetNwPlusEstimatedPointsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables>(GetNwPlusEstimatedPointsDocument, options);
        }
export function useGetNwPlusEstimatedPointsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables>(GetNwPlusEstimatedPointsDocument, options);
        }
export type GetNwPlusEstimatedPointsQueryHookResult = ReturnType<typeof useGetNwPlusEstimatedPointsQuery>;
export type GetNwPlusEstimatedPointsLazyQueryHookResult = ReturnType<typeof useGetNwPlusEstimatedPointsLazyQuery>;
export type GetNwPlusEstimatedPointsSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusEstimatedPointsSuspenseQuery>;
export type GetNwPlusEstimatedPointsQueryResult = ApolloReactCommon.QueryResult<GetNwPlusEstimatedPointsQuery, GetNwPlusEstimatedPointsQueryVariables>;
export const GetContentRecsDocument = gql`
    query GetContentRecs {
  contentRecommendationPosts {
    personalised {
      ...WeeklyReads
    }
  }
}
    ${WeeklyReadsFragmentDoc}`;
export type GetContentRecsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetContentRecsQuery, GetContentRecsQueryVariables>, 'query'>;

    export const GetContentRecsComponent = (props: GetContentRecsComponentProps) => (
      <ApolloReactComponents.Query<GetContentRecsQuery, GetContentRecsQueryVariables> query={GetContentRecsDocument} {...props} />
    );
    
export type GetContentRecsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetContentRecsQuery, GetContentRecsQueryVariables>
    } & TChildProps;
export function withGetContentRecs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetContentRecsQuery,
  GetContentRecsQueryVariables,
  GetContentRecsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetContentRecsQuery, GetContentRecsQueryVariables, GetContentRecsProps<TChildProps, TDataName>>(GetContentRecsDocument, {
      alias: 'getContentRecs',
      ...operationOptions
    });
};

/**
 * __useGetContentRecsQuery__
 *
 * To run a query within a React component, call `useGetContentRecsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetContentRecsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetContentRecsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetContentRecsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetContentRecsQuery, GetContentRecsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetContentRecsQuery, GetContentRecsQueryVariables>(GetContentRecsDocument, options);
      }
export function useGetContentRecsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetContentRecsQuery, GetContentRecsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetContentRecsQuery, GetContentRecsQueryVariables>(GetContentRecsDocument, options);
        }
export function useGetContentRecsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetContentRecsQuery, GetContentRecsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetContentRecsQuery, GetContentRecsQueryVariables>(GetContentRecsDocument, options);
        }
export type GetContentRecsQueryHookResult = ReturnType<typeof useGetContentRecsQuery>;
export type GetContentRecsLazyQueryHookResult = ReturnType<typeof useGetContentRecsLazyQuery>;
export type GetContentRecsSuspenseQueryHookResult = ReturnType<typeof useGetContentRecsSuspenseQuery>;
export type GetContentRecsQueryResult = ApolloReactCommon.QueryResult<GetContentRecsQuery, GetContentRecsQueryVariables>;
export const RecentlyViewedQueryIdsDocument = gql`
    query RecentlyViewedQueryIds($maxPagesCount: Int) {
  recentlyViewed(maxPagesCount: $maxPagesCount) {
    id
  }
}
    `;
export type RecentlyViewedQueryIdsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables>, 'query'>;

    export const RecentlyViewedQueryIdsComponent = (props: RecentlyViewedQueryIdsComponentProps) => (
      <ApolloReactComponents.Query<RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables> query={RecentlyViewedQueryIdsDocument} {...props} />
    );
    
export type RecentlyViewedQueryIdsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables>
    } & TChildProps;
export function withRecentlyViewedQueryIds<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RecentlyViewedQueryIdsQuery,
  RecentlyViewedQueryIdsQueryVariables,
  RecentlyViewedQueryIdsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables, RecentlyViewedQueryIdsProps<TChildProps, TDataName>>(RecentlyViewedQueryIdsDocument, {
      alias: 'recentlyViewedQueryIds',
      ...operationOptions
    });
};

/**
 * __useRecentlyViewedQueryIdsQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedQueryIdsQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedQueryIdsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedQueryIdsQuery({
 *   variables: {
 *      maxPagesCount: // value for 'maxPagesCount'
 *   },
 * });
 */
export function useRecentlyViewedQueryIdsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables>(RecentlyViewedQueryIdsDocument, options);
      }
export function useRecentlyViewedQueryIdsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables>(RecentlyViewedQueryIdsDocument, options);
        }
export function useRecentlyViewedQueryIdsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables>(RecentlyViewedQueryIdsDocument, options);
        }
export type RecentlyViewedQueryIdsQueryHookResult = ReturnType<typeof useRecentlyViewedQueryIdsQuery>;
export type RecentlyViewedQueryIdsLazyQueryHookResult = ReturnType<typeof useRecentlyViewedQueryIdsLazyQuery>;
export type RecentlyViewedQueryIdsSuspenseQueryHookResult = ReturnType<typeof useRecentlyViewedQueryIdsSuspenseQuery>;
export type RecentlyViewedQueryIdsQueryResult = ApolloReactCommon.QueryResult<RecentlyViewedQueryIdsQuery, RecentlyViewedQueryIdsQueryVariables>;
export const GetWeeklyReadsArticlesDocument = gql`
    query GetWeeklyReadsArticles($pagination: OffsetPaginationInput, $filter: ArticleFilterInput) {
  articles(pagination: $pagination, filter: $filter) {
    items {
      ...PostTemplate
    }
  }
}
    ${PostTemplateFragmentDoc}`;
export type GetWeeklyReadsArticlesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables>, 'query'>;

    export const GetWeeklyReadsArticlesComponent = (props: GetWeeklyReadsArticlesComponentProps) => (
      <ApolloReactComponents.Query<GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables> query={GetWeeklyReadsArticlesDocument} {...props} />
    );
    
export type GetWeeklyReadsArticlesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables>
    } & TChildProps;
export function withGetWeeklyReadsArticles<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetWeeklyReadsArticlesQuery,
  GetWeeklyReadsArticlesQueryVariables,
  GetWeeklyReadsArticlesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables, GetWeeklyReadsArticlesProps<TChildProps, TDataName>>(GetWeeklyReadsArticlesDocument, {
      alias: 'getWeeklyReadsArticles',
      ...operationOptions
    });
};

/**
 * __useGetWeeklyReadsArticlesQuery__
 *
 * To run a query within a React component, call `useGetWeeklyReadsArticlesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWeeklyReadsArticlesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWeeklyReadsArticlesQuery({
 *   variables: {
 *      pagination: // value for 'pagination'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetWeeklyReadsArticlesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables>(GetWeeklyReadsArticlesDocument, options);
      }
export function useGetWeeklyReadsArticlesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables>(GetWeeklyReadsArticlesDocument, options);
        }
export function useGetWeeklyReadsArticlesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables>(GetWeeklyReadsArticlesDocument, options);
        }
export type GetWeeklyReadsArticlesQueryHookResult = ReturnType<typeof useGetWeeklyReadsArticlesQuery>;
export type GetWeeklyReadsArticlesLazyQueryHookResult = ReturnType<typeof useGetWeeklyReadsArticlesLazyQuery>;
export type GetWeeklyReadsArticlesSuspenseQueryHookResult = ReturnType<typeof useGetWeeklyReadsArticlesSuspenseQuery>;
export type GetWeeklyReadsArticlesQueryResult = ApolloReactCommon.QueryResult<GetWeeklyReadsArticlesQuery, GetWeeklyReadsArticlesQueryVariables>;
export const GetLearningUserInfoDocument = gql`
    query GetLearningUserInfo {
  globalIdentityProfile {
    firstName
  }
}
    `;
export type GetLearningUserInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables>, 'query'>;

    export const GetLearningUserInfoComponent = (props: GetLearningUserInfoComponentProps) => (
      <ApolloReactComponents.Query<GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables> query={GetLearningUserInfoDocument} {...props} />
    );
    
export type GetLearningUserInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables>
    } & TChildProps;
export function withGetLearningUserInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetLearningUserInfoQuery,
  GetLearningUserInfoQueryVariables,
  GetLearningUserInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables, GetLearningUserInfoProps<TChildProps, TDataName>>(GetLearningUserInfoDocument, {
      alias: 'getLearningUserInfo',
      ...operationOptions
    });
};

/**
 * __useGetLearningUserInfoQuery__
 *
 * To run a query within a React component, call `useGetLearningUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLearningUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLearningUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLearningUserInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables>(GetLearningUserInfoDocument, options);
      }
export function useGetLearningUserInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables>(GetLearningUserInfoDocument, options);
        }
export function useGetLearningUserInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables>(GetLearningUserInfoDocument, options);
        }
export type GetLearningUserInfoQueryHookResult = ReturnType<typeof useGetLearningUserInfoQuery>;
export type GetLearningUserInfoLazyQueryHookResult = ReturnType<typeof useGetLearningUserInfoLazyQuery>;
export type GetLearningUserInfoSuspenseQueryHookResult = ReturnType<typeof useGetLearningUserInfoSuspenseQuery>;
export type GetLearningUserInfoQueryResult = ApolloReactCommon.QueryResult<GetLearningUserInfoQuery, GetLearningUserInfoQueryVariables>;
export const NerdUpBannerGetNerdUpCardStatusDocument = gql`
    query NerdUpBannerGetNerdUpCardStatus {
  nerdUpCreditCard {
    applicationStatus
  }
}
    `;
export type NerdUpBannerGetNerdUpCardStatusComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables>, 'query'>;

    export const NerdUpBannerGetNerdUpCardStatusComponent = (props: NerdUpBannerGetNerdUpCardStatusComponentProps) => (
      <ApolloReactComponents.Query<NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables> query={NerdUpBannerGetNerdUpCardStatusDocument} {...props} />
    );
    
export type NerdUpBannerGetNerdUpCardStatusProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables>
    } & TChildProps;
export function withNerdUpBannerGetNerdUpCardStatus<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NerdUpBannerGetNerdUpCardStatusQuery,
  NerdUpBannerGetNerdUpCardStatusQueryVariables,
  NerdUpBannerGetNerdUpCardStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables, NerdUpBannerGetNerdUpCardStatusProps<TChildProps, TDataName>>(NerdUpBannerGetNerdUpCardStatusDocument, {
      alias: 'nerdUpBannerGetNerdUpCardStatus',
      ...operationOptions
    });
};

/**
 * __useNerdUpBannerGetNerdUpCardStatusQuery__
 *
 * To run a query within a React component, call `useNerdUpBannerGetNerdUpCardStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useNerdUpBannerGetNerdUpCardStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNerdUpBannerGetNerdUpCardStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useNerdUpBannerGetNerdUpCardStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables>(NerdUpBannerGetNerdUpCardStatusDocument, options);
      }
export function useNerdUpBannerGetNerdUpCardStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables>(NerdUpBannerGetNerdUpCardStatusDocument, options);
        }
export function useNerdUpBannerGetNerdUpCardStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables>(NerdUpBannerGetNerdUpCardStatusDocument, options);
        }
export type NerdUpBannerGetNerdUpCardStatusQueryHookResult = ReturnType<typeof useNerdUpBannerGetNerdUpCardStatusQuery>;
export type NerdUpBannerGetNerdUpCardStatusLazyQueryHookResult = ReturnType<typeof useNerdUpBannerGetNerdUpCardStatusLazyQuery>;
export type NerdUpBannerGetNerdUpCardStatusSuspenseQueryHookResult = ReturnType<typeof useNerdUpBannerGetNerdUpCardStatusSuspenseQuery>;
export type NerdUpBannerGetNerdUpCardStatusQueryResult = ApolloReactCommon.QueryResult<NerdUpBannerGetNerdUpCardStatusQuery, NerdUpBannerGetNerdUpCardStatusQueryVariables>;
export const TreasuryAccountDocument = gql`
    query TreasuryAccount {
  treasuryAccountMarketing {
    yieldToMaturityPercentage
  }
}
    `;
export type TreasuryAccountComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TreasuryAccountQuery, TreasuryAccountQueryVariables>, 'query'>;

    export const TreasuryAccountComponent = (props: TreasuryAccountComponentProps) => (
      <ApolloReactComponents.Query<TreasuryAccountQuery, TreasuryAccountQueryVariables> query={TreasuryAccountDocument} {...props} />
    );
    
export type TreasuryAccountProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TreasuryAccountQuery, TreasuryAccountQueryVariables>
    } & TChildProps;
export function withTreasuryAccount<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TreasuryAccountQuery,
  TreasuryAccountQueryVariables,
  TreasuryAccountProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TreasuryAccountQuery, TreasuryAccountQueryVariables, TreasuryAccountProps<TChildProps, TDataName>>(TreasuryAccountDocument, {
      alias: 'treasuryAccount',
      ...operationOptions
    });
};

/**
 * __useTreasuryAccountQuery__
 *
 * To run a query within a React component, call `useTreasuryAccountQuery` and pass it any options that fit your needs.
 * When your component renders, `useTreasuryAccountQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTreasuryAccountQuery({
 *   variables: {
 *   },
 * });
 */
export function useTreasuryAccountQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TreasuryAccountQuery, TreasuryAccountQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TreasuryAccountQuery, TreasuryAccountQueryVariables>(TreasuryAccountDocument, options);
      }
export function useTreasuryAccountLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TreasuryAccountQuery, TreasuryAccountQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TreasuryAccountQuery, TreasuryAccountQueryVariables>(TreasuryAccountDocument, options);
        }
export function useTreasuryAccountSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TreasuryAccountQuery, TreasuryAccountQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TreasuryAccountQuery, TreasuryAccountQueryVariables>(TreasuryAccountDocument, options);
        }
export type TreasuryAccountQueryHookResult = ReturnType<typeof useTreasuryAccountQuery>;
export type TreasuryAccountLazyQueryHookResult = ReturnType<typeof useTreasuryAccountLazyQuery>;
export type TreasuryAccountSuspenseQueryHookResult = ReturnType<typeof useTreasuryAccountSuspenseQuery>;
export type TreasuryAccountQueryResult = ApolloReactCommon.QueryResult<TreasuryAccountQuery, TreasuryAccountQueryVariables>;
export const GetNwPlusOutstandingEventsQueryDocument = gql`
    query GetNwPlusOutstandingEventsQuery($currentDate: DateTime) {
  nwPlusOutstandingEvents(currentDate: $currentDate) {
    events {
      id
      points
      slug
      ...NerdyNudgeFragment
    }
  }
}
    ${NerdyNudgeFragmentFragmentDoc}`;
export type GetNwPlusOutstandingEventsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables>, 'query'>;

    export const GetNwPlusOutstandingEventsQueryComponent = (props: GetNwPlusOutstandingEventsQueryComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables> query={GetNwPlusOutstandingEventsQueryDocument} {...props} />
    );
    
export type GetNwPlusOutstandingEventsQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables>
    } & TChildProps;
export function withGetNwPlusOutstandingEventsQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusOutstandingEventsQueryQuery,
  GetNwPlusOutstandingEventsQueryQueryVariables,
  GetNwPlusOutstandingEventsQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables, GetNwPlusOutstandingEventsQueryProps<TChildProps, TDataName>>(GetNwPlusOutstandingEventsQueryDocument, {
      alias: 'getNwPlusOutstandingEventsQuery',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusOutstandingEventsQueryQuery__
 *
 * To run a query within a React component, call `useGetNwPlusOutstandingEventsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusOutstandingEventsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusOutstandingEventsQueryQuery({
 *   variables: {
 *      currentDate: // value for 'currentDate'
 *   },
 * });
 */
export function useGetNwPlusOutstandingEventsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables>(GetNwPlusOutstandingEventsQueryDocument, options);
      }
export function useGetNwPlusOutstandingEventsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables>(GetNwPlusOutstandingEventsQueryDocument, options);
        }
export function useGetNwPlusOutstandingEventsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables>(GetNwPlusOutstandingEventsQueryDocument, options);
        }
export type GetNwPlusOutstandingEventsQueryQueryHookResult = ReturnType<typeof useGetNwPlusOutstandingEventsQueryQuery>;
export type GetNwPlusOutstandingEventsQueryLazyQueryHookResult = ReturnType<typeof useGetNwPlusOutstandingEventsQueryLazyQuery>;
export type GetNwPlusOutstandingEventsQuerySuspenseQueryHookResult = ReturnType<typeof useGetNwPlusOutstandingEventsQuerySuspenseQuery>;
export type GetNwPlusOutstandingEventsQueryQueryResult = ApolloReactCommon.QueryResult<GetNwPlusOutstandingEventsQueryQuery, GetNwPlusOutstandingEventsQueryQueryVariables>;
export const GetQuickStartGuideDocument = gql`
    query GetQuickStartGuide {
  mobileAppIdentityProfile {
    devices {
      deviceLastLogin
    }
  }
}
    `;
export type GetQuickStartGuideComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables>, 'query'>;

    export const GetQuickStartGuideComponent = (props: GetQuickStartGuideComponentProps) => (
      <ApolloReactComponents.Query<GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables> query={GetQuickStartGuideDocument} {...props} />
    );
    
export type GetQuickStartGuideProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables>
    } & TChildProps;
export function withGetQuickStartGuide<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetQuickStartGuideQuery,
  GetQuickStartGuideQueryVariables,
  GetQuickStartGuideProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables, GetQuickStartGuideProps<TChildProps, TDataName>>(GetQuickStartGuideDocument, {
      alias: 'getQuickStartGuide',
      ...operationOptions
    });
};

/**
 * __useGetQuickStartGuideQuery__
 *
 * To run a query within a React component, call `useGetQuickStartGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetQuickStartGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetQuickStartGuideQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetQuickStartGuideQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables>(GetQuickStartGuideDocument, options);
      }
export function useGetQuickStartGuideLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables>(GetQuickStartGuideDocument, options);
        }
export function useGetQuickStartGuideSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables>(GetQuickStartGuideDocument, options);
        }
export type GetQuickStartGuideQueryHookResult = ReturnType<typeof useGetQuickStartGuideQuery>;
export type GetQuickStartGuideLazyQueryHookResult = ReturnType<typeof useGetQuickStartGuideLazyQuery>;
export type GetQuickStartGuideSuspenseQueryHookResult = ReturnType<typeof useGetQuickStartGuideSuspenseQuery>;
export type GetQuickStartGuideQueryResult = ApolloReactCommon.QueryResult<GetQuickStartGuideQuery, GetQuickStartGuideQueryVariables>;
export const InsurancePoliciesForQuickStartGuideDocument = gql`
    query InsurancePoliciesForQuickStartGuide {
  insurancePolicies {
    policies {
      id
      isExpired
      policyType
    }
  }
}
    `;
export type InsurancePoliciesForQuickStartGuideComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables>, 'query'>;

    export const InsurancePoliciesForQuickStartGuideComponent = (props: InsurancePoliciesForQuickStartGuideComponentProps) => (
      <ApolloReactComponents.Query<InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables> query={InsurancePoliciesForQuickStartGuideDocument} {...props} />
    );
    
export type InsurancePoliciesForQuickStartGuideProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables>
    } & TChildProps;
export function withInsurancePoliciesForQuickStartGuide<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsurancePoliciesForQuickStartGuideQuery,
  InsurancePoliciesForQuickStartGuideQueryVariables,
  InsurancePoliciesForQuickStartGuideProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables, InsurancePoliciesForQuickStartGuideProps<TChildProps, TDataName>>(InsurancePoliciesForQuickStartGuideDocument, {
      alias: 'insurancePoliciesForQuickStartGuide',
      ...operationOptions
    });
};

/**
 * __useInsurancePoliciesForQuickStartGuideQuery__
 *
 * To run a query within a React component, call `useInsurancePoliciesForQuickStartGuideQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsurancePoliciesForQuickStartGuideQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsurancePoliciesForQuickStartGuideQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsurancePoliciesForQuickStartGuideQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables>(InsurancePoliciesForQuickStartGuideDocument, options);
      }
export function useInsurancePoliciesForQuickStartGuideLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables>(InsurancePoliciesForQuickStartGuideDocument, options);
        }
export function useInsurancePoliciesForQuickStartGuideSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables>(InsurancePoliciesForQuickStartGuideDocument, options);
        }
export type InsurancePoliciesForQuickStartGuideQueryHookResult = ReturnType<typeof useInsurancePoliciesForQuickStartGuideQuery>;
export type InsurancePoliciesForQuickStartGuideLazyQueryHookResult = ReturnType<typeof useInsurancePoliciesForQuickStartGuideLazyQuery>;
export type InsurancePoliciesForQuickStartGuideSuspenseQueryHookResult = ReturnType<typeof useInsurancePoliciesForQuickStartGuideSuspenseQuery>;
export type InsurancePoliciesForQuickStartGuideQueryResult = ApolloReactCommon.QueryResult<InsurancePoliciesForQuickStartGuideQuery, InsurancePoliciesForQuickStartGuideQueryVariables>;
export const GetTuAuthenticationStatusProfileDocument = gql`
    query GetTuAuthenticationStatusProfile {
  tuAuthenticationStatusProfile {
    status
  }
}
    `;
export type GetTuAuthenticationStatusProfileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables>, 'query'>;

    export const GetTuAuthenticationStatusProfileComponent = (props: GetTuAuthenticationStatusProfileComponentProps) => (
      <ApolloReactComponents.Query<GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables> query={GetTuAuthenticationStatusProfileDocument} {...props} />
    );
    
export type GetTuAuthenticationStatusProfileProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables>
    } & TChildProps;
export function withGetTuAuthenticationStatusProfile<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTuAuthenticationStatusProfileQuery,
  GetTuAuthenticationStatusProfileQueryVariables,
  GetTuAuthenticationStatusProfileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables, GetTuAuthenticationStatusProfileProps<TChildProps, TDataName>>(GetTuAuthenticationStatusProfileDocument, {
      alias: 'getTuAuthenticationStatusProfile',
      ...operationOptions
    });
};

/**
 * __useGetTuAuthenticationStatusProfileQuery__
 *
 * To run a query within a React component, call `useGetTuAuthenticationStatusProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTuAuthenticationStatusProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTuAuthenticationStatusProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTuAuthenticationStatusProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables>(GetTuAuthenticationStatusProfileDocument, options);
      }
export function useGetTuAuthenticationStatusProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables>(GetTuAuthenticationStatusProfileDocument, options);
        }
export function useGetTuAuthenticationStatusProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables>(GetTuAuthenticationStatusProfileDocument, options);
        }
export type GetTuAuthenticationStatusProfileQueryHookResult = ReturnType<typeof useGetTuAuthenticationStatusProfileQuery>;
export type GetTuAuthenticationStatusProfileLazyQueryHookResult = ReturnType<typeof useGetTuAuthenticationStatusProfileLazyQuery>;
export type GetTuAuthenticationStatusProfileSuspenseQueryHookResult = ReturnType<typeof useGetTuAuthenticationStatusProfileSuspenseQuery>;
export type GetTuAuthenticationStatusProfileQueryResult = ApolloReactCommon.QueryResult<GetTuAuthenticationStatusProfileQuery, GetTuAuthenticationStatusProfileQueryVariables>;
export const ExperimentationDocument = gql`
    query experimentation($testName: String!, $userAttributes: JSON!, $anonymousId: String!) {
  experimentDecisions(
    testNames: [$testName]
    userAttributes: $userAttributes
    anonymousId: $anonymousId
  ) {
    ...ExperimentQueryFields
    __typename
  }
}
    ${ExperimentQueryFieldsFragmentDoc}`;
export type ExperimentationComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExperimentationQuery, ExperimentationQueryVariables>, 'query'> & ({ variables: ExperimentationQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExperimentationComponent = (props: ExperimentationComponentProps) => (
      <ApolloReactComponents.Query<ExperimentationQuery, ExperimentationQueryVariables> query={ExperimentationDocument} {...props} />
    );
    
export type ExperimentationProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ExperimentationQuery, ExperimentationQueryVariables>
    } & TChildProps;
export function withExperimentation<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ExperimentationQuery,
  ExperimentationQueryVariables,
  ExperimentationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ExperimentationQuery, ExperimentationQueryVariables, ExperimentationProps<TChildProps, TDataName>>(ExperimentationDocument, {
      alias: 'experimentation',
      ...operationOptions
    });
};

/**
 * __useExperimentationQuery__
 *
 * To run a query within a React component, call `useExperimentationQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentationQuery({
 *   variables: {
 *      testName: // value for 'testName'
 *      userAttributes: // value for 'userAttributes'
 *      anonymousId: // value for 'anonymousId'
 *   },
 * });
 */
export function useExperimentationQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExperimentationQuery, ExperimentationQueryVariables> & ({ variables: ExperimentationQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExperimentationQuery, ExperimentationQueryVariables>(ExperimentationDocument, options);
      }
export function useExperimentationLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExperimentationQuery, ExperimentationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExperimentationQuery, ExperimentationQueryVariables>(ExperimentationDocument, options);
        }
export function useExperimentationSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExperimentationQuery, ExperimentationQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExperimentationQuery, ExperimentationQueryVariables>(ExperimentationDocument, options);
        }
export type ExperimentationQueryHookResult = ReturnType<typeof useExperimentationQuery>;
export type ExperimentationLazyQueryHookResult = ReturnType<typeof useExperimentationLazyQuery>;
export type ExperimentationSuspenseQueryHookResult = ReturnType<typeof useExperimentationSuspenseQuery>;
export type ExperimentationQueryResult = ApolloReactCommon.QueryResult<ExperimentationQuery, ExperimentationQueryVariables>;
export const NerdUpAuthenticationDocument = gql`
    mutation NerdUpAuthentication {
  generateNerdUpAuthenticationTokens {
    accessToken
    refreshToken
  }
}
    `;
export type NerdUpAuthenticationMutationFn = ApolloReactCommon.MutationFunction<NerdUpAuthenticationMutation, NerdUpAuthenticationMutationVariables>;
export type NerdUpAuthenticationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<NerdUpAuthenticationMutation, NerdUpAuthenticationMutationVariables>, 'mutation'>;

    export const NerdUpAuthenticationComponent = (props: NerdUpAuthenticationComponentProps) => (
      <ApolloReactComponents.Mutation<NerdUpAuthenticationMutation, NerdUpAuthenticationMutationVariables> mutation={NerdUpAuthenticationDocument} {...props} />
    );
    
export type NerdUpAuthenticationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<NerdUpAuthenticationMutation, NerdUpAuthenticationMutationVariables>
    } & TChildProps;
export function withNerdUpAuthentication<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NerdUpAuthenticationMutation,
  NerdUpAuthenticationMutationVariables,
  NerdUpAuthenticationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, NerdUpAuthenticationMutation, NerdUpAuthenticationMutationVariables, NerdUpAuthenticationProps<TChildProps, TDataName>>(NerdUpAuthenticationDocument, {
      alias: 'nerdUpAuthentication',
      ...operationOptions
    });
};

/**
 * __useNerdUpAuthenticationMutation__
 *
 * To run a mutation, you first call `useNerdUpAuthenticationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNerdUpAuthenticationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nerdUpAuthenticationMutation, { data, loading, error }] = useNerdUpAuthenticationMutation({
 *   variables: {
 *   },
 * });
 */
export function useNerdUpAuthenticationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NerdUpAuthenticationMutation, NerdUpAuthenticationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NerdUpAuthenticationMutation, NerdUpAuthenticationMutationVariables>(NerdUpAuthenticationDocument, options);
      }
export type NerdUpAuthenticationMutationHookResult = ReturnType<typeof useNerdUpAuthenticationMutation>;
export type NerdUpAuthenticationMutationResult = ApolloReactCommon.MutationResult<NerdUpAuthenticationMutation>;
export type NerdUpAuthenticationMutationOptions = ApolloReactCommon.BaseMutationOptions<NerdUpAuthenticationMutation, NerdUpAuthenticationMutationVariables>;
export const GetNerdUpCardStatusNerdUpDocument = gql`
    query GetNerdUpCardStatusNerdUp {
  nerdUpCreditCard {
    applicationStatus
  }
}
    `;
export type GetNerdUpCardStatusNerdUpComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables>, 'query'>;

    export const GetNerdUpCardStatusNerdUpComponent = (props: GetNerdUpCardStatusNerdUpComponentProps) => (
      <ApolloReactComponents.Query<GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables> query={GetNerdUpCardStatusNerdUpDocument} {...props} />
    );
    
export type GetNerdUpCardStatusNerdUpProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables>
    } & TChildProps;
export function withGetNerdUpCardStatusNerdUp<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNerdUpCardStatusNerdUpQuery,
  GetNerdUpCardStatusNerdUpQueryVariables,
  GetNerdUpCardStatusNerdUpProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables, GetNerdUpCardStatusNerdUpProps<TChildProps, TDataName>>(GetNerdUpCardStatusNerdUpDocument, {
      alias: 'getNerdUpCardStatusNerdUp',
      ...operationOptions
    });
};

/**
 * __useGetNerdUpCardStatusNerdUpQuery__
 *
 * To run a query within a React component, call `useGetNerdUpCardStatusNerdUpQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNerdUpCardStatusNerdUpQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNerdUpCardStatusNerdUpQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNerdUpCardStatusNerdUpQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables>(GetNerdUpCardStatusNerdUpDocument, options);
      }
export function useGetNerdUpCardStatusNerdUpLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables>(GetNerdUpCardStatusNerdUpDocument, options);
        }
export function useGetNerdUpCardStatusNerdUpSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables>(GetNerdUpCardStatusNerdUpDocument, options);
        }
export type GetNerdUpCardStatusNerdUpQueryHookResult = ReturnType<typeof useGetNerdUpCardStatusNerdUpQuery>;
export type GetNerdUpCardStatusNerdUpLazyQueryHookResult = ReturnType<typeof useGetNerdUpCardStatusNerdUpLazyQuery>;
export type GetNerdUpCardStatusNerdUpSuspenseQueryHookResult = ReturnType<typeof useGetNerdUpCardStatusNerdUpSuspenseQuery>;
export type GetNerdUpCardStatusNerdUpQueryResult = ApolloReactCommon.QueryResult<GetNerdUpCardStatusNerdUpQuery, GetNerdUpCardStatusNerdUpQueryVariables>;
export const RecentlyViewedDashboardQueryDocument = gql`
    query RecentlyViewedDashboardQuery($maxPagesCount: Int) {
  recentlyViewed(maxPagesCount: $maxPagesCount) {
    dateLastVisited
    id
    numberOfVisits
    synopsis
    title
    type
    urlPath
  }
}
    `;
export type RecentlyViewedDashboardQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables>, 'query'>;

    export const RecentlyViewedDashboardQueryComponent = (props: RecentlyViewedDashboardQueryComponentProps) => (
      <ApolloReactComponents.Query<RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables> query={RecentlyViewedDashboardQueryDocument} {...props} />
    );
    
export type RecentlyViewedDashboardQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables>
    } & TChildProps;
export function withRecentlyViewedDashboardQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RecentlyViewedDashboardQueryQuery,
  RecentlyViewedDashboardQueryQueryVariables,
  RecentlyViewedDashboardQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables, RecentlyViewedDashboardQueryProps<TChildProps, TDataName>>(RecentlyViewedDashboardQueryDocument, {
      alias: 'recentlyViewedDashboardQuery',
      ...operationOptions
    });
};

/**
 * __useRecentlyViewedDashboardQueryQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedDashboardQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedDashboardQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedDashboardQueryQuery({
 *   variables: {
 *      maxPagesCount: // value for 'maxPagesCount'
 *   },
 * });
 */
export function useRecentlyViewedDashboardQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables>(RecentlyViewedDashboardQueryDocument, options);
      }
export function useRecentlyViewedDashboardQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables>(RecentlyViewedDashboardQueryDocument, options);
        }
export function useRecentlyViewedDashboardQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables>(RecentlyViewedDashboardQueryDocument, options);
        }
export type RecentlyViewedDashboardQueryQueryHookResult = ReturnType<typeof useRecentlyViewedDashboardQueryQuery>;
export type RecentlyViewedDashboardQueryLazyQueryHookResult = ReturnType<typeof useRecentlyViewedDashboardQueryLazyQuery>;
export type RecentlyViewedDashboardQuerySuspenseQueryHookResult = ReturnType<typeof useRecentlyViewedDashboardQuerySuspenseQuery>;
export type RecentlyViewedDashboardQueryQueryResult = ApolloReactCommon.QueryResult<RecentlyViewedDashboardQueryQuery, RecentlyViewedDashboardQueryQueryVariables>;
export const ClearRecentlyViewedHistoryDocument = gql`
    mutation ClearRecentlyViewedHistory {
  clearRecentlyViewedHistory
}
    `;
export type ClearRecentlyViewedHistoryMutationFn = ApolloReactCommon.MutationFunction<ClearRecentlyViewedHistoryMutation, ClearRecentlyViewedHistoryMutationVariables>;
export type ClearRecentlyViewedHistoryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ClearRecentlyViewedHistoryMutation, ClearRecentlyViewedHistoryMutationVariables>, 'mutation'>;

    export const ClearRecentlyViewedHistoryComponent = (props: ClearRecentlyViewedHistoryComponentProps) => (
      <ApolloReactComponents.Mutation<ClearRecentlyViewedHistoryMutation, ClearRecentlyViewedHistoryMutationVariables> mutation={ClearRecentlyViewedHistoryDocument} {...props} />
    );
    
export type ClearRecentlyViewedHistoryProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ClearRecentlyViewedHistoryMutation, ClearRecentlyViewedHistoryMutationVariables>
    } & TChildProps;
export function withClearRecentlyViewedHistory<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ClearRecentlyViewedHistoryMutation,
  ClearRecentlyViewedHistoryMutationVariables,
  ClearRecentlyViewedHistoryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ClearRecentlyViewedHistoryMutation, ClearRecentlyViewedHistoryMutationVariables, ClearRecentlyViewedHistoryProps<TChildProps, TDataName>>(ClearRecentlyViewedHistoryDocument, {
      alias: 'clearRecentlyViewedHistory',
      ...operationOptions
    });
};

/**
 * __useClearRecentlyViewedHistoryMutation__
 *
 * To run a mutation, you first call `useClearRecentlyViewedHistoryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useClearRecentlyViewedHistoryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [clearRecentlyViewedHistoryMutation, { data, loading, error }] = useClearRecentlyViewedHistoryMutation({
 *   variables: {
 *   },
 * });
 */
export function useClearRecentlyViewedHistoryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ClearRecentlyViewedHistoryMutation, ClearRecentlyViewedHistoryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ClearRecentlyViewedHistoryMutation, ClearRecentlyViewedHistoryMutationVariables>(ClearRecentlyViewedHistoryDocument, options);
      }
export type ClearRecentlyViewedHistoryMutationHookResult = ReturnType<typeof useClearRecentlyViewedHistoryMutation>;
export type ClearRecentlyViewedHistoryMutationResult = ApolloReactCommon.MutationResult<ClearRecentlyViewedHistoryMutation>;
export type ClearRecentlyViewedHistoryMutationOptions = ApolloReactCommon.BaseMutationOptions<ClearRecentlyViewedHistoryMutation, ClearRecentlyViewedHistoryMutationVariables>;
export const SavedContentByEntityTypeDocument = gql`
    query SavedContentByEntityType($entityType: String!) {
  savedContentByEntityType(entityType: $entityType) {
    savedAt
    content {
      ... on Article {
        title
        synopsis
        id
        link
      }
    }
  }
}
    `;
export type SavedContentByEntityTypeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables>, 'query'> & ({ variables: SavedContentByEntityTypeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const SavedContentByEntityTypeComponent = (props: SavedContentByEntityTypeComponentProps) => (
      <ApolloReactComponents.Query<SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables> query={SavedContentByEntityTypeDocument} {...props} />
    );
    
export type SavedContentByEntityTypeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables>
    } & TChildProps;
export function withSavedContentByEntityType<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  SavedContentByEntityTypeQuery,
  SavedContentByEntityTypeQueryVariables,
  SavedContentByEntityTypeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables, SavedContentByEntityTypeProps<TChildProps, TDataName>>(SavedContentByEntityTypeDocument, {
      alias: 'savedContentByEntityType',
      ...operationOptions
    });
};

/**
 * __useSavedContentByEntityTypeQuery__
 *
 * To run a query within a React component, call `useSavedContentByEntityTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useSavedContentByEntityTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSavedContentByEntityTypeQuery({
 *   variables: {
 *      entityType: // value for 'entityType'
 *   },
 * });
 */
export function useSavedContentByEntityTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables> & ({ variables: SavedContentByEntityTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables>(SavedContentByEntityTypeDocument, options);
      }
export function useSavedContentByEntityTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables>(SavedContentByEntityTypeDocument, options);
        }
export function useSavedContentByEntityTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables>(SavedContentByEntityTypeDocument, options);
        }
export type SavedContentByEntityTypeQueryHookResult = ReturnType<typeof useSavedContentByEntityTypeQuery>;
export type SavedContentByEntityTypeLazyQueryHookResult = ReturnType<typeof useSavedContentByEntityTypeLazyQuery>;
export type SavedContentByEntityTypeSuspenseQueryHookResult = ReturnType<typeof useSavedContentByEntityTypeSuspenseQuery>;
export type SavedContentByEntityTypeQueryResult = ApolloReactCommon.QueryResult<SavedContentByEntityTypeQuery, SavedContentByEntityTypeQueryVariables>;
export const GetNetWorthRealAssetsDocument = gql`
    query GetNetWorthRealAssets {
  netWorthRealAssets {
    assets {
      id
      type
      isHiddenFromNetWorth
      amount
      lastReportedOrSyncedAt
      isSelfReported
      ... on NetWorthHomeIntegrated {
        address {
          addressLine1
          addressLine2
          city
          state
          zipCode
        }
        externalInfo {
          source
          value
        }
      }
      ... on NetWorthRealAssetSelfReported {
        nickname
      }
    }
  }
}
    `;
export type GetNetWorthRealAssetsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables>, 'query'>;

    export const GetNetWorthRealAssetsComponent = (props: GetNetWorthRealAssetsComponentProps) => (
      <ApolloReactComponents.Query<GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables> query={GetNetWorthRealAssetsDocument} {...props} />
    );
    
export type GetNetWorthRealAssetsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables>
    } & TChildProps;
export function withGetNetWorthRealAssets<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNetWorthRealAssetsQuery,
  GetNetWorthRealAssetsQueryVariables,
  GetNetWorthRealAssetsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables, GetNetWorthRealAssetsProps<TChildProps, TDataName>>(GetNetWorthRealAssetsDocument, {
      alias: 'getNetWorthRealAssets',
      ...operationOptions
    });
};

/**
 * __useGetNetWorthRealAssetsQuery__
 *
 * To run a query within a React component, call `useGetNetWorthRealAssetsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetWorthRealAssetsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetWorthRealAssetsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNetWorthRealAssetsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables>(GetNetWorthRealAssetsDocument, options);
      }
export function useGetNetWorthRealAssetsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables>(GetNetWorthRealAssetsDocument, options);
        }
export function useGetNetWorthRealAssetsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables>(GetNetWorthRealAssetsDocument, options);
        }
export type GetNetWorthRealAssetsQueryHookResult = ReturnType<typeof useGetNetWorthRealAssetsQuery>;
export type GetNetWorthRealAssetsLazyQueryHookResult = ReturnType<typeof useGetNetWorthRealAssetsLazyQuery>;
export type GetNetWorthRealAssetsSuspenseQueryHookResult = ReturnType<typeof useGetNetWorthRealAssetsSuspenseQuery>;
export type GetNetWorthRealAssetsQueryResult = ApolloReactCommon.QueryResult<GetNetWorthRealAssetsQuery, GetNetWorthRealAssetsQueryVariables>;
export const GetInsuranceAccountsForSettingsDocument = gql`
    query GetInsuranceAccountsForSettings {
  insuranceAccounts {
    success
    insuranceAccounts {
      id
      insuranceProviderName
      friendlyInsuranceProviderName
      requiresReconnect
    }
  }
}
    `;
export type GetInsuranceAccountsForSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables>, 'query'>;

    export const GetInsuranceAccountsForSettingsComponent = (props: GetInsuranceAccountsForSettingsComponentProps) => (
      <ApolloReactComponents.Query<GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables> query={GetInsuranceAccountsForSettingsDocument} {...props} />
    );
    
export type GetInsuranceAccountsForSettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables>
    } & TChildProps;
export function withGetInsuranceAccountsForSettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInsuranceAccountsForSettingsQuery,
  GetInsuranceAccountsForSettingsQueryVariables,
  GetInsuranceAccountsForSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables, GetInsuranceAccountsForSettingsProps<TChildProps, TDataName>>(GetInsuranceAccountsForSettingsDocument, {
      alias: 'getInsuranceAccountsForSettings',
      ...operationOptions
    });
};

/**
 * __useGetInsuranceAccountsForSettingsQuery__
 *
 * To run a query within a React component, call `useGetInsuranceAccountsForSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceAccountsForSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceAccountsForSettingsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetInsuranceAccountsForSettingsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables>(GetInsuranceAccountsForSettingsDocument, options);
      }
export function useGetInsuranceAccountsForSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables>(GetInsuranceAccountsForSettingsDocument, options);
        }
export function useGetInsuranceAccountsForSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables>(GetInsuranceAccountsForSettingsDocument, options);
        }
export type GetInsuranceAccountsForSettingsQueryHookResult = ReturnType<typeof useGetInsuranceAccountsForSettingsQuery>;
export type GetInsuranceAccountsForSettingsLazyQueryHookResult = ReturnType<typeof useGetInsuranceAccountsForSettingsLazyQuery>;
export type GetInsuranceAccountsForSettingsSuspenseQueryHookResult = ReturnType<typeof useGetInsuranceAccountsForSettingsSuspenseQuery>;
export type GetInsuranceAccountsForSettingsQueryResult = ApolloReactCommon.QueryResult<GetInsuranceAccountsForSettingsQuery, GetInsuranceAccountsForSettingsQueryVariables>;
export const GetReconnectTokenForSettingsDocument = gql`
    query GetReconnectTokenForSettings($accountId: ID!) {
  accountReconnectToken(accountId: $accountId) {
    reconnectToken
  }
}
    `;
export type GetReconnectTokenForSettingsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables>, 'query'> & ({ variables: GetReconnectTokenForSettingsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetReconnectTokenForSettingsComponent = (props: GetReconnectTokenForSettingsComponentProps) => (
      <ApolloReactComponents.Query<GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables> query={GetReconnectTokenForSettingsDocument} {...props} />
    );
    
export type GetReconnectTokenForSettingsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables>
    } & TChildProps;
export function withGetReconnectTokenForSettings<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetReconnectTokenForSettingsQuery,
  GetReconnectTokenForSettingsQueryVariables,
  GetReconnectTokenForSettingsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables, GetReconnectTokenForSettingsProps<TChildProps, TDataName>>(GetReconnectTokenForSettingsDocument, {
      alias: 'getReconnectTokenForSettings',
      ...operationOptions
    });
};

/**
 * __useGetReconnectTokenForSettingsQuery__
 *
 * To run a query within a React component, call `useGetReconnectTokenForSettingsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetReconnectTokenForSettingsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetReconnectTokenForSettingsQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetReconnectTokenForSettingsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables> & ({ variables: GetReconnectTokenForSettingsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables>(GetReconnectTokenForSettingsDocument, options);
      }
export function useGetReconnectTokenForSettingsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables>(GetReconnectTokenForSettingsDocument, options);
        }
export function useGetReconnectTokenForSettingsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables>(GetReconnectTokenForSettingsDocument, options);
        }
export type GetReconnectTokenForSettingsQueryHookResult = ReturnType<typeof useGetReconnectTokenForSettingsQuery>;
export type GetReconnectTokenForSettingsLazyQueryHookResult = ReturnType<typeof useGetReconnectTokenForSettingsLazyQuery>;
export type GetReconnectTokenForSettingsSuspenseQueryHookResult = ReturnType<typeof useGetReconnectTokenForSettingsSuspenseQuery>;
export type GetReconnectTokenForSettingsQueryResult = ApolloReactCommon.QueryResult<GetReconnectTokenForSettingsQuery, GetReconnectTokenForSettingsQueryVariables>;
export const DeleteInsuranceByAccountIdDocument = gql`
    mutation DeleteInsuranceByAccountId($accountId: ID!) {
  deleteInsuranceByAccountId(accountId: $accountId) {
    success
  }
}
    `;
export type DeleteInsuranceByAccountIdMutationFn = ApolloReactCommon.MutationFunction<DeleteInsuranceByAccountIdMutation, DeleteInsuranceByAccountIdMutationVariables>;
export type DeleteInsuranceByAccountIdComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteInsuranceByAccountIdMutation, DeleteInsuranceByAccountIdMutationVariables>, 'mutation'>;

    export const DeleteInsuranceByAccountIdComponent = (props: DeleteInsuranceByAccountIdComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteInsuranceByAccountIdMutation, DeleteInsuranceByAccountIdMutationVariables> mutation={DeleteInsuranceByAccountIdDocument} {...props} />
    );
    
export type DeleteInsuranceByAccountIdProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteInsuranceByAccountIdMutation, DeleteInsuranceByAccountIdMutationVariables>
    } & TChildProps;
export function withDeleteInsuranceByAccountId<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteInsuranceByAccountIdMutation,
  DeleteInsuranceByAccountIdMutationVariables,
  DeleteInsuranceByAccountIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteInsuranceByAccountIdMutation, DeleteInsuranceByAccountIdMutationVariables, DeleteInsuranceByAccountIdProps<TChildProps, TDataName>>(DeleteInsuranceByAccountIdDocument, {
      alias: 'deleteInsuranceByAccountId',
      ...operationOptions
    });
};

/**
 * __useDeleteInsuranceByAccountIdMutation__
 *
 * To run a mutation, you first call `useDeleteInsuranceByAccountIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteInsuranceByAccountIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteInsuranceByAccountIdMutation, { data, loading, error }] = useDeleteInsuranceByAccountIdMutation({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useDeleteInsuranceByAccountIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteInsuranceByAccountIdMutation, DeleteInsuranceByAccountIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteInsuranceByAccountIdMutation, DeleteInsuranceByAccountIdMutationVariables>(DeleteInsuranceByAccountIdDocument, options);
      }
export type DeleteInsuranceByAccountIdMutationHookResult = ReturnType<typeof useDeleteInsuranceByAccountIdMutation>;
export type DeleteInsuranceByAccountIdMutationResult = ApolloReactCommon.MutationResult<DeleteInsuranceByAccountIdMutation>;
export type DeleteInsuranceByAccountIdMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteInsuranceByAccountIdMutation, DeleteInsuranceByAccountIdMutationVariables>;
export const FollowAuthorDocument = gql`
    mutation FollowAuthor($entityId: Int!) {
  followAuthor(entityId: $entityId) {
    id
    entityId
  }
}
    `;
export type FollowAuthorMutationFn = ApolloReactCommon.MutationFunction<FollowAuthorMutation, FollowAuthorMutationVariables>;
export type FollowAuthorComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<FollowAuthorMutation, FollowAuthorMutationVariables>, 'mutation'>;

    export const FollowAuthorComponent = (props: FollowAuthorComponentProps) => (
      <ApolloReactComponents.Mutation<FollowAuthorMutation, FollowAuthorMutationVariables> mutation={FollowAuthorDocument} {...props} />
    );
    
export type FollowAuthorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<FollowAuthorMutation, FollowAuthorMutationVariables>
    } & TChildProps;
export function withFollowAuthor<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FollowAuthorMutation,
  FollowAuthorMutationVariables,
  FollowAuthorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, FollowAuthorMutation, FollowAuthorMutationVariables, FollowAuthorProps<TChildProps, TDataName>>(FollowAuthorDocument, {
      alias: 'followAuthor',
      ...operationOptions
    });
};

/**
 * __useFollowAuthorMutation__
 *
 * To run a mutation, you first call `useFollowAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useFollowAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [followAuthorMutation, { data, loading, error }] = useFollowAuthorMutation({
 *   variables: {
 *      entityId: // value for 'entityId'
 *   },
 * });
 */
export function useFollowAuthorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<FollowAuthorMutation, FollowAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<FollowAuthorMutation, FollowAuthorMutationVariables>(FollowAuthorDocument, options);
      }
export type FollowAuthorMutationHookResult = ReturnType<typeof useFollowAuthorMutation>;
export type FollowAuthorMutationResult = ApolloReactCommon.MutationResult<FollowAuthorMutation>;
export type FollowAuthorMutationOptions = ApolloReactCommon.BaseMutationOptions<FollowAuthorMutation, FollowAuthorMutationVariables>;
export const UnfollowAuthorDocument = gql`
    mutation UnfollowAuthor($id: ID!) {
  unfollowAuthor(id: $id)
}
    `;
export type UnfollowAuthorMutationFn = ApolloReactCommon.MutationFunction<UnfollowAuthorMutation, UnfollowAuthorMutationVariables>;
export type UnfollowAuthorComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnfollowAuthorMutation, UnfollowAuthorMutationVariables>, 'mutation'>;

    export const UnfollowAuthorComponent = (props: UnfollowAuthorComponentProps) => (
      <ApolloReactComponents.Mutation<UnfollowAuthorMutation, UnfollowAuthorMutationVariables> mutation={UnfollowAuthorDocument} {...props} />
    );
    
export type UnfollowAuthorProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UnfollowAuthorMutation, UnfollowAuthorMutationVariables>
    } & TChildProps;
export function withUnfollowAuthor<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnfollowAuthorMutation,
  UnfollowAuthorMutationVariables,
  UnfollowAuthorProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UnfollowAuthorMutation, UnfollowAuthorMutationVariables, UnfollowAuthorProps<TChildProps, TDataName>>(UnfollowAuthorDocument, {
      alias: 'unfollowAuthor',
      ...operationOptions
    });
};

/**
 * __useUnfollowAuthorMutation__
 *
 * To run a mutation, you first call `useUnfollowAuthorMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnfollowAuthorMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unfollowAuthorMutation, { data, loading, error }] = useUnfollowAuthorMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useUnfollowAuthorMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnfollowAuthorMutation, UnfollowAuthorMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnfollowAuthorMutation, UnfollowAuthorMutationVariables>(UnfollowAuthorDocument, options);
      }
export type UnfollowAuthorMutationHookResult = ReturnType<typeof useUnfollowAuthorMutation>;
export type UnfollowAuthorMutationResult = ApolloReactCommon.MutationResult<UnfollowAuthorMutation>;
export type UnfollowAuthorMutationOptions = ApolloReactCommon.BaseMutationOptions<UnfollowAuthorMutation, UnfollowAuthorMutationVariables>;
export const FollowedAuthorsDocument = gql`
    query FollowedAuthors {
  followedAuthors {
    id
    entityId
    author {
      link
      name
      slug
      tagline
    }
  }
}
    `;
export type FollowedAuthorsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FollowedAuthorsQuery, FollowedAuthorsQueryVariables>, 'query'>;

    export const FollowedAuthorsComponent = (props: FollowedAuthorsComponentProps) => (
      <ApolloReactComponents.Query<FollowedAuthorsQuery, FollowedAuthorsQueryVariables> query={FollowedAuthorsDocument} {...props} />
    );
    
export type FollowedAuthorsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FollowedAuthorsQuery, FollowedAuthorsQueryVariables>
    } & TChildProps;
export function withFollowedAuthors<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FollowedAuthorsQuery,
  FollowedAuthorsQueryVariables,
  FollowedAuthorsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FollowedAuthorsQuery, FollowedAuthorsQueryVariables, FollowedAuthorsProps<TChildProps, TDataName>>(FollowedAuthorsDocument, {
      alias: 'followedAuthors',
      ...operationOptions
    });
};

/**
 * __useFollowedAuthorsQuery__
 *
 * To run a query within a React component, call `useFollowedAuthorsQuery` and pass it any options that fit your needs.
 * When your component renders, `useFollowedAuthorsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFollowedAuthorsQuery({
 *   variables: {
 *   },
 * });
 */
export function useFollowedAuthorsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FollowedAuthorsQuery, FollowedAuthorsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FollowedAuthorsQuery, FollowedAuthorsQueryVariables>(FollowedAuthorsDocument, options);
      }
export function useFollowedAuthorsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FollowedAuthorsQuery, FollowedAuthorsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FollowedAuthorsQuery, FollowedAuthorsQueryVariables>(FollowedAuthorsDocument, options);
        }
export function useFollowedAuthorsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FollowedAuthorsQuery, FollowedAuthorsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FollowedAuthorsQuery, FollowedAuthorsQueryVariables>(FollowedAuthorsDocument, options);
        }
export type FollowedAuthorsQueryHookResult = ReturnType<typeof useFollowedAuthorsQuery>;
export type FollowedAuthorsLazyQueryHookResult = ReturnType<typeof useFollowedAuthorsLazyQuery>;
export type FollowedAuthorsSuspenseQueryHookResult = ReturnType<typeof useFollowedAuthorsSuspenseQuery>;
export type FollowedAuthorsQueryResult = ApolloReactCommon.QueryResult<FollowedAuthorsQuery, FollowedAuthorsQueryVariables>;
export const GetNerdUpCardStatusDocument = gql`
    query GetNerdUpCardStatus {
  nerdUpCreditCard {
    applicationStatus
    cardStatus
  }
}
    `;
export type GetNerdUpCardStatusComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables>, 'query'>;

    export const GetNerdUpCardStatusComponent = (props: GetNerdUpCardStatusComponentProps) => (
      <ApolloReactComponents.Query<GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables> query={GetNerdUpCardStatusDocument} {...props} />
    );
    
export type GetNerdUpCardStatusProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables>
    } & TChildProps;
export function withGetNerdUpCardStatus<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNerdUpCardStatusQuery,
  GetNerdUpCardStatusQueryVariables,
  GetNerdUpCardStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables, GetNerdUpCardStatusProps<TChildProps, TDataName>>(GetNerdUpCardStatusDocument, {
      alias: 'getNerdUpCardStatus',
      ...operationOptions
    });
};

/**
 * __useGetNerdUpCardStatusQuery__
 *
 * To run a query within a React component, call `useGetNerdUpCardStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNerdUpCardStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNerdUpCardStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNerdUpCardStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables>(GetNerdUpCardStatusDocument, options);
      }
export function useGetNerdUpCardStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables>(GetNerdUpCardStatusDocument, options);
        }
export function useGetNerdUpCardStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables>(GetNerdUpCardStatusDocument, options);
        }
export type GetNerdUpCardStatusQueryHookResult = ReturnType<typeof useGetNerdUpCardStatusQuery>;
export type GetNerdUpCardStatusLazyQueryHookResult = ReturnType<typeof useGetNerdUpCardStatusLazyQuery>;
export type GetNerdUpCardStatusSuspenseQueryHookResult = ReturnType<typeof useGetNerdUpCardStatusSuspenseQuery>;
export type GetNerdUpCardStatusQueryResult = ApolloReactCommon.QueryResult<GetNerdUpCardStatusQuery, GetNerdUpCardStatusQueryVariables>;
export const GetUserInfoDocument = gql`
    query GetUserInfo {
  financialIdentityProfile {
    annualIncome
    monthlyNetIncome
  }
  identity {
    email
  }
  globalIdentityProfile {
    firstName
    lastName
  }
}
    `;
export type GetUserInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserInfoQuery, GetUserInfoQueryVariables>, 'query'>;

    export const GetUserInfoComponent = (props: GetUserInfoComponentProps) => (
      <ApolloReactComponents.Query<GetUserInfoQuery, GetUserInfoQueryVariables> query={GetUserInfoDocument} {...props} />
    );
    
export type GetUserInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserInfoQuery, GetUserInfoQueryVariables>
    } & TChildProps;
export function withGetUserInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserInfoQuery,
  GetUserInfoQueryVariables,
  GetUserInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserInfoQuery, GetUserInfoQueryVariables, GetUserInfoProps<TChildProps, TDataName>>(GetUserInfoDocument, {
      alias: 'getUserInfo',
      ...operationOptions
    });
};

/**
 * __useGetUserInfoQuery__
 *
 * To run a query within a React component, call `useGetUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
      }
export function useGetUserInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
        }
export function useGetUserInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserInfoQuery, GetUserInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserInfoQuery, GetUserInfoQueryVariables>(GetUserInfoDocument, options);
        }
export type GetUserInfoQueryHookResult = ReturnType<typeof useGetUserInfoQuery>;
export type GetUserInfoLazyQueryHookResult = ReturnType<typeof useGetUserInfoLazyQuery>;
export type GetUserInfoSuspenseQueryHookResult = ReturnType<typeof useGetUserInfoSuspenseQuery>;
export type GetUserInfoQueryResult = ApolloReactCommon.QueryResult<GetUserInfoQuery, GetUserInfoQueryVariables>;
export const UpdateNameDocument = gql`
    mutation UpdateName($input: UpdateNameInput!) {
  updateName(input: $input) {
    lastName
    firstName
  }
}
    `;
export type UpdateNameMutationFn = ApolloReactCommon.MutationFunction<UpdateNameMutation, UpdateNameMutationVariables>;
export type UpdateNameComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateNameMutation, UpdateNameMutationVariables>, 'mutation'>;

    export const UpdateNameComponent = (props: UpdateNameComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateNameMutation, UpdateNameMutationVariables> mutation={UpdateNameDocument} {...props} />
    );
    
export type UpdateNameProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateNameMutation, UpdateNameMutationVariables>
    } & TChildProps;
export function withUpdateName<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateNameMutation,
  UpdateNameMutationVariables,
  UpdateNameProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateNameMutation, UpdateNameMutationVariables, UpdateNameProps<TChildProps, TDataName>>(UpdateNameDocument, {
      alias: 'updateName',
      ...operationOptions
    });
};

/**
 * __useUpdateNameMutation__
 *
 * To run a mutation, you first call `useUpdateNameMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateNameMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateNameMutation, { data, loading, error }] = useUpdateNameMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateNameMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateNameMutation, UpdateNameMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateNameMutation, UpdateNameMutationVariables>(UpdateNameDocument, options);
      }
export type UpdateNameMutationHookResult = ReturnType<typeof useUpdateNameMutation>;
export type UpdateNameMutationResult = ApolloReactCommon.MutationResult<UpdateNameMutation>;
export type UpdateNameMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateNameMutation, UpdateNameMutationVariables>;
export const UpdateIncomeDocument = gql`
    mutation UpdateIncome($input: UpdateIncomeInput!) {
  updateIncome(input: $input) {
    annualIncome
    monthlyNetIncome
  }
}
    `;
export type UpdateIncomeMutationFn = ApolloReactCommon.MutationFunction<UpdateIncomeMutation, UpdateIncomeMutationVariables>;
export type UpdateIncomeComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateIncomeMutation, UpdateIncomeMutationVariables>, 'mutation'>;

    export const UpdateIncomeComponent = (props: UpdateIncomeComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateIncomeMutation, UpdateIncomeMutationVariables> mutation={UpdateIncomeDocument} {...props} />
    );
    
export type UpdateIncomeProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateIncomeMutation, UpdateIncomeMutationVariables>
    } & TChildProps;
export function withUpdateIncome<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateIncomeMutation,
  UpdateIncomeMutationVariables,
  UpdateIncomeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateIncomeMutation, UpdateIncomeMutationVariables, UpdateIncomeProps<TChildProps, TDataName>>(UpdateIncomeDocument, {
      alias: 'updateIncome',
      ...operationOptions
    });
};

/**
 * __useUpdateIncomeMutation__
 *
 * To run a mutation, you first call `useUpdateIncomeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIncomeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIncomeMutation, { data, loading, error }] = useUpdateIncomeMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateIncomeMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIncomeMutation, UpdateIncomeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateIncomeMutation, UpdateIncomeMutationVariables>(UpdateIncomeDocument, options);
      }
export type UpdateIncomeMutationHookResult = ReturnType<typeof useUpdateIncomeMutation>;
export type UpdateIncomeMutationResult = ApolloReactCommon.MutationResult<UpdateIncomeMutation>;
export type UpdateIncomeMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIncomeMutation, UpdateIncomeMutationVariables>;
export const GetIdentityDocument = gql`
    query GetIdentity {
  identity {
    id
    identityId
  }
}
    `;
export type GetIdentityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetIdentityQuery, GetIdentityQueryVariables>, 'query'>;

    export const GetIdentityComponent = (props: GetIdentityComponentProps) => (
      <ApolloReactComponents.Query<GetIdentityQuery, GetIdentityQueryVariables> query={GetIdentityDocument} {...props} />
    );
    
export type GetIdentityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetIdentityQuery, GetIdentityQueryVariables>
    } & TChildProps;
export function withGetIdentity<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetIdentityQuery,
  GetIdentityQueryVariables,
  GetIdentityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetIdentityQuery, GetIdentityQueryVariables, GetIdentityProps<TChildProps, TDataName>>(GetIdentityDocument, {
      alias: 'getIdentity',
      ...operationOptions
    });
};

/**
 * __useGetIdentityQuery__
 *
 * To run a query within a React component, call `useGetIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdentityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIdentityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIdentityQuery, GetIdentityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIdentityQuery, GetIdentityQueryVariables>(GetIdentityDocument, options);
      }
export function useGetIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIdentityQuery, GetIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIdentityQuery, GetIdentityQueryVariables>(GetIdentityDocument, options);
        }
export function useGetIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIdentityQuery, GetIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIdentityQuery, GetIdentityQueryVariables>(GetIdentityDocument, options);
        }
export type GetIdentityQueryHookResult = ReturnType<typeof useGetIdentityQuery>;
export type GetIdentityLazyQueryHookResult = ReturnType<typeof useGetIdentityLazyQuery>;
export type GetIdentitySuspenseQueryHookResult = ReturnType<typeof useGetIdentitySuspenseQuery>;
export type GetIdentityQueryResult = ApolloReactCommon.QueryResult<GetIdentityQuery, GetIdentityQueryVariables>;
export const GetNotificationsPreferencesDocument = gql`
    query GetNotificationsPreferences {
  mobileAppIdentityProfile {
    devices {
      deviceLastLogin
    }
  }
  subscriptionIdentityProfile {
    emailEnabled
    emailCreditMonitoringEnabled
    emailSpendingAlertsEnabled
    emailMarketingEnabled
    emailPersonalizedContentEnabled
    pushEnabled
    pushCreditMonitoringEnabled
    pushSpendingAlertsEnabled
    pushMarketingUpdatesEnabled
    pushPersonalizedContentEnabled
  }
}
    `;
export type GetNotificationsPreferencesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables>, 'query'>;

    export const GetNotificationsPreferencesComponent = (props: GetNotificationsPreferencesComponentProps) => (
      <ApolloReactComponents.Query<GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables> query={GetNotificationsPreferencesDocument} {...props} />
    );
    
export type GetNotificationsPreferencesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables>
    } & TChildProps;
export function withGetNotificationsPreferences<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNotificationsPreferencesQuery,
  GetNotificationsPreferencesQueryVariables,
  GetNotificationsPreferencesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables, GetNotificationsPreferencesProps<TChildProps, TDataName>>(GetNotificationsPreferencesDocument, {
      alias: 'getNotificationsPreferences',
      ...operationOptions
    });
};

/**
 * __useGetNotificationsPreferencesQuery__
 *
 * To run a query within a React component, call `useGetNotificationsPreferencesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNotificationsPreferencesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNotificationsPreferencesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNotificationsPreferencesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables>(GetNotificationsPreferencesDocument, options);
      }
export function useGetNotificationsPreferencesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables>(GetNotificationsPreferencesDocument, options);
        }
export function useGetNotificationsPreferencesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables>(GetNotificationsPreferencesDocument, options);
        }
export type GetNotificationsPreferencesQueryHookResult = ReturnType<typeof useGetNotificationsPreferencesQuery>;
export type GetNotificationsPreferencesLazyQueryHookResult = ReturnType<typeof useGetNotificationsPreferencesLazyQuery>;
export type GetNotificationsPreferencesSuspenseQueryHookResult = ReturnType<typeof useGetNotificationsPreferencesSuspenseQuery>;
export type GetNotificationsPreferencesQueryResult = ApolloReactCommon.QueryResult<GetNotificationsPreferencesQuery, GetNotificationsPreferencesQueryVariables>;
export const UpdateSubscriptionProfileV2Document = gql`
    mutation UpdateSubscriptionProfileV2($subscriptionProfile: UpdateSubscriptionProfileInput!, $identityId: String!) {
  updateSubscriptionProfile(
    subscriptionProfile: $subscriptionProfile
    identityId: $identityId
  ) {
    emailEnabled
    emailCreditMonitoringEnabled
    emailSpendingAlertsEnabled
    emailMarketingEnabled
    emailPersonalizedContentEnabled
    pushEnabled
    pushCreditMonitoringEnabled
    pushSpendingAlertsEnabled
    pushMarketingUpdatesEnabled
    pushPersonalizedContentEnabled
  }
}
    `;
export type UpdateSubscriptionProfileV2MutationFn = ApolloReactCommon.MutationFunction<UpdateSubscriptionProfileV2Mutation, UpdateSubscriptionProfileV2MutationVariables>;
export type UpdateSubscriptionProfileV2ComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSubscriptionProfileV2Mutation, UpdateSubscriptionProfileV2MutationVariables>, 'mutation'>;

    export const UpdateSubscriptionProfileV2Component = (props: UpdateSubscriptionProfileV2ComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSubscriptionProfileV2Mutation, UpdateSubscriptionProfileV2MutationVariables> mutation={UpdateSubscriptionProfileV2Document} {...props} />
    );
    
export type UpdateSubscriptionProfileV2Props<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSubscriptionProfileV2Mutation, UpdateSubscriptionProfileV2MutationVariables>
    } & TChildProps;
export function withUpdateSubscriptionProfileV2<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSubscriptionProfileV2Mutation,
  UpdateSubscriptionProfileV2MutationVariables,
  UpdateSubscriptionProfileV2Props<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSubscriptionProfileV2Mutation, UpdateSubscriptionProfileV2MutationVariables, UpdateSubscriptionProfileV2Props<TChildProps, TDataName>>(UpdateSubscriptionProfileV2Document, {
      alias: 'updateSubscriptionProfileV2',
      ...operationOptions
    });
};

/**
 * __useUpdateSubscriptionProfileV2Mutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionProfileV2Mutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionProfileV2Mutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionProfileV2Mutation, { data, loading, error }] = useUpdateSubscriptionProfileV2Mutation({
 *   variables: {
 *      subscriptionProfile: // value for 'subscriptionProfile'
 *      identityId: // value for 'identityId'
 *   },
 * });
 */
export function useUpdateSubscriptionProfileV2Mutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionProfileV2Mutation, UpdateSubscriptionProfileV2MutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionProfileV2Mutation, UpdateSubscriptionProfileV2MutationVariables>(UpdateSubscriptionProfileV2Document, options);
      }
export type UpdateSubscriptionProfileV2MutationHookResult = ReturnType<typeof useUpdateSubscriptionProfileV2Mutation>;
export type UpdateSubscriptionProfileV2MutationResult = ApolloReactCommon.MutationResult<UpdateSubscriptionProfileV2Mutation>;
export type UpdateSubscriptionProfileV2MutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubscriptionProfileV2Mutation, UpdateSubscriptionProfileV2MutationVariables>;
export const GetUserScopesDocument = gql`
    query GetUserScopes {
  identity {
    id
    scopes
  }
}
    `;
export type GetUserScopesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserScopesQuery, GetUserScopesQueryVariables>, 'query'>;

    export const GetUserScopesComponent = (props: GetUserScopesComponentProps) => (
      <ApolloReactComponents.Query<GetUserScopesQuery, GetUserScopesQueryVariables> query={GetUserScopesDocument} {...props} />
    );
    
export type GetUserScopesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserScopesQuery, GetUserScopesQueryVariables>
    } & TChildProps;
export function withGetUserScopes<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserScopesQuery,
  GetUserScopesQueryVariables,
  GetUserScopesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserScopesQuery, GetUserScopesQueryVariables, GetUserScopesProps<TChildProps, TDataName>>(GetUserScopesDocument, {
      alias: 'getUserScopes',
      ...operationOptions
    });
};

/**
 * __useGetUserScopesQuery__
 *
 * To run a query within a React component, call `useGetUserScopesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserScopesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserScopesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserScopesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserScopesQuery, GetUserScopesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserScopesQuery, GetUserScopesQueryVariables>(GetUserScopesDocument, options);
      }
export function useGetUserScopesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserScopesQuery, GetUserScopesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserScopesQuery, GetUserScopesQueryVariables>(GetUserScopesDocument, options);
        }
export function useGetUserScopesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserScopesQuery, GetUserScopesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserScopesQuery, GetUserScopesQueryVariables>(GetUserScopesDocument, options);
        }
export type GetUserScopesQueryHookResult = ReturnType<typeof useGetUserScopesQuery>;
export type GetUserScopesLazyQueryHookResult = ReturnType<typeof useGetUserScopesLazyQuery>;
export type GetUserScopesSuspenseQueryHookResult = ReturnType<typeof useGetUserScopesSuspenseQuery>;
export type GetUserScopesQueryResult = ApolloReactCommon.QueryResult<GetUserScopesQuery, GetUserScopesQueryVariables>;
export const GetEmailAndHasPasswordDocument = gql`
    query GetEmailAndHasPassword {
  identity {
    email
    hasPassword
  }
}
    `;
export type GetEmailAndHasPasswordComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables>, 'query'>;

    export const GetEmailAndHasPasswordComponent = (props: GetEmailAndHasPasswordComponentProps) => (
      <ApolloReactComponents.Query<GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables> query={GetEmailAndHasPasswordDocument} {...props} />
    );
    
export type GetEmailAndHasPasswordProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables>
    } & TChildProps;
export function withGetEmailAndHasPassword<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetEmailAndHasPasswordQuery,
  GetEmailAndHasPasswordQueryVariables,
  GetEmailAndHasPasswordProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables, GetEmailAndHasPasswordProps<TChildProps, TDataName>>(GetEmailAndHasPasswordDocument, {
      alias: 'getEmailAndHasPassword',
      ...operationOptions
    });
};

/**
 * __useGetEmailAndHasPasswordQuery__
 *
 * To run a query within a React component, call `useGetEmailAndHasPasswordQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetEmailAndHasPasswordQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetEmailAndHasPasswordQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetEmailAndHasPasswordQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables>(GetEmailAndHasPasswordDocument, options);
      }
export function useGetEmailAndHasPasswordLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables>(GetEmailAndHasPasswordDocument, options);
        }
export function useGetEmailAndHasPasswordSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables>(GetEmailAndHasPasswordDocument, options);
        }
export type GetEmailAndHasPasswordQueryHookResult = ReturnType<typeof useGetEmailAndHasPasswordQuery>;
export type GetEmailAndHasPasswordLazyQueryHookResult = ReturnType<typeof useGetEmailAndHasPasswordLazyQuery>;
export type GetEmailAndHasPasswordSuspenseQueryHookResult = ReturnType<typeof useGetEmailAndHasPasswordSuspenseQuery>;
export type GetEmailAndHasPasswordQueryResult = ApolloReactCommon.QueryResult<GetEmailAndHasPasswordQuery, GetEmailAndHasPasswordQueryVariables>;
export const UpdateRecurlyBillingInfoDocument = gql`
    mutation UpdateRecurlyBillingInfo($token_id: String) {
  updateRecurlyBillingInfo(token_id: $token_id) {
    success
    error
  }
}
    `;
export type UpdateRecurlyBillingInfoMutationFn = ApolloReactCommon.MutationFunction<UpdateRecurlyBillingInfoMutation, UpdateRecurlyBillingInfoMutationVariables>;
export type UpdateRecurlyBillingInfoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateRecurlyBillingInfoMutation, UpdateRecurlyBillingInfoMutationVariables>, 'mutation'>;

    export const UpdateRecurlyBillingInfoComponent = (props: UpdateRecurlyBillingInfoComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateRecurlyBillingInfoMutation, UpdateRecurlyBillingInfoMutationVariables> mutation={UpdateRecurlyBillingInfoDocument} {...props} />
    );
    
export type UpdateRecurlyBillingInfoProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateRecurlyBillingInfoMutation, UpdateRecurlyBillingInfoMutationVariables>
    } & TChildProps;
export function withUpdateRecurlyBillingInfo<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateRecurlyBillingInfoMutation,
  UpdateRecurlyBillingInfoMutationVariables,
  UpdateRecurlyBillingInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateRecurlyBillingInfoMutation, UpdateRecurlyBillingInfoMutationVariables, UpdateRecurlyBillingInfoProps<TChildProps, TDataName>>(UpdateRecurlyBillingInfoDocument, {
      alias: 'updateRecurlyBillingInfo',
      ...operationOptions
    });
};

/**
 * __useUpdateRecurlyBillingInfoMutation__
 *
 * To run a mutation, you first call `useUpdateRecurlyBillingInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurlyBillingInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurlyBillingInfoMutation, { data, loading, error }] = useUpdateRecurlyBillingInfoMutation({
 *   variables: {
 *      token_id: // value for 'token_id'
 *   },
 * });
 */
export function useUpdateRecurlyBillingInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRecurlyBillingInfoMutation, UpdateRecurlyBillingInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRecurlyBillingInfoMutation, UpdateRecurlyBillingInfoMutationVariables>(UpdateRecurlyBillingInfoDocument, options);
      }
export type UpdateRecurlyBillingInfoMutationHookResult = ReturnType<typeof useUpdateRecurlyBillingInfoMutation>;
export type UpdateRecurlyBillingInfoMutationResult = ApolloReactCommon.MutationResult<UpdateRecurlyBillingInfoMutation>;
export type UpdateRecurlyBillingInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRecurlyBillingInfoMutation, UpdateRecurlyBillingInfoMutationVariables>;
export const ReactivateNwPlusSubscriptionDocument = gql`
    mutation reactivateNwPlusSubscription {
  reactivateNwPlusSubscription {
    success
    error
  }
}
    `;
export type ReactivateNwPlusSubscriptionMutationFn = ApolloReactCommon.MutationFunction<ReactivateNwPlusSubscriptionMutation, ReactivateNwPlusSubscriptionMutationVariables>;
export type ReactivateNwPlusSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ReactivateNwPlusSubscriptionMutation, ReactivateNwPlusSubscriptionMutationVariables>, 'mutation'>;

    export const ReactivateNwPlusSubscriptionComponent = (props: ReactivateNwPlusSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<ReactivateNwPlusSubscriptionMutation, ReactivateNwPlusSubscriptionMutationVariables> mutation={ReactivateNwPlusSubscriptionDocument} {...props} />
    );
    
export type ReactivateNwPlusSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ReactivateNwPlusSubscriptionMutation, ReactivateNwPlusSubscriptionMutationVariables>
    } & TChildProps;
export function withReactivateNwPlusSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReactivateNwPlusSubscriptionMutation,
  ReactivateNwPlusSubscriptionMutationVariables,
  ReactivateNwPlusSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ReactivateNwPlusSubscriptionMutation, ReactivateNwPlusSubscriptionMutationVariables, ReactivateNwPlusSubscriptionProps<TChildProps, TDataName>>(ReactivateNwPlusSubscriptionDocument, {
      alias: 'reactivateNwPlusSubscription',
      ...operationOptions
    });
};

/**
 * __useReactivateNwPlusSubscriptionMutation__
 *
 * To run a mutation, you first call `useReactivateNwPlusSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReactivateNwPlusSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reactivateNwPlusSubscriptionMutation, { data, loading, error }] = useReactivateNwPlusSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useReactivateNwPlusSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReactivateNwPlusSubscriptionMutation, ReactivateNwPlusSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReactivateNwPlusSubscriptionMutation, ReactivateNwPlusSubscriptionMutationVariables>(ReactivateNwPlusSubscriptionDocument, options);
      }
export type ReactivateNwPlusSubscriptionMutationHookResult = ReturnType<typeof useReactivateNwPlusSubscriptionMutation>;
export type ReactivateNwPlusSubscriptionMutationResult = ApolloReactCommon.MutationResult<ReactivateNwPlusSubscriptionMutation>;
export type ReactivateNwPlusSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<ReactivateNwPlusSubscriptionMutation, ReactivateNwPlusSubscriptionMutationVariables>;
export const CancelNwPlusSubscriptionDocument = gql`
    mutation cancelNwPlusSubscription {
  cancelNwPlusSubscription {
    success
    error
  }
}
    `;
export type CancelNwPlusSubscriptionMutationFn = ApolloReactCommon.MutationFunction<CancelNwPlusSubscriptionMutation, CancelNwPlusSubscriptionMutationVariables>;
export type CancelNwPlusSubscriptionComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CancelNwPlusSubscriptionMutation, CancelNwPlusSubscriptionMutationVariables>, 'mutation'>;

    export const CancelNwPlusSubscriptionComponent = (props: CancelNwPlusSubscriptionComponentProps) => (
      <ApolloReactComponents.Mutation<CancelNwPlusSubscriptionMutation, CancelNwPlusSubscriptionMutationVariables> mutation={CancelNwPlusSubscriptionDocument} {...props} />
    );
    
export type CancelNwPlusSubscriptionProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CancelNwPlusSubscriptionMutation, CancelNwPlusSubscriptionMutationVariables>
    } & TChildProps;
export function withCancelNwPlusSubscription<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CancelNwPlusSubscriptionMutation,
  CancelNwPlusSubscriptionMutationVariables,
  CancelNwPlusSubscriptionProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CancelNwPlusSubscriptionMutation, CancelNwPlusSubscriptionMutationVariables, CancelNwPlusSubscriptionProps<TChildProps, TDataName>>(CancelNwPlusSubscriptionDocument, {
      alias: 'cancelNwPlusSubscription',
      ...operationOptions
    });
};

/**
 * __useCancelNwPlusSubscriptionMutation__
 *
 * To run a mutation, you first call `useCancelNwPlusSubscriptionMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelNwPlusSubscriptionMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelNwPlusSubscriptionMutation, { data, loading, error }] = useCancelNwPlusSubscriptionMutation({
 *   variables: {
 *   },
 * });
 */
export function useCancelNwPlusSubscriptionMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CancelNwPlusSubscriptionMutation, CancelNwPlusSubscriptionMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CancelNwPlusSubscriptionMutation, CancelNwPlusSubscriptionMutationVariables>(CancelNwPlusSubscriptionDocument, options);
      }
export type CancelNwPlusSubscriptionMutationHookResult = ReturnType<typeof useCancelNwPlusSubscriptionMutation>;
export type CancelNwPlusSubscriptionMutationResult = ApolloReactCommon.MutationResult<CancelNwPlusSubscriptionMutation>;
export type CancelNwPlusSubscriptionMutationOptions = ApolloReactCommon.BaseMutationOptions<CancelNwPlusSubscriptionMutation, CancelNwPlusSubscriptionMutationVariables>;
export const UpdateRecurlyAccountAddressInfoDocument = gql`
    mutation UpdateRecurlyAccountAddressInfo($address: RecurlyAddressInput) {
  updateRecurlyAccountAddressInfo(address: $address) {
    address {
      street1
      street2
      city
      region
      postalCode
    }
  }
}
    `;
export type UpdateRecurlyAccountAddressInfoMutationFn = ApolloReactCommon.MutationFunction<UpdateRecurlyAccountAddressInfoMutation, UpdateRecurlyAccountAddressInfoMutationVariables>;
export type UpdateRecurlyAccountAddressInfoComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateRecurlyAccountAddressInfoMutation, UpdateRecurlyAccountAddressInfoMutationVariables>, 'mutation'>;

    export const UpdateRecurlyAccountAddressInfoComponent = (props: UpdateRecurlyAccountAddressInfoComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateRecurlyAccountAddressInfoMutation, UpdateRecurlyAccountAddressInfoMutationVariables> mutation={UpdateRecurlyAccountAddressInfoDocument} {...props} />
    );
    
export type UpdateRecurlyAccountAddressInfoProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateRecurlyAccountAddressInfoMutation, UpdateRecurlyAccountAddressInfoMutationVariables>
    } & TChildProps;
export function withUpdateRecurlyAccountAddressInfo<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateRecurlyAccountAddressInfoMutation,
  UpdateRecurlyAccountAddressInfoMutationVariables,
  UpdateRecurlyAccountAddressInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateRecurlyAccountAddressInfoMutation, UpdateRecurlyAccountAddressInfoMutationVariables, UpdateRecurlyAccountAddressInfoProps<TChildProps, TDataName>>(UpdateRecurlyAccountAddressInfoDocument, {
      alias: 'updateRecurlyAccountAddressInfo',
      ...operationOptions
    });
};

/**
 * __useUpdateRecurlyAccountAddressInfoMutation__
 *
 * To run a mutation, you first call `useUpdateRecurlyAccountAddressInfoMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateRecurlyAccountAddressInfoMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateRecurlyAccountAddressInfoMutation, { data, loading, error }] = useUpdateRecurlyAccountAddressInfoMutation({
 *   variables: {
 *      address: // value for 'address'
 *   },
 * });
 */
export function useUpdateRecurlyAccountAddressInfoMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateRecurlyAccountAddressInfoMutation, UpdateRecurlyAccountAddressInfoMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateRecurlyAccountAddressInfoMutation, UpdateRecurlyAccountAddressInfoMutationVariables>(UpdateRecurlyAccountAddressInfoDocument, options);
      }
export type UpdateRecurlyAccountAddressInfoMutationHookResult = ReturnType<typeof useUpdateRecurlyAccountAddressInfoMutation>;
export type UpdateRecurlyAccountAddressInfoMutationResult = ApolloReactCommon.MutationResult<UpdateRecurlyAccountAddressInfoMutation>;
export type UpdateRecurlyAccountAddressInfoMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateRecurlyAccountAddressInfoMutation, UpdateRecurlyAccountAddressInfoMutationVariables>;
export const GetNwPlusMembershipStatusDocument = gql`
    query GetNWPlusMembershipStatus {
  ...nwPlusMembershipStatusQueryFragment
}
    ${NwPlusMembershipStatusQueryFragmentFragmentDoc}`;
export type GetNwPlusMembershipStatusComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables>, 'query'>;

    export const GetNwPlusMembershipStatusComponent = (props: GetNwPlusMembershipStatusComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables> query={GetNwPlusMembershipStatusDocument} {...props} />
    );
    
export type GetNwPlusMembershipStatusProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables>
    } & TChildProps;
export function withGetNwPlusMembershipStatus<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusMembershipStatusQuery,
  GetNwPlusMembershipStatusQueryVariables,
  GetNwPlusMembershipStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables, GetNwPlusMembershipStatusProps<TChildProps, TDataName>>(GetNwPlusMembershipStatusDocument, {
      alias: 'getNwPlusMembershipStatus',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusMembershipStatusQuery__
 *
 * To run a query within a React component, call `useGetNwPlusMembershipStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusMembershipStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusMembershipStatusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusMembershipStatusQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables>(GetNwPlusMembershipStatusDocument, options);
      }
export function useGetNwPlusMembershipStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables>(GetNwPlusMembershipStatusDocument, options);
        }
export function useGetNwPlusMembershipStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables>(GetNwPlusMembershipStatusDocument, options);
        }
export type GetNwPlusMembershipStatusQueryHookResult = ReturnType<typeof useGetNwPlusMembershipStatusQuery>;
export type GetNwPlusMembershipStatusLazyQueryHookResult = ReturnType<typeof useGetNwPlusMembershipStatusLazyQuery>;
export type GetNwPlusMembershipStatusSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusMembershipStatusSuspenseQuery>;
export type GetNwPlusMembershipStatusQueryResult = ApolloReactCommon.QueryResult<GetNwPlusMembershipStatusQuery, GetNwPlusMembershipStatusQueryVariables>;
export const GetRecurlyBillingHistoryDocument = gql`
    query GetRecurlyBillingHistory {
  ...RecurlyBillingHistoryQueryFragment
}
    ${RecurlyBillingHistoryQueryFragmentFragmentDoc}`;
export type GetRecurlyBillingHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables>, 'query'>;

    export const GetRecurlyBillingHistoryComponent = (props: GetRecurlyBillingHistoryComponentProps) => (
      <ApolloReactComponents.Query<GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables> query={GetRecurlyBillingHistoryDocument} {...props} />
    );
    
export type GetRecurlyBillingHistoryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables>
    } & TChildProps;
export function withGetRecurlyBillingHistory<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRecurlyBillingHistoryQuery,
  GetRecurlyBillingHistoryQueryVariables,
  GetRecurlyBillingHistoryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables, GetRecurlyBillingHistoryProps<TChildProps, TDataName>>(GetRecurlyBillingHistoryDocument, {
      alias: 'getRecurlyBillingHistory',
      ...operationOptions
    });
};

/**
 * __useGetRecurlyBillingHistoryQuery__
 *
 * To run a query within a React component, call `useGetRecurlyBillingHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurlyBillingHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurlyBillingHistoryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecurlyBillingHistoryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables>(GetRecurlyBillingHistoryDocument, options);
      }
export function useGetRecurlyBillingHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables>(GetRecurlyBillingHistoryDocument, options);
        }
export function useGetRecurlyBillingHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables>(GetRecurlyBillingHistoryDocument, options);
        }
export type GetRecurlyBillingHistoryQueryHookResult = ReturnType<typeof useGetRecurlyBillingHistoryQuery>;
export type GetRecurlyBillingHistoryLazyQueryHookResult = ReturnType<typeof useGetRecurlyBillingHistoryLazyQuery>;
export type GetRecurlyBillingHistorySuspenseQueryHookResult = ReturnType<typeof useGetRecurlyBillingHistorySuspenseQuery>;
export type GetRecurlyBillingHistoryQueryResult = ApolloReactCommon.QueryResult<GetRecurlyBillingHistoryQuery, GetRecurlyBillingHistoryQueryVariables>;
export const GetRecurlyAccountInfoDocument = gql`
    query GetRecurlyAccountInfo {
  ...RecurlyAccountInfoQueryFragment
}
    ${RecurlyAccountInfoQueryFragmentFragmentDoc}`;
export type GetRecurlyAccountInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables>, 'query'>;

    export const GetRecurlyAccountInfoComponent = (props: GetRecurlyAccountInfoComponentProps) => (
      <ApolloReactComponents.Query<GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables> query={GetRecurlyAccountInfoDocument} {...props} />
    );
    
export type GetRecurlyAccountInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables>
    } & TChildProps;
export function withGetRecurlyAccountInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRecurlyAccountInfoQuery,
  GetRecurlyAccountInfoQueryVariables,
  GetRecurlyAccountInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables, GetRecurlyAccountInfoProps<TChildProps, TDataName>>(GetRecurlyAccountInfoDocument, {
      alias: 'getRecurlyAccountInfo',
      ...operationOptions
    });
};

/**
 * __useGetRecurlyAccountInfoQuery__
 *
 * To run a query within a React component, call `useGetRecurlyAccountInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRecurlyAccountInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRecurlyAccountInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRecurlyAccountInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables>(GetRecurlyAccountInfoDocument, options);
      }
export function useGetRecurlyAccountInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables>(GetRecurlyAccountInfoDocument, options);
        }
export function useGetRecurlyAccountInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables>(GetRecurlyAccountInfoDocument, options);
        }
export type GetRecurlyAccountInfoQueryHookResult = ReturnType<typeof useGetRecurlyAccountInfoQuery>;
export type GetRecurlyAccountInfoLazyQueryHookResult = ReturnType<typeof useGetRecurlyAccountInfoLazyQuery>;
export type GetRecurlyAccountInfoSuspenseQueryHookResult = ReturnType<typeof useGetRecurlyAccountInfoSuspenseQuery>;
export type GetRecurlyAccountInfoQueryResult = ApolloReactCommon.QueryResult<GetRecurlyAccountInfoQuery, GetRecurlyAccountInfoQueryVariables>;
export const GetAllSubscriptionManagementDataDocument = gql`
    query GetAllSubscriptionManagementData {
  ...RecurlyAccountInfoQueryFragment
  ...nwPlusMembershipStatusQueryFragment
  ...RecurlyBillingHistoryQueryFragment
}
    ${RecurlyAccountInfoQueryFragmentFragmentDoc}
${NwPlusMembershipStatusQueryFragmentFragmentDoc}
${RecurlyBillingHistoryQueryFragmentFragmentDoc}`;
export type GetAllSubscriptionManagementDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables>, 'query'>;

    export const GetAllSubscriptionManagementDataComponent = (props: GetAllSubscriptionManagementDataComponentProps) => (
      <ApolloReactComponents.Query<GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables> query={GetAllSubscriptionManagementDataDocument} {...props} />
    );
    
export type GetAllSubscriptionManagementDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables>
    } & TChildProps;
export function withGetAllSubscriptionManagementData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAllSubscriptionManagementDataQuery,
  GetAllSubscriptionManagementDataQueryVariables,
  GetAllSubscriptionManagementDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables, GetAllSubscriptionManagementDataProps<TChildProps, TDataName>>(GetAllSubscriptionManagementDataDocument, {
      alias: 'getAllSubscriptionManagementData',
      ...operationOptions
    });
};

/**
 * __useGetAllSubscriptionManagementDataQuery__
 *
 * To run a query within a React component, call `useGetAllSubscriptionManagementDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAllSubscriptionManagementDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAllSubscriptionManagementDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAllSubscriptionManagementDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables>(GetAllSubscriptionManagementDataDocument, options);
      }
export function useGetAllSubscriptionManagementDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables>(GetAllSubscriptionManagementDataDocument, options);
        }
export function useGetAllSubscriptionManagementDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables>(GetAllSubscriptionManagementDataDocument, options);
        }
export type GetAllSubscriptionManagementDataQueryHookResult = ReturnType<typeof useGetAllSubscriptionManagementDataQuery>;
export type GetAllSubscriptionManagementDataLazyQueryHookResult = ReturnType<typeof useGetAllSubscriptionManagementDataLazyQuery>;
export type GetAllSubscriptionManagementDataSuspenseQueryHookResult = ReturnType<typeof useGetAllSubscriptionManagementDataSuspenseQuery>;
export type GetAllSubscriptionManagementDataQueryResult = ApolloReactCommon.QueryResult<GetAllSubscriptionManagementDataQuery, GetAllSubscriptionManagementDataQueryVariables>;
export const GetFinancialTransactionByIdDocument = gql`
    query GetFinancialTransactionById($transactionId: ID!) {
  financialTransactionById(transactionId: $transactionId) {
    account {
      id
      name
      mask
      financialPortal {
        id
        marketplaceInstitution {
          id
          name
        }
      }
    }
    amount
    categoryId
    currency
    date
    description
    id
    isHidden
    isPending
    merchantName
    type
  }
}
    `;
export type GetFinancialTransactionByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables>, 'query'> & ({ variables: GetFinancialTransactionByIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFinancialTransactionByIdComponent = (props: GetFinancialTransactionByIdComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables> query={GetFinancialTransactionByIdDocument} {...props} />
    );
    
export type GetFinancialTransactionByIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables>
    } & TChildProps;
export function withGetFinancialTransactionById<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialTransactionByIdQuery,
  GetFinancialTransactionByIdQueryVariables,
  GetFinancialTransactionByIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables, GetFinancialTransactionByIdProps<TChildProps, TDataName>>(GetFinancialTransactionByIdDocument, {
      alias: 'getFinancialTransactionById',
      ...operationOptions
    });
};

/**
 * __useGetFinancialTransactionByIdQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionByIdQuery({
 *   variables: {
 *      transactionId: // value for 'transactionId'
 *   },
 * });
 */
export function useGetFinancialTransactionByIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables> & ({ variables: GetFinancialTransactionByIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables>(GetFinancialTransactionByIdDocument, options);
      }
export function useGetFinancialTransactionByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables>(GetFinancialTransactionByIdDocument, options);
        }
export function useGetFinancialTransactionByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables>(GetFinancialTransactionByIdDocument, options);
        }
export type GetFinancialTransactionByIdQueryHookResult = ReturnType<typeof useGetFinancialTransactionByIdQuery>;
export type GetFinancialTransactionByIdLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionByIdLazyQuery>;
export type GetFinancialTransactionByIdSuspenseQueryHookResult = ReturnType<typeof useGetFinancialTransactionByIdSuspenseQuery>;
export type GetFinancialTransactionByIdQueryResult = ApolloReactCommon.QueryResult<GetFinancialTransactionByIdQuery, GetFinancialTransactionByIdQueryVariables>;
export const FinancialTransactionsSpendingByMonthDocument = gql`
    query FinancialTransactionsSpendingByMonth($dateInStartMonth: Date!, $dateInEndMonth: Date!, $filter: FinancialTransactionsFilterInput) {
  financialTransactionsSpendingByMonth(
    dateInTargetStartMonth: $dateInStartMonth
    dateInTargetEndMonth: $dateInEndMonth
    filter: $filter
  ) {
    spendingByMonth {
      date
      amount
    }
  }
}
    `;
export type FinancialTransactionsSpendingByMonthComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables>, 'query'> & ({ variables: FinancialTransactionsSpendingByMonthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FinancialTransactionsSpendingByMonthComponent = (props: FinancialTransactionsSpendingByMonthComponentProps) => (
      <ApolloReactComponents.Query<FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables> query={FinancialTransactionsSpendingByMonthDocument} {...props} />
    );
    
export type FinancialTransactionsSpendingByMonthProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables>
    } & TChildProps;
export function withFinancialTransactionsSpendingByMonth<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FinancialTransactionsSpendingByMonthQuery,
  FinancialTransactionsSpendingByMonthQueryVariables,
  FinancialTransactionsSpendingByMonthProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables, FinancialTransactionsSpendingByMonthProps<TChildProps, TDataName>>(FinancialTransactionsSpendingByMonthDocument, {
      alias: 'financialTransactionsSpendingByMonth',
      ...operationOptions
    });
};

/**
 * __useFinancialTransactionsSpendingByMonthQuery__
 *
 * To run a query within a React component, call `useFinancialTransactionsSpendingByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialTransactionsSpendingByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialTransactionsSpendingByMonthQuery({
 *   variables: {
 *      dateInStartMonth: // value for 'dateInStartMonth'
 *      dateInEndMonth: // value for 'dateInEndMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useFinancialTransactionsSpendingByMonthQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables> & ({ variables: FinancialTransactionsSpendingByMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables>(FinancialTransactionsSpendingByMonthDocument, options);
      }
export function useFinancialTransactionsSpendingByMonthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables>(FinancialTransactionsSpendingByMonthDocument, options);
        }
export function useFinancialTransactionsSpendingByMonthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables>(FinancialTransactionsSpendingByMonthDocument, options);
        }
export type FinancialTransactionsSpendingByMonthQueryHookResult = ReturnType<typeof useFinancialTransactionsSpendingByMonthQuery>;
export type FinancialTransactionsSpendingByMonthLazyQueryHookResult = ReturnType<typeof useFinancialTransactionsSpendingByMonthLazyQuery>;
export type FinancialTransactionsSpendingByMonthSuspenseQueryHookResult = ReturnType<typeof useFinancialTransactionsSpendingByMonthSuspenseQuery>;
export type FinancialTransactionsSpendingByMonthQueryResult = ApolloReactCommon.QueryResult<FinancialTransactionsSpendingByMonthQuery, FinancialTransactionsSpendingByMonthQueryVariables>;
export const GetTransactionsDocument = gql`
    query GetTransactions($filter: FinancialTransactionsFilterInput, $pagination: AdvancedOffsetPaginationInput) {
  financialTransactions(filter: $filter, pagination: $pagination) {
    pagination {
      limit
      offset
      resultSetToken
    }
    transactions {
      account {
        id
        name
        mask
        financialPortal {
          id
          marketplaceInstitution {
            id
            name
          }
        }
      }
      amount
      category
      categoryId
      currency
      date
      description
      id
      isHidden
      isPending
      merchantName
      type
    }
  }
}
    `;
export type GetTransactionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTransactionsQuery, GetTransactionsQueryVariables>, 'query'>;

    export const GetTransactionsComponent = (props: GetTransactionsComponentProps) => (
      <ApolloReactComponents.Query<GetTransactionsQuery, GetTransactionsQueryVariables> query={GetTransactionsDocument} {...props} />
    );
    
export type GetTransactionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTransactionsQuery, GetTransactionsQueryVariables>
    } & TChildProps;
export function withGetTransactions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTransactionsQuery,
  GetTransactionsQueryVariables,
  GetTransactionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTransactionsQuery, GetTransactionsQueryVariables, GetTransactionsProps<TChildProps, TDataName>>(GetTransactionsDocument, {
      alias: 'getTransactions',
      ...operationOptions
    });
};

/**
 * __useGetTransactionsQuery__
 *
 * To run a query within a React component, call `useGetTransactionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTransactionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTransactionsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetTransactionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
      }
export function useGetTransactionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export function useGetTransactionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTransactionsQuery, GetTransactionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTransactionsQuery, GetTransactionsQueryVariables>(GetTransactionsDocument, options);
        }
export type GetTransactionsQueryHookResult = ReturnType<typeof useGetTransactionsQuery>;
export type GetTransactionsLazyQueryHookResult = ReturnType<typeof useGetTransactionsLazyQuery>;
export type GetTransactionsSuspenseQueryHookResult = ReturnType<typeof useGetTransactionsSuspenseQuery>;
export type GetTransactionsQueryResult = ApolloReactCommon.QueryResult<GetTransactionsQuery, GetTransactionsQueryVariables>;
export const HasFinancialPortalsDocument = gql`
    query HasFinancialPortals {
  linkedFinancialPortals {
    portals {
      id
    }
  }
}
    `;
export type HasFinancialPortalsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables>, 'query'>;

    export const HasFinancialPortalsComponent = (props: HasFinancialPortalsComponentProps) => (
      <ApolloReactComponents.Query<HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables> query={HasFinancialPortalsDocument} {...props} />
    );
    
export type HasFinancialPortalsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables>
    } & TChildProps;
export function withHasFinancialPortals<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HasFinancialPortalsQuery,
  HasFinancialPortalsQueryVariables,
  HasFinancialPortalsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables, HasFinancialPortalsProps<TChildProps, TDataName>>(HasFinancialPortalsDocument, {
      alias: 'hasFinancialPortals',
      ...operationOptions
    });
};

/**
 * __useHasFinancialPortalsQuery__
 *
 * To run a query within a React component, call `useHasFinancialPortalsQuery` and pass it any options that fit your needs.
 * When your component renders, `useHasFinancialPortalsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHasFinancialPortalsQuery({
 *   variables: {
 *   },
 * });
 */
export function useHasFinancialPortalsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables>(HasFinancialPortalsDocument, options);
      }
export function useHasFinancialPortalsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables>(HasFinancialPortalsDocument, options);
        }
export function useHasFinancialPortalsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables>(HasFinancialPortalsDocument, options);
        }
export type HasFinancialPortalsQueryHookResult = ReturnType<typeof useHasFinancialPortalsQuery>;
export type HasFinancialPortalsLazyQueryHookResult = ReturnType<typeof useHasFinancialPortalsLazyQuery>;
export type HasFinancialPortalsSuspenseQueryHookResult = ReturnType<typeof useHasFinancialPortalsSuspenseQuery>;
export type HasFinancialPortalsQueryResult = ApolloReactCommon.QueryResult<HasFinancialPortalsQuery, HasFinancialPortalsQueryVariables>;
export const GetIsTransactionTooltipFilterSeenDocument = gql`
    query GetIsTransactionTooltipFilterSeen {
  membershipAppActivity {
    isTransactionsFilterTooltipSeen
  }
}
    `;
export type GetIsTransactionTooltipFilterSeenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables>, 'query'>;

    export const GetIsTransactionTooltipFilterSeenComponent = (props: GetIsTransactionTooltipFilterSeenComponentProps) => (
      <ApolloReactComponents.Query<GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables> query={GetIsTransactionTooltipFilterSeenDocument} {...props} />
    );
    
export type GetIsTransactionTooltipFilterSeenProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables>
    } & TChildProps;
export function withGetIsTransactionTooltipFilterSeen<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetIsTransactionTooltipFilterSeenQuery,
  GetIsTransactionTooltipFilterSeenQueryVariables,
  GetIsTransactionTooltipFilterSeenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables, GetIsTransactionTooltipFilterSeenProps<TChildProps, TDataName>>(GetIsTransactionTooltipFilterSeenDocument, {
      alias: 'getIsTransactionTooltipFilterSeen',
      ...operationOptions
    });
};

/**
 * __useGetIsTransactionTooltipFilterSeenQuery__
 *
 * To run a query within a React component, call `useGetIsTransactionTooltipFilterSeenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsTransactionTooltipFilterSeenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsTransactionTooltipFilterSeenQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsTransactionTooltipFilterSeenQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables>(GetIsTransactionTooltipFilterSeenDocument, options);
      }
export function useGetIsTransactionTooltipFilterSeenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables>(GetIsTransactionTooltipFilterSeenDocument, options);
        }
export function useGetIsTransactionTooltipFilterSeenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables>(GetIsTransactionTooltipFilterSeenDocument, options);
        }
export type GetIsTransactionTooltipFilterSeenQueryHookResult = ReturnType<typeof useGetIsTransactionTooltipFilterSeenQuery>;
export type GetIsTransactionTooltipFilterSeenLazyQueryHookResult = ReturnType<typeof useGetIsTransactionTooltipFilterSeenLazyQuery>;
export type GetIsTransactionTooltipFilterSeenSuspenseQueryHookResult = ReturnType<typeof useGetIsTransactionTooltipFilterSeenSuspenseQuery>;
export type GetIsTransactionTooltipFilterSeenQueryResult = ApolloReactCommon.QueryResult<GetIsTransactionTooltipFilterSeenQuery, GetIsTransactionTooltipFilterSeenQueryVariables>;
export const UpdateIsTransactionsFilterTooltipSeenDocument = gql`
    mutation UpdateIsTransactionsFilterTooltipSeen($membershipAppActivity: MembershipAppActivityInput!) {
  updateMembershipAppActivity(membershipAppActivity: $membershipAppActivity) {
    isTransactionsFilterTooltipSeen
  }
}
    `;
export type UpdateIsTransactionsFilterTooltipSeenMutationFn = ApolloReactCommon.MutationFunction<UpdateIsTransactionsFilterTooltipSeenMutation, UpdateIsTransactionsFilterTooltipSeenMutationVariables>;
export type UpdateIsTransactionsFilterTooltipSeenComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateIsTransactionsFilterTooltipSeenMutation, UpdateIsTransactionsFilterTooltipSeenMutationVariables>, 'mutation'>;

    export const UpdateIsTransactionsFilterTooltipSeenComponent = (props: UpdateIsTransactionsFilterTooltipSeenComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateIsTransactionsFilterTooltipSeenMutation, UpdateIsTransactionsFilterTooltipSeenMutationVariables> mutation={UpdateIsTransactionsFilterTooltipSeenDocument} {...props} />
    );
    
export type UpdateIsTransactionsFilterTooltipSeenProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateIsTransactionsFilterTooltipSeenMutation, UpdateIsTransactionsFilterTooltipSeenMutationVariables>
    } & TChildProps;
export function withUpdateIsTransactionsFilterTooltipSeen<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateIsTransactionsFilterTooltipSeenMutation,
  UpdateIsTransactionsFilterTooltipSeenMutationVariables,
  UpdateIsTransactionsFilterTooltipSeenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateIsTransactionsFilterTooltipSeenMutation, UpdateIsTransactionsFilterTooltipSeenMutationVariables, UpdateIsTransactionsFilterTooltipSeenProps<TChildProps, TDataName>>(UpdateIsTransactionsFilterTooltipSeenDocument, {
      alias: 'updateIsTransactionsFilterTooltipSeen',
      ...operationOptions
    });
};

/**
 * __useUpdateIsTransactionsFilterTooltipSeenMutation__
 *
 * To run a mutation, you first call `useUpdateIsTransactionsFilterTooltipSeenMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateIsTransactionsFilterTooltipSeenMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateIsTransactionsFilterTooltipSeenMutation, { data, loading, error }] = useUpdateIsTransactionsFilterTooltipSeenMutation({
 *   variables: {
 *      membershipAppActivity: // value for 'membershipAppActivity'
 *   },
 * });
 */
export function useUpdateIsTransactionsFilterTooltipSeenMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateIsTransactionsFilterTooltipSeenMutation, UpdateIsTransactionsFilterTooltipSeenMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateIsTransactionsFilterTooltipSeenMutation, UpdateIsTransactionsFilterTooltipSeenMutationVariables>(UpdateIsTransactionsFilterTooltipSeenDocument, options);
      }
export type UpdateIsTransactionsFilterTooltipSeenMutationHookResult = ReturnType<typeof useUpdateIsTransactionsFilterTooltipSeenMutation>;
export type UpdateIsTransactionsFilterTooltipSeenMutationResult = ApolloReactCommon.MutationResult<UpdateIsTransactionsFilterTooltipSeenMutation>;
export type UpdateIsTransactionsFilterTooltipSeenMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateIsTransactionsFilterTooltipSeenMutation, UpdateIsTransactionsFilterTooltipSeenMutationVariables>;
export const GetInsuranceDocumentUrlDocument = gql`
    query GetInsuranceDocumentUrl($documentId: ID!) {
  insuranceDocumentUrl(documentId: $documentId) {
    success
    documentUrl
  }
}
    `;
export type GetInsuranceDocumentUrlComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables>, 'query'> & ({ variables: GetInsuranceDocumentUrlQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetInsuranceDocumentUrlComponent = (props: GetInsuranceDocumentUrlComponentProps) => (
      <ApolloReactComponents.Query<GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables> query={GetInsuranceDocumentUrlDocument} {...props} />
    );
    
export type GetInsuranceDocumentUrlProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables>
    } & TChildProps;
export function withGetInsuranceDocumentUrl<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInsuranceDocumentUrlQuery,
  GetInsuranceDocumentUrlQueryVariables,
  GetInsuranceDocumentUrlProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables, GetInsuranceDocumentUrlProps<TChildProps, TDataName>>(GetInsuranceDocumentUrlDocument, {
      alias: 'getInsuranceDocumentUrl',
      ...operationOptions
    });
};

/**
 * __useGetInsuranceDocumentUrlQuery__
 *
 * To run a query within a React component, call `useGetInsuranceDocumentUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsuranceDocumentUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsuranceDocumentUrlQuery({
 *   variables: {
 *      documentId: // value for 'documentId'
 *   },
 * });
 */
export function useGetInsuranceDocumentUrlQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables> & ({ variables: GetInsuranceDocumentUrlQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables>(GetInsuranceDocumentUrlDocument, options);
      }
export function useGetInsuranceDocumentUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables>(GetInsuranceDocumentUrlDocument, options);
        }
export function useGetInsuranceDocumentUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables>(GetInsuranceDocumentUrlDocument, options);
        }
export type GetInsuranceDocumentUrlQueryHookResult = ReturnType<typeof useGetInsuranceDocumentUrlQuery>;
export type GetInsuranceDocumentUrlLazyQueryHookResult = ReturnType<typeof useGetInsuranceDocumentUrlLazyQuery>;
export type GetInsuranceDocumentUrlSuspenseQueryHookResult = ReturnType<typeof useGetInsuranceDocumentUrlSuspenseQuery>;
export type GetInsuranceDocumentUrlQueryResult = ApolloReactCommon.QueryResult<GetInsuranceDocumentUrlQuery, GetInsuranceDocumentUrlQueryVariables>;
export const InsuranceFreePoliciesDocument = gql`
    query InsuranceFreePolicies {
  insurancePolicies {
    success
    policies {
      id
      identityId
      accountId
      policyType
      policyDurationMonths
      carrierName
      friendlyInsuranceProviderName
      totalPremiumCents
      expiryDate
      status
      effectiveDate
      renewalDate
      isExpired
      vehicles {
        make
        model
      }
      dwellings {
        address {
          fullAddress
        }
      }
      insuranceProviderLogo
      requiresReconnect
    }
  }
}
    `;
export type InsuranceFreePoliciesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables>, 'query'>;

    export const InsuranceFreePoliciesComponent = (props: InsuranceFreePoliciesComponentProps) => (
      <ApolloReactComponents.Query<InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables> query={InsuranceFreePoliciesDocument} {...props} />
    );
    
export type InsuranceFreePoliciesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables>
    } & TChildProps;
export function withInsuranceFreePolicies<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsuranceFreePoliciesQuery,
  InsuranceFreePoliciesQueryVariables,
  InsuranceFreePoliciesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables, InsuranceFreePoliciesProps<TChildProps, TDataName>>(InsuranceFreePoliciesDocument, {
      alias: 'insuranceFreePolicies',
      ...operationOptions
    });
};

/**
 * __useInsuranceFreePoliciesQuery__
 *
 * To run a query within a React component, call `useInsuranceFreePoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsuranceFreePoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsuranceFreePoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsuranceFreePoliciesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables>(InsuranceFreePoliciesDocument, options);
      }
export function useInsuranceFreePoliciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables>(InsuranceFreePoliciesDocument, options);
        }
export function useInsuranceFreePoliciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables>(InsuranceFreePoliciesDocument, options);
        }
export type InsuranceFreePoliciesQueryHookResult = ReturnType<typeof useInsuranceFreePoliciesQuery>;
export type InsuranceFreePoliciesLazyQueryHookResult = ReturnType<typeof useInsuranceFreePoliciesLazyQuery>;
export type InsuranceFreePoliciesSuspenseQueryHookResult = ReturnType<typeof useInsuranceFreePoliciesSuspenseQuery>;
export type InsuranceFreePoliciesQueryResult = ApolloReactCommon.QueryResult<InsuranceFreePoliciesQuery, InsuranceFreePoliciesQueryVariables>;
export const InsurancePolicyPageDocument = gql`
    query InsurancePolicyPage($policyId: ID!) {
  insurancePolicy(policyId: $policyId) {
    policy {
      id
      isExpired
      policyType
      updatedAt
      friendlyInsuranceProviderName
    }
  }
}
    `;
export type InsurancePolicyPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables>, 'query'> & ({ variables: InsurancePolicyPageQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InsurancePolicyPageComponent = (props: InsurancePolicyPageComponentProps) => (
      <ApolloReactComponents.Query<InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables> query={InsurancePolicyPageDocument} {...props} />
    );
    
export type InsurancePolicyPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables>
    } & TChildProps;
export function withInsurancePolicyPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsurancePolicyPageQuery,
  InsurancePolicyPageQueryVariables,
  InsurancePolicyPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables, InsurancePolicyPageProps<TChildProps, TDataName>>(InsurancePolicyPageDocument, {
      alias: 'insurancePolicyPage',
      ...operationOptions
    });
};

/**
 * __useInsurancePolicyPageQuery__
 *
 * To run a query within a React component, call `useInsurancePolicyPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsurancePolicyPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsurancePolicyPageQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useInsurancePolicyPageQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables> & ({ variables: InsurancePolicyPageQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables>(InsurancePolicyPageDocument, options);
      }
export function useInsurancePolicyPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables>(InsurancePolicyPageDocument, options);
        }
export function useInsurancePolicyPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables>(InsurancePolicyPageDocument, options);
        }
export type InsurancePolicyPageQueryHookResult = ReturnType<typeof useInsurancePolicyPageQuery>;
export type InsurancePolicyPageLazyQueryHookResult = ReturnType<typeof useInsurancePolicyPageLazyQuery>;
export type InsurancePolicyPageSuspenseQueryHookResult = ReturnType<typeof useInsurancePolicyPageSuspenseQuery>;
export type InsurancePolicyPageQueryResult = ApolloReactCommon.QueryResult<InsurancePolicyPageQuery, InsurancePolicyPageQueryVariables>;
export const GetPartialRateReportPageDataDocument = gql`
    query GetPartialRateReportPageData($policyId: ID!, $limit: Int) {
  insurancePolicyRateReport(policyId: $policyId, limit: $limit) {
    rateReport {
      rates {
        id
        annualPremium
      }
    }
  }
}
    `;
export type GetPartialRateReportPageDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables>, 'query'> & ({ variables: GetPartialRateReportPageDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetPartialRateReportPageDataComponent = (props: GetPartialRateReportPageDataComponentProps) => (
      <ApolloReactComponents.Query<GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables> query={GetPartialRateReportPageDataDocument} {...props} />
    );
    
export type GetPartialRateReportPageDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables>
    } & TChildProps;
export function withGetPartialRateReportPageData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPartialRateReportPageDataQuery,
  GetPartialRateReportPageDataQueryVariables,
  GetPartialRateReportPageDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables, GetPartialRateReportPageDataProps<TChildProps, TDataName>>(GetPartialRateReportPageDataDocument, {
      alias: 'getPartialRateReportPageData',
      ...operationOptions
    });
};

/**
 * __useGetPartialRateReportPageDataQuery__
 *
 * To run a query within a React component, call `useGetPartialRateReportPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartialRateReportPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartialRateReportPageDataQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetPartialRateReportPageDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables> & ({ variables: GetPartialRateReportPageDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables>(GetPartialRateReportPageDataDocument, options);
      }
export function useGetPartialRateReportPageDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables>(GetPartialRateReportPageDataDocument, options);
        }
export function useGetPartialRateReportPageDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables>(GetPartialRateReportPageDataDocument, options);
        }
export type GetPartialRateReportPageDataQueryHookResult = ReturnType<typeof useGetPartialRateReportPageDataQuery>;
export type GetPartialRateReportPageDataLazyQueryHookResult = ReturnType<typeof useGetPartialRateReportPageDataLazyQuery>;
export type GetPartialRateReportPageDataSuspenseQueryHookResult = ReturnType<typeof useGetPartialRateReportPageDataSuspenseQuery>;
export type GetPartialRateReportPageDataQueryResult = ApolloReactCommon.QueryResult<GetPartialRateReportPageDataQuery, GetPartialRateReportPageDataQueryVariables>;
export const GetRateReportPolicyTypeDocument = gql`
    query GetRateReportPolicyType($policyId: ID!) {
  insurancePolicy(policyId: $policyId) {
    policy {
      id
      carrierName
      monthlyPremiumCents
      policyDurationMonths
      policyType
      totalPremiumCents
    }
  }
}
    `;
export type GetRateReportPolicyTypeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables>, 'query'> & ({ variables: GetRateReportPolicyTypeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRateReportPolicyTypeComponent = (props: GetRateReportPolicyTypeComponentProps) => (
      <ApolloReactComponents.Query<GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables> query={GetRateReportPolicyTypeDocument} {...props} />
    );
    
export type GetRateReportPolicyTypeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables>
    } & TChildProps;
export function withGetRateReportPolicyType<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRateReportPolicyTypeQuery,
  GetRateReportPolicyTypeQueryVariables,
  GetRateReportPolicyTypeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables, GetRateReportPolicyTypeProps<TChildProps, TDataName>>(GetRateReportPolicyTypeDocument, {
      alias: 'getRateReportPolicyType',
      ...operationOptions
    });
};

/**
 * __useGetRateReportPolicyTypeQuery__
 *
 * To run a query within a React component, call `useGetRateReportPolicyTypeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRateReportPolicyTypeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRateReportPolicyTypeQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetRateReportPolicyTypeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables> & ({ variables: GetRateReportPolicyTypeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables>(GetRateReportPolicyTypeDocument, options);
      }
export function useGetRateReportPolicyTypeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables>(GetRateReportPolicyTypeDocument, options);
        }
export function useGetRateReportPolicyTypeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables>(GetRateReportPolicyTypeDocument, options);
        }
export type GetRateReportPolicyTypeQueryHookResult = ReturnType<typeof useGetRateReportPolicyTypeQuery>;
export type GetRateReportPolicyTypeLazyQueryHookResult = ReturnType<typeof useGetRateReportPolicyTypeLazyQuery>;
export type GetRateReportPolicyTypeSuspenseQueryHookResult = ReturnType<typeof useGetRateReportPolicyTypeSuspenseQuery>;
export type GetRateReportPolicyTypeQueryResult = ApolloReactCommon.QueryResult<GetRateReportPolicyTypeQuery, GetRateReportPolicyTypeQueryVariables>;
export const GetUserInfoActivityDocument = gql`
    query GetUserInfoActivity {
  globalIdentityProfile {
    firstName
  }
}
    `;
export type GetUserInfoActivityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables>, 'query'>;

    export const GetUserInfoActivityComponent = (props: GetUserInfoActivityComponentProps) => (
      <ApolloReactComponents.Query<GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables> query={GetUserInfoActivityDocument} {...props} />
    );
    
export type GetUserInfoActivityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables>
    } & TChildProps;
export function withGetUserInfoActivity<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetUserInfoActivityQuery,
  GetUserInfoActivityQueryVariables,
  GetUserInfoActivityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables, GetUserInfoActivityProps<TChildProps, TDataName>>(GetUserInfoActivityDocument, {
      alias: 'getUserInfoActivity',
      ...operationOptions
    });
};

/**
 * __useGetUserInfoActivityQuery__
 *
 * To run a query within a React component, call `useGetUserInfoActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserInfoActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserInfoActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUserInfoActivityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables>(GetUserInfoActivityDocument, options);
      }
export function useGetUserInfoActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables>(GetUserInfoActivityDocument, options);
        }
export function useGetUserInfoActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables>(GetUserInfoActivityDocument, options);
        }
export type GetUserInfoActivityQueryHookResult = ReturnType<typeof useGetUserInfoActivityQuery>;
export type GetUserInfoActivityLazyQueryHookResult = ReturnType<typeof useGetUserInfoActivityLazyQuery>;
export type GetUserInfoActivitySuspenseQueryHookResult = ReturnType<typeof useGetUserInfoActivitySuspenseQuery>;
export type GetUserInfoActivityQueryResult = ApolloReactCommon.QueryResult<GetUserInfoActivityQuery, GetUserInfoActivityQueryVariables>;
export const GetNwPlusCompletedEventsDocument = gql`
    query GetNwPlusCompletedEvents($filter: NwPlusRewardedCompletedEventFilter) {
  nwPlusRewardedCompletedEvents(filter: $filter) {
    eventId
    eventType
    points
    reportedAt
    category
    title
  }
}
    `;
export type GetNwPlusCompletedEventsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables>, 'query'>;

    export const GetNwPlusCompletedEventsComponent = (props: GetNwPlusCompletedEventsComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables> query={GetNwPlusCompletedEventsDocument} {...props} />
    );
    
export type GetNwPlusCompletedEventsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables>
    } & TChildProps;
export function withGetNwPlusCompletedEvents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusCompletedEventsQuery,
  GetNwPlusCompletedEventsQueryVariables,
  GetNwPlusCompletedEventsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables, GetNwPlusCompletedEventsProps<TChildProps, TDataName>>(GetNwPlusCompletedEventsDocument, {
      alias: 'getNwPlusCompletedEvents',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusCompletedEventsQuery__
 *
 * To run a query within a React component, call `useGetNwPlusCompletedEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusCompletedEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusCompletedEventsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetNwPlusCompletedEventsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables>(GetNwPlusCompletedEventsDocument, options);
      }
export function useGetNwPlusCompletedEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables>(GetNwPlusCompletedEventsDocument, options);
        }
export function useGetNwPlusCompletedEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables>(GetNwPlusCompletedEventsDocument, options);
        }
export type GetNwPlusCompletedEventsQueryHookResult = ReturnType<typeof useGetNwPlusCompletedEventsQuery>;
export type GetNwPlusCompletedEventsLazyQueryHookResult = ReturnType<typeof useGetNwPlusCompletedEventsLazyQuery>;
export type GetNwPlusCompletedEventsSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusCompletedEventsSuspenseQuery>;
export type GetNwPlusCompletedEventsQueryResult = ApolloReactCommon.QueryResult<GetNwPlusCompletedEventsQuery, GetNwPlusCompletedEventsQueryVariables>;
export const GetNwPlusUserRedeemedRewardsQueryDocument = gql`
    query GetNwPlusUserRedeemedRewardsQuery($limit: Int, $skip: Int, $order: NwPlusCompletedEventOrder, $sort: NwPlusCompletedEventSort) {
  nwPlusRedeemedRewardsHistory(
    limit: $limit
    skip: $skip
    order: $order
    sort: $sort
  ) {
    rewards {
      id
      redeemedPoints
      reportedAt
      rewardCategories
      rewardName
    }
  }
}
    `;
export type GetNwPlusUserRedeemedRewardsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables>, 'query'>;

    export const GetNwPlusUserRedeemedRewardsQueryComponent = (props: GetNwPlusUserRedeemedRewardsQueryComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables> query={GetNwPlusUserRedeemedRewardsQueryDocument} {...props} />
    );
    
export type GetNwPlusUserRedeemedRewardsQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables>
    } & TChildProps;
export function withGetNwPlusUserRedeemedRewardsQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusUserRedeemedRewardsQueryQuery,
  GetNwPlusUserRedeemedRewardsQueryQueryVariables,
  GetNwPlusUserRedeemedRewardsQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables, GetNwPlusUserRedeemedRewardsQueryProps<TChildProps, TDataName>>(GetNwPlusUserRedeemedRewardsQueryDocument, {
      alias: 'getNwPlusUserRedeemedRewardsQuery',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusUserRedeemedRewardsQueryQuery__
 *
 * To run a query within a React component, call `useGetNwPlusUserRedeemedRewardsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusUserRedeemedRewardsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusUserRedeemedRewardsQueryQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *      skip: // value for 'skip'
 *      order: // value for 'order'
 *      sort: // value for 'sort'
 *   },
 * });
 */
export function useGetNwPlusUserRedeemedRewardsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables>(GetNwPlusUserRedeemedRewardsQueryDocument, options);
      }
export function useGetNwPlusUserRedeemedRewardsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables>(GetNwPlusUserRedeemedRewardsQueryDocument, options);
        }
export function useGetNwPlusUserRedeemedRewardsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables>(GetNwPlusUserRedeemedRewardsQueryDocument, options);
        }
export type GetNwPlusUserRedeemedRewardsQueryQueryHookResult = ReturnType<typeof useGetNwPlusUserRedeemedRewardsQueryQuery>;
export type GetNwPlusUserRedeemedRewardsQueryLazyQueryHookResult = ReturnType<typeof useGetNwPlusUserRedeemedRewardsQueryLazyQuery>;
export type GetNwPlusUserRedeemedRewardsQuerySuspenseQueryHookResult = ReturnType<typeof useGetNwPlusUserRedeemedRewardsQuerySuspenseQuery>;
export type GetNwPlusUserRedeemedRewardsQueryQueryResult = ApolloReactCommon.QueryResult<GetNwPlusUserRedeemedRewardsQueryQuery, GetNwPlusUserRedeemedRewardsQueryQueryVariables>;
export const GetNwPlusRedeemableRewardsQueryDocument = gql`
    query GetNwPlusRedeemableRewardsQuery {
  nwPlusRedeemableRewards {
    rewards {
      id
      name
      price
      priority
      pictureUrl
    }
  }
}
    `;
export type GetNwPlusRedeemableRewardsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables>, 'query'>;

    export const GetNwPlusRedeemableRewardsQueryComponent = (props: GetNwPlusRedeemableRewardsQueryComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables> query={GetNwPlusRedeemableRewardsQueryDocument} {...props} />
    );
    
export type GetNwPlusRedeemableRewardsQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables>
    } & TChildProps;
export function withGetNwPlusRedeemableRewardsQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusRedeemableRewardsQueryQuery,
  GetNwPlusRedeemableRewardsQueryQueryVariables,
  GetNwPlusRedeemableRewardsQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables, GetNwPlusRedeemableRewardsQueryProps<TChildProps, TDataName>>(GetNwPlusRedeemableRewardsQueryDocument, {
      alias: 'getNwPlusRedeemableRewardsQuery',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusRedeemableRewardsQueryQuery__
 *
 * To run a query within a React component, call `useGetNwPlusRedeemableRewardsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusRedeemableRewardsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusRedeemableRewardsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusRedeemableRewardsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables>(GetNwPlusRedeemableRewardsQueryDocument, options);
      }
export function useGetNwPlusRedeemableRewardsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables>(GetNwPlusRedeemableRewardsQueryDocument, options);
        }
export function useGetNwPlusRedeemableRewardsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables>(GetNwPlusRedeemableRewardsQueryDocument, options);
        }
export type GetNwPlusRedeemableRewardsQueryQueryHookResult = ReturnType<typeof useGetNwPlusRedeemableRewardsQueryQuery>;
export type GetNwPlusRedeemableRewardsQueryLazyQueryHookResult = ReturnType<typeof useGetNwPlusRedeemableRewardsQueryLazyQuery>;
export type GetNwPlusRedeemableRewardsQuerySuspenseQueryHookResult = ReturnType<typeof useGetNwPlusRedeemableRewardsQuerySuspenseQuery>;
export type GetNwPlusRedeemableRewardsQueryQueryResult = ApolloReactCommon.QueryResult<GetNwPlusRedeemableRewardsQueryQuery, GetNwPlusRedeemableRewardsQueryQueryVariables>;
export const NwPlusReferralQueryDocument = gql`
    query NwPlusReferralQuery($eventTypes: [String!]!) {
  nwPlusReferralCode {
    referralCode
  }
  nwPlusReferralCodeStats {
    numberOfReferredUsers
  }
  rewardEventPoints(eventTypes: $eventTypes) {
    rewards {
      points
    }
  }
}
    `;
export type NwPlusReferralQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables>, 'query'> & ({ variables: NwPlusReferralQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NwPlusReferralQueryComponent = (props: NwPlusReferralQueryComponentProps) => (
      <ApolloReactComponents.Query<NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables> query={NwPlusReferralQueryDocument} {...props} />
    );
    
export type NwPlusReferralQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables>
    } & TChildProps;
export function withNwPlusReferralQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NwPlusReferralQueryQuery,
  NwPlusReferralQueryQueryVariables,
  NwPlusReferralQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables, NwPlusReferralQueryProps<TChildProps, TDataName>>(NwPlusReferralQueryDocument, {
      alias: 'nwPlusReferralQuery',
      ...operationOptions
    });
};

/**
 * __useNwPlusReferralQueryQuery__
 *
 * To run a query within a React component, call `useNwPlusReferralQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useNwPlusReferralQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNwPlusReferralQueryQuery({
 *   variables: {
 *      eventTypes: // value for 'eventTypes'
 *   },
 * });
 */
export function useNwPlusReferralQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables> & ({ variables: NwPlusReferralQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables>(NwPlusReferralQueryDocument, options);
      }
export function useNwPlusReferralQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables>(NwPlusReferralQueryDocument, options);
        }
export function useNwPlusReferralQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables>(NwPlusReferralQueryDocument, options);
        }
export type NwPlusReferralQueryQueryHookResult = ReturnType<typeof useNwPlusReferralQueryQuery>;
export type NwPlusReferralQueryLazyQueryHookResult = ReturnType<typeof useNwPlusReferralQueryLazyQuery>;
export type NwPlusReferralQuerySuspenseQueryHookResult = ReturnType<typeof useNwPlusReferralQuerySuspenseQuery>;
export type NwPlusReferralQueryQueryResult = ApolloReactCommon.QueryResult<NwPlusReferralQueryQuery, NwPlusReferralQueryQueryVariables>;
export const GetPointsQueryDocument = gql`
    query GetPointsQuery {
  nwPlusPointsSummary {
    points
    earnedYearlyPoints
  }
}
    `;
export type GetPointsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetPointsQueryQuery, GetPointsQueryQueryVariables>, 'query'>;

    export const GetPointsQueryComponent = (props: GetPointsQueryComponentProps) => (
      <ApolloReactComponents.Query<GetPointsQueryQuery, GetPointsQueryQueryVariables> query={GetPointsQueryDocument} {...props} />
    );
    
export type GetPointsQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetPointsQueryQuery, GetPointsQueryQueryVariables>
    } & TChildProps;
export function withGetPointsQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetPointsQueryQuery,
  GetPointsQueryQueryVariables,
  GetPointsQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetPointsQueryQuery, GetPointsQueryQueryVariables, GetPointsQueryProps<TChildProps, TDataName>>(GetPointsQueryDocument, {
      alias: 'getPointsQuery',
      ...operationOptions
    });
};

/**
 * __useGetPointsQueryQuery__
 *
 * To run a query within a React component, call `useGetPointsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPointsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPointsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetPointsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetPointsQueryQuery, GetPointsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetPointsQueryQuery, GetPointsQueryQueryVariables>(GetPointsQueryDocument, options);
      }
export function useGetPointsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetPointsQueryQuery, GetPointsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetPointsQueryQuery, GetPointsQueryQueryVariables>(GetPointsQueryDocument, options);
        }
export function useGetPointsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetPointsQueryQuery, GetPointsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetPointsQueryQuery, GetPointsQueryQueryVariables>(GetPointsQueryDocument, options);
        }
export type GetPointsQueryQueryHookResult = ReturnType<typeof useGetPointsQueryQuery>;
export type GetPointsQueryLazyQueryHookResult = ReturnType<typeof useGetPointsQueryLazyQuery>;
export type GetPointsQuerySuspenseQueryHookResult = ReturnType<typeof useGetPointsQuerySuspenseQuery>;
export type GetPointsQueryQueryResult = ApolloReactCommon.QueryResult<GetPointsQueryQuery, GetPointsQueryQueryVariables>;
export const GetFinancialNerdWalletPlusShoppingRewardsDocument = gql`
    query GetFinancialNerdWalletPlusShoppingRewards($filter: FinancialNwPlusRewardFilterInput, $currentDate: DateTime) {
  financialNwPlusRewards(filter: $filter, currentDate: $currentDate) {
    ...NerdwalletPlusShoppingRewardTrackerResponseFragment
  }
}
    ${NerdwalletPlusShoppingRewardTrackerResponseFragmentFragmentDoc}`;
export type GetFinancialNerdWalletPlusShoppingRewardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables>, 'query'>;

    export const GetFinancialNerdWalletPlusShoppingRewardsComponent = (props: GetFinancialNerdWalletPlusShoppingRewardsComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables> query={GetFinancialNerdWalletPlusShoppingRewardsDocument} {...props} />
    );
    
export type GetFinancialNerdWalletPlusShoppingRewardsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables>
    } & TChildProps;
export function withGetFinancialNerdWalletPlusShoppingRewards<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialNerdWalletPlusShoppingRewardsQuery,
  GetFinancialNerdWalletPlusShoppingRewardsQueryVariables,
  GetFinancialNerdWalletPlusShoppingRewardsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables, GetFinancialNerdWalletPlusShoppingRewardsProps<TChildProps, TDataName>>(GetFinancialNerdWalletPlusShoppingRewardsDocument, {
      alias: 'getFinancialNerdWalletPlusShoppingRewards',
      ...operationOptions
    });
};

/**
 * __useGetFinancialNerdWalletPlusShoppingRewardsQuery__
 *
 * To run a query within a React component, call `useGetFinancialNerdWalletPlusShoppingRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialNerdWalletPlusShoppingRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialNerdWalletPlusShoppingRewardsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      currentDate: // value for 'currentDate'
 *   },
 * });
 */
export function useGetFinancialNerdWalletPlusShoppingRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables>(GetFinancialNerdWalletPlusShoppingRewardsDocument, options);
      }
export function useGetFinancialNerdWalletPlusShoppingRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables>(GetFinancialNerdWalletPlusShoppingRewardsDocument, options);
        }
export function useGetFinancialNerdWalletPlusShoppingRewardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables>(GetFinancialNerdWalletPlusShoppingRewardsDocument, options);
        }
export type GetFinancialNerdWalletPlusShoppingRewardsQueryHookResult = ReturnType<typeof useGetFinancialNerdWalletPlusShoppingRewardsQuery>;
export type GetFinancialNerdWalletPlusShoppingRewardsLazyQueryHookResult = ReturnType<typeof useGetFinancialNerdWalletPlusShoppingRewardsLazyQuery>;
export type GetFinancialNerdWalletPlusShoppingRewardsSuspenseQueryHookResult = ReturnType<typeof useGetFinancialNerdWalletPlusShoppingRewardsSuspenseQuery>;
export type GetFinancialNerdWalletPlusShoppingRewardsQueryResult = ApolloReactCommon.QueryResult<GetFinancialNerdWalletPlusShoppingRewardsQuery, GetFinancialNerdWalletPlusShoppingRewardsQueryVariables>;
export const NwPlusUserReviewsDocument = gql`
    query nwPlusUserReviews {
  nwPlusUserReviews {
    reviews {
      userName
      userReview
    }
  }
}
    `;
export type NwPlusUserReviewsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables>, 'query'>;

    export const NwPlusUserReviewsComponent = (props: NwPlusUserReviewsComponentProps) => (
      <ApolloReactComponents.Query<NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables> query={NwPlusUserReviewsDocument} {...props} />
    );
    
export type NwPlusUserReviewsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables>
    } & TChildProps;
export function withNwPlusUserReviews<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NwPlusUserReviewsQuery,
  NwPlusUserReviewsQueryVariables,
  NwPlusUserReviewsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables, NwPlusUserReviewsProps<TChildProps, TDataName>>(NwPlusUserReviewsDocument, {
      alias: 'nwPlusUserReviews',
      ...operationOptions
    });
};

/**
 * __useNwPlusUserReviewsQuery__
 *
 * To run a query within a React component, call `useNwPlusUserReviewsQuery` and pass it any options that fit your needs.
 * When your component renders, `useNwPlusUserReviewsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNwPlusUserReviewsQuery({
 *   variables: {
 *   },
 * });
 */
export function useNwPlusUserReviewsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables>(NwPlusUserReviewsDocument, options);
      }
export function useNwPlusUserReviewsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables>(NwPlusUserReviewsDocument, options);
        }
export function useNwPlusUserReviewsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables>(NwPlusUserReviewsDocument, options);
        }
export type NwPlusUserReviewsQueryHookResult = ReturnType<typeof useNwPlusUserReviewsQuery>;
export type NwPlusUserReviewsLazyQueryHookResult = ReturnType<typeof useNwPlusUserReviewsLazyQuery>;
export type NwPlusUserReviewsSuspenseQueryHookResult = ReturnType<typeof useNwPlusUserReviewsSuspenseQuery>;
export type NwPlusUserReviewsQueryResult = ApolloReactCommon.QueryResult<NwPlusUserReviewsQuery, NwPlusUserReviewsQueryVariables>;
export const GetWllMicrositeCashUrlDocument = gql`
    query GetWllMicrositeCashUrl {
  wllMicrositeUrl
}
    `;
export type GetWllMicrositeCashUrlComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables>, 'query'>;

    export const GetWllMicrositeCashUrlComponent = (props: GetWllMicrositeCashUrlComponentProps) => (
      <ApolloReactComponents.Query<GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables> query={GetWllMicrositeCashUrlDocument} {...props} />
    );
    
export type GetWllMicrositeCashUrlProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables>
    } & TChildProps;
export function withGetWllMicrositeCashUrl<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetWllMicrositeCashUrlQuery,
  GetWllMicrositeCashUrlQueryVariables,
  GetWllMicrositeCashUrlProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables, GetWllMicrositeCashUrlProps<TChildProps, TDataName>>(GetWllMicrositeCashUrlDocument, {
      alias: 'getWllMicrositeCashUrl',
      ...operationOptions
    });
};

/**
 * __useGetWllMicrositeCashUrlQuery__
 *
 * To run a query within a React component, call `useGetWllMicrositeCashUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWllMicrositeCashUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWllMicrositeCashUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWllMicrositeCashUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables>(GetWllMicrositeCashUrlDocument, options);
      }
export function useGetWllMicrositeCashUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables>(GetWllMicrositeCashUrlDocument, options);
        }
export function useGetWllMicrositeCashUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables>(GetWllMicrositeCashUrlDocument, options);
        }
export type GetWllMicrositeCashUrlQueryHookResult = ReturnType<typeof useGetWllMicrositeCashUrlQuery>;
export type GetWllMicrositeCashUrlLazyQueryHookResult = ReturnType<typeof useGetWllMicrositeCashUrlLazyQuery>;
export type GetWllMicrositeCashUrlSuspenseQueryHookResult = ReturnType<typeof useGetWllMicrositeCashUrlSuspenseQuery>;
export type GetWllMicrositeCashUrlQueryResult = ApolloReactCommon.QueryResult<GetWllMicrositeCashUrlQuery, GetWllMicrositeCashUrlQueryVariables>;
export const NwPlusPurchaseRewardDocument = gql`
    mutation nwPlusPurchaseReward($rewardId: String!) {
  nwPlusPurchaseReward(rewardId: $rewardId) {
    benefit {
      id
      type
      createdAt
      redeemedAt
    }
    status
  }
}
    `;
export type NwPlusPurchaseRewardMutationFn = ApolloReactCommon.MutationFunction<NwPlusPurchaseRewardMutation, NwPlusPurchaseRewardMutationVariables>;
export type NwPlusPurchaseRewardComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<NwPlusPurchaseRewardMutation, NwPlusPurchaseRewardMutationVariables>, 'mutation'>;

    export const NwPlusPurchaseRewardComponent = (props: NwPlusPurchaseRewardComponentProps) => (
      <ApolloReactComponents.Mutation<NwPlusPurchaseRewardMutation, NwPlusPurchaseRewardMutationVariables> mutation={NwPlusPurchaseRewardDocument} {...props} />
    );
    
export type NwPlusPurchaseRewardProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<NwPlusPurchaseRewardMutation, NwPlusPurchaseRewardMutationVariables>
    } & TChildProps;
export function withNwPlusPurchaseReward<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NwPlusPurchaseRewardMutation,
  NwPlusPurchaseRewardMutationVariables,
  NwPlusPurchaseRewardProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, NwPlusPurchaseRewardMutation, NwPlusPurchaseRewardMutationVariables, NwPlusPurchaseRewardProps<TChildProps, TDataName>>(NwPlusPurchaseRewardDocument, {
      alias: 'nwPlusPurchaseReward',
      ...operationOptions
    });
};

/**
 * __useNwPlusPurchaseRewardMutation__
 *
 * To run a mutation, you first call `useNwPlusPurchaseRewardMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNwPlusPurchaseRewardMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [nwPlusPurchaseRewardMutation, { data, loading, error }] = useNwPlusPurchaseRewardMutation({
 *   variables: {
 *      rewardId: // value for 'rewardId'
 *   },
 * });
 */
export function useNwPlusPurchaseRewardMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NwPlusPurchaseRewardMutation, NwPlusPurchaseRewardMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NwPlusPurchaseRewardMutation, NwPlusPurchaseRewardMutationVariables>(NwPlusPurchaseRewardDocument, options);
      }
export type NwPlusPurchaseRewardMutationHookResult = ReturnType<typeof useNwPlusPurchaseRewardMutation>;
export type NwPlusPurchaseRewardMutationResult = ApolloReactCommon.MutationResult<NwPlusPurchaseRewardMutation>;
export type NwPlusPurchaseRewardMutationOptions = ApolloReactCommon.BaseMutationOptions<NwPlusPurchaseRewardMutation, NwPlusPurchaseRewardMutationVariables>;
export const GetNwPlusRedeemableRewardsPageDocument = gql`
    query GetNwPlusRedeemableRewardsPage {
  nwPlusRedeemableRewards {
    rewards {
      id
      name
      price
      priority
      pictureUrl
      type
      description
      detailPictureUrl
      terms
    }
  }
}
    `;
export type GetNwPlusRedeemableRewardsPageComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables>, 'query'>;

    export const GetNwPlusRedeemableRewardsPageComponent = (props: GetNwPlusRedeemableRewardsPageComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables> query={GetNwPlusRedeemableRewardsPageDocument} {...props} />
    );
    
export type GetNwPlusRedeemableRewardsPageProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables>
    } & TChildProps;
export function withGetNwPlusRedeemableRewardsPage<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusRedeemableRewardsPageQuery,
  GetNwPlusRedeemableRewardsPageQueryVariables,
  GetNwPlusRedeemableRewardsPageProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables, GetNwPlusRedeemableRewardsPageProps<TChildProps, TDataName>>(GetNwPlusRedeemableRewardsPageDocument, {
      alias: 'getNwPlusRedeemableRewardsPage',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusRedeemableRewardsPageQuery__
 *
 * To run a query within a React component, call `useGetNwPlusRedeemableRewardsPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusRedeemableRewardsPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusRedeemableRewardsPageQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusRedeemableRewardsPageQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables>(GetNwPlusRedeemableRewardsPageDocument, options);
      }
export function useGetNwPlusRedeemableRewardsPageLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables>(GetNwPlusRedeemableRewardsPageDocument, options);
        }
export function useGetNwPlusRedeemableRewardsPageSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables>(GetNwPlusRedeemableRewardsPageDocument, options);
        }
export type GetNwPlusRedeemableRewardsPageQueryHookResult = ReturnType<typeof useGetNwPlusRedeemableRewardsPageQuery>;
export type GetNwPlusRedeemableRewardsPageLazyQueryHookResult = ReturnType<typeof useGetNwPlusRedeemableRewardsPageLazyQuery>;
export type GetNwPlusRedeemableRewardsPageSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusRedeemableRewardsPageSuspenseQuery>;
export type GetNwPlusRedeemableRewardsPageQueryResult = ApolloReactCommon.QueryResult<GetNwPlusRedeemableRewardsPageQuery, GetNwPlusRedeemableRewardsPageQueryVariables>;
export const GetWllMicrositeRewardsUrlDocument = gql`
    query GetWllMicrositeRewardsUrl {
  wllMicrositeUrl
}
    `;
export type GetWllMicrositeRewardsUrlComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables>, 'query'>;

    export const GetWllMicrositeRewardsUrlComponent = (props: GetWllMicrositeRewardsUrlComponentProps) => (
      <ApolloReactComponents.Query<GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables> query={GetWllMicrositeRewardsUrlDocument} {...props} />
    );
    
export type GetWllMicrositeRewardsUrlProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables>
    } & TChildProps;
export function withGetWllMicrositeRewardsUrl<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetWllMicrositeRewardsUrlQuery,
  GetWllMicrositeRewardsUrlQueryVariables,
  GetWllMicrositeRewardsUrlProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables, GetWllMicrositeRewardsUrlProps<TChildProps, TDataName>>(GetWllMicrositeRewardsUrlDocument, {
      alias: 'getWllMicrositeRewardsUrl',
      ...operationOptions
    });
};

/**
 * __useGetWllMicrositeRewardsUrlQuery__
 *
 * To run a query within a React component, call `useGetWllMicrositeRewardsUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWllMicrositeRewardsUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWllMicrositeRewardsUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetWllMicrositeRewardsUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables>(GetWllMicrositeRewardsUrlDocument, options);
      }
export function useGetWllMicrositeRewardsUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables>(GetWllMicrositeRewardsUrlDocument, options);
        }
export function useGetWllMicrositeRewardsUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables>(GetWllMicrositeRewardsUrlDocument, options);
        }
export type GetWllMicrositeRewardsUrlQueryHookResult = ReturnType<typeof useGetWllMicrositeRewardsUrlQuery>;
export type GetWllMicrositeRewardsUrlLazyQueryHookResult = ReturnType<typeof useGetWllMicrositeRewardsUrlLazyQuery>;
export type GetWllMicrositeRewardsUrlSuspenseQueryHookResult = ReturnType<typeof useGetWllMicrositeRewardsUrlSuspenseQuery>;
export type GetWllMicrositeRewardsUrlQueryResult = ApolloReactCommon.QueryResult<GetWllMicrositeRewardsUrlQuery, GetWllMicrositeRewardsUrlQueryVariables>;
export const GetNwPlusUserQualifiedRewardsQueryDocument = gql`
    query GetNwPlusUserQualifiedRewardsQuery {
  nwPlusUserQualifiedRewards {
    allRewards {
      ...QualifiedReward
    }
    featuredRewards {
      ...QualifiedReward
    }
  }
}
    ${QualifiedRewardFragmentDoc}`;
export type GetNwPlusUserQualifiedRewardsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables>, 'query'>;

    export const GetNwPlusUserQualifiedRewardsQueryComponent = (props: GetNwPlusUserQualifiedRewardsQueryComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables> query={GetNwPlusUserQualifiedRewardsQueryDocument} {...props} />
    );
    
export type GetNwPlusUserQualifiedRewardsQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables>
    } & TChildProps;
export function withGetNwPlusUserQualifiedRewardsQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusUserQualifiedRewardsQueryQuery,
  GetNwPlusUserQualifiedRewardsQueryQueryVariables,
  GetNwPlusUserQualifiedRewardsQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables, GetNwPlusUserQualifiedRewardsQueryProps<TChildProps, TDataName>>(GetNwPlusUserQualifiedRewardsQueryDocument, {
      alias: 'getNwPlusUserQualifiedRewardsQuery',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusUserQualifiedRewardsQueryQuery__
 *
 * To run a query within a React component, call `useGetNwPlusUserQualifiedRewardsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusUserQualifiedRewardsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusUserQualifiedRewardsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusUserQualifiedRewardsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables>(GetNwPlusUserQualifiedRewardsQueryDocument, options);
      }
export function useGetNwPlusUserQualifiedRewardsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables>(GetNwPlusUserQualifiedRewardsQueryDocument, options);
        }
export function useGetNwPlusUserQualifiedRewardsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables>(GetNwPlusUserQualifiedRewardsQueryDocument, options);
        }
export type GetNwPlusUserQualifiedRewardsQueryQueryHookResult = ReturnType<typeof useGetNwPlusUserQualifiedRewardsQueryQuery>;
export type GetNwPlusUserQualifiedRewardsQueryLazyQueryHookResult = ReturnType<typeof useGetNwPlusUserQualifiedRewardsQueryLazyQuery>;
export type GetNwPlusUserQualifiedRewardsQuerySuspenseQueryHookResult = ReturnType<typeof useGetNwPlusUserQualifiedRewardsQuerySuspenseQuery>;
export type GetNwPlusUserQualifiedRewardsQueryQueryResult = ApolloReactCommon.QueryResult<GetNwPlusUserQualifiedRewardsQueryQuery, GetNwPlusUserQualifiedRewardsQueryQueryVariables>;
export const GetNwPlusPerkRewardsOfferDocument = gql`
    query GetNwPlusPerkRewardsOffer($marketplaceId: ID!) {
  marketplaceEntityV2(id: $marketplaceId) {
    id
    ... on NerdwalletPlusOfferV2 {
      applyLink
      productType
      entityType
      name
    }
  }
}
    `;
export type GetNwPlusPerkRewardsOfferComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables>, 'query'> & ({ variables: GetNwPlusPerkRewardsOfferQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNwPlusPerkRewardsOfferComponent = (props: GetNwPlusPerkRewardsOfferComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables> query={GetNwPlusPerkRewardsOfferDocument} {...props} />
    );
    
export type GetNwPlusPerkRewardsOfferProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables>
    } & TChildProps;
export function withGetNwPlusPerkRewardsOffer<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusPerkRewardsOfferQuery,
  GetNwPlusPerkRewardsOfferQueryVariables,
  GetNwPlusPerkRewardsOfferProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables, GetNwPlusPerkRewardsOfferProps<TChildProps, TDataName>>(GetNwPlusPerkRewardsOfferDocument, {
      alias: 'getNwPlusPerkRewardsOffer',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusPerkRewardsOfferQuery__
 *
 * To run a query within a React component, call `useGetNwPlusPerkRewardsOfferQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusPerkRewardsOfferQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusPerkRewardsOfferQuery({
 *   variables: {
 *      marketplaceId: // value for 'marketplaceId'
 *   },
 * });
 */
export function useGetNwPlusPerkRewardsOfferQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables> & ({ variables: GetNwPlusPerkRewardsOfferQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables>(GetNwPlusPerkRewardsOfferDocument, options);
      }
export function useGetNwPlusPerkRewardsOfferLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables>(GetNwPlusPerkRewardsOfferDocument, options);
        }
export function useGetNwPlusPerkRewardsOfferSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables>(GetNwPlusPerkRewardsOfferDocument, options);
        }
export type GetNwPlusPerkRewardsOfferQueryHookResult = ReturnType<typeof useGetNwPlusPerkRewardsOfferQuery>;
export type GetNwPlusPerkRewardsOfferLazyQueryHookResult = ReturnType<typeof useGetNwPlusPerkRewardsOfferLazyQuery>;
export type GetNwPlusPerkRewardsOfferSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusPerkRewardsOfferSuspenseQuery>;
export type GetNwPlusPerkRewardsOfferQueryResult = ApolloReactCommon.QueryResult<GetNwPlusPerkRewardsOfferQuery, GetNwPlusPerkRewardsOfferQueryVariables>;
export const GetNwPlusDashboardDataDocument = gql`
    query GetNwPlusDashboardData {
  identity {
    roles
    isNerdWalletPlusMember
  }
  globalIdentityProfile {
    firstName
  }
  membershipAppActivity {
    nwPlusMaxEarnedPointsModalDismissedAt
  }
  nwPlusPredictions {
    pointsEarnPrediction {
      overallSummary {
        type
        summary {
          remainingPoints
        }
      }
    }
  }
  nwPlusPointsSummary {
    points
    earnedYearlyPoints
  }
}
    `;
export type GetNwPlusDashboardDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables>, 'query'>;

    export const GetNwPlusDashboardDataComponent = (props: GetNwPlusDashboardDataComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables> query={GetNwPlusDashboardDataDocument} {...props} />
    );
    
export type GetNwPlusDashboardDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables>
    } & TChildProps;
export function withGetNwPlusDashboardData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusDashboardDataQuery,
  GetNwPlusDashboardDataQueryVariables,
  GetNwPlusDashboardDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables, GetNwPlusDashboardDataProps<TChildProps, TDataName>>(GetNwPlusDashboardDataDocument, {
      alias: 'getNwPlusDashboardData',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusDashboardDataQuery__
 *
 * To run a query within a React component, call `useGetNwPlusDashboardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusDashboardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusDashboardDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusDashboardDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables>(GetNwPlusDashboardDataDocument, options);
      }
export function useGetNwPlusDashboardDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables>(GetNwPlusDashboardDataDocument, options);
        }
export function useGetNwPlusDashboardDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables>(GetNwPlusDashboardDataDocument, options);
        }
export type GetNwPlusDashboardDataQueryHookResult = ReturnType<typeof useGetNwPlusDashboardDataQuery>;
export type GetNwPlusDashboardDataLazyQueryHookResult = ReturnType<typeof useGetNwPlusDashboardDataLazyQuery>;
export type GetNwPlusDashboardDataSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusDashboardDataSuspenseQuery>;
export type GetNwPlusDashboardDataQueryResult = ApolloReactCommon.QueryResult<GetNwPlusDashboardDataQuery, GetNwPlusDashboardDataQueryVariables>;
export const GetNwPlusMonthlyCreditCardPaymentInfoDocument = gql`
    query GetNwPlusMonthlyCreditCardPaymentInfo {
  nwPlusMonthlyCreditCardPaymentInfo {
    creditCardAccounts {
      id
      name
      mask
    }
    creditCardSelectedAccountId
  }
}
    `;
export type GetNwPlusMonthlyCreditCardPaymentInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables>, 'query'>;

    export const GetNwPlusMonthlyCreditCardPaymentInfoComponent = (props: GetNwPlusMonthlyCreditCardPaymentInfoComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables> query={GetNwPlusMonthlyCreditCardPaymentInfoDocument} {...props} />
    );
    
export type GetNwPlusMonthlyCreditCardPaymentInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables>
    } & TChildProps;
export function withGetNwPlusMonthlyCreditCardPaymentInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusMonthlyCreditCardPaymentInfoQuery,
  GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables,
  GetNwPlusMonthlyCreditCardPaymentInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables, GetNwPlusMonthlyCreditCardPaymentInfoProps<TChildProps, TDataName>>(GetNwPlusMonthlyCreditCardPaymentInfoDocument, {
      alias: 'getNwPlusMonthlyCreditCardPaymentInfo',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusMonthlyCreditCardPaymentInfoQuery__
 *
 * To run a query within a React component, call `useGetNwPlusMonthlyCreditCardPaymentInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusMonthlyCreditCardPaymentInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusMonthlyCreditCardPaymentInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusMonthlyCreditCardPaymentInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables>(GetNwPlusMonthlyCreditCardPaymentInfoDocument, options);
      }
export function useGetNwPlusMonthlyCreditCardPaymentInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables>(GetNwPlusMonthlyCreditCardPaymentInfoDocument, options);
        }
export function useGetNwPlusMonthlyCreditCardPaymentInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables>(GetNwPlusMonthlyCreditCardPaymentInfoDocument, options);
        }
export type GetNwPlusMonthlyCreditCardPaymentInfoQueryHookResult = ReturnType<typeof useGetNwPlusMonthlyCreditCardPaymentInfoQuery>;
export type GetNwPlusMonthlyCreditCardPaymentInfoLazyQueryHookResult = ReturnType<typeof useGetNwPlusMonthlyCreditCardPaymentInfoLazyQuery>;
export type GetNwPlusMonthlyCreditCardPaymentInfoSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusMonthlyCreditCardPaymentInfoSuspenseQuery>;
export type GetNwPlusMonthlyCreditCardPaymentInfoQueryResult = ApolloReactCommon.QueryResult<GetNwPlusMonthlyCreditCardPaymentInfoQuery, GetNwPlusMonthlyCreditCardPaymentInfoQueryVariables>;
export const UpdateCreditCardForMonitoringDocument = gql`
    mutation UpdateCreditCardForMonitoring($membershipAppActivity: MembershipAppActivityInput!) {
  updateMembershipAppActivity(membershipAppActivity: $membershipAppActivity) {
    nwPlusRewards
  }
}
    `;
export type UpdateCreditCardForMonitoringMutationFn = ApolloReactCommon.MutationFunction<UpdateCreditCardForMonitoringMutation, UpdateCreditCardForMonitoringMutationVariables>;
export type UpdateCreditCardForMonitoringComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateCreditCardForMonitoringMutation, UpdateCreditCardForMonitoringMutationVariables>, 'mutation'>;

    export const UpdateCreditCardForMonitoringComponent = (props: UpdateCreditCardForMonitoringComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateCreditCardForMonitoringMutation, UpdateCreditCardForMonitoringMutationVariables> mutation={UpdateCreditCardForMonitoringDocument} {...props} />
    );
    
export type UpdateCreditCardForMonitoringProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateCreditCardForMonitoringMutation, UpdateCreditCardForMonitoringMutationVariables>
    } & TChildProps;
export function withUpdateCreditCardForMonitoring<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateCreditCardForMonitoringMutation,
  UpdateCreditCardForMonitoringMutationVariables,
  UpdateCreditCardForMonitoringProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateCreditCardForMonitoringMutation, UpdateCreditCardForMonitoringMutationVariables, UpdateCreditCardForMonitoringProps<TChildProps, TDataName>>(UpdateCreditCardForMonitoringDocument, {
      alias: 'updateCreditCardForMonitoring',
      ...operationOptions
    });
};

/**
 * __useUpdateCreditCardForMonitoringMutation__
 *
 * To run a mutation, you first call `useUpdateCreditCardForMonitoringMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateCreditCardForMonitoringMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateCreditCardForMonitoringMutation, { data, loading, error }] = useUpdateCreditCardForMonitoringMutation({
 *   variables: {
 *      membershipAppActivity: // value for 'membershipAppActivity'
 *   },
 * });
 */
export function useUpdateCreditCardForMonitoringMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateCreditCardForMonitoringMutation, UpdateCreditCardForMonitoringMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateCreditCardForMonitoringMutation, UpdateCreditCardForMonitoringMutationVariables>(UpdateCreditCardForMonitoringDocument, options);
      }
export type UpdateCreditCardForMonitoringMutationHookResult = ReturnType<typeof useUpdateCreditCardForMonitoringMutation>;
export type UpdateCreditCardForMonitoringMutationResult = ApolloReactCommon.MutationResult<UpdateCreditCardForMonitoringMutation>;
export type UpdateCreditCardForMonitoringMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateCreditCardForMonitoringMutation, UpdateCreditCardForMonitoringMutationVariables>;
export const GetNerdWalletPlusCheckoutUserInfoDocument = gql`
    query GetNerdWalletPlusCheckoutUserInfo {
  identity {
    email
    id
  }
  globalIdentityProfile {
    firstName
    lastName
  }
}
    `;
export type GetNerdWalletPlusCheckoutUserInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables>, 'query'>;

    export const GetNerdWalletPlusCheckoutUserInfoComponent = (props: GetNerdWalletPlusCheckoutUserInfoComponentProps) => (
      <ApolloReactComponents.Query<GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables> query={GetNerdWalletPlusCheckoutUserInfoDocument} {...props} />
    );
    
export type GetNerdWalletPlusCheckoutUserInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables>
    } & TChildProps;
export function withGetNerdWalletPlusCheckoutUserInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNerdWalletPlusCheckoutUserInfoQuery,
  GetNerdWalletPlusCheckoutUserInfoQueryVariables,
  GetNerdWalletPlusCheckoutUserInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables, GetNerdWalletPlusCheckoutUserInfoProps<TChildProps, TDataName>>(GetNerdWalletPlusCheckoutUserInfoDocument, {
      alias: 'getNerdWalletPlusCheckoutUserInfo',
      ...operationOptions
    });
};

/**
 * __useGetNerdWalletPlusCheckoutUserInfoQuery__
 *
 * To run a query within a React component, call `useGetNerdWalletPlusCheckoutUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNerdWalletPlusCheckoutUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNerdWalletPlusCheckoutUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNerdWalletPlusCheckoutUserInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables>(GetNerdWalletPlusCheckoutUserInfoDocument, options);
      }
export function useGetNerdWalletPlusCheckoutUserInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables>(GetNerdWalletPlusCheckoutUserInfoDocument, options);
        }
export function useGetNerdWalletPlusCheckoutUserInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables>(GetNerdWalletPlusCheckoutUserInfoDocument, options);
        }
export type GetNerdWalletPlusCheckoutUserInfoQueryHookResult = ReturnType<typeof useGetNerdWalletPlusCheckoutUserInfoQuery>;
export type GetNerdWalletPlusCheckoutUserInfoLazyQueryHookResult = ReturnType<typeof useGetNerdWalletPlusCheckoutUserInfoLazyQuery>;
export type GetNerdWalletPlusCheckoutUserInfoSuspenseQueryHookResult = ReturnType<typeof useGetNerdWalletPlusCheckoutUserInfoSuspenseQuery>;
export type GetNerdWalletPlusCheckoutUserInfoQueryResult = ApolloReactCommon.QueryResult<GetNerdWalletPlusCheckoutUserInfoQuery, GetNerdWalletPlusCheckoutUserInfoQueryVariables>;
export const CreateRecurlyPurchaseDocument = gql`
    mutation CreateRecurlyPurchase($tokenId: String!, $anonymousId: String, $firstName: String, $lastName: String, $referralCode: String, $couponCodes: [String], $autoRenew: Boolean, $mailingAddress: RecurlyAddressInput) {
  createRecurlyPurchase(
    tokenId: $tokenId
    anonymousId: $anonymousId
    firstName: $firstName
    lastName: $lastName
    referralCode: $referralCode
    couponCodes: $couponCodes
    autoRenew: $autoRenew
    mailingAddress: $mailingAddress
  ) {
    id
    success
    error
    referralSucceeded
  }
}
    `;
export type CreateRecurlyPurchaseMutationFn = ApolloReactCommon.MutationFunction<CreateRecurlyPurchaseMutation, CreateRecurlyPurchaseMutationVariables>;
export type CreateRecurlyPurchaseComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateRecurlyPurchaseMutation, CreateRecurlyPurchaseMutationVariables>, 'mutation'>;

    export const CreateRecurlyPurchaseComponent = (props: CreateRecurlyPurchaseComponentProps) => (
      <ApolloReactComponents.Mutation<CreateRecurlyPurchaseMutation, CreateRecurlyPurchaseMutationVariables> mutation={CreateRecurlyPurchaseDocument} {...props} />
    );
    
export type CreateRecurlyPurchaseProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateRecurlyPurchaseMutation, CreateRecurlyPurchaseMutationVariables>
    } & TChildProps;
export function withCreateRecurlyPurchase<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateRecurlyPurchaseMutation,
  CreateRecurlyPurchaseMutationVariables,
  CreateRecurlyPurchaseProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateRecurlyPurchaseMutation, CreateRecurlyPurchaseMutationVariables, CreateRecurlyPurchaseProps<TChildProps, TDataName>>(CreateRecurlyPurchaseDocument, {
      alias: 'createRecurlyPurchase',
      ...operationOptions
    });
};

/**
 * __useCreateRecurlyPurchaseMutation__
 *
 * To run a mutation, you first call `useCreateRecurlyPurchaseMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateRecurlyPurchaseMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createRecurlyPurchaseMutation, { data, loading, error }] = useCreateRecurlyPurchaseMutation({
 *   variables: {
 *      tokenId: // value for 'tokenId'
 *      anonymousId: // value for 'anonymousId'
 *      firstName: // value for 'firstName'
 *      lastName: // value for 'lastName'
 *      referralCode: // value for 'referralCode'
 *      couponCodes: // value for 'couponCodes'
 *      autoRenew: // value for 'autoRenew'
 *      mailingAddress: // value for 'mailingAddress'
 *   },
 * });
 */
export function useCreateRecurlyPurchaseMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateRecurlyPurchaseMutation, CreateRecurlyPurchaseMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateRecurlyPurchaseMutation, CreateRecurlyPurchaseMutationVariables>(CreateRecurlyPurchaseDocument, options);
      }
export type CreateRecurlyPurchaseMutationHookResult = ReturnType<typeof useCreateRecurlyPurchaseMutation>;
export type CreateRecurlyPurchaseMutationResult = ApolloReactCommon.MutationResult<CreateRecurlyPurchaseMutation>;
export type CreateRecurlyPurchaseMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateRecurlyPurchaseMutation, CreateRecurlyPurchaseMutationVariables>;
export const RateReportsForPolicyTileDocument = gql`
    query RateReportsForPolicyTile($limit: Int) {
  insurancePoliciesRateReports(limit: $limit) {
    rateReports {
      policyId
      rates {
        id
        annualPremium
      }
    }
  }
}
    `;
export type RateReportsForPolicyTileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables>, 'query'>;

    export const RateReportsForPolicyTileComponent = (props: RateReportsForPolicyTileComponentProps) => (
      <ApolloReactComponents.Query<RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables> query={RateReportsForPolicyTileDocument} {...props} />
    );
    
export type RateReportsForPolicyTileProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables>
    } & TChildProps;
export function withRateReportsForPolicyTile<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RateReportsForPolicyTileQuery,
  RateReportsForPolicyTileQueryVariables,
  RateReportsForPolicyTileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables, RateReportsForPolicyTileProps<TChildProps, TDataName>>(RateReportsForPolicyTileDocument, {
      alias: 'rateReportsForPolicyTile',
      ...operationOptions
    });
};

/**
 * __useRateReportsForPolicyTileQuery__
 *
 * To run a query within a React component, call `useRateReportsForPolicyTileQuery` and pass it any options that fit your needs.
 * When your component renders, `useRateReportsForPolicyTileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRateReportsForPolicyTileQuery({
 *   variables: {
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useRateReportsForPolicyTileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables>(RateReportsForPolicyTileDocument, options);
      }
export function useRateReportsForPolicyTileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables>(RateReportsForPolicyTileDocument, options);
        }
export function useRateReportsForPolicyTileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables>(RateReportsForPolicyTileDocument, options);
        }
export type RateReportsForPolicyTileQueryHookResult = ReturnType<typeof useRateReportsForPolicyTileQuery>;
export type RateReportsForPolicyTileLazyQueryHookResult = ReturnType<typeof useRateReportsForPolicyTileLazyQuery>;
export type RateReportsForPolicyTileSuspenseQueryHookResult = ReturnType<typeof useRateReportsForPolicyTileSuspenseQuery>;
export type RateReportsForPolicyTileQueryResult = ApolloReactCommon.QueryResult<RateReportsForPolicyTileQuery, RateReportsForPolicyTileQueryVariables>;
export const GetWpArticleByIdDocument = gql`
    query GetWpArticleById($input: PostItemInput, $sizes: [MediaItemImageSizeEnum!]) {
  article(input: $input) {
    id
    title
    synopsis
    link
    featuredMedia {
      altText
      croppedImages(sizes: $sizes) {
        file
        height
        size
        sourceUrl
        width
      }
    }
    authors {
      id
      link
      name
      avatarUrls {
        size
        url
      }
    }
  }
}
    `;
export type GetWpArticleByIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables>, 'query'>;

    export const GetWpArticleByIdComponent = (props: GetWpArticleByIdComponentProps) => (
      <ApolloReactComponents.Query<GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables> query={GetWpArticleByIdDocument} {...props} />
    );
    
export type GetWpArticleByIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables>
    } & TChildProps;
export function withGetWpArticleById<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetWpArticleByIdQuery,
  GetWpArticleByIdQueryVariables,
  GetWpArticleByIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables, GetWpArticleByIdProps<TChildProps, TDataName>>(GetWpArticleByIdDocument, {
      alias: 'getWpArticleById',
      ...operationOptions
    });
};

/**
 * __useGetWpArticleByIdQuery__
 *
 * To run a query within a React component, call `useGetWpArticleByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWpArticleByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWpArticleByIdQuery({
 *   variables: {
 *      input: // value for 'input'
 *      sizes: // value for 'sizes'
 *   },
 * });
 */
export function useGetWpArticleByIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables>(GetWpArticleByIdDocument, options);
      }
export function useGetWpArticleByIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables>(GetWpArticleByIdDocument, options);
        }
export function useGetWpArticleByIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables>(GetWpArticleByIdDocument, options);
        }
export type GetWpArticleByIdQueryHookResult = ReturnType<typeof useGetWpArticleByIdQuery>;
export type GetWpArticleByIdLazyQueryHookResult = ReturnType<typeof useGetWpArticleByIdLazyQuery>;
export type GetWpArticleByIdSuspenseQueryHookResult = ReturnType<typeof useGetWpArticleByIdSuspenseQuery>;
export type GetWpArticleByIdQueryResult = ApolloReactCommon.QueryResult<GetWpArticleByIdQuery, GetWpArticleByIdQueryVariables>;
export const InsurancePoliciesDocument = gql`
    query InsurancePolicies {
  insurancePolicies {
    success
    policies {
      id
      accountId
      identityId
      policyType
      policyDurationMonths
      carrierName
      friendlyInsuranceProviderName
      totalPremiumCents
      status
      expiryDate
      effectiveDate
      renewalDate
      isExpired
      vehicles {
        make
        model
      }
      dwellings {
        address {
          fullAddress
        }
      }
      insuranceProviderLogo
      requiresReconnect
    }
  }
}
    `;
export type InsurancePoliciesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>, 'query'>;

    export const InsurancePoliciesComponent = (props: InsurancePoliciesComponentProps) => (
      <ApolloReactComponents.Query<InsurancePoliciesQuery, InsurancePoliciesQueryVariables> query={InsurancePoliciesDocument} {...props} />
    );
    
export type InsurancePoliciesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>
    } & TChildProps;
export function withInsurancePolicies<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsurancePoliciesQuery,
  InsurancePoliciesQueryVariables,
  InsurancePoliciesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InsurancePoliciesQuery, InsurancePoliciesQueryVariables, InsurancePoliciesProps<TChildProps, TDataName>>(InsurancePoliciesDocument, {
      alias: 'insurancePolicies',
      ...operationOptions
    });
};

/**
 * __useInsurancePoliciesQuery__
 *
 * To run a query within a React component, call `useInsurancePoliciesQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsurancePoliciesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsurancePoliciesQuery({
 *   variables: {
 *   },
 * });
 */
export function useInsurancePoliciesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>(InsurancePoliciesDocument, options);
      }
export function useInsurancePoliciesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>(InsurancePoliciesDocument, options);
        }
export function useInsurancePoliciesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>(InsurancePoliciesDocument, options);
        }
export type InsurancePoliciesQueryHookResult = ReturnType<typeof useInsurancePoliciesQuery>;
export type InsurancePoliciesLazyQueryHookResult = ReturnType<typeof useInsurancePoliciesLazyQuery>;
export type InsurancePoliciesSuspenseQueryHookResult = ReturnType<typeof useInsurancePoliciesSuspenseQuery>;
export type InsurancePoliciesQueryResult = ApolloReactCommon.QueryResult<InsurancePoliciesQuery, InsurancePoliciesQueryVariables>;
export const GetRateReportPageDataDocument = gql`
    query GetRateReportPageData($policyId: ID!, $limit: Int) {
  tuCreditReportIdentityProfile {
    vantageScore3
  }
  insurancePolicyRateReport(policyId: $policyId, limit: $limit) {
    rateReport {
      policyId
      updatedAt
      rates {
        id
        annualPremium
        marketplaceProductId
        marketplaceProductName
        marketplaceEntity {
          starRating
          reviewLink
          productBottomLine
          institution {
            id
            name
            logo
          }
        }
      }
    }
  }
  insurancePolicy(policyId: $policyId) {
    policy {
      id
      name
      carrierName
      policyType
      policyDurationMonths
      effectiveDate
      expiryDate
      isExpired
      totalPremiumCents
      monthlyPremiumCents
      updatedAt
      vehicles {
        garagingAddress {
          zip
          state
        }
        drivers {
          birthdate
        }
      }
      dwellings {
        id
        address {
          state
        }
      }
    }
  }
  insurancePolicyOverrides(policyId: $policyId) {
    id
    overrides {
      global {
        creditScore
        birthdate
      }
      policy {
        carMake
        carYear
        carModel
        zipCode
      }
    }
  }
}
    `;
export type GetRateReportPageDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables>, 'query'> & ({ variables: GetRateReportPageDataQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRateReportPageDataComponent = (props: GetRateReportPageDataComponentProps) => (
      <ApolloReactComponents.Query<GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables> query={GetRateReportPageDataDocument} {...props} />
    );
    
export type GetRateReportPageDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables>
    } & TChildProps;
export function withGetRateReportPageData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRateReportPageDataQuery,
  GetRateReportPageDataQueryVariables,
  GetRateReportPageDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables, GetRateReportPageDataProps<TChildProps, TDataName>>(GetRateReportPageDataDocument, {
      alias: 'getRateReportPageData',
      ...operationOptions
    });
};

/**
 * __useGetRateReportPageDataQuery__
 *
 * To run a query within a React component, call `useGetRateReportPageDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRateReportPageDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRateReportPageDataQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetRateReportPageDataQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables> & ({ variables: GetRateReportPageDataQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables>(GetRateReportPageDataDocument, options);
      }
export function useGetRateReportPageDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables>(GetRateReportPageDataDocument, options);
        }
export function useGetRateReportPageDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables>(GetRateReportPageDataDocument, options);
        }
export type GetRateReportPageDataQueryHookResult = ReturnType<typeof useGetRateReportPageDataQuery>;
export type GetRateReportPageDataLazyQueryHookResult = ReturnType<typeof useGetRateReportPageDataLazyQuery>;
export type GetRateReportPageDataSuspenseQueryHookResult = ReturnType<typeof useGetRateReportPageDataSuspenseQuery>;
export type GetRateReportPageDataQueryResult = ApolloReactCommon.QueryResult<GetRateReportPageDataQuery, GetRateReportPageDataQueryVariables>;
export const GetManageSubscriptionUrlDocument = gql`
    query GetManageSubscriptionUrl {
  identity {
    id
    isNerdWalletPlusMember
  }
  recurlyAccountManagementPageUrl
}
    `;
export type GetManageSubscriptionUrlComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>, 'query'>;

    export const GetManageSubscriptionUrlComponent = (props: GetManageSubscriptionUrlComponentProps) => (
      <ApolloReactComponents.Query<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables> query={GetManageSubscriptionUrlDocument} {...props} />
    );
    
export type GetManageSubscriptionUrlProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>
    } & TChildProps;
export function withGetManageSubscriptionUrl<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetManageSubscriptionUrlQuery,
  GetManageSubscriptionUrlQueryVariables,
  GetManageSubscriptionUrlProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables, GetManageSubscriptionUrlProps<TChildProps, TDataName>>(GetManageSubscriptionUrlDocument, {
      alias: 'getManageSubscriptionUrl',
      ...operationOptions
    });
};

/**
 * __useGetManageSubscriptionUrlQuery__
 *
 * To run a query within a React component, call `useGetManageSubscriptionUrlQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetManageSubscriptionUrlQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetManageSubscriptionUrlQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetManageSubscriptionUrlQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>(GetManageSubscriptionUrlDocument, options);
      }
export function useGetManageSubscriptionUrlLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>(GetManageSubscriptionUrlDocument, options);
        }
export function useGetManageSubscriptionUrlSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>(GetManageSubscriptionUrlDocument, options);
        }
export type GetManageSubscriptionUrlQueryHookResult = ReturnType<typeof useGetManageSubscriptionUrlQuery>;
export type GetManageSubscriptionUrlLazyQueryHookResult = ReturnType<typeof useGetManageSubscriptionUrlLazyQuery>;
export type GetManageSubscriptionUrlSuspenseQueryHookResult = ReturnType<typeof useGetManageSubscriptionUrlSuspenseQuery>;
export type GetManageSubscriptionUrlQueryResult = ApolloReactCommon.QueryResult<GetManageSubscriptionUrlQuery, GetManageSubscriptionUrlQueryVariables>;
export const RegisterSubscriptionSuccessDocument = gql`
    mutation RegisterSubscriptionSuccess($anonymousId: String) {
  registerNwPlusSubscriptionSuccess(anonymousId: $anonymousId) {
    id
    isNerdWalletPlusMember
  }
}
    `;
export type RegisterSubscriptionSuccessMutationFn = ApolloReactCommon.MutationFunction<RegisterSubscriptionSuccessMutation, RegisterSubscriptionSuccessMutationVariables>;
export type RegisterSubscriptionSuccessComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<RegisterSubscriptionSuccessMutation, RegisterSubscriptionSuccessMutationVariables>, 'mutation'>;

    export const RegisterSubscriptionSuccessComponent = (props: RegisterSubscriptionSuccessComponentProps) => (
      <ApolloReactComponents.Mutation<RegisterSubscriptionSuccessMutation, RegisterSubscriptionSuccessMutationVariables> mutation={RegisterSubscriptionSuccessDocument} {...props} />
    );
    
export type RegisterSubscriptionSuccessProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<RegisterSubscriptionSuccessMutation, RegisterSubscriptionSuccessMutationVariables>
    } & TChildProps;
export function withRegisterSubscriptionSuccess<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RegisterSubscriptionSuccessMutation,
  RegisterSubscriptionSuccessMutationVariables,
  RegisterSubscriptionSuccessProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, RegisterSubscriptionSuccessMutation, RegisterSubscriptionSuccessMutationVariables, RegisterSubscriptionSuccessProps<TChildProps, TDataName>>(RegisterSubscriptionSuccessDocument, {
      alias: 'registerSubscriptionSuccess',
      ...operationOptions
    });
};

/**
 * __useRegisterSubscriptionSuccessMutation__
 *
 * To run a mutation, you first call `useRegisterSubscriptionSuccessMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRegisterSubscriptionSuccessMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [registerSubscriptionSuccessMutation, { data, loading, error }] = useRegisterSubscriptionSuccessMutation({
 *   variables: {
 *      anonymousId: // value for 'anonymousId'
 *   },
 * });
 */
export function useRegisterSubscriptionSuccessMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<RegisterSubscriptionSuccessMutation, RegisterSubscriptionSuccessMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<RegisterSubscriptionSuccessMutation, RegisterSubscriptionSuccessMutationVariables>(RegisterSubscriptionSuccessDocument, options);
      }
export type RegisterSubscriptionSuccessMutationHookResult = ReturnType<typeof useRegisterSubscriptionSuccessMutation>;
export type RegisterSubscriptionSuccessMutationResult = ApolloReactCommon.MutationResult<RegisterSubscriptionSuccessMutation>;
export type RegisterSubscriptionSuccessMutationOptions = ApolloReactCommon.BaseMutationOptions<RegisterSubscriptionSuccessMutation, RegisterSubscriptionSuccessMutationVariables>;
export const RetrieveIdentityDocument = gql`
    query RetrieveIdentity {
  identity {
    id
    identityId
  }
}
    `;
export type RetrieveIdentityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RetrieveIdentityQuery, RetrieveIdentityQueryVariables>, 'query'>;

    export const RetrieveIdentityComponent = (props: RetrieveIdentityComponentProps) => (
      <ApolloReactComponents.Query<RetrieveIdentityQuery, RetrieveIdentityQueryVariables> query={RetrieveIdentityDocument} {...props} />
    );
    
export type RetrieveIdentityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RetrieveIdentityQuery, RetrieveIdentityQueryVariables>
    } & TChildProps;
export function withRetrieveIdentity<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RetrieveIdentityQuery,
  RetrieveIdentityQueryVariables,
  RetrieveIdentityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RetrieveIdentityQuery, RetrieveIdentityQueryVariables, RetrieveIdentityProps<TChildProps, TDataName>>(RetrieveIdentityDocument, {
      alias: 'retrieveIdentity',
      ...operationOptions
    });
};

/**
 * __useRetrieveIdentityQuery__
 *
 * To run a query within a React component, call `useRetrieveIdentityQuery` and pass it any options that fit your needs.
 * When your component renders, `useRetrieveIdentityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRetrieveIdentityQuery({
 *   variables: {
 *   },
 * });
 */
export function useRetrieveIdentityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RetrieveIdentityQuery, RetrieveIdentityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RetrieveIdentityQuery, RetrieveIdentityQueryVariables>(RetrieveIdentityDocument, options);
      }
export function useRetrieveIdentityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RetrieveIdentityQuery, RetrieveIdentityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RetrieveIdentityQuery, RetrieveIdentityQueryVariables>(RetrieveIdentityDocument, options);
        }
export function useRetrieveIdentitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RetrieveIdentityQuery, RetrieveIdentityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RetrieveIdentityQuery, RetrieveIdentityQueryVariables>(RetrieveIdentityDocument, options);
        }
export type RetrieveIdentityQueryHookResult = ReturnType<typeof useRetrieveIdentityQuery>;
export type RetrieveIdentityLazyQueryHookResult = ReturnType<typeof useRetrieveIdentityLazyQuery>;
export type RetrieveIdentitySuspenseQueryHookResult = ReturnType<typeof useRetrieveIdentitySuspenseQuery>;
export type RetrieveIdentityQueryResult = ApolloReactCommon.QueryResult<RetrieveIdentityQuery, RetrieveIdentityQueryVariables>;
export const UnsubscribeFromNotificationDocument = gql`
    mutation UnsubscribeFromNotification($subscriptionField: SubscriptionTypeEnum!, $unsubscribeToken: String!) {
  unsubscribeFromNotification(
    subscriptionField: $subscriptionField
    unsubscribeToken: $unsubscribeToken
  ) {
    ...SubscriptionProfileFields
  }
}
    ${SubscriptionProfileFieldsFragmentDoc}`;
export type UnsubscribeFromNotificationMutationFn = ApolloReactCommon.MutationFunction<UnsubscribeFromNotificationMutation, UnsubscribeFromNotificationMutationVariables>;
export type UnsubscribeFromNotificationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UnsubscribeFromNotificationMutation, UnsubscribeFromNotificationMutationVariables>, 'mutation'>;

    export const UnsubscribeFromNotificationComponent = (props: UnsubscribeFromNotificationComponentProps) => (
      <ApolloReactComponents.Mutation<UnsubscribeFromNotificationMutation, UnsubscribeFromNotificationMutationVariables> mutation={UnsubscribeFromNotificationDocument} {...props} />
    );
    
export type UnsubscribeFromNotificationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UnsubscribeFromNotificationMutation, UnsubscribeFromNotificationMutationVariables>
    } & TChildProps;
export function withUnsubscribeFromNotification<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UnsubscribeFromNotificationMutation,
  UnsubscribeFromNotificationMutationVariables,
  UnsubscribeFromNotificationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UnsubscribeFromNotificationMutation, UnsubscribeFromNotificationMutationVariables, UnsubscribeFromNotificationProps<TChildProps, TDataName>>(UnsubscribeFromNotificationDocument, {
      alias: 'unsubscribeFromNotification',
      ...operationOptions
    });
};

/**
 * __useUnsubscribeFromNotificationMutation__
 *
 * To run a mutation, you first call `useUnsubscribeFromNotificationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnsubscribeFromNotificationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unsubscribeFromNotificationMutation, { data, loading, error }] = useUnsubscribeFromNotificationMutation({
 *   variables: {
 *      subscriptionField: // value for 'subscriptionField'
 *      unsubscribeToken: // value for 'unsubscribeToken'
 *   },
 * });
 */
export function useUnsubscribeFromNotificationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UnsubscribeFromNotificationMutation, UnsubscribeFromNotificationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UnsubscribeFromNotificationMutation, UnsubscribeFromNotificationMutationVariables>(UnsubscribeFromNotificationDocument, options);
      }
export type UnsubscribeFromNotificationMutationHookResult = ReturnType<typeof useUnsubscribeFromNotificationMutation>;
export type UnsubscribeFromNotificationMutationResult = ApolloReactCommon.MutationResult<UnsubscribeFromNotificationMutation>;
export type UnsubscribeFromNotificationMutationOptions = ApolloReactCommon.BaseMutationOptions<UnsubscribeFromNotificationMutation, UnsubscribeFromNotificationMutationVariables>;
export const UpdateSubscriptionWithoutIdentityDocument = gql`
    mutation UpdateSubscriptionWithoutIdentity($subscriptionSettings: UpdateSubscriptionProfileInput!, $updateSubscriptionToken: String) {
  updateSubscriptionWithoutIdentity(
    subscriptionSettings: $subscriptionSettings
    updateSubscriptionToken: $updateSubscriptionToken
  ) {
    ...SubscriptionProfileFields
  }
}
    ${SubscriptionProfileFieldsFragmentDoc}`;
export type UpdateSubscriptionWithoutIdentityMutationFn = ApolloReactCommon.MutationFunction<UpdateSubscriptionWithoutIdentityMutation, UpdateSubscriptionWithoutIdentityMutationVariables>;
export type UpdateSubscriptionWithoutIdentityComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateSubscriptionWithoutIdentityMutation, UpdateSubscriptionWithoutIdentityMutationVariables>, 'mutation'>;

    export const UpdateSubscriptionWithoutIdentityComponent = (props: UpdateSubscriptionWithoutIdentityComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateSubscriptionWithoutIdentityMutation, UpdateSubscriptionWithoutIdentityMutationVariables> mutation={UpdateSubscriptionWithoutIdentityDocument} {...props} />
    );
    
export type UpdateSubscriptionWithoutIdentityProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateSubscriptionWithoutIdentityMutation, UpdateSubscriptionWithoutIdentityMutationVariables>
    } & TChildProps;
export function withUpdateSubscriptionWithoutIdentity<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateSubscriptionWithoutIdentityMutation,
  UpdateSubscriptionWithoutIdentityMutationVariables,
  UpdateSubscriptionWithoutIdentityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateSubscriptionWithoutIdentityMutation, UpdateSubscriptionWithoutIdentityMutationVariables, UpdateSubscriptionWithoutIdentityProps<TChildProps, TDataName>>(UpdateSubscriptionWithoutIdentityDocument, {
      alias: 'updateSubscriptionWithoutIdentity',
      ...operationOptions
    });
};

/**
 * __useUpdateSubscriptionWithoutIdentityMutation__
 *
 * To run a mutation, you first call `useUpdateSubscriptionWithoutIdentityMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateSubscriptionWithoutIdentityMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateSubscriptionWithoutIdentityMutation, { data, loading, error }] = useUpdateSubscriptionWithoutIdentityMutation({
 *   variables: {
 *      subscriptionSettings: // value for 'subscriptionSettings'
 *      updateSubscriptionToken: // value for 'updateSubscriptionToken'
 *   },
 * });
 */
export function useUpdateSubscriptionWithoutIdentityMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateSubscriptionWithoutIdentityMutation, UpdateSubscriptionWithoutIdentityMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateSubscriptionWithoutIdentityMutation, UpdateSubscriptionWithoutIdentityMutationVariables>(UpdateSubscriptionWithoutIdentityDocument, options);
      }
export type UpdateSubscriptionWithoutIdentityMutationHookResult = ReturnType<typeof useUpdateSubscriptionWithoutIdentityMutation>;
export type UpdateSubscriptionWithoutIdentityMutationResult = ApolloReactCommon.MutationResult<UpdateSubscriptionWithoutIdentityMutation>;
export type UpdateSubscriptionWithoutIdentityMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateSubscriptionWithoutIdentityMutation, UpdateSubscriptionWithoutIdentityMutationVariables>;
export const GetAccountListForNetWorthDocument = gql`
    query GetAccountListForNetWorth {
  netWorthRealAssets {
    assets {
      amount
      id
      isHiddenFromNetWorth
      isSelfReported
      lastReportedOrSyncedAt
      type
      ... on NetWorthHomeIntegrated {
        address {
          addressLine1
          addressLine2
          city
          state
          zipCode
        }
        externalInfo {
          source
          value
        }
      }
      ... on NetWorthRealAssetSelfReported {
        nickname
      }
    }
  }
  netWorthAccounts {
    accounts {
      financialAccountId
      id
      isHiddenFromNetWorth
    }
  }
  financialAccounts {
    accounts {
      balance
      currency
      financialPortal {
        authState
        id
        isActiveSync
        marketplaceInstitution {
          id
          logoUrl
          name
        }
        primarySource
        transactionsState
      }
      id
      isHidden
      isHiddenFromNetWorth
      lastSyncedAt
      mask
      name
      status
      subtype
      updatedAt
    }
  }
  netWorthBalancesByFinancialDataCategorization {
    assetSums {
      autoValueSum
      checkingSum
      homeValueSum
      investmentSum
      personalPropertyValueSum
      retirementSum
      savingsSum
    }
    debtSums {
      creditCardSum
      loanSum
      mortgageSum
    }
  }
}
    `;
export type GetAccountListForNetWorthComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables>, 'query'>;

    export const GetAccountListForNetWorthComponent = (props: GetAccountListForNetWorthComponentProps) => (
      <ApolloReactComponents.Query<GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables> query={GetAccountListForNetWorthDocument} {...props} />
    );
    
export type GetAccountListForNetWorthProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables>
    } & TChildProps;
export function withGetAccountListForNetWorth<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetAccountListForNetWorthQuery,
  GetAccountListForNetWorthQueryVariables,
  GetAccountListForNetWorthProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables, GetAccountListForNetWorthProps<TChildProps, TDataName>>(GetAccountListForNetWorthDocument, {
      alias: 'getAccountListForNetWorth',
      ...operationOptions
    });
};

/**
 * __useGetAccountListForNetWorthQuery__
 *
 * To run a query within a React component, call `useGetAccountListForNetWorthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAccountListForNetWorthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAccountListForNetWorthQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetAccountListForNetWorthQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables>(GetAccountListForNetWorthDocument, options);
      }
export function useGetAccountListForNetWorthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables>(GetAccountListForNetWorthDocument, options);
        }
export function useGetAccountListForNetWorthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables>(GetAccountListForNetWorthDocument, options);
        }
export type GetAccountListForNetWorthQueryHookResult = ReturnType<typeof useGetAccountListForNetWorthQuery>;
export type GetAccountListForNetWorthLazyQueryHookResult = ReturnType<typeof useGetAccountListForNetWorthLazyQuery>;
export type GetAccountListForNetWorthSuspenseQueryHookResult = ReturnType<typeof useGetAccountListForNetWorthSuspenseQuery>;
export type GetAccountListForNetWorthQueryResult = ApolloReactCommon.QueryResult<GetAccountListForNetWorthQuery, GetAccountListForNetWorthQueryVariables>;
export const GetIdentityProfileQueryDocument = gql`
    query getIdentityProfileQuery {
  tuCreditReportIdentityProfile {
    vantageScore3
    reportPulledAt
    vantageScore3Bucket
  }
}
    `;
export type GetIdentityProfileQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables>, 'query'>;

    export const GetIdentityProfileQueryComponent = (props: GetIdentityProfileQueryComponentProps) => (
      <ApolloReactComponents.Query<GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables> query={GetIdentityProfileQueryDocument} {...props} />
    );
    
export type GetIdentityProfileQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables>
    } & TChildProps;
export function withGetIdentityProfileQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetIdentityProfileQueryQuery,
  GetIdentityProfileQueryQueryVariables,
  GetIdentityProfileQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables, GetIdentityProfileQueryProps<TChildProps, TDataName>>(GetIdentityProfileQueryDocument, {
      alias: 'getIdentityProfileQuery',
      ...operationOptions
    });
};

/**
 * __useGetIdentityProfileQueryQuery__
 *
 * To run a query within a React component, call `useGetIdentityProfileQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdentityProfileQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdentityProfileQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIdentityProfileQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables>(GetIdentityProfileQueryDocument, options);
      }
export function useGetIdentityProfileQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables>(GetIdentityProfileQueryDocument, options);
        }
export function useGetIdentityProfileQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables>(GetIdentityProfileQueryDocument, options);
        }
export type GetIdentityProfileQueryQueryHookResult = ReturnType<typeof useGetIdentityProfileQueryQuery>;
export type GetIdentityProfileQueryLazyQueryHookResult = ReturnType<typeof useGetIdentityProfileQueryLazyQuery>;
export type GetIdentityProfileQuerySuspenseQueryHookResult = ReturnType<typeof useGetIdentityProfileQuerySuspenseQuery>;
export type GetIdentityProfileQueryQueryResult = ApolloReactCommon.QueryResult<GetIdentityProfileQueryQuery, GetIdentityProfileQueryQueryVariables>;
export const GetTermsOfServiceAcknowledgementsDocument = gql`
    query GetTermsOfServiceAcknowledgements {
  termsOfServiceIdentityProfile {
    acknowledgements {
      type
      source
      version
    }
  }
}
    `;
export type GetTermsOfServiceAcknowledgementsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables>, 'query'>;

    export const GetTermsOfServiceAcknowledgementsComponent = (props: GetTermsOfServiceAcknowledgementsComponentProps) => (
      <ApolloReactComponents.Query<GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables> query={GetTermsOfServiceAcknowledgementsDocument} {...props} />
    );
    
export type GetTermsOfServiceAcknowledgementsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables>
    } & TChildProps;
export function withGetTermsOfServiceAcknowledgements<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTermsOfServiceAcknowledgementsQuery,
  GetTermsOfServiceAcknowledgementsQueryVariables,
  GetTermsOfServiceAcknowledgementsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables, GetTermsOfServiceAcknowledgementsProps<TChildProps, TDataName>>(GetTermsOfServiceAcknowledgementsDocument, {
      alias: 'getTermsOfServiceAcknowledgements',
      ...operationOptions
    });
};

/**
 * __useGetTermsOfServiceAcknowledgementsQuery__
 *
 * To run a query within a React component, call `useGetTermsOfServiceAcknowledgementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTermsOfServiceAcknowledgementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTermsOfServiceAcknowledgementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTermsOfServiceAcknowledgementsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables>(GetTermsOfServiceAcknowledgementsDocument, options);
      }
export function useGetTermsOfServiceAcknowledgementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables>(GetTermsOfServiceAcknowledgementsDocument, options);
        }
export function useGetTermsOfServiceAcknowledgementsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables>(GetTermsOfServiceAcknowledgementsDocument, options);
        }
export type GetTermsOfServiceAcknowledgementsQueryHookResult = ReturnType<typeof useGetTermsOfServiceAcknowledgementsQuery>;
export type GetTermsOfServiceAcknowledgementsLazyQueryHookResult = ReturnType<typeof useGetTermsOfServiceAcknowledgementsLazyQuery>;
export type GetTermsOfServiceAcknowledgementsSuspenseQueryHookResult = ReturnType<typeof useGetTermsOfServiceAcknowledgementsSuspenseQuery>;
export type GetTermsOfServiceAcknowledgementsQueryResult = ApolloReactCommon.QueryResult<GetTermsOfServiceAcknowledgementsQuery, GetTermsOfServiceAcknowledgementsQueryVariables>;
export const NotifyPlaidLinkEventDocument = gql`
    mutation NotifyPlaidLinkEvent($event: ProxyEventType!, $eventBody: JSON, $financialPortalId: ID, $isMigrate: Boolean, $linkToken: String, $marketplaceInstitutionId: ID, $source: FinancialDataSource, $sourceEntityId: ID, $sourceInstitutionId: ID) {
  publishFinancialDataLinkEvent(
    event: $event
    eventBody: $eventBody
    financialPortalId: $financialPortalId
    isMigrate: $isMigrate
    linkToken: $linkToken
    migrationMarketplaceInstitutionId: $marketplaceInstitutionId
    source: $source
    sourceEntityId: $sourceEntityId
    sourceInstitutionId: $sourceInstitutionId
  ) {
    success
  }
}
    `;
export type NotifyPlaidLinkEventMutationFn = ApolloReactCommon.MutationFunction<NotifyPlaidLinkEventMutation, NotifyPlaidLinkEventMutationVariables>;
export type NotifyPlaidLinkEventComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<NotifyPlaidLinkEventMutation, NotifyPlaidLinkEventMutationVariables>, 'mutation'>;

    export const NotifyPlaidLinkEventComponent = (props: NotifyPlaidLinkEventComponentProps) => (
      <ApolloReactComponents.Mutation<NotifyPlaidLinkEventMutation, NotifyPlaidLinkEventMutationVariables> mutation={NotifyPlaidLinkEventDocument} {...props} />
    );
    
export type NotifyPlaidLinkEventProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<NotifyPlaidLinkEventMutation, NotifyPlaidLinkEventMutationVariables>
    } & TChildProps;
export function withNotifyPlaidLinkEvent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NotifyPlaidLinkEventMutation,
  NotifyPlaidLinkEventMutationVariables,
  NotifyPlaidLinkEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, NotifyPlaidLinkEventMutation, NotifyPlaidLinkEventMutationVariables, NotifyPlaidLinkEventProps<TChildProps, TDataName>>(NotifyPlaidLinkEventDocument, {
      alias: 'notifyPlaidLinkEvent',
      ...operationOptions
    });
};

/**
 * __useNotifyPlaidLinkEventMutation__
 *
 * To run a mutation, you first call `useNotifyPlaidLinkEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useNotifyPlaidLinkEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [notifyPlaidLinkEventMutation, { data, loading, error }] = useNotifyPlaidLinkEventMutation({
 *   variables: {
 *      event: // value for 'event'
 *      eventBody: // value for 'eventBody'
 *      financialPortalId: // value for 'financialPortalId'
 *      isMigrate: // value for 'isMigrate'
 *      linkToken: // value for 'linkToken'
 *      marketplaceInstitutionId: // value for 'marketplaceInstitutionId'
 *      source: // value for 'source'
 *      sourceEntityId: // value for 'sourceEntityId'
 *      sourceInstitutionId: // value for 'sourceInstitutionId'
 *   },
 * });
 */
export function useNotifyPlaidLinkEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<NotifyPlaidLinkEventMutation, NotifyPlaidLinkEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<NotifyPlaidLinkEventMutation, NotifyPlaidLinkEventMutationVariables>(NotifyPlaidLinkEventDocument, options);
      }
export type NotifyPlaidLinkEventMutationHookResult = ReturnType<typeof useNotifyPlaidLinkEventMutation>;
export type NotifyPlaidLinkEventMutationResult = ApolloReactCommon.MutationResult<NotifyPlaidLinkEventMutation>;
export type NotifyPlaidLinkEventMutationOptions = ApolloReactCommon.BaseMutationOptions<NotifyPlaidLinkEventMutation, NotifyPlaidLinkEventMutationVariables>;
export const ReinitializeFinancialPortalMutationDocument = gql`
    mutation ReinitializeFinancialPortalMutation($financialPortalId: ID!, $redirectUri: String) {
  reinitializeFinancialPortal(
    financialPortalId: $financialPortalId
    redirectUri: $redirectUri
  ) {
    details {
      publicToken
      recommendedInstitutionId
      recommendedSourceInstitutionId
    }
    financialPortal {
      id
      primaryClientAction
    }
  }
}
    `;
export type ReinitializeFinancialPortalMutationMutationFn = ApolloReactCommon.MutationFunction<ReinitializeFinancialPortalMutationMutation, ReinitializeFinancialPortalMutationMutationVariables>;
export type ReinitializeFinancialPortalMutationComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<ReinitializeFinancialPortalMutationMutation, ReinitializeFinancialPortalMutationMutationVariables>, 'mutation'>;

    export const ReinitializeFinancialPortalMutationComponent = (props: ReinitializeFinancialPortalMutationComponentProps) => (
      <ApolloReactComponents.Mutation<ReinitializeFinancialPortalMutationMutation, ReinitializeFinancialPortalMutationMutationVariables> mutation={ReinitializeFinancialPortalMutationDocument} {...props} />
    );
    
export type ReinitializeFinancialPortalMutationProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<ReinitializeFinancialPortalMutationMutation, ReinitializeFinancialPortalMutationMutationVariables>
    } & TChildProps;
export function withReinitializeFinancialPortalMutation<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ReinitializeFinancialPortalMutationMutation,
  ReinitializeFinancialPortalMutationMutationVariables,
  ReinitializeFinancialPortalMutationProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, ReinitializeFinancialPortalMutationMutation, ReinitializeFinancialPortalMutationMutationVariables, ReinitializeFinancialPortalMutationProps<TChildProps, TDataName>>(ReinitializeFinancialPortalMutationDocument, {
      alias: 'reinitializeFinancialPortalMutation',
      ...operationOptions
    });
};

/**
 * __useReinitializeFinancialPortalMutationMutation__
 *
 * To run a mutation, you first call `useReinitializeFinancialPortalMutationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReinitializeFinancialPortalMutationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reinitializeFinancialPortalMutationMutation, { data, loading, error }] = useReinitializeFinancialPortalMutationMutation({
 *   variables: {
 *      financialPortalId: // value for 'financialPortalId'
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useReinitializeFinancialPortalMutationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<ReinitializeFinancialPortalMutationMutation, ReinitializeFinancialPortalMutationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<ReinitializeFinancialPortalMutationMutation, ReinitializeFinancialPortalMutationMutationVariables>(ReinitializeFinancialPortalMutationDocument, options);
      }
export type ReinitializeFinancialPortalMutationMutationHookResult = ReturnType<typeof useReinitializeFinancialPortalMutationMutation>;
export type ReinitializeFinancialPortalMutationMutationResult = ApolloReactCommon.MutationResult<ReinitializeFinancialPortalMutationMutation>;
export type ReinitializeFinancialPortalMutationMutationOptions = ApolloReactCommon.BaseMutationOptions<ReinitializeFinancialPortalMutationMutation, ReinitializeFinancialPortalMutationMutationVariables>;
export const AcknowledgeTermsOfServiceDocument = gql`
    mutation AcknowledgeTermsOfService($input: AcknowledgeTermsOfServiceInput!) {
  acknowledgeTermsOfService(input: $input) {
    success
  }
}
    `;
export type AcknowledgeTermsOfServiceMutationFn = ApolloReactCommon.MutationFunction<AcknowledgeTermsOfServiceMutation, AcknowledgeTermsOfServiceMutationVariables>;
export type AcknowledgeTermsOfServiceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AcknowledgeTermsOfServiceMutation, AcknowledgeTermsOfServiceMutationVariables>, 'mutation'>;

    export const AcknowledgeTermsOfServiceComponent = (props: AcknowledgeTermsOfServiceComponentProps) => (
      <ApolloReactComponents.Mutation<AcknowledgeTermsOfServiceMutation, AcknowledgeTermsOfServiceMutationVariables> mutation={AcknowledgeTermsOfServiceDocument} {...props} />
    );
    
export type AcknowledgeTermsOfServiceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AcknowledgeTermsOfServiceMutation, AcknowledgeTermsOfServiceMutationVariables>
    } & TChildProps;
export function withAcknowledgeTermsOfService<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AcknowledgeTermsOfServiceMutation,
  AcknowledgeTermsOfServiceMutationVariables,
  AcknowledgeTermsOfServiceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AcknowledgeTermsOfServiceMutation, AcknowledgeTermsOfServiceMutationVariables, AcknowledgeTermsOfServiceProps<TChildProps, TDataName>>(AcknowledgeTermsOfServiceDocument, {
      alias: 'acknowledgeTermsOfService',
      ...operationOptions
    });
};

/**
 * __useAcknowledgeTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAcknowledgeTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeTermsOfServiceMutation, { data, loading, error }] = useAcknowledgeTermsOfServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcknowledgeTermsOfServiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcknowledgeTermsOfServiceMutation, AcknowledgeTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcknowledgeTermsOfServiceMutation, AcknowledgeTermsOfServiceMutationVariables>(AcknowledgeTermsOfServiceDocument, options);
      }
export type AcknowledgeTermsOfServiceMutationHookResult = ReturnType<typeof useAcknowledgeTermsOfServiceMutation>;
export type AcknowledgeTermsOfServiceMutationResult = ApolloReactCommon.MutationResult<AcknowledgeTermsOfServiceMutation>;
export type AcknowledgeTermsOfServiceMutationOptions = ApolloReactCommon.BaseMutationOptions<AcknowledgeTermsOfServiceMutation, AcknowledgeTermsOfServiceMutationVariables>;
export const DeleteFinancialPortalDocument = gql`
    mutation DeleteFinancialPortal($financialPortalId: ID!) {
  deleteFinancialPortal(financialPortalId: $financialPortalId) {
    success
  }
}
    `;
export type DeleteFinancialPortalMutationFn = ApolloReactCommon.MutationFunction<DeleteFinancialPortalMutation, DeleteFinancialPortalMutationVariables>;
export type DeleteFinancialPortalComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeleteFinancialPortalMutation, DeleteFinancialPortalMutationVariables>, 'mutation'>;

    export const DeleteFinancialPortalComponent = (props: DeleteFinancialPortalComponentProps) => (
      <ApolloReactComponents.Mutation<DeleteFinancialPortalMutation, DeleteFinancialPortalMutationVariables> mutation={DeleteFinancialPortalDocument} {...props} />
    );
    
export type DeleteFinancialPortalProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeleteFinancialPortalMutation, DeleteFinancialPortalMutationVariables>
    } & TChildProps;
export function withDeleteFinancialPortal<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeleteFinancialPortalMutation,
  DeleteFinancialPortalMutationVariables,
  DeleteFinancialPortalProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeleteFinancialPortalMutation, DeleteFinancialPortalMutationVariables, DeleteFinancialPortalProps<TChildProps, TDataName>>(DeleteFinancialPortalDocument, {
      alias: 'deleteFinancialPortal',
      ...operationOptions
    });
};

/**
 * __useDeleteFinancialPortalMutation__
 *
 * To run a mutation, you first call `useDeleteFinancialPortalMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteFinancialPortalMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteFinancialPortalMutation, { data, loading, error }] = useDeleteFinancialPortalMutation({
 *   variables: {
 *      financialPortalId: // value for 'financialPortalId'
 *   },
 * });
 */
export function useDeleteFinancialPortalMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeleteFinancialPortalMutation, DeleteFinancialPortalMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeleteFinancialPortalMutation, DeleteFinancialPortalMutationVariables>(DeleteFinancialPortalDocument, options);
      }
export type DeleteFinancialPortalMutationHookResult = ReturnType<typeof useDeleteFinancialPortalMutation>;
export type DeleteFinancialPortalMutationResult = ApolloReactCommon.MutationResult<DeleteFinancialPortalMutation>;
export type DeleteFinancialPortalMutationOptions = ApolloReactCommon.BaseMutationOptions<DeleteFinancialPortalMutation, DeleteFinancialPortalMutationVariables>;
export const GetFinancialAccountsDocument = gql`
    query getFinancialAccounts {
  ...FinancialAccountsForUserFragment
}
    ${FinancialAccountsForUserFragmentFragmentDoc}`;
export type GetFinancialAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables>, 'query'>;

    export const GetFinancialAccountsComponent = (props: GetFinancialAccountsComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables> query={GetFinancialAccountsDocument} {...props} />
    );
    
export type GetFinancialAccountsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables>
    } & TChildProps;
export function withGetFinancialAccounts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialAccountsQuery,
  GetFinancialAccountsQueryVariables,
  GetFinancialAccountsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables, GetFinancialAccountsProps<TChildProps, TDataName>>(GetFinancialAccountsDocument, {
      alias: 'getFinancialAccounts',
      ...operationOptions
    });
};

/**
 * __useGetFinancialAccountsQuery__
 *
 * To run a query within a React component, call `useGetFinancialAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancialAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables>(GetFinancialAccountsDocument, options);
      }
export function useGetFinancialAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables>(GetFinancialAccountsDocument, options);
        }
export function useGetFinancialAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables>(GetFinancialAccountsDocument, options);
        }
export type GetFinancialAccountsQueryHookResult = ReturnType<typeof useGetFinancialAccountsQuery>;
export type GetFinancialAccountsLazyQueryHookResult = ReturnType<typeof useGetFinancialAccountsLazyQuery>;
export type GetFinancialAccountsSuspenseQueryHookResult = ReturnType<typeof useGetFinancialAccountsSuspenseQuery>;
export type GetFinancialAccountsQueryResult = ApolloReactCommon.QueryResult<GetFinancialAccountsQuery, GetFinancialAccountsQueryVariables>;
export const GetLinkedFinancialPortalsForFinancialInstitutionsDocument = gql`
    query GetLinkedFinancialPortalsForFinancialInstitutions {
  linkedFinancialPortals {
    portals {
      accountsState
      authState
      id
      isActiveSync
      isRefreshing
      marketplaceInstitution {
        externalId
        id
        logoUrl
        name
      }
      migrationDetails {
        hasUserConfirmed
      }
      primarySource
      transactionsState
      sourceInstitutionId
      updatedAt
      deleteQueuedAt
    }
  }
}
    `;
export type GetLinkedFinancialPortalsForFinancialInstitutionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables>, 'query'>;

    export const GetLinkedFinancialPortalsForFinancialInstitutionsComponent = (props: GetLinkedFinancialPortalsForFinancialInstitutionsComponentProps) => (
      <ApolloReactComponents.Query<GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables> query={GetLinkedFinancialPortalsForFinancialInstitutionsDocument} {...props} />
    );
    
export type GetLinkedFinancialPortalsForFinancialInstitutionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables>
    } & TChildProps;
export function withGetLinkedFinancialPortalsForFinancialInstitutions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetLinkedFinancialPortalsForFinancialInstitutionsQuery,
  GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables,
  GetLinkedFinancialPortalsForFinancialInstitutionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables, GetLinkedFinancialPortalsForFinancialInstitutionsProps<TChildProps, TDataName>>(GetLinkedFinancialPortalsForFinancialInstitutionsDocument, {
      alias: 'getLinkedFinancialPortalsForFinancialInstitutions',
      ...operationOptions
    });
};

/**
 * __useGetLinkedFinancialPortalsForFinancialInstitutionsQuery__
 *
 * To run a query within a React component, call `useGetLinkedFinancialPortalsForFinancialInstitutionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkedFinancialPortalsForFinancialInstitutionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkedFinancialPortalsForFinancialInstitutionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetLinkedFinancialPortalsForFinancialInstitutionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables>(GetLinkedFinancialPortalsForFinancialInstitutionsDocument, options);
      }
export function useGetLinkedFinancialPortalsForFinancialInstitutionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables>(GetLinkedFinancialPortalsForFinancialInstitutionsDocument, options);
        }
export function useGetLinkedFinancialPortalsForFinancialInstitutionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables>(GetLinkedFinancialPortalsForFinancialInstitutionsDocument, options);
        }
export type GetLinkedFinancialPortalsForFinancialInstitutionsQueryHookResult = ReturnType<typeof useGetLinkedFinancialPortalsForFinancialInstitutionsQuery>;
export type GetLinkedFinancialPortalsForFinancialInstitutionsLazyQueryHookResult = ReturnType<typeof useGetLinkedFinancialPortalsForFinancialInstitutionsLazyQuery>;
export type GetLinkedFinancialPortalsForFinancialInstitutionsSuspenseQueryHookResult = ReturnType<typeof useGetLinkedFinancialPortalsForFinancialInstitutionsSuspenseQuery>;
export type GetLinkedFinancialPortalsForFinancialInstitutionsQueryResult = ApolloReactCommon.QueryResult<GetLinkedFinancialPortalsForFinancialInstitutionsQuery, GetLinkedFinancialPortalsForFinancialInstitutionsQueryVariables>;
export const UpdateFinancialPrioritiesDocument = gql`
    mutation UpdateFinancialPriorities($financialPriorities: FinancialPrioritiesInput!) {
  updateFinancialPriorities(financialPriorities: $financialPriorities) {
    id
    ...FinancialPrioritiesFragment
  }
}
    ${FinancialPrioritiesFragmentFragmentDoc}`;
export type UpdateFinancialPrioritiesMutationFn = ApolloReactCommon.MutationFunction<UpdateFinancialPrioritiesMutation, UpdateFinancialPrioritiesMutationVariables>;
export type UpdateFinancialPrioritiesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateFinancialPrioritiesMutation, UpdateFinancialPrioritiesMutationVariables>, 'mutation'>;

    export const UpdateFinancialPrioritiesComponent = (props: UpdateFinancialPrioritiesComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateFinancialPrioritiesMutation, UpdateFinancialPrioritiesMutationVariables> mutation={UpdateFinancialPrioritiesDocument} {...props} />
    );
    
export type UpdateFinancialPrioritiesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateFinancialPrioritiesMutation, UpdateFinancialPrioritiesMutationVariables>
    } & TChildProps;
export function withUpdateFinancialPriorities<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateFinancialPrioritiesMutation,
  UpdateFinancialPrioritiesMutationVariables,
  UpdateFinancialPrioritiesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateFinancialPrioritiesMutation, UpdateFinancialPrioritiesMutationVariables, UpdateFinancialPrioritiesProps<TChildProps, TDataName>>(UpdateFinancialPrioritiesDocument, {
      alias: 'updateFinancialPriorities',
      ...operationOptions
    });
};

/**
 * __useUpdateFinancialPrioritiesMutation__
 *
 * To run a mutation, you first call `useUpdateFinancialPrioritiesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialPrioritiesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialPrioritiesMutation, { data, loading, error }] = useUpdateFinancialPrioritiesMutation({
 *   variables: {
 *      financialPriorities: // value for 'financialPriorities'
 *   },
 * });
 */
export function useUpdateFinancialPrioritiesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFinancialPrioritiesMutation, UpdateFinancialPrioritiesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFinancialPrioritiesMutation, UpdateFinancialPrioritiesMutationVariables>(UpdateFinancialPrioritiesDocument, options);
      }
export type UpdateFinancialPrioritiesMutationHookResult = ReturnType<typeof useUpdateFinancialPrioritiesMutation>;
export type UpdateFinancialPrioritiesMutationResult = ApolloReactCommon.MutationResult<UpdateFinancialPrioritiesMutation>;
export type UpdateFinancialPrioritiesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFinancialPrioritiesMutation, UpdateFinancialPrioritiesMutationVariables>;
export const GetCanopyIdentityIdDocument = gql`
    query GetCanopyIdentityId {
  canopyIdentityId
}
    `;
export type GetCanopyIdentityIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables>, 'query'>;

    export const GetCanopyIdentityIdComponent = (props: GetCanopyIdentityIdComponentProps) => (
      <ApolloReactComponents.Query<GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables> query={GetCanopyIdentityIdDocument} {...props} />
    );
    
export type GetCanopyIdentityIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables>
    } & TChildProps;
export function withGetCanopyIdentityId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCanopyIdentityIdQuery,
  GetCanopyIdentityIdQueryVariables,
  GetCanopyIdentityIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables, GetCanopyIdentityIdProps<TChildProps, TDataName>>(GetCanopyIdentityIdDocument, {
      alias: 'getCanopyIdentityId',
      ...operationOptions
    });
};

/**
 * __useGetCanopyIdentityIdQuery__
 *
 * To run a query within a React component, call `useGetCanopyIdentityIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanopyIdentityIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanopyIdentityIdQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCanopyIdentityIdQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables>(GetCanopyIdentityIdDocument, options);
      }
export function useGetCanopyIdentityIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables>(GetCanopyIdentityIdDocument, options);
        }
export function useGetCanopyIdentityIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables>(GetCanopyIdentityIdDocument, options);
        }
export type GetCanopyIdentityIdQueryHookResult = ReturnType<typeof useGetCanopyIdentityIdQuery>;
export type GetCanopyIdentityIdLazyQueryHookResult = ReturnType<typeof useGetCanopyIdentityIdLazyQuery>;
export type GetCanopyIdentityIdSuspenseQueryHookResult = ReturnType<typeof useGetCanopyIdentityIdSuspenseQuery>;
export type GetCanopyIdentityIdQueryResult = ApolloReactCommon.QueryResult<GetCanopyIdentityIdQuery, GetCanopyIdentityIdQueryVariables>;
export const FetchRateReportDocument = gql`
    query FetchRateReport($policyId: ID!, $limit: Int) {
  insurancePolicyRateReport(policyId: $policyId, limit: $limit) {
    rateReport {
      rates {
        id
      }
    }
  }
}
    `;
export type FetchRateReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FetchRateReportQuery, FetchRateReportQueryVariables>, 'query'> & ({ variables: FetchRateReportQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const FetchRateReportComponent = (props: FetchRateReportComponentProps) => (
      <ApolloReactComponents.Query<FetchRateReportQuery, FetchRateReportQueryVariables> query={FetchRateReportDocument} {...props} />
    );
    
export type FetchRateReportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FetchRateReportQuery, FetchRateReportQueryVariables>
    } & TChildProps;
export function withFetchRateReport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FetchRateReportQuery,
  FetchRateReportQueryVariables,
  FetchRateReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FetchRateReportQuery, FetchRateReportQueryVariables, FetchRateReportProps<TChildProps, TDataName>>(FetchRateReportDocument, {
      alias: 'fetchRateReport',
      ...operationOptions
    });
};

/**
 * __useFetchRateReportQuery__
 *
 * To run a query within a React component, call `useFetchRateReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useFetchRateReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFetchRateReportQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useFetchRateReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<FetchRateReportQuery, FetchRateReportQueryVariables> & ({ variables: FetchRateReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FetchRateReportQuery, FetchRateReportQueryVariables>(FetchRateReportDocument, options);
      }
export function useFetchRateReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FetchRateReportQuery, FetchRateReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FetchRateReportQuery, FetchRateReportQueryVariables>(FetchRateReportDocument, options);
        }
export function useFetchRateReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FetchRateReportQuery, FetchRateReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FetchRateReportQuery, FetchRateReportQueryVariables>(FetchRateReportDocument, options);
        }
export type FetchRateReportQueryHookResult = ReturnType<typeof useFetchRateReportQuery>;
export type FetchRateReportLazyQueryHookResult = ReturnType<typeof useFetchRateReportLazyQuery>;
export type FetchRateReportSuspenseQueryHookResult = ReturnType<typeof useFetchRateReportSuspenseQuery>;
export type FetchRateReportQueryResult = ApolloReactCommon.QueryResult<FetchRateReportQuery, FetchRateReportQueryVariables>;
export const AcknowledgementCanopyTermsOfServiceDocument = gql`
    mutation AcknowledgementCanopyTermsOfService($source: String!, $version: String!) {
  acknowledgeCanopyTermsOfServiceAgreement(source: $source, version: $version) {
    success
  }
}
    `;
export type AcknowledgementCanopyTermsOfServiceMutationFn = ApolloReactCommon.MutationFunction<AcknowledgementCanopyTermsOfServiceMutation, AcknowledgementCanopyTermsOfServiceMutationVariables>;
export type AcknowledgementCanopyTermsOfServiceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AcknowledgementCanopyTermsOfServiceMutation, AcknowledgementCanopyTermsOfServiceMutationVariables>, 'mutation'>;

    export const AcknowledgementCanopyTermsOfServiceComponent = (props: AcknowledgementCanopyTermsOfServiceComponentProps) => (
      <ApolloReactComponents.Mutation<AcknowledgementCanopyTermsOfServiceMutation, AcknowledgementCanopyTermsOfServiceMutationVariables> mutation={AcknowledgementCanopyTermsOfServiceDocument} {...props} />
    );
    
export type AcknowledgementCanopyTermsOfServiceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AcknowledgementCanopyTermsOfServiceMutation, AcknowledgementCanopyTermsOfServiceMutationVariables>
    } & TChildProps;
export function withAcknowledgementCanopyTermsOfService<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AcknowledgementCanopyTermsOfServiceMutation,
  AcknowledgementCanopyTermsOfServiceMutationVariables,
  AcknowledgementCanopyTermsOfServiceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AcknowledgementCanopyTermsOfServiceMutation, AcknowledgementCanopyTermsOfServiceMutationVariables, AcknowledgementCanopyTermsOfServiceProps<TChildProps, TDataName>>(AcknowledgementCanopyTermsOfServiceDocument, {
      alias: 'acknowledgementCanopyTermsOfService',
      ...operationOptions
    });
};

/**
 * __useAcknowledgementCanopyTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAcknowledgementCanopyTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgementCanopyTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgementCanopyTermsOfServiceMutation, { data, loading, error }] = useAcknowledgementCanopyTermsOfServiceMutation({
 *   variables: {
 *      source: // value for 'source'
 *      version: // value for 'version'
 *   },
 * });
 */
export function useAcknowledgementCanopyTermsOfServiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcknowledgementCanopyTermsOfServiceMutation, AcknowledgementCanopyTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcknowledgementCanopyTermsOfServiceMutation, AcknowledgementCanopyTermsOfServiceMutationVariables>(AcknowledgementCanopyTermsOfServiceDocument, options);
      }
export type AcknowledgementCanopyTermsOfServiceMutationHookResult = ReturnType<typeof useAcknowledgementCanopyTermsOfServiceMutation>;
export type AcknowledgementCanopyTermsOfServiceMutationResult = ApolloReactCommon.MutationResult<AcknowledgementCanopyTermsOfServiceMutation>;
export type AcknowledgementCanopyTermsOfServiceMutationOptions = ApolloReactCommon.BaseMutationOptions<AcknowledgementCanopyTermsOfServiceMutation, AcknowledgementCanopyTermsOfServiceMutationVariables>;
export const AcknowledgeCoveredTermsOfServiceDocument = gql`
    mutation AcknowledgeCoveredTermsOfService {
  acknowledgeCoveredTermsOfService {
    success
  }
}
    `;
export type AcknowledgeCoveredTermsOfServiceMutationFn = ApolloReactCommon.MutationFunction<AcknowledgeCoveredTermsOfServiceMutation, AcknowledgeCoveredTermsOfServiceMutationVariables>;
export type AcknowledgeCoveredTermsOfServiceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AcknowledgeCoveredTermsOfServiceMutation, AcknowledgeCoveredTermsOfServiceMutationVariables>, 'mutation'>;

    export const AcknowledgeCoveredTermsOfServiceComponent = (props: AcknowledgeCoveredTermsOfServiceComponentProps) => (
      <ApolloReactComponents.Mutation<AcknowledgeCoveredTermsOfServiceMutation, AcknowledgeCoveredTermsOfServiceMutationVariables> mutation={AcknowledgeCoveredTermsOfServiceDocument} {...props} />
    );
    
export type AcknowledgeCoveredTermsOfServiceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AcknowledgeCoveredTermsOfServiceMutation, AcknowledgeCoveredTermsOfServiceMutationVariables>
    } & TChildProps;
export function withAcknowledgeCoveredTermsOfService<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AcknowledgeCoveredTermsOfServiceMutation,
  AcknowledgeCoveredTermsOfServiceMutationVariables,
  AcknowledgeCoveredTermsOfServiceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AcknowledgeCoveredTermsOfServiceMutation, AcknowledgeCoveredTermsOfServiceMutationVariables, AcknowledgeCoveredTermsOfServiceProps<TChildProps, TDataName>>(AcknowledgeCoveredTermsOfServiceDocument, {
      alias: 'acknowledgeCoveredTermsOfService',
      ...operationOptions
    });
};

/**
 * __useAcknowledgeCoveredTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAcknowledgeCoveredTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeCoveredTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeCoveredTermsOfServiceMutation, { data, loading, error }] = useAcknowledgeCoveredTermsOfServiceMutation({
 *   variables: {
 *   },
 * });
 */
export function useAcknowledgeCoveredTermsOfServiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcknowledgeCoveredTermsOfServiceMutation, AcknowledgeCoveredTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcknowledgeCoveredTermsOfServiceMutation, AcknowledgeCoveredTermsOfServiceMutationVariables>(AcknowledgeCoveredTermsOfServiceDocument, options);
      }
export type AcknowledgeCoveredTermsOfServiceMutationHookResult = ReturnType<typeof useAcknowledgeCoveredTermsOfServiceMutation>;
export type AcknowledgeCoveredTermsOfServiceMutationResult = ApolloReactCommon.MutationResult<AcknowledgeCoveredTermsOfServiceMutation>;
export type AcknowledgeCoveredTermsOfServiceMutationOptions = ApolloReactCommon.BaseMutationOptions<AcknowledgeCoveredTermsOfServiceMutation, AcknowledgeCoveredTermsOfServiceMutationVariables>;
export const GetCanopyFlowInitialDataDocument = gql`
    query GetCanopyFlowInitialData {
  canopyTermsOfServiceAgreements {
    success
    acknowledgements {
      source
      type
      version
    }
  }
  hasAcknowledgedCoveredTermsOfService {
    acknowledged
  }
  insurancePolicies {
    policies {
      id
      carrierName
      policyType
    }
  }
}
    `;
export type GetCanopyFlowInitialDataComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables>, 'query'>;

    export const GetCanopyFlowInitialDataComponent = (props: GetCanopyFlowInitialDataComponentProps) => (
      <ApolloReactComponents.Query<GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables> query={GetCanopyFlowInitialDataDocument} {...props} />
    );
    
export type GetCanopyFlowInitialDataProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables>
    } & TChildProps;
export function withGetCanopyFlowInitialData<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCanopyFlowInitialDataQuery,
  GetCanopyFlowInitialDataQueryVariables,
  GetCanopyFlowInitialDataProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables, GetCanopyFlowInitialDataProps<TChildProps, TDataName>>(GetCanopyFlowInitialDataDocument, {
      alias: 'getCanopyFlowInitialData',
      ...operationOptions
    });
};

/**
 * __useGetCanopyFlowInitialDataQuery__
 *
 * To run a query within a React component, call `useGetCanopyFlowInitialDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanopyFlowInitialDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanopyFlowInitialDataQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCanopyFlowInitialDataQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables>(GetCanopyFlowInitialDataDocument, options);
      }
export function useGetCanopyFlowInitialDataLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables>(GetCanopyFlowInitialDataDocument, options);
        }
export function useGetCanopyFlowInitialDataSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables>(GetCanopyFlowInitialDataDocument, options);
        }
export type GetCanopyFlowInitialDataQueryHookResult = ReturnType<typeof useGetCanopyFlowInitialDataQuery>;
export type GetCanopyFlowInitialDataLazyQueryHookResult = ReturnType<typeof useGetCanopyFlowInitialDataLazyQuery>;
export type GetCanopyFlowInitialDataSuspenseQueryHookResult = ReturnType<typeof useGetCanopyFlowInitialDataSuspenseQuery>;
export type GetCanopyFlowInitialDataQueryResult = ApolloReactCommon.QueryResult<GetCanopyFlowInitialDataQuery, GetCanopyFlowInitialDataQueryVariables>;
export const AcknowledgeCoveredTcpaConsentDocument = gql`
    mutation AcknowledgeCoveredTCPAConsent($policyId: ID!) {
  acknowledgeCoveredTCPAConsent(policyId: $policyId) {
    success
    quoteUrl
    shoppingFinishId
  }
}
    `;
export type AcknowledgeCoveredTcpaConsentMutationFn = ApolloReactCommon.MutationFunction<AcknowledgeCoveredTcpaConsentMutation, AcknowledgeCoveredTcpaConsentMutationVariables>;
export type AcknowledgeCoveredTcpaConsentComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AcknowledgeCoveredTcpaConsentMutation, AcknowledgeCoveredTcpaConsentMutationVariables>, 'mutation'>;

    export const AcknowledgeCoveredTcpaConsentComponent = (props: AcknowledgeCoveredTcpaConsentComponentProps) => (
      <ApolloReactComponents.Mutation<AcknowledgeCoveredTcpaConsentMutation, AcknowledgeCoveredTcpaConsentMutationVariables> mutation={AcknowledgeCoveredTcpaConsentDocument} {...props} />
    );
    
export type AcknowledgeCoveredTcpaConsentProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AcknowledgeCoveredTcpaConsentMutation, AcknowledgeCoveredTcpaConsentMutationVariables>
    } & TChildProps;
export function withAcknowledgeCoveredTcpaConsent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AcknowledgeCoveredTcpaConsentMutation,
  AcknowledgeCoveredTcpaConsentMutationVariables,
  AcknowledgeCoveredTcpaConsentProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AcknowledgeCoveredTcpaConsentMutation, AcknowledgeCoveredTcpaConsentMutationVariables, AcknowledgeCoveredTcpaConsentProps<TChildProps, TDataName>>(AcknowledgeCoveredTcpaConsentDocument, {
      alias: 'acknowledgeCoveredTcpaConsent',
      ...operationOptions
    });
};

/**
 * __useAcknowledgeCoveredTcpaConsentMutation__
 *
 * To run a mutation, you first call `useAcknowledgeCoveredTcpaConsentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeCoveredTcpaConsentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeCoveredTcpaConsentMutation, { data, loading, error }] = useAcknowledgeCoveredTcpaConsentMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useAcknowledgeCoveredTcpaConsentMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcknowledgeCoveredTcpaConsentMutation, AcknowledgeCoveredTcpaConsentMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcknowledgeCoveredTcpaConsentMutation, AcknowledgeCoveredTcpaConsentMutationVariables>(AcknowledgeCoveredTcpaConsentDocument, options);
      }
export type AcknowledgeCoveredTcpaConsentMutationHookResult = ReturnType<typeof useAcknowledgeCoveredTcpaConsentMutation>;
export type AcknowledgeCoveredTcpaConsentMutationResult = ApolloReactCommon.MutationResult<AcknowledgeCoveredTcpaConsentMutation>;
export type AcknowledgeCoveredTcpaConsentMutationOptions = ApolloReactCommon.BaseMutationOptions<AcknowledgeCoveredTcpaConsentMutation, AcknowledgeCoveredTcpaConsentMutationVariables>;
export const InsurancePolicyDocument = gql`
    query InsurancePolicy($policyId: ID!) {
  insurancePolicy(policyId: $policyId) {
    success
    policy {
      id
      name
      policyNumber
      policyType
      effectiveDate
      expiryDate
      isExpired
      totalPremiumCents
      carrierName
      friendlyInsuranceProviderName
      updatedAt
      vehicles {
        id
        year
        make
        model
        type
        vin
        garagingAddress {
          id
          fullAddress
        }
        drivers {
          id
          firstName
          middleName
          lastName
          gender
          birthdate
        }
      }
      dwellings {
        id
        address {
          fullAddress
        }
        yearBuilt
        type
      }
      namedInsureds {
        id
        firstName
        middleName
        lastName
      }
      documents {
        id
        title
        dateAdded
        documentType
        policyId
      }
    }
  }
}
    `;
export type InsurancePolicyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<InsurancePolicyQuery, InsurancePolicyQueryVariables>, 'query'> & ({ variables: InsurancePolicyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const InsurancePolicyComponent = (props: InsurancePolicyComponentProps) => (
      <ApolloReactComponents.Query<InsurancePolicyQuery, InsurancePolicyQueryVariables> query={InsurancePolicyDocument} {...props} />
    );
    
export type InsurancePolicyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<InsurancePolicyQuery, InsurancePolicyQueryVariables>
    } & TChildProps;
export function withInsurancePolicy<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InsurancePolicyQuery,
  InsurancePolicyQueryVariables,
  InsurancePolicyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, InsurancePolicyQuery, InsurancePolicyQueryVariables, InsurancePolicyProps<TChildProps, TDataName>>(InsurancePolicyDocument, {
      alias: 'insurancePolicy',
      ...operationOptions
    });
};

/**
 * __useInsurancePolicyQuery__
 *
 * To run a query within a React component, call `useInsurancePolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useInsurancePolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useInsurancePolicyQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useInsurancePolicyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<InsurancePolicyQuery, InsurancePolicyQueryVariables> & ({ variables: InsurancePolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<InsurancePolicyQuery, InsurancePolicyQueryVariables>(InsurancePolicyDocument, options);
      }
export function useInsurancePolicyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<InsurancePolicyQuery, InsurancePolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<InsurancePolicyQuery, InsurancePolicyQueryVariables>(InsurancePolicyDocument, options);
        }
export function useInsurancePolicySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<InsurancePolicyQuery, InsurancePolicyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<InsurancePolicyQuery, InsurancePolicyQueryVariables>(InsurancePolicyDocument, options);
        }
export type InsurancePolicyQueryHookResult = ReturnType<typeof useInsurancePolicyQuery>;
export type InsurancePolicyLazyQueryHookResult = ReturnType<typeof useInsurancePolicyLazyQuery>;
export type InsurancePolicySuspenseQueryHookResult = ReturnType<typeof useInsurancePolicySuspenseQuery>;
export type InsurancePolicyQueryResult = ApolloReactCommon.QueryResult<InsurancePolicyQuery, InsurancePolicyQueryVariables>;
export const HidePolicyDocument = gql`
    mutation HidePolicy($policyId: ID!) {
  hidePolicy(policyId: $policyId) {
    success
    policies {
      id
    }
  }
}
    `;
export type HidePolicyMutationFn = ApolloReactCommon.MutationFunction<HidePolicyMutation, HidePolicyMutationVariables>;
export type HidePolicyComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<HidePolicyMutation, HidePolicyMutationVariables>, 'mutation'>;

    export const HidePolicyComponent = (props: HidePolicyComponentProps) => (
      <ApolloReactComponents.Mutation<HidePolicyMutation, HidePolicyMutationVariables> mutation={HidePolicyDocument} {...props} />
    );
    
export type HidePolicyProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<HidePolicyMutation, HidePolicyMutationVariables>
    } & TChildProps;
export function withHidePolicy<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  HidePolicyMutation,
  HidePolicyMutationVariables,
  HidePolicyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, HidePolicyMutation, HidePolicyMutationVariables, HidePolicyProps<TChildProps, TDataName>>(HidePolicyDocument, {
      alias: 'hidePolicy',
      ...operationOptions
    });
};

/**
 * __useHidePolicyMutation__
 *
 * To run a mutation, you first call `useHidePolicyMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useHidePolicyMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [hidePolicyMutation, { data, loading, error }] = useHidePolicyMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useHidePolicyMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<HidePolicyMutation, HidePolicyMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<HidePolicyMutation, HidePolicyMutationVariables>(HidePolicyDocument, options);
      }
export type HidePolicyMutationHookResult = ReturnType<typeof useHidePolicyMutation>;
export type HidePolicyMutationResult = ApolloReactCommon.MutationResult<HidePolicyMutation>;
export type HidePolicyMutationOptions = ApolloReactCommon.BaseMutationOptions<HidePolicyMutation, HidePolicyMutationVariables>;
export const GetRelinkNudgeReconnectTokenDocument = gql`
    query GetRelinkNudgeReconnectToken($accountId: ID!) {
  accountReconnectToken(accountId: $accountId) {
    reconnectToken
  }
}
    `;
export type GetRelinkNudgeReconnectTokenComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables>, 'query'> & ({ variables: GetRelinkNudgeReconnectTokenQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetRelinkNudgeReconnectTokenComponent = (props: GetRelinkNudgeReconnectTokenComponentProps) => (
      <ApolloReactComponents.Query<GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables> query={GetRelinkNudgeReconnectTokenDocument} {...props} />
    );
    
export type GetRelinkNudgeReconnectTokenProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables>
    } & TChildProps;
export function withGetRelinkNudgeReconnectToken<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRelinkNudgeReconnectTokenQuery,
  GetRelinkNudgeReconnectTokenQueryVariables,
  GetRelinkNudgeReconnectTokenProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables, GetRelinkNudgeReconnectTokenProps<TChildProps, TDataName>>(GetRelinkNudgeReconnectTokenDocument, {
      alias: 'getRelinkNudgeReconnectToken',
      ...operationOptions
    });
};

/**
 * __useGetRelinkNudgeReconnectTokenQuery__
 *
 * To run a query within a React component, call `useGetRelinkNudgeReconnectTokenQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRelinkNudgeReconnectTokenQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRelinkNudgeReconnectTokenQuery({
 *   variables: {
 *      accountId: // value for 'accountId'
 *   },
 * });
 */
export function useGetRelinkNudgeReconnectTokenQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables> & ({ variables: GetRelinkNudgeReconnectTokenQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables>(GetRelinkNudgeReconnectTokenDocument, options);
      }
export function useGetRelinkNudgeReconnectTokenLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables>(GetRelinkNudgeReconnectTokenDocument, options);
        }
export function useGetRelinkNudgeReconnectTokenSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables>(GetRelinkNudgeReconnectTokenDocument, options);
        }
export type GetRelinkNudgeReconnectTokenQueryHookResult = ReturnType<typeof useGetRelinkNudgeReconnectTokenQuery>;
export type GetRelinkNudgeReconnectTokenLazyQueryHookResult = ReturnType<typeof useGetRelinkNudgeReconnectTokenLazyQuery>;
export type GetRelinkNudgeReconnectTokenSuspenseQueryHookResult = ReturnType<typeof useGetRelinkNudgeReconnectTokenSuspenseQuery>;
export type GetRelinkNudgeReconnectTokenQueryResult = ApolloReactCommon.QueryResult<GetRelinkNudgeReconnectTokenQuery, GetRelinkNudgeReconnectTokenQueryVariables>;
export const NetWorthHomeValueResultWithPossibilitiesByAddressDocument = gql`
    query netWorthHomeValueResultWithPossibilitiesByAddress($address: NetWorthHomeValueResultAddressInput!, $source: NetWorthHomeValueResultSourceEnum) {
  netWorthHomeValueResultWithPossibilitiesByAddress(
    address: $address
    source: $source
  ) {
    data {
      ... on NetWorthHomeValueResultResponseData {
        address {
          addressLine1
          addressLine2
          city
          state
          zipCode
        }
        propertyId
        source
        value
      }
      ... on NetWorthHomeValuePossibilityResponseData {
        possibilities {
          address {
            addressLine1
            addressLine2
            city
            state
            zipCode
          }
          propertyId
          source
          url
          value
        }
      }
      type
    }
    error {
      errorType
    }
  }
}
    `;
export type NetWorthHomeValueResultWithPossibilitiesByAddressComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables>, 'query'> & ({ variables: NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NetWorthHomeValueResultWithPossibilitiesByAddressComponent = (props: NetWorthHomeValueResultWithPossibilitiesByAddressComponentProps) => (
      <ApolloReactComponents.Query<NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables> query={NetWorthHomeValueResultWithPossibilitiesByAddressDocument} {...props} />
    );
    
export type NetWorthHomeValueResultWithPossibilitiesByAddressProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables>
    } & TChildProps;
export function withNetWorthHomeValueResultWithPossibilitiesByAddress<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NetWorthHomeValueResultWithPossibilitiesByAddressQuery,
  NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables,
  NetWorthHomeValueResultWithPossibilitiesByAddressProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables, NetWorthHomeValueResultWithPossibilitiesByAddressProps<TChildProps, TDataName>>(NetWorthHomeValueResultWithPossibilitiesByAddressDocument, {
      alias: 'netWorthHomeValueResultWithPossibilitiesByAddress',
      ...operationOptions
    });
};

/**
 * __useNetWorthHomeValueResultWithPossibilitiesByAddressQuery__
 *
 * To run a query within a React component, call `useNetWorthHomeValueResultWithPossibilitiesByAddressQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetWorthHomeValueResultWithPossibilitiesByAddressQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetWorthHomeValueResultWithPossibilitiesByAddressQuery({
 *   variables: {
 *      address: // value for 'address'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useNetWorthHomeValueResultWithPossibilitiesByAddressQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables> & ({ variables: NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables>(NetWorthHomeValueResultWithPossibilitiesByAddressDocument, options);
      }
export function useNetWorthHomeValueResultWithPossibilitiesByAddressLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables>(NetWorthHomeValueResultWithPossibilitiesByAddressDocument, options);
        }
export function useNetWorthHomeValueResultWithPossibilitiesByAddressSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables>(NetWorthHomeValueResultWithPossibilitiesByAddressDocument, options);
        }
export type NetWorthHomeValueResultWithPossibilitiesByAddressQueryHookResult = ReturnType<typeof useNetWorthHomeValueResultWithPossibilitiesByAddressQuery>;
export type NetWorthHomeValueResultWithPossibilitiesByAddressLazyQueryHookResult = ReturnType<typeof useNetWorthHomeValueResultWithPossibilitiesByAddressLazyQuery>;
export type NetWorthHomeValueResultWithPossibilitiesByAddressSuspenseQueryHookResult = ReturnType<typeof useNetWorthHomeValueResultWithPossibilitiesByAddressSuspenseQuery>;
export type NetWorthHomeValueResultWithPossibilitiesByAddressQueryResult = ApolloReactCommon.QueryResult<NetWorthHomeValueResultWithPossibilitiesByAddressQuery, NetWorthHomeValueResultWithPossibilitiesByAddressQueryVariables>;
export const NetWorthHomeValueResultByPropertyIdDocument = gql`
    query netWorthHomeValueResultByPropertyId($propertyId: ID!, $source: NetWorthHomeValueResultSourceEnum!) {
  netWorthHomeValueResultByPropertyId(propertyId: $propertyId, source: $source) {
    data {
      propertyId
      source
      value
    }
  }
}
    `;
export type NetWorthHomeValueResultByPropertyIdComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables>, 'query'> & ({ variables: NetWorthHomeValueResultByPropertyIdQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const NetWorthHomeValueResultByPropertyIdComponent = (props: NetWorthHomeValueResultByPropertyIdComponentProps) => (
      <ApolloReactComponents.Query<NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables> query={NetWorthHomeValueResultByPropertyIdDocument} {...props} />
    );
    
export type NetWorthHomeValueResultByPropertyIdProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables>
    } & TChildProps;
export function withNetWorthHomeValueResultByPropertyId<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  NetWorthHomeValueResultByPropertyIdQuery,
  NetWorthHomeValueResultByPropertyIdQueryVariables,
  NetWorthHomeValueResultByPropertyIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables, NetWorthHomeValueResultByPropertyIdProps<TChildProps, TDataName>>(NetWorthHomeValueResultByPropertyIdDocument, {
      alias: 'netWorthHomeValueResultByPropertyId',
      ...operationOptions
    });
};

/**
 * __useNetWorthHomeValueResultByPropertyIdQuery__
 *
 * To run a query within a React component, call `useNetWorthHomeValueResultByPropertyIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useNetWorthHomeValueResultByPropertyIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNetWorthHomeValueResultByPropertyIdQuery({
 *   variables: {
 *      propertyId: // value for 'propertyId'
 *      source: // value for 'source'
 *   },
 * });
 */
export function useNetWorthHomeValueResultByPropertyIdQuery(baseOptions: ApolloReactHooks.QueryHookOptions<NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables> & ({ variables: NetWorthHomeValueResultByPropertyIdQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables>(NetWorthHomeValueResultByPropertyIdDocument, options);
      }
export function useNetWorthHomeValueResultByPropertyIdLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables>(NetWorthHomeValueResultByPropertyIdDocument, options);
        }
export function useNetWorthHomeValueResultByPropertyIdSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables>(NetWorthHomeValueResultByPropertyIdDocument, options);
        }
export type NetWorthHomeValueResultByPropertyIdQueryHookResult = ReturnType<typeof useNetWorthHomeValueResultByPropertyIdQuery>;
export type NetWorthHomeValueResultByPropertyIdLazyQueryHookResult = ReturnType<typeof useNetWorthHomeValueResultByPropertyIdLazyQuery>;
export type NetWorthHomeValueResultByPropertyIdSuspenseQueryHookResult = ReturnType<typeof useNetWorthHomeValueResultByPropertyIdSuspenseQuery>;
export type NetWorthHomeValueResultByPropertyIdQueryResult = ApolloReactCommon.QueryResult<NetWorthHomeValueResultByPropertyIdQuery, NetWorthHomeValueResultByPropertyIdQueryVariables>;
export const UpdateModalDismissedAtDocument = gql`
    mutation UpdateModalDismissedAt($membershipAppActivity: MembershipAppActivityInput!) {
  updateMembershipAppActivity(membershipAppActivity: $membershipAppActivity) {
    nwPlusMaxEarnedPointsModalDismissedAt
  }
}
    `;
export type UpdateModalDismissedAtMutationFn = ApolloReactCommon.MutationFunction<UpdateModalDismissedAtMutation, UpdateModalDismissedAtMutationVariables>;
export type UpdateModalDismissedAtComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateModalDismissedAtMutation, UpdateModalDismissedAtMutationVariables>, 'mutation'>;

    export const UpdateModalDismissedAtComponent = (props: UpdateModalDismissedAtComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateModalDismissedAtMutation, UpdateModalDismissedAtMutationVariables> mutation={UpdateModalDismissedAtDocument} {...props} />
    );
    
export type UpdateModalDismissedAtProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateModalDismissedAtMutation, UpdateModalDismissedAtMutationVariables>
    } & TChildProps;
export function withUpdateModalDismissedAt<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateModalDismissedAtMutation,
  UpdateModalDismissedAtMutationVariables,
  UpdateModalDismissedAtProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateModalDismissedAtMutation, UpdateModalDismissedAtMutationVariables, UpdateModalDismissedAtProps<TChildProps, TDataName>>(UpdateModalDismissedAtDocument, {
      alias: 'updateModalDismissedAt',
      ...operationOptions
    });
};

/**
 * __useUpdateModalDismissedAtMutation__
 *
 * To run a mutation, you first call `useUpdateModalDismissedAtMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateModalDismissedAtMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateModalDismissedAtMutation, { data, loading, error }] = useUpdateModalDismissedAtMutation({
 *   variables: {
 *      membershipAppActivity: // value for 'membershipAppActivity'
 *   },
 * });
 */
export function useUpdateModalDismissedAtMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateModalDismissedAtMutation, UpdateModalDismissedAtMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateModalDismissedAtMutation, UpdateModalDismissedAtMutationVariables>(UpdateModalDismissedAtDocument, options);
      }
export type UpdateModalDismissedAtMutationHookResult = ReturnType<typeof useUpdateModalDismissedAtMutation>;
export type UpdateModalDismissedAtMutationResult = ApolloReactCommon.MutationResult<UpdateModalDismissedAtMutation>;
export type UpdateModalDismissedAtMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateModalDismissedAtMutation, UpdateModalDismissedAtMutationVariables>;
export const GetNwPlusPointsSummaryNwPlusContextDocument = gql`
    query GetNwPlusPointsSummaryNWPlusContext {
  nwPlusPointsSummary {
    points
  }
}
    `;
export type GetNwPlusPointsSummaryNwPlusContextComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables>, 'query'>;

    export const GetNwPlusPointsSummaryNwPlusContextComponent = (props: GetNwPlusPointsSummaryNwPlusContextComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables> query={GetNwPlusPointsSummaryNwPlusContextDocument} {...props} />
    );
    
export type GetNwPlusPointsSummaryNwPlusContextProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables>
    } & TChildProps;
export function withGetNwPlusPointsSummaryNwPlusContext<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusPointsSummaryNwPlusContextQuery,
  GetNwPlusPointsSummaryNwPlusContextQueryVariables,
  GetNwPlusPointsSummaryNwPlusContextProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables, GetNwPlusPointsSummaryNwPlusContextProps<TChildProps, TDataName>>(GetNwPlusPointsSummaryNwPlusContextDocument, {
      alias: 'getNwPlusPointsSummaryNwPlusContext',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusPointsSummaryNwPlusContextQuery__
 *
 * To run a query within a React component, call `useGetNwPlusPointsSummaryNwPlusContextQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusPointsSummaryNwPlusContextQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusPointsSummaryNwPlusContextQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusPointsSummaryNwPlusContextQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables>(GetNwPlusPointsSummaryNwPlusContextDocument, options);
      }
export function useGetNwPlusPointsSummaryNwPlusContextLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables>(GetNwPlusPointsSummaryNwPlusContextDocument, options);
        }
export function useGetNwPlusPointsSummaryNwPlusContextSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables>(GetNwPlusPointsSummaryNwPlusContextDocument, options);
        }
export type GetNwPlusPointsSummaryNwPlusContextQueryHookResult = ReturnType<typeof useGetNwPlusPointsSummaryNwPlusContextQuery>;
export type GetNwPlusPointsSummaryNwPlusContextLazyQueryHookResult = ReturnType<typeof useGetNwPlusPointsSummaryNwPlusContextLazyQuery>;
export type GetNwPlusPointsSummaryNwPlusContextSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusPointsSummaryNwPlusContextSuspenseQuery>;
export type GetNwPlusPointsSummaryNwPlusContextQueryResult = ApolloReactCommon.QueryResult<GetNwPlusPointsSummaryNwPlusContextQuery, GetNwPlusPointsSummaryNwPlusContextQueryVariables>;
export const GetNetWorthDocument = gql`
    query GetNetWorth {
  netWorthBalancesByFinancialDataCategorization {
    totalNetWorthIncludingHomeEquity
  }
  netWorthAccounts {
    accounts {
      id
      financialAccountId
      isHiddenFromNetWorth
    }
  }
  netWorthRealAssets {
    assets {
      id
      type
      isHiddenFromNetWorth
    }
  }
  linkedFinancialPortals {
    portals {
      id
      accounts {
        id
        isHidden
        type
        subtype
      }
    }
  }
  wealthRecommenderUser {
    id
  }
}
    `;
export type GetNetWorthComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNetWorthQuery, GetNetWorthQueryVariables>, 'query'>;

    export const GetNetWorthComponent = (props: GetNetWorthComponentProps) => (
      <ApolloReactComponents.Query<GetNetWorthQuery, GetNetWorthQueryVariables> query={GetNetWorthDocument} {...props} />
    );
    
export type GetNetWorthProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNetWorthQuery, GetNetWorthQueryVariables>
    } & TChildProps;
export function withGetNetWorth<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNetWorthQuery,
  GetNetWorthQueryVariables,
  GetNetWorthProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNetWorthQuery, GetNetWorthQueryVariables, GetNetWorthProps<TChildProps, TDataName>>(GetNetWorthDocument, {
      alias: 'getNetWorth',
      ...operationOptions
    });
};

/**
 * __useGetNetWorthQuery__
 *
 * To run a query within a React component, call `useGetNetWorthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetWorthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetWorthQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNetWorthQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNetWorthQuery, GetNetWorthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNetWorthQuery, GetNetWorthQueryVariables>(GetNetWorthDocument, options);
      }
export function useGetNetWorthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNetWorthQuery, GetNetWorthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNetWorthQuery, GetNetWorthQueryVariables>(GetNetWorthDocument, options);
        }
export function useGetNetWorthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNetWorthQuery, GetNetWorthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNetWorthQuery, GetNetWorthQueryVariables>(GetNetWorthDocument, options);
        }
export type GetNetWorthQueryHookResult = ReturnType<typeof useGetNetWorthQuery>;
export type GetNetWorthLazyQueryHookResult = ReturnType<typeof useGetNetWorthLazyQuery>;
export type GetNetWorthSuspenseQueryHookResult = ReturnType<typeof useGetNetWorthSuspenseQuery>;
export type GetNetWorthQueryResult = ApolloReactCommon.QueryResult<GetNetWorthQuery, GetNetWorthQueryVariables>;
export const GetNetWorthHistoryDocument = gql`
    query GetNetWorthHistory($netWorthFilter: NetWorthHistoryFiltersEnum!, $effectiveDate: DateTimeWithTimeOffset!) {
  netWorthHistory(netWorthFilter: $netWorthFilter, effectiveDate: $effectiveDate) {
    netWorthFilter
    history {
      date
      value
    }
  }
}
    `;
export type GetNetWorthHistoryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables>, 'query'> & ({ variables: GetNetWorthHistoryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetNetWorthHistoryComponent = (props: GetNetWorthHistoryComponentProps) => (
      <ApolloReactComponents.Query<GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables> query={GetNetWorthHistoryDocument} {...props} />
    );
    
export type GetNetWorthHistoryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables>
    } & TChildProps;
export function withGetNetWorthHistory<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNetWorthHistoryQuery,
  GetNetWorthHistoryQueryVariables,
  GetNetWorthHistoryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables, GetNetWorthHistoryProps<TChildProps, TDataName>>(GetNetWorthHistoryDocument, {
      alias: 'getNetWorthHistory',
      ...operationOptions
    });
};

/**
 * __useGetNetWorthHistoryQuery__
 *
 * To run a query within a React component, call `useGetNetWorthHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetWorthHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetWorthHistoryQuery({
 *   variables: {
 *      netWorthFilter: // value for 'netWorthFilter'
 *      effectiveDate: // value for 'effectiveDate'
 *   },
 * });
 */
export function useGetNetWorthHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables> & ({ variables: GetNetWorthHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables>(GetNetWorthHistoryDocument, options);
      }
export function useGetNetWorthHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables>(GetNetWorthHistoryDocument, options);
        }
export function useGetNetWorthHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables>(GetNetWorthHistoryDocument, options);
        }
export type GetNetWorthHistoryQueryHookResult = ReturnType<typeof useGetNetWorthHistoryQuery>;
export type GetNetWorthHistoryLazyQueryHookResult = ReturnType<typeof useGetNetWorthHistoryLazyQuery>;
export type GetNetWorthHistorySuspenseQueryHookResult = ReturnType<typeof useGetNetWorthHistorySuspenseQuery>;
export type GetNetWorthHistoryQueryResult = ApolloReactCommon.QueryResult<GetNetWorthHistoryQuery, GetNetWorthHistoryQueryVariables>;
export const GetNetWorthBalancesForSummaryGraphsDocument = gql`
    query GetNetWorthBalancesForSummaryGraphs {
  netWorthBalancesByFinancialDataCategorization {
    assetSums {
      auto_value: autoValueSum
      checking: checkingSum
      home_value: homeValueSum
      investment: investmentSum
      personal_property_value: personalPropertyValueSum
      retirement: retirementSum
      savings: savingsSum
    }
    debtSums {
      credit_card: creditCardSum
      loan: loanSum
      mortgage: mortgageSum
      non_mortgage_loan: nonMortgageLoanSum
    }
  }
}
    `;
export type GetNetWorthBalancesForSummaryGraphsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables>, 'query'>;

    export const GetNetWorthBalancesForSummaryGraphsComponent = (props: GetNetWorthBalancesForSummaryGraphsComponentProps) => (
      <ApolloReactComponents.Query<GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables> query={GetNetWorthBalancesForSummaryGraphsDocument} {...props} />
    );
    
export type GetNetWorthBalancesForSummaryGraphsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables>
    } & TChildProps;
export function withGetNetWorthBalancesForSummaryGraphs<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNetWorthBalancesForSummaryGraphsQuery,
  GetNetWorthBalancesForSummaryGraphsQueryVariables,
  GetNetWorthBalancesForSummaryGraphsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables, GetNetWorthBalancesForSummaryGraphsProps<TChildProps, TDataName>>(GetNetWorthBalancesForSummaryGraphsDocument, {
      alias: 'getNetWorthBalancesForSummaryGraphs',
      ...operationOptions
    });
};

/**
 * __useGetNetWorthBalancesForSummaryGraphsQuery__
 *
 * To run a query within a React component, call `useGetNetWorthBalancesForSummaryGraphsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNetWorthBalancesForSummaryGraphsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNetWorthBalancesForSummaryGraphsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNetWorthBalancesForSummaryGraphsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables>(GetNetWorthBalancesForSummaryGraphsDocument, options);
      }
export function useGetNetWorthBalancesForSummaryGraphsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables>(GetNetWorthBalancesForSummaryGraphsDocument, options);
        }
export function useGetNetWorthBalancesForSummaryGraphsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables>(GetNetWorthBalancesForSummaryGraphsDocument, options);
        }
export type GetNetWorthBalancesForSummaryGraphsQueryHookResult = ReturnType<typeof useGetNetWorthBalancesForSummaryGraphsQuery>;
export type GetNetWorthBalancesForSummaryGraphsLazyQueryHookResult = ReturnType<typeof useGetNetWorthBalancesForSummaryGraphsLazyQuery>;
export type GetNetWorthBalancesForSummaryGraphsSuspenseQueryHookResult = ReturnType<typeof useGetNetWorthBalancesForSummaryGraphsSuspenseQuery>;
export type GetNetWorthBalancesForSummaryGraphsQueryResult = ApolloReactCommon.QueryResult<GetNetWorthBalancesForSummaryGraphsQuery, GetNetWorthBalancesForSummaryGraphsQueryVariables>;
export const FinancialPrioritiesFeatureDiscoveryDocument = gql`
    query FinancialPrioritiesFeatureDiscovery {
  financialPrioritiesFeatureDiscovery {
    id
    isDismissed
    impressionCount
  }
}
    `;
export type FinancialPrioritiesFeatureDiscoveryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables>, 'query'>;

    export const FinancialPrioritiesFeatureDiscoveryComponent = (props: FinancialPrioritiesFeatureDiscoveryComponentProps) => (
      <ApolloReactComponents.Query<FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables> query={FinancialPrioritiesFeatureDiscoveryDocument} {...props} />
    );
    
export type FinancialPrioritiesFeatureDiscoveryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables>
    } & TChildProps;
export function withFinancialPrioritiesFeatureDiscovery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  FinancialPrioritiesFeatureDiscoveryQuery,
  FinancialPrioritiesFeatureDiscoveryQueryVariables,
  FinancialPrioritiesFeatureDiscoveryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables, FinancialPrioritiesFeatureDiscoveryProps<TChildProps, TDataName>>(FinancialPrioritiesFeatureDiscoveryDocument, {
      alias: 'financialPrioritiesFeatureDiscovery',
      ...operationOptions
    });
};

/**
 * __useFinancialPrioritiesFeatureDiscoveryQuery__
 *
 * To run a query within a React component, call `useFinancialPrioritiesFeatureDiscoveryQuery` and pass it any options that fit your needs.
 * When your component renders, `useFinancialPrioritiesFeatureDiscoveryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFinancialPrioritiesFeatureDiscoveryQuery({
 *   variables: {
 *   },
 * });
 */
export function useFinancialPrioritiesFeatureDiscoveryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables>(FinancialPrioritiesFeatureDiscoveryDocument, options);
      }
export function useFinancialPrioritiesFeatureDiscoveryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables>(FinancialPrioritiesFeatureDiscoveryDocument, options);
        }
export function useFinancialPrioritiesFeatureDiscoverySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables>(FinancialPrioritiesFeatureDiscoveryDocument, options);
        }
export type FinancialPrioritiesFeatureDiscoveryQueryHookResult = ReturnType<typeof useFinancialPrioritiesFeatureDiscoveryQuery>;
export type FinancialPrioritiesFeatureDiscoveryLazyQueryHookResult = ReturnType<typeof useFinancialPrioritiesFeatureDiscoveryLazyQuery>;
export type FinancialPrioritiesFeatureDiscoverySuspenseQueryHookResult = ReturnType<typeof useFinancialPrioritiesFeatureDiscoverySuspenseQuery>;
export type FinancialPrioritiesFeatureDiscoveryQueryResult = ApolloReactCommon.QueryResult<FinancialPrioritiesFeatureDiscoveryQuery, FinancialPrioritiesFeatureDiscoveryQueryVariables>;
export const UpdateFinancialPrioritiesFeatureDiscoveryDocument = gql`
    mutation UpdateFinancialPrioritiesFeatureDiscovery($isDismissed: Boolean, $impressionCount: Int) {
  updateFinancialPrioritiesFeatureDiscovery(
    isDismissed: $isDismissed
    impressionCount: $impressionCount
  ) {
    id
    isDismissed
    impressionCount
  }
}
    `;
export type UpdateFinancialPrioritiesFeatureDiscoveryMutationFn = ApolloReactCommon.MutationFunction<UpdateFinancialPrioritiesFeatureDiscoveryMutation, UpdateFinancialPrioritiesFeatureDiscoveryMutationVariables>;
export type UpdateFinancialPrioritiesFeatureDiscoveryComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateFinancialPrioritiesFeatureDiscoveryMutation, UpdateFinancialPrioritiesFeatureDiscoveryMutationVariables>, 'mutation'>;

    export const UpdateFinancialPrioritiesFeatureDiscoveryComponent = (props: UpdateFinancialPrioritiesFeatureDiscoveryComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateFinancialPrioritiesFeatureDiscoveryMutation, UpdateFinancialPrioritiesFeatureDiscoveryMutationVariables> mutation={UpdateFinancialPrioritiesFeatureDiscoveryDocument} {...props} />
    );
    
export type UpdateFinancialPrioritiesFeatureDiscoveryProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateFinancialPrioritiesFeatureDiscoveryMutation, UpdateFinancialPrioritiesFeatureDiscoveryMutationVariables>
    } & TChildProps;
export function withUpdateFinancialPrioritiesFeatureDiscovery<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateFinancialPrioritiesFeatureDiscoveryMutation,
  UpdateFinancialPrioritiesFeatureDiscoveryMutationVariables,
  UpdateFinancialPrioritiesFeatureDiscoveryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateFinancialPrioritiesFeatureDiscoveryMutation, UpdateFinancialPrioritiesFeatureDiscoveryMutationVariables, UpdateFinancialPrioritiesFeatureDiscoveryProps<TChildProps, TDataName>>(UpdateFinancialPrioritiesFeatureDiscoveryDocument, {
      alias: 'updateFinancialPrioritiesFeatureDiscovery',
      ...operationOptions
    });
};

/**
 * __useUpdateFinancialPrioritiesFeatureDiscoveryMutation__
 *
 * To run a mutation, you first call `useUpdateFinancialPrioritiesFeatureDiscoveryMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialPrioritiesFeatureDiscoveryMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialPrioritiesFeatureDiscoveryMutation, { data, loading, error }] = useUpdateFinancialPrioritiesFeatureDiscoveryMutation({
 *   variables: {
 *      isDismissed: // value for 'isDismissed'
 *      impressionCount: // value for 'impressionCount'
 *   },
 * });
 */
export function useUpdateFinancialPrioritiesFeatureDiscoveryMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFinancialPrioritiesFeatureDiscoveryMutation, UpdateFinancialPrioritiesFeatureDiscoveryMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFinancialPrioritiesFeatureDiscoveryMutation, UpdateFinancialPrioritiesFeatureDiscoveryMutationVariables>(UpdateFinancialPrioritiesFeatureDiscoveryDocument, options);
      }
export type UpdateFinancialPrioritiesFeatureDiscoveryMutationHookResult = ReturnType<typeof useUpdateFinancialPrioritiesFeatureDiscoveryMutation>;
export type UpdateFinancialPrioritiesFeatureDiscoveryMutationResult = ApolloReactCommon.MutationResult<UpdateFinancialPrioritiesFeatureDiscoveryMutation>;
export type UpdateFinancialPrioritiesFeatureDiscoveryMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFinancialPrioritiesFeatureDiscoveryMutation, UpdateFinancialPrioritiesFeatureDiscoveryMutationVariables>;
export const RecentlyViewedQueryDocument = gql`
    query RecentlyViewedQuery($maxPagesCount: Int) {
  recentlyViewed(maxPagesCount: $maxPagesCount) {
    numberOfVisits
    dateLastVisited
    urlPath
    id
    title
    synopsis
  }
}
    `;
export type RecentlyViewedQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables>, 'query'>;

    export const RecentlyViewedQueryComponent = (props: RecentlyViewedQueryComponentProps) => (
      <ApolloReactComponents.Query<RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables> query={RecentlyViewedQueryDocument} {...props} />
    );
    
export type RecentlyViewedQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables>
    } & TChildProps;
export function withRecentlyViewedQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  RecentlyViewedQueryQuery,
  RecentlyViewedQueryQueryVariables,
  RecentlyViewedQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables, RecentlyViewedQueryProps<TChildProps, TDataName>>(RecentlyViewedQueryDocument, {
      alias: 'recentlyViewedQuery',
      ...operationOptions
    });
};

/**
 * __useRecentlyViewedQueryQuery__
 *
 * To run a query within a React component, call `useRecentlyViewedQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useRecentlyViewedQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useRecentlyViewedQueryQuery({
 *   variables: {
 *      maxPagesCount: // value for 'maxPagesCount'
 *   },
 * });
 */
export function useRecentlyViewedQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables>(RecentlyViewedQueryDocument, options);
      }
export function useRecentlyViewedQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables>(RecentlyViewedQueryDocument, options);
        }
export function useRecentlyViewedQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables>(RecentlyViewedQueryDocument, options);
        }
export type RecentlyViewedQueryQueryHookResult = ReturnType<typeof useRecentlyViewedQueryQuery>;
export type RecentlyViewedQueryLazyQueryHookResult = ReturnType<typeof useRecentlyViewedQueryLazyQuery>;
export type RecentlyViewedQuerySuspenseQueryHookResult = ReturnType<typeof useRecentlyViewedQuerySuspenseQuery>;
export type RecentlyViewedQueryQueryResult = ApolloReactCommon.QueryResult<RecentlyViewedQueryQuery, RecentlyViewedQueryQueryVariables>;
export const GetCreditScoreUserInfoDocument = gql`
    query GetCreditScoreUserInfo {
  globalIdentityProfile {
    firstName
    lastName
    mailingAddress {
      city
      state
      addressLine1
      addressLine2
      zipCode
    }
    phoneNumber
    dateOfBirth
  }
}
    `;
export type GetCreditScoreUserInfoComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables>, 'query'>;

    export const GetCreditScoreUserInfoComponent = (props: GetCreditScoreUserInfoComponentProps) => (
      <ApolloReactComponents.Query<GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables> query={GetCreditScoreUserInfoDocument} {...props} />
    );
    
export type GetCreditScoreUserInfoProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables>
    } & TChildProps;
export function withGetCreditScoreUserInfo<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCreditScoreUserInfoQuery,
  GetCreditScoreUserInfoQueryVariables,
  GetCreditScoreUserInfoProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables, GetCreditScoreUserInfoProps<TChildProps, TDataName>>(GetCreditScoreUserInfoDocument, {
      alias: 'getCreditScoreUserInfo',
      ...operationOptions
    });
};

/**
 * __useGetCreditScoreUserInfoQuery__
 *
 * To run a query within a React component, call `useGetCreditScoreUserInfoQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCreditScoreUserInfoQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCreditScoreUserInfoQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCreditScoreUserInfoQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables>(GetCreditScoreUserInfoDocument, options);
      }
export function useGetCreditScoreUserInfoLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables>(GetCreditScoreUserInfoDocument, options);
        }
export function useGetCreditScoreUserInfoSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables>(GetCreditScoreUserInfoDocument, options);
        }
export type GetCreditScoreUserInfoQueryHookResult = ReturnType<typeof useGetCreditScoreUserInfoQuery>;
export type GetCreditScoreUserInfoLazyQueryHookResult = ReturnType<typeof useGetCreditScoreUserInfoLazyQuery>;
export type GetCreditScoreUserInfoSuspenseQueryHookResult = ReturnType<typeof useGetCreditScoreUserInfoSuspenseQuery>;
export type GetCreditScoreUserInfoQueryResult = ApolloReactCommon.QueryResult<GetCreditScoreUserInfoQuery, GetCreditScoreUserInfoQueryVariables>;
export const GetTuTermsOfServiceAcknowledgementsDocument = gql`
    query GetTUTermsOfServiceAcknowledgements {
  termsOfServiceIdentityProfile {
    acknowledgements {
      type
      source
      version
    }
  }
}
    `;
export type GetTuTermsOfServiceAcknowledgementsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables>, 'query'>;

    export const GetTuTermsOfServiceAcknowledgementsComponent = (props: GetTuTermsOfServiceAcknowledgementsComponentProps) => (
      <ApolloReactComponents.Query<GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables> query={GetTuTermsOfServiceAcknowledgementsDocument} {...props} />
    );
    
export type GetTuTermsOfServiceAcknowledgementsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables>
    } & TChildProps;
export function withGetTuTermsOfServiceAcknowledgements<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetTuTermsOfServiceAcknowledgementsQuery,
  GetTuTermsOfServiceAcknowledgementsQueryVariables,
  GetTuTermsOfServiceAcknowledgementsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables, GetTuTermsOfServiceAcknowledgementsProps<TChildProps, TDataName>>(GetTuTermsOfServiceAcknowledgementsDocument, {
      alias: 'getTuTermsOfServiceAcknowledgements',
      ...operationOptions
    });
};

/**
 * __useGetTuTermsOfServiceAcknowledgementsQuery__
 *
 * To run a query within a React component, call `useGetTuTermsOfServiceAcknowledgementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetTuTermsOfServiceAcknowledgementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetTuTermsOfServiceAcknowledgementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetTuTermsOfServiceAcknowledgementsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables>(GetTuTermsOfServiceAcknowledgementsDocument, options);
      }
export function useGetTuTermsOfServiceAcknowledgementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables>(GetTuTermsOfServiceAcknowledgementsDocument, options);
        }
export function useGetTuTermsOfServiceAcknowledgementsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables>(GetTuTermsOfServiceAcknowledgementsDocument, options);
        }
export type GetTuTermsOfServiceAcknowledgementsQueryHookResult = ReturnType<typeof useGetTuTermsOfServiceAcknowledgementsQuery>;
export type GetTuTermsOfServiceAcknowledgementsLazyQueryHookResult = ReturnType<typeof useGetTuTermsOfServiceAcknowledgementsLazyQuery>;
export type GetTuTermsOfServiceAcknowledgementsSuspenseQueryHookResult = ReturnType<typeof useGetTuTermsOfServiceAcknowledgementsSuspenseQuery>;
export type GetTuTermsOfServiceAcknowledgementsQueryResult = ApolloReactCommon.QueryResult<GetTuTermsOfServiceAcknowledgementsQuery, GetTuTermsOfServiceAcknowledgementsQueryVariables>;
export const InitializeCreditProfileDocument = gql`
    mutation InitializeCreditProfile($customer: CreditProfileAuthCustomerInput!) {
  initializeCreditProfile(customer: $customer) {
    ...CreditProfileAuthStatusProfileFragment
  }
}
    ${CreditProfileAuthStatusProfileFragmentFragmentDoc}`;
export type InitializeCreditProfileMutationFn = ApolloReactCommon.MutationFunction<InitializeCreditProfileMutation, InitializeCreditProfileMutationVariables>;
export type InitializeCreditProfileComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<InitializeCreditProfileMutation, InitializeCreditProfileMutationVariables>, 'mutation'>;

    export const InitializeCreditProfileComponent = (props: InitializeCreditProfileComponentProps) => (
      <ApolloReactComponents.Mutation<InitializeCreditProfileMutation, InitializeCreditProfileMutationVariables> mutation={InitializeCreditProfileDocument} {...props} />
    );
    
export type InitializeCreditProfileProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<InitializeCreditProfileMutation, InitializeCreditProfileMutationVariables>
    } & TChildProps;
export function withInitializeCreditProfile<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  InitializeCreditProfileMutation,
  InitializeCreditProfileMutationVariables,
  InitializeCreditProfileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, InitializeCreditProfileMutation, InitializeCreditProfileMutationVariables, InitializeCreditProfileProps<TChildProps, TDataName>>(InitializeCreditProfileDocument, {
      alias: 'initializeCreditProfile',
      ...operationOptions
    });
};

/**
 * __useInitializeCreditProfileMutation__
 *
 * To run a mutation, you first call `useInitializeCreditProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useInitializeCreditProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [initializeCreditProfileMutation, { data, loading, error }] = useInitializeCreditProfileMutation({
 *   variables: {
 *      customer: // value for 'customer'
 *   },
 * });
 */
export function useInitializeCreditProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<InitializeCreditProfileMutation, InitializeCreditProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<InitializeCreditProfileMutation, InitializeCreditProfileMutationVariables>(InitializeCreditProfileDocument, options);
      }
export type InitializeCreditProfileMutationHookResult = ReturnType<typeof useInitializeCreditProfileMutation>;
export type InitializeCreditProfileMutationResult = ApolloReactCommon.MutationResult<InitializeCreditProfileMutation>;
export type InitializeCreditProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<InitializeCreditProfileMutation, InitializeCreditProfileMutationVariables>;
export const AuthenticateCreditProfileQuestionsDocument = gql`
    mutation AuthenticateCreditProfileQuestions($answers: [CreditProfileAuthAnswerInput!]!, $resetPasscode: Boolean) {
  authenticateCreditProfileQuestions(
    answers: $answers
    resetPasscode: $resetPasscode
  ) {
    ...TuCreditReportIdentityProfileFragment
    ...CreditProfileAuthStatusProfileFragment
  }
}
    ${TuCreditReportIdentityProfileFragmentFragmentDoc}
${CreditProfileAuthStatusProfileFragmentFragmentDoc}`;
export type AuthenticateCreditProfileQuestionsMutationFn = ApolloReactCommon.MutationFunction<AuthenticateCreditProfileQuestionsMutation, AuthenticateCreditProfileQuestionsMutationVariables>;
export type AuthenticateCreditProfileQuestionsComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AuthenticateCreditProfileQuestionsMutation, AuthenticateCreditProfileQuestionsMutationVariables>, 'mutation'>;

    export const AuthenticateCreditProfileQuestionsComponent = (props: AuthenticateCreditProfileQuestionsComponentProps) => (
      <ApolloReactComponents.Mutation<AuthenticateCreditProfileQuestionsMutation, AuthenticateCreditProfileQuestionsMutationVariables> mutation={AuthenticateCreditProfileQuestionsDocument} {...props} />
    );
    
export type AuthenticateCreditProfileQuestionsProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AuthenticateCreditProfileQuestionsMutation, AuthenticateCreditProfileQuestionsMutationVariables>
    } & TChildProps;
export function withAuthenticateCreditProfileQuestions<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AuthenticateCreditProfileQuestionsMutation,
  AuthenticateCreditProfileQuestionsMutationVariables,
  AuthenticateCreditProfileQuestionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AuthenticateCreditProfileQuestionsMutation, AuthenticateCreditProfileQuestionsMutationVariables, AuthenticateCreditProfileQuestionsProps<TChildProps, TDataName>>(AuthenticateCreditProfileQuestionsDocument, {
      alias: 'authenticateCreditProfileQuestions',
      ...operationOptions
    });
};

/**
 * __useAuthenticateCreditProfileQuestionsMutation__
 *
 * To run a mutation, you first call `useAuthenticateCreditProfileQuestionsMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAuthenticateCreditProfileQuestionsMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [authenticateCreditProfileQuestionsMutation, { data, loading, error }] = useAuthenticateCreditProfileQuestionsMutation({
 *   variables: {
 *      answers: // value for 'answers'
 *      resetPasscode: // value for 'resetPasscode'
 *   },
 * });
 */
export function useAuthenticateCreditProfileQuestionsMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AuthenticateCreditProfileQuestionsMutation, AuthenticateCreditProfileQuestionsMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AuthenticateCreditProfileQuestionsMutation, AuthenticateCreditProfileQuestionsMutationVariables>(AuthenticateCreditProfileQuestionsDocument, options);
      }
export type AuthenticateCreditProfileQuestionsMutationHookResult = ReturnType<typeof useAuthenticateCreditProfileQuestionsMutation>;
export type AuthenticateCreditProfileQuestionsMutationResult = ApolloReactCommon.MutationResult<AuthenticateCreditProfileQuestionsMutation>;
export type AuthenticateCreditProfileQuestionsMutationOptions = ApolloReactCommon.BaseMutationOptions<AuthenticateCreditProfileQuestionsMutation, AuthenticateCreditProfileQuestionsMutationVariables>;
export const CreateTrustSessionIdDocument = gql`
    mutation CreateTrustSessionId($blackBox: String!) {
  createTrustSessionId(input: {blackBox: $blackBox}) {
    success
  }
}
    `;
export type CreateTrustSessionIdMutationFn = ApolloReactCommon.MutationFunction<CreateTrustSessionIdMutation, CreateTrustSessionIdMutationVariables>;
export type CreateTrustSessionIdComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<CreateTrustSessionIdMutation, CreateTrustSessionIdMutationVariables>, 'mutation'>;

    export const CreateTrustSessionIdComponent = (props: CreateTrustSessionIdComponentProps) => (
      <ApolloReactComponents.Mutation<CreateTrustSessionIdMutation, CreateTrustSessionIdMutationVariables> mutation={CreateTrustSessionIdDocument} {...props} />
    );
    
export type CreateTrustSessionIdProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<CreateTrustSessionIdMutation, CreateTrustSessionIdMutationVariables>
    } & TChildProps;
export function withCreateTrustSessionId<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CreateTrustSessionIdMutation,
  CreateTrustSessionIdMutationVariables,
  CreateTrustSessionIdProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, CreateTrustSessionIdMutation, CreateTrustSessionIdMutationVariables, CreateTrustSessionIdProps<TChildProps, TDataName>>(CreateTrustSessionIdDocument, {
      alias: 'createTrustSessionId',
      ...operationOptions
    });
};

/**
 * __useCreateTrustSessionIdMutation__
 *
 * To run a mutation, you first call `useCreateTrustSessionIdMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateTrustSessionIdMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createTrustSessionIdMutation, { data, loading, error }] = useCreateTrustSessionIdMutation({
 *   variables: {
 *      blackBox: // value for 'blackBox'
 *   },
 * });
 */
export function useCreateTrustSessionIdMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<CreateTrustSessionIdMutation, CreateTrustSessionIdMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<CreateTrustSessionIdMutation, CreateTrustSessionIdMutationVariables>(CreateTrustSessionIdDocument, options);
      }
export type CreateTrustSessionIdMutationHookResult = ReturnType<typeof useCreateTrustSessionIdMutation>;
export type CreateTrustSessionIdMutationResult = ApolloReactCommon.MutationResult<CreateTrustSessionIdMutation>;
export type CreateTrustSessionIdMutationOptions = ApolloReactCommon.BaseMutationOptions<CreateTrustSessionIdMutation, CreateTrustSessionIdMutationVariables>;
export const TuAuthenticationStatusProfileDocument = gql`
    query TuAuthenticationStatusProfile {
  tuAuthenticationStatusProfile {
    ...CreditProfileAuthStatusProfileFragment
  }
}
    ${CreditProfileAuthStatusProfileFragmentFragmentDoc}`;
export type TuAuthenticationStatusProfileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables>, 'query'>;

    export const TuAuthenticationStatusProfileComponent = (props: TuAuthenticationStatusProfileComponentProps) => (
      <ApolloReactComponents.Query<TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables> query={TuAuthenticationStatusProfileDocument} {...props} />
    );
    
export type TuAuthenticationStatusProfileProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables>
    } & TChildProps;
export function withTuAuthenticationStatusProfile<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  TuAuthenticationStatusProfileQuery,
  TuAuthenticationStatusProfileQueryVariables,
  TuAuthenticationStatusProfileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables, TuAuthenticationStatusProfileProps<TChildProps, TDataName>>(TuAuthenticationStatusProfileDocument, {
      alias: 'tuAuthenticationStatusProfile',
      ...operationOptions
    });
};

/**
 * __useTuAuthenticationStatusProfileQuery__
 *
 * To run a query within a React component, call `useTuAuthenticationStatusProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useTuAuthenticationStatusProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTuAuthenticationStatusProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useTuAuthenticationStatusProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables>(TuAuthenticationStatusProfileDocument, options);
      }
export function useTuAuthenticationStatusProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables>(TuAuthenticationStatusProfileDocument, options);
        }
export function useTuAuthenticationStatusProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables>(TuAuthenticationStatusProfileDocument, options);
        }
export type TuAuthenticationStatusProfileQueryHookResult = ReturnType<typeof useTuAuthenticationStatusProfileQuery>;
export type TuAuthenticationStatusProfileLazyQueryHookResult = ReturnType<typeof useTuAuthenticationStatusProfileLazyQuery>;
export type TuAuthenticationStatusProfileSuspenseQueryHookResult = ReturnType<typeof useTuAuthenticationStatusProfileSuspenseQuery>;
export type TuAuthenticationStatusProfileQueryResult = ApolloReactCommon.QueryResult<TuAuthenticationStatusProfileQuery, TuAuthenticationStatusProfileQueryVariables>;
export const EnrollCreditProfileDocument = gql`
    mutation EnrollCreditProfile {
  enrollCreditProfile {
    ...TuCreditReportIdentityProfileFragment
  }
}
    ${TuCreditReportIdentityProfileFragmentFragmentDoc}`;
export type EnrollCreditProfileMutationFn = ApolloReactCommon.MutationFunction<EnrollCreditProfileMutation, EnrollCreditProfileMutationVariables>;
export type EnrollCreditProfileComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EnrollCreditProfileMutation, EnrollCreditProfileMutationVariables>, 'mutation'>;

    export const EnrollCreditProfileComponent = (props: EnrollCreditProfileComponentProps) => (
      <ApolloReactComponents.Mutation<EnrollCreditProfileMutation, EnrollCreditProfileMutationVariables> mutation={EnrollCreditProfileDocument} {...props} />
    );
    
export type EnrollCreditProfileProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<EnrollCreditProfileMutation, EnrollCreditProfileMutationVariables>
    } & TChildProps;
export function withEnrollCreditProfile<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EnrollCreditProfileMutation,
  EnrollCreditProfileMutationVariables,
  EnrollCreditProfileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EnrollCreditProfileMutation, EnrollCreditProfileMutationVariables, EnrollCreditProfileProps<TChildProps, TDataName>>(EnrollCreditProfileDocument, {
      alias: 'enrollCreditProfile',
      ...operationOptions
    });
};

/**
 * __useEnrollCreditProfileMutation__
 *
 * To run a mutation, you first call `useEnrollCreditProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEnrollCreditProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [enrollCreditProfileMutation, { data, loading, error }] = useEnrollCreditProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useEnrollCreditProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EnrollCreditProfileMutation, EnrollCreditProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EnrollCreditProfileMutation, EnrollCreditProfileMutationVariables>(EnrollCreditProfileDocument, options);
      }
export type EnrollCreditProfileMutationHookResult = ReturnType<typeof useEnrollCreditProfileMutation>;
export type EnrollCreditProfileMutationResult = ApolloReactCommon.MutationResult<EnrollCreditProfileMutation>;
export type EnrollCreditProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<EnrollCreditProfileMutation, EnrollCreditProfileMutationVariables>;
export const AcknowledgeTuTermsOfServiceDocument = gql`
    mutation AcknowledgeTuTermsOfService($input: AcknowledgeTermsOfServiceInput!) {
  acknowledgeTermsOfService(input: $input) {
    success
  }
}
    `;
export type AcknowledgeTuTermsOfServiceMutationFn = ApolloReactCommon.MutationFunction<AcknowledgeTuTermsOfServiceMutation, AcknowledgeTuTermsOfServiceMutationVariables>;
export type AcknowledgeTuTermsOfServiceComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AcknowledgeTuTermsOfServiceMutation, AcknowledgeTuTermsOfServiceMutationVariables>, 'mutation'>;

    export const AcknowledgeTuTermsOfServiceComponent = (props: AcknowledgeTuTermsOfServiceComponentProps) => (
      <ApolloReactComponents.Mutation<AcknowledgeTuTermsOfServiceMutation, AcknowledgeTuTermsOfServiceMutationVariables> mutation={AcknowledgeTuTermsOfServiceDocument} {...props} />
    );
    
export type AcknowledgeTuTermsOfServiceProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AcknowledgeTuTermsOfServiceMutation, AcknowledgeTuTermsOfServiceMutationVariables>
    } & TChildProps;
export function withAcknowledgeTuTermsOfService<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AcknowledgeTuTermsOfServiceMutation,
  AcknowledgeTuTermsOfServiceMutationVariables,
  AcknowledgeTuTermsOfServiceProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AcknowledgeTuTermsOfServiceMutation, AcknowledgeTuTermsOfServiceMutationVariables, AcknowledgeTuTermsOfServiceProps<TChildProps, TDataName>>(AcknowledgeTuTermsOfServiceDocument, {
      alias: 'acknowledgeTuTermsOfService',
      ...operationOptions
    });
};

/**
 * __useAcknowledgeTuTermsOfServiceMutation__
 *
 * To run a mutation, you first call `useAcknowledgeTuTermsOfServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAcknowledgeTuTermsOfServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [acknowledgeTuTermsOfServiceMutation, { data, loading, error }] = useAcknowledgeTuTermsOfServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAcknowledgeTuTermsOfServiceMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AcknowledgeTuTermsOfServiceMutation, AcknowledgeTuTermsOfServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AcknowledgeTuTermsOfServiceMutation, AcknowledgeTuTermsOfServiceMutationVariables>(AcknowledgeTuTermsOfServiceDocument, options);
      }
export type AcknowledgeTuTermsOfServiceMutationHookResult = ReturnType<typeof useAcknowledgeTuTermsOfServiceMutation>;
export type AcknowledgeTuTermsOfServiceMutationResult = ApolloReactCommon.MutationResult<AcknowledgeTuTermsOfServiceMutation>;
export type AcknowledgeTuTermsOfServiceMutationOptions = ApolloReactCommon.BaseMutationOptions<AcknowledgeTuTermsOfServiceMutation, AcknowledgeTuTermsOfServiceMutationVariables>;
export const ZendeskUserInfoQueryDocument = gql`
    query ZendeskUserInfoQuery {
  identity {
    email
  }
  globalIdentityProfile {
    firstName
    lastName
  }
}
    `;
export type ZendeskUserInfoQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables>, 'query'>;

    export const ZendeskUserInfoQueryComponent = (props: ZendeskUserInfoQueryComponentProps) => (
      <ApolloReactComponents.Query<ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables> query={ZendeskUserInfoQueryDocument} {...props} />
    );
    
export type ZendeskUserInfoQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables>
    } & TChildProps;
export function withZendeskUserInfoQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ZendeskUserInfoQueryQuery,
  ZendeskUserInfoQueryQueryVariables,
  ZendeskUserInfoQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables, ZendeskUserInfoQueryProps<TChildProps, TDataName>>(ZendeskUserInfoQueryDocument, {
      alias: 'zendeskUserInfoQuery',
      ...operationOptions
    });
};

/**
 * __useZendeskUserInfoQueryQuery__
 *
 * To run a query within a React component, call `useZendeskUserInfoQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useZendeskUserInfoQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useZendeskUserInfoQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useZendeskUserInfoQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables>(ZendeskUserInfoQueryDocument, options);
      }
export function useZendeskUserInfoQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables>(ZendeskUserInfoQueryDocument, options);
        }
export function useZendeskUserInfoQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables>(ZendeskUserInfoQueryDocument, options);
        }
export type ZendeskUserInfoQueryQueryHookResult = ReturnType<typeof useZendeskUserInfoQueryQuery>;
export type ZendeskUserInfoQueryLazyQueryHookResult = ReturnType<typeof useZendeskUserInfoQueryLazyQuery>;
export type ZendeskUserInfoQuerySuspenseQueryHookResult = ReturnType<typeof useZendeskUserInfoQuerySuspenseQuery>;
export type ZendeskUserInfoQueryQueryResult = ApolloReactCommon.QueryResult<ZendeskUserInfoQueryQuery, ZendeskUserInfoQueryQueryVariables>;
export const ExperimentDecisionsDocument = gql`
    query ExperimentDecisions($testNames: [String!]!, $userAttributes: JSON!) {
  experimentDecisions(testNames: $testNames, userAttributes: $userAttributes) {
    experimentName
    assignedVariantName
  }
}
    `;
export type ExperimentDecisionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables>, 'query'> & ({ variables: ExperimentDecisionsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const ExperimentDecisionsComponent = (props: ExperimentDecisionsComponentProps) => (
      <ApolloReactComponents.Query<ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables> query={ExperimentDecisionsDocument} {...props} />
    );
    
export type ExperimentDecisionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables>
    } & TChildProps;
export function withExperimentDecisions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ExperimentDecisionsQuery,
  ExperimentDecisionsQueryVariables,
  ExperimentDecisionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables, ExperimentDecisionsProps<TChildProps, TDataName>>(ExperimentDecisionsDocument, {
      alias: 'experimentDecisions',
      ...operationOptions
    });
};

/**
 * __useExperimentDecisionsQuery__
 *
 * To run a query within a React component, call `useExperimentDecisionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useExperimentDecisionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExperimentDecisionsQuery({
 *   variables: {
 *      testNames: // value for 'testNames'
 *      userAttributes: // value for 'userAttributes'
 *   },
 * });
 */
export function useExperimentDecisionsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables> & ({ variables: ExperimentDecisionsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables>(ExperimentDecisionsDocument, options);
      }
export function useExperimentDecisionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables>(ExperimentDecisionsDocument, options);
        }
export function useExperimentDecisionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables>(ExperimentDecisionsDocument, options);
        }
export type ExperimentDecisionsQueryHookResult = ReturnType<typeof useExperimentDecisionsQuery>;
export type ExperimentDecisionsLazyQueryHookResult = ReturnType<typeof useExperimentDecisionsLazyQuery>;
export type ExperimentDecisionsSuspenseQueryHookResult = ReturnType<typeof useExperimentDecisionsSuspenseQuery>;
export type ExperimentDecisionsQueryResult = ApolloReactCommon.QueryResult<ExperimentDecisionsQuery, ExperimentDecisionsQueryVariables>;
export const GetCanopyTermsOfServiceAgreementsDocument = gql`
    query GetCanopyTermsOfServiceAgreements {
  canopyTermsOfServiceAgreements {
    success
    acknowledgements {
      source
      type
      version
    }
  }
}
    `;
export type GetCanopyTermsOfServiceAgreementsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables>, 'query'>;

    export const GetCanopyTermsOfServiceAgreementsComponent = (props: GetCanopyTermsOfServiceAgreementsComponentProps) => (
      <ApolloReactComponents.Query<GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables> query={GetCanopyTermsOfServiceAgreementsDocument} {...props} />
    );
    
export type GetCanopyTermsOfServiceAgreementsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables>
    } & TChildProps;
export function withGetCanopyTermsOfServiceAgreements<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCanopyTermsOfServiceAgreementsQuery,
  GetCanopyTermsOfServiceAgreementsQueryVariables,
  GetCanopyTermsOfServiceAgreementsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables, GetCanopyTermsOfServiceAgreementsProps<TChildProps, TDataName>>(GetCanopyTermsOfServiceAgreementsDocument, {
      alias: 'getCanopyTermsOfServiceAgreements',
      ...operationOptions
    });
};

/**
 * __useGetCanopyTermsOfServiceAgreementsQuery__
 *
 * To run a query within a React component, call `useGetCanopyTermsOfServiceAgreementsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCanopyTermsOfServiceAgreementsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCanopyTermsOfServiceAgreementsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCanopyTermsOfServiceAgreementsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables>(GetCanopyTermsOfServiceAgreementsDocument, options);
      }
export function useGetCanopyTermsOfServiceAgreementsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables>(GetCanopyTermsOfServiceAgreementsDocument, options);
        }
export function useGetCanopyTermsOfServiceAgreementsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables>(GetCanopyTermsOfServiceAgreementsDocument, options);
        }
export type GetCanopyTermsOfServiceAgreementsQueryHookResult = ReturnType<typeof useGetCanopyTermsOfServiceAgreementsQuery>;
export type GetCanopyTermsOfServiceAgreementsLazyQueryHookResult = ReturnType<typeof useGetCanopyTermsOfServiceAgreementsLazyQuery>;
export type GetCanopyTermsOfServiceAgreementsSuspenseQueryHookResult = ReturnType<typeof useGetCanopyTermsOfServiceAgreementsSuspenseQuery>;
export type GetCanopyTermsOfServiceAgreementsQueryResult = ApolloReactCommon.QueryResult<GetCanopyTermsOfServiceAgreementsQuery, GetCanopyTermsOfServiceAgreementsQueryVariables>;
export const GetCoveredTermsOfServiceAcknowledgementDocument = gql`
    query GetCoveredTermsOfServiceAcknowledgement {
  hasAcknowledgedCoveredTermsOfService {
    acknowledged
  }
}
    `;
export type GetCoveredTermsOfServiceAcknowledgementComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables>, 'query'>;

    export const GetCoveredTermsOfServiceAcknowledgementComponent = (props: GetCoveredTermsOfServiceAcknowledgementComponentProps) => (
      <ApolloReactComponents.Query<GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables> query={GetCoveredTermsOfServiceAcknowledgementDocument} {...props} />
    );
    
export type GetCoveredTermsOfServiceAcknowledgementProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables>
    } & TChildProps;
export function withGetCoveredTermsOfServiceAcknowledgement<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetCoveredTermsOfServiceAcknowledgementQuery,
  GetCoveredTermsOfServiceAcknowledgementQueryVariables,
  GetCoveredTermsOfServiceAcknowledgementProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables, GetCoveredTermsOfServiceAcknowledgementProps<TChildProps, TDataName>>(GetCoveredTermsOfServiceAcknowledgementDocument, {
      alias: 'getCoveredTermsOfServiceAcknowledgement',
      ...operationOptions
    });
};

/**
 * __useGetCoveredTermsOfServiceAcknowledgementQuery__
 *
 * To run a query within a React component, call `useGetCoveredTermsOfServiceAcknowledgementQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCoveredTermsOfServiceAcknowledgementQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCoveredTermsOfServiceAcknowledgementQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetCoveredTermsOfServiceAcknowledgementQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables>(GetCoveredTermsOfServiceAcknowledgementDocument, options);
      }
export function useGetCoveredTermsOfServiceAcknowledgementLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables>(GetCoveredTermsOfServiceAcknowledgementDocument, options);
        }
export function useGetCoveredTermsOfServiceAcknowledgementSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables>(GetCoveredTermsOfServiceAcknowledgementDocument, options);
        }
export type GetCoveredTermsOfServiceAcknowledgementQueryHookResult = ReturnType<typeof useGetCoveredTermsOfServiceAcknowledgementQuery>;
export type GetCoveredTermsOfServiceAcknowledgementLazyQueryHookResult = ReturnType<typeof useGetCoveredTermsOfServiceAcknowledgementLazyQuery>;
export type GetCoveredTermsOfServiceAcknowledgementSuspenseQueryHookResult = ReturnType<typeof useGetCoveredTermsOfServiceAcknowledgementSuspenseQuery>;
export type GetCoveredTermsOfServiceAcknowledgementQueryResult = ApolloReactCommon.QueryResult<GetCoveredTermsOfServiceAcknowledgementQuery, GetCoveredTermsOfServiceAcknowledgementQueryVariables>;
export const GetNwPlusAvailableRewardsDocument = gql`
    query getNwPlusAvailableRewards {
  nwPlusAvailableRewards {
    oneTimeRewards {
      codes
      copy
      dollarValue
      points
      recurringPattern
      tooltipContent
    }
    premiumRewards {
      codes
      copy
      dollarValue
      points
      recurringPattern
      tooltipContent
    }
    recurringRewards {
      codes
      copy
      dollarValue
      points
      recurringPattern
      tooltipContent
    }
  }
}
    `;
export type GetNwPlusAvailableRewardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables>, 'query'>;

    export const GetNwPlusAvailableRewardsComponent = (props: GetNwPlusAvailableRewardsComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables> query={GetNwPlusAvailableRewardsDocument} {...props} />
    );
    
export type GetNwPlusAvailableRewardsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables>
    } & TChildProps;
export function withGetNwPlusAvailableRewards<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusAvailableRewardsQuery,
  GetNwPlusAvailableRewardsQueryVariables,
  GetNwPlusAvailableRewardsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables, GetNwPlusAvailableRewardsProps<TChildProps, TDataName>>(GetNwPlusAvailableRewardsDocument, {
      alias: 'getNwPlusAvailableRewards',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusAvailableRewardsQuery__
 *
 * To run a query within a React component, call `useGetNwPlusAvailableRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusAvailableRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusAvailableRewardsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusAvailableRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables>(GetNwPlusAvailableRewardsDocument, options);
      }
export function useGetNwPlusAvailableRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables>(GetNwPlusAvailableRewardsDocument, options);
        }
export function useGetNwPlusAvailableRewardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables>(GetNwPlusAvailableRewardsDocument, options);
        }
export type GetNwPlusAvailableRewardsQueryHookResult = ReturnType<typeof useGetNwPlusAvailableRewardsQuery>;
export type GetNwPlusAvailableRewardsLazyQueryHookResult = ReturnType<typeof useGetNwPlusAvailableRewardsLazyQuery>;
export type GetNwPlusAvailableRewardsSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusAvailableRewardsSuspenseQuery>;
export type GetNwPlusAvailableRewardsQueryResult = ApolloReactCommon.QueryResult<GetNwPlusAvailableRewardsQuery, GetNwPlusAvailableRewardsQueryVariables>;
export const CoveredQuoteStatusDocument = gql`
    query CoveredQuoteStatus($policyId: ID!) {
  coveredQuoteStatus(policyId: $policyId) {
    status
    quoteUrl
    shoppingFinishId
  }
}
    `;
export type CoveredQuoteStatusComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables>, 'query'> & ({ variables: CoveredQuoteStatusQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const CoveredQuoteStatusComponent = (props: CoveredQuoteStatusComponentProps) => (
      <ApolloReactComponents.Query<CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables> query={CoveredQuoteStatusDocument} {...props} />
    );
    
export type CoveredQuoteStatusProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables>
    } & TChildProps;
export function withCoveredQuoteStatus<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  CoveredQuoteStatusQuery,
  CoveredQuoteStatusQueryVariables,
  CoveredQuoteStatusProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables, CoveredQuoteStatusProps<TChildProps, TDataName>>(CoveredQuoteStatusDocument, {
      alias: 'coveredQuoteStatus',
      ...operationOptions
    });
};

/**
 * __useCoveredQuoteStatusQuery__
 *
 * To run a query within a React component, call `useCoveredQuoteStatusQuery` and pass it any options that fit your needs.
 * When your component renders, `useCoveredQuoteStatusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCoveredQuoteStatusQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useCoveredQuoteStatusQuery(baseOptions: ApolloReactHooks.QueryHookOptions<CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables> & ({ variables: CoveredQuoteStatusQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables>(CoveredQuoteStatusDocument, options);
      }
export function useCoveredQuoteStatusLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables>(CoveredQuoteStatusDocument, options);
        }
export function useCoveredQuoteStatusSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables>(CoveredQuoteStatusDocument, options);
        }
export type CoveredQuoteStatusQueryHookResult = ReturnType<typeof useCoveredQuoteStatusQuery>;
export type CoveredQuoteStatusLazyQueryHookResult = ReturnType<typeof useCoveredQuoteStatusLazyQuery>;
export type CoveredQuoteStatusSuspenseQueryHookResult = ReturnType<typeof useCoveredQuoteStatusSuspenseQuery>;
export type CoveredQuoteStatusQueryResult = ApolloReactCommon.QueryResult<CoveredQuoteStatusQuery, CoveredQuoteStatusQueryVariables>;
export const EmitRewardableEventDocument = gql`
    mutation EmitRewardableEvent($type: String!, $payload: JSON) {
  earnReward(type: $type, payload: $payload) {
    eventId
    status
    points
  }
}
    `;
export type EmitRewardableEventMutationFn = ApolloReactCommon.MutationFunction<EmitRewardableEventMutation, EmitRewardableEventMutationVariables>;
export type EmitRewardableEventComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<EmitRewardableEventMutation, EmitRewardableEventMutationVariables>, 'mutation'>;

    export const EmitRewardableEventComponent = (props: EmitRewardableEventComponentProps) => (
      <ApolloReactComponents.Mutation<EmitRewardableEventMutation, EmitRewardableEventMutationVariables> mutation={EmitRewardableEventDocument} {...props} />
    );
    
export type EmitRewardableEventProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<EmitRewardableEventMutation, EmitRewardableEventMutationVariables>
    } & TChildProps;
export function withEmitRewardableEvent<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EmitRewardableEventMutation,
  EmitRewardableEventMutationVariables,
  EmitRewardableEventProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, EmitRewardableEventMutation, EmitRewardableEventMutationVariables, EmitRewardableEventProps<TChildProps, TDataName>>(EmitRewardableEventDocument, {
      alias: 'emitRewardableEvent',
      ...operationOptions
    });
};

/**
 * __useEmitRewardableEventMutation__
 *
 * To run a mutation, you first call `useEmitRewardableEventMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useEmitRewardableEventMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [emitRewardableEventMutation, { data, loading, error }] = useEmitRewardableEventMutation({
 *   variables: {
 *      type: // value for 'type'
 *      payload: // value for 'payload'
 *   },
 * });
 */
export function useEmitRewardableEventMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<EmitRewardableEventMutation, EmitRewardableEventMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<EmitRewardableEventMutation, EmitRewardableEventMutationVariables>(EmitRewardableEventDocument, options);
      }
export type EmitRewardableEventMutationHookResult = ReturnType<typeof useEmitRewardableEventMutation>;
export type EmitRewardableEventMutationResult = ApolloReactCommon.MutationResult<EmitRewardableEventMutation>;
export type EmitRewardableEventMutationOptions = ApolloReactCommon.BaseMutationOptions<EmitRewardableEventMutation, EmitRewardableEventMutationVariables>;
export const GetClickedBankingOffersDocument = gql`
    query getClickedBankingOffers {
  financialNwPlusRewards {
    bankingAccounts {
      marketplaceBankingOffer {
        id
      }
      shoppingFinishedAt
    }
  }
}
    `;
export type GetClickedBankingOffersComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables>, 'query'>;

    export const GetClickedBankingOffersComponent = (props: GetClickedBankingOffersComponentProps) => (
      <ApolloReactComponents.Query<GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables> query={GetClickedBankingOffersDocument} {...props} />
    );
    
export type GetClickedBankingOffersProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables>
    } & TChildProps;
export function withGetClickedBankingOffers<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetClickedBankingOffersQuery,
  GetClickedBankingOffersQueryVariables,
  GetClickedBankingOffersProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables, GetClickedBankingOffersProps<TChildProps, TDataName>>(GetClickedBankingOffersDocument, {
      alias: 'getClickedBankingOffers',
      ...operationOptions
    });
};

/**
 * __useGetClickedBankingOffersQuery__
 *
 * To run a query within a React component, call `useGetClickedBankingOffersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClickedBankingOffersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClickedBankingOffersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClickedBankingOffersQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables>(GetClickedBankingOffersDocument, options);
      }
export function useGetClickedBankingOffersLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables>(GetClickedBankingOffersDocument, options);
        }
export function useGetClickedBankingOffersSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables>(GetClickedBankingOffersDocument, options);
        }
export type GetClickedBankingOffersQueryHookResult = ReturnType<typeof useGetClickedBankingOffersQuery>;
export type GetClickedBankingOffersLazyQueryHookResult = ReturnType<typeof useGetClickedBankingOffersLazyQuery>;
export type GetClickedBankingOffersSuspenseQueryHookResult = ReturnType<typeof useGetClickedBankingOffersSuspenseQuery>;
export type GetClickedBankingOffersQueryResult = ApolloReactCommon.QueryResult<GetClickedBankingOffersQuery, GetClickedBankingOffersQueryVariables>;
export const AnonymousShoppingEventsDocument = gql`
    query AnonymousShoppingEvents($anonymousId: ID!) {
  anonymousShoppingEvents(anonymousId: $anonymousId) {
    items {
      shoppingFinishedId
      shoppingFinishedAt
      marketplaceInstitutionId
      marketplaceProductId
      marketplaceOfferId
      productType
      nwPlusActivationStatus
    }
  }
}
    `;
export type AnonymousShoppingEventsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables>, 'query'> & ({ variables: AnonymousShoppingEventsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const AnonymousShoppingEventsComponent = (props: AnonymousShoppingEventsComponentProps) => (
      <ApolloReactComponents.Query<AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables> query={AnonymousShoppingEventsDocument} {...props} />
    );
    
export type AnonymousShoppingEventsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables>
    } & TChildProps;
export function withAnonymousShoppingEvents<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AnonymousShoppingEventsQuery,
  AnonymousShoppingEventsQueryVariables,
  AnonymousShoppingEventsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables, AnonymousShoppingEventsProps<TChildProps, TDataName>>(AnonymousShoppingEventsDocument, {
      alias: 'anonymousShoppingEvents',
      ...operationOptions
    });
};

/**
 * __useAnonymousShoppingEventsQuery__
 *
 * To run a query within a React component, call `useAnonymousShoppingEventsQuery` and pass it any options that fit your needs.
 * When your component renders, `useAnonymousShoppingEventsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAnonymousShoppingEventsQuery({
 *   variables: {
 *      anonymousId: // value for 'anonymousId'
 *   },
 * });
 */
export function useAnonymousShoppingEventsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables> & ({ variables: AnonymousShoppingEventsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables>(AnonymousShoppingEventsDocument, options);
      }
export function useAnonymousShoppingEventsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables>(AnonymousShoppingEventsDocument, options);
        }
export function useAnonymousShoppingEventsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables>(AnonymousShoppingEventsDocument, options);
        }
export type AnonymousShoppingEventsQueryHookResult = ReturnType<typeof useAnonymousShoppingEventsQuery>;
export type AnonymousShoppingEventsLazyQueryHookResult = ReturnType<typeof useAnonymousShoppingEventsLazyQuery>;
export type AnonymousShoppingEventsSuspenseQueryHookResult = ReturnType<typeof useAnonymousShoppingEventsSuspenseQuery>;
export type AnonymousShoppingEventsQueryResult = ApolloReactCommon.QueryResult<AnonymousShoppingEventsQuery, AnonymousShoppingEventsQueryVariables>;
export const EligibleBankingAccountsDocument = gql`
    query EligibleBankingAccounts($productType: String!, $query: [MarketplaceQueryInput!]) {
  marketplaceSearch(productType: $productType, query: $query) {
    entities {
      ... on BankingOfferV2 {
        institution {
          id
          name
        }
        product {
          id
          name
        }
        displayName
        id
      }
    }
  }
}
    `;
export type EligibleBankingAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables>, 'query'> & ({ variables: EligibleBankingAccountsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EligibleBankingAccountsComponent = (props: EligibleBankingAccountsComponentProps) => (
      <ApolloReactComponents.Query<EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables> query={EligibleBankingAccountsDocument} {...props} />
    );
    
export type EligibleBankingAccountsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables>
    } & TChildProps;
export function withEligibleBankingAccounts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EligibleBankingAccountsQuery,
  EligibleBankingAccountsQueryVariables,
  EligibleBankingAccountsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables, EligibleBankingAccountsProps<TChildProps, TDataName>>(EligibleBankingAccountsDocument, {
      alias: 'eligibleBankingAccounts',
      ...operationOptions
    });
};

/**
 * __useEligibleBankingAccountsQuery__
 *
 * To run a query within a React component, call `useEligibleBankingAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibleBankingAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibleBankingAccountsQuery({
 *   variables: {
 *      productType: // value for 'productType'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useEligibleBankingAccountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables> & ({ variables: EligibleBankingAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables>(EligibleBankingAccountsDocument, options);
      }
export function useEligibleBankingAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables>(EligibleBankingAccountsDocument, options);
        }
export function useEligibleBankingAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables>(EligibleBankingAccountsDocument, options);
        }
export type EligibleBankingAccountsQueryHookResult = ReturnType<typeof useEligibleBankingAccountsQuery>;
export type EligibleBankingAccountsLazyQueryHookResult = ReturnType<typeof useEligibleBankingAccountsLazyQuery>;
export type EligibleBankingAccountsSuspenseQueryHookResult = ReturnType<typeof useEligibleBankingAccountsSuspenseQuery>;
export type EligibleBankingAccountsQueryResult = ApolloReactCommon.QueryResult<EligibleBankingAccountsQuery, EligibleBankingAccountsQueryVariables>;
export const EligibleBankingNwPlusAccountsDocument = gql`
    query EligibleBankingNWPlusAccounts($productType: String!, $query: [MarketplaceQueryInput!]) {
  marketplaceSearch(productType: $productType, query: $query) {
    entities {
      ... on BankingOfferV2 {
        id
        productType
        status
        federallyInsuredAnnotation
        analyticsProps {
          institutionId
          legacyIssuer
          legacySlug
          offerId
          productId
          hasLegacyImpression
          legacyAdditionalEventData
          legacyVertical
        }
        cta {
          link
          subtext
          text
          type
        }
        displayName
        image {
          alt
          source
        }
        monetizable
        showNameInComparisonTable
        isMonetizing
        placementDrivers {
          description
          id
          label
          value
          valueTooltip
          valueTooltipHasHtml
        }
        versionId
        reviewLink
        starRating
        starRatingTooltip
      }
    }
  }
}
    `;
export type EligibleBankingNwPlusAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables>, 'query'> & ({ variables: EligibleBankingNwPlusAccountsQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const EligibleBankingNwPlusAccountsComponent = (props: EligibleBankingNwPlusAccountsComponentProps) => (
      <ApolloReactComponents.Query<EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables> query={EligibleBankingNwPlusAccountsDocument} {...props} />
    );
    
export type EligibleBankingNwPlusAccountsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables>
    } & TChildProps;
export function withEligibleBankingNwPlusAccounts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  EligibleBankingNwPlusAccountsQuery,
  EligibleBankingNwPlusAccountsQueryVariables,
  EligibleBankingNwPlusAccountsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables, EligibleBankingNwPlusAccountsProps<TChildProps, TDataName>>(EligibleBankingNwPlusAccountsDocument, {
      alias: 'eligibleBankingNwPlusAccounts',
      ...operationOptions
    });
};

/**
 * __useEligibleBankingNwPlusAccountsQuery__
 *
 * To run a query within a React component, call `useEligibleBankingNwPlusAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useEligibleBankingNwPlusAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEligibleBankingNwPlusAccountsQuery({
 *   variables: {
 *      productType: // value for 'productType'
 *      query: // value for 'query'
 *   },
 * });
 */
export function useEligibleBankingNwPlusAccountsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables> & ({ variables: EligibleBankingNwPlusAccountsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables>(EligibleBankingNwPlusAccountsDocument, options);
      }
export function useEligibleBankingNwPlusAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables>(EligibleBankingNwPlusAccountsDocument, options);
        }
export function useEligibleBankingNwPlusAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables>(EligibleBankingNwPlusAccountsDocument, options);
        }
export type EligibleBankingNwPlusAccountsQueryHookResult = ReturnType<typeof useEligibleBankingNwPlusAccountsQuery>;
export type EligibleBankingNwPlusAccountsLazyQueryHookResult = ReturnType<typeof useEligibleBankingNwPlusAccountsLazyQuery>;
export type EligibleBankingNwPlusAccountsSuspenseQueryHookResult = ReturnType<typeof useEligibleBankingNwPlusAccountsSuspenseQuery>;
export type EligibleBankingNwPlusAccountsQueryResult = ApolloReactCommon.QueryResult<EligibleBankingNwPlusAccountsQuery, EligibleBankingNwPlusAccountsQueryVariables>;
export const GetInsurancePullDocument = gql`
    query GetInsurancePull($pullId: ID!) {
  insurancePull(pullId: $pullId) {
    success
    pull {
      id
      carrierName
      friendlyCarrierName
      policies {
        id
        carrierName
        friendlyCarrierName
        isExpired
        policyDurationMonths
        policyType
        totalPremiumCents
      }
      unsupportedPolicies {
        rawValue
        friendlyValue
      }
    }
  }
}
    `;
export type GetInsurancePullComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInsurancePullQuery, GetInsurancePullQueryVariables>, 'query'> & ({ variables: GetInsurancePullQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetInsurancePullComponent = (props: GetInsurancePullComponentProps) => (
      <ApolloReactComponents.Query<GetInsurancePullQuery, GetInsurancePullQueryVariables> query={GetInsurancePullDocument} {...props} />
    );
    
export type GetInsurancePullProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInsurancePullQuery, GetInsurancePullQueryVariables>
    } & TChildProps;
export function withGetInsurancePull<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInsurancePullQuery,
  GetInsurancePullQueryVariables,
  GetInsurancePullProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInsurancePullQuery, GetInsurancePullQueryVariables, GetInsurancePullProps<TChildProps, TDataName>>(GetInsurancePullDocument, {
      alias: 'getInsurancePull',
      ...operationOptions
    });
};

/**
 * __useGetInsurancePullQuery__
 *
 * To run a query within a React component, call `useGetInsurancePullQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePullQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePullQuery({
 *   variables: {
 *      pullId: // value for 'pullId'
 *   },
 * });
 */
export function useGetInsurancePullQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInsurancePullQuery, GetInsurancePullQueryVariables> & ({ variables: GetInsurancePullQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInsurancePullQuery, GetInsurancePullQueryVariables>(GetInsurancePullDocument, options);
      }
export function useGetInsurancePullLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInsurancePullQuery, GetInsurancePullQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInsurancePullQuery, GetInsurancePullQueryVariables>(GetInsurancePullDocument, options);
        }
export function useGetInsurancePullSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInsurancePullQuery, GetInsurancePullQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInsurancePullQuery, GetInsurancePullQueryVariables>(GetInsurancePullDocument, options);
        }
export type GetInsurancePullQueryHookResult = ReturnType<typeof useGetInsurancePullQuery>;
export type GetInsurancePullLazyQueryHookResult = ReturnType<typeof useGetInsurancePullLazyQuery>;
export type GetInsurancePullSuspenseQueryHookResult = ReturnType<typeof useGetInsurancePullSuspenseQuery>;
export type GetInsurancePullQueryResult = ApolloReactCommon.QueryResult<GetInsurancePullQuery, GetInsurancePullQueryVariables>;
export const GetIsNerdWalletPlusMemberDocument = gql`
    query GetIsNerdWalletPlusMember {
  identity {
    id
    isNerdWalletPlusMember
    roles
  }
}
    `;
export type GetIsNerdWalletPlusMemberComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables>, 'query'>;

    export const GetIsNerdWalletPlusMemberComponent = (props: GetIsNerdWalletPlusMemberComponentProps) => (
      <ApolloReactComponents.Query<GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables> query={GetIsNerdWalletPlusMemberDocument} {...props} />
    );
    
export type GetIsNerdWalletPlusMemberProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables>
    } & TChildProps;
export function withGetIsNerdWalletPlusMember<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetIsNerdWalletPlusMemberQuery,
  GetIsNerdWalletPlusMemberQueryVariables,
  GetIsNerdWalletPlusMemberProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables, GetIsNerdWalletPlusMemberProps<TChildProps, TDataName>>(GetIsNerdWalletPlusMemberDocument, {
      alias: 'getIsNerdWalletPlusMember',
      ...operationOptions
    });
};

/**
 * __useGetIsNerdWalletPlusMemberQuery__
 *
 * To run a query within a React component, call `useGetIsNerdWalletPlusMemberQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIsNerdWalletPlusMemberQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIsNerdWalletPlusMemberQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIsNerdWalletPlusMemberQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables>(GetIsNerdWalletPlusMemberDocument, options);
      }
export function useGetIsNerdWalletPlusMemberLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables>(GetIsNerdWalletPlusMemberDocument, options);
        }
export function useGetIsNerdWalletPlusMemberSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables>(GetIsNerdWalletPlusMemberDocument, options);
        }
export type GetIsNerdWalletPlusMemberQueryHookResult = ReturnType<typeof useGetIsNerdWalletPlusMemberQuery>;
export type GetIsNerdWalletPlusMemberLazyQueryHookResult = ReturnType<typeof useGetIsNerdWalletPlusMemberLazyQuery>;
export type GetIsNerdWalletPlusMemberSuspenseQueryHookResult = ReturnType<typeof useGetIsNerdWalletPlusMemberSuspenseQuery>;
export type GetIsNerdWalletPlusMemberQueryResult = ApolloReactCommon.QueryResult<GetIsNerdWalletPlusMemberQuery, GetIsNerdWalletPlusMemberQueryVariables>;
export const GetInvestmentAccountsRewardsDocument = gql`
    query GetInvestmentAccountsRewards($currentDate: DateTime) {
  investmentAccountsNwPlusRewards(currentDate: $currentDate) {
    rewards {
      rewardTypes {
        points
        eventType
      }
      steps {
        title {
          ...RichTextFragment
        }
        tagline {
          ...RichTextFragment
        }
        alertMessage {
          ...RichTextFragment
        }
        extraTagline {
          ...RichTextFragment
        }
        failedTagline {
          ...RichTextFragment
        }
        status
        analyticsStatus
        ctaText {
          ...RichTextFragment
        }
        infoMessage {
          ...RichTextFragment
        }
      }
    }
  }
}
    ${RichTextFragmentFragmentDoc}`;
export type GetInvestmentAccountsRewardsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables>, 'query'>;

    export const GetInvestmentAccountsRewardsComponent = (props: GetInvestmentAccountsRewardsComponentProps) => (
      <ApolloReactComponents.Query<GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables> query={GetInvestmentAccountsRewardsDocument} {...props} />
    );
    
export type GetInvestmentAccountsRewardsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables>
    } & TChildProps;
export function withGetInvestmentAccountsRewards<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInvestmentAccountsRewardsQuery,
  GetInvestmentAccountsRewardsQueryVariables,
  GetInvestmentAccountsRewardsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables, GetInvestmentAccountsRewardsProps<TChildProps, TDataName>>(GetInvestmentAccountsRewardsDocument, {
      alias: 'getInvestmentAccountsRewards',
      ...operationOptions
    });
};

/**
 * __useGetInvestmentAccountsRewardsQuery__
 *
 * To run a query within a React component, call `useGetInvestmentAccountsRewardsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInvestmentAccountsRewardsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInvestmentAccountsRewardsQuery({
 *   variables: {
 *      currentDate: // value for 'currentDate'
 *   },
 * });
 */
export function useGetInvestmentAccountsRewardsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables>(GetInvestmentAccountsRewardsDocument, options);
      }
export function useGetInvestmentAccountsRewardsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables>(GetInvestmentAccountsRewardsDocument, options);
        }
export function useGetInvestmentAccountsRewardsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables>(GetInvestmentAccountsRewardsDocument, options);
        }
export type GetInvestmentAccountsRewardsQueryHookResult = ReturnType<typeof useGetInvestmentAccountsRewardsQuery>;
export type GetInvestmentAccountsRewardsLazyQueryHookResult = ReturnType<typeof useGetInvestmentAccountsRewardsLazyQuery>;
export type GetInvestmentAccountsRewardsSuspenseQueryHookResult = ReturnType<typeof useGetInvestmentAccountsRewardsSuspenseQuery>;
export type GetInvestmentAccountsRewardsQueryResult = ApolloReactCommon.QueryResult<GetInvestmentAccountsRewardsQuery, GetInvestmentAccountsRewardsQueryVariables>;
export const UpdateFinancialNwPlusRewardViewedDocument = gql`
    mutation UpdateFinancialNwPlusRewardViewed($id: ID!, $eventId: ID!) {
  updateFinancialNwPlusRewardViewed(id: $id, eventId: $eventId) {
    creditCard {
      id
      events {
        id
        eventType
        emittedAt
        viewedAt
        pointsRewarded
      }
    }
    bankingAccount {
      id
      events {
        id
        eventType
        emittedAt
        viewedAt
        pointsRewarded
      }
    }
  }
}
    `;
export type UpdateFinancialNwPlusRewardViewedMutationFn = ApolloReactCommon.MutationFunction<UpdateFinancialNwPlusRewardViewedMutation, UpdateFinancialNwPlusRewardViewedMutationVariables>;
export type UpdateFinancialNwPlusRewardViewedComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateFinancialNwPlusRewardViewedMutation, UpdateFinancialNwPlusRewardViewedMutationVariables>, 'mutation'>;

    export const UpdateFinancialNwPlusRewardViewedComponent = (props: UpdateFinancialNwPlusRewardViewedComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateFinancialNwPlusRewardViewedMutation, UpdateFinancialNwPlusRewardViewedMutationVariables> mutation={UpdateFinancialNwPlusRewardViewedDocument} {...props} />
    );
    
export type UpdateFinancialNwPlusRewardViewedProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateFinancialNwPlusRewardViewedMutation, UpdateFinancialNwPlusRewardViewedMutationVariables>
    } & TChildProps;
export function withUpdateFinancialNwPlusRewardViewed<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateFinancialNwPlusRewardViewedMutation,
  UpdateFinancialNwPlusRewardViewedMutationVariables,
  UpdateFinancialNwPlusRewardViewedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateFinancialNwPlusRewardViewedMutation, UpdateFinancialNwPlusRewardViewedMutationVariables, UpdateFinancialNwPlusRewardViewedProps<TChildProps, TDataName>>(UpdateFinancialNwPlusRewardViewedDocument, {
      alias: 'updateFinancialNwPlusRewardViewed',
      ...operationOptions
    });
};

/**
 * __useUpdateFinancialNwPlusRewardViewedMutation__
 *
 * To run a mutation, you first call `useUpdateFinancialNwPlusRewardViewedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateFinancialNwPlusRewardViewedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateFinancialNwPlusRewardViewedMutation, { data, loading, error }] = useUpdateFinancialNwPlusRewardViewedMutation({
 *   variables: {
 *      id: // value for 'id'
 *      eventId: // value for 'eventId'
 *   },
 * });
 */
export function useUpdateFinancialNwPlusRewardViewedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateFinancialNwPlusRewardViewedMutation, UpdateFinancialNwPlusRewardViewedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateFinancialNwPlusRewardViewedMutation, UpdateFinancialNwPlusRewardViewedMutationVariables>(UpdateFinancialNwPlusRewardViewedDocument, options);
      }
export type UpdateFinancialNwPlusRewardViewedMutationHookResult = ReturnType<typeof useUpdateFinancialNwPlusRewardViewedMutation>;
export type UpdateFinancialNwPlusRewardViewedMutationResult = ApolloReactCommon.MutationResult<UpdateFinancialNwPlusRewardViewedMutation>;
export type UpdateFinancialNwPlusRewardViewedMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateFinancialNwPlusRewardViewedMutation, UpdateFinancialNwPlusRewardViewedMutationVariables>;
export const GetRewardEventPointsUseRewardsPointsHookDocument = gql`
    query GetRewardEventPointsUseRewardsPointsHook($eventTypes: [String!], $includeAll: Boolean) {
  rewardEventPoints(eventTypes: $eventTypes, includeAll: $includeAll) {
    rewards {
      eventType
      points
    }
  }
}
    `;
export type GetRewardEventPointsUseRewardsPointsHookComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables>, 'query'>;

    export const GetRewardEventPointsUseRewardsPointsHookComponent = (props: GetRewardEventPointsUseRewardsPointsHookComponentProps) => (
      <ApolloReactComponents.Query<GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables> query={GetRewardEventPointsUseRewardsPointsHookDocument} {...props} />
    );
    
export type GetRewardEventPointsUseRewardsPointsHookProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables>
    } & TChildProps;
export function withGetRewardEventPointsUseRewardsPointsHook<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetRewardEventPointsUseRewardsPointsHookQuery,
  GetRewardEventPointsUseRewardsPointsHookQueryVariables,
  GetRewardEventPointsUseRewardsPointsHookProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables, GetRewardEventPointsUseRewardsPointsHookProps<TChildProps, TDataName>>(GetRewardEventPointsUseRewardsPointsHookDocument, {
      alias: 'getRewardEventPointsUseRewardsPointsHook',
      ...operationOptions
    });
};

/**
 * __useGetRewardEventPointsUseRewardsPointsHookQuery__
 *
 * To run a query within a React component, call `useGetRewardEventPointsUseRewardsPointsHookQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRewardEventPointsUseRewardsPointsHookQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRewardEventPointsUseRewardsPointsHookQuery({
 *   variables: {
 *      eventTypes: // value for 'eventTypes'
 *      includeAll: // value for 'includeAll'
 *   },
 * });
 */
export function useGetRewardEventPointsUseRewardsPointsHookQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables>(GetRewardEventPointsUseRewardsPointsHookDocument, options);
      }
export function useGetRewardEventPointsUseRewardsPointsHookLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables>(GetRewardEventPointsUseRewardsPointsHookDocument, options);
        }
export function useGetRewardEventPointsUseRewardsPointsHookSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables>(GetRewardEventPointsUseRewardsPointsHookDocument, options);
        }
export type GetRewardEventPointsUseRewardsPointsHookQueryHookResult = ReturnType<typeof useGetRewardEventPointsUseRewardsPointsHookQuery>;
export type GetRewardEventPointsUseRewardsPointsHookLazyQueryHookResult = ReturnType<typeof useGetRewardEventPointsUseRewardsPointsHookLazyQuery>;
export type GetRewardEventPointsUseRewardsPointsHookSuspenseQueryHookResult = ReturnType<typeof useGetRewardEventPointsUseRewardsPointsHookSuspenseQuery>;
export type GetRewardEventPointsUseRewardsPointsHookQueryResult = ApolloReactCommon.QueryResult<GetRewardEventPointsUseRewardsPointsHookQuery, GetRewardEventPointsUseRewardsPointsHookQueryVariables>;
export const GetInsurancePolicyRateReportDocument = gql`
    query GetInsurancePolicyRateReport($policyId: ID!, $limit: Int) {
  insurancePolicyRateReport(policyId: $policyId, limit: $limit) {
    rateReport {
      policyId
      updatedAt
      rates {
        id
        annualPremium
        marketplaceProductId
        marketplaceProductName
        marketplaceEntity {
          starRating
          reviewLink
          productBottomLine
          institution {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export type GetInsurancePolicyRateReportComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables>, 'query'> & ({ variables: GetInsurancePolicyRateReportQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetInsurancePolicyRateReportComponent = (props: GetInsurancePolicyRateReportComponentProps) => (
      <ApolloReactComponents.Query<GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables> query={GetInsurancePolicyRateReportDocument} {...props} />
    );
    
export type GetInsurancePolicyRateReportProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables>
    } & TChildProps;
export function withGetInsurancePolicyRateReport<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInsurancePolicyRateReportQuery,
  GetInsurancePolicyRateReportQueryVariables,
  GetInsurancePolicyRateReportProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables, GetInsurancePolicyRateReportProps<TChildProps, TDataName>>(GetInsurancePolicyRateReportDocument, {
      alias: 'getInsurancePolicyRateReport',
      ...operationOptions
    });
};

/**
 * __useGetInsurancePolicyRateReportQuery__
 *
 * To run a query within a React component, call `useGetInsurancePolicyRateReportQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePolicyRateReportQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePolicyRateReportQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      limit: // value for 'limit'
 *   },
 * });
 */
export function useGetInsurancePolicyRateReportQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables> & ({ variables: GetInsurancePolicyRateReportQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables>(GetInsurancePolicyRateReportDocument, options);
      }
export function useGetInsurancePolicyRateReportLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables>(GetInsurancePolicyRateReportDocument, options);
        }
export function useGetInsurancePolicyRateReportSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables>(GetInsurancePolicyRateReportDocument, options);
        }
export type GetInsurancePolicyRateReportQueryHookResult = ReturnType<typeof useGetInsurancePolicyRateReportQuery>;
export type GetInsurancePolicyRateReportLazyQueryHookResult = ReturnType<typeof useGetInsurancePolicyRateReportLazyQuery>;
export type GetInsurancePolicyRateReportSuspenseQueryHookResult = ReturnType<typeof useGetInsurancePolicyRateReportSuspenseQuery>;
export type GetInsurancePolicyRateReportQueryResult = ApolloReactCommon.QueryResult<GetInsurancePolicyRateReportQuery, GetInsurancePolicyRateReportQueryVariables>;
export const BudgetBreakdownByMonthDocument = gql`
    query BudgetBreakdownByMonth($numMonths: Int, $today: DateTime) {
  financialTransactionsBudgetBreakdownByMonth(
    numMonths: $numMonths
    today: $today
  ) {
    budgetBreakdownByMonth {
      year
      month
      bucketBreakdown {
        wants {
          total
          categories {
            amount
            category
            categoryId
          }
          incomePercent
          amountOverGoal
          goal
        }
        needs {
          total
          categories {
            amount
            category
            categoryId
          }
          incomePercent
          amountOverGoal
          goal
        }
        savingsAndDebt {
          total
          categories {
            amount
            category
            categoryId
          }
          incomePercent
          amountOverGoal
          goal
        }
      }
      spend
      saved
      income
      isInGuidelines
    }
  }
}
    `;
export type BudgetBreakdownByMonthComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables>, 'query'>;

    export const BudgetBreakdownByMonthComponent = (props: BudgetBreakdownByMonthComponentProps) => (
      <ApolloReactComponents.Query<BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables> query={BudgetBreakdownByMonthDocument} {...props} />
    );
    
export type BudgetBreakdownByMonthProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables>
    } & TChildProps;
export function withBudgetBreakdownByMonth<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BudgetBreakdownByMonthQuery,
  BudgetBreakdownByMonthQueryVariables,
  BudgetBreakdownByMonthProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables, BudgetBreakdownByMonthProps<TChildProps, TDataName>>(BudgetBreakdownByMonthDocument, {
      alias: 'budgetBreakdownByMonth',
      ...operationOptions
    });
};

/**
 * __useBudgetBreakdownByMonthQuery__
 *
 * To run a query within a React component, call `useBudgetBreakdownByMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useBudgetBreakdownByMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBudgetBreakdownByMonthQuery({
 *   variables: {
 *      numMonths: // value for 'numMonths'
 *      today: // value for 'today'
 *   },
 * });
 */
export function useBudgetBreakdownByMonthQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables>(BudgetBreakdownByMonthDocument, options);
      }
export function useBudgetBreakdownByMonthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables>(BudgetBreakdownByMonthDocument, options);
        }
export function useBudgetBreakdownByMonthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables>(BudgetBreakdownByMonthDocument, options);
        }
export type BudgetBreakdownByMonthQueryHookResult = ReturnType<typeof useBudgetBreakdownByMonthQuery>;
export type BudgetBreakdownByMonthLazyQueryHookResult = ReturnType<typeof useBudgetBreakdownByMonthLazyQuery>;
export type BudgetBreakdownByMonthSuspenseQueryHookResult = ReturnType<typeof useBudgetBreakdownByMonthSuspenseQuery>;
export type BudgetBreakdownByMonthQueryResult = ApolloReactCommon.QueryResult<BudgetBreakdownByMonthQuery, BudgetBreakdownByMonthQueryVariables>;
export const GetFinancialTransactionCategoriesDocument = gql`
    query GetFinancialTransactionCategories {
  financialTransactionCategories {
    categories {
      id
      iconUri
      displayName
    }
  }
}
    `;
export type GetFinancialTransactionCategoriesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables>, 'query'>;

    export const GetFinancialTransactionCategoriesComponent = (props: GetFinancialTransactionCategoriesComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables> query={GetFinancialTransactionCategoriesDocument} {...props} />
    );
    
export type GetFinancialTransactionCategoriesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables>
    } & TChildProps;
export function withGetFinancialTransactionCategories<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialTransactionCategoriesQuery,
  GetFinancialTransactionCategoriesQueryVariables,
  GetFinancialTransactionCategoriesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables, GetFinancialTransactionCategoriesProps<TChildProps, TDataName>>(GetFinancialTransactionCategoriesDocument, {
      alias: 'getFinancialTransactionCategories',
      ...operationOptions
    });
};

/**
 * __useGetFinancialTransactionCategoriesQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionCategoriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionCategoriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionCategoriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancialTransactionCategoriesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables>(GetFinancialTransactionCategoriesDocument, options);
      }
export function useGetFinancialTransactionCategoriesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables>(GetFinancialTransactionCategoriesDocument, options);
        }
export function useGetFinancialTransactionCategoriesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables>(GetFinancialTransactionCategoriesDocument, options);
        }
export type GetFinancialTransactionCategoriesQueryHookResult = ReturnType<typeof useGetFinancialTransactionCategoriesQuery>;
export type GetFinancialTransactionCategoriesLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionCategoriesLazyQuery>;
export type GetFinancialTransactionCategoriesSuspenseQueryHookResult = ReturnType<typeof useGetFinancialTransactionCategoriesSuspenseQuery>;
export type GetFinancialTransactionCategoriesQueryResult = ApolloReactCommon.QueryResult<GetFinancialTransactionCategoriesQuery, GetFinancialTransactionCategoriesQueryVariables>;
export const GetFeatureFlagDocument = gql`
    query GetFeatureFlag($name: String!) {
  featureFlag(featureFlagName: $name) {
    name
    value
  }
}
    `;
export type GetFeatureFlagComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>, 'query'> & ({ variables: GetFeatureFlagQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFeatureFlagComponent = (props: GetFeatureFlagComponentProps) => (
      <ApolloReactComponents.Query<GetFeatureFlagQuery, GetFeatureFlagQueryVariables> query={GetFeatureFlagDocument} {...props} />
    );
    
export type GetFeatureFlagProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>
    } & TChildProps;
export function withGetFeatureFlag<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFeatureFlagQuery,
  GetFeatureFlagQueryVariables,
  GetFeatureFlagProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFeatureFlagQuery, GetFeatureFlagQueryVariables, GetFeatureFlagProps<TChildProps, TDataName>>(GetFeatureFlagDocument, {
      alias: 'getFeatureFlag',
      ...operationOptions
    });
};

/**
 * __useGetFeatureFlagQuery__
 *
 * To run a query within a React component, call `useGetFeatureFlagQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFeatureFlagQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFeatureFlagQuery({
 *   variables: {
 *      name: // value for 'name'
 *   },
 * });
 */
export function useGetFeatureFlagQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables> & ({ variables: GetFeatureFlagQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
      }
export function useGetFeatureFlagLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
        }
export function useGetFeatureFlagSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>(GetFeatureFlagDocument, options);
        }
export type GetFeatureFlagQueryHookResult = ReturnType<typeof useGetFeatureFlagQuery>;
export type GetFeatureFlagLazyQueryHookResult = ReturnType<typeof useGetFeatureFlagLazyQuery>;
export type GetFeatureFlagSuspenseQueryHookResult = ReturnType<typeof useGetFeatureFlagSuspenseQuery>;
export type GetFeatureFlagQueryResult = ApolloReactCommon.QueryResult<GetFeatureFlagQuery, GetFeatureFlagQueryVariables>;
export const GetScopesForMfaMiddlewareDocument = gql`
    query GetScopesForMfaMiddleware {
  identity {
    id
    isNerdWalletPlusMember
    scopes
    roles
  }
}
    `;
export type GetScopesForMfaMiddlewareComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables>, 'query'>;

    export const GetScopesForMfaMiddlewareComponent = (props: GetScopesForMfaMiddlewareComponentProps) => (
      <ApolloReactComponents.Query<GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables> query={GetScopesForMfaMiddlewareDocument} {...props} />
    );
    
export type GetScopesForMfaMiddlewareProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables>
    } & TChildProps;
export function withGetScopesForMfaMiddleware<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetScopesForMfaMiddlewareQuery,
  GetScopesForMfaMiddlewareQueryVariables,
  GetScopesForMfaMiddlewareProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables, GetScopesForMfaMiddlewareProps<TChildProps, TDataName>>(GetScopesForMfaMiddlewareDocument, {
      alias: 'getScopesForMfaMiddleware',
      ...operationOptions
    });
};

/**
 * __useGetScopesForMfaMiddlewareQuery__
 *
 * To run a query within a React component, call `useGetScopesForMfaMiddlewareQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScopesForMfaMiddlewareQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScopesForMfaMiddlewareQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetScopesForMfaMiddlewareQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables>(GetScopesForMfaMiddlewareDocument, options);
      }
export function useGetScopesForMfaMiddlewareLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables>(GetScopesForMfaMiddlewareDocument, options);
        }
export function useGetScopesForMfaMiddlewareSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables>(GetScopesForMfaMiddlewareDocument, options);
        }
export type GetScopesForMfaMiddlewareQueryHookResult = ReturnType<typeof useGetScopesForMfaMiddlewareQuery>;
export type GetScopesForMfaMiddlewareLazyQueryHookResult = ReturnType<typeof useGetScopesForMfaMiddlewareLazyQuery>;
export type GetScopesForMfaMiddlewareSuspenseQueryHookResult = ReturnType<typeof useGetScopesForMfaMiddlewareSuspenseQuery>;
export type GetScopesForMfaMiddlewareQueryResult = ApolloReactCommon.QueryResult<GetScopesForMfaMiddlewareQuery, GetScopesForMfaMiddlewareQueryVariables>;
export const BankingOfferQueryDocument = gql`
    query bankingOfferQuery($namedQuery: String!) {
  marketplaceSearch(
    entityType: "OFFERS"
    productType: "BANKING"
    namedQuery: $namedQuery
  ) {
    entities {
      ... on BankingOfferV2 {
        id
        productType
        status
        federallyInsuredAnnotation
        analyticsProps {
          institutionId
          legacyIssuer
          legacySlug
          offerId
          productId
          hasLegacyImpression
          legacyAdditionalEventData
          legacyVertical
        }
        cta {
          link
          subtext
          text
          type
        }
        displayName
        image {
          alt
          source
        }
        monetizable
        showNameInComparisonTable
        isMonetizing
        placementDrivers {
          description
          id
          label
          value
          valueTooltip
          valueTooltipHasHtml
        }
        versionId
        reviewLink
        starRating
        starRatingTooltip
      }
    }
  }
}
    `;
export type BankingOfferQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<BankingOfferQueryQuery, BankingOfferQueryQueryVariables>, 'query'> & ({ variables: BankingOfferQueryQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const BankingOfferQueryComponent = (props: BankingOfferQueryComponentProps) => (
      <ApolloReactComponents.Query<BankingOfferQueryQuery, BankingOfferQueryQueryVariables> query={BankingOfferQueryDocument} {...props} />
    );
    
export type BankingOfferQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<BankingOfferQueryQuery, BankingOfferQueryQueryVariables>
    } & TChildProps;
export function withBankingOfferQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  BankingOfferQueryQuery,
  BankingOfferQueryQueryVariables,
  BankingOfferQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, BankingOfferQueryQuery, BankingOfferQueryQueryVariables, BankingOfferQueryProps<TChildProps, TDataName>>(BankingOfferQueryDocument, {
      alias: 'bankingOfferQuery',
      ...operationOptions
    });
};

/**
 * __useBankingOfferQueryQuery__
 *
 * To run a query within a React component, call `useBankingOfferQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useBankingOfferQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useBankingOfferQueryQuery({
 *   variables: {
 *      namedQuery: // value for 'namedQuery'
 *   },
 * });
 */
export function useBankingOfferQueryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<BankingOfferQueryQuery, BankingOfferQueryQueryVariables> & ({ variables: BankingOfferQueryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<BankingOfferQueryQuery, BankingOfferQueryQueryVariables>(BankingOfferQueryDocument, options);
      }
export function useBankingOfferQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<BankingOfferQueryQuery, BankingOfferQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<BankingOfferQueryQuery, BankingOfferQueryQueryVariables>(BankingOfferQueryDocument, options);
        }
export function useBankingOfferQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<BankingOfferQueryQuery, BankingOfferQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<BankingOfferQueryQuery, BankingOfferQueryQueryVariables>(BankingOfferQueryDocument, options);
        }
export type BankingOfferQueryQueryHookResult = ReturnType<typeof useBankingOfferQueryQuery>;
export type BankingOfferQueryLazyQueryHookResult = ReturnType<typeof useBankingOfferQueryLazyQuery>;
export type BankingOfferQuerySuspenseQueryHookResult = ReturnType<typeof useBankingOfferQuerySuspenseQuery>;
export type BankingOfferQueryQueryResult = ApolloReactCommon.QueryResult<BankingOfferQueryQuery, BankingOfferQueryQueryVariables>;
export const GetInsurancePolicyDocument = gql`
    query GetInsurancePolicy($policyId: ID!) {
  insurancePolicy(policyId: $policyId) {
    success
    policy {
      id
      name
      carrierName
      policyType
      policyDurationMonths
      effectiveDate
      expiryDate
      isExpired
      totalPremiumCents
      monthlyPremiumCents
      updatedAt
      vehicles {
        garagingAddress {
          zip
          state
        }
      }
      dwellings {
        id
        address {
          state
        }
      }
    }
  }
  insurancePolicyOverrides(policyId: $policyId) {
    id
    overrides {
      policy {
        zipCode
      }
    }
  }
}
    `;
export type GetInsurancePolicyComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables>, 'query'> & ({ variables: GetInsurancePolicyQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetInsurancePolicyComponent = (props: GetInsurancePolicyComponentProps) => (
      <ApolloReactComponents.Query<GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables> query={GetInsurancePolicyDocument} {...props} />
    );
    
export type GetInsurancePolicyProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables>
    } & TChildProps;
export function withGetInsurancePolicy<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInsurancePolicyQuery,
  GetInsurancePolicyQueryVariables,
  GetInsurancePolicyProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables, GetInsurancePolicyProps<TChildProps, TDataName>>(GetInsurancePolicyDocument, {
      alias: 'getInsurancePolicy',
      ...operationOptions
    });
};

/**
 * __useGetInsurancePolicyQuery__
 *
 * To run a query within a React component, call `useGetInsurancePolicyQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePolicyQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePolicyQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetInsurancePolicyQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables> & ({ variables: GetInsurancePolicyQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables>(GetInsurancePolicyDocument, options);
      }
export function useGetInsurancePolicyLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables>(GetInsurancePolicyDocument, options);
        }
export function useGetInsurancePolicySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables>(GetInsurancePolicyDocument, options);
        }
export type GetInsurancePolicyQueryHookResult = ReturnType<typeof useGetInsurancePolicyQuery>;
export type GetInsurancePolicyLazyQueryHookResult = ReturnType<typeof useGetInsurancePolicyLazyQuery>;
export type GetInsurancePolicySuspenseQueryHookResult = ReturnType<typeof useGetInsurancePolicySuspenseQuery>;
export type GetInsurancePolicyQueryResult = ApolloReactCommon.QueryResult<GetInsurancePolicyQuery, GetInsurancePolicyQueryVariables>;
export const GetInsurancePolicyOverridesDocument = gql`
    query GetInsurancePolicyOverrides($policyId: ID!) {
  tuCreditReportIdentityProfile {
    vantageScore3
  }
  insurancePolicyOverrides(policyId: $policyId) {
    id
    policy {
      id
      type
    }
    overrides {
      global {
        birthdate
        creditScore
        gender
      }
      policy {
        carYear
        carMake
        carModel
        zipCode
        yearBuilt
      }
    }
  }
}
    `;
export type GetInsurancePolicyOverridesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables>, 'query'> & ({ variables: GetInsurancePolicyOverridesQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetInsurancePolicyOverridesComponent = (props: GetInsurancePolicyOverridesComponentProps) => (
      <ApolloReactComponents.Query<GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables> query={GetInsurancePolicyOverridesDocument} {...props} />
    );
    
export type GetInsurancePolicyOverridesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables>
    } & TChildProps;
export function withGetInsurancePolicyOverrides<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetInsurancePolicyOverridesQuery,
  GetInsurancePolicyOverridesQueryVariables,
  GetInsurancePolicyOverridesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables, GetInsurancePolicyOverridesProps<TChildProps, TDataName>>(GetInsurancePolicyOverridesDocument, {
      alias: 'getInsurancePolicyOverrides',
      ...operationOptions
    });
};

/**
 * __useGetInsurancePolicyOverridesQuery__
 *
 * To run a query within a React component, call `useGetInsurancePolicyOverridesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetInsurancePolicyOverridesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetInsurancePolicyOverridesQuery({
 *   variables: {
 *      policyId: // value for 'policyId'
 *   },
 * });
 */
export function useGetInsurancePolicyOverridesQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables> & ({ variables: GetInsurancePolicyOverridesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables>(GetInsurancePolicyOverridesDocument, options);
      }
export function useGetInsurancePolicyOverridesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables>(GetInsurancePolicyOverridesDocument, options);
        }
export function useGetInsurancePolicyOverridesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables>(GetInsurancePolicyOverridesDocument, options);
        }
export type GetInsurancePolicyOverridesQueryHookResult = ReturnType<typeof useGetInsurancePolicyOverridesQuery>;
export type GetInsurancePolicyOverridesLazyQueryHookResult = ReturnType<typeof useGetInsurancePolicyOverridesLazyQuery>;
export type GetInsurancePolicyOverridesSuspenseQueryHookResult = ReturnType<typeof useGetInsurancePolicyOverridesSuspenseQuery>;
export type GetInsurancePolicyOverridesQueryResult = ApolloReactCommon.QueryResult<GetInsurancePolicyOverridesQuery, GetInsurancePolicyOverridesQueryVariables>;
export const UpdateInsurancePolicyOverridesDocument = gql`
    mutation UpdateInsurancePolicyOverrides($policyId: ID!, $globalOverrides: GlobalInsurancePolicyOverridesInput!, $localOverrides: LocalInsurancePolicyOverridesInput!) {
  updateInsurancePolicyOverrides(
    policyId: $policyId
    globalOverrides: $globalOverrides
    localOverrides: $localOverrides
  ) {
    id
    policy {
      id
      type
    }
    overrides {
      global {
        birthdate
        creditScore
        gender
      }
      policy {
        carYear
        carMake
        carModel
        yearBuilt
        zipCode
      }
    }
  }
}
    `;
export type UpdateInsurancePolicyOverridesMutationFn = ApolloReactCommon.MutationFunction<UpdateInsurancePolicyOverridesMutation, UpdateInsurancePolicyOverridesMutationVariables>;
export type UpdateInsurancePolicyOverridesComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<UpdateInsurancePolicyOverridesMutation, UpdateInsurancePolicyOverridesMutationVariables>, 'mutation'>;

    export const UpdateInsurancePolicyOverridesComponent = (props: UpdateInsurancePolicyOverridesComponentProps) => (
      <ApolloReactComponents.Mutation<UpdateInsurancePolicyOverridesMutation, UpdateInsurancePolicyOverridesMutationVariables> mutation={UpdateInsurancePolicyOverridesDocument} {...props} />
    );
    
export type UpdateInsurancePolicyOverridesProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<UpdateInsurancePolicyOverridesMutation, UpdateInsurancePolicyOverridesMutationVariables>
    } & TChildProps;
export function withUpdateInsurancePolicyOverrides<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  UpdateInsurancePolicyOverridesMutation,
  UpdateInsurancePolicyOverridesMutationVariables,
  UpdateInsurancePolicyOverridesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, UpdateInsurancePolicyOverridesMutation, UpdateInsurancePolicyOverridesMutationVariables, UpdateInsurancePolicyOverridesProps<TChildProps, TDataName>>(UpdateInsurancePolicyOverridesDocument, {
      alias: 'updateInsurancePolicyOverrides',
      ...operationOptions
    });
};

/**
 * __useUpdateInsurancePolicyOverridesMutation__
 *
 * To run a mutation, you first call `useUpdateInsurancePolicyOverridesMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateInsurancePolicyOverridesMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateInsurancePolicyOverridesMutation, { data, loading, error }] = useUpdateInsurancePolicyOverridesMutation({
 *   variables: {
 *      policyId: // value for 'policyId'
 *      globalOverrides: // value for 'globalOverrides'
 *      localOverrides: // value for 'localOverrides'
 *   },
 * });
 */
export function useUpdateInsurancePolicyOverridesMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<UpdateInsurancePolicyOverridesMutation, UpdateInsurancePolicyOverridesMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<UpdateInsurancePolicyOverridesMutation, UpdateInsurancePolicyOverridesMutationVariables>(UpdateInsurancePolicyOverridesDocument, options);
      }
export type UpdateInsurancePolicyOverridesMutationHookResult = ReturnType<typeof useUpdateInsurancePolicyOverridesMutation>;
export type UpdateInsurancePolicyOverridesMutationResult = ApolloReactCommon.MutationResult<UpdateInsurancePolicyOverridesMutation>;
export type UpdateInsurancePolicyOverridesMutationOptions = ApolloReactCommon.BaseMutationOptions<UpdateInsurancePolicyOverridesMutation, UpdateInsurancePolicyOverridesMutationVariables>;
export const GetFinancialPrioritiesDocument = gql`
    query GetFinancialPriorities {
  financialPriorities {
    id
    ...FinancialPrioritiesFragment
  }
}
    ${FinancialPrioritiesFragmentFragmentDoc}`;
export type GetFinancialPrioritiesComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables>, 'query'>;

    export const GetFinancialPrioritiesComponent = (props: GetFinancialPrioritiesComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables> query={GetFinancialPrioritiesDocument} {...props} />
    );
    
export type GetFinancialPrioritiesProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables>
    } & TChildProps;
export function withGetFinancialPriorities<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialPrioritiesQuery,
  GetFinancialPrioritiesQueryVariables,
  GetFinancialPrioritiesProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables, GetFinancialPrioritiesProps<TChildProps, TDataName>>(GetFinancialPrioritiesDocument, {
      alias: 'getFinancialPriorities',
      ...operationOptions
    });
};

/**
 * __useGetFinancialPrioritiesQuery__
 *
 * To run a query within a React component, call `useGetFinancialPrioritiesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialPrioritiesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialPrioritiesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancialPrioritiesQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables>(GetFinancialPrioritiesDocument, options);
      }
export function useGetFinancialPrioritiesLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables>(GetFinancialPrioritiesDocument, options);
        }
export function useGetFinancialPrioritiesSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables>(GetFinancialPrioritiesDocument, options);
        }
export type GetFinancialPrioritiesQueryHookResult = ReturnType<typeof useGetFinancialPrioritiesQuery>;
export type GetFinancialPrioritiesLazyQueryHookResult = ReturnType<typeof useGetFinancialPrioritiesLazyQuery>;
export type GetFinancialPrioritiesSuspenseQueryHookResult = ReturnType<typeof useGetFinancialPrioritiesSuspenseQuery>;
export type GetFinancialPrioritiesQueryResult = ApolloReactCommon.QueryResult<GetFinancialPrioritiesQuery, GetFinancialPrioritiesQueryVariables>;
export const AddNetWorthHomeIntegratedDocument = gql`
    mutation AddNetWorthHomeIntegrated($address: NetWorthHomeIntegratedAddressInput!, $externalInfo: NetWorthHomeIntegratedExternalInfoInput!) {
  addNetWorthHomeIntegrated(address: $address, externalInfo: $externalInfo) {
    asset {
      id
      type
      isHiddenFromNetWorth
      amount
      lastReportedOrSyncedAt
      address {
        addressLine1
        addressLine2
        city
        state
        zipCode
      }
      externalInfo {
        source
        value
      }
      isSelfReported
    }
  }
}
    `;
export type AddNetWorthHomeIntegratedMutationFn = ApolloReactCommon.MutationFunction<AddNetWorthHomeIntegratedMutation, AddNetWorthHomeIntegratedMutationVariables>;
export type AddNetWorthHomeIntegratedComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddNetWorthHomeIntegratedMutation, AddNetWorthHomeIntegratedMutationVariables>, 'mutation'>;

    export const AddNetWorthHomeIntegratedComponent = (props: AddNetWorthHomeIntegratedComponentProps) => (
      <ApolloReactComponents.Mutation<AddNetWorthHomeIntegratedMutation, AddNetWorthHomeIntegratedMutationVariables> mutation={AddNetWorthHomeIntegratedDocument} {...props} />
    );
    
export type AddNetWorthHomeIntegratedProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddNetWorthHomeIntegratedMutation, AddNetWorthHomeIntegratedMutationVariables>
    } & TChildProps;
export function withAddNetWorthHomeIntegrated<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddNetWorthHomeIntegratedMutation,
  AddNetWorthHomeIntegratedMutationVariables,
  AddNetWorthHomeIntegratedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddNetWorthHomeIntegratedMutation, AddNetWorthHomeIntegratedMutationVariables, AddNetWorthHomeIntegratedProps<TChildProps, TDataName>>(AddNetWorthHomeIntegratedDocument, {
      alias: 'addNetWorthHomeIntegrated',
      ...operationOptions
    });
};

/**
 * __useAddNetWorthHomeIntegratedMutation__
 *
 * To run a mutation, you first call `useAddNetWorthHomeIntegratedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNetWorthHomeIntegratedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNetWorthHomeIntegratedMutation, { data, loading, error }] = useAddNetWorthHomeIntegratedMutation({
 *   variables: {
 *      address: // value for 'address'
 *      externalInfo: // value for 'externalInfo'
 *   },
 * });
 */
export function useAddNetWorthHomeIntegratedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNetWorthHomeIntegratedMutation, AddNetWorthHomeIntegratedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddNetWorthHomeIntegratedMutation, AddNetWorthHomeIntegratedMutationVariables>(AddNetWorthHomeIntegratedDocument, options);
      }
export type AddNetWorthHomeIntegratedMutationHookResult = ReturnType<typeof useAddNetWorthHomeIntegratedMutation>;
export type AddNetWorthHomeIntegratedMutationResult = ApolloReactCommon.MutationResult<AddNetWorthHomeIntegratedMutation>;
export type AddNetWorthHomeIntegratedMutationOptions = ApolloReactCommon.BaseMutationOptions<AddNetWorthHomeIntegratedMutation, AddNetWorthHomeIntegratedMutationVariables>;
export const AddNetWorthRealAssetSelfReportedDocument = gql`
    mutation AddNetWorthRealAssetSelfReported($type: NetWorthRealAssetTypeEnum!, $amount: Float!, $nickname: String!) {
  addNetWorthRealAssetSelfReported(
    type: $type
    amount: $amount
    nickname: $nickname
  ) {
    asset {
      id
      type
      isHiddenFromNetWorth
      amount
      lastReportedOrSyncedAt
      nickname
      isSelfReported
    }
  }
}
    `;
export type AddNetWorthRealAssetSelfReportedMutationFn = ApolloReactCommon.MutationFunction<AddNetWorthRealAssetSelfReportedMutation, AddNetWorthRealAssetSelfReportedMutationVariables>;
export type AddNetWorthRealAssetSelfReportedComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<AddNetWorthRealAssetSelfReportedMutation, AddNetWorthRealAssetSelfReportedMutationVariables>, 'mutation'>;

    export const AddNetWorthRealAssetSelfReportedComponent = (props: AddNetWorthRealAssetSelfReportedComponentProps) => (
      <ApolloReactComponents.Mutation<AddNetWorthRealAssetSelfReportedMutation, AddNetWorthRealAssetSelfReportedMutationVariables> mutation={AddNetWorthRealAssetSelfReportedDocument} {...props} />
    );
    
export type AddNetWorthRealAssetSelfReportedProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<AddNetWorthRealAssetSelfReportedMutation, AddNetWorthRealAssetSelfReportedMutationVariables>
    } & TChildProps;
export function withAddNetWorthRealAssetSelfReported<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  AddNetWorthRealAssetSelfReportedMutation,
  AddNetWorthRealAssetSelfReportedMutationVariables,
  AddNetWorthRealAssetSelfReportedProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, AddNetWorthRealAssetSelfReportedMutation, AddNetWorthRealAssetSelfReportedMutationVariables, AddNetWorthRealAssetSelfReportedProps<TChildProps, TDataName>>(AddNetWorthRealAssetSelfReportedDocument, {
      alias: 'addNetWorthRealAssetSelfReported',
      ...operationOptions
    });
};

/**
 * __useAddNetWorthRealAssetSelfReportedMutation__
 *
 * To run a mutation, you first call `useAddNetWorthRealAssetSelfReportedMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddNetWorthRealAssetSelfReportedMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addNetWorthRealAssetSelfReportedMutation, { data, loading, error }] = useAddNetWorthRealAssetSelfReportedMutation({
 *   variables: {
 *      type: // value for 'type'
 *      amount: // value for 'amount'
 *      nickname: // value for 'nickname'
 *   },
 * });
 */
export function useAddNetWorthRealAssetSelfReportedMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AddNetWorthRealAssetSelfReportedMutation, AddNetWorthRealAssetSelfReportedMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AddNetWorthRealAssetSelfReportedMutation, AddNetWorthRealAssetSelfReportedMutationVariables>(AddNetWorthRealAssetSelfReportedDocument, options);
      }
export type AddNetWorthRealAssetSelfReportedMutationHookResult = ReturnType<typeof useAddNetWorthRealAssetSelfReportedMutation>;
export type AddNetWorthRealAssetSelfReportedMutationResult = ApolloReactCommon.MutationResult<AddNetWorthRealAssetSelfReportedMutation>;
export type AddNetWorthRealAssetSelfReportedMutationOptions = ApolloReactCommon.BaseMutationOptions<AddNetWorthRealAssetSelfReportedMutation, AddNetWorthRealAssetSelfReportedMutationVariables>;
export const DeactivateCreditProfileDocument = gql`
    mutation DeactivateCreditProfile {
  deactivateCreditProfile {
    ...CreditProfileAuthStatusProfileFragment
  }
}
    ${CreditProfileAuthStatusProfileFragmentFragmentDoc}`;
export type DeactivateCreditProfileMutationFn = ApolloReactCommon.MutationFunction<DeactivateCreditProfileMutation, DeactivateCreditProfileMutationVariables>;
export type DeactivateCreditProfileComponentProps = Omit<ApolloReactComponents.MutationComponentOptions<DeactivateCreditProfileMutation, DeactivateCreditProfileMutationVariables>, 'mutation'>;

    export const DeactivateCreditProfileComponent = (props: DeactivateCreditProfileComponentProps) => (
      <ApolloReactComponents.Mutation<DeactivateCreditProfileMutation, DeactivateCreditProfileMutationVariables> mutation={DeactivateCreditProfileDocument} {...props} />
    );
    
export type DeactivateCreditProfileProps<TChildProps = {}, TDataName extends string = 'mutate'> = {
      [key in TDataName]: ApolloReactCommon.MutationFunction<DeactivateCreditProfileMutation, DeactivateCreditProfileMutationVariables>
    } & TChildProps;
export function withDeactivateCreditProfile<TProps, TChildProps = {}, TDataName extends string = 'mutate'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  DeactivateCreditProfileMutation,
  DeactivateCreditProfileMutationVariables,
  DeactivateCreditProfileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withMutation<TProps, DeactivateCreditProfileMutation, DeactivateCreditProfileMutationVariables, DeactivateCreditProfileProps<TChildProps, TDataName>>(DeactivateCreditProfileDocument, {
      alias: 'deactivateCreditProfile',
      ...operationOptions
    });
};

/**
 * __useDeactivateCreditProfileMutation__
 *
 * To run a mutation, you first call `useDeactivateCreditProfileMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeactivateCreditProfileMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deactivateCreditProfileMutation, { data, loading, error }] = useDeactivateCreditProfileMutation({
 *   variables: {
 *   },
 * });
 */
export function useDeactivateCreditProfileMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<DeactivateCreditProfileMutation, DeactivateCreditProfileMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<DeactivateCreditProfileMutation, DeactivateCreditProfileMutationVariables>(DeactivateCreditProfileDocument, options);
      }
export type DeactivateCreditProfileMutationHookResult = ReturnType<typeof useDeactivateCreditProfileMutation>;
export type DeactivateCreditProfileMutationResult = ApolloReactCommon.MutationResult<DeactivateCreditProfileMutation>;
export type DeactivateCreditProfileMutationOptions = ApolloReactCommon.BaseMutationOptions<DeactivateCreditProfileMutation, DeactivateCreditProfileMutationVariables>;
export const GetFinancialDataProfileForUserDocument = gql`
    query GetFinancialDataProfileForUser {
  ...FinancialAccountsForUserFragment
  ...LinkedFinancialPortalsForUserFragment
  ...FinancialAccountTypeSumsFragment
}
    ${FinancialAccountsForUserFragmentFragmentDoc}
${LinkedFinancialPortalsForUserFragmentFragmentDoc}
${FinancialAccountTypeSumsFragmentFragmentDoc}`;
export type GetFinancialDataProfileForUserComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables>, 'query'>;

    export const GetFinancialDataProfileForUserComponent = (props: GetFinancialDataProfileForUserComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables> query={GetFinancialDataProfileForUserDocument} {...props} />
    );
    
export type GetFinancialDataProfileForUserProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables>
    } & TChildProps;
export function withGetFinancialDataProfileForUser<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialDataProfileForUserQuery,
  GetFinancialDataProfileForUserQueryVariables,
  GetFinancialDataProfileForUserProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables, GetFinancialDataProfileForUserProps<TChildProps, TDataName>>(GetFinancialDataProfileForUserDocument, {
      alias: 'getFinancialDataProfileForUser',
      ...operationOptions
    });
};

/**
 * __useGetFinancialDataProfileForUserQuery__
 *
 * To run a query within a React component, call `useGetFinancialDataProfileForUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialDataProfileForUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialDataProfileForUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetFinancialDataProfileForUserQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables>(GetFinancialDataProfileForUserDocument, options);
      }
export function useGetFinancialDataProfileForUserLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables>(GetFinancialDataProfileForUserDocument, options);
        }
export function useGetFinancialDataProfileForUserSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables>(GetFinancialDataProfileForUserDocument, options);
        }
export type GetFinancialDataProfileForUserQueryHookResult = ReturnType<typeof useGetFinancialDataProfileForUserQuery>;
export type GetFinancialDataProfileForUserLazyQueryHookResult = ReturnType<typeof useGetFinancialDataProfileForUserLazyQuery>;
export type GetFinancialDataProfileForUserSuspenseQueryHookResult = ReturnType<typeof useGetFinancialDataProfileForUserSuspenseQuery>;
export type GetFinancialDataProfileForUserQueryResult = ApolloReactCommon.QueryResult<GetFinancialDataProfileForUserQuery, GetFinancialDataProfileForUserQueryVariables>;
export const GetFinancialTransactionsProjectionForMonthDocument = gql`
    query GetFinancialTransactionsProjectionForMonth($dateInTargetMonth: Date!) {
  financialTransactionsProjectionForMonth(dateInTargetMonth: $dateInTargetMonth) {
    earning
  }
}
    `;
export type GetFinancialTransactionsProjectionForMonthComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables>, 'query'> & ({ variables: GetFinancialTransactionsProjectionForMonthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFinancialTransactionsProjectionForMonthComponent = (props: GetFinancialTransactionsProjectionForMonthComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables> query={GetFinancialTransactionsProjectionForMonthDocument} {...props} />
    );
    
export type GetFinancialTransactionsProjectionForMonthProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables>
    } & TChildProps;
export function withGetFinancialTransactionsProjectionForMonth<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialTransactionsProjectionForMonthQuery,
  GetFinancialTransactionsProjectionForMonthQueryVariables,
  GetFinancialTransactionsProjectionForMonthProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables, GetFinancialTransactionsProjectionForMonthProps<TChildProps, TDataName>>(GetFinancialTransactionsProjectionForMonthDocument, {
      alias: 'getFinancialTransactionsProjectionForMonth',
      ...operationOptions
    });
};

/**
 * __useGetFinancialTransactionsProjectionForMonthQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionsProjectionForMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionsProjectionForMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionsProjectionForMonthQuery({
 *   variables: {
 *      dateInTargetMonth: // value for 'dateInTargetMonth'
 *   },
 * });
 */
export function useGetFinancialTransactionsProjectionForMonthQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables> & ({ variables: GetFinancialTransactionsProjectionForMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables>(GetFinancialTransactionsProjectionForMonthDocument, options);
      }
export function useGetFinancialTransactionsProjectionForMonthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables>(GetFinancialTransactionsProjectionForMonthDocument, options);
        }
export function useGetFinancialTransactionsProjectionForMonthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables>(GetFinancialTransactionsProjectionForMonthDocument, options);
        }
export type GetFinancialTransactionsProjectionForMonthQueryHookResult = ReturnType<typeof useGetFinancialTransactionsProjectionForMonthQuery>;
export type GetFinancialTransactionsProjectionForMonthLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionsProjectionForMonthLazyQuery>;
export type GetFinancialTransactionsProjectionForMonthSuspenseQueryHookResult = ReturnType<typeof useGetFinancialTransactionsProjectionForMonthSuspenseQuery>;
export type GetFinancialTransactionsProjectionForMonthQueryResult = ApolloReactCommon.QueryResult<GetFinancialTransactionsProjectionForMonthQuery, GetFinancialTransactionsProjectionForMonthQueryVariables>;
export const GetFinancialTransactionsTopCategoriesBySpendingDocument = gql`
    query GetFinancialTransactionsTopCategoriesBySpending($dateInTargetStartMonth: Date!, $dateInTargetEndMonth: Date!) {
  financialTransactionsTopCategoriesBySpending(
    dateInTargetStartMonth: $dateInTargetStartMonth
    dateInTargetEndMonth: $dateInTargetEndMonth
  ) {
    topCategoriesBySpending {
      amount
      category
      categoryId
    }
  }
}
    `;
export type GetFinancialTransactionsTopCategoriesBySpendingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables>, 'query'> & ({ variables: GetFinancialTransactionsTopCategoriesBySpendingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFinancialTransactionsTopCategoriesBySpendingComponent = (props: GetFinancialTransactionsTopCategoriesBySpendingComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables> query={GetFinancialTransactionsTopCategoriesBySpendingDocument} {...props} />
    );
    
export type GetFinancialTransactionsTopCategoriesBySpendingProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables>
    } & TChildProps;
export function withGetFinancialTransactionsTopCategoriesBySpending<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialTransactionsTopCategoriesBySpendingQuery,
  GetFinancialTransactionsTopCategoriesBySpendingQueryVariables,
  GetFinancialTransactionsTopCategoriesBySpendingProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables, GetFinancialTransactionsTopCategoriesBySpendingProps<TChildProps, TDataName>>(GetFinancialTransactionsTopCategoriesBySpendingDocument, {
      alias: 'getFinancialTransactionsTopCategoriesBySpending',
      ...operationOptions
    });
};

/**
 * __useGetFinancialTransactionsTopCategoriesBySpendingQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionsTopCategoriesBySpendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionsTopCategoriesBySpendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionsTopCategoriesBySpendingQuery({
 *   variables: {
 *      dateInTargetStartMonth: // value for 'dateInTargetStartMonth'
 *      dateInTargetEndMonth: // value for 'dateInTargetEndMonth'
 *   },
 * });
 */
export function useGetFinancialTransactionsTopCategoriesBySpendingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables> & ({ variables: GetFinancialTransactionsTopCategoriesBySpendingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables>(GetFinancialTransactionsTopCategoriesBySpendingDocument, options);
      }
export function useGetFinancialTransactionsTopCategoriesBySpendingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables>(GetFinancialTransactionsTopCategoriesBySpendingDocument, options);
        }
export function useGetFinancialTransactionsTopCategoriesBySpendingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables>(GetFinancialTransactionsTopCategoriesBySpendingDocument, options);
        }
export type GetFinancialTransactionsTopCategoriesBySpendingQueryHookResult = ReturnType<typeof useGetFinancialTransactionsTopCategoriesBySpendingQuery>;
export type GetFinancialTransactionsTopCategoriesBySpendingLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionsTopCategoriesBySpendingLazyQuery>;
export type GetFinancialTransactionsTopCategoriesBySpendingSuspenseQueryHookResult = ReturnType<typeof useGetFinancialTransactionsTopCategoriesBySpendingSuspenseQuery>;
export type GetFinancialTransactionsTopCategoriesBySpendingQueryResult = ApolloReactCommon.QueryResult<GetFinancialTransactionsTopCategoriesBySpendingQuery, GetFinancialTransactionsTopCategoriesBySpendingQueryVariables>;
export const GetFinancialTransactionsAverageSpendingByDayOfTheMonthDocument = gql`
    query GetFinancialTransactionsAverageSpendingByDayOfTheMonth($dateInTargetStartMonth: Date!, $dateInTargetEndMonth: Date!) {
  financialTransactionsAverageSpendingByDayOfTheMonth(
    dateInTargetStartMonth: $dateInTargetStartMonth
    dateInTargetEndMonth: $dateInTargetEndMonth
  ) {
    averageSpendingByDayOfTheMonth {
      amount
      dayOfTheMonth
    }
  }
}
    `;
export type GetFinancialTransactionsAverageSpendingByDayOfTheMonthComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables>, 'query'> & ({ variables: GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFinancialTransactionsAverageSpendingByDayOfTheMonthComponent = (props: GetFinancialTransactionsAverageSpendingByDayOfTheMonthComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables> query={GetFinancialTransactionsAverageSpendingByDayOfTheMonthDocument} {...props} />
    );
    
export type GetFinancialTransactionsAverageSpendingByDayOfTheMonthProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables>
    } & TChildProps;
export function withGetFinancialTransactionsAverageSpendingByDayOfTheMonth<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery,
  GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables,
  GetFinancialTransactionsAverageSpendingByDayOfTheMonthProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables, GetFinancialTransactionsAverageSpendingByDayOfTheMonthProps<TChildProps, TDataName>>(GetFinancialTransactionsAverageSpendingByDayOfTheMonthDocument, {
      alias: 'getFinancialTransactionsAverageSpendingByDayOfTheMonth',
      ...operationOptions
    });
};

/**
 * __useGetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery({
 *   variables: {
 *      dateInTargetStartMonth: // value for 'dateInTargetStartMonth'
 *      dateInTargetEndMonth: // value for 'dateInTargetEndMonth'
 *   },
 * });
 */
export function useGetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables> & ({ variables: GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables>(GetFinancialTransactionsAverageSpendingByDayOfTheMonthDocument, options);
      }
export function useGetFinancialTransactionsAverageSpendingByDayOfTheMonthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables>(GetFinancialTransactionsAverageSpendingByDayOfTheMonthDocument, options);
        }
export function useGetFinancialTransactionsAverageSpendingByDayOfTheMonthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables>(GetFinancialTransactionsAverageSpendingByDayOfTheMonthDocument, options);
        }
export type GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryHookResult = ReturnType<typeof useGetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery>;
export type GetFinancialTransactionsAverageSpendingByDayOfTheMonthLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionsAverageSpendingByDayOfTheMonthLazyQuery>;
export type GetFinancialTransactionsAverageSpendingByDayOfTheMonthSuspenseQueryHookResult = ReturnType<typeof useGetFinancialTransactionsAverageSpendingByDayOfTheMonthSuspenseQuery>;
export type GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryResult = ApolloReactCommon.QueryResult<GetFinancialTransactionsAverageSpendingByDayOfTheMonthQuery, GetFinancialTransactionsAverageSpendingByDayOfTheMonthQueryVariables>;
export const GetFinancialTransactionsSpendingByDateForMonthDocument = gql`
    query GetFinancialTransactionsSpendingByDateForMonth($dateInTargetMonth: Date!) {
  financialTransactionsSpendingByDateForMonth(
    dateInTargetMonth: $dateInTargetMonth
  ) {
    spendingByDayOfTheMonthForPriorMonth {
      dayOfTheMonth
      amount
    }
    spendingByDayOfTheMonthForTargetMonth {
      dayOfTheMonth
      amount
    }
  }
}
    `;
export type GetFinancialTransactionsSpendingByDateForMonthComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables>, 'query'> & ({ variables: GetFinancialTransactionsSpendingByDateForMonthQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFinancialTransactionsSpendingByDateForMonthComponent = (props: GetFinancialTransactionsSpendingByDateForMonthComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables> query={GetFinancialTransactionsSpendingByDateForMonthDocument} {...props} />
    );
    
export type GetFinancialTransactionsSpendingByDateForMonthProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables>
    } & TChildProps;
export function withGetFinancialTransactionsSpendingByDateForMonth<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialTransactionsSpendingByDateForMonthQuery,
  GetFinancialTransactionsSpendingByDateForMonthQueryVariables,
  GetFinancialTransactionsSpendingByDateForMonthProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables, GetFinancialTransactionsSpendingByDateForMonthProps<TChildProps, TDataName>>(GetFinancialTransactionsSpendingByDateForMonthDocument, {
      alias: 'getFinancialTransactionsSpendingByDateForMonth',
      ...operationOptions
    });
};

/**
 * __useGetFinancialTransactionsSpendingByDateForMonthQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionsSpendingByDateForMonthQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionsSpendingByDateForMonthQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionsSpendingByDateForMonthQuery({
 *   variables: {
 *      dateInTargetMonth: // value for 'dateInTargetMonth'
 *   },
 * });
 */
export function useGetFinancialTransactionsSpendingByDateForMonthQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables> & ({ variables: GetFinancialTransactionsSpendingByDateForMonthQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables>(GetFinancialTransactionsSpendingByDateForMonthDocument, options);
      }
export function useGetFinancialTransactionsSpendingByDateForMonthLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables>(GetFinancialTransactionsSpendingByDateForMonthDocument, options);
        }
export function useGetFinancialTransactionsSpendingByDateForMonthSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables>(GetFinancialTransactionsSpendingByDateForMonthDocument, options);
        }
export type GetFinancialTransactionsSpendingByDateForMonthQueryHookResult = ReturnType<typeof useGetFinancialTransactionsSpendingByDateForMonthQuery>;
export type GetFinancialTransactionsSpendingByDateForMonthLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionsSpendingByDateForMonthLazyQuery>;
export type GetFinancialTransactionsSpendingByDateForMonthSuspenseQueryHookResult = ReturnType<typeof useGetFinancialTransactionsSpendingByDateForMonthSuspenseQuery>;
export type GetFinancialTransactionsSpendingByDateForMonthQueryResult = ApolloReactCommon.QueryResult<GetFinancialTransactionsSpendingByDateForMonthQuery, GetFinancialTransactionsSpendingByDateForMonthQueryVariables>;
export const GetFinancialTransactionsTopMerchantsBySpendingDocument = gql`
    query GetFinancialTransactionsTopMerchantsBySpending($dateInTargetStartMonth: Date!, $dateInTargetEndMonth: Date!, $pagination: AdvancedOffsetPaginationInput) {
  financialTransactionsTopMerchantsBySpending(
    dateInTargetStartMonth: $dateInTargetStartMonth
    dateInTargetEndMonth: $dateInTargetEndMonth
    pagination: $pagination
  ) {
    topMerchantsBySpending {
      amount
      merchantName
    }
  }
}
    `;
export type GetFinancialTransactionsTopMerchantsBySpendingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables>, 'query'> & ({ variables: GetFinancialTransactionsTopMerchantsBySpendingQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFinancialTransactionsTopMerchantsBySpendingComponent = (props: GetFinancialTransactionsTopMerchantsBySpendingComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables> query={GetFinancialTransactionsTopMerchantsBySpendingDocument} {...props} />
    );
    
export type GetFinancialTransactionsTopMerchantsBySpendingProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables>
    } & TChildProps;
export function withGetFinancialTransactionsTopMerchantsBySpending<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialTransactionsTopMerchantsBySpendingQuery,
  GetFinancialTransactionsTopMerchantsBySpendingQueryVariables,
  GetFinancialTransactionsTopMerchantsBySpendingProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables, GetFinancialTransactionsTopMerchantsBySpendingProps<TChildProps, TDataName>>(GetFinancialTransactionsTopMerchantsBySpendingDocument, {
      alias: 'getFinancialTransactionsTopMerchantsBySpending',
      ...operationOptions
    });
};

/**
 * __useGetFinancialTransactionsTopMerchantsBySpendingQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionsTopMerchantsBySpendingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionsTopMerchantsBySpendingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionsTopMerchantsBySpendingQuery({
 *   variables: {
 *      dateInTargetStartMonth: // value for 'dateInTargetStartMonth'
 *      dateInTargetEndMonth: // value for 'dateInTargetEndMonth'
 *      pagination: // value for 'pagination'
 *   },
 * });
 */
export function useGetFinancialTransactionsTopMerchantsBySpendingQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables> & ({ variables: GetFinancialTransactionsTopMerchantsBySpendingQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables>(GetFinancialTransactionsTopMerchantsBySpendingDocument, options);
      }
export function useGetFinancialTransactionsTopMerchantsBySpendingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables>(GetFinancialTransactionsTopMerchantsBySpendingDocument, options);
        }
export function useGetFinancialTransactionsTopMerchantsBySpendingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables>(GetFinancialTransactionsTopMerchantsBySpendingDocument, options);
        }
export type GetFinancialTransactionsTopMerchantsBySpendingQueryHookResult = ReturnType<typeof useGetFinancialTransactionsTopMerchantsBySpendingQuery>;
export type GetFinancialTransactionsTopMerchantsBySpendingLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionsTopMerchantsBySpendingLazyQuery>;
export type GetFinancialTransactionsTopMerchantsBySpendingSuspenseQueryHookResult = ReturnType<typeof useGetFinancialTransactionsTopMerchantsBySpendingSuspenseQuery>;
export type GetFinancialTransactionsTopMerchantsBySpendingQueryResult = ApolloReactCommon.QueryResult<GetFinancialTransactionsTopMerchantsBySpendingQuery, GetFinancialTransactionsTopMerchantsBySpendingQueryVariables>;
export const GetFinancialTransactionsSpendingAndEarningForMonthRangeDocument = gql`
    query GetFinancialTransactionsSpendingAndEarningForMonthRange($dateInStartMonth: Date!, $dateInEndMonth: Date!, $filter: FinancialTransactionsFilterInput) {
  financialTransactionsSpendingAndEarningForMonthRange(
    dateInStartMonth: $dateInStartMonth
    dateInEndMonth: $dateInEndMonth
    filter: $filter
  ) {
    spendingAndEarningForMonthRange {
      spending
      earning
    }
  }
}
    `;
export type GetFinancialTransactionsSpendingAndEarningForMonthRangeComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables>, 'query'> & ({ variables: GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables; skip?: boolean; } | { skip: boolean; });

    export const GetFinancialTransactionsSpendingAndEarningForMonthRangeComponent = (props: GetFinancialTransactionsSpendingAndEarningForMonthRangeComponentProps) => (
      <ApolloReactComponents.Query<GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables> query={GetFinancialTransactionsSpendingAndEarningForMonthRangeDocument} {...props} />
    );
    
export type GetFinancialTransactionsSpendingAndEarningForMonthRangeProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables>
    } & TChildProps;
export function withGetFinancialTransactionsSpendingAndEarningForMonthRange<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery,
  GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables,
  GetFinancialTransactionsSpendingAndEarningForMonthRangeProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables, GetFinancialTransactionsSpendingAndEarningForMonthRangeProps<TChildProps, TDataName>>(GetFinancialTransactionsSpendingAndEarningForMonthRangeDocument, {
      alias: 'getFinancialTransactionsSpendingAndEarningForMonthRange',
      ...operationOptions
    });
};

/**
 * __useGetFinancialTransactionsSpendingAndEarningForMonthRangeQuery__
 *
 * To run a query within a React component, call `useGetFinancialTransactionsSpendingAndEarningForMonthRangeQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetFinancialTransactionsSpendingAndEarningForMonthRangeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetFinancialTransactionsSpendingAndEarningForMonthRangeQuery({
 *   variables: {
 *      dateInStartMonth: // value for 'dateInStartMonth'
 *      dateInEndMonth: // value for 'dateInEndMonth'
 *      filter: // value for 'filter'
 *   },
 * });
 */
export function useGetFinancialTransactionsSpendingAndEarningForMonthRangeQuery(baseOptions: ApolloReactHooks.QueryHookOptions<GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables> & ({ variables: GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables>(GetFinancialTransactionsSpendingAndEarningForMonthRangeDocument, options);
      }
export function useGetFinancialTransactionsSpendingAndEarningForMonthRangeLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables>(GetFinancialTransactionsSpendingAndEarningForMonthRangeDocument, options);
        }
export function useGetFinancialTransactionsSpendingAndEarningForMonthRangeSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables>(GetFinancialTransactionsSpendingAndEarningForMonthRangeDocument, options);
        }
export type GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryHookResult = ReturnType<typeof useGetFinancialTransactionsSpendingAndEarningForMonthRangeQuery>;
export type GetFinancialTransactionsSpendingAndEarningForMonthRangeLazyQueryHookResult = ReturnType<typeof useGetFinancialTransactionsSpendingAndEarningForMonthRangeLazyQuery>;
export type GetFinancialTransactionsSpendingAndEarningForMonthRangeSuspenseQueryHookResult = ReturnType<typeof useGetFinancialTransactionsSpendingAndEarningForMonthRangeSuspenseQuery>;
export type GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryResult = ApolloReactCommon.QueryResult<GetFinancialTransactionsSpendingAndEarningForMonthRangeQuery, GetFinancialTransactionsSpendingAndEarningForMonthRangeQueryVariables>;
export const ProviderAccountsDocument = gql`
    query ProviderAccounts {
  financialPortals {
    portals {
      primarySource
    }
  }
}
    `;
export type ProviderAccountsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<ProviderAccountsQuery, ProviderAccountsQueryVariables>, 'query'>;

    export const ProviderAccountsComponent = (props: ProviderAccountsComponentProps) => (
      <ApolloReactComponents.Query<ProviderAccountsQuery, ProviderAccountsQueryVariables> query={ProviderAccountsDocument} {...props} />
    );
    
export type ProviderAccountsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<ProviderAccountsQuery, ProviderAccountsQueryVariables>
    } & TChildProps;
export function withProviderAccounts<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  ProviderAccountsQuery,
  ProviderAccountsQueryVariables,
  ProviderAccountsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, ProviderAccountsQuery, ProviderAccountsQueryVariables, ProviderAccountsProps<TChildProps, TDataName>>(ProviderAccountsDocument, {
      alias: 'providerAccounts',
      ...operationOptions
    });
};

/**
 * __useProviderAccountsQuery__
 *
 * To run a query within a React component, call `useProviderAccountsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProviderAccountsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProviderAccountsQuery({
 *   variables: {
 *   },
 * });
 */
export function useProviderAccountsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<ProviderAccountsQuery, ProviderAccountsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProviderAccountsQuery, ProviderAccountsQueryVariables>(ProviderAccountsDocument, options);
      }
export function useProviderAccountsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProviderAccountsQuery, ProviderAccountsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProviderAccountsQuery, ProviderAccountsQueryVariables>(ProviderAccountsDocument, options);
        }
export function useProviderAccountsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProviderAccountsQuery, ProviderAccountsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProviderAccountsQuery, ProviderAccountsQueryVariables>(ProviderAccountsDocument, options);
        }
export type ProviderAccountsQueryHookResult = ReturnType<typeof useProviderAccountsQuery>;
export type ProviderAccountsLazyQueryHookResult = ReturnType<typeof useProviderAccountsLazyQuery>;
export type ProviderAccountsSuspenseQueryHookResult = ReturnType<typeof useProviderAccountsSuspenseQuery>;
export type ProviderAccountsQueryResult = ApolloReactCommon.QueryResult<ProviderAccountsQuery, ProviderAccountsQueryVariables>;
export const GetIdentityAndProfileDocument = gql`
    query GetIdentityAndProfile {
  identity {
    id
    identityId
    isNerdWalletPlusMember
    roles
  }
  globalIdentityProfile {
    firstName
  }
}
    `;
export type GetIdentityAndProfileComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables>, 'query'>;

    export const GetIdentityAndProfileComponent = (props: GetIdentityAndProfileComponentProps) => (
      <ApolloReactComponents.Query<GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables> query={GetIdentityAndProfileDocument} {...props} />
    );
    
export type GetIdentityAndProfileProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables>
    } & TChildProps;
export function withGetIdentityAndProfile<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetIdentityAndProfileQuery,
  GetIdentityAndProfileQueryVariables,
  GetIdentityAndProfileProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables, GetIdentityAndProfileProps<TChildProps, TDataName>>(GetIdentityAndProfileDocument, {
      alias: 'getIdentityAndProfile',
      ...operationOptions
    });
};

/**
 * __useGetIdentityAndProfileQuery__
 *
 * To run a query within a React component, call `useGetIdentityAndProfileQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetIdentityAndProfileQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetIdentityAndProfileQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetIdentityAndProfileQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables>(GetIdentityAndProfileDocument, options);
      }
export function useGetIdentityAndProfileLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables>(GetIdentityAndProfileDocument, options);
        }
export function useGetIdentityAndProfileSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables>(GetIdentityAndProfileDocument, options);
        }
export type GetIdentityAndProfileQueryHookResult = ReturnType<typeof useGetIdentityAndProfileQuery>;
export type GetIdentityAndProfileLazyQueryHookResult = ReturnType<typeof useGetIdentityAndProfileLazyQuery>;
export type GetIdentityAndProfileSuspenseQueryHookResult = ReturnType<typeof useGetIdentityAndProfileSuspenseQuery>;
export type GetIdentityAndProfileQueryResult = ApolloReactCommon.QueryResult<GetIdentityAndProfileQuery, GetIdentityAndProfileQueryVariables>;
export const GetNwPlusInProgressPointsDocument = gql`
    query GetNwPlusInProgressPoints($filter: FinancialNwPlusRewardFilterInput, $currentDate: DateTime, $eventTypes: [String!]) {
  financialNwPlusRewards(filter: $filter, currentDate: $currentDate) {
    creditCards {
      id
      steps {
        status
      }
      rewardsProgress {
        hasMadeOnTimePayment
      }
    }
    bankingAccounts {
      id
      steps {
        status
      }
      rewardsProgress {
        hasFundedAccount
      }
    }
  }
  rewardEventPoints(eventTypes: $eventTypes) {
    rewards {
      points
      eventType
    }
  }
}
    `;
export type GetNwPlusInProgressPointsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables>, 'query'>;

    export const GetNwPlusInProgressPointsComponent = (props: GetNwPlusInProgressPointsComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables> query={GetNwPlusInProgressPointsDocument} {...props} />
    );
    
export type GetNwPlusInProgressPointsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables>
    } & TChildProps;
export function withGetNwPlusInProgressPoints<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusInProgressPointsQuery,
  GetNwPlusInProgressPointsQueryVariables,
  GetNwPlusInProgressPointsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables, GetNwPlusInProgressPointsProps<TChildProps, TDataName>>(GetNwPlusInProgressPointsDocument, {
      alias: 'getNwPlusInProgressPoints',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusInProgressPointsQuery__
 *
 * To run a query within a React component, call `useGetNwPlusInProgressPointsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusInProgressPointsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusInProgressPointsQuery({
 *   variables: {
 *      filter: // value for 'filter'
 *      currentDate: // value for 'currentDate'
 *      eventTypes: // value for 'eventTypes'
 *   },
 * });
 */
export function useGetNwPlusInProgressPointsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables>(GetNwPlusInProgressPointsDocument, options);
      }
export function useGetNwPlusInProgressPointsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables>(GetNwPlusInProgressPointsDocument, options);
        }
export function useGetNwPlusInProgressPointsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables>(GetNwPlusInProgressPointsDocument, options);
        }
export type GetNwPlusInProgressPointsQueryHookResult = ReturnType<typeof useGetNwPlusInProgressPointsQuery>;
export type GetNwPlusInProgressPointsLazyQueryHookResult = ReturnType<typeof useGetNwPlusInProgressPointsLazyQuery>;
export type GetNwPlusInProgressPointsSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusInProgressPointsSuspenseQuery>;
export type GetNwPlusInProgressPointsQueryResult = ApolloReactCommon.QueryResult<GetNwPlusInProgressPointsQuery, GetNwPlusInProgressPointsQueryVariables>;
export const GetMembershipAppActivityDocument = gql`
    query GetMembershipAppActivity {
  membershipAppActivity {
    nwPlusMaxEarnedPointsModalDismissedAt
  }
}
    `;
export type GetMembershipAppActivityComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables>, 'query'>;

    export const GetMembershipAppActivityComponent = (props: GetMembershipAppActivityComponentProps) => (
      <ApolloReactComponents.Query<GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables> query={GetMembershipAppActivityDocument} {...props} />
    );
    
export type GetMembershipAppActivityProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables>
    } & TChildProps;
export function withGetMembershipAppActivity<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetMembershipAppActivityQuery,
  GetMembershipAppActivityQueryVariables,
  GetMembershipAppActivityProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables, GetMembershipAppActivityProps<TChildProps, TDataName>>(GetMembershipAppActivityDocument, {
      alias: 'getMembershipAppActivity',
      ...operationOptions
    });
};

/**
 * __useGetMembershipAppActivityQuery__
 *
 * To run a query within a React component, call `useGetMembershipAppActivityQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetMembershipAppActivityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetMembershipAppActivityQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetMembershipAppActivityQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables>(GetMembershipAppActivityDocument, options);
      }
export function useGetMembershipAppActivityLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables>(GetMembershipAppActivityDocument, options);
        }
export function useGetMembershipAppActivitySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables>(GetMembershipAppActivityDocument, options);
        }
export type GetMembershipAppActivityQueryHookResult = ReturnType<typeof useGetMembershipAppActivityQuery>;
export type GetMembershipAppActivityLazyQueryHookResult = ReturnType<typeof useGetMembershipAppActivityLazyQuery>;
export type GetMembershipAppActivitySuspenseQueryHookResult = ReturnType<typeof useGetMembershipAppActivitySuspenseQuery>;
export type GetMembershipAppActivityQueryResult = ApolloReactCommon.QueryResult<GetMembershipAppActivityQuery, GetMembershipAppActivityQueryVariables>;
export const GetNerdWalletPlusPointsEstimateDocument = gql`
    query GetNerdWalletPlusPointsEstimate {
  nwPlusPointsEstimate {
    points
  }
}
    `;
export type GetNerdWalletPlusPointsEstimateComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables>, 'query'>;

    export const GetNerdWalletPlusPointsEstimateComponent = (props: GetNerdWalletPlusPointsEstimateComponentProps) => (
      <ApolloReactComponents.Query<GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables> query={GetNerdWalletPlusPointsEstimateDocument} {...props} />
    );
    
export type GetNerdWalletPlusPointsEstimateProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables>
    } & TChildProps;
export function withGetNerdWalletPlusPointsEstimate<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNerdWalletPlusPointsEstimateQuery,
  GetNerdWalletPlusPointsEstimateQueryVariables,
  GetNerdWalletPlusPointsEstimateProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables, GetNerdWalletPlusPointsEstimateProps<TChildProps, TDataName>>(GetNerdWalletPlusPointsEstimateDocument, {
      alias: 'getNerdWalletPlusPointsEstimate',
      ...operationOptions
    });
};

/**
 * __useGetNerdWalletPlusPointsEstimateQuery__
 *
 * To run a query within a React component, call `useGetNerdWalletPlusPointsEstimateQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNerdWalletPlusPointsEstimateQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNerdWalletPlusPointsEstimateQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNerdWalletPlusPointsEstimateQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables>(GetNerdWalletPlusPointsEstimateDocument, options);
      }
export function useGetNerdWalletPlusPointsEstimateLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables>(GetNerdWalletPlusPointsEstimateDocument, options);
        }
export function useGetNerdWalletPlusPointsEstimateSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables>(GetNerdWalletPlusPointsEstimateDocument, options);
        }
export type GetNerdWalletPlusPointsEstimateQueryHookResult = ReturnType<typeof useGetNerdWalletPlusPointsEstimateQuery>;
export type GetNerdWalletPlusPointsEstimateLazyQueryHookResult = ReturnType<typeof useGetNerdWalletPlusPointsEstimateLazyQuery>;
export type GetNerdWalletPlusPointsEstimateSuspenseQueryHookResult = ReturnType<typeof useGetNerdWalletPlusPointsEstimateSuspenseQuery>;
export type GetNerdWalletPlusPointsEstimateQueryResult = ApolloReactCommon.QueryResult<GetNerdWalletPlusPointsEstimateQuery, GetNerdWalletPlusPointsEstimateQueryVariables>;
export const GetNwPlusPointsSummaryDocument = gql`
    query GetNwPlusPointsSummary {
  nwPlusPointsSummary {
    points
    earnedYearlyPoints
  }
}
    `;
export type GetNwPlusPointsSummaryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables>, 'query'>;

    export const GetNwPlusPointsSummaryComponent = (props: GetNwPlusPointsSummaryComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables> query={GetNwPlusPointsSummaryDocument} {...props} />
    );
    
export type GetNwPlusPointsSummaryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables>
    } & TChildProps;
export function withGetNwPlusPointsSummary<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusPointsSummaryQuery,
  GetNwPlusPointsSummaryQueryVariables,
  GetNwPlusPointsSummaryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables, GetNwPlusPointsSummaryProps<TChildProps, TDataName>>(GetNwPlusPointsSummaryDocument, {
      alias: 'getNwPlusPointsSummary',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusPointsSummaryQuery__
 *
 * To run a query within a React component, call `useGetNwPlusPointsSummaryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusPointsSummaryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusPointsSummaryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusPointsSummaryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables>(GetNwPlusPointsSummaryDocument, options);
      }
export function useGetNwPlusPointsSummaryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables>(GetNwPlusPointsSummaryDocument, options);
        }
export function useGetNwPlusPointsSummarySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables>(GetNwPlusPointsSummaryDocument, options);
        }
export type GetNwPlusPointsSummaryQueryHookResult = ReturnType<typeof useGetNwPlusPointsSummaryQuery>;
export type GetNwPlusPointsSummaryLazyQueryHookResult = ReturnType<typeof useGetNwPlusPointsSummaryLazyQuery>;
export type GetNwPlusPointsSummarySuspenseQueryHookResult = ReturnType<typeof useGetNwPlusPointsSummarySuspenseQuery>;
export type GetNwPlusPointsSummaryQueryResult = ApolloReactCommon.QueryResult<GetNwPlusPointsSummaryQuery, GetNwPlusPointsSummaryQueryVariables>;
export const GetNwPlusPredictionsDocument = gql`
    query GetNwPlusPredictions {
  nwPlusPredictions {
    pointsEarnPrediction {
      overallSummary {
        type
        summary {
          remainingPoints
        }
      }
    }
  }
}
    `;
export type GetNwPlusPredictionsComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables>, 'query'>;

    export const GetNwPlusPredictionsComponent = (props: GetNwPlusPredictionsComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables> query={GetNwPlusPredictionsDocument} {...props} />
    );
    
export type GetNwPlusPredictionsProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables>
    } & TChildProps;
export function withGetNwPlusPredictions<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusPredictionsQuery,
  GetNwPlusPredictionsQueryVariables,
  GetNwPlusPredictionsProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables, GetNwPlusPredictionsProps<TChildProps, TDataName>>(GetNwPlusPredictionsDocument, {
      alias: 'getNwPlusPredictions',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusPredictionsQuery__
 *
 * To run a query within a React component, call `useGetNwPlusPredictionsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusPredictionsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusPredictionsQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusPredictionsQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables>(GetNwPlusPredictionsDocument, options);
      }
export function useGetNwPlusPredictionsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables>(GetNwPlusPredictionsDocument, options);
        }
export function useGetNwPlusPredictionsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables>(GetNwPlusPredictionsDocument, options);
        }
export type GetNwPlusPredictionsQueryHookResult = ReturnType<typeof useGetNwPlusPredictionsQuery>;
export type GetNwPlusPredictionsLazyQueryHookResult = ReturnType<typeof useGetNwPlusPredictionsLazyQuery>;
export type GetNwPlusPredictionsSuspenseQueryHookResult = ReturnType<typeof useGetNwPlusPredictionsSuspenseQuery>;
export type GetNwPlusPredictionsQueryResult = ApolloReactCommon.QueryResult<GetNwPlusPredictionsQuery, GetNwPlusPredictionsQueryVariables>;
export const GetNwPlusAllAndCompletedRewardsQueryDocument = gql`
    query GetNwPlusAllAndCompletedRewardsQuery {
  nwPlusUserQualifiedRewards(includeCompleted: true) {
    allRewards {
      ...QualifiedReward
    }
    completedRewards {
      ...QualifiedReward
    }
  }
}
    ${QualifiedRewardFragmentDoc}`;
export type GetNwPlusAllAndCompletedRewardsQueryComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables>, 'query'>;

    export const GetNwPlusAllAndCompletedRewardsQueryComponent = (props: GetNwPlusAllAndCompletedRewardsQueryComponentProps) => (
      <ApolloReactComponents.Query<GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables> query={GetNwPlusAllAndCompletedRewardsQueryDocument} {...props} />
    );
    
export type GetNwPlusAllAndCompletedRewardsQueryProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables>
    } & TChildProps;
export function withGetNwPlusAllAndCompletedRewardsQuery<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetNwPlusAllAndCompletedRewardsQueryQuery,
  GetNwPlusAllAndCompletedRewardsQueryQueryVariables,
  GetNwPlusAllAndCompletedRewardsQueryProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables, GetNwPlusAllAndCompletedRewardsQueryProps<TChildProps, TDataName>>(GetNwPlusAllAndCompletedRewardsQueryDocument, {
      alias: 'getNwPlusAllAndCompletedRewardsQuery',
      ...operationOptions
    });
};

/**
 * __useGetNwPlusAllAndCompletedRewardsQueryQuery__
 *
 * To run a query within a React component, call `useGetNwPlusAllAndCompletedRewardsQueryQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetNwPlusAllAndCompletedRewardsQueryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetNwPlusAllAndCompletedRewardsQueryQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetNwPlusAllAndCompletedRewardsQueryQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables>(GetNwPlusAllAndCompletedRewardsQueryDocument, options);
      }
export function useGetNwPlusAllAndCompletedRewardsQueryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables>(GetNwPlusAllAndCompletedRewardsQueryDocument, options);
        }
export function useGetNwPlusAllAndCompletedRewardsQuerySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables>(GetNwPlusAllAndCompletedRewardsQueryDocument, options);
        }
export type GetNwPlusAllAndCompletedRewardsQueryQueryHookResult = ReturnType<typeof useGetNwPlusAllAndCompletedRewardsQueryQuery>;
export type GetNwPlusAllAndCompletedRewardsQueryLazyQueryHookResult = ReturnType<typeof useGetNwPlusAllAndCompletedRewardsQueryLazyQuery>;
export type GetNwPlusAllAndCompletedRewardsQuerySuspenseQueryHookResult = ReturnType<typeof useGetNwPlusAllAndCompletedRewardsQuerySuspenseQuery>;
export type GetNwPlusAllAndCompletedRewardsQueryQueryResult = ApolloReactCommon.QueryResult<GetNwPlusAllAndCompletedRewardsQueryQuery, GetNwPlusAllAndCompletedRewardsQueryQueryVariables>;
export const GetLinkTokenForLinkingDocument = gql`
    query GetLinkTokenForLinking($redirectUri: String) {
  initializeLinkToken(redirectUri: $redirectUri) {
    token
  }
}
    `;
export type GetLinkTokenForLinkingComponentProps = Omit<ApolloReactComponents.QueryComponentOptions<GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables>, 'query'>;

    export const GetLinkTokenForLinkingComponent = (props: GetLinkTokenForLinkingComponentProps) => (
      <ApolloReactComponents.Query<GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables> query={GetLinkTokenForLinkingDocument} {...props} />
    );
    
export type GetLinkTokenForLinkingProps<TChildProps = {}, TDataName extends string = 'data'> = {
      [key in TDataName]: ApolloReactHoc.DataValue<GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables>
    } & TChildProps;
export function withGetLinkTokenForLinking<TProps, TChildProps = {}, TDataName extends string = 'data'>(operationOptions?: ApolloReactHoc.OperationOption<
  TProps,
  GetLinkTokenForLinkingQuery,
  GetLinkTokenForLinkingQueryVariables,
  GetLinkTokenForLinkingProps<TChildProps, TDataName>>) {
    return ApolloReactHoc.withQuery<TProps, GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables, GetLinkTokenForLinkingProps<TChildProps, TDataName>>(GetLinkTokenForLinkingDocument, {
      alias: 'getLinkTokenForLinking',
      ...operationOptions
    });
};

/**
 * __useGetLinkTokenForLinkingQuery__
 *
 * To run a query within a React component, call `useGetLinkTokenForLinkingQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLinkTokenForLinkingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLinkTokenForLinkingQuery({
 *   variables: {
 *      redirectUri: // value for 'redirectUri'
 *   },
 * });
 */
export function useGetLinkTokenForLinkingQuery(baseOptions?: ApolloReactHooks.QueryHookOptions<GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables>(GetLinkTokenForLinkingDocument, options);
      }
export function useGetLinkTokenForLinkingLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables>(GetLinkTokenForLinkingDocument, options);
        }
export function useGetLinkTokenForLinkingSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables>(GetLinkTokenForLinkingDocument, options);
        }
export type GetLinkTokenForLinkingQueryHookResult = ReturnType<typeof useGetLinkTokenForLinkingQuery>;
export type GetLinkTokenForLinkingLazyQueryHookResult = ReturnType<typeof useGetLinkTokenForLinkingLazyQuery>;
export type GetLinkTokenForLinkingSuspenseQueryHookResult = ReturnType<typeof useGetLinkTokenForLinkingSuspenseQuery>;
export type GetLinkTokenForLinkingQueryResult = ApolloReactCommon.QueryResult<GetLinkTokenForLinkingQuery, GetLinkTokenForLinkingQueryVariables>;